/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		38: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 294);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(29);
var hide = __webpack_require__(19);
var redefine = __webpack_require__(20);
var ctx = __webpack_require__(30);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(505)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(507);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FORM_TYPE = exports.FORM_TYPE = {
  TEXTBOX: 1,
  TEXTAREA: 2,
  CHECKBOX: 3,
  RADIO: 4,
  DROPDOWN: 5,
  DATEPICKER: 6,
  ARRAY_OBJECT: 7,
  SLOT: 8,
  DAY_HOURS_SELECTOR: 9,
  SALARY_RANGE: 10,
  HEADER: 11,
  MULTI_SELECT: 12,
  LABEL: 13,
  MONTH_PICKER: 14,
  SUB_HEADER: 15,
  TIME_PICKER: 16,
  FILE: 17,
  SECTION: 18,
  RATING_GROUP: 19,
  SEPARATOR: 20,
  RADIO_TABLE: 21,
  TEXT_EDITOR: 22,
  LIST_ITEMS: 23,
  CHECKBOX_TABLE: 24,
  LANGUAGE_INPUT: 25,
  BOOKING_SECTION: 26,
  TOTAL_YEARS: 27,
  SIGN_DOCUMENT: 28,
  MULTI_DATEPICKER: 29,
  FILE_WITH_INFO: 30,
  HTML: 31,
  LIST_TEXTBOX: 32,
  COLOR_PICKER: 33,
  CHECKBOX_CONDITION: 34,
  YEAR_PICKER: 35,
  PRODUCT_SELECTION: 36,
  RADIO_ICON: 37,
  RATING: 38,
  CHECKBOX_ICON: 39,
  DATETIME_PICKER: 40,
  HTML_SELECTION: 41,
  EXPRESSION: 42,
  CHECKBOX_ITEM: 43,
  PAYMENT: 44,
  LOGGING: 45,
  PASSWORD: 46,
  PRESET_SECTION: 47,
  TAG_HTML: 48,
  PRESET_FIELDS: 49,
  CROPABLE_FILE: 50,
  CREDIT_PACKAGE_SELECTION: 51,
  LIST_TEXTFIELD_INPUT: 52,
  LIST_TEXTAREA: 53,
  LIST_DATEPICKER: 54,
  STRIPE_SUBSCRIPTION_SELECTION: 55,
  BUILDER_FIELD_SELECTOR: 56,
  COLOR_INPUT: 57,
  STATUS_COLOR_INPUT: 58,
  PLACEMENT_JOB_SELECTION: 59,
  LIST_FILES: 60,
  VIDEO: 61,
  LIST_DATE_TIMES_PICKER: 62,
  DATA: 63, // Attach data in list fields
  EVALUATION: 64,
  RETURNING_APPLICANT_BTN: 65, // Button for returning applicant
  SIGNATURE_FIELD: 66,
  HEADER_SLOT: 67, // Header slot (in case of the actual header is hidden)
  SIGNATURE_PAD: 68,
  LIST_TEXT_EDITOR_MULTI_SELECT: 69,
  LIST_TEXT_BOX_MULTI_SELECT: 70,
  LIST_BUILDER_FIELD_SELECTOR: 71,
  DISPLAY_DATES_DURATION: 72,
  LIST_ITEM_MULTI_SELECT: 73,
  CHECKBOX_GROUP_WITH_DATE_RANGE: 74,
  LIST_TEXT_AREA_MULTI_SELECT: 75,
  LIST_2_TEXT_BOX_MULTI_SELECT: 76,
  MONTHLY_CREDIT_PACKAGE_SELECTION: 77,
  LIST_2_TEXTBOX: 78,
  SECTION_BOUNDERY_SLOT: 79,
  REARRANGE_LIST: 80,
  LIST_2_MULTI_SELECT: 81
};

var LIST_FIELD_TYPES_NOT_CHECK_COMPLETION = exports.LIST_FIELD_TYPES_NOT_CHECK_COMPLETION = [FORM_TYPE.SLOT, FORM_TYPE.SECTION, FORM_TYPE.BOOKING_SECTION, FORM_TYPE.HEADER, FORM_TYPE.FILE, FORM_TYPE.FILE_WITH_INFO, FORM_TYPE.CHECKBOX_CONDITION, FORM_TYPE.SIGN_DOCUMENT, FORM_TYPE.EVALUATION, FORM_TYPE.PRESET_SECTION, FORM_TYPE.PAYMENT, FORM_TYPE.HTML, FORM_TYPE.DATA, FORM_TYPE.RETURNING_APPLICANT_BTN, FORM_TYPE.SEPARATOR, FORM_TYPE.LOGGING, FORM_TYPE.LABEL, FORM_TYPE.SUB_HEADER, FORM_TYPE.CREDIT_PACKAGE_SELECTION, FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION, FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION, FORM_TYPE.DISPLAY_DATES_DURATION, FORM_TYPE.EXPRESSION];

var LIST_FIELD_TYPES_HAS_NO_REQUIRED_OPTIONS = exports.LIST_FIELD_TYPES_HAS_NO_REQUIRED_OPTIONS = [FORM_TYPE.SLOT, FORM_TYPE.SECTION, FORM_TYPE.BOOKING_SECTION, FORM_TYPE.HEADER, FORM_TYPE.CHECKBOX_CONDITION, FORM_TYPE.PRESET_SECTION, FORM_TYPE.PAYMENT, FORM_TYPE.HTML, FORM_TYPE.DATA, FORM_TYPE.RETURNING_APPLICANT_BTN, FORM_TYPE.SEPARATOR, FORM_TYPE.LOGGING, FORM_TYPE.LABEL, FORM_TYPE.SUB_HEADER, FORM_TYPE.DISPLAY_DATES_DURATION, FORM_TYPE.EXPRESSION];

var LIST_FIELDS_NO_MODEL = exports.LIST_FIELDS_NO_MODEL = [FORM_TYPE.SLOT, FORM_TYPE.SECTION, FORM_TYPE.BOOKING_SECTION, FORM_TYPE.HEADER, FORM_TYPE.FILE_WITH_INFO, FORM_TYPE.CHECKBOX_CONDITION, FORM_TYPE.SIGN_DOCUMENT, FORM_TYPE.EVALUATION, FORM_TYPE.PRESET_SECTION, FORM_TYPE.PAYMENT, FORM_TYPE.HTML, FORM_TYPE.DATA, FORM_TYPE.RETURNING_APPLICANT_BTN, FORM_TYPE.SEPARATOR, FORM_TYPE.LABEL, FORM_TYPE.SUB_HEADER, FORM_TYPE.DISPLAY_DATES_DURATION, FORM_TYPE.EXPRESSION, FORM_TYPE.SECTION_BOUNDERY_SLOT, FORM_TYPE.PLACEMENT_JOB_SELECTION];

var ACTION_TYPE = exports.ACTION_TYPE = {
  ADD: 1,
  UPDATE: 2,
  DELETE: 3,
  CANCEL: 4,
  SET_VISIBILITY: 5,
  DELETE_FILE: 6
};

var TEXTBOX_INPUT_TYPE = exports.TEXTBOX_INPUT_TYPE = {
  TEXT: "TEXT",
  INTEGER: "INTEGER",
  POSITIVE_INTEGER: "POSITIVE_INTEGER",
  POSITIVE_DOUBLE: "POSITIVE_DOUBLE",
  DOUBLE: "DOUBLE"
};

var SERVICE_TYPES = exports.SERVICE_TYPES = {
  PLACEMENT: "Placement",
  SITTER: "Sitter"
};

var FILE_TYPES = exports.FILE_TYPES = {
  DOCUMENT: "Document",
  IMAGE: "Image",
  ALL: "All"
};

var JOB_TYPES = exports.JOB_TYPES = {
  PLACEMENT: "Placement",
  SHIFT: "Shift"
};

var BUILDER_USER_TYPE = exports.BUILDER_USER_TYPE = {
  CANDIDATE: "Candidate",
  CLIENT: "Client",
  UNSPECIFIED: "Unspecified"
};

var BUILDER_TYPE = exports.BUILDER_TYPE = {
  APPLICATION: "Application",
  PROFILE: "Profile",
  SECTION: "Section",
  FILE_INFO: "File Information",
  REFERENCE_CHECK: "Reference Check",
  PLACEMENT_JOB: "Placement Job",
  ADD_USER: "Add User",
  SHIFT_JOB_REPORT: "Shift Job Report",
  JOB_APPLICATION_FORM: "Job Application Form",
  SCHEDULE_INTERVIEW_FORM: "Schedule Interview Form",
  REVIEW_USER: "Review User",
  ADMIN_INFORMATION: "Admin Information"
};

var PROFILE_PICTURE_SCOPE = exports.PROFILE_PICTURE_SCOPE = {
  NONE: "None",
  PRIVATE: "Private",
  PUBLIC: "Public"
};

var DEFAULT_DOCUMENT_SCOPE = exports.DEFAULT_DOCUMENT_SCOPE = ["Private", "Public"];

var PRICE_TYPES = exports.PRICE_TYPES = {
  REGISTRATION_FEE: "Registration Fee",
  HOURLY_BOOKING_RATE: "Hourly Booking Rate",
  HOURLY_FEE_PER_ADDITIONAL_CHILD: "Hourly Fee Per Additional Child",
  HOURLY_AGENCY_FEE: "Hourly Agency Fee",
  HOURLY_AGENCY_COMMISSION: "Hourly Agency Commission",
  TRAVEL_FEE: "Travel Fee",
  RUSH_FEE: "Rush Fee",
  CANDIDATE_RUSH_FEE: "Candidate Rush Fee",
  RUSH_HOURLY_FEE: "Rush Hourly Fee",
  PER_BOOKING_AGENCY_FEE: "Per Booking Agency Fee",
  PER_BOOKING_CANDIDATE_FEE: "Per Booking Candidate Fee",
  PER_TIME_RANGE_CANDIDATE_FEE: "Per Time Range Candidate Fee",
  HOURLY_SERVICES_SELECTION: "Hourly Service Selection",
  BOOKING_TOTAL_DISCOUNT: "Booking Total Discount",
  ADMIN_FEE: "Admin Fee",
  ADMIN_PERCENTAGE: "Admin Percentage",
  ADDITIONAL_OVERNIGHT_HOURLY_RATE: "Additional Overnight Hourly Rate",
  HOURLY_RATE_FOR_ADDITIONAL_HOURS: "Hourly Rate for Additional Hours"
};

var JOB_STATUSES = exports.JOB_STATUSES = {
  CANCELLED: "Cancelled",
  ASSIGNED: "Assigned"
};

var DOCUMENT_SECTION_INPUT_DIAGLOG_TYPE = exports.DOCUMENT_SECTION_INPUT_DIAGLOG_TYPE = {
  ACCESS_CONTROL: 0,
  UPLOAD_FILE: 1
};

var INPUT_STATUS = exports.INPUT_STATUS = {
  VALID: 0,
  INVALID: 1,
  EMPTY: 2
};

var STRIPE_PAYMENT_ERROR_IDS = exports.STRIPE_PAYMENT_ERROR_IDS = {
  EMPTY: "stripe-payment-error-empty",
  INVALID: "stripe-payment-error-invalid"
};

var JOB_UPDATE_STATUS_SENT = exports.JOB_UPDATE_STATUS_SENT = {
  POSTER: 1,
  FILLER: 2,
  POSTER_FILLER: 3,
  NONE: 0
};

var PAYMENT_TYPES = exports.PAYMENT_TYPES = {
  STRIPE: "Stripe",
  AUTHORIZE: "Authorize.Net",
  QUICKBOOKS: "Quickbooks",
  SQUARE: "Square"
};

var DATE_RANGE_DAYS = exports.DATE_RANGE_DAYS = {
  MY_SCHEDULE_NUM_OF_PAST_DAY: 14,
  MY_SCHEDULE_NUM_OF_FUTURE_DAY: 28,

  MY_JOB_NUM_OF_PAST_DAY: 14,
  MY_JOB_NUM_OF_FUTURE_DAY: 28
};

var OPTION_LIST_TYPES = exports.OPTION_LIST_TYPES = {
  CANDIDATE_LIST_FIELDS: "Candidate List Fields",
  EMPLOYER_LIST_FIELDS: "Client List Fields",
  PLACEMENT_JOB_LIST_FIELDS: "Placement Job List Fields",
  SHIFT_JOB_LIST_FIELDS: "Shift Job List Fields",
  ADMIN_LIST: "Admin List",
  BOOKING_CATEGORIES: "Booking Categories",
  BOOKING_STATUSES: "Booking Statuses",
  CLASS_CATEGORY_LIST: "Class Categories",
  BOOKING_BUILDER_LIST: "Booking Builder List"
};

var DEFAULT_TYPES = exports.DEFAULT_TYPES = {
  AGENCY_ADMIN_EMAIL_LIST: "Agency Admin Email List",
  AGENCY_FROM_EMAIL_LIST: "Agency From Email List"
};

var BUTTON_STATUS = exports.BUTTON_STATUS = {
  NORMAL: "Normal",
  SUBMITTING: "Submitting",
  DONE: "Done"
};

var BROADCAST_TYPE = exports.BROADCAST_TYPE = {
  SHIFT_JOB: "Shift Job",
  PLACEMENT_JOB: "Placement Job",
  SYSTEM_EVENT: "System Event"
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28), __webpack_require__(498).setImmediate))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLogger", function() { return createLogger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["default"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(68)('wks');
var uid = __webpack_require__(48);
var Symbol = __webpack_require__(7).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(32);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(8)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(151);
var toPrimitive = __webpack_require__(35);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(36);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR = exports.DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES = exports.DEFAULT_PLACEMENT_JOB_FILTER_FIELDS = exports.DEFAULT_PRICE_INFO_ITEMS_PLACEMENT = exports.DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES = exports.DEFAULT_TEMPLATE_10_PARAMS = exports.DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS = exports.ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS = exports.DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED = exports.DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED = exports.DEFAULT_EMAIL_STATUSES = exports.DEFAULT_SCHEDULE_EVENT_TYPES = exports.DEFAULT_PROFILE_TOP_WELCOME_TEXT = exports.DEFAULT_DATEPICKER_FIELD = exports.DEFAULT_REPORT_PROBLEM_NOTE_LABEL = exports.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION = exports.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL = exports.DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT = exports.DEFAULT_ANALYTICS_DASHBOARD_SELECTION = exports.DEFAULT_USER_EXPORT_OPTIONS = exports.USER_EXPORT_OPTIONS = exports.DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT = exports.DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE = exports.DEFAULT_CANDIDATE_TABLE_JOB_FIELD_KEYS = exports.DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS = exports.DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST = exports.DEFAULT_REQUEST_TIME_OFF_CATEGORIES = exports.DEFAULT_LOGIN_PAGE_HELPER_TEXT = exports.DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD = exports.DEFAULT_SHIFT_JOB_CALENDAR_TITLE = exports.DEFAULT_DO_NOT_WANT_AGAIN_TEXT = exports.BOOKING_RESULT_DEFAULT_FIELDS = exports.DEFAULT_STATUS_REQUIRE_REASON_CHANGE = exports.DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE = exports.DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE = exports.DEFAULT_DISCLAIMER_TEXT = exports.DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS = exports.DEFAULT_PLACEMENT_JOB_BOARD_FIELDS = exports.DEFAULT_HEADING_CLIENT_INTERVIEW = exports.DEFAULT_HEADING_CANDIDATE_INTERVIEW = exports.DEFAULT_FAVICON_URL = exports.DEFAULT_COLOR_PICKER_OPTIONS = exports.DEFAULT_NAV_BAR_TEXT_COLOR = exports.DEFAULT_NAV_BAR_COLOR = exports.DEFAULT_TEMPLATE_11_PARAMS = exports.DEFAULT_TEMPLATE_9_PARAMS = exports.DEFAULT_TEMPLATE_8_PARAMS = exports.DEFAULT_TEMPLATE_7_PARAMS = exports.DEFAULT_TEMPLATE_6_PARAMS = exports.DEFAULT_TEMPLATE_5_PARAMS = exports.DEFAULT_TEMPLATE_4_PARAMS = exports.DEFAULT_TEMPLATE_3_PARAMS = exports.DEFAULT_TEMPLATE_2_PARAMS = exports.DEFAULT_PROFILE_IMAGE_SUFFIX = exports.DEFAULT_PROFILE_IMAGE = exports.DEFAULT_PLACEMENT_JOB_STATUSES = exports.DEFAULT_PLACEMENT_JOB_TABLE_FIELDS = exports.DEFAULT_MY_JOBS_TABLE_FIELDS = exports.DEFAULT_TIME_SHEET_TABLE_FIELDS = exports.DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER = exports.DEFAULT_DASHBOARD_TABLE_FIELDS_CANDIDATE = exports.DEFAULT_DASHBOARD_TABLE_MODELS_EMPLOYER = exports.DEFAULT_DASHBOARD_TABLE_MODELS_CANDIDATE = exports.DEFAULT_SHIFT_JOB_STATUSES = exports.DEFAULT_LIST_COLORS = exports.DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS = exports.DEFAULT_EMPLOYER_STATUSES = exports.DEFAULT_SHIFT_JOB_CSV_OPTIONS = exports.SHIFT_JOB_CSV_OPTIONS = exports.DEFAULT_TABLE_FIELDS_OPTIONS = exports.DEFAULT_CANDIDATE_STATUSES = undefined;

var _customDefineType = __webpack_require__(6);

var DEFAULT_CANDIDATE_STATUSES = exports.DEFAULT_CANDIDATE_STATUSES = ["Pre Application", "Applied", "Rejected", "Inactive", "Application Approved", "Interview Complete", "Document Signed", "Reference Check Complete", "Background Check Complete", "Profile Complete", "Hired"];

var DEFAULT_TABLE_FIELDS_OPTIONS = exports.DEFAULT_TABLE_FIELDS_OPTIONS = [{
  label: "Name",
  model: "first_name_last_name"
}, {
  label: "Secondary Name",
  model: "secondary_first_name_secondary_last_name"
}, {
  label: "Status",
  model: "status"
}, {
  label: "Status 2",
  model: "second_status"
}, {
  label: "Registration Date",
  model: "created_date"
}, {
  label: "Last Login",
  model: "last_login"
}, {
  label: "Last Updated",
  model: "last_updated_date"
}, {
  label: "Last Contacted",
  model: "last_contacted_date"
}, {
  label: "Last Active",
  model: "last_activity"
}, {
  label: "Types",
  model: "types"
}, {
  label: "Admin Manager",
  model: "admin_manager"
}, {
  label: "Locations",
  model: "locations"
}, {
  label: "Language",
  model: "language"
}, {
  label: "Tags",
  model: "tags"
}, {
  label: "Profile Picture",
  model: "profile_pic"
}, {
  label: "ID",
  model: "id"
}, {
  label: "Checklist",
  model: "checklist"
}, {
  label: "Profile Checklist",
  model: "profile_checklist"
}];
var SHIFT_JOB_CSV_OPTIONS = exports.SHIFT_JOB_CSV_OPTIONS = [{
  displayLabel: "Client Name",
  label: "Client",
  model: "poster_name"
}, {
  displayLabel: "Poster Employer Name",
  label: "Poster Employer Name",
  model: "poster__employer_name"
}, {
  displayLabel: "Poster First Name",
  label: "Poster First Name",
  model: "poster__first_name"
}, {
  displayLabel: "Poster Email",
  label: "Poster Email",
  model: "poster__email"
}, {
  displayLabel: "Poster Last Name",
  label: "Poster Last Name",
  model: "poster__last_name"
}, {
  displayLabel: "Client ID",
  label: "Client ID",
  model: "poster_id"
}, {
  displayLabel: "Date",
  label: "Date",
  model: "date"
}, {
  displayLabel: "Candidate Name",
  label: "Candidate",
  model: "filler_name"
}, {
  displayLabel: "Candidate",
  label: "Candidate ID",
  model: "filler_id"
}, {
  displayLabel: "Job Type",
  label: "Job Type",
  model: "job_type"
}, {
  displayLabel: "Title",
  label: "Title",
  model: "title"
}, {
  displayLabel: "Booked Start Time",
  label: "Booked Start Time",
  model: "start_time"
}, {
  displayLabel: "Booked End Time",
  label: "Booked End Time",
  model: "end_time"
}, {
  displayLabel: "Actual Start Time",
  label: "Actual Start Time",
  model: "actual_start_time"
}, {
  displayLabel: "Actual End Time",
  label: "Actual End Time",
  model: "actual_end_time"
}, {
  displayLabel: "Total Hours",
  label: "Total Hours",
  model: "hours_worked"
},
// {
//   displayLabel: "Regular Hours",
//   label: "Regular Hours",
//   model: "decimal2",
// },
// {
//   displayLabel: "OT Hours",
//   label: "OT Hours",
//   model: "decimal3",
// },
{
  displayLabel: "Paid",
  label: "Paid",
  model: "decimal4"
}, {
  displayLabel: "Admin Note",
  label: "Admin Note",
  model: "admin_notes"
}, {
  displayLabel: "Admin Notes",
  label: "Admin Notes",
  model: "list_admin_notes"
}, {
  displayLabel: "Clock In Note",
  label: "Clock In Note",
  model: "clock_in_notes"
}, {
  displayLabel: "Clock Out Note",
  label: "Clock Out Note",
  model: "clock_out_notes"
}, {
  displayLabel: "Mileage",
  label: "Mileage",
  model: "mileage"
}, {
  displayLabel: "Reimbursement",
  label: "Reimbursement",
  model: "reimbursement"
}, {
  displayLabel: "Bonus",
  label: "Bonus",
  model: "bonus"
}, {
  displayLabel: "Status",
  label: "Status",
  model: "status"
}, {
  displayLabel: "Tags",
  label: "Tags",
  model: "poster__tags"
}, {
  displayLabel: "Hours Booked",
  label: "Hours Booked",
  model: "hours_booked"
}, {
  displayLabel: "Number of Children",
  label: "Number of Children",
  model: "number_children"
}];

var DEFAULT_SHIFT_JOB_CSV_OPTIONS = exports.DEFAULT_SHIFT_JOB_CSV_OPTIONS = [{ displayLabel: "Client", label: "Client", model: "poster_name" }, { displayLabel: "Client ID", label: "Client ID", model: "poster_id" }, { displayLabel: "Date", label: "Date", model: "date" }, { displayLabel: "Candidate", label: "Candidate", model: "filler_name" }, {
  displayLabel: "Candidate ID",
  label: "Candidate ID",
  model: "filler_id"
}, { displayLabel: "Job Type", label: "Job Type", model: "job_type" }, { displayLabel: "Title", label: "Title", model: "title" }, {
  displayLabel: "Booked Start Time",
  label: "Booked Start Time",
  model: "start_time"
}, {
  displayLabel: "Booked End Time",
  label: "Booked End Time",
  model: "end_time"
}, {
  displayLabel: "Actual Start Time",
  label: "Actual Start Time",
  model: "actual_start_time"
}, {
  displayLabel: "Actual End Time",
  label: "Actual End Time",
  model: "actual_end_time"
}, {
  displayLabel: "Regular Hours",
  label: "Regular Hours",
  model: "decimal2"
}, { displayLabel: "OT Hours", label: "OT Hours", model: "decimal3" }, { displayLabel: "Paid", label: "Paid", model: "decimal4" }, {
  displayLabel: "Admin Note",
  label: "Admin Note",
  model: "admin_notes"
}, {
  displayLabel: "Clock In Note",
  label: "Clock In Note",
  model: "clock_in_notes"
}, {
  displayLabel: "Clock Out Note",
  label: "Clock Out Note",
  model: "clock_out_notes"
}, { displayLabel: "Mileage", label: "Mileage", model: "mileage" }, {
  displayLabel: "Reimbursement",
  label: "Reimbursement",
  model: "reimbursement"
}, { displayLabel: "Bonus", label: "Bonus", model: "bonus" }, { displayLabel: "Status", label: "Status", model: "status" }];

var DEFAULT_EMPLOYER_STATUSES = exports.DEFAULT_EMPLOYER_STATUSES = ["Pre Application", "Applied", "Inactive", "Application Approved", "Documents Signed",
// 'Payment Info Entered',
// "Payment Link Sent",
"Initial Payment Made", "Consultation Booked", "Consultation Complete", "Job Posted",
// "Nanny Assigned",
"Active", "Lost", "Complete"];

var DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS = exports.DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS = ["Potential Fit", "Candidate Consideration", "Candidate Interested", "Candidate Not Interested", "Declined", "Under Consideration", "No Longer Available", "Interested", "Not Interested", 'Interviewing', 'Not Interested After Interview', 'Trialing', 'Not Interested After Trial', "Offer Extended", "Assigned", "Hired", "Favorite", "Got Let Go", "Fired", "Quit", "Do Not Match"];

var DEFAULT_LIST_COLORS = exports.DEFAULT_LIST_COLORS = ["#ff6969", "#FFB6C1", "#bfbfff", "#c2c2c2", "#9c9c9c", "#6dc96d", "#f5f5dc", "#03c6fc", "#0331fc", "#00ff37"];

var DEFAULT_SHIFT_JOB_STATUSES = exports.DEFAULT_SHIFT_JOB_STATUSES = [{ status: "Requested", color: DEFAULT_LIST_COLORS[0] }, { status: "Cancelled", color: DEFAULT_LIST_COLORS[3] }, { status: "Broadcasted", color: DEFAULT_LIST_COLORS[5] }, { status: "Assigned", color: DEFAULT_LIST_COLORS[1] }, { status: "In Progress", color: DEFAULT_LIST_COLORS[2] }, { status: "Completed", color: DEFAULT_LIST_COLORS[4] }, { status: "Charged", color: DEFAULT_LIST_COLORS[7] }];

var DEFAULT_DASHBOARD_TABLE_MODELS_CANDIDATE = exports.DEFAULT_DASHBOARD_TABLE_MODELS_CANDIDATE = ["first_name_last_name", "email", "created_date", "last_login", "status"];

var DEFAULT_DASHBOARD_TABLE_MODELS_EMPLOYER = exports.DEFAULT_DASHBOARD_TABLE_MODELS_EMPLOYER = ["first_name_last_name", "email", "phone", "created_date", "status"];

var DEFAULT_DASHBOARD_TABLE_FIELDS_CANDIDATE = exports.DEFAULT_DASHBOARD_TABLE_FIELDS_CANDIDATE = [{
  displayLabel: "Name",
  model: "first_name_last_name"
}, {
  displayLabel: "Email",
  model: "email"
}, {
  displayLabel: "Registration Date",
  model: "created_date"
}, {
  displayLabel: "Last Login",
  model: "last_login"
}, {
  displayLabel: "Status",
  model: "status"
}];

var DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER = exports.DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER = [{
  displayLabel: "Name",
  model: "first_name_last_name"
}, {
  displayLabel: "Email",
  model: "email"
}, {
  displayLabel: "Phone",
  model: "phone"
}, {
  displayLabel: "Registration Date",
  model: "created_date"
}, {
  displayLabel: "Status",
  model: "status"
}];

var DEFAULT_TIME_SHEET_TABLE_FIELDS = exports.DEFAULT_TIME_SHEET_TABLE_FIELDS = [{
  displayLabel: "Candidate",
  model: "filler_name"
}, {
  displayLabel: "Client",
  model: "poster_name"
}, {
  displayLabel: "Location",
  model: "locations"
}, {
  displayLabel: "Date",
  model: "date"
}, {
  displayLabel: "Category",
  model: "category"
}, {
  displayLabel: "Title",
  model: "title"
}, {
  displayLabel: "Booked Start",
  model: "start_time"
}, {
  displayLabel: "Booked End",
  model: "end_time"
}, {
  displayLabel: "Clocked Start",
  model: "actual_start_time",
  noteModel: "clock_in_notes"
}, {
  displayLabel: "Clocked End",
  model: "actual_end_time",
  noteModel: "clock_out_notes"
}, {
  displayLabel: "Hours Worked",
  model: "hours_worked"
}, {
  displayLabel: "Candidate Pay",
  model: "total_candidate_pay"
}, {
  displayLabel: "Total Client Charge",
  model: "total_client_charge"
},
// {
//   displayLabel: "Regular"
// },
// {
//   displayLabel: "OT"
// },
// {
//   displayLabel: "Mileage",
//   model: "mileage"
// },
// {
//   displayLabel: "Paid",
//   model: "decimal4"
// },
{
  displayLabel: "Status",
  model: "status",
  noteModel: "admin_notes"
}];

var DEFAULT_MY_JOBS_TABLE_FIELDS = exports.DEFAULT_MY_JOBS_TABLE_FIELDS = [{
  displayLabel: "Date",
  model: "date"
}, {
  displayLabel: "Details",
  model: "job-details-slot"
}, {
  displayLabel: "Booked Start",
  model: "start_time"
}, {
  displayLabel: "Booked End",
  model: "end_time"
}, {
  displayLabel: "Clocked Start",
  model: "actual_start_time"
}, {
  displayLabel: "Clocked End",
  model: "actual_end_time"
}, {
  displayLabel: "Regular"
}, {
  displayLabel: "OT"
}, {
  displayLabel: "Status",
  model: "status"
}, {
  displayLabel: "Actions",
  model: "custom-actions-slot"
}];

var DEFAULT_PLACEMENT_JOB_TABLE_FIELDS = exports.DEFAULT_PLACEMENT_JOB_TABLE_FIELDS = [{
  label: "Title",
  displayLabel: "Title",
  model: "title"
}, {
  label: "Date Created",
  displayLabel: "Date Created",
  model: "created_date"
}, {
  label: "Status",
  displayLabel: "Status",
  model: "status"
}, {
  label: "Manager",
  displayLabel: "Manager",
  model: "adminName"
}, {
  label: "Client",
  displayLabel: "Client",
  model: "poster_name"
}, {
  label: "City",
  displayLabel: "City",
  model: "city"
}, {
  label: "State",
  displayLabel: "State",
  model: "provincestate"
}, {
  label: "Start Date",
  displayLabel: "Start Date",
  model: "start_date_text"
}, {
  label: "Compensation",
  displayLabel: "Compensation",
  model: "compensation"
}, {
  label: "Categories",
  displayLabel: "Categories",
  model: "types"
}];

var DEFAULT_PLACEMENT_JOB_STATUSES = exports.DEFAULT_PLACEMENT_JOB_STATUSES = ["Draft", "Requested", "Posted", "Broadcasted", "Active", "Inactive", "Interviewing", "Trialing", "Placed", "Invoice Sent", "Invoice Paid", "Replacement", "Followed Up", "Closed", "Filled"];

var DEFAULT_PROFILE_IMAGE = exports.DEFAULT_PROFILE_IMAGE = "https://d10217p7vdlmii.cloudfront.net/media/profile_pics/default_avatar.jpg";

var DEFAULT_PROFILE_IMAGE_SUFFIX = exports.DEFAULT_PROFILE_IMAGE_SUFFIX = "/media/profile_pics/default_avatar.jpg";

var DEFAULT_TEMPLATE_2_PARAMS = exports.DEFAULT_TEMPLATE_2_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "white"
  },
  userType: {
    text: "[[types]]",
    fontSize: "40px",
    fontFamily: "Arizonia",
    color: "black"
  },
  leftContent: "Click Edit button to customize content",
  rightSection1: {
    header: {
      text: "Nanny Bio",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  rightSection2: {
    header: {
      text: "Highlights",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  imgLogo: {
    width: "200px"
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  imgOther: {
    src: "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire_icon_1.1.png",
    width: "250px"
  },
  backgroundColor: {
    top: "#4e5c50",
    left: "#f9b696",
    rightHeader1: "#d5d4d2",
    rightHeader2: "#d5d4d2"
  }
};

var DEFAULT_TEMPLATE_3_PARAMS = exports.DEFAULT_TEMPLATE_3_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "#565656"
  },
  image1: {
    src: "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire_icon_1.1.png",
    width: "250px"
  },
  image2: {
    src: "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire+logo+thin+dark+1.0.png",
    width: "100px"
  },
  contentHeader: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {}
};

var DEFAULT_TEMPLATE_4_PARAMS = exports.DEFAULT_TEMPLATE_4_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "#565656"
  },
  leftContent: "Click Edit button to customize content",
  rightContent1: "Click Edit button to customize content",
  rightContent2: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {
    left: "#f9b696"
  },
  imgLogo: {
    width: "200px"
  }
};

var DEFAULT_TEMPLATE_5_PARAMS = exports.DEFAULT_TEMPLATE_5_PARAMS = {
  topContent: "Click Edit button to customize content",
  middleContent: "Click Edit button to customize content",
  leftContent: "Click Edit button to customize content",
  rightContent: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {
    bottom: "rgba(239, 224, 221, 0.6)"
  }
};

var DEFAULT_TEMPLATE_6_PARAMS = exports.DEFAULT_TEMPLATE_6_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "60px",
    fontFamily: "Open Sans",
    color: "#565656"
  },
  leftContent: "Click Edit button to customize content",
  rightContent1: "Click Edit button to customize content",
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  backgroundColor: {
    left: "#f9b696"
  },
  slogan: "Click Edit button to customize content",
  image1: {
    width: "200px",
    src: "https://d10217p7vdlmii.cloudfront.net/media/files/enginehire_icon_1.1_e098b3dc-7edb-4e4c-b69a-69975474bfb6.png"
  }
};

var DEFAULT_TEMPLATE_7_PARAMS = exports.DEFAULT_TEMPLATE_7_PARAMS = {
  topRightContent: "Click Edit button to customize content",
  bottomLeftContent: "Click Edit button to customize content",
  bottomRightContent: "Click Edit button to customize content"
};

var DEFAULT_TEMPLATE_8_PARAMS = exports.DEFAULT_TEMPLATE_8_PARAMS = {
  content: "Click Edit button to customize content"
};

var DEFAULT_TEMPLATE_9_PARAMS = exports.DEFAULT_TEMPLATE_9_PARAMS = {
  presentedByText: {
    text: "Presented by",
    fontSize: "16px"
  },
  imgLogo: {
    height: "50px"
  },
  topRight: {
    content: "Click Edit button to customize content"
  },
  bottomLeft: {
    content: "Click Edit button to customize content"
  },
  bottomRight: {
    content: "Click Edit button to customize content"
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE,
    height: '180px'
  },
  backgroundColor: {
    left: '#f3efed',
    separatorBar: '#ded5cc'
  },
  separatorBarHeight: "50px"
};

var DEFAULT_TEMPLATE_11_PARAMS = exports.DEFAULT_TEMPLATE_11_PARAMS = {
  imgLogo: {
    height: "50px"
  },
  topRight: {
    content: "Click Edit button to customize content"
  },
  bottomLeft: {
    content: "Click Edit button to customize content"
  },
  bottomRight: {
    content: "Click Edit button to customize content"
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE,
    height: '180px'
  },
  backgroundColor: {
    left: '#f3efed',
    separatorBar: '#ded5cc'
  }
};

var DEFAULT_NAV_BAR_COLOR = exports.DEFAULT_NAV_BAR_COLOR = "#e9ecef";
var DEFAULT_NAV_BAR_TEXT_COLOR = exports.DEFAULT_NAV_BAR_TEXT_COLOR = "#1f4e78";
var DEFAULT_COLOR_PICKER_OPTIONS = exports.DEFAULT_COLOR_PICKER_OPTIONS = ["#1FBC9C", "#1CA085", "#2ECC70", "#27AF60", "#3398DB", "#2980B9", "#A463BF", "#8E43AD", "#3D556E", "#222F3D", "#F2C511", "#F39C19", "#E84B3C", "#C0382B", "#DDE6E8", "#BDC3C8"];

var DEFAULT_FAVICON_URL = exports.DEFAULT_FAVICON_URL = "https://agency.enginehire.io/favicon1.1.ico";

var DEFAULT_HEADING_CANDIDATE_INTERVIEW = exports.DEFAULT_HEADING_CANDIDATE_INTERVIEW = ["Phone Screen Notes", "Interview Notes", "Candidate Interview 3", "Candidate Interview 4"];

var DEFAULT_HEADING_CLIENT_INTERVIEW = exports.DEFAULT_HEADING_CLIENT_INTERVIEW = ["Welcome Call Notes", "Consultation Notes", "Client Interview 3", "Client Interview 4"];

var DEFAULT_PLACEMENT_JOB_BOARD_FIELDS = exports.DEFAULT_PLACEMENT_JOB_BOARD_FIELDS = [{
  label: "Compensation",
  displayLabel: "Compensation",
  model: "compensation"
}, {
  label: "Children Description",
  displayLabel: "Children",
  model: "children_description"
}, { label: "Start Date Text", displayLabel: "Start", model: "start_date_text" },
// { label: "Date", displayLabel: "Start Date", model: "date" },
{ label: "Text", displayLabel: "Schedule", model: "text" }, { label: "Location", displayLabel: "Location", model: "location" }];

var DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS = exports.DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS = [{ label: "Location", displayLabel: "Location", model: "location" }, { label: "Start Date Text", displayLabel: "Start", model: "start_date_text" }, { label: "Date", displayLabel: "Start Date", model: "date" }, { label: "Start Time", displayLabel: "Start Time", model: "start_time" }, { label: "End Time", displayLabel: "End Time", model: "end_time" }, { label: "Candidate Rate", displayLabel: "Hourly Rate", model: "candidate_rate" }, { label: "Travel Fee", displayLabel: "Travel Fee", model: "travel_fee" }, {
  label: "Children Description",
  displayLabel: "Children",
  model: "children_description"
}, {
  label: "Compensation",
  displayLabel: "Compensation",
  model: "compensation"
}, { label: "Text", displayLabel: "Schedule", model: "text" }, { label: "Description", displayLabel: "Description", model: "description" }];

var DEFAULT_DISCLAIMER_TEXT = exports.DEFAULT_DISCLAIMER_TEXT = "Rates are subject to change, the\nrate seen above is an approximation and may change based on your\nspecific circumstance once reviewed by our staff.";
var DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE = exports.DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE = "We do not have anyone available for this time at the moment, but you can still submit your request and we will try to match you with someone!";
var DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE = exports.DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE = "Unfortunately, there are no candidates currently available for the date and time you've selected.";
var DEFAULT_STATUS_REQUIRE_REASON_CHANGE = exports.DEFAULT_STATUS_REQUIRE_REASON_CHANGE = ['Rejected', 'Inactive'];

var BOOKING_RESULT_DEFAULT_FIELDS = exports.BOOKING_RESULT_DEFAULT_FIELDS = [{
  displayLabel: "Clocked Start Date",
  label: "Clocked Start Date",
  model: "actual_start_date",
  type: _customDefineType.FORM_TYPE.DATEPICKER,
  itemPerRow: 2,
  isRequired: false
}, {
  displayLabel: "Clocked End Date",
  label: "Clocked End Date",
  model: "actual_end_date",
  type: _customDefineType.FORM_TYPE.DATEPICKER,
  itemPerRow: 2,
  isRequired: false
}, {
  displayLabel: "Clocked Start Time",
  label: "Clocked Start Time",
  model: "actual_start_time",
  type: _customDefineType.FORM_TYPE.TIME_PICKER,
  itemPerRow: 2,
  isRequired: false
}, {
  displayLabel: "Clocked End Time",
  label: "Clocked End Time",
  model: "actual_end_time",
  type: _customDefineType.FORM_TYPE.TIME_PICKER,
  itemPerRow: 2,
  isRequired: false
}, {
  displayLabel: "Breaks",
  label: "Breaks",
  model: "breaks"
}, {
  displayLabel: "Hours Worked",
  label: "Hours Worked",
  model: "hours_worked",
  isRequired: false
}, {
  displayLabel: "Regular Hours",
  label: "Regular Hours",
  model: "regular_hours"
}, {
  displayLabel: "OT Hours",
  label: "OT Hours",
  model: "ot_hours"
}, {
  displayLabel: "Total Paid",
  label: "Total Paid",
  model: "decimal4",
  isRequired: false,
  prefix: "$"
}, {
  displayLabel: "Clock In Notes",
  label: "Clock In Notes",
  model: "clock_in_notes",
  type: _customDefineType.FORM_TYPE.TEXTAREA,
  isRequired: false
}, {
  displayLabel: "Clock Out Notes",
  label: "Clock Out Notes",
  model: "clock_out_notes",
  type: _customDefineType.FORM_TYPE.TEXTAREA,
  isRequired: false
}, {
  displayLabel: "Admin Notes",
  label: "Admin Notes",
  model: "admin_notes",
  type: _customDefineType.FORM_TYPE.TEXTAREA,
  isRequired: false
}];
var DEFAULT_DO_NOT_WANT_AGAIN_TEXT = exports.DEFAULT_DO_NOT_WANT_AGAIN_TEXT = "We will do our best to connect you with others in the future.";

var DEFAULT_SHIFT_JOB_CALENDAR_TITLE = exports.DEFAULT_SHIFT_JOB_CALENDAR_TITLE = "[[poster_name]] [[start_time]] - [[end_time]] [[title]] ([[status]] - [[filler_name]]) {[[number_application]]}";

var DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD = exports.DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD = "[[poster_first_name]] [[start_time]] - [[end_time]]";

var DEFAULT_LOGIN_PAGE_HELPER_TEXT = exports.DEFAULT_LOGIN_PAGE_HELPER_TEXT = "First time logging in? Please try your email address as your password!";

var DEFAULT_REQUEST_TIME_OFF_CATEGORIES = exports.DEFAULT_REQUEST_TIME_OFF_CATEGORIES = ['Holiday', 'Sick', 'Unpaid', 'Paid'];

var DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST = exports.DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST = ['Client Cancelled', 'Candidate Cancelled', 'Other'];

var DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS = exports.DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS = [{
  label: "Booked Date",
  displayLabel: "Booked Date",
  model: "date"
}, {
  label: "Booked Start Time",
  displayLabel: "Booked Start Time",
  model: "start_time"
}, {
  label: "Booked End Time",
  displayLabel: "Booked End Time",
  model: "end_time"
}, {
  label: "Poster",
  displayLabel: "Poster",
  model: "poster_name"
}, {
  label: "Distance",
  displayLabel: "Distance",
  model: "distance"
}];

var DEFAULT_CANDIDATE_TABLE_JOB_FIELD_KEYS = exports.DEFAULT_CANDIDATE_TABLE_JOB_FIELD_KEYS = 'id,date,end_date,start_time,end_time,status,title,category,filled,filler,filler_id,filler_name,poster,poster_id,poster_name,poster__first_name,poster__last_name,poster__types,poster__status,poster__tags,poster__locations,poster__email,poster__employer_name,decimal4,mileage,actual_start_date,actual_start_time,actual_end_date,actual_end_time,agency_id,locations,location,latitude,longitude,text3,text4,text5,admin_notes,hours_worked,total_candidate_pay,total_client_charge,tip,admin_fee,admin_fee_subtraction,rush_fee,per_booking_agency_fee,per_booking_candidate_fee,additional_fee,breaks,clock_in_notes,clock_out_notes,candidate_rate,client_rate,agency_fee,travel_fee,poster__stripe_customer_id,filler__stripe_connect_id,poster__authorize_net_profile,address1,address2,scraper_account__account_type,scraper_account__name,selector1,agency,type,city';

var DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE = exports.DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE = '<h2>You are committing to filling this job, are you sure?</h2>';

var DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT = exports.DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT = 'Accept Job';

var USER_EXPORT_OPTIONS = exports.USER_EXPORT_OPTIONS = [{
  displayLabel: "First Name",
  label: "First Name",
  model: "first_name"
}, { displayLabel: "Last Name", label: "Last Name", model: "last_name" }, { displayLabel: "Email", label: "Email", model: "email" }, { displayLabel: "Status", label: "Status", model: "status" }, {
  displayLabel: "Date Registered",
  label: "Date Registered",
  model: "created_date"
}, { displayLabel: "User ID", label: "User ID", model: "id" }, {
  displayLabel: "Address",
  label: "Address",
  model: "address1"
}, {
  displayLabel: "Address 2",
  label: "Address 2",
  model: "address2"
}, { displayLabel: "City", label: "City", model: "city" }, {
  displayLabel: "Postal Code",
  label: "Postal Code",
  model: "postal_code"
}, {
  displayLabel: "State",
  label: "State",
  model: "provincestate"
}, {
  displayLabel: "Country",
  label: "Country",
  model: "country"
}, {
  displayLabel: "Phone",
  label: "Phone",
  model: "phone"
}, {
  displayLabel: "Phone 2",
  label: "Phone 2",
  model: "phone2"
}, { displayLabel: "Email 2", label: "Email 2", model: "email2" }, {
  displayLabel: "Last Login",
  label: "Last Login",
  model: "last_login"
}, {
  displayLabel: "Types",
  label: "Types",
  model: "types"
}, {
  displayLabel: "Time in Status",
  label: "Time in Status",
  model: "time_in_status"
}];

var DEFAULT_USER_EXPORT_OPTIONS = exports.DEFAULT_USER_EXPORT_OPTIONS = [{
  displayLabel: "First Name",
  label: "First Name",
  model: "first_name"
}, { displayLabel: "Last Name", label: "Last Name", model: "last_name" }, { displayLabel: "Email", label: "Email", model: "email" }, { displayLabel: "Status", label: "Status", model: "status" }, {
  displayLabel: "Date Registered",
  label: "Date Registered",
  model: "created_date"
}, {
  displayLabel: "Address",
  label: "Address",
  model: "address1"
}, { displayLabel: "City", label: "City", model: "city" }, {
  displayLabel: "Postal Code",
  label: "Postal Code",
  model: "postal_code"
}, {
  displayLabel: "State",
  label: "State",
  model: "provincestate"
}, {
  displayLabel: "Phone",
  label: "Phone",
  model: "phone"
}, {
  displayLabel: "Last Login",
  label: "Last Login",
  model: "last_login"
}, {
  displayLabel: "Profile Link",
  label: "Profile Link",
  model: "profile_link"
}];

var DEFAULT_ANALYTICS_DASHBOARD_SELECTION = exports.DEFAULT_ANALYTICS_DASHBOARD_SELECTION = ["types", "tags", "locations"];

var DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT = exports.DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT = "I have a problem";
var DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL = exports.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL = "Upload Files";
var DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION = exports.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION = "Please upload files";
var DEFAULT_REPORT_PROBLEM_NOTE_LABEL = exports.DEFAULT_REPORT_PROBLEM_NOTE_LABEL = "Additional Notes";

var DEFAULT_DATEPICKER_FIELD = exports.DEFAULT_DATEPICKER_FIELD = {
  FORMAT: "YYYY-MM-DD",
  PLACEHOLDER: "YYYY-MM-DD"
};

var DEFAULT_PROFILE_TOP_WELCOME_TEXT = exports.DEFAULT_PROFILE_TOP_WELCOME_TEXT = "Welcome to [[agency_name]], [[first_name]]";

var DEFAULT_SCHEDULE_EVENT_TYPES = exports.DEFAULT_SCHEDULE_EVENT_TYPES = ["Phone Interview", "Video Interview", "In Person Interview", "Other"];

var DEFAULT_EMAIL_STATUSES = exports.DEFAULT_EMAIL_STATUSES = {
  Open: {
    display: "Opened",
    color: "green"
  },
  Delivery: {
    display: "Delivered",
    color: "blue"
  },
  Bounce: {
    display: "Bounce",
    color: "gray"
  }
};

var DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED = exports.DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED = "Mark as Completed";
var DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED = exports.DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED = "Completed";

var ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS = exports.ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS = [{
  label: "Types",
  model: "types",
  isMulti: true
}, {
  label: "Tags",
  model: "tags",
  isMulti: true
}, {
  label: "Locations",
  model: "locations",
  isMulti: true
}, {
  label: "Status",
  model: "status"
}];

var DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS = exports.DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS = [{
  label: "Reference Name",
  displayLabel: "Reference Name",
  model: "reference_name"
}, {
  label: "User Name",
  displayLabel: "User Name",
  model: "user_name"
}, {
  label: "User Status",
  displayLabel: "User Status",
  model: "reference_provider_status"
}, {
  label: "User Second Status",
  displayLabel: "User Second Status",
  model: "reference_provider_second_status"
}, {
  label: "Phone Number",
  displayLabel: "Phone Number",
  model: "phone"
}, {
  label: "Email Address",
  displayLabel: "Email Address",
  model: "email"
}, {
  label: "Locations",
  displayLabel: "Locations",
  model: "reference_provider_locations"
}, {
  label: "Check Completion Date",
  displayLabel: "Check Completion Date",
  model: "check_completion_date"
}, {
  label: "IP Tracking",
  displayLabel: "IP Tracking",
  model: "ip_address"
}];

var DEFAULT_TEMPLATE_10_PARAMS = exports.DEFAULT_TEMPLATE_10_PARAMS = {
  nameHeader: {
    text: "[[first_name]] [[last_name]]",
    fontSize: "30px",
    fontFamily: "Open Sans",
    color: "white"
  },
  userType: {
    text: "[[types]]",
    fontSize: "40px",
    fontFamily: "Arizonia",
    color: "black"
  },
  aboutMeSection: {
    header: {
      text: "About Me",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  rightSection1: {
    header: {
      text: "Info Details",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  rightSection2: {
    header: {
      text: "Achievements",
      fontSize: "40px",
      fontFamily: "Open Sans",
      color: "black"
    },
    content: "Click Edit button to customize content"
  },
  imgLogo: {
    width: "200px"
  },
  imgProfile: {
    src: DEFAULT_PROFILE_IMAGE
  },
  imgOther: {
    src: "https://s3.ca-central-1.amazonaws.com/agency.enginehire.io/graphics/enginehire_icon_1.1.png",
    width: "140px",
    height: "140px"
  },
  backgroundColor: "#f9b696",
  backgroundImage: ''
};

var DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES = exports.DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES = '<h5>The date is full and the booking request will be added to the waitlist</h5>';

var DEFAULT_PRICE_INFO_ITEMS_PLACEMENT = exports.DEFAULT_PRICE_INFO_ITEMS_PLACEMENT = ['Booking Rate', 'Client Rate', 'Candidate Rate', 'Agency Fee', 'Travel Fee', 'Rush Fee', 'Candidate Rush Fee', 'Booking Fee', 'Per Booking Fee', 'Per Booking Agency Fee', 'Per Booking Candidate Fee'];

var DEFAULT_PLACEMENT_JOB_FILTER_FIELDS = exports.DEFAULT_PLACEMENT_JOB_FILTER_FIELDS = [{
  label: "Filter by Status",
  model: "status"
}, {
  label: "Filter by Locations",
  model: "locations"
}, {
  label: "Filter by Manager",
  model: "admin_manager"
}, {
  label: "Filter by Client",
  model: "poster_id"
}, {
  label: "Filter by Categories",
  model: "types"
}];

var DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES = exports.DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES = ["Potential Fit", "Candidate Consideration", "Candidate Interested", "Candidate Not Interested", "Do Not Match"];

var DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR = exports.DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR = "\n  <h4>\n  Hello! Sorry, our office hours are from [[office_hour_from]] to [[office_hour_to]]<br/>\n  Please book during this time and we will be happy to assist you!\n  </h4>\n";

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var createDesc = __webpack_require__(47);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var hide = __webpack_require__(19);
var has = __webpack_require__(23);
var SRC = __webpack_require__(48)('src');
var $toString = __webpack_require__(298);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(29).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(8);
var defined = __webpack_require__(36);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(189);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(69);
var defined = __webpack_require__(36);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(70);
var createDesc = __webpack_require__(47);
var toIObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(35);
var has = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(151);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(23);
var toObject = __webpack_require__(16);
var IE_PROTO = __webpack_require__(106)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var tryGet = function tryGet(value) {
  try {
    var r = value();
    if (typeof r !== "undefined") {
      if (r === null) {
        return "";
      }
      return r;
    }
    return "";
  } catch (e) {
    return "";
  }
};

exports.default = tryGet;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(18);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(8);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc823762_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDialog_vue__ = __webpack_require__(535);
function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc823762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc823762_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(29);
var fails = __webpack_require__(8);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(30);
var IObject = __webpack_require__(69);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var asc = __webpack_require__(122);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(246);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(14)) {
  var LIBRARY = __webpack_require__(42);
  var global = __webpack_require__(7);
  var fails = __webpack_require__(8);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(87);
  var $buffer = __webpack_require__(130);
  var ctx = __webpack_require__(30);
  var anInstance = __webpack_require__(54);
  var propertyDesc = __webpack_require__(47);
  var hide = __webpack_require__(19);
  var redefineAll = __webpack_require__(56);
  var toInteger = __webpack_require__(32);
  var toLength = __webpack_require__(13);
  var toIndex = __webpack_require__(179);
  var toAbsoluteIndex = __webpack_require__(50);
  var toPrimitive = __webpack_require__(35);
  var has = __webpack_require__(23);
  var classof = __webpack_require__(62);
  var isObject = __webpack_require__(10);
  var toObject = __webpack_require__(16);
  var isArrayIter = __webpack_require__(119);
  var create = __webpack_require__(51);
  var getPrototypeOf = __webpack_require__(26);
  var gOPN = __webpack_require__(52).f;
  var getIterFn = __webpack_require__(121);
  var uid = __webpack_require__(48);
  var wks = __webpack_require__(12);
  var createArrayMethod = __webpack_require__(38);
  var createArrayIncludes = __webpack_require__(77);
  var speciesConstructor = __webpack_require__(72);
  var ArrayIterators = __webpack_require__(124);
  var Iterators = __webpack_require__(64);
  var $iterDetect = __webpack_require__(82);
  var setSpecies = __webpack_require__(53);
  var arrayFill = __webpack_require__(123);
  var arrayCopyWithin = __webpack_require__(168);
  var $DP = __webpack_require__(15);
  var $GOPD = __webpack_require__(25);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(174);
var $export = __webpack_require__(0);
var shared = __webpack_require__(68)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(177))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(48)('meta');
var isObject = __webpack_require__(10);
var has = __webpack_require__(23);
var setDesc = __webpack_require__(15).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(8)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(12)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(19)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAP_FIELD_TYPES = exports.LIST_COMMON_FIELDS = exports.MAP_DIALOG_SECTION = exports.MAP_REQUIRE_KEYS = exports.LIST_BOOLEAN_OTHER_PROPERTY = exports.MAP_MODEL_OTHER_PROPERTIES = exports.MAP_OTHER_PROPERTIES = undefined;

var _customDefineType = __webpack_require__(6);

var _modelByTypes = __webpack_require__(91);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MAP_OTHER_PROPERTIES = exports.MAP_OTHER_PROPERTIES = {
    PLACE_HOLDER: "Place Holder",
    OPTION_LIST: "Option List",
    //   MAX_LENGTH: "Max Length",
    //   VALUE_TYPE: "Value Type",
    FILE_TYPE: "File Type",
    SHOW_CONDITION: "Show Condition",
    SHOW_CONDITION_ADVANCE: "Advance Show Condition",
    SECONDARY_SHOW_CONDITION: "Secondary Show Condition",
    THIRD_SHOW_CONDITION: "Third Show Condition",
    HAS_OTHER: "Has Other", // In some case, checkbox or radio group has last option is 'Other', By select 'Other', it show a textbox to input custom value
    INITIAL_VIEW: "Initial View",
    SECTION_TYPE: "Section Type",
    DESCRIPTION: "Field Remark",
    BOTTOM_DESCRIPTION: "Field Remark (Bottom)",
    ADMIN_DESCRIPTION: "Field Remark (Admin Only)",
    GRADE_LIST: "Grade List",
    NUMBER_OF_COLUMN: "Number Of Columns",
    TEXTBOX_OPTION: "Textbox Option",
    ITEM_LIST: "Item List",
    HEADER_LIST: "Header List",
    INITIAL_VALUE: "Initial Value (Value when object is created)",
    DEFAULT_OPTION: "Default Value 1",
    DEFAULT_MULTI_OPTIONS: "Default Value 2",
    DEFAULT_VALUE: "Default Value 3",
    DEFAULT_VALUE_MULTI_LINES: "Default Value 4",
    DEFAULT_TIME: "Default Time",
    HIDE_SECTION_TITLE: "Hide Section Title", // In case of section, there are some case there is no section title
    SHOW_AT_TOP: "Show at top", // In case of upload image (for example: profile picture), display the image at top right of section
    HIDE_SALARY_PERIOD: "Hide Salary Period", // In case of salary range, Hide or show period (per year/month/week/hour)
    CUSTOMIZABLE_ITEM_LIST: "Customizable Item List", // Can add or remove item of checkbox table
    /*
    This property specifies if the model is share between several fields
    This is used to be compatible with older version, in which several fields are stored in one model
    For example: [firstName, lastName] store in 'features'
    */
    SHARE_MODEL: "Share Model",
    USE_DUPLICATE_MODEL: "Use Duplicate Model", // This property specifies if we want to reuse a model for more than 1 field
    HAS_CHECK_ALL: "Has Check All", // In case of checkbox group, display a checkbox to check all other checkboxes
    MINUTES_INTERVAL: "Minutes Interval",
    IS_24_HOUR_FORMAT: "is 24 Hour Format",
    IS_HTML: "Is HTML Format", // In case of checkbox group, display option by HTML format
    MAX_FILE_SIZE: "Max size",
    CUSTOM_LABEL: "Custom labels",
    CUSTOM_DATE_FORMAT: "Custom Date Format",
    APPEND_TO_BODY: "Show Datepicker Over Modal",
    SEARCHABLE: "Searchable",
    OPEN_ON_SELECT: "Open on Select",
    IS_ARRAY_MODEL: "Is Array Model",
    USE_TIME_PICKER: "Use Time Picker",
    EXCLUSIVE_OPTIONS: "Exclusive Options",
    IS_PRECONDITION_CHECK: "Is Precondition Check",
    HAS_NOTE: "Has Note Column",
    HAS_TIME_OFF: "Has Time Off Column",
    MESSAGE_ON_CLICK: "Show dialog when click item",
    COLLAPSE_BY_DEFAULT: "Collapse section by default",
    IS_PRIVATE: "Is Private",
    IS_ADMIN_ONLY_SECTION: "Is Admin Only Section",
    IS_ADMIN_ONLY: "Is Admin Only",
    SCROLL_TO_NEXT_ITEM_ON_SELECT: "Scroll to next item on Select",
    SHOW_IN_ADMIN_PANEL: "Only Show In Admin Panel",
    SHOW_IN_INTERVIEW_PANEL: "Only Show In Interview Panel",
    IS_HIDDEN: "Is Hidden",
    HIDE_DESCRIPTION_IN_VIEW_SCREEN: "Hide Field Remark in View Screen",
    HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN: "Hide Field Remark (Admin Only) in View Screen",
    EXCLUDE_CHILDREN_QUESTION: "Exclude Children Question",
    EXCLUDE_ADDRESS_QUESTION: "Exclude Address Question",
    EXCLUDE_REPEAT_BOOKING: "Exclude Repeat Booking",
    HAS_NUMBER_CANDIDATE_QUESTION: "Has Number of Candidate Question",
    HIDE_ADDITIONAL_DATES_QUESTION: "Hide Additional Dates Question",
    HIDE_LABEL: "Hide Label",
    SHOW_DOWNLOAD_FILE: "Show Download Reference Check File",
    BOOKING_REQUIRE_PAYMENT_INFO: "Payment information is required for booking",
    SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS: "For recurring requests select all days",
    CHARGE_CLIENT_WHEN_ASSIGN_CANDIDATE: "Charge Client when candidate is assigned",
    BLANK_FILE_URL: "Has Blank Document Template",
    MIN_DURATION_ALLOW_EDIT_BOOKING: "Not allow edit booking within x hours",
    MIN_DURATION_ALLOW_ADD_BOOKING: "Not allow to book within x hours",
    HIDE_DETAIL_LABEL: "Hide Label when View Profile",
    SHOW_IN_PROFILE: "Show In User Profile",
    HIDE_IN_PROFILE: "Hide In User Profile",
    SHOW_IN_EDIT_PROFILE: "Show In Edit Profile Dialog",
    CHARGE_ON_SUBMIT: "Charge on Submit",
    HAS_DERIVED_MODEL: "Has derived model",
    IS_INTEGER_FIELD: "Is Integer Field",
    IS_FLOAT_FIELD: "Is Float Field",
    NOT_REQUIRED_IN_APPLICATION: "Not Required In Application",
    NOT_IN_APPLICATION: "Not on application but in profile",
    SHOW_AGE: "Show Age",
    SHOW_PASSED_TIMES: "Show how much time has passed",
    SHOW_PUBLIC_FORM_LINK: "Show Public Form Link",
    SHOW_IN_CANDIDATE_VIEW: "Show In Candidate View",
    IS_UNIQUE: "Unique Values",
    IS_IN_PLACEMENT_INFO_TAB: "Show in placement information tab",
    HAS_CONFIRM_FIELD: "Has Confirmation Field",
    EXCLUDE_FROM_SUMMARY_EMAIL: "Exclude from summary email",
    ADMIN_CAN_ADD_OPTION: "Admin Can Add Option",
    POPULATE_WEEK_AVAILABILITIES: "Populate Week Availabilities",
    INFO_ONCE_EXPIRED: "Information once expired",
    CAN_ADD_MULTIPLE: "Can add multiple",
    IS_A_PHONE_NUMBER: "Is a phone number",
    ONLY_ONE_CHECKED_ITEM_REQUIRED: "Only require 1 checked item"
};

var MAP_MODEL_OTHER_PROPERTIES = exports.MAP_MODEL_OTHER_PROPERTIES = {
    placeholder: [MAP_OTHER_PROPERTIES.PLACE_HOLDER],
    fileType: [MAP_OTHER_PROPERTIES.FILE_TYPE],
    showIf: [MAP_OTHER_PROPERTIES.SHOW_CONDITION],
    showIfAdvance: [MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfSecondary: [MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION],
    showIfThird: [MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION],
    showIfValue: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfEmpty: [MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfValueNot: [MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfValueSecondary: [MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION],
    showIfValueThird: [MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION],
    hasOther: [MAP_OTHER_PROPERTIES.HAS_OTHER],
    hasCheckAll: [MAP_OTHER_PROPERTIES.HAS_CHECK_ALL],
    isHtml: [MAP_OTHER_PROPERTIES.IS_HTML],
    initialView: [MAP_OTHER_PROPERTIES.INITIAL_VIEW],
    description: [MAP_OTHER_PROPERTIES.DESCRIPTION],
    bottomDescription: [MAP_OTHER_PROPERTIES.BOTTOM_DESCRIPTION],
    adminDescription: [MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION],
    gradeList: [MAP_OTHER_PROPERTIES.GRADE_LIST],
    numberOfColumn: [MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN],
    textboxOption: [MAP_OTHER_PROPERTIES.TEXTBOX_OPTION],
    defaultValue: [MAP_OTHER_PROPERTIES.DEFAULT_OPTION, MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS, MAP_OTHER_PROPERTIES.DEFAULT_VALUE, MAP_OTHER_PROPERTIES.DEFAULT_VALUE_MULTI_LINES],
    initialValue: [MAP_OTHER_PROPERTIES.INITIAL_VALUE],
    hideSectionTitle: [MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE],
    showAtTop: [MAP_OTHER_PROPERTIES.SHOW_AT_TOP],
    hidePeriod: [MAP_OTHER_PROPERTIES.HIDE_SALARY_PERIOD],
    customizableItemList: [MAP_OTHER_PROPERTIES.CUSTOMIZABLE_ITEM_LIST],
    isShareModel: [MAP_OTHER_PROPERTIES.SHARE_MODEL],
    shareModelIndex: [MAP_OTHER_PROPERTIES.SHARE_MODEL],
    useDuplicateModel: [MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL],
    maxSize: [MAP_OTHER_PROPERTIES.MAX_FILE_SIZE],
    customLabels: [MAP_OTHER_PROPERTIES.CUSTOM_LABEL],
    customDateFormat: [MAP_OTHER_PROPERTIES.CUSTOM_DATE_FORMAT],
    searchable: [MAP_OTHER_PROPERTIES.SEARCHABLE],
    openOnSelect: [MAP_OTHER_PROPERTIES.OPEN_ON_SELECT],
    isArrayModel: [MAP_OTHER_PROPERTIES.IS_ARRAY_MODEL],
    useTimePicker: [MAP_OTHER_PROPERTIES.USE_TIME_PICKER],
    exclusiveOptions: [MAP_OTHER_PROPERTIES.EXCLUSIVE_OPTIONS],
    isPreconditionCheck: [MAP_OTHER_PROPERTIES.IS_PRECONDITION_CHECK],
    hasNote: [MAP_OTHER_PROPERTIES.HAS_NOTE],
    hasTimeOff: [MAP_OTHER_PROPERTIES.HAS_TIME_OFF],
    isShowDialog: [MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK],
    collapseByDefault: [MAP_OTHER_PROPERTIES.COLLAPSE_BY_DEFAULT],
    isPrivate: [MAP_OTHER_PROPERTIES.IS_PRIVATE],
    isAdminOnlySection: [MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY_SECTION],
    isAdminOnly: [MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY],
    scrollToNextItem: [MAP_OTHER_PROPERTIES.SCROLL_TO_NEXT_ITEM_ON_SELECT],
    showInAdminPanel: [MAP_OTHER_PROPERTIES.SHOW_IN_ADMIN_PANEL],
    showInInterviewPanel: [MAP_OTHER_PROPERTIES.SHOW_IN_INTERVIEW_PANEL],
    isHidden: [MAP_OTHER_PROPERTIES.IS_HIDDEN],
    hideDescriptionInViewScreen: [MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN],
    hideAdminDescriptionInViewScreen: [MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN],
    excludeChildrenQuestion: [MAP_OTHER_PROPERTIES.EXCLUDE_CHILDREN_QUESTION],
    excludeAddressQuestion: [MAP_OTHER_PROPERTIES.EXCLUDE_ADDRESS_QUESTION],
    hasNumberCandidateQuestion: [MAP_OTHER_PROPERTIES.HAS_NUMBER_CANDIDATE_QUESTION],
    hideAdditionalDateQuestion: [MAP_OTHER_PROPERTIES.HIDE_ADDITIONAL_DATES_QUESTION],
    hideLabel: [MAP_OTHER_PROPERTIES.HIDE_LABEL],
    excludeRepeatBooking: [MAP_OTHER_PROPERTIES.EXCLUDE_REPEAT_BOOKING],
    showDownloadFile: [MAP_OTHER_PROPERTIES.SHOW_DOWNLOAD_FILE],
    bookingRequirePaymentInfo: [MAP_OTHER_PROPERTIES.BOOKING_REQUIRE_PAYMENT_INFO],
    selectAllDaysForRecurringRequests: [MAP_OTHER_PROPERTIES.SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS],
    chargeClientWhenAssignCandidate: [MAP_OTHER_PROPERTIES.CHARGE_CLIENT_WHEN_ASSIGN_CANDIDATE],
    minDurationAllowEditBooking: [MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_EDIT_BOOKING],
    minDurationAllowAddBooking: [MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_ADD_BOOKING],
    hideDetailLabel: [MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL],
    showInProfile: [MAP_OTHER_PROPERTIES.SHOW_IN_PROFILE],
    hideInProfile: [MAP_OTHER_PROPERTIES.HIDE_IN_PROFILE],
    showInEditProfile: [MAP_OTHER_PROPERTIES.SHOW_IN_EDIT_PROFILE],
    chargeOnSubmit: [MAP_OTHER_PROPERTIES.CHARGE_ON_SUBMIT],
    hasDerivedModel: [MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL],
    isIntegerField: [MAP_OTHER_PROPERTIES.IS_INTEGER_FIELD],
    isFloatField: [MAP_OTHER_PROPERTIES.IS_FLOAT_FIELD],
    notRequiredInApplication: [MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION],
    notInApplication: [MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
    showAge: [MAP_OTHER_PROPERTIES.SHOW_AGE],
    showPassedTime: [MAP_OTHER_PROPERTIES.SHOW_PASSED_TIMES],
    showPublicFormLink: [MAP_OTHER_PROPERTIES.SHOW_PUBLIC_FORM_LINK],
    showInCandidateView: [MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
    isUnique: [MAP_OTHER_PROPERTIES.IS_UNIQUE],
    isInPlacementInfoTab: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
    hasConfirmField: [MAP_OTHER_PROPERTIES.HAS_CONFIRM_FIELD],
    excludeFromSummaryEmail: [MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL],
    adminCanAddOption: [MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION],
    populateWeekAvailabilities: [MAP_OTHER_PROPERTIES.POPULATE_WEEK_AVAILABILITIES],
    canAddMultiple: [MAP_OTHER_PROPERTIES.CAN_ADD_MULTIPLE],
    isAPhoneNumber: [MAP_OTHER_PROPERTIES.IS_A_PHONE_NUMBER],
    onlyRequiredOneCheckedItem: [MAP_OTHER_PROPERTIES.ONLY_ONE_CHECKED_ITEM_REQUIRED]
};

var LIST_BOOLEAN_OTHER_PROPERTY = exports.LIST_BOOLEAN_OTHER_PROPERTY = ["hasOther", "hasCheckAll", "isHtml", "allowPastDate", "hideSectionTitle", "showAtTop", "hidePeriod", "customizableItemList", "isShareModel", "useDuplicateModel", "isOptional", "searchable", "openOnSelect", "isArrayModel", "useTimePicker", "isPreconditionCheck", "hasNote", "hasTimeOff", "isShowDialog", "collapseByDefault", "isPrivate", "isAdminOnlySection", "isAdminOnly", "scrollToNextItem", "showInAdminPanel", "showInInterviewPanel", "isHidden", "hideDescriptionInViewScreen", "hideAdminDescriptionInViewScreen", "isInPlacementInfoTab", "excludeChildrenQuestion", "excludeAddressQuestion", "hasNumberCandidateQuestion", "hideAdditionalDateQuestion", "hideLabel", "excludeRepeatBooking", "showDownloadFile", "bookingRequirePaymentInfo", "selectAllDaysForRecurringRequests", "hideDetailLabel", "showInProfile", "showInEditProfile", "hideInProfile", "chargeOnSubmit", "hasDerivedModel", "showPublicFormLink", "isIntegerField", "isFloatField", "notRequiredInApplication", "notInApplication", "showInCandidateView", "hasConfirmField", "excludeFromSummaryEmail", "isUnique", "adminCanAddOption", "chargeClientWhenAssignCandidate", "populateWeekAvailabilities", "showPassedTime", "canAddMultiple", "isAPhoneNumber", "onlyRequiredOneCheckedItem"];

var MAP_REQUIRE_KEYS = exports.MAP_REQUIRE_KEYS = {
    LABEL: "label",
    OPTION_LIST: "optionList",
    ITEM_LIST: "itemList",
    HEADER_LIST: "headerList",
    LIST_DAYS: "listDays",
    NAME: "name",
    SECTION_BUILDER_ID: "sectionBuilderId",
    FILE_INFO_BUILDER_ID: "fileInfoBuilderId",
    MODEL: "model",
    GRADE_LIST: "gradeList",
    DOCUMENT_TEMPLATE_ID: "documentTemplateId",
    EVALUATION_TEMPLATE_ID: "evaluationTemplateId",
    HTML_KEY: "html",
    LABEL_MODEL: "labelModel",
    PRODUCT_LIST: "productList",
    DESCRIPTION_LIST: "descriptionList",
    ICON_LIST: "iconList",
    PRICE_LIST: "priceList",
    HTML_LIST: "htmlList",
    CREDIT_NUMBER_LIST: "creditNumberList",
    OPTION: "option",
    LOG_ITEM: "logItem",
    CONFIRM_LABEL: "confirmLabel",
    PRESET_SECTION: "presetSection",
    PRESET_FIELDS: "presetFields",
    PAYMENT_TYPE: "paymentType",
    STEP_INDEX: "stepIndex",
    PLAN_ID_LIST: "planIdList"
};

var MAP_DIALOG_SECTION = exports.MAP_DIALOG_SECTION = {
    People: {
        name: "People",
        api: "/api/people/",
        apiKey: "people"
    },
    Children: {
        name: "Children",
        api: "/api/children/",
        apiKey: "children"
    },
    Reference: {
        name: "Reference",
        api: "/api/references/",
        apiKey: "references"
    },
    Experience: {
        name: "Experience",
        api: "/api/experiences/",
        apiKey: "experiences"
    },
    Education: {
        name: "Education",
        api: "/api/education/",
        apiKey: "education"
    },
    Pet: {
        name: "Pet",
        api: "/api/pets/",
        apiKey: "pets"
    },
    Booking: {
        name: "Booking",
        api: "/api/jobs/",
        apiKey: "jobs"
    },
    Contact: {
        name: "Contact",
        api: "/api/contacts/",
        apiKey: "contacts"
    },
    Address: {
        name: "Address",
        api: "/api/addresses/",
        apiKey: "addresses"
    }
};

var LIST_COMMON_FIELDS = exports.LIST_COMMON_FIELDS = [{
    id: _customDefineType.FORM_TYPE.TEXTBOX,
    tooltip: "Textbox",
    icon: "text_fields"
}, {
    id: _customDefineType.FORM_TYPE.TEXTAREA,
    tooltip: "Textarea",
    icon: "description"
}, {
    id: _customDefineType.FORM_TYPE.RADIO,
    tooltip: "Radio",
    icon: "radio_button_checked"
}, {
    id: _customDefineType.FORM_TYPE.CHECKBOX,
    tooltip: "Checkbox",
    icon: "check_box"
}, {
    id: _customDefineType.FORM_TYPE.DATEPICKER,
    tooltip: "Date Picker",
    icon: "today"
}, {
    id: _customDefineType.FORM_TYPE.MULTI_SELECT,
    tooltip: "Multi Select",
    icon: "library_add_check"
}, {
    id: _customDefineType.FORM_TYPE.FILE,
    tooltip: "File",
    icon: "attach_file"
}, {
    id: _customDefineType.FORM_TYPE.SUB_HEADER,
    tooltip: "Section Secondary Title",
    icon: "title"
}, {
    id: _customDefineType.FORM_TYPE.HTML,
    tooltip: "HTML",
    icon: "code"
}];

var MAP_FIELD_TYPES = exports.MAP_FIELD_TYPES = {
    TEXTBOX: {
        id: _customDefineType.FORM_TYPE.TEXTBOX,
        value: "Textbox",
        icon: "text_fields",
        options: [MAP_OTHER_PROPERTIES.PLACE_HOLDER, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.DEFAULT_VALUE, MAP_OTHER_PROPERTIES.SHARE_MODEL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.IS_INTEGER_FIELD, MAP_OTHER_PROPERTIES.IS_FLOAT_FIELD, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.HAS_CONFIRM_FIELD, MAP_OTHER_PROPERTIES.IS_A_PHONE_NUMBER],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SPECIFIC_TEXT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SPECIFIC_TEXT)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_CHILDREN_TEXT)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_CONTACT_TEXT)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT)),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_TEXT), _toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_TEXT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_TEXT)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            JobApplication: ['message'],
            Relationship: _modelByTypes.MODEL_RELATIONSHIP_TEXT,
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_TEXT), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_INTEGER_FIELD), _toConsumableArray(_modelByTypes.MODEL_FLOAT_FIELD), _toConsumableArray(_modelByTypes.MODEL_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    TEXTAREA: {
        id: _customDefineType.FORM_TYPE.TEXTAREA,
        value: "Textarea",
        icon: "description",
        options: [MAP_OTHER_PROPERTIES.PLACE_HOLDER, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.DEFAULT_VALUE_MULTI_LINES, MAP_OTHER_PROPERTIES.SHARE_MODEL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SPECIFIC_TEXT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SPECIFIC_TEXT)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_CHILDREN_TEXT)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_CONTACT_TEXT)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT)),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_TEXT), _toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_TEXT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_TEXT)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            JobApplication: ['message'],
            Relationship: _modelByTypes.MODEL_RELATIONSHIP_TEXT,
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_TEXT), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_TEXT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    RADIO: {
        id: _customDefineType.FORM_TYPE.RADIO,
        value: "Radio",
        isSelection: true,
        icon: "radio_button_checked",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.HAS_OTHER, MAP_OTHER_PROPERTIES.DEFAULT_OPTION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.BOTTOM_DESCRIPTION, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.SHARE_MODEL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN, MAP_OTHER_PROPERTIES.IS_HTML, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.IS_HIDDEN, MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating"], _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SPECIFIC_TEXT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SELECTOR)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SELECTOR), ["gender"]),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_SELECTOR)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            JobApplication: ['message'],
            Relationship: _modelByTypes.MODEL_RELATIONSHIP_TEXT,
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_BOOLEAN_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    RADIO_ICON: {
        id: _customDefineType.FORM_TYPE.RADIO_ICON,
        value: "Radio Icon",
        isSelection: true,
        icon: "radio_button_checked",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DEFAULT_OPTION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.BOTTOM_DESCRIPTION, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.SHARE_MODEL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating"], _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SPECIFIC_TEXT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SELECTOR)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SELECTOR), ["gender"]),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_SELECTOR)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_BOOLEAN_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.ICON_LIST]
    },
    CHECKBOX_ITEM: {
        id: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
        value: "Checkbox Item (Single Checkbox)",
        isSelection: true,
        icon: "check",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating"], _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SPECIFIC_TEXT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SELECTOR)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SELECTOR), ["gender"]),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_SELECTOR)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            JobApplication: ['message'],
            Relationship: _modelByTypes.MODEL_RELATIONSHIP_TEXT,
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LABEL]
    },
    CHECKBOX: {
        id: _customDefineType.FORM_TYPE.CHECKBOX,
        value: "Checkbox Group",
        isSelection: true,
        icon: "check_box",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.HAS_OTHER, MAP_OTHER_PROPERTIES.HAS_CHECK_ALL, MAP_OTHER_PROPERTIES.IS_HTML, MAP_OTHER_PROPERTIES.TEXTBOX_OPTION, MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN, MAP_OTHER_PROPERTIES.EXCLUSIVE_OPTIONS, MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.IS_HIDDEN, MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_MULTISELECT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            JobApplication: [], Relationship: [],
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_MULTI_SELECT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    CHECKBOX_ICON: {
        id: _customDefineType.FORM_TYPE.CHECKBOX_ICON,
        value: "Checkbox Icon",
        isSelection: true,
        icon: "check_box",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.HAS_OTHER, MAP_OTHER_PROPERTIES.HAS_CHECK_ALL, MAP_OTHER_PROPERTIES.IS_HTML, MAP_OTHER_PROPERTIES.TEXTBOX_OPTION, MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_MULTISELECT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_MULTI_SELECT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    SALARY_RANGE: {
        id: _customDefineType.FORM_TYPE.SALARY_RANGE,
        value: "Salary Range",
        isSelection: false,
        icon: "check_box",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.HAS_OTHER, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.TEXTBOX_OPTION, MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS, MAP_OTHER_PROPERTIES.HIDE_SALARY_PERIOD, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: { Default: _modelByTypes.MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    DATEPICKER: {
        id: _customDefineType.FORM_TYPE.DATEPICKER,
        value: "Date Picker",
        icon: "today",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.INITIAL_VIEW, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.SHOW_AGE, MAP_OTHER_PROPERTIES.SHOW_PASSED_TIMES, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.CUSTOM_DATE_FORMAT, MAP_OTHER_PROPERTIES.APPEND_TO_BODY],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            Experience: _modelByTypes.MODEL_EXPERIENCE_DATE,
            Reference: _modelByTypes.MODEL_REFERENCE_DATE,
            Education: _modelByTypes.MODEL_EDUCATION_DATE,
            ReferenceCheck: [],
            Children: _modelByTypes.MODEL_CHILDREN_DATE,
            Booking: _modelByTypes.MODEL_BOOKING_DATE,
            FileInfo: _modelByTypes.MODEL_FILE_INFO_DATE,
            JobApplication: [], Relationship: [],
            Default: _modelByTypes.MODEL_DATE
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    MULTI_DATEPICKER: {
        id: _customDefineType.FORM_TYPE.MULTI_DATEPICKER,
        value: "Multi Date Picker",
        isSelection: true,
        icon: "date_range",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_MULTI_SELECT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.NAME]
    },
    TIMEPICKER: {
        id: _customDefineType.FORM_TYPE.TIME_PICKER,
        value: "Time Picker",
        icon: "query_builder",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.MINUTES_INTERVAL, MAP_OTHER_PROPERTIES.IS_24_HOUR_FORMAT, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.DEFAULT_TIME],
        models: {
            Booking: _modelByTypes.MODEL_BOOKING_TIME_PICKER,
            JobApplication: [], Relationship: [],
            Default: _modelByTypes.MODEL_TIME_PICKER
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    DATETIME_PICKER: {
        id: _customDefineType.FORM_TYPE.DATETIME_PICKER,
        value: "Date Time Picker",
        icon: "watch_later",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.INITIAL_VIEW, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.MINUTES_INTERVAL, MAP_OTHER_PROPERTIES.IS_24_HOUR_FORMAT, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Reference: ["check_completion_date"],
            ReferenceCheck: ["check_completion_date"],
            JobApplication: [], Relationship: [],
            Default: []
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    MONTHPICKER: {
        id: _customDefineType.FORM_TYPE.MONTH_PICKER,
        value: "Month Picker",
        icon: "event",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.INITIAL_VIEW, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Experience: _modelByTypes.MODEL_EXPERIENCE_DATE,
            Reference: _modelByTypes.MODEL_REFERENCE_DATE,
            Education: _modelByTypes.MODEL_EDUCATION_DATE,
            Children: _modelByTypes.MODEL_CHILDREN_DATE,
            Booking: _modelByTypes.MODEL_BOOKING_DATE,
            FileInfo: _modelByTypes.MODEL_FILE_INFO_DATE,
            JobApplication: [], Relationship: [],
            Default: _modelByTypes.MODEL_DATE
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    YEAR_PICKER: {
        id: _customDefineType.FORM_TYPE.YEAR_PICKER,
        value: "Year Picker",
        icon: "school",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SELECTOR)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SELECTOR)),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            JobApplication: [], Relationship: [],
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    TIME_TABLE: {
        id: _customDefineType.FORM_TYPE.DAY_HOURS_SELECTOR,
        value: "Time Availability",
        icon: "event_available",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.MINUTES_INTERVAL, MAP_OTHER_PROPERTIES.IS_24_HOUR_FORMAT, MAP_OTHER_PROPERTIES.CUSTOM_LABEL, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.USE_TIME_PICKER, MAP_OTHER_PROPERTIES.HAS_NOTE, MAP_OTHER_PROPERTIES.HAS_TIME_OFF, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.POPULATE_WEEK_AVAILABILITIES],
        models: { Default: _modelByTypes.MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LIST_DAYS]
    },
    DROPDOWN: {
        id: _customDefineType.FORM_TYPE.DROPDOWN,
        value: "Dropdown",
        isSelection: true,
        icon: "arrow_drop_down_circle_outlined",
        options: [MAP_OTHER_PROPERTIES.PLACE_HOLDER, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DEFAULT_OPTION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.SHARE_MODEL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating"]),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SELECTOR), ["gender"]),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_SELECTOR)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EDUCATION_SELECTOR)),
            JobApplication: [], Relationship: [],
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    MULTISELECT: {
        id: _customDefineType.FORM_TYPE.MULTI_SELECT,
        value: "Multi-Select",
        isSelection: true,
        icon: "library_add_check",
        options: [MAP_OTHER_PROPERTIES.PLACE_HOLDER, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.SEARCHABLE, MAP_OTHER_PROPERTIES.OPEN_ON_SELECT, MAP_OTHER_PROPERTIES.IS_ARRAY_MODEL, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS, MAP_OTHER_PROPERTIES.INITIAL_VALUE, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION, MAP_OTHER_PROPERTIES.HAS_OTHER],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_MULTISELECT)),
            ReferenceCheck_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Reference_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating", "status"]),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Experience_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            Booking_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_BOOKING_TEXT)),
            Pet_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Contact_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Address_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_SELECTOR)),
            Default: _modelByTypes.MODEL_MULTI_SELECT,
            JobApplication: [], Relationship: [],
            JobApplication_Single: [],
            Default_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    FILE: {
        id: _customDefineType.FORM_TYPE.FILE,
        value: "File",
        icon: "attach_file",
        options: [MAP_OTHER_PROPERTIES.FILE_TYPE, MAP_OTHER_PROPERTIES.MAX_FILE_SIZE, MAP_OTHER_PROPERTIES.SHOW_AT_TOP, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.BLANK_FILE_URL, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Pet: ["pic", "file1", "file2"],
            Reference: _modelByTypes.MODEL_REFERENCE_FILE,
            ReferenceCheck: _modelByTypes.MODEL_REFERENCE_FILE,
            Experience: _modelByTypes.MODEL_EXPERIENCE_FILE,
            Booking: _modelByTypes.MODEL_BOOKING_FILE,
            Default: _modelByTypes.MODEL_FILE_ALL
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    LABEL: {
        id: _customDefineType.FORM_TYPE.LABEL,
        value: "Label",
        icon: "label",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Default: ["Present"]
        },
        requireKeys: []
    },
    LIST_ITEMS: {
        id: _customDefineType.FORM_TYPE.LIST_ITEMS,
        value: "List Items",
        icon: "list",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.ITEM_LIST]
    },
    SECTION: {
        id: _customDefineType.FORM_TYPE.SECTION,
        value: "Section",
        icon: "view_list",
        options: [MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_PRECONDITION_CHECK, MAP_OTHER_PROPERTIES.COLLAPSE_BY_DEFAULT, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY_SECTION, MAP_OTHER_PROPERTIES.SHOW_IN_ADMIN_PANEL, MAP_OTHER_PROPERTIES.SHOW_IN_INTERVIEW_PANEL, MAP_OTHER_PROPERTIES.SHOW_DOWNLOAD_FILE, MAP_OTHER_PROPERTIES.SHOW_PUBLIC_FORM_LINK, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.SECTION_BUILDER_ID]
    },
    PRESET_SECTION: {
        id: _customDefineType.FORM_TYPE.PRESET_SECTION,
        value: "Preset Section",
        icon: "view_stream",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.IS_PRIVATE],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.PRESET_SECTION]
    },
    PRESET_FIELDS: {
        id: _customDefineType.FORM_TYPE.PRESET_FIELDS,
        value: "Preset Fields",
        icon: "view_stream",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.PRESET_FIELDS]
    },
    BOOKING_SECTION: {
        id: _customDefineType.FORM_TYPE.BOOKING_SECTION,
        value: "Booking Section",
        icon: "event_available",
        options: [MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.EXCLUDE_CHILDREN_QUESTION, MAP_OTHER_PROPERTIES.EXCLUDE_ADDRESS_QUESTION, MAP_OTHER_PROPERTIES.SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS, MAP_OTHER_PROPERTIES.EXCLUDE_REPEAT_BOOKING, MAP_OTHER_PROPERTIES.HAS_NUMBER_CANDIDATE_QUESTION, MAP_OTHER_PROPERTIES.HIDE_ADDITIONAL_DATES_QUESTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_ADD_BOOKING],
        optionsProfile: [MAP_OTHER_PROPERTIES.BOOKING_REQUIRE_PAYMENT_INFO, MAP_OTHER_PROPERTIES.SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS, MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_EDIT_BOOKING, MAP_OTHER_PROPERTIES.CHARGE_CLIENT_WHEN_ASSIGN_CANDIDATE],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.SECTION_BUILDER_ID]
    },
    HEADER: {
        id: _customDefineType.FORM_TYPE.HEADER,
        value: "Section Title",
        icon: "title_outlined",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL]
    },
    SUB_HEADER: {
        id: _customDefineType.FORM_TYPE.SUB_HEADER,
        value: "Section Secondary Title",
        icon: "title",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL]
    },
    HTML: {
        id: _customDefineType.FORM_TYPE.HTML,
        value: "HTML",
        icon: "code",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.SHOW_IN_PROFILE, MAP_OTHER_PROPERTIES.SHOW_IN_EDIT_PROFILE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL],
        optionsBooking: [MAP_OTHER_PROPERTIES.IS_UNIQUE, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
        optionPlacementJob: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
        requireKeys: [MAP_REQUIRE_KEYS.HTML_KEY]
    },
    RATING_GROUP: {
        id: _customDefineType.FORM_TYPE.RATING_GROUP,
        value: "Rating Group",
        icon: "grading",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.GRADE_LIST, MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: { Default: _modelByTypes.MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.ITEM_LIST]
    },
    RADIO_TABLE: {
        id: _customDefineType.FORM_TYPE.RADIO_TABLE,
        value: "Radio Table",
        icon: "playlist_add_check",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: _modelByTypes.MODEL_REFERENCE_CHECK_MULTISELECT,
            Default: _modelByTypes.MODEL_MULTI_SELECT
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.ITEM_LIST]
    },
    CHECKBOX_TABLE: {
        id: _customDefineType.FORM_TYPE.CHECKBOX_TABLE,
        value: "Checkbox Table",
        icon: "checklist",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.CUSTOMIZABLE_ITEM_LIST, MAP_OTHER_PROPERTIES.HAS_NOTE, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.ONLY_ONE_CHECKED_ITEM_REQUIRED],
        models: { Default: _modelByTypes.MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.ITEM_LIST]
    },
    LANGUAGE_INPUT: {
        id: _customDefineType.FORM_TYPE.LANGUAGE_INPUT,
        value: "Language Input",
        icon: "language",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: { Default: _modelByTypes.MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    SEPARATOR: {
        id: _customDefineType.FORM_TYPE.SEPARATOR,
        value: "Separator",
        icon: "horizontal_rule",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION]
    },
    TEXT_EDITOR: {
        id: _customDefineType.FORM_TYPE.TEXT_EDITOR,
        value: "Text Editor",
        icon: "article",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.DEFAULT_VALUE_MULTI_LINES, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT)),
            Education: _modelByTypes.MODEL_EDUCATION_SPECIFIC_TEXT,
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_SPECIFIC_TEXT)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_TEXT), _toConsumableArray(_modelByTypes.MODEL_CHILDREN_SPECIFIC_TEXT)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_CONTACT_TEXT)),
            Address: [].concat(_toConsumableArray(_modelByTypes.MODEL_ADDRESS_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_ADDRESS_TEXT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_TEXT)),
            JobApplication: ['message'],
            Relationship: _modelByTypes.MODEL_RELATIONSHIP_TEXT,
            Default: _modelByTypes.MODEL_TEXT
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    SIGN_DOCUMENT: {
        id: _customDefineType.FORM_TYPE.SIGN_DOCUMENT,
        value: "Sign Document",
        icon: "gesture_rounded",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.HIDE_LABEL, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.DOCUMENT_TEMPLATE_ID]
    },
    FILE_WITH_INFO: {
        id: _customDefineType.FORM_TYPE.FILE_WITH_INFO,
        value: "File With Additional Information",
        icon: "attachment",
        options: [MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.BLANK_FILE_URL, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.INFO_ONCE_EXPIRED, MAP_OTHER_PROPERTIES.CAN_ADD_MULTIPLE],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL]
    },
    LIST_TEXTBOX: {
        id: _customDefineType.FORM_TYPE.LIST_TEXTBOX,
        value: "List Textbox",
        isSelection: true,
        icon: "reorder",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_MULTI_SELECT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LABEL_MODEL]
    },
    CHECKBOX_CONDITION: {
        id: _customDefineType.FORM_TYPE.CHECKBOX_CONDITION,
        value: "Checkbox Condition",
        icon: "check_circle",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.LABEL]
    },
    PRODUCT_SELECTION: {
        id: _customDefineType.FORM_TYPE.PRODUCT_SELECTION,
        value: "Product Selection",
        icon: "how_to_reg",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ARRAY_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            Booking_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Pet_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Contact_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Default: _modelByTypes.MODEL_MULTI_SELECT,
            Default_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.PRODUCT_LIST, MAP_REQUIRE_KEYS.ICON_LIST, MAP_REQUIRE_KEYS.DESCRIPTION_LIST, MAP_REQUIRE_KEYS.PRICE_LIST, MAP_REQUIRE_KEYS.MODEL]
    },
    CREDIT_PACKAGE_SELECTION: {
        id: _customDefineType.FORM_TYPE.CREDIT_PACKAGE_SELECTION,
        value: "Credit Package Condition",
        icon: "account_balance",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.HTML_LIST, MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.CREDIT_NUMBER_LIST, MAP_REQUIRE_KEYS.PRICE_LIST]
    },
    STRIPE_SUBSCRIPTION_SELECTION: {
        id: _customDefineType.FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION,
        value: "Stripe Subscription Selection",
        icon: "S",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.HEADER_LIST, MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.PLAN_ID_LIST]
    },
    RATING: {
        id: _customDefineType.FORM_TYPE.RATING,
        value: "Rating",
        isSelection: true,
        icon: "star_rate",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.HAS_OTHER, MAP_OTHER_PROPERTIES.DEFAULT_OPTION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating"]),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SPECIFIC_TEXT), _toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_SELECTOR)),
            Education: [].concat(_toConsumableArray(_modelByTypes.MODEL_EDUCATION_SELECTOR)),
            Children: [].concat(_toConsumableArray(_modelByTypes.MODEL_CHILDREN_SELECTOR), ["gender"]),
            Pet: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Contact: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            FileInfo: [].concat(_toConsumableArray(_modelByTypes.MODEL_FILE_INFO_SELECTOR)),
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_BOOLEAN_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    HTML_SELECTION: {
        id: _customDefineType.FORM_TYPE.HTML_SELECTION,
        value: "HTML Selection",
        isSelection: true,
        icon: "price_check",
        options: [MAP_OTHER_PROPERTIES.PLACE_HOLDER, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN, MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.SCROLL_TO_NEXT_ITEM_ON_SELECT, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_MULTISELECT)),
            ReferenceCheck_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), _toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_SELECTOR), ["rating"]),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Reference_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_SELECTOR), ["rating"]),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            Booking_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_SELECTOR)),
            Pet_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_PET_SPECIFIC_SELECTOR)),
            Contact_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_CONTACT_SELECTOR)),
            Default: _modelByTypes.MODEL_MULTI_SELECT,
            Default_Single: [].concat(_toConsumableArray(_modelByTypes.MODEL_SELECTOR), _toConsumableArray(_modelByTypes.MODEL_SPECIFIC_SELECTOR))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.HTML_LIST]
    },
    EXPRESSION: {
        id: _customDefineType.FORM_TYPE.EXPRESSION,
        value: "Display Value by Expression",
        icon: "functions"
    },
    PAYMENT: {
        id: _customDefineType.FORM_TYPE.PAYMENT,
        value: "Payment",
        icon: "payment",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.CHARGE_ON_SUBMIT, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.PAYMENT_TYPE]
    },
    LOGGING: {
        id: _customDefineType.FORM_TYPE.LOGGING,
        value: "Auto Log",
        icon: "update",
        options: [MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_TEXT), ["check_completion_date"]),
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_TEXT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LOG_ITEM]
    },
    PASSWORD: {
        id: _customDefineType.FORM_TYPE.PASSWORD,
        value: "Password",
        icon: "password",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.HIDE_IN_PROFILE, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            Default: ['password']
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.CONFIRM_LABEL]
    },
    PLACEMENT_JOB_SELECTION: {
        id: _customDefineType.FORM_TYPE.PLACEMENT_JOB_SELECTION,
        value: "Placement Job Selection",
        icon: "work"
    },
    EVALUATION: {
        id: _customDefineType.FORM_TYPE.EVALUATION,
        value: "Evaluation",
        icon: "quiz",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.HIDE_LABEL, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.EVALUATION_TEMPLATE_ID]
    },
    VIDEO: {
        id: _customDefineType.FORM_TYPE.VIDEO,
        value: "Video Recorder",
        icon: "videocam",
        models: {
            Default: ['video_id']
        }
    },
    RETURNING_APPLICANT_BTN: {
        id: _customDefineType.FORM_TYPE.RETURNING_APPLICANT_BTN,
        value: "Returning Applicant Button",
        icon: "assignment_return"
    },
    SIGNATURE_FIELD: {
        id: _customDefineType.FORM_TYPE.SIGNATURE_FIELD,
        value: "Signature Field",
        icon: "gesture",
        options: [MAP_OTHER_PROPERTIES.PLACE_HOLDER, MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_CHECK_MULTISELECT)),
            Reference: [].concat(_toConsumableArray(_modelByTypes.MODEL_REFERENCE_MULTISELECT)),
            Experience: [].concat(_toConsumableArray(_modelByTypes.MODEL_EXPERIENCE_MULTISELECT)),
            Booking: [].concat(_toConsumableArray(_modelByTypes.MODEL_BOOKING_MULTISELECT)),
            JobApplication: [], Relationship: [],
            Default: [].concat(_toConsumableArray(_modelByTypes.MODEL_MULTI_SELECT))
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    }
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGEX_VALID_NUMBER = exports.REGEX_VALID_NUMBER = {
  INTEGER: new RegExp("^\\-?\\d*$"),
  POSITIVE_INTEGER: new RegExp("^\\d*$"),
  DOUBLE: new RegExp("^\\-?(\\d+\\.)?\\d*$"),
  POSITIVE_DOUBLE: new RegExp("^(\\d+\\.)?\\d*$")
};

var REGEX_EXTRACT_HTML_TAG_CONTENT = exports.REGEX_EXTRACT_HTML_TAG_CONTENT = new RegExp("<.*>([^<>]*)<.*>");
var REGEX_REPLACE_HTML_TAG = exports.REGEX_REPLACE_HTML_TAG = /<[^>]+>/g;
var REGEX_VALIDATE_EMAIL = exports.REGEX_VALIDATE_EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
var REGEX_NORMALIZE_TEXT = exports.REGEX_NORMALIZE_TEXT = /[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g;
var REGEX_MATCH_TEXT_FIELD = exports.REGEX_MATCH_TEXT_FIELD = /^\[\[field(\d+)\]\]$/;
var REGEX_SPLIT_FIELD = exports.REGEX_SPLIT_FIELD = /(\[\[field\d+\]\]|\[\[x[^\]]*\]\])/;

var REGEX_EXTRACT_FIELD_TAGS = exports.REGEX_EXTRACT_FIELD_TAGS = /\[\[[^\]]+\]\]/g;
var REGEX_EXTRACT_FIELD_SUB_TAGS = exports.REGEX_EXTRACT_FIELD_SUB_TAGS = /\{\{[^\}]+\}\}/g;
var REGEX_EXTRACT_CHECKBOX_PARENT_OPTION = exports.REGEX_EXTRACT_CHECKBOX_PARENT_OPTION = /data\-parent="(\d+)"/;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(153);
var enumBugKeys = __webpack_require__(107);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(5);
var dPs = __webpack_require__(154);
var enumBugKeys = __webpack_require__(107);
var IE_PROTO = __webpack_require__(106)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(104)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(108).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(153);
var hiddenKeys = __webpack_require__(107).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var dP = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var call = __webpack_require__(166);
var isArrayIter = __webpack_require__(119);
var anObject = __webpack_require__(5);
var toLength = __webpack_require__(13);
var getIterFn = __webpack_require__(121);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(20);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIST_REQUIRED_STATUSES = exports.LIST_REQUIRED_STATUSES = ["Pre Application"];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(721),
    getValue = __webpack_require__(726);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(15).f;
var has = __webpack_require__(23);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(36);
var fails = __webpack_require__(8);
var spaces = __webpack_require__(110);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZOOM_API_BASE_URL = exports.BASE_WS_URL = exports.BASE_URL = exports.PARAM_HIDE_LOADING = exports.PARAM_HIDE_ERROR_MODAL = exports.PARAM_BACKGROUND_KEY = exports.PARAM_LOGIN = exports.VALUE_LOGIN = exports.PARAM_REDIRECT_ON_USER_EXIST = exports.VALUE_REDIRECT_ON_USER_EXIST = exports.PARAM_RESOURCE_INFO_KEY = exports.PARAM_USER_CREATED = undefined;

var _development = __webpack_require__(643);

var _development2 = _interopRequireDefault(_development);

var _production = __webpack_require__(644);

var _production2 = _interopRequireDefault(_production);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PARAM_USER_CREATED = exports.PARAM_USER_CREATED = "user_created=true";
var PARAM_RESOURCE_INFO_KEY = exports.PARAM_RESOURCE_INFO_KEY = "resource";
var VALUE_REDIRECT_ON_USER_EXIST = exports.VALUE_REDIRECT_ON_USER_EXIST = "redirect-on-user-exist";
var PARAM_REDIRECT_ON_USER_EXIST = exports.PARAM_REDIRECT_ON_USER_EXIST = PARAM_RESOURCE_INFO_KEY + "=" + VALUE_REDIRECT_ON_USER_EXIST;
var VALUE_LOGIN = exports.VALUE_LOGIN = "login";
var PARAM_LOGIN = exports.PARAM_LOGIN = PARAM_RESOURCE_INFO_KEY + "=" + VALUE_LOGIN;
var PARAM_BACKGROUND_KEY = exports.PARAM_BACKGROUND_KEY = "in_background";
var PARAM_HIDE_ERROR_MODAL = exports.PARAM_HIDE_ERROR_MODAL = "hide-error";
var PARAM_HIDE_LOADING = exports.PARAM_HIDE_LOADING = "hide-loading";

var envParams =  true ? _production2.default : _development2.default;

var BASE_URL = exports.BASE_URL = envParams.BASE_URL;

var BASE_WS_URL = exports.BASE_WS_URL = envParams.BASE_WS_URL;

var ZOOM_API_BASE_URL = exports.ZOOM_API_BASE_URL = envParams.BASE_URL;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appendHideLoadingParam = exports.appendBackgroundParam = exports.appendUrlParam = undefined;

var _urlParams = __webpack_require__(65);

var appendUrlParam = exports.appendUrlParam = function appendUrlParam(apiPath, param) {
    if (apiPath.includes('?')) {
        return apiPath + '&' + param;
    } else {
        return apiPath + '?' + param;
    }
};

var appendBackgroundParam = exports.appendBackgroundParam = function appendBackgroundParam(apiPath) {
    return appendUrlParam(apiPath, _urlParams.PARAM_BACKGROUND_KEY + '=true');
};

var appendHideLoadingParam = exports.appendHideLoadingParam = function appendHideLoadingParam(apiPath) {
    return appendUrlParam(apiPath, _urlParams.PARAM_HIDE_LOADING + '=true');
};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(29);
var global = __webpack_require__(7);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(42) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(5);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(18);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getLatestList = exports.getLatestList = function getLatestList(listOldData, listIds, listUpdatedData) {
    var result = listUpdatedData || [];
    result = result.filter(function (item) {
        return listIds.includes(item.id);
    });
    var listUpdatedIds = listUpdatedData.map(function (item) {
        return item.id;
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = listOldData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (!listIds.includes(item.id)) {
                continue;
            }
            if (listUpdatedIds.includes(item.id)) {
                continue;
            }
            result.push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
};

var getRequestUrlParams = exports.getRequestUrlParams = function getRequestUrlParams(object) {
    var params = "";
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Object.entries(object)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                key = _step2$value[0],
                value = _step2$value[1];

            if (value) {
                params += key + "=" + value + "&";
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return params;
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var hasCommonElement = exports.hasCommonElement = function hasCommonElement(arr1, arr2) {
    if (arr1 == null || arr2 == null) {
        return false;
    }
    return arr1.some(function (r) {
        return arr2.includes(r);
    });
};

// If arr3 is defined, only check for the items inside arr3
var containsAllElements = exports.containsAllElements = function containsAllElements(arr1, arr2, arr3) {
    if (!arr1) {
        arr1 = [];
    }
    if (!arr2) {
        arr2 = [];
    }
    if (arr3 && arr3.length) {
        // If arr3 contains None, no item to check => return True
        if (arr3.includes('None')) {
            return true;
        }
        arr2 = arr2.filter(function (element) {
            return arr3.includes(element);
        });
    }
    return arr2.every(function (element) {
        return arr1.includes(element);
    });
};

// Sort array by prop (increasing, put null at the end)
var sortArrayByProp = exports.sortArrayByProp = function sortArrayByProp(arr, prop) {
    return arr.sort(function (item1, item2) {
        return (item2[prop] != null) - (item1[prop] != null) || item1[prop] - item2[prop];
    });
};

// Put all element of arr2 in middle of arr1 (position is specified by index)
var insertArrayInArray = exports.insertArrayInArray = function insertArrayInArray(arr1, arr2, index) {
    if (!arr1) {
        return;
    }
    if (!arr2) {
        return;
    }
    if (!index || index === -1) {
        // Put at the end
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = arr2[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                arr1.push(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return;
    }
    var insertIndex = index;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = arr2[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item = _step2.value;

            arr1.splice(insertIndex, 0, _item);
            insertIndex += 1;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

// Remove all items which has duplicated key in arr
// If key is undefined, treat it as primitive value instead of object
var deduplicateArrayOfObject = exports.deduplicateArrayOfObject = function deduplicateArrayOfObject(arr, key) {
    if (!arr) {
        return [];
    }
    if (key) {
        return arr.filter(function (v, i, a) {
            return a.findIndex(function (v2) {
                return v2[key] === v[key];
            }) === i;
        });
    } else {
        return arr.filter(function (v, i, a) {
            return a.findIndex(function (v2) {
                return v2 === v;
            }) === i;
        });
    }
};

var deduplicateArray = exports.deduplicateArray = function deduplicateArray(arr) {
    return deduplicateArrayOfObject(arr);
};

var cloneArrayOfObject = exports.cloneArrayOfObject = function cloneArrayOfObject(inputArr) {
    var result = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = inputArr[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            result.push(_extends({}, item));
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return result;
};

var filterFast = exports.filterFast = function filterFast(data, ids) {
    var mapIds = ids.reduce(function (acc, cur) {
        acc[cur] = 1;return acc;
    }, {});
    return data.filter(function (item) {
        return mapIds[item.id] === 1;
    });
};

var replaceItemInList = exports.replaceItemInList = function replaceItemInList(inputLst, newItem) {
    if (!inputLst) {
        return [];
    }
    var index = inputLst.findIndex(function (item) {
        return item.id === newItem.id;
    });
    if (index >= 0) {
        inputLst[index] = newItem;
    }
    return [].concat(_toConsumableArray(inputLst));
};

var mergeArrayOfObject = exports.mergeArrayOfObject = function mergeArrayOfObject(oldArr, updatedArr) {
    var mapUpdatedIds = {};
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = updatedArr[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            mapUpdatedIds[item.id] = true;
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    var result = updatedArr;
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = oldArr[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _item2 = _step5.value;

            if (mapUpdatedIds[_item2.id]) {
                continue;
            }
            result.push(_item2);
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    return result;
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(140),
    getRawTag = __webpack_require__(722),
    objectToString = __webpack_require__(723);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(24);
var toLength = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(50);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(36);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(10);
var cof = __webpack_require__(31);
var MATCH = __webpack_require__(12)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(62);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(170);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(19);
var fails = __webpack_require__(8);
var defined = __webpack_require__(36);
var wks = __webpack_require__(12);
var regexpExec = __webpack_require__(125);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var redefineAll = __webpack_require__(56);
var meta = __webpack_require__(43);
var forOf = __webpack_require__(55);
var anInstance = __webpack_require__(54);
var isObject = __webpack_require__(10);
var fails = __webpack_require__(8);
var $iterDetect = __webpack_require__(82);
var setToStringTag = __webpack_require__(61);
var inheritIfRequired = __webpack_require__(111);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var hide = __webpack_require__(19);
var uid = __webpack_require__(48);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(42) || !__webpack_require__(8)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(7)[K];
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(18);
var ctx = __webpack_require__(30);
var forOf = __webpack_require__(55);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MODEL_SPECIFIC_SELECTOR = exports.MODEL_SPECIFIC_SELECTOR = ["location", "marketing_source", "city", "provincestate", "country", "billing_city", "billing_state", "billing_zip", "billing_country", "language"];

var MODEL_SELECTOR = exports.MODEL_SELECTOR = ["selector1", "selector2", "selector3", "selector4", "selector5", "selector6", "selector7", "selector8", "selector9", "selector10", "selector11", "selector12", "selector13", "selector14", "selector15", "selector16", "selector17", "selector18", "selector19", "selector20", "selector21", "selector22", "selector23", "selector24", "selector25", "selector26", "selector27", "selector28", "selector29", "selector30", "selector31", "selector32", "selector33", "selector34", "selector35", "text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10", "text11", "text12", "text13", "text14", "text15", "text16", "text17", "text18", "text19", "text20", "text21", "text22", "text23", "text24", "text25", "text26", "text27", "text28", "text29", "text30", "text31", "text32", "text33", "text34", "text35", "text36", "text37", "text38", "text39", "text40", "text41", "text42", "text43", "text44", "text45", "text46", "text47", "text48", "text49", "text50", "text51", "text52", "text53", "text54", "text55", "text56", "text57", "text58", "text59", "text60", "text61", "text62", "text63", "text64", "text65", "text66", "text67", "text68", "text69", "text70", "currency", "provincestate", "status"];

var MODEL_CHILDREN_SELECTOR = exports.MODEL_CHILDREN_SELECTOR = ["selector1", "selector2", "selector3", "selector4", "selector5", "selector6", "selector7", "selector8"];

var MODEL_CONTACT_SELECTOR = exports.MODEL_CONTACT_SELECTOR = ["selector1", "selector2", "selector3", "selector4", "selector5"];

var MODEL_MULTI_SELECT = exports.MODEL_MULTI_SELECT = ["multiselect1", "multiselect2", "multiselect3", "multiselect4", "multiselect5", "multiselect6", "multiselect7", "multiselect8", "multiselect9", "multiselect10", "multiselect11", "multiselect12", "multiselect13", "multiselect14", "multiselect15", "multiselect16", "multiselect17", "multiselect18", "multiselect19", "multiselect20", "multiselect21", "multiselect22", "multiselect23", "multiselect24", "multiselect25", "multiselect26", "multiselect27", "multiselect28", "multiselect29", "multiselect30", "multiselect31", "multiselect32", "multiselect33", "multiselect34", "multiselect35", "multiselect36", "multiselect37", "multiselect38", "multiselect39", "multiselect40", "types", "skills", "skills2", "skills3", "sectors", "features", "features2", "preferences", "preferences2", "preferences3", "tags", "locations"];

var MODEL_SHARE_MULTI_FIELDS = exports.MODEL_SHARE_MULTI_FIELDS = ["multiselect1", "multiselect2", "multiselect3", "multiselect4", "multiselect5", "multiselect6", "multiselect7", "multiselect8", "multiselect9", "multiselect10", "multiselect11", "multiselect12", "multiselect13", "multiselect14", "multiselect15", "multiselect16", "multiselect17", "multiselect18", "multiselect19", "multiselect20", "multiselect21", "multiselect22", "multiselect23", "multiselect24", "multiselect25", "multiselect26", "multiselect27", "multiselect28", "multiselect29", "multiselect30", "multiselect31", "multiselect32", "multiselect33", "multiselect34", "multiselect35", "multiselect36", "multiselect37", "multiselect38", "multiselect39", "multiselect40", "types", "job_types", "skills", "skills2", "skills3", "sectors", "features", "features2", "preferences", "preferences2", "preferences3", "tags", "locations"];

var MODEL_BOOLEAN_SELECTOR = exports.MODEL_BOOLEAN_SELECTOR = ["boolean_selector1", "boolean_selector2", "boolean_selector3", "boolean_selector4", "boolean_selector5", "boolean_selector6", "boolean_selector7", "boolean_selector8", "boolean_selector9", "boolean_selector10", "boolean_selector11", "boolean_selector12", "boolean_selector13", "boolean_selector14", "boolean_selector15", "boolean_selector16", "boolean_selector17", "boolean_selector18", "boolean_selector19", "boolean_selector20"];

var MODEL_TIME_PICKER = exports.MODEL_TIME_PICKER = ["time1", "time2", "time3", "time4"];

var MODEL_FILE_NONE_IMAGE = exports.MODEL_FILE_NONE_IMAGE = ["resume", "transcript", "file1", "file2", "file3", "file4", "file5", "file6", "file7", "file8", "file9", "file10", "file11", "file12", "file13", "file14", "file15"];

var MODEL_TEXT = exports.MODEL_TEXT = ["text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10", "text11", "text12", "text13", "text14", "text15", "text16", "text17", "text18", "text19", "text20", "text21", "text22", "text23", "text24", "text25", "text26", "text27", "text28", "text29", "text30", "text31", "text32", "text33", "text34", "text35", "text36", "text37", "text38", "text39", "text40", "text41", "text42", "text43", "text44", "text45", "text46", "text47", "text48", "text49", "text50", "text51", "text52", "text53", "text54", "text55", "text56", "text57", "text58", "text59", "text60", "text61", "text62", "text63", "text64", "text65", "text66", "text67", "text68", "text69", "text70", "summary", "overview", "text_field1", "richtext1", "richtext2", "present_employer", "title", "about_us", "stripe_customer_id"];

var MODEL_CHILDREN_TEXT = exports.MODEL_CHILDREN_TEXT = ["text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10", "text11", "text12", "text13", "text14", "text15", "text16", "text17", "text18", "text19", "text20"];

var MODEL_CONTACT_TEXT = exports.MODEL_CONTACT_TEXT = ["text1", "text2", "text3", "text4", "text5"];

var MODEL_RELATIONSHIP_TEXT = exports.MODEL_RELATIONSHIP_TEXT = ["text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10", "text11", "text12"];

var MODEL_PET_TEXT = exports.MODEL_PET_TEXT = ["text1", "text2", "text3", "text4", "text5"];

var MODEL_FILE_ALL = exports.MODEL_FILE_ALL = ["profile_pic"].concat(MODEL_FILE_NONE_IMAGE);

var MODEL_REFERENCE_FILE = exports.MODEL_REFERENCE_FILE = ["reference_document", "file1", "file2"];

var MODEL_EXPERIENCE_FILE = exports.MODEL_EXPERIENCE_FILE = ["recommendation_letter", "file1", "file2"];

var MODEL_BOOKING_FILE = exports.MODEL_BOOKING_FILE = ["file1", "file2", "file3", "file4", "file5", "file6", "file7"];

var MODEL_DATE = exports.MODEL_DATE = ["birthday", "available_date", "date1", "date2", "date3", "date4", "date5"];

var MODEL_USER_PHONE_FIELD = exports.MODEL_USER_PHONE_FIELD = ["phone", "phone2", "info__custom_phone1", "info__custom_phone2", "info__custom_phone3", "info__custom_phone4", "info__custom_phone5", "info__custom_phone6", "info__custom_phone7", "info__custom_phone8", "info__custom_phone9", "info__custom_phone10", "info__custom_phone11", "info__custom_phone12", "info__custom_phone13", "info__custom_phone14", "info__custom_phone15"];

var MODEL_SPECIFIC_TEXT = exports.MODEL_SPECIFIC_TEXT = ["email", "email2", "first_name", "middle_name", "last_name", "name", "employer_name", // Used for family names
"secondary_first_name", "secondary_last_name", "address1", "address2", "city", "postal_code", "provincestate", "country", "billing_first_name", "billing_last_name", "billing_address", "billing_city", "billing_state", "billing_zip", "billing_country", "marketing_source", "how_did_you_hear", "government_ID_number", "social_security", "summary", "salary_range", "facebook", "linkedin", "twitter", "education_institution", "degree", "diploma", "description", "present_employer", "title", "about_us", "promo_code", "currency", "rate", "language"].concat(MODEL_USER_PHONE_FIELD);

var MODEL_REFERENCE_TEXT = exports.MODEL_REFERENCE_TEXT = ["text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10"];

var MODEL_REFERENCE_SELECTOR = exports.MODEL_REFERENCE_SELECTOR = ["selector1", "selector2", "selector3", "selector4", "selector5"];

var MODEL_REFERENCE_MULTISELECT = exports.MODEL_REFERENCE_MULTISELECT = ["multiselect1", "multiselect2", "multiselect3", "multiselect4", "multiselect5"];

var MODEL_EXPERIENCE_SELECTOR = exports.MODEL_EXPERIENCE_SELECTOR = ["selector1", "selector2", "selector3"];

var MODEL_REFERENCE_SPECIFIC_TEXT = exports.MODEL_REFERENCE_SPECIFIC_TEXT = ["reference_note", "reference_shareable_note", "contact_history", "company", "email", "first_name", "last_name",
// "name",
"phone", "phone2", "relationship", "title", "children", "city", "compensation", "country", "provincestate", "reason_ended", "note", "person_worked_for_name", "address1", "address2", "postal_code", "current_role", "status"];

var MODEL_REFERENCE_DATE = exports.MODEL_REFERENCE_DATE = ["start_date", "end_date"];

var MODEL_EXPERIENCE_TEXT = exports.MODEL_EXPERIENCE_TEXT = ["text1", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9"];

var MODEL_CONTACT_SPECIFIC_TEXT = exports.MODEL_CONTACT_SPECIFIC_TEXT = ["user_name", "first_name", "last_name", "phone", "phone2", "email", "type", "organization", "title", "relationship", "note", "address1", "address2", "city", "postal_code", "provincestate", "country"];

var MODEL_EXPERIENCE_SPECIFIC_TEXT = exports.MODEL_EXPERIENCE_SPECIFIC_TEXT = ["experience_verification_note", "experience_verification_shareable_note", "experience_verification_contact_history", "children", "city", "company_name", "compensation", "country", "employment_type", "provincestate", "reason_ended", "title", "note", "person_worked_for_name", "phone", "email", "address1", "address2", "postal_code", "current_role", "start_date_text", "end_date_text"];

var MODEL_EXPERIENCE_DATE = exports.MODEL_EXPERIENCE_DATE = ["start_date", "end_date"];

var MODEL_EXPERIENCE_MULTISELECT = exports.MODEL_EXPERIENCE_MULTISELECT = ["tasks_performed", "ages_worked_with", "multiselect1", "multiselect2", "multiselect3", "multiselect4", "multiselect5", "types"];

// EDUCATION ----

var MODEL_EDUCATION_SPECIFIC_TEXT = exports.MODEL_EDUCATION_SPECIFIC_TEXT = ["area_of_study", "institution", "institution_type", "note", "grade", "degree", "country", "city", "provincestate", "start_date_text", "end_date_text", "text1", "text2", "text3"];

var MODEL_EDUCATION_SELECTOR = exports.MODEL_EDUCATION_SELECTOR = ["institution_type", "graduated"];

var MODEL_EDUCATION_DATE = exports.MODEL_EDUCATION_DATE = ["start_date", "end_date"];

// CHILDREN ----

var MODEL_CHILDREN_SPECIFIC_TEXT = exports.MODEL_CHILDREN_SPECIFIC_TEXT = ["first_name", "middle_name", "last_name", "name", "age", "gender", "personality_interests", "schedule", "special_needs"];

// PET ----

var MODEL_PET_SPECIFIC_TEXT = exports.MODEL_PET_SPECIFIC_TEXT = ["description", "name", "size", "breed"];

var MODEL_PET_SPECIFIC_SELECTOR = exports.MODEL_PET_SPECIFIC_SELECTOR = ["breed", "careExpected", "type"];

// Address ----

var MODEL_ADDRESS_SPECIFIC_TEXT = exports.MODEL_ADDRESS_SPECIFIC_TEXT = ["address1", "address2", "postal_code", "city", "provincestate", "country", "notes"];

var MODEL_ADDRESS_SELECTOR = exports.MODEL_ADDRESS_SELECTOR = ["selector1", "selector2", "selector3", "selector4", "selector5"];

var MODEL_ADDRESS_TEXT = exports.MODEL_ADDRESS_TEXT = ["text1", "text2", "text3", "text4", "text5"];

var MODEL_CHILDREN_DATE = exports.MODEL_CHILDREN_DATE = ["birthday"];

var MODEL_BOOKING_TIME_PICKER = exports.MODEL_BOOKING_TIME_PICKER = ["start_time", "end_time"];

var MODEL_BOOKING_DATE = exports.MODEL_BOOKING_DATE = ["date", "end_date", "date_revenue_generate"];

var MODEL_BOOKING_SELECTOR = exports.MODEL_BOOKING_SELECTOR = ["selector1", "selector2", "selector3", "selector4", "selector5", "selector6", "selector7", "selector8", "selector9", "is_out_of_town", "hide_from_job_board", "visible_to_candidates", "sick_children", "skip_charge", "timezone"];

var MODEL_BOOKING_TEXT = exports.MODEL_BOOKING_TEXT = ["text", "text2", "text3", "text4", "text5", "text6", "text7", "text8", "text9", "text10", "text11", "text12", "text13", "text14", "text15", "description", "admin_notes", "dispute_note", "candidate_dispute_notes", "compensation_type", "compensation", "children_description", "cancel_reason", "category", "special_instructions", "address1", "address2", "postal_code", "city", "provincestate", "country", "location", "travel_fee", "candidate_rate", "client_rate", "agency_fee", "revenue"];

var MODEL_BOOKING_MULTISELECT = exports.MODEL_BOOKING_MULTISELECT = ["multiselect1", "multiselect2", "multiselect3", "multiselect4", "checklist", "logistic_requirements", "locations", "types"];

// FILE ADDITIONAL INFORMATIOn
var MODEL_FILE_INFO_DATE = exports.MODEL_FILE_INFO_DATE = ["expiry"];
var MODEL_FILE_INFO_SELECTOR = exports.MODEL_FILE_INFO_SELECTOR = ["selector1", "selector2", "selector3", "selector4"];
var MODEL_FILE_INFO_SPECIFIC_TEXT = exports.MODEL_FILE_INFO_SPECIFIC_TEXT = ["note"];

// Reference check form
var MODEL_REFERENCE_CHECK_MULTISELECT = exports.MODEL_REFERENCE_CHECK_MULTISELECT = ["check_multiselect1", "check_multiselect2", "check_multiselect3", "check_multiselect4", "check_multiselect5", "check_multiselect6", "check_multiselect7", "check_multiselect8", "check_multiselect9", "check_multiselect10"];

var MODEL_REFERENCE_CHECK_SELECTOR = exports.MODEL_REFERENCE_CHECK_SELECTOR = ["check_selector1", "check_selector2", "check_selector3", "check_selector4", "check_selector5", "check_selector6", "check_selector7", "check_selector8", "check_selector9", "check_selector10"];

var MODEL_REFERENCE_CHECK_TEXT = exports.MODEL_REFERENCE_CHECK_TEXT = ["check_text1", "check_text2", "check_text3", "check_text4", "check_text5", "check_text6", "check_text7", "check_text8", "check_text9", "check_text10", "check_text11", "check_text12", "check_text13", "check_text14", "check_text15", "check_text16", "check_text17", "check_text18", "check_text19", "check_text20", "check_text21", "check_text22", "check_text23", "check_text24", "check_text25", "check_text26", "check_text27", "check_text28", "check_text29", "check_text30", "check_text31", "check_text32", "check_text33", "check_text34", "check_text35", "check_text36", "check_text37", "check_text38", "check_text39", "check_text40", "check_text41", "check_text42", "check_text43", "check_text44", "check_text45", "check_completion_date_text"];

var MODEL_INTEGER_FIELD = exports.MODEL_INTEGER_FIELD = ["integer1", "integer2"];

var MODEL_FLOAT_FIELD = exports.MODEL_FLOAT_FIELD = ["user_latitude", "user_longitude"];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var dateInDjangoFormat = exports.dateInDjangoFormat = function dateInDjangoFormat(date) {
    if (date == null) {
        return null;
    }
    if (typeof date === 'string') {
        if (date.includes('T')) {
            return date.split('T')[0];
        }
        return date;
    }
    // Want to convert date in the YYYY-MM-DD format for Django storage
    return date.getFullYear().toString() + "-" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + date.getDate().toString()).slice(-2);
};

var getPreviousDate = exports.getPreviousDate = function getPreviousDate(startDate) {
    var date = void 0;
    if ((typeof startDate === 'undefined' ? 'undefined' : _typeof(startDate)) === 'object') {
        date = new Date(startDate.getTime());
    } else {
        if (startDate.includes(':')) {
            date = new Date(startDate);
        } else {
            date = new Date(startDate + 'T00:00:00');
        }
    }
    date.setDate(date.getDate() - 1);
    return dateInDjangoFormat(date);
};

var getPreviousYear = exports.getPreviousYear = function getPreviousYear(startDate) {
    var date = void 0;
    if ((typeof startDate === 'undefined' ? 'undefined' : _typeof(startDate)) === 'object') {
        date = new Date(startDate.getTime());
    } else {
        if (startDate.includes(':')) {
            date = new Date(startDate);
        } else {
            date = new Date(startDate + 'T00:00:00');
        }
    }
    date.setFullYear(date.getFullYear() - 1);
    return dateInDjangoFormat(date);
};

var getDayMonthFromDate = exports.getDayMonthFromDate = function getDayMonthFromDate(date) {
    if (!date) {
        return null;
    }
    return date.split('-').slice(1).join('-');
};

var addDaysToDate = exports.addDaysToDate = function addDaysToDate(numberOfDays, date) {
    if (!date) {
        date = new Date();
    }
    // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
    date = date.setDate(date.getDate() + numberOfDays); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
    return new Date(date);
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(711),
    listCacheDelete = __webpack_require__(712),
    listCacheGet = __webpack_require__(713),
    listCacheHas = __webpack_require__(714),
    listCacheSet = __webpack_require__(715);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(75);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(735);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(139),
    isLength = __webpack_require__(254);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX_MODEL_FILE_INFO = exports.PREFIX_MODEL_FILE_INFO = "File_Info_";
var RADIO_OTHER_OPTIONS_PREFIX = exports.RADIO_OTHER_OPTIONS_PREFIX = "|:::|other|:::|";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TIME_FROM_TO_SEPARATOR = exports.TIME_FROM_TO_SEPARATOR = "\t";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UNASSIGN_CANDIDATE_SETTINGS = exports.DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR_SETTINGS = exports.DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR_SETTINGS = exports.SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES = exports.TIME_SHEET_JOB_DIALOG_SETTINGS = exports.PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = exports.SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = exports.DISCLAIMER_TEXT_ADDING_BOOKING_SETTING = exports.TIMESHEET_SUMMARY_SETTINGS = exports.SCHEDULER_VIEW_DEFAULT_FILTERS_SETTINGS = exports.PUBLIC_JOB_END_TIME_SETTING = exports.PUBLIC_JOB_START_TIME_SETTING = exports.PUBLIC_JOB_END_DATE_SETTING = exports.PUBLIC_JOB_START_DATE_SETTING = exports.CANDIDATE_TAGS_SCHEDULER_VIEW_SETTINGS = exports.ADD_EDIT_BOOKING_DIALOG_SETTINGS = exports.CANDIDATE_VISIBILITY_REQUEST_SHIFT_JOBS_SETTINGS = exports.PLACEMENT_JOBS_SETTINGS = exports.SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO_SETTINGS = exports.SHIFT_JOB_CALENDAR_FIELDS_SETTINGS = exports.SEND_CONFIRMATION_EMAIL_ASSIGNING_SHIFT_JOB_SETTINGS = exports.SEND_CONFIRMATION_EMAIL_BULK_ASSIGNING_SHIFT_JOB_SETTINGS = exports.QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR_SETTINGS = exports.CLIENT_BOOKING_SETTINGS = exports.CANDIDATE_MY_JOBS_TABLE_SETTINGS = exports.JOB_PAGE_SETTING = exports.DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR_SETTINGS = exports.HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_SETTINGS = exports.PLACEMENT_JOB_BROADCAST_SETTINGS = exports.CANCELLING_REASON_SHIFT_JOB_SETTINGS = exports.CANDIDATE_APPLICATION_STATUS_COLOR_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST_SETTINGS = exports.FILTER_LOCATION_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = exports.CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS_SETTINGS = exports.SHIFT_JOB_STATUSES_FIELD_SETTINGS = exports.PLACEMENT_JOB_STATUSES_FIELD_SETTINGS = exports.PLACEMENT_JOB_TYPES_FIELD_SETTINGS = exports.FULFILLMENT_EXCLUDE_STATUSES_SETTINGS = exports.JOB_CSV_EXPORT_FIELD_SETTINGS = exports.CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER_SETTINGS = exports.SHIFT_JOB_FUTURE_DATE_RANGE_FILTER_SETTINGS = exports.SHIFT_JOB_PAST_DATE_RANGE_FILTER_SETTINGS = exports.TIME_SHEET_TABLE_FIELDS_SETTINGS = undefined;

var _customDefineType = __webpack_require__(6);

var _defaultValues = __webpack_require__(17);

var _userDashboard = __webpack_require__(579);

var _options = __webpack_require__(132);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var TIME_SHEET_TABLE_FIELDS_SETTINGS = exports.TIME_SHEET_TABLE_FIELDS_SETTINGS = [{
    key: "REVERSE_DEFAULT_DATE_SORT_ORDER_SHIFT_JOB_CALENDAR_TABLE_VIEW",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.reverse_default_date_sort_order_shift_table_view'
}, {
    key: "SELECT_FIELDS_TABLE_VIEW",
    model: "advance_setting.time_sheet_table_columns",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    optionListModel: [],
    predefinedOptionList: []
}];

var SHIFT_JOB_PAST_DATE_RANGE_FILTER_SETTINGS = exports.SHIFT_JOB_PAST_DATE_RANGE_FILTER_SETTINGS = [{
    key: "SHIFT_JOB_PAST_DATE_RANGE_FILTER",
    model: "advance_setting.load_shift_jobs_number_of_past_days",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

var SHIFT_JOB_FUTURE_DATE_RANGE_FILTER_SETTINGS = exports.SHIFT_JOB_FUTURE_DATE_RANGE_FILTER_SETTINGS = [{
    key: "SHIFT_JOB_FUTURE_DATE_RANGE_FILTER",
    model: "advance_setting.load_shift_jobs_number_of_future_days",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

var CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER_SETTINGS = [{
    key: "CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER",
    model: "advance_setting.load_my_job_of_past_days",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: 14
}];

var CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER_SETTINGS = [{
    key: "CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER",
    model: "advance_setting.load_my_job_of_future_days",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: 28
}];

var CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER_SETTINGS = [{
    key: "CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER",
    model: "advance_setting.load_my_schedule_of_past_days",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: 14
}];

var CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER_SETTINGS = exports.CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER_SETTINGS = [{
    key: "CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER",
    model: "advance_setting.load_my_schedule_of_future_days",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: 28
}];

var JOB_CSV_EXPORT_FIELD_SETTINGS = exports.JOB_CSV_EXPORT_FIELD_SETTINGS = [{
    key: "JOB_CSV_EXPORT_FIELD",
    model: "advance_setting.shift_job_csv_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: _defaultValues.DEFAULT_SHIFT_JOB_CSV_OPTIONS,
    optionList: _defaultValues.SHIFT_JOB_CSV_OPTIONS,
    predefinedOptionList: []
}];

var FULFILLMENT_EXCLUDE_STATUSES_SETTINGS = exports.FULFILLMENT_EXCLUDE_STATUSES_SETTINGS = [{
    key: "FULFILLMENT_EXCLUDE_STATUSES",
    model: "advance_setting.fulfillment_exclude_statuses",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: ['Cancelled'],
    optionListModel: 'shift_job_statuses',
    optionLabel: "status",
    optionModel: "status",
    canEmpty: true
}];

var PLACEMENT_JOB_TYPES_FIELD_SETTINGS = exports.PLACEMENT_JOB_TYPES_FIELD_SETTINGS = [{
    key: "PLACEMENT_JOB_TYPES_FIELD",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'public_advance_setting.placement_job_types'
}];

var PLACEMENT_JOB_STATUSES_FIELD_SETTINGS = exports.PLACEMENT_JOB_STATUSES_FIELD_SETTINGS = [{
    key: "PLACEMENT_JOB_STATUSES_FIELD",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'placement_job_statuses',
    hasInitElement: false,
    default: _defaultValues.DEFAULT_PLACEMENT_JOB_STATUSES
}];

var SHIFT_JOB_STATUSES_FIELD_SETTINGS = exports.SHIFT_JOB_STATUSES_FIELD_SETTINGS = [{
    key: "SHIFT_JOB_STATUSES_FIELD",
    type: _customDefineType.FORM_TYPE.STATUS_COLOR_INPUT,
    fieldLabel: "Status",
    model: 'shift_job_statuses'
}, {
    key: "REASON_FOR_CANCELLATION_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'public_advance_setting.shift_job_cancellation_reason_list',
    hasInitElement: false,
    default: _defaultValues.DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST
}, {
    key: "SHIFT_JOB_STATUSES_DO_NOT_BLOCK_AVAILABILTIY",
    model: "public_advance_setting.list_shift_job_statuses_cancelled",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: ['Cancelled'],
    optionListModel: 'shift_job_statuses',
    optionLabel: "status",
    optionModel: "status",
    canEmpty: true
}];

var CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS_SETTINGS = exports.CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS_SETTINGS = [{
    key: "SELECT_FIELDS_TABLE_VIEW",
    model: "advance_setting.candidate_available_jobs_table_columns",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: _defaultValues.DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS
}];

var DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = [{
    key: "DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.default_candidate_statuses_shift_job_broadcast',
    optionListModel: 'candidate_statuses',
    default: []
}];

var DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = [{
    key: "DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'placement_job_broadcast_statuses',
    optionListModel: 'candidate_statuses',
    default: []
}];

var DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST_SETTINGS = [{
    key: "DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.default_candidate_hide_statuses_shift_job_broadcast',
    optionListModel: 'candidate_statuses',
    default: []
}];

var DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST_SETTINGS = [{
    key: "DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.default_candidate_hide_statuses_placement_job_broadcast',
    optionListModel: 'candidate_statuses',
    default: []
}];

var DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST_SETTINGS = [{
    key: "DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.default_candidate_types_shift_job_broadcast',
    optionListModel: 'candidate_types',
    default: []
}];

var FILTER_LOCATION_SHIFT_JOB_BROADCAST_SETTINGS = exports.FILTER_LOCATION_SHIFT_JOB_BROADCAST_SETTINGS = [{
    key: "INITIAL_FILTER_LOCATION_BY_CLIENT_LOCATION",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.initial_filter_location_by_client_location',
    default: false
}];

var DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST_SETTINGS = exports.DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST_SETTINGS = [{
    key: "DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.default_candidate_tags_shift_job_broadcast',
    optionListModel: 'candidate_tags',
    default: []
}].concat(_toConsumableArray(_userDashboard.CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS));

var CANDIDATE_APPLICATION_STATUS_COLOR_SETTINGS = exports.CANDIDATE_APPLICATION_STATUS_COLOR_SETTINGS = [{
    key: "CANDIDATE_EACH_STATUS_APPLICATION_COLOR",
    type: _customDefineType.FORM_TYPE.STATUS_COLOR_INPUT,
    fieldLabel: "Status",
    optionListModel: 'advance_setting.candidate_client_relationship_status',
    hasInitElement: false,
    model: "public_advance_setting.candidate_table_application_status_color"
}];

var CANCELLING_REASON_SHIFT_JOB_SETTINGS = exports.CANCELLING_REASON_SHIFT_JOB_SETTINGS = [{
    key: "DO_NOT_ASK_FOR_REASON_CANCELLING_SHIFT_JOB",
    model: "public_advance_setting.do_not_ask_reason_client_cancels_shift_job",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM
}, {
    key: "INCLUDE_CANCELLING_REASON_CANDIDATE_EMAIL_SHIFT_JOB",
    model: "public_advance_setting.include_booking_cancel_reason_candidate_email",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "CUSTOM_CONFIRM_TEXT_CLIENT_CANCEL_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
    model: "advance_setting.custom_text_canceling_shift_job"
}];
var PLACEMENT_JOB_BROADCAST_SETTINGS = exports.PLACEMENT_JOB_BROADCAST_SETTINGS = [{
    key: "DISABLE_PLACEMENT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.disable_placement_job_default_distance_search',
    default: false
}];
var HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_SETTINGS = exports.HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_SETTINGS = [{
    key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_ALREADY_BOOKED",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.check_hide_booked_candidates_broadcast',
    default: true
}, {
    key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_TIME_OFF",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.check_hide_timeoff_candidates_broadcast',
    default: true
}, {
    key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NOT_AVAILABLE",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.check_hide_unavailable_candidates_broadcast',
    default: true
}, {
    key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NO_MATCHING_TAG",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.hide_candidates_no_matching_tag_broadcast',
    default: false
}, {
    key: "HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_DO_NOT_MATCH_LIST",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.hide_candidates_do_not_match_list',
    default: true
}, {
    key: "DISABLE_SHIFT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.disable_shift_job_default_distance_search',
    default: false
}];

var DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR_SETTINGS = exports.DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR_SETTINGS = [{
    key: "DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.default_filter_job_statuses_shift_job_calendar',
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false
}];

var JOB_PAGE_SETTING = exports.JOB_PAGE_SETTING = [{
    key: "CUSTOM_CONFIRM_TEXT_ACCEPT_JOB",
    type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
    model: "public_advance_setting.custom_confirm_text_accept_job",
    default: _defaultValues.DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE
}, {
    key: "CANDIDATE_CAN_MARK_CLIENT_AS_FAV",
    model: "public_advance_setting.candidate_can_mark_client_favorite",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "CANDIDATE_CAN_MARK_CLIENT_AS_DO_NOT_WANT_AGAIN",
    model: "public_advance_setting.candidate_can_mark_client_do_not_want_again",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "SELECT_ZOOM_LEVEL_OF_JOB_MAP",
    model: "public_advance_setting.zoom_level_of_job_map",
    isIntegerField: true,
    default: 13
}, {
    key: "SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE",
    model: "public_advance_setting.client_shift_job_profile",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: []
}, {
    key: "SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE_TO_ASSIGNEE",
    model: "public_advance_setting.client_shift_job_profile_assignee",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: []
}, {
    key: "SHOW_CLIENT_PROFILE_ON_JOB_LISTING",
    model: "show_client_profile_on_job_listings",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "SHOW_CLIENT_PROFILE_ON_JOB_LISTING_TO_ASSIGNEE_ONLY",
    model: "public_advance_setting.visible_to_assign_candidates",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "show_client_profile_on_job_listings",
    showIfValue: "Yes"
}, {
    key: "CANDIDATE_STATUSES_CAN_VIEW_CLIENT_PROFILE",
    model: "public_advance_setting.candidate_statuses_can_view_client_profile",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    optionListModel: 'candidate_statuses',
    showIf: "show_client_profile_on_job_listings",
    showIfValue: "Yes",
    showIfSecondary: "public_advance_setting.visible_to_assign_candidates",
    showIfValueSecondary: "No",
    showIfEmptySecondary: true
}, {
    key: "CANDIDATE_TYPES_CAN_VIEW_CLIENT_PROFILE",
    model: "public_advance_setting.candidate_types_can_view_client_profile",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    optionListModel: "candidate_types",
    isMulti: true,
    showIf: "show_client_profile_on_job_listings",
    showIfValue: "Yes",
    showIfSecondary: "public_advance_setting.visible_to_assign_candidates",
    showIfValueSecondary: "No",
    showIfEmptySecondary: true
}];

var CANDIDATE_MY_JOBS_TABLE_SETTINGS = exports.CANDIDATE_MY_JOBS_TABLE_SETTINGS = [{
    key: "SELECT_FIELDS_MY_JOBS_TABLE",
    model: "advance_setting.my_jobs_table_columns",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: _defaultValues.DEFAULT_MY_JOBS_TABLE_FIELDS
}, {
    key: "CANDIDATE_CUSTOM_CLOCKOUT_MESSAGE",
    model: "advance_setting.candidate_custom_clockout_message",
    type: _customDefineType.FORM_TYPE.TEXTAREA,
    default: ""
}, {
    key: "HAS_REPORT_PROBLEM_BUTTON",
    model: "advance_setting.has_report_problem_button",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "REPORT_PROBLEM_BUTTON_TEXT",
    model: "advance_setting.report_problem_button_text",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
    showIf: "advance_setting.has_report_problem_button",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_UPLOAD_FILE_LABEL",
    model: "advance_setting.report_problem_upload_file_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
    showIf: "advance_setting.has_report_problem_button",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION",
    model: "advance_setting.report_problem_upload_file_description",
    type: _customDefineType.FORM_TYPE.TEXTAREA,
    default: _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
    showIf: "advance_setting.has_report_problem_button",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_NOTE_LABEL",
    model: "advance_setting.report_problem_note_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
    showIf: "advance_setting.has_report_problem_button",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_NOTIFICATION_EMAILS",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'advance_setting.report_problem_notification_emails',
    hasInitElement: false,
    showIf: "advance_setting.has_report_problem_button",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_NEW_JOB_STATUS",
    optionListModel: "shift_job_statuses",
    optionLabel: "status",
    optionModel: "status",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    model: "advance_setting.report_problem_new_job_status",
    showIf: "advance_setting.has_report_problem_button",
    showIfValue: "Yes"
}, {
    key: "CANDIDATE_CAN_MARK_JOB_AS_COMPLETED",
    model: "advance_setting.candidate_can_mark_job_as_completed",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "MARK_JOB_COMPLETED_BUTTON_TEXT",
    model: "advance_setting.mark_job_completed_button_text",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "Yes"
}, {
    key: "STATUS_JOB_CANDIDATE_MARK_COMPLETED",
    optionListModel: "shift_job_statuses",
    optionLabel: "status",
    optionModel: "status",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    model: "advance_setting.job_status_after_candidate_mark_job_completed",
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "Yes",
    default: _defaultValues.DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED
}, {
    key: "HAS_CLOCK_IN_CLOCK_OUT_BUTTON",
    model: "advance_setting.hide_clock_in_out",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "MANUALLY_CLOCK_IN_CLOCK_OUT_JOBS",
    model: "manual_clocking",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "GET_USER_LOCATIONS_WHEN_CLOCK_IN_OUT",
    model: "advance_setting.get_user_location_when_clock_in_out",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "MINUTES_INTERVAL_CANDIDATE_CLOCK_IN_CLOCK_OUT",
    model: "advance_setting.minute_interval_clock_in_out",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    default: 15,
    hasClearButton: true,
    closeOnSelect: true,
    isMulti: false,
    optionLabel: "label",
    optionModel: "model",
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "HIDE_MILEAGE_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB",
    model: "advance_setting.hide_mileage_question",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "CHARGE_TRANSFER_INCLUDE_MILEAGE",
    model: "advance_setting.charge_transfer_include_mileage",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.hide_mileage_question",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "CHARGE_TRANSFER_PRICE_PER_MILE",
    model: "advance_setting.charge_transfer_price_per_mile",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: "0.625",
    showIf: "advance_setting.charge_transfer_include_mileage",
    showIfValue: "Yes"
}, {
    key: "HIDE_REIMBURSEMENT_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB",
    model: "advance_setting.hide_reimbursement_question",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "CHARGE_TRANSFER_INCLUDE_REIMBURSEMENT",
    model: "advance_setting.charge_transfer_include_reimbersement",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.hide_reimbursement_question",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "CANDIDATE_ABLE_CREATE_JOBS_TO_CLOCK_IN_OUT",
    model: "advance_setting.candidates_can_create_jobs",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "CLIENT_CAN_CONFIRM_CLOCK_IN_OUT_CANDIDATE_PHONE",
    model: "advance_setting.client_confirm_clock_in_out",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_mark_job_as_completed",
    showIfValue: "No",
    showIfEmpty: true
}, {
    key: "STATUS_JOB_CLIENT_CONFIRM_CLOCK_IN_OUT_TIME",
    optionListModel: "shift_job_statuses",
    optionLabel: "status",
    optionModel: "status",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    model: "advance_setting.job_status_after_client_confirm_clock_in_out",
    showIf: "advance_setting.client_confirm_clock_in_out"
}, {
    key: "STATUS_JOB_CLIENT_DISAPPROVE_CLOCK_IN_OUT_TIME",
    optionListModel: "shift_job_statuses",
    optionLabel: "status",
    optionModel: "status",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    default: "Client Disapproved",
    isMulti: false,
    model: "advance_setting.job_status_after_client_disapprove_clock_in_out",
    showIf: "advance_setting.client_confirm_clock_in_out"
}, {
    key: "NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    optionList: [0, 1, 2, 4, 6, 12, 18, 24, 48, 72],
    closeOnSelect: false,
    isMulti: true,
    hasClearButton: true,
    model: "advance_setting.hours_notify_filler",
    itemPerRow: 2,
    infoLinkId: "SET_NOTIFICATION_TO_CANDIDATE_FOR_SHIFT_JOB"
}, {
    key: "METHOD_NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    optionList: ['Email', 'SMS'],
    closeOnSelect: false,
    isMulti: true,
    model: "advance_setting.methods_notify_filler",
    default: ["Email"],
    itemPerRow: 2
}, {
    key: "NOTIFY_CANDIDATE_FOR_CLOCK_IN_MINUTES",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    optionList: [0, 5, 10, 15, 30, 60, 120, 180, 360, 1440],
    closeOnSelect: false,
    isMulti: true,
    hasClearButton: true,
    model: "advance_setting.minutes_notify_clockin",
    itemPerRow: 2
}, {
    key: "NOTIFY_CANDIDATE_FOR_CLOCK_OUT_MINUTES",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    optionList: [0, 5, 10, 15, 30, 60, 120, 180, 360, 1440],
    closeOnSelect: false,
    isMulti: true,
    hasClearButton: true,
    model: "advance_setting.minutes_notify_clockout",
    itemPerRow: 2
}, {
    key: "METHOD_NOTIFY_CLOCK_IN_OUT",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    optionList: ['Email', 'SMS'],
    closeOnSelect: false,
    isMulti: true,
    model: "advance_setting.methods_notify_clock_inout",
    default: ["Email"],
    itemPerRow: 1
}, {
    key: "RECORD_BREAK_ITEMS_DURING_SHIFTS",
    model: "advance_setting.can_add_breaks",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "CANDIDATE_CAN_SUBMIT_SHIFT_JOB_REPORT",
    model: "advance_setting.candidate_can_submit_shift_job_report",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "SHIFT_JOB_REPORT_ADMIN_ONLY",
    model: "advance_setting.shift_job_report_admin_only",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_submit_shift_job_report",
    showIfValue: "Yes"
}, {
    key: "SUBMIT_SHIFT_JOB_REPORT_MANDATORY_BEFORE_CLOCKOUT",
    model: "advance_setting.shift_job_report_mandatory",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false,
    showIf: "advance_setting.candidate_can_submit_shift_job_report",
    showIfValue: "Yes"
}, {
    key: "CUSTOMIZE_SUBMIT_REPORT_BUTTON_LABEL",
    model: "advance_setting.customize_submit_report_button_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: 'Submit Report',
    showIf: "advance_setting.candidate_can_submit_shift_job_report",
    showIfValue: "Yes"
}, {
    key: "ADMIN_EMAIL_NOTIFICATION_SHIFT_JOB_REPORT",
    model: "advance_setting.admin_ids_notification_shift_job_report",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    optionListType: _customDefineType.OPTION_LIST_TYPES.ADMIN_LIST,
    optionLabel: "email",
    optionModel: "id",
    showIf: "advance_setting.candidate_can_submit_shift_job_report",
    showIfValue: "Yes"
}, {
    key: "CANDIDATE_NOT_ALLOW_REVIEW",
    model: "public_advance_setting.candidate_not_allow_review",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}];

var CLIENT_BOOKING_SETTINGS = exports.CLIENT_BOOKING_SETTINGS = [{
    key: "CLIENT_HAS_REPORT_PROBLEM_BUTTON",
    model: "advance_setting.has_report_problem_button_for_client",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "REPORT_PROBLEM_BUTTON_TEXT",
    model: "advance_setting.client_report_problem_button_text",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
    showIf: "advance_setting.has_report_problem_button_for_client",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_UPLOAD_FILE_LABEL",
    model: "advance_setting.client_report_problem_upload_file_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
    showIf: "advance_setting.has_report_problem_button_for_client",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION",
    model: "advance_setting.client_report_problem_upload_file_description",
    type: _customDefineType.FORM_TYPE.TEXTAREA,
    default: _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
    showIf: "advance_setting.has_report_problem_button_for_client",
    showIfValue: "Yes"
}, {
    key: "REPORT_PROBLEM_NOTE_LABEL",
    model: "advance_setting.client_report_problem_note_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: _defaultValues.DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
    showIf: "advance_setting.has_report_problem_button_for_client",
    showIfValue: "Yes"
}, {
    key: "CLIENT_REPORT_PROBLEM_NOTIFICATION_EMAILS",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'advance_setting.client_report_problem_notification_emails',
    hasInitElement: false,
    showIf: "advance_setting.has_report_problem_button_for_client",
    showIfValue: "Yes"
}, {
    key: "CLIENT_REPORT_PROBLEM_NEW_JOB_STATUS",
    optionListModel: "shift_job_statuses",
    optionLabel: "status",
    optionModel: "status",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    model: "advance_setting.client_report_problem_new_job_status",
    showIf: "advance_setting.has_report_problem_button_for_client",
    showIfValue: "Yes"
}];

var QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR_SETTINGS = exports.QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR_SETTINGS = [{
    key: "QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR",
    model: "advance_setting.shift_job_calendar_search_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR
}, {
    key: "STATUS_HIDDEN_PAST_DATE_SHIFT_JOB_CALENDAR",
    model: "advance_setting.status_hidden_past_date_shift_job_calendar",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: [],
    optionListModel: 'shift_job_statuses',
    optionLabel: "status",
    optionModel: "status",
    canEmpty: true
}];

var SEND_CONFIRMATION_EMAIL_BULK_ASSIGNING_SHIFT_JOB_SETTINGS = exports.SEND_CONFIRMATION_EMAIL_BULK_ASSIGNING_SHIFT_JOB_SETTINGS = [{
    key: "SEND_EMAIL_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_notification_to_candidate_on_bulk_assign_job',
    default: true
}, {
    key: "SEND_EMAIL_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_notification_to_client_on_bulk_assign_job',
    default: true
}, {
    key: "SEND_SMS_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_sms_notification_to_candidate_on_bulk_assign_job',
    default: false
}, {
    key: "SEND_SMS_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_sms_notification_to_client_on_bulk_assign_job',
    default: false
}];

var SEND_CONFIRMATION_EMAIL_ASSIGNING_SHIFT_JOB_SETTINGS = exports.SEND_CONFIRMATION_EMAIL_ASSIGNING_SHIFT_JOB_SETTINGS = [{
    key: "SEND_EMAIL_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_candidate_assign_confirmation_email_shift_job',
    default: true
}, {
    key: "SEND_EMAIL_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_client_assign_confirmation_email_shift_job',
    default: true
}, {
    key: "SEND_SMS_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_candidate_assign_confirmation_sms_shift_job',
    default: false
}, {
    key: "SEND_SMS_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_client_assign_confirmation_sms_shift_job',
    default: false
}, {
    key: "SELECT_DEFAULT_CANDIDATE_STATUSES_APPEAR_ASSIGNING_CANDIDATE",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: "advance_setting.default_candidate_statuses_appear_assigning_candidate",
    optionListModel: "candidate_statuses",
    closeOnSelect: false,
    isMulti: true,
    hasClearButton: true
}, {
    key: "SELECT_DEFAULT_CANDIDATE_TYPES_APPEAR_ASSIGNING_CANDIDATE",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: "advance_setting.default_candidate_types_appear_assigning_candidate",
    optionListModel: "candidate_types",
    closeOnSelect: false,
    isMulti: true,
    hasClearButton: true
}, {
    key: "DO_NOT_WARN_ABOUT_CANDIDATE_GENERAL_AVAILABILITY",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.do_not_warn_about_candidate_availability',
    default: false
}];

var SHIFT_JOB_CALENDAR_FIELDS_SETTINGS = exports.SHIFT_JOB_CALENDAR_FIELDS_SETTINGS = [{
    key: "SELECT_SHIFT_JOB_CALENDAR_FIELDS",
    model: "advance_setting.shift_job_calendar_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: []
}];

var SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO_SETTINGS = exports.SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO_SETTINGS = [{
    key: "SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO",
    model: "advance_setting.shift_job_calendar_result_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: _defaultValues.BOOKING_RESULT_DEFAULT_FIELDS,
    predefinedOptionList: _defaultValues.BOOKING_RESULT_DEFAULT_FIELDS
}];

var PLACEMENT_JOBS_SETTINGS = exports.PLACEMENT_JOBS_SETTINGS = [{
    key: "BROADCAST_STATUSES_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'placement_job_broadcast_statuses',
    optionListModel: "candidate_statuses",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}, {
    key: "HIDE_DISTANCE_FROM_JOB_CANDIDATE_VIEW_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.hide_distance_viewing_placement_job',
    default: false
}, {
    key: "SHOW_NOT_INTERESTED_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.show_placement_not_interested_button',
    default: true
}, {
    key: "SHOW_MIGHT_BE_INTERESTED_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.show_placement_maybe_interested_button',
    default: true
}, {
    key: "NOTIFICATION_CLIENT_EXPRESS_INTEREST_CANDIDATE_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.notify_client_when_interest_placement',
    default: false
}, {
    key: "CANDIDATE_SEE_PLACEMENT_JOBS_OUTSIDE_LOCATION",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.can_see_placement_job_outside_location',
    default: true
}, {
    key: "CANDIDATES_ACCEPT_JOB_WHEN_JOB_IS_BROADCASTED",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.candidates_accept_job_when_job_is_broadcasted',
    default: false
}, {
    key: "JOB_FULL_WIDTH_BAR_STYLE_MODE",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.job_board_full_width_bar_mode',
    default: false
}, {
    key: "SHOW_JOB_IMAGE_IN_FULL_WIDTH_BAR_STYLE_MODE",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.show_image_job_board_full_width_bar_mode',
    default: false,
    showIf: "public_advance_setting.job_board_full_width_bar_mode"
}, {
    key: "SHOW_HIRED_BADGE_ON_JOB_BOARD",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "advance_setting.show_hired_badge_on_job_board",
    default: false,
    showIf: "public_advance_setting.job_board_full_width_bar_mode"
}, {
    key: "SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "public_advance_setting.show_map_job_board",
    default: false
}, {
    key: "JOB_BOARD_LONG_TERM_PLACEMENT_JOBS_HEADING",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    model: 'placement_job_board_heading'
}, {
    key: "AVAILABLE_JOB_WITHIN_MILE_RADIUS_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    model: 'public_advance_setting.placement_job_distance_to_show_on_job_board'
}, {
    key: "SELECT_FIELDS_PLACEMENT_JOBS_DETAIL_VIEW",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    model: 'public_advance_setting.job_board_detail_view_fields',
    optionList: [],
    default: _defaultValues.DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS
}, {
    key: "CANDIDATE_STATUSES_SEE_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.placement_job_viewing_statuses',
    optionListModel: "candidate_statuses",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}, {
    key: "CANDIDATE_TYPES_SEE_PLACEMENT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.placement_job_viewing_types',
    optionListModel: "candidate_types",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}];

var CANDIDATE_VISIBILITY_REQUEST_SHIFT_JOBS_SETTINGS = exports.CANDIDATE_VISIBILITY_REQUEST_SHIFT_JOBS_SETTINGS = [{
    key: "CANDIDATE_STATUSES_SEE_SHIFT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.shift_job_viewing_statuses',
    optionListModel: "candidate_statuses",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}, {
    key: "CANDIDATE_TAGS_SEE_SHIFT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.shift_job_viewing_tags',
    optionListModel: "candidate_tags",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}, {
    key: "CANDIDATE_TYPES_SEE_SHIFT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.shift_job_viewing_types',
    optionListModel: "candidate_types",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}, {
    key: "ONLY_ALLOW_CANDIDATE_TO_SEE_MATCHING_CATEGORY",
    model: "public_advance_setting.candidate_see_matching_category",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "CANDIDATE_STATUSES_REQUEST_WORK_SHIFT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'shift_job_application_statuses',
    optionListModel: "candidate_statuses",
    isMulti: true,
    searchable: true,
    closeOnSelect: true
}, {
    key: "CANDIDATE_TYPES_REQUEST_WORK_SHIFT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.shift_job_application_types',
    optionListModel: "candidate_types",
    isMulti: true,
    searchable: true,
    closeOnSelect: true,
    hasClearButton: true
}, {
    key: "CANDIDATE_SELF_ASSIGN_THEMSELVES_SHIFT_JOBS",
    model: "candidates_can_accept_shift_jobs",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "ONLY_ALLOW_CANDIDATE_TO_ACCEPT_MATCHING_CATEGORY",
    model: "public_advance_setting.candidate_accept_matching_category",
    showIf: "candidates_can_accept_shift_jobs",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    default: false
}, {
    key: "SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD_SHIFT_JOB",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "public_advance_setting.show_map_shift_job_board",
    default: false
}, {
    key: "CANDIDATE_STATUSES_ACCEPT_SHIFT_JOBS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'shift_job_accept_statuses',
    optionListModel: "candidate_statuses",
    isMulti: true,
    searchable: true,
    closeOnSelect: true,
    hasClearButton: true,
    showIf: "candidates_can_accept_shift_jobs"
}, {
    key: "CUSTOM_CONFIRM_TEXT_ACCEPT_JOB",
    type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
    model: "public_advance_setting.custom_confirm_text_accept_job",
    default: _defaultValues.DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE,
    showIf: "candidates_can_accept_shift_jobs"
}, {
    key: "CUSTOM_CONFIRM_TEXT_ACCEPT_JOB_BUTTON",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    model: "public_advance_setting.custom_confirm_text_accept_job_button",
    default: _defaultValues.DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT,
    showIf: "candidates_can_accept_shift_jobs"
}, {
    key: "DEFAULT_VIEW_AVAILABLE_SHIFT_JOB_CALENDAR",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.default_view_available_jobs_calendar',
    optionList: ['Week', '2 Weeks', 'Month', 'Year'],
    default: "Week",
    isMulti: false,
    searchable: false,
    closeOnSelect: true
}, {
    key: "CUSTOM_TEXT_MESSAGE_SHIFT_JOB_ACCEPTED",
    type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
    model: "public_advance_setting.custom_text_shift_job_accepted"
}];

var ADD_EDIT_BOOKING_DIALOG_SETTINGS = exports.ADD_EDIT_BOOKING_DIALOG_SETTINGS = [{
    key: "DO_NOT_AUTO_POPULATE_ADDRESS",
    model: "public_advance_setting.do_not_auto_populate_address",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM
}, {
    key: "SELECT_MINUTES_INTERVAL_BOOKING_TIME",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: "public_advance_setting.custom_minute_interval_booking_time",
    optionList: [1, 5, 10, 15, 30],
    closeOnSelect: true,
    isMulti: false,
    default: 15
}, {
    key: "SELECT_MINUTES_INTERVAL_SHIFT_JOB_CALENDAR",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: "advance_setting.booking_minutes_interval",
    optionList: [1, 5, 10, 15, 30],
    closeOnSelect: true,
    isMulti: false,
    default: 15
}];

var CANDIDATE_TAGS_SCHEDULER_VIEW_SETTINGS = exports.CANDIDATE_TAGS_SCHEDULER_VIEW_SETTINGS = [{
    key: "CANDIDATE_TAGS_MATCHING_OPTIONS_SCHEDULER_VIEW",
    model: "public_advance_setting.candiate_tags_matching_options_scheduler_view",
    type: _customDefineType.FORM_TYPE.RADIO,
    default: 'All Of',
    optionList: ['All Of', 'Any Of', 'None Of']
}];

var PUBLIC_JOB_START_DATE_SETTING = exports.PUBLIC_JOB_START_DATE_SETTING = [{
    key: "PUBLIC_JOB_START_DATE_LABEL",
    model: "public_advance_setting.public_job_start_date_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: "Start Date"
}];

var PUBLIC_JOB_END_DATE_SETTING = exports.PUBLIC_JOB_END_DATE_SETTING = [{
    key: "PUBLIC_JOB_END_DATE_LABEL",
    model: "public_advance_setting.public_job_end_date_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: "End Date"
}];

var PUBLIC_JOB_START_TIME_SETTING = exports.PUBLIC_JOB_START_TIME_SETTING = [{
    key: "PUBLIC_JOB_START_TIME_LABEL",
    model: "public_advance_setting.public_job_start_time_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: "Start Time"
}];

var PUBLIC_JOB_END_TIME_SETTING = exports.PUBLIC_JOB_END_TIME_SETTING = [{
    key: "PUBLIC_JOB_END_TIME_LABEL",
    model: "public_advance_setting.public_job_end_time_label",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: "End Time"
}];

var SCHEDULER_VIEW_DEFAULT_FILTERS_SETTINGS = exports.SCHEDULER_VIEW_DEFAULT_FILTERS_SETTINGS = [{
    key: "JOB_STATUSES_TO_HIDE_FROM_SCHEDULER_VIEW",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.job_statuses_to_hide_scheduler_view',
    default: ['Assigned'],
    isMulti: true,
    closeOnSelect: false,
    hasClearButton: true
}, {
    key: "DEFAULT_FILTER_CANDIDATE_TYPES_SCHEDULER_VIEW",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.filter_candidate_types_scheduler_view',
    default: [],
    isMulti: true,
    closeOnSelect: false,
    hasClearButton: true,
    optionListModel: 'candidate_types'
}, {
    key: "DEFAULT_FILTER_CANDIDATE_STATUSES_SCHEDULER_VIEW",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.filter_candidate_statuses_scheduler_view',
    default: [],
    isMulti: true,
    closeOnSelect: false,
    hasClearButton: true,
    optionListModel: 'candidate_statuses'
}, {
    key: "DEFAULT_FILTER_CANDIDATE_TAGS_SCHEDULER_VIEW",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.filter_candidate_tags_scheduler_view',
    default: [],
    isMulti: true,
    closeOnSelect: false,
    hasClearButton: true,
    optionListModel: 'candidate_tags'
}, {
    key: "SHIFT_JOB_STATUS_AFTER_DRAG_DROP_TO_ASSIGN",
    model: "advance_setting.shift_job_status_after_drag_drop_to_assign",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    default: 'Assigned',
    optionListModel: 'shift_job_statuses',
    optionLabel: "status",
    optionModel: "status",
    canEmpty: true
}];

var TIMESHEET_SUMMARY_SETTINGS = exports.TIMESHEET_SUMMARY_SETTINGS = [{
    key: "USE_BOOKED_TIME_IF_NO_CLOCKED_TIME",
    model: "advance_setting.use_booked_time_if_no_clocked_time",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM
}];

var DISCLAIMER_TEXT_ADDING_BOOKING_SETTING = exports.DISCLAIMER_TEXT_ADDING_BOOKING_SETTING = [{
    key: "DISCLAIMER_TEXT_ADDING_BOOKING",
    type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
    model: "public_advance_setting.disclaimer_text_booking_section",
    default: _defaultValues.DEFAULT_DISCLAIMER_TEXT
}];

var SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = exports.SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = [{
    key: "SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS",
    model: "advance_setting.shift_job_broadcast_candidate_table_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: []
}];

var PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = exports.PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS_SETTING = [{
    key: "PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS",
    model: "advance_setting.placement_job_broadcast_candidate_table_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: []
}];

var TIME_SHEET_JOB_DIALOG_SETTINGS = exports.TIME_SHEET_JOB_DIALOG_SETTINGS = [{
    key: "HIDE_SHIFT_JOB_DUPLICATE_BUTTON",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.hide_shift_job_duplicate_button'
}, {
    key: "HIDE_SHIFT_JOB_UPDATE_MANAGER_SECTION",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.hide_shift_job_update_manager'
}, {
    key: "HIDE_SHIFT_JOB_NOTES_SECTION",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.hide_shift_job_notes'
}];

var SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES = exports.SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES = [{
    key: "SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "advance_setting.admin_default_hide_unavailable_candidates"
}];

var DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR_SETTINGS = exports.DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR_SETTINGS = [{
    key: "DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.filter_client_types_shift_job_calendar',
    optionListModel: 'employer_types',
    default: []
}];

var DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR_SETTINGS = exports.DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR_SETTINGS = [{
    key: "DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.filter_client_statuses_shift_job_calendar',
    optionListModel: 'employer_statuses',
    default: []
}];

var UNASSIGN_CANDIDATE_SETTINGS = exports.UNASSIGN_CANDIDATE_SETTINGS = [{
    key: "SEND_EMAIL_NOTIFICATION_WHEN_UNASSIGN_CANDIDATE",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.send_email_to_candidate_on_unassign',
    default: true
}];

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_format_parse__ = __webpack_require__(600);


function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _extends$1() {
  return _extends$1 = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends$1.apply(this, arguments);
}

var normalMerge = ["attrs", "props", "domProps"],
    toArrayMerge = ["class", "style", "directives"],
    functionalMerge = ["on", "nativeOn"],
    mergeJsxProps = function mergeJsxProps(a) {
  return a.reduce(function (c, a) {
    for (var b in a) {
      if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends$1({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
        var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];
        c[b] = d.concat(e);
      } else if (-1 !== functionalMerge.indexOf(b)) {
        for (var f in a[b]) {
          if (c[b][f]) {
            var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
                h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
            c[b][f] = g.concat(h);
          } else c[b][f] = a[b][f];
        }
      } else if ("hook" == b) for (var i in a[b]) {
        c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];
      } else c[b] = a[b];
    }

    return c;
  }, {});
},
    mergeFn = function mergeFn(a, b) {
  return function () {
    a && a.apply(this, arguments), b && b.apply(this, arguments);
  };
};

var helper = mergeJsxProps;

// new Date(10, 0, 1) The year from 0 to 99 will be incremented by 1900 automatically.
function createDate(y) {
  var M = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var date = new Date(y, M, d, h, m, s, ms);

  if (y < 100 && y >= 0) {
    date.setFullYear(y);
  }

  return date;
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}
function isValidRangeDate(date) {
  return Array.isArray(date) && date.length === 2 && date.every(isValidDate) && date[0] <= date[1];
}
function isValidDates(dates) {
  return Array.isArray(dates) && dates.every(isValidDate);
}
function getValidDate(value) {
  var date = new Date(value);

  if (isValidDate(date)) {
    return date;
  }

  for (var _len = arguments.length, backup = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    backup[_key - 1] = arguments[_key];
  }

  if (backup.length) {
    return getValidDate.apply(void 0, backup);
  }

  return new Date();
}
function startOfYear(value) {
  var date = new Date(value);
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfMonth(value) {
  var date = new Date(value);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfDay(value) {
  var date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}
function getCalendar(_ref) {
  var firstDayOfWeek = _ref.firstDayOfWeek,
      year = _ref.year,
      month = _ref.month;
  var arr = []; // change to the last day of the last month

  var calendar = createDate(year, month, 0);
  var lastDayInLastMonth = calendar.getDate(); // getDay() 0 is Sunday, 1 is Monday

  var firstDayInLastMonth = lastDayInLastMonth - (calendar.getDay() + 7 - firstDayOfWeek) % 7;

  for (var i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
    arr.push(createDate(year, month, i - lastDayInLastMonth));
  } // change to the last day of the current month


  calendar.setMonth(month + 1, 0);
  var lastDayInCurrentMonth = calendar.getDate();

  for (var _i = 1; _i <= lastDayInCurrentMonth; _i++) {
    arr.push(createDate(year, month, _i));
  }

  var lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1;
  var nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth;

  for (var _i2 = 1; _i2 <= nextMonthLength; _i2++) {
    arr.push(createDate(year, month, lastDayInCurrentMonth + _i2));
  }

  return arr;
}
function setMonth(dirtyDate, dirtyMonth) {
  var date = new Date(dirtyDate);
  var month = typeof dirtyMonth === 'function' ? dirtyMonth(date.getMonth()) : Number(dirtyMonth);
  var year = date.getFullYear();
  var daysInMonth = createDate(year, month + 1, 0).getDate();
  var day = date.getDate();
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
function setYear(dirtyDate, dirtyYear) {
  var date = new Date(dirtyDate);
  var year = typeof dirtyYear === 'function' ? dirtyYear(date.getFullYear()) : dirtyYear;
  date.setFullYear(year);
  return date;
}
function assignTime(target, source) {
  var date = new Date(target);
  var time = new Date(source);
  date.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
  return date;
}

/**
 * chunk the array
 * @param {Array} arr
 * @param {Number} size
 */
function chunk(arr, size) {
  if (!Array.isArray(arr)) {
    return [];
  }

  var result = [];
  var len = arr.length;
  var i = 0;
  size = size || len;

  while (i < len) {
    result.push(arr.slice(i, i += size));
  }

  return result;
}
/**
 * isObject
 * @param {*} obj
 * @returns {Boolean}
 */

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * pick object
 * @param {Object} obj
 * @param {Array|String} props
 */

function pick(obj, props) {
  if (!isObject(obj)) return {};

  if (!Array.isArray(props)) {
    props = [props];
  }

  var res = {};
  props.forEach(function (prop) {
    if (prop in obj) {
      res[prop] = obj[prop];
    }
  });
  return res;
}
/**
 * deep merge two object without merging array
 * @param {object} target
 * @param {object} source
 */

function mergeDeep(target, source) {
  if (!isObject(target)) {
    return {};
  }

  var result = target;

  if (isObject(source)) {
    Object.keys(source).forEach(function (key) {
      var value = source[key];

      if (isObject(value) && isObject(target[key])) {
        value = mergeDeep(target[key], value);
      }

      result = _objectSpread2({}, result, _defineProperty({}, key, value));
    });
  }

  return result;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var en = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;
});

var en$1 = unwrapExports(en);

var lang = {
  formatLocale: en$1,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true
};

var defaultLocale = 'en';
var locales = {};
locales[defaultLocale] = lang;
function locale(name, object, isLocal) {
  if (typeof name !== 'string') return locales[defaultLocale];
  var l = defaultLocale;

  if (locales[name]) {
    l = name;
  }

  if (object) {
    locales[name] = object;
    l = name;
  }

  if (!isLocal) {
    defaultLocale = l;
  }

  return locales[name] || locales[defaultLocale];
}
/**
 * get locale object
 * @param {string} name lang
 */

function getLocale(name) {
  return locale(name, null, true);
}

/* istanbul ignore file */
function rafThrottle(fn) {
  var isRunning = false;
  return function fnBinfRaf() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isRunning) return;
    isRunning = true;
    requestAnimationFrame(function () {
      isRunning = false;
      fn.apply(_this, args);
    });
  };
}

/**
 * get the hidden element width, height
 * @param {HTMLElement} element dom
 */
function getPopupElementSize(element) {
  var originalDisplay = element.style.display;
  var originalVisibility = element.style.visibility;
  element.style.display = 'block';
  element.style.visibility = 'hidden';
  var styles = window.getComputedStyle(element);
  var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
  var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
  element.style.display = originalDisplay;
  element.style.visibility = originalVisibility;
  return {
    width: width,
    height: height
  };
}
/**
 * get the popup position
 * @param {HTMLElement} el relative element
 * @param {Number} targetWidth target element's width
 * @param {Number} targetHeight target element's height
 * @param {Boolean} fixed
 */

function getRelativePosition(el, targetWidth, targetHeight, fixed) {
  var left = 0;
  var top = 0;
  var offsetX = 0;
  var offsetY = 0;
  var relativeRect = el.getBoundingClientRect();
  var dw = document.documentElement.clientWidth;
  var dh = document.documentElement.clientHeight;

  if (fixed) {
    offsetX = window.pageXOffset + relativeRect.left;
    offsetY = window.pageYOffset + relativeRect.top;
  }

  if (dw - relativeRect.left < targetWidth && relativeRect.right < targetWidth) {
    left = offsetX - relativeRect.left + 1;
  } else if (relativeRect.left + relativeRect.width / 2 <= dw / 2) {
    left = offsetX;
  } else {
    left = offsetX + relativeRect.width - targetWidth;
  }

  if (relativeRect.top <= targetHeight && dh - relativeRect.bottom <= targetHeight) {
    top = offsetY + dh - relativeRect.top - targetHeight;
  } else if (relativeRect.top + relativeRect.height / 2 <= dh / 2) {
    top = offsetY + relativeRect.height;
  } else {
    top = offsetY - targetHeight;
  }

  return {
    left: "".concat(left, "px"),
    top: "".concat(top, "px")
  };
}
function getScrollParent(node) {
  var until = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  if (!node || node === until) {
    return null;
  }

  var style = function style(value, prop) {
    return getComputedStyle(value, null).getPropertyValue(prop);
  };

  var regex = /(auto|scroll)/;
  var scroll = regex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'));
  return scroll ? node : getScrollParent(node.parentNode, until);
}

//
var script = {
  name: 'Popup',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      top: '',
      left: ''
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        this.$nextTick(function () {
          if (val) {
            _this.displayPopup();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }

    this._clickoutEvent = 'ontouchend' in document ? 'touchstart' : 'mousedown';
    document.addEventListener(this._clickoutEvent, this.handleClickOutside); // change the popup position when resize or scroll

    var relativeElement = this.$parent.$el;
    this._displayPopup = rafThrottle(function () {
      return _this2.displayPopup();
    });
    this._scrollParent = getScrollParent(relativeElement) || window;

    this._scrollParent.addEventListener('scroll', this._displayPopup);

    window.addEventListener('resize', this._displayPopup);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.appendToBody && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }

    document.removeEventListener(this._clickoutEvent, this.handleClickOutside);

    this._scrollParent.removeEventListener('scroll', this._displayPopup);

    window.removeEventListener('resize', this._displayPopup);
  },
  methods: {
    handleClickOutside: function handleClickOutside(evt) {
      if (!this.visible) return;
      var target = evt.target;
      var el = this.$el;

      if (el && !el.contains(target)) {
        this.$emit('clickoutside', evt);
      }
    },
    displayPopup: function displayPopup() {
      if (!this.visible) return;
      var popup = this.$el;
      var relativeElement = this.$parent.$el;
      var appendToBody = this.appendToBody;

      if (!this._popupRect) {
        this._popupRect = getPopupElementSize(popup);
      }

      var _this$_popupRect = this._popupRect,
          width = _this$_popupRect.width,
          height = _this$_popupRect.height;

      var _getRelativePosition = getRelativePosition(relativeElement, width, height, appendToBody),
          left = _getRelativePosition.left,
          top = _getRelativePosition.top;

      this.left = left;
      this.top = top;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": _vm.prefixClass + "-zoom-in-down"
    }
  }, [_vm.visible ? _c('div', {
    class: _vm.prefixClass + "-datepicker-main " + _vm.prefixClass + "-datepicker-popup",
    style: {
      top: _vm.top,
      left: _vm.left,
      position: 'absolute'
    }
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"
    }
  })]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, {}, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  })]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, {}, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
    }
  })]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, {}, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: {
    type: String
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-icon-" + _vm.type,
    attrs: {
      "type": "button"
    }
  }, _vm.$listeners), [_c('i', {
    class: _vm.prefixClass + "-icon-" + _vm.type
  })]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$1, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$2 = {
  name: 'TableDate',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    getWeek: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_date_format_parse__["b" /* getWeek */];
      }
    },
    prefixClass: {
      default: 'mx'
    },
    onDateMouseEnter: {
      default: undefined
    },
    onDateMouseLeave: {
      default: undefined
    }
  },
  props: {
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    titleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    getRowClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    firstDayOfWeek: function firstDayOfWeek() {
      return this.getLocale().formatLocale.firstDayOfWeek || 0;
    },
    yearMonth: function yearMonth() {
      var _this$getLocale = this.getLocale(),
          yearFormat = _this$getLocale.yearFormat,
          monthBeforeYear = _this$getLocale.monthBeforeYear,
          _this$getLocale$month = _this$getLocale.monthFormat,
          monthFormat = _this$getLocale$month === void 0 ? 'MMM' : _this$getLocale$month;

      var yearLabel = {
        panel: 'year',
        label: this.formatDate(this.calendar, yearFormat)
      };
      var monthLabel = {
        panel: 'month',
        label: this.formatDate(this.calendar, monthFormat)
      };
      return monthBeforeYear ? [monthLabel, yearLabel] : [yearLabel, monthLabel];
    },
    days: function days() {
      var locale = this.getLocale();
      var days = locale.days || locale.formatLocale.weekdaysMin;
      return days.concat(days).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7);
    },
    dates: function dates() {
      var year = this.calendar.getFullYear();
      var month = this.calendar.getMonth();
      var arr = getCalendar({
        firstDayOfWeek: this.firstDayOfWeek,
        year: year,
        month: month
      });
      return chunk(arr, 7);
    }
  },
  methods: {
    handleIconLeftClick: function handleIconLeftClick() {
      this.$emit('changecalendar', setMonth(this.calendar, function (v) {
        return v - 1;
      }), 'last-month');
    },
    handleIconRightClick: function handleIconRightClick() {
      this.$emit('changecalendar', setMonth(this.calendar, function (v) {
        return v + 1;
      }), 'next-month');
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 1;
      }), 'last-year');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 1;
      }), 'next-year');
    },
    handlePanelChange: function handlePanelChange(panel) {
      this.$emit('changepanel', panel);
    },
    handleMouseEnter: function handleMouseEnter(cell) {
      if (typeof this.onDateMouseEnter === 'function') {
        this.onDateMouseEnter(cell);
      }
    },
    handleMouseLeave: function handleMouseLeave(cell) {
      if (typeof this.onDateMouseLeave === 'function') {
        this.onDateMouseLeave(cell);
      }
    },
    handleCellClick: function handleCellClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var index = target.getAttribute('data-row-col');

      if (index) {
        var _index$split$map = index.split(',').map(function (v) {
          return parseInt(v, 10);
        }),
            _index$split$map2 = _slicedToArray(_index$split$map, 2),
            row = _index$split$map2[0],
            col = _index$split$map2[1];

        var date = this.dates[row][col];
        this.$emit('select', new Date(date));
      }
    },
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    getCellTitle: function getCellTitle(date) {
      var fmt = this.titleFormat;
      return this.formatDate(date, fmt);
    },
    getWeekNumber: function getWeekNumber(date) {
      return this.getWeek(date, this.getLocale().formatLocale);
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-date"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left"
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "left"
    },
    on: {
      "click": _vm.handleIconLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right"
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "right"
    },
    on: {
      "click": _vm.handleIconRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, _vm._l(_vm.yearMonth, function (item) {
    return _c('button', {
      key: item.panel,
      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-current-" + item.panel,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.handlePanelChange(item.panel);
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]);
  }), 0)], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-date"
  }, [_c('thead', [_c('tr', [_vm.showWeekNumber ? _c('th', {
    class: _vm.prefixClass + "-week-number-header"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.days, function (day) {
    return _c('th', {
      key: day
    }, [_vm._v(_vm._s(day))]);
  })], 2)]), _vm._v(" "), _c('tbody', {
    on: {
      "click": _vm.handleCellClick
    }
  }, _vm._l(_vm.dates, function (row, i) {
    return _c('tr', {
      key: i,
      class: [_vm.prefixClass + "-date-row", _vm.getRowClasses(row)]
    }, [_vm.showWeekNumber ? _c('td', {
      class: _vm.prefixClass + "-week-number",
      attrs: {
        "data-row-col": i + ",0"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getWeekNumber(row[0])) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell),
        attrs: {
          "data-row-col": i + "," + j,
          "title": _vm.getCellTitle(cell)
        },
        on: {
          "mouseenter": function mouseenter($event) {
            return _vm.handleMouseEnter(cell);
          },
          "mouseleave": function mouseleave($event) {
            return _vm.handleMouseLeave(cell);
          }
        }
      }, [_c('div', [_vm._v(_vm._s(cell.getDate()))])]);
    })], 2);
  }), 0)])])]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$2, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$3 = {
  name: 'TableMonth',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    calendarYear: function calendarYear() {
      return this.calendar.getFullYear();
    },
    months: function months() {
      var locale = this.getLocale();
      var monthsLocale = locale.months || locale.formatLocale.monthsShort;
      var months = monthsLocale.map(function (text, month) {
        return {
          text: text,
          month: month
        };
      });
      return chunk(months, 3);
    }
  },
  methods: {
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 1;
      }), 'last-year');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 1;
      }), 'next-year');
    },
    handlePanelChange: function handlePanelChange() {
      this.$emit('changepanel', 'year');
    },
    handleClick: function handleClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var month = target.getAttribute('data-month');

      if (month) {
        this.$emit('select', parseInt(month, 10));
      }
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-month"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left"
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right"
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, [_c('button', {
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handlePanelChange
    }
  }, [_vm._v("\n        " + _vm._s(_vm.calendarYear) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-month",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l(_vm.months, function (row, i) {
    return _c('tr', {
      key: i
    }, _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell.month),
        attrs: {
          "data-month": cell.month
        }
      }, [_c('div', [_vm._v(_vm._s(cell.text))])]);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$3, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
var script$4 = {
  name: 'TableYear',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getYearPanel: {
      type: Function
    }
  },
  computed: {
    years: function years() {
      var calendar = new Date(this.calendar);

      if (typeof this.getYearPanel === 'function') {
        return this.getYearPanel(calendar);
      }

      return this.getYears(calendar);
    },
    firstYear: function firstYear() {
      return this.years[0][0];
    },
    lastYear: function lastYear() {
      var last = function last(arr) {
        return arr[arr.length - 1];
      };

      return last(last(this.years));
    }
  },
  methods: {
    getYears: function getYears(calendar) {
      var firstYear = Math.floor(calendar.getFullYear() / 10) * 10;
      var years = [];

      for (var i = 0; i < 10; i++) {
        years.push(firstYear + i);
      }

      return chunk(years, 2);
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 10;
      }), 'last-decade');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 10;
      }), 'next-decade');
    },
    handleClick: function handleClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var year = target.getAttribute('data-year');

      if (year) {
        this.$emit('select', parseInt(year, 10));
      }
    }
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-year"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left"
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right"
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.firstYear))]), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-decade-separator"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastYear))])])], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-year",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l(_vm.years, function (row, i) {
    return _c('tr', {
      key: i
    }, _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell),
        attrs: {
          "data-year": cell
        }
      }, [_c('div', [_vm._v(_vm._s(cell))])]);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$4, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var CalendarPanel = {
  name: 'CalendarPanel',
  inject: {
    prefixClass: {
      default: 'mx'
    },
    dispatchDatePicker: {
      default: function _default() {
        return function () {};
      }
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function _default() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }
    },
    defaultPanel: {
      type: String
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    type: {
      type: String,
      default: 'date'
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: undefined
    },
    getYearPanel: {
      type: Function
    },
    titleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    calendar: Date,
    // update date when select year or month
    partialUpdate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var panels = ['date', 'month', 'year'];
    var index = Math.max(panels.indexOf(this.type), panels.indexOf(this.defaultPanel));
    var panel = index !== -1 ? panels[index] : 'date';
    return {
      panel: panel,
      innerCalendar: new Date()
    };
  },
  computed: {
    innerValue: function innerValue() {
      var value = Array.isArray(this.value) ? this.value : [this.value];
      var map = {
        year: startOfYear,
        month: startOfMonth,
        date: startOfDay
      };
      var start = map[this.type] || map.date;
      return value.filter(isValidDate).map(function (v) {
        return start(v);
      });
    },
    calendarYear: function calendarYear() {
      return this.innerCalendar.getFullYear();
    },
    calendarMonth: function calendarMonth() {
      return this.innerCalendar.getMonth();
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: 'initCalendar'
    },
    calendar: {
      handler: 'initCalendar'
    },
    defaultValue: {
      handler: 'initCalendar'
    }
  },
  methods: {
    initCalendar: function initCalendar() {
      var calendarDate = this.calendar;

      if (!isValidDate(calendarDate)) {
        var length = this.innerValue.length;
        calendarDate = getValidDate(length > 0 ? this.innerValue[length - 1] : this.defaultValue);
      }

      this.innerCalendar = startOfMonth(calendarDate);
    },
    isDisabled: function isDisabled(date) {
      return this.disabledDate(new Date(date), this.innerValue);
    },
    emitDate: function emitDate(date, type) {
      if (!this.isDisabled(date)) {
        this.$emit('select', date, type, this.innerValue); // someone need get the first selected date to set range value. (#429)

        this.dispatchDatePicker('pick', date, type);
      }
    },
    handleCalendarChange: function handleCalendarChange(calendar, type) {
      var oldCalendar = new Date(this.innerCalendar);
      this.innerCalendar = calendar;
      this.$emit('update:calendar', calendar);
      this.dispatchDatePicker('calendar-change', calendar, oldCalendar, type);
    },
    handelPanelChange: function handelPanelChange(panel) {
      var oldPanel = this.panel;
      this.panel = panel;
      this.dispatchDatePicker('panel-change', panel, oldPanel);
    },
    handleSelectYear: function handleSelectYear(year) {
      if (this.type === 'year') {
        var date = this.getYearCellDate(year);
        this.emitDate(date, 'year');
      } else {
        this.handleCalendarChange(createDate(year, this.calendarMonth), 'year');
        this.handelPanelChange('month');

        if (this.partialUpdate && this.innerValue.length === 1) {
          var _date = new Date(this.innerValue[0]);

          _date.setFullYear(year);

          this.emitDate(_date, 'year');
        }
      }
    },
    handleSelectMonth: function handleSelectMonth(month) {
      if (this.type === 'month') {
        var date = this.getMonthCellDate(month);
        this.emitDate(date, 'month');
      } else {
        this.handleCalendarChange(createDate(this.calendarYear, month), 'month');
        this.handelPanelChange('date');

        if (this.partialUpdate && this.innerValue.length === 1) {
          var _date2 = new Date(this.innerValue[0]);

          _date2.setFullYear(this.calendarYear);

          this.emitDate(setMonth(_date2, month), 'month');
        }
      }
    },
    handleSelectDate: function handleSelectDate(date) {
      this.emitDate(date, this.type === 'week' ? 'week' : 'date');
    },
    getMonthCellDate: function getMonthCellDate(month) {
      return createDate(this.calendarYear, month);
    },
    getYearCellDate: function getYearCellDate(year) {
      return createDate(year, 0);
    },
    getDateClasses: function getDateClasses(cellDate) {
      var notCurrentMonth = cellDate.getMonth() !== this.calendarMonth;
      var classes = [];

      if (cellDate.getTime() === new Date().setHours(0, 0, 0, 0)) {
        classes.push('today');
      }

      if (notCurrentMonth) {
        classes.push('not-current-month');
      }

      var state = this.getStateClass(cellDate);

      if (!(state === 'active' && notCurrentMonth)) {
        classes.push(state);
      }

      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getMonthClasses: function getMonthClasses(month) {
      if (this.type !== 'month') {
        return this.calendarMonth === month ? 'active' : '';
      }

      var classes = [];
      var cellDate = this.getMonthCellDate(month);
      classes.push(this.getStateClass(cellDate));
      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getYearClasses: function getYearClasses(year) {
      if (this.type !== 'year') {
        return this.calendarYear === year ? 'active' : '';
      }

      var classes = [];
      var cellDate = this.getYearCellDate(year);
      classes.push(this.getStateClass(cellDate));
      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getStateClass: function getStateClass(cellDate) {
      if (this.isDisabled(cellDate)) {
        return 'disabled';
      }

      if (this.innerValue.some(function (v) {
        return v.getTime() === cellDate.getTime();
      })) {
        return 'active';
      }

      return '';
    },
    getWeekState: function getWeekState(row) {
      if (this.type !== 'week') return '';
      var start = row[0].getTime();
      var end = row[6].getTime();
      var active = this.innerValue.some(function (v) {
        var time = v.getTime();
        return time >= start && time <= end;
      });
      return active ? "".concat(this.prefixClass, "-active-week") : '';
    }
  },
  render: function render() {
    var h = arguments[0];
    var panel = this.panel,
        innerCalendar = this.innerCalendar;

    if (panel === 'year') {
      return h(__vue_component__$7, {
        "attrs": {
          "calendar": innerCalendar,
          "getCellClasses": this.getYearClasses,
          "getYearPanel": this.getYearPanel
        },
        "on": {
          "select": this.handleSelectYear,
          "changecalendar": this.handleCalendarChange
        }
      });
    }

    if (panel === 'month') {
      return h(__vue_component__$6, {
        "attrs": {
          "calendar": innerCalendar,
          "getCellClasses": this.getMonthClasses
        },
        "on": {
          "select": this.handleSelectMonth,
          "changepanel": this.handelPanelChange,
          "changecalendar": this.handleCalendarChange
        }
      });
    }

    return h(__vue_component__$5, {
      "class": _defineProperty({}, "".concat(this.prefixClass, "-calendar-week-mode"), this.type === 'week'),
      "attrs": {
        "calendar": innerCalendar,
        "getCellClasses": this.getDateClasses,
        "getRowClasses": this.getWeekState,
        "titleFormat": this.titleFormat,
        "showWeekNumber": typeof this.showWeekNumber === 'boolean' ? this.showWeekNumber : this.type === 'week'
      },
      "on": {
        "select": this.handleSelectDate,
        "changepanel": this.handelPanelChange,
        "changecalendar": this.handleCalendarChange
      }
    });
  }
};

var CalendarRange = {
  name: 'CalendarRange',
  components: {
    CalendarPanel: CalendarPanel
  },
  provide: function provide() {
    return {
      onDateMouseEnter: this.onDateMouseEnter,
      onDateMouseLeave: this.onDateMouseLeave
    };
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: _objectSpread2({}, CalendarPanel.props),
  data: function data() {
    return {
      innerValue: [],
      calendars: [],
      hoveredValue: null
    };
  },
  computed: {
    // Minimum difference between start and end calendars
    calendarMinDiff: function calendarMinDiff() {
      var map = {
        date: 1,
        // type:date  min 1 month
        month: 1 * 12,
        // type:month min 1 year
        year: 10 * 12 // type:year  min 10 year

      };
      return map[this.type] || map.date;
    },
    calendarMaxDiff: function calendarMaxDiff() {
      return Infinity;
    },
    defaultValues: function defaultValues() {
      return Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        this.innerValue = isValidRangeDate(this.value) ? this.value : [new Date(NaN), new Date(NaN)];
        var calendars = this.innerValue.map(function (v, i) {
          return startOfMonth(getValidDate(v, _this.defaultValues[i]));
        });
        this.updateCalendars(calendars);
      }
    }
  },
  methods: {
    handleSelect: function handleSelect(date, type) {
      var _this$innerValue = _slicedToArray(this.innerValue, 2),
          startValue = _this$innerValue[0],
          endValue = _this$innerValue[1];

      if (isValidDate(startValue) && !isValidDate(endValue)) {
        if (startValue.getTime() > date.getTime()) {
          this.innerValue = [date, startValue];
        } else {
          this.innerValue = [startValue, date];
        }

        this.emitDate(this.innerValue, type);
      } else {
        this.innerValue = [date, new Date(NaN)];
      }
    },
    onDateMouseEnter: function onDateMouseEnter(cell) {
      this.hoveredValue = cell;
    },
    onDateMouseLeave: function onDateMouseLeave() {
      this.hoveredValue = null;
    },
    emitDate: function emitDate(dates, type) {
      this.$emit('select', dates, type);
    },
    updateStartCalendar: function updateStartCalendar(value) {
      this.updateCalendars([value, this.calendars[1]], 1);
    },
    updateEndCalendar: function updateEndCalendar(value) {
      this.updateCalendars([this.calendars[0], value], 0);
    },
    updateCalendars: function updateCalendars(calendars) {
      var adjustIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var gap = this.getCalendarGap(calendars);

      if (gap) {
        var calendar = new Date(calendars[adjustIndex]);
        calendar.setMonth(calendar.getMonth() + (adjustIndex === 0 ? -gap : gap));
        calendars[adjustIndex] = calendar;
      }

      this.calendars = calendars;
    },
    getCalendarGap: function getCalendarGap(calendars) {
      var _calendars = _slicedToArray(calendars, 2),
          calendarLeft = _calendars[0],
          calendarRight = _calendars[1];

      var yearDiff = calendarRight.getFullYear() - calendarLeft.getFullYear();
      var monthDiff = calendarRight.getMonth() - calendarLeft.getMonth();
      var diff = yearDiff * 12 + monthDiff;
      var min = this.calendarMinDiff;
      var max = this.calendarMaxDiff;

      if (diff < min) {
        return min - diff;
      }

      if (diff > max) {
        return max - diff;
      }

      return 0;
    },
    getRangeClasses: function getRangeClasses(cellDate, currentDates, classnames) {
      var classes = [].concat(this.getClasses(cellDate, currentDates, classnames));
      if (/disabled|active/.test(classnames)) return classes;

      var inRange = function inRange(data, range) {
        var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
          return v.getTime();
        };
        var value = fn(data);

        var _range$map = range.map(fn),
            _range$map2 = _slicedToArray(_range$map, 2),
            min = _range$map2[0],
            max = _range$map2[1];

        if (min > max) {
          var _ref = [max, min];
          min = _ref[0];
          max = _ref[1];
        }

        return value > min && value < max;
      };

      if (currentDates.length === 2 && inRange(cellDate, currentDates)) {
        return classes.concat('in-range');
      }

      if (currentDates.length === 1 && this.hoveredValue && inRange(cellDate, [currentDates[0], this.hoveredValue])) {
        return classes.concat('hover-in-range');
      }

      return classes;
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var calendarRange = this.calendars.map(function (calendar, index) {
      var props = _objectSpread2({}, _this2.$props, {
        calendar: calendar,
        value: _this2.innerValue,
        defaultValue: _this2.defaultValues[index],
        getClasses: _this2.getRangeClasses,
        // don't update when range is true
        partialUpdate: false
      });

      var on = {
        select: _this2.handleSelect,
        'update:calendar': index === 0 ? _this2.updateStartCalendar : _this2.updateEndCalendar
      };
      return h("calendar-panel", {
        "props": _objectSpread2({}, props),
        "on": _objectSpread2({}, on)
      });
    });
    var prefixClass = this.prefixClass;
    return h("div", {
      "class": "".concat(prefixClass, "-range-wrapper")
    }, [calendarRange]);
  }
};

var scrollBarWidth;
function getScrollbarWidth () {
  if (typeof window === 'undefined') return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  scrollBarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return scrollBarWidth;
}

//
var script$5 = {
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  data: function data() {
    return {
      scrollbarWidth: 0,
      thumbTop: '',
      thumbHeight: ''
    };
  },
  created: function created() {
    this.scrollbarWidth = getScrollbarWidth();
    document.addEventListener('mouseup', this.handleDragend);
  },
  beforeDestroy: function beforeDestroy() {
    document.addEventListener('mouseup', this.handleDragend);
  },
  mounted: function mounted() {
    this.$nextTick(this.getThumbSize);
  },
  methods: {
    getThumbSize: function getThumbSize() {
      var wrap = this.$refs.wrap;
      if (!wrap) return;
      var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      this.thumbHeight = heightPercentage < 100 ? "".concat(heightPercentage, "%") : '';
    },
    handleScroll: function handleScroll(evt) {
      var el = evt.currentTarget;
      var scrollHeight = el.scrollHeight,
          scrollTop = el.scrollTop;
      this.thumbTop = "".concat(scrollTop * 100 / scrollHeight, "%");
    },
    handleDragstart: function handleDragstart(evt) {
      evt.stopImmediatePropagation();
      this._draggable = true;
      var offsetTop = this.$refs.thumb.offsetTop;
      this._prevY = evt.clientY - offsetTop;
      document.addEventListener('mousemove', this.handleDraging);
    },
    handleDraging: function handleDraging(evt) {
      if (!this._draggable) return;
      var clientY = evt.clientY;
      var wrap = this.$refs.wrap;
      var scrollHeight = wrap.scrollHeight,
          clientHeight = wrap.clientHeight;
      var offsetY = clientY - this._prevY;
      var top = offsetY * scrollHeight / clientHeight;
      wrap.scrollTop = top;
    },
    handleDragend: function handleDragend() {
      if (this._draggable) {
        this._draggable = false;
        document.removeEventListener('mousemove', this.handleDraging);
      }
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-scrollbar",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, [_c('div', {
    ref: "wrap",
    class: _vm.prefixClass + "-scrollbar-wrap",
    style: {
      marginRight: "-" + _vm.scrollbarWidth + "px"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-scrollbar-track"
  }, [_c('div', {
    ref: "thumb",
    class: _vm.prefixClass + "-scrollbar-thumb",
    style: {
      height: _vm.thumbHeight,
      top: _vm.thumbTop
    },
    on: {
      "mousedown": _vm.handleDragstart
    }
  })])]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$5, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//

var padNumber = function padNumber(value) {
  value = parseInt(value, 10);
  return value < 10 ? "0".concat(value) : "".concat(value);
};

var generateOptions = function generateOptions(length, step, options) {
  if (Array.isArray(options)) {
    return options.filter(function (v) {
      return v >= 0 && v < length;
    });
  }

  if (step <= 0) {
    step = 1;
  }

  var arr = [];

  for (var i = 0; i < length; i += step) {
    arr.push(i);
  }

  return arr;
};

var scrollTo = function scrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  // jump to target if duration zero
  if (duration <= 0) {
    requestAnimationFrame(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var tick = difference / duration * 10;
  requestAnimationFrame(function () {
    var scrollTop = element.scrollTop + tick;

    if (scrollTop >= to) {
      element.scrollTop = to;
      return;
    }

    element.scrollTop = scrollTop;
    scrollTo(element, to, duration - 10);
  });
};

var script$6 = {
  name: 'ListColumns',
  components: {
    ScrollbarVertical: __vue_component__$8
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    date: Date,
    scrollDuration: {
      type: Number,
      default: 100
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    showHour: {
      type: Boolean,
      default: true
    },
    showMinute: {
      type: Boolean,
      default: true
    },
    showSecond: {
      type: Boolean,
      default: true
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    use12h: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columns: function columns() {
      var cols = [];
      if (this.showHour) cols.push({
        type: 'hour',
        list: this.getHoursList()
      });
      if (this.showMinute) cols.push({
        type: 'minute',
        list: this.getMinutesList()
      });
      if (this.showSecond) cols.push({
        type: 'second',
        list: this.getSecondsList()
      });
      if (this.use12h) cols.push({
        type: 'ampm',
        list: this.getAMPMList()
      });
      return cols.filter(function (v) {
        return v.list.length > 0;
      });
    }
  },
  watch: {
    date: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          _this.scrollToSelected(_this.scrollDuration);
        });
      }
    }
  },
  mounted: function mounted() {
    this.scrollToSelected(0);
  },
  methods: {
    getHoursList: function getHoursList() {
      var _this2 = this;

      return generateOptions(this.use12h ? 12 : 24, this.hourStep, this.hourOptions).map(function (num) {
        var date = new Date(_this2.date);
        var text = padNumber(num);

        if (_this2.use12h) {
          if (num === 0) {
            text = '12';
          }

          if (date.getHours() >= 12) {
            num += 12;
          }
        }

        var value = date.setHours(num);
        return {
          value: value,
          text: text
        };
      });
    },
    getMinutesList: function getMinutesList() {
      var _this3 = this;

      return generateOptions(60, this.minuteStep, this.minuteOptions).map(function (num) {
        var value = new Date(_this3.date).setMinutes(num);
        return {
          value: value,
          text: padNumber(num)
        };
      });
    },
    getSecondsList: function getSecondsList() {
      var _this4 = this;

      return generateOptions(60, this.secondStep, this.secondOptions).map(function (num) {
        var value = new Date(_this4.date).setSeconds(num);
        return {
          value: value,
          text: padNumber(num)
        };
      });
    },
    getAMPMList: function getAMPMList() {
      var _this5 = this;

      return ['AM', 'PM'].map(function (text, i) {
        var date = new Date(_this5.date);
        var value = date.setHours(date.getHours() % 12 + i * 12);
        return {
          text: text,
          value: value
        };
      });
    },
    scrollToSelected: function scrollToSelected(duration) {
      var elements = this.$el.querySelectorAll('.active');

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var scrollElement = getScrollParent(element, this.$el);

        if (scrollElement) {
          var to = element.offsetTop;
          scrollTo(scrollElement, to, duration);
        }
      }
    },
    handleSelect: function handleSelect(evt) {
      var target = evt.target,
          currentTarget = evt.currentTarget;
      if (target.tagName.toUpperCase() !== 'LI') return;
      var type = currentTarget.getAttribute('data-type');
      var colIndex = parseInt(currentTarget.getAttribute('data-index'), 10);
      var cellIndex = parseInt(target.getAttribute('data-index'), 10);
      var value = this.columns[colIndex].list[cellIndex].value;
      this.$emit('select', value, type);
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-time-columns"
  }, _vm._l(_vm.columns, function (col, i) {
    return _c('scrollbar-vertical', {
      key: i,
      class: _vm.prefixClass + "-time-column"
    }, [_c('ul', {
      class: _vm.prefixClass + "-time-list",
      attrs: {
        "data-type": col.type,
        "data-index": i
      },
      on: {
        "click": _vm.handleSelect
      }
    }, _vm._l(col.list, function (item, j) {
      return _c('li', {
        key: item.value,
        class: [_vm.prefixClass + "-time-item", _vm.getClasses(item.value, col.type)],
        attrs: {
          "data-index": j
        }
      }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
    }), 0)]);
  }), 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$6, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//

function parseOption() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var values = time.split(':');

  if (values.length >= 2) {
    var hours = parseInt(values[0], 10);
    var minutes = parseInt(values[1], 10);
    return {
      hours: hours,
      minutes: minutes
    };
  }

  return null;
}

var scrollTo$1 = function scrollTo(element, to) {
  if (element) {
    element.scrollTop = to;
  }
};

var script$7 = {
  name: 'ListOptions',
  components: {
    ScrollbarVertical: __vue_component__$8
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    date: Date,
    options: {
      type: [Object, Function],
      default: function _default() {
        return [];
      }
    },
    format: {
      type: String,
      default: 'HH:mm:ss'
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    list: function list() {
      var result = [];
      var options = this.options;

      if (typeof options === 'function') {
        return options() || [];
      }

      var start = parseOption(options.start);
      var end = parseOption(options.end);
      var step = parseOption(options.step);
      var fmt = options.format || this.format;

      if (start && end && step) {
        var startMinutes = start.minutes + start.hours * 60;
        var endMinutes = end.minutes + end.hours * 60;
        var stepMinutes = step.minutes + step.hours * 60;
        var len = Math.floor((endMinutes - startMinutes) / stepMinutes);

        for (var i = 0; i <= len; i++) {
          var timeMinutes = startMinutes + i * stepMinutes;
          var hours = Math.floor(timeMinutes / 60);
          var minutes = timeMinutes % 60;
          var value = new Date(this.date).setHours(hours, minutes, 0);
          result.push({
            value: value,
            text: this.formatDate(value, fmt)
          });
        }
      }

      return result;
    }
  },
  mounted: function mounted() {
    this.scrollToSelected();
  },
  methods: {
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    scrollToSelected: function scrollToSelected() {
      var element = this.$el.querySelector('.active');
      if (!element) return;
      var scrollElement = getScrollParent(element, this.$el);
      if (!scrollElement) return;
      var to = element.offsetTop;
      scrollTo$1(scrollElement, to);
    },
    handleSelect: function handleSelect(value) {
      this.$emit('select', value, 'time');
    }
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('scrollbar-vertical', _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.value,
      class: [_vm.prefixClass + "-time-option", _vm.getClasses(item.value)],
      on: {
        "click": function click($event) {
          return _vm.handleSelect(item.value);
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")]);
  }), 0);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$7, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
var script$8 = {
  name: 'TimePanel',
  components: {
    ListColumns: __vue_component__$9,
    ListOptions: __vue_component__$a
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function _default() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }
    },
    format: {
      default: 'HH:mm:ss'
    },
    timeTitleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    showTimeHeader: {
      type: Boolean,
      default: false
    },
    disabledTime: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    timePickerOptions: {
      type: [Object, Function],
      default: function _default() {
        return null;
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    showHour: {
      type: Boolean,
      default: undefined
    },
    showMinute: {
      type: Boolean,
      default: undefined
    },
    showSecond: {
      type: Boolean,
      default: undefined
    },
    use12h: {
      type: Boolean,
      default: undefined
    },
    scrollDuration: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      innerValue: getValidDate(this.value, this.defaultValue)
    };
  },
  computed: {
    title: function title() {
      var titleFormat = this.timeTitleFormat;
      var date = new Date(this.innerValue);
      return this.formatDate(date, titleFormat);
    },
    innerForamt: function innerForamt() {
      return typeof this.format === 'string' ? this.format : 'HH:mm:ss';
    },
    ShowHourMinuteSecondAMPM: function ShowHourMinuteSecondAMPM() {
      var _this = this;

      var fmt = this.innerForamt;
      var defaultProps = {
        showHour: /[HhKk]/.test(fmt),
        showMinute: /m/.test(fmt),
        showSecond: /s/.test(fmt),
        use12h: /a/i.test(fmt)
      };
      var obj = {};
      Object.keys(defaultProps).forEach(function (key) {
        obj[key] = typeof _this[key] === 'boolean' ? _this[key] : defaultProps[key];
      });
      return obj;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.innerValue = getValidDate(this.value, this.defaultValue);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    isDisabledTime: function isDisabledTime(value) {
      return this.disabledTime(new Date(value));
    },
    isDisabledHour: function isDisabledHour(date) {
      var value = new Date(date);
      return this.isDisabledTime(value) && this.isDisabledTime(value.setMinutes(0, 0, 0)) && this.isDisabledTime(value.setMinutes(59, 59, 999));
    },
    isDisabledMinute: function isDisabledMinute(date) {
      var value = new Date(date);
      return this.isDisabledTime(value) && this.isDisabledTime(value.setSeconds(0, 0)) && this.isDisabledTime(value.setSeconds(59, 999));
    },
    isDisabledAMPM: function isDisabledAMPM(date) {
      var value = new Date(date);
      var minHour = value.getHours() < 12 ? 0 : 12;
      var maxHour = minHour + 11;
      return this.isDisabledTime(value) && this.isDisabledTime(value.setHours(minHour, 0, 0, 0)) && this.isDisabledTime(value.setHours(maxHour, 59, 59, 999));
    },
    isDisabled: function isDisabled(date, type) {
      if (type === 'hour') {
        return this.isDisabledHour(date);
      }

      if (type === 'minute') {
        return this.isDisabledMinute(date);
      }

      if (type === 'ampm') {
        return this.isDisabledAMPM(date);
      }

      return this.isDisabledTime(date);
    },
    handleSelect: function handleSelect(value, type) {
      var date = new Date(value);

      if (!this.isDisabled(value, type)) {
        this.innerValue = date;

        if (!this.isDisabledTime(date)) {
          this.$emit('select', date, type);
        }
      }
    },
    handleClickTitle: function handleClickTitle() {
      this.$emit('clicktitle');
    },
    getClasses: function getClasses(value, type) {
      var cellDate = new Date(value);

      if (this.isDisabled(value, type)) {
        return 'disabled';
      }

      if (cellDate.getTime() === this.innerValue.getTime()) {
        return 'active';
      }

      return '';
    }
  }
};

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-time"
  }, [_vm.showTimeHeader ? _c('div', {
    class: _vm.prefixClass + "-time-header"
  }, [_c('button', {
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-time-header-title",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClickTitle
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-time-content"
  }, [_vm.timePickerOptions ? _c('list-options', {
    attrs: {
      "date": _vm.innerValue,
      "get-classes": _vm.getClasses,
      "options": _vm.timePickerOptions,
      "format": _vm.innerForamt
    },
    on: {
      "select": _vm.handleSelect
    }
  }) : _c('list-columns', _vm._b({
    attrs: {
      "date": _vm.innerValue,
      "get-classes": _vm.getClasses,
      "hour-options": _vm.hourOptions,
      "minute-options": _vm.minuteOptions,
      "second-options": _vm.secondOptions,
      "hour-step": _vm.hourStep,
      "minute-step": _vm.minuteStep,
      "second-step": _vm.secondStep,
      "scroll-duration": _vm.scrollDuration
    },
    on: {
      "select": _vm.handleSelect
    }
  }, 'list-columns', _vm.ShowHourMinuteSecondAMPM, false))], 1)]);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$8, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var TimeRange = {
  name: 'TimeRange',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: _objectSpread2({}, __vue_component__$b.props),
  data: function data() {
    return {
      startValue: new Date(NaN),
      endValue: new Date(NaN)
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (isValidRangeDate(this.value)) {
          var _this$value = _slicedToArray(this.value, 2),
              startValue = _this$value[0],
              endValue = _this$value[1];

          this.startValue = startValue;
          this.endValue = endValue;
        } else {
          this.startValue = new Date(NaN);
          this.endValue = new Date(NaN);
        }
      }
    }
  },
  methods: {
    emitChange: function emitChange(type, index) {
      var date = [this.startValue, this.endValue];
      this.$emit('select', date, type === 'time' ? 'time-range' : type, index);
    },
    handleSelectStart: function handleSelectStart(date, type) {
      this.startValue = date; // check the NaN

      if (!(this.endValue.getTime() >= date.getTime())) {
        this.endValue = date;
      }

      this.emitChange(type, 0);
    },
    handleSelectEnd: function handleSelectEnd(date, type) {
      // check the NaN
      this.endValue = date;

      if (!(this.startValue.getTime() <= date.getTime())) {
        this.startValue = date;
      }

      this.emitChange(type, 1);
    },
    disabledStartTime: function disabledStartTime(date) {
      return this.disabledTime(date, 0);
    },
    disabledEndTime: function disabledEndTime(date) {
      return date.getTime() < this.startValue.getTime() || this.disabledTime(date, 1);
    }
  },
  render: function render() {
    var h = arguments[0];
    var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    var prefixClass = this.prefixClass;
    return h("div", {
      "class": "".concat(prefixClass, "-range-wrapper")
    }, [h(__vue_component__$b, {
      "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
        value: this.startValue,
        defaultValue: defaultValues[0],
        disabledTime: this.disabledStartTime
      })),
      "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
        select: this.handleSelectStart
      }))
    }), h(__vue_component__$b, {
      "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
        value: this.endValue,
        defaultValue: defaultValues[1],
        disabledTime: this.disabledEndTime
      })),
      "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
        select: this.handleSelectEnd
      }))
    })]);
  }
};

var DatetimePanel = {
  name: 'DatetimePanel',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  emits: ['select', 'update:show-time-panel'],
  props: _objectSpread2({}, CalendarPanel.props, {}, __vue_component__$b.props, {
    showTimePanel: {
      type: Boolean,
      default: undefined
    }
  }),
  data: function data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    }
  },
  methods: {
    closeTimePanel: function closeTimePanel() {
      this.defaultTimeVisible = false;
      this.$emit('update:show-time-panel', false);
    },
    openTimePanel: function openTimePanel() {
      this.defaultTimeVisible = true;
      this.$emit('update:show-time-panel', true);
    },
    emitDate: function emitDate(date, type) {
      this.$emit('select', date, type);
    },
    handleSelect: function handleSelect(date, type) {
      if (type === 'date') {
        this.openTimePanel();
      }

      var datetime = assignTime(date, getValidDate(this.value, this.defaultValue));

      if (this.disabledTime(new Date(datetime))) {
        // set the time of defalutValue;
        datetime = assignTime(date, this.defaultValue);

        if (this.disabledTime(new Date(datetime))) {
          // if disabled don't emit date
          this.currentValue = datetime;
          return;
        }
      }

      this.emitDate(datetime, type);
    }
  },
  render: function render() {
    var h = arguments[0];
    var calendarProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarPanel.props)), {
        type: 'date',
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    };
    var timeProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(__vue_component__$b.props)), {
        showTimeHeader: true,
        value: this.currentValue
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    };
    var prefixClass = this.prefixClass;
    return h("div", [h(CalendarPanel, helper([{}, calendarProps])), this.timeVisible && h(__vue_component__$b, helper([{
      "class": "".concat(prefixClass, "-calendar-time")
    }, timeProps]))]);
  }
};

var DatetimeRange = {
  name: 'DatetimeRange',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  emits: ['select', 'update:show-time-panel'],
  props: _objectSpread2({}, CalendarRange.props, {}, TimeRange.props, {
    showTimePanel: {
      type: Boolean,
      default: undefined
    }
  }),
  data: function data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    }
  },
  methods: {
    closeTimePanel: function closeTimePanel() {
      this.defaultTimeVisible = false;
      this.$emit('update:show-time-panel', false);
    },
    openTimePanel: function openTimePanel() {
      this.defaultTimeVisible = true;
      this.$emit('update:show-time-panel', true);
    },
    emitDate: function emitDate(dates, type) {
      this.$emit('select', dates, type);
    },
    handleSelect: function handleSelect(dates, type) {
      var _this = this;

      if (type === 'date') {
        this.openTimePanel();
      }

      var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
      var datetimes = dates.map(function (date, i) {
        var time = isValidRangeDate(_this.value) ? _this.value[i] : defaultValues[i];
        return assignTime(date, time);
      });

      if (datetimes[1].getTime() < datetimes[0].getTime()) {
        datetimes = [datetimes[0], datetimes[0]];
      }

      if (datetimes.some(this.disabledTime)) {
        datetimes = dates.map(function (date, i) {
          return assignTime(date, defaultValues[i]);
        });

        if (datetimes.some(this.disabledTime)) {
          this.currentValue = datetimes;
          return;
        }
      }

      this.emitDate(datetimes, type);
    }
  },
  render: function render() {
    var h = arguments[0];
    var calendarProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarRange.props)), {
        type: 'date',
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    };
    var timeProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(TimeRange.props)), {
        value: this.currentValue,
        showTimeHeader: true
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    };
    var prefixClass = this.prefixClass;
    return h("div", [h(CalendarRange, helper([{}, calendarProps])), this.timeVisible && h(TimeRange, helper([{
      "class": "".concat(prefixClass, "-calendar-time")
    }, timeProps]))]);
  }
};

var componentMap = {
  default: CalendarPanel,
  time: __vue_component__$b,
  datetime: DatetimePanel
};
var componentRangeMap = {
  default: CalendarRange,
  time: TimeRange,
  datetime: DatetimeRange
};
var DatePicker = {
  name: 'DatePicker',
  provide: function provide() {
    var _this = this;

    return {
      // make locale reactive
      getLocale: function getLocale() {
        return _this.locale;
      },
      getWeek: this.getWeek,
      prefixClass: this.prefixClass,
      dispatchDatePicker: this.$emit.bind(this)
    };
  },
  props: _objectSpread2({}, DatetimePanel.props, {
    value: {},
    valueType: {
      type: String,
      default: 'date' // date, format, timestamp, or token like 'YYYY-MM-DD'

    },
    type: {
      type: String,
      // ['date', 'datetime', 'time', 'year', 'month', 'week']
      default: 'date'
    },
    format: {
      type: String
    },
    formatter: {
      type: Object
    },
    range: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rangeSeparator: {
      type: String
    },
    lang: {
      type: [String, Object]
    },
    placeholder: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    prefixClass: {
      type: String,
      default: 'mx'
    },
    inputClass: {},
    inputAttr: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: undefined
    },
    popupClass: {},
    popupStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    inline: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    renderInputText: {
      type: Function
    },
    shortcuts: {
      type: Array,
      validator: function validator(value) {
        return Array.isArray(value) && value.every(function (v) {
          return isObject(v) && typeof v.text === 'string' && typeof v.onClick === 'function';
        });
      },
      default: function _default() {
        return [];
      }
    }
  }),
  data: function data() {
    return {
      // cache the innervalue, wait to confirm
      currentValue: null,
      userInput: null,
      defaultOpen: false
    };
  },
  computed: {
    popupVisible: function popupVisible() {
      return !this.disabled && (typeof this.open === 'boolean' ? this.open : this.defaultOpen);
    },
    innerRangeSeparator: function innerRangeSeparator() {
      return this.rangeSeparator || (this.multiple ? ',' : ' ~ ');
    },
    innerFormat: function innerFormat() {
      var map = {
        date: 'YYYY-MM-DD',
        datetime: 'YYYY-MM-DD HH:mm:ss',
        year: 'YYYY',
        month: 'YYYY-MM',
        time: 'HH:mm:ss',
        week: 'w'
      };
      return this.format || map[this.type] || map.date;
    },
    innerValue: function innerValue() {
      var value = this.value;

      if (this.validMultipleType) {
        value = Array.isArray(value) ? value : [];
        return value.map(this.value2date);
      }

      if (this.range) {
        value = Array.isArray(value) ? value.slice(0, 2) : [null, null];
        return value.map(this.value2date);
      }

      return this.value2date(value);
    },
    text: function text() {
      var _this2 = this;

      if (this.userInput !== null) {
        return this.userInput;
      }

      if (typeof this.renderInputText === 'function') {
        return this.renderInputText(this.innerValue);
      }

      if (!this.isValidValue(this.innerValue)) {
        return '';
      }

      if (Array.isArray(this.innerValue)) {
        return this.innerValue.map(function (v) {
          return _this2.formatDate(v);
        }).join(this.innerRangeSeparator);
      }

      return this.formatDate(this.innerValue);
    },
    showClearIcon: function showClearIcon() {
      return !this.disabled && this.clearable && this.text;
    },
    locale: function locale() {
      if (isObject(this.lang)) {
        return mergeDeep(getLocale(), this.lang);
      }

      return getLocale(this.lang);
    },
    validMultipleType: function validMultipleType() {
      var types = ['date', 'month', 'year'];
      return this.multiple && !this.range && types.indexOf(this.type) !== -1;
    }
  },
  watch: {
    innerValue: {
      immediate: true,
      handler: function handler(val) {
        this.currentValue = val;
      }
    },
    popupVisible: {
      handler: function handler(val) {
        if (val) {
          this.currentValue = this.innerValue;
        }
      }
    }
  },
  created: function created() {
    if (_typeof(this.format) === 'object') {
      console.warn("[vue2-datepicker]: The prop `format` don't support Object any more. You can use the new prop `formatter` to replace it");
    }
  },
  methods: {
    handleClickOutSide: function handleClickOutSide(evt) {
      var target = evt.target;

      if (!this.$el.contains(target)) {
        this.closePopup();
      }
    },
    getFormatter: function getFormatter(key) {
      return isObject(this.formatter) && this.formatter[key] || isObject(this.format) && this.format[key];
    },
    getWeek: function getWeek$1(date, options) {
      if (typeof this.getFormatter('getWeek') === 'function') {
        return this.getFormatter('getWeek')(date, options);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["b" /* getWeek */])(date, options);
    },
    parseDate: function parseDate(value, fmt) {
      fmt = fmt || this.innerFormat;

      if (typeof this.getFormatter('parse') === 'function') {
        return this.getFormatter('parse')(value, fmt);
      }

      var backupDate = new Date();
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["c" /* parse */])(value, fmt, {
        locale: this.locale.formatLocale,
        backupDate: backupDate
      });
    },
    formatDate: function formatDate(date, fmt) {
      fmt = fmt || this.innerFormat;

      if (typeof this.getFormatter('stringify') === 'function') {
        return this.getFormatter('stringify')(date, fmt);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.locale.formatLocale
      });
    },
    // transform the outer value to inner date
    value2date: function value2date(value) {
      switch (this.valueType) {
        case 'date':
          return value instanceof Date ? new Date(value.getTime()) : new Date(NaN);

        case 'timestamp':
          return typeof value === 'number' ? new Date(value) : new Date(NaN);

        case 'format':
          return typeof value === 'string' ? this.parseDate(value) : new Date(NaN);

        default:
          return typeof value === 'string' ? this.parseDate(value, this.valueType) : new Date(NaN);
      }
    },
    // transform the inner date to outer value
    date2value: function date2value(date) {
      if (!isValidDate(date)) return null;

      switch (this.valueType) {
        case 'date':
          return date;

        case 'timestamp':
          return date.getTime();

        case 'format':
          return this.formatDate(date);

        default:
          return this.formatDate(date, this.valueType);
      }
    },
    emitValue: function emitValue(date, type) {
      var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // fix IE11/10 trigger input event when input is focused. (placeholder !== '')
      this.userInput = null;
      var value = Array.isArray(date) ? date.map(this.date2value) : this.date2value(date);
      this.$emit('input', value);
      this.$emit('change', value, type);

      if (close) {
        this.closePopup();
      }

      return value;
    },
    isValidValue: function isValidValue(value) {
      if (this.validMultipleType) {
        return isValidDates(value);
      }

      if (this.range) {
        return isValidRangeDate(value);
      }

      return isValidDate(value);
    },
    isValidValueAndNotDisabled: function isValidValueAndNotDisabled(value) {
      if (!this.isValidValue(value)) {
        return false;
      }

      var disabledDate = typeof this.disabledDate === 'function' ? this.disabledDate : function () {
        return false;
      };
      var disabledTime = typeof this.disabledTime === 'function' ? this.disabledTime : function () {
        return false;
      };

      if (!Array.isArray(value)) {
        value = [value];
      }

      return value.every(function (v) {
        return !disabledDate(v) && !disabledTime(v);
      });
    },
    handleMultipleDates: function handleMultipleDates(date, dates) {
      if (this.validMultipleType && dates) {
        var nextDates = dates.filter(function (v) {
          return v.getTime() !== date.getTime();
        });

        if (nextDates.length === dates.length) {
          nextDates.push(date);
        }

        return nextDates;
      }

      return date;
    },
    handleSelectDate: function handleSelectDate(val, type, dates) {
      val = this.handleMultipleDates(val, dates);

      if (this.confirm) {
        this.currentValue = val;
      } else {
        this.emitValue(val, type, // this.type === 'datetime', click the time should close popup
        !this.validMultipleType && (type === this.type || type === 'time'));
      }
    },
    clear: function clear() {
      this.emitValue(this.range ? [null, null] : null);
      this.$emit('clear');
    },
    handleClear: function handleClear(evt) {
      evt.stopPropagation();
      this.clear();
    },
    handleConfirmDate: function handleConfirmDate() {
      var value = this.emitValue(this.currentValue);
      this.$emit('confirm', value);
    },
    handleSelectShortcut: function handleSelectShortcut(evt) {
      var index = evt.currentTarget.getAttribute('data-index');
      var item = this.shortcuts[parseInt(index, 10)];

      if (isObject(item) && typeof item.onClick === 'function') {
        var date = item.onClick(this);

        if (date) {
          this.emitValue(date);
        }
      }
    },
    openPopup: function openPopup(evt) {
      if (this.popupVisible || this.disabled) return;
      this.defaultOpen = true;
      this.$emit('open', evt);
      this.$emit('update:open', true);
    },
    closePopup: function closePopup() {
      if (!this.popupVisible) return;
      this.defaultOpen = false;
      this.$emit('close');
      this.$emit('update:open', false);
    },
    blur: function blur() {
      // when use slot input
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    focus: function focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    handleInputChange: function handleInputChange() {
      var _this3 = this;

      if (!this.editable || this.userInput === null) return;
      var text = this.userInput.trim();
      this.userInput = null;

      if (text === '') {
        this.clear();
        return;
      }

      var date;

      if (this.validMultipleType) {
        date = text.split(this.innerRangeSeparator).map(function (v) {
          return _this3.parseDate(v.trim());
        });
      } else if (this.range) {
        var arr = text.split(this.innerRangeSeparator);

        if (arr.length !== 2) {
          // Maybe the separator during the day is the same as the separator for the date
          // eg: 2019-10-09-2020-01-02
          arr = text.split(this.innerRangeSeparator.trim());
        }

        date = arr.map(function (v) {
          return _this3.parseDate(v.trim());
        });
      } else {
        date = this.parseDate(text);
      }

      if (this.isValidValueAndNotDisabled(date)) {
        this.emitValue(date);
        this.blur();
      } else {
        this.$emit('input-error', text);
      }
    },
    handleInputInput: function handleInputInput(evt) {
      // slot input v-model
      this.userInput = typeof evt === 'string' ? evt : evt.target.value;
    },
    handleInputKeydown: function handleInputKeydown(evt) {
      var keyCode = evt.keyCode; // Tab 9 or Enter 13

      if (keyCode === 9) {
        this.closePopup();
      } else if (keyCode === 13) {
        this.handleInputChange();
      }
    },
    handleInputBlur: function handleInputBlur(evt) {
      // tab close
      this.$emit('blur', evt);
    },
    handleInputFocus: function handleInputFocus(evt) {
      this.openPopup(evt);
      this.$emit('focus', evt);
    },
    hasSlot: function hasSlot(name) {
      return !!(this.$slots[name] || this.$scopedSlots[name]);
    },
    renderSlot: function renderSlot(name, fallback, props) {
      var slotFn = this.$scopedSlots[name];

      if (slotFn) {
        return slotFn(props) || fallback;
      }

      return this.$slots[name] || fallback;
    },
    renderInput: function renderInput() {
      var h = this.$createElement;
      var prefixClass = this.prefixClass;

      var props = _objectSpread2({
        name: 'date',
        type: 'text',
        autocomplete: 'off',
        value: this.text,
        class: this.inputClass || "".concat(this.prefixClass, "-input"),
        readonly: !this.editable,
        disabled: this.disabled,
        placeholder: this.placeholder
      }, this.inputAttr);

      var value = props.value,
          className = props.class,
          attrs = _objectWithoutProperties(props, ["value", "class"]);

      var events = {
        keydown: this.handleInputKeydown,
        focus: this.handleInputFocus,
        blur: this.handleInputBlur,
        input: this.handleInputInput,
        change: this.handleInputChange
      };
      var input = this.renderSlot('input', h("input", {
        "domProps": {
          "value": value
        },
        "class": className,
        "attrs": _objectSpread2({}, attrs),
        "on": _objectSpread2({}, events),
        "ref": "input"
      }), {
        props: props,
        events: events
      });
      var calendarIcon = this.type === 'time' ? h(__vue_component__$2) : h(__vue_component__$1);
      return h("div", {
        "class": "".concat(prefixClass, "-input-wrapper"),
        "on": {
          "mousedown": this.openPopup,
          "touchstart": this.openPopup
        }
      }, [input, this.showClearIcon ? h("i", {
        "class": "".concat(prefixClass, "-icon-clear"),
        "on": {
          "mousedown": this.handleClear,
          "touchstart": this.handleClear
        }
      }, [this.renderSlot('icon-clear', h(__vue_component__$3))]) : null, h("i", {
        "class": "".concat(prefixClass, "-icon-calendar")
      }, [this.renderSlot('icon-calendar', calendarIcon)])]);
    },
    renderContent: function renderContent() {
      var h = this.$createElement;
      var map = this.range ? componentRangeMap : componentMap;
      var Component = map[this.type] || map.default;

      var props = _objectSpread2({}, pick(this.$props, Object.keys(Component.props)), {
        value: this.currentValue
      });

      var on = _objectSpread2({}, pick(this.$listeners, Component.emits || []), {
        select: this.handleSelectDate
      });

      var content = h(Component, helper([{}, {
        props: props,
        on: on,
        ref: 'picker'
      }]));
      return h("div", {
        "class": "".concat(this.prefixClass, "-datepicker-body")
      }, [this.renderSlot('content', content, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderSidebar: function renderSidebar() {
      var _this4 = this;

      var h = this.$createElement;
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-datepicker-sidebar")
      }, [this.renderSlot('sidebar', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.shortcuts.map(function (v, i) {
        return h("button", {
          "key": i,
          "attrs": {
            "data-index": i,
            "type": "button"
          },
          "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-btn-text ").concat(prefixClass, "-btn-shortcut"),
          "on": {
            "click": _this4.handleSelectShortcut
          }
        }, [v.text]);
      })]);
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      return h("div", {
        "class": "".concat(this.prefixClass, "-datepicker-header")
      }, [this.renderSlot('header', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderFooter: function renderFooter() {
      var h = this.$createElement;
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-datepicker-footer")
      }, [this.renderSlot('footer', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.confirm ? h("button", {
        "attrs": {
          "type": "button"
        },
        "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-datepicker-btn-confirm"),
        "on": {
          "click": this.handleConfirmDate
        }
      }, [this.confirmText]) : null]);
    }
  },
  render: function render() {
    var _class;

    var h = arguments[0];
    var prefixClass = this.prefixClass,
        inline = this.inline,
        disabled = this.disabled;
    var sidedar = this.hasSlot('sidebar') || this.shortcuts.length ? this.renderSidebar() : null;
    var content = h("div", {
      "class": "".concat(prefixClass, "-datepicker-content")
    }, [this.hasSlot('header') ? this.renderHeader() : null, this.renderContent(), this.hasSlot('footer') || this.confirm ? this.renderFooter() : null]);
    return h("div", {
      "class": (_class = {}, _defineProperty(_class, "".concat(prefixClass, "-datepicker"), true), _defineProperty(_class, "".concat(prefixClass, "-datepicker-range"), this.range), _defineProperty(_class, "".concat(prefixClass, "-datepicker-inline"), inline), _defineProperty(_class, "disabled", disabled), _class)
    }, [!inline ? this.renderInput() : null, !inline ? h(__vue_component__, {
      "ref": "popup",
      "class": this.popupClass,
      "style": this.popupStyle,
      "attrs": {
        "visible": this.popupVisible,
        "appendToBody": this.appendToBody
      },
      "on": {
        "clickoutside": this.handleClickOutSide
      }
    }, [sidedar, content]) : h("div", {
      "class": "".concat(prefixClass, "-datepicker-main")
    }, [sidedar, content])]);
  }
};

DatePicker.locale = locale;

DatePicker.install = function install(Vue) {
  Vue.component(DatePicker.name, DatePicker);
};

if (typeof window !== 'undefined' && window.Vue) {
  DatePicker.install(window.Vue);
}

_extends(DatePicker, {
  CalendarPanel: CalendarPanel,
  CalendarRange: CalendarRange,
  TimePanel: __vue_component__$b,
  TimeRange: TimeRange,
  DatetimePanel: DatetimePanel,
  DatetimeRange: DatetimeRange
});

/* harmony default export */ __webpack_exports__["default"] = (DatePicker);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(197);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _ApplicationForm = __webpack_require__(524);

var _ApplicationForm2 = _interopRequireDefault(_ApplicationForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [{
    path: "/application-form/:agencyID/:profileID",
    component: _ApplicationForm2.default,
    name: "Application Form Builder"
}];

exports.default = new _vueRouter2.default({ mode: "history", routes: routes });

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var document = __webpack_require__(7).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(29);
var LIBRARY = __webpack_require__(42);
var wksExt = __webpack_require__(152);
var defineProperty = __webpack_require__(15).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(68)('keys');
var uid = __webpack_require__(48);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(7).document;
module.exports = document && document.documentElement;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(5);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(30)(Function.call, __webpack_require__(25).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var setPrototypeOf = __webpack_require__(109).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(36);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(42);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(64);
var $iterCreate = __webpack_require__(116);
var setToStringTag = __webpack_require__(61);
var getPrototypeOf = __webpack_require__(26);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(51);
var descriptor = __webpack_require__(47);
var setToStringTag = __webpack_require__(61);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(19)(IteratorPrototype, __webpack_require__(12)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(81);
var defined = __webpack_require__(36);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(12)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(64);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(15);
var createDesc = __webpack_require__(47);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(62);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(64);
module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(387);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(50);
var toLength = __webpack_require__(13);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(44);
var step = __webpack_require__(169);
var Iterators = __webpack_require__(64);
var toIObject = __webpack_require__(24);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(115)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(71);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(80)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var invoke = __webpack_require__(159);
var html = __webpack_require__(108);
var cel = __webpack_require__(104);
var global = __webpack_require__(7);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(31)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var macrotask = __webpack_require__(127).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(31)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(18);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var DESCRIPTORS = __webpack_require__(14);
var LIBRARY = __webpack_require__(42);
var $typed = __webpack_require__(87);
var hide = __webpack_require__(19);
var redefineAll = __webpack_require__(56);
var fails = __webpack_require__(8);
var anInstance = __webpack_require__(54);
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(13);
var toIndex = __webpack_require__(179);
var gOPN = __webpack_require__(52).f;
var dP = __webpack_require__(15).f;
var arrayFill = __webpack_require__(123);
var setToStringTag = __webpack_require__(61);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054f9d05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StarRating_vue__ = __webpack_require__(531);
function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StarRating_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054f9d05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StarRating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TIME_OPTIONS = exports.TIME_OPTIONS = {
    AMPM: ["AM", "PM"],
    HOUR: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    MINUTE: ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"],
    MINUTE_FULL: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"]
};

var CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS = exports.CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS = [{
    label: "Booking Rate",
    key: "BOOKING_RATE",
    model: "customize_booking_rate_text"
}, {
    label: "Booking Fee",
    key: "BOOKING_FEE",
    model: "customize_booking_fee_text"
}, {
    label: "Per Booking Fee",
    key: "PER_BOOKING_FEE",
    model: "customize_per_booking_fee_text"
}, {
    label: "Client Rate",
    key: "CLIENT_RATE",
    model: "customize_client_rate_text"
}, {
    label: "Candidate Rate",
    key: "CANDIDATE_RATE",
    model: "customize_candidate_rate_text"
}, {
    label: "Agency Fee",
    key: "AGENCY_FEE",
    model: "customize_agency_fee_text"
}, {
    label: "Travel Fee",
    key: "TRAVEL_FEE",
    model: "customize_travel_fee_text"
}, {
    label: "Rush Fee",
    key: "RUSH_FEE",
    model: "customize_rush_fee_text"
}, {
    label: "Candidate Rush Fee",
    key: "CANDIDATE_RUSH_FEE",
    model: "customize_candidate_rush_fee_text"
}, {
    label: "Per Booking Agency Fee",
    key: "PER_BOOKING_AGENCY_FEE",
    model: "customize_per_booking_agency_fee_text"
}, {
    label: "Per Booking Candidate Fee",
    key: "PER_BOOKING_CANDIDATE_FEE",
    model: "customize_per_booking_candidate_fee_text"
}, {
    label: "Admin Fee",
    key: "ADMIN_FEE",
    model: "customize_admin_fee_text"
}, {
    label: "Admin Percentage Fee",
    key: "ADMIN_PERCENTAGE",
    model: "customize_admin_percentage_text"
}, {
    label: "Additional Fees",
    key: "BOOKING_RATE",
    model: "customize_additional_fee_text"
}];

var AGENCY_TYPES = exports.AGENCY_TYPES = {
    NANNY_AND_HOUSE_HOLDING_STAFF: "Nanny and Household Staffing",
    DENTAL: "Dental",
    VIRTUAL_ASSISTANT: "Virtual Assistant",
    OTHER: "Other"
};

var SCRAPER_TYPES = exports.SCRAPER_TYPES = [{
    label: "Bright",
    value: "Bright"
}, {
    label: "Care",
    value: "Care"
}];

var AGENCY_SERVICES = exports.AGENCY_SERVICES = ["Long Term Nanny Placement", "Short Term Nanny Placement", "On Call Sitters", "Newborn Care Specialists", "Doulas", "Corporate Back-up Care", "Event Childcare", "Hotel Childcare", "Preschools", "Daycare Centers", "Home Staffing Specialists", "Domestic Worker Placement", "Nanny Placement", "Executive Nanny Placement", "Au Pair Placement", "Caregiver Placement", "Night Nurse Placement", "Office Cleaner Placement", "Temp Placement"];

var DISTANCE_UNITS = exports.DISTANCE_UNITS = [{
    label: "Kilometer",
    value: "km"
}, {
    label: "Mile",
    value: "miles"
}];

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobFillerInfo_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobFillerInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobFillerInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobFillerInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobFillerInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcf4eac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobFillerInfo_vue__ = __webpack_require__(553);
function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcf4eac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobFillerInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcf4eac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobFillerInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3414d127_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__ = __webpack_require__(571);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3414d127"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3414d127_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isDate */
/* harmony export (immutable) */ __webpack_exports__["d"] = toDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidDate;
/* unused harmony export startOfWeek */
/* harmony export (immutable) */ __webpack_exports__["c"] = startOfWeekYear;
/* harmony export (immutable) */ __webpack_exports__["a"] = getWeek;
function isDate(value) {
  return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
}
function toDate(value) {
  if (isDate(value)) {
    return new Date(value.getTime());
  }

  if (value == null) {
    return new Date(NaN);
  }

  return new Date(value);
}
function isValidDate(value) {
  return isDate(value) && !isNaN(value.getTime());
}
function startOfWeek(value) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!(firstDayOfWeek >= 0 && firstDayOfWeek <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6');
  }

  var date = toDate(value);
  var day = date.getDay();
  var diff = (day + 7 - firstDayOfWeek) % 7;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfWeekYear(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
      _ref$firstWeekContain = _ref.firstWeekContainsDate,
      firstWeekContainsDate = _ref$firstWeekContain === void 0 ? 1 : _ref$firstWeekContain;

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7');
  }

  var date = toDate(value);
  var year = date.getFullYear();
  var firstDateOfFirstWeek = new Date(0);

  for (var i = year + 1; i >= year - 1; i--) {
    firstDateOfFirstWeek.setFullYear(i, 0, firstWeekContainsDate);
    firstDateOfFirstWeek.setHours(0, 0, 0, 0);
    firstDateOfFirstWeek = startOfWeek(firstDateOfFirstWeek, firstDayOfWeek);

    if (date.getTime() >= firstDateOfFirstWeek.getTime()) {
      break;
    }
  }

  return firstDateOfFirstWeek;
}
function getWeek(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$firstDayOfWeek = _ref2.firstDayOfWeek,
      firstDayOfWeek = _ref2$firstDayOfWeek === void 0 ? 0 : _ref2$firstDayOfWeek,
      _ref2$firstWeekContai = _ref2.firstWeekContainsDate,
      firstWeekContainsDate = _ref2$firstWeekContai === void 0 ? 1 : _ref2$firstWeekContai;

  var date = toDate(value);
  var firstDateOfThisWeek = startOfWeek(date, firstDayOfWeek);
  var firstDateOfFirstWeek = startOfWeekYear(date, {
    firstDayOfWeek: firstDayOfWeek,
    firstWeekContainsDate: firstWeekContainsDate
  });
  var diff = firstDateOfThisWeek.getTime() - firstDateOfFirstWeek.getTime();
  return Math.round(diff / (7 * 24 * 3600 * 1000)) + 1;
}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(11);

var _vuex2 = _interopRequireDefault(_vuex);

var _general = __webpack_require__(652);

var _general2 = _interopRequireDefault(_general);

var _authentication = __webpack_require__(653);

var _authentication2 = _interopRequireDefault(_authentication);

var _communication = __webpack_require__(654);

var _communication2 = _interopRequireDefault(_communication);

var _documents = __webpack_require__(655);

var _documents2 = _interopRequireDefault(_documents);

var _candidates = __webpack_require__(656);

var _candidates2 = _interopRequireDefault(_candidates);

var _employers = __webpack_require__(657);

var _employers2 = _interopRequireDefault(_employers);

var _relationships = __webpack_require__(658);

var _relationships2 = _interopRequireDefault(_relationships);

var _agency = __webpack_require__(659);

var _agency2 = _interopRequireDefault(_agency);

var _dialogs = __webpack_require__(660);

var _dialogs2 = _interopRequireDefault(_dialogs);

var _resultDialogContent = __webpack_require__(661);

var _resultDialogContent2 = _interopRequireDefault(_resultDialogContent);

var _confirmDialogContent = __webpack_require__(662);

var _confirmDialogContent2 = _interopRequireDefault(_confirmDialogContent);

var _errorDialogContent = __webpack_require__(663);

var _errorDialogContent2 = _interopRequireDefault(_errorDialogContent);

var _emailTemplate = __webpack_require__(664);

var _emailTemplate2 = _interopRequireDefault(_emailTemplate);

var _smsTemplate = __webpack_require__(665);

var _smsTemplate2 = _interopRequireDefault(_smsTemplate);

var _documentTemplate = __webpack_require__(666);

var _documentTemplate2 = _interopRequireDefault(_documentTemplate);

var _colors = __webpack_require__(667);

var _colors2 = _interopRequireDefault(_colors);

var _fonts = __webpack_require__(668);

var _fonts2 = _interopRequireDefault(_fonts);

var _jobs = __webpack_require__(669);

var _jobs2 = _interopRequireDefault(_jobs);

var _formData = __webpack_require__(671);

var _formData2 = _interopRequireDefault(_formData);

var _language = __webpack_require__(672);

var _language2 = _interopRequireDefault(_language);

var _keap = __webpack_require__(694);

var _keap2 = _interopRequireDefault(_keap);

var _prices = __webpack_require__(695);

var _prices2 = _interopRequireDefault(_prices);

var _badges = __webpack_require__(696);

var _badges2 = _interopRequireDefault(_badges);

var _builders = __webpack_require__(697);

var _builders2 = _interopRequireDefault(_builders);

var _reference = __webpack_require__(698);

var _reference2 = _interopRequireDefault(_reference);

var _experiences = __webpack_require__(699);

var _experiences2 = _interopRequireDefault(_experiences);

var _placementJobs = __webpack_require__(700);

var _placementJobs2 = _interopRequireDefault(_placementJobs);

var _evaluations = __webpack_require__(701);

var _evaluations2 = _interopRequireDefault(_evaluations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    // menuState: '',
    skills: ["Administration", "Advocacy/Public Engagement", "Business", "Clinical Work", "Education & Skills Training", "Event Planning", "Finance", "Fundraising", "Grant Development", "Human Resources", "Information Technology", "Knowledge Translation", "Monitoring, Evaluation & Research", "Partnership Building", "Policy", "Program Management/Coordination", "Project Planning", "Public Relations/Communications", "Quality Improvement", "Stakeholder Engagement", "Strategy Development", "Supervision"],
    focusAreas: [
    // 'Chronic Diseases',
    "Climate Change", "Education", "Emergency Response", "Environmental Health", "Epidemiology", "Food Security & Nutrition", "Indigenous Health", "Infectious Diseases", "International Development", "Medicine", "Mental Health", "Migration and Refugee Health", "Non-Infectious Diseases", "Public Health", "Sexual & Reproductive Health", "Vision Care", "Water & Sanitation", "Women’s and/or Children’s Health", "Youth Health"],
    organizationTypes: ["Charity", "For-Profit", "Non-Profit/NGO", "Hospital", "Multilateral Agency", "Governmental Organization", "University/Research Lab"],
    organizationSizes: ["1-10", "11-50", "51-100", "101-200", "201-500", "500+"],
    organizationStatures: ["Well known with an established brand", "Smaller, less well known"],
    // https://css-tricks.com/snippets/javascript/array-of-country-names/
    countries: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"],
    listCountries: [{ "name": "United States", "code": "US" }, { "name": "Canada", "code": "CA" }, { "name": "Afghanistan", "code": "AF" }, { "name": "land Islands", "code": "AX" }, { "name": "Albania", "code": "AL" }, { "name": "Algeria", "code": "DZ" }, { "name": "American Samoa", "code": "AS" }, { "name": "AndorrA", "code": "AD" }, { "name": "Angola", "code": "AO" }, { "name": "Anguilla", "code": "AI" }, { "name": "Antarctica", "code": "AQ" }, { "name": "Antigua and Barbuda", "code": "AG" }, { "name": "Argentina", "code": "AR" }, { "name": "Armenia", "code": "AM" }, { "name": "Aruba", "code": "AW" }, { "name": "Australia", "code": "AU" }, { "name": "Austria", "code": "AT" }, { "name": "Azerbaijan", "code": "AZ" }, { "name": "Bahamas", "code": "BS" }, { "name": "Bahrain", "code": "BH" }, { "name": "Bangladesh", "code": "BD" }, { "name": "Barbados", "code": "BB" }, { "name": "Belarus", "code": "BY" }, { "name": "Belgium", "code": "BE" }, { "name": "Belize", "code": "BZ" }, { "name": "Benin", "code": "BJ" }, { "name": "Bermuda", "code": "BM" }, { "name": "Bhutan", "code": "BT" }, { "name": "Bolivia", "code": "BO" }, { "name": "Bosnia and Herzegovina", "code": "BA" }, { "name": "Botswana", "code": "BW" }, { "name": "Bouvet Island", "code": "BV" }, { "name": "Brazil", "code": "BR" }, { "name": "British Indian Ocean Territory", "code": "IO" }, { "name": "Brunei Darussalam", "code": "BN" }, { "name": "Bulgaria", "code": "BG" }, { "name": "Burkina Faso", "code": "BF" }, { "name": "Burundi", "code": "BI" }, { "name": "Cambodia", "code": "KH" }, { "name": "Cameroon", "code": "CM" }, { "name": "Cape Verde", "code": "CV" }, { "name": "Cayman Islands", "code": "KY" }, { "name": "Central African Republic", "code": "CF" }, { "name": "Chad", "code": "TD" }, { "name": "Chile", "code": "CL" }, { "name": "China", "code": "CN" }, { "name": "Christmas Island", "code": "CX" }, { "name": "Cocos (Keeling) Islands", "code": "CC" }, { "name": "Colombia", "code": "CO" }, { "name": "Comoros", "code": "KM" }, { "name": "Congo", "code": "CG" }, { "name": "Congo, The Democratic Republic of the", "code": "CD" }, { "name": "Cook Islands", "code": "CK" }, { "name": "Costa Rica", "code": "CR" }, { "name": "Cote D\"Ivoire", "code": "CI" }, { "name": "Croatia", "code": "HR" }, { "name": "Cuba", "code": "CU" }, { "name": "Cyprus", "code": "CY" }, { "name": "Czech Republic", "code": "CZ" }, { "name": "Denmark", "code": "DK" }, { "name": "Djibouti", "code": "DJ" }, { "name": "Dominica", "code": "DM" }, { "name": "Dominican Republic", "code": "DO" }, { "name": "Ecuador", "code": "EC" }, { "name": "Egypt", "code": "EG" }, { "name": "El Salvador", "code": "SV" }, { "name": "Equatorial Guinea", "code": "GQ" }, { "name": "Eritrea", "code": "ER" }, { "name": "Estonia", "code": "EE" }, { "name": "Ethiopia", "code": "ET" }, { "name": "Falkland Islands (Malvinas)", "code": "FK" }, { "name": "Faroe Islands", "code": "FO" }, { "name": "Fiji", "code": "FJ" }, { "name": "Finland", "code": "FI" }, { "name": "France", "code": "FR" }, { "name": "French Guiana", "code": "GF" }, { "name": "French Polynesia", "code": "PF" }, { "name": "French Southern Territories", "code": "TF" }, { "name": "Gabon", "code": "GA" }, { "name": "Gambia", "code": "GM" }, { "name": "Georgia", "code": "GE" }, { "name": "Germany", "code": "DE" }, { "name": "Ghana", "code": "GH" }, { "name": "Gibraltar", "code": "GI" }, { "name": "Greece", "code": "GR" }, { "name": "Greenland", "code": "GL" }, { "name": "Grenada", "code": "GD" }, { "name": "Guadeloupe", "code": "GP" }, { "name": "Guam", "code": "GU" }, { "name": "Guatemala", "code": "GT" }, { "name": "Guernsey", "code": "GG" }, { "name": "Guinea", "code": "GN" }, { "name": "Guinea-Bissau", "code": "GW" }, { "name": "Guyana", "code": "GY" }, { "name": "Haiti", "code": "HT" }, { "name": "Heard Island and Mcdonald Islands", "code": "HM" }, { "name": "Holy See (Vatican City State)", "code": "VA" }, { "name": "Honduras", "code": "HN" }, { "name": "Hong Kong", "code": "HK" }, { "name": "Hungary", "code": "HU" }, { "name": "Iceland", "code": "IS" }, { "name": "India", "code": "IN" }, { "name": "Indonesia", "code": "ID" }, { "name": "Iran, Islamic Republic Of", "code": "IR" }, { "name": "Iraq", "code": "IQ" }, { "name": "Ireland", "code": "IE" }, { "name": "Isle of Man", "code": "IM" }, { "name": "Israel", "code": "IL" }, { "name": "Italy", "code": "IT" }, { "name": "Jamaica", "code": "JM" }, { "name": "Japan", "code": "JP" }, { "name": "Jersey", "code": "JE" }, { "name": "Jordan", "code": "JO" }, { "name": "Kazakhstan", "code": "KZ" }, { "name": "Kenya", "code": "KE" }, { "name": "Kiribati", "code": "KI" }, { "name": "Korea, Democratic People\"S Republic of", "code": "KP" }, { "name": "Korea, Republic of", "code": "KR" }, { "name": "Kuwait", "code": "KW" }, { "name": "Kyrgyzstan", "code": "KG" }, { "name": "Lao People\"S Democratic Republic", "code": "LA" }, { "name": "Latvia", "code": "LV" }, { "name": "Lebanon", "code": "LB" }, { "name": "Lesotho", "code": "LS" }, { "name": "Liberia", "code": "LR" }, { "name": "Libyan Arab Jamahiriya", "code": "LY" }, { "name": "Liechtenstein", "code": "LI" }, { "name": "Lithuania", "code": "LT" }, { "name": "Luxembourg", "code": "LU" }, { "name": "Macao", "code": "MO" }, { "name": "Macedonia, The Former Yugoslav Republic of", "code": "MK" }, { "name": "Madagascar", "code": "MG" }, { "name": "Malawi", "code": "MW" }, { "name": "Malaysia", "code": "MY" }, { "name": "Maldives", "code": "MV" }, { "name": "Mali", "code": "ML" }, { "name": "Malta", "code": "MT" }, { "name": "Marshall Islands", "code": "MH" }, { "name": "Martinique", "code": "MQ" }, { "name": "Mauritania", "code": "MR" }, { "name": "Mauritius", "code": "MU" }, { "name": "Mayotte", "code": "YT" }, { "name": "Mexico", "code": "MX" }, { "name": "Micronesia, Federated States of", "code": "FM" }, { "name": "Moldova, Republic of", "code": "MD" }, { "name": "Monaco", "code": "MC" }, { "name": "Mongolia", "code": "MN" }, { "name": "Montenegro", "code": "ME" }, { "name": "Montserrat", "code": "MS" }, { "name": "Morocco", "code": "MA" }, { "name": "Mozambique", "code": "MZ" }, { "name": "Myanmar", "code": "MM" }, { "name": "Namibia", "code": "NA" }, { "name": "Nauru", "code": "NR" }, { "name": "Nepal", "code": "NP" }, { "name": "Netherlands", "code": "NL" }, { "name": "Netherlands Antilles", "code": "AN" }, { "name": "New Caledonia", "code": "NC" }, { "name": "New Zealand", "code": "NZ" }, { "name": "Nicaragua", "code": "NI" }, { "name": "Niger", "code": "NE" }, { "name": "Nigeria", "code": "NG" }, { "name": "Niue", "code": "NU" }, { "name": "Norfolk Island", "code": "NF" }, { "name": "Northern Mariana Islands", "code": "MP" }, { "name": "Norway", "code": "NO" }, { "name": "Oman", "code": "OM" }, { "name": "Pakistan", "code": "PK" }, { "name": "Palau", "code": "PW" }, { "name": "Palestinian Territory, Occupied", "code": "PS" }, { "name": "Panama", "code": "PA" }, { "name": "Papua New Guinea", "code": "PG" }, { "name": "Paraguay", "code": "PY" }, { "name": "Peru", "code": "PE" }, { "name": "Philippines", "code": "PH" }, { "name": "Pitcairn", "code": "PN" }, { "name": "Poland", "code": "PL" }, { "name": "Portugal", "code": "PT" }, { "name": "Puerto Rico", "code": "PR" }, { "name": "Qatar", "code": "QA" }, { "name": "Reunion", "code": "RE" }, { "name": "Romania", "code": "RO" }, { "name": "Russian Federation", "code": "RU" }, { "name": "RWANDA", "code": "RW" }, { "name": "Saint Helena", "code": "SH" }, { "name": "Saint Kitts and Nevis", "code": "KN" }, { "name": "Saint Lucia", "code": "LC" }, { "name": "Saint Pierre and Miquelon", "code": "PM" }, { "name": "Saint Vincent and the Grenadines", "code": "VC" }, { "name": "Samoa", "code": "WS" }, { "name": "San Marino", "code": "SM" }, { "name": "Sao Tome and Principe", "code": "ST" }, { "name": "Saudi Arabia", "code": "SA" }, { "name": "Senegal", "code": "SN" }, { "name": "Serbia", "code": "RS" }, { "name": "Seychelles", "code": "SC" }, { "name": "Sierra Leone", "code": "SL" }, { "name": "Singapore", "code": "SG" }, { "name": "Slovakia", "code": "SK" }, { "name": "Slovenia", "code": "SI" }, { "name": "Solomon Islands", "code": "SB" }, { "name": "Somalia", "code": "SO" }, { "name": "South Africa", "code": "ZA" }, { "name": "South Georgia and the South Sandwich Islands", "code": "GS" }, { "name": "Spain", "code": "ES" }, { "name": "Sri Lanka", "code": "LK" }, { "name": "Sudan", "code": "SD" }, { "name": "Suriname", "code": "SR" }, { "name": "Svalbard and Jan Mayen", "code": "SJ" }, { "name": "Swaziland", "code": "SZ" }, { "name": "Sweden", "code": "SE" }, { "name": "Switzerland", "code": "CH" }, { "name": "Syrian Arab Republic", "code": "SY" }, { "name": "Taiwan, Province of China", "code": "TW" }, { "name": "Tajikistan", "code": "TJ" }, { "name": "Tanzania, United Republic of", "code": "TZ" }, { "name": "Thailand", "code": "TH" }, { "name": "Timor-Leste", "code": "TL" }, { "name": "Togo", "code": "TG" }, { "name": "Tokelau", "code": "TK" }, { "name": "Tonga", "code": "TO" }, { "name": "Trinidad and Tobago", "code": "TT" }, { "name": "Tunisia", "code": "TN" }, { "name": "Turkey", "code": "TR" }, { "name": "Turkmenistan", "code": "TM" }, { "name": "Turks and Caicos Islands", "code": "TC" }, { "name": "Tuvalu", "code": "TV" }, { "name": "Uganda", "code": "UG" }, { "name": "Ukraine", "code": "UA" }, { "name": "United Arab Emirates", "code": "AE" }, { "name": "United Kingdom", "code": "GB" }, { "name": "United States Minor Outlying Islands", "code": "UM" }, { "name": "Uruguay", "code": "UY" }, { "name": "Uzbekistan", "code": "UZ" }, { "name": "Vanuatu", "code": "VU" }, { "name": "Venezuela", "code": "VE" }, { "name": "Viet Nam", "code": "VN" }, { "name": "Virgin Islands, British", "code": "VG" }, { "name": "Virgin Islands, U.S.", "code": "VI" }, { "name": "Wallis and Futuna", "code": "WF" }, { "name": "Western Sahara", "code": "EH" }, { "name": "Yemen", "code": "YE" }, { "name": "Zambia", "code": "ZM" }, { "name": "Zimbabwe", "code": "ZW" }],
    languages: [{ code: "ab", name: "Abkhaz", nativeName: "аҧсуа" }, { code: "aa", name: "Afar", nativeName: "Afaraf" }, { code: "af", name: "Afrikaans", nativeName: "Afrikaans" }, { code: "ak", name: "Akan", nativeName: "Akan" }, { code: "sq", name: "Albanian", nativeName: "Shqip" }, { code: "am", name: "Amharic", nativeName: "አማርኛ" }, { code: "ar", name: "Arabic", nativeName: "العربية" }, { code: "an", name: "Aragonese", nativeName: "Aragonés" }, { code: "hy", name: "Armenian", nativeName: "Հայերեն" }, { code: "as", name: "Assamese", nativeName: "অসমীয়া" }, { code: "av", name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ" }, { code: "ae", name: "Avestan", nativeName: "avesta" }, { code: "ay", name: "Aymara", nativeName: "aymar aru" }, { code: "az", name: "Azerbaijani", nativeName: "azərbaycan dili" }, { code: "bm", name: "Bambara", nativeName: "bamanankan" }, { code: "ba", name: "Bashkir", nativeName: "башҡорт теле" }, { code: "eu", name: "Basque", nativeName: "euskara, euskera" }, { code: "be", name: "Belarusian", nativeName: "Беларуская" }, { code: "bn", name: "Bengali", nativeName: "বাংলা" }, { code: "bh", name: "Bihari", nativeName: "भोजपुरी" }, { code: "bi", name: "Bislama", nativeName: "Bislama" }, { code: "bs", name: "Bosnian", nativeName: "bosanski jezik" }, { code: "br", name: "Breton", nativeName: "brezhoneg" }, { code: "bg", name: "Bulgarian", nativeName: "български език" }, { code: "my", name: "Burmese", nativeName: "ဗမာစာ" }, { code: "ca", name: "Catalan; Valencian", nativeName: "Català" }, { code: "ch", name: "Chamorro", nativeName: "Chamoru" }, { code: "ce", name: "Chechen", nativeName: "нохчийн мотт" }, {
      code: "ny",
      name: "Chichewa; Chewa; Nyanja",
      nativeName: "chiCheŵa, chinyanja"
    }, {
      code: "zh",
      name: "Chinese",
      nativeName: "中文 (Zhōngwén), 汉语, 漢語"
    }, { code: "cv", name: "Chuvash", nativeName: "чӑваш чӗлхи" }, { code: "kw", name: "Cornish", nativeName: "Kernewek" }, { code: "co", name: "Corsican", nativeName: "corsu, lingua corsa" }, { code: "cr", name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ" }, { code: "hr", name: "Croatian", nativeName: "hrvatski" }, { code: "cs", name: "Czech", nativeName: "česky, čeština" }, { code: "da", name: "Danish", nativeName: "dansk" }, { code: "dv", name: "Divehi; Dhivehi; Maldivian;", nativeName: "ދިވެހި" }, { code: "nl", name: "Dutch", nativeName: "Nederlands, Vlaams" }, { code: "en", name: "English", nativeName: "English" }, { code: "eo", name: "Esperanto", nativeName: "Esperanto" }, { code: "et", name: "Estonian", nativeName: "eesti, eesti keel" }, { code: "ee", name: "Ewe", nativeName: "Eʋegbe" }, { code: "fo", name: "Faroese", nativeName: "føroyskt" }, { code: "fj", name: "Fijian", nativeName: "vosa Vakaviti" }, { code: "fi", name: "Finnish", nativeName: "suomi, suomen kieli" }, { code: "fr", name: "French", nativeName: "français, langue française" }, {
      code: "ff",
      name: "Fula; Fulah; Pulaar; Pular",
      nativeName: "Fulfulde, Pulaar, Pular"
    }, { code: "gl", name: "Galician", nativeName: "Galego" }, { code: "ka", name: "Georgian", nativeName: "ქართული" }, { code: "de", name: "German", nativeName: "Deutsch" }, { code: "el", name: "Greek, Modern", nativeName: "Ελληνικά" }, { code: "gn", name: "Guaraní", nativeName: "Avañeẽ" }, { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી" }, {
      code: "ht",
      name: "Haitian; Haitian Creole",
      nativeName: "Kreyòl ayisyen"
    }, { code: "ha", name: "Hausa", nativeName: "Hausa, هَوُسَ" }, { code: "he", name: "Hebrew (modern)", nativeName: "עברית" }, { code: "hz", name: "Herero", nativeName: "Otjiherero" }, { code: "hi", name: "Hindi", nativeName: "हिन्दी, हिंदी" }, { code: "ho", name: "Hiri Motu", nativeName: "Hiri Motu" }, { code: "hu", name: "Hungarian", nativeName: "Magyar" }, { code: "ia", name: "Interlingua", nativeName: "Interlingua" }, { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" }, {
      code: "ie",
      name: "Interlingue",
      nativeName: "Originally called Occidental; then Interlingue after WWII"
    }, { code: "ga", name: "Irish", nativeName: "Gaeilge" }, { code: "ig", name: "Igbo", nativeName: "Asụsụ Igbo" }, { code: "ik", name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun" }, { code: "io", name: "Ido", nativeName: "Ido" }, { code: "is", name: "Icelandic", nativeName: "Íslenska" }, { code: "it", name: "Italian", nativeName: "Italiano" }, { code: "iu", name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ" }, {
      code: "ja",
      name: "Japanese",
      nativeName: "日本語 (にほんご／にっぽんご)"
    }, { code: "jv", name: "Javanese", nativeName: "basa Jawa" }, {
      code: "kl",
      name: "Kalaallisut, Greenlandic",
      nativeName: "kalaallisut, kalaallit oqaasii"
    }, { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" }, { code: "kr", name: "Kanuri", nativeName: "Kanuri" }, { code: "ks", name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎" }, { code: "kk", name: "Kazakh", nativeName: "Қазақ тілі" }, { code: "km", name: "Khmer", nativeName: "ភាសាខ្មែរ" }, { code: "ki", name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ" }, { code: "rw", name: "Kinyarwanda", nativeName: "Ikinyarwanda" }, { code: "ky", name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили" }, { code: "kv", name: "Komi", nativeName: "коми кыв" }, { code: "kg", name: "Kongo", nativeName: "KiKongo" }, {
      code: "ko",
      name: "Korean",
      nativeName: "한국어 (韓國語), 조선말 (朝鮮語)"
    }, { code: "ku", name: "Kurdish", nativeName: "Kurdî, كوردی‎" }, { code: "kj", name: "Kwanyama, Kuanyama", nativeName: "Kuanyama" }, { code: "la", name: "Latin", nativeName: "latine, lingua latina" }, {
      code: "lb",
      name: "Luxembourgish, Letzeburgesch",
      nativeName: "Lëtzebuergesch"
    }, { code: "lg", name: "Luganda", nativeName: "Luganda" }, {
      code: "li",
      name: "Limburgish, Limburgan, Limburger",
      nativeName: "Limburgs"
    }, { code: "ln", name: "Lingala", nativeName: "Lingála" }, { code: "lo", name: "Lao", nativeName: "ພາສາລາວ" }, { code: "lt", name: "Lithuanian", nativeName: "lietuvių kalba" }, { code: "lu", name: "Luba-Katanga", nativeName: "" }, { code: "lv", name: "Latvian", nativeName: "latviešu valoda" }, { code: "gv", name: "Manx", nativeName: "Gaelg, Gailck" }, { code: "mk", name: "Macedonian", nativeName: "македонски јазик" }, { code: "mg", name: "Malagasy", nativeName: "Malagasy fiteny" }, { code: "ms", name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎" }, { code: "ml", name: "Malayalam", nativeName: "മലയാളം" }, { code: "mt", name: "Maltese", nativeName: "Malti" }, { code: "mi", name: "Māori", nativeName: "te reo Māori" }, { code: "mr", name: "Marathi (Marāṭhī)", nativeName: "मराठी" }, { code: "mh", name: "Marshallese", nativeName: "Kajin M̧ajeļ" }, { code: "mn", name: "Mongolian", nativeName: "монгол" }, { code: "na", name: "Nauru", nativeName: "Ekakairũ Naoero" }, {
      code: "nv",
      name: "Navajo, Navaho",
      nativeName: "Diné bizaad, Dinékʼehǰí"
    }, { code: "nb", name: "Norwegian Bokmål", nativeName: "Norsk bokmål" }, { code: "nd", name: "North Ndebele", nativeName: "isiNdebele" }, { code: "ne", name: "Nepali", nativeName: "नेपाली" }, { code: "ng", name: "Ndonga", nativeName: "Owambo" }, { code: "nn", name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk" }, { code: "no", name: "Norwegian", nativeName: "Norsk" }, { code: "ii", name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop" }, { code: "nr", name: "South Ndebele", nativeName: "isiNdebele" }, { code: "oc", name: "Occitan", nativeName: "Occitan" }, { code: "oj", name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" }, {
      code: "cu",
      name: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
      nativeName: "ѩзыкъ словѣньскъ"
    }, { code: "om", name: "Oromo", nativeName: "Afaan Oromoo" }, { code: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ" }, { code: "os", name: "Ossetian, Ossetic", nativeName: "ирон æвзаг" }, { code: "pa", name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎" }, { code: "pi", name: "Pāli", nativeName: "पाऴि" }, { code: "fa", name: "Persian", nativeName: "فارسی" }, { code: "pl", name: "Polish", nativeName: "polski" }, { code: "ps", name: "Pashto, Pushto", nativeName: "پښتو" }, { code: "pt", name: "Portuguese", nativeName: "Português" }, { code: "qu", name: "Quechua", nativeName: "Runa Simi, Kichwa" }, { code: "rm", name: "Romansh", nativeName: "rumantsch grischun" }, { code: "rn", name: "Kirundi", nativeName: "kiRundi" }, {
      code: "ro",
      name: "Romanian, Moldavian, Moldovan",
      nativeName: "română"
    }, { code: "ru", name: "Russian", nativeName: "русский язык" }, { code: "sa", name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्" }, { code: "sc", name: "Sardinian", nativeName: "sardu" }, { code: "sd", name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎" }, { code: "se", name: "Northern Sami", nativeName: "Davvisámegiella" }, { code: "sm", name: "Samoan", nativeName: "gagana faa Samoa" }, { code: "sg", name: "Sango", nativeName: "yângâ tî sängö" }, { code: "sr", name: "Serbian", nativeName: "српски језик" }, { code: "gd", name: "Scottish Gaelic; Gaelic", nativeName: "Gàidhlig" }, { code: "sn", name: "Shona", nativeName: "chiShona" }, { code: "si", name: "Sinhala, Sinhalese", nativeName: "සිංහල" }, { code: "sk", name: "Slovak", nativeName: "slovenčina" }, { code: "sl", name: "Slovene", nativeName: "slovenščina" }, { code: "so", name: "Somali", nativeName: "Soomaaliga, af Soomaali" }, { code: "st", name: "Southern Sotho", nativeName: "Sesotho" }, {
      code: "es",
      name: "Spanish; Castilian",
      nativeName: "español, castellano"
    }, { code: "su", name: "Sundanese", nativeName: "Basa Sunda" }, { code: "sw", name: "Swahili", nativeName: "Kiswahili" }, { code: "ss", name: "Swati", nativeName: "SiSwati" }, { code: "sv", name: "Swedish", nativeName: "svenska" }, { code: "ta", name: "Tamil", nativeName: "தமிழ்" }, { code: "te", name: "Telugu", nativeName: "తెలుగు" }, { code: "tg", name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎" }, { code: "th", name: "Thai", nativeName: "ไทย" }, { code: "ti", name: "Tigrinya", nativeName: "ትግርኛ" }, {
      code: "bo",
      name: "Tibetan Standard, Tibetan, Central",
      nativeName: "བོད་ཡིག"
    }, { code: "tk", name: "Turkmen", nativeName: "Türkmen, Түркмен" }, {
      code: "tl",
      name: "Tagalog",
      nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
    }, { code: "tn", name: "Tswana", nativeName: "Setswana" }, { code: "to", name: "Tonga (Tonga Islands)", nativeName: "faka Tonga" }, { code: "tr", name: "Turkish", nativeName: "Türkçe" }, { code: "ts", name: "Tsonga", nativeName: "Xitsonga" }, { code: "tt", name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎" }, { code: "tw", name: "Twi", nativeName: "Twi" }, { code: "ty", name: "Tahitian", nativeName: "Reo Tahiti" }, { code: "ug", name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎" }, { code: "uk", name: "Ukrainian", nativeName: "українська" }, { code: "ur", name: "Urdu", nativeName: "اردو" }, { code: "uz", name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎" }, { code: "ve", name: "Venda", nativeName: "Tshivenḓa" }, { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" }, { code: "vo", name: "Volapük", nativeName: "Volapük" }, { code: "wa", name: "Walloon", nativeName: "Walon" }, { code: "cy", name: "Welsh", nativeName: "Cymraeg" }, { code: "wo", name: "Wolof", nativeName: "Wollof" }, { code: "fy", name: "Western Frisian", nativeName: "Frysk" }, { code: "xh", name: "Xhosa", nativeName: "isiXhosa" }, { code: "yi", name: "Yiddish", nativeName: "ייִדיש" }, { code: "yo", name: "Yoruba", nativeName: "Yorùbá" }, {
      code: "za",
      name: "Zhuang, Chuang",
      nativeName: "Saɯ cueŋƅ, Saw cuengh"
    }],

    positions: ["Nanny", "House Manager", "Baby/Night Nurse", "Other"],
    ages: ["Newborn (0-6 months)", "Infant (6 months - 12 months)", "Toddler (1-2 years)", "Preschool (3-5 years)", "Gradeschool (6-12 years)", "Teenager (13+ years)"],
    experiences: ["Private Babysitting (non-relatives)", "Private Babysitting (only-relatives)", "Daycare Center", "Preschool", "Church Nursery", "Camp Counsellor", "Nanny"],
    comfortableWith: ["Drive/Transport children to/from activities", "Overnight Care", "Animals", "Parents who work from home", "Supervising Swimming", "Light housekeeping", "Caring for sick children", "Meal prepping", "Running light errands"],
    documentsOptions: ["Child Abuse Check", "Criminal Record Check with Vulnerable Sector Check", "Standard CPR/First Aid Level C", "Drivers Abstract Report"],
    days: [
    // "Sunday",
    "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    // commitmentOptions: [
    //   'Long Term (longer than 1 year)', 'Short Term (1 year or less)', 'Temporary',
    // ],
    // availabilityOptions: [
    //   'Full Time', 'Part Time', 'Come and Go', 'Live In'
    // ],
    // drvingStatuses: [
    //   'D.L. and Car', 'Driver\'s License only', 'Neither',
    // ],
    // certificationStatuses: [
    //   'Yes', 'Willing to get certified', 'No',
    // ],
    // vaccinationStatuses: [
    //   'Yes', 'Willing to get', 'No'
    // ],
    // petsOptions: [
    //   'Dog', 'Cat', 'Neither',
    // ],
    // travelOptions: [
    //   'Domestic', 'International', 'No travel',
    // ],
    yesNoOptions: ["Yes", "No"],
    cities: ["Chicago", "New York"],
    months: [{ short: "Jan", number: "01" }, { short: "Feb", number: "02" }, { short: "Mar", number: "03" }, { short: "Apr", number: "04" }, { short: "May", number: "05" }, { short: "Jun", number: "06" }, { short: "Jul", number: "07" }, { short: "Aug", number: "08" }, { short: "Sep", number: "09" }, { short: "Oct", number: "10" }, { short: "Nov", number: "11" }, { short: "Dec", number: "12" }]
  },
  mutations: {
    // storeMenuState (state, menuState) {
    //   state.menuState = menuState
    // }
  },
  actions: {
    // setMenuState ({commit}, menuState) {
    //   commit(storeMenuState, menuState)
    // }
  },
  getters: {
    // menuState (state) {
    //   return state.menuState
    // },
    skills: function skills(state) {
      return state.skills;
    },
    focusAreas: function focusAreas(state) {
      return state.focusAreas;
    },
    organizationTypes: function organizationTypes(state) {
      return state.organizationTypes;
    },
    organizationSizes: function organizationSizes(state) {
      return state.organizationSizes;
    },
    organizationStatures: function organizationStatures(state) {
      return state.organizationStatures;
    },
    countries: function countries(state) {
      return state.countries;
    },
    listCountries: function listCountries(state) {
      return state.listCountries;
    },
    languages: function languages(state) {
      return state.languages;
    },


    // candidateStatuses (state) {
    //   return state.candidateStatuses
    // },
    // employerStatuses (state) {
    //   return state.employerStatuses
    // },

    positions: function positions(state) {
      return state.positions;
    },
    ages: function ages(state) {
      return state.ages;
    },
    experiences: function experiences(state) {
      return state.experiences;
    },
    comfortableWith: function comfortableWith(state) {
      return state.comfortableWith;
    },
    documentsOptions: function documentsOptions(state) {
      return state.documentsOptions;
    },
    days: function days(state) {
      return state.days;
    },
    yesNoOptions: function yesNoOptions(state) {
      return state.yesNoOptions;
    },
    cities: function cities(state) {
      return state.cities;
    },
    months: function months(state) {
      return state.months;
    }
  },
  modules: {
    general: _general2.default,
    authentication: _authentication2.default,
    communication: _communication2.default,
    documents: _documents2.default,
    candidates: _candidates2.default,
    employers: _employers2.default,
    relationships: _relationships2.default,
    agency: _agency2.default,
    dialogs: _dialogs2.default,
    resultDialogContent: _resultDialogContent2.default,
    confirmDialogContent: _confirmDialogContent2.default,
    errorDialogContent: _errorDialogContent2.default,
    emailTemplate: _emailTemplate2.default,
    smsTemplate: _smsTemplate2.default,
    documentTemplate: _documentTemplate2.default,
    colors: _colors2.default,
    fonts: _fonts2.default,
    jobs: _jobs2.default,
    formData: _formData2.default,
    language: _language2.default,
    keap: _keap2.default,
    prices: _prices2.default,
    badges: _badges2.default,
    builders: _builders2.default,
    reference: _reference2.default,
    experiences: _experiences2.default,
    placementJobs: _placementJobs2.default,
    evaluations: _evaluations2.default
  }
});

/***/ }),
/* 137 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(76),
    isObject = __webpack_require__(60);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39),
    stubFalse = __webpack_require__(757);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(758),
    baseUnary = __webpack_require__(759),
    nodeUtil = __webpack_require__(760);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(257);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VALID_IMAGE_FILE_TYPE = exports.VALID_IMAGE_FILE_TYPE = ["image/jpeg", "image/png"];
var VALID_IMAGE_INCLUDE_GIF_FILE_TYPE = exports.VALID_IMAGE_INCLUDE_GIF_FILE_TYPE = ["image/gif", "image/jpeg", "image/png"];
var VALID_DOC_FILE_TYPE = exports.VALID_DOC_FILE_TYPE = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6a9d738_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDialog_vue__ = __webpack_require__(572);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6a9d738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6a9d738_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

(function(t,e){ true?module.exports=e():"function"===typeof define&&define.amd?define([],e):"object"===typeof exports?exports["vue-swatches"]=e():t["vue-swatches"]=e()})("undefined"!==typeof self?self:this,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s="fb15")}({"0ca3":function(t,e,n){"use strict";var r=n("c6aa"),i=n.n(r);i.a},7937:function(t,e,n){},"7fca":function(t,e,n){"use strict";var r=n("c10a"),i=n.n(r);i.a},8875:function(t,e,n){var r,i,o;(function(n,c){i=[],r=c,o="function"===typeof r?r.apply(e,i):r,void 0===o||(t.exports=o)})("undefined"!==typeof self&&self,(function(){function t(){if(document.currentScript)return document.currentScript;try{throw new Error}catch(h){var t,e,n,r=/.*at [^(]*\((.*):(.+):(.+)\)$/gi,i=/@([^@]*):(\d+):(\d+)\s*$/gi,o=r.exec(h.stack)||i.exec(h.stack),c=o&&o[1]||!1,s=o&&o[2]||!1,a=document.location.href.replace(document.location.hash,""),l=document.getElementsByTagName("script");c===a&&(t=document.documentElement.outerHTML,e=new RegExp("(?:[^\\n]+?\\n){0,"+(s-2)+"}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*","i"),n=t.replace(e,"$1").trim());for(var u=0;u<l.length;u++){if("interactive"===l[u].readyState)return l[u];if(l[u].src===c)return l[u];if(c===a&&l[u].innerHTML&&l[u].innerHTML.trim()===n)return l[u]}return null}}return t}))},9334:function(t,e,n){"use strict";var r=n("7937"),i=n.n(r);i.a},c10a:function(t,e,n){},c6aa:function(t,e,n){},fb15:function(t,e,n){"use strict";if(n.r(e),n.d(e,"DEFAULT_BACKGROUND_COLOR",(function(){return E})),n.d(e,"DEFAULT_BORDER_RADIUS",(function(){return R})),n.d(e,"DEFAULT_ROW_LENGTH",(function(){return F})),n.d(e,"DEFAULT_TRIGGER_CONTAINER_SPACE",(function(){return P})),n.d(e,"DEFAULT_SWATCH_SIZE",(function(){return D})),n.d(e,"DEFAULT_SHOW_BORDER",(function(){return A})),n.d(e,"extractPropertyFromPreset",(function(){return T})),"undefined"!==typeof window){var r=window.document.currentScript,i=n("8875");r=i(),"currentScript"in document||Object.defineProperty(document,"currentScript",{get:i});var o=r&&r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);o&&(n.p=o[1])}var c=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vue-swatches",attrs:{tabindex:"-1"},on:{blur:function(e){return t.onBlur(e.relatedTarget)}}},[t.inline?t._e():n("div",{ref:"triggerWrapper",staticClass:"vue-swatches__trigger__wrapper",on:{click:t.togglePopover}},[t._t("trigger",[n("div",{staticClass:"vue-swatches__trigger",class:{"vue-swatches--is-empty":!t.value,"vue-swatches--is-disabled":t.disabled},style:t.triggerStyles},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isNoColor,expression:"isNoColor"}],staticClass:"vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"},[n("div",{staticClass:"vue-swatches__diagonal"})])])])],2),n("transition",{attrs:{name:"vue-swatches-show-hide"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.inline||t.isOpen,expression:"inline || isOpen"}],ref:"containerWrapper",staticClass:"vue-swatches__container",class:{"vue-swatches--inline":t.inline},style:t.containerStyles},[n("div",{staticClass:"vue-swatches__wrapper",style:t.wrapperStyles},[t.isNested?t._l(t.computedSwatches,(function(e,r){return n("div",{key:r,staticClass:"vue-swatches__row"},t._l(e,(function(i,o){return n("v-swatch",{key:o,attrs:{"is-last":r===t.computedSwatches.length-1&&o===e.length,"row-length-setted":null!==t.rowLength||null!==t.presetRowLength,"border-radius":t.computedBorderRadius,disabled:t.getSwatchDisabled(i),inline:t.inline,selected:t.checkEquality(t.getSwatchColor(i),t.value),"swatch-size":t.computedSwatchSize,"spacing-size":t.computedSpacingSize,"show-border":t.getSwatchShowBorder(i),"show-checkbox":t.showCheckbox,"show-labels":t.showLabels,"swatch-color":t.getSwatchColor(i),"swatch-label":t.getSwatchLabel(i),"swatch-alt":t.getSwatchAlt(i),"swatch-style":t.swatchStyle},on:{blur:function(e){return t.onBlur(e)},click:function(e){return t.updateSwatch(i)}},nativeOn:{click:function(e){return t.updateSwatch(i)}}})})),1)})):t._l(t.computedSwatches,(function(e,r){return n("v-swatch",{key:r,attrs:{"is-last":r===t.computedSwatches.length-1,"row-length-setted":null!==t.rowLength||null!==t.presetRowLength,"border-radius":t.computedBorderRadius,disabled:t.getSwatchDisabled(e),inline:t.inline,selected:t.checkEquality(t.getSwatchColor(e),t.value),"swatch-size":t.computedSwatchSize,"spacing-size":t.computedSpacingSize,"show-border":t.getSwatchShowBorder(e),"show-checkbox":t.showCheckbox,"show-labels":t.showLabels,"swatch-color":t.getSwatchColor(e),"swatch-label":t.getSwatchLabel(e),"swatch-alt":t.getSwatchAlt(e),"swatch-style":t.swatchStyle},on:{blur:function(e){return t.onBlur(e)},click:function(n){return t.updateSwatch(e)}},nativeOn:{click:function(n){return t.updateSwatch(e)}}})}))],2),t.showFallback?n("div",{staticClass:"vue-swatches__fallback__wrapper",style:t.computedFallbackWrapperStyles},[n("span",{staticClass:"vue-swatches__fallback__input--wrapper"},[n("input",{ref:"fallbackInput",staticClass:"vue-swatches__fallback__input",class:t.fallbackInputClass,attrs:{type:t.fallbackInputType},domProps:{value:t.internalValue},on:{input:function(e){return t.updateSwatch(e.target.value,{fromFallbackInput:!0})}}})]),t.showFallbackOk?n("button",{staticClass:"vue-swatches__fallback__button",class:t.fallbackOkClass,on:{click:function(e){return e.preventDefault(),t.onFallbackButtonClick(e)}}},[t._v(" "+t._s(t.fallbackOkText)+" ")]):t._e()]):t._e()])])],1)},s=[],a={colors:["#1FBC9C","#1CA085","#2ECC70","#27AF60","#3398DB","#2980B9","#A463BF","#8E43AD","#3D556E","#222F3D","#F2C511","#F39C19","#E84B3C","#C0382B","#DDE6E8","#BDC3C8"],rowLength:4},l={colors:["#CC0001","#E36101","#FFCC00","#009900","#0066CB","#000000","#FFFFFF"],showBorder:!0},u={colors:[["#000000","#434343","#666666","#999999","#b7b7b7","#cccccc","#d9d9d9","#efefef","#f3f3f3","#ffffff"],["#980000","#ff0000","#ff9900","#ffff00","#00ff00","#00ffff","#4a86e8","#0000ff","#9900ff","#ff00ff"],["#e6b8af","#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#c9daf8","#cfe2f3","#d9d2e9","#ead1dc"],["#dd7e6b","#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#a4c2f4","#9fc5e8","#b4a7d6","#d5a6bd"],["#cc4125","#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6d9eeb","#6fa8dc","#8e7cc3","#c27ba0"],["#a61c00","#cc0000","#e69138","#f1c232","#6aa84f","#45818e","#3c78d8","#3d85c6","#674ea7","#a64d79"],["#85200c","#990000","#b45f06","#bf9000","#38761d","#134f5c","#1155cc","#0b5394","#351c75","#741b47"],["#5b0f00","#660000","#783f04","#7f6000","#274e13","#0c343d","#1c4587","#073763","#20124d","#4c1130"]],borderRadius:"0",rowLength:10,swatchSize:24,spacingSize:0},h=function(){var t=this,e=this,n=e.$createElement,r=e._self._c||n;return r("div",{staticClass:"vue-swatches__swatch",class:{"vue-swatches__swatch--border":e.showBorder,"vue-swatches__swatch--selected":e.selected,"vue-swatches__swatch--is-disabled":e.disabled},style:e.swatchStyles,attrs:{"aria-label":e.swatchAlt,role:"button",tabindex:"0"},on:{keyup:function(t){return!t.type.indexOf("key")&&e._k(t.keyCode,"enter",13,t.key,"Enter")?null:e.$emit("click",e.swatchColor)},blur:function(e){return t.$emit("blur",e.relatedTarget)}}},[""===e.swatchColor?r("div",{staticClass:"vue-swatches__diagonal__wrapper vue-swatches--has-children-centered"},[r("div",{staticClass:"vue-swatches__diagonal"})]):e._e(),r("v-check",{directives:[{name:"show",rawName:"v-show",value:e.showCheckbox&&e.selected,expression:"showCheckbox && selected"}]}),e.showLabels?r("div",{staticClass:"vue-swatches__swatch__label",style:e.labelStyles},[e._v(" "+e._s(e.swatchLabel)+" ")]):e._e()],1)},p=[],d=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vue-swatches__check__wrapper vue-swatches--has-children-centered"},[n("div",{staticClass:"vue-swatches__check__circle vue-swatches--has-children-centered"},[n("svg",{staticClass:"check",attrs:{version:"1.1",role:"presentation",width:"12",height:"12",viewBox:"0 0 1792 1792"}},[n("path",{staticClass:"vue-swatches__check__path",attrs:{d:"M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"}})])])])},f=[],w={name:"v-check",data:function(){return{}}},b=w;n("7fca");function S(t,e,n,r,i,o,c,s){var a,l="function"===typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=n,l._compiled=!0),r&&(l.functional=!0),o&&(l._scopeId="data-v-"+o),c?(a=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"===typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(c)},l._ssrRegister=a):i&&(a=s?function(){i.call(this,this.$root.$options.shadowRoot)}:i),a)if(l.functional){l._injectStyles=a;var u=l.render;l.render=function(t,e){return a.call(e),u(t,e)}}else{var h=l.beforeCreate;l.beforeCreate=h?[].concat(h,a):[a]}return{exports:t,options:l}}var g=S(b,d,f,!1,null,null,null),y=g.exports;function v(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function m(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?v(Object(n),!0).forEach((function(e){_(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function _(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var O={name:"v-swatch",components:{VCheck:y},props:{borderRadius:{type:String},isLast:{type:Boolean,default:!1},rowLengthSetted:{type:Boolean,default:!1},disabled:{type:Boolean},inline:{type:Boolean},selected:{type:Boolean,default:!1},showCheckbox:{type:Boolean},showBorder:{type:Boolean},showLabels:{type:Boolean},spacingSize:{type:Number},swatchColor:{type:String,default:""},swatchLabel:{type:String},swatchAlt:{type:String},swatchSize:{type:Number},swatchStyle:{type:Object}},data:function(){return{}},computed:{computedLabelStyle:function(){var t=8+3*Math.floor(this.spacingSize/5);return{bottom:"-".concat(t,"px")}},computedSwatchStyle:function(){var t={width:"".concat(this.swatchSize,"px"),height:"".concat(this.swatchSize,"px"),borderRadius:this.borderRadius,backgroundColor:""!==this.swatchColor?this.swatchColor:"#FFFFFF",cursor:this.cursorStyle};return this.inline&&this.isLast||(t.marginRight="".concat(this.spacingSize,"px")),this.inline&&!this.rowLengthSetted?t:m({},t,{marginBottom:"".concat(this.spacingSize,"px")})},cursorStyle:function(){return this.disabled?"not-allowed":"pointer"},labelStyles:function(){return[this.computedLabelStyle]},swatchStyles:function(){return[this.computedSwatchStyle,this.swatchStyle]}}},C=O,k=(n("0ca3"),S(C,h,p,!1,null,null,null)),x=k.exports;function B(t){return B="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},B(t)}function j(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function L(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?j(Object(n),!0).forEach((function(e){z(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):j(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}function z(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var E="#ffffff",R="10px",F=4,P=5,D=42,A=!1,T=function(t,e,n){return"string"!==typeof t?null:"text-basic"===t?void 0===l[e]?null:l[e]:"text-advanced"===t?void 0===u[e]?null:u[e]:"basic"===t||n?void 0===a[e]?null:a[e]:null},$={name:"v-swatches",components:{VSwatch:x},props:{backgroundColor:{type:String,default:E},closeOnSelect:{type:Boolean,default:!0},swatches:{type:[Array,String],default:function(){return"basic"}},disabled:{type:Boolean,default:!1},fallbackInputClass:{type:[Array,Object,String],default:null},fallbackInputType:{type:String,default:function(){return"text"},validator:function(t){return-1!==["text","color"].indexOf(t)}},fallbackOkClass:{type:[Array,Object,String],default:null},fallbackOkText:{type:String,default:"Ok"},inline:{type:Boolean,default:!1},shapes:{type:String,default:"squares"},popoverX:{type:String,default:"right"},popoverY:{type:String,default:"bottom"},rowLength:{type:[Number,String],default:null},showBorder:{type:Boolean,default:null},showFallback:{type:Boolean,default:!1},showCheckbox:{type:Boolean,default:!0},showLabels:{type:Boolean,default:!1},spacingSize:{type:Number,default:null},swatchSize:{type:[Number,String],default:null},swatchStyle:{type:[Object,Array],default:function(){}},triggerStyle:{type:[Object,Array],default:function(){}},wrapperStyle:{type:[Object,Array],default:function(){}},value:{type:String,default:null}},data:function(){return{alwaysOnScreenStyle:{},componentMounted:!1,internalValue:this.value,internalIsOpen:!1}},computed:{isNested:function(){return!!(this.computedSwatches&&this.computedSwatches.length&&this.computedSwatches[0]instanceof Array)},isOpen:function(){return!this.inline&&this.internalIsOpen},isNoColor:function(){return this.checkEquality("",this.value)},presetBorderRadius:function(){return T(this.swatches,"borderRadius")},presetRowLength:function(){return T(this.swatches,"rowLength")},presetShowBorder:function(){return T(this.swatches,"showBorder")},presetSwatchSize:function(){return T(this.swatches,"swatchSize")},presetSpacingSize:function(){return T(this.swatches,"spacingSize")},computedSwatches:function(){return this.swatches instanceof Array?this.swatches:"string"===typeof this.swatches?T(this.swatches,"colors",!0):[]},computedBorderRadius:function(){return null!==this.presetBorderRadius?this.presetBorderRadius:this.borderRadius},computedRowLength:function(){return null!==this.rowLength?Number(this.rowLength):null!==this.presetRowLength?this.presetRowLength:this.computedSwatches.length<F&&!this.isNested?this.computedSwatches.length:F},computedSwatchSize:function(){return null!==this.swatchSize?Number(this.swatchSize):null!==this.presetSwatchSize?this.presetSwatchSize:D},computedSpacingSize:function(){return null!==this.spacingSize?this.spacingSize:null!==this.presetSpacingSize?this.presetSpacingSize:Math.round(.25*this.computedSwatchSize)},computedShowBorder:function(){return null!==this.showBorder?this.showBorder:null!==this.presetShowBorder?this.presetShowBorder:A},showFallbackOk:function(){return!this.inline},borderRadius:function(){return"squares"===this.shapes?"".concat(Math.round(.25*this.computedSwatchSize),"px"):"circles"===this.shapes?"50%":""},wrapperWidth:function(){return this.computedRowLength*(this.computedSwatchSize+this.computedSpacingSize)},computedtriggerStyle:function(){return{width:"42px",height:"42px",backgroundColor:this.value?this.value:"#ffffff",borderRadius:"circles"===this.shapes?"50%":R}},triggerStyles:function(){return[this.computedtriggerStyle,this.triggerStyle]},containerStyles:function(){var t=[{backgroundColor:this.backgroundColor},this.alwaysOnScreenStyle];return this.inline?t:[].concat(t,[{padding:"5px",marginBottom:"5px"}])},computedWrapperStyle:function(){return this.inline?{}:{paddingTop:"".concat(this.computedSpacingSize,"px"),paddingLeft:"".concat(this.computedSpacingSize,"px"),width:"".concat(this.wrapperWidth,"px")}},wrapperStyles:function(){return[this.computedWrapperStyle,this.wrapperStyle]},computedFallbackWrapperStyle:function(){var t={marginLeft:"".concat(this.computedSpacingSize,"px"),paddingBottom:"".concat(this.computedSpacingSize,"px")};return this.inline?t:L({},t,{width:"".concat(this.wrapperWidth-this.computedSpacingSize,"px")})},computedFallbackWrapperStyles:function(){return[this.computedFallbackWrapperStyle]}},watch:{value:function(t){this.internalValue=t}},mounted:function(){this.componentMounted=!0},methods:{checkEquality:function(t,e){return!(!t&&""!==t||!e&&""!==e)&&t.toUpperCase()===e.toUpperCase()},hidePopover:function(){this.internalIsOpen=!1,this.$el.blur(),this.$emit("close",this.internalValue)},getAlwaysOnScreenStyle:function(){var t={},e=this.$refs.triggerWrapper,n=this.$refs.containerWrapper;if(!this.componentMounted||this.inline||!e||!window||!document)return t;var r=e.getBoundingClientRect(),i=5,o=(document.documentElement.clientWidth||window.innerWidth)-5,c=5,s=(document.documentElement.clientHeight||window.innerHeight)-5;n.style.visibility="hidden",n.style.display="block";var a=n.getBoundingClientRect();return n.style.display="none",n.style.visibility="visible","top"===this.popoverY?r.top-a.height<c?(t.top="".concat(r.height+P,"px"),t.bottom="auto"):(t.bottom="".concat(r.height+P,"px"),t.top="auto"):"bottom"===this.popoverY&&(r.bottom+a.height>s?(t.bottom="".concat(r.height+P,"px"),t.top="auto"):(t.top="".concat(r.height+P,"px"),t.bottom="auto")),"left"===this.popoverX?r.right-a.width<i?(t.left=0,t.right="auto"):(t.right=0,t.left="auto"):"right"===this.popoverX&&(r.left+a.width>o?(t.right=0,t.left="auto"):(t.left=0,t.right="auto")),t},getSwatchShowBorder:function(t){return"string"===typeof t?this.computedShowBorder:"object"===B(t)?void 0!==t.showBorder?t.showBorder:this.computedShowBorder:void 0},getSwatchColor:function(t){return"string"===typeof t?t:"object"===B(t)?t.color:void 0},getSwatchDisabled:function(t){return"string"===typeof t?this.disabled:"object"===B(t)?void 0!==t.disabled?t.disabled:this.disabled:void 0},getSwatchLabel:function(t){return"string"===typeof t?t:"object"===B(t)?t.label||t.color:void 0},getSwatchAlt:function(t){return"string"===typeof t?t:"object"===B(t)?t.alt||this.getSwatchLabel(t):void 0},onBlur:function(t){this.isOpen&&(null!==t&&this.$el.contains(t)||(this.internalIsOpen=!1,this.$emit("close",this.internalValue)))},onFallbackButtonClick:function(){this.hidePopover()},showPopover:function(){this.isOpen||this.inline||this.disabled||(this.alwaysOnScreenStyle=this.getAlwaysOnScreenStyle(),this.internalIsOpen=!0,this.$el.focus(),this.$emit("open"))},togglePopover:function(){this.isOpen?this.hidePopover():this.showPopover()},updateSwatch:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.fromFallbackInput;if(!this.getSwatchDisabled(t)){var r=this.getSwatchColor(t);this.internalValue=r,this.$emit("input",r),!this.closeOnSelect||this.inline||n||this.hidePopover()}}}},N=$,W=(n("9334"),S(N,c,s,!1,null,null,null)),I=W.exports;e["default"]=I}})["default"]}));
//# sourceMappingURL=vue-swatches.umd.min.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f43d33_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10f43d33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f43d33_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(8)(function () {
  return Object.defineProperty(__webpack_require__(104)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(23);
var toIObject = __webpack_require__(24);
var arrayIndexOf = __webpack_require__(77)(false);
var IE_PROTO = __webpack_require__(106)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var anObject = __webpack_require__(5);
var getKeys = __webpack_require__(49);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(24);
var gOPN = __webpack_require__(52).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(49);
var gOPS = __webpack_require__(78);
var pIE = __webpack_require__(70);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(69);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(8)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(18);
var isObject = __webpack_require__(10);
var invoke = __webpack_require__(159);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(7).parseInt;
var $trim = __webpack_require__(63).trim;
var ws = __webpack_require__(110);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(7).parseFloat;
var $trim = __webpack_require__(63).trim;

module.exports = 1 / $parseFloat(__webpack_require__(110) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(31);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(10);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(113);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(5);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(18);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(69);
var toLength = __webpack_require__(13);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(50);
var toLength = __webpack_require__(13);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(125);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(15).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(71)
});


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(5);
var isObject = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(129);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(175);
var validate = __webpack_require__(57);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(86)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(15).f;
var create = __webpack_require__(51);
var redefineAll = __webpack_require__(56);
var ctx = __webpack_require__(30);
var anInstance = __webpack_require__(54);
var forOf = __webpack_require__(55);
var $iterDefine = __webpack_require__(115);
var step = __webpack_require__(169);
var setSpecies = __webpack_require__(53);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(43).fastKey;
var validate = __webpack_require__(57);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(175);
var validate = __webpack_require__(57);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(86)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var each = __webpack_require__(38)(0);
var redefine = __webpack_require__(20);
var meta = __webpack_require__(43);
var assign = __webpack_require__(156);
var weak = __webpack_require__(178);
var isObject = __webpack_require__(10);
var validate = __webpack_require__(57);
var NATIVE_WEAK_MAP = __webpack_require__(57);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(86)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(56);
var getWeak = __webpack_require__(43).getWeak;
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(10);
var anInstance = __webpack_require__(54);
var forOf = __webpack_require__(55);
var createArrayMethod = __webpack_require__(38);
var $has = __webpack_require__(23);
var validate = __webpack_require__(57);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(13);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(52);
var gOPS = __webpack_require__(78);
var anObject = __webpack_require__(5);
var Reflect = __webpack_require__(7).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(79);
var isObject = __webpack_require__(10);
var toLength = __webpack_require__(13);
var ctx = __webpack_require__(30);
var IS_CONCAT_SPREADABLE = __webpack_require__(12)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(13);
var repeat = __webpack_require__(112);
var defined = __webpack_require__(36);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(49);
var toIObject = __webpack_require__(24);
var isEnum = __webpack_require__(70).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(62);
var from = __webpack_require__(185);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(55);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _Footer = __webpack_require__(506);

var _Footer2 = _interopRequireDefault(_Footer);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _router = __webpack_require__(103);

var _router2 = _interopRequireDefault(_router);

var _ErrorDialog = __webpack_require__(610);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

var _ConfirmDialog = __webpack_require__(614);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

var _ResultDialog = __webpack_require__(618);

var _ResultDialog2 = _interopRequireDefault(_ResultDialog);

var _InfoDialog = __webpack_require__(622);

var _InfoDialog2 = _interopRequireDefault(_InfoDialog);

var _InputDialog = __webpack_require__(626);

var _InputDialog2 = _interopRequireDefault(_InputDialog);

var _FilePreviewDialog = __webpack_require__(630);

var _FilePreviewDialog2 = _interopRequireDefault(_FilePreviewDialog);

var _SpinnerLoading = __webpack_require__(638);

var _SpinnerLoading2 = _interopRequireDefault(_SpinnerLoading);

var _menuItems = __webpack_require__(642);

var _urlParams = __webpack_require__(65);

var _defaultValues = __webpack_require__(17);

var _customDefineType = __webpack_require__(6);

var _errorCode = __webpack_require__(645);

__webpack_require__(646);

var _vueSimpleContextMenu = __webpack_require__(648);

var _vueSimpleContextMenu2 = _interopRequireDefault(_vueSimpleContextMenu);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "app",
  data: function data() {
    return {
      msg: "Welcome to Your Vue.js App",
      map: null,
      selector: null,
      showMobileNav: false,
      isLoadingEmployerList: false,
      isLoadingCandidateList: false,
      isLoadingAdminList: false,
      isLoadingProfileTemplateList: false,
      isLoadingCandidateProfileTemplateList: false,
      isLoadingClientProfileTemplateList: false,
      isLoadingAgency: false,
      isLoadingPackageList: false,
      TOP_MENU_ALL_ITEMS: _menuItems.TOP_MENU_ALL_ITEMS,
      ADMIN_MENU_ALL_ITEMS: _menuItems.ADMIN_MENU_ALL_ITEMS,
      selectedMenuItem: "Dashboard",
      intervalFunc: null,
      checkMultiLoginInvervalFunc: null,
      hideLogo: false,
      showEngineHow: true,
      showRecentViewed: true
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.query && this.$route.query["hide-logo"]) {
      this.hideLogo = true;
    }
    this.setupInterceptor();
    // Not try to login in case of called inside iframe or in application form
    if (this.isAutoLoginNeeded) {
      try {
        this.$store.dispatch("tryAutoLogin");
      } catch (e) {
        // try to login in may has exception if cannot access localStorage
        console.log(e);
      }
    }

    this.$store.watch(function (state) {
      return state.authentication.agencyID;
    }, function (value) {
      // Agency changed
      _this.$store.dispatch("setProfileBuilderList", null);
      _this.$store.dispatch("setProfileTemplateList", []);
      _this.$store.dispatch("setCandidateList", []);
      _this.$store.dispatch("setEmployerList", []);
      _this.$store.dispatch("setAgency", {});
      _this.$store.dispatch("setAdminSetting", {});

      // Set timeout to wait for the agency API request
      if (value) {
        setTimeout(function () {
          _this.getPublicAgency();
        }, 100);
      }
    }, { immediate: true });

    this.setColor();
    this.setFonts();
    this.setDataList();
    this.setContextMenu();

    // Get number of messages
    this.intervalFunc = setInterval(function _callee() {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loadMessagesSummary();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    }, 120000);
    if (this.$route.query.selector === "Home") {
      this.showEngineHow = false;
      this.showRecentViewed = false;
    }
  },

  watch: {
    $route: {
      handler: function handler(to, from) {
        if (to) {
          if (["Agent Dashboard", "Employer Dashboard", "Candidate Dashboard"].includes(to.name)) {
            this.selectedMenuItem = "Dashboard";
          } else {
            this.selectedMenuItem = to.name;
          }
        }
        if (to.path == "/dashboard-v2") {
          this.$store.commit("setDashboardV2", true);
        } else {
          this.$store.commit("setDashboardV2", false);
        }
      },

      immediate: true
    }
  },
  mounted: function mounted() {
    this.setWindowWidth(window.innerWidth);
    document.addEventListener("click", this.onClick);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("click", this.onClick);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("message", this.receiveMessage);
    if (this.intervalFunc) {
      clearInterval(this.intervalFunc);
    }
    if (this.checkMultiLoginInvervalFunc) {
      clearInterval(this.checkMultiLoginInvervalFunc);
    }
    if (this.checkRecentSMSMessagesFunc) {
      clearInterval(this.checkRecentSMSMessagesFunc);
    }
  },

  components: {
    ErrorDialog: _ErrorDialog2.default,
    ConfirmDialog: _ConfirmDialog2.default,
    ResultDialog: _ResultDialog2.default,
    InfoDialog: _InfoDialog2.default,
    InputDialog: _InputDialog2.default,
    FilePreviewDialog: _FilePreviewDialog2.default,
    AppFooter: _Footer2.default,
    VueSimpleContextMenu: _vueSimpleContextMenu2.default,
    SpinnerLoading: _SpinnerLoading2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["employerList", "candidateList", "employerLastLoginFilter", "candidateLastLoginFilter", "hasMessage", "isAgent", "loggedinUser", "jobTypes", "showShiftJobBoardInternally", "shiftJobViewingStatuses", "shiftJobViewingTags", "shiftJobViewingTypes", "placementJobViewingStatuses", "placementJobViewingTypes", "hideMenuBar"]), {
    // Check if auto login needed
    isAutoLoginNeeded: function isAutoLoginNeeded() {
      // Not auto login if in an embeded site
      if (this.isEmbed) {
        return false;
      }
      if (this.$route && ["Application Form Builder", "Login", "Agency Job Board", "Job", "Public Job"].includes(this.$route.name)) {
        // Get agency id in localstorage
        var storedAgencyID = void 0;
        try {
          storedAgencyID = localStorage.getItem("agency_id");
        } catch (e) {
          // Cannot read localstorage, don't need auto login
          return false;
        }
        // Auto login if the login user access to profile builder of same agency
        return Number(storedAgencyID) === Number(this.$route.params.agencyID);
      }
      return true;
    },
    auth: function auth() {
      // Lecture 363
      return this.$store.getters.isAuthenticated;
    },

    title: {
      get: function get() {
        document.title = this.remaining;
        return this.remaining;
      },
      set: function set(val) {
        // console.log(val)
        document.title = val;
      }
    },
    isLoading: function isLoading() {
      return this.$store.getters.loadingReqNumber > 0;
    },

    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed: function isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["loadMessagesSummary", "getListRecentSMSLogs", "setWindowWidth", "setLoggedinUser", "setIframePositionTop", "setWindowHeight", "setIframeScaleY", "setIframeParentHeight"]), {
    receiveMessage: function receiveMessage(event) {
      try {
        var eventData = JSON.parse(event.data);
        if (eventData.iframePositionTop != null) {
          this.setIframePositionTop(eventData.iframePositionTop);
        }
        if (eventData.windowHeight != null) {
          this.setWindowHeight(eventData.windowHeight);
        }
        if (eventData.windowHeight != null) {
          this.setIframeParentHeight(eventData.windowHeight);
        }
        if (eventData.scaleY) {
          this.setIframeScaleY(eventData.scaleY);
        }
      } catch (e) {}
    },
    setDataList: function setDataList() {
      var _this2 = this;

      this.$store.watch(function (state) {
        return state.general.loadPackageListReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        // Check if package list is loaded
        if (_this2.$store.getters.packageList) {
          return;
        }
        _this2.getPackageList();
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.general.loadProfileTemplateListReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        // Check if profile template list is loaded
        if (_this2.$store.getters.profileTemplateList && _this2.$store.getters.profileTemplateList.length > 0) {
          return;
        }
        _this2.getProfileTemplateList();
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.general.reloadProfileTemplateListReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        _this2.getProfileTemplateList();
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.general.loadCandidateProfileTemplateListReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        // Check if candidate builder list is loaded
        if (_this2.$store.getters.candidateProfileTemplateList && _this2.$store.getters.candidateProfileTemplateList.length > 0) {
          return;
        }
        _this2.getCandidateProfileTemplateList();
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.general.loadClientProfileTemplateListReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        // Check if client builder list is loaded
        if (_this2.$store.getters.clientProfileTemplateList && _this2.$store.getters.clientProfileTemplateList.length > 0) {
          return;
        }
        _this2.getClientProfileTemplateList();
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.agency.loadAgencyReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        // Check if agency is loaded
        if (_this2.$store.getters.agency && Object.keys(_this2.$store.getters.agency).length > 0) {
          return;
        }
        _this2.getAgency();
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.agency.reloadAgencyReqNumber;
      }, function (val) {
        if (!val) {
          return;
        }
        _this2.getAgency();
      }, { immediate: true });
    },
    setColor: function setColor() {
      this.$store.watch(function (state) {
        return state.colors.primaryColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--coredarkcolor", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.primaryDarkerColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--coredarkercolor", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.secondaryColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--corelightcolor", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.secondaryDarkerColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--thrivehiregrey", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.profileTextColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--profiletextcolor", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.cancelButtonColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--cancelbuttoncolor", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.cancelButtonHoverColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--cancelbuttonhovercolor", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.colors.labelColor;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--labelcolor", value);
      }, { immediate: true });
    },
    setFonts: function setFonts() {
      this.$store.watch(function (state) {
        return state.fonts.rootFont;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--rootfontfamily", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.fonts.headingsFont;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--headingsfontfamily", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.fonts.headingOneCase;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--headingOneCase", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.fonts.headingTwoCase;
      }, function (value) {
        if (!value) {
          return;
        }
        console.log("headingTwoCase", value);
        var selector = document.querySelector(":root");
        selector.style.setProperty("--headingTwoCase", value);
      }, { immediate: true });
      this.$store.watch(function (state) {
        return state.fonts.headingThreeCase;
      }, function (value) {
        if (!value) {
          return;
        }
        var selector = document.querySelector(":root");
        selector.style.setProperty("--headingThreeCase", value);
      }, { immediate: true });
    },
    setContextMenu: function setContextMenu() {
      var _this3 = this;

      this.$store.watch(function (state) {
        return state.general.contextMenu;
      }, function (value) {
        if (!value || !_this3.$refs.contextMenu) {
          return;
        }
        _this3.$nextTick(function () {
          _this3.$refs.contextMenu.showMenu(value.event);
        });
      }, { immediate: true });
    },
    notifyDurationTime: function notifyDurationTime(config) {
      try {
        var duration = new Date().getTime() - config.meta.requestStartedAt;
        if (duration > 30000) {
          this.$bugsnag.notify(new Error("Long response time " + this.$store.getters.agencyID + " " + duration + " " + config.url), {
            metaData: {
              url: config.url,
              agencyId: this.$store.getters.agencyID,
              duration: duration
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    setupInterceptor: function setupInterceptor() {
      var _this4 = this;

      _axios2.default.interceptors.request.use(function (config) {
        try {
          if (localStorage.getItem("token")) {
            config.headers["Authorization"] = "Token " + localStorage.getItem("token");
          }
        } catch (e) {
          // Cannot access to localstorage in case of access from iframe or some case in Safari of iPhone
          // Refer to https://stackoverflow.com/questions/46632093/getting-security-error-on-iphone-when-using-localstorage
          if (_this4.$store.getters.userToken) {
            config.headers["Authorization"] = "Token " + _this4.$store.getters.userToken;
          }
        }
        try {
          config.meta = config.meta || {};
          config.meta.requestStartedAt = new Date().getTime();
        } catch (e) {}
        // https://stackoverflow.com/questions/48173717/enabling-cors-on-a-nginx-server-in-elasticbeanstalk/48721443
        config.headers["Access-Control-Allow-Origin"] = "*";

        // Check to add trailing slash to url
        var url = config.url.trim();
        var tokens = url.split("?");
        if (tokens[0].includes("/api/")) {
          if (url.includes("?")) {
            if (!tokens[0].endsWith("/")) {
              url = url.replace("?", "/?");
            }
          } else {
            // Check trailing slash
            if (!url.endsWith("/")) {
              url = url + "/";
            }
          }
          config.url = url;
        }
        // Add timezone to request body of Job API
        var listEndpointAddUrlPrefix = ["/api/jobs/", "/job-fillers", "/api/actions/", "/send-and-log-email/", "/api/shiftjobreports/", "/application-submit/", "/api/comments/", "/api/questions/", "/send-repeat-blaster/", "/set-user-status/", "/api/events/"];
        if (listEndpointAddUrlPrefix.some(function (prefix) {
          return url.indexOf(prefix) === 0;
        })) {
          if (config.data && !(config.data instanceof FormData)) {
            config.data = _extends({}, config.data, {
              timezone: config.data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
              root_url: _this4.rootUrl
            });
          }
        }
        if (!_this4.isHideLoadingRequest(url)) {
          _this4.showLoading();
        }

        return config;
      }, function (error) {
        console.log(error);
        _this4.hideLoading();
        return Promise.reject(error);
      });
      _axios2.default.interceptors.response.use(function (response) {
        var url = void 0;
        if (response && response.config) {
          url = response.config.url;
          _this4.notifyDurationTime(response.config);
        }
        if (!_this4.isHideLoadingRequest(url)) {
          _this4.hideLoading();
        }
        return response;
      }, function _callee2(error) {
        var url;
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = void 0;

                if (error && error.config) {
                  url = error.config.url;
                  _this4.notifyDurationTime(error.config);
                }

                if (!_this4.isBackgroundRequest(url)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", error);

              case 4:
                if (!_this4.isHideLoadingRequest(url)) {
                  _this4.hideLoading();
                }

                if (!(error.response && error.response.status == 409 && error.response.data && error.response.data.multi_login_access)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", error);

              case 7:
                if (_this4.hideErrorModal(url)) {
                  _context2.next = 11;
                  break;
                }

                if (!(!_this4.isAgent && error.response && error.response.status == 409 && error.response.data && error.response.data.timeoff_assigned_job_conflict)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", error);

              case 10:

                _this4.handleError(error);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, null, _this4);
      });
    },
    getWarningUserCreatedResource: function getWarningUserCreatedResource(error) {
      if (error == null || error.response == null) {
        return null;
      }
      if (error.response.config == null || error.response.config.url == null) {
        return null;
      }
      var url = error.response.config.url;
      // Check for login API
      if (url.includes(_urlParams.PARAM_LOGIN)) {
        return _urlParams.VALUE_LOGIN;
      }
      if (!url.includes(_urlParams.PARAM_USER_CREATED)) {
        return null;
      }
      return this.getParameterByName(url, _urlParams.PARAM_RESOURCE_INFO_KEY);
    },
    isBackgroundRequest: function isBackgroundRequest(url) {
      if (!url) {
        return false;
      }
      return this.getParameterByName(url, _urlParams.PARAM_BACKGROUND_KEY) === "true";
    },
    isHideLoadingRequest: function isHideLoadingRequest(url) {
      if (!url) {
        return false;
      }
      if (this.isBackgroundRequest(url)) {
        return true;
      }
      return this.getParameterByName(url, _urlParams.PARAM_HIDE_LOADING) === "true";
    },
    hideErrorModal: function hideErrorModal(url) {
      if (!url) {
        return false;
      }
      return this.getParameterByName(url, _urlParams.PARAM_HIDE_ERROR_MODAL) === "true";
    },
    warningConflict: function warningConflict(error) {
      var _this5 = this;

      var responseData = error.response.data;
      var detailMessage = responseData.message || "";
      detailMessage = detailMessage.replace("Please select another candidate", "").trim();
      return new Promise(function (resolve) {
        _this5.showConfirmDialog({
          innerHtml: "<h2>Do you want to continue and ignore the conflict?<h2><h5>" + detailMessage + "</h5>",
          onAcceptCallback: function onAcceptCallback() {
            var requestBody = error.config.data;
            try {
              requestBody = JSON.parse(requestBody);
            } catch (e) {}
            if (responseData.availability_conflict) {
              requestBody.ignore_availability_conflict = true;
            }
            if (responseData.time_conflict) {
              requestBody.ignore_time_conflict = true;
            }
            if (responseData.unique_value_conflict) {
              requestBody.ignore_unique_value_conflict = true;
            }
            if (responseData.timeoff_assigned_job_conflict) {
              requestBody.ignore_timeoff_assigned_job_conflict = true;
            }
            if (responseData.status_conflict) {
              requestBody.check_job_status = false;
            }
            if (responseData.do_not_match) {
              requestBody.ignore_do_not_match = true;
            }
            var res = _axios2.default.request(_extends({}, error.config, {
              data: requestBody
            }));
            resolve(res);
          },
          onRejectCallback: function onRejectCallback() {
            resolve();
          }
        });
      });
    },
    handleError: function handleError(error) {
      var warningResource, errorMessage, errorCode, detail, res;
      return regeneratorRuntime.async(function handleError$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              warningResource = this.getWarningUserCreatedResource(error);

              if (!(error == null || error.response == null)) {
                _context3.next = 5;
                break;
              }

              if (warningResource) {
                this.showErrorDialog({
                  title: "Your application has been submitted! BUT",
                  message: "There was an error processing your " + warningResource + " (Error: " + String(error) + "). Could you please login and update in your profile."
                });
              } else {
                errorMessage = String(error);

                if (errorMessage === "Error: Network Error") {
                  this.showErrorDialog("NETWORK_ERROR");
                } else {
                  this.showErrorDialog({
                    title: "There is an error",
                    message: errorMessage
                  });
                }
              }
              _context3.next = 24;
              break;

            case 5:
              if (!error.response.data) {
                _context3.next = 16;
                break;
              }

              errorCode = error.response.data.error_code;

              if (!(errorCode === _errorCode.ERROR_CODE.USER_EXISTED)) {
                _context3.next = 10;
                break;
              }

              this.showConfirmDialog({
                innerHtml: this.$store.getters.agencyPublic.duplicate_email_error_message,
                acceptLabel: "Navigate to Login",
                rejectLabel: "Edit the form",
                onAcceptCallback: function onAcceptCallback() {
                  return _router2.default.replace({ name: "Login" });
                }
              });
              return _context3.abrupt("return");

            case 10:
              detail = error.response.data.detail;

              if (!(this.$store.getters.userID && detail === "Sorry, you no longer have profile access.")) {
                _context3.next = 16;
                break;
              }

              _context3.next = 14;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + this.$store.getters.userID + "/"));

            case 14:
              res = _context3.sent;

              this.setLoggedinUser(res.data);

            case 16:
              if (!warningResource) {
                _context3.next = 23;
                break;
              }

              if (!(warningResource === _urlParams.VALUE_LOGIN)) {
                _context3.next = 20;
                break;
              }

              if (error.response.status === 400) {
                this.showErrorDialog({
                  title: "Incorrect email or password",
                  message: "Sorry, your email or password is incorrect! Please try again, or use the forgot password link to rest your password."
                });
              } else {
                this.showErrorDialog({
                  title: "There is an error",
                  errorObj: error.response.data
                });
              }
              return _context3.abrupt("return");

            case 20:
              this.showErrorDialog({
                title: "Your application has been submitted! BUT",
                message: "There was an error processing your " + warningResource + ". Could you please login and update in your profile.",
                errorObj: error.response.data
              });
              _context3.next = 24;
              break;

            case 23:
              this.showErrorDialog({
                title: "There is an error",
                errorObj: error.response.data
              });

            case 24:
              throw error;

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    },
    onClick: function onClick() {
      // Adding event handler to document:
      // https://stackoverflow.com/questions/41950432/vue-js-call-the-click-event-for-whole-page-document
      if (this.showMobileNav === true) {
        this.showMobileNav = false;
      }
    },
    logout: function logout(keepCache) {
      if (keepCache != true) {
        this.removeCheckMultipleLoginCache();
      }
      this.$store.dispatch("logout");
    },
    checkMultipleLogin: function checkMultipleLogin(forceLogout) {
      var _this6 = this;

      // check multiple logins and if it is not multiple login, update the access time
      if (localStorage.getItem("token")) {
        _axios2.default.post("check-multiple-login/?resource=login&in_background=true", {}).then(function (res) {
          if (res.response && res.response.status == 409) {
            if (forceLogout) {
              _this6.logout(true);
              _this6.showErrorDialog("FORCE_LOGOUT_ERROR_DIALOG");
            }

            if (_this6.checkMultiLoginInvervalFunc) {
              clearInterval(_this6.checkMultiLoginInvervalFunc);
              _this6.checkMultiLoginInvervalFunc = null;
            }
          }
        });
      }
    },
    removeCheckMultipleLoginCache: function removeCheckMultipleLoginCache() {
      if (localStorage.getItem("token")) {
        _axios2.default.delete("check-multiple-login/?in_background=true", {
          headers: {
            Authorization: "Token " + localStorage.getItem("token")
          }
        });
      }
    },
    getPublicAgency: function getPublicAgency() {
      var res;
      return regeneratorRuntime.async(function getPublicAgency$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (this.$store.getters.agencyID) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              if (!this.isLoadingAgency) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              if (!(this.$store.getters.agency && Array.keys(this.$store.getters.agency).length)) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return");

            case 6:
              _context4.next = 8;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/agenciespublic/" + this.$store.getters.agencyID + "/"));

            case 8:
              res = _context4.sent;

              this.setPublicAgency(res.data);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    },

    // Get profile template list for both client and candidate
    getProfileTemplateList: function getProfileTemplateList() {
      var _this7 = this;

      var res;
      return regeneratorRuntime.async(function getProfileTemplateList$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (this.$store.getters.agencyID) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              if (!this.isLoadingProfileTemplateList) {
                _context5.next = 4;
                break;
              }

              return _context5.abrupt("return");

            case 4:
              // Mark there is one request sending
              this.isLoadingProfileTemplateList = true;

              _context5.next = 7;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/profiletemplates/?agency=" + this.$store.getters.agencyID));

            case 7:
              res = _context5.sent;

              setTimeout(function () {
                _this7.$store.dispatch("setIsLoadingProfileTemplate", false);
              }, 100);

              this.isLoadingProfileTemplateList = false;
              this.$store.dispatch("setProfileTemplateList", res.data ? res.data : []);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    },

    // Get profile template list for candidate
    getCandidateProfileTemplateList: function getCandidateProfileTemplateList() {
      var _this8 = this;

      var res;
      return regeneratorRuntime.async(function getCandidateProfileTemplateList$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (this.$store.getters.agencyID) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              if (!this.isLoadingProfileTemplateList) {
                _context6.next = 4;
                break;
              }

              return _context6.abrupt("return");

            case 4:
              if (!this.isLoadingCandidateProfileTemplateList) {
                _context6.next = 6;
                break;
              }

              return _context6.abrupt("return");

            case 6:
              // Mark there is one request sending
              this.isLoadingCandidateProfileTemplateList = true;

              _context6.next = 9;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/profiletemplates/?agency=" + this.$store.getters.agencyID + "&user_type=" + _customDefineType.BUILDER_USER_TYPE.CANDIDATE));

            case 9:
              res = _context6.sent;

              setTimeout(function () {
                _this8.$store.dispatch("setIsLoadingProfileTemplate", false);
              }, 100);

              this.isLoadingCandidateProfileTemplateList = false;
              this.$store.dispatch("setCandidateProfileTemplateList", res.data ? res.data.filter(function (template) {
                return template.deactivated === false;
              }) : []);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    },

    // Get profile template list for client
    getClientProfileTemplateList: function getClientProfileTemplateList() {
      var _this9 = this;

      var res;
      return regeneratorRuntime.async(function getClientProfileTemplateList$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (this.$store.getters.agencyID) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              if (!this.isLoadingProfileTemplateList) {
                _context7.next = 4;
                break;
              }

              return _context7.abrupt("return");

            case 4:
              if (!this.isLoadingClientProfileTemplateList) {
                _context7.next = 6;
                break;
              }

              return _context7.abrupt("return");

            case 6:
              // Mark there is one request sending
              this.isLoadingClientProfileTemplateList = true;

              _context7.next = 9;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/profiletemplates/?agency=" + this.$store.getters.agencyID + "&user_type=" + _customDefineType.BUILDER_USER_TYPE.CLIENT));

            case 9:
              res = _context7.sent;

              setTimeout(function () {
                _this9.$store.dispatch("setIsLoadingProfileTemplate", false);
              }, 100);
              console.log("res 1 ========>", res);
              this.isLoadingClientProfileTemplateList = false;
              this.$store.dispatch("setClientProfileTemplateList", res.data ? res.data.filter(function (template) {
                return template.deactivated === false;
              }) : []);
              console.log("res 2 ========>", res);

            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    },
    getPackageList: function getPackageList() {
      var res, packageList;
      return regeneratorRuntime.async(function getPackageList$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (this.$store.getters.agencyID) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt("return");

            case 2:
              if (!this.isLoadingPackageList) {
                _context8.next = 4;
                break;
              }

              return _context8.abrupt("return");

            case 4:
              // Mark there is one request sending
              this.isLoadingPackageList = true;

              _context8.next = 7;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/packages/?agency=" + this.$store.getters.agencyID));

            case 7:
              res = _context8.sent;


              this.isLoadingPackageList = false;
              packageList = res.data;

              if (!packageList) {
                packageList = [];
              }
              packageList = packageList.sort(function (a, b) {
                return a.order > b.order ? 1 : -1;
              });
              this.$store.dispatch("setPackageList", packageList);

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    },
    getAgency: function getAgency() {
      var res, agency;
      return regeneratorRuntime.async(function getAgency$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (this.$store.getters.agencyID) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return");

            case 2:
              if (!this.isLoadingAgency) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt("return");

            case 4:
              // Mark there is one request sending
              this.isLoadingAgency = true;

              _context9.next = 7;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/agencies/" + this.$store.getters.agencyID));

            case 7:
              res = _context9.sent;
              agency = {};

              if (res && res.data) {
                agency = res.data;
              }
              this.isLoadingAgency = false;
              this.setAgency(agency);

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    },
    checkRecentSMSMessages: function checkRecentSMSMessages() {
      var listRecentLogs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, log, content;

      return regeneratorRuntime.async(function checkRecentSMSMessages$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return regeneratorRuntime.awrap(this.getListRecentSMSLogs());

            case 2:
              listRecentLogs = _context10.sent;

              if (!(listRecentLogs && listRecentLogs.length)) {
                _context10.next = 23;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context10.prev = 7;

              for (_iterator = listRecentLogs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                log = _step.value;
                content = log.phone;

                if (log.user_name) {
                  content = content + " (" + log.user_name + ")";
                }
                content = content + ": " + log.message;
                this.$toasted.show(content, {
                  duration: 15000,
                  action: [{
                    icon: "close",
                    class: "close-toast-btn",
                    onClick: function onClick(e, toastObject) {
                      toastObject.goAway(0);
                    }
                  }]
                });
              }
              _context10.next = 15;
              break;

            case 11:
              _context10.prev = 11;
              _context10.t0 = _context10["catch"](7);
              _didIteratorError = true;
              _iteratorError = _context10.t0;

            case 15:
              _context10.prev = 15;
              _context10.prev = 16;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 18:
              _context10.prev = 18;

              if (!_didIteratorError) {
                _context10.next = 21;
                break;
              }

              throw _iteratorError;

            case 21:
              return _context10.finish(18);

            case 22:
              return _context10.finish(15);

            case 23:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this, [[7, 11, 15, 23], [16,, 18, 22]]);
    },
    dashboardRedirect: function dashboardRedirect() {
      if (this.$store.getters.isCandidate) {
        _router2.default.replace({ name: "Candidate Dashboard" });
      } else if (this.$store.getters.isEmployer) {
        _router2.default.replace({ name: "Employer Dashboard" });
      } else if (this.$store.getters.isAgent) {
        _router2.default.replace({ name: "Agent Dashboard" });
      }
    },
    handleScroll: function handleScroll() {
      this.$store.dispatch("setPageScrollTop", window.scrollY);
    },
    handleResize: function handleResize() {
      this.setWindowWidth(window.innerWidth);
      this.$store.dispatch("increaseScreenResizeCount");
    },
    handleClickApp: function handleClickApp(event) {
      this.$store.dispatch("setLastClickY", event.y);
    },
    contextMenuOptionClicked: function contextMenuOptionClicked(event) {
      if (event && event.option) {
        if (event.option.onSelectData) {
          event.option.onSelect(event.option.onSelectData);
        } else {
          event.option.onSelect();
        }
      }
    },
    handleClickHelp: function handleClickHelp() {
      this.submitTrackingClick("Click Enginehire Help", "Global Button");
    }
  })
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      email: '',
      emailEmployer: '',
      emailCandidate: '',
      justSubscribed: false
    };
  },

  methods: {}
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(22);
var normalizeHeaderName = __webpack_require__(512);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(193);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(193);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(148)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var settle = __webpack_require__(513);
var buildURL = __webpack_require__(190);
var buildFullPath = __webpack_require__(515);
var parseHeaders = __webpack_require__(518);
var isURLSameOrigin = __webpack_require__(519);
var createError = __webpack_require__(194);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(520);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(514);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
  * vue-router v3.5.3
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.3';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["default"] = (VueRouter);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _fieldTypes = __webpack_require__(45);

var _separator = __webpack_require__(100);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  components: {
    ApplicationSectionWithDialog: function ApplicationSectionWithDialog() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 895));
    },
    BookingSectionWithDialog: function BookingSectionWithDialog() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 202));
    },
    SigningDocument: function SigningDocument() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 903));
    },
    FileUpload: function FileUpload() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 134));
    },
    StripePayment: function StripePayment() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 205));
    },
    AuthorizeNetPayment: function AuthorizeNetPayment() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 904));
    },
    QuickbooksPayment: function QuickbooksPayment() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 905));
    },
    ApplicationSectionInput: function ApplicationSectionInput() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 906));
    },
    EvaluationInApplicationForm: function EvaluationInApplicationForm() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 907));
    },
    FileWithInfo: function FileWithInfo() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 908));
    },
    StripeSubscriptionSelection: function StripeSubscriptionSelection() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 909));
    },
    GoogleCaptcha: function GoogleCaptcha() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 910));
    },
    FileWithLabel: function FileWithLabel() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 228));
    }
  },
  props: {
    isBookingOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      applicationData: {
        agency: Number(this.$route.params.agencyID),
        application_form: Number(this.$route.params.profileID),
        selected_placement_jobs: []
      },
      profile: {},
      submitClicked: false,
      mapDependentObjects: {},
      listRejectConditions: [],
      listTypeConditions: [],
      listChecklistConditions: [],
      listBadgeConditions: [],
      listStatusConditions: [],
      listSecondStatusConditions: [],
      listTagConditions: [],
      listKeapTagConditions: [],
      listLocationConditions: [],
      listManagerConditions: [],
      listSecondManagerConditions: [],
      listMembershipConditions: [],
      listErrorConditions: [],
      listModelsAdminOnly: [],
      listModelsAdminClient: [],
      mapDependentLabelName: {},
      listBookingJobs: [],
      mapSignatures: {},
      mapDocumentTemplates: {},
      mapFileInfo: {},
      mapSavedFileInfo: {},
      mapCheckboxCondition: {},
      jobViewID: "", //jobView id to track views & applications. Passed from Job component
      currentStep: 1, // For multi-steps application form
      numberOfStep: 1,
      mapCheckboxConditionStep: {},
      builderLocations: [],
      builderLanguages: [],
      FORM_TYPE: _customDefineType.FORM_TYPE,
      PAYMENT_TYPES: _customDefineType.PAYMENT_TYPES,
      authorizePaymentInfo: {},
      authorizeOpaqueData: null,
      quickbooksPaymentInfo: {},
      userStatus: null,
      userTypes: null,
      intervalSubmitFunc: null,
      registeredUserId: null,
      listEvaluation: [],
      initialLoggedInUser: null,
      listSnapshots: [],
      listOriginalEvaluations: [],
      listOriginalDocuments: [],
      hasDuplicatedEmailError: false,
      mapSavedDependentObjects: {}, // Use to track if the data is changed since the last submit
      listSavedEvaluations: [],
      listSavedDocuments: [],
      lastTrackingRequest: "",
      preApplicationUserStatus: null,
      isClickPrevious: false,
      stripeSubscriptionSelected: null,
      isVerifiedCaptcha: false,
      mapSectionAPICount: {}, // Ex: /api/references/: 2, /api/experiences/: 1 ...
      stripePaymentMethodId: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["agencyHumanName", "useModalInApplicationForm", "candidateTypes", "candidateTags", "employerTypes", "employerTags", "candidateStatuses", "employerStatuses", "onlyShowMatchedLocations", "publicCandidateList", "candidateListMainInfo", "isAgent", "candidateReapplicationStatuses", "clientReapplicationStatuses", "userID", "agencyLogoHeightInPx", "agencyPublic", "agencyLocations"]), {
    isShowFormSubmitted: function isShowFormSubmitted() {
      if (!this.profile || !this.profile.id) {
        // Not finish loading;
        return false;
      }
      if (this.initialLoggedInUser && this.initialLoggedInUser.status) {
        if (this.listAllowApplicantStatuses.includes("All") || this.listAllowApplicantStatuses.includes(this.initialLoggedInUser.status)) {
          return false;
        }
      }
      return this.userID && !this.isAgent;
    },
    listAllowApplicantStatuses: function listAllowApplicantStatuses() {
      return this.getListAllowReturningApplicantStatuses(this.profile);
    },
    hasPlaceholderEmailInfo: function hasPlaceholderEmailInfo() {
      var _this = this;

      if (!this.applicationData) {
        return false;
      }
      if (!this.listDisplayFields) {
        return true;
      }
      // If one of these fields are showed => show Submit button
      var listKeys = ["phone", "email", "first_name", "last_name"];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var key = _step.value;

          if (_this.applicationData[key]) {
            return {
              v: true
            };
          }
          var listFields = _this.listDisplayFields.filter(function (field) {
            return field.model == key;
          });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = listFields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var field = _step2.value;

              if (_this.isItemShow(_this.applicationData, field, _this.listFields)) {
                return {
                  v: true
                };
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        };

        for (var _iterator = listKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();

          if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    redirectToLink: function redirectToLink() {
      var _this2 = this;

      var linkTypes = this.tryGet(function () {
        return _this2.profile.additional_information.redirect_to_link_types;
      });
      if (linkTypes && linkTypes.length && this.userTypes) {
        var linkItem = linkTypes.find(function (item) {
          return item.types && _this2.hasCommonElement(item.types, _this2.userTypes);
        });
        if (linkItem && linkItem.link) {
          return linkItem.link;
        }
      }
      return this.tryGet(function () {
        return _this2.profile.additional_information.redirect_to_link;
      });
    },
    redirectImmediately: function redirectImmediately() {
      var _this3 = this;

      return this.tryGet(function () {
        return _this3.profile.additional_information.redirect_immediately;
      });
    },
    applicationFormColors: function applicationFormColors() {
      var _this4 = this;

      var colorObject = "";
      if (this.profile.background_color) {
        colorObject += "background-color : " + this.profile.background_color + ";";
      }
      if (this.tryGet(function () {
        return _this4.profile.additional_information.font_color;
      })) {
        colorObject += "--appFormFontColor : " + this.profile.additional_information.font_color + ";";
      }
      return colorObject;
    },
    hasFontColor: function hasFontColor() {
      var _this5 = this;

      return this.tryGet(function () {
        return _this5.profile.additional_information.font_color;
      });
    },
    hasParseCVButton: function hasParseCVButton() {
      var _this6 = this;

      return this.tryGet(function () {
        return _this6.profile.additional_information.has_parse_cv_btn;
      });
    },
    parseCVLabel: function parseCVLabel() {
      var _this7 = this;

      return this.tryGet(function () {
        return _this7.profile.additional_information.parse_cv_button_label;
      }) || "Upload Resume/CV to parse";
    },
    hideAllMenuItems: function hideAllMenuItems() {
      var _this8 = this;

      return this.tryGet(function () {
        return _this8.profile.additional_information.hide_all_menu_items;
      });
    },
    submissionMessageDuration: function submissionMessageDuration() {
      var _this9 = this;

      return this.tryGet(function () {
        return _this9.profile.additional_information.submission_confirmation_duration;
      });
    },
    rejectionMessageDuration: function rejectionMessageDuration() {
      var _this10 = this;

      return this.tryGet(function () {
        return _this10.profile.additional_information.rejection_message_duration;
      });
    },
    hasSpaceBottomEmbedded: function hasSpaceBottomEmbedded() {
      var _this11 = this;

      return this.tryGet(function () {
        return _this11.profile.additional_information.has_space_bottom_embedded;
      });
    },
    hasCaptcha: function hasCaptcha() {
      var _this12 = this;

      return this.tryGet(function () {
        return _this12.profile.additional_information.enable_captcha;
      });
    },
    spaceHeightBottomEmbedded: function spaceHeightBottomEmbedded() {
      var _this13 = this;

      return this.tryGet(function () {
        return _this13.profile.additional_information.space_height_bottom_embedded;
      }) || "500";
    },
    hideFormTitle: function hideFormTitle() {
      if (this.isBookingOnly) {
        return true;
      }
      if (!this.profile || !this.profile.additional_information) {
        return false;
      }
      if (this.profile.additional_information.hide_form_title) {
        return true;
      }
      if (this.isEmbed) {
        if (this.profile.additional_information.hide_form_title_in_embedded) {
          return true;
        }
      }
      return false;
    },
    language: function language() {
      return this.applicationData.language;
    },
    locations: function locations() {
      return this.applicationData.locations;
    },

    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed: function isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    profileID: function profileID() {
      return Number(this.$route.params.profileID);
    },
    agencyID: function agencyID() {
      return Number(this.$route.params.agencyID);
    },
    submitSuccessDialog: function submitSuccessDialog() {
      var _this14 = this;

      var messageTypes = this.tryGet(function () {
        return _this14.profile.additional_information.submission_confirmation_by_types;
      });
      if (messageTypes && messageTypes.length && this.userTypes) {
        var messageItem = messageTypes.find(function (item) {
          return item.types && _this14.hasCommonElement(item.types, _this14.userTypes);
        });
        if (messageItem) {
          return {
            innerHtml: messageItem.message
          };
        }
      }
      var messageStatus = this.tryGet(function () {
        return _this14.profile.additional_information.submission_confirmation_by_statuses;
      });
      if (messageStatus && messageStatus.length && this.userStatus) {
        var _messageItem = messageStatus.find(function (item) {
          return item.statuses && item.statuses.includes(_this14.userStatus);
        });
        if (_messageItem) {
          return {
            innerHtml: _messageItem.message
          };
        }
      }
      if (this.type === _customDefineType.BUILDER_USER_TYPE.UNSPECIFIED) {
        var userType = this.applicationData.userType;
        if (userType === this.candidateOption) {
          var message = this.getAdditionalInfo("submission_confirmation_candidate") || this.getLabelByKeys("RESULT_DIALOGS.SUBMIT_SUCCESS_CONTACT_FORM.INNER_HTML");
          if (message) {
            return {
              innerHtml: message
            };
          }
        } else if (userType === this.clientOption) {
          var _message = this.getAdditionalInfo("submission_confirmation_client") || this.getLabelByKeys("RESULT_DIALOGS.SUBMIT_SUCCESS_CONTACT_FORM.INNER_HTML");
          if (_message) {
            return {
              innerHtml: _message
            };
          }
        }
      }
      var submissionConfirmationMessage = this.getApplicationProperty("submission_confirmation");
      if (this.type === _customDefineType.BUILDER_USER_TYPE.CLIENT) {
        return this.getSubmissionDialogContent(submissionConfirmationMessage, this.$store.getters.submitSuccessFamilyForm);
      } else {
        return this.getSubmissionDialogContent(submissionConfirmationMessage, this.$store.getters.submitSuccessNannyForm);
      }
    },
    submitRejectDialog: function submitRejectDialog() {
      var rejectionMessage = this.getApplicationProperty("rejection_message");
      return this.getSubmissionDialogContent(rejectionMessage, this.$store.getters.submitRejectForm);
    },
    hasLocationQuestion: function hasLocationQuestion() {
      if (this.profile.additional_information && this.profile.additional_information.exclude_location_question) {
        return false;
      }
      if (this.listLocations && this.listLocations.length > 1) {
        return true;
      }
      return false;
    },
    hasLanguageQuestion: function hasLanguageQuestion() {
      if (this.profile.additional_information && this.profile.additional_information.exclude_language_question) {
        return false;
      }
      if (this.listLanguages && this.listLanguages.length > 1) {
        return true;
      }
      return false;
    },
    listFields: function listFields() {
      var listFields = this.profile.list_fields;
      if (!listFields) {
        return [];
      }
      // Not on application but in profile
      listFields = listFields.filter(function (field) {
        return !field.notInApplication;
      });
      // Merge two array, then flat the result
      var mergeExcludeModel = [].concat.apply([], [].concat(_toConsumableArray(this.listModelsAdminOnly), _toConsumableArray(this.listModelsAdminClient)));
      listFields = listFields.filter(function (field) {
        return !mergeExcludeModel.includes(field.model);
      });
      // Filter hidden fields
      listFields = listFields.filter(function (field) {
        return !field.isHidden;
      });
      // Check to insert location fields
      if (this.hasLocationQuestion) {
        // Find index of location field in list fields (it is below the HTML field or precondition check fields)
        var locationFieldIndex = 0;
        var stepIndex = 1;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = listFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var field = _step3.value;

            if (field.isPreconditionCheck) {
              locationFieldIndex += 1;
              stepIndex = 2;
            } else if (field.type === _customDefineType.FORM_TYPE.HTML || field.isHidden) {
              locationFieldIndex += 1;
            } else {
              break;
            }
          }
          // Insert locations field
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var locationQuestion = "Which locations are you interested in?";
        if (this.profile.additional_information && this.profile.additional_information.location_question) {
          locationQuestion = this.profile.additional_information.location_question;
        }

        var locationField = {
          label: locationQuestion,
          type: _customDefineType.FORM_TYPE.CHECKBOX,
          optionList: this.listLocations.join("\n"),
          model: "locations",
          stepIndex: stepIndex
        };
        // Multilanguage for location
        if (this.listLanguages && this.listLanguages.some(function (lang) {
          return lang !== "English";
        })) {
          // Multilanguage for label
          if (this.profile.additional_information) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = this.listLanguages[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var lang = _step4.value;

                locationField["label_lang_" + lang] = this.profile.additional_information["location_question_lang_" + lang];
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        }
        if (this.profile.additional_information && this.profile.additional_information.single_location) {
          listFields.splice(locationFieldIndex, 0, _extends({}, locationField, {
            type: _customDefineType.FORM_TYPE.RADIO,
            isShareModel: true,
            shareModelIndex: 0
          }));
        } else {
          listFields.splice(locationFieldIndex, 0, locationField);
        }
      }

      // Check to insert languages field
      if (this.hasLanguageQuestion) {
        // Find index of language field in list fields (it is below the HTML field or precondition check fields)
        var languageFieldIndex = 0;
        var _stepIndex = 1;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = listFields[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _field = _step5.value;

            if (_field.isPreconditionCheck) {
              languageFieldIndex += 1;
              _stepIndex = 2;
            } else if (_field.type === _customDefineType.FORM_TYPE.HTML || _field.isHidden) {
              languageFieldIndex += 1;
            } else {
              break;
            }
          }
          // Insert locations field
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        var languageQuestion = "Which language do you want to use?";
        if (this.profile.additional_information && this.profile.additional_information.language_question) {
          languageQuestion = this.profile.additional_information.language_question;
        }
        var languageField = {
          label: languageQuestion,
          type: _customDefineType.FORM_TYPE.RADIO,
          optionList: this.listLanguages.join("\n"),
          model: "language",
          stepIndex: _stepIndex
        };
        // Multilanguage for label
        if (this.profile.additional_information) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = this.listLanguages[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var _lang = _step6.value;

              languageField["label_lang_" + _lang] = this.profile.additional_information["language_question_lang_" + _lang];
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
        listFields.splice(languageFieldIndex, 0, languageField);
      }

      // Check to insert user type question
      if (this.type === _customDefineType.BUILDER_USER_TYPE.UNSPECIFIED) {
        // Find index of user type field in list fields (it is below the HTML field or precondition check fields)
        var userTypeFieldIndex = 0;
        var _stepIndex2 = 1;
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = listFields[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _field2 = _step7.value;

            if (_field2.isPreconditionCheck) {
              userTypeFieldIndex += 1;
              _stepIndex2 = 2;
            } else if (_field2.type === _customDefineType.FORM_TYPE.HTML || _field2.isHidden) {
              userTypeFieldIndex += 1;
            } else {
              break;
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        var userTypeField = {
          label: this.getAdditionalInfo("user_type_question", "Please specify user type?"),
          type: _customDefineType.FORM_TYPE.RADIO,
          optionList: [this.candidateOption, this.clientOption],
          stepIndex: _stepIndex2,
          model: "userType"
        };
        // Multilanguage for label
        if (this.profile.additional_information) {
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = this.listLanguages[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _lang2 = _step8.value;

              userTypeField["label_lang_" + _lang2] = this.profile.additional_information["user_type_question_lang_" + _lang2] || userTypeField.label;
              var candidateOption = this.profile.additional_information["user_type_candidate_option_lang_" + _lang2];
              var clientOption = this.profile.additional_information["user_type_client_option_lang_" + _lang2];
              if (candidateOption && clientOption) {
                userTypeField["optionList_lang_" + _lang2] = [candidateOption, clientOption];
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
        listFields.splice(userTypeFieldIndex, 0, userTypeField);
      }

      // Check duplicate model and print to console
      /*
      if (listFields) {
        const listModels = listFields
          .filter((field) => field.model)
          .map((field) => field.model);
        this.findDuplicates(listModels);
      }
      console.log(listFields.filter(field => field.model === 'multiselect20'));
      */
      if (this.isBookingOnly) {
        if (this.registeredUserId) {
          listFields = listFields.filter(function (field) {
            return field.type === _customDefineType.FORM_TYPE.BOOKING_SECTION;
          });
        } else {
          listFields = [];
        }
      }
      return listFields;
    },
    listFileModels: function listFileModels() {
      if (!this.listFields) {
        return [];
      }
      return this.listFields.filter(function (field) {
        return field.type === _customDefineType.FORM_TYPE.FILE;
      }).map(function (field) {
        return field.model;
      });
    },
    candidateOption: function candidateOption() {
      return this.getAdditionalInfo("user_type_candidate_option", "Candidate");
    },
    clientOption: function clientOption() {
      return this.getAdditionalInfo("user_type_client_option", "Client");
    },
    listDisplayFields: function listDisplayFields() {
      var _this15 = this;

      // check for fields that are not required in application but required in profile
      this.listFields.map(function (field) {
        if (field.notRequiredInApplication) {
          field.isRequired = false;
        }
      });
      if (this.profile.is_multi_steps_form) {
        return this.listFields.filter(function (field) {
          return field.stepIndex === _this15.currentStep;
        });
      } else {
        return this.listFields;
      }
    },
    listDialogSections: function listDialogSections() {
      var _this16 = this;

      return this.listFields.filter(function (field) {
        return [_customDefineType.FORM_TYPE.SLOT, _customDefineType.FORM_TYPE.SECTION, _customDefineType.FORM_TYPE.BOOKING_SECTION].includes(field.type) && _this16.isItemShow(_this16.applicationData, field, _this16.listFields);
      });
    },
    listFileInfoFields: function listFileInfoFields() {
      var _this17 = this;

      return this.listFields.filter(function (field) {
        return field.type === _customDefineType.FORM_TYPE.FILE_WITH_INFO && _this17.isItemShow(_this17.applicationData, field, _this17.listFields);
      });
    },
    stripeSubscriptionSelectionField: function stripeSubscriptionSelectionField() {
      var _this18 = this;

      if (!this.listFields) {
        return null;
      }
      return this.listFields.find(function (field) {
        return field.type === _customDefineType.FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION && _this18.isItemShow(_this18.applicationData, field, _this18.listFields);
      });
    },
    hasMultipleBooking: function hasMultipleBooking() {
      var count = 0;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.listDialogSections[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var section = _step9.value;

          if (section.type == _customDefineType.FORM_TYPE.BOOKING_SECTION) {
            count += 1;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return count > 1;
    },
    paymentField: function paymentField() {
      var _this19 = this;

      return this.listFields.find(function (field) {
        return field.type === _customDefineType.FORM_TYPE.PAYMENT && _this19.isItemShow(_this19.applicationData, field, _this19.listFields);
      });
    },
    creditPackageSelectionField: function creditPackageSelectionField() {
      var _this20 = this;

      return this.listFields.find(function (field) {
        return [_customDefineType.FORM_TYPE.CREDIT_PACKAGE_SELECTION, _customDefineType.FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION].includes(field.type) && _this20.isItemShow(_this20.applicationData, field, _this20.listFields);
      });
    },
    isMonthlyCreditPackageSelection: function isMonthlyCreditPackageSelection() {
      if (!this.creditPackageSelectionField) {
        return false;
      }
      return this.creditPackageSelectionField.type === _customDefineType.FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION;
    },
    listCheckboxConditionFields: function listCheckboxConditionFields() {
      return this.listFields.filter(function (field) {
        return field.type === _customDefineType.FORM_TYPE.CHECKBOX_CONDITION;
      });
    },
    listAllSignDocumentField: function listAllSignDocumentField() {
      return this.listFields.filter(function (field) {
        return field.type === _customDefineType.FORM_TYPE.SIGN_DOCUMENT;
      });
    },
    listSignDocumentField: function listSignDocumentField() {
      var _this21 = this;

      return this.listAllSignDocumentField.filter(function (field) {
        return _this21.isItemShow(_this21.applicationData, field, _this21.listFields);
      });
    },
    listAllEvaluationField: function listAllEvaluationField() {
      return this.listFields.filter(function (field) {
        return field.type === _customDefineType.FORM_TYPE.EVALUATION;
      });
    },
    listEvaluationField: function listEvaluationField() {
      var _this22 = this;

      return this.listAllEvaluationField.filter(function (field) {
        return _this22.isItemShow(_this22.applicationData, field, _this22.listFields);
      });
    },
    returningApplicantBtnField: function returningApplicantBtnField() {
      var _this23 = this;

      return this.listFields.find(function (field) {
        return field.type === _customDefineType.FORM_TYPE.RETURNING_APPLICANT_BTN && _this23.isItemShow(_this23.applicationData, field, _this23.listFields);
      });
    },
    type: function type() {
      return this.profile.user_type;
    },
    isShowSubmitButton: function isShowSubmitButton() {
      if (this.isBookingOnly) {
        if (!this.registeredUserId) {
          return false;
        }
        return true;
      }
      if (!this.hasPlaceholderEmailInfo) {
        return false;
      }
      if (!this.profile.is_multi_steps_form) {
        return true;
      }
      return this.currentStep === this.numberOfStep;
    },
    isShowPreviousButton: function isShowPreviousButton() {
      if (!this.profile.is_multi_steps_form) {
        return false;
      }
      return this.currentStep !== 1;
    },
    isShowNextButton: function isShowNextButton() {
      if (!this.profile.is_multi_steps_form) {
        return false;
      }
      return this.currentStep !== this.numberOfStep;
    },
    listLocations: function listLocations() {
      if (this.builderLocations && this.builderLocations.length > 0) {
        return this.builderLocations;
      }
      return this.agencyLocations || [];
    },
    listLanguages: function listLanguages() {
      if (this.builderLanguages && this.builderLanguages.length > 0) {
        return this.builderLanguages;
      }
      if (this.$store.getters.agencyPublic) {
        var languages = this.$store.getters.agencyPublic.listLanguages;
        if (languages && languages.length > 0) {
          return languages;
        }
      }
      return [];
    },
    hasAuthorizePayment: function hasAuthorizePayment() {
      return this.paymentField && this.paymentField.paymentType === _customDefineType.PAYMENT_TYPES.AUTHORIZE;
    },
    hasQuickbooksPayment: function hasQuickbooksPayment() {
      return this.paymentField && this.paymentField.paymentType === _customDefineType.PAYMENT_TYPES.QUICKBOOKS;
    },
    hasStripePayment: function hasStripePayment() {
      return this.paymentField && ![_customDefineType.PAYMENT_TYPES.AUTHORIZE, _customDefineType.PAYMENT_TYPES.QUICKBOOKS].includes(this.paymentField.paymentType);
    },
    apiLoginID: function apiLoginID() {
      if (this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.authorize_net_params) {
        return this.$store.getters.agencyPublic.authorize_net_params.loginID;
      }
      return "";
    },
    clientKey: function clientKey() {
      if (this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.authorize_net_params) {
        return this.$store.getters.agencyPublic.authorize_net_params.clientKey;
      }
      return "";
    },
    listRequiredModelAuthorizePayment: function listRequiredModelAuthorizePayment() {
      var ref = this.$refs.authorizeNetPayment;
      if (!ref) {
        return [];
      }
      var listFields = ref.listFields;
      if (!listFields) {
        return [];
      }
      return listFields.filter(function (field) {
        return field.isRequired;
      }).map(function (field) {
        return field.model;
      });
    },
    listRequiredModelQuickbooksPayment: function listRequiredModelQuickbooksPayment() {
      var ref = this.$refs.quickbooksPayment;
      if (!ref) {
        return [];
      }
      var listFields = ref.listFields;
      if (!listFields) {
        return [];
      }
      return listFields.filter(function (field) {
        return field.isRequired;
      }).map(function (field) {
        return field.model;
      });
    },
    isOneItemPerRow: function isOneItemPerRow() {
      return this.profile && this.profile.additional_information && this.profile.additional_information.one_field_per_row_email;
    },
    chargeClientWhenBooking: function chargeClientWhenBooking() {
      return this.profile && this.profile.additional_information && this.profile.additional_information.charge_client_when_booking;
    },
    includeCandidatePayment: function includeCandidatePayment() {
      return this.profile && this.profile.additional_information && this.profile.additional_information.include_candidate_payment;
    },
    employerTypesNotCharge: function employerTypesNotCharge() {
      return this.profile && this.profile.additional_information && this.profile.additional_information.employer_types_not_charge;
    },
    chargeOn: function chargeOn() {
      if (this.profile && this.profile.additional_information && this.profile.additional_information.charge_on) {
        return this.profile.additional_information.charge_on;
      }
      return "submit_form";
    },
    isTrackApplication: function isTrackApplication() {
      return this.profile && this.profile.additional_information && this.profile.additional_information.is_track_application;
    },
    applicationAbandonStatus: function applicationAbandonStatus() {
      if (this.profile && this.profile.additional_information && this.profile.additional_information.application_abandon_status) {
        return this.profile.additional_information.application_abandon_status;
      }
      return "Application Started";
    },
    secondStatusChangeTo: function secondStatusChangeTo() {
      if (this.profile && this.profile.additional_information && this.profile.additional_information.second_status_change) {
        return this.profile.additional_information.second_status_change;
      }
      return null;
    },
    customizeLogo: function customizeLogo() {
      var _this24 = this;

      return this.tryGet(function () {
        return _this24.convertToAbsolutePath(_this24.profile.additional_information.customize_logo);
      });
    },
    hideDuplicatedEmailWarning: function hideDuplicatedEmailWarning() {
      var _this25 = this;

      return this.tryGet(function () {
        return _this25.profile.additional_information.hide_duplicate_email_warning;
      });
    },
    hideDuplicatedPhoneWarning: function hideDuplicatedPhoneWarning() {
      var _this26 = this;

      return this.tryGet(function () {
        return _this26.profile.additional_information.hide_duplicate_phone_warning;
      });
    }
  }),
  watch: {
    agencyPublic: {
      handler: function handler(val) {
        if (!val) {
          return;
        }
        this.setPredefinedOptionList();
      },

      immediate: true
    },
    language: {
      handler: function handler(val) {
        this.$store.dispatch("setLanguage", val);
      },

      immediate: true
    },
    hideAllMenuItems: {
      handler: function handler(val) {
        if (!this.isAgent) {
          this.setHideMenuBar(val);
        }
      },

      immediate: true
    },
    locations: {
      handler: function handler(val) {
        var _this27 = this;

        // Check if filler is no longer matched because of changing locations
        if (!this.onlyShowMatchedLocations) {
          return;
        }
        if (!this.listBookingJobs) {
          return;
        }
        var listAssignedBookings = this.listBookingJobs.filter(function (booking) {
          return booking.filler;
        });
        if (!listAssignedBookings.length) {
          return;
        }
        var listCandidates = this.candidateListMainInfo || this.publicCandidateList;
        if (this.applicationData.locations && this.applicationData.locations.length) {
          // Check if locations of filler is not matched with locations of poster => clear filler
          listCandidates = listCandidates.filter(function (candidate) {
            return _this27.hasCommonElement(candidate.locations, _this27.applicationData.locations);
          });
          var listCandidateIds = listCandidates.map(function (candidate) {
            return candidate.id;
          });
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = listAssignedBookings[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var booking = _step10.value;

              if (!listCandidateIds.includes(booking.filler)) {
                delete booking.filler;
                delete booking.filled;
                delete booking.filler_name;
                delete booking.filled_date;
              }
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }
        }
      },

      immediate: true
    }
  },
  created: function created() {
    var _this28 = this;

    var savedData, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _step11$value, _key, value, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _key2;

    return regeneratorRuntime.async(function created$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!this.$route.query) {
              _context3.next = 62;
              break;
            }

            if (isNaN(this.$route.query.step)) {
              _context3.next = 29;
              break;
            }

            // Reload saved data to set initial value for all data
            // In case user click Next, Previous, router changes, page is reload, we need to restore data
            this.currentStep = Number(this.$route.query.step);
            savedData = this.$store.getters.applicationStateData;

            if (!(savedData && Object.keys(savedData).length)) {
              _context3.next = 28;
              break;
            }

            _iteratorNormalCompletion11 = true;
            _didIteratorError11 = false;
            _iteratorError11 = undefined;
            _context3.prev = 8;

            for (_iterator11 = Object.entries(savedData)[Symbol.iterator](); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              _step11$value = _slicedToArray(_step11.value, 2), _key = _step11$value[0], value = _step11$value[1];

              this[_key] = value;
            }
            _context3.next = 16;
            break;

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](8);
            _didIteratorError11 = true;
            _iteratorError11 = _context3.t0;

          case 16:
            _context3.prev = 16;
            _context3.prev = 17;

            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }

          case 19:
            _context3.prev = 19;

            if (!_didIteratorError11) {
              _context3.next = 22;
              break;
            }

            throw _iteratorError11;

          case 22:
            return _context3.finish(19);

          case 23:
            return _context3.finish(16);

          case 24:
            this.$nextTick(function () {
              if (_this28.currentStep > 1 && _this28.currentStep < _this28.numberOfStep) {
                var listVisibleFields = _this28.listDisplayFields.filter(function (field) {
                  return _this28.isItemShow(_this28.applicationData, field, _this28.listFields);
                });
                if (!listVisibleFields.length) {
                  // There is no field in current step => jump to next steps or previous steps
                  if (_this28.isClickPrevious) {
                    _this28.currentStep = _this28.currentStep - 1;
                  } else {
                    _this28.currentStep = _this28.currentStep + 1;
                  }
                  _this28.$store.dispatch("setApplicationStateData", _this28.$data);
                  _this28.$router.replace({
                    name: "Application Form Builder",
                    query: {
                      step: _this28.currentStep
                    }
                  });
                  return;
                }
              }
              setTimeout(function () {
                if (_this28.$refs.stepInfo) {
                  if (_this28.isEmbed) {
                    try {
                      // ScrollIntoView does not work on iframe in Safari
                      window.parent.postMessage(_this28.$refs.stepInfo.getBoundingClientRect().top, "*");
                    } catch (e) {}
                  } else {
                    _this28.$refs.stepInfo.scrollIntoView({
                      block: "start",
                      behavior: "smooth"
                    });
                  }
                }
                if (_this28.isTrackApplication) {
                  // Get number of messages
                  _this28.intervalSubmitFunc = setInterval(function _callee() {
                    return regeneratorRuntime.async(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this28.submitTrackingApplicationData();

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, null, _this28);
                  }, 60000);
                }
              }, 50);
            });

            return _context3.abrupt("return");

          case 28:
            // Redirect to first page
            if (this.currentStep && this.currentStep !== 1) {
              this.$router.replace({
                name: "Application Form Builder"
              });
            }

          case 29:
            // Init application data via URL
            _iteratorNormalCompletion12 = true;
            _didIteratorError12 = false;
            _iteratorError12 = undefined;
            _context3.prev = 32;
            _iterator12 = Object.keys(this.$route.query)[Symbol.iterator]();

          case 34:
            if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
              _context3.next = 47;
              break;
            }

            _key2 = _step12.value;

            if (!["step", "user", "hashId"].includes(_key2)) {
              _context3.next = 38;
              break;
            }

            return _context3.abrupt("continue", 44);

          case 38:
            value = this.$route.query[_key2];

            if (!(_key2 === "referral_code")) {
              _context3.next = 42;
              break;
            }

            this.applicationData.referal_id = value;
            return _context3.abrupt("continue", 44);

          case 42:
            // In case of array in URL
            try {
              value = JSON.parse(decodeURIComponent(value));
            } catch (e) {}
            if (!this.applicationData[_key2]) {
              this.applicationData[_key2] = value;
              if (_key2.indexOf("multiselect") === 0 || ["types"].includes(_key2)) {
                if (!Array.isArray(value)) {
                  this.applicationData[_key2] = [value];
                }
              }
            }

          case 44:
            _iteratorNormalCompletion12 = true;
            _context3.next = 34;
            break;

          case 47:
            _context3.next = 53;
            break;

          case 49:
            _context3.prev = 49;
            _context3.t1 = _context3["catch"](32);
            _didIteratorError12 = true;
            _iteratorError12 = _context3.t1;

          case 53:
            _context3.prev = 53;
            _context3.prev = 54;

            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }

          case 56:
            _context3.prev = 56;

            if (!_didIteratorError12) {
              _context3.next = 59;
              break;
            }

            throw _iteratorError12;

          case 59:
            return _context3.finish(56);

          case 60:
            return _context3.finish(53);

          case 61:
            this.applicationData = _extends({}, this.applicationData);

          case 62:
            console.log(this.$data);
            this.$store.dispatch("setAgencyID", this.agencyID);
            _context3.next = 66;
            return regeneratorRuntime.awrap(this.loadProfileBuilderFields());

          case 66:
            if (!(this.userID && !this.isAgent)) {
              _context3.next = 70;
              break;
            }

            _context3.next = 69;
            return regeneratorRuntime.awrap(this.loadPreApplication(this.userID));

          case 69:
            this.initialLoggedInUser = _context3.sent;

          case 70:

            // Load pre application
            if (this.$route.query) {
              if (this.$route.query.user || this.$route.query.hashId) {
                this.loadPreApplication(this.$route.query.user, this.$route.query.hashId);
              }
            }

            if (this.isBookingOnly) {
              this.handleClickReturningApplicantBtn();
            }

            // Sets the jobViewID of the current job view object
            this.jobViewID = this.$route.query.jobViewID;
            console.log("Job View ID: " + this.jobViewID);
            if (this.isTrackApplication) {
              // Get number of messages
              this.intervalSubmitFunc = setInterval(function _callee2() {
                return regeneratorRuntime.async(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _this28.submitTrackingApplicationData();

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, null, _this28);
              }, 60000);
            }

          case 75:
          case "end":
            return _context3.stop();
        }
      }
    }, null, this, [[8, 12, 16, 24], [17,, 19, 23], [32, 49, 53, 61], [54,, 56, 60]]);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.intervalSubmitFunc) {
      clearInterval(this.intervalSubmitFunc);
    }
    this.setHideMenuBar(false);
  },

  methods: _extends({}, (0, _vuex.mapActions)(["setHideMenuBar", "setCandidateBuilderList", "setClientBuilderList", "reloadProfileBuilderList"]), {
    getDuplicatedEmailWarning: function getDuplicatedEmailWarning(email) {
      var _this29 = this;

      return this.getSubmissionDialogContent(this.tryGet(function () {
        return _this29.profile.additional_information.duplicated_email_warning.replace("[[returning-application-button]]", "<a class=\"button-link\" id=\"returning-application-button\">here</a>").replace("[[email]]", email);
      }), { key: "APPLICATION_FORM_DUPLICATED_EMAIL", params: [email] });
    },
    getDuplicatedPhoneWarning: function getDuplicatedPhoneWarning(phone) {
      var _this30 = this;

      return this.getSubmissionDialogContent(this.tryGet(function () {
        return _this30.profile.additional_information.duplicated_phone_warning.replace("[[returning-application-button]]", "<a class=\"button-link\" id=\"returning-application-button\">here</a>").replace("[[phone]]", phone);
      }), { key: "APPLICATION_FORM_DUPLICATED_PHONE", params: [phone] });
    },
    setPredefinedOptionList: function setPredefinedOptionList() {
      var _this31 = this;

      if (!this.profile || !this.profile.list_fields) {
        return;
      }
      this.profile.list_fields.forEach(function (field) {
        if (!field.optionList || !field.optionList.length) {
          if (field.model === "types") {
            field.optionList = _this31.type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE ? _this31.candidateTypes : _this31.employerTypes;
          }
          if (field.model === "tags") {
            field.optionList = _this31.type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE ? _this31.candidateTags : _this31.employerTags;
          }
          if (field.model === "status") {
            field.optionList = _this31.type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE ? _this31.candidateStatuses : _this31.employerStatuses;
          }
          if (field.model === "locations") {
            field.optionList = _this31.agencyLocations;
          }
        }
      });
    },
    isValidPreApplicationUser: function isValidPreApplicationUser(user) {
      // Validate agency id
      if (this.agencyID !== user.agency_id) {
        this.showErrorDialog("APPLICATION_FORM_USER_INCORRECT_USER_ID");
        return false;
      }

      // Validate user type (client/candidate)
      var is_candidate = this.type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
      var is_employer = this.type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
      if (is_candidate && !user.is_candidate) {
        this.showErrorDialog("APPLICATION_FORM_USER_INCORRECT_USER_ID");
        return false;
      }
      if (is_employer && !user.is_employer) {
        this.showErrorDialog("APPLICATION_FORM_USER_INCORRECT_USER_ID");
        return false;
      }
      if (this.isBookingOnly) {
        return true;
      }

      // Validate user status
      var allowStatuses = this.getListAllowReturningApplicantStatuses(this.profile);
      if (!allowStatuses.includes("All")) {
        if (!allowStatuses.includes(user.status)) {
          this.showErrorDialog("APPLICATION_FORM_USER_SUBMITTED");
          return false;
        }
      }
      return true;
    },
    loadProfileBuilderFields: function loadProfileBuilderFields() {
      var _this32 = this;

      var listBuilder, builder, listStepIndices, listDialogFields, listFileInfoFields, listCheckboxConditionFields, listShareModelFields, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, field, res;

      return regeneratorRuntime.async(function loadProfileBuilderFields$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return regeneratorRuntime.awrap(this.getListProfileBuilder());

            case 2:
              listBuilder = _context4.sent;

              if (!(listBuilder == null)) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return");

            case 5:
              // Find the builder by profileID
              this.profile = listBuilder.find(function (builder) {
                return builder.id === _this32.profileID;
              });

              if (!(this.profile == null)) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return");

            case 8:

              // Merge list field of section builder into application builder
              builder = this.mergeBuilders(this.profile, listBuilder);

              this.builderLocations = builder.locations;
              this.builderLanguages = builder.languages;
              if (this.profile.is_multi_steps_form) {
                listStepIndices = builder.listFields.map(function (field) {
                  return field.stepIndex;
                });

                console.log(listStepIndices);
                this.numberOfStep = Math.max.apply(Math, _toConsumableArray(listStepIndices));
              }
              this.profile.list_fields = builder.listFields;
              this.listRejectConditions = builder.listRejectConditions;
              this.listTypeConditions = builder.listTypeConditions;
              this.listTagConditions = builder.listTagConditions;
              this.listChecklistConditions = builder.listChecklistConditions;
              this.listBadgeConditions = builder.listBadgeConditions;
              this.listStatusConditions = builder.listStatusConditions;
              this.listSecondStatusConditions = builder.listSecondStatusConditions;
              this.listKeapTagConditions = builder.listKeapTagConditions;
              this.listLocationConditions = builder.listLocationConditions;
              this.listManagerConditions = builder.listManagerConditions;
              this.listSecondManagerConditions = builder.listSecondManagerConditions;
              this.listMembershipConditions = builder.listMembershipConditions;
              this.listErrorConditions = builder.listErrorConditions;
              this.listModelsAdminOnly = builder.listModelsAdminOnly;
              this.listModelsAdminClient = builder.listModelsAdminClient;

              this.profile.list_fields.forEach(function (field) {
                if (field.optionList && typeof field.optionList === "string") {
                  var options = field.optionList.split("\n").map(function (option) {
                    return option.trim();
                  }).filter(function (option) {
                    return option.length > 0;
                  });
                  field.optionList = options;
                }
                // Add email validation
                if (field.model && ["email", "email2"].includes(field.model)) {
                  field.validation = [{
                    regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
                    message: "Please enter a valid email."
                  }];
                }
              });

              this.setPredefinedOptionList();

              // Init mapDependentObjects
              listDialogFields = this.profile.list_fields.filter(function (field) {
                return [_customDefineType.FORM_TYPE.SLOT, _customDefineType.FORM_TYPE.SECTION, _customDefineType.FORM_TYPE.BOOKING_SECTION].includes(field.type) && field.name !== _fieldTypes.MAP_DIALOG_SECTION.People.name;
              });

              listDialogFields.forEach(function (field) {
                if (!_this32.mapDependentObjects[field.label]) {
                  _this32.mapDependentObjects[field.label] = [];
                }
                _this32.mapDependentLabelName[field.label] = field.name;
                var apiKey = _this32.tryGet(function () {
                  return _fieldTypes.MAP_DIALOG_SECTION[field.name].apiKey;
                });
                if (apiKey) {
                  var count = _this32.mapSectionAPICount[apiKey] || 0;
                  _this32.mapSectionAPICount[apiKey] = count + 1;
                }
              });
              this.saveMapDependentObjects();

              // Init map file info
              listFileInfoFields = this.profile.list_fields.filter(function (field) {
                return field.type === _customDefineType.FORM_TYPE.FILE_WITH_INFO;
              });


              listFileInfoFields.forEach(function (field) {
                _this32.mapFileInfo[field.label] = [];
              });
              this.mapFileInfo = Object.assign({}, this.mapFileInfo);
              this.saveMapFileInfo();

              // Init map checkbox condition with all value is false
              listCheckboxConditionFields = this.profile.list_fields.filter(function (field) {
                return field.type === _customDefineType.FORM_TYPE.CHECKBOX_CONDITION;
              });

              listCheckboxConditionFields.forEach(function (field) {
                var optionList = _this32.convertStringToArray(field.optionList);
                for (var index = 0; index < optionList.length; index++) {
                  _this32.mapCheckboxCondition[field.label + index] = false;
                  if (_this32.profile.is_multi_steps_form) {
                    _this32.mapCheckboxConditionStep[field.label + index] = field.stepIndex;
                  }
                }
              });
              // Init value for share model and list text fields
              listShareModelFields = this.profile.list_fields.filter(function (field) {
                return field.isShareModel || field.type === _customDefineType.FORM_TYPE.LIST_TEXTBOX;
              });

              listShareModelFields.forEach(function (field) {
                if (_this32.applicationData[field.model] == null) {
                  _this32.applicationData[field.model] = [];
                }
                _this32.applicationData[field.model][field.shareModelIndex] = "";
              });
              // Initial locations value
              if (this.applicationData.locations == null) {
                this.applicationData.locations = [];
              }

              // Get documenttemplates
              _iteratorNormalCompletion13 = true;
              _didIteratorError13 = false;
              _iteratorError13 = undefined;
              _context4.prev = 45;
              _iterator13 = this.listAllSignDocumentField[Symbol.iterator]();

            case 47:
              if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                _context4.next = 57;
                break;
              }

              field = _step13.value;

              if (!field.documentTemplateId) {
                _context4.next = 54;
                break;
              }

              _context4.next = 52;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/documenttemplates/?id=" + field.documentTemplateId));

            case 52:
              res = _context4.sent;

              if (res && res.data && res.data.length > 0) {
                this.mapDocumentTemplates[this.getKeySigningField(field)] = res.data[0];
              }

            case 54:
              _iteratorNormalCompletion13 = true;
              _context4.next = 47;
              break;

            case 57:
              _context4.next = 63;
              break;

            case 59:
              _context4.prev = 59;
              _context4.t0 = _context4["catch"](45);
              _didIteratorError13 = true;
              _iteratorError13 = _context4.t0;

            case 63:
              _context4.prev = 63;
              _context4.prev = 64;

              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }

            case 66:
              _context4.prev = 66;

              if (!_didIteratorError13) {
                _context4.next = 69;
                break;
              }

              throw _iteratorError13;

            case 69:
              return _context4.finish(66);

            case 70:
              return _context4.finish(63);

            case 71:
              this.mapDocumentTemplates = Object.assign({}, this.mapDocumentTemplates);
              // If there is only 1 language in the list, set it as selected language
              if (this.listLanguages && this.listLanguages.length === 1) {
                this.applicationData.language = this.listLanguages[0];
              }

            case 73:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this, [[45, 59, 63, 71], [64,, 66, 70]]);
    },
    saveMapDependentObjects: function saveMapDependentObjects() {
      this.mapSavedDependentObjects = {};
      try {
        this.mapSavedDependentObjects = JSON.parse(JSON.stringify(this.mapDependentObjects));
      } catch (_) {}
    },
    saveMapFileInfo: function saveMapFileInfo() {
      this.mapSavedFileInfo = {};
      try {
        this.mapSavedFileInfo = JSON.parse(JSON.stringify(this.mapFileInfo));
      } catch (_) {}
    },
    saveListEvaluations: function saveListEvaluations() {
      this.listSavedEvaluations = [];
      try {
        this.listSavedEvaluations = JSON.parse(JSON.stringify(this.listEvaluation));
      } catch (_) {}
    },
    saveListDocuments: function saveListDocuments(listDocs) {
      this.listSavedDocuments = [];
      try {
        this.listSavedDocuments = JSON.parse(JSON.stringify(listDocs));
      } catch (_) {}
    },
    getKeySigningField: function getKeySigningField(field) {
      return field.label + field.documentTemplateId;
    },
    getAdditionalInfo: function getAdditionalInfo(key, defaultValue) {
      if (this.profile.additional_information && this.profile.additional_information[key]) {
        return this.profile.additional_information[key];
      }
      return defaultValue;
    },
    getApplicationProperty: function getApplicationProperty(propertyName) {
      if (this.$store.getters.language && this.profile.additional_information) {
        var value = this.profile.additional_information[propertyName + "_lang_" + this.$store.getters.language];
        if (value) {
          return value;
        }
      }
      return this.profile[propertyName];
    },
    getFieldProperty: function getFieldProperty(item, key) {
      var language = this.$store.getters.language;
      if (!language) {
        return item[key];
      }
      if (item[key + "_lang_" + language]) {
        return item[key + "_lang_" + language];
      }
      return item[key];
    },
    onChangeCheckboxCondition: function onChangeCheckboxCondition() {
      var _this33 = this;

      this.$nextTick(function () {
        _this33.mapCheckboxCondition = JSON.parse(JSON.stringify(_this33.mapCheckboxCondition));
      });
    },
    handleSignDocument: function handleSignDocument(signField, data) {
      this.mapSignatures[signField.label] = data;
    },
    getListProfileBuilder: function getListProfileBuilder() {
      var _this34 = this;

      return regeneratorRuntime.async(function getListProfileBuilder$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", new Promise(function _callee3(resolve, reject) {
                var res;
                return regeneratorRuntime.async(function _callee3$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/get-application-profile-sections/?application_id=" + _this34.profileID));

                      case 2:
                        res = _context5.sent;

                        if (res) {
                          if (_this34.type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE) {
                            _this34.setCandidateBuilderList(res.data);
                          } else {
                            _this34.setClientBuilderList(res.data);
                          }
                          resolve(res.data);
                        } else {
                          reject();
                        }

                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, null, _this34);
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    },
    checkInvalidFields: function checkInvalidFields() {
      var errorInfo = this.hasInvalidField(this.applicationData, this.listFields);
      if (errorInfo) {
        console.log("Invalid field");
        return errorInfo;
      }
      // Check if credit package selection field is required
      if (this.creditPackageSelectionField && this.creditPackageSelectionField.isRequired) {
        if (!this.applicationData.credit_package) {
          console.log("Credit package require");
          return {
            field: this.creditPackageSelectionField,
            type: "Required Field"
          };
        }
      }
      if (this.stripeSubscriptionSelectionField && this.stripeSubscriptionSelectionField.isRequired) {
        if (!this.stripeSubscriptionSelected || !this.stripeSubscriptionSelected.planId) {
          return {
            field: this.stripeSubscriptionSelectionField,
            type: "Required Field"
          };
        }
      }
      // Check checkbox condition is uncheck
      if (Object.values(this.mapCheckboxCondition).includes(false)) {
        // Check if the field is showed
        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;

        try {
          for (var _iterator14 = this.listCheckboxConditionFields[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var checkboxConditionField = _step14.value;

            // Field is not showed
            if (!this.isItemShow(this.applicationData, checkboxConditionField, this.listFields)) {
              continue;
            }
            var optionList = this.convertStringToArray(checkboxConditionField.optionList);
            // Check if there is any unchecked option
            for (var index = 0; index < optionList.length; index++) {
              if (this.mapCheckboxCondition[checkboxConditionField.label + index] === false) {
                console.log("Checkbox condition unchecked", checkboxConditionField.label + index);
                return {
                  field: checkboxConditionField,
                  type: "Required Field"
                };
                return true;
              }
            }
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }
      }
      return this.checkInvalidPaymentField();
    },
    checkInvalidPaymentField: function checkInvalidPaymentField() {
      // Check payment input
      if (this.paymentField) {
        // Check if payment information is invalid
        if (this.hasAuthorizePayment) {
          if (this.paymentField.isRequired) {
            if (!this.authorizePaymentInfo) {
              console.log("Invalid authorize.net payment info");
              return {
                message: "Authorize.net payment information required"
              };
            }
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = this.listRequiredModelAuthorizePayment[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var model = _step15.value;

                if (!this.authorizePaymentInfo[model]) {
                  console.log("Required " + model + " in authorize.net payment information");
                  return {
                    message: "Required " + this.convertUnderscoreToLabel(model) + " in authorize.net payment information"
                  };
                }
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }
          }
        } else if (this.hasQuickbooksPayment) {
          if (this.paymentField.isRequired) {
            if (!this.quickbooksPaymentInfo) {
              console.log("Quickbooks payment info");
              return {
                message: "Required quickbooks payment information"
              };
            }
            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
              for (var _iterator16 = this.listRequiredModelQuickbooksPayment[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                var _model = _step16.value;

                if (!this.quickbooksPaymentInfo[_model]) {
                  console.log("Invalid Quickbooks payment info", _model);
                  return {
                    message: "Required " + this.convertUnderscoreToLabel(_model) + " in Quickbooks payment information"
                  };
                }
              }
            } catch (err) {
              _didIteratorError16 = true;
              _iteratorError16 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }
              } finally {
                if (_didIteratorError16) {
                  throw _iteratorError16;
                }
              }
            }
          }
        } else {
          // Default is Stripe
          var invalidPaymentEl = document.getElementById(_customDefineType.STRIPE_PAYMENT_ERROR_IDS.INVALID);
          if (invalidPaymentEl) {
            console.log("Invalid stripe payment info");
            return {
              message: "Invalid stripe payment information"
            };
            return true;
          }
          // Check if payment information is empty
          if (this.paymentField.isRequired) {
            var emptyPaymentEl = document.getElementById(_customDefineType.STRIPE_PAYMENT_ERROR_IDS.EMPTY);
            if (emptyPaymentEl) {
              return {
                message: "Stripe payment information require"
              };
              console.log("Empty stripe payment info");
              return true;
            }
          }
        }
      }
      return false;
    },
    checkMissingDependencyObject: function checkMissingDependencyObject() {
      var _this35 = this;

      // Get dialogsection corresponding with current step
      var listDialogSections = this.listDialogSections;
      if (this.profile.is_multi_steps_form) {
        listDialogSections = listDialogSections.filter(function (dialogSection) {
          return dialogSection.stepIndex === _this35.currentStep;
        });
      }

      // Check to find any missing dependency object
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = listDialogSections[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var dialogSection = _step17.value;

          if (dialogSection.name === "Booking") {
            continue;
          }
          if (this.getMinCount(dialogSection)) {
            if (this.mapDependentObjects[dialogSection.label] == null) {
              this.showMissingDependencyError(dialogSection);
              return true;
            }
            if (this.mapDependentObjects[dialogSection.label].length < dialogSection.minCount) {
              this.showMissingDependencyError(dialogSection);
              return true;
            }
          }
          // Validate required field if not using modals to input reference,...
          if (!this.useModalInApplicationForm && this.mapDependentObjects[dialogSection.label]) {
            var _ret2 = function () {
              var listFields = dialogSection.list_fields;
              var listExcludeModels = [].concat(_toConsumableArray(dialogSection.listModelsAdminOnly), _toConsumableArray(dialogSection.listModelsAdminClient));
              listFields = listFields.filter(function (field) {
                return !listExcludeModels.includes(field.model);
              });
              // Check all fields are filled
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = _this35.mapDependentObjects[dialogSection.label][Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var sectionContent = _step18.value;

                  var errorInfo = _this35.hasInvalidField(sectionContent, listFields, _this35.$store.getters.isAgent);
                  if (errorInfo) {
                    _this35.showErrorDialog({
                      key: "INVALID_INPUT_ERROR",
                      params: [_this35.getErrorMessage(errorInfo)]
                    });
                    console.log("Invalid field Agent only", sectionContent);
                    return {
                      v: true
                    };
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }();

            if ((typeof _ret2 === "undefined" ? "undefined" : _typeof(_ret2)) === "object") return _ret2.v;
          }
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      return false;
    },
    checkMissingJobBookingObject: function checkMissingJobBookingObject() {
      // Find builder for job booking
      var bookingBuilder = this.listDialogSections.find(function (dialogSection) {
        return dialogSection.name === "Booking";
      });
      if (bookingBuilder == null) {
        return false;
      }
      // Validate if bookingBuilder corresponding with current step (in case of multi-steps form)
      if (this.profile.is_multi_steps_form) {
        if (bookingBuilder.stepIndex !== this.currentStep) {
          return false;
        }
      }
      // Min count is not defined
      if (!this.getMinCount(bookingBuilder)) {
        return false;
      }
      if (this.listBookingJobs.length < bookingBuilder.minCount) {
        this.showMissingDependencyError(bookingBuilder);
        return true;
      }
      return false;
    },
    showMissingDependencyError: function showMissingDependencyError(builder) {
      var content = this.tryGet(function () {
        return builder.additionalInformation.missing_required_items_error;
      });
      if (content && content.length > 10) {
        this.showErrorDialog({
          innerHtml: content
        });
        return;
      }
      var label = builder.label;
      if (builder.minCount == 1) {
        label = this.convertToSingularForm(builder.label);
      }
      this.showErrorDialog({
        key: 'MISSING_DEPENDENCY_OBJECT_ERROR',
        params: [label, builder.minCount]
      });
    },
    checkMissingSignDocument: function checkMissingSignDocument() {
      var _this36 = this;

      var listSignDocumentField = this.listSignDocumentField;
      // Get field which corresponding with current step
      if (this.profile.is_multi_steps_form) {
        listSignDocumentField = listSignDocumentField.filter(function (field) {
          return field.stepIndex === _this36.currentStep;
        });
      }
      // Check no sign field
      if (listSignDocumentField.length === 0) {
        return false;
      }
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = listSignDocumentField[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var signField = _step19.value;

          var signatures = this.mapSignatures[signField.label];
          if (signatures == null) {
            this.showErrorDialog(this.$store.getters.missingSignatureError);
            return true;
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      return false;
    },
    checkMissingEvaluation: function checkMissingEvaluation() {
      var _this37 = this;

      var listEvaluationField = this.listEvaluationField;
      // Get field which corresponding with current step
      if (this.profile.is_multi_steps_form) {
        listEvaluationField = listEvaluationField.filter(function (field) {
          return field.stepIndex === _this37.currentStep;
        });
      }
      // Check no sign field
      if (listEvaluationField.length === 0) {
        return false;
      }
      if (!this.listEvaluation) {
        this.showErrorDialog("MISSING_EVALUATION_ERROR");
        return true;
      }
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        var _loop2 = function _loop2() {
          var evaluationField = _step20.value;

          var evaluation = _this37.listEvaluation.find(function (evaluation) {
            return evaluation.template_id === evaluationField.evaluationTemplateId;
          });
          if (evaluation == null) {
            _this37.showErrorDialog("MISSING_EVALUATION_ERROR");
            return {
              v: true
            };
          }
        };

        for (var _iterator20 = listEvaluationField[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var _ret3 = _loop2();

          if ((typeof _ret3 === "undefined" ? "undefined" : _typeof(_ret3)) === "object") return _ret3.v;
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      return false;
    },
    checkMissingFileWithInfo: function checkMissingFileWithInfo() {
      var _this38 = this;

      // Get file with info field which corresponding with current step
      var listFileInfoFields = this.listFileInfoFields;
      if (this.profile.is_multi_steps_form) {
        listFileInfoFields = listFileInfoFields.filter(function (field) {
          return field.stepIndex === _this38.currentStep;
        });
      }
      // Check no file with info field
      if (listFileInfoFields.length === 0) {
        return false;
      }
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = listFileInfoFields[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var fileInfoField = _step21.value;

          if (!this.isItemShow(this.applicationData, fileInfoField, this.listFields)) {
            continue;
          }
          var fileInfo = this.mapFileInfo[fileInfoField.label];
          // Validate required file is uploaded
          if (fileInfoField.isRequired) {
            if (!(fileInfo && fileInfo.length && fileInfo[0] && fileInfo[0].url)) {
              this.showErrorDialog({
                key: "INVALID_INPUT_ERROR",
                params: ["Field Require: " + fileInfoField.label]
              });
              console.log("Require file with info", fileInfoField);
              return true;
            }
          }
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      return false;
    },
    handleClickPreviousButton: function handleClickPreviousButton() {
      this.currentStep = this.currentStep - 1;
      this.isClickPrevious = true;
      this.$store.dispatch("setApplicationStateData", this.$data);
      this.$router.replace({
        name: "Application Form Builder",
        query: {
          step: this.currentStep
        }
      });
    },

    // Check if all options of checkboxes are checked
    isAllCheckboxOptionsChecked: function isAllCheckboxOptionsChecked(field) {
      if (!this.applicationData[field.model]) {
        // No option is checked
        console.log("false");
        console.log(field.model);
        console.log(this.applicationData);
        return false;
      }
      var optionList = this.normalizedArrayValue(field.optionList);
      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = optionList[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var option = _step22.value;

          if (!this.applicationData[field.model].includes(option)) {
            console.log(option);
            // Option is unchecked
            return false;
          }
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      return true;
    },
    handleClickNextButton: function handleClickNextButton() {
      var listPreconditionCheckboxFields, _iteratorNormalCompletion23, _didIteratorError23, _iteratorError23, _iterator23, _step23, preconditionCheckboxField, _iteratorNormalCompletion24, _didIteratorError24, _iteratorError24, _iterator24, _step24, _key3, step, errorInfo, _errorInfo, isSetPaymentMethod, res;

      return regeneratorRuntime.async(function handleClickNextButton$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              // Check precondition checkboxes are checked
              listPreconditionCheckboxFields = this.listDisplayFields.filter(function (field) {
                return field.isPreconditionCheck && [_customDefineType.FORM_TYPE.CHECKBOX].includes(field.type);
              });

              if (!listPreconditionCheckboxFields.length) {
                _context7.next = 29;
                break;
              }

              _iteratorNormalCompletion23 = true;
              _didIteratorError23 = false;
              _iteratorError23 = undefined;
              _context7.prev = 5;
              _iterator23 = listPreconditionCheckboxFields[Symbol.iterator]();

            case 7:
              if (_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done) {
                _context7.next = 15;
                break;
              }

              preconditionCheckboxField = _step23.value;

              if (this.isAllCheckboxOptionsChecked(preconditionCheckboxField)) {
                _context7.next = 12;
                break;
              }

              // Show rejection message
              this.showErrorDialog({
                innerHtml: preconditionCheckboxField.rejectionMessage
              });
              return _context7.abrupt("return");

            case 12:
              _iteratorNormalCompletion23 = true;
              _context7.next = 7;
              break;

            case 15:
              _context7.next = 21;
              break;

            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7["catch"](5);
              _didIteratorError23 = true;
              _iteratorError23 = _context7.t0;

            case 21:
              _context7.prev = 21;
              _context7.prev = 22;

              if (!_iteratorNormalCompletion23 && _iterator23.return) {
                _iterator23.return();
              }

            case 24:
              _context7.prev = 24;

              if (!_didIteratorError23) {
                _context7.next = 27;
                break;
              }

              throw _iteratorError23;

            case 27:
              return _context7.finish(24);

            case 28:
              return _context7.finish(21);

            case 29:
              this.submitClicked = true;
              // Check missing checkbox condition
              _iteratorNormalCompletion24 = true;
              _didIteratorError24 = false;
              _iteratorError24 = undefined;
              _context7.prev = 33;
              _iterator24 = Object.keys(this.mapCheckboxConditionStep)[Symbol.iterator]();

            case 35:
              if (_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done) {
                _context7.next = 46;
                break;
              }

              _key3 = _step24.value;
              step = this.mapCheckboxConditionStep[_key3];

              if (!(step !== this.currentStep)) {
                _context7.next = 40;
                break;
              }

              return _context7.abrupt("continue", 43);

            case 40:
              if (!(this.mapCheckboxCondition[_key3] === false)) {
                _context7.next = 43;
                break;
              }

              this.showErrorDialog({
                key: "INVALID_INPUT_ERROR",
                params: ["Field Require: " + _key3]
              });
              return _context7.abrupt("return");

            case 43:
              _iteratorNormalCompletion24 = true;
              _context7.next = 35;
              break;

            case 46:
              _context7.next = 52;
              break;

            case 48:
              _context7.prev = 48;
              _context7.t1 = _context7["catch"](33);
              _didIteratorError24 = true;
              _iteratorError24 = _context7.t1;

            case 52:
              _context7.prev = 52;
              _context7.prev = 53;

              if (!_iteratorNormalCompletion24 && _iterator24.return) {
                _iterator24.return();
              }

            case 55:
              _context7.prev = 55;

              if (!_didIteratorError24) {
                _context7.next = 58;
                break;
              }

              throw _iteratorError24;

            case 58:
              return _context7.finish(55);

            case 59:
              return _context7.finish(52);

            case 60:
              errorInfo = this.hasInvalidField(this.applicationData, this.listDisplayFields);

              if (!errorInfo) {
                _context7.next = 66;
                break;
              }

              this.showErrorDialog({
                key: "INVALID_INPUT_ERROR",
                params: [this.getErrorMessage(errorInfo)]
              });
              return _context7.abrupt("return");

            case 66:
              if (!this.checkMissingDependencyObject()) {
                _context7.next = 70;
                break;
              }

              return _context7.abrupt("return");

            case 70:
              if (!this.checkMissingJobBookingObject()) {
                _context7.next = 74;
                break;
              }

              return _context7.abrupt("return");

            case 74:
              if (!this.checkMissingSignDocument()) {
                _context7.next = 78;
                break;
              }

              return _context7.abrupt("return");

            case 78:
              if (!this.checkMissingEvaluation()) {
                _context7.next = 82;
                break;
              }

              return _context7.abrupt("return");

            case 82:
              if (!this.checkMissingFileWithInfo()) {
                _context7.next = 84;
                break;
              }

              return _context7.abrupt("return");

            case 84:
              if (!(this.paymentField && this.paymentField.stepIndex === this.currentStep)) {
                _context7.next = 94;
                break;
              }

              _errorInfo = this.checkInvalidPaymentField();

              if (!_errorInfo) {
                _context7.next = 89;
                break;
              }

              this.showErrorDialog({
                key: "INVALID_INPUT_ERROR",
                params: [this.getErrorMessage(_errorInfo)]
              });
              return _context7.abrupt("return");

            case 89:
              _context7.next = 91;
              return regeneratorRuntime.awrap(this.setStripePaymentMethod());

            case 91:
              isSetPaymentMethod = _context7.sent;

              if (isSetPaymentMethod) {
                _context7.next = 94;
                break;
              }

              return _context7.abrupt("return");

            case 94:
              this.setUserType(this.applicationData);
              _context7.next = 97;
              return regeneratorRuntime.awrap(_axios2.default.post("/validate-application-form/", _extends({}, this.applicationData, {
                user_id: this.registeredUserId
              })));

            case 97:
              res = _context7.sent;

              if (!(!res || !res.data)) {
                _context7.next = 100;
                break;
              }

              return _context7.abrupt("return");

            case 100:
              this.submitClicked = false;
              this.currentStep = this.currentStep + 1;
              this.isClickPrevious = false;
              this.$store.dispatch("setApplicationStateData", this.$data);
              this.$router.replace({
                name: "Application Form Builder",
                query: {
                  step: this.currentStep
                }
              });

            case 105:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this, [[5, 17, 21, 29], [22,, 24, 28], [33, 48, 52, 60], [53,, 55, 59]]);
    },
    setStripePaymentMethod: function setStripePaymentMethod() {
      var emptyPaymentEl, isACH, paymentMethodId;
      return regeneratorRuntime.async(function setStripePaymentMethod$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (this.hasStripePayment) {
                _context8.next = 2;
                break;
              }

              return _context8.abrupt("return", true);

            case 2:
              if (this.$refs.stripePayment) {
                _context8.next = 4;
                break;
              }

              return _context8.abrupt("return", true);

            case 4:
              // Create Stripe payment method
              emptyPaymentEl = document.getElementById(_customDefineType.STRIPE_PAYMENT_ERROR_IDS.EMPTY);
              isACH = document.getElementById("ach-description");
              // Check if payment element is not empty

              if (!(isACH || !emptyPaymentEl)) {
                _context8.next = 13;
                break;
              }

              _context8.next = 9;
              return regeneratorRuntime.awrap(this.$refs.stripePayment.createPaymentMethod());

            case 9:
              paymentMethodId = _context8.sent;

              if (paymentMethodId) {
                _context8.next = 12;
                break;
              }

              return _context8.abrupt("return", false);

            case 12:
              this.stripePaymentMethodId = paymentMethodId;

            case 13:
              return _context8.abrupt("return", true);

            case 14:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    },
    submitAuthorizePayment: function submitAuthorizePayment() {
      var _this39 = this;

      return new Promise(function _callee4(resolve) {
        var _iteratorNormalCompletion25, _didIteratorError25, _iteratorError25, _iterator25, _step25, model, authData, cardData, fullName, secureData;

        return regeneratorRuntime.async(function _callee4$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this39.authorizePaymentInfo) {
                  _context9.next = 3;
                  break;
                }

                resolve(true);
                return _context9.abrupt("return");

              case 3:
                _iteratorNormalCompletion25 = true;
                _didIteratorError25 = false;
                _iteratorError25 = undefined;
                _context9.prev = 6;
                _iterator25 = _this39.listRequiredModelAuthorizePayment[Symbol.iterator]();

              case 8:
                if (_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done) {
                  _context9.next = 16;
                  break;
                }

                model = _step25.value;

                if (_this39.authorizePaymentInfo[model]) {
                  _context9.next = 13;
                  break;
                }

                resolve(true);
                return _context9.abrupt("return");

              case 13:
                _iteratorNormalCompletion25 = true;
                _context9.next = 8;
                break;

              case 16:
                _context9.next = 22;
                break;

              case 18:
                _context9.prev = 18;
                _context9.t0 = _context9["catch"](6);
                _didIteratorError25 = true;
                _iteratorError25 = _context9.t0;

              case 22:
                _context9.prev = 22;
                _context9.prev = 23;

                if (!_iteratorNormalCompletion25 && _iterator25.return) {
                  _iterator25.return();
                }

              case 25:
                _context9.prev = 25;

                if (!_didIteratorError25) {
                  _context9.next = 28;
                  break;
                }

                throw _iteratorError25;

              case 28:
                return _context9.finish(25);

              case 29:
                return _context9.finish(22);

              case 30:
                authData = {
                  clientKey: _this39.clientKey,
                  apiLoginID: _this39.apiLoginID
                };
                cardData = _extends({}, _this39.authorizePaymentInfo);
                fullName = "";

                if (cardData.firstName) {
                  fullName = cardData.firstName;
                }
                if (cardData.lastName) {
                  fullName = fullName + " " + cardData.lastName;
                }
                fullName = fullName.trim();
                if (fullName) {
                  cardData.fullName = fullName;
                }
                secureData = {
                  authData: authData,
                  cardData: _this39.authorizePaymentInfo
                };

                Accept.dispatchData(secureData, function (response) {
                  if (response.opaqueData) {
                    _this39.authorizeOpaqueData = response.opaqueData;
                    resolve(true);
                    return;
                  }
                  console.log(response);
                  if (_this39.paymentField.isRequired) {
                    if (response && response.messages && response.messages.message) {
                      _this39.showErrorDialog({
                        key: "INVALID_PAYMENT_INFORMATION",
                        params: [response.messages.message.map(function (message) {
                          return message.code + ": " + message.text;
                        }).join(", ")]
                      });
                      resolve(false);
                      return;
                    } else {
                      _this39.showErrorDialog({
                        key: "INVALID_PAYMENT_INFORMATION",
                        params: [String(response)]
                      });
                      resolve(false);
                      return;
                    }
                  }
                  _this39.authorizeOpaqueData = null;
                  resolve(true);
                });

              case 39:
              case "end":
                return _context9.stop();
            }
          }
        }, null, _this39, [[6, 18, 22, 30], [23,, 25, 29]]);
      });
    },
    getBookingAmountPayment: function getBookingAmountPayment() {
      if (this.$refs.bookingSection && this.$refs.bookingSection.length) {
        var amount = 0;
        if (this.includeCandidatePayment) {
          amount = this.$refs.bookingSection[0].getTotalFee();
        } else {
          amount = this.$refs.bookingSection[0].getAgencyFee();
        }
        return amount;
      }
      return 0;
    },
    getNumberOfBookings: function getNumberOfBookings() {
      // Count total number of bookings
      if (!this.listBookingJobs) {
        return 0;
      }
      var result = 0;
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.listBookingJobs[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var booking = _step26.value;

          result += this.getListDateOfRepeatBooking(booking).length;
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      return result;
    },
    showCheckPaymentResult: function showCheckPaymentResult() {
      var paymentExpression = this.profile.additional_information.payment_expression;
      if (paymentExpression) {
        var payment = this.calcEval("(function() {" + this.replaceTagValue(paymentExpression, _extends({}, this.applicationData, {
          number_booking: this.getNumberOfBookings()
        }), false, [], true) + "}())");
        this.addDiscountInfo(payment);
        this.showResultDialog({
          innerHtml: "<h2>Payment Expression Result</h2><p>" + JSON.stringify(payment) + "</p>"
        });
      }
    },

    // Get stripe discount object
    // {coupon: counpon_id} or {promotion_code: code_id}
    addDiscountInfo: function addDiscountInfo(payment) {
      if (!payment) {
        return;
      }
      if (this.applicationData.promo_code && this.profile.promo_codes) {
        var _iteratorNormalCompletion27 = true;
        var _didIteratorError27 = false;
        var _iteratorError27 = undefined;

        try {
          for (var _iterator27 = this.profile.promo_codes[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
            var code = _step27.value;

            if (code.code === this.applicationData.promo_code) {
              if (code.type === "Stripe Promotion Code") {
                if (payment.subscription) {
                  payment.subscription.promotion_code = code.codeID;
                  return;
                }
                if (payment.amount) {
                  payment.promotion_code = code.codeID;
                  return;
                }
              }
              if (code.type === "Stripe Coupon") {
                if (payment.subscription) {
                  payment.subscription.coupon = code.couponID;
                  return;
                }
                if (payment.amount) {
                  payment.coupon = code.couponID;
                  return;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError27 = true;
          _iteratorError27 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion27 && _iterator27.return) {
              _iterator27.return();
            }
          } finally {
            if (_didIteratorError27) {
              throw _iteratorError27;
            }
          }
        }
      }
      return;
    },
    submitApplication: function submitApplication() {
      var errorInfo, isValid, errorMessage;
      return regeneratorRuntime.async(function submitApplication$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (!this.hasCaptcha) {
                _context10.next = 4;
                break;
              }

              if (this.isVerifiedCaptcha) {
                _context10.next = 4;
                break;
              }

              this.showErrorDialog("CAPTCHA_NOT_COMPLETED");
              return _context10.abrupt("return");

            case 4:
              // Convert email fields to lower case
              if (this.applicationData.email) {
                this.applicationData.email = this.applicationData.email.toLowerCase();
              }
              if (this.applicationData.email2) {
                this.applicationData.email2 = this.applicationData.email2.toLowerCase();
              }
              this.submitClicked = true;
              errorInfo = this.checkInvalidFields();

              if (!errorInfo) {
                _context10.next = 13;
                break;
              }

              this.showErrorDialog({
                key: "INVALID_INPUT_ERROR",
                params: [this.getErrorMessage(errorInfo)]
              });
              return _context10.abrupt("return");

            case 13:
              if (!this.checkMissingDependencyObject()) {
                _context10.next = 17;
                break;
              }

              return _context10.abrupt("return");

            case 17:
              if (!this.checkMissingJobBookingObject()) {
                _context10.next = 21;
                break;
              }

              return _context10.abrupt("return");

            case 21:
              if (!this.checkMissingSignDocument()) {
                _context10.next = 25;
                break;
              }

              return _context10.abrupt("return");

            case 25:
              if (!this.checkMissingEvaluation()) {
                _context10.next = 29;
                break;
              }

              return _context10.abrupt("return");

            case 29:
              if (!this.checkMissingFileWithInfo()) {
                _context10.next = 31;
                break;
              }

              return _context10.abrupt("return");

            case 31:
              if (!this.hasDuplicatedEmailError) {
                _context10.next = 34;
                break;
              }

              this.showErrorDialog(_extends({}, this.getDuplicatedEmailWarning(this.applicationData.email), {
                onClickContent: this.handleClickDuplicatedWarningContent
              }));
              return _context10.abrupt("return");

            case 34:
              if (!this.hasAuthorizePayment) {
                _context10.next = 40;
                break;
              }

              _context10.next = 37;
              return regeneratorRuntime.awrap(this.submitAuthorizePayment());

            case 37:
              isValid = _context10.sent;

              if (isValid) {
                _context10.next = 40;
                break;
              }

              return _context10.abrupt("return");

            case 40:
              errorMessage = this.getErrorFromCondition(this.listErrorConditions, this.applicationData);

              if (!errorMessage) {
                _context10.next = 44;
                break;
              }

              this.showErrorDialog(_extends({}, this.$store.getters.inputConditionError, {
                message: errorMessage
              }));
              return _context10.abrupt("return");

            case 44:
              if (!this.applicationData.email) {
                this.applicationData.email = this.generatePlaceholderEmail(this.applicationData);
              }

              this.registerUser();

            case 46:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this);
    },
    getConditionString: function getConditionString(condition) {
      var _this40 = this;

      var listTexts = [];
      try {
        var listConditions = condition.conditions.listConditions;
        listConditions.forEach(function (condition) {
          var field = _this40.listFields.find(function (field) {
            return field.model === condition.model;
          });
          if (!field) {
            return;
          }
          console.log(field.label);
          console.log(condition);
          listTexts.push(field.label + " " + (condition.operator || "").toLowerCase() + " " + condition.value);
        });
        return listTexts.join("\n");
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    setUserType: function setUserType(obj) {
      var _this41 = this;

      if (this.type === _customDefineType.BUILDER_USER_TYPE.UNSPECIFIED) {
        obj.is_candidate = this.applicationData.userType === this.candidateOption;
        obj.is_employer = this.applicationData.userType === this.clientOption;
        var builderId = void 0;
        if (obj.is_candidate) {
          builderId = this.tryGet(function () {
            return _this41.profile.additional_information.application_builder_candidate;
          });
        } else {
          builderId = this.tryGet(function () {
            return _this41.profile.additional_information.application_builder_client;
          });
        }
        if (builderId) {
          obj.application_form = builderId;
          obj.original_contact_form = Number(this.$route.params.profileID);
        }
      } else {
        obj.is_candidate = this.type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
        obj.is_employer = this.type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
      }
    },

    // Calculate charge amount for authorize.net/quickbooks payments
    calculateChargeAmount: function calculateChargeAmount(totalBookingFee) {
      var amount = 0;
      var hasPaymentExpression = false;
      // Check if price expression is used
      if (this.profile.additional_information) {
        var paymentExpression = this.profile.additional_information.payment_expression;
        if (paymentExpression) {
          hasPaymentExpression = true;
          amount = this.calcEval("(function() {" + this.replaceTagValue(paymentExpression, _extends({}, this.applicationData, {
            number_booking: this.listBookingJobs ? this.listBookingJobs.length : 0
          }), false, [], true) + "}())");
        }
      }
      if (!hasPaymentExpression) {
        if (this.paymentField.chargeAmount) {
          amount = this.paymentField.chargeAmount;
        } else if (totalBookingFee) {
          amount = totalBookingFee;
        }
      }
      return amount;
    },
    registerUser: function registerUser() {
      var _this42 = this;

      var hasBookingSection, totalBookingFee, status, userType, candidateStatus, clientStatus, _iteratorNormalCompletion28, _didIteratorError28, _iteratorError28, _iterator28, _step28, model, membershipInfo, userTypes, userTags, conditionalStatusObject, conditionalStatus, conditionalSecondStatusObject, conditionalSecondStatus, requestBody, secondStatus, userLocations, listAdminManager, _listAdminManager, userChecklist, userBadges, amount, _amount, keapTagIds1, tagIds, keapTagIds2, keapTagIds, _iteratorNormalCompletion29, _didIteratorError29, _iteratorError29, _iterator29, _step29, field, listFileFields, _iteratorNormalCompletion30, _didIteratorError30, _iteratorError30, _iterator30, _step30, fileModel, mapDialogSectionByLabel, listKeapSectionInfo, _loop3, dependentName, _loop4, _ret5, addressInfo, listOtherModel, isExisted, formData, hasFile, index, fileField, uploadFileRes, _index, _fileField, filePath, _iteratorNormalCompletion31, _didIteratorError31, _iteratorError31, _iterator31, _step31, _fileField2, fileName, payment, isSetPaymentMethod, paymentExpression, paymentExpressionVal, emptyPaymentEl, res, label;

      return regeneratorRuntime.async(function registerUser$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              hasBookingSection = this.listDialogSections.some(function (field) {
                return field.type === _customDefineType.FORM_TYPE.BOOKING_SECTION;
              });
              // Calculate total booking fee

              totalBookingFee = 0;

              if (this.chargeClientWhenBooking) {
                totalBookingFee = this.getBookingAmountPayment();
              }
              status = "Applied";

              if (this.profile.status_change) {
                status = this.profile.status_change;
              }
              if (this.type === _customDefineType.BUILDER_USER_TYPE.UNSPECIFIED) {
                userType = this.applicationData.userType;

                if (userType === this.candidateOption) {
                  candidateStatus = this.getAdditionalInfo("status_change_candidate");

                  if (candidateStatus) {
                    status = candidateStatus;
                  }
                } else if (userType === this.clientOption) {
                  clientStatus = this.getAdditionalInfo("status_change_client");

                  if (clientStatus) {
                    status = clientStatus;
                  }
                }
              }
              if (this.isMatchCombinedConditions(this.listRejectConditions, this.applicationData)) {
                status = "Rejected";
              }

              // Reset value of the fields which are not showed
              _iteratorNormalCompletion28 = true;
              _didIteratorError28 = false;
              _iteratorError28 = undefined;
              _context11.prev = 10;
              for (_iterator28 = Object.keys(this.applicationData)[Symbol.iterator](); !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                model = _step28.value;

                this.resetValueOfHiddenField(this.applicationData, this.applicationData, this.listFields, model);
              }

              // Check to autofill location if there is only one location
              _context11.next = 18;
              break;

            case 14:
              _context11.prev = 14;
              _context11.t0 = _context11["catch"](10);
              _didIteratorError28 = true;
              _iteratorError28 = _context11.t0;

            case 18:
              _context11.prev = 18;
              _context11.prev = 19;

              if (!_iteratorNormalCompletion28 && _iterator28.return) {
                _iterator28.return();
              }

            case 21:
              _context11.prev = 21;

              if (!_didIteratorError28) {
                _context11.next = 24;
                break;
              }

              throw _iteratorError28;

            case 24:
              return _context11.finish(21);

            case 25:
              return _context11.finish(18);

            case 26:
              if (this.listLocations && this.listLocations.length === 1) {
                this.applicationData["locations"] = [].concat(_toConsumableArray(this.listLocations));
              }

              // Calculate membership info
              membershipInfo = this.getMembershipInfoFromCondition(this.listMembershipConditions, this.applicationData);

              // Calculate type

              userTypes = this.calculateUserProperties(this.listTypeConditions, this.applicationData, this.applicationData.types, "type");


              userTypes.push.apply(userTypes, this.profile.user_types_on_registration); // If certain user types are always set for this application form https://stackoverflow.com/questions/4842993/javascript-push-an-entire-list

              this.userTypes = userTypes;
              // Calculate user tags
              userTags = this.calculateUserProperties(this.listTagConditions, this.applicationData, this.applicationData.tags, "tag");

              // Calculate conditional status

              conditionalStatusObject = this.calculateUserProperty(this.listStatusConditions, this.applicationData, "status");
              conditionalStatus = null;

              if (conditionalStatusObject && conditionalStatusObject.status) {
                conditionalStatus = conditionalStatusObject.status;
              }
              if (conditionalStatus) {
                status = conditionalStatus;
              }

              conditionalSecondStatusObject = this.calculateUserProperty(this.listSecondStatusConditions, this.applicationData, "second_status");
              conditionalSecondStatus = null;

              if (conditionalSecondStatusObject && conditionalSecondStatusObject.second_status) {
                conditionalSecondStatus = conditionalSecondStatusObject.second_status;
              }

              // Create request body
              requestBody = _extends({}, this.applicationData, {
                types: userTypes,
                tags: userTags,
                membership_info: membershipInfo,
                status: status,
                password: this.applicationData.password ? this.applicationData.password : this.applicationData.email,
                application_content: this.getApplicationEmailContent(this.applicationData, this.listFields, this.mapDependentObjects, this.listBookingJobs, this.isOneItemPerRow),
                url: this.rootUrl
              });
              secondStatus = this.secondStatusChangeTo || conditionalSecondStatus;

              if (secondStatus) {
                requestBody.second_status = secondStatus;
              }

              if (!requestBody.locations || !requestBody.locations.length) {
                if (this.listLocationConditions && this.listLocationConditions.length) {
                  // Calculate user locations
                  userLocations = this.calculateUserProperties(this.listLocationConditions, this.applicationData, this.applicationData.locations, "location");

                  requestBody.locations = userLocations;
                }
              }
              if (!requestBody.admin_manager) {
                if (this.listManagerConditions && this.listManagerConditions.length) {
                  // Calculate user locations
                  listAdminManager = this.calculateUserProperties(this.listManagerConditions, this.applicationData, null, "admin_manager");

                  if (listAdminManager && listAdminManager.length) {
                    requestBody.admin_manager = listAdminManager[0];
                  }
                }
              }

              if (!requestBody.second_admin_manager) {
                if (this.listSecondManagerConditions && this.listSecondManagerConditions.length) {
                  // Calculate user locations
                  _listAdminManager = this.calculateUserProperties(this.listSecondManagerConditions, this.applicationData, null, "second_admin_manager");

                  if (_listAdminManager && _listAdminManager.length) {
                    requestBody.second_admin_manager = _listAdminManager[0];
                  }
                }
              }

              if (this.listChecklistConditions && this.listChecklistConditions.length) {
                // Calculate user checklist
                userChecklist = this.calculateUserProperties(this.listChecklistConditions, this.applicationData, this.applicationData.checklist, "admin_checklist");

                if (userChecklist && userChecklist.length) {
                  requestBody.checklist = userChecklist;
                }
              }

              if (this.listBadgeConditions && this.listBadgeConditions.length) {
                // Calculate user badge
                userBadges = this.calculateUserProperties(this.listBadgeConditions, this.applicationData, [], "badge");

                if (userBadges && userBadges.length) {
                  requestBody.badges = userBadges;
                }
              }

              // Update value of derived model
              this.updateDerivedModel(requestBody, this.listFields);

              // User type
              this.setUserType(requestBody);
              if (this.hasAuthorizePayment && this.authorizeOpaqueData) {
                requestBody["authorize_opaque_data"] = this.authorizeOpaqueData;
                amount = this.calculateChargeAmount(totalBookingFee);

                if (amount) {
                  requestBody["charge_amount"] = amount;
                }
              }
              if (this.hasQuickbooksPayment && this.quickbooksPaymentInfo) {
                requestBody["quickbooks_payment_info"] = this.quickbooksPaymentInfo;
                _amount = this.calculateChargeAmount(totalBookingFee);

                if (_amount) {
                  requestBody["charge_amount"] = _amount;
                }
              }

              // Calculate keap tag IDs
              if (this.profile.additional_information && this.profile.additional_information.add_to_keap) {
                keapTagIds1 = this.profile.additional_information.keap_tag_ids;
                tagIds = this.calculateUserProperties(this.listKeapTagConditions, this.applicationData, null, "keap_tag");
                keapTagIds2 = tagIds.join(",");

                // Keap tag id is combined of keap tag 1 and keap tag 2

                keapTagIds = this.concatStrings(keapTagIds1, keapTagIds2, ",");


                if (keapTagIds) {
                  requestBody["keap_tag_ids"] = keapTagIds;
                }
              }

              // Correct format for time picker fields
              _iteratorNormalCompletion29 = true;
              _didIteratorError29 = false;
              _iteratorError29 = undefined;
              _context11.prev = 55;
              for (_iterator29 = this.listFields[Symbol.iterator](); !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
                field = _step29.value;

                if (field.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
                  if (field.model && requestBody[field.model] && _typeof(requestBody[field.model]) === "object") {
                    requestBody[field.model] = this.getTimeString(requestBody[field.model]);
                  }
                }
              }

              // Find data for custom keap field
              _context11.next = 63;
              break;

            case 59:
              _context11.prev = 59;
              _context11.t1 = _context11["catch"](55);
              _didIteratorError29 = true;
              _iteratorError29 = _context11.t1;

            case 63:
              _context11.prev = 63;
              _context11.prev = 64;

              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }

            case 66:
              _context11.prev = 66;

              if (!_didIteratorError29) {
                _context11.next = 69;
                break;
              }

              throw _iteratorError29;

            case 69:
              return _context11.finish(66);

            case 70:
              return _context11.finish(63);

            case 71:
              this.attachKeapInfo(requestBody, this.profile.additional_information, this.listFields, this.applicationData);

              listFileFields = [];
              _iteratorNormalCompletion30 = true;
              _didIteratorError30 = false;
              _iteratorError30 = undefined;
              _context11.prev = 76;

              for (_iterator30 = this.listFileModels[Symbol.iterator](); !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                fileModel = _step30.value;

                if (this.applicationData[fileModel]) {
                  listFileFields.push({
                    model: fileModel,
                    type: "people",
                    file: this.applicationData[fileModel],
                    url: this.applicationData[fileModel]
                  });
                  delete requestBody[fileModel];
                }
              }

              // Dependent data: Experience, Children, Pet, Reference, Contact, Education
              _context11.next = 84;
              break;

            case 80:
              _context11.prev = 80;
              _context11.t2 = _context11["catch"](76);
              _didIteratorError30 = true;
              _iteratorError30 = _context11.t2;

            case 84:
              _context11.prev = 84;
              _context11.prev = 85;

              if (!_iteratorNormalCompletion30 && _iterator30.return) {
                _iterator30.return();
              }

            case 87:
              _context11.prev = 87;

              if (!_didIteratorError30) {
                _context11.next = 90;
                break;
              }

              throw _iteratorError30;

            case 90:
              return _context11.finish(87);

            case 91:
              return _context11.finish(84);

            case 92:
              mapDialogSectionByLabel = {};

              this.listDialogSections.forEach(function (dialogSection) {
                mapDialogSectionByLabel[dialogSection.label] = dialogSection;
              });

              listKeapSectionInfo = []; // List of section which need to be added to keap

              _loop3 = function _loop3(dependentName) {
                var apiKey = _this42.tryGet(function () {
                  return _fieldTypes.MAP_DIALOG_SECTION[_this42.mapDependentLabelName[dependentName]].apiKey;
                });
                if (apiKey) {
                  delete requestBody[apiKey];
                }
              };

              for (dependentName in this.mapDependentObjects) {
                _loop3(dependentName);
              }

              _loop4 = function _loop4(dependentName) {
                var apiKey = _this42.tryGet(function () {
                  return _fieldTypes.MAP_DIALOG_SECTION[_this42.mapDependentLabelName[dependentName]].apiKey;
                });
                var listDependentObjects = _this42.mapDependentObjects[dependentName];
                if (!mapDialogSectionByLabel[dependentName]) {
                  return "continue";
                }
                // Check if add to keap
                if (mapDialogSectionByLabel[dependentName].additionalInformation && mapDialogSectionByLabel[dependentName].additionalInformation.add_to_keap) {
                  var keapSectionInfo = {
                    name: apiKey
                  };
                  var relationship = mapDialogSectionByLabel[dependentName].additionalInformation.relationship;
                  if (relationship) {
                    keapSectionInfo.relationship = relationship;
                  }
                  listKeapSectionInfo.push(keapSectionInfo);
                }
                var sectionListFields = mapDialogSectionByLabel[dependentName].list_fields;
                var sectionListFileModels = sectionListFields.filter(function (field) {
                  return field.type === _customDefineType.FORM_TYPE.FILE;
                }).map(function (field) {
                  return field.model;
                });
                // Use a cloned variable to avoid reference variable
                var listDependentObjectRequests = [];
                for (var _index2 = 0; _index2 < listDependentObjects.length; _index2++) {
                  var dependentObject = listDependentObjects[_index2];
                  if (!dependentObject.type) {
                    dependentObject.type = dependentName;
                  }
                  var clonedObject = _extends({}, dependentObject);
                  if (clonedObject.id == 0) {
                    delete clonedObject.id;
                  }
                  var _iteratorNormalCompletion32 = true;
                  var _didIteratorError32 = false;
                  var _iteratorError32 = undefined;

                  try {
                    for (var _iterator32 = sectionListFileModels[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                      var sectionFileModel = _step32.value;

                      if (dependentObject[sectionFileModel]) {
                        listFileFields.push({
                          model: sectionFileModel,
                          type: apiKey,
                          index: _index2,
                          label: dependentName,
                          file: dependentObject[sectionFileModel]
                        });
                        delete clonedObject[sectionFileModel];
                      }
                    }
                  } catch (err) {
                    _didIteratorError32 = true;
                    _iteratorError32 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion32 && _iterator32.return) {
                        _iterator32.return();
                      }
                    } finally {
                      if (_didIteratorError32) {
                        throw _iteratorError32;
                      }
                    }
                  }

                  _this42.attachKeapInfo(clonedObject, mapDialogSectionByLabel[dependentName].additionalInformation, sectionListFields, clonedObject);
                  listDependentObjectRequests.push(clonedObject);
                }
                if (requestBody[apiKey]) {
                  requestBody[apiKey] = [].concat(_toConsumableArray(requestBody[apiKey]), listDependentObjectRequests);
                } else {
                  requestBody[apiKey] = listDependentObjectRequests;
                }
              };

              _context11.t3 = regeneratorRuntime.keys(this.mapDependentObjects);

            case 99:
              if ((_context11.t4 = _context11.t3()).done) {
                _context11.next = 106;
                break;
              }

              dependentName = _context11.t4.value;
              _ret5 = _loop4(dependentName);

              if (!(_ret5 === "continue")) {
                _context11.next = 104;
                break;
              }

              return _context11.abrupt("continue", 99);

            case 104:
              _context11.next = 99;
              break;

            case 106:

              requestBody.keap_section_info = listKeapSectionInfo;

              // List of fields will be submitted with the job
              // If those addresses field of job is undefined, it will be get from user
              addressInfo = {};
              listOtherModel = ["address1", "address2", "postal_code", "city"];

              listOtherModel.forEach(function (model) {
                if (_this42.applicationData[model]) {
                  addressInfo[model] = _this42.applicationData[model];
                }
              });
              if (hasBookingSection) {
                // Job Booking Information
                requestBody["jobs"] = this.listBookingJobs.map(function (job) {
                  return _extends({}, addressInfo, job);
                });
              }

              // Signing document
              requestBody["documents"] = this.getSigningDocuments();

              // File with info
              this.setFileWithInfo(requestBody);

              if (!listFileFields.length) {
                _context11.next = 172;
                break;
              }

              _context11.next = 116;
              return regeneratorRuntime.awrap(this.checkUserExistance());

            case 116:
              isExisted = _context11.sent;

              if (!isExisted) {
                _context11.next = 120;
                break;
              }

              this.showConfirmDialog({
                innerHtml: this.$store.getters.agencyPublic.duplicate_email_error_message,
                acceptLabel: "Navigate to Login",
                rejectLabel: "Edit the form",
                onAcceptCallback: function onAcceptCallback() {
                  return _this42.$router.replace({ name: "Login" });
                }
              });
              return _context11.abrupt("return");

            case 120:
              // Submit files
              formData = new FormData();
              hasFile = false;
              index = 0;

            case 123:
              if (!(index < listFileFields.length)) {
                _context11.next = 136;
                break;
              }

              fileField = listFileFields[index];

              if (!fileField.url) {
                _context11.next = 127;
                break;
              }

              return _context11.abrupt("continue", 133);

            case 127:
              if (!(typeof fileField.file === "string")) {
                _context11.next = 131;
                break;
              }

              if (!fileField.file.includes("user_upload_files")) {
                _context11.next = 131;
                break;
              }

              fileField.url = fileField.file;
              return _context11.abrupt("continue", 133);

            case 131:
              hasFile = true;
              formData.append(index, fileField.file);

            case 133:
              index++;
              _context11.next = 123;
              break;

            case 136:
              if (!hasFile) {
                _context11.next = 150;
                break;
              }

              formData.append("agency", this.agencyID);
              formData.append("profile-builder", this.profileID);
              formData.append("email", this.applicationData.email);
              _context11.prev = 140;
              _context11.next = 143;
              return regeneratorRuntime.awrap(_axios2.default.post("/upload-files/", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }));

            case 143:
              uploadFileRes = _context11.sent;

              if (uploadFileRes && uploadFileRes.data) {
                for (_index = 0; _index < listFileFields.length; _index++) {
                  _fileField = listFileFields[_index];

                  if (uploadFileRes.data[_index]) {
                    filePath = uploadFileRes.data[_index];

                    _fileField.url = filePath;
                  }
                }
              }
              _context11.next = 150;
              break;

            case 147:
              _context11.prev = 147;
              _context11.t5 = _context11["catch"](140);

              console.log(_context11.t5);

            case 150:
              if (!(this.profile.additional_information && this.profile.additional_information.add_document_to_keap)) {
                _context11.next = 171;
                break;
              }

              if (!(listFileFields && this.$store.getters.mapUploadedFileUrlName)) {
                _context11.next = 171;
                break;
              }

              _iteratorNormalCompletion31 = true;
              _didIteratorError31 = false;
              _iteratorError31 = undefined;
              _context11.prev = 155;

              for (_iterator31 = listFileFields[Symbol.iterator](); !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                _fileField2 = _step31.value;

                if (_fileField2.url) {
                  fileName = this.$store.getters.mapUploadedFileUrlName[_fileField2.url];

                  if (fileName) {
                    _fileField2.file_name = fileName;
                  }
                }
              }
              _context11.next = 163;
              break;

            case 159:
              _context11.prev = 159;
              _context11.t6 = _context11["catch"](155);
              _didIteratorError31 = true;
              _iteratorError31 = _context11.t6;

            case 163:
              _context11.prev = 163;
              _context11.prev = 164;

              if (!_iteratorNormalCompletion31 && _iterator31.return) {
                _iterator31.return();
              }

            case 166:
              _context11.prev = 166;

              if (!_didIteratorError31) {
                _context11.next = 169;
                break;
              }

              throw _iteratorError31;

            case 169:
              return _context11.finish(166);

            case 170:
              return _context11.finish(163);

            case 171:
              requestBody.file_urls = listFileFields;

            case 172:
              payment = null;

              if (!this.hasStripePayment) {
                _context11.next = 183;
                break;
              }

              _context11.next = 176;
              return regeneratorRuntime.awrap(this.setStripePaymentMethod());

            case 176:
              isSetPaymentMethod = _context11.sent;

              if (isSetPaymentMethod) {
                _context11.next = 179;
                break;
              }

              return _context11.abrupt("return");

            case 179:
              if (this.stripePaymentMethodId) {
                requestBody.payment_method = this.stripePaymentMethodId;
              }
              if (totalBookingFee) {
                payment = { amount: totalBookingFee, chargeBookingFee: true, description: "Charge booking fee" };
              } else if (this.applicationData.credit_package && !this.isMonthlyCreditPackageSelection) {
                payment = {
                  amount: Number(this.applicationData.credit_package.price),
                  chargeCreditPackage: true,
                  description: "Charge for " + this.applicationData.credit_package.credits + " credits"
                };
              }
              if (this.profile.additional_information) {
                paymentExpression = this.profile.additional_information.payment_expression;

                if (paymentExpression) {
                  paymentExpressionVal = this.calcEval("(function() {" + this.replaceTagValue(paymentExpression, _extends({}, this.applicationData, {
                    number_booking: this.getNumberOfBookings()
                  }), false, [], true) + "}())");

                  if (paymentExpressionVal) {
                    payment = paymentExpressionVal;
                    // Charge later
                    if (payment && payment.amount) {
                      if (this.chargeOn === "create_booking" && !(this.listBookingJobs && this.listBookingJobs.length) || this.chargeOn === "assign_candidate") {
                        requestBody.charge_info = {
                          amount: payment.amount,
                          charge_on: this.chargeOn
                        };
                        payment = null;
                      }
                    }
                  }
                }
              }
              if (this.stripeSubscriptionSelected && this.stripeSubscriptionSelected.planId) {
                if (!payment) {
                  payment = {};
                }
                payment.subscription = {
                  plan_id: this.stripeSubscriptionSelected.planId,
                  fee_percentage: 0,
                  tax_percentage: 0
                };
                requestBody.info__stripe_subscription_selected = this.stripeSubscriptionSelected;
              }

            case 183:

              // Check if create week availabilities
              this.setWeekAvailabilities(requestBody);
              if (this.registeredUserId) {
                requestBody.tracking_id = this.registeredUserId;
              }

              if (this.listEvaluation && this.listEvaluation.length) {
                requestBody.evaluations = this.listEvaluation;
              }
              if (this.isEmbed && this.redirectToLink) {
                this.showResultDialog({
                  title: "Thank you, please wait!",
                  noToast: true,
                  hideButton: true
                });
              }

              if (this.isBookingOnly) {
                requestBody = {
                  poster: requestBody.tracking_id,
                  jobs: requestBody.jobs,
                  application_form: requestBody.application_form,
                  create_jobs: true
                };
              }

              // Submit Stripe payment
              if (this.hasStripePayment) {
                emptyPaymentEl = document.getElementById(_customDefineType.STRIPE_PAYMENT_ERROR_IDS.EMPTY);
                // Check if payment element is not empty

                if (!emptyPaymentEl) {
                  this.addDiscountInfo(payment);
                }
                requestBody.payment_detail = payment;
              }

              if (this.applicationData.credit_package) {
                requestBody.is_monthly_credit_package_selection = this.isMonthlyCreditPackageSelection;
              }

              // Send create user request
              _context11.next = 192;
              return regeneratorRuntime.awrap(_axios2.default.post("/application-submit/", requestBody));

            case 192:
              res = _context11.sent;

              if (!(res && res.data)) {
                _context11.next = 227;
                break;
              }

              if (this.isEmbed && this.redirectToLink) {
                this.hideResultDialog();
              }
              this.initialLoggedInUser = null;

              if (!this.isBookingOnly) {
                _context11.next = 199;
                break;
              }

              this.showResultDialog("BOOKING_SUBMITTED_RESULT_DIALOG");
              return _context11.abrupt("return");

            case 199:
              if (this.intervalSubmitFunc) {
                clearInterval(this.intervalSubmitFunc);
              }

              // Handle status change
              _context11.next = 202;
              return regeneratorRuntime.awrap(this.handleAfterUserStatusChanged(_extends({}, res.data, { types: userTypes }), status, null, conditionalStatus ? {
                reason: "Set Conditional Status in Application Form\n" + this.getConditionString(conditionalStatusObject)
              } : null, false, true));

            case 202:
              if (!secondStatus) {
                _context11.next = 205;
                break;
              }

              _context11.next = 205;
              return regeneratorRuntime.awrap(this.handleAfterUserStatusChanged(_extends({}, res.data, { types: userTypes }), secondStatus, null, {
                reason: "Set Conditional Second Status in Application Form\n" + this.getConditionString(conditionalSecondStatusObject)
              }, true, true));

            case 205:

              this.userStatus = status;

              if (!(status === "Rejected")) {
                _context11.next = 210;
                break;
              }

              if (this.redirectToLink) {
                this.showResultDialog(_extends({}, this.submitRejectDialog, {
                  onCloseCallback: function onCloseCallback() {
                    window.top.location.href = _this42.redirectToLink;
                  }
                }));
                if (this.rejectionMessageDuration) {
                  setTimeout(function () {
                    _this42.hideResultDialog();
                    window.top.location.href = _this42.redirectToLink;
                  }, Number(this.rejectionMessageDuration) * 1000);
                }
              } else {
                this.showResultDialog(this.submitRejectDialog);
              }
              _context11.next = 221;
              break;

            case 210:
              label = "Close";

              if (this.profile.redirect_to_dashboard_on_registration) {
                label = "Continue";
              }

              if (!this.redirectToLink) {
                _context11.next = 220;
                break;
              }

              if (!this.redirectImmediately) {
                _context11.next = 216;
                break;
              }

              window.top.location.href = this.redirectToLink;
              return _context11.abrupt("return");

            case 216:
              if (this.submissionMessageDuration && Number(this.submissionMessageDuration)) {
                this.showResultDialog(_extends({}, this.submitSuccessDialog, {
                  closeLabel: label,
                  onCloseCallback: this.onCloseResultDialog
                }));
                setTimeout(function () {
                  _this42.hideResultDialog();
                  window.top.location.href = _this42.redirectToLink;
                }, Number(this.submissionMessageDuration) * 1000);
              } else {
                if (this.submissionMessageDuration && !Number(this.submissionMessageDuration)) {
                  // No submission confirmation message
                  this.showResultDialog({
                    title: "Thank you, please wait!",
                    noToast: true,
                    hideButton: true
                  });
                  setTimeout(function () {
                    _this42.hideResultDialog();
                    window.top.location.href = _this42.redirectToLink;
                  }, 1000);
                } else {
                  this.showResultDialog(_extends({}, this.submitSuccessDialog, {
                    closeLabel: label,
                    onCloseCallback: this.onCloseResultDialog
                  }));
                }
              }
              return _context11.abrupt("return");

            case 220:
              this.showResultDialog(_extends({}, this.submitSuccessDialog, {
                closeLabel: label,
                onCloseCallback: this.onCloseResultDialog
              }));

            case 221:
              if (this.redirectToLink) {
                _context11.next = 225;
                break;
              }

              _context11.next = 224;
              return regeneratorRuntime.awrap(this.handleLogin({
                email: requestBody.email,
                password: requestBody.password,
                user_type: this.type === _customDefineType.BUILDER_USER_TYPE.CLIENT ? "employer" : "candidate",
                agency: this.agencyID
              }));

            case 224:

              if (this.profile.redirect_to_dashboard_on_registration && !this.isEmbed) {
                // this.$store.dispatch("getAgency", this.agencyID);
                this.dashboardRedirect();
              }

            case 225:
              _context11.next = 228;
              break;

            case 227:
              if (this.isEmbed && this.redirectToLink) {
                // Hide result (Thank you, please wait) to show error
                this.hideResultDialog();
              }

            case 228:
            case "end":
              return _context11.stop();
          }
        }
      }, null, this, [[10, 14, 18, 26], [19,, 21, 25], [55, 59, 63, 71], [64,, 66, 70], [76, 80, 84, 92], [85,, 87, 91], [140, 147], [155, 159, 163, 171], [164,, 166, 170]]);
    },
    parseTimeString: function parseTimeString(input) {
      /* Parse time from String to Object
        Input: '00:11:AM
        Output: {hh: 00, mm: 11, A: AM}
      */
      var tokens = input.split(":");
      if (tokens.length != 3) {
        return null;
      } else {
        return this.getTimeString({
          hh: tokens[0],
          mm: tokens[1],
          A: tokens[2]
        });
      }
    },
    setWeekAvailabilities: function setWeekAvailabilities(requestBody) {
      var field = this.listFields.find(function (field) {
        return field.populateWeekAvailabilities;
      });
      if (!field || !field.listDays) {
        return;
      }
      var inputArr = this.applicationData[field.model];
      if (!inputArr) {
        return;
      }
      var listDays = field.listDays.split("\n").map(function (item) {
        return item.trim();
      });
      var mapAvailability = {};
      for (var index in inputArr) {
        var val = inputArr[index];
        if (val) {
          var fromToTokens = void 0;
          if (val.includes(_separator.TIME_FROM_TO_SEPARATOR)) {
            // New data is separated by tab (use with Textbox)
            fromToTokens = val.split(_separator.TIME_FROM_TO_SEPARATOR);
          } else {
            if (!field.useTimePicker) {
              // Old data is separated by comma (use with Timepicker)
              var mapReplacedValues = {
                ":AM": " AM",
                ":PM": " PM"
              };
              fromToTokens = this.replaceAllByMap(val, mapReplacedValues).split(",");
            }
            fromToTokens = val.split(",");
            // Only get first 2 items
            fromToTokens = fromToTokens.slice(0, 2);
          }
          var from = void 0,
              to = void 0;
          // Parse from
          if (field.useTimePicker) {
            if (fromToTokens[0]) {
              from = this.parseTimeString(fromToTokens[0]);
            }
            if (fromToTokens[1]) {
              to = this.parseTimeString(fromToTokens[1]);
            }
          }
          if (from && to) {
            mapAvailability[listDays[index].toLowerCase()] = [[from, to]];
          }
        }
      }
      requestBody.week_availabilities = mapAvailability;
    },
    checkUserExistance: function checkUserExistance() {
      var _this43 = this;

      return new Promise(function _callee5(resolve) {
        var requestBody, res;
        return regeneratorRuntime.async(function _callee5$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!_this43.registeredUserId) {
                  _context12.next = 3;
                  break;
                }

                resolve(false);
                return _context12.abrupt("return");

              case 3:
                requestBody = {
                  email: _this43.applicationData.email,
                  agency_id: _this43.$store.getters.agencyID
                };

                _this43.setUserType(requestBody);
                _context12.next = 7;
                return regeneratorRuntime.awrap(_axios2.default.post("/check-user-existence/", requestBody));

              case 7:
                res = _context12.sent;

                if (res.data) {
                  _context12.next = 11;
                  break;
                }

                resolve(false);
                return _context12.abrupt("return");

              case 11:
                // If user existed, and status is not in reapplication_statuses, return code is 2
                resolve(res.data.code === 2);

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, null, _this43);
      });
    },
    getSigningDocuments: function getSigningDocuments() {
      if (this.listSignDocumentField.length === 0) {
        return [];
      }
      var result = [];
      var _iteratorNormalCompletion33 = true;
      var _didIteratorError33 = false;
      var _iteratorError33 = undefined;

      try {
        for (var _iterator33 = this.listSignDocumentField[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
          var signField = _step33.value;

          if (!this.mapSignatures[signField.label]) {
            continue;
          }
          var template = this.mapDocumentTemplates[this.getKeySigningField(signField)];
          result.push(_extends({
            title: template.name,
            template: template.id,
            signing_user: this.$store.getters.userID,
            status: "Signed"
          }, this.mapSignatures[signField.label], {
            signing_date: this.todayDatetimeDjangoFormat,
            fields_labels: template.fields,
            fields_required: template.fields_required,
            edit_access: template.edit_access,
            organization_signer: template.organization_signer,
            order: template.order,
            signer_labels: template.signer_labels,
            use_image: template.use_image,
            params: template.params,
            agency_owner: this.$store.getters.agencyName,
            agency: this.$store.getters.agencyID
          }));
        }
      } catch (err) {
        _didIteratorError33 = true;
        _iteratorError33 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion33 && _iterator33.return) {
            _iterator33.return();
          }
        } finally {
          if (_didIteratorError33) {
            throw _iteratorError33;
          }
        }
      }

      return result;
    },
    onCloseResultDialog: function onCloseResultDialog() {
      if (this.redirectToLink) {
        window.top.location.href = this.redirectToLink;
        return;
      }
      if (this.profile.additional_information && this.profile.additional_information.open_on_close_result_section_id && this.profile.redirect_to_dashboard_on_registration && !this.isEmbed) {
        this.$store.dispatch("setOpenProfileSectionId", this.profile.additional_information.open_on_close_result_section_id);
      }
    },
    jobViewApplicationSubmitted: function jobViewApplicationSubmitted() {
      // Update JobView item to show that an application was submitted
      if (this.jobViewID) {
        _axios2.default.patch("/job-clicks/" + this.jobViewID, {
          new_application_submitted: true
        }).then(function (res) {
          console.log("Job view object updated");
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    getMinCount: function getMinCount(dialogSection) {
      if (dialogSection.notRequiredInApplication) {
        return null;
      }
      return dialogSection.minCount;
    },
    reloadApplicationData: function reloadApplicationData() {
      this.applicationData = _extends({}, this.applicationData);
    },
    isShowDuplicatedWarning: function isShowDuplicatedWarning(model) {
      if (model === "email") {
        if (this.hideDuplicatedEmailWarning) {
          return false;
        }
      }
      if (model === "phone") {
        if (this.hideDuplicatedPhoneWarning) {
          return false;
        }
      }
      return true;
    },
    isDuplicatedUser: function isDuplicatedUser(code) {
      if (code === 2) {
        return true;
      }
      if (code === 3 && this.returningApplicantBtnField && !this.registeredUserId) {
        return true;
      }
      return false;
    },
    handleBlurField: function handleBlurField(model) {
      var requestBody, res;
      return regeneratorRuntime.async(function handleBlurField$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (model === "email") {
                this.hasDuplicatedEmailError = false;
              }
              // Check if email, phone is existed

              if (!["email", "phone"].includes(model)) {
                _context13.next = 11;
                break;
              }

              if (!this.isShowDuplicatedWarning(model)) {
                _context13.next = 10;
                break;
              }

              requestBody = {
                country: this.applicationData.country,
                agency_id: this.$store.getters.agencyID,
                id: this.registeredUserId
              };

              this.setUserType(requestBody);
              requestBody[model] = this.applicationData[model];
              _context13.next = 8;
              return regeneratorRuntime.awrap(_axios2.default.post(this.appendBackgroundParam("/check-user-existence/"), requestBody));

            case 8:
              res = _context13.sent;

              if (res && res.data && this.isDuplicatedUser(res.data.code) && res.data.field) {
                if (res.data.field === "email") {
                  this.hasDuplicatedEmailError = true;
                  this.showErrorDialog(_extends({}, this.getDuplicatedEmailWarning(res.data.value || this.applicationData.email), {
                    onClickContent: this.handleClickDuplicatedWarningContent
                  }));
                } else if (res.data.field === "phone number") {
                  this.showErrorDialog(_extends({}, this.getDuplicatedPhoneWarning(res.data.value || this.applicationData.phone), {
                    onClickContent: this.handleClickDuplicatedWarningContent
                  }));
                }
              }

            case 10:
              if (this.isTrackApplication) {
                this.submitTrackingApplicationData();
              }

            case 11:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    },
    handleClickDuplicatedWarningContent: function handleClickDuplicatedWarningContent(targetId) {
      if (targetId === "returning-application-button") {
        this.hideErrorDialog();
        this.handleClickReturningApplicantBtn();
      }
    },
    handleSubmitEvaluation: function handleSubmitEvaluation(evaluationInfo) {
      if (evaluationInfo && evaluationInfo.template_id) {
        evaluationInfo.template = evaluationInfo.template_id;
        this.listEvaluation = this.listEvaluation.filter(function (evaluation) {
          return evaluation.template_id !== evaluationInfo.template_id;
        });
        this.listEvaluation.push(evaluationInfo);
      }
    },
    handleClickReturningApplicantBtn: function handleClickReturningApplicantBtn() {
      var _this44 = this;

      return regeneratorRuntime.async(function handleClickReturningApplicantBtn$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              this.showInputDialog({
                title: "Email Address",
                listFields: [{
                  label: "Please enter the email address you used to fill the application previously",
                  model: "email"
                }],
                onSubmitCallback: function onSubmitCallback(info) {
                  var requestBody, res;
                  return regeneratorRuntime.async(function onSubmitCallback$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          requestBody = {
                            agency: _this44.agencyID,
                            email: info.email
                          };

                          _this44.setUserType(requestBody);
                          _context14.next = 4;
                          return regeneratorRuntime.awrap(_axios2.default.post("/generate-verification-code/", requestBody));

                        case 4:
                          res = _context14.sent;

                          if (!(!res || !res.data)) {
                            _context14.next = 7;
                            break;
                          }

                          return _context14.abrupt("return");

                        case 7:
                          if (!(res.data.code === -1)) {
                            _context14.next = 10;
                            break;
                          }

                          // User not found
                          _this44.showErrorDialog("RETURNING_APPLICANT_EMAIL_NOT_FOUND");
                          return _context14.abrupt("return");

                        case 10:
                          _this44.showVerificationCodeInputDialog(info.email);

                        case 11:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, null, _this44);
                }
              });

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, null, this);
    },
    showVerificationCodeInputDialog: function showVerificationCodeInputDialog(email) {
      var _this45 = this;

      this.showInputDialog({
        title: "Verification Code",
        listFields: [{
          label: "An email with a verification code has just been sent to " + email + ". Please enter your verification code to continue.",
          model: "code"
        }],
        onSubmitCallback: function onSubmitCallback(info) {
          var requestBody, res, userID;
          return regeneratorRuntime.async(function onSubmitCallback$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  requestBody = {
                    agency: _this45.agencyID,
                    email: email,
                    code: info.code
                  };

                  _this45.setUserType(requestBody);
                  _context16.next = 4;
                  return regeneratorRuntime.awrap(_axios2.default.post("/verify-code/", requestBody));

                case 4:
                  res = _context16.sent;

                  if (!(!res || !res.data)) {
                    _context16.next = 7;
                    break;
                  }

                  return _context16.abrupt("return");

                case 7:
                  userID = res.data.user_id;

                  if (userID) {
                    _context16.next = 11;
                    break;
                  }

                  _this45.showErrorDialog("RETURNING_APPLICANT_INCORRECT_CODE");
                  return _context16.abrupt("return");

                case 11:
                  _context16.next = 13;
                  return regeneratorRuntime.awrap(_this45.loadPreApplication(userID));

                case 13:
                  if (_this45.registeredUserId) {
                    _this45.showResultDialog("RETURNING_APPLICANT_RESULT_DIALOG");
                  }

                case 14:
                case "end":
                  return _context16.stop();
              }
            }
          }, null, _this45);
        }
      });
    },
    loadPreApplication: function loadPreApplication(userID, hashID) {
      var _this46 = this;

      var res, user, _iteratorNormalCompletion34, _didIteratorError34, _iteratorError34, _iterator34, _step34, fileModel, ampApiCounts, _loop5, _dependentName, _loop6, _dependentName2, _ret7;

      return regeneratorRuntime.async(function loadPreApplication$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.post("/return-public-user/", {
                user_id: userID,
                id: hashID
              }));

            case 2:
              res = _context17.sent;

              if (!(res && res.data && res.data.user)) {
                _context17.next = 48;
                break;
              }

              user = res.data.user;

              if (!this.isValidPreApplicationUser(user)) {
                _context17.next = 47;
                break;
              }

              this.applicationData = _extends({}, this.applicationData, this.extractSelectedFields(user, this.listFields, true), {
                locations: user.locations,
                language: user.language
              });
              _iteratorNormalCompletion34 = true;
              _didIteratorError34 = false;
              _iteratorError34 = undefined;
              _context17.prev = 10;
              for (_iterator34 = this.listFileModels[Symbol.iterator](); !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                fileModel = _step34.value;

                if (this.applicationData[fileModel]) {
                  this.applicationData[fileModel] = this.convertToRelativePath(this.applicationData[fileModel]);
                }
              }
              _context17.next = 18;
              break;

            case 14:
              _context17.prev = 14;
              _context17.t0 = _context17["catch"](10);
              _didIteratorError34 = true;
              _iteratorError34 = _context17.t0;

            case 18:
              _context17.prev = 18;
              _context17.prev = 19;

              if (!_iteratorNormalCompletion34 && _iterator34.return) {
                _iterator34.return();
              }

            case 21:
              _context17.prev = 21;

              if (!_didIteratorError34) {
                _context17.next = 24;
                break;
              }

              throw _iteratorError34;

            case 24:
              return _context17.finish(21);

            case 25:
              return _context17.finish(18);

            case 26:
              if (this.isBookingOnly) {
                this.applicationData.first_name = user.first_name;
                this.applicationData.last_name = user.last_name;
                this.applicationData.email = user.email;
              }
              this.registeredUserId = user.id;
              this.preApplicationUserStatus = user.status;
              // Load existing references, experiences, ...
              ampApiCounts = {};

              _loop5 = function _loop5(_dependentName) {
                var apiKey = _this46.tryGet(function () {
                  return _fieldTypes.MAP_DIALOG_SECTION[_this46.mapDependentLabelName[_dependentName]].apiKey;
                });
                if (apiKey) {
                  var currentVal = ampApiCounts[apiKey] || 0;
                  ampApiCounts[apiKey] = currentVal + 1;
                }
              };

              for (_dependentName in this.mapDependentObjects) {
                _loop5(_dependentName);
              }

              _loop6 = function _loop6(_dependentName2) {
                if (!_dependentName2) {
                  return "continue";
                }
                var apiKey = _this46.tryGet(function () {
                  return _fieldTypes.MAP_DIALOG_SECTION[_this46.mapDependentLabelName[_dependentName2]].apiKey;
                });
                var label = _dependentName2.trim();
                if (apiKey && user[apiKey] && user[apiKey].length) {
                  var listValues = user[apiKey];
                  if (ampApiCounts[apiKey] > 1) {
                    listValues = listValues.filter(function (item) {
                      return item.type && item.type.trim() == label;
                    });
                  }
                  _this46.mapDependentObjects[_dependentName2] = listValues;
                }
              };

              _context17.t1 = regeneratorRuntime.keys(this.mapDependentObjects);

            case 34:
              if ((_context17.t2 = _context17.t1()).done) {
                _context17.next = 41;
                break;
              }

              _dependentName2 = _context17.t2.value;
              _ret7 = _loop6(_dependentName2);

              if (!(_ret7 === "continue")) {
                _context17.next = 39;
                break;
              }

              return _context17.abrupt("continue", 34);

            case 39:
              _context17.next = 34;
              break;

            case 41:
              this.saveMapDependentObjects();
              // Load evaluations
              if (user.evaluations) {
                user.evaluations.forEach(function (evaluation) {
                  evaluation.template_id = evaluation.template;
                  delete evaluation.id;
                });
                this.listOriginalEvaluations = user.evaluations;
                this.listEvaluation = [].concat(_toConsumableArray(this.listOriginalEvaluations));
              }
              this.saveListEvaluations();
              if (user.documents) {
                this.listOriginalDocuments = user.documents;
              }
              this.saveListDocuments(this.getSigningDocuments());
              if (user.files) {
                user.files.forEach(function (file) {
                  if (file.file_link) {
                    file.url = _this46.convertToRelativePath(file.file_link);
                  }
                  delete file.file_link;
                  delete file.user;
                  delete file.agency;
                });
                this.listFileInfoFields.forEach(function (field) {
                  var listFiles = user.files.filter(function (file) {
                    return file.name === field.label;
                  });
                  _this46.mapFileInfo[field.label] = listFiles;
                  _this46.saveMapFileInfo();
                });
              }

            case 47:
              return _context17.abrupt("return", user);

            case 48:
            case "end":
              return _context17.stop();
          }
        }
      }, null, this, [[10, 14, 18, 26], [19,, 21, 25]]);
    },
    setDependentData: function setDependentData(requestBody) {
      var _this47 = this;

      // Dependent data: Experience, Children, Pet, Reference, Contact, Education
      var mapDialogSectionByLabel = {};
      var listFileFields = [];
      this.listDialogSections.forEach(function (dialogSection) {
        mapDialogSectionByLabel[dialogSection.label] = dialogSection;
      });
      var mapOldObjects = this.mapSavedDependentObjects;

      var _loop7 = function _loop7(_dependentName3) {
        var apiKey = _this47.tryGet(function () {
          return _fieldTypes.MAP_DIALOG_SECTION[_this47.mapDependentLabelName[_dependentName3]].apiKey;
        });
        if (apiKey) {
          delete requestBody[apiKey];
        }
      };

      for (var _dependentName3 in this.mapDependentObjects) {
        _loop7(_dependentName3);
      }

      var _loop8 = function _loop8(_dependentName4) {
        var apiKey = _this47.tryGet(function () {
          return _fieldTypes.MAP_DIALOG_SECTION[_this47.mapDependentLabelName[_dependentName4]].apiKey;
        });
        var listDependentObjects = _this47.mapDependentObjects[_dependentName4];
        if (!mapDialogSectionByLabel[_dependentName4]) {
          return "continue";
        }
        var listPreviousDependentObjects = _this47.tryGet(function () {
          return mapOldObjects[_dependentName4];
        }) || [];

        var sectionListFields = mapDialogSectionByLabel[_dependentName4].list_fields;
        if (_this47.mapSectionAPICount[apiKey] <= 1) {
          if (_this47.isUnchangedList(listPreviousDependentObjects, listDependentObjects, sectionListFields)) {
            return "continue";
          }
        }
        var sectionListFileModels = sectionListFields.filter(function (field) {
          return field.type === _customDefineType.FORM_TYPE.FILE;
        }).map(function (field) {
          return field.model;
        });
        // Use a cloned variable to avoid reference variable
        var listDependentObjectRequests = [];
        for (var index = 0; index < listDependentObjects.length; index++) {
          var dependentObject = listDependentObjects[index];
          if (!dependentObject.type) {
            dependentObject.type = _dependentName4;
          }
          var clonedObject = _extends({}, dependentObject);
          if (clonedObject.id == 0) {
            delete clonedObject.id;
          }
          var _iteratorNormalCompletion35 = true;
          var _didIteratorError35 = false;
          var _iteratorError35 = undefined;

          try {
            for (var _iterator35 = sectionListFileModels[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
              var sectionFileModel = _step35.value;

              if (dependentObject[sectionFileModel]) {
                var fileValue = dependentObject[sectionFileModel];
                var fileObj = {
                  model: sectionFileModel,
                  type: apiKey,
                  index: index,
                  label: _dependentName4,
                  file: fileValue
                };
                if (typeof fileValue === "string") {
                  fileObj.url = _this47.convertToRelativePath(fileValue);
                }
                listFileFields.push(fileObj);
                delete clonedObject[sectionFileModel];
              }
            }
          } catch (err) {
            _didIteratorError35 = true;
            _iteratorError35 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion35 && _iterator35.return) {
                _iterator35.return();
              }
            } finally {
              if (_didIteratorError35) {
                throw _iteratorError35;
              }
            }
          }

          listDependentObjectRequests.push(clonedObject);
        }
        if (requestBody[apiKey]) {
          requestBody[apiKey] = [].concat(_toConsumableArray(requestBody[apiKey]), listDependentObjectRequests);
        } else {
          requestBody[apiKey] = listDependentObjectRequests;
        }
        requestBody.file_urls = listFileFields;
      };

      for (var _dependentName4 in this.mapDependentObjects) {
        var _ret9 = _loop8(_dependentName4);

        if (_ret9 === "continue") continue;
      }
      this.saveMapDependentObjects();
    },
    setFileWithInfo: function setFileWithInfo(requestBody) {
      var _this48 = this;

      // File with info
      var listFileInfo = [];
      var listSaveFileInfo = [];
      var _iteratorNormalCompletion36 = true;
      var _didIteratorError36 = false;
      var _iteratorError36 = undefined;

      try {
        var _loop9 = function _loop9() {
          var fileInfoField = _step36.value;

          var saveFileInfos = _this48.tryGet(function () {
            return _this48.mapSavedFileInfo[fileInfoField.label];
          }) || [];
          listSaveFileInfo = [].concat(_toConsumableArray(listSaveFileInfo), _toConsumableArray(saveFileInfos));
          var fileInfos = _this48.mapFileInfo[fileInfoField.label];
          if (!fileInfos || !fileInfos.length) {
            return "continue";
          }
          listFileInfo = [].concat(_toConsumableArray(listFileInfo), _toConsumableArray(fileInfos));
        };

        for (var _iterator36 = this.listFileInfoFields[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
          var _ret10 = _loop9();

          if (_ret10 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError36 = true;
        _iteratorError36 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion36 && _iterator36.return) {
            _iterator36.return();
          }
        } finally {
          if (_didIteratorError36) {
            throw _iteratorError36;
          }
        }
      }

      if (!this.isUnchangedList(listSaveFileInfo, listFileInfo)) {
        requestBody["files"] = listFileInfo;
      }
      this.saveMapFileInfo();
    },
    submitTrackingApplicationData: function submitTrackingApplicationData() {
      var requestBody, listSignedDoc, listFileFields, _iteratorNormalCompletion37, _didIteratorError37, _iteratorError37, _iterator37, _step37, fileModel, trackingRequest, userTypes, res;

      return regeneratorRuntime.async(function submitTrackingApplicationData$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!this.hasDuplicatedEmailError) {
                _context18.next = 2;
                break;
              }

              return _context18.abrupt("return");

            case 2:
              if (!(!this.applicationData || !this.applicationData.email)) {
                _context18.next = 4;
                break;
              }

              return _context18.abrupt("return");

            case 4:
              // Convert email fields to lower case
              if (this.applicationData.email) {
                this.applicationData.email = this.applicationData.email.toLowerCase();
              }
              if (this.applicationData.email2) {
                this.applicationData.email2 = this.applicationData.email2.toLowerCase();
              }
              requestBody = _extends({}, this.applicationData, {
                status: this.preApplicationUserStatus || this.applicationAbandonStatus,
                tracking_id: this.registeredUserId,
                is_tracking: true,
                password: this.applicationData.password || this.applicationData.email
              });

              this.setUserType(requestBody);
              this.setDependentData(requestBody);
              if (this.listEvaluation && this.listEvaluation.length) {
                if (!this.isUnchangedList(this.listSavedEvaluations, this.listEvaluation)) {
                  requestBody.evaluations = this.listEvaluation;
                }
              }
              this.saveListEvaluations();
              // Signing document
              listSignedDoc = this.getSigningDocuments();

              if (listSignedDoc && listSignedDoc.length) {
                if (!this.isUnchangedList(this.listSavedDocuments, listSignedDoc)) {
                  requestBody["documents"] = listSignedDoc;
                }
              }
              this.saveListDocuments(listSignedDoc);

              // File field
              listFileFields = [];
              _iteratorNormalCompletion37 = true;
              _didIteratorError37 = false;
              _iteratorError37 = undefined;
              _context18.prev = 18;

              for (_iterator37 = this.listFileModels[Symbol.iterator](); !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                fileModel = _step37.value;

                if (this.applicationData[fileModel]) {
                  listFileFields.push({
                    model: fileModel,
                    type: "people",
                    file: this.applicationData[fileModel],
                    url: this.applicationData[fileModel]
                  });
                  delete requestBody[fileModel];
                }
              }
              _context18.next = 26;
              break;

            case 22:
              _context18.prev = 22;
              _context18.t0 = _context18["catch"](18);
              _didIteratorError37 = true;
              _iteratorError37 = _context18.t0;

            case 26:
              _context18.prev = 26;
              _context18.prev = 27;

              if (!_iteratorNormalCompletion37 && _iterator37.return) {
                _iterator37.return();
              }

            case 29:
              _context18.prev = 29;

              if (!_didIteratorError37) {
                _context18.next = 32;
                break;
              }

              throw _iteratorError37;

            case 32:
              return _context18.finish(29);

            case 33:
              return _context18.finish(26);

            case 34:
              if (listFileFields.length) {
                requestBody.file_urls = listFileFields;
              }
              this.setFileWithInfo(requestBody);

              trackingRequest = JSON.stringify(requestBody);

              if (!(trackingRequest === this.lastTrackingRequest)) {
                _context18.next = 39;
                break;
              }

              return _context18.abrupt("return");

            case 39:
              this.lastTrackingRequest = trackingRequest;

              // Set type conditions
              // Calculate type
              if (this.listTypeConditions && this.listTypeConditions.length) {
                userTypes = this.calculateUserProperties(this.listTypeConditions, this.applicationData, [], "type");

                if (userTypes && userTypes.length) {
                  requestBody.types = userTypes;
                  this.userTypes = userTypes;
                }
              }

              _context18.next = 43;
              return regeneratorRuntime.awrap(_axios2.default.post("/application-submit/?in_background=true", requestBody));

            case 43:
              res = _context18.sent;

              if (res && res.data) {
                if (!this.registeredUserId) {
                  this.registeredUserId = res.data.id;
                }
              } else {
                this.mapSavedDependentObjects = {};
                this.mapSavedFileInfo = {};
                this.listSavedDocuments = [];
              }

            case 45:
            case "end":
              return _context18.stop();
          }
        }
      }, null, this, [[18, 22, 26, 34], [27,, 29, 33]]);
    },
    handleClickEditName: function handleClickEditName() {
      var _this49 = this;

      this.showInputDialog({
        title: "Title",
        listFields: [{
          type: _customDefineType.FORM_TYPE.TEXTBOX,
          model: "name"
        }],
        data: {
          name: this.profile.name
        },
        onSubmitCallback: function onSubmitCallback(info) {
          return regeneratorRuntime.async(function onSubmitCallback$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _context19.next = 2;
                  return regeneratorRuntime.awrap(_axios2.default.patch("/api/profilesections/" + _this49.profile.id + "/", {
                    name: info.name
                  }));

                case 2:
                  _this49.reloadProfileBuilderList();

                case 3:
                case "end":
                  return _context19.stop();
              }
            }
          }, null, _this49);
        }
      });
    },
    handleClickEditDescription: function handleClickEditDescription() {
      var _this50 = this;

      this.showInputDialog({
        title: "Description",
        listFields: [{
          type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
          isRequired: false,
          model: "instructions"
        }],
        data: {
          instructions: this.profile.instructions || ""
        },
        onSubmitCallback: function onSubmitCallback(info) {
          return regeneratorRuntime.async(function onSubmitCallback$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  _context20.next = 2;
                  return regeneratorRuntime.awrap(_axios2.default.patch("/api/profilesections/" + _this50.profile.id + "/", {
                    instructions: info.instructions
                  }));

                case 2:
                  _this50.reloadProfileBuilderList();

                case 3:
                case "end":
                  return _context20.stop();
              }
            }
          }, null, _this50);
        }
      });
    },
    handleUploadFile: function handleUploadFile(info) {
      var _this51 = this;

      var fileLink, res, errorCode, profileInfo, basicInfo, day, month, year, listDependentKeys, mapApiKeyLabel, _iteratorNormalCompletion38, _didIteratorError38, _iteratorError38, _loop10, _iterator38, _step38, educations, references, experiences;

      return regeneratorRuntime.async(function handleUploadFile$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              fileLink = this.convertToAbsolutePath(info);
              // const fileLink = 'https://enginehireio-static-and-media.s3.amazonaws.com/media/user_upload_files/2/52/no_email/NWoZK3kTsExUVw/Tayler%20_McGee_Resume.pdf';

              _context21.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.post("https://vauctehb57kjsxa7rwgyz5a2ja0lodrf.lambda-url.us-east-2.on.aws/", {
                cv_url: fileLink,
                agency_id: this.agencyID
              }));

            case 3:
              res = _context21.sent;

              if (!(!res || !res.data || !res.data.data || !res.data.data.profile)) {
                _context21.next = 8;
                break;
              }

              errorCode = this.tryGet(function () {
                return res.data.error.code;
              });

              this.showErrorDialog({
                key: 'PARSE_CV_ERROR_DIALOG',
                params: [errorCode]
              });
              return _context21.abrupt("return");

            case 8:
              _context21.next = 10;
              return regeneratorRuntime.awrap(_axios2.default.post('/api/logs-management/log-event/', {
                component: 'Here API Lambda'
              }));

            case 10:
              profileInfo = res.data.data.profile;
              basicInfo = profileInfo.basics;

              if (basicInfo) {
                if (basicInfo.emails && basicInfo.emails.length) {
                  this.applicationData.email = basicInfo.emails[0];
                }
                if (basicInfo.phone_numbers && basicInfo.phone_numbers.length) {
                  this.applicationData.phone = basicInfo.phone_numbers[0];
                }
                if (basicInfo.first_name) {
                  this.applicationData.first_name = basicInfo.first_name;
                }
                if (basicInfo.last_name) {
                  this.applicationData.last_name = basicInfo.last_name;
                }
                if (basicInfo.date_of_birth && basicInfo.date_of_birth.day) {
                  day = basicInfo.date_of_birth.day;
                  month = basicInfo.date_of_birth.month;
                  year = basicInfo.date_of_birth.year;

                  if (day && month && year) {
                    if (month < 10) {
                      month = "0" + month;
                    }
                    if (day < 10) {
                      day = "0" + day;
                    }
                    this.applicationData.birthday = year + "-" + month + "-" + day;
                  }
                }
                if (basicInfo.address) {
                  this.applicationData.address1 = basicInfo.address;
                }
                this.applicationData = _extends({}, this.applicationData);
              }
              listDependentKeys = [];
              mapApiKeyLabel = {};
              _iteratorNormalCompletion38 = true;
              _didIteratorError38 = false;
              _iteratorError38 = undefined;
              _context21.prev = 18;

              _loop10 = function _loop10() {
                var itemLabel = _step38.value;

                var itemName = _this51.mapDependentLabelName[itemLabel];
                var apiKey = _this51.tryGet(function () {
                  return _fieldTypes.MAP_DIALOG_SECTION[itemName].apiKey;
                });
                if (apiKey && !listDependentKeys.includes(apiKey)) {
                  listDependentKeys.push(apiKey);
                  mapApiKeyLabel[apiKey] = itemLabel;
                }
              };

              for (_iterator38 = Object.keys(this.mapDependentLabelName)[Symbol.iterator](); !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                _loop10();
              }
              _context21.next = 27;
              break;

            case 23:
              _context21.prev = 23;
              _context21.t0 = _context21["catch"](18);
              _didIteratorError38 = true;
              _iteratorError38 = _context21.t0;

            case 27:
              _context21.prev = 27;
              _context21.prev = 28;

              if (!_iteratorNormalCompletion38 && _iterator38.return) {
                _iterator38.return();
              }

            case 30:
              _context21.prev = 30;

              if (!_didIteratorError38) {
                _context21.next = 33;
                break;
              }

              throw _iteratorError38;

            case 33:
              return _context21.finish(30);

            case 34:
              return _context21.finish(27);

            case 35:
              if (listDependentKeys.includes('education')) {
                educations = profileInfo.educations;

                if (educations && educations.length) {
                  this.mapDependentObjects[mapApiKeyLabel['education']] = educations.map(function (item) {
                    var education = {
                      type: mapApiKeyLabel['education'],
                      institution: item.issuing_organization,
                      graduated: !item.is_current
                    };
                    if (item.start_year) {
                      education.start_date = item.start_year + "-01-01";
                    }
                    if (item.end_year) {
                      education.end_date = item.end_year + "-01-01";
                    }
                    if (item.description) {
                      education.note = item.description;
                    }
                    return education;
                  });
                }
              }

              if (listDependentKeys.includes('references')) {
                references = profileInfo.references;

                if (references && references.length) {
                  this.mapDependentObjects[mapApiKeyLabel['references']] = references.map(function (item) {
                    var reference = {
                      type: mapApiKeyLabel['references'],
                      first_name: item.first_name,
                      last_name: item.last_name,
                      email: item.email,
                      phone: item.phone_number
                    };
                    return reference;
                  });
                }
              }

              if (listDependentKeys.includes('experiences')) {
                experiences = profileInfo.professional_experiences || profileInfo.experiences;

                if (experiences && experiences.length) {
                  this.mapDependentObjects[mapApiKeyLabel['experiences']] = experiences.map(function (item) {
                    var experience = {
                      type: mapApiKeyLabel['experiences'],
                      company_name: item.company,
                      person_worked_for_name: item.company,
                      title: item.title,
                      current_role: item.is_current
                    };
                    if (item.start_date && item.start_date.year) {
                      var _month = item.start_date.month || 1;
                      if (_month < 10) {
                        _month = "0" + _month;
                      }
                      experience.start_date = item.start_date.year + "-" + _month + "-01";
                    }
                    if (item.end_date && item.end_date.year) {
                      var _month2 = item.end_date.month || 1;
                      if (_month2 < 10) {
                        _month2 = "0" + _month2;
                      }
                      experience.end_date = item.end_date.year + "-" + _month2 + "-01";
                    }
                    return experience;
                  });
                }
              }
              this.mapDependentObjects = _extends({}, this.mapDependentObjects);

              console.log(res.data);

            case 40:
            case "end":
              return _context21.stop();
          }
        }
      }, null, this, [[18, 23, 27, 35], [28,, 30, 34]]);
    }
  })
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to detail information of fields by rows*/


var _customDefineType = __webpack_require__(6);

var _modelByTypes = __webpack_require__(91);

var _vuex = __webpack_require__(11);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "DetailSectionRowLayout",
  components: {
    RatingGroupDetail: function RatingGroupDetail() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 896));
    },
    RadioTableDetail: function RadioTableDetail() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 897));
    },
    CheckboxGroupDetail: function CheckboxGroupDetail() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 898));
    },
    ProductSelectionDetail: function ProductSelectionDetail() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 899));
    },
    StarRating: function StarRating() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 131));
    },
    CheckboxTable: function CheckboxTable() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 283));
    },
    HtmlSelectionDetail: function HtmlSelectionDetail() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 900));
    },
    DayHourSelectorDetail: function DayHourSelectorDetail() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 901));
    },
    SignatureDetail: function SignatureDetail() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 902));
    }
  },
  props: {
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelData: Object,
    labelKey: {
      type: String,
      default: "label"
    },
    listExcludeFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listHiddenIconFields: {
      //Show hidden icon next to field label
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listAdminOnlyIconFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hiddenIconTooltip: String,
    visibleIconTooltip: String,
    user: Object,
    tagData: Object,
    isInlineAnswer: {
      type: Boolean,
      default: false
    },
    hideDescription: {
      type: Boolean,
      default: false
    },
    hideLabelSpacing: {
      type: Boolean,
      default: false
    },
    builderField: Object
  },
  data: function data() {
    return {
      FORM_TYPE: _customDefineType.FORM_TYPE,
      FILE_TYPES: _customDefineType.FILE_TYPES
    };
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["agencyCurrency", "multipleFillersShiftJob", "listJobIdFillers", "isAgent"]), {
    isPrivateSection: function isPrivateSection() {
      return this.builderField && this.builderField.isPrivate;
    },
    listRowInput: function listRowInput() {
      var _this = this;

      return this.listFields.reduce(function (accResult, cur) {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        var lastEl = accResult[accResult.length - 1];
        if (_this.isFullBootstrapRow(lastEl)) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        accResult[accResult.length - 1].push(cur);
        // If need to display total years, add a field after end_date to display total years
        // if (this.hasTotalYearsFields && cur.model === "end_date") {
        //   accResult[accResult.length - 1].push({
        //     itemPerRow: 3,
        //     type: FORM_TYPE.TOTAL_YEARS,
        //     label: "Total Years",
        //   });
        // }
        return accResult;
      }, []);
    },
    hasTotalYearsFields: function hasTotalYearsFields() {
      var hasStartDateField = this.listFields.some(function (field) {
        return field.model === "start_date";
      });
      var hasEndDateField = this.listFields.some(function (field) {
        return field.model === "end_date";
      });
      return hasStartDateField && hasEndDateField;
    },
    editAccess: function editAccess() {
      if (!this.user || !this.user.id) {
        // Don't consider about edit access
        return null;
      }
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    language: function language() {
      return this.$store.getters.language;
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["handleUpdateBuilderField", "reloadProfileBuilderList"]), {
    getFieldProperty: function getFieldProperty(item, key) {
      if (item == null) {
        return "";
      }
      if (key === "label" && item.keyLangLabel) {
        return this.getLabelByKeys(item.keyLangLabel);
      }
      if (key === "description") {
        if (this.hideDescription) {
          return "";
        }
        if (item.hideDescriptionInViewScreen) {
          return "";
        }
      }
      if (key === "adminDescription" && item.hideAdminDescriptionInViewScreen) {
        return "";
      }
      if (!this.language) {
        return item[key];
      }
      if (item[key + "_lang_" + this.language]) {
        return item[key + "_lang_" + this.language];
      }
      return item[key];
    },
    getMapOptionListByLanguage: function getMapOptionListByLanguage(item) {
      if (!item.optionList) {
        return {};
      }
      var listOptionsByLangs = void 0;
      if (item.keyLangOptions) {
        listOptionsByLangs = this.getLabelByKeys(item.keyLangOptions);
      } else {
        if (!this.language) {
          return {};
        }
        if (!item["optionList_lang_" + this.language]) {
          return {};
        }
        listOptionsByLangs = this.convertStringToArray(item["optionList_lang_" + this.language]);
      }
      var listOptions = this.convertStringToArray(item.optionList);
      var result = {};
      for (var index = 0; index < listOptions.length; index++) {
        result[listOptions[index]] = listOptionsByLangs[index];
      }
      return result;
    },
    showDeleteFile: function showDeleteFile(item) {
      // User can delete if the file is not required
      if (this.user && this.user.id == this.$store.getters.userID) {
        return !item.isRequired;
      }
      return false;
    },
    hasAccessibleRelationship: function hasAccessibleRelationship(item) {
      var _this2 = this;

      // Non login user
      if (!this.$store.getters.userID) {
        return false;
      }
      if (!this.user) {
        return false;
      }
      var listAccessStatus = item.relationshipStatusAccessible;
      if (!listAccessStatus || !listAccessStatus.length) {
        return false;
      }
      if (!this.user.employers) {
        return false;
      }
      // Find logging in user in the list of relationship
      var relationship = this.user.employers.find(function (relationship) {
        return relationship.employer === _this2.$store.getters.userID && listAccessStatus.includes(relationship.status);
      });
      if (!relationship) {
        return false;
      }
      return true;
    },

    // Check if the field is visible to filler (candidate view private field of employer)
    isVisibleByFiller: function isVisibleByFiller(item) {
      var _this3 = this;

      // Non login user
      if (!this.$store.getters.userID) {
        return false;
      }
      if (!this.user) {
        return false;
      }
      if (!item.visibleToFiller) {
        return false;
      }
      if (!this.user.jobs) {
        return false;
      }
      // Check if there is at least 1 job which is assigned to the candidate
      if (this.multipleFillersShiftJob) {
        return this.user.jobs.some(function (job) {
          return job.filled && _this3.listJobIdFillers.includes(job.id);
        });
      } else {
        return this.user.jobs.some(function (job) {
          return job.filled && job.filler === _this3.$store.getters.userID;
        });
      }
    },
    getClassList: function getClassList(item) {
      // Check in case need to display total years in experience dialog
      if (["start_date", "end_date"].includes(item.model)) {
        if (this.hasTotalYearsFields) {
          return "col-lg-4";
        }
      }
      if (item.type === _customDefineType.FORM_TYPE.FILE && item.showAtTop) {
        return "";
      }
      if (item.type !== _customDefineType.FORM_TYPE.TAG_HTML) {
        // Not keep space if item is not displayed
        if (!this.isDisplayItem(item)) {
          return "";
        }
      }

      var itemPerRow = item.itemPerRow;
      if (itemPerRow === 0) {
        return "col";
      }
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    isDisplayItem: function isDisplayItem(item) {
      if (item.type === _customDefineType.FORM_TYPE.TOTAL_YEARS) {
        return true;
      }
      if (item.type === _customDefineType.FORM_TYPE.LIST_ITEMS) {
        return true;
      }
      if (this.listExcludeFields.includes(item.isShareModel ? item.model + "-" + item.shareModelIndex : item.model)) {
        return false;
      }
      if (item.model === "password") {
        return false;
      }
      if (item.type === _customDefineType.FORM_TYPE.CHECKBOX_CONDITION) {
        return false;
      }
      if (![_customDefineType.FORM_TYPE.LABEL, _customDefineType.FORM_TYPE.HTML].includes(item.type) && item.model == null) {
        return false;
      }
      // Private item is not showed in public access
      if (item.isPrivate && this.editAccess === false) {
        if (!this.hasAccessibleRelationship(item) && !this.isVisibleByFiller(item)) {
          return false;
        }
      }
      if (!this.isItemShow(this.modelData, item, this.listFields)) {
        return false;
      }
      if (item.type === _customDefineType.FORM_TYPE.LABEL) {
        return true;
      }
      if (this.isMissingField(this.modelData, item)) {
        return false;
      }
      if (item.keyNotNull) {
        if (this.modelData[item.keyNotNull] == null) {
          return false;
        }
      }
      if (item.keyNull) {
        if (this.modelData[item.keyNull] != null) {
          return false;
        }
      }
      return true;
    },
    getDisplayValue: function getDisplayValue(item, key) {
      var _this4 = this;

      if (item.type === _customDefineType.FORM_TYPE.TOTAL_YEARS) {
        return this.calculateDiffYears(this.modelData.start_date, this.modelData.end_date);
      }
      if (item.type === _customDefineType.FORM_TYPE.LABEL) {
        return item.model;
      }
      if (item.type === _customDefineType.FORM_TYPE.LIST_ITEMS) {
        return item.itemList;
      }
      var value = this.getValueOfObjectKey(this.modelData, key);
      if (_modelByTypes.MODEL_USER_PHONE_FIELD.includes(key)) {
        value = this.getDisplayPhone(value);
      }
      if (item.type === _customDefineType.FORM_TYPE.LIST_DATE_TIMES_PICKER) {
        return value.map(function (item) {
          return item.date;
        }).join("\n");
      }
      // Check to display multi-languages
      if (item.optionList && this.language) {
        var mapOptionList = this.getMapOptionListByLanguage(item);
        if (mapOptionList) {
          if (Array.isArray(value)) {
            var valueByLang = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var valueElement = _step.value;

                var valueElementByLang = mapOptionList[valueElement];
                if (valueElementByLang) {
                  valueByLang.push(valueElementByLang);
                } else {
                  valueByLang.push(valueElement);
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            value = valueByLang;
          } else if (typeof value === "string") {
            var _valueByLang = mapOptionList[value];
            if (_valueByLang) {
              value = _valueByLang;
            }
          }
        }
      }
      // Check share model
      if (item.isShareModel && Array.isArray(value)) {
        if (value[item.shareModelIndex]) {
          var result = value[item.shareModelIndex];
          if (item.type === _customDefineType.FORM_TYPE.RADIO) {
            result = this.removeOtherRadioPrefix(result);
          }
          return result;
        } else {
          return "";
        }
      }
      if (item.type === _customDefineType.FORM_TYPE.SALARY_RANGE) {
        if (value == null || value.length < 3) {
          return "";
        }
        if (item.hidePeriod) {
          return "From: " + this.currencySign(this.agencyCurrency) + value[0] + " To: " + this.currencySign(this.agencyCurrency) + value[1];
        } else {
          return "From: " + this.currencySign(this.agencyCurrency) + value[0] + " To: " + this.currencySign(this.agencyCurrency) + value[1] + " per " + value[2];
        }
      } else if (item.type === _customDefineType.FORM_TYPE.MONTH_PICKER) {
        return this.getDisplayMonthYear(value);
      }
      // Convert display of multiselect values with option label, option model
      if (item.type === _customDefineType.FORM_TYPE.MULTI_SELECT) {
        if (item.optionModel && item.optionLabel) {
          var optionList = this.getOptionsListByLanguage(item) || item.optionListAll;
          if (optionList) {
            if (Array.isArray(value)) {
              value = value.map(function (selectedOptionModel) {
                var selectedOption = optionList.find(function (option) {
                  return option[item.optionModel] === selectedOptionModel;
                });
                if (selectedOption) {
                  return selectedOption[item.optionLabel];
                }
                return selectedOptionModel;
              });
            } else {
              var selectedOption = optionList.find(function (option) {
                return option[item.optionModel] === value;
              });
              if (selectedOption) {
                value = selectedOption[item.optionLabel];
              }
            }
          }
        }
      }

      if (Array.isArray(value)) {
        return value.join("\n");
      }
      if (typeof value === "boolean") {
        return value ? this.getLabelByKeys("OPTIONS.YES") : this.getLabelByKeys("OPTIONS.NO");
      }
      if (item.type === _customDefineType.FORM_TYPE.FILE) {
        if (item.fileType === _customDefineType.FILE_TYPES.IMAGE) {
          // If it is a image file, create URL to display image
          if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && value != null) {
            return URL.createObjectURL(value);
          }
        }
      } else if (item.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
        if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
          return this.convertTimeAMPMToString(value);
        } else {
          return this.convertTimeStringToStringAMPM(value);
        }
      } else if (item.type === _customDefineType.FORM_TYPE.DATEPICKER) {
        var dateValue = this.tryGet(function () {
          return _this4.getDateString(value);
        }) || value;
        if (item.dateFormat) {
          dateValue = this.convertDate(value, "YYYY-MM-DD", item.dateFormat);
        }
        try {
          if (this.showAge(item)) {
            return this.calculateAgeInMonthsAndYears(value);
          }
          if (item.showPassedTime) {
            return dateValue + " (" + this.calculateAgeInMonthsAndYears(value) + ")";
          }
          if (item.model === "birthday" || this.tryGet(function () {
            return item.others;
          }).includes("Show Age")) {
            return dateValue + " (Age: " + this.calculateAgeInMonthsAndYears(value) + ")";
          }
          return dateValue;
        } catch (e) {
          return value;
        }
      } else if (item.type === _customDefineType.FORM_TYPE.DATETIME_PICKER) {
        try {
          return new Date(value).toUTCString();
        } catch (e) {
          return value;
        }
      } else if (item.type === _customDefineType.FORM_TYPE.YEAR_PICKER) {
        return this.getYearFromDate(value);
      } else if (item.type === _customDefineType.FORM_TYPE.LOGGING) {
        if (item.logItem === "Date Time") {
          if (value) {
            return new Date(value);
          }
        }
      } else if ([_customDefineType.FORM_TYPE.RADIO, _customDefineType.FORM_TYPE.MULTI_SELECT].includes(item.type)) {
        value = this.removeOtherRadioPrefix(value);
      }
      return value;
    },

    // Get label which is displayed in detail profile
    getDisplayLabel: function getDisplayLabel(item) {
      if (item.hideDetailLabel) {
        return null;
      }
      var result = void 0;
      // If keyLanglabel is defined, use it as label
      if (item.keyLangLabel && !item[this.labelKey]) {
        result = this.getLabelByKeys(item.keyLangLabel);
      }
      // Check if label is defined by language
      if (this.language) {
        // If labelDetail is defined, it is the displayed label
        if (item["labelKey_lang_" + this.language]) {
          result = item["labelKey_lang_" + this.language];
        }
        // If labelDetail is not defined or is an empty string, the corresponding label will be the displayed label
        if (result == null || result.trim().length === 0) {
          result = item["label_lang_" + this.language];
        }
      }
      // If labelDetail is defined, it is the displayed label
      if (result == null || result.trim().length === 0) {
        if (item[this.labelKey]) {
          result = item[this.labelKey];
        }
      }
      // If labelDetail is not defined or is an empty string, the corresponding label will be the displayed label
      if (result == null || result.trim().length === 0) {
        result = item.label;
      }
      if (result == null) {
        return null;
      }
      result = result.trim();
      // Remove * character at the end of displayed label
      if (result && result.length > 0) {
        if (result[result.length - 1] === "*") {
          result = result.substring(0, result.length - 1).trim();
        }
      }
      return result;
    },
    getOptionsListByLanguage: function getOptionsListByLanguage(item) {
      if (this.language) {
        if (item["optionList_lang_" + this.language]) {
          return item["optionList_lang_" + this.language];
        }
      }

      return item.optionList;
    },
    showDeleteFileConfirmDialog: function showDeleteFileConfirmDialog(model) {
      this.showConfirmDialog(_extends({}, this.$store.getters.deleteFileConfirmDialog, {
        onAcceptCallback: this.deleteFile,
        onAcceptCallbackData: model
      }));
    },
    deleteFile: function deleteFile(model) {
      this.$emit("deleteModel", model);
    },
    showAge: function showAge(item) {
      return !this.editAccess && (item.model === "birthday" || this.tryGet(function () {
        return item.others;
      }).includes("Show Age"));
    },
    handleClickToggleVisibility: function handleClickToggleVisibility(item, isVisible) {
      var _this5 = this;

      if (!this.isAgent) {
        return;
      }
      if (!this.builderField || !this.builderField.sectionBuilderId) {
        return;
      }
      this.showConfirmDialog({
        key: isVisible ? "MAKE_FIELD_VISIBLE_CONFIRM_DIALOG" : "MAKE_FIELD_HIDDEN_CONFIRM_DIALOG",
        onAcceptCallback: function onAcceptCallback() {
          var requestBody, res;
          return regeneratorRuntime.async(function onAcceptCallback$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  requestBody = {
                    model: item.model,
                    isPrivate: !isVisible
                  };
                  _context.next = 3;
                  return regeneratorRuntime.awrap(_this5.handleUpdateBuilderField({
                    builderId: _this5.builderField.sectionBuilderId,
                    requestBody: requestBody
                  }));

                case 3:
                  res = _context.sent;

                  if (res) {
                    _this5.reloadProfileBuilderList();
                  }

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, null, _this5);
        }
      });
    }
  })
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "StarRating",
  data: function data() {
    return {
      stars: this.value,
      starDesc: {},
      hoverItem: null
    };
  },

  props: {
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    value: {
      type: [Number, String]
    },
    maxStars: {
      type: Number,
      default: 5
    },
    ratingDescription: {
      type: Array,
      default: function _default() {
        return [{
          text: "Poor",
          class: "star-poor"
        }, {
          text: "Below Average",
          class: "star-belowAverage"
        }, {
          text: "Average",
          class: "star-average"
        }, {
          text: "Good",
          class: "star-good"
        }, {
          text: "Excellent",
          class: "star-excellent"
        }];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: false
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    starSize: {
      type: Number,
      default: 32
    },
    showRating: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    rate: function rate(star) {
      if (this.disabled) {
        return;
      }
      if (star <= this.maxStars && star >= 0) {
        this.stars = this.stars === star ? star - 1 : star;
      }
      this.$emit("input", this.stars);
    },
    hoverStar: function hoverStar(star) {
      if (this.disabled) {
        return;
      }
      this.hoverItem = star;
      if (star <= this.maxStars && star >= 0) {
        this.starDesc = this.ratingDescription[star - 1];
      }
    },
    mouseLeftStar: function mouseLeftStar() {
      if (this.disabled) {
        return;
      }
      this.hoverItem = null;
      if (this.stars) {
        this.starDesc = this.ratingDescription[this.stars - 1];
        return this.starDesc;
      } else {
        this.starDesc = "";
      }
    },
    getRatingDesc: function getRatingDesc(star) {
      if (star) {
        this.starDesc = this.ratingDescription[star - 1];
      }
      return this.starDesc;
    }
  }
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
This component is used to show a modal dialog
By using <modal> of vue-js-modal, it always show the dialog at center of screen
However, in some case, we want to show the dialog at a specific position (not center)
*/


var _vuex = __webpack_require__(11);

exports.default = {
  name: "ModalDialog",
  props: {
    // True if dialog is showed
    value: Boolean,
    width: {
      type: Number,
      default: 80
    },
    closeByClickOutside: {
      type: Boolean,
      default: false
    },
    // Specify layer in case of multiple dialog in screen. Dialog which higher level will be display at top
    level: {
      type: Number,
      default: 2
    },
    blockBackgroundScroll: {
      type: Boolean,
      default: true
    },
    hideCloseBtn: Boolean,
    useWhiteBgCloseButton: {
      type: Boolean,
      default: false
    },
    loadTimeout: {
      type: Number,
      default: 510
    },
    isInline: {
      type: Boolean,
      default: false
    },
    isInlinePin: {
      type: Boolean,
      default: false
    },
    showInRight: Boolean, // Show in right side of screen
    showInLeft: Boolean, // Show half side of the left
    isHidden: Boolean,
    topCloseBtn: {
      type: String,
      default: "1em"
    },
    rightCloseBtn: {
      type: String,
      default: "1em"
    }
  },
  data: function data() {
    return {
      topPosition: null,
      closeBtnTop: 0,
      isShow: false,
      baseZIndex: 9980 + 10 * this.level
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["iframePositionTop", "iframeParentHeight", "iframeScaleY", "agencyID", "isAgent"]), {
    maxHeightDialogContent: function maxHeightDialogContent() {
      if (this.agencyID && [24].includes(Number(this.agencyID))) {
        return this.iframeParentHeight - 200;
      } else {
        return this.iframeParentHeight - 100;
      }
    },
    dialogContentTop: function dialogContentTop() {
      if (this.topPosition == null) {
        return "unset";
      }
      return this.topPosition + "px";
    },
    dialogId: function dialogId() {
      return "enginehire-dialog-container-" + this._uid;
    },

    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed: function isEmbed() {
      if (this.isAgent) {
        return false;
      }
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    left: function left() {
      if (this.showInLeft) {
        return 0;
      }
      if (this.showInRight) {
        return 100 - this.width;
      }
      return (100 - this.width) / 2;
    }
  }),
  watch: {
    value: {
      handler: function handler(val) {
        var _this = this;

        this.$store.dispatch("setDialogScrollTop", 0);
        if (val && !this.isInlinePin) {
          this.isShow = true;
          // Find z-index of all existing modal dialog
          var listDialogElements = document.getElementsByClassName("overlay-panel");
          var maxZIndex = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = listDialogElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var element = _step.value;

              // Skip current element
              if (element.getAttribute("data-uid") === this._uid) {
                continue;
              }
              var zIndex = element.getAttribute("data-index");
              if (zIndex && zIndex > maxZIndex) {
                zIndex = Number(zIndex);
                if (zIndex > maxZIndex) {
                  maxZIndex = zIndex;
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (this.baseZIndex <= maxZIndex) {
            this.baseZIndex = maxZIndex + 1;
          }

          setTimeout(function () {
            // Dialog is open
            // Add class v--modal-block-scroll to the body
            if (_this.blockBackgroundScroll) {
              document.body.classList.add("v--modal-block-scroll");
            }
            var boundingRect = _this.$refs.dialogContent.getBoundingClientRect();
            console.log(boundingRect, window.innerHeight);
            _this.closeBtnTop = boundingRect.top - 18;
            var dialogHeight = boundingRect.height;
            if (_this.isEmbed) {
              var top = void 0;
              if (_this.iframePositionTop) {
                top = 0 - _this.iframePositionTop;
                if (_this.iframeScaleY) {
                  top = top / _this.iframeScaleY;
                }
              } else {
                top = _this.$store.getters.lastClickY - dialogHeight + 30;
              }
              if (top < 0) {
                top = 0;
              }
              if (top < 100) {
                if (_this.iframeParentHeight && dialogHeight < _this.iframeParentHeight - 100) {
                  top = 100;
                }
              }
              _this.topPosition = top;
            } else {
              _this.topPosition = (window.innerHeight - dialogHeight) / 2;
              console.log(_this.topPosition);
              if (_this.width >= 90) {
                if (_this.topPosition > window.innerHeight * 0.1) {
                  _this.topPosition = window.innerHeight * 0.05;
                }
              }
            }
            setTimeout(function () {
              _this.closeBtnTop = _this.$refs.dialogContent.getBoundingClientRect().top - 18;
            }, 10);
          }, this.loadTimeout);
        } else {
          if (this.$refs.modal && this.$refs.modal.classList) {
            this.$refs.modal.classList.add("closing-dialog");
          }
          this.isShow = false;
          // Remove class v--modal-block-scroll to the body
          if (this.blockBackgroundScroll) {
            document.body.classList.remove("v--modal-block-scroll");
            document.body.style.paddingRight = null;
          }
        }
      },

      immediate: true
    },
    level: {
      handler: function handler(val) {
        this.baseZIndex = 9980 + 10 * this.level;
      },

      immediate: true
    }
  },
  methods: {
    handleScrollDialog: function handleScrollDialog(event) {
      this.$store.dispatch("setDialogScrollTop", event.target.scrollTop);
    },
    handleCloseDialog: function handleCloseDialog() {
      this.$emit("close");
      this.$emit("input", false);
    }
  }
};

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSectionWithDialog_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSectionWithDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSectionWithDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSectionWithDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSectionWithDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480ead33_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingSectionWithDialog_vue__ = __webpack_require__(599);
function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-480ead33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSectionWithDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_480ead33_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingSectionWithDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _UpdateBookingDialog = __webpack_require__(538);

var _UpdateBookingDialog2 = _interopRequireDefault(_UpdateBookingDialog);

var _ReportProblemButtons = __webpack_require__(581);

var _ReportProblemButtons2 = _interopRequireDefault(_ReportProblemButtons);

var _customDefineType = __webpack_require__(6);

var _defaultValues = __webpack_require__(17);

var _vueSimpleCalendar = __webpack_require__(284);

var _BookingPriceInfo = __webpack_require__(207);

var _BookingPriceInfo2 = _interopRequireDefault(_BookingPriceInfo);

var _PriceInfoCalculation = __webpack_require__(209);

var _PriceInfoCalculation2 = _interopRequireDefault(_PriceInfoCalculation);

var _vuex = __webpack_require__(11);

var _CheckboxItem = __webpack_require__(220);

var _CheckboxItem2 = _interopRequireDefault(_CheckboxItem);

var _DataTable = __webpack_require__(222);

var _DataTable2 = _interopRequireDefault(_DataTable);

var _vuejsDatepicker = __webpack_require__(285);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _jobSettings = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

__webpack_require__(597);


/**
 * The component is used to show for the booking section
 */
exports.default = {
  name: "BookingSectionWithDialog",
  props: {
    id: String,
    user: Object,
    sectionTitle: String,
    // Description which are only visible to admin
    adminDescription: String,
    description: String,
    name: String,
    listFields: Array,
    keyTitles: {
      type: Array,
      default: function _default() {
        return ["name"];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    submitClicked: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: ""
    },
    categoryList: {
      type: String,
      default: ""
    },
    // If number of children is more than that, additional fee will be added
    numberOfAllowedChildren: {
      type: Number,
      default: 1
    },
    // Minimum number of item
    minCount: Number,
    api: String,
    excludeChildrenQuestion: {
      type: Boolean,
      default: false
    },
    excludeAddressQuestion: {
      type: Boolean,
      default: false
    },
    excludeRepeatBooking: {
      type: Boolean,
      default: false
    },
    hasNumberCandidateQuestion: {
      type: Boolean,
      default: false
    },
    hideAdditionalDateQuestion: {
      type: Boolean,
      default: false
    },
    bookingRequirePaymentInfo: {
      type: Boolean,
      default: false
    },
    selectAllDaysForRecurringRequests: {
      type: Boolean,
      default: false
    },
    bookingField: {
      type: Object,
      default: function _default() {}
    },
    chargeClientWhenBooking: {
      type: Boolean,
      default: false
    },
    chargeClientWhenAssign: {
      // Setting in profile type builder
      type: Boolean,
      default: false
    },
    includeCandidatePayment: {
      type: Boolean,
      default: false
    },
    isInApplicationForm: {
      type: Boolean,
      default: false
    },
    employerTypesNotCharge: {
      type: Array
    },
    multipleBookingSections: {
      type: Boolean,
      default: false
    },
    shiftJobProblemReports: {
      type: Boolean,
      default: false
    },
    profileBuilderID: Number
  },
  mixins: [_PriceInfoCalculation2.default],
  components: {
    UpdateBookingDialog: _UpdateBookingDialog2.default,
    CalendarView: _vueSimpleCalendar.CalendarView,
    CalendarViewHeader: _vueSimpleCalendar.CalendarViewHeader,
    BookingPriceInfo: _BookingPriceInfo2.default,
    CheckboxItem: _CheckboxItem2.default,
    DataTable: _DataTable2.default,
    Datepicker: _vuejsDatepicker2.default,
    ReportProblemButtons: _ReportProblemButtons2.default
  },
  data: function data() {
    return {
      isShowBookingDialog: false,
      booking: {},
      isAddBookingDialog: false,
      indexOfEdittingBooking: 0,
      showDate: new Date(),
      calendarJobs: [],
      dialogTitle: "",
      selectedDate: null,
      batchID: null,
      originalJob: {}, // Job before edit,
      hidePastBooking: true,
      bookingData: [],
      JOB_STATUSES: _customDefineType.JOB_STATUSES,
      expandingID: -1,
      tempID: 0, // id of booking before adding to DB
      isShowAssignee: false,
      selectedJob: {},
      listJobFiller: [],
      FORM_TYPE: _customDefineType.FORM_TYPE,
      creditCount: 0,
      hasDateQuestion: false,
      DEFAULT_DISCLAIMER_TEXT: _defaultValues.DEFAULT_DISCLAIMER_TEXT,
      candidateList: [],
      isTableView: false,
      filterStart: null,
      filterEnd: null,
      tab: "month",
      CLIENT_BOOKING_SETTINGS: _jobSettings.CLIENT_BOOKING_SETTINGS,
      DISCLAIMER_TEXT_ADDING_BOOKING_SETTING: _jobSettings.DISCLAIMER_TEXT_ADDING_BOOKING_SETTING,
      numberOfPastDays: 30,
      smsFooter: "",
      isShowSectionBuilderUpSertDialog: false,
      currentPage: 1
    };
  },
  created: function created() {
    var res, smsFooterObj;
    return regeneratorRuntime.async(function created$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return regeneratorRuntime.awrap(this.loadPriceList());

          case 2:
            if (!(!this.api && (this.clientCanAssignShiftJobApplicationForm || this.autoAssignCandidate))) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return regeneratorRuntime.awrap(_axios2.default.get("get-public-candidates-list/?agency=" + this.agencyID));

          case 5:
            res = _context.sent;

            this.candidateList = res.data.users;
            this.setPublicCandidateList(this.candidateList);

          case 8:
            if (!(this.user && this.user.id)) {
              _context.next = 11;
              break;
            }

            _context.next = 11;
            return regeneratorRuntime.awrap(this.loadPreviousMatchCandidatesByEmployer(this.user.id));

          case 11:
            _context.next = 13;
            return regeneratorRuntime.awrap(this.getAdminSetting());

          case 13:
            smsFooterObj = _context.sent;

            if (smsFooterObj && smsFooterObj.smsFooter) {
              this.smsFooter = "\n\n" + smsFooterObj.smsFooter;
            }

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, null, this);
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["jobStatusAfterClientSelectCandidate", "JobStatusClientCantEditShiftBookings", "isAgent", "priceList", "hourlyServiceSelectionList", "quickbooksPriceSelectionList", "candidateListMainInfo", "tentativeAssignStatus", "jobTypeShortTermQuery", "agency", "sendNotificationToFillerOnChange", "notifyAllApplicants", "clientCanSelectMultipleCandidates", "showWeeklyScheduleReleaseButton", "preReleaseShiftJobStatus", "disclaimerTextBookingSection", "showIdClientSideShiftJobCalendar", "clientCanAssignShiftJob", "clientCanAssignShiftJobApplicationForm", "agencyID", "employerShiftRequestEmails", "acceptJobsByGroup", "multipleFillersShiftJob", "hideCandidateLastNameForShiftJobs", "autoAssignCandidate", "agencyCurrency", "clientTypesViewOnlyBooking", "createBookingGroupNotificationEmails", "agencyCurrencySign", "wordUsedForCandidates", "shiftJobStatusesWhereJobStatusVisible", "jobStatusesRefund", "onlyRefundForNonFilledJob", "includeBookingCancelReasonInCandidateEmail", "hideCandidatePreReleaseStatus", "clientTypesUseBookingCredits", "agencyUseBookingCredits", "doNotAutoPopulateAddress", "getCandidateBadge", "allowBookOnBlockedDate", "customMinutesIntervalBookingTime", "listPreviousMatchCandidatesOfEmployer", "language", "doNotBookOutsideOfficeHours", "warningBookOutsideOfficeHours"]), {
    employerShiftRequestEmailsByLocation: function employerShiftRequestEmailsByLocation() {
      var _this = this;

      var listLocations = this.getJobLocations(this.user, this.booking);
      return this.getListEmailSubmissionNotification(this.employerShiftRequestEmails, this.tryGet(function () {
        return _this.$store.getters.agency.advance_setting.employer_shift_request_emails_by_locations;
      }), listLocations);
    },
    employerShiftChangeRequestEmailsByLocation: function employerShiftChangeRequestEmailsByLocation() {
      var _this2 = this;

      if (!this.$store.getters.agency) {
        return [];
      }
      var listLocations = this.getJobLocations(this.user, this.booking);
      return this.getListEmailSubmissionNotification(this.$store.getters.agency.employer_shift_change_request_emails, this.tryGet(function () {
        return _this2.$store.getters.agency.advance_setting.employer_shift_change_request_emails_by_locations;
      }), listLocations);
    },

    // Cannot add or edit or delete bookings
    isViewOnly: function isViewOnly() {
      if (this.user && this.user.types && this.clientTypesViewOnlyBooking && this.clientTypesViewOnlyBooking.length) {
        if (this.hasCommonElement(this.user.types, this.clientTypesViewOnlyBooking)) {
          return true;
        }
      }
      return false;
    },
    listTableFieldsBooking: function listTableFieldsBooking() {
      var _this3 = this;

      var result = [{
        displayLabel: "Date",
        model: "date",
        sort_model: "date",
        transformFunction: this.getTitle
      }, {
        displayLabel: "Candidate",
        model: "filler_name",
        transformFunction: this.getBookingFillerName
      }, {
        displayLabel: "Category",
        model: "category"
      }, {
        displayLabel: "Start Time",
        model: "start_time"
      }, {
        displayLabel: "End Time",
        model: "end_time"
      }, {
        displayLabel: "Hours",
        model: "hours_worked"
      }, {
        displayLabel: "Rate",
        model: "client_rate",
        transformFunction: function transformFunction(booking) {
          if (!booking || !booking.client_rate) {
            return;
          }
          return "" + _this3.currencySign(_this3.agencyCurrency) + booking.client_rate + "/hr";
        }
      }, {
        displayLabel: "Total",
        model: "total_client_charge",
        transformFunction: function transformFunction(booking) {
          if (!booking || !booking.total_client_charge) {
            return;
          }
          return "" + _this3.currencySign(_this3.agencyCurrency) + booking.total_client_charge;
        }
      }];
      if (this.hourlyServiceSelectionList && this.hourlyServiceSelectionList.length) {
        result.splice(4, 0, {
          displayLabel: "Service",
          model: "title"
        });
      }
      return result;
    },
    mapBookingGroup: function mapBookingGroup() {
      // map group_id => list of jobs
      var result = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.bookingData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var job = _step.value;

          if (job.job_group) {
            var list_jobs = [];
            if (result[job.job_group]) {
              list_jobs = result[job.job_group];
            }
            list_jobs.push(job);
            result[job.job_group] = list_jobs;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    defaultShiftJobStatus: function defaultShiftJobStatus() {
      if (this.agency) {
        var listStatuses = this.agency.shift_job_statuses;
        if (listStatuses == null || listStatuses.length === 0) {
          return _defaultValues.DEFAULT_SHIFT_JOB_STATUSES.map(function (item) {
            return item.status;
          });
        }
        return listStatuses.map(function (item) {
          return item.status;
        });
      } else {
        return [];
      }
    },

    // Use in PRICE_INFO_CALCULATION_MIXIN
    listPrices: function listPrices() {
      return this.priceList;
    },
    cancellationPolicy: function cancellationPolicy() {
      var _this4 = this;

      return this.tryGet(function () {
        return _this4.bookingField.additionalInformation.cancellation_policy.segments;
      }) || [];
    },
    listBookingFields: function listBookingFields() {
      return this.getListShowFields(false);
    },
    listDisplayBookingFields: function listDisplayBookingFields() {
      return this.getListShowFields(true);
    },
    posterName: function posterName() {
      if (!this.user) {
        return "";
      }
      if (this.user.first_name && this.user.last_name) {
        return this.user.first_name + " " + this.user.last_name;
      } else if (this.user.name) {
        return this.user.name;
      }
    },
    listShowBooking: function listShowBooking() {
      var _this5 = this;

      var bookingData = this.bookingData;
      if (this.hidePastBooking) {
        if (this.bookingData == null) {
          return [];
        }
        bookingData = this.bookingData.filter(function (booking) {
          return !_this5.isPastBooking(booking);
        });
      }
      // Sort booking by date
      bookingData = bookingData.sort(function (booking1, booking2) {
        if (booking1.start_time && booking2.start_time) {
          return new Date(booking1.date + "T" + booking1.start_time) >= new Date(booking2.date + "T" + booking2.start_time) ? 1 : -1;
        } else {
          return new Date(booking1.date) >= new Date(booking2.date) ? 1 : -1;
        }
      });
      if (this.numberOfPastDays) {
        var filterStart = this.addDaysToDate(0 - Number(this.numberOfPastDays));
        bookingData = bookingData.filter(function (job) {
          return job.date >= _this5.dateInDjangoFormat(filterStart);
        });
      }
      return bookingData;
    },
    listShowBookingCurrentPage: function listShowBookingCurrentPage() {
      return this.listShowBooking.slice((this.currentPage - 1) * 100, this.currentPage * 100);
    },
    totalPage: function totalPage() {
      return Math.ceil(this.listShowBooking.length / 100);
    },
    listShowBookingTableView: function listShowBookingTableView() {
      var _this6 = this;

      var filteredResult = this.listShowBooking;
      if (this.filterStart) {
        filteredResult = filteredResult.filter(function (job) {
          return job.date >= _this6.dateInDjangoFormat(_this6.filterStart);
        });
      }

      if (this.filterEnd) {
        filteredResult = filteredResult.filter(function (job) {
          return job.date <= _this6.dateInDjangoFormat(_this6.filterEnd);
        });
      }
      return filteredResult;
    },
    listZipCodes: function listZipCodes() {
      if (this.bookingField.additionalInformation && this.bookingField.additionalInformation.list_zip_codes) {
        return this.bookingField.additionalInformation.list_zip_codes.split(",").map(function (item) {
          return item.trim();
        });
      }
      return [];
    },
    listShowCalendarJobs: function listShowCalendarJobs() {
      return this.calendarJobs;
    },
    listPriceServices: function listPriceServices() {
      var _this7 = this;

      // Not show in the application form (because user type is not defined)
      if (!this.user || !this.user.id) {
        return [];
      }
      var result = this.hourlyServiceSelectionList;
      // Filter by types
      result = result.filter(function (price) {
        return !price.user_types || !price.user_types.length || _this7.containsAllElements(_this7.user.types, price.user_types);
      });
      // Filter by locations
      result = result.filter(function (price) {
        return !price.locations || !price.locations.length || _this7.hasCommonElement(price.locations, _this7.user.locations);
      });

      result.forEach(function (price) {
        var label = price.name;
        if (price.price2) {
          label = label + ", $" + price.price2 + " per hour";
        }
        price.label = label;
      });
      return result;
    },
    disclaimerText: function disclaimerText() {
      if (!this.disclaimerTextBookingSection || this.disclaimerTextBookingSection === "<br>") {
        return this.DEFAULT_DISCLAIMER_TEXT;
      }
      return this.disclaimerTextBookingSection;
    },
    editAccess: function editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true;
      } else {
        return false;
      }
    },
    maxNumberChildrenAllowed: function maxNumberChildrenAllowed() {
      if (this.bookingField && this.bookingField.maxNumberChildrenAllowed) {
        return this.bookingField.maxNumberChildrenAllowed;
      }
      return 10;
    },
    listUpSertBookingFields: function listUpSertBookingFields() {
      var _this8 = this;

      this.listBookingFields.forEach(function (item) {
        if (_this8.tryGet(function () {
          return item.model === "start_time";
        }) || _this8.tryGet(function () {
          return item.model === "end_time";
        })) {
          if (!item.minutesInterval) {
            item.minutesInterval = _this8.customMinutesIntervalBookingTime;
          }
        }
        if (_this8.tryGet(function () {
          return item.model === "additional_dates";
        })) {
          item.minutesInterval = _this8.customMinutesIntervalBookingTime;
        }
      });
      if (this.hasDateQuestion) {
        return [{
          type: _customDefineType.FORM_TYPE.DATEPICKER,
          keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_DATE",
          model: "date",
          initialView: "day",
          minDate: this.isAgent ? null : new Date()
        }].concat(_toConsumableArray(this.listBookingFields));
      } else {
        return this.listBookingFields;
      }
    },
    listFieldsUpdateBooking: function listFieldsUpdateBooking() {
      return [{
        type: _customDefineType.FORM_TYPE.DATEPICKER,
        keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_DATE",
        model: "date",
        initialView: "day",
        minDate: this.isAgent ? null : new Date()
      }].concat(_toConsumableArray(this.listBookingFields));
    },
    bookingCancellationReason: function bookingCancellationReason() {
      return this.includeBookingCancelReasonInCandidateEmail && this.booking.cancel_reason ? "Reason: " + this.booking.cancel_reason : "";
    },
    hasDurationField: function hasDurationField() {
      return this.listFields && this.listFields.some(function (field) {
        return field.model === "duration";
      });
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["createShiftJob", "updateShiftJob", "loadPriceList", "loadCandidateListMainInfo", "updateFillersOfJob", "setPublicCandidateList", "loadPreviousMatchCandidatesByEmployer", "reloadProfileBuilderList"]), {
    getBookingSummary: function getBookingSummary(booking) {
      var title = this.getTitle(booking);
      if (booking.start_time && booking.end_time) {
        title += " (" + this.convertTimeStringToStringAMPM(booking.start_time) + " - " + this.convertTimeStringToStringAMPM(booking.end_time) + ")";
      }
      return title;
    },
    showAddGroupDialog: function showAddGroupDialog() {
      var _this9 = this;

      var optionList = [];
      var listNonPastBookings = this.bookingData.filter(function (booking) {
        return !_this9.isPastBooking(booking);
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = listNonPastBookings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var booking = _step2.value;

          optionList.push({
            label: this.getBookingSummary(booking),
            id: booking.id
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.showInputDialog({
        title: "Add Booking Group",
        listFields: [{
          label: "Select Bookings",
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          isMulti: true,
          model: "ids",
          optionList: optionList,
          optionModel: "id",
          optionLabel: "label"
        }],
        onSubmitCallback: this.createBookingGroup
      });
    },
    createBookingGroup: function createBookingGroup(info) {
      var _this10 = this;

      var jobInfos, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _loop, _iterator3, _step3;

      return regeneratorRuntime.async(function createBookingGroup$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.post("/create-job-group/", {
                poster: this.user.id,
                agency: this.$store.getters.agencyID,
                agency_owner: this.$store.getters.agencyName,
                jobs: info.ids
              }));

            case 2:
              if (!(this.createBookingGroupNotificationEmails && this.createBookingGroupNotificationEmails.length)) {
                _context2.next = 25;
                break;
              }

              jobInfos = "";
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context2.prev = 7;

              _loop = function _loop() {
                var id = _step3.value;

                var booking = _this10.bookingData.find(function (booking) {
                  return booking.id === id;
                });
                jobInfos += "\n" + _this10.getBookingSummary(booking);
              };

              for (_iterator3 = info.ids[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                _loop();
              }
              _context2.next = 16;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](7);
              _didIteratorError3 = true;
              _iteratorError3 = _context2.t0;

            case 16:
              _context2.prev = 16;
              _context2.prev = 17;

              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }

            case 19:
              _context2.prev = 19;

              if (!_didIteratorError3) {
                _context2.next = 22;
                break;
              }

              throw _iteratorError3;

            case 22:
              return _context2.finish(19);

            case 23:
              return _context2.finish(16);

            case 24:
              this.sendEmail(_extends({}, this.$store.getters.bookingGroupCreatedAgencyNotificationEmailTemplate, {
                recipients: this.createBookingGroupNotificationEmails
              }), jobInfos, this.user.first_name, this.user.last_name, this.user.email);

            case 25:
              this.loadListBooking();

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, [[7, 12, 16, 24], [17,, 19, 23]]);
    },
    canEditBooking: function canEditBooking(status) {
      var _this11 = this;

      if (this.tryGet(function () {
        return _this11.JobStatusClientCantEditShiftBookings.length;
      })) {
        return !this.JobStatusClientCantEditShiftBookings.includes(status);
      }
      return true;
    },

    // Fee client pay agency per booking
    getAgencyFee: function getAgencyFee() {
      var amount = 0;
      if (!this.listShowBooking || !this.$refs.priceInfo) {
        return 0;
      }
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.$refs.priceInfo[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var priceInfoRef = _step4.value;

          var perBookingAgencyFee = priceInfoRef.totalPerBookingAgencyFee;
          if (perBookingAgencyFee) {
            amount += Number(perBookingAgencyFee);
          }
          var agencyRate = priceInfoRef.agencyRate;
          if (agencyRate) {
            amount += priceInfoRef.bookingDuration * Number(agencyRate);
          }
          // Rush fee is fee pay to agency
          var rushFee = priceInfoRef.rushFee;
          if (rushFee) {
            amount += Number(rushFee);
          }
          // Admin fee
          var adminFee = priceInfoRef.adminFee;
          if (adminFee) {
            amount += Number(adminFee);
          }
          var adminFeeSubstraction = priceInfoRef.adminFeeSubstraction;
          if (adminFeeSubstraction) {
            amount += Number(adminFeeSubstraction);
          }
          var totalDiscount = priceInfoRef.totalDiscount;
          if (totalDiscount) {
            amount = amount - Number(totalDiscount);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return amount;
    },

    // Fee client pay agency and candidate per booking
    getTotalFee: function getTotalFee() {
      var amount = 0;
      if (!this.listShowBooking || !this.$refs.priceInfo) {
        return 0;
      }
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.$refs.priceInfo[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var priceInfoRef = _step5.value;

          var flatRate = priceInfoRef.totalFlatRate;
          if (flatRate) {
            amount += flatRate;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return amount;
    },
    getListShowFields: function getListShowFields(isForView) {
      var _this12 = this;

      var listFields = Object.assign([], this.listFields);
      if (!this.isAgent && this.bookingField.listModelsAdminOnly) {
        listFields = listFields.filter(function (field) {
          return !_this12.bookingField.listModelsAdminOnly.includes(field.model);
        });
      }
      if (isForView) {
        listFields = listFields.filter(function (field) {
          return field.type !== _customDefineType.FORM_TYPE.HTML;
        });
      }

      if (this.isAddBookingDialog && !this.excludeRepeatBooking) {
        // Find position to insert repeat fields
        var insertIndex = 0;
        for (var index = listFields.length - 1; index >= 0; index--) {
          // repeat fields are insert after the date, time fields
          if (["date", "start_time", "end_time", "end_date"].includes(listFields[index].model)) {
            insertIndex = index + 1;
            break;
          }
        }
        // Find recurring preset fields
        var recurringFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Recurring Fields";
        });
        if (recurringFieldIndex !== -1) {
          insertIndex = recurringFieldIndex;
        }
        listFields.splice(insertIndex, 0, {
          type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT",
          model: "repeat",
          isRequired: false
        });
        listFields.splice(insertIndex + 1, 0, {
          type: _customDefineType.FORM_TYPE.DATEPICKER,
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT_UNTIL",
          model: "repeat_end_date",
          showIf: "repeat",
          minDate: this.selectedDate,
          initialView: "day"
        });
        listFields.splice(insertIndex + 2, 0, {
          type: _customDefineType.FORM_TYPE.LABEL,
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT_EVERY",
          showIf: "repeat"
        });
        listFields.splice(insertIndex + 3, 0, {
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          model: "repeat_count",
          optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          showIf: "repeat",
          itemPerRow: 2,
          defaultValue: 0
        });
        listFields.splice(insertIndex + 4, 0, {
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          model: "repeat_type",
          optionList: ["Days", "Weeks"],
          keyLangOptions: "BOOKING_DIALOG.OPTIONS.REPEAT_TYPE",
          showIf: "repeat",
          itemPerRow: 2,
          defaultValue: 1
        });
        listFields.splice(insertIndex + 5, 0, {
          type: _customDefineType.FORM_TYPE.CHECKBOX,
          model: "repeat_weekdays",
          keyLangLabel: "BOOKING_DIALOG.LABEL.REPEAT_ON",
          keyLangOptions: "BOOKING_DIALOG.OPTIONS.REPEAT_ON",
          optionList: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          showIf: "repeat_type",
          showIfValue: ["Weeks"],
          hasCheckAll: true,
          markAllAsChecked: this.selectAllDaysForRecurringRequests
        });
      }

      if (this.hasNumberCandidateQuestion && this.isAddBookingDialog) {
        listFields.push({
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          keyLangLabel: "BOOKING_DIALOG.LABEL.NUMBER_CANDIDATE",
          keyLangLabelParams: [this.wordUsedForCandidates],
          optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
          model: "number_candidate",
          isRequired: false,
          defaultValue: 0
        });
      }

      if (this.listPriceServices && this.listPriceServices.length) {
        // Find service selection preset fields
        var serviceSelectionFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Service Selection";
        });
        this.insertArrayInArray(listFields, [{
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_SERVICE",
          optionListAll: this.listPriceServices,
          isMulti: false,
          optionModel: "name",
          optionLabel: "label",
          model: "title"
        }], serviceSelectionFieldIndex);
      }
      if (this.quickbooksPriceSelectionList && this.quickbooksPriceSelectionList.length) {
        // Find quickbooks price selection preset field
        var quickbookPriceSelectionFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Quickbooks Price Selection";
        });
        if (quickbookPriceSelectionFieldIndex >= 0) {
          this.insertArrayInArray(listFields, [{
            type: _customDefineType.FORM_TYPE.MULTI_SELECT,
            keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_QUICKBOOKS_PRICE",
            optionListAll: this.quickbooksPriceSelectionList,
            isMulti: false,
            optionModel: "id",
            optionLabel: "name",
            model: "qbd_pricing_id"
          }], quickbookPriceSelectionFieldIndex);
        }
      }
      // Find candidate selection preset fields
      var candidateSelectionFieldIndex = listFields.findIndex(function (field) {
        return field.presetFields === "Candidate Selection";
      });
      if (candidateSelectionFieldIndex >= 0) {
        this.insertArrayInArray(listFields, [_extends({}, listFields[candidateSelectionFieldIndex], {
          type: _customDefineType.FORM_TYPE.SLOT,
          label: listFields[candidateSelectionFieldIndex].label || "Candidate Selection"
        })], candidateSelectionFieldIndex);
      }
      if (!this.hideAdditionalDateQuestion && !this.hasDurationField) {
        // Find Add Additional Dates preset fields
        var addAdditionalDatesFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Add Additional Dates";
        });
        var additionalDateField = {
          type: _customDefineType.FORM_TYPE.LIST_DATE_TIMES_PICKER,
          keyLangLabel: "BOOKING_DIALOG.LABEL.ADDITIONAL_DATES",
          model: "additional_dates",
          isRequired: false,
          allowPastDate: false
        };
        if (addAdditionalDatesFieldIndex == -1) {
          listFields.splice(0, 0, additionalDateField);
        } else {
          this.insertArrayInArray(listFields, [additionalDateField], addAdditionalDatesFieldIndex);
        }
      }
      if (!this.excludeAddressQuestion) {
        var listAddressFields = [];
        listAddressFields.push({
          type: _customDefineType.FORM_TYPE.TEXTBOX,
          keyLangLabel: "BOOKING_DIALOG.LABEL.BOOKING_ADDRESS",
          model: "address1"
        });
        listAddressFields.push({
          type: _customDefineType.FORM_TYPE.TEXTBOX,
          keyLangLabel: "BOOKING_DIALOG.LABEL.ADDRESS_LINE2",
          hideDetailLabel: true,
          model: "address2",
          isRequired: false
        });
        if (isForView) {
          listAddressFields.push({
            type: _customDefineType.FORM_TYPE.TAG_HTML,
            hideDetailLabel: true,
            itemPerRow: 1,
            model: "[[city]], [[provincestate]], [[postal_code]]"
          });
        } else {
          listAddressFields.push({
            type: _customDefineType.FORM_TYPE.TEXTBOX,
            keyLangLabel: "BOOKING_DIALOG.LABEL.CITY",
            hideDetailLabel: true,
            itemPerRow: 3,
            model: "city"
          });
          listAddressFields.push({
            type: _customDefineType.FORM_TYPE.TEXTBOX,
            keyLangLabel: "BOOKING_DIALOG.LABEL.STATE",
            hideDetailLabel: true,
            itemPerRow: 3,
            model: "provincestate"
          });
          if (this.listZipCodes && this.listZipCodes.length) {
            listAddressFields.push({
              type: _customDefineType.FORM_TYPE.MULTI_SELECT,
              keyLangLabel: "BOOKING_DIALOG.LABEL.ZIP_CODE",
              hideDetailLabel: true,
              optionList: this.listZipCodes,
              itemPerRow: 3,
              model: "postal_code"
            });
          } else {
            listAddressFields.push({
              type: _customDefineType.FORM_TYPE.TEXTBOX,
              keyLangLabel: "BOOKING_DIALOG.LABEL.ZIP_CODE",
              hideDetailLabel: true,
              itemPerRow: 3,
              model: "postal_code"
            });
          }
        }
        // Find address preset fields
        var addressFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Address Fields";
        });
        var addressField = listFields.find(function (field) {
          return field.presetFields === "Address Fields";
        });
        if (addressField && addressField.selectUserAddresses) {
          var addressSelectionField = {
            type: _customDefineType.FORM_TYPE.MULTI_SELECT,
            label: addressField.label,
            isMulti: false,
            model: "address_id",
            optionList: this.user.addresses,
            optionLabel: "address1",
            optionModel: "id"
          };
          this.insertArrayInArray(listFields, [addressSelectionField], addressFieldIndex);
        } else {
          this.insertArrayInArray(listFields, listAddressFields, addressFieldIndex);
        }
      }
      var hasChildrenQuestion = false;
      // Children selection question
      if (this.user && this.user.children && this.user.children.length) {
        var childrenSelectionFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Children Selection";
        });
        if (childrenSelectionFieldIndex >= 0) {
          hasChildrenQuestion = true;
          this.insertArrayInArray(listFields, [_extends({}, listFields[childrenSelectionFieldIndex], {
            type: _customDefineType.FORM_TYPE.MULTI_SELECT,
            optionList: this.user.children,
            isMulti: true,
            model: "children_ids",
            optionLabel: "first_name",
            optionModel: "id"
          })], childrenSelectionFieldIndex);
        }
      }

      if (!this.excludeChildrenQuestion) {
        var numberChildrenFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Number of Children";
        });
        this.insertArrayInArray(listFields, [_extends({}, listFields[numberChildrenFieldIndex], {
          isHidden: hasChildrenQuestion,
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          keyLangLabel: "BOOKING_DIALOG.LABEL.NUMBER_CHILDREN",
          optionList: [].concat(_toConsumableArray(Array(this.maxNumberChildrenAllowed).keys())).map(function (i) {
            return i + 1;
          }),
          isMulti: false,
          model: "number_children"
        })], numberChildrenFieldIndex);
      }

      if (this.user && this.user.pets && this.user.pets.length) {
        var petSelectionFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Pet Selection";
        });
        if (petSelectionFieldIndex >= 0) {
          this.insertArrayInArray(listFields, [_extends({}, listFields[petSelectionFieldIndex], {
            type: _customDefineType.FORM_TYPE.MULTI_SELECT,
            optionList: this.user.pets,
            isMulti: true,
            model: "pet_ids",
            optionLabel: "name",
            optionModel: "id",
            isRequired: false
          })], petSelectionFieldIndex);
        }
      }

      if (this.listPreviousMatchCandidatesOfEmployer && this.listPreviousMatchCandidatesOfEmployer.length) {
        var previousMatchFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Previously Matched Candidate Selection";
        });
        if (previousMatchFieldIndex >= 0) {
          this.insertArrayInArray(listFields, [_extends({}, listFields[previousMatchFieldIndex], {
            type: _customDefineType.FORM_TYPE.MULTI_SELECT,
            optionList: this.listPreviousMatchCandidatesOfEmployer,
            isMulti: true,
            model: "selected_previous_match_ids",
            optionLabel: "filler_name",
            optionModel: "filler",
            isRequired: false
          })], previousMatchFieldIndex);
        }
      }

      if (this.normalizedCategoryList && this.normalizedCategoryList.length > 1) {
        // Find address preset fields
        var categoryFieldIndex = listFields.findIndex(function (field) {
          return field.presetFields === "Category";
        });
        this.insertArrayInArray(listFields, [_extends({}, listFields[categoryFieldIndex], {
          type: _customDefineType.FORM_TYPE.MULTI_SELECT,
          keyLangLabel: "BOOKING_DIALOG.LABEL.SELECT_JOB_CATEGORY",
          optionList: this.categoryList,
          isMulti: false,
          model: "category"
        })], categoryFieldIndex);
      }
      return listFields.filter(function (field) {
        return field.type !== _customDefineType.FORM_TYPE.PRESET_FIELDS;
      });
    },
    getNumberOfJob: function getNumberOfJob(day) {
      var _this13 = this;

      if (!this.calendarJobs) {
        return "";
      }
      var dateString = this.dateInDjangoFormat(day);
      var numberOfBooking = this.calendarJobs.filter(function (item) {
        return _this13.dateInDjangoFormat(item.startDate) == dateString;
      }).length;
      if (numberOfBooking && numberOfBooking > 1) {
        return "(" + numberOfBooking + ")";
      }
      return "";
    },
    isPastBooking: function isPastBooking(booking) {
      var bookingDate = new Date(booking.date + "T23:59:59");
      // if (booking.end_time) {
      //   bookingDate = new Date(booking.date + "T" + booking.end_time);
      // }
      return bookingDate < new Date();
    },
    getListBookings: function getListBookings() {
      var _this14 = this;

      return regeneratorRuntime.async(function getListBookings$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise(function _callee(resolve, reject) {
                var res;
                return regeneratorRuntime.async(function _callee$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/get-jobs-by-poster/?poster=" + _this14.user.id + "&job_type=" + _this14.jobTypeShortTermQuery + "&agency=" + _this14.agencyID + "&reports=true"));

                      case 2:
                        res = _context3.sent;

                        if (!res) {
                          reject();
                        }
                        resolve(res.data.jobs);

                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, null, _this14);
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    },
    handleUpdateObjects: function handleUpdateObjects(_ref) {
      var actionType = _ref.actionType,
          data = _ref.data,
          assignees = _ref.assignees,
          numberOfBooking = _ref.numberOfBooking,
          hasResultDialog = _ref.hasResultDialog;

      var targetJobs, oldBooking, assignInfo, assignee, isFilled, jobBookingInfo, title, numberBooking, bookingIndex, listCreatedBookingIds, _jobBookingInfo, bookingTitle, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, targetJob;

      return regeneratorRuntime.async(function handleUpdateObjects$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              targetJobs = void 0; // Creating jobs or updating jobs

              oldBooking = _extends({}, this.booking); // Booking before update

              this.booking = data;
              assignInfo = {};

              if (assignees && assignees.length) {
                assignee = assignees[0];
                isFilled = this.jobStatusAfterClientSelectCandidate === "Assigned";


                assignInfo = {
                  status: this.jobStatusAfterClientSelectCandidate,
                  filled: isFilled,
                  filler: assignee.id,
                  filler_name: assignee.first_name + " " + assignee.last_name,
                  filled_date: new Date()
                };
              }

              if (!(actionType === _customDefineType.ACTION_TYPE.ADD)) {
                _context5.next = 21;
                break;
              }

              if (data.date) {
                this.selectedDate = new Date(data.date + "T00:00:00");
              }
              // Collapse all other booking (to expand the new one)
              this.bookingData.forEach(function (booking) {
                return booking.isExpand = false;
              });
              jobBookingInfo = _extends({}, this.booking, {
                start_time: this.getTimeString(this.booking.start_time),
                end_time: this.getTimeString(this.booking.end_time),
                date: this.dateInDjangoFormat(this.selectedDate),
                category: this.getJobCategory(this.booking, this.getCategoryList(this.bookingField)),
                isExpand: true,
                id: this.tempID
              });

              this.correctEndDate(jobBookingInfo);
              title = void 0;

              if (this.booking.start_time && this.booking.end_time) {
                title = this.convertTimeAMPMToString(this.booking.start_time) + " - " + this.convertTimeAMPMToString(this.booking.end_time);
              } else {
                title = "Booking";
              }
              if (this.booking.title) {
                title += " " + this.booking.title;
              }
              numberBooking = this.booking.number_candidate || 1;

              for (bookingIndex = 0; bookingIndex < numberBooking; bookingIndex += 1) {
                if (!this.api) {
                  this.bookingData.push(_extends({}, jobBookingInfo, assignInfo));
                  this.calendarJobs.push({
                    id: this.tempID,
                    startDate: this.selectedDate,
                    endDate: this.booking.end_date,
                    startTime: this.getTimeString(this.booking.start_time),
                    style: this.getBookingStyle(this.booking.status, this.selectedDate),
                    title: title
                  });
                }
                this.tempID += 1;
              }
              listCreatedBookingIds = []; // List of created booking ids

              if (!this.$refs.updateBookingDialog) {
                _context5.next = 19;
                break;
              }

              _context5.next = 19;
              return regeneratorRuntime.awrap(this.$refs.updateBookingDialog.handleAfterSavingData(listCreatedBookingIds));

            case 19:
              _context5.next = 32;
              break;

            case 21:
              if (!(actionType === _customDefineType.ACTION_TYPE.UPDATE)) {
                _context5.next = 31;
                break;
              }

              targetJobs = [this.booking];
              _jobBookingInfo = _extends({}, this.booking, {
                start_time: this.getTimeString(this.booking.start_time),
                end_time: this.getTimeString(this.booking.end_time),
                category: this.getJobCategory(this.booking, this.getCategoryList(this.bookingField))
              }, assignInfo);

              this.correctEndDate(_jobBookingInfo);
              if (this.indexOfEdittingBooking >= 0) {
                this.bookingData[this.indexOfEdittingBooking] = _jobBookingInfo;
                this.bookingData = [].concat(_toConsumableArray(this.bookingData));
                bookingTitle = void 0;

                if (this.booking.start_time && this.booking.end_time) {
                  bookingTitle = this.convertTimeAMPMToString(this.booking.start_time) + " - " + this.convertTimeAMPMToString(this.booking.end_time);
                } else {
                  bookingTitle = "Booking";
                }

                if (this.booking.title) {
                  bookingTitle += " " + this.booking.title;
                }
                this.calendarJobs[this.indexOfEdittingBooking].title = bookingTitle;

                this.calendarJobs[this.indexOfEdittingBooking].endDate = this.booking.end_date;
                this.calendarJobs[this.indexOfEdittingBooking].startTime = this.getTimeString(this.booking.start_time);
              }

              if (!this.$refs.updateBookingDialog) {
                _context5.next = 29;
                break;
              }

              _context5.next = 29;
              return regeneratorRuntime.awrap(this.$refs.updateBookingDialog.handleAfterSavingData());

            case 29:
              _context5.next = 32;
              break;

            case 31:
              if (actionType === _customDefineType.ACTION_TYPE.DELETE) {
                if (this.indexOfEdittingBooking >= 0) {
                  this.bookingData.splice(this.indexOfEdittingBooking, 1);
                  this.calendarJobs.splice(this.indexOfEdittingBooking, 1);
                }
              }

            case 32:
              if (!(this.clientCanSelectMultipleCandidates && assignees && assignees.length)) {
                _context5.next = 59;
                break;
              }

              _iteratorNormalCompletion6 = true;
              _didIteratorError6 = false;
              _iteratorError6 = undefined;
              _context5.prev = 36;
              _iterator6 = targetJobs[Symbol.iterator]();

            case 38:
              if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                _context5.next = 45;
                break;
              }

              targetJob = _step6.value;
              _context5.next = 42;
              return regeneratorRuntime.awrap(this.updateFillersOfJob({
                job: targetJob,
                fillers: assignees,
                status: this.jobStatusAfterClientSelectCandidate,
                notAllowStatus: this.jobStatusAfterClientSelectCandidate === "Assigned" ? null : "Assigned"
              }));

            case 42:
              _iteratorNormalCompletion6 = true;
              _context5.next = 38;
              break;

            case 45:
              _context5.next = 51;
              break;

            case 47:
              _context5.prev = 47;
              _context5.t0 = _context5["catch"](36);
              _didIteratorError6 = true;
              _iteratorError6 = _context5.t0;

            case 51:
              _context5.prev = 51;
              _context5.prev = 52;

              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }

            case 54:
              _context5.prev = 54;

              if (!_didIteratorError6) {
                _context5.next = 57;
                break;
              }

              throw _iteratorError6;

            case 57:
              return _context5.finish(54);

            case 58:
              return _context5.finish(51);

            case 59:

              this.updateBookingIndex();
              this.$emit("input", this.bookingData);

            case 61:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this, [[36, 47, 51, 59], [52,, 54, 58]]);
    },
    updateBookingIndex: function updateBookingIndex() {
      // Update booking index
      if (this.bookingData) {
        var index = 0;
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = this.bookingData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var booking = _step7.value;

            if (booking.status == _customDefineType.JOB_STATUSES.CANCELLED) {
              booking.index = -1;
            } else {
              booking.index = index;
              index += 1;
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
    },
    getModifiedData: function getModifiedData(jobBookingInfo) {
      var _this15 = this;

      var result = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.listFieldsUpdateBooking[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var field = _step8.value;

          if (this.bookingField && this.bookingField.listModelsAdminOnly) {
            if (this.bookingField.listModelsAdminOnly.includes(field.model)) {
              continue;
            }
          }
          var oldValue = this.originalJob[field.model];
          var newValue = jobBookingInfo[field.model];
          if (!oldValue && !newValue) {
            continue;
          }
          if (oldValue === newValue) {
            continue;
          }
          if (["start_time", "end_time"].includes(field.model)) {
            oldValue = this.convertTimeStringToStringAMPM(oldValue);
            newValue = this.convertTimeStringToStringAMPM(newValue);
          } else if (field.model == "additional_dates") {
            newValue = newValue.map(function (item) {
              return _this15.getDateString(item.date) + " (" + _this15.convertTimeStringToStringAMPM(item.start_time) + " - " + _this15.convertTimeStringToStringAMPM(item.end_time) + ")";
            }).join(", ");
          }
          var fieldLabel = field.label || this.getLabelByKeys(field.keyLangLabel);
          result.push("Old " + fieldLabel + ": " + oldValue + ", New " + fieldLabel + ": " + newValue);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return result.join("\n");
    },
    setShowDate: function setShowDate(d) {
      this.showDate = d;
    },
    getTimeStringAMPM: function getTimeStringAMPM(time) {
      return time.hh + ":" + time.mm + " " + time.A;
    },
    checkBookingOutSideBussinessHours: function checkBookingOutSideBussinessHours() {
      if (!this.doNotBookOutsideOfficeHours) {
        return false;
      }
      var outsideResult = this.isJobCreatedInBusinessHour();
      if (!(outsideResult && outsideResult.isInside)) {
        this.showErrorDialog({
          innerHtml: this.replaceTagValue(this.warningBookOutsideOfficeHours, {
            office_hour_from: this.djangotimeformatAMPM(outsideResult.startTime),
            office_hour_to: this.djangotimeformatAMPM(outsideResult.endTime)
          })
        });
        return true;
      }
      return false;
    },
    onClickDate: function onClickDate(d) {
      var today;
      return regeneratorRuntime.async(function onClickDate$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.isViewOnly) {
                _context6.next = 3;
                break;
              }

              console.log("1");
              return _context6.abrupt("return");

            case 3:
              today = new Date();

              today.setHours(0, 0, 0, 0);

              if (!(!this.isAgent && d < today)) {
                _context6.next = 8;
                break;
              }

              console.log("2");
              // Click a date in the past
              return _context6.abrupt("return");

            case 8:
              console.log("3");
              // Check if booking in list blocked date

              if (!(!this.isAgent && this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.shift_request_full_dates && !this.allowBookOnBlockedDate)) {
                _context6.next = 13;
                break;
              }

              if (!this.$store.getters.agencyPublic.shift_request_full_dates.includes(this.dateInDjangoFormat(d))) {
                _context6.next = 13;
                break;
              }

              this.showResultDialog("BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG");
              return _context6.abrupt("return");

            case 13:
              if (this.isAgent) {
                _context6.next = 16;
                break;
              }

              if (!this.checkBookingOutSideBussinessHours()) {
                _context6.next = 16;
                break;
              }

              return _context6.abrupt("return");

            case 16:
              this.selectedDate = d;

              this.booking = {
                index: this.bookingData ? this.bookingData.length : 0
              };
              if (!this.doNotAutoPopulateAddress) {
                this.booking = _extends({}, this.booking, {
                  address1: this.user.address1,
                  address2: this.user.address2,
                  city: this.user.city,
                  provincestate: this.user.provincestate,
                  postal_code: this.user.postal_code,
                  locations: this.user.locations
                });
              }
              // Auto populate field
              this.autoPopulateFields();
              this.isAddBookingDialog = true;
              this.dialogTitle = this.getLabelByKeys("BUTTONS.ADD_A_BOOKING") + " - " + d.toDateString();
              this.hasDateQuestion = false;
              this.isShowBookingDialog = true;

            case 24:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    },
    autoPopulateFields: function autoPopulateFields() {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.listBookingFields[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var field = _step9.value;

          if (field.autoPopulateSource && field.model) {
            if (this.user[field.autoPopulateSource] && !this.booking[field.model]) {
              this.booking[field.model] = this.user[field.autoPopulateSource];
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    clickAddBooking: function clickAddBooking() {
      return regeneratorRuntime.async(function clickAddBooking$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (this.isAgent) {
                _context7.next = 3;
                break;
              }

              if (!this.checkBookingOutSideBussinessHours()) {
                _context7.next = 3;
                break;
              }

              return _context7.abrupt("return");

            case 3:
              this.booking = {
                index: this.bookingData ? this.bookingData.length : 0
              };
              if (!this.doNotAutoPopulateAddress) {
                this.booking = _extends({}, this.booking, {
                  address1: this.user.address1,
                  address2: this.user.address2,
                  city: this.user.city,
                  provincestate: this.user.provincestate,
                  postal_code: this.user.postal_code
                });
              }
              this.autoPopulateFields();
              this.dialogTitle = this.getLabelByKeys("BUTTONS.ADD_A_BOOKING");
              this.isAddBookingDialog = true;
              this.hasDateQuestion = true;
              this.selectedDate = null;
              this.isShowBookingDialog = true;

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    },
    handleClickDuplicateBooking: function handleClickDuplicateBooking(job) {
      var _this16 = this;

      var listRemovedKeys;
      return regeneratorRuntime.async(function handleClickDuplicateBooking$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              this.booking = _extends({}, job, {
                index: this.bookingData ? this.bookingData.length : 0
              });
              this.booking.status = "Requested";
              listRemovedKeys = ["filled", "filler", "filled_date", "filler_name", "fillers"];

              listRemovedKeys.forEach(function (key) {
                delete _this16.booking[key];
              });
              this.dialogTitle = "Duplicate a booking";
              this.isAddBookingDialog = true;
              this.hasDateQuestion = true;
              this.selectedDate = null;
              this.isShowBookingDialog = true;

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    },
    onClickItem: function onClickItem(event) {
      var bookingId;
      return regeneratorRuntime.async(function onClickItem$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              // id of booking which is clicked
              bookingId = event.id;
              // Expand the booking which has bookingId, collapse all others

              this.bookingData.forEach(function (booking) {
                return booking.isExpand = booking.id === bookingId;
              });
              this.bookingData = JSON.parse(JSON.stringify(this.bookingData));

              // Show assignee

              if (this.api) {
                _context9.next = 5;
                break;
              }

              return _context9.abrupt("return");

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    },
    handleClickCancelBooking: function handleClickCancelBooking(job) {
      var _this17 = this;

      var forceCloseBookingDialog = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (forceCloseBookingDialog) {
        this.$nextTick(function () {
          _this17.$refs.jobInfoDialog.hideModal();
        });
        return;
      }
      this.booking = _extends({}, job, {
        start_time: this.getTimeFromString(job.start_time),
        end_time: this.getTimeFromString(job.end_time)
      });
      this.$refs.updateBookingDialog.data = _extends({}, this.booking);
      this.$nextTick(function () {
        _this17.$refs.updateBookingDialog.showCancelBookingConfirmDialog();
      });
    },
    handleClickEditBooking: function handleClickEditBooking(job, index) {
      return regeneratorRuntime.async(function handleClickEditBooking$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (index == null) {
                index = this.listShowBooking.findIndex(function (booking) {
                  return booking.id === job.id;
                });
              }
              if (!index && this.listShowBooking) {
                // Find index of job in listShowBooking
                index = this.listShowBooking.findIndex(function (booking) {
                  return booking.id === job.id;
                });
              }
              this.selectedDate = job.date;
              this.originalJob = JSON.parse(JSON.stringify(job));
              this.booking = _extends({}, job, {
                start_time: this.getTimeFromString(job.start_time),
                end_time: this.getTimeFromString(job.end_time)
              });
              this.dialogTitle = "Edit Booking - " + new Date(this.selectedDate + "T00:00:00").toDateString();
              this.indexOfEdittingBooking = index;
              this.isAddBookingDialog = false;
              this.hasDateQuestion = true;
              this.isShowBookingDialog = true;

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this);
    },
    getTitle: function getTitle(job) {
      var startDate = new Date(job.date + "T00:00:00").toDateString();
      if (!job.end_date) {
        return startDate;
      }
      var endDate = new Date(job.end_date + "T00:00:00").toDateString();
      if (startDate === endDate) {
        return startDate;
      }
      return startDate + " - " + endDate;
    },
    getBookingStyle: function getBookingStyle(status, date) {
      if (status === _customDefineType.JOB_STATUSES.CANCELLED) {
        return "white-space: normal; border-color: #c7c5c3; background-color: #c7c5c3;";
      }
      if (this.isPastDate(date)) {
        return "white-space: normal; border-color: var(--bootstrapgrey); background-color: var(--bootstrapgrey);";
      }
      if (status === _customDefineType.JOB_STATUSES.ASSIGNED) {
        return "white-space: normal; border-color: #e7e5ff; background-color: #e7e5ff;";
      }
      return "white-space: normal; border-color: #ff6969; background-color: #ff6969;";
    },
    isPastDate: function isPastDate(date) {
      if (date) {
        var date1 = new Date(date);
        var userTimezoneOffset = new Date(date1).getTimezoneOffset() * 60000;
        var jobDate = new Date(date1.getTime() + userTimezoneOffset);
        var date2 = new Date();
        var userTimezoneOffset2 = new Date(date2).getTimezoneOffset() * 60000;
        var currentDate = new Date(date2.getTime() + userTimezoneOffset2);
        return jobDate.toDateString() != currentDate.toDateString() && Date.parse(new Date(date)) < Date.parse(new Date());
      }
      return false;
    },

    // Save current expanding booking before reload list booking (to keep the expanding booking after reload)
    saveCurrentExpandingBooking: function saveCurrentExpandingBooking() {
      if (this.bookingData == null) {
        this.expandingID = -1;
        return;
      }
      var expandingBooking = this.bookingData.find(function (booking) {
        return booking.isExpand;
      });
      if (expandingBooking) {
        this.expandingID = expandingBooking.id;
        return;
      }
      this.expandingID = -1;
      return;
    },
    loadListBooking: function loadListBooking(jobs) {
      var calendarJobs, bookingData, listBooking, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, booking, jobBookingInfo, candidateFee, title, jobFiller;

      return regeneratorRuntime.async(function loadListBooking$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              calendarJobs = [];
              bookingData = [];
              listBooking = void 0;

              if (!(jobs && !this.shiftJobProblemReports)) {
                _context11.next = 7;
                break;
              }

              listBooking = jobs;
              _context11.next = 10;
              break;

            case 7:
              _context11.next = 9;
              return regeneratorRuntime.awrap(this.getListBookings());

            case 9:
              listBooking = _context11.sent;

            case 10:
              listBooking = listBooking.sort(function (a, b) {
                return a.id > b.id ? 1 : -1;
              });
              _iteratorNormalCompletion10 = true;
              _didIteratorError10 = false;
              _iteratorError10 = undefined;
              _context11.prev = 14;
              _iterator10 = listBooking[Symbol.iterator]();

            case 16:
              if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                _context11.next = 40;
                break;
              }

              booking = _step10.value;

              if (!(this.multipleBookingSections && booking.type)) {
                _context11.next = 22;
                break;
              }

              if (!(booking.type != this.sectionTitle)) {
                _context11.next = 22;
                break;
              }

              if (!(!this.bookingField || !this.bookingField.sectionBuilderId || this.bookingField.sectionBuilderId !== booking.section_builder_id)) {
                _context11.next = 22;
                break;
              }

              return _context11.abrupt("continue", 37);

            case 22:
              if (!this.batchID) {
                this.batchID = booking.job_group;
              }
              jobBookingInfo = _extends({}, booking, {
                client_rate: "client_rate" in booking ? booking.client_rate : this.calculatePricePerHour(booking),
                agency_fee: "agency_fee" in booking ? booking.agency_fee : this.calculateAgencyFee(booking),
                travel_fee: "travel_fee" in booking ? booking.travel_fee : this.calculateTravelFee(booking),
                rush_fee: "rush_fee" in booking ? booking.rush_fee : this.calculateRushFee(booking),
                candidate_rush_fee: "candidate_rush_fee" in booking ? booking.candidate_rush_fee : this.calculateCandidateRushFee(booking),
                per_booking_agency_fee: "per_booking_agency_fee" in booking ? booking.per_booking_agency_fee : this.getPerBookingAgencyFee(booking),
                per_booking_candidate_fee: "per_booking_candidate_fee" in booking ? booking.per_booking_candidate_fee : this.getPerBookingCandidateFee(booking),
                isExpand: booking.id === this.expandingID
              });

              if (booking.total_candidate_pay) {
                jobBookingInfo["total_candidate_pay"] = booking.total_candidate_pay;
              }
              if (booking.candidate_rate) {
                jobBookingInfo["candidate_rate"] = booking.candidate_rate;
              }
              if (!jobBookingInfo["total_candidate_pay"] && !jobBookingInfo["candidate_rate"]) {
                candidateFee = this.calculateCandidateFee(booking);

                if (candidateFee) {
                  jobBookingInfo["total_candidate_pay"] = candidateFee;
                } else {
                  jobBookingInfo["candidate_rate"] = this.calculateCandidateRate(booking);
                }
              }

              bookingData.push(jobBookingInfo);
              title = "";
              jobFiller = "";

              if (booking.filler_name && this.hideCandidateLastNameForShiftJobs) {
                jobFiller = booking.filler_name.split(" ")[0];
              }
              if (this.user.is_employer && this.showIdClientSideShiftJobCalendar) {
                title = booking.id + " ";
              }
              if (booking.start_time && booking.end_time) {
                title += this.convertTimeStringToStringAMPM(booking.start_time) + " - " + this.convertTimeStringToStringAMPM(booking.end_time);
              } else if (booking.category) {
                title += booking.category;
              } else {
                title += "Booking";
              }
              if (booking.title) {
                title += " " + booking.title;
              }
              if (this.showWeeklyScheduleReleaseButton && booking.status === this.preReleaseShiftJobStatus || !booking.filler_name) {
                if (this.$store.getters.isAgent) {
                  title += " (" + booking.status + ")";
                }
              } else {
                // Don't show status of Booking to Client
                if (jobFiller && this.hideCandidateLastNameForShiftJobs) {
                  title += " (" + jobFiller + ")";
                } else {
                  title += " (" + booking.filler_name + ")";
                }
              }
              // statuses where job status is visible to the client
              if (!this.isAgent && this.shiftJobStatusesWhereJobStatusVisible.includes(booking.status)) {
                title += " (" + booking.status + ")";
              }

              calendarJobs.push({
                id: booking.id,
                startDate: booking.date,
                endDate: booking.end_date,
                startTime: booking.start_time,
                style: this.getBookingStyle(booking.status, booking.date),
                title: title
              });

            case 37:
              _iteratorNormalCompletion10 = true;
              _context11.next = 16;
              break;

            case 40:
              _context11.next = 46;
              break;

            case 42:
              _context11.prev = 42;
              _context11.t0 = _context11["catch"](14);
              _didIteratorError10 = true;
              _iteratorError10 = _context11.t0;

            case 46:
              _context11.prev = 46;
              _context11.prev = 47;

              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }

            case 49:
              _context11.prev = 49;

              if (!_didIteratorError10) {
                _context11.next = 52;
                break;
              }

              throw _iteratorError10;

            case 52:
              return _context11.finish(49);

            case 53:
              return _context11.finish(46);

            case 54:
              this.updateBookingIndex();
              this.bookingData = bookingData;
              this.calendarJobs = calendarJobs;

            case 57:
            case "end":
              return _context11.stop();
          }
        }
      }, null, this, [[14, 42, 46, 54], [47,, 49, 53]]);
    },
    getBookingFillerName: function getBookingFillerName(booking) {
      var jobFiller = booking.filler_name || "";
      if (booking.filler_name && this.hideCandidateLastNameForShiftJobs) {
        jobFiller = booking.filler_name.split(" ")[0];
      }
      return jobFiller;
    },
    expandBooking: function expandBooking(job) {
      this.bookingData.forEach(function (booking) {
        return booking.isExpand = false;
      });
      job.isExpand = true;
      this.bookingData = JSON.parse(JSON.stringify(this.bookingData));
    },
    showDeleteGroupConfirm: function showDeleteGroupConfirm(group_id) {
      this.showConfirmDialog({
        key: "DELETE_BOOKING_GROUP_CONFIRM_DIALOG",
        onAcceptCallback: this.deleteGroup,
        onAcceptCallbackData: group_id
      });
    },
    deleteGroup: function deleteGroup(group_id) {
      return regeneratorRuntime.async(function deleteGroup$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.delete("/api/jobgroups/" + group_id));

            case 2:
              this.loadListBooking();

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, null, this);
    },
    handleUnassignCandidate: function handleUnassignCandidate(filler) {
      var res;
      return regeneratorRuntime.async(function handleUnassignCandidate$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/jobs/" + this.selectedJob.id + "/"));

            case 2:
              res = _context13.sent;

              this.selectedJob = res.data;
              this.listJobFiller = this.listJobFiller.filter(function (jobFiller) {
                return jobFiller.id !== filler.id;
              });
              this.loadListBooking();

            case 6:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    },
    getFieldProperty: function getFieldProperty(item, key) {
      if (item == null) {
        return "";
      }
      if (this.language) {
        if (item[key + "_lang_" + this.language]) {
          return item[key + "_lang_" + this.language];
        }
      }
      if (key === "label" && !item[key] && item.keyLangLabel) {
        if (item.keyLangLabelParams) {
          return this.getLabelByKeys.apply(this, [item.keyLangLabel].concat(_toConsumableArray(item.keyLangLabelParams)));
        } else {
          return this.getLabelByKeys(item.keyLangLabel);
        }
      }
      return item[key];
    },
    handleShowBuilderSetting: function handleShowBuilderSetting() {
      this.isShowSectionBuilderUpSertDialog = true;
    }
  })
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _watch;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
This component is used for a dialog (add/edit) objects (reference/children/experience/education...)
 */


var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _StripePayment = __webpack_require__(205);

var _StripePayment2 = _interopRequireDefault(_StripePayment);

var _BookingPriceInfo = __webpack_require__(207);

var _BookingPriceInfo2 = _interopRequireDefault(_BookingPriceInfo);

var _vuex = __webpack_require__(11);

var _JobFillerInfo = __webpack_require__(133);

var _JobFillerInfo2 = _interopRequireDefault(_JobFillerInfo);

var _SelectFillerDialog = __webpack_require__(554);

var _SelectFillerDialog2 = _interopRequireDefault(_SelectFillerDialog);

var _CandidateSelectionSection = __webpack_require__(558);

var _CandidateSelectionSection2 = _interopRequireDefault(_CandidateSelectionSection);

var _jobSettings = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "UpdateBookingDialog",
  props: {
    header: String,
    name: String,
    user: Object,
    passedData: Object,
    title: String,
    keyTitles: {
      type: Array,
      default: function _default() {
        return ["name"];
      }
    },
    // Selected date for Booking only
    selectedDate: String,
    value: Boolean,
    isAdd: Boolean,
    listFields: Array,
    // List models which is not showed
    listExcludeFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    bookingRequirePaymentInfo: {
      type: Boolean,
      default: false
    },
    listPrices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listPriceServices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categoryList: {
      type: String,
      default: ""
    },
    chargeClientWhenBooking: {
      type: Boolean,
      default: false
    },
    chargeClientWhenAssign: {
      // Setting in profile type builder
      type: Boolean,
      default: false
    },
    includeCandidatePayment: {
      type: Boolean,
      default: false
    },
    employerTypesNotCharge: {
      type: Array
    },
    listBookings: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // If number of children is more than that, additional fee will be added
    numberOfAllowedChildren: {
      type: Number,
      default: 1
    },
    cancellationPolicy: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    candidateList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    passedBookingField: Object,
    passedCreditCount: Number,
    isInApplicationForm: {
      type: Boolean,
      default: false
    },
    profileBuilderID: Number,
    isFixedPoster: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      submitClicked: false,
      ACTION_TYPE: _customDefineType.ACTION_TYPE,
      isShow: false,
      data: {},
      originalData: {},
      listRelatedJobs: [],
      listSelectedCandidates: [],
      listInterestedCandidates: [],
      listNotMatchCandidateIds: [],
      listFavoriteCandidateIds: [],
      isShowAddUserDialog: false,
      addingUserType: "",
      showFillerListForUpdate: false,
      isShowSelectFillerDialog: false,
      selectingFillerDate: null,
      mapSelectedCandidates: {},
      keepDialogOpen: false,
      addUserModel: "",
      bookingDateTimeInfo: {},
      CANCELLING_REASON_SHIFT_JOB_SETTINGS: _jobSettings.CANCELLING_REASON_SHIFT_JOB_SETTINGS,
      ADD_EDIT_BOOKING_DIALOG_SETTINGS: _jobSettings.ADD_EDIT_BOOKING_DIALOG_SETTINGS,
      posterCreditCount: null,
      listPosterChildren: [],
      listPosterPets: [],
      listPosterAddresses: []
    };
  },

  components: {
    ModalDialog: _ModalDialog2.default,
    StripePayment: _StripePayment2.default,
    BookingPriceInfo: _BookingPriceInfo2.default,
    JobFillerInfo: _JobFillerInfo2.default,
    SelectFillerDialog: _SelectFillerDialog2.default,
    CandidateSelectionSection: _CandidateSelectionSection2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["agencyID", "availabilities", "weekAvailabilities", "candidateListMainInfo", "clientCanAssignShiftJob", "clientCanExpressInterestShiftJob", "clientCanAssignShiftJobApplicationForm", "shiftJobSelectionProfileFields", "candidateInfoSelectionFields", // list candidate info to show for avaialble candidates
  "customTextCancelingShiftJob", "onlyShowMatchedTags", "onlyShowMatchedLocations", "onlyShowMatchedZipcodes", "shiftJobStatusClientCanCancel", "isAgent", "jobTypeShortTermQuery", "clientCanSelectMultipleCandidates", "clientSelectionCandidateTypes", "candidateMatchingCategoryField", "clientSelectionCandidateStatuses", "hourlyServiceSelectionList", "employerShiftRequestEmails", "autoAssignCandidate", "messageNobodyAvailable", "candidatesCanSetRate", "textSelfSelectNobodyAvailable", "wordUsedForCandidates", "minChildrenAgeField", "agent", "agencyCurrencySign", "broadcastOnCreateJob", "chooseAddOptionSelectively", "shiftRequestMinimumHours", "doNotAskReasonClientCancelsShiftJob", "listModelRecalculatedWhenAssignJob", "doNotAutoPopulateAddress", "shiftJobCandidateUnassignStatus", "allowBookOnBlockedDate", "jobStatusForBlockedDate", "customMessageRequestForBlockedDates", "agencyLocations", "rushFeeInfo", "minDurationPerCategories", "minDurationPerTypes", "minDurationPerLocations"]), {
    creditCount: function creditCount() {
      return this.passedCreditCount || this.posterCreditCount;
    },
    employerShiftRequestEmailsByLocation: function employerShiftRequestEmailsByLocation() {
      var _this = this;

      var listLocations = this.getJobLocations(this.user, this.data);
      return this.getListEmailSubmissionNotification(this.employerShiftRequestEmails, this.tryGet(function () {
        return _this.$store.getters.agency.advance_setting.employer_shift_request_emails_by_locations;
      }), listLocations);
    },
    bookingField: function bookingField() {
      var _this2 = this;

      if (this.passedBookingField) {
        return this.passedBookingField;
      }
      if (!this.listFields) {
        return null;
      }
      var dataField = this.listFields.find(function (field) {
        return field.dataKey === "list-booking-fields";
      });
      if (!dataField) {
        return null;
      }
      var listBookingFields = dataField.data;
      if (listBookingFields && listBookingFields.length) {
        if (listBookingFields.length === 1) {
          return listBookingFields[0];
        }
        if (this.data && this.data.type) {
          return listBookingFields.find(function (field) {
            return field.label === _this2.data.type;
          });
        }
      }
    },
    sectionBuilderId: function sectionBuilderId() {
      if (!this.bookingField) {
        return null;
      }
      return this.bookingField.sectionBuilderId;
    },
    shiftRequestMinimumHoursPerClient: function shiftRequestMinimumHoursPerClient() {
      var _this3 = this;

      var userTypes = this.user && this.user.types ? this.user.types : [];
      var userLocations = this.user && this.user.locations ? this.user.locations : [];
      var result = this.shiftRequestMinimumHours;
      var listMinValues = [];
      if (this.jobCategory && this.minDurationPerCategories && this.minDurationPerCategories.length) {
        var minimumHoursPerCategories = this.minDurationPerCategories.filter(function (hour) {
          return hour.minimun_hours && hour.categories && hour.categories.includes(_this3.jobCategory);
        }).map(function (hour) {
          return parseInt(hour.minimun_hours);
        });

        if (minimumHoursPerCategories.length) {
          listMinValues.push(Math.min.apply(Math, _toConsumableArray(minimumHoursPerCategories)));
        }
      }
      if (this.minDurationPerTypes && this.minDurationPerTypes.length && userTypes.length > 0) {
        var minimumHoursPerClientTypes = this.minDurationPerTypes.filter(function (hour) {
          return hour.minimun_hours && hour.client_types && _this3.hasCommonElement(hour.client_types, userTypes);
        }).map(function (hour) {
          return parseInt(hour.minimun_hours);
        });

        if (minimumHoursPerClientTypes.length) {
          listMinValues.push(Math.min.apply(Math, _toConsumableArray(minimumHoursPerClientTypes)));
        }
      }
      if (this.minDurationPerLocations && this.minDurationPerLocations.length && userLocations.length > 0) {
        var minimumHoursPerClientLocations = this.minDurationPerLocations.filter(function (hour) {
          return hour.minimun_hours && hour.locations && _this3.hasCommonElement(hour.locations, userLocations);
        }).map(function (hour) {
          return parseInt(hour.minimun_hours);
        });

        if (minimumHoursPerClientLocations.length) {
          listMinValues.push(Math.min.apply(Math, _toConsumableArray(minimumHoursPerClientLocations)));
        }
      }

      if (listMinValues.length) {
        result = Math.min.apply(Math, listMinValues);
      }
      return result;
    },
    isInvalidBookingDuration: function isInvalidBookingDuration() {
      var compareCode = this.compareDuration(this.startDate, this.bookingDateTimeInfo.start_time, this.bookingDateTimeInfo.end_date, this.bookingDateTimeInfo.end_time, this.shiftRequestMinimumHoursPerClient);
      return compareCode === -1;
    },
    chargeClientWhenAssignCandidate: function chargeClientWhenAssignCandidate() {
      if (this.chargeClientWhenAssign) {
        return true;
      }
      if (this.bookingField) {
        return this.bookingField.chargeClientWhenAssignCandidate;
      }
      return null;
    },
    hasPresetCandidateSelection: function hasPresetCandidateSelection() {
      if (!this.listFields) {
        return false;
      }
      return this.listFields.some(function (field) {
        return field.type === _customDefineType.FORM_TYPE.SLOT && field.presetFields === "Candidate Selection";
      });
    },
    listBookingDates: function listBookingDates() {
      return this.getListDateOfRepeatBooking(this.bookingDateTimeInfo, this.selectedDate);
    },
    numberOfBooking: function numberOfBooking() {
      var repeatCount = this.getListDateOfRepeatBooking(this.bookingDateTimeInfo, this.selectedDate).length;
      if (!this.data || !this.data.number_candidate) {
        return repeatCount;
      }
      return repeatCount * this.data.number_candidate;
    },
    listUniqueFields: function listUniqueFields() {
      if (!this.listFields) {
        return [];
      }
      return this.listFields.filter(function (field) {
        return field.isUnique;
      }).map(function (field) {
        return { model: field.model, label: field.label };
      });
    },
    numberOfBookingUsingCredit: function numberOfBookingUsingCredit() {
      if (!this.creditCount) {
        // No booking uses credits
        return 0;
      }
      if (this.creditCount >= this.numberOfBooking) {
        // All bookings use credits
        return this.numberOfBooking;
      }
      // Some uses credit
      return this.creditCount;
    },
    canCancelJob: function canCancelJob() {
      if (!this.passedData) {
        return false;
      }
      return this.shiftJobStatusClientCanCancel.includes(this.passedData.status);
    },
    startDate: function startDate() {
      return this.bookingDateTimeInfo.date || this.selectedDate;
    },
    endDate: function endDate() {
      return this.bookingDateTimeInfo.end_date;
    },
    listPricesUpsertBooking: function listPricesUpsertBooking() {
      var _this4 = this;

      var result = this.listPrices;
      if (this.user && this.user.membership_info && this.isAdd) {
        var membershipInfo = this.user.membership_info;
        if (membershipInfo.freePrices && membershipInfo.amount) {
          // Check if booking date is not expired
          var selectedDate = this.startDate;
          if (this.isDateInRange(selectedDate, membershipInfo.date, membershipInfo.duration)) {
            // Count number of jobs in current month
            var listBookings = this.listBookings;
            if (this.user.id) {
              listBookings = listBookings.filter(function (booking) {
                return !booking.poster || booking.poster === _this4.user.id;
              });
            }
            listBookings = listBookings.filter(function (booking) {
              return booking.status !== _customDefineType.JOB_STATUSES.CANCELLED;
            });
            // Find all possible valid ranges
            var listRanges = this.splitDateRange(membershipInfo.date, membershipInfo.duration);
            var selectedRange = void 0;
            var selectedDateStr = this.dateInDjangoFormat(this.addTimeToDate(selectedDate));
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = listRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var range = _step.value;

                if (selectedDateStr >= range[0] && selectedDateStr <= range[1]) {
                  selectedRange = range;
                }
              }
              // Count total number of jobs which is in the same month with selected date
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var numBooking = listBookings.filter(function (booking) {
              return booking.date >= selectedRange[0] && booking.date <= selectedRange[1];
            }).length;
            if (numBooking < membershipInfo.amount) {
              result = result.filter(function (price) {
                return !membershipInfo.freePrices.includes(price.id);
              });
            }
          }
        }
      }
      return result;
    },
    listVisibleFields: function listVisibleFields() {
      var _this5 = this;

      if (this.listFields == null) {
        return [];
      }
      var listFields = this.listFields.filter(function (field) {
        return !_this5.listExcludeFields.includes(field.model);
      });
      var additionalDateField = listFields.find(function (field) {
        return field.model === "additional_dates";
      });
      if (additionalDateField) {
        additionalDateField.minDuration = this.shiftRequestMinimumHoursPerClient;
      }
      // Check to insert option list for locations field
      var locationsField = listFields.find(function (field) {
        return field.model === "locations";
      });
      if (locationsField && !locationsField.optionList) {
        locationsField.optionList = this.agencyLocations;
        locationsField.setOutside = true;
      }
      if (!this.isFixedPoster) {
        var childrenSelectionField = listFields.find(function (field) {
          return field.model === "children_ids";
        });

        if (childrenSelectionField) {
          childrenSelectionField.optionList = this.listPosterChildren;
        }

        var petSelectionField = listFields.find(function (field) {
          return field.model === "pet_ids";
        });

        if (petSelectionField) {
          petSelectionField.optionList = this.listPosterPets;
        }

        var addressSelectionField = listFields.find(function (field) {
          return field.model === "address_id";
        });

        if (addressSelectionField) {
          addressSelectionField.optionList = this.listPosterAddresses;
        }
      }

      // Check show condition of people fields
      if (this.user) {
        listFields = listFields.filter(function (field) {
          if (!field.showIf) {
            return true;
          }
          if (field.showIf.indexOf("people_") === 0) {
            return _this5.isItemShow(_this5.user, _extends({}, field, { showIf: field.showIf.replace("people_", "") }), []);
          }
          return true;
        });
      }
      listFields = this.cloneArrayOfObject(listFields);
      listFields.forEach(function (field) {
        if (field.showIf && field.showIf.indexOf("people_") === 0) {
          field.showIf = null;
        }
      });
      var result = listFields;
      // Insert a slot field for warning message
      var endTimeIndex = result.findIndex(function (x) {
        return x.model == "end_time";
      });
      if (endTimeIndex && endTimeIndex > -1) {
        result.splice(endTimeIndex + 1, 0, {
          type: _customDefineType.FORM_TYPE.SLOT,
          label: "Warning Message"
        });
      }
      return result;
    },
    skipChargeUser: function skipChargeUser() {
      if (this.employerTypesNotCharge && this.employerTypesNotCharge.length) {
        if (this.hasCommonElement(this.employerTypesNotCharge, this.user.types)) {
          return true;
        }
      }
      return false;
    },
    hasPaymentField: function hasPaymentField() {
      if (!this.bookingRequirePaymentInfo) {
        return false;
      }
      if (!this.user) {
        return false;
      }
      if (this.user.stripe_customer_id) {
        return false;
      }
      if (this.skipChargeUser) {
        return false;
      }
      if (!this.includeCandidatePayment) {
        // Use credits
        if (this.numberOfBooking <= this.creditCount) {
          return false;
        }
      }
      return true;
    },
    listDateTimesOfJobs: function listDateTimesOfJobs() {
      return this.getListDateTimeOfJobs(this.bookingDateTimeInfo);
    },

    // Filter the availabilities which has date in range of job's date
    listRelatedAvailabilities: function listRelatedAvailabilities() {
      if (this.availabilities) {
        // Get list dates from start_date to end_date of the booking
        var listDates = this.listDateTimesOfJobs.map(function (datetimes) {
          return datetimes.date;
        });
        return this.availabilities.filter(function (availability) {
          return listDates.includes(availability.date);
        });
      } else {
        return [];
      }
    },
    listCandidatesIdHasAvailability: function listCandidatesIdHasAvailability() {
      var listIds1 = [];
      var listIds2 = [];
      if (this.listRelatedAvailabilities) {
        listIds1 = this.listRelatedAvailabilities.map(function (availability) {
          return availability.user;
        });
      }
      if (this.weekAvailabilities) {
        listIds2 = this.weekAvailabilities.map(function (availability) {
          return availability.user;
        });
      }
      var listIds = [].concat(_toConsumableArray(listIds1), _toConsumableArray(listIds2));
      return [].concat(_toConsumableArray(new Set(listIds))); // Deduplicate
    },

    // List all cand
    listFilteredCandidates: function listFilteredCandidates() {
      var _this6 = this;

      var listCandidates = this.candidateListMainInfo || this.candidateList;
      if (!this.startDate || !listCandidates || !this.user) {
        return [];
      }
      // Check if candidate is in 'not match' relationships
      if (this.listNotMatchCandidateIds && this.listNotMatchCandidateIds.length) {
        listCandidates = listCandidates.filter(function (candidate) {
          return !_this6.listNotMatchCandidateIds.includes(candidate.id);
        });
      }

      // Check if candidate's tags must contains all client's tags
      if (this.onlyShowMatchedTags) {
        listCandidates = listCandidates.filter(function (candidate) {
          return _this6.containsAllElements(candidate.tags, _this6.user.tags, _this6.$store.getters.clientTagsRelevantMatching);
        });
      }
      // Check if candidate's locations must contains at least one of the client's locations
      if (this.onlyShowMatchedLocations && this.user.locations && this.user.locations.length) {
        listCandidates = listCandidates.filter(function (candidate) {
          return _this6.hasCommonElement(candidate.locations, _this6.user.locations);
        });
      }
      if (this.onlyShowMatchedZipcodes) {
        var postalCode = this.data.postal_code;
        if (!postalCode && this.user && this.user.postal_code) {
          postalCode = this.user.postal_code;
        }
        if (postalCode) {
          listCandidates = listCandidates.filter(function (candidate) {
            return candidate.working_postal_codes && candidate.working_postal_codes.includes(postalCode);
          });
        }
      }
      if (this.clientSelectionCandidateTypes && this.clientSelectionCandidateTypes.length) {
        listCandidates = listCandidates.filter(function (candidate) {
          return _this6.hasCommonElement(candidate.types, _this6.clientSelectionCandidateTypes);
        });
      }
      if (this.clientSelectionCandidateStatuses && this.clientSelectionCandidateStatuses.length) {
        listCandidates = listCandidates.filter(function (candidate) {
          return _this6.clientSelectionCandidateStatuses.includes(candidate.status);
        });
      }

      if (this.candidateMatchingCategoryField && this.data && this.data.category) {
        listCandidates = listCandidates.filter(function (candidate) {
          var fieldVal = candidate[_this6.candidateMatchingCategoryField];
          if (!fieldVal) {
            return false;
          }
          if (Array.isArray(fieldVal)) {
            if (fieldVal.includes(_this6.data.category)) {
              return true;
            }
          } else {
            if (fieldVal == _this6.data.category) {
              return true;
            }
          }
          return false;
        });
      }

      // Filter candidates by min ages
      if (this.minChildrenAgeField && this.user && this.user.children) {
        var listChildrenWithAges = this.user.children.filter(function (child) {
          return child.birthday;
        });
        if (listChildrenWithAges && listChildrenWithAges.length) {
          var minChildrenAge = Math.min.apply(Math, _toConsumableArray(listChildrenWithAges.map(function (child) {
            return _this6.getAgeInYears(child.birthday);
          })));
          listCandidates = listCandidates.filter(function (candidate) {
            if (candidate[_this6.minChildrenAgeField]) {
              var minAge = candidate[_this6.minChildrenAgeField];
              if (Array.isArray(minAge)) {
                minAge = Math.min.apply(Math, _toConsumableArray(minAge.map(function (age) {
                  return _this6.getNumberFromString(age);
                })));
              } else {
                minAge = _this6.getNumberFromString(minAge);
              }
              return !minAge || minAge <= minChildrenAge;
            } else {
              return false;
            }
          });
        }
      }
      return listCandidates;
    },
    listPartlyAvailableCandidates: function listPartlyAvailableCandidates() {
      var _this7 = this;

      var listFilterIds = this.listFilteredCandidates.map(function (candidate) {
        return candidate.id;
      });
      var date = this.dateInDjangoFormat(this.startDate);
      var mapCandidateTimeBlocks = this.getMapAvailableCandidates(date, this.listRelatedAvailabilities || [], this.weekAvailabilities || [], this.listRelatedJobs || [], listFilterIds, this.listFilteredCandidates);
      var result = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop = function _loop() {
          var candidateId = _step2.value;

          var candidate = _this7.listFilteredCandidates.find(function (candidate) {
            return candidate.id == candidateId;
          });
          console.log(candidate);
          if (!candidate) {
            return "continue";
          }
          // Check exceed max job daily
          var isExceed = _this7.isExceedMaxJobDaily(candidate, _this7.listRelatedJobs, _this7.bookingDateTimeInfo, _this7.listDateTimesOfJobs);
          if (isExceed) {
            return "continue";
          }
          result.push({
            candidate: candidate,
            blocks: mapCandidateTimeBlocks[candidateId],
            isExceed: isExceed
          });
        };

        for (var _iterator2 = Object.keys(mapCandidateTimeBlocks)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    },
    listAvailableCandidatesAllBookings: function listAvailableCandidatesAllBookings() {
      var _this8 = this;

      return this.listFilteredCandidates.filter(function (candidate) {
        return _this8.listCandidatesIdHasAvailability.includes(candidate.id);
      });
    },
    listAvailableCandidates: function listAvailableCandidates() {
      var _this9 = this;

      var booking = this.bookingDateTimeInfo;
      // This is the list of candidates displayed when a single job is clicked on
      return this.listFilteredCandidates.filter(function (candidate) {
        return _this9.listCandidatesIdHasAvailability.includes(candidate.id);
      }).filter(function (candidate) {
        return !_this9.isAvailabilityConflict(candidate, _this9.listRelatedAvailabilities, _this9.weekAvailabilities || [], _this9.listDateTimesOfJobs) && !_this9.isTimeConflict(candidate, _this9.listRelatedJobs, booking) && !_this9.isTimeOffConflict(candidate, _this9.listRelatedAvailabilities, _this9.listDateTimesOfJobs) && !_this9.isExceedMaxJobDaily(candidate, _this9.listRelatedJobs, booking, _this9.listDateTimesOfJobs);
      });
    },
    hasSelectInterestedCandidateSelection: function hasSelectInterestedCandidateSelection() {
      return this.clientCanExpressInterestShiftJob && (!this.passedData || !this.passedData.filler);
    },
    hasFillerSelection: function hasFillerSelection() {
      if (this.isInApplicationForm) {
        return this.clientCanAssignShiftJobApplicationForm;
      }
      return this.clientCanAssignShiftJob && (!this.passedData || !this.passedData.filler || this.showFillerListForUpdate);
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["loadAvailabilities", "loadWeekAvailabilities", "loadCandidateListMainInfo", "loadCandidateInfoSelectionFields", "getRelationshipsByEmployer", "reloadCandidateListMainInfo", "reloadEmployerListMainInfo", "unassignShiftJob", "setMapJobNumberOfMonth"]), {
    refreshData: function refreshData() {
      this.data = _extends({}, this.data);
    },
    hideModal: function hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal: function showModal() {
      var _this10 = this;

      var candidate;
      return regeneratorRuntime.async(function showModal$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.hasFillerSelection || this.hasSelectInterestedCandidateSelection || this.autoAssignCandidate)) {
                _context.next = 17;
                break;
              }

              this.listSelectedCandidates = [];
              this.listInterestedCandidates = [];
              // Initialize candidate selections
              if (this.passedData.filler) {
                candidate = this.listFilteredCandidates.find(function (candidate) {
                  return candidate.id === _this10.passedData.filler;
                });

                if (candidate) {
                  this.listSelectedCandidates = [candidate];
                }
              }
              _context.next = 6;
              return regeneratorRuntime.awrap(this.loadAvailabilities());

            case 6:
              _context.next = 8;
              return regeneratorRuntime.awrap(this.loadWeekAvailabilities());

            case 8:
              _context.next = 10;
              return regeneratorRuntime.awrap(this.loadCandidateInfoSelectionFields());

            case 10:
              if (!(this.user && this.user.id)) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return regeneratorRuntime.awrap(this.loadCandidateListMainInfo());

            case 13:
              this.loadNotMatchRelationships();
              this.loadFavoriteCandidates();

            case 15:
              this.getListRelatedJob();
              this.showFillerListForUpdate = false;

            case 17:
              this.posterCreditCount = null;
              this.isShow = true;

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    loadNotMatchRelationships: function loadNotMatchRelationships() {
      var listRelationships;
      return regeneratorRuntime.async(function loadNotMatchRelationships$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return regeneratorRuntime.awrap(this.getRelationshipsByEmployer({
                id: this.user.id,
                status: "Do Not Match"
              }));

            case 2:
              listRelationships = _context2.sent;

              this.listNotMatchCandidateIds = listRelationships.map(function (relationship) {
                return relationship.candidate;
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    },
    loadFavoriteCandidates: function loadFavoriteCandidates() {
      var listRelationships;
      return regeneratorRuntime.async(function loadFavoriteCandidates$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return regeneratorRuntime.awrap(this.getRelationshipsByEmployer({
                id: this.user.id,
                status: "Favorite"
              }));

            case 2:
              listRelationships = _context3.sent;

              this.listFavoriteCandidateIds = listRelationships.map(function (relationship) {
                return relationship.candidate;
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    },
    getListRelatedJob: function getListRelatedJob() {
      var _this11 = this;

      var res;
      return regeneratorRuntime.async(function getListRelatedJob$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!this.hasFillerSelection && !this.autoAssignCandidate)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              _context4.next = 4;
              return regeneratorRuntime.awrap(_axios2.default.get("/get-all-jobs/?job_type=" + this.jobTypeShortTermQuery + "&agency=" + this.agencyID));

            case 4:
              res = _context4.sent;

              this.listRelatedJobs = res.data.jobs;
              if (!this.isAdd && this.passedData && this.passedData.id) {
                this.listRelatedJobs = this.listRelatedJobs.filter(function (job) {
                  return job.id !== _this11.passedData.id;
                });
              }

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    },
    isPaymentFieldInvalid: function isPaymentFieldInvalid() {
      // Check if payment information is invalid
      var invalidPaymentEl = document.getElementById(_customDefineType.STRIPE_PAYMENT_ERROR_IDS.INVALID);
      if (invalidPaymentEl) {
        return true;
      }
      // Check if payment information is empty
      var emptyPaymentEl = document.getElementById(_customDefineType.STRIPE_PAYMENT_ERROR_IDS.EMPTY);
      if (emptyPaymentEl) {
        return true;
      }
      return false;
    },
    handleClickSaveButton: function handleClickSaveButton() {
      // Check missing date of additional dates
      if (this.data.additional_dates) {
        if (this.data.additional_dates.some(function (item) {
          return !item.date;
        })) {
          this.showErrorDialog("MISSING_DATE_OF_ADDITIONAL_DATES_ERROR_DIALOG");
          return;
        }
        if (this.data.additional_dates.some(function (item) {
          return item.invalidDuration;
        })) {
          this.showErrorDialog({
            key: "BOOKING_DURATION_TOO_SHORT_ERROR",
            params: [this.shiftRequestMinimumHoursPerClient]
          });
          return;
        }
      }
      if (this.isPastDate(this.startDate)) {
        this.showConfirmDialog({
          key: "BOOKING_IN_PAST_DATE_CONFIRM_DIALOG",
          onAcceptCallback: this.handleSaveJob
        });
      } else {
        this.handleSaveJob();
      }
    },
    handleSaveJob: function handleSaveJob() {
      var _this12 = this;

      var selectedDate, additionalInfo, isContinue, minHours, compareCode, compareCode2, priceInfo, candidateFee, listPriceServices, price, candidateRate, assignees, listAvailableCandidateIds, listCandidates, filler;
      return regeneratorRuntime.async(function handleSaveJob$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // Normalize startTime, endTime inside additional_dates
              if (this.data.additional_dates) {
                this.data.additional_dates.forEach(function (item) {
                  if (item.start_time) {
                    item.start_time = _this12.getTimeString(item.start_time);
                  }
                  if (item.end_time) {
                    item.end_time = _this12.getTimeString(item.end_time);
                  }
                });
              }

              if (!(this.bookingField && !this.$store.getters.isAgent)) {
                _context5.next = 13;
                break;
              }

              if (!this.isAdd) {
                _context5.next = 9;
                break;
              }

              if (!this.bookingField.numberOfHoursAddBooking) {
                _context5.next = 7;
                break;
              }

              if (!(this.calculateHoursFromNow(this.startDate, this.getTimeString(this.data.start_time)) < Number(this.bookingField.numberOfHoursAddBooking))) {
                _context5.next = 7;
                break;
              }

              if (this.bookingField.notAllowAddBookingMessage && this.bookingField.notAllowAddBookingMessage.length) {
                this.showErrorDialog({
                  innerHtml: this.bookingField.notAllowAddBookingMessage
                });
              } else {
                this.showErrorDialog({
                  key: "CANNOT_ADD_BOOKING_WITHIN_X_HOURS",
                  params: [this.bookingField.numberOfHoursAddBooking]
                });
              }
              return _context5.abrupt("return");

            case 7:
              _context5.next = 13;
              break;

            case 9:
              if (!this.bookingField.numberOfHours) {
                _context5.next = 13;
                break;
              }

              if (!(this.calculateHoursFromNow(this.data.date, this.data.start_time) < Number(this.bookingField.numberOfHours))) {
                _context5.next = 13;
                break;
              }

              if (this.bookingField.notAllowEditBookingMessage) {
                this.showErrorDialog({
                  innerHtml: this.bookingField.notAllowEditBookingMessage
                });
              } else {
                this.showErrorDialog({
                  key: "CANNOT_EDIT_BOOKING_WITHIN_X_HOURS",
                  params: [this.bookingField.numberOfHours]
                });
              }
              return _context5.abrupt("return");

            case 13:
              selectedDate = this.startDate;

              // Check if booking in list blocked date

              if (!(!this.isAgent && this.isAdd && this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.shift_request_full_dates)) {
                _context5.next = 28;
                break;
              }

              if (!this.$store.getters.agencyPublic.shift_request_full_dates.includes(this.dateInDjangoFormat(selectedDate))) {
                _context5.next = 28;
                break;
              }

              if (!this.allowBookOnBlockedDate) {
                _context5.next = 22;
                break;
              }

              this.showResultDialog({
                innerHtml: this.customMessageRequestForBlockedDates
              });
              this.data.is_blocked_date = true;
              this.data.status = this.jobStatusForBlockedDate;
              _context5.next = 28;
              break;

            case 22:
              this.showResultDialog("BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG");
              additionalInfo = "";

              if (this.data.start_time && this.data.end_time) {
                additionalInfo += "Booking Time: " + this.getTimeString(this.data.start_time) + " - " + this.getTimeString(this.data.end_time);
              }
              if (this.data.end_date) {
                additionalInfo += "<br/>End Date " + this.addTimeToDate(this.data.end_date).toDateString();
              }
              if (this.user && this.user.id) {
                this.sendEmail(_extends({}, this.$store.getters.bookingOnBlockedDateAdminNotification, {
                  recipients: this.employerShiftRequestEmailsByLocation
                }), this.user.first_name, this.user.last_name, this.addTimeToDate(selectedDate).toDateString(), this.user.email, additionalInfo);
              }
              return _context5.abrupt("return");

            case 28:

              this.submitClicked = true;
              // this.broadcastAppNotification();
              // Check to show warning for missing fields
              _context5.next = 31;
              return regeneratorRuntime.awrap(this.validateBaseInputValues(this.data, this.listVisibleFields));

            case 31:
              isContinue = _context5.sent;

              if (isContinue) {
                _context5.next = 34;
                break;
              }

              return _context5.abrupt("return");

            case 34:
              // Check for missing start_time and end_time
              minHours = this.shiftRequestMinimumHoursPerClient;
              compareCode = this.compareDuration(selectedDate, this.data.start_time, this.data.end_date, this.data.end_time, minHours);

              if (!(compareCode === -3)) {
                _context5.next = 39;
                break;
              }

              this.showErrorDialog(this.$store.getters.endDateBeforeStartDateError);
              return _context5.abrupt("return");

            case 39:
              if (!(compareCode === -1 && !this.$store.getters.isAgent)) {
                _context5.next = 42;
                break;
              }

              this.showErrorDialog(_extends({}, this.$store.getters.bookingDurationTooShortError, {
                params: [minHours]
              }));
              return _context5.abrupt("return");

            case 42:
              if (!(compareCode === -2)) {
                _context5.next = 49;
                break;
              }

              this.data.end_date = this.getNextDate(selectedDate);
              // Check booking duration with new end_date

              if (this.$store.getters.isAgent) {
                _context5.next = 49;
                break;
              }

              compareCode2 = this.compareDuration(selectedDate, this.data.start_time, this.data.end_date, this.data.end_time, minHours);

              if (!(compareCode2 === -1)) {
                _context5.next = 49;
                break;
              }

              this.showErrorDialog(_extends({}, this.$store.getters.bookingDurationTooShortError, {
                params: [minHours]
              }));
              return _context5.abrupt("return");

            case 49:
              if (!this.hasPaymentField) {
                _context5.next = 53;
                break;
              }

              if (!this.isPaymentFieldInvalid()) {
                _context5.next = 53;
                break;
              }

              this.showErrorDialog("PAYMENT_INFORMATION_REQUIRED");
              return _context5.abrupt("return");

            case 53:
              priceInfo = {
                client_rate: this.$refs.priceInfo.clientRate || 0,
                agency_fee: this.$refs.priceInfo.agencyRate || 0,
                travel_fee: this.$refs.priceInfo.travelFeePerBooking || 0,
                rush_fee: this.$refs.priceInfo.rushFeePerBooking || 0,
                per_booking_agency_fee: this.$refs.priceInfo.perBookingAgencyFee || 0,
                per_booking_candidate_fee: this.$refs.priceInfo.perBookingCandidateFee || 0,
                admin_fee: this.$refs.priceInfo.adminFeePerBooking || 0,
                admin_fee_subtraction: this.$refs.priceInfo.adminFeeSubstractionPerBooking || 0,
                total_discount: this.$refs.priceInfo.totalDiscount || 0
              };

              if (priceInfo.rush_fee && this.rushFeeInfo) {
                if (this.rushFeeInfo.listDates === this.listBookingDates) {
                  priceInfo.fee_details = {
                    rush_fee: this.rushFeeInfo.listFees
                  };
                }
              }
              candidateFee = this.$refs.priceInfo.candidateFee;

              if (candidateFee) {
                priceInfo["total_candidate_pay"] = candidateFee || 0;
                priceInfo["candidate_rate"] = null;
              } else {
                priceInfo["candidate_rate"] = this.$refs.priceInfo.candidateRate || 0;
                priceInfo["total_candidate_pay"] = null;
              }

              if (!this.data.title) {
                _context5.next = 64;
                break;
              }

              listPriceServices = this.hourlyServiceSelectionList;

              if (this.listPriceServices && this.listPriceServices.length) {
                listPriceServices = this.listPriceServices;
              }
              price = listPriceServices.find(function (price) {
                return price.name === _this12.data.title;
              });

              if (price) {
                _context5.next = 63;
                break;
              }

              return _context5.abrupt("return");

            case 63:
              if (price.is_price_expession) {
                priceInfo["candidate_rate"] = this.getPriceFromExpression(this.user, this.data, price.price_expression1, this.selectedDate) || 0;
                priceInfo["client_rate"] = this.getPriceFromExpression(this.user, this.data, price.price_expression2, this.selectedDate) || 0;
              } else {
                priceInfo["candidate_rate"] = price.price1 || 0;
                priceInfo["client_rate"] = price.price2 || 0;
              }

            case 64:
              if (this.candidatesCanSetRate && this.listSelectedCandidates && this.listSelectedCandidates.length) {
                candidateRate = this.listSelectedCandidates[0].rate;

                if (candidateRate) {
                  priceInfo["candidate_rate"] = candidateRate;
                }
              }

              // Check if client_rate is defined in the form
              if (this.listVisibleFields.some(function (field) {
                return field.model === "client_rate";
              })) {
                if (this.data.client_rate) {
                  priceInfo.client_rate = this.data.client_rate;
                }
              }

              assignees = this.listSelectedCandidates;
              // Filter out the candidate which is not in the selection list (user may change date time after selecting filler)

              listAvailableCandidateIds = this.listAvailableCandidates ? this.listAvailableCandidates.map(function (user) {
                return user.id;
              }) : [];

              if (assignees) {
                assignees = assignees.filter(function (candidate) {
                  return listAvailableCandidateIds.includes(candidate.id);
                });
              }
              // Assign automatically

              if (!this.autoAssignCandidate) {
                _context5.next = 78;
                break;
              }

              if (!(!this.data.filled && !this.listSelectedCandidates.length)) {
                _context5.next = 78;
                break;
              }

              if (!(this.listAvailableCandidates && this.listAvailableCandidates.length)) {
                _context5.next = 75;
                break;
              }

              assignees = [this.listAvailableCandidates[0]];
              _context5.next = 78;
              break;

            case 75:
              this.keepDialogOpen = false;
              this.showResultDialog({
                title: this.messageNobodyAvailable,
                closeLabel: "OK",
                onCloseCallback: this.emitDataOnSubmit,
                onCloseCallbackData: {
                  priceInfo: priceInfo,
                  assignees: assignees
                }
              });
              return _context5.abrupt("return");

            case 78:
              if (!(this.clientCanAssignShiftJob && this.isChangeBookingDateTime() && this.passedData.filler && this.showFillerListForUpdate == false)) {
                _context5.next = 105;
                break;
              }

              _context5.next = 81;
              return regeneratorRuntime.awrap(this.loadAvailabilities());

            case 81:
              _context5.next = 83;
              return regeneratorRuntime.awrap(this.loadWeekAvailabilities());

            case 83:
              _context5.next = 85;
              return regeneratorRuntime.awrap(this.loadCandidateInfoSelectionFields());

            case 85:
              if (!(this.user && this.user.id)) {
                _context5.next = 88;
                break;
              }

              _context5.next = 88;
              return regeneratorRuntime.awrap(this.loadCandidateListMainInfo());

            case 88:
              listCandidates = this.candidateListMainInfo || this.candidateList;
              filler = listCandidates.find(function (cand) {
                return cand.id === _this12.passedData.filler;
              });
              // Check if the filler is still available for the job

              if (!filler) {
                _context5.next = 105;
                break;
              }

              if (!(this.isAvailabilityConflict(filler, this.listRelatedAvailabilities, this.weekAvailabilities || [], this.listDateTimesOfJobs, true) || this.isTimeConflict(filler, this.listRelatedJobs, _extends({}, this.bookingDateTimeInfo, {
                id: this.passedData.id
              })) || this.isTimeOffConflict(filler, this.listRelatedAvailabilities, this.listDateTimesOfJobs))) {
                _context5.next = 105;
                break;
              }

              _context5.next = 94;
              return regeneratorRuntime.awrap(this.unassignShiftJobAndNotification(this.passedData, this.user, filler.id));

            case 94:
              this.data.status = this.shiftJobCandidateUnassignStatus || "Requested";
              this.data.filled = false;
              this.data.filler = null;
              this.data.filler_name = "";
              this.data.filled_date = null;
              this.showResultDialog("RESELECT_JOB_FILLER_RESULT_DIALOG");
              if (this.user && this.user.id) {
                this.loadNotMatchRelationships();
                this.loadFavoriteCandidates();
              }
              this.showFillerListForUpdate = true;
              // Save data and let user select filler later (still open the dialog)
              this.keepDialogOpen = true;
              this.emitDataOnSubmit({ priceInfo: priceInfo, assignees: assignees }, false);
              return _context5.abrupt("return");

            case 105:
              this.keepDialogOpen = false;
              this.emitDataOnSubmit({ priceInfo: priceInfo, assignees: assignees });

            case 107:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    },
    isChangeBookingDateTime: function isChangeBookingDateTime() {
      if (this.isAdd) {
        return false;
      }
      if (!this.passedData.id) {
        return false;
      }
      if (this.data.date && this.passedData.date) {
        if (this.dateInDjangoFormat(this.data.date) !== this.dateInDjangoFormat(this.passedData.date)) {
          return true;
        }
      }
      if (this.data.start_time && this.passedData.start_time) {
        if (this.getTimeString(this.passedData.start_time) !== this.getTimeString(this.data.start_time)) {
          return true;
        }
      }
      if (this.data.end_time && this.passedData.end_time) {
        if (this.getTimeString(this.passedData.end_time) !== this.getTimeString(this.data.end_time)) {
          return true;
        }
      }
      return false;
    },
    emitDataOnSubmit: function emitDataOnSubmit(_ref) {
      var priceInfo = _ref.priceInfo,
          assignees = _ref.assignees;
      var hasResultDialog = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return regeneratorRuntime.async(function emitDataOnSubmit$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (this.clientCanExpressInterestShiftJob) {
                if (!this.data.list_interest_candidate_ids || !this.data.list_interest_candidate_ids.length) {
                  this.data.list_interest_candidate_ids = this.listInterestedCandidates.map(function (candidate) {
                    return candidate.id;
                  });
                }
              }
              this.$emit("saved", {
                actionType: this.isAdd ? _customDefineType.ACTION_TYPE.ADD : _customDefineType.ACTION_TYPE.UPDATE,
                data: _extends({}, this.data, priceInfo, {
                  section_builder_id: this.sectionBuilderId,
                  profile_builder_id: this.profileBuilderID,
                  unique_fields: this.listUniqueFields,
                  map_date_filler: this.mapSelectedCandidates
                }),
                assignees: assignees,
                numberOfBooking: this.numberOfBooking,
                hasResultDialog: hasResultDialog
              });

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    },
    handleAfterSavingData: function handleAfterSavingData(listBookingIds) {
      var _this13 = this;

      return new Promise(function _callee(resolve) {
        var isCreateStripeCustomer, amount, isCharged, requestBody, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, bookingId, amountPerBooking, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _bookingId;

        return regeneratorRuntime.async(function _callee$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                isCreateStripeCustomer = false;

                if (!((_this13.chargeClientWhenBooking || _this13.chargeClientWhenAssignCandidate) && _this13.isAdd && !_this13.skipChargeUser)) {
                  _context7.next = 82;
                  break;
                }

                // Calculate amount
                amount = 0;

                if (_this13.includeCandidatePayment) {
                  amount = _this13.getTotalFee();
                } else {
                  amount = _this13.getAgencyFee();
                }

                if (!amount) {
                  _context7.next = 82;
                  break;
                }

                isCharged = false;

                if (!_this13.hasPaymentField) {
                  _context7.next = 20;
                  break;
                }

                if (!(_this13.chargeClientWhenBooking || _this13.chargeClientWhenAssignCandidate && _this13.data.filler)) {
                  _context7.next = 14;
                  break;
                }

                _context7.next = 11;
                return regeneratorRuntime.awrap(_this13.$refs.stripePayment.createCustomer(_this13.user, {
                  amount: amount
                }, listBookingIds[0], "Booking fee (Booking Date: " + _this13.getDateString(_this13.startDate) + ")"));

              case 11:
                isCharged = true;
                _context7.next = 16;
                break;

              case 14:
                _context7.next = 16;
                return regeneratorRuntime.awrap(_this13.$refs.stripePayment.createCustomer(_this13.user));

              case 16:
                _this13.$emit("reloadUser");
                isCreateStripeCustomer = true;
                _context7.next = 25;
                break;

              case 20:
                if (!_this13.user.stripe_customer_id) {
                  _context7.next = 25;
                  break;
                }

                if (!(_this13.chargeClientWhenBooking || _this13.chargeClientWhenAssignCandidate && _this13.data.filler)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 24;
                return regeneratorRuntime.awrap(_axios2.default.post("/stripe-collect-payment-from-existing-customer/", {
                  stripe_payer_account: _this13.user.stripe_customer_id,
                  stripe_payee_account: _this13.$store.getters.agency.stripe_account_id,
                  amount: Math.round(parseFloat(amount).toFixed(2) * 100),
                  receipt_email: _this13.user.email,
                  currency: _this13.user.currency || _this13.$store.getters.agency.currency,
                  log: true,
                  agency: _this13.$store.getters.agencyID,
                  user: _this13.user.id,
                  category: "Job",
                  related_id: listBookingIds[0],
                  description: "Charge Client when create booking (Booking Date: " + _this13.getDateString(_this13.startDate) + " - ID: " + listBookingIds[0]
                }));

              case 24:
                isCharged = true;

              case 25:
                if (!(isCharged && listBookingIds)) {
                  _context7.next = 54;
                  break;
                }

                requestBody = {
                  date_client_charged: _this13.dateInDjangoFormat(new Date())
                };

                if (_this13.includeCandidatePayment) {
                  requestBody.total_client_charge = _this13.roundNumberTwoDigits(amount);
                }
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context7.prev = 31;
                _iterator3 = listBookingIds[Symbol.iterator]();

              case 33:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context7.next = 40;
                  break;
                }

                bookingId = _step3.value;
                _context7.next = 37;
                return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + bookingId + "/", requestBody));

              case 37:
                _iteratorNormalCompletion3 = true;
                _context7.next = 33;
                break;

              case 40:
                _context7.next = 46;
                break;

              case 42:
                _context7.prev = 42;
                _context7.t0 = _context7["catch"](31);
                _didIteratorError3 = true;
                _iteratorError3 = _context7.t0;

              case 46:
                _context7.prev = 46;
                _context7.prev = 47;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 49:
                _context7.prev = 49;

                if (!_didIteratorError3) {
                  _context7.next = 52;
                  break;
                }

                throw _iteratorError3;

              case 52:
                return _context7.finish(49);

              case 53:
                return _context7.finish(46);

              case 54:
                if (!(_this13.chargeClientWhenAssignCandidate && !isCharged)) {
                  _context7.next = 82;
                  break;
                }

                amountPerBooking = amount / listBookingIds.length;
                // Update user information to charge client when candidate is assigned

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context7.prev = 59;
                _iterator4 = listBookingIds[Symbol.iterator]();

              case 61:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context7.next = 68;
                  break;
                }

                _bookingId = _step4.value;
                _context7.next = 65;
                return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + _bookingId + "/", {
                  charge_client_on_assign: _this13.roundNumberTwoDigits(amountPerBooking)
                }));

              case 65:
                _iteratorNormalCompletion4 = true;
                _context7.next = 61;
                break;

              case 68:
                _context7.next = 74;
                break;

              case 70:
                _context7.prev = 70;
                _context7.t1 = _context7["catch"](59);
                _didIteratorError4 = true;
                _iteratorError4 = _context7.t1;

              case 74:
                _context7.prev = 74;
                _context7.prev = 75;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 77:
                _context7.prev = 77;

                if (!_didIteratorError4) {
                  _context7.next = 80;
                  break;
                }

                throw _iteratorError4;

              case 80:
                return _context7.finish(77);

              case 81:
                return _context7.finish(74);

              case 82:
                if (!(_this13.hasPaymentField && !isCreateStripeCustomer)) {
                  _context7.next = 86;
                  break;
                }

                _context7.next = 85;
                return regeneratorRuntime.awrap(_this13.$refs.stripePayment.createCustomer(_this13.user));

              case 85:
                _this13.$emit("reloadUser");

              case 86:
                if (!_this13.keepDialogOpen) {
                  _this13.hideModal();
                }
                _context7.next = 92;
                break;

              case 89:
                _context7.prev = 89;
                _context7.t2 = _context7["catch"](0);

                if (!_this13.keepDialogOpen) {
                  _this13.hideModal();
                }

              case 92:
                resolve();

              case 93:
              case "end":
                return _context7.stop();
            }
          }
        }, null, _this13, [[0, 89], [31, 42, 46, 54], [47,, 49, 53], [59, 70, 74, 82], [75,, 77, 81]]);
      });
    },
    showDeleteBookingConfirmDialog: function showDeleteBookingConfirmDialog() {
      this.showConfirmDialog(_extends({}, this.$store.getters.deleteBookingConfirmDialog, {
        onAcceptCallback: this.deleteBooking
      }));
    },
    deleteBooking: function deleteBooking() {
      this.hideModal();
      this.$emit("saved", { actionType: _customDefineType.ACTION_TYPE.DELETE, data: this.data });
    },
    handleClickCloseButton: function handleClickCloseButton() {
      if (this.isDisableConfirmCancellation()) {
        this.hideModal();
        return;
      }
      // Check if data is unchanged
      if (this.isUnchangedObject(this.originalData, this.data, this.listVisibleFields)) {
        this.hideModal();
        return;
      }
      this.showConfirmDialog(_extends({}, this.$store.getters.cancelConfirmDialog, {
        onAcceptCallback: this.hideModal
      }));
    },

    // Fee client pay agency per booking
    getAgencyFee: function getAgencyFee() {
      var amount = 0;

      if (!this.$refs.priceInfo) {
        return this.roundNumberTwoDigits(amount);
      }

      var perBookingAgencyFee = this.$refs.priceInfo.totalPerBookingAgencyFee;
      if (perBookingAgencyFee) {
        amount += Number(perBookingAgencyFee);
      }
      // Rush fee is fee pay to agency
      var rushFee = this.$refs.priceInfo.rushFee;
      if (rushFee) {
        amount += Number(rushFee);
      }
      var agencyRate = this.$refs.priceInfo.agencyRate;
      if (agencyRate) {
        amount += this.$refs.priceInfo.bookingDuration * Number(agencyRate);
      }
      // Admin fee
      var adminFee = this.$refs.priceInfo.adminFee;
      if (adminFee) {
        amount += Number(adminFee);
      }
      var adminFeeSubstraction = this.$refs.priceInfo.adminFeeSubstraction;
      if (adminFeeSubstraction) {
        amount += Number(adminFeeSubstraction);
      }
      var totalDiscount = this.$refs.priceInfo.totalDiscount;
      if (totalDiscount) {
        amount = amount - Number(totalDiscount);
      }
      return this.roundNumberTwoDigits(amount);
    },

    // Fee client pay agency and candidate per booking
    getTotalFee: function getTotalFee() {
      var amount = 0;

      if (!this.$refs.priceInfo) {
        return this.roundNumberTwoDigits(amount);
      }

      var flatRate = this.$refs.priceInfo.totalFlatRate;
      if (flatRate) {
        amount += flatRate;
      }
      return this.roundNumberTwoDigits(amount);
    },
    handleClickUserButton: function handleClickUserButton(_ref2) {
      var _this14 = this;

      var btnId = _ref2.btnId,
          model = _ref2.model,
          el = _ref2.el;

      if (btnId === "add-client") {
        this.addingUserType = "employer";
        this.addUserModel = model;
        this.isShowAddUserDialog = true;
      } else if (btnId === "view-client") {
        this.showUserProfileDialog(this.data.poster, false);
      } else if (btnId === "add-candidate") {
        this.addingUserType = "candidate";
        this.addUserModel = model;
        this.isShowAddUserDialog = true;
      } else if (btnId === "view-filler") {
        this.showUserProfileDialog(this.data.filler, true);
      } else if (btnId === "view-tentative-filler") {
        this.showUserProfileDialog(this.data.tentatively_filler, true);
      } else if (btnId === "add-option") {
        this.showInputDialog({
          title: "New Options",
          listFields: [{
            type: _customDefineType.FORM_TYPE.TEXTBOX,
            model: "option"
          }],
          onSubmitCallback: function onSubmitCallback(info) {
            return regeneratorRuntime.async(function onSubmitCallback$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    console.log(el);
                    _context8.next = 3;
                    return regeneratorRuntime.awrap(_axios2.default.patch("/profile-builder/" + el.builderId + "/", {
                      action_type: "Add Option",
                      option: info.option,
                      model: model
                    }));

                  case 3:
                    _context8.next = 5;
                    return regeneratorRuntime.awrap(_this14.reloadProfileBuilderList());

                  case 5:
                  case "end":
                    return _context8.stop();
                }
              }
            }, null, _this14);
          }
        });
      }
    },
    handleClickTextboxButton: function handleClickTextboxButton(_ref3) {
      var btnId = _ref3.btnId,
          model = _ref3.model;
      var res;
      return regeneratorRuntime.async(function handleClickTextboxButton$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(btnId === "check-for-existing")) {
                _context9.next = 5;
                break;
              }

              _context9.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.post("/check-existing-job/", {
                model: model,
                agency: this.agencyID,
                value: this.data[model]
              }));

            case 3:
              res = _context9.sent;

              this.showResultDialog({ title: res.data.message, noToast: true });

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    },
    handleClickSelectIndividualBooking: function handleClickSelectIndividualBooking() {
      this.isShowSelectFillerDialog = true;
    },
    handleUpdateSelection: function handleUpdateSelection(model) {
      var _this15 = this;

      if (model === "children_ids") {
        if (this.data.children_ids) {
          this.data.number_children = this.data.children_ids.length;
        } else {
          this.data.number_children = null;
        }
      }
      this.$nextTick(function () {
        _this15.refreshData();
      });
    }
  }),
  watch: (_watch = {
    data: {
      immediate: true,
      handler: function handler(value) {
        if (!value) {
          this.bookingDateTimeInfo = { date: this.selectedDate };
          return;
        }
        var listKeys = ["date", "end_date", "start_time", "end_time", "repeat", "repeat_end_date", "repeat_count", "repeat_type", "repeat_weekdays", "additional_dates"];
        // Check if data is unchanged
        if (value) {
          var isChange = false;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = listKeys[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var key = _step5.value;

              if (!this.selectedDate || key !== "date") {
                if (value[key] != this.bookingDateTimeInfo[key]) {
                  isChange = true;
                  break;
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          if (!isChange) {
            return;
          }
        }
        var result = {};

        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = listKeys[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _key = _step6.value;

            result[_key] = this.data[_key];
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        this.bookingDateTimeInfo = _extends({}, result, {
          date: value.date || this.selectedDate
        });
      }
    },
    value: {
      immediate: true,
      handler: function handler(value) {
        var _this16 = this;

        if (value === true) {
          this.submitClicked = false;
          this.data = _extends({}, this.passedData);
          if (!this.data.number_children && this.tryGet(function () {
            return _this16.user.children.length;
          })) {
            this.data["number_children"] = this.user.children.length;
            this.data.children_ids = this.user.children.map(function (child) {
              return child.id;
            });
          }
          if (!this.data.end_date) {
            this.data.end_date = this.selectedDate;
          }
          this.originalData = _extends({}, this.data);
          if (this.isAdd && this.broadcastOnCreateJob) {
            this.data.is_broadcast = true;
          }
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    },
    isShow: {
      immediate: true,
      handler: function handler() {
        this.$emit("input", this.isShow);
      }
    },
    startDate: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.data.end_date = val;
        }
      }
    }
  }, _defineProperty(_watch, "isShow", {
    immediate: true,
    handler: function handler() {
      this.$emit("input", this.isShow);
    }
  }), _defineProperty(_watch, "listAvailableCandidates", {
    immediate: true,
    handler: function handler() {
      if (!this.isAdd) {
        return;
      }
      // Check if list selected candidates is still in the available list
      var listAvailableIds = [];
      if (this.listAvailableCandidates) {
        listAvailableIds = this.listAvailableCandidates.map(function (candidate) {
          return candidate.id;
        });
      }
      var listCandidateNoLongerAvailables = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = this.listSelectedCandidates[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var candidate = _step7.value;

          if (!listAvailableIds.includes(candidate.id)) {
            listCandidateNoLongerAvailables.push(candidate);
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      if (!listCandidateNoLongerAvailables.length) {
        return;
      }
      var info = listCandidateNoLongerAvailables.map(function (user) {
        return user.first_name + " " + user.last_name;
      }).join(", ");
      this.showResultDialog({
        key: "CANDIDATES_NO_LONGER_AVAILABLES",
        params: [info]
      });
      var listNotAvailableIds = listCandidateNoLongerAvailables.map(function (user) {
        return user.id;
      });
      this.listSelectedCandidates = this.listSelectedCandidates.filter(function (candidate) {
        return !listNotAvailableIds.includes(candidate.id);
      });
    }
  }), _defineProperty(_watch, "listSelectedCandidates", {
    immediate: true,
    handler: function handler(val) {
      var _this17 = this;

      var fillerId;
      return regeneratorRuntime.async(function handler$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (!this.$store.getters.isRecalculatePriceOnAssignJob) {
                _context10.next = 8;
                break;
              }

              fillerId = void 0;

              if (val && val.length) {
                fillerId = val[0].id;
              }
              _context10.next = 5;
              return regeneratorRuntime.awrap(this.setMapJobNumberOfMonthOnAssignJob(this.data, this.startDate, fillerId));

            case 5:
              this.data.selected_filler_id = fillerId;
              if (fillerId) {
                this.listModelRecalculatedWhenAssignJob.forEach(function (model) {
                  _this17.data[model] = null;
                });
              }
              this.data = _extends({}, this.data);

            case 8:
              console.log(val);

            case 9:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this);
    }
  }), _watch)
};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripePayment_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripePayment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripePayment_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripePayment_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripePayment_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a65a253_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripePayment_vue__ = __webpack_require__(543);
function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a65a253"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripePayment_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a65a253_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripePayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _customDefineType = __webpack_require__(6);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "StripePayment",
  props: {
    user: {
      type: Object,
      default: function _default() {}
    },
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    isRequired: {
      type: Boolean,
      default: false
    },
    submitClicked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: "card-element"
    }
  },
  data: function data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      cardError: false,
      isStripeSetup: false,
      STRIPE_PAYMENT_ERROR_IDS: _customDefineType.STRIPE_PAYMENT_ERROR_IDS,
      unwatch: null,
      paymentMethodId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.setUpStripe();
    this.unwatch = this.$store.watch(function (state) {
      return state.agency.agencyPublic;
    }, function (val) {
      if (!val) {
        return;
      }
      _this.setUpStripe();
    }, { immediate: true });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.unwatch) {
      this.unwatch();
    }
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["agencyCurrency", "registrationFeeStripeDescription"]), {
    isCardComplete: function isCardComplete() {
      if (this.card) {
        return this.card._complete;
      } else {
        return false;
      }
    }
  }),
  methods: {
    setUpStripe: function setUpStripe() {
      var _this2 = this;

      if (!this.$store.getters.agencyPublic || !Object.keys(this.$store.getters.agencyPublic).length) {
        // Not finish loading
        return;
      }
      if (this.isStripeSetup) {
        return;
      }
      this.isStripeSetup = true;
      this.stripe = Stripe("pk_live_uQWLhWijqTDmzPz1heFX42gd00M0Oov1EL", {
        // stripeAccount: "acct_1GDXlTE7jOFBALyf" // Test account
        //   // stripeAccount: this.$store.getters.stripeAccountID
        // stripeAccount: 'acct_1GDZdaDZMNxDtGP7' // Express
        // stripeAccount: "acct_1Bg1iOJgWhWzU0rX", // Standard
        stripeAccount: this.$store.getters.agencyPublic.stripe_account_id
      });
      this.elements = this.stripe.elements();
      // this.elements = stripe.elements();

      var style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            // color: "#aab7c4",
            color: "#1f4e78"
          }
        },

        invalid: {
          // All of the error styles go inside of here.
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      this.card = this.elements.create("card", { style: style });
      this.card.mount("#" + this.id);

      this.card.addEventListener("change", function (_ref) {
        var error = _ref.error;

        var displayError = document.getElementById("card-errors");
        if (error) {
          displayError.textContent = error.message;
          _this2.cardError = true;
        } else {
          displayError.textContent = "";
          _this2.cardError = false;
        }
        _this2.$nextTick(function () {
          var paymentInfoErrorInnerHtml = "";
          if (_this2.cardError) {
            paymentInfoErrorInnerHtml = "<span id='" + _customDefineType.STRIPE_PAYMENT_ERROR_IDS.INVALID + "'>Payment information is incorrect</span>";
          } else {
            if (_this2.isCardComplete) {
              paymentInfoErrorInnerHtml = "";
            } else {
              paymentInfoErrorInnerHtml = "<span id='" + _customDefineType.STRIPE_PAYMENT_ERROR_IDS.EMPTY + "'>The field is required.</span>";
            }
          }
          var paymentInfoError = document.getElementById("payment-info-error");
          if (paymentInfoError) {
            paymentInfoError.innerHTML = paymentInfoErrorInnerHtml;
          }
        });
      });
    },
    createPaymentMethod: function createPaymentMethod() {
      var _this3 = this;

      return new Promise(function _callee(resolve) {
        var userEmail, result, errorMessage;
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userEmail = _this3.user.email;

                _this3.showLoading();
                _context.next = 4;
                return regeneratorRuntime.awrap(_this3.stripe.createPaymentMethod({
                  type: "card",
                  // card: cardElement,
                  card: _this3.card,
                  billing_details: {
                    email: userEmail
                  }
                }));

              case 4:
                result = _context.sent;

                _this3.hideLoading();
                if (result.error) {
                  errorMessage = result.error.message ? result.error.message : JSON.stringify(result.error);

                  _this3.showErrorDialog({
                    title: "Error when creating Stripe payment method",
                    message: errorMessage
                  });
                  resolve();
                } else {
                  _this3.paymentMethodId = result.paymentMethod.id;
                  resolve(_this3.paymentMethodId);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, null, _this3);
      });
    },
    createCustomerAndCharge: function createCustomerAndCharge(user, payment) {
      var _this4 = this;

      var giftCardCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var userEmail = user.email;
      var userName = user.first_name + " " + user.last_name;
      return new Promise(function _callee2(resolve) {
        var createCustomerRes;
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return regeneratorRuntime.awrap(_axios2.default.post("/stripe-create-customer-v2/", {
                  email: userEmail,
                  name: userName,
                  enginehire_id: user.id,
                  payment_method_id: _this4.paymentMethodId,
                  stripe_account: _this4.$store.getters.agencyPublic.stripe_account_id,
                  agency: _this4.$store.getters.agencyID,
                  charge_info: payment,
                  charge_description: _this4.registrationFeeStripeDescription,
                  gift_card_code: giftCardCode
                }));

              case 2:
                createCustomerRes = _context2.sent;

                if (!payment) {
                  _context2.next = 9;
                  break;
                }

                if (!_this4.tryGet(function () {
                  return createCustomerRes.data.charge_success;
                })) {
                  _context2.next = 7;
                  break;
                }

                // Collect payment successfully
                resolve(true);
                return _context2.abrupt("return");

              case 7:
                _context2.next = 11;
                break;

              case 9:
                // No payment need
                resolve(true);
                return _context2.abrupt("return");

              case 11:
                resolve(false);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, null, _this4);
      });
    },
    createCustomer: function createCustomer(user, payment, jobId, chargeDescription) {
      var _this5 = this;

      return new Promise(function _callee3(resolve) {
        var userEmail, userName, result, errorMessage, createCustomerRes, currency;
        return regeneratorRuntime.async(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                userEmail = _this5.user.email;
                userName = _this5.user.first_name + " " + _this5.user.last_name;
                _context3.next = 4;
                return regeneratorRuntime.awrap(_this5.stripe.createPaymentMethod({
                  type: "card",
                  // card: cardElement,
                  card: _this5.card,
                  billing_details: {
                    email: userEmail
                  }
                }));

              case 4:
                result = _context3.sent;

                if (!result.error) {
                  _context3.next = 10;
                  break;
                }

                errorMessage = result.error.message ? result.error.message : JSON.stringify(result.error);

                _this5.showErrorDialog({
                  title: "Error when creating payment method",
                  message: errorMessage
                });
                _context3.next = 26;
                break;

              case 10:
                _context3.next = 12;
                return regeneratorRuntime.awrap(_axios2.default.post("/stripe-create-customer-v2/", {
                  email: userEmail,
                  name: userName,
                  enginehire_id: user.id,
                  payment_method_id: result.paymentMethod.id,
                  stripe_account: _this5.$store.getters.agencyPublic.stripe_account_id,
                  agency: _this5.$store.getters.agencyID
                }));

              case 12:
                createCustomerRes = _context3.sent;

                if (!(payment && createCustomerRes && createCustomerRes.data)) {
                  _context3.next = 26;
                  break;
                }

                if (!payment.amount) {
                  _context3.next = 21;
                  break;
                }

                currency = user.currency || _this5.agencyCurrency;

                if (!currency) {
                  currency = "usd"; // Default currency
                }
                _context3.next = 19;
                return regeneratorRuntime.awrap(_axios2.default.post("/stripe-collect-payment-from-existing-customer/", {
                  stripe_payer_account: createCustomerRes.data.stripe_customer.id,
                  stripe_payee_account: _this5.$store.getters.agencyPublic.stripe_account_id,
                  amount: Math.round(payment.amount * 100),
                  receipt_email: userEmail,
                  currency: currency,
                  log: true,
                  agency: _this5.$store.getters.agencyID,
                  user: user.id,
                  category: "Job",
                  related_id: jobId,
                  description: chargeDescription
                }));

              case 19:
                _context3.next = 24;
                break;

              case 21:
                if (!payment.subscription) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 24;
                return regeneratorRuntime.awrap(_axios2.default.post("/stripe-create-subscription/", {
                  stripe_account: _this5.$store.getters.agencyPublic.stripe_account_id,
                  customer_id: createCustomerRes.data.stripe_customer.id,
                  plan_id: payment.subscription.plan_id,
                  fee_percentage: payment.subscription.fee_percentage,
                  tax_percentage: payment.subscription.tax_percentage,
                  coupon: payment.subscription.coupon,
                  promotion_code: payment.subscription.promotion_code,
                  agency: _this5.$store.getters.agencyID
                }));

              case 24:
                // Collect payment successfully
                resolve(true);
                return _context3.abrupt("return");

              case 26:
                resolve();

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, null, _this5);
      });
    }
  }
};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingPriceInfo_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingPriceInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingPriceInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingPriceInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingPriceInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b425296_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingPriceInfo_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b425296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingPriceInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b425296_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingPriceInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _PriceInfoCalculation = __webpack_require__(209);

var _PriceInfoCalculation2 = _interopRequireDefault(_PriceInfoCalculation);

var _PriceValueItem = __webpack_require__(546);

var _PriceValueItem2 = _interopRequireDefault(_PriceValueItem);

var _vuex = __webpack_require__(11);

var _options = __webpack_require__(132);

var _customDefineType = __webpack_require__(6);

var _defaultValues = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "BookingPriceInfo",
  components: { PriceValueItem: _PriceValueItem2.default },
  props: {
    job: Object,
    originalJob: Object,
    categoryList: {
      type: String,
      default: ""
    },
    user: {
      type: Object,
      default: function _default() {}
    },
    listPrices: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnLayout: {
      type: Boolean,
      default: false
    },
    selectedDate: String,
    // If number of children is more than that, additional fee will be added
    numberOfAllowedChildren: {
      type: Number,
      default: 1
    },
    numberOfBooking: {
      type: Number,
      default: 1
    },
    numberOfBookingUsingCredit: {
      type: Number,
      default: 0
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    listDateTimesOfJobs: Array,
    listBookingDates: Array,
    forceRecalculate: {
      type: Boolean,
      default: false
    },
    isInApplicationForm: {
      type: Boolean,
      default: false
    }
  },
  mixins: [_PriceInfoCalculation2.default],
  data: function data() {
    return {
      candidateRateModified: null,
      agencyRateModified: null,
      travelFeeModified: null,
      rushFeeModified: null,
      candidateRushFeeModified: null,
      perBookingAgencyFeeModified: null,
      perBookingCandidateFeeModified: null,
      totalHourlyRateModified: null,
      totalFlatRateModified: null,
      adminFeeModified: null,
      adminFeeSubstractionModified: null,
      DEFAULT_PRICE_INFO_ITEMS_PLACEMENT: _defaultValues.DEFAULT_PRICE_INFO_ITEMS_PLACEMENT
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["isAgent", "showCandidateRateToClient", "showClientRateToClient", "placementOfPriceInfoFields"]), {
    numberOfBookingNotUsingCredit: function numberOfBookingNotUsingCredit() {
      return this.numberOfBooking - this.numberOfBookingUsingCredit;
    },
    bookingDuration: function bookingDuration() {
      var _this = this;

      if (this.listDateTimesOfJobs && this.listDateTimesOfJobs.length > 1 && this.job.start_time && this.job.end_time) {
        var totalDuration = this.listDateTimesOfJobs.reduce(function (acc, cur) {
          return acc + _this.calculateDuration(cur.date, cur.startTime, cur.date, cur.endTime);
        }, 0);
        return totalDuration.toFixed(2);
      }
      var startDate = this.job.date || this.selectedDate;
      return (this.calculateDuration(startDate, this.getTimeString(this.job.start_time), this.job.end_date ? this.job.end_date : startDate, this.getTimeString(this.job.end_time)) * this.numberOfBooking).toFixed(2);
    },
    showCombinePrice: function showCombinePrice() {
      return this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.public_advance_setting && this.$store.getters.agencyPublic.public_advance_setting.show_combined_booking_price;
    },
    showTotalBookingFee: function showTotalBookingFee() {
      return this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.public_advance_setting && this.$store.getters.agencyPublic.public_advance_setting.show_total_booking_fee;
    },
    clientRate: function clientRate() {
      // Check if agency rate or candidate rate changed
      var isCandidateRateChanged = this.isFeeChanged(this.calculateCandidateRate);
      var isAgencyRateChanged = this.isFeeChanged(this.calculateAgencyFee);
      if (!isCandidateRateChanged && !isAgencyRateChanged) {
        if (this.originalJob && this.originalJob.client_rate && this.originalJob.client_rate !== "0.00") {
          return Number(this.originalJob.client_rate);
        }
      }
      var result = 0;
      if (this.candidateRate && !isNaN(this.candidateRate)) {
        result = Number(this.candidateRate);
      }
      if (this.agencyRate && !isNaN(this.agencyRate)) {
        result = result + Number(this.agencyRate);
      }
      return result;
    },

    candidateRate: {
      get: function get() {
        if (this.candidateRateModified != null) {
          return this.candidateRateModified;
        }
        return this.calculateFee("candidate_rate", this.calculateCandidateRate);
      },
      set: function set(val) {
        this.candidateRateModified = val;
      }
    },
    agencyRate: {
      get: function get() {
        if (!this.numberOfBookingNotUsingCredit) {
          return 0;
        }
        if (this.agencyRateModified != null) {
          return this.agencyRateModified;
        }
        return this.calculateFee("agency_fee", this.calculateAgencyFee);
      },
      set: function set(val) {
        this.agencyRateModified = val;
      }
    },
    travelFee: {
      get: function get() {
        if (this.travelFeeModified != null) {
          return this.travelFeeModified;
        }
        return this.calculateFee("travel_fee", this.calculateTravelFee, this.numberOfBooking);
      },
      set: function set(val) {
        this.travelFeeModified = val;
      }
    },
    travelFeePerBooking: function travelFeePerBooking() {
      if (!this.numberOfBooking || !this.travelFee) {
        return this.travelFee;
      }
      if (this.job && this.job.travel_fee && this.travelFeeModified == null) {
        return this.roundNumberTwoDigits(Number(this.job.travel_fee));
      }
      return this.roundNumberTwoDigits(Number(this.travelFee) / this.numberOfBooking);
    },

    rushFee: {
      get: function get() {
        if (this.rushFeeModified != null) {
          return this.rushFeeModified;
        }
        return this.calculateFee("rush_fee", this.calculateRushFee, this.numberOfBooking);
      },
      set: function set(val) {
        this.rushFeeModified = val;
      }
    },
    rushFeePerBooking: function rushFeePerBooking() {
      if (!this.numberOfBooking || !this.rushFee) {
        return this.rushFee;
      }
      return this.roundNumberTwoDigits(Number(this.rushFee) / this.numberOfBooking);
    },

    candidateRushFee: {
      get: function get() {
        if (this.candidateRushFeeModified != null) {
          return this.candidateRushFeeModified;
        }
        return this.calculateFee("candidate_rush_fee", this.calculateCandidateRushFee, this.numberOfBooking);
      },
      set: function set(val) {
        this.candidateRushFeeModified = val;
      }
    },
    candidateRushFeePerBooking: function candidateRushFeePerBooking() {
      if (!this.numberOfBooking || !this.candidateRushFee) {
        return this.candidateRushFee;
      }
      return this.roundNumberTwoDigits(Number(this.candidateRushFee) / this.numberOfBooking);
    },
    totalRushFee: function totalRushFee() {
      var result = 0;
      if (this.rushFee) {
        result += Number(this.rushFee);
      }
      if (this.candidateRushFee) {
        result += Number(this.candidateRushFee);
      }
      return result;
    },

    perBookingAgencyFee: {
      get: function get() {
        if (!this.numberOfBookingNotUsingCredit) {
          return 0;
        }
        if (this.perBookingAgencyFeeModified != null) {
          return this.perBookingAgencyFeeModified;
        }
        return this.calculateFee("per_booking_agency_fee", this.getPerBookingAgencyFee);
      },
      set: function set(val) {
        this.perBookingAgencyFeeModified = val;
      }
    },
    totalDiscount: function totalDiscount() {
      return this.getTotalDiscount(_extends({}, this.job, {
        bulk_count: this.numberOfBooking
      }));
    },
    totalPerBookingAgencyFee: function totalPerBookingAgencyFee() {
      if (!this.numberOfBookingNotUsingCredit) {
        return 0;
      }
      if (!this.numberOfBookingNotUsingCredit || !this.perBookingAgencyFee) {
        return this.perBookingAgencyFee;
      }
      return this.roundNumberTwoDigits(Number(this.perBookingAgencyFee) * this.numberOfBookingNotUsingCredit);
    },

    perBookingCandidateFee: {
      get: function get() {
        if (this.perBookingCandidateFeeModified != null) {
          return this.perBookingCandidateFeeModified;
        }
        return this.calculateFee("per_booking_candidate_fee", this.getPerBookingCandidateFee);
      },
      set: function set(val) {
        this.perBookingCandidateFeeModified = val;
      }
    },
    totalPerBookingCandidateFee: function totalPerBookingCandidateFee() {
      if (!this.numberOfBooking || !this.perBookingCandidateFee) {
        return this.perBookingCandidateFee;
      }
      return this.roundNumberTwoDigits(Number(this.perBookingCandidateFee) * this.numberOfBooking);
    },

    adminFee: {
      get: function get() {
        if (this.adminFeeModified != null) {
          return this.adminFeeModified;
        }
        if (this.job && this.job.admin_fee) {
          if (this.job.admin_fee === "0.00") {
            return 0;
          }
          return this.job.admin_fee;
        }
        var totalFee = this.totalFlatRateExcludeAdminFee;
        var adminFee = this.getAdminFeeOfJob(this.job, totalFee);
        return adminFee;
      },
      set: function set(val) {
        this.adminFeeModified = val;
      }
    },
    adminFeePerBooking: function adminFeePerBooking() {
      if (!this.numberOfBooking || !this.adminFee) {
        return this.adminFee;
      }
      return this.roundNumberTwoDigits(Number(this.adminFee) / this.numberOfBooking);
    },

    adminFeeSubstraction: {
      get: function get() {
        if (this.adminFeeSubstractionModified != null) {
          return this.adminFeeSubstractionModified;
        }
        if (this.job && this.job.admin_fee_subtraction) {
          if (this.job.admin_fee_subtraction === "0.00") {
            return 0;
          }
          return this.job.admin_fee_subtraction;
        }
        var totalFee = this.totalFlatRateExcludeAdminFee;
        var adminFee = this.getAdminFeeOfJob(this.job, totalFee, _customDefineType.PRICE_TYPES.ADMIN_PERCENTAGE);
        return adminFee;
      },
      set: function set(val) {
        this.adminFeeSubstractionModified = val;
      }
    },
    adminFeeSubstractionPerBooking: function adminFeeSubstractionPerBooking() {
      if (!this.numberOfBooking || !this.adminFeeSubstraction) {
        return this.adminFeeSubstraction;
      }
      return this.roundNumberTwoDigits(Number(this.adminFeeSubstraction) / this.numberOfBooking);
    },

    totalHourlyRate: {
      get: function get() {
        if (this.totalHourlyRateModified != null) {
          return this.totalHourlyRateModified;
        }
        var result = 0;
        if (this.candidateRate) {
          result += Number(this.candidateRate);
        }
        if (this.agencyRate) {
          result += Number(this.agencyRate);
        }
        return result;
      },
      set: function set(val) {
        this.totalHourlyRateModified = val;
      }
    },
    totalFlatRateExcludeAdminFee: function totalFlatRateExcludeAdminFee() {
      if (this.totalFlatRateModified != null) {
        if (this.adminFee) {
          return Number(this.totalFlatRateModified) - Number(this.adminFee);
        } else {
          return this.totalFlatRateModified;
        }
      }
      var result = 0;
      if (this.travelFee) {
        result += Number(this.travelFee);
      }
      if (this.rushFee) {
        result += Number(this.rushFee);
      }
      if (this.candidateRushFee) {
        result += Number(this.candidateRushFee);
      }
      if (this.totalPerBookingAgencyFee) {
        result += Number(this.totalPerBookingAgencyFee);
      }
      if (this.totalPerBookingCandidateFee) {
        result += Number(this.totalPerBookingCandidateFee);
      }
      if (this.candidateRate) {
        result += Number(this.candidateRate) * Number(this.bookingDuration);
      }
      if (this.agencyRate) {
        result += Number(this.agencyRate) * Number(this.bookingDuration);
      }
      if (this.job.additional_fee) {
        result += Number(this.job.additional_fee);
      }
      return result;
    },

    totalFlatRate: {
      get: function get() {
        if (this.adminFee) {
          return Number(this.totalFlatRateExcludeAdminFee) + Number(this.adminFee);
        } else {
          return this.totalFlatRateExcludeAdminFee;
        }
      },
      set: function set(val) {
        this.totalFlatRateModified = val;
      }
    },
    candidateFee: function candidateFee() {
      return this.calculateCandidateFee(this.job);
    },
    perBookingFlatRate: function perBookingFlatRate() {
      if (this.totalFlatRate && this.job.repeat) {
        return this.totalFlatRate / this.numberOfBooking;
      }
      return 0;
    },
    pricingInfoList: function pricingInfoList() {
      if (this.placementOfPriceInfoFields.length) {
        return this.placementOfPriceInfoFields;
      }
      return this.DEFAULT_PRICE_INFO_ITEMS_PLACEMENT;
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["setRushFeeInfo"]), {
    isFeeChanged: function isFeeChanged(feeFunction) {
      var rate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // Calculated fee
      if (rate == null) {
        rate = feeFunction(this.job);
      }
      // Check if fee, rate changed because of updating booking
      if (this.originalJob && Object.keys(this.originalJob).length) {
        var originalRate = feeFunction(this.originalJob);
        if (originalRate !== rate) {
          return true;
        }
      }
      return false;
    },
    calculateFee: function calculateFee(model, feeFunction, numberOfBooking) {
      console.log(model, this.job);
      if (this.forceRecalculate) {
        // Change to a non exist model to recalculate fee
        model = "non_existed";
      }
      // Calculated fee
      var rate = feeFunction(this.job);
      console.log(rate);
      var isFeeChanged = this.isFeeChanged(feeFunction, rate);
      if (!isFeeChanged) {
        // Saved fee (It might be adjusted by agency)
        if (this.job && model in this.job) {
          if (this.job[model] === "0.00") {
            return 0;
          }
          return this.job[model];
        }
      }
      if (rate) {
        if (numberOfBooking > 1) {
          if (model.indexOf("rush_fee") >= 0) {
            // Calculate rate for each booking
            var result = 0;
            var listRushFee = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = this.listBookingDates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var dateTime = _step.value;

                var bookingRate = feeFunction(_extends({}, this.job, {
                  date: dateTime.date
                }));
                listRushFee.push(_extends({}, dateTime, {
                  fee: bookingRate
                }));
                if (bookingRate) {
                  result += bookingRate;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            if (model === "rush_fee") {
              this.setRushFeeInfo({
                listFees: listRushFee,
                listDates: this.listBookingDates
              });
            }
            return result;
          }
          return rate * numberOfBooking;
        } else {
          return rate;
        }
      }
    },
    getLabel: function getLabel(label) {
      var _this2 = this;

      var item = _options.CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS.find(function (item) {
        return item.label === label;
      });
      if (!item) {
        return label;
      }
      var settingLabel = this.tryGet(function () {
        return _this2.$store.getters.agencyPublic.public_advance_setting[item.model];
      });
      if (settingLabel && settingLabel !== item.label) {
        return settingLabel;
      }
      return this.getLabelByKeys("BOOKING_SECTION.PRICES." + item.key) || settingLabel;
    },
    getIsShowPriceToClient: function getIsShowPriceToClient(label) {
      var _this3 = this;

      var item = _options.CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS.find(function (item) {
        return item.label === label;
      });
      if (item) {
        var result = this.tryGet(function () {
          return _this3.$store.getters.agencyPublic.public_advance_setting["show_" + item.key.toLowerCase() + "_to_client"];
        });
        if (result != null && result !== "") {
          return result;
        }
      }
      return true; // Default is true
    },
    getItemPlacement: function getItemPlacement(item, field) {
      if (item === field) {
        return true;
      }
      return false;
    }
  })
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _customDefineType = __webpack_require__(6);

exports.default = {
    props: {
        categoryList: {
            type: String,
            default: ""
        },
        user: {
            type: Object,
            default: function _default() {}
        }
    },
    computed: {
        normalizedCategoryList: function normalizedCategoryList() {
            if (Array.isArray(this.categoryList)) {
                return this.categoryList;
            }
            return this.categoryList.split("\n").map(function (category) {
                return category.trim();
            }).filter(function (category) {
                return category.length > 0;
            });
        }
    },
    methods: {
        getPrice: function getPrice(priceObject, job) {
            var basePrice = null;
            if (priceObject.is_price_condition) {
                console.log(priceObject);
                var data = this.getObjectToCalculatePrice(this.user, job, priceObject.price_expression, this.selectedDate);
                var condition = this.calculateUserProperty([priceObject.price_condition], data, 'price');
                if (condition && condition.price) {
                    basePrice = Number(condition.price);
                }
            } else if (priceObject.is_price_expession) {
                basePrice = this.getPriceFromExpression(this.user, job, priceObject.price_expression, this.selectedDate);
            } else {
                basePrice = Number(priceObject.price);
            }

            if (basePrice) {
                // Adjustment for holiday
                var adjustInfo = this.getHolidayAdjustment(job, priceObject);
                basePrice = this.getAdjustPrice(basePrice, adjustInfo);
                // Adjustment for surge price
                if (this.$store.getters.turnOnSurgePricing) {
                    basePrice = this.getAdjustPrice(basePrice, priceObject.surge_pricing);
                }
                return basePrice;
            }
            return null;
        },
        getAdjustPrice: function getAdjustPrice(basePrice, adjustInfo) {
            if (!adjustInfo || !adjustInfo.type || !adjustInfo.value) {
                return basePrice;
            }
            if (adjustInfo.type === 'Add') {
                return basePrice + adjustInfo.value;
            } else {
                return basePrice * adjustInfo.value;
            }
        },

        /*
        If option is_restrict_time is set for Hourly booking rate
        or PER_TIME_RANGE_CANDIDATE_FEE is set => Use candidate fee
        In other case, candidate_rate will be used.
        */
        calculateCandidateFee: function calculateCandidateFee(job) {
            var _this = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var result = 0;
            // Find per time range candidate fee
            var timeRangeCandidatePrice = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.PER_TIME_RANGE_CANDIDATE_FEE && _this.isJobMatchPrice(job, price, _this.normalizedCategoryList);
            });

            var listHourBookingRate = this.listPrices.filter(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.HOURLY_BOOKING_RATE && _this.isJobMatchPrice(job, price, _this.normalizedCategoryList) && price.is_restrict_time;
            });
            if (!timeRangeCandidatePrice && !listHourBookingRate.length) {
                // Use candidate rate
                return null;
            }

            // Calculate start time and end time
            var startDate = job.date;
            if (!startDate) {
                startDate = this.dateInDjangoFormat(this.selectedDate);
            }

            var endDate = job.end_date;
            if (!endDate) {
                endDate = startDate;
            }

            if (timeRangeCandidatePrice) {
                if (timeRangeCandidatePrice.is_restrict_time) {
                    var listRanges = this.splitTimeRanges(startDate, job.start_time, endDate, job.end_time, timeRangeCandidatePrice.start_time, timeRangeCandidatePrice.end_time);
                    result += this.getPrice(timeRangeCandidatePrice, job) * listRanges.length;
                } else {
                    result += this.getPrice(timeRangeCandidatePrice, job);
                }
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = listHourBookingRate[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var hourBookingRate = _step.value;

                    if (hourBookingRate) {
                        var _listRanges = this.splitTimeRanges(startDate, job.start_time, endDate, job.end_time, hourBookingRate.start_time, hourBookingRate.end_time);
                        // Calculate total time
                        var _totalTime = _listRanges.map(function (range) {
                            return _this.calculateDurationInHours(range[0], range[1]);
                        }).reduce(function (a, b) {
                            return a + b;
                        }, 0);
                        result += this.getPrice(hourBookingRate, job) * _totalTime;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var hourlyFeePerAdditionalChild = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.HOURLY_FEE_PER_ADDITIONAL_CHILD && _this.isJobMatchPrice(job, price, _this.normalizedCategoryList);
            });
            if (hourlyFeePerAdditionalChild && job.number_children && Number(job.number_children) > this.numberOfAllowedChildren) {
                var totalTime = this.calculateDurationInHours(startDate + "T" + this.getTimeString(job.start_time), endDate + "T" + this.getTimeString(job.end_time));
                result = result + this.getPrice(hourlyFeePerAdditionalChild, job) * (Number(job.number_children) - this.numberOfAllowedChildren) * totalTime;
            }
            return this.roundNumberTwoDigits(result);
        },
        calculateCandidateRate: function calculateCandidateRate(job) {
            var _this2 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var result = 0;
            var hourBookingRate = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.HOURLY_BOOKING_RATE && _this2.isJobMatchPrice(job, price, _this2.normalizedCategoryList);
            });
            if (hourBookingRate) {
                result = this.getPrice(hourBookingRate, job);
            }
            var hourlyFeePerAdditionalChild = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.HOURLY_FEE_PER_ADDITIONAL_CHILD && _this2.isJobMatchPrice(job, price, _this2.normalizedCategoryList);
            });
            if (hourlyFeePerAdditionalChild && job.number_children && Number(job.number_children) > this.numberOfAllowedChildren) {
                result = result + this.getPrice(hourlyFeePerAdditionalChild, job) * (Number(job.number_children) - this.numberOfAllowedChildren);
            }
            return this.roundNumberTwoDigits(result);
        },
        calculateTravelFee: function calculateTravelFee(job) {
            var _this3 = this;

            if (!job.city) {
                return;
            }
            if (this.listPrices.length === 0) {
                return;
            }
            var travelFeePrice = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.TRAVEL_FEE && _this3.compareTextWithoutPunctuation(job.city, price.location) && _this3.isJobMatchPrice(job, price, _this3.normalizedCategoryList);
            });
            if (travelFeePrice) {
                return this.getPrice(travelFeePrice, job);
            }
            return;
        },

        /*
        Calculate number of hours from created time to start time
        */
        calculateLapseCreateTimeToStartTime: function calculateLapseCreateTimeToStartTime(job) {
            // Get created time
            var createdTime = new Date();
            if (job.created_date) {
                createdTime = new Date(job.created_date).getTime();
            }
            var startDate = job.date;
            if (!startDate) {
                startDate = this.dateInDjangoFormat(this.selectedDate);
            }
            var startTime = job.start_time ? this.getTimeString(job.start_time) : "00:00:00";
            var startDateTime = new Date(startDate + "T" + startTime).getTime();
            return (startDateTime - createdTime) / 3600000; // Diff in hour
        },
        calculateRushFee: function calculateRushFee(job) {
            var _this4 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var diff = this.calculateLapseCreateTimeToStartTime(job);
            var rushFeePrice = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.RUSH_FEE && _this4.isJobMatchPrice(job, price, _this4.normalizedCategoryList) && diff <= Number(price.hours);
            });
            if (rushFeePrice) {
                return this.getPrice(rushFeePrice, job);
            }
            return;
        },
        calculateCandidateRushFee: function calculateCandidateRushFee(job) {
            var _this5 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var diff = this.calculateLapseCreateTimeToStartTime(job);
            var rushFeePrice = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.CANDIDATE_RUSH_FEE && _this5.isJobMatchPrice(job, price, _this5.normalizedCategoryList) && diff <= Number(price.hours);
            });
            if (rushFeePrice) {
                return this.getPrice(rushFeePrice, job);
            }
            return;
        },

        // The same with client rate
        calculatePricePerHour: function calculatePricePerHour(job) {
            if (this.listPrices.length === 0) {
                return;
            }
            var agencyRate = this.calculateAgencyFee(job) || 0;
            var candidateRate = this.calculateCandidateRate(job) || 0;

            return this.roundNumberTwoDigits(Number(agencyRate) + Number(candidateRate));
        },
        calculateTotalBookingFee: function calculateTotalBookingFee() {
            var _this6 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var totalFee = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop = function _loop() {
                    var job = _step2.value;

                    var hourlyAgencyFee = _this6.listPrices.find(function (price) {
                        return price.type === _customDefineType.PRICE_TYPES.HOURLY_AGENCY_FEE && _this6.isJobMatchPrice(job, price, _this6.normalizedCategoryList);
                    });
                    if (!hourlyAgencyFee) {
                        return "continue";
                    }
                    var startDate = job.date;
                    if (!startDate) {
                        startDate = _this6.dateInDjangoFormat(_this6.selectedDate);
                    }
                    var jobDuration = _this6.compareDuration(startDate, job.start_time, job.end_date, job.end_time, 4);
                    totalFee += jobDuration * _this6.getPrice(hourlyAgencyFee, job);
                };

                for (var _iterator2 = this.bookingData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ret = _loop();

                    if (_ret === "continue") continue;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return this.roundNumberTwoDigits(totalFee);
        },
        calculateAgencyFee: function calculateAgencyFee(job) {
            var _this7 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var result = 0;
            var hourlyAgencyFee = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.HOURLY_AGENCY_FEE && _this7.isJobMatchPrice(job, price, _this7.normalizedCategoryList);
            });
            if (hourlyAgencyFee) {
                result = result + this.getPrice(hourlyAgencyFee, job);
            }

            var hourlyAgencyCommission = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.HOURLY_AGENCY_COMMISSION && _this7.isJobMatchPrice(job, price, _this7.normalizedCategoryList);
            });
            if (hourlyAgencyCommission) {
                result = result + this.getPrice(hourlyAgencyCommission, job);
            }
            // Calculate rush hourly fee
            var diff = this.calculateLapseCreateTimeToStartTime(job);
            var rushHourlyFeePrice = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.RUSH_HOURLY_FEE && _this7.isJobMatchPrice(job, price, _this7.normalizedCategoryList) && diff <= Number(price.hours);
            });
            if (rushHourlyFeePrice) {
                result = result + this.getPrice(rushHourlyFeePrice, job);
            }

            return this.roundNumberTwoDigits(result);
        },
        getPerBookingAgencyFee: function getPerBookingAgencyFee(job) {
            var _this8 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var listBookingFees = this.listPrices.filter(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.PER_BOOKING_AGENCY_FEE && _this8.isJobMatchPrice(job, price, _this8.normalizedCategoryList);
            });
            if (!listBookingFees.length) {
                return;
            }
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = listBookingFees[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var bookingFee = _step3.value;

                    var fee = this.getPrice(bookingFee, job);
                    if (fee) {
                        return fee;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return;
        },
        getPerBookingCandidateFee: function getPerBookingCandidateFee(job) {
            var _this9 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var listBookingFees = this.listPrices.filter(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.PER_BOOKING_CANDIDATE_FEE && _this9.isJobMatchPrice(job, price, _this9.normalizedCategoryList);
            });
            if (!listBookingFees.length) {
                return;
            }
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = listBookingFees[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var bookingFee = _step4.value;

                    var fee = this.getPrice(bookingFee, job);
                    if (fee) {
                        return fee;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return;
        },
        getTotalDiscount: function getTotalDiscount(job) {
            var _this10 = this;

            if (this.listPrices.length === 0) {
                return;
            }
            var bookingFee = this.listPrices.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.BOOKING_TOTAL_DISCOUNT && _this10.isJobMatchPrice(job, price, _this10.normalizedCategoryList);
            });
            if (!bookingFee) {
                return;
            }

            return this.getPrice(bookingFee, job);
        },
        getHolidayAdjustment: function getHolidayAdjustment(job, price) {
            var _this11 = this;

            var jobLocations = void 0;
            if (job && job.locations) {
                jobLocations = job.locations;
            } else if (this.user && this.user.locations) {
                jobLocations = this.user.locations;
            }
            var holidays = price.holidays;
            if (!holidays) {
                return null;
            }
            if (!job) {
                return null;
            }
            var startDate = job.date;
            if (!startDate) {
                startDate = this.dateInDjangoFormat(this.selectedDate);
            }
            if (!startDate) {
                return null;
            }
            var startTime = null;
            if (job.start_time) {
                startTime = this.getTimeString(job.start_time);
            }
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = holidays[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var holiday = _step5.value;

                    if (isNaN(holiday.multiplier)) {
                        continue;
                    }
                    var bookingDay = this.dateInDjangoFormat(startDate);
                    // Remove year
                    bookingDay = bookingDay.substring(4);
                    if (!bookingDay) {
                        continue;
                    }
                    var match = false;
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        var _loop2 = function _loop2() {
                            var date = _step6.value;

                            // Check if holiday location is matched
                            if (_this11.$store.getters.agencyHolidays) {
                                var holidayInfo = _this11.$store.getters.agencyHolidays.find(function (holiday) {
                                    return holiday.date === date;
                                });
                                if (holidayInfo && holidayInfo.locations && holidayInfo.locations.length) {
                                    if (!_this11.hasCommonElement(holidayInfo.locations, jobLocations)) {
                                        return "continue";
                                    }
                                }
                            }
                            if (date.includes(bookingDay)) {
                                match = true;
                                return "break";
                            }
                        };

                        _loop3: for (var _iterator6 = holiday.dates[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var _ret2 = _loop2();

                            switch (_ret2) {
                                case "continue":
                                    continue;

                                case "break":
                                    break _loop3;}
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }

                    if (match) {
                        // Check if time is match
                        if (holiday.startTime) {
                            if (!startTime || startTime < holiday.startTime) {
                                continue;
                            }
                        }
                        if (holiday.endTime) {
                            if (!startTime || startTime > holiday.endTime) {
                                continue;
                            }
                        }

                        return { value: Number(holiday.multiplier), type: holiday.type };
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return null;
        },
        getAdminFeeOfJob: function getAdminFeeOfJob(job, totalFee) {
            var _this12 = this;

            var priceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _customDefineType.PRICE_TYPES.ADMIN_FEE;

            if (!totalFee) {
                return;
            }
            if (this.listPrices.length === 0) {
                return;
            }
            var priceItem = this.listPrices.find(function (price) {
                return price.type === priceType && _this12.isJobMatchPrice(job, price, _this12.normalizedCategoryList);
            });
            if (!priceItem) {
                return;
            }

            return Number(totalFee) * Number(priceItem.percentage) / 100;
        },
        recalculatePriceOnAssignJob: function recalculatePriceOnAssignJob(job, fillerId) {
            var _this13 = this;

            return new Promise(function _callee(resolve) {
                var result;
                return regeneratorRuntime.async(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                result = {};

                                if (!_this13.$store.getters.isRecalculatePriceOnAssignJob) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 4;
                                return regeneratorRuntime.awrap(_this13.setMapJobNumberOfMonthOnAssignJob(job, job.date, fillerId));

                            case 4:
                                _this13.$store.getters.listModelRecalculatedWhenAssignJob.forEach(function (model) {
                                    var jobObj = _extends({}, job, { selected_filler_id: fillerId });
                                    if (model === 'agency_fee') {
                                        result[model] = _this13.calculateAgencyFee(jobObj);
                                    }
                                    if (model === 'candidate_rate') {
                                        result[model] = _this13.calculateCandidateRate(jobObj);
                                    }
                                    if (model === 'client_rate') {
                                        var clientRate = 0;
                                        var agencyRate = _this13.calculateAgencyFee(jobObj);
                                        var candidateRate = _this13.calculateCandidateRate(jobObj);
                                        if (agencyRate) {
                                            clientRate = clientRate + Number(agencyRate);
                                        }
                                        if (candidateRate) {
                                            clientRate = clientRate + Number(candidateRate);
                                        }
                                        result[model] = clientRate;
                                    }
                                });

                            case 5:
                                resolve(result);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, null, _this13);
            });
        }
    }
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _customDefineType = __webpack_require__(6);

var _vuex = __webpack_require__(11);

exports.default = {
  name: "PriceValueItem",
  props: {
    label: String,
    value: [Number, String],
    columnLayout: Boolean,
    isPerHourRate: {
      type: Boolean,
      default: false
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["isAgent", "agencyCurrencySign"])),
  methods: {
    showUpdatePriceDialog: function showUpdatePriceDialog() {
      this.showInputDialog({
        title: "Update " + this.label,
        listFields: [{ type: _customDefineType.FORM_TYPE.TEXTBOX, model: "value" }],
        data: {
          value: this.roundNumberTwoDigits(this.value)
        },
        onSubmitCallback: this.updatePriceValue
      });
    },
    updatePriceValue: function updatePriceValue(info) {
      this.$emit("input", info.value);
    }
  }
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(11);

var _customDefineType = __webpack_require__(6);

exports.default = {
  name: "JobFillerInfo",
  props: {
    jobFiller: Object,
    listFields: Array,
    listAdditionalInfo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["hideCandidateLastNameForShiftJobs", "shiftViewFullProfile"]), {
    listVisibleFields: function listVisibleFields() {
      if (!this.listFields) {
        return [];
      }
      return this.listFields.filter(function (field) {
        return !["user_badges__agency_badge_id", "reviews"].includes(field.model);
      });
    },
    jobFillerInfo: function jobFillerInfo() {
      var _this = this;

      var result = this.jobFiller;
      if (this.listAdditionalInfo && this.jobFiller.id) {
        var filler = this.listAdditionalInfo.find(function (user) {
          return user.id === _this.jobFiller.id;
        });
        if (filler) {
          return _extends({}, result, filler);
        }
      }
      return result;
    },
    isShowProfilePicture: function isShowProfilePicture() {
      if (this.$store.getters.agencyPublic == null) {
        return false;
      }
      var scope = this.$store.getters.agencyPublic.candidate_profile_picture_scope;
      // In case of candidate, default is public
      if (scope === "") {
        scope = _customDefineType.PROFILE_PICTURE_SCOPE.PUBLIC;
      }
      if (scope == null) {
        return false;
      }

      if (scope === _customDefineType.PROFILE_PICTURE_SCOPE.PUBLIC) {
        // Public: always show
        return true;
      }
      // No profile picture
      return false;
    }
  })
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _JobFillerInfo = __webpack_require__(133);

var _JobFillerInfo2 = _interopRequireDefault(_JobFillerInfo);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "SelectFillerDialog",
  props: {
    // Status of dialog: Open, close
    value: Boolean,
    listDateTimesOfJobs: Array,
    bookingInfo: Object,
    listCandidates: Array,
    listRelatedAvailabilities: Array,
    weekAvailabilities: Array,
    listRelatedJobs: Array,
    listFavoriteCandidateIds: Array
  },
  components: {
    ModalDialog: _ModalDialog2.default,
    JobFillerInfo: _JobFillerInfo2.default
  },
  data: function data() {
    return {
      isShow: false,
      bookingIndex: 0,
      listSelectedCandidates: [],
      mapSelectedCandidates: {}
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["shiftJobSelectionProfileFields", "candidateInfoSelectionFields", "clientCanSelectMultipleCandidates", "wordUsedForCandidates", "textSelfSelectNobodyAvailable", "candidatesCanSetRate"]), {
    maxBookingIndex: function maxBookingIndex() {
      var listIndex = this.listDateTimesOfJobs.map(function (dateTime) {
        return dateTime.index;
      });
      return Math.max.apply(Math, _toConsumableArray(listIndex));
    },
    listSelectedDateTime: function listSelectedDateTime() {
      var _this = this;

      return this.listDateTimesOfJobs.filter(function (dateTime) {
        return dateTime.index === _this.bookingIndex;
      });
    },
    startDate: function startDate() {
      if (!this.listSelectedDateTime || !this.listSelectedDateTime.length) {
        return "";
      }
      return this.listSelectedDateTime[0].date;
    },
    listAvailableCandidates: function listAvailableCandidates() {
      var _this2 = this;

      if (!this.isShow) {
        // Dialog is not showed
        return [];
      }
      var booking = _extends({}, this.bookingInfo, {
        date: this.startDate
      });
      return this.listCandidates.filter(function (candidate) {
        return !_this2.isAvailabilityConflict(candidate, _this2.listRelatedAvailabilities, _this2.weekAvailabilities || [], _this2.listSelectedDateTime) && !_this2.isTimeConflict(candidate, _this2.listRelatedJobs, booking) && !_this2.isTimeOffConflict(candidate, _this2.listRelatedAvailabilities, _this2.listSelectedDateTime) && !_this2.isExceedMaxJobDaily(candidate, _this2.listRelatedJobs, booking, _this2.listSelectedDateTime);
      });
    }
  }),
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        if (value === true) {
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    },
    isShow: {
      immediate: true,
      handler: function handler() {
        this.$emit("input", this.isShow);
      }
    }
  },
  methods: {
    hideModal: function hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal: function showModal() {
      this.isShow = true;
    },
    hasUnselectCandidateBtn: function hasUnselectCandidateBtn(candidate) {
      return this.listSelectedCandidates.some(function (cand) {
        return cand.id === candidate.id;
      });
    },
    hasSelectCandidateBtn: function hasSelectCandidateBtn(candidate) {
      if (this.clientCanSelectMultipleCandidates) {
        return !this.listSelectedCandidates.some(function (cand) {
          return cand.id === candidate.id;
        });
      } else {
        return !this.listSelectedCandidates.length;
      }
    },
    handleUnselectCandidates: function handleUnselectCandidates(candidate) {
      this.listSelectedCandidates = this.listSelectedCandidates.filter(function (cand) {
        return cand.id !== candidate.id;
      });
    },
    handleClickNext: function handleClickNext() {
      this.mapSelectedCandidates[this.startDate] = this.listSelectedCandidates.map(function (candidate) {
        return candidate.id;
      });
      this.bookingIndex += 1;
      this.listSelectedCandidates = [];
    },
    handleClickSubmit: function handleClickSubmit() {
      this.mapSelectedCandidates[this.startDate] = this.listSelectedCandidates.map(function (candidate) {
        return candidate.id;
      });
      this.$emit("selected", this.mapSelectedCandidates);
      this.hideModal();
    }
  }
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _JobFillerInfo = __webpack_require__(133);

var _JobFillerInfo2 = _interopRequireDefault(_JobFillerInfo);

var _Badges = __webpack_require__(561);

var _Badges2 = _interopRequireDefault(_Badges);

var _ReviewInfo = __webpack_require__(574);

var _ReviewInfo2 = _interopRequireDefault(_ReviewInfo);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "CandidateSelectionSection",
  components: {
    JobFillerInfo: _JobFillerInfo2.default,
    Badges: _Badges2.default,
    ReviewInfo: _ReviewInfo2.default
  },
  props: {
    listAvailableCandidates: Array,
    listPartlyAvailableCandidates: Array,
    listFavoriteCandidateIds: Array,
    numberOfBooking: Number,
    value: Array,
    booking: {
      type: Object,
      default: function _default() {}
    },
    isSelectInterestedCandidate: {
      type: Boolean,
      default: false
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["wordUsedForCandidates", "textSelfSelectNobodyAvailable", "shiftJobSelectionProfileFields", "clientCanSelectMultipleCandidates", "candidateInfoSelectionFields", // list candidate info to show for avaialble candidates
  "candidatesCanSetRate"]), {
    mapUserIdBadgeIds: function mapUserIdBadgeIds() {
      if (!this.candidateInfoSelectionFields) {
        return {};
      }
      var result = {};
      this.candidateInfoSelectionFields.forEach(function (item) {
        if (item.user_badges__agency_badge_id) {
          result[item.id] = item.user_badges__agency_badge_id;
        }
      });
      return result;
    },
    mapUserIdReviews: function mapUserIdReviews() {
      if (!this.candidateInfoSelectionFields) {
        return {};
      }
      var result = {};
      this.candidateInfoSelectionFields.forEach(function (item) {
        if (item.review_records) {
          result[item.id] = item.review_records;
        }
      });
      return result;
    },
    isMultiSelection: function isMultiSelection() {
      return this.clientCanSelectMultipleCandidates || this.isSelectInterestedCandidate;
    },
    hasTimeInputted: function hasTimeInputted() {
      return this.getTimeString(this.booking.start_time) && this.getTimeString(this.booking.end_time);
    }
  }),
  data: function data() {
    return {
      listSelectedCandidates: this.value || []
    };
  },

  methods: _extends({}, (0, _vuex.mapActions)(['setSelectedCandidate']), {
    handleUnselectCandidates: function handleUnselectCandidates(candidate) {
      this.listSelectedCandidates = this.listSelectedCandidates.filter(function (cand) {
        return cand.id !== candidate.id;
      });
      this.$emit("input", this.listSelectedCandidates);
    },
    handleSelectCandidate: function handleSelectCandidate(candidate) {
      this.setSelectedCandidate(candidate);
      this.listSelectedCandidates.push(candidate);
      this.$emit("input", this.listSelectedCandidates);
    },
    hasSelectCandidateBtn: function hasSelectCandidateBtn(candidate) {
      if (this.isMultiSelection) {
        return !this.listSelectedCandidates.some(function (cand) {
          return cand.id === candidate.id;
        });
      } else {
        return !this.listSelectedCandidates.length;
      }
    },
    hasUnselectCandidateBtn: function hasUnselectCandidateBtn(candidate) {
      return this.listSelectedCandidates.some(function (cand) {
        return cand.id === candidate.id;
      });
    }
  })
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _InputDialog = __webpack_require__(147);

var _InputDialog2 = _interopRequireDefault(_InputDialog);

var _customDefineType = __webpack_require__(6);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  components: {
    ModalDialog: _ModalDialog2.default,
    InputDialog: _InputDialog2.default
  },
  props: {
    user: Object,
    candidateCanAddBadge: Boolean,
    unassignedBadges: Array,
    header: String,
    badgeIds: Array
  },
  data: function data() {
    return {
      photos: [],
      isShow: false,
      isShowInputDialog: false,
      isShowConfirmDelete: false,
      selectedFile: null,
      selectedBadgeId: null,
      candidateSelectedBadge: null
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["getBadges"]), {
    listFieldsMetaData: function listFieldsMetaData() {
      return [{
        type: _customDefineType.FORM_TYPE.TEXTBOX,
        label: "Badge Title",
        model: "name"
      }];
    },
    candidateBadgesList: function candidateBadgesList() {
      var _this = this;

      if (this.badgeIds) {
        if (!this.getBadges) {
          return [];
        }
        return this.getBadges.filter(function (item) {
          return _this.badgeIds.includes(item.id);
        });
      } else {
        var uniqueBadge = [].concat(_toConsumableArray(new Map(this.$store.getters.getSelectedCandidateBadges.map(function (item) {
          return [item["badge_id"], item];
        })).values()));
        return uniqueBadge;
      }
    },
    agencyBadgesList: function agencyBadgesList() {
      return this.$store.getters.getBadges;
    }
  }),
  methods: {
    onChange: function onChange() {
      return regeneratorRuntime.async(function onChange$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.selectedFile = this.$refs.addBadgeImage.files[0];

              if (!(this.selectedFile == null)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (!(this.selectedFile.size === 0)) {
                _context.next = 8;
                break;
              }

              this.showErrorDialog(this.$store.getters.emptyFileError);
              return _context.abrupt("return");

            case 8:
              if (!(this.selectedFile.size > this.maxSizeInByte)) {
                _context.next = 11;
                break;
              }

              this.showErrorDialog(this.$store.getters.fileSizeExceedLimitError);
              return _context.abrupt("return");

            case 11:
              this.isShowInputDialog = true;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    submitMetaData: function submitMetaData(event) {
      var form, res;
      return regeneratorRuntime.async(function submitMetaData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // Upload file to server

              form = new FormData();

              form.append("picture", this.selectedFile);
              form.append("name", event.name);
              form.append("user_id", this.user.id);

              _context2.next = 6;
              return regeneratorRuntime.awrap(_axios2.default.post("/api/badge/create", form));

            case 6:
              res = _context2.sent;

              console.log(res);
              this.$refs.addBadgeImage.value = "";

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    },
    assignBadge: function assignBadge() {
      var _this2 = this;

      return regeneratorRuntime.async(function assignBadge$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.candidateSelectedBadge.review_required && this.candidateSelectedBadge.email !== null)) {
                _context3.next = 4;
                break;
              }

              _axios2.default.post("/api/candidate_badge/review_request", {
                agency_badge_id: this.candidateSelectedBadge.id,
                agency_id: this.candidateSelectedBadge.agency,
                user_id: this.user.id,
                from_email: this.$store.getters.agency.from_email,
                to_email: this.candidateSelectedBadge.email,
                sub_domain: window.location.host.split(".")[0]
              }).then(function () {
                _this2.showResultDialog({
                  title: "Request has been sent. Badge will be added once approved"
                });
              });
              _context3.next = 8;
              break;

            case 4:
              _context3.next = 6;
              return regeneratorRuntime.awrap(_axios2.default.post("/api/candidate_badge/create", {
                candidate_badges: [{
                  agency_badge: this.candidateSelectedBadge.id,
                  agency: this.candidateSelectedBadge.agency,
                  user: this.user.id
                }]
              }));

            case 6:
              _context3.next = 8;
              return regeneratorRuntime.awrap(this.$store.dispatch("getCandidateBadge", {
                candidateId: this.user.id
              }));

            case 8:
              this.candidateSelectedBadge = null;

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    },
    showDeletePhotoConfirmDialog: function showDeletePhotoConfirmDialog(badgeId) {
      this.selectedBadgeId = badgeId;
      this.showConfirmDialog({
        key: "DELETE_PHOTO_CONFIRM_DIALOG",
        params: [selectedPhoto.name],
        onAcceptCallback: this.deletePhoto
      });
    },
    deletePhoto: function deletePhoto() {
      return regeneratorRuntime.async(function deletePhoto$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.delete("/api/badge/delete/" + this.selectedBadgeId));

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    }
  }
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* 
This dialog is used to get input from user for some simple form.
For example: a dialog contains a textbox, user fill in the textbox, then click Submit button
 */


var _customDefineType = __webpack_require__(6);

var _vueSwatches = __webpack_require__(149);

var _vueSwatches2 = _interopRequireDefault(_vueSwatches);

var _MultiSelect = __webpack_require__(150);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _FileUpload = __webpack_require__(134);

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "InputDialog",
  props: {
    // Status of dialog: Open, close
    value: Boolean,
    description: String,
    listFields: Array,
    isShowSubmitButton: {
      type: Boolean,
      default: true
    },
    submitButton: {
      type: String,
      default: "Submit"
    },
    title: String,
    initialValue: Object,
    ignoreAgentMissing: {
      type: Boolean,
      default: false
    },
    listTagFields: Array,
    // Tag data which is used to replace tag in form element (for example: Checkbox option)
    tagData: Object,
    closeOnSubmit: {
      type: Boolean,
      default: true
    },
    hideHr: {
      type: Boolean,
      default: false
    },
    hasDistanceTop: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VSwatches: _vueSwatches2.default,
    MultiSelect: _MultiSelect2.default,
    ModalDialog: _ModalDialog2.default,
    FileUpload: _FileUpload2.default
  },
  data: function data() {
    return {
      FORM_TYPE: _customDefineType.FORM_TYPE,
      applicationData: {},
      isShow: false,
      submitClicked: false,
      selectedField: null,
      isShowTagInputDialog: false
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["isRecordingVideo"]), {
    listFieldsInputTag: function listFieldsInputTag() {
      if (!this.listTagFields || !this.listTagFields.length) {
        return [];
      }
      return [{
        label: "Tag field",
        model: "model",
        type: _customDefineType.FORM_TYPE.MULTI_SELECT,
        optionList: this.listTagFields,
        optionLabel: "label",
        optionModel: "model"
      }];
    }
  }),
  methods: {
    setApplicationData: function setApplicationData(data) {
      this.applicationData = _extends({}, data);
    },
    handleChange: function handleChange(selectedFieldsData) {
      this.$emit("changed", selectedFieldsData);
    },
    hideModal: function hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal: function showModal() {
      this.isShow = true;
    },
    handleSubmit: function handleSubmit() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.applicationData, this.listFields, this.$store.getters.isAgent && this.ignoreAgentMissing)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        return;
      } else {
        this.$emit("submit", this.applicationData);
        if (this.closeOnSubmit) {
          this.hideModal();
        }
      }
    },
    handleShowInsertTagDialog: function handleShowInsertTagDialog(field) {
      this.selectedField = field;
      this.isShowTagInputDialog = true;
    },
    handleInsertTag: function handleInsertTag(info) {
      var fieldModel = this.selectedField.model;
      if (!this.applicationData[fieldModel]) {
        this.applicationData[fieldModel] = "";
      }
      this.applicationData[fieldModel] += "[[" + info.model + "]]";
      this.applicationData = JSON.parse(JSON.stringify(this.applicationData));
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        if (value === true) {
          this.submitClicked = false;
          if (this.initialValue) {
            this.applicationData = Object.assign({}, this.initialValue);
          }
          this.showModal();
        } else {
          this.hideModal();
        }
      }
    },
    isShow: {
      immediate: true,
      handler: function handler() {
        this.$emit("input", this.isShow);
      }
    }
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  This component is used for select value of field' property,
  for example: number of item per row: 1, 2, 3, 4
*/

exports.default = {
  name: "MultiSelect",
  props: {
    id: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: [String, Number, Array, Object],
    /* List of options, can be list of String or list of Object */
    optionList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSelectClass: {
      type: String,
      default: "mb-2 w-100"
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    customLabel: {},
    /* In case optionList is list of Object, optionLabel specifies key of option which is showed in label */
    optionLabel: String,
    /* In case optionList is list of Object, optionLabel specifies key of option for v-model */
    optionModel: String,
    placeholder: {
      type: String,
      default: ""
    },
    hasClearButton: {
      type: Boolean,
      default: false
    },
    hasSelectAllBtn: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 150
    },
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    additionalSelectedInfoFunc: Function // Function to display additional information of the selected item
  },
  data: function data() {
    return {
      hasUserAction: false
    };
  },

  computed: {
    listDisplayButtons: function listDisplayButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return null;
      }
      var result = this.buttonGroups.filter(function (button) {
        return button.id !== "add-option" && button.id !== "agency-setting" && !button.id.includes("inline");
      });
      if (this.inputVal) {
        return result;
      }
      return result.filter(function (button) {
        return !button.showIfSelect;
      });
    },
    listDisplayInlineButtons: function listDisplayInlineButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return [];
      }
      var result = this.buttonGroups.filter(function (button) {
        return button.id.includes("inline");
      });
      if (!result.length) {
        return [];
      }
      return result;
    },

    inputVal: {
      get: function get() {
        var _this = this;

        if (this.optionModel) {
          if (this.value == null) {
            return this.value;
          }
          if (Array.isArray(this.value)) {
            // Multi Selection
            return this.optionList.filter(function (option) {
              return _this.value.includes(option[_this.optionModel]);
            });
          } else {
            // Single selection
            var selectedOption = this.optionList.find(function (option) {
              return option[_this.optionModel] === _this.value;
            });
            if (selectedOption) {
              return selectedOption;
            } else {
              return this.value;
            }
          }
        } else {
          return this.value;
        }
      },
      set: function set(val) {
        var _this2 = this;

        var result = val;
        if (this.optionModel) {
          if (val) {
            if (Array.isArray(val)) {
              // Multi selection
              result = val.map(function (item) {
                return item[_this2.optionModel];
              });
            } else {
              result = val[this.optionModel];
              // Single selection
            }
          }
        }
        this.$emit("input", result);
        if (this.hasUserAction) {
          this.$emit("userInput", result);
        }
        this.hasUserAction = false;
      }
    }
  },
  methods: {
    handleSelect: function handleSelect(info) {
      this.$emit("select", info);
      this.hasUserAction = true;
    },
    handleRemove: function handleRemove(info) {
      this.$emit("remove", info);
      this.hasUserAction = true;
    },
    handleOnInput: function handleOnInput(info) {
      if (info === null) {
        if (!this.isMultiple) {
          this.$emit("input", "");
        }
        return;
      }
      if (this.optionModel && info) {
        this.$emit("change", info[this.optionModel]);
      } else {
        this.$emit("change", info);
      }
    },
    clearSelection: function clearSelection() {
      var val = void 0;
      if (this.isMultiple) {
        val = [];
      } else {
        val = "";
      }
      this.$emit("input", val);
      this.$emit("userInput", val);
    },
    selectAll: function selectAll() {
      var _this3 = this;

      var val = void 0;
      if (this.optionModel) {
        val = this.optionList.map(function (option) {
          return option[_this3.optionModel];
        });
      } else {
        val = [].concat(_toConsumableArray(this.optionList));
      }
      this.$emit("input", val);
      this.$emit("userInput", val);
    },
    handleClickButton: function handleClickButton(button) {
      this.$emit("clickBtn", button.id);
    }
  }
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fileType = __webpack_require__(146);

var _customDefineType = __webpack_require__(6);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "FileUpload",
  props: {
    /* Name of the component*/
    name: String,
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: [File, String],
    // Remark at the end of component
    remark: String,
    // Maximum file size in MB
    maxSize: {
      type: Number,
      default: 100
    },
    fileType: String,
    initialUrl: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Info if submit file to server after upload
    submitInfo: Object,
    blankFileUrl: String,
    builderField: Object,
    hasAccessControlBtn: Boolean
  },

  data: function data() {
    return {
      selectFile: this.value,
      imageUrl: this.initialUrl
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (!this.submitInfo) {
          if (this.value && typeof this.value === "string" && this.value !== this.selectFile) {
            this.selectFile = this.value;
            this.imageUrl = this.convertToAbsolutePath(this.value);
          }
        }
      }
    }
  },
  created: function created() {
    if (typeof this.value === "string") {
      this.imageUrl = this.convertToAbsolutePath(this.value);
    }
  },

  computed: {
    maxSizeInByte: function maxSizeInByte() {
      return this.maxSize * 1024 * 1024;
    },
    isDoc: function isDoc() {
      return this.fileType === _customDefineType.FILE_TYPES.DOCUMENT;
    },
    isImage: function isImage() {
      return this.fileType === _customDefineType.FILE_TYPES.IMAGE;
    },
    uploadFileId: function uploadFileId() {
      return "upload-file-id-" + this._uid + "-" + this.name;
    }
  },
  methods: {
    onChange: function onChange() {
      var selectFile, formData, uploadFileRes, fileURL;
      return regeneratorRuntime.async(function onChange$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectFile = this.$refs.file.files[0];

              if (!(selectFile == null)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (selectFile.size === 0) {
                this.showErrorDialog(this.$store.getters.emptyFileError);
                this.selectFile = null;
              } else if (selectFile.size > this.maxSizeInByte) {
                this.showErrorDialog(this.$store.getters.fileSizeExceedLimitError);
                this.selectFile = null;
              } else if (this.isImage && !_fileType.VALID_IMAGE_FILE_TYPE.includes(selectFile.type)) {
                this.showErrorDialog(this.$store.getters.invalidImageFileTypeError);
                this.selectFile = null;
              } else if (this.isDoc && !_fileType.VALID_DOC_FILE_TYPE.includes(selectFile.type)) {
                this.showErrorDialog(this.$store.getters.invalidDocFileTypeError);
                this.selectFile = null;
              } else {
                this.selectFile = selectFile;
              }

              if (this.isImage) {
                if (this.selectFile == null) {
                  this.imageUrl = null;
                } else {
                  this.imageUrl = URL.createObjectURL(this.selectFile);
                }
              }

              if (!this.submitInfo) {
                _context.next = 18;
                break;
              }

              // Upload file to server
              formData = new FormData();

              formData.append("file", selectFile);
              formData.append("agency", this.$store.getters.agencyID);
              if (this.submitInfo.profileBuilder) {
                formData.append("profile-builder", this.submitInfo.profileBuilder);
              }
              if (this.submitInfo.email) {
                formData.append("email", this.submitInfo.email);
              }
              if (this.submitInfo.type) {
                formData.append("type", this.submitInfo.type);
              }
              _context.next = 14;
              return regeneratorRuntime.awrap(_axios2.default.post("/upload-files/", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }));

            case 14:
              uploadFileRes = _context.sent;

              if (uploadFileRes && uploadFileRes.data) {
                fileURL = uploadFileRes.data.file;

                this.$store.dispatch("addUploadedFileUrlName", {
                  url: fileURL,
                  name: this.selectFile.name
                });
                this.$emit("input", fileURL);
              }
              _context.next = 19;
              break;

            case 18:
              this.$emit("input", this.selectFile);

            case 19:
              this.$refs.file.value = "";

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    dragover: function dragover(event) {
      event.preventDefault();
    },
    drop: function drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to upload a file by drag and drop or click to select */

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StarRating = __webpack_require__(131);

var _StarRating2 = _interopRequireDefault(_StarRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ReviewInfo",
  props: {
    header: String,
    reviewInfo: Array
  },
  components: {
    StarRating: _StarRating2.default
  },
  methods: {
    getReviewerInfo: function getReviewerInfo(review) {
      var firstName = review.reviewer__first_name;
      var lastName = review.reviewer__last_name;
      if (lastName) {
        lastName = lastName[0] + ".";
      }
      return (firstName + " " + lastName).trim();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vuex = __webpack_require__(11);

var _jobSettings = __webpack_require__(101);

var _customDefineType = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ReportProblemButtons",
  props: {
    user: Object,
    job: Object
  },
  data: function data() {
    return {
      FORM_TYPE: _customDefineType.FORM_TYPE,
      CLIENT_BOOKING_SETTINGS: _jobSettings.CLIENT_BOOKING_SETTINGS
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["clientHasReportProblemButton", "clientReportProblemButtonText", "clientReportProblemUploadFilesLabel", "clientReportProblemUploadFilesDescription", "clientReportProblemNoteLabel", "clientReportProblemNotificationEmails", "clientReportProblemNewJobStatus", "listShiftJobStatusesCancelled"]), {
    reviewReportsHeader: function reviewReportsHeader() {
      return [{ displayLabel: "Note", model: "note" }, { displayLabel: "Files", model: "files" }, { displayLabel: "Date", model: "report_date" }];
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["updateJob"]), {
    handleClickReportProblemButton: function handleClickReportProblemButton(job) {
      var _this = this;

      this.showInputDialog({
        title: "Please input the following information",
        listFields: [{
          type: _customDefineType.FORM_TYPE.LIST_FILES,
          label: this.clientReportProblemUploadFilesLabel,
          description: this.clientReportProblemUploadFilesDescription,
          isRequired: false,
          model: "files",
          name: "File"
        }, {
          type: _customDefineType.FORM_TYPE.TEXTAREA,
          label: this.clientReportProblemNoteLabel,
          isRequired: false,
          model: "note"
        }],
        onSubmitCallback: function onSubmitCallback(info) {
          var res;
          return regeneratorRuntime.async(function onSubmitCallback$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return regeneratorRuntime.awrap(_axios2.default.post("/api/jobreports/", _extends({}, info, {
                    job: job.id,
                    user: _this.user.id
                  })));

                case 2:
                  res = _context.sent;


                  _this.sendEmail(_extends({}, _this.$store.getters.clientReportProblemEmailTemplate, {
                    file_urls: info.files,
                    recipients: _this.clientReportProblemNotificationEmails
                  }), _this.clientReportProblemButtonText, _this.user.first_name + " " + _this.user.last_name, _this.user.id, _this.clientReportProblemNoteLabel, info.note, _this.getDateString(job.date), job.id);
                  // Update job status

                  if (!_this.clientReportProblemNewJobStatus) {
                    _context.next = 7;
                    break;
                  }

                  _context.next = 7;
                  return regeneratorRuntime.awrap(_this.updateJob({
                    jobId: job.id,
                    info: {
                      status: _this.clientReportProblemNewJobStatus
                    }
                  }));

                case 7:
                  _this.$emit('reload');

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, null, _this);
        }
      });
    },
    hasReportProblemButtonCheck: function hasReportProblemButtonCheck(job) {
      if (!this.clientHasReportProblemButton) {
        return false;
      }
      if (this.listShiftJobStatusesCancelled.includes(job.status)) {
        return false;
      }
      return true;
    },
    hasReviewReportButtonCheck: function hasReviewReportButtonCheck(job) {
      if (!this.clientHasReportProblemButton || !job.reports) {
        return false;
      }
      return true;
    },
    showReviewReportsDialog: function showReviewReportsDialog(job) {
      var reports;
      return regeneratorRuntime.async(function showReviewReportsDialog$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.job = job;
              _context2.next = 3;
              return regeneratorRuntime.awrap(this.getReports(job));

            case 3:
              reports = _context2.sent;

              this.showInfoDialog({
                title: "Reported Problems",
                listTableHeaders: this.reviewReportsHeader,
                listRows: reports
              });

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    },
    getReports: function getReports(job) {
      var res;
      return regeneratorRuntime.async(function getReports$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/jobreports/?job=" + job.id + "&user=" + this.user.id));

            case 2:
              res = _context3.sent;
              return _context3.abrupt("return", res.data.map(function (report) {
                if (report.date) {
                  report.report_date = new Date(report.date).toDateString() + " at " + new Date(report.date).toLocaleTimeString();
                }
                return report;
              }));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
  })
};

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxItem_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9acb1b44_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxItem_vue__ = __webpack_require__(585);
function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9acb1b44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9acb1b44_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// This component include a checkbox and a label
exports.default = {
  name: "CheckboxItem",
  props: {
    name: String,
    value: [Boolean, String],
    label: [String, Object],
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    option: String,
    messageDialogs: Array,
    hasMarginTop: {
      type: Boolean,
      default: true
    },
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    defaultValue: Boolean,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    if (this.defaultValue) {
      this.$emit("input", this.defaultValue);
    }
  },

  computed: {
    displayLabel: function displayLabel() {
      if (_typeof(this.label) === "object") {
        if (this.label.LABEL) {
          return this.label.LABEL;
        }
      }
      return this.label;
    },
    id: function id() {
      return "checkbox-item-" + this._uid + "-" + this.name;
    },
    hasAgencySettingBtn: function hasAgencySettingBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some(function (button) {
        return button.id === "agency-setting";
      });
    },
    agencySettingBtn: function agencySettingBtn() {
      if (!this.hasAgencySettingBtn) {
        return {};
      }
      return this.buttonGroups.find(function (button) {
        return button.id === "agency-setting";
      });
    },

    inputVal: {
      get: function get() {
        if (this.option) {
          if (this.value == null) {
            return false;
          }
          if (typeof this.value === "string") {
            return this.value.trim() === this.option.trim();
          }
          return this.value === this.option;
        } else {
          return this.value;
        }
      },
      set: function set(val) {
        if (this.option) {
          this.$emit("input", val ? this.option : "");
        } else {
          this.$emit("input", val);
        }
      }
    }
  },
  methods: {
    onChangeCheck: function onChangeCheck(isCheck) {
      // Check to show message dialog
      if (this.messageDialogs && isCheck) {
        var messageDialog = this.messageDialogs.find(function (item) {
          return item.message;
        });
        if (messageDialog) {
          this.showResultDialog({ innerHtml: messageDialog.message });
          if (!messageDialog.isSelectable) {
            return;
          }
        }
      }
    }
  }
};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fed8aaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fed8aaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fed8aaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(11);

var _TableCell = __webpack_require__(588);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableCellBadge = __webpack_require__(592);

var _TableCellBadge2 = _interopRequireDefault(_TableCellBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "DataTable",
  props: {
    // Specify header of table. Each element include: displayLabel, model, category (optional)
    listHeaders: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //if extra headers need to be displayed,passed through this prop. Each element include: displayLabel, model, category (optional)
    additionalHeaders: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    //Specify another row of headers above listHeaders to categorize listHeaders. Each element includes: displayLabel, categoryModel, span
    categoryHeaders: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //option to hide checklists on displayed data
    showCheckbox: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },

    //Specify if the first cell in each row is a header cell
    LeftHeader2DTable: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    // Specify data of table. Data for each column is map by model value
    listData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    listStatus: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // List of checked row
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCandidateTable: {
      type: Boolean,
      default: true
    },
    isShiftJobTable: {
      type: Boolean,
      default: false
    },
    // Sort from outside
    sortInfo: Object,
    defaultItemPerPage: {
      type: [Number, String],
      default: 50
    },
    defaultSortInfo: Object,
    showPageCounter: {
      type: Boolean,
      default: true
    },
    isJobTable: {
      type: Boolean,
      default: false
    },
    isApplicantTable: {
      type: Boolean,
      default: false
    },
    isTemplateTable: {
      type: Boolean,
      default: false
    },
    isShowUserDialog: {
      type: Boolean,
      default: false
    },
    groupBy: String,
    hasStickyHeader: {
      type: Boolean,
      default: false
    },
    hasSumHeader: {
      type: Boolean,
      default: false
    },
    noColor: {
      type: Boolean,
      default: false
    },
    isRedundantBuilder: {
      type: Function,
      default: function _default() {}
    },
    findUsingBuilder: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {
    TableCell: _TableCell2.default,
    TableCellBadge: _TableCellBadge2.default
  },
  data: function data() {
    var listDateModel = ["date", "created_date", "last_login", "last_updated_date", "last_activity", "recent_access"];
    var listTimeModel = ["start_time", "end_time", "actual_start_time", "actual_end_time"];
    var sortModel = void 0;
    var sortOrder = void 0;
    if (this.defaultSortInfo) {
      sortModel = this.defaultSortInfo.model;
      sortOrder = this.defaultSortInfo.order;
    } else {
      // Load default sort
      if (this.isCandidateTable) {
        sortModel = this.$store.getters.agency.sort_candidates_by;
      } else {
        sortModel = this.$store.getters.agency.sort_clients_by;
      }
      if (!sortModel || sortModel.includes(" ")) {
        // Created date is default value
        sortModel = "created_date";
      }
      if (listDateModel.includes(sortModel)) {
        sortOrder = -1;
      } else {
        sortOrder = 1;
      }
    }
    var secondarySort = null;
    if (this.defaultSortInfo) {
      if (this.defaultSortInfo.secondary_model) {
        secondarySort = {
          model: this.defaultSortInfo.secondary_model,
          order: this.defaultSortInfo.secondary_order
        };
      }
    }
    return {
      checkedRows: [],
      sortModel: sortModel,
      sortOrder: sortOrder,
      secondarySort: secondarySort,
      isSelectAll: false,
      listDateModel: listDateModel,
      listTimeModel: listTimeModel,
      numberOfLoadingRequest: 0, // Number of loading request when click check all
      itemPerPage: this.defaultItemPerPage,
      currentPage: 1
    };
  },
  created: function created() {
    this.$emit("sort", { model: this.sortModel, order: this.sortOrder });
  },

  watch: {
    sortInfo: {
      handler: function handler() {
        if (!this.sortInfo) {
          return;
        }
        if (!this.sortInfo.order || !this.sortInfo.model) {
          return;
        }
        this.sortOrder = this.sortInfo.order;
        this.sortModel = this.sortInfo.model;
      },

      immediate: true
    },
    checkedRows: {
      handler: function handler() {
        var _this = this;

        if (this.displayData.length && this.checkedRows.length === this.displayData.length) {
          this.isSelectAll = true;
        } else {
          this.isSelectAll = false;
        }
        if (this.checkedRows.length) {
          var listCheckedRows = this.displayData.filter(function (item) {
            return _this.checkedRows.includes(item.id);
          });
          this.$emit("input", listCheckedRows);
        } else {
          this.$emit("input", []);
        }
      },

      immediate: true
    },
    // value: {
    //   handler() {
    //     if (this.value) {
    //       this.checkedRows = this.value.map((item) => item.id);
    //     } else {
    //       this.checkedRows = [];
    //     }
    //   },
    //   immediate: true,
    // },
    displayData: {
      handler: function handler() {
        this.updateCheckedRow();
        this.isSelectAll = false;
      },

      immediate: true
    },
    listData: {
      handler: function handler() {
        // Check if all of the checked data is still in the screen
        this.updateCheckedRow();
        this.isSelectAll = false;
        this.currentPage = 1;
      },

      immediate: true
    }
  },
  updated: function updated() {
    // After updated, hide loading (loading is showed when click select all)
    if (this.numberOfLoadingRequest === 1) {
      this.numberOfLoadingRequest -= 1;
      this.hideLoading();
    }
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["agency", "clientTableTypesColorList", "clientTableTagsColorList", "candidateTableTypesColorList", "candidateTableTagsColorList", "agencyCurrencySign"]), {
    numberOfColumns: function numberOfColumns() {
      var result = this.mergedHeaders.length + 1;
      if (this.showCheckbox) {
        result += 1;
      }
      return result;
    },
    listStatusColors: function listStatusColors() {
      if (!this.$store.getters.agency) {
        return [];
      }
      if (this.isCandidateTable) {
        var listStatusColors = this.$store.getters.agency.candidate_table_status_color;
        return listStatusColors ? listStatusColors : [];
      } else if (this.isShiftJobTable) {
        var _listStatusColors = this.$store.getters.shiftJobStatuses;
        return _listStatusColors ? _listStatusColors : [];
      } else if (this.isApplicantTable) {
        var _listStatusColors2 = this.$store.getters.agency.public_advance_setting.candidate_table_application_status_color;
        return _listStatusColors2 ? _listStatusColors2 : [];
      } else {
        var _listStatusColors3 = this.$store.getters.agency.client_table_status_color;
        return _listStatusColors3 ? _listStatusColors3 : [];
      }
    },
    listTypesColors: function listTypesColors() {
      var _this2 = this;

      if (!this.agency) {
        return [];
      }
      if (this.isCandidateTable && this.tryGet(function () {
        return _this2.candidateTableTypesColorList;
      })) {
        return this.candidateTableTypesColorList;
      }
      if (!this.isCandidateTable && this.tryGet(function () {
        return _this2.clientTableTypesColorList;
      })) {
        return this.clientTableTypesColorList;
      }
      return [];
    },
    listTagsColors: function listTagsColors() {
      var _this3 = this;

      if (!this.agency) {
        return [];
      }
      if (this.isCandidateTable && this.tryGet(function () {
        return _this3.candidateTableTagsColorList;
      })) {
        return this.candidateTableTagsColorList;
      }
      if (!this.isCandidateTable && this.tryGet(function () {
        return _this3.clientTableTagsColorList;
      })) {
        return this.clientTableTagsColorList;
      }
      return [];
    },
    mergedHeaders: function mergedHeaders() {
      var headerArray = [];
      headerArray = this.listHeaders.concat(this.additionalHeaders);
      if (this.LeftHeader2DTable) {
        headerArray.unshift({
          displayLabel: this.LeftHeader2DTable,
          model: "LeftHeader"
        });
      }

      // remove 'adminNotes' column from table header as we are passing it through slot.
      headerArray = headerArray.filter(function (header) {
        return header.model !== "adminNotes";
      });
      //return new array containing basic headers and the addition headers
      return headerArray;
    },
    listAllRows: function listAllRows() {
      var _this4 = this;

      var listData = [].concat(_toConsumableArray(this.listData));
      if (this.groupBy) {
        var mapGroup = listData.reduce(function (acc, cur) {
          acc[cur[_this4.groupBy]] = acc[cur[_this4.groupBy]] || [];
          acc[cur[_this4.groupBy]].push(cur);
          return acc;
        }, Object.create(null));
        var listKeys = Object.keys(mapGroup);
        if (this.sortModel === this.groupBy) {
          listKeys = listKeys.sort(this.sortStatus);
        } else {
          listKeys = listKeys.sort(function (e1, e2) {
            return e1 > e2;
          });
        }
        var result = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = listKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var listValues = mapGroup[key];
            result.push({
              isGroupHeader: true,
              header: key,
              model: this.groupBy
            });
            listValues = listValues.sort(this.sortRows);
            result = [].concat(_toConsumableArray(result), _toConsumableArray(listValues));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return result;
      } else {
        // Sort data before display
        if (this.sortModel && this.sortOrder) {
          listData = listData.sort(this.sortRows);
        }
      }
      return listData;
    },
    displayData: function displayData() {
      if (this.itemPerPage === "All") {
        return this.listAllRows;
      }

      return this.listAllRows.slice((this.currentPage - 1) * this.itemPerPage, this.currentPage * this.itemPerPage);
    },
    totalPage: function totalPage() {
      if (this.itemPerPage === "All") {
        return 1;
      }
      return Math.ceil(this.listAllRows.length / this.itemPerPage);
    },
    startNumber: function startNumber() {
      if (this.itemPerPage === "All") {
        return 1;
      }
      return (this.currentPage - 1) * this.itemPerPage + 1;
    },
    endNumber: function endNumber() {
      if (this.itemPerPage === "All") {
        return this.listAllRows.length;
      }
      var endNumber = this.currentPage * this.itemPerPage;
      if (endNumber < this.listAllRows.length) {
        return endNumber;
      }
      return this.listAllRows.length;
    }
  }),
  methods: {
    getSortModel: function getSortModel(field) {
      return field.sort_model || field.model;
    },
    sortStatus: function sortStatus(status1, status2) {
      // Find index in list status
      var index1 = this.listStatus.indexOf(status1);
      var index2 = this.listStatus.indexOf(status2);
      // If both status are not in list status, sort by alphabet
      if (index1 === -1 && index2 === -1) {
        if (status1 == null) {
          return 0 - this.sortOrder;
        }
        if (status2 == null) {
          return this.sortOrder;
        }
        return status1.toLowerCase() < status2.toLowerCase() ? 0 - this.sortOrder : this.sortOrder;
      }

      return index1 < index2 ? 0 - this.sortOrder : this.sortOrder;
    },
    sortRows: function sortRows(e1, e2) {
      if (this.sortModel === "status" && this.listStatus) {
        return this.sortStatus(e1.status, e2.status);
      } else if (this.sortModel === "first_name_last_name") {
        var firstName1 = e1["first_name"];
        var lastName1 = e1["last_name"];
        var firstName2 = e2["first_name"];
        var lastName2 = e2["last_name"];
        if (firstName1 == null || firstName2 == null) {
          // Compare last name
          if (lastName1 == null || lastName2 == null) {
            return this.sortOrder;
          } else {
            return lastName1.toLowerCase() < lastName2.toLowerCase() ? 0 - this.sortOrder : this.sortOrder;
          }
        } else {
          if (firstName1.toLowerCase() === firstName2.toLowerCase()) {
            // Compare last name
            return lastName1.toLowerCase() < lastName2.toLowerCase() ? 0 - this.sortOrder : this.sortOrder;
          } else {
            // Compare first name
            return firstName1.toLowerCase() < firstName2.toLowerCase() ? 0 - this.sortOrder : this.sortOrder;
          }
        }
      } else if (this.sortModel === "recent_access") {
        return this.getLastAccessTime(e1) < this.getLastAccessTime(e2) ? 0 - this.sortOrder : this.sortOrder;
      } else if (["timestamp", "created_date", "date"].includes(this.sortModel)) {
        if (this.secondarySort) {
          if (e1[this.sortModel] === e2[this.sortModel]) {
            var sortOrder = this.secondarySort.order || 1;
            return e1[this.secondarySort.model] < e2[this.secondarySort.model] ? 0 - sortOrder : sortOrder;
          }
        }
        return e1[this.sortModel] < e2[this.sortModel] ? 0 - this.sortOrder : this.sortOrder;
      } else if (["application_date", "report_date"].includes(this.sortModel)) {
        if (e1[this.sortModel] && e2[this.sortModel]) {
          return new Date(e1[this.sortModel].replace("at ", "")) > new Date(e2[this.sortModel].replace("at ", "")) ? 0 - this.sortOrder : this.sortOrder;
        }
      } else {
        if (["distance_to_job"].includes(this.sortModel)) {
          if (e1[this.sortModel] == null) {
            return this.sortOrder;
          }
          if (e2[this.sortModel] == null) {
            return 0 - this.sortOrder;
          }
        } else {
          if (e1[this.sortModel] == null) {
            return 0 - this.sortOrder;
          }
          if (e2[this.sortModel] == null) {
            return this.sortOrder;
          }
        }
        // Numeric fields
        if (typeof e1[this.sortModel] === "number" && typeof e2[this.sortModel] === "number") {
          // Numeric fields
          return e1[this.sortModel] < e2[this.sortModel] ? 0 - this.sortOrder : this.sortOrder;
        }
        return e1[this.sortModel].toString().toLowerCase() < e2[this.sortModel].toString().toLowerCase() ? 0 - this.sortOrder : this.sortOrder;
      }
    },
    getColor: function getColor(item, fieldName) {
      if (this.noColor) return "";
      if (fieldName) {
        if (fieldName === "types" && item) {
          var typeColor = this.listTypesColors.find(function (listItem) {
            return listItem.type && listItem.type.trim() === item.trim();
          });
          if (typeColor) {
            return typeColor.color;
          }
          return "#d9d9da"; //this is the default color for type pill
        }
        if (fieldName === "tags" && item) {
          var tagColor = this.listTagsColors.find(function (listItem) {
            return listItem.tag && listItem.tag.trim() === item.trim();
          });
          if (tagColor) {
            return tagColor.color;
          }
          return "#d9d9da"; //this is the default color for tag pill
        }
        return;
      }
      var statusColor = this.listStatusColors.find(function (statusColor) {
        return statusColor.status === item.status;
      });
      if (statusColor) {
        return statusColor.color;
      }
    },
    getTextColor: function getTextColor(item) {
      if (this.isTemplateTable && item.deactivated) {
        return "#cccccc";
      }
      return "black";
    },
    handleClickSelectAll: function handleClickSelectAll(isSelectAll) {
      var _this5 = this;

      // When click select all, show loading
      if (this.numberOfLoadingRequest === 0) {
        this.numberOfLoadingRequest += 1;
        this.showLoading();
      }
      setTimeout(function () {
        if (isSelectAll) {
          // Click select all at candidate tab
          _this5.checkedRows = _this5.displayData.map(function (item) {
            return item.id;
          });
        } else {
          // Deselect all
          _this5.checkedRows = [];
        }
      }, 10);
    },
    handleSortColumn: function handleSortColumn(field, order) {
      this.sortModel = field.sort_model || field.model;
      this.sortOrder = order;
      this.$emit("sort", { model: field.model, order: order });
    },
    getCellContent: function getCellContent(row, field) {
      if (field.transformFunction) {
        var content = field.transformFunction(row);
        if (!field.model) {
          field.model = field.displayLabel || field.label;
        }
        if (field.model.indexOf(this._uid + "_") !== 0) {
          field.model = this._uid + "_" + field.model;
        }
        row[field.model] = content;
        return content;
      }
      if (field.transformModelFunction) {
        return field.transformModelFunction(row[field.model]);
      }
      if (this.categoryHeaders.length > 0 && field.hasOwnProperty("category")) {
        return row[field.category][field.model];
      }
      return this.getTableCellContent(row, field, this.listFields);
    },
    handleClickPrevious: function handleClickPrevious() {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
      }
    },
    handleClickNext: function handleClickNext() {
      if (this.currentPage < this.totalPage) {
        this.currentPage = this.currentPage + 1;
      }
    },
    getSum: function getSum(field) {
      var result = 0;
      var isAllEmpty = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.listAllRows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item[field.model] != null && item[field.model] !== "") {
            isAllEmpty = false;
          }
          if (isNaN(item[field.model])) {
            return "";
          }
          result += Number(item[field.model]);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (isAllEmpty) {
        return "";
      }
      return result;
    },

    // Check if all of the checked data is still in the screen
    updateCheckedRow: function updateCheckedRow() {
      if (!this.checkedRows || !this.displayData) {
        this.checkedRows = [];
        return;
      }
      var listIds = this.checkedRows;
      var mapCurrentDisplayIds = this.displayData.map(function (item) {
        return item.id;
      });
      if (!listIds.every(function (id) {
        return mapCurrentDisplayIds.includes(id);
      })) {
        this.checkedRows = [];
        return;
      }
    }
  }
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(11);

var _fieldTypes = __webpack_require__(45);

exports.default = {
  name: "TableCell",
  props: {
    content: [String, Number],
    field: Object,
    row: Object,
    listStatusColors: Array,
    isJobTable: Boolean,
    isApplicantTable: {
      type: Boolean,
      default: false
    },
    isTemplateTable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      wordLengthLimit: 20, // If more than this, display Show More
      isDisplayFull: false,
      MAP_DIALOG_SECTION: _fieldTypes.MAP_DIALOG_SECTION
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["agencyCurrencySign"]), {
    transformNoteContent: function transformNoteContent() {
      if (!this.field || !this.field.transformNoteFunction) {
        return null;
      }
      return this.field.transformNoteFunction(this.row);
    },
    hasShowMoreLessButton: function hasShowMoreLessButton() {
      if (typeof this.content !== "string") {
        return false;
      }
      var tokens = this.content.split(" ");
      return tokens.length > this.wordLengthLimit;
    },
    displayContent: function displayContent() {
      if (!this.hasShowMoreLessButton) {
        return this.content;
      }
      if (this.isDisplayFull) {
        return this.content;
      }
      var tokens = this.content.split(" ");
      return tokens.slice(0, this.wordLengthLimit).join(" ");
    },
    hasDiffWarning: function hasDiffWarning() {
      var field = this.field;
      if (field.diffCheckModel) {
        if (!this.content) {
          return false;
        }
        var value = this.row[field.model];
        if (!value) {
          return false;
        }
        var refValue = this.row[field.diffCheckModel];
        if (value != refValue) {
          return true;
        }
      }
      return false;
    },
    noteModelOfField: function noteModelOfField() {
      var field = this.field;
      if (field.noteModel) {
        var noteModel = field.noteModel;
        if (noteModel === "text3") {
          return "clock_in_notes";
        }
        if (noteModel === "text4") {
          return "clock_out_notes";
        }
        if (noteModel === "text5") {
          return "admin_notes";
        }
        return noteModel;
      } else {
        return null;
      }
    },
    jobDateString: function jobDateString() {
      var job = this.row;
      if (!job || !job.date) {
        return "";
      }
      return this.addTimeToDate(job.date).toDateString();
    },
    fieldUseCurrency: function fieldUseCurrency() {
      if (!this.field || !this.field.model) {
        return false;
      }
      if (["candidate_rate", "client_rate", "agency_fee", "per_booking_agency_fee", "per_booking_candidate_fee", "travel_fee", "rush_fee", "candidate_rush_fee", "admin_fee", "admin_fee_subtraction", "additional_fee", "total_client_charge", "total_candidate_pay"].includes(this.field.model)) {
        return true;
      }
      return false;
    }
  }),
  methods: {
    showNote: function showNote(row) {
      if (this.field.showNoteFunc) {
        this.field.showNoteFunc(row);
      } else {
        this.showResultDialog({
          message: row[this.noteModelOfField],
          title: this.field.noteTitle
        });
      }
    },
    getSectionType: function getSectionType(api) {
      var section = Object.values(this.MAP_DIALOG_SECTION).find(function (item) {
        return item.api === api;
      });
      if (section == null) {
        return null;
      }
      return section.name;
    }
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Display types, tags of table
exports.default = {
  name: "TableCellBadge",
  props: {
    content: String,
    getColor: Function,
    name: String
  }
};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var locale = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "PDFButton",
  props: {
    buttonClass: { String: String },
    buttonStyle: { String: String, default: "" },
    urlLink: { String: String },
    buttonText: { String: String }
  }
};

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileWithLabel_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e443d3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileWithLabel_vue__ = __webpack_require__(608);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65e443d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e443d3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _fileType = __webpack_require__(146);

var _customDefineType = __webpack_require__(6);

var _PDFButton = __webpack_require__(286);

var _PDFButton2 = _interopRequireDefault(_PDFButton);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "FileWithLabel",
  props: {
    /* Name of the component*/
    name: String,
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    value: [File, String],
    // Remark at the end of component
    remark: String,
    // Maximum file size in MB
    maxSize: {
      type: Number,
      default: 100
    },
    fileType: String,
    initialUrl: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Info if submit file to server after upload
    submitInfo: Object,
    blankFileUrl: String,
    builderField: Object,
    uploadLabel: String,
    hideBorder: Boolean
  },
  components: {
    PDFButton: _PDFButton2.default
  },
  data: function data() {
    return {
      selectFile: this.value,
      imageUrl: this.initialUrl
    };
  },
  created: function created() {
    if (typeof this.value === "string") {
      this.imageUrl = this.convertToAbsolutePath(this.value);
    }
    if (this.initialUrl && !this.value) {
      this.inputVal = this.initialUrl;
    }
  },

  computed: {
    maxSizeInByte: function maxSizeInByte() {
      return this.maxSize * 1024 * 1024;
    },
    isDoc: function isDoc() {
      return this.fileType === _customDefineType.FILE_TYPES.DOCUMENT;
    },
    isImage: function isImage() {
      return this.fileType === _customDefineType.FILE_TYPES.IMAGE;
    },
    uploadFileId: function uploadFileId() {
      return "upload-file-id-" + this._uid + "-" + this.name;
    },
    isFileSubmitted: function isFileSubmitted() {
      return this.inputVal;
    },

    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (val && this.field) {
          val.name = this.field.label;
        }
        this.$emit("input", val);
      }
    }
  },
  methods: {
    onChange: function onChange() {
      var selectFile, formData, uploadFileRes, fileURL;
      return regeneratorRuntime.async(function onChange$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectFile = this.$refs.file.files[0];

              if (!(selectFile == null)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (selectFile.size === 0) {
                this.showErrorDialog(this.$store.getters.emptyFileError);
                this.selectFile = null;
              } else if (selectFile.size > this.maxSizeInByte) {
                this.showErrorDialog(this.$store.getters.fileSizeExceedLimitError);
                this.selectFile = null;
              } else if (this.isImage && !_fileType.VALID_IMAGE_FILE_TYPE.includes(selectFile.type)) {
                this.showErrorDialog(this.$store.getters.invalidImageFileTypeError);
                this.selectFile = null;
              } else if (this.isDoc && !_fileType.VALID_DOC_FILE_TYPE.includes(selectFile.type)) {
                this.showErrorDialog(this.$store.getters.invalidDocFileTypeError);
                this.selectFile = null;
              } else {
                this.selectFile = selectFile;
              }

              if (this.isImage) {
                if (this.selectFile == null) {
                  this.imageUrl = null;
                } else {
                  this.imageUrl = URL.createObjectURL(this.selectFile);
                }
              }

              // Upload file to server
              formData = new FormData();

              formData.append("file", selectFile);
              formData.append("agency", this.$store.getters.agencyID);
              if (this.submitInfo.profileBuilder) {
                formData.append("profile-builder", this.submitInfo.profileBuilder);
              }
              if (this.submitInfo.email) {
                formData.append("email", this.submitInfo.email);
              }
              if (this.submitInfo.type) {
                formData.append("type", this.submitInfo.type);
              }
              if (this.builderField && this.builderField.category) {
                formData.append("category", this.builderField.category);
              }
              _context.next = 14;
              return regeneratorRuntime.awrap(_axios2.default.post("/upload-files/", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }));

            case 14:
              uploadFileRes = _context.sent;

              if (uploadFileRes && uploadFileRes.data) {
                fileURL = uploadFileRes.data.file;

                this.$store.dispatch("addUploadedFileUrlName", {
                  url: fileURL,
                  name: this.selectFile.name
                });
                this.inputVal = fileURL;
              }
              this.$refs.file.value = "";

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    showDeleteDocumentConfirmDialog: function showDeleteDocumentConfirmDialog() {
      var _this = this;

      this.showConfirmDialog(_extends({}, this.$store.getters.deleteFileConfirmDialog, {
        onAcceptCallback: function onAcceptCallback() {
          _this.inputVal = null;
        }
      }));
    }
  }
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show error dialog.
To show an error, call this.showErrorDialog(errorObject)
Structure of errorObject:
{
    title: 'String',
    message: 'String',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbacData: object <- This field is optional, it is parameter of onCloseCallback function
}

*/


var _regex = __webpack_require__(46);

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "ErrorDialog",
  data: function data() {
    return {
      title: "",
      message: "",
      errorObj: null,
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null,
      isShow: false,
      params: [],
      innerHtml: null,
      onClickContent: null
    };
  },
  components: {
    ModalDialog: _ModalDialog2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["agencyID", "userID"]), {
    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed: function isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }),
  methods: {
    handleClickContent: function handleClickContent(event) {
      if (this.onClickContent) {
        this.onClickContent(event.target && event.target.id);
      }
    },
    extractErrorContent: function extractErrorContent(content) {
      if (typeof content !== "string") {
        return content;
      }
      var matchArr = content.match(_regex.REGEX_EXTRACT_HTML_TAG_CONTENT);
      if (matchArr != null) {
        return matchArr[1];
      }
      return content;
    },
    closeErrorDialog: function closeErrorDialog() {
      this.isShow = false;
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showErrorDialog(null);
    },
    showError: function showError(errorDialog) {
      var _this = this;

      this.title = errorDialog.title;
      this.message = errorDialog.message;
      this.errorObj = errorDialog.errorObj;
      this.innerHtml = errorDialog.innerHtml;
      if (errorDialog.messageList) {
        this.messageList = errorDialog.messageList;
      }
      if (!errorDialog.closeLabel) {
        this.closeLabel = this.getLabelByKeys("BUTTONS.CLOSE");
      } else {
        this.closeLabel = errorDialog.closeLabel;
      }

      this.params = errorDialog.params ? errorDialog.params : [];
      this.onCloseCallback = errorDialog.onCloseCallback;
      this.onCloseCallbackData = errorDialog.onCloseCallbackData;
      this.onClickContent = errorDialog.onClickContent;
      var key = errorDialog.key;
      var isMultiLanguageCloseLabel = false;
      if (key) {
        var title = this.getLabelByKeys("ERROR_DIALOGS." + key + ".TITLE");
        if (title) {
          this.title = title;
        }
        var message = this.getLabelByKeys("ERROR_DIALOGS." + key + ".MESSAGE");
        if (message) {
          this.message = message;
        }
        var innerHtml = this.getLabelByKeys("ERROR_DIALOGS." + key + ".INNER_HTML");
        if (innerHtml) {
          this.innerHtml = innerHtml;
        }
        var closeLabel = this.getLabelByKeys("ERROR_DIALOGS." + key + ".CLOSE_LABEL");
        if (closeLabel) {
          this.closeLabel = closeLabel;
          isMultiLanguageCloseLabel = true;
        }
      }
      // Use multi-language for close label
      if (!isMultiLanguageCloseLabel) {
        var displayCloseLabel = this.getLabelByKeys("BUTTONS." + this.closeLabel.toUpperCase());
        if (displayCloseLabel) {
          this.closeLabel = displayCloseLabel;
        }
      }
      this.isShow = true;
      var requestBody = {
        agency: this.agencyID,
        user: this.userID,
        url: this.$route.query.page
      };
      if (this.innerHtml) {
        requestBody.full_error = this.formatContent.apply(this, [this.innerHtml].concat(_toConsumableArray(this.params)));
      } else {
        var fullError = "";
        if (this.title) {
          requestBody.title = this.formatContent.apply(this, [this.title].concat(_toConsumableArray(this.params)));
          fullError += requestBody.title + "\n";
        }
        if (this.message) {
          requestBody.message = this.formatContent.apply(this, [this.message].concat(_toConsumableArray(this.params)));
          fullError += requestBody.message + "\n";
        }
        requestBody.full_error = fullError;
      }
      if (this.errorObj) {
        requestBody.full_error += this.tryGet(function () {
          return JSON.stringify(_this.errorObj);
        });
      }
      _axios2.default.post("/error-log/?in_background=true", requestBody);
    },
    getDisplayKey: function getDisplayKey(key) {
      if (key === "reply_address") {
        return "email address";
      } else {
        return key;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.watch(function (state) {
      return state.dialogs.errorDialog;
    }, function (value) {
      if (_this2.$store.getters.loadingReqNumber > 0) {
        return;
      }
      if (!value) {
        _this2.isShow = false;
        _this2.showErrorDialog(null);
      } else {
        _this2.showError(value);
      }
    }, { immediate: true });

    this.$store.watch(function (state) {
      return state.dialogs.loadingReqNumber;
    }, function (value) {
      if (value > 0) {
        return;
      }
      var errorDialog = _this2.$store.getters.errorDialog;
      if (errorDialog == null) {
        return;
      }
      _this2.showError(errorDialog);
    }, { immediate: true });
  }
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ConfirmDialog",
  data: function data() {
    return {
      message: "",
      acceptLabel: "",
      acceptLabel2: "",
      rejectLabel: "",
      confirmReason: "",
      reasonOnConfirmLabel: "",
      requiredConfirmReason: true, // Default: required
      isRequired: false,
      showReasonInput: false,
      onAcceptCallback: null,
      onAcceptCallbackData: null,
      onAcceptCallback2: null,
      onAcceptCallbackData2: null,
      onRejectCallback: null,
      onRejectCallbackData: null,
      params: [],
      innerHtml: null,
      isShow: false,
      isAcceptClick: false
    };
  },
  components: {
    ModalDialog: _ModalDialog2.default
  },
  computed: {
    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed: function isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  },
  methods: {
    onReject: function onReject() {
      this.isShow = false;
      if (!this.isAcceptClick) {
        if (this.onRejectCallback) {
          if (this.onRejectCallbackData) {
            this.onRejectCallback(this.onRejectCallbackData);
          } else {
            this.onRejectCallback();
          }
        }
      }
      this.showConfirmDialog(null);
    },
    onAccept: function onAccept() {
      this.isAcceptClick = true;
      var required = false;
      if (this.showReasonInput) {
        if (this.requiredConfirmReason && !this.confirmReason) {
          this.isRequired = true;
          required = true;
        } else {
          this.onAcceptCallbackData = this.confirmReason;
        }
      }

      if (!required) {
        this.isRequired = false;
        this.isShow = false;

        if (this.onAcceptCallback) {
          if (!this.onAcceptCallbackData) {
            this.onAcceptCallback();
          } else {
            this.onAcceptCallback(this.onAcceptCallbackData);
          }
        }
        this.showConfirmDialog(null);
      }
    },
    onAccept2: function onAccept2() {
      this.isAcceptClick = true;
      this.showConfirmDialog(null);
      if (this.onAcceptCallback2) {
        if (!this.onAcceptCallbackData2) {
          if (this.confirmReason) {
            this.onAcceptCallback2(this.confirmReason);
          } else {
            this.onAcceptCallback2();
          }
        } else {
          this.onAcceptCallback2(this.onAcceptCallbackData2);
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.dialogs.confirmDialog;
    }, function (value) {
      if (!value) {
        _this.isShow = false;
        _this.showConfirmDialog(null);
      } else {
        console.log(value);
        if (_this.isShow) {
          return;
        }
        _this.isAcceptClick = false;
        _this.message = value.message;
        if (!value.acceptLabel) {
          _this.acceptLabel = "Yes";
        } else {
          _this.acceptLabel = value.acceptLabel;
        }
        if (value.acceptLabel2) {
          _this.acceptLabel2 = value.acceptLabel2;
        } else {
          _this.acceptLabel2 = "";
        }
        if (!value.rejectLabel) {
          _this.rejectLabel = "No";
        } else {
          _this.rejectLabel = value.rejectLabel;
        }
        _this.showReasonInput = false;
        if (value.showReasonInput) {
          _this.requiredConfirmReason = value.requiredConfirmReason === false ? false : true;
          _this.showReasonInput = true;
          if (!value.reasonOnConfirmLabel) {
            _this.reasonOnConfirmLabel = "Reason for Confirmation";
          } else {
            _this.reasonOnConfirmLabel = value.reasonOnConfirmLabel;
          }
          _this.confirmReason = "";
        }
        _this.innerHtml = value.innerHtml;
        _this.onAcceptCallback = value.onAcceptCallback;
        _this.onAcceptCallbackData = value.onAcceptCallbackData;
        _this.onAcceptCallback2 = value.onAcceptCallback2;
        _this.onAcceptCallbackData2 = value.onAcceptCallbackData2;
        _this.onRejectCallback = value.onRejectCallback;
        _this.onRejectCallbackData = value.onRejectCallbackData;
        _this.params = value.params ? value.params : [];
        var key = value.key;
        var isMultiLanguageAcceptLabel = false;
        var isMultiLanguageRejectLabel = false;
        var isMultiLanguageAcceptLabel2 = false;
        if (key) {
          var message = _this.getLabelByKeys("CONFIRM_DIALOGS." + key + ".MESSAGE");
          if (message) {
            _this.message = message;
          }
          var innerHtml = _this.getLabelByKeys("CONFIRM_DIALOGS." + key + ".INNER_HTML");
          if (innerHtml) {
            _this.innerHtml = innerHtml;
          }
          var acceptLabel = _this.getLabelByKeys("CONFIRM_DIALOGS." + key + ".ACCEPT_LABEL");
          if (acceptLabel) {
            _this.acceptLabel = acceptLabel;
            isMultiLanguageAcceptLabel = true;
          }
          var acceptLabel2 = _this.getLabelByKeys("CONFIRM_DIALOGS." + key + ".ACCEPT_LABEL2");
          if (acceptLabel2) {
            _this.acceptLabel2 = acceptLabel2;
            isMultiLanguageAcceptLabel2 = true;
          }
          var rejectLabel = _this.getLabelByKeys("CONFIRM_DIALOGS." + key + ".REJECT_LABEL");
          if (rejectLabel) {
            _this.rejectLabel = rejectLabel;
            isMultiLanguageRejectLabel = true;
          }
        }
        // Use multi-language for accept label
        if (!isMultiLanguageAcceptLabel) {
          var displayAcceptLabel = _this.getLabelByKeys("BUTTONS." + _this.acceptLabel.toUpperCase());
          if (displayAcceptLabel) {
            _this.acceptLabel = displayAcceptLabel;
          }
        }
        // Use multi-language for accept label 2
        if (!isMultiLanguageAcceptLabel2) {
          var displayAcceptLabel2 = _this.getLabelByKeys("BUTTONS." + _this.acceptLabel2.toUpperCase());
          if (displayAcceptLabel2) {
            _this.acceptLabel2 = displayAcceptLabel2;
          }
        }
        // Use multi-language for reject label
        if (!isMultiLanguageRejectLabel) {
          var displayRejectLabel = _this.getLabelByKeys("BUTTONS." + _this.rejectLabel.toUpperCase());
          if (displayRejectLabel) {
            _this.rejectLabel = displayRejectLabel;
          }
        }
        _this.isShow = true;
      }
    }, { immediate: true });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show confirm dialog.
To show an confirm, call this.showConfirmDialog(confirmObject)
Structure of confirmObject:
{
    message: 'String',
    showReasonInput: 'Boolean', <- This field is optional, if not set, use default: false, on True shows input textbox for reason of confirmation
    reasonOnConfirmLabel: 'String', This field is optional, if not set and showReasonInput is True, use default: Reason for Confirmation
    acceptLabel: 'String', <- This field is optional, if not set, use default: Yes
    rejectLabel: 'String',  <- This field is optional, if not set, use default: No
    onAcceptCallback: function reference <- This field is optional, if set, the function will be called after click accept button 
    onAcceptCallbackData: object <- This field is optional, it is parameter of onAcceptCallback function
}

*/

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show result dialog.
To show an result, call this.showResultDialog(resultObject)
Structure of resultObject:
{
    title: 'String',
    message: 'String',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbacData: object <- This field is optional, it is parameter of onCloseCallback function
}

*/

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "ResultDialog",
  data: function data() {
    return {
      title: "",
      message: "",
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null,
      innerHtml: null,
      additionalFooter: null,
      params: [],
      isShow: false,
      hideButton: false,
      noToast: false, // Always show dialog
      onClickContent: null
    };
  },
  components: {
    ModalDialog: _ModalDialog2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["isAgent"]), {
    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed: function isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }),
  methods: {
    closeResultDialog: function closeResultDialog() {
      this.isShow = false;
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showResultDialog(null);
    },
    handleClickContent: function handleClickContent(event) {
      if (this.onClickContent) {
        this.onClickContent(event.target && event.target.id);
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.dialogs.resultDialog;
    }, function (value) {
      if (!value) {
        _this.isShow = false;
        _this.showResultDialog(null);
      } else {
        if (_this.isShow) {
          return;
        }
        _this.noToast = value.noToast;
        _this.title = value.title;
        _this.message = value.message;
        if (value.messageList) {
          _this.messageList = value.messageList;
        }
        _this.innerHtml = value.innerHtml;
        _this.additionalFooter = value.additionalFooter;
        if (!value.closeLabel) {
          _this.closeLabel = _this.getLabelByKeys("BUTTONS.CLOSE");
        } else {
          _this.closeLabel = value.closeLabel;
        }
        _this.onCloseCallback = value.onCloseCallback;
        _this.onCloseCallbackData = value.onCloseCallbackData;
        _this.params = value.params ? value.params : [];
        _this.onClickContent = value.onClickContent;
        _this.hideButton = value.hideButton;
        var key = value.key;
        var isMultiLanguageCloseLabel = false;
        if (key) {
          var title = _this.getLabelByKeys("RESULT_DIALOGS." + key + ".TITLE");
          if (title) {
            _this.title = title;
          }
          var message = _this.getLabelByKeys("RESULT_DIALOGS." + key + ".MESSAGE");
          if (message) {
            _this.message = message;
          }
          var innerHtml = _this.getLabelByKeys("RESULT_DIALOGS." + key + ".INNER_HTML");
          if (innerHtml) {
            _this.innerHtml = innerHtml;
          }
          var closeLabel = _this.getLabelByKeys("RESULT_DIALOGS." + key + ".CLOSE_LABEL");
          if (closeLabel) {
            _this.closeLabel = closeLabel;
            isMultiLanguageCloseLabel = true;
          }
        }
        // Use multi-language for close label
        if (!isMultiLanguageCloseLabel) {
          var displayCloseLabel = _this.getLabelByKeys("BUTTONS." + _this.closeLabel.toUpperCase());
          if (displayCloseLabel) {
            _this.closeLabel = displayCloseLabel;
          }
        }
        if (_this.isAgent && !_this.noToast) {
          // For the simple result dialog to show to admin, use toast instead of dialog
          if (_this.title && !_this.message && !_this.innerHtml && !_this.onCloseCallback) {
            _this.$toasted.show(_this.formatContent.apply(_this, [_this.title].concat(_toConsumableArray(_this.params))));
            _this.showResultDialog(null);
            return;
          }
        }
        _this.isShow = true;
      }
    }, { immediate: true });
  }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _DataTable = __webpack_require__(222);

var _DataTable2 = _interopRequireDefault(_DataTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show info dialog.
To show an info dialog, call this.showInfoDialog(infoObject)
Structure of infoObject:
{
    title: 'String',
    listFields: 'Array',
    data: 'Object',
    closeLabel: 'String', <- This field is optional, if not set, use default: Close
    onCloseCallback: function reference <- This field is optional, if set, the function will be called after close dialog
    onCloseCallbackData: object <- This field is optional, it is parameter of onCloseCallback function
    optionalButton: 'String', <- This field is optional if set shows a button on left side of dialog
    onOptionalCallback: function reference <- this field is optional if set function is called on click
    onOptionalClose: 'Bool', <- Default false, close dialog before option call back function is called
    onOptionalCallbackData: 'object' <- This field is optional, it is parameter of onOptionalCallback function
    optionalButton2: 'String', <- This field is optional if set shows a button on left side of dialog
    onOptionalCallback2: function reference <- this field is optional if set function is called on click
    onOptionalClose2: 'Bool', <- Default false, close dialog before option call back function is called
    onOptionalCallbackData2: 'object' <- This field is optional, it is parameter of onOptionalCallback2 function
}

*/

exports.default = {
  name: "InfoDialog",
  data: function data() {
    return {
      title: "",
      description: "",
      closeLabel: "",
      onCloseCallback: null,
      onCloseCallbackData: null,
      listFields: [],
      data: {},
      isShow: false,
      listTableHeaders: [],
      listRows: [],
      hasEditIcon: false,
      onEditCallback: null,
      optionalButton: null,
      onOptionalCallback: null,
      onOptionalClose: null,
      onOptionalCallbackData: null,
      optionalButton2: null,
      onOptionalCallback2: null,
      onOptionalClose2: null,
      onOptionalCallbackData2: null,
      onClickContent: null
    };
  },
  components: {
    ModalDialog: _ModalDialog2.default,
    DataTable: _DataTable2.default
  },
  methods: {
    closeInfoDialog: function closeInfoDialog() {
      this.isShow = false;
      if (this.onCloseCallback) {
        if (!this.onCloseCallbackData) {
          this.onCloseCallback();
        } else {
          this.onCloseCallback(this.onCloseCallbackData);
        }
      }
      this.showInfoDialog(null);
    },
    optionalInfoButton: function optionalInfoButton() {
      if (this.onOptionalClose) {
        this.isShow = false;
      }
      if (this.onOptionalCallback) {
        if (!this.onOptionalCallbackData) {
          this.onOptionalCallback();
        } else {
          this.onOptionalCallback(this.onOptionalCallbackData);
        }
      }
      if (this.onOptionalClose) {
        this.showInfoDialog(null);
      }
      console.log("option");
    },
    optionalInfoButton2: function optionalInfoButton2() {
      if (this.onOptionalClose2) {
        this.isShow = false;
      }
      if (this.onOptionalCallback2) {
        if (!this.onOptionalCallbackData2) {
          this.onOptionalCallback2();
        } else {
          this.onOptionalCallback2(this.onOptionalCallbackData2);
        }
      }
      if (this.onOptionalClose2) {
        this.showInfoDialog(null);
      }
    },
    handleClickEditButton: function handleClickEditButton() {
      if (this.onEditCallback) {
        this.onEditCallback();
      }
    },
    handleClickContent: function handleClickContent(event) {
      if (this.onClickContent) {
        this.onClickContent(event.target && event.target.id);
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.dialogs.infoDialog;
    }, function (value) {
      if (!value) {
        _this.isShow = false;
        _this.showInfoDialog(null);
      } else {
        if (_this.isShow) {
          return;
        }
        _this.title = value.title;
        _this.message = value.message;
        _this.listFields = value.listFields;
        _this.data = value.data;
        if (!value.closeLabel) {
          _this.closeLabel = _this.getLabelByKeys("BUTTONS.CLOSE");
        } else {
          _this.closeLabel = value.closeLabel;
        }
        _this.onCloseCallback = value.onCloseCallback;
        _this.onCloseCallbackData = value.onCloseCallbackData;
        _this.optionalButton = value.optionalButton ? value.optionalButton : false;
        _this.onOptionalCallback = value.onOptionalCallback;
        _this.onOptionalClose = value.onOptionalClose ? value.onOptionalClose : false;
        _this.onOptionalCallbackData = value.onOptionalCallbackData;

        _this.optionalButton2 = value.optionalButton2 ? value.optionalButton2 : false;
        _this.onOptionalCallback2 = value.onOptionalCallback2;
        _this.onOptionalClose2 = value.onOptionalClose2 ? value.onOptionalClose2 : false;
        _this.onOptionalCallbackData2 = value.onOptionalCallbackData2;
        _this.listTableHeaders = value.listTableHeaders;
        _this.listRows = value.listRows;
        _this.hasEditIcon = value.hasEditIcon;
        _this.onClickContent = value.onClickContent;
        if (value.onEditCallback) {
          _this.onEditCallback = value.onEditCallback;
        }
        _this.isShow = true;
      }
    }, { immediate: true });
  },

  watch: {
    isShow: {
      immediate: true,
      handler: function handler() {
        if (!this.isShow) {
          this.closeInfoDialog();
        }
      }
    }
  }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show input dialog.
To show an input dialog, call this.showInputDialog(inputObject)
Structure of inputObject:
{
    title: 'String',
    listFields: 'Array',
    data: 'Object', // Initial data
    submitLabel: 'String', <- This field is optional, if not set, use default: Submit
    cancelLabel: 'String' <- This field is optional, if not set, use default: Cancel
    onSubmitCallback: function reference <- This field is optional, if set, the function will be called after close dialog
}

*/

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "InputDialog",
  data: function data() {
    return {
      title: "",
      description: "",
      onSubmitCallback: null,
      onCloseCallback: null,
      listFields: [],
      applicationData: {},
      isShow: false,
      submitLabel: "Submit",
      cancelLabel: "Cancel",
      deleteLabel: "Delete",
      submitClicked: false,
      hasDistanceTop: false,
      keepDialogOnSubmit: false,
      hasDeleteBtn: false,
      confirmDeleteKey: "",
      onDeleteCallback: null,
      level: null
    };
  },
  components: {
    ModalDialog: _ModalDialog2.default
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["isRecordingVideo", "agencyID", "userID"]), {
    dialogId: function dialogId() {
      return "input_dialog_" + this.agencyID + "_" + this.userID;
    }
  }),
  methods: {
    hideModal: function hideModal() {
      if (this.onCloseCallback) {
        this.onCloseCallback();
      }
      this.isShow = false;
      this.hideInputDialog();
    },
    handleSubmit: function handleSubmit() {
      this.submitClicked = true;
      if (this.hasInvalidField(this.applicationData, this.listFields)) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        return;
      } else {
        if (this.onSubmitCallback) {
          this.onSubmitCallback(this.applicationData);
        }
        if (!this.keepDialogOnSubmit) {
          this.isShow = false;
          this.showInputDialog(null);
        }
      }
    },
    handleClickDeleteBtn: function handleClickDeleteBtn() {
      var _this = this;

      this.showConfirmDialog({
        key: this.confirmDeleteKey,
        onAcceptCallback: function onAcceptCallback() {
          if (_this.onDeleteCallback) {
            _this.onDeleteCallback();
            _this.hideModal();
          }
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.watch(function (state) {
      return state.dialogs.inputDialog;
    }, function (value) {
      if (!value) {
        _this2.isShow = false;
        _this2.showInputDialog(null);
      } else {
        if (_this2.isShow) {
          return;
        }
        _this2.title = value.title;
        _this2.message = value.message;
        _this2.description = value.description;
        _this2.listFields = value.listFields;
        if (value.data) {
          _this2.applicationData = value.data;
        } else {
          _this2.applicationData = {};
        }
        if (!value.submitLabel) {
          _this2.submitLabel = _this2.getLabelByKeys("BUTTONS.SUBMIT");
        } else {
          _this2.submitLabel = value.submitLabel;
        }
        if (!value.cancelLabel) {
          _this2.cancelLabel = _this2.getLabelByKeys("BUTTONS.CANCEL");
        } else {
          _this2.cancelLabel = value.cancelLabel;
        }
        _this2.onSubmitCallback = value.onSubmitCallback;
        _this2.onCloseCallback = value.onCloseCallback;
        _this2.hasDistanceTop = value.hasDistanceTop;
        _this2.keepDialogOnSubmit = value.keepDialogOnSubmit;
        _this2.level = value.level;
        _this2.hasDeleteBtn = value.hasDeleteBtn;
        if (_this2.hasDeleteBtn) {
          if (!value.deleteLabel) {
            _this2.deleteLabel = _this2.getLabelByKeys("BUTTONS.DELETE");
          } else {
            _this2.deleteLabel = value.deleteLabel;
          }
          _this2.confirmDeleteKey = value.confirmDeleteKey;
          _this2.onDeleteCallback = value.onDeleteCallback;
        }
        _this2.submitClicked = false;
        _this2.isShow = true;
      }
    }, { immediate: true });
  },

  watch: {
    isShow: {
      immediate: true,
      handler: function handler() {
        if (!this.isShow) {
          this.hideModal();
        }
      }
    }
  }
};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalDialog = __webpack_require__(34);

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

var _vueDocPreview = __webpack_require__(236);

var _vueDocPreview2 = _interopRequireDefault(_vueDocPreview);

var _FilePreview = __webpack_require__(633);

var _FilePreview2 = _interopRequireDefault(_FilePreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "FilePreviewDialog",
  data: function data() {
    return {
      isShow: false,
      url: "",
      showInLeft: false,
      additionalBtn: null
    };
  },

  components: {
    ModalDialog: _ModalDialog2.default,
    VueDocPreview: _vueDocPreview2.default,
    FilePreview: _FilePreview2.default
  },
  created: function created() {
    var _this = this;

    this.$store.watch(function (state) {
      return state.general.filePreview;
    }, function _callee(value) {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (value) {
                _context.next = 6;
                break;
              }

              _this.isShow = false;
              _this.showFilePreviewDialog(null);
              return _context.abrupt("return");

            case 6:
              if (!_this.isShow) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _this.url = value.url;
              _this.additionalBtn = value.additionalBtn;

              _this.showInLeft = _this.getShowInLeft();
              if (_this.isPdf || _this.isImage || _this.isOfficeDoc) {
                _this.isShow = true;
              } else {
                _this.openResourceURLDirectly();
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    }, { immediate: true });
  },

  computed: {
    fileExtension: function fileExtension() {
      try {
        return this.url.split(".").pop().toLowerCase();
      } catch (e) {
        return null;
      }
    },
    isPdf: function isPdf() {
      return this.fileExtension === "pdf";
    },
    isImage: function isImage() {
      return ["png", "jpg", "jpeg"].includes(this.fileExtension);
    },
    isOfficeDoc: function isOfficeDoc() {
      return ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(this.fileExtension);
    },
    isIphone: function isIphone() {
      return this.getMobileOperatingSystem() === "iOS";
    }
  },
  methods: {
    hideModal: function hideModal() {
      this.isShow = false;
      this.showFilePreviewDialog(null);
    },
    openResourceURLDirectly: function openResourceURLDirectly() {
      if (!this.url) {
        return;
      }
      window.open(this.url, "_blank");
    },
    getShowInLeft: function getShowInLeft() {
      // Check if the component is showed in the dialog or in the screen
      var interviewTab = document.getElementById("interview-profile");
      if (interviewTab != null) {
        return true;
      }
      // Check if the component is showed in the job posting dialog
      var jobPostingDialogEl = document.getElementById("job-posting-dialog");
      if (jobPostingDialogEl != null) {
        return true;
      }
      return false;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"===typeof define&&define.amd?define([],t):"object"===typeof exports?exports["vueDocPreview"]=t():e["vueDocPreview"]=t()})("undefined"!==typeof self?self:this,function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"===typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(r,i,function(t){return e[t]}.bind(null,i));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e["default"]}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s="fb15")}({"01f9":function(e,t,n){"use strict";var r=n("2d00"),i=n("5ca1"),a=n("2aba"),o=n("32e9"),s=n("84f2"),c=n("41a0"),l=n("7f20"),u=n("38fd"),d=n("2b4c")("iterator"),p=!([].keys&&"next"in[].keys()),f="@@iterator",g="keys",h="values",m=function(){return this};e.exports=function(e,t,n,b,v,_,y){c(n,t,b);var x,w,E,S=function(e){if(!p&&e in M)return M[e];switch(e){case g:return function(){return new n(this,e)};case h:return function(){return new n(this,e)}}return function(){return new n(this,e)}},k=t+" Iterator",N=v==h,C=!1,M=e.prototype,O=M[d]||M[f]||v&&M[v],T=O||S(v),R=v?N?S("entries"):T:void 0,A="Array"==t&&M.entries||O;if(A&&(E=u(A.call(new e)),E!==Object.prototype&&E.next&&(l(E,k,!0),r||"function"==typeof E[d]||o(E,d,m))),N&&O&&O.name!==h&&(C=!0,T=function(){return O.call(this)}),r&&!y||!p&&!C&&M[d]||o(M,d,T),s[t]=T,s[k]=m,v)if(x={values:N?T:S(h),keys:_?T:S(g),entries:R},y)for(w in x)w in M||a(M,w,x[w]);else i(i.P+i.F*(p||C),t,x);return x}},"0209":function(e,t){e.exports=function(e){var t={className:"keyword",begin:"\\b[a-z\\d_]*_t\\b"},n={className:"string",variants:[{begin:'(u8?|U)?L?"',end:'"',illegal:"\\n",contains:[e.BACKSLASH_ESCAPE]},{begin:'(u8?|U)?R"',end:'"',contains:[e.BACKSLASH_ESCAPE]},{begin:"'\\\\?.",end:"'",illegal:"."}]},r={className:"number",variants:[{begin:"\\b(0b[01']+)"},{begin:"(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"},{begin:"(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"}],relevance:0},i={className:"meta",begin:/#\s*[a-z]+\b/,end:/$/,keywords:{"meta-keyword":"if else elif endif define undef warning error line pragma ifdef ifndef include"},contains:[{begin:/\\\n/,relevance:0},e.inherit(n,{className:"meta-string"}),{className:"meta-string",begin:/<[^\n>]*>/,end:/$/,illegal:"\\n"},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},a=e.IDENT_RE+"\\s*\\(",o={keyword:"int float while private char catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using asm case typeid short reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignof constexpr decltype noexcept static_assert thread_local restrict _Bool complex _Complex _Imaginary atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return and or not",built_in:"std string cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap array shared_ptr abort abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr",literal:"true false nullptr NULL"},s=[t,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,r,n];return{aliases:["c","cc","h","c++","h++","hpp"],keywords:o,illegal:"</",contains:s.concat([i,{begin:"\\b(deque|list|queue|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",end:">",keywords:o,contains:["self",t]},{begin:e.IDENT_RE+"::",keywords:o},{variants:[{begin:/=/,end:/;/},{begin:/\(/,end:/\)/},{beginKeywords:"new throw return else",end:/;/}],keywords:o,contains:s.concat([{begin:/\(/,end:/\)/,keywords:o,contains:s.concat(["self"]),relevance:0}]),relevance:0},{className:"function",begin:"("+e.IDENT_RE+"[\\*&\\s]+)+"+a,returnBegin:!0,end:/[{;=]/,excludeEnd:!0,keywords:o,illegal:/[^\w\s\*&]/,contains:[{begin:a,returnBegin:!0,contains:[e.TITLE_MODE],relevance:0},{className:"params",begin:/\(/,end:/\)/,keywords:o,relevance:0,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,n,r,t]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,i]},{className:"class",beginKeywords:"class struct",end:/[{;:]/,contains:[{begin:/</,end:/>/,contains:["self"]},e.TITLE_MODE]}]),exports:{preprocessor:i,strings:n,keywords:o}}}},"044b":function(e,t){function n(e){return!!e.constructor&&"function"===typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}function r(e){return"function"===typeof e.readFloatLE&&"function"===typeof e.slice&&n(e.slice(0,0))}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
e.exports=function(e){return null!=e&&(n(e)||r(e)||!!e._isBuffer)}},"04b0":function(e,t){e.exports=function(e){return{aliases:["md","mkdown","mkd"],contains:[{className:"section",variants:[{begin:"^#{1,6}",end:"$"},{begin:"^.+?\\n[=-]{2,}$"}]},{begin:"<",end:">",subLanguage:"xml",relevance:0},{className:"bullet",begin:"^([*+-]|(\\d+\\.))\\s+"},{className:"strong",begin:"[*_]{2}.+?[*_]{2}"},{className:"emphasis",variants:[{begin:"\\*.+?\\*"},{begin:"_.+?_",relevance:0}]},{className:"quote",begin:"^>\\s+",end:"$"},{className:"code",variants:[{begin:"^```w*s*$",end:"^```s*$"},{begin:"`.+?`"},{begin:"^( {4}|\t)",end:"$",relevance:0}]},{begin:"^[-\\*]{3,}",end:"$"},{begin:"\\[.+?\\][\\(\\[].*?[\\)\\]]",returnBegin:!0,contains:[{className:"string",begin:"\\[",end:"\\]",excludeBegin:!0,returnEnd:!0,relevance:0},{className:"link",begin:"\\]\\(",end:"\\)",excludeBegin:!0,excludeEnd:!0},{className:"symbol",begin:"\\]\\[",end:"\\]",excludeBegin:!0,excludeEnd:!0}],relevance:10},{begin:/^\[[^\n]+\]:/,returnBegin:!0,contains:[{className:"symbol",begin:/\[/,end:/\]/,excludeBegin:!0,excludeEnd:!0},{className:"link",begin:/:\s*/,end:/$/,excludeBegin:!0}]}]}}},"0a06":function(e,t,n){"use strict";var r=n("2444"),i=n("c532"),a=n("f6b4"),o=n("5270");function s(e){this.defaults=e,this.interceptors={request:new a,response:new a}}s.prototype.request=function(e){"string"===typeof e&&(e=i.merge({url:arguments[0]},arguments[1])),e=i.merge(r,{method:"get"},this.defaults,e),e.method=e.method.toLowerCase();var t=[o,void 0],n=Promise.resolve(e);this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});while(t.length)n=n.then(t.shift(),t.shift());return n},i.forEach(["delete","get","head","options"],function(e){s.prototype[e]=function(t,n){return this.request(i.merge(n||{},{method:e,url:t}))}}),i.forEach(["post","put","patch"],function(e){s.prototype[e]=function(t,n,r){return this.request(i.merge(r||{},{method:e,url:t,data:n}))}}),e.exports=s},"0bfb":function(e,t,n){"use strict";var r=n("cb7c");e.exports=function(){var e=r(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t}},"0d58":function(e,t,n){var r=n("ce10"),i=n("e11e");e.exports=Object.keys||function(e){return r(e,i)}},"0df6":function(e,t,n){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},"0e54":function(e,t,n){(function(t){(function(t){"use strict";var n={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:h,hr:/^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,nptable:h,blockquote:/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:"^ {0,3}(?:<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?\\?>\\n*|<![A-Z][\\s\\S]*?>\\n*|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=\\h*\\n)[\\s\\S]*?(?:\\n{2,}|$)|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=\\h*\\n)[\\s\\S]*?(?:\\n{2,}|$))",def:/^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,table:h,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,paragraph:/^([^\n]+(?:\n(?!hr|heading|lheading| {0,3}>|<\/?(?:tag)(?: +|\n|\/?>)|<(?:script|pre|style|!--))[^\n]+)*)/,text:/^[^\n]+/};function r(e){this.tokens=[],this.tokens.links={},this.options=e||v.defaults,this.rules=n.normal,this.options.pedantic?this.rules=n.pedantic:this.options.gfm&&(this.options.tables?this.rules=n.tables:this.rules=n.gfm)}n._label=/(?!\s*\])(?:\\[\[\]]|[^\[\]])+/,n._title=/(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/,n.def=d(n.def).replace("label",n._label).replace("title",n._title).getRegex(),n.bullet=/(?:[*+-]|\d+\.)/,n.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/,n.item=d(n.item,"gm").replace(/bull/g,n.bullet).getRegex(),n.list=d(n.list).replace(/bull/g,n.bullet).replace("hr","\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def","\\n+(?="+n.def.source+")").getRegex(),n._tag="address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul",n._comment=/<!--(?!-?>)[\s\S]*?-->/,n.html=d(n.html,"i").replace("comment",n._comment).replace("tag",n._tag).replace("attribute",/ +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(),n.paragraph=d(n.paragraph).replace("hr",n.hr).replace("heading",n.heading).replace("lheading",n.lheading).replace("tag",n._tag).getRegex(),n.blockquote=d(n.blockquote).replace("paragraph",n.paragraph).getRegex(),n.normal=m({},n),n.gfm=m({},n.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\n? *\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/}),n.gfm.paragraph=d(n.paragraph).replace("(?!","(?!"+n.gfm.fences.source.replace("\\1","\\2")+"|"+n.list.source.replace("\\1","\\3")+"|").getRegex(),n.tables=m({},n.gfm,{nptable:/^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,table:/^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/}),n.pedantic=m({},n.normal,{html:d("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment",n._comment).replace(/tag/g,"(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/}),r.rules=n,r.lex=function(e,t){var n=new r(t);return n.lex(e)},r.prototype.lex=function(e){return e=e.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n"),this.token(e,!0)},r.prototype.token=function(e,t){var r,i,a,o,s,c,l,u,d,p,f,g,h;e=e.replace(/^ +$/gm,"");while(e)if((a=this.rules.newline.exec(e))&&(e=e.substring(a[0].length),a[0].length>1&&this.tokens.push({type:"space"})),a=this.rules.code.exec(e))e=e.substring(a[0].length),a=a[0].replace(/^ {4}/gm,""),this.tokens.push({type:"code",text:this.options.pedantic?a:a.replace(/\n+$/,"")});else if(a=this.rules.fences.exec(e))e=e.substring(a[0].length),this.tokens.push({type:"code",lang:a[2],text:a[3]||""});else if(a=this.rules.heading.exec(e))e=e.substring(a[0].length),this.tokens.push({type:"heading",depth:a[1].length,text:a[2]});else if(t&&(a=this.rules.nptable.exec(e))&&(c={type:"table",header:b(a[1].replace(/^ *| *\| *$/g,"")),align:a[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:a[3]?a[3].replace(/\n$/,"").split("\n"):[]},c.header.length===c.align.length)){for(e=e.substring(a[0].length),u=0;u<c.align.length;u++)/^ *-+: *$/.test(c.align[u])?c.align[u]="right":/^ *:-+: *$/.test(c.align[u])?c.align[u]="center":/^ *:-+ *$/.test(c.align[u])?c.align[u]="left":c.align[u]=null;for(u=0;u<c.cells.length;u++)c.cells[u]=b(c.cells[u],c.header.length);this.tokens.push(c)}else if(a=this.rules.hr.exec(e))e=e.substring(a[0].length),this.tokens.push({type:"hr"});else if(a=this.rules.blockquote.exec(e))e=e.substring(a[0].length),this.tokens.push({type:"blockquote_start"}),a=a[0].replace(/^ *> ?/gm,""),this.token(a,t),this.tokens.push({type:"blockquote_end"});else if(a=this.rules.list.exec(e)){for(e=e.substring(a[0].length),o=a[2],f=o.length>1,this.tokens.push({type:"list_start",ordered:f,start:f?+o:""}),a=a[0].match(this.rules.item),r=!1,p=a.length,u=0;u<p;u++)c=a[u],l=c.length,c=c.replace(/^ *([*+-]|\d+\.) +/,""),~c.indexOf("\n ")&&(l-=c.length,c=this.options.pedantic?c.replace(/^ {1,4}/gm,""):c.replace(new RegExp("^ {1,"+l+"}","gm"),"")),this.options.smartLists&&u!==p-1&&(s=n.bullet.exec(a[u+1])[0],o===s||o.length>1&&s.length>1||(e=a.slice(u+1).join("\n")+e,u=p-1)),i=r||/\n\n(?!\s*$)/.test(c),u!==p-1&&(r="\n"===c.charAt(c.length-1),i||(i=r)),g=/^\[[ xX]\] /.test(c),h=void 0,g&&(h=" "!==c[1],c=c.replace(/^\[[ xX]\] +/,"")),this.tokens.push({type:i?"loose_item_start":"list_item_start",task:g,checked:h}),this.token(c,!1),this.tokens.push({type:"list_item_end"});this.tokens.push({type:"list_end"})}else if(a=this.rules.html.exec(e))e=e.substring(a[0].length),this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&("pre"===a[1]||"script"===a[1]||"style"===a[1]),text:a[0]});else if(t&&(a=this.rules.def.exec(e)))e=e.substring(a[0].length),a[3]&&(a[3]=a[3].substring(1,a[3].length-1)),d=a[1].toLowerCase().replace(/\s+/g," "),this.tokens.links[d]||(this.tokens.links[d]={href:a[2],title:a[3]});else if(t&&(a=this.rules.table.exec(e))&&(c={type:"table",header:b(a[1].replace(/^ *| *\| *$/g,"")),align:a[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:a[3]?a[3].replace(/(?: *\| *)?\n$/,"").split("\n"):[]},c.header.length===c.align.length)){for(e=e.substring(a[0].length),u=0;u<c.align.length;u++)/^ *-+: *$/.test(c.align[u])?c.align[u]="right":/^ *:-+: *$/.test(c.align[u])?c.align[u]="center":/^ *:-+ *$/.test(c.align[u])?c.align[u]="left":c.align[u]=null;for(u=0;u<c.cells.length;u++)c.cells[u]=b(c.cells[u].replace(/^ *\| *| *\| *$/g,""),c.header.length);this.tokens.push(c)}else if(a=this.rules.lheading.exec(e))e=e.substring(a[0].length),this.tokens.push({type:"heading",depth:"="===a[2]?1:2,text:a[1]});else if(t&&(a=this.rules.paragraph.exec(e)))e=e.substring(a[0].length),this.tokens.push({type:"paragraph",text:"\n"===a[1].charAt(a[1].length-1)?a[1].slice(0,-1):a[1]});else if(a=this.rules.text.exec(e))e=e.substring(a[0].length),this.tokens.push({type:"text",text:a[0]});else if(e)throw new Error("Infinite loop on byte: "+e.charCodeAt(0));return this.tokens};var i={escape:/^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,autolink:/^<(scheme:[^\s\x00-\x1f<>]*|email)>/,url:h,tag:"^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",link:/^!?\[(label)\]\(href(?:\s+(title))?\s*\)/,reflink:/^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,nolink:/^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,strong:/^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)|^__([^\s])__(?!_)|^\*\*([^\s])\*\*(?!\*)/,em:/^_([^\s][\s\S]*?[^\s_])_(?!_)|^_([^\s_][\s\S]*?[^\s])_(?!_)|^\*([^\s][\s\S]*?[^\s*])\*(?!\*)|^\*([^\s*][\s\S]*?[^\s])\*(?!\*)|^_([^\s_])_(?!_)|^\*([^\s*])\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`]?)\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:h,text:/^[\s\S]+?(?=[\\<!\[`*]|\b_| {2,}\n|$)/};function a(e,t){if(this.options=t||v.defaults,this.links=e,this.rules=i.normal,this.renderer=this.options.renderer||new o,this.renderer.options=this.options,!this.links)throw new Error("Tokens array requires a `links` property.");this.options.pedantic?this.rules=i.pedantic:this.options.gfm&&(this.options.breaks?this.rules=i.breaks:this.rules=i.gfm)}function o(e){this.options=e||v.defaults}function s(){}function c(e){this.tokens=[],this.token=null,this.options=e||v.defaults,this.options.renderer=this.options.renderer||new o,this.renderer=this.options.renderer,this.renderer.options=this.options}function l(e,t){return e.replace(t?/&/g:/&(?!#?\w+;)/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function u(e){return e.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi,function(e,t){return t=t.toLowerCase(),"colon"===t?":":"#"===t.charAt(0)?"x"===t.charAt(1)?String.fromCharCode(parseInt(t.substring(2),16)):String.fromCharCode(+t.substring(1)):""})}function d(e,t){return e=e.source||e,t=t||"",{replace:function(t,n){return n=n.source||n,n=n.replace(/(^|[^\[])\^/g,"$1"),e=e.replace(t,n),this},getRegex:function(){return new RegExp(e,t)}}}function p(e,t){return f[" "+e]||(/^[^:]+:\/*[^/]*$/.test(e)?f[" "+e]=e+"/":f[" "+e]=e.replace(/[^/]*$/,"")),e=f[" "+e],"//"===t.slice(0,2)?e.replace(/:[\s\S]*/,":")+t:"/"===t.charAt(0)?e.replace(/(:\/*[^/]*)[\s\S]*/,"$1")+t:e+t}i._escapes=/\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g,i._scheme=/[a-zA-Z][a-zA-Z0-9+.-]{1,31}/,i._email=/[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/,i.autolink=d(i.autolink).replace("scheme",i._scheme).replace("email",i._email).getRegex(),i._attribute=/\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/,i.tag=d(i.tag).replace("comment",n._comment).replace("attribute",i._attribute).getRegex(),i._label=/(?:\[[^\[\]]*\]|\\[\[\]]?|`[^`]*`|[^\[\]\\])*?/,i._href=/\s*(<(?:\\[<>]?|[^\s<>\\])*>|(?:\\[()]?|\([^\s\x00-\x1f()\\]*\)|[^\s\x00-\x1f()\\])*?)/,i._title=/"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/,i.link=d(i.link).replace("label",i._label).replace("href",i._href).replace("title",i._title).getRegex(),i.reflink=d(i.reflink).replace("label",i._label).getRegex(),i.normal=m({},i),i.pedantic=m({},i.normal,{strong:/^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,link:d(/^!?\[(label)\]\((.*?)\)/).replace("label",i._label).getRegex(),reflink:d(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label",i._label).getRegex()}),i.gfm=m({},i.normal,{escape:d(i.escape).replace("])","~|])").getRegex(),url:d(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("email",i._email).getRegex(),_backpedal:/(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:d(i.text).replace("]|","~]|").replace("|","|https?://|ftp://|www\\.|[a-zA-Z0-9.!#$%&'*+/=?^_`{\\|}~-]+@|").getRegex()}),i.breaks=m({},i.gfm,{br:d(i.br).replace("{2,}","*").getRegex(),text:d(i.gfm.text).replace("{2,}","*").getRegex()}),a.rules=i,a.output=function(e,t,n){var r=new a(t,n);return r.output(e)},a.prototype.output=function(e){var t,n,r,i,o,s="";while(e)if(o=this.rules.escape.exec(e))e=e.substring(o[0].length),s+=o[1];else if(o=this.rules.autolink.exec(e))e=e.substring(o[0].length),"@"===o[2]?(n=l(this.mangle(o[1])),r="mailto:"+n):(n=l(o[1]),r=n),s+=this.renderer.link(r,null,n);else if(this.inLink||!(o=this.rules.url.exec(e))){if(o=this.rules.tag.exec(e))!this.inLink&&/^<a /i.test(o[0])?this.inLink=!0:this.inLink&&/^<\/a>/i.test(o[0])&&(this.inLink=!1),e=e.substring(o[0].length),s+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(o[0]):l(o[0]):o[0];else if(o=this.rules.link.exec(e))e=e.substring(o[0].length),this.inLink=!0,r=o[2],this.options.pedantic?(t=/^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(r),t?(r=t[1],i=t[3]):i=""):i=o[3]?o[3].slice(1,-1):"",r=r.trim().replace(/^<([\s\S]*)>$/,"$1"),s+=this.outputLink(o,{href:a.escapes(r),title:a.escapes(i)}),this.inLink=!1;else if((o=this.rules.reflink.exec(e))||(o=this.rules.nolink.exec(e))){if(e=e.substring(o[0].length),t=(o[2]||o[1]).replace(/\s+/g," "),t=this.links[t.toLowerCase()],!t||!t.href){s+=o[0].charAt(0),e=o[0].substring(1)+e;continue}this.inLink=!0,s+=this.outputLink(o,t),this.inLink=!1}else if(o=this.rules.strong.exec(e))e=e.substring(o[0].length),s+=this.renderer.strong(this.output(o[4]||o[3]||o[2]||o[1]));else if(o=this.rules.em.exec(e))e=e.substring(o[0].length),s+=this.renderer.em(this.output(o[6]||o[5]||o[4]||o[3]||o[2]||o[1]));else if(o=this.rules.code.exec(e))e=e.substring(o[0].length),s+=this.renderer.codespan(l(o[2].trim(),!0));else if(o=this.rules.br.exec(e))e=e.substring(o[0].length),s+=this.renderer.br();else if(o=this.rules.del.exec(e))e=e.substring(o[0].length),s+=this.renderer.del(this.output(o[1]));else if(o=this.rules.text.exec(e))e=e.substring(o[0].length),s+=this.renderer.text(l(this.smartypants(o[0])));else if(e)throw new Error("Infinite loop on byte: "+e.charCodeAt(0))}else o[0]=this.rules._backpedal.exec(o[0])[0],e=e.substring(o[0].length),"@"===o[2]?(n=l(o[0]),r="mailto:"+n):(n=l(o[0]),r="www."===o[1]?"http://"+n:n),s+=this.renderer.link(r,null,n);return s},a.escapes=function(e){return e?e.replace(a.rules._escapes,"$1"):e},a.prototype.outputLink=function(e,t){var n=t.href,r=t.title?l(t.title):null;return"!"!==e[0].charAt(0)?this.renderer.link(n,r,this.output(e[1])):this.renderer.image(n,r,l(e[1]))},a.prototype.smartypants=function(e){return this.options.smartypants?e.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…"):e},a.prototype.mangle=function(e){if(!this.options.mangle)return e;for(var t,n="",r=e.length,i=0;i<r;i++)t=e.charCodeAt(i),Math.random()>.5&&(t="x"+t.toString(16)),n+="&#"+t+";";return n},o.prototype.code=function(e,t,n){if(this.options.highlight){var r=this.options.highlight(e,t);null!=r&&r!==e&&(n=!0,e=r)}return t?'<pre><code class="'+this.options.langPrefix+l(t,!0)+'">'+(n?e:l(e,!0))+"</code></pre>\n":"<pre><code>"+(n?e:l(e,!0))+"</code></pre>"},o.prototype.blockquote=function(e){return"<blockquote>\n"+e+"</blockquote>\n"},o.prototype.html=function(e){return e},o.prototype.heading=function(e,t,n){return this.options.headerIds?"<h"+t+' id="'+this.options.headerPrefix+n.toLowerCase().replace(/[^\w]+/g,"-")+'">'+e+"</h"+t+">\n":"<h"+t+">"+e+"</h"+t+">\n"},o.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"},o.prototype.list=function(e,t,n){var r=t?"ol":"ul",i=t&&1!==n?' start="'+n+'"':"";return"<"+r+i+">\n"+e+"</"+r+">\n"},o.prototype.listitem=function(e){return"<li>"+e+"</li>\n"},o.prototype.checkbox=function(e){return"<input "+(e?'checked="" ':"")+'disabled="" type="checkbox"'+(this.options.xhtml?" /":"")+"> "},o.prototype.paragraph=function(e){return"<p>"+e+"</p>\n"},o.prototype.table=function(e,t){return t&&(t="<tbody>"+t+"</tbody>"),"<table>\n<thead>\n"+e+"</thead>\n"+t+"</table>\n"},o.prototype.tablerow=function(e){return"<tr>\n"+e+"</tr>\n"},o.prototype.tablecell=function(e,t){var n=t.header?"th":"td",r=t.align?"<"+n+' align="'+t.align+'">':"<"+n+">";return r+e+"</"+n+">\n"},o.prototype.strong=function(e){return"<strong>"+e+"</strong>"},o.prototype.em=function(e){return"<em>"+e+"</em>"},o.prototype.codespan=function(e){return"<code>"+e+"</code>"},o.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"},o.prototype.del=function(e){return"<del>"+e+"</del>"},o.prototype.link=function(e,t,n){if(this.options.sanitize){try{var r=decodeURIComponent(u(e)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return n}if(0===r.indexOf("javascript:")||0===r.indexOf("vbscript:")||0===r.indexOf("data:"))return n}this.options.baseUrl&&!g.test(e)&&(e=p(this.options.baseUrl,e));try{e=encodeURI(e).replace(/%25/g,"%")}catch(e){return n}var i='<a href="'+l(e)+'"';return t&&(i+=' title="'+t+'"'),i+=">"+n+"</a>",i},o.prototype.image=function(e,t,n){this.options.baseUrl&&!g.test(e)&&(e=p(this.options.baseUrl,e));var r='<img src="'+e+'" alt="'+n+'"';return t&&(r+=' title="'+t+'"'),r+=this.options.xhtml?"/>":">",r},o.prototype.text=function(e){return e},s.prototype.strong=s.prototype.em=s.prototype.codespan=s.prototype.del=s.prototype.text=function(e){return e},s.prototype.link=s.prototype.image=function(e,t,n){return""+n},s.prototype.br=function(){return""},c.parse=function(e,t){var n=new c(t);return n.parse(e)},c.prototype.parse=function(e){this.inline=new a(e.links,this.options),this.inlineText=new a(e.links,m({},this.options,{renderer:new s})),this.tokens=e.reverse();var t="";while(this.next())t+=this.tok();return t},c.prototype.next=function(){return this.token=this.tokens.pop()},c.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0},c.prototype.parseText=function(){var e=this.token.text;while("text"===this.peek().type)e+="\n"+this.next().text;return this.inline.output(e)},c.prototype.tok=function(){switch(this.token.type){case"space":return"";case"hr":return this.renderer.hr();case"heading":return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,u(this.inlineText.output(this.token.text)));case"code":return this.renderer.code(this.token.text,this.token.lang,this.token.escaped);case"table":var e,t,n,r,i="",a="";for(n="",e=0;e<this.token.header.length;e++)n+=this.renderer.tablecell(this.inline.output(this.token.header[e]),{header:!0,align:this.token.align[e]});for(i+=this.renderer.tablerow(n),e=0;e<this.token.cells.length;e++){for(t=this.token.cells[e],n="",r=0;r<t.length;r++)n+=this.renderer.tablecell(this.inline.output(t[r]),{header:!1,align:this.token.align[r]});a+=this.renderer.tablerow(n)}return this.renderer.table(i,a);case"blockquote_start":a="";while("blockquote_end"!==this.next().type)a+=this.tok();return this.renderer.blockquote(a);case"list_start":a="";var o=this.token.ordered,s=this.token.start;while("list_end"!==this.next().type)a+=this.tok();return this.renderer.list(a,o,s);case"list_item_start":a="",this.token.task&&(a+=this.renderer.checkbox(this.token.checked));while("list_item_end"!==this.next().type)a+="text"===this.token.type?this.parseText():this.tok();return this.renderer.listitem(a);case"loose_item_start":a="";while("list_item_end"!==this.next().type)a+=this.tok();return this.renderer.listitem(a);case"html":return this.renderer.html(this.token.text);case"paragraph":return this.renderer.paragraph(this.inline.output(this.token.text));case"text":return this.renderer.paragraph(this.parseText())}};var f={},g=/^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;function h(){}function m(e){for(var t,n,r=1;r<arguments.length;r++)for(n in t=arguments[r],t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}function b(e,t){var n=e.replace(/([^\\])\|/g,"$1 |").split(/ +\| */),r=0;if(n.length>t)n.splice(t);else while(n.length<t)n.push("");for(;r<n.length;r++)n[r]=n[r].replace(/\\\|/g,"|");return n}function v(e,t,n){if("undefined"===typeof e||null===e)throw new Error("marked(): input parameter is undefined or null");if("string"!==typeof e)throw new Error("marked(): input parameter is of type "+Object.prototype.toString.call(e)+", string expected");if(n||"function"===typeof t){n||(n=t,t=null),t=m({},v.defaults,t||{});var i,a,o=t.highlight,s=0;try{i=r.lex(e,t)}catch(e){return n(e)}a=i.length;var u=function(e){if(e)return t.highlight=o,n(e);var r;try{r=c.parse(i,t)}catch(t){e=t}return t.highlight=o,e?n(e):n(null,r)};if(!o||o.length<3)return u();if(delete t.highlight,!a)return u();for(;s<i.length;s++)(function(e){"code"!==e.type?--a||u():o(e.text,e.lang,function(t,n){return t?u(t):null==n||n===e.text?--a||u():(e.text=n,e.escaped=!0,void(--a||u()))})})(i[s])}else try{return t&&(t=m({},v.defaults,t)),c.parse(r.lex(e,t),t)}catch(e){if(e.message+="\nPlease report this to https://github.com/markedjs/marked.",(t||v.defaults).silent)return"<p>An error occurred:</p><pre>"+l(e.message+"",!0)+"</pre>";throw e}}h.exec=h,v.options=v.setOptions=function(e){return m(v.defaults,e),v},v.getDefaults=function(){return{baseUrl:null,breaks:!1,gfm:!0,headerIds:!0,headerPrefix:"",highlight:null,langPrefix:"language-",mangle:!0,pedantic:!1,renderer:new o,sanitize:!1,sanitizer:null,silent:!1,smartLists:!1,smartypants:!1,tables:!0,xhtml:!1}},v.defaults=v.getDefaults(),v.Parser=c,v.parser=c.parse,v.Renderer=o,v.TextRenderer=s,v.Lexer=r,v.lexer=r.lex,v.InlineLexer=a,v.inlineLexer=a.output,v.parse=v,e.exports=v})(this||"undefined"!==typeof window&&window)}).call(this,n("c8ba"))},"11e9":function(e,t,n){var r=n("52a7"),i=n("4630"),a=n("6821"),o=n("6a99"),s=n("69a8"),c=n("c69a"),l=Object.getOwnPropertyDescriptor;t.f=n("9e1e")?l:function(e,t){if(e=a(e),t=o(t,!0),c)try{return l(e,t)}catch(e){}if(s(e,t))return i(!r.f.call(e,t),e[t])}},1495:function(e,t,n){var r=n("86cc"),i=n("cb7c"),a=n("0d58");e.exports=n("9e1e")?Object.defineProperties:function(e,t){i(e);var n,o=a(t),s=o.length,c=0;while(s>c)r.f(e,n=o[c++],t[n]);return e}},1846:function(e,t){e.exports=function(e){var t="[\\w-]+",n="("+t+"|@{"+t+"})",r=[],i=[],a=function(e){return{className:"string",begin:"~?"+e+".*?"+e}},o=function(e,t,n){return{className:e,begin:t,relevance:n}},s={begin:"\\(",end:"\\)",contains:i,relevance:0};i.push(e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,a("'"),a('"'),e.CSS_NUMBER_MODE,{begin:"(url|data-uri)\\(",starts:{className:"string",end:"[\\)\\n]",excludeEnd:!0}},o("number","#[0-9A-Fa-f]+\\b"),s,o("variable","@@?"+t,10),o("variable","@{"+t+"}"),o("built_in","~?`[^`]*?`"),{className:"attribute",begin:t+"\\s*:",end:":",returnBegin:!0,excludeEnd:!0},{className:"meta",begin:"!important"});var c=i.concat({begin:"{",end:"}",contains:r}),l={beginKeywords:"when",endsWithParent:!0,contains:[{beginKeywords:"and not"}].concat(i)},u={begin:n+"\\s*:",returnBegin:!0,end:"[;}]",relevance:0,contains:[{className:"attribute",begin:n,end:":",excludeEnd:!0,starts:{endsWithParent:!0,illegal:"[<=$]",relevance:0,contains:i}}]},d={className:"keyword",begin:"@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",starts:{end:"[;{}]",returnEnd:!0,contains:i,relevance:0}},p={className:"variable",variants:[{begin:"@"+t+"\\s*:",relevance:15},{begin:"@"+t}],starts:{end:"[;}]",returnEnd:!0,contains:c}},f={variants:[{begin:"[\\.#:&\\[>]",end:"[;{}]"},{begin:n,end:"{"}],returnBegin:!0,returnEnd:!0,illegal:"[<='$\"]",relevance:0,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,l,o("keyword","all\\b"),o("variable","@{"+t+"}"),o("selector-tag",n+"%?",0),o("selector-id","#"+n),o("selector-class","\\."+n,0),o("selector-tag","&",0),{className:"selector-attr",begin:"\\[",end:"\\]"},{className:"selector-pseudo",begin:/:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},{begin:"\\(",end:"\\)",contains:c},{begin:"!important"}]};return r.push(e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,d,p,u,f),{case_insensitive:!0,illegal:"[=>'/<($\"]",contains:r}}},1991:function(e,t,n){var r,i,a,o=n("9b43"),s=n("31f4"),c=n("fab2"),l=n("230e"),u=n("7726"),d=u.process,p=u.setImmediate,f=u.clearImmediate,g=u.MessageChannel,h=u.Dispatch,m=0,b={},v="onreadystatechange",_=function(){var e=+this;if(b.hasOwnProperty(e)){var t=b[e];delete b[e],t()}},y=function(e){_.call(e.data)};p&&f||(p=function(e){var t=[],n=1;while(arguments.length>n)t.push(arguments[n++]);return b[++m]=function(){s("function"==typeof e?e:Function(e),t)},r(m),m},f=function(e){delete b[e]},"process"==n("2d95")(d)?r=function(e){d.nextTick(o(_,e,1))}:h&&h.now?r=function(e){h.now(o(_,e,1))}:g?(i=new g,a=i.port2,i.port1.onmessage=y,r=o(a.postMessage,a,1)):u.addEventListener&&"function"==typeof postMessage&&!u.importScripts?(r=function(e){u.postMessage(e+"","*")},u.addEventListener("message",y,!1)):r=v in l("script")?function(e){c.appendChild(l("script"))[v]=function(){c.removeChild(this),_.call(e)}}:function(e){setTimeout(o(_,e,1),0)}),e.exports={set:p,clear:f}},"1b3b":function(e,t,n){var r=n("cc5d");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var i=n("499e").default;i("7d62a38e",r,!0,{sourceMap:!1,shadowMode:!1})},"1d2b":function(e,t,n){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},"1eb2":function(e,t,n){var r;"undefined"!==typeof window&&((r=window.document.currentScript)&&(r=r.src.match(/(.+\/)[^/]+\.js$/))&&(n.p=r[1]))},"1fa8":function(e,t,n){var r=n("cb7c");e.exports=function(e,t,n,i){try{return i?t(r(n)[0],n[1]):t(n)}catch(t){var a=e["return"];throw void 0!==a&&r(a.call(e)),t}}},"230e":function(e,t,n){var r=n("d3f4"),i=n("7726").document,a=r(i)&&r(i.createElement);e.exports=function(e){return a?i.createElement(e):{}}},2350:function(e,t){function n(e,t){var n=e[1]||"",i=e[3];if(!i)return n;if(t&&"function"===typeof btoa){var a=r(i),o=i.sources.map(function(e){return"/*# sourceURL="+i.sourceRoot+e+" */"});return[n].concat(o).concat([a]).join("\n")}return[n].join("\n")}function r(e){var t=btoa(unescape(encodeURIComponent(JSON.stringify(e)))),n="sourceMappingURL=data:application/json;charset=utf-8;base64,"+t;return"/*# "+n+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"===typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var a=this[i][0];"number"===typeof a&&(r[a]=!0)}for(i=0;i<e.length;i++){var o=e[i];"number"===typeof o[0]&&r[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),t.push(o))}},t}},"23c6":function(e,t,n){var r=n("2d95"),i=n("2b4c")("toStringTag"),a="Arguments"==r(function(){return arguments}()),o=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,s;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=o(t=Object(e),i))?n:a?r(t):"Object"==(s=r(t))&&"function"==typeof t.callee?"Arguments":s}},2444:function(e,t,n){"use strict";(function(t){var r=n("c532"),i=n("c8af"),a={"Content-Type":"application/x-www-form-urlencoded"};function o(e,t){!r.isUndefined(e)&&r.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}function s(){var e;return"undefined"!==typeof XMLHttpRequest?e=n("b50d"):"undefined"!==typeof t&&(e=n("b50d")),e}var c={adapter:s(),transformRequest:[function(e,t){return i(t,"Content-Type"),r.isFormData(e)||r.isArrayBuffer(e)||r.isBuffer(e)||r.isStream(e)||r.isFile(e)||r.isBlob(e)?e:r.isArrayBufferView(e)?e.buffer:r.isURLSearchParams(e)?(o(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):r.isObject(e)?(o(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"===typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(e){return e>=200&&e<300},headers:{common:{Accept:"application/json, text/plain, */*"}}};r.forEach(["delete","get","head"],function(e){c.headers[e]={}}),r.forEach(["post","put","patch"],function(e){c.headers[e]=r.merge(a)}),e.exports=c}).call(this,n("4362"))},2621:function(e,t){t.f=Object.getOwnPropertySymbols},"27ee":function(e,t,n){var r=n("23c6"),i=n("2b4c")("iterator"),a=n("84f2");e.exports=n("8378").getIteratorMethod=function(e){if(void 0!=e)return e[i]||e["@@iterator"]||a[r(e)]}},2907:function(e,t){e.exports=function(e){var t={begin:"\\$+[a-zA-Z_-ÿ][a-zA-Z0-9_-ÿ]*"},n={className:"meta",begin:/<\?(php)?|\?>/},r={className:"string",contains:[e.BACKSLASH_ESCAPE,n],variants:[{begin:'b"',end:'"'},{begin:"b'",end:"'"},e.inherit(e.APOS_STRING_MODE,{illegal:null}),e.inherit(e.QUOTE_STRING_MODE,{illegal:null})]},i={variants:[e.BINARY_NUMBER_MODE,e.C_NUMBER_MODE]};return{aliases:["php3","php4","php5","php6"],case_insensitive:!0,keywords:"and include_once list abstract global private echo interface as static endswitch array null if endwhile or const for endforeach self var while isset public protected exit foreach throw elseif include __FILE__ empty require_once do xor return parent clone use __CLASS__ __LINE__ else break print eval new catch __METHOD__ case exception default die require __FUNCTION__ enddeclare final try switch continue endfor endif declare unset true false trait goto instanceof insteadof __DIR__ __NAMESPACE__ yield finally",contains:[e.HASH_COMMENT_MODE,e.COMMENT("//","$",{contains:[n]}),e.COMMENT("/\\*","\\*/",{contains:[{className:"doctag",begin:"@[A-Za-z]+"}]}),e.COMMENT("__halt_compiler.+?;",!1,{endsWithParent:!0,keywords:"__halt_compiler",lexemes:e.UNDERSCORE_IDENT_RE}),{className:"string",begin:/<<<['"]?\w+['"]?$/,end:/^\w+;?$/,contains:[e.BACKSLASH_ESCAPE,{className:"subst",variants:[{begin:/\$\w+/},{begin:/\{\$/,end:/\}/}]}]},n,{className:"keyword",begin:/\$this\b/},t,{begin:/(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/},{className:"function",beginKeywords:"function",end:/[;{]/,excludeEnd:!0,illegal:"\\$|\\[|%",contains:[e.UNDERSCORE_TITLE_MODE,{className:"params",begin:"\\(",end:"\\)",contains:["self",t,e.C_BLOCK_COMMENT_MODE,r,i]}]},{className:"class",beginKeywords:"class interface",end:"{",excludeEnd:!0,illegal:/[:\(\$"]/,contains:[{beginKeywords:"extends implements"},e.UNDERSCORE_TITLE_MODE]},{beginKeywords:"namespace",end:";",illegal:/[\.']/,contains:[e.UNDERSCORE_TITLE_MODE]},{beginKeywords:"use",end:";",contains:[e.UNDERSCORE_TITLE_MODE]},{begin:"=>"},r,i]}}},"2a93":function(e,t){e.exports=function(e){var t={className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[{begin:"'''",end:"'''",relevance:10},{begin:'"""',end:'"""',relevance:10},{begin:'"',end:'"'},{begin:"'",end:"'"}]};return{aliases:["toml"],case_insensitive:!0,illegal:/\S/,contains:[e.COMMENT(";","$"),e.HASH_COMMENT_MODE,{className:"section",begin:/^\s*\[+/,end:/\]+/},{begin:/^[a-z0-9\[\]_-]+\s*=\s*/,end:"$",returnBegin:!0,contains:[{className:"attr",begin:/[a-z0-9\[\]_-]+/},{begin:/=/,endsWithParent:!0,relevance:0,contains:[{className:"literal",begin:/\bon|off|true|false|yes|no\b/},{className:"variable",variants:[{begin:/\$[\w\d"][\w\d_]*/},{begin:/\$\{(.*?)}/}]},t,{className:"number",begin:/([\+\-]+)?[\d]+_[\d_]+/},e.NUMBER_MODE]}]}]}}},"2aba":function(e,t,n){var r=n("7726"),i=n("32e9"),a=n("69a8"),o=n("ca5a")("src"),s="toString",c=Function[s],l=(""+c).split(s);n("8378").inspectSource=function(e){return c.call(e)},(e.exports=function(e,t,n,s){var c="function"==typeof n;c&&(a(n,"name")||i(n,"name",t)),e[t]!==n&&(c&&(a(n,o)||i(n,o,e[t]?""+e[t]:l.join(String(t)))),e===r?e[t]=n:s?e[t]?e[t]=n:i(e,t,n):(delete e[t],i(e,t,n)))})(Function.prototype,s,function(){return"function"==typeof this&&this[o]||c.call(this)})},"2aeb":function(e,t,n){var r=n("cb7c"),i=n("1495"),a=n("e11e"),o=n("613b")("IE_PROTO"),s=function(){},c="prototype",l=function(){var e,t=n("230e")("iframe"),r=a.length,i="<",o=">";t.style.display="none",n("fab2").appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write(i+"script"+o+"document.F=Object"+i+"/script"+o),e.close(),l=e.F;while(r--)delete l[c][a[r]];return l()};e.exports=Object.create||function(e,t){var n;return null!==e?(s[c]=r(e),n=new s,s[c]=null,n[o]=e):n=l(),void 0===t?n:i(n,t)}},"2b4c":function(e,t,n){var r=n("5537")("wks"),i=n("ca5a"),a=n("7726").Symbol,o="function"==typeof a,s=e.exports=function(e){return r[e]||(r[e]=o&&a[e]||(o?a:i)("Symbol."+e))};s.store=r},"2d00":function(e,t){e.exports=!1},"2d83":function(e,t,n){"use strict";var r=n("387f");e.exports=function(e,t,n,i,a){var o=new Error(e);return r(o,t,n,i,a)}},"2d95":function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},"2e67":function(e,t,n){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},"2e7b":function(e,t){e.exports=function(e){var t="true false yes no null",n="^[ \\-]*",r="[a-zA-Z_][\\w\\-]*",i={className:"attr",variants:[{begin:n+r+":"},{begin:n+'"'+r+'":'},{begin:n+"'"+r+"':"}]},a={className:"template-variable",variants:[{begin:"{{",end:"}}"},{begin:"%{",end:"}"}]},o={className:"string",relevance:0,variants:[{begin:/'/,end:/'/},{begin:/"/,end:/"/},{begin:/\S+/}],contains:[e.BACKSLASH_ESCAPE,a]};return{case_insensitive:!0,aliases:["yml","YAML","yaml"],contains:[i,{className:"meta",begin:"^---s*$",relevance:10},{className:"string",begin:"[\\|>] *$",returnEnd:!0,contains:o.contains,end:i.variants[0].begin},{begin:"<%[%=-]?",end:"[%-]?%>",subLanguage:"ruby",excludeBegin:!0,excludeEnd:!0,relevance:0},{className:"type",begin:"!!"+e.UNDERSCORE_IDENT_RE},{className:"meta",begin:"&"+e.UNDERSCORE_IDENT_RE+"$"},{className:"meta",begin:"\\*"+e.UNDERSCORE_IDENT_RE+"$"},{className:"bullet",begin:"^ *-",relevance:0},e.HASH_COMMENT_MODE,{beginKeywords:t,keywords:{literal:t}},e.C_NUMBER_MODE,o]}}},"30b5":function(e,t,n){"use strict";var r=n("c532");function i(e){return encodeURIComponent(e).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}e.exports=function(e,t,n){if(!t)return e;var a;if(n)a=n(t);else if(r.isURLSearchParams(t))a=t.toString();else{var o=[];r.forEach(t,function(e,t){null!==e&&"undefined"!==typeof e&&(r.isArray(e)?t+="[]":e=[e],r.forEach(e,function(e){r.isDate(e)?e=e.toISOString():r.isObject(e)&&(e=JSON.stringify(e)),o.push(i(t)+"="+i(e))}))}),a=o.join("&")}return a&&(e+=(-1===e.indexOf("?")?"?":"&")+a),e}},"31f4":function(e,t){e.exports=function(e,t,n){var r=void 0===n;switch(t.length){case 0:return r?e():e.call(n);case 1:return r?e(t[0]):e.call(n,t[0]);case 2:return r?e(t[0],t[1]):e.call(n,t[0],t[1]);case 3:return r?e(t[0],t[1],t[2]):e.call(n,t[0],t[1],t[2]);case 4:return r?e(t[0],t[1],t[2],t[3]):e.call(n,t[0],t[1],t[2],t[3])}return e.apply(n,t)}},"32e9":function(e,t,n){var r=n("86cc"),i=n("4630");e.exports=n("9e1e")?function(e,t,n){return r.f(e,t,i(1,n))}:function(e,t,n){return e[t]=n,e}},"332f":function(e,t){e.exports=function(e){var t="[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*",n=t+"(<"+t+"(\\s*,\\s*"+t+")*>)?",r="false synchronized int abstract float private char boolean static null if const for true while long strictfp finally protected import native final void enum else break transient catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private module requires exports do",i="\\b(0[bB]([01]+[01_]+[01]+|[01]+)|0[xX]([a-fA-F0-9]+[a-fA-F0-9_]+[a-fA-F0-9]+|[a-fA-F0-9]+)|(([\\d]+[\\d_]+[\\d]+|[\\d]+)(\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))?|\\.([\\d]+[\\d_]+[\\d]+|[\\d]+))([eE][-+]?\\d+)?)[lLfF]?",a={className:"number",begin:i,relevance:0};return{aliases:["jsp"],keywords:r,illegal:/<\/|#/,contains:[e.COMMENT("/\\*\\*","\\*/",{relevance:0,contains:[{begin:/\w+@/,relevance:0},{className:"doctag",begin:"@[A-Za-z]+"}]}),e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"class",beginKeywords:"class interface",end:/[{;=]/,excludeEnd:!0,keywords:"class interface",illegal:/[:"\[\]]/,contains:[{beginKeywords:"extends implements"},e.UNDERSCORE_TITLE_MODE]},{beginKeywords:"new throw return else",relevance:0},{className:"function",begin:"("+n+"\\s+)+"+e.UNDERSCORE_IDENT_RE+"\\s*\\(",returnBegin:!0,end:/[{;=]/,excludeEnd:!0,keywords:r,contains:[{begin:e.UNDERSCORE_IDENT_RE+"\\s*\\(",returnBegin:!0,relevance:0,contains:[e.UNDERSCORE_TITLE_MODE]},{className:"params",begin:/\(/,end:/\)/,keywords:r,relevance:0,contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]},a,{className:"meta",begin:"@[A-Za-z]+"}]}}},"33a4":function(e,t,n){var r=n("84f2"),i=n("2b4c")("iterator"),a=Array.prototype;e.exports=function(e){return void 0!==e&&(r.Array===e||a[i]===e)}},3846:function(e,t,n){n("9e1e")&&"g"!=/./g.flags&&n("86cc").f(RegExp.prototype,"flags",{configurable:!0,get:n("0bfb")})},"387f":function(e,t,n){"use strict";e.exports=function(e,t,n,r,i){return e.config=t,n&&(e.code=n),e.request=r,e.response=i,e}},"38fd":function(e,t,n){var r=n("69a8"),i=n("4bf8"),a=n("613b")("IE_PROTO"),o=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=i(e),r(e,a)?e[a]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?o:null}},3934:function(e,t,n){"use strict";var r=n("c532");e.exports=r.isStandardBrowserEnv()?function(){var e,t=/(msie|trident)/i.test(navigator.userAgent),n=document.createElement("a");function i(e){var r=e;return t&&(n.setAttribute("href",r),r=n.href),n.setAttribute("href",r),{href:n.href,protocol:n.protocol?n.protocol.replace(/:$/,""):"",host:n.host,search:n.search?n.search.replace(/^\?/,""):"",hash:n.hash?n.hash.replace(/^#/,""):"",hostname:n.hostname,port:n.port,pathname:"/"===n.pathname.charAt(0)?n.pathname:"/"+n.pathname}}return e=i(window.location.href),function(t){var n=r.isString(t)?i(t):t;return n.protocol===e.protocol&&n.host===e.host}}():function(){return function(){return!0}}()},"3d53":function(e,t,n){var r=n("4e29");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var i=n("499e").default;i("53ee4149",r,!0,{sourceMap:!1,shadowMode:!1})},"41a0":function(e,t,n){"use strict";var r=n("2aeb"),i=n("4630"),a=n("7f20"),o={};n("32e9")(o,n("2b4c")("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(o,{next:i(1,n)}),a(e,t+" Iterator")}},4362:function(e,t,n){t.nextTick=function(e){setTimeout(e,0)},t.platform=t.arch=t.execPath=t.title="browser",t.pid=1,t.browser=!0,t.env={},t.argv=[],t.binding=function(e){throw new Error("No such module. (Possibly not yet loaded)")},function(){var e,r="/";t.cwd=function(){return r},t.chdir=function(t){e||(e=n("df7c")),r=e.resolve(t,r)}}(),t.exit=t.kill=t.umask=t.dlopen=t.uptime=t.memoryUsage=t.uvCounters=function(){},t.features={}},"456d":function(e,t,n){var r=n("4bf8"),i=n("0d58");n("5eda")("keys",function(){return function(e){return i(r(e))}})},4588:function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},4630:function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},"467f":function(e,t,n){"use strict";var r=n("2d83");e.exports=function(e,t,n){var i=n.config.validateStatus;n.status&&i&&!i(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},"499e":function(e,t,n){"use strict";function r(e,t){for(var n=[],r={},i=0;i<t.length;i++){var a=t[i],o=a[0],s=a[1],c=a[2],l=a[3],u={id:e+":"+i,css:s,media:c,sourceMap:l};r[o]?r[o].parts.push(u):n.push(r[o]={id:o,parts:[u]})}return n}n.r(t),n.d(t,"default",function(){return g});var i="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var a={},o=i&&(document.head||document.getElementsByTagName("head")[0]),s=null,c=0,l=!1,u=function(){},d=null,p="data-vue-ssr-id",f="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function g(e,t,n,i){l=n,d=i||{};var o=r(e,t);return h(o),function(t){for(var n=[],i=0;i<o.length;i++){var s=o[i],c=a[s.id];c.refs--,n.push(c)}t?(o=r(e,t),h(o)):o=[];for(i=0;i<n.length;i++){c=n[i];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete a[c.id]}}}}function h(e){for(var t=0;t<e.length;t++){var n=e[t],r=a[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(b(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{var o=[];for(i=0;i<n.parts.length;i++)o.push(b(n.parts[i]));a[n.id]={id:n.id,refs:1,parts:o}}}}function m(){var e=document.createElement("style");return e.type="text/css",o.appendChild(e),e}function b(e){var t,n,r=document.querySelector("style["+p+'~="'+e.id+'"]');if(r){if(l)return u;r.parentNode.removeChild(r)}if(f){var i=c++;r=s||(s=m()),t=_.bind(null,r,i,!1),n=_.bind(null,r,i,!0)}else r=m(),t=y.bind(null,r),n=function(){r.parentNode.removeChild(r)};return t(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;t(e=r)}else n()}}var v=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}();function _(e,t,n,r){var i=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=v(t,i);else{var a=document.createTextNode(i),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(a,o[t]):e.appendChild(a)}}function y(e,t){var n=t.css,r=t.media,i=t.sourceMap;if(r&&e.setAttribute("media",r),d.ssrId&&e.setAttribute(p,t.id),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{while(e.firstChild)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}},"4a59":function(e,t,n){var r=n("9b43"),i=n("1fa8"),a=n("33a4"),o=n("cb7c"),s=n("9def"),c=n("27ee"),l={},u={};t=e.exports=function(e,t,n,d,p){var f,g,h,m,b=p?function(){return e}:c(e),v=r(n,d,t?2:1),_=0;if("function"!=typeof b)throw TypeError(e+" is not iterable!");if(a(b)){for(f=s(e.length);f>_;_++)if(m=t?v(o(g=e[_])[0],g[1]):v(e[_]),m===l||m===u)return m}else for(h=b.call(e);!(g=h.next()).done;)if(m=i(h,v,g.value,t),m===l||m===u)return m};t.BREAK=l,t.RETURN=u},"4bf8":function(e,t,n){var r=n("be13");e.exports=function(e){return Object(r(e))}},"4dd1":function(e,t){e.exports=function(e){var t="[A-Za-z$_][0-9A-Za-z$_]*",n={keyword:"in of if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await static import from as",literal:"true false null undefined NaN Infinity",built_in:"eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Promise"},r={className:"number",variants:[{begin:"\\b(0[bB][01]+)"},{begin:"\\b(0[oO][0-7]+)"},{begin:e.C_NUMBER_RE}],relevance:0},i={className:"subst",begin:"\\$\\{",end:"\\}",keywords:n,contains:[]},a={className:"string",begin:"`",end:"`",contains:[e.BACKSLASH_ESCAPE,i]};i.contains=[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,a,r,e.REGEXP_MODE];var o=i.contains.concat([e.C_BLOCK_COMMENT_MODE,e.C_LINE_COMMENT_MODE]);return{aliases:["js","jsx"],keywords:n,contains:[{className:"meta",relevance:10,begin:/^\s*['"]use (strict|asm)['"]/},{className:"meta",begin:/^#!/,end:/$/},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,a,e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,r,{begin:/[{,]\s*/,relevance:0,contains:[{begin:t+"\\s*:",returnBegin:!0,relevance:0,contains:[{className:"attr",begin:t,relevance:0}]}]},{begin:"("+e.RE_STARTERS_RE+"|\\b(case|return|throw)\\b)\\s*",keywords:"return throw case",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.REGEXP_MODE,{className:"function",begin:"(\\(.*?\\)|"+t+")\\s*=>",returnBegin:!0,end:"\\s*=>",contains:[{className:"params",variants:[{begin:t},{begin:/\(\s*\)/},{begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,keywords:n,contains:o}]}]},{begin:/</,end:/(\/\w+|\w+\/)>/,subLanguage:"xml",contains:[{begin:/<\w+\s*\/>/,skip:!0},{begin:/<\w+/,end:/(\/\w+|\w+\/)>/,skip:!0,contains:[{begin:/<\w+\s*\/>/,skip:!0},"self"]}]}],relevance:0},{className:"function",beginKeywords:"function",end:/\{/,excludeEnd:!0,contains:[e.inherit(e.TITLE_MODE,{begin:t}),{className:"params",begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,contains:o}],illegal:/\[|%/},{begin:/\$[(.]/},e.METHOD_GUARD,{className:"class",beginKeywords:"class",end:/[{;=]/,excludeEnd:!0,illegal:/[:"\[\]]/,contains:[{beginKeywords:"extends"},e.UNDERSCORE_TITLE_MODE]},{beginKeywords:"constructor",end:/\{/,excludeEnd:!0}],illegal:/#(?!!)/}}},"4e29":function(e,t,n){t=e.exports=n("2350")(!1),t.push([e.i,"\n.root[data-v-78671096] {\n  height: 100%;\n}\n",""])},"508e":function(e,t){e.exports=function(e){var t={begin:"`[\\s\\S]",relevance:0},n={className:"variable",variants:[{begin:/\$[\w\d][\w\d_:]*/}]},r={className:"literal",begin:/\$(null|true|false)\b/},i={className:"string",variants:[{begin:/"/,end:/"/},{begin:/@"/,end:/^"@/}],contains:[t,n,{className:"variable",begin:/\$[A-z]/,end:/[^A-z]/}]},a={className:"string",variants:[{begin:/'/,end:/'/},{begin:/@'/,end:/^'@/}]},o={className:"doctag",variants:[{begin:/\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/},{begin:/\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/}]},s=e.inherit(e.COMMENT(null,null),{variants:[{begin:/#/,end:/$/},{begin:/<#/,end:/#>/}],contains:[o]});return{aliases:["ps"],lexemes:/-?[A-z\.\-]+/,case_insensitive:!0,keywords:{keyword:"if else foreach return function do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch",built_in:"Add-Computer Add-Content Add-History Add-JobTrigger Add-Member Add-PSSnapin Add-Type Checkpoint-Computer Clear-Content Clear-EventLog Clear-History Clear-Host Clear-Item Clear-ItemProperty Clear-Variable Compare-Object Complete-Transaction Connect-PSSession Connect-WSMan Convert-Path ConvertFrom-Csv ConvertFrom-Json ConvertFrom-SecureString ConvertFrom-StringData ConvertTo-Csv ConvertTo-Html ConvertTo-Json ConvertTo-SecureString ConvertTo-Xml Copy-Item Copy-ItemProperty Debug-Process Disable-ComputerRestore Disable-JobTrigger Disable-PSBreakpoint Disable-PSRemoting Disable-PSSessionConfiguration Disable-WSManCredSSP Disconnect-PSSession Disconnect-WSMan Disable-ScheduledJob Enable-ComputerRestore Enable-JobTrigger Enable-PSBreakpoint Enable-PSRemoting Enable-PSSessionConfiguration Enable-ScheduledJob Enable-WSManCredSSP Enter-PSSession Exit-PSSession Export-Alias Export-Clixml Export-Console Export-Counter Export-Csv Export-FormatData Export-ModuleMember Export-PSSession ForEach-Object Format-Custom Format-List Format-Table Format-Wide Get-Acl Get-Alias Get-AuthenticodeSignature Get-ChildItem Get-Command Get-ComputerRestorePoint Get-Content Get-ControlPanelItem Get-Counter Get-Credential Get-Culture Get-Date Get-Event Get-EventLog Get-EventSubscriber Get-ExecutionPolicy Get-FormatData Get-Host Get-HotFix Get-Help Get-History Get-IseSnippet Get-Item Get-ItemProperty Get-Job Get-JobTrigger Get-Location Get-Member Get-Module Get-PfxCertificate Get-Process Get-PSBreakpoint Get-PSCallStack Get-PSDrive Get-PSProvider Get-PSSession Get-PSSessionConfiguration Get-PSSnapin Get-Random Get-ScheduledJob Get-ScheduledJobOption Get-Service Get-TraceSource Get-Transaction Get-TypeData Get-UICulture Get-Unique Get-Variable Get-Verb Get-WinEvent Get-WmiObject Get-WSManCredSSP Get-WSManInstance Group-Object Import-Alias Import-Clixml Import-Counter Import-Csv Import-IseSnippet Import-LocalizedData Import-PSSession Import-Module Invoke-AsWorkflow Invoke-Command Invoke-Expression Invoke-History Invoke-Item Invoke-RestMethod Invoke-WebRequest Invoke-WmiMethod Invoke-WSManAction Join-Path Limit-EventLog Measure-Command Measure-Object Move-Item Move-ItemProperty New-Alias New-Event New-EventLog New-IseSnippet New-Item New-ItemProperty New-JobTrigger New-Object New-Module New-ModuleManifest New-PSDrive New-PSSession New-PSSessionConfigurationFile New-PSSessionOption New-PSTransportOption New-PSWorkflowExecutionOption New-PSWorkflowSession New-ScheduledJobOption New-Service New-TimeSpan New-Variable New-WebServiceProxy New-WinEvent New-WSManInstance New-WSManSessionOption Out-Default Out-File Out-GridView Out-Host Out-Null Out-Printer Out-String Pop-Location Push-Location Read-Host Receive-Job Register-EngineEvent Register-ObjectEvent Register-PSSessionConfiguration Register-ScheduledJob Register-WmiEvent Remove-Computer Remove-Event Remove-EventLog Remove-Item Remove-ItemProperty Remove-Job Remove-JobTrigger Remove-Module Remove-PSBreakpoint Remove-PSDrive Remove-PSSession Remove-PSSnapin Remove-TypeData Remove-Variable Remove-WmiObject Remove-WSManInstance Rename-Computer Rename-Item Rename-ItemProperty Reset-ComputerMachinePassword Resolve-Path Restart-Computer Restart-Service Restore-Computer Resume-Job Resume-Service Save-Help Select-Object Select-String Select-Xml Send-MailMessage Set-Acl Set-Alias Set-AuthenticodeSignature Set-Content Set-Date Set-ExecutionPolicy Set-Item Set-ItemProperty Set-JobTrigger Set-Location Set-PSBreakpoint Set-PSDebug Set-PSSessionConfiguration Set-ScheduledJob Set-ScheduledJobOption Set-Service Set-StrictMode Set-TraceSource Set-Variable Set-WmiInstance Set-WSManInstance Set-WSManQuickConfig Show-Command Show-ControlPanelItem Show-EventLog Sort-Object Split-Path Start-Job Start-Process Start-Service Start-Sleep Start-Transaction Start-Transcript Stop-Computer Stop-Job Stop-Process Stop-Service Stop-Transcript Suspend-Job Suspend-Service Tee-Object Test-ComputerSecureChannel Test-Connection Test-ModuleManifest Test-Path Test-PSSessionConfigurationFile Trace-Command Unblock-File Undo-Transaction Unregister-Event Unregister-PSSessionConfiguration Unregister-ScheduledJob Update-FormatData Update-Help Update-List Update-TypeData Use-Transaction Wait-Event Wait-Job Wait-Process Where-Object Write-Debug Write-Error Write-EventLog Write-Host Write-Output Write-Progress Write-Verbose Write-Warning Add-MDTPersistentDrive Disable-MDTMonitorService Enable-MDTMonitorService Get-MDTDeploymentShareStatistics Get-MDTMonitorData Get-MDTOperatingSystemCatalog Get-MDTPersistentDrive Import-MDTApplication Import-MDTDriver Import-MDTOperatingSystem Import-MDTPackage Import-MDTTaskSequence New-MDTDatabase Remove-MDTMonitorData Remove-MDTPersistentDrive Restore-MDTPersistentDrive Set-MDTMonitorData Test-MDTDeploymentShare Test-MDTMonitorData Update-MDTDatabaseSchema Update-MDTDeploymentShare Update-MDTLinkedDS Update-MDTMedia Update-MDTMedia Add-VamtProductKey Export-VamtData Find-VamtManagedMachine Get-VamtConfirmationId Get-VamtProduct Get-VamtProductKey Import-VamtData Initialize-VamtData Install-VamtConfirmationId Install-VamtProductActivation Install-VamtProductKey Update-VamtProduct",nomarkup:"-ne -eq -lt -gt -ge -le -not -like -notlike -match -notmatch -contains -notcontains -in -notin -replace"},contains:[t,e.NUMBER_MODE,i,a,r,n,s]}}},5270:function(e,t,n){"use strict";var r=n("c532"),i=n("c401"),a=n("2e67"),o=n("2444"),s=n("d925"),c=n("e683");function l(e){e.cancelToken&&e.cancelToken.throwIfRequested()}e.exports=function(e){l(e),e.baseURL&&!s(e.url)&&(e.url=c(e.baseURL,e.url)),e.headers=e.headers||{},e.data=i(e.data,e.headers,e.transformRequest),e.headers=r.merge(e.headers.common||{},e.headers[e.method]||{},e.headers||{}),r.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]});var t=e.adapter||o.adapter;return t(e).then(function(t){return l(e),t.data=i(t.data,t.headers,e.transformResponse),t},function(t){return a(t)||(l(e),t&&t.response&&(t.response.data=i(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},"52a7":function(e,t){t.f={}.propertyIsEnumerable},"551c":function(e,t,n){"use strict";var r,i,a,o,s=n("2d00"),c=n("7726"),l=n("9b43"),u=n("23c6"),d=n("5ca1"),p=n("d3f4"),f=n("d8e8"),g=n("f605"),h=n("4a59"),m=n("ebd6"),b=n("1991").set,v=n("8079")(),_=n("a5b8"),y=n("9c80"),x=n("a25f"),w=n("bcaa"),E="Promise",S=c.TypeError,k=c.process,N=k&&k.versions,C=N&&N.v8||"",M=c[E],O="process"==u(k),T=function(){},R=i=_.f,A=!!function(){try{var e=M.resolve(1),t=(e.constructor={})[n("2b4c")("species")]=function(e){e(T,T)};return(O||"function"==typeof PromiseRejectionEvent)&&e.then(T)instanceof t&&0!==C.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(e){}}(),D=function(e){var t;return!(!p(e)||"function"!=typeof(t=e.then))&&t},L=function(e,t){if(!e._n){e._n=!0;var n=e._c;v(function(){var r=e._v,i=1==e._s,a=0,o=function(t){var n,a,o,s=i?t.ok:t.fail,c=t.resolve,l=t.reject,u=t.domain;try{s?(i||(2==e._h&&j(e),e._h=1),!0===s?n=r:(u&&u.enter(),n=s(r),u&&(u.exit(),o=!0)),n===t.promise?l(S("Promise-chain cycle")):(a=D(n))?a.call(n,c,l):c(n)):l(r)}catch(e){u&&!o&&u.exit(),l(e)}};while(n.length>a)o(n[a++]);e._c=[],e._n=!1,t&&!e._h&&I(e)})}},I=function(e){b.call(c,function(){var t,n,r,i=e._v,a=P(e);if(a&&(t=y(function(){O?k.emit("unhandledRejection",i,e):(n=c.onunhandledrejection)?n({promise:e,reason:i}):(r=c.console)&&r.error&&r.error("Unhandled promise rejection",i)}),e._h=O||P(e)?2:1),e._a=void 0,a&&t.e)throw t.v})},P=function(e){return 1!==e._h&&0===(e._a||e._c).length},j=function(e){b.call(c,function(){var t;O?k.emit("rejectionHandled",e):(t=c.onrejectionhandled)&&t({promise:e,reason:e._v})})},B=function(e){var t=this;t._d||(t._d=!0,t=t._w||t,t._v=e,t._s=2,t._a||(t._a=t._c.slice()),L(t,!0))},U=function(e){var t,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===e)throw S("Promise can't be resolved itself");(t=D(e))?v(function(){var r={_w:n,_d:!1};try{t.call(e,l(U,r,1),l(B,r,1))}catch(e){B.call(r,e)}}):(n._v=e,n._s=1,L(n,!1))}catch(e){B.call({_w:n,_d:!1},e)}}};A||(M=function(e){g(this,M,E,"_h"),f(e),r.call(this);try{e(l(U,this,1),l(B,this,1))}catch(e){B.call(this,e)}},r=function(e){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=n("dcbc")(M.prototype,{then:function(e,t){var n=R(m(this,M));return n.ok="function"!=typeof e||e,n.fail="function"==typeof t&&t,n.domain=O?k.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&L(this,!1),n.promise},catch:function(e){return this.then(void 0,e)}}),a=function(){var e=new r;this.promise=e,this.resolve=l(U,e,1),this.reject=l(B,e,1)},_.f=R=function(e){return e===M||e===o?new a(e):i(e)}),d(d.G+d.W+d.F*!A,{Promise:M}),n("7f20")(M,E),n("7a56")(E),o=n("8378")[E],d(d.S+d.F*!A,E,{reject:function(e){var t=R(this),n=t.reject;return n(e),t.promise}}),d(d.S+d.F*(s||!A),E,{resolve:function(e){return w(s&&this===o?M:this,e)}}),d(d.S+d.F*!(A&&n("5cc5")(function(e){M.all(e)["catch"](T)})),E,{all:function(e){var t=this,n=R(t),r=n.resolve,i=n.reject,a=y(function(){var n=[],a=0,o=1;h(e,!1,function(e){var s=a++,c=!1;n.push(void 0),o++,t.resolve(e).then(function(e){c||(c=!0,n[s]=e,--o||r(n))},i)}),--o||r(n)});return a.e&&i(a.v),n.promise},race:function(e){var t=this,n=R(t),r=n.reject,i=y(function(){h(e,!1,function(e){t.resolve(e).then(n.resolve,r)})});return i.e&&r(i.v),n.promise}})},5537:function(e,t,n){var r=n("8378"),i=n("7726"),a="__core-js_shared__",o=i[a]||(i[a]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:r.version,mode:n("2d00")?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},"5ad2":function(e,t){e.exports=function(e){var t={literal:"true false null"},n=[e.QUOTE_STRING_MODE,e.C_NUMBER_MODE],r={end:",",endsWithParent:!0,excludeEnd:!0,contains:n,keywords:t},i={begin:"{",end:"}",contains:[{className:"attr",begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE],illegal:"\\n"},e.inherit(r,{begin:/:/})],illegal:"\\S"},a={begin:"\\[",end:"\\]",contains:[e.inherit(r)],illegal:"\\S"};return n.splice(n.length,0,i,a),{contains:n,keywords:t,illegal:"\\S"}}},"5ca1":function(e,t,n){var r=n("7726"),i=n("8378"),a=n("32e9"),o=n("2aba"),s=n("9b43"),c="prototype",l=function(e,t,n){var u,d,p,f,g=e&l.F,h=e&l.G,m=e&l.S,b=e&l.P,v=e&l.B,_=h?r:m?r[t]||(r[t]={}):(r[t]||{})[c],y=h?i:i[t]||(i[t]={}),x=y[c]||(y[c]={});for(u in h&&(n=t),n)d=!g&&_&&void 0!==_[u],p=(d?_:n)[u],f=v&&d?s(p,r):b&&"function"==typeof p?s(Function.call,p):p,_&&o(_,u,p,e&l.U),y[u]!=p&&a(y,u,f),b&&x[u]!=p&&(x[u]=p)};r.core=i,l.F=1,l.G=2,l.S=4,l.P=8,l.B=16,l.W=32,l.U=64,l.R=128,e.exports=l},"5cc5":function(e,t,n){var r=n("2b4c")("iterator"),i=!1;try{var a=[7][r]();a["return"]=function(){i=!0},Array.from(a,function(){throw 2})}catch(e){}e.exports=function(e,t){if(!t&&!i)return!1;var n=!1;try{var a=[7],o=a[r]();o.next=function(){return{done:n=!0}},a[r]=function(){return o},e(a)}catch(e){}return n}},"5dbc":function(e,t,n){var r=n("d3f4"),i=n("8b97").set;e.exports=function(e,t,n){var a,o=t.constructor;return o!==n&&"function"==typeof o&&(a=o.prototype)!==n.prototype&&r(a)&&i&&i(e,a),e}},"5eda":function(e,t,n){var r=n("5ca1"),i=n("8378"),a=n("79e5");e.exports=function(e,t){var n=(i.Object||{})[e]||Object[e],o={};o[e]=t(n),r(r.S+r.F*a(function(){n(1)}),"Object",o)}},6113:function(e,t){e.exports=function(e){var t="[a-zA-Z-][a-zA-Z0-9_-]*",n={className:"variable",begin:"(\\$"+t+")\\b"},r={className:"number",begin:"#[0-9A-Fa-f]+"};e.CSS_NUMBER_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,e.C_BLOCK_COMMENT_MODE;return{case_insensitive:!0,illegal:"[=/|']",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"selector-id",begin:"\\#[A-Za-z0-9_-]+",relevance:0},{className:"selector-class",begin:"\\.[A-Za-z0-9_-]+",relevance:0},{className:"selector-attr",begin:"\\[",end:"\\]",illegal:"$"},{className:"selector-tag",begin:"\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b",relevance:0},{begin:":(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)"},{begin:"::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)"},n,{className:"attribute",begin:"\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b",illegal:"[^\\s]"},{begin:"\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b"},{begin:":",end:";",contains:[n,r,e.CSS_NUMBER_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,{className:"meta",begin:"!important"}]},{begin:"@",end:"[{;]",keywords:"mixin include extend for if else each while charset import debug media page content font-face namespace warn",contains:[n,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,r,e.CSS_NUMBER_MODE,{begin:"\\s[A-Za-z0-9_.-]+",relevance:0}]}]}}},"613b":function(e,t,n){var r=n("5537")("keys"),i=n("ca5a");e.exports=function(e){return r[e]||(r[e]=i(e))}},"626a":function(e,t,n){var r=n("2d95");e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},"66a3":function(e,t,n){"use strict";var r=n("3d53"),i=n.n(r);i.a},6821:function(e,t,n){var r=n("626a"),i=n("be13");e.exports=function(e){return r(i(e))}},"69a8":function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},"6a99":function(e,t,n){var r=n("d3f4");e.exports=function(e,t){if(!r(e))return e;var n,i;if(t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;if("function"==typeof(n=e.valueOf)&&!r(i=n.call(e)))return i;if(!t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},"6b54":function(e,t,n){"use strict";n("3846");var r=n("cb7c"),i=n("0bfb"),a=n("9e1e"),o="toString",s=/./[o],c=function(e){n("2aba")(RegExp.prototype,o,e,!0)};n("79e5")(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?c(function(){var e=r(this);return"/".concat(e.source,"/","flags"in e?e.flags:!a&&e instanceof RegExp?i.call(e):void 0)}):s.name!=o&&c(function(){return s.call(this)})},7333:function(e,t,n){"use strict";var r=n("0d58"),i=n("2621"),a=n("52a7"),o=n("4bf8"),s=n("626a"),c=Object.assign;e.exports=!c||n("79e5")(function(){var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach(function(e){t[e]=e}),7!=c({},e)[n]||Object.keys(c({},t)).join("")!=r})?function(e,t){var n=o(e),c=arguments.length,l=1,u=i.f,d=a.f;while(c>l){var p,f=s(arguments[l++]),g=u?r(f).concat(u(f)):r(f),h=g.length,m=0;while(h>m)d.call(f,p=g[m++])&&(n[p]=f[p])}return n}:c},7726:function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},"77f1":function(e,t,n){var r=n("4588"),i=Math.max,a=Math.min;e.exports=function(e,t){return e=r(e),e<0?i(e+t,0):a(e,t)}},"79e5":function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},"7a56":function(e,t,n){"use strict";var r=n("7726"),i=n("86cc"),a=n("9e1e"),o=n("2b4c")("species");e.exports=function(e){var t=r[e];a&&t&&!t[o]&&i.f(t,o,{configurable:!0,get:function(){return this}})}},"7a77":function(e,t,n){"use strict";function r(e){this.message=e}r.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},r.prototype.__CANCEL__=!0,e.exports=r},"7aac":function(e,t,n){"use strict";var r=n("c532");e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,i,a,o){var s=[];s.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&s.push("expires="+new Date(n).toGMTString()),r.isString(i)&&s.push("path="+i),r.isString(a)&&s.push("domain="+a),!0===o&&s.push("secure"),document.cookie=s.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},"7f20":function(e,t,n){var r=n("86cc").f,i=n("69a8"),a=n("2b4c")("toStringTag");e.exports=function(e,t,n){e&&!i(e=n?e:e.prototype,a)&&r(e,a,{configurable:!0,value:t})}},"7f7f":function(e,t,n){var r=n("86cc").f,i=Function.prototype,a=/^\s*function ([^ (]*)/,o="name";o in i||n("9e1e")&&r(i,o,{configurable:!0,get:function(){try{return(""+this).match(a)[1]}catch(e){return""}}})},8079:function(e,t,n){var r=n("7726"),i=n("1991").set,a=r.MutationObserver||r.WebKitMutationObserver,o=r.process,s=r.Promise,c="process"==n("2d95")(o);e.exports=function(){var e,t,n,l=function(){var r,i;c&&(r=o.domain)&&r.exit();while(e){i=e.fn,e=e.next;try{i()}catch(r){throw e?n():t=void 0,r}}t=void 0,r&&r.enter()};if(c)n=function(){o.nextTick(l)};else if(!a||r.navigator&&r.navigator.standalone)if(s&&s.resolve){var u=s.resolve(void 0);n=function(){u.then(l)}}else n=function(){i.call(r,l)};else{var d=!0,p=document.createTextNode("");new a(l).observe(p,{characterData:!0}),n=function(){p.data=d=!d}}return function(r){var i={fn:r,next:void 0};t&&(t.next=i),e||(e=i,n()),t=i}}},8378:function(e,t){var n=e.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},"84f2":function(e,t){e.exports={}},"86cc":function(e,t,n){var r=n("cb7c"),i=n("c69a"),a=n("6a99"),o=Object.defineProperty;t.f=n("9e1e")?Object.defineProperty:function(e,t,n){if(r(e),t=a(t,!0),r(n),i)try{return o(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},"8b97":function(e,t,n){var r=n("d3f4"),i=n("cb7c"),a=function(e,t){if(i(e),!r(t)&&null!==t)throw TypeError(t+": can't set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=n("9b43")(Function.call,n("11e9").f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return a(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):void 0),check:a}},"8dcb":function(e,t){e.exports=function(e){var t="[A-Za-z0-9\\._:-]+",n={endsWithParent:!0,illegal:/</,relevance:0,contains:[{className:"attr",begin:t,relevance:0},{begin:/=\s*/,relevance:0,contains:[{className:"string",endsParent:!0,variants:[{begin:/"/,end:/"/},{begin:/'/,end:/'/},{begin:/[^\s"'=<>`]+/}]}]}]};return{aliases:["html","xhtml","rss","atom","xjb","xsd","xsl","plist"],case_insensitive:!0,contains:[{className:"meta",begin:"<!DOCTYPE",end:">",relevance:10,contains:[{begin:"\\[",end:"\\]"}]},e.COMMENT("\x3c!--","--\x3e",{relevance:10}),{begin:"<\\!\\[CDATA\\[",end:"\\]\\]>",relevance:10},{begin:/<\?(php)?/,end:/\?>/,subLanguage:"php",contains:[{begin:"/\\*",end:"\\*/",skip:!0}]},{className:"tag",begin:"<style(?=\\s|>|$)",end:">",keywords:{name:"style"},contains:[n],starts:{end:"</style>",returnEnd:!0,subLanguage:["css","xml"]}},{className:"tag",begin:"<script(?=\\s|>|$)",end:">",keywords:{name:"script"},contains:[n],starts:{end:"<\/script>",returnEnd:!0,subLanguage:["actionscript","javascript","handlebars","xml"]}},{className:"meta",variants:[{begin:/<\?xml/,end:/\?>/,relevance:10},{begin:/<\?\w+/,end:/\?>/}]},{className:"tag",begin:"</?",end:"/?>",contains:[{className:"name",begin:/[^\/><\s]+/,relevance:0},n]}]}}},"8df4":function(e,t,n){"use strict";var r=n("7a77");function i(e){if("function"!==typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new r(e),t(n.reason))})}i.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},i.source=function(){var e,t=new i(function(t){e=t});return{token:t,cancel:e}},e.exports=i},9093:function(e,t,n){var r=n("ce10"),i=n("e11e").concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,i)}},9510:function(e,t){e.exports=function(e){var t={keyword:"and elif is global as in if from raise for except finally print import pass return exec else break not with class assert yield try while continue del or def lambda async await nonlocal|10 None True False",built_in:"Ellipsis NotImplemented"},n={className:"meta",begin:/^(>>>|\.\.\.) /},r={className:"subst",begin:/\{/,end:/\}/,keywords:t,illegal:/#/},i={className:"string",contains:[e.BACKSLASH_ESCAPE],variants:[{begin:/(u|b)?r?'''/,end:/'''/,contains:[n],relevance:10},{begin:/(u|b)?r?"""/,end:/"""/,contains:[n],relevance:10},{begin:/(fr|rf|f)'''/,end:/'''/,contains:[n,r]},{begin:/(fr|rf|f)"""/,end:/"""/,contains:[n,r]},{begin:/(u|r|ur)'/,end:/'/,relevance:10},{begin:/(u|r|ur)"/,end:/"/,relevance:10},{begin:/(b|br)'/,end:/'/},{begin:/(b|br)"/,end:/"/},{begin:/(fr|rf|f)'/,end:/'/,contains:[r]},{begin:/(fr|rf|f)"/,end:/"/,contains:[r]},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]},a={className:"number",relevance:0,variants:[{begin:e.BINARY_NUMBER_RE+"[lLjJ]?"},{begin:"\\b(0o[0-7]+)[lLjJ]?"},{begin:e.C_NUMBER_RE+"[lLjJ]?"}]},o={className:"params",begin:/\(/,end:/\)/,contains:["self",n,a,i]};return r.contains=[i,a,n],{aliases:["py","gyp"],keywords:t,illegal:/(<\/|->|\?)|=>/,contains:[n,a,i,e.HASH_COMMENT_MODE,{variants:[{className:"function",beginKeywords:"def"},{className:"class",beginKeywords:"class"}],end:/:/,illegal:/[${=;\n,]/,contains:[e.UNDERSCORE_TITLE_MODE,o,{begin:/->/,endsWithParent:!0,keywords:"None"}]},{className:"meta",begin:/^[\t ]*@/,end:/$/},{begin:/\b(print|exec)\(/}]}}},"9b43":function(e,t,n){var r=n("d8e8");e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,i){return e.call(t,n,r,i)}}return function(){return e.apply(t,arguments)}}},"9c6c":function(e,t,n){var r=n("2b4c")("unscopables"),i=Array.prototype;void 0==i[r]&&n("32e9")(i,r,{}),e.exports=function(e){i[r][e]=!0}},"9c80":function(e,t){e.exports=function(e){try{return{e:!1,v:e()}}catch(e){return{e:!0,v:e}}}},"9def":function(e,t,n){var r=n("4588"),i=Math.min;e.exports=function(e){return e>0?i(r(e),9007199254740991):0}},"9e1e":function(e,t,n){e.exports=!n("79e5")(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},"9fa6":function(e,t,n){"use strict";var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function i(){this.message="String contains an invalid character"}function a(e){for(var t,n,a=String(e),o="",s=0,c=r;a.charAt(0|s)||(c="=",s%1);o+=c.charAt(63&t>>8-s%1*8)){if(n=a.charCodeAt(s+=.75),n>255)throw new i;t=t<<8|n}return o}i.prototype=new Error,i.prototype.code=5,i.prototype.name="InvalidCharacterError",e.exports=a},a25f:function(e,t,n){var r=n("7726"),i=r.navigator;e.exports=i&&i.userAgent||""},a5b8:function(e,t,n){"use strict";var r=n("d8e8");function i(e){var t,n;this.promise=new e(function(e,r){if(void 0!==t||void 0!==n)throw TypeError("Bad Promise constructor");t=e,n=r}),this.resolve=r(t),this.reject=r(n)}e.exports.f=function(e){return new i(e)}},a70e:function(e,t,n){(function(e){"object"===typeof window&&window||"object"===typeof self&&self;e(t)})(function(e){var t=[],n=Object.keys,r={},i={},a=/^(no-?highlight|plain|text)$/i,o=/\blang(?:uage)?-([\w-]+)\b/i,s=/((^(<[^>]+>|\t|)+|(?:\n)))/gm,c="</span>",l={classPrefix:"hljs-",tabReplace:null,useBR:!1,languages:void 0};function u(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function d(e){return e.nodeName.toLowerCase()}function p(e,t){var n=e&&e.exec(t);return n&&0===n.index}function f(e){return a.test(e)}function g(e){var t,n,r,i,a=e.className+" ";if(a+=e.parentNode?e.parentNode.className:"",n=o.exec(a),n)return T(n[1])?n[1]:"no-highlight";for(a=a.split(/\s+/),t=0,r=a.length;t<r;t++)if(i=a[t],f(i)||T(i))return i}function h(e){var t,n={},r=Array.prototype.slice.call(arguments,1);for(t in e)n[t]=e[t];return r.forEach(function(e){for(t in e)n[t]=e[t]}),n}function m(e){var t=[];return function e(n,r){for(var i=n.firstChild;i;i=i.nextSibling)3===i.nodeType?r+=i.nodeValue.length:1===i.nodeType&&(t.push({event:"start",offset:r,node:i}),r=e(i,r),d(i).match(/br|hr|img|input/)||t.push({event:"stop",offset:r,node:i}));return r}(e,0),t}function b(e,n,r){var i=0,a="",o=[];function s(){return e.length&&n.length?e[0].offset!==n[0].offset?e[0].offset<n[0].offset?e:n:"start"===n[0].event?e:n:e.length?e:n}function c(e){function n(e){return" "+e.nodeName+'="'+u(e.value).replace('"',"&quot;")+'"'}a+="<"+d(e)+t.map.call(e.attributes,n).join("")+">"}function l(e){a+="</"+d(e)+">"}function p(e){("start"===e.event?c:l)(e.node)}while(e.length||n.length){var f=s();if(a+=u(r.substring(i,f[0].offset)),i=f[0].offset,f===e){o.reverse().forEach(l);do{p(f.splice(0,1)[0]),f=s()}while(f===e&&f.length&&f[0].offset===i);o.reverse().forEach(c)}else"start"===f[0].event?o.push(f[0].node):o.pop(),p(f.splice(0,1)[0])}return a+u(r.substr(i))}function v(e){return e.variants&&!e.cached_variants&&(e.cached_variants=e.variants.map(function(t){return h(e,{variants:null},t)})),e.cached_variants||e.endsWithParent&&[h(e)]||[e]}function _(e){function t(e){return e&&e.source||e}function r(n,r){return new RegExp(t(n),"m"+(e.case_insensitive?"i":"")+(r?"g":""))}function i(a,o){if(!a.compiled){if(a.compiled=!0,a.keywords=a.keywords||a.beginKeywords,a.keywords){var s={},c=function(t,n){e.case_insensitive&&(n=n.toLowerCase()),n.split(" ").forEach(function(e){var n=e.split("|");s[n[0]]=[t,n[1]?Number(n[1]):1]})};"string"===typeof a.keywords?c("keyword",a.keywords):n(a.keywords).forEach(function(e){c(e,a.keywords[e])}),a.keywords=s}a.lexemesRe=r(a.lexemes||/\w+/,!0),o&&(a.beginKeywords&&(a.begin="\\b("+a.beginKeywords.split(" ").join("|")+")\\b"),a.begin||(a.begin=/\B|\b/),a.beginRe=r(a.begin),a.end||a.endsWithParent||(a.end=/\B|\b/),a.end&&(a.endRe=r(a.end)),a.terminator_end=t(a.end)||"",a.endsWithParent&&o.terminator_end&&(a.terminator_end+=(a.end?"|":"")+o.terminator_end)),a.illegal&&(a.illegalRe=r(a.illegal)),null==a.relevance&&(a.relevance=1),a.contains||(a.contains=[]),a.contains=Array.prototype.concat.apply([],a.contains.map(function(e){return v("self"===e?a:e)})),a.contains.forEach(function(e){i(e,a)}),a.starts&&i(a.starts,o);var l=a.contains.map(function(e){return e.beginKeywords?"\\.?("+e.begin+")\\.?":e.begin}).concat([a.terminator_end,a.illegal]).map(t).filter(Boolean);a.terminators=l.length?r(l.join("|"),!0):{exec:function(){return null}}}}i(e)}function y(e,t,n,i){function a(e,t){var n,r;for(n=0,r=t.contains.length;n<r;n++)if(p(t.contains[n].beginRe,e))return t.contains[n]}function o(e,t){if(p(e.endRe,t)){while(e.endsParent&&e.parent)e=e.parent;return e}if(e.endsWithParent)return o(e.parent,t)}function s(e,t){return!n&&p(t.illegalRe,e)}function d(e,t){var n=w.case_insensitive?t[0].toLowerCase():t[0];return e.keywords.hasOwnProperty(n)&&e.keywords[n]}function f(e,t,n,r){var i=r?"":l.classPrefix,a='<span class="'+i,o=n?"":c;return a+=e+'">',a+t+o}function g(){var e,t,n,r;if(!S.keywords)return u(C);r="",t=0,S.lexemesRe.lastIndex=0,n=S.lexemesRe.exec(C);while(n)r+=u(C.substring(t,n.index)),e=d(S,n),e?(M+=e[1],r+=f(e[0],u(n[0]))):r+=u(n[0]),t=S.lexemesRe.lastIndex,n=S.lexemesRe.exec(C);return r+u(C.substr(t))}function h(){var e="string"===typeof S.subLanguage;if(e&&!r[S.subLanguage])return u(C);var t=e?y(S.subLanguage,C,!0,k[S.subLanguage]):x(C,S.subLanguage.length?S.subLanguage:void 0);return S.relevance>0&&(M+=t.relevance),e&&(k[S.subLanguage]=t.top),f(t.language,t.value,!1,!0)}function m(){N+=null!=S.subLanguage?h():g(),C=""}function b(e){N+=e.className?f(e.className,"",!0):"",S=Object.create(e,{parent:{value:S}})}function v(e,t){if(C+=e,null==t)return m(),0;var n=a(t,S);if(n)return n.skip?C+=t:(n.excludeBegin&&(C+=t),m(),n.returnBegin||n.excludeBegin||(C=t)),b(n,t),n.returnBegin?0:t.length;var r=o(S,t);if(r){var i=S;i.skip?C+=t:(i.returnEnd||i.excludeEnd||(C+=t),m(),i.excludeEnd&&(C=t));do{S.className&&(N+=c),S.skip||(M+=S.relevance),S=S.parent}while(S!==r.parent);return r.starts&&b(r.starts,""),i.returnEnd?0:t.length}if(s(t,S))throw new Error('Illegal lexeme "'+t+'" for mode "'+(S.className||"<unnamed>")+'"');return C+=t,t.length||1}var w=T(e);if(!w)throw new Error('Unknown language: "'+e+'"');_(w);var E,S=i||w,k={},N="";for(E=S;E!==w;E=E.parent)E.className&&(N=f(E.className,"",!0)+N);var C="",M=0;try{var O,R,A=0;while(1){if(S.terminators.lastIndex=A,O=S.terminators.exec(t),!O)break;R=v(t.substring(A,O.index),O[0]),A=O.index+R}for(v(t.substr(A)),E=S;E.parent;E=E.parent)E.className&&(N+=c);return{relevance:M,value:N,language:e,top:S}}catch(e){if(e.message&&-1!==e.message.indexOf("Illegal"))return{relevance:0,value:u(t)};throw e}}function x(e,t){t=t||l.languages||n(r);var i={relevance:0,value:u(e)},a=i;return t.filter(T).forEach(function(t){var n=y(t,e,!1);n.language=t,n.relevance>a.relevance&&(a=n),n.relevance>i.relevance&&(a=i,i=n)}),a.language&&(i.second_best=a),i}function w(e){return l.tabReplace||l.useBR?e.replace(s,function(e,t){return l.useBR&&"\n"===e?"<br>":l.tabReplace?t.replace(/\t/g,l.tabReplace):""}):e}function E(e,t,n){var r=t?i[t]:n,a=[e.trim()];return e.match(/\bhljs\b/)||a.push("hljs"),-1===e.indexOf(r)&&a.push(r),a.join(" ").trim()}function S(e){var t,n,r,i,a,o=g(e);f(o)||(l.useBR?(t=document.createElementNS("http://www.w3.org/1999/xhtml","div"),t.innerHTML=e.innerHTML.replace(/\n/g,"").replace(/<br[ \/]*>/g,"\n")):t=e,a=t.textContent,r=o?y(o,a,!0):x(a),n=m(t),n.length&&(i=document.createElementNS("http://www.w3.org/1999/xhtml","div"),i.innerHTML=r.value,r.value=b(n,m(i),a)),r.value=w(r.value),e.innerHTML=r.value,e.className=E(e.className,o,r.language),e.result={language:r.language,re:r.relevance},r.second_best&&(e.second_best={language:r.second_best.language,re:r.second_best.relevance}))}function k(e){l=h(l,e)}function N(){if(!N.called){N.called=!0;var e=document.querySelectorAll("pre code");t.forEach.call(e,S)}}function C(){addEventListener("DOMContentLoaded",N,!1),addEventListener("load",N,!1)}function M(t,n){var a=r[t]=n(e);a.aliases&&a.aliases.forEach(function(e){i[e]=t})}function O(){return n(r)}function T(e){return e=(e||"").toLowerCase(),r[e]||r[i[e]]}return e.highlight=y,e.highlightAuto=x,e.fixMarkup=w,e.highlightBlock=S,e.configure=k,e.initHighlighting=N,e.initHighlightingOnLoad=C,e.registerLanguage=M,e.listLanguages=O,e.getLanguage=T,e.inherit=h,e.IDENT_RE="[a-zA-Z]\\w*",e.UNDERSCORE_IDENT_RE="[a-zA-Z_]\\w*",e.NUMBER_RE="\\b\\d+(\\.\\d+)?",e.C_NUMBER_RE="(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",e.BINARY_NUMBER_RE="\\b(0b[01]+)",e.RE_STARTERS_RE="!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",e.BACKSLASH_ESCAPE={begin:"\\\\[\\s\\S]",relevance:0},e.APOS_STRING_MODE={className:"string",begin:"'",end:"'",illegal:"\\n",contains:[e.BACKSLASH_ESCAPE]},e.QUOTE_STRING_MODE={className:"string",begin:'"',end:'"',illegal:"\\n",contains:[e.BACKSLASH_ESCAPE]},e.PHRASAL_WORDS_MODE={begin:/\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/},e.COMMENT=function(t,n,r){var i=e.inherit({className:"comment",begin:t,end:n,contains:[]},r||{});return i.contains.push(e.PHRASAL_WORDS_MODE),i.contains.push({className:"doctag",begin:"(?:TODO|FIXME|NOTE|BUG|XXX):",relevance:0}),i},e.C_LINE_COMMENT_MODE=e.COMMENT("//","$"),e.C_BLOCK_COMMENT_MODE=e.COMMENT("/\\*","\\*/"),e.HASH_COMMENT_MODE=e.COMMENT("#","$"),e.NUMBER_MODE={className:"number",begin:e.NUMBER_RE,relevance:0},e.C_NUMBER_MODE={className:"number",begin:e.C_NUMBER_RE,relevance:0},e.BINARY_NUMBER_MODE={className:"number",begin:e.BINARY_NUMBER_RE,relevance:0},e.CSS_NUMBER_MODE={className:"number",begin:e.NUMBER_RE+"(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",relevance:0},e.REGEXP_MODE={className:"regexp",begin:/\//,end:/\/[gimuy]*/,illegal:/\n/,contains:[e.BACKSLASH_ESCAPE,{begin:/\[/,end:/\]/,relevance:0,contains:[e.BACKSLASH_ESCAPE]}]},e.TITLE_MODE={className:"title",begin:e.IDENT_RE,relevance:0},e.UNDERSCORE_TITLE_MODE={className:"title",begin:e.UNDERSCORE_IDENT_RE,relevance:0},e.METHOD_GUARD={begin:"\\.\\s*"+e.UNDERSCORE_IDENT_RE,relevance:0},e})},aa0f:function(e,t,n){"use strict";var r=n("e4bc"),i=n.n(r);i.a},aa77:function(e,t,n){var r=n("5ca1"),i=n("be13"),a=n("79e5"),o=n("fdef"),s="["+o+"]",c="​",l=RegExp("^"+s+s+"*"),u=RegExp(s+s+"*$"),d=function(e,t,n){var i={},s=a(function(){return!!o[e]()||c[e]()!=c}),l=i[e]=s?t(p):o[e];n&&(i[n]=l),r(r.P+r.F*s,"String",i)},p=d.trim=function(e,t){return e=String(i(e)),1&t&&(e=e.replace(l,"")),2&t&&(e=e.replace(u,"")),e};e.exports=d},ac6a:function(e,t,n){for(var r=n("cadf"),i=n("0d58"),a=n("2aba"),o=n("7726"),s=n("32e9"),c=n("84f2"),l=n("2b4c"),u=l("iterator"),d=l("toStringTag"),p=c.Array,f={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},g=i(f),h=0;h<g.length;h++){var m,b=g[h],v=f[b],_=o[b],y=_&&_.prototype;if(y&&(y[u]||s(y,u,p),y[d]||s(y,d,b),c[b]=p,v))for(m in r)y[m]||a(y,m,r[m],!0)}},acb3:function(e,t,n){t=e.exports=n("2350")(!1),t.push([e.i,"\n.vm-markdown-html[data-v-4cf456b0] {\n  padding: 15px;\n  overflow: auto;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  word-wrap: break-word;\n}\n.vm-markdown-html ul[data-v-4cf456b0] {\n  margin: 10px 20px;\n  list-style-type: square;\n  padding: 0;\n}\n.vm-markdown-html ol[data-v-4cf456b0] {\n  margin: 10px 20px;\n  list-style-type: decimal;\n  padding: 0;\n}\n.vm-markdown-html li[data-v-4cf456b0] {\n  display: list-item;\n  padding: 0;\n}\n.vm-markdown-html hr[data-v-4cf456b0] {\n  margin: 15px 0;\n  border-top: 1px solid #eeeff1;\n}\n.vm-markdown-html pre[data-v-4cf456b0] {\n  display: block;\n  margin: 10px 0;\n  padding: 8px;\n  border-radius: 4px;\n  background-color: #f2f2f2;\n  color: #656565;\n  font-size: 14px;\n}\n.vm-markdown-html blockquote[data-v-4cf456b0] {\n  display: block;\n  border-left: 4px solid #ddd;\n  margin: 15px 0;\n  padding: 0 15px;\n}\n.vm-markdown-html img[data-v-4cf456b0] {\n  margin: 20px 0;\n}\n.vm-markdown-html a[data-v-4cf456b0] {\n  color: #41b883;\n}\n.vm-markdown-html table[data-v-4cf456b0] {\n  border: 1px solid #eee;\n  border-collapse: collapse;\n}\n.vm-markdown-html tr[data-v-4cf456b0] {\n  border: 1px solid #eee;\n}\n.vm-markdown-html th[data-v-4cf456b0] {\n  padding: 8px 30px;\n  border-right: 1px solid #eee;\n  background-color: #f2f2f2;\n}\n.vm-markdown-html td[data-v-4cf456b0] {\n  padding: 8px 30px;\n  border-right: 1px solid #eee;\n}\n.vm-markdown-html code[data-v-4cf456b0] {\n  background-color: #fbfbfb;\n}\n",""])},af44:function(e,t){e.exports=function(e){var t={keyword:"in if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const class public private protected get set super static implements enum export import declare type namespace abstract as from extends async await",literal:"true false null undefined NaN Infinity",built_in:"eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document any number boolean string void Promise"};return{aliases:["ts"],keywords:t,contains:[{className:"meta",begin:/^\s*['"]use strict['"]/},e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,{className:"string",begin:"`",end:"`",contains:[e.BACKSLASH_ESCAPE,{className:"subst",begin:"\\$\\{",end:"\\}"}]},e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,{className:"number",variants:[{begin:"\\b(0[bB][01]+)"},{begin:"\\b(0[oO][0-7]+)"},{begin:e.C_NUMBER_RE}],relevance:0},{begin:"("+e.RE_STARTERS_RE+"|\\b(case|return|throw)\\b)\\s*",keywords:"return throw case",contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE,e.REGEXP_MODE,{className:"function",begin:"(\\(.*?\\)|"+e.IDENT_RE+")\\s*=>",returnBegin:!0,end:"\\s*=>",contains:[{className:"params",variants:[{begin:e.IDENT_RE},{begin:/\(\s*\)/},{begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,keywords:t,contains:["self",e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE]}]}]}],relevance:0},{className:"function",begin:"function",end:/[\{;]/,excludeEnd:!0,keywords:t,contains:["self",e.inherit(e.TITLE_MODE,{begin:/[A-Za-z$_][0-9A-Za-z$_]*/}),{className:"params",begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,keywords:t,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE],illegal:/["'\(]/}],illegal:/%/,relevance:0},{beginKeywords:"constructor",end:/\{/,excludeEnd:!0,contains:["self",{className:"params",begin:/\(/,end:/\)/,excludeBegin:!0,excludeEnd:!0,keywords:t,contains:[e.C_LINE_COMMENT_MODE,e.C_BLOCK_COMMENT_MODE],illegal:/["'\(]/}]},{begin:/module\./,keywords:{built_in:"module"},relevance:0},{beginKeywords:"module",end:/\{/,excludeEnd:!0},{beginKeywords:"interface",end:/\{/,excludeEnd:!0,keywords:"interface extends"},{begin:/\$[(.]/},{begin:"\\."+e.IDENT_RE,relevance:0},{className:"meta",begin:"@[A-Za-z]+"}]}}},b50d:function(e,t,n){"use strict";var r=n("c532"),i=n("467f"),a=n("30b5"),o=n("c345"),s=n("3934"),c=n("2d83"),l="undefined"!==typeof window&&window.btoa&&window.btoa.bind(window)||n("9fa6");e.exports=function(e){return new Promise(function(t,u){var d=e.data,p=e.headers;r.isFormData(d)&&delete p["Content-Type"];var f=new XMLHttpRequest,g="onreadystatechange",h=!1;if("undefined"===typeof window||!window.XDomainRequest||"withCredentials"in f||s(e.url)||(f=new window.XDomainRequest,g="onload",h=!0,f.onprogress=function(){},f.ontimeout=function(){}),e.auth){var m=e.auth.username||"",b=e.auth.password||"";p.Authorization="Basic "+l(m+":"+b)}if(f.open(e.method.toUpperCase(),a(e.url,e.params,e.paramsSerializer),!0),f.timeout=e.timeout,f[g]=function(){if(f&&(4===f.readyState||h)&&(0!==f.status||f.responseURL&&0===f.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in f?o(f.getAllResponseHeaders()):null,r=e.responseType&&"text"!==e.responseType?f.response:f.responseText,a={data:r,status:1223===f.status?204:f.status,statusText:1223===f.status?"No Content":f.statusText,headers:n,config:e,request:f};i(t,u,a),f=null}},f.onerror=function(){u(c("Network Error",e,null,f)),f=null},f.ontimeout=function(){u(c("timeout of "+e.timeout+"ms exceeded",e,"ECONNABORTED",f)),f=null},r.isStandardBrowserEnv()){var v=n("7aac"),_=(e.withCredentials||s(e.url))&&e.xsrfCookieName?v.read(e.xsrfCookieName):void 0;_&&(p[e.xsrfHeaderName]=_)}if("setRequestHeader"in f&&r.forEach(p,function(e,t){"undefined"===typeof d&&"content-type"===t.toLowerCase()?delete p[t]:f.setRequestHeader(t,e)}),e.withCredentials&&(f.withCredentials=!0),e.responseType)try{f.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"===typeof e.onDownloadProgress&&f.addEventListener("progress",e.onDownloadProgress),"function"===typeof e.onUploadProgress&&f.upload&&f.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){f&&(f.abort(),u(e),f=null)}),void 0===d&&(d=null),f.send(d)})}},b65b:function(e,t){e.exports=function(e){return{aliases:["console"],contains:[{className:"meta",begin:"^\\s{0,3}[\\w\\d\\[\\]()@-]*[>%$#]",starts:{end:"$",subLanguage:"bash"}}]}}},bc3a:function(e,t,n){e.exports=n("cee4")},bcaa:function(e,t,n){var r=n("cb7c"),i=n("d3f4"),a=n("a5b8");e.exports=function(e,t){if(r(e),i(t)&&t.constructor===e)return t;var n=a.f(e),o=n.resolve;return o(t),n.promise}},be13:function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},c345:function(e,t,n){"use strict";var r=n("c532"),i=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,a,o={};return e?(r.forEach(e.split("\n"),function(e){if(a=e.indexOf(":"),t=r.trim(e.substr(0,a)).toLowerCase(),n=r.trim(e.substr(a+1)),t){if(o[t]&&i.indexOf(t)>=0)return;o[t]="set-cookie"===t?(o[t]?o[t]:[]).concat([n]):o[t]?o[t]+", "+n:n}}),o):o}},c366:function(e,t,n){var r=n("6821"),i=n("9def"),a=n("77f1");e.exports=function(e){return function(t,n,o){var s,c=r(t),l=i(c.length),u=a(o,l);if(e&&n!=n){while(l>u)if(s=c[u++],s!=s)return!0}else for(;l>u;u++)if((e||u in c)&&c[u]===n)return e||u||0;return!e&&-1}}},c401:function(e,t,n){"use strict";var r=n("c532");e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},c532:function(e,t,n){"use strict";var r=n("1d2b"),i=n("044b"),a=Object.prototype.toString;function o(e){return"[object Array]"===a.call(e)}function s(e){return"[object ArrayBuffer]"===a.call(e)}function c(e){return"undefined"!==typeof FormData&&e instanceof FormData}function l(e){var t;return t="undefined"!==typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer,t}function u(e){return"string"===typeof e}function d(e){return"number"===typeof e}function p(e){return"undefined"===typeof e}function f(e){return null!==e&&"object"===typeof e}function g(e){return"[object Date]"===a.call(e)}function h(e){return"[object File]"===a.call(e)}function m(e){return"[object Blob]"===a.call(e)}function b(e){return"[object Function]"===a.call(e)}function v(e){return f(e)&&b(e.pipe)}function _(e){return"undefined"!==typeof URLSearchParams&&e instanceof URLSearchParams}function y(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function x(){return("undefined"===typeof navigator||"ReactNative"!==navigator.product)&&("undefined"!==typeof window&&"undefined"!==typeof document)}function w(e,t){if(null!==e&&"undefined"!==typeof e)if("object"!==typeof e&&(e=[e]),o(e))for(var n=0,r=e.length;n<r;n++)t.call(null,e[n],n,e);else for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.call(null,e[i],i,e)}function E(){var e={};function t(t,n){"object"===typeof e[n]&&"object"===typeof t?e[n]=E(e[n],t):e[n]=t}for(var n=0,r=arguments.length;n<r;n++)w(arguments[n],t);return e}function S(e,t,n){return w(t,function(t,i){e[i]=n&&"function"===typeof t?r(t,n):t}),e}e.exports={isArray:o,isArrayBuffer:s,isBuffer:i,isFormData:c,isArrayBufferView:l,isString:u,isNumber:d,isObject:f,isUndefined:p,isDate:g,isFile:h,isBlob:m,isFunction:b,isStream:v,isURLSearchParams:_,isStandardBrowserEnv:x,forEach:w,merge:E,extend:S,trim:y}},c5f6:function(e,t,n){"use strict";var r=n("7726"),i=n("69a8"),a=n("2d95"),o=n("5dbc"),s=n("6a99"),c=n("79e5"),l=n("9093").f,u=n("11e9").f,d=n("86cc").f,p=n("aa77").trim,f="Number",g=r[f],h=g,m=g.prototype,b=a(n("2aeb")(m))==f,v="trim"in String.prototype,_=function(e){var t=s(e,!1);if("string"==typeof t&&t.length>2){t=v?t.trim():p(t,3);var n,r,i,a=t.charCodeAt(0);if(43===a||45===a){if(n=t.charCodeAt(2),88===n||120===n)return NaN}else if(48===a){switch(t.charCodeAt(1)){case 66:case 98:r=2,i=49;break;case 79:case 111:r=8,i=55;break;default:return+t}for(var o,c=t.slice(2),l=0,u=c.length;l<u;l++)if(o=c.charCodeAt(l),o<48||o>i)return NaN;return parseInt(c,r)}}return+t};if(!g(" 0o1")||!g("0b1")||g("+0x1")){g=function(e){var t=arguments.length<1?0:e,n=this;return n instanceof g&&(b?c(function(){m.valueOf.call(n)}):a(n)!=f)?o(new h(_(t)),n,g):_(t)};for(var y,x=n("9e1e")?l(h):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),w=0;x.length>w;w++)i(h,y=x[w])&&!i(g,y)&&d(g,y,u(h,y));g.prototype=m,m.constructor=g,n("2aba")(r,f,g)}},c69a:function(e,t,n){e.exports=!n("9e1e")&&!n("79e5")(function(){return 7!=Object.defineProperty(n("230e")("div"),"a",{get:function(){return 7}}).a})},c8af:function(e,t,n){"use strict";var r=n("c532");e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},c8ba:function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"===typeof window&&(n=window)}e.exports=n},ca5a:function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},cadf:function(e,t,n){"use strict";var r=n("9c6c"),i=n("d53b"),a=n("84f2"),o=n("6821");e.exports=n("01f9")(Array,"Array",function(e,t){this._t=o(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,i(1)):i(0,"keys"==t?n:"values"==t?e[n]:[n,e[n]])},"values"),a.Arguments=a.Array,r("keys"),r("values"),r("entries")},cb7c:function(e,t,n){var r=n("d3f4");e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},cc5d:function(e,t,n){t=e.exports=n("2350")(!1),t.push([e.i,"/*\n\nArduino® Light Theme - Stefania Mellai <s.mellai@arduino.cc>\n\n*/\n\n.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 0.5em;\n  background: #FFFFFF;\n}\n\n.hljs,\n.hljs-subst {\n  color: #434f54;\n}\n\n.hljs-keyword,\n.hljs-attribute,\n.hljs-selector-tag,\n.hljs-doctag,\n.hljs-name {\n  color: #00979D;\n}\n\n.hljs-built_in,\n.hljs-literal,\n.hljs-bullet,\n.hljs-code,\n.hljs-addition {\n  color: #D35400;\n}\n\n.hljs-regexp,\n.hljs-symbol,\n.hljs-variable,\n.hljs-template-variable,\n.hljs-link,\n.hljs-selector-attr,\n.hljs-selector-pseudo {\n  color: #00979D;\n}\n\n.hljs-type,\n.hljs-string,\n.hljs-selector-id,\n.hljs-selector-class,\n.hljs-quote,\n.hljs-template-tag,\n.hljs-deletion {\n  color: #005C5F;\n}\n\n.hljs-title,\n.hljs-section {\n  color: #880000;\n  font-weight: bold;\n}\n\n.hljs-comment {\n  color: rgba(149,165,166,.8);\n}\n\n.hljs-meta-keyword {\n  color: #728E00;\n}\n\n.hljs-meta {\n  color: #728E00;\n  color: #434f54;\n}\n\n.hljs-emphasis {\n  font-style: italic;\n}\n\n.hljs-strong {\n  font-weight: bold;\n}\n\n.hljs-function {\n  color: #728E00;\n}\n\n.hljs-number {\n  color: #8A7B52;  \n}\n",""])},ce10:function(e,t,n){var r=n("69a8"),i=n("6821"),a=n("c366")(!1),o=n("613b")("IE_PROTO");e.exports=function(e,t){var n,s=i(e),c=0,l=[];for(n in s)n!=o&&r(s,n)&&l.push(n);while(t.length>c)r(s,n=t[c++])&&(~a(l,n)||l.push(n));return l}},cee4:function(e,t,n){"use strict";var r=n("c532"),i=n("1d2b"),a=n("0a06"),o=n("2444");function s(e){var t=new a(e),n=i(a.prototype.request,t);return r.extend(n,a.prototype,t),r.extend(n,t),n}var c=s(o);c.Axios=a,c.create=function(e){return s(r.merge(o,e))},c.Cancel=n("7a77"),c.CancelToken=n("8df4"),c.isCancel=n("2e67"),c.all=function(e){return Promise.all(e)},c.spread=n("0df6"),e.exports=c,e.exports.default=c},d3f4:function(e,t){e.exports=function(e){return"object"===typeof e?null!==e:"function"===typeof e}},d53b:function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},d8e8:function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},d925:function(e,t,n){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},dcbc:function(e,t,n){var r=n("2aba");e.exports=function(e,t,n){for(var i in t)r(e,i,t[i],n);return e}},de09:function(e,t){e.exports=function(e){var t=e.COMMENT("--","$");return{case_insensitive:!0,illegal:/[<>{}*#]/,contains:[{beginKeywords:"begin end start commit rollback savepoint lock alter create drop rename call delete do handler insert load replace select truncate update set show pragma grant merge describe use explain help declare prepare execute deallocate release unlock purge reset change stop analyze cache flush optimize repair kill install uninstall checksum restore check backup revoke comment",end:/;/,endsWithParent:!0,lexemes:/[\w\.]+/,keywords:{keyword:"abort abs absolute acc acce accep accept access accessed accessible account acos action activate add addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias allocate allow alter always analyze ancillary and any anydata anydataset anyschema anytype apply archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base char_length character_length characters characterset charindex charset charsetform charsetid check checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation collect colu colum column column_value columns columns_updated comment commit compact compatibility compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection consider consistent constant constraint constraints constructor container content contents context contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor deterministic diagnostics difference dimension direct_load directory disable disable_all disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding execu execut execute exempt exists exit exp expire explain export export_set extended extent external external_1 external_2 externally extract failed failed_login_attempts failover failure far fast feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final finish first first_value fixed flash_cache flashback floor flush following follows for forall force form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ftp full function general generated get get_format get_lock getdate getutcdate global global_name globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex hierarchy high high_priority hosts hour http id ident_current ident_incr ident_seed identified identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile initial initialized initially initrans inmemory inner innodb input insert install instance instantiable instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lax lcase lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime managed management manual map mapping mask master master_pos_wait match matched materialized max maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans md5 measures median medium member memcompress memory merge microsecond mid migration min minextents minimum mining minus minute minvalue missing mod mode model modification modify module monitoring month months mount move movement multiset mutex name name_const names nan national native natural nav nchar nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck noswitch not nothing notice notrim novalidate now nowait nth_value nullif nulls num numb numbe nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary out outer outfile outline output over overflow overriding package pad parallel parallel_enable parameters parent parse partial partition partitions pascal passing password password_grace_time password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction prediction_cost prediction_details prediction_probability prediction_set prepare present preserve prior priority private private_sga privileges procedural procedure procedure_analyze processlist profiles project prompt protection public publishingservername purge quarter query quick quiesce quota quotename radians raise rand range rank raw read reads readsize rebuild record records recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename repair repeat replace replicate replication required reset resetlogs resize resource respect restore restricted result result_cache resumable resume retention return returning returns reuse reverse revoke right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll sdo_georaster sdo_topo_geometry search sec_to_time second section securefile security seed segment select self sequence sequential serializable server servererror session session_user sessions_per_user set sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone standby start starting startup statement static statistics stats_binomial_test stats_crosstab stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tan tdo template temporary terminated tertiary_weights test than then thread through tier ties time time_format time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unpivot unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear wellformed when whene whenev wheneve whenever where while whitespace with within without work wrapped xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek",literal:"true false null",built_in:"array bigint binary bit blob boolean char character date dec decimal float int int8 integer interval number numeric real record serial serial8 smallint text varchar varying void"},contains:[{className:"string",begin:"'",end:"'",contains:[e.BACKSLASH_ESCAPE,{begin:"''"}]},{className:"string",begin:'"',end:'"',contains:[e.BACKSLASH_ESCAPE,{begin:'""'}]},{className:"string",begin:"`",end:"`",contains:[e.BACKSLASH_ESCAPE]},e.C_NUMBER_MODE,e.C_BLOCK_COMMENT_MODE,t]},e.C_BLOCK_COMMENT_MODE,t]}}},df7c:function(e,t,n){(function(e){function n(e,t){for(var n=0,r=e.length-1;r>=0;r--){var i=e[r];"."===i?e.splice(r,1):".."===i?(e.splice(r,1),n++):n&&(e.splice(r,1),n--)}if(t)for(;n--;n)e.unshift("..");return e}var r=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,i=function(e){return r.exec(e).slice(1)};function a(e,t){if(e.filter)return e.filter(t);for(var n=[],r=0;r<e.length;r++)t(e[r],r,e)&&n.push(e[r]);return n}t.resolve=function(){for(var t="",r=!1,i=arguments.length-1;i>=-1&&!r;i--){var o=i>=0?arguments[i]:e.cwd();if("string"!==typeof o)throw new TypeError("Arguments to path.resolve must be strings");o&&(t=o+"/"+t,r="/"===o.charAt(0))}return t=n(a(t.split("/"),function(e){return!!e}),!r).join("/"),(r?"/":"")+t||"."},t.normalize=function(e){var r=t.isAbsolute(e),i="/"===o(e,-1);return e=n(a(e.split("/"),function(e){return!!e}),!r).join("/"),e||r||(e="."),e&&i&&(e+="/"),(r?"/":"")+e},t.isAbsolute=function(e){return"/"===e.charAt(0)},t.join=function(){var e=Array.prototype.slice.call(arguments,0);return t.normalize(a(e,function(e,t){if("string"!==typeof e)throw new TypeError("Arguments to path.join must be strings");return e}).join("/"))},t.relative=function(e,n){function r(e){for(var t=0;t<e.length;t++)if(""!==e[t])break;for(var n=e.length-1;n>=0;n--)if(""!==e[n])break;return t>n?[]:e.slice(t,n-t+1)}e=t.resolve(e).substr(1),n=t.resolve(n).substr(1);for(var i=r(e.split("/")),a=r(n.split("/")),o=Math.min(i.length,a.length),s=o,c=0;c<o;c++)if(i[c]!==a[c]){s=c;break}var l=[];for(c=s;c<i.length;c++)l.push("..");return l=l.concat(a.slice(s)),l.join("/")},t.sep="/",t.delimiter=":",t.dirname=function(e){var t=i(e),n=t[0],r=t[1];return n||r?(r&&(r=r.substr(0,r.length-1)),n+r):"."},t.basename=function(e,t){var n=i(e)[2];return t&&n.substr(-1*t.length)===t&&(n=n.substr(0,n.length-t.length)),n},t.extname=function(e){return i(e)[3]};var o="b"==="ab".substr(-1)?function(e,t,n){return e.substr(t,n)}:function(e,t,n){return t<0&&(t=e.length+t),e.substr(t,n)}}).call(this,n("4362"))},e11e:function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},e4bc:function(e,t,n){var r=n("acb3");"string"===typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);var i=n("499e").default;i("0d200294",r,!0,{sourceMap:!1,shadowMode:!1})},e683:function(e,t,n){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},ebd6:function(e,t,n){var r=n("cb7c"),i=n("d8e8"),a=n("2b4c")("species");e.exports=function(e,t){var n,o=r(e).constructor;return void 0===o||void 0==(n=r(o)[a])?t:i(n)}},ee8c:function(e,t){e.exports=function(e){var t="[a-zA-Z-][a-zA-Z0-9_-]*",n={begin:/[A-Z\_\.\-]+\s*:/,returnBegin:!0,end:";",endsWithParent:!0,contains:[{className:"attribute",begin:/\S/,end:":",excludeEnd:!0,starts:{endsWithParent:!0,excludeEnd:!0,contains:[{begin:/[\w-]+\(/,returnBegin:!0,contains:[{className:"built_in",begin:/[\w-]+/},{begin:/\(/,end:/\)/,contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE]}]},e.CSS_NUMBER_MODE,e.QUOTE_STRING_MODE,e.APOS_STRING_MODE,e.C_BLOCK_COMMENT_MODE,{className:"number",begin:"#[0-9A-Fa-f]+"},{className:"meta",begin:"!important"}]}}]};return{case_insensitive:!0,illegal:/[=\/|'\$]/,contains:[e.C_BLOCK_COMMENT_MODE,{className:"selector-id",begin:/#[A-Za-z0-9_-]+/},{className:"selector-class",begin:/\.[A-Za-z0-9_-]+/},{className:"selector-attr",begin:/\[/,end:/\]/,illegal:"$"},{className:"selector-pseudo",begin:/:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/},{begin:"@(font-face|page)",lexemes:"[a-z-]+",keywords:"font-face page"},{begin:"@",end:"[{;]",illegal:/:/,contains:[{className:"keyword",begin:/\w+/},{begin:/\s/,endsWithParent:!0,excludeEnd:!0,relevance:0,contains:[e.APOS_STRING_MODE,e.QUOTE_STRING_MODE,e.CSS_NUMBER_MODE]}]},{className:"selector-tag",begin:t,relevance:0},{begin:"{",end:"}",illegal:/\S/,contains:[e.C_BLOCK_COMMENT_MODE,n]}]}}},f0f8:function(e,t){e.exports=function(e){var t={className:"variable",variants:[{begin:/\$[\w\d#@][\w\d_]*/},{begin:/\$\{(.*?)}/}]},n={className:"string",begin:/"/,end:/"/,contains:[e.BACKSLASH_ESCAPE,t,{className:"variable",begin:/\$\(/,end:/\)/,contains:[e.BACKSLASH_ESCAPE]}]},r={className:"string",begin:/'/,end:/'/};return{aliases:["sh","zsh"],lexemes:/\b-?[a-z\._]+\b/,keywords:{keyword:"if then else elif fi for while in do done case esac function",literal:"true false",built_in:"break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp",_:"-ne -eq -lt -gt -f -d -e -s -l -a"},contains:[{className:"meta",begin:/^#![^\n]+sh\s*$/,relevance:10},{className:"function",begin:/\w[\w\d_]*\s*\(\s*\)\s*\{/,returnBegin:!0,contains:[e.inherit(e.TITLE_MODE,{begin:/\w[\w\d_]*/})],relevance:0},e.HASH_COMMENT_MODE,n,r,t]}}},f54f:function(e,t){e.exports=function(e){var t={className:"variable",variants:[{begin:/\$\d+/},{begin:/\$\{/,end:/}/},{begin:"[\\$\\@]"+e.UNDERSCORE_IDENT_RE}]},n={endsWithParent:!0,lexemes:"[a-z/_]+",keywords:{literal:"on off yes no true false none blocked debug info notice warn error crit select break last permanent redirect kqueue rtsig epoll poll /dev/poll"},relevance:0,illegal:"=>",contains:[e.HASH_COMMENT_MODE,{className:"string",contains:[e.BACKSLASH_ESCAPE,t],variants:[{begin:/"/,end:/"/},{begin:/'/,end:/'/}]},{begin:"([a-z]+):/",end:"\\s",endsWithParent:!0,excludeEnd:!0,contains:[t]},{className:"regexp",contains:[e.BACKSLASH_ESCAPE,t],variants:[{begin:"\\s\\^",end:"\\s|{|;",returnEnd:!0},{begin:"~\\*?\\s+",end:"\\s|{|;",returnEnd:!0},{begin:"\\*(\\.[a-z\\-]+)+"},{begin:"([a-z\\-]+\\.)+\\*"}]},{className:"number",begin:"\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"},{className:"number",begin:"\\b\\d+[kKmMgGdshdwy]*\\b",relevance:0},t]};return{aliases:["nginxconf"],contains:[e.HASH_COMMENT_MODE,{begin:e.UNDERSCORE_IDENT_RE+"\\s+{",returnBegin:!0,end:"{",contains:[{className:"section",begin:e.UNDERSCORE_IDENT_RE}],relevance:0},{begin:e.UNDERSCORE_IDENT_RE+"\\s",end:";|{",returnBegin:!0,contains:[{className:"attribute",begin:e.UNDERSCORE_IDENT_RE,starts:n}],relevance:0}],illegal:"[^\\s\\}]"}}},f605:function(e,t){e.exports=function(e,t,n,r){if(!(e instanceof t)||void 0!==r&&r in e)throw TypeError(n+": incorrect invocation!");return e}},f6b4:function(e,t,n){"use strict";var r=n("c532");function i(){this.handlers=[]}i.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},i.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},i.prototype.forEach=function(e){r.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=i},f751:function(e,t,n){var r=n("5ca1");r(r.S+r.F,"Object",{assign:n("7333")})},fab2:function(e,t,n){var r=n("7726").document;e.exports=r&&r.documentElement},fb15:function(e,t,n){"use strict";n.r(t);n("1eb2"),n("551c"),n("f751"),n("c5f6");var r=n("bc3a"),i=n.n(r),a=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vm-markdown-html",domProps:{innerHTML:e._s(e.content)}})},o=[],s=(n("7f7f"),n("ac6a"),n("cadf"),n("456d"),n("0e54")),c=n.n(s),l=n("a70e"),u=n.n(l),d=(n("1b3b"),n("4dd1")),p=n.n(d),f=n("0209"),g=n.n(f),h=n("8dcb"),m=n.n(h),b=n("f0f8"),v=n.n(b),_=n("ee8c"),y=n.n(_),x=n("04b0"),w=n.n(x),E=n("2a93"),S=n.n(E),k=n("332f"),N=n.n(k),C=n("1846"),M=n.n(C),O=n("f54f"),T=n.n(O),R=n("2907"),A=n.n(R),D=n("508e"),L=n.n(D),I=n("9510"),P=n.n(I),j=n("6113"),B=n.n(j),U=n("b65b"),z=n.n(U),$=n("de09"),G=n.n($),q=n("2e7b"),F=n.n(q),H=n("af44"),K=n.n(H),W=n("5ad2"),V=n.n(W);u.a.registerLanguage("javascript",p.a),u.a.registerLanguage("js",p.a),u.a.registerLanguage("cpp",g.a),u.a.registerLanguage("xml",m.a),u.a.registerLanguage("bash",v.a),u.a.registerLanguage("css",y.a),u.a.registerLanguage("markdown",w.a),u.a.registerLanguage("ini",S.a),u.a.registerLanguage("java",N.a),u.a.registerLanguage("less",M.a),u.a.registerLanguage("nginx",T.a),u.a.registerLanguage("php",A.a),u.a.registerLanguage("powershell",L.a),u.a.registerLanguage("python",P.a),u.a.registerLanguage("scss",B.a),u.a.registerLanguage("shell",z.a),u.a.registerLanguage("sql",G.a),u.a.registerLanguage("yaml",F.a),u.a.registerLanguage("typescript",K.a),u.a.registerLanguage("ts",K.a),u.a.registerLanguage("json",V.a),u.a.highlightCode=function(){var e=document.querySelectorAll("pre code");[].forEach.call(e,u.a.highlightBlock)};var Z=u.a,J=(n("6b54"),function e(t,n){for(var r in n)t[r]=t[r]&&"[object Object]"===t[r].toString()?e(t[r],n[r]):t[r]=n[r];return t}),X=function(e){var t=Object.keys(e),n="";return t.forEach(function(t){n+="".concat(t," : ").concat(e[t],";")}),n},Q={name:"Markdown",props:{value:{type:String,default:""},mdStyle:{type:Object}},data:function(){return{content:" ",codeBgColor:"rgb(248, 248, 248)",defaultStyle:{ul:{margin:"10px 20px","list-style-type":"square",padding:"0"},ol:{margin:"10px 20px","list-style-type":"decimal",padding:"0"},li:{display:"list-item",padding:"0"},hr:{margin:"15px 0","border-top":"1px solid #eeeff1"},pre:{display:"block",margin:"10px 0",padding:"8px","border-radius":"4px","background-color":"rgb(248, 248, 248)",color:"#656565","font-size":"14px"},blockquote:{display:"block","border-left":"4px solid #ddd",margin:"15px 0",padding:"0 15px"},img:{margin:"20px 0"},a:{color:"#41b883"},table:{border:"1px solid #eee","border-collapse":"collapse"},tr:{border:"1px solid #eee"},th:{padding:"8px 30px","border-right":"1px solid #eee","background-color":"#f2f2f2"},td:{padding:"8px 30px","border-right":"1px solid #eee"},code:{"background-color":"rgb(248, 248, 248)"}}}},watch:{value:function(e){this.updateContent(e)}},mounted:function(){this.updateContent(this.value)},methods:{updateContent:function(e){if(e){var t=c()(e);this.content=t;var n=this;this.$nextTick(function(){n.parseHtml(),Z.highlightCode()})}},parseHtml:function(){var e=this.mdStyle?J(this.defaultStyle,this.mdStyle):this.defaultStyle,t=Object.keys(e),n={};t.forEach(function(t){n[t]=X(e[t])});var r=document.getElementsByClassName("vm-markdown-html")[0];if(r)for(var i=Object.keys(n),a=0;a<i.length;a++){var o=r.getElementsByTagName(i[a]);if(o.length>0)for(var s=0;s<o.length;s++)o[s].style.cssText=n[i[a]]}}}},Y=Q;n("aa0f");function ee(e,t,n,r,i,a,o,s){var c,l="function"===typeof e?e.options:e;if(t&&(l.render=t,l.staticRenderFns=n,l._compiled=!0),r&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),o?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"===typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=s?function(){i.call(this,this.$root.$options.shadowRoot)}:i),c)if(l.functional){l._injectStyles=c;var u=l.render;l.render=function(e,t){return c.call(t),u(e,t)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,c):[c]}return{exports:e,options:l}}var te=ee(Y,a,o,!1,null,"4cf456b0",null);te.options.__file="Markdown.vue";var ne,re,ie=te.exports,ae={name:"TextPreview",props:{value:{type:String,default:" "},textStyle:{type:Object}},data:function(){return{refId:"textPreview".concat((new Date).getTime()+Math.random()),defaultStyle:{"font-size":"18px"}}},mounted:function(){this.setStyle()},methods:{setStyle:function(){var e=this.textStyle?J(this.defaultStyle,this.textStyle):this.defaultStyle,t=this.$refs[this.refId],n=t.getElementsByTagName("pre")[0];n.style.cssText=X(e)}},render:function(e){return e("div",{class:"content",ref:this.refId},[e("pre",[this.value])])}},oe=ae,se=ee(oe,ne,re,!1,null,null,null);se.options.__file="TextPreview.vue";var ce=se.exports,le=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticStyle:{height:"100%"}},[n("iframe",{attrs:{src:e.value,frameborder:"0",width:"100%",height:"100%"}})])},ue=[],de={name:"Office",props:{value:{type:String,default:""},height:{type:[String,Number],default:700}}},pe=de,fe=ee(pe,le,ue,!1,null,null,null);fe.options.__file="Office.vue";var ge,he,me=fe.exports,be={method:"get",responseType:"blob"},ve={name:"app",components:{Markdown:ie,TextPreview:ce,Office:me},props:{type:{type:String,default:"md"},value:{type:String,default:""},height:{type:Number,default:90},language:{type:String,default:""},mdStyle:{type:Object,default:null},textStyle:{type:Object,default:null},url:{type:String,default:""},requestConfig:{type:Object,default:function(){return{}}}},data:function(){return{tempValue:"",parseComponet:"Markdown",styler:""}},watch:{type:function(e){this.updateType()}},computed:{actualValue:function(){return this.tempValueC(),"office"===this.type?"https://view.officeapps.live.com/op/view.aspx?src=".concat(this.tempValue):"code"===this.type&&this.language?"```".concat(this.language,"\n").concat(this.tempValue,"\n```"):this.tempValue}},mounted:function(){this.updateType()},methods:{tempValueC:function(){if(this.value)this.tempValue=this.value;else if("office"!==this.type){var e=this;Object.assign(be,this.requestConfig,{url:this.url}),this.download(be).then(function(t){e.tempValue=t}).catch(function(t){e.tempValue="Download Error!",console.error(t)})}else this.tempValue=this.url},download:function(e){return new Promise(function(t,n){i()(e).then(function(e){var n=new FileReader;n.readAsText(new Blob([e.data])),n.onload=function(){t(n.result)}}).catch(function(e){n(e)})})},setHeiht:function(){var e=this.height;if(e<0&&(e=0),e>100)this.styler="height: ".concat(e,"px");else if("office"===this.type){var t=this.getClientHeight()*e/100;this.styler="height: ".concat(t,"px")}else this.styler="height: ".concat(e,"%")},getClientHeight:function(){var e=document.documentElement.clientHeight;return e},updateType:function(){switch(this.type){case"markdown":this.parseComponet="Markdown";break;case"text":this.parseComponet="TextPreview";break;case"office":this.parseComponet="Office";break;case"code":this.parseComponet="Markdown";break}this.setHeiht()}},render:function(e){var t=e("div",["Prop type error, Type must be markdown/office/text/code!"]);return"markdown"===this.type||"code"===this.type?t=e(ie,{attrs:{value:this.actualValue,mdStyle:this.mdStyle}}):"text"===this.type?t=e(ce,{attrs:{value:this.actualValue,textStyle:this.textStyle}}):"office"===this.type&&(t=e(me,{attrs:{value:this.actualValue}})),e("div",{attrs:{id:"VueDocPreviewRoot"},class:"root",style:this.styler},[t])}},_e=ve,ye=(n("66a3"),ee(_e,ge,he,!1,null,"78671096",null));ye.options.__file="App.vue";var xe=ye.exports,we=xe;t["default"]=we},fdef:function(e,t){e.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"}})});
//# sourceMappingURL=vueDocPreview.umd.min.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueDocPreview = __webpack_require__(236);

var _vueDocPreview2 = _interopRequireDefault(_vueDocPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "FilePreview",
  props: {
    url: String
  },
  components: {
    VueDocPreview: _vueDocPreview2.default
  },
  data: function data() {
    return {
      displayPdf: false
    };
  },
  created: function created() {
    var _this = this;

    setTimeout(function () {
      _this.displayPdf = true;
    }, 1000);
  },

  computed: {
    fileExtension: function fileExtension() {
      try {
        return this.url.split(".").pop().toLowerCase();
      } catch (e) {
        return null;
      }
    },
    isPdf: function isPdf() {
      return this.fileExtension === "pdf";
    },
    isImage: function isImage() {
      return ["png", "jpg", "jpeg"].includes(this.fileExtension);
    },
    isOfficeDoc: function isOfficeDoc() {
      return ["doc", "docx", "ppt", "pptx", "xls", "xlsx"].includes(this.fileExtension);
    },
    isIphone: function isIphone() {
      return this.getMobileOperatingSystem() === "iOS";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "SpinnerLoading"
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(240);

var _en2 = _interopRequireDefault(_en);

var _en3 = __webpack_require__(241);

var _en4 = _interopRequireDefault(_en3);

var _en5 = __webpack_require__(242);

var _en6 = _interopRequireDefault(_en5);

var _en7 = __webpack_require__(243);

var _en8 = _interopRequireDefault(_en7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Submit",
        PREVIOUS: "Previous",
        NEXT: "Next",
        VIEW: "View",
        UPLOAD: "Upload",
        UPLOAD_FILE: "Upload File",
        VIEW_FILE: "View File",
        DELETE_FILE: "Delete File",
        CLOSE: "Close",
        DELETE: "Delete",
        CANCEL: "Cancel",
        YES: "Yes",
        NO: "No",
        OK: "Ok",
        ADD: "Add",
        UPDATE_STATUS: "Update Status",
        RETURN_DASHBOARD: "Return to Dashboard",
        REFRESH: "Refresh",
        BULK_UPDATE_STATUS: "Update Status of Selected",
        BULK_OVERWRITE_LOCATIONS: "Overwrite Locations",
        BULK_OVERWRITE_TYPES: "Overwrite Types",
        BULK_OVERWRITE_TAGS: "Overwrite Tags",
        BULK_ADD_LOCATIONS: "Add Locations",
        BULK_ADD_TYPES: "Add Types",
        BULK_ADD_TAGS: "Add Tags",
        BULK_UPDATE: "Bulk Update",
        CHARGE_THROUGH_AUTHORIZE_NET: "Charge Through Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Charge Through Stripe",
        INVOICE_THROUGH_STRIPE: "Invoice Through Stripe",
        ADD_USER_TO_MAILCHIMP: "Add {0} Users to Mailchimp",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Charge Client and Payout Candidate",
        BULK_COPY_SUGGESTED_CHARGE: "Bulk Copy Suggested Charge to Total Client Charge",
        BULK_DELETE: "Delete Selected",
        BULK_UNASSIGNED: "Unassign Selected",
        EXPORT_EMPLOYERS: "Export Client Mailing List",
        EXPORT_CANDIDATES: "Export Candidate Mailing List",
        UPDATE_MANAGER: "Update {0}",
        VIEW_PROFILE: "View Profile",
        VIEW_OFFER: "View Offer",
        SAVE: "Save",
        EXPAND_ALL: "Expand All",
        COLLAPSE_ALL: "Collapse All",
        SELECT_ALL: "Select All",
        UNSELECT_ALL: "Unselect All",
        RESET_FILTERS: "Reset Filters",
        CLOCK_IN: "Clock In",
        ADD_A_BREAK: "Add a Break",
        CLOCK_OUT: "Clock Out",
        CONFIRM_CLOCK_IN_OUT: "Client Confirm",
        LEAVE_REVIEW: "Leave a Review",
        DECLINE: "Decline",
        DECLINE_WITHOUT_NOTIFICATION: "Decline Without Notification",
        UNDECLINE: "Undecline",
        ACCEPT: "Accept",
        CHECK_PAYMENT: "Check Payment Expression",
        CREATE_SNAPSHOT_APPLICATION_FORM: "Save Current Application Form",
        RESTORE_APPLICATION_FORM: "Restore Saved Application Version",
        RETURNING_APPLICANT: "I am a returning applicant",
        ASSIGN: "Assign",
        TENTATIVELY_ASSIGN: "Tentatively Assign",
        SIGN: "Sign",
        EDIT: "Edit",
        DUPLICATE: "Duplicate",
        ADD_ADDITIONAL_DATES: "Add Additional Dates",
        ADD_A_BOOKING: "Add a Booking",
        ADD_A_GROUP: "Add a Group",
        MESSAGE: "Message",
        UPDATE_CUSTOM_STATUS: "Update {0} Status",
        UPDATE: "Update",
        ADD_OPTION: "Add Option",
        EDIT_SETTING: "Edit Settings",
        DONE: "Done",
        SUBMIT_REPORT: "Submit Report",
        REVIEW_REPORT_BUTTON: "View Reported Problems",
        SEARCH_CANDIDATES_FOR_ALL_BOOKING: "Search for candidates available for all open bookings",
        SHARE_WITH_MARKET_PLACE: "Share With the Agency Marketplace",
        CUSTOMIZE_TEMPLATE: "Customize Template"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "New Status",
        NEW_LOCATIONS: "New Locations",
        NEW_TYPES: "New Types",
        NEW_TAGS: "New Tags",
        FILTER_BY_STATUS: "Filter by Status",
        FILTER_BY_STATUSES: "Filter by Statuses",
        FILTER_BY: "Filter by {0}",
        STATUSES_TO_HIDE: "Statuses to Hide",
        FILTER_BY_LOCATIONS: "Filter by Locations",
        FILTER_BY_DURATIONS: "Filter by Durations",
        FILTER_BY_ROLES: "Filter by Roles",
        FILTER_BY_TYPES: "Filter by Types",
        FILTER_BY_TAGS: "Filter by Tags",
        FILTER_BY_MANAGER: "Filter by Manager",
        FILTER_BY_CLIENT: "Filter by Client",
        FILTER_BY_CATEGORIES: "Filter by Categories",
        FILTER_BY_START_DATE: "Filter by Start Date",
        FILTER_BY_END_DATE: "Filter by End Date",
        FILTER_BY_WEEK_DAY: "Filter by Week Day",
        FILTER_BY_CLIENTS: "Filter by Clients",
        FILTER_BY_CLIENT_STATUSES: "Filter by Client Statuses",
        FILTER_BY_CLIENT_TYPES: "Filter by Client Types",
        FILTER_BY_CANDIDATES: "Filter by Candidate(s)",
        FILTER_BY_JOB_TYPES: "Filter by Job Types",
        FILTER_BY_JOB_STATUSES: "Filter by Job Statuses",
        FILTER_BY_JOB_ID: "Filter by Job ID",
        SELECT_SCRAPER_ACCOUNTS: "Select Scraper Accounts",
        FILTER_BY_USER_TYPE: "Filter by User Type",
        KEYWORD_SEARCH_USER_PROFILE: "Search for keyword/phrase anywhere on user profile, hit Enter to apply search",
        SEARCH_BY_NAME_EMAIL_PHONE: "Search by Name, Email or Phone Number",
        FILTER_BY_RECENT_ACTIVE: "Filter by Recently Active",
        SELECT_LOCATIONS: "Select Locations",
        SELECT_OPTION: "Select Option",
        SELECT_CLIENT: "Select Client",
        SELECT_CANDIDATE: "Select Candidate",
        SELECT_CANDIDATES: "Select Candidates",
        SELECT_CANDIDATE_SEARCHABLE: "Select Candidate (Type to search)",
        SELECT_ADMINS: "Select Admins",
        SELECT_ADMIN_RECEIVE_EMAIL: "Select admins who receive emails",
        SELECT_STATUS: "Select Status",
        SELECT_LANGUAGES: "Select Languages",
        SELECT_TYPES: "Select Types",
        SELECT_TYPE: "Select Type",
        SELECT_AUDIENCE: "Select Audience",
        SELECT_TAGS: "Select Tags",
        SELECT_USER_TYPE: "Select User Type",
        SELECT_USER_TYPES: "Select User Types",
        SELECT_CATEGORY: "Select Category",
        SELECT_CATEGORY_ADMIN_ONLY: "Select Category (Admin Only)",
        SELECT_TRIGGER: "Select Trigger",
        SELECT_ONE: "Select One",
        SELECT_PROFILE_BUILDER: "Select Profile Builder",
        SELECT_TIME_OFF_CATEOGRY: "Select Time Off Category",
        SELECT_DESTINATION: "Select Destination",
        SELECT_ACCESS_LEVEL: "Select Access Level",
        SELECT_VISIBILITY_SCOPE: "Select Visibility Scope",
        SELECT_AREAS: "Select Areas",
        NUMBER: "Number",
        DESCRIPTION_CHARGE: "Description of charge (this description will be included on the user's receipt)"
    },
    LABELS: {
        SELECT_TEMPLATE: "Select Template",
        SELECT_ANALYTICS_DASHBOARD_FIELDS: "Select fields for analytics",
        FILTER_BY_LOCATIONS: "Filter by Locations",
        FILTER_BY_TYPES: "Filter by Types",
        FILTER_BY_MANAGER: "Filter by Manager",
        FILTER_BY_CLIENT: "Filter by Client",
        FILTER_BY_CATEGORIES: "Filter by Categories",
        FILTER_BY_STATUS: "Filter by Status",
        ADDRESS: "Address",
        CITY: "City",
        STATE: "State",
        COUNTRY: "Country",
        ZIP_CODE: "Zip Code",
        LOCATIONS: "Locations",
        DESCRIPTION: "Description",
        PER_HOUR: "per hour",
        ADD_ITEM: "Add {0}",
        EDIT_ITEM: "Edit {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Save and Add another {0}",
        WELCOME_TEXT: "Welcome to {0}"
    },
    HEADERS: {
        EMAIL_LOG: "Email Log",
        SMS_LOG: "SMS Log"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "How to hide statuses by default",
        HOW_TO_CHANGE_STATUS: "How to add/change statuses"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Separate multiple emails with ; (eg: nanny1@hotmail.com; nanny2@hotmail.com )",
        SMS_NOTE: "Please note that there is a cost of $0.0115 (1.15\xA2) per 160 characters of sent/received SMS.",
        SMS_COUNTER_NOTE: "The exact character count will depend on the information inserted into the actual message.",
        CLIENT_NOT_ENTERED_STRIPE: "Client has not entered Stripe information.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "Client has not entered Authorize.Net information.",
        CANDIDATE_NOT_ENTERED_STRIPE: "Candidate has not entered Stripe information.",
        INTERVIEW_PANEL: "Note: These notes are for internal administrator use only and are not\n        shared with candidates or clients.",
        CANDIDATE_SHAREABLE_LINK: "This is a shareable link of the candidate profile. If you want\n        to see what a client will see, <strong>make sure you log out</strong> and then\n        view the link (or open it in a different browser). This is <strong>not</strong> a link for your candidate to log in with. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">Learn more.</a>",
        CLIENT_SHAREABLE_LINK: "This is a shareable link of the client profile. If you want to\n        see what a candidate will see, <strong>make sure you log out</strong> and then\n        view the link (or open it in a different browser). This is <strong>not</strong> a link for your clients to log in with. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">Learn more.</a>",
        CLIENT_PUBLIC_PAYMENT_LINK: "This is a public payment link. Client can access to this link to input payment information without logging in",
        TYPE_YOUR_NAME_TO_SIGN: 'Please type your name to sign (you agree that this constitutes the equivalent of signing a physical document)',
        JOB_BOARD_ADMIN_VIEW_WARNING: 'You are viewing this job board as an admin. If you want to see it from the perspective of a candidate please open it in a different browser or incognito window. If you need help embedding this into your website please get in touch with us!'
    },
    TABLE_HEADERS: {
        ACTIONS: "Actions",
        NOTES: "Notes",
        VALUE: "Value",
        EFFECTIVE_FROM: "Effective From",
        EFFECTIVE_UNTIL: "Effective Until",
        TYPE: "Type",
        CATEGORIES: "Categories"
    },
    OPTIONS: {
        "YES": "Yes",
        "NO": "No"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "This field is required."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Thank You!",
        STEP_OF: "Step {0} of {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Please help us to fill the form below",
        REFERENCE_FOR: "Reference for {0} {1}",
        REFERENCE_INPUT_BY: "Reference Information inputted by {0} {1}",
        FORM_SUBMITTED: "The reference check form has been submitted!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Drop a file here or click to upload",
        MAXIMUM_UPLOAD_SIZE: "Maximum upload size {0}MB",
        FILE_EXCEED_MAXIMUM: "File size exceeds {0}MB.",
        FILE: "File"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Bookings",
            HIDE_PAST_BOOKINGS: "Hide past bookings",
            BOOKING_CREDIT_LEFT: "{0} booking credits left",
            MIN_BOOKING_REQUIRE: "You need at least {0} booking!",
            MIN_BOOKINGS_REQUIRE: "You need at least {0} bookings!",
            SELECTED_CANDIDATE: "Selected Candidate",
            TOTAL_BOOKING_FEE: "Total Booking Fee",
            BOOKING_GROUPS: "Booking Groups"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Please click on the booking (on calendar) to learn more about your assigned service provider and leave a review.",
            CLICK_ON_DATE: "Please click a date to add a booking.",
            CLICK_ON_OTHER_DATE: "Please click another date on the calendar to add a booking.",
            BOOKING_GROUP: "All bookings in the same group must be assigned to one assignee"
        },
        PRICES: {
            BOOKING_RATE: "Booking Rate",
            BOOKING_FEE: "Booking Fee",
            PER_BOOKING_FEE: "Per Booking Fee",
            CLIENT_RATE: "Client Rate",
            CANDIDATE_RATE: "Candidate Rate",
            AGENCY_FEE: "Agency Fee",
            TRAVEL_FEE: "Travel Fee",
            RUSH_FEE: "Rush Fee",
            CANDIDATE_RUSH_FEE: "Candidate Rush Fee",
            PER_BOOKING_AGENCY_FEE: "Per Booking Agency Fee",
            PER_BOOKING_CANDIDATE_FEE: "Per Booking Candidate Fee",
            ADMIN_FEE: "Admin Fee",
            ADMIN_PERCENTAGE: "Admin Percentage",
            ADDITIONAL_FEES: "Additional Fees"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            ADDITIONAL_DATES: "Add Additional Dates",
            START_TIME: "Start Time",
            END_TIME: "End Time",
            END_DATE: "End Date",
            SELECT_CLIENT: "Select Client",
            ASSIGNED_CANDIDATE: "Do you want to assign this job?",
            TENTATIVELY_ASSIGN_CANDIDATE: "Do you want to tentatively assign this job?",
            REPEAT: "Do you want this service more than once (repeating/recurring)?",
            REPEAT_UNTIL: "Repeat Until",
            REPEAT_EVERY: "Repeat Every",
            REPEAT_ON: "Repeat On",
            BOOKING_ADDRESS: "Booking Address",
            ADDRESS_LINE2: "Address Line 2",
            CITY: "City",
            STATE: "State/Province",
            ZIP_CODE: "Zip Code",
            NUMBER_CHILDREN: "How many children will be cared for?",
            SELECT_JOB_CATEGORY: "Select Job Category",
            SELECT_DATE: "Booking Date",
            SELECT_SERVICE: "Select Service",
            SELECT_QUICKBOOKS_PRICE: "Select Price",
            NUMBER_CANDIDATE: "Number of {0} Needed",
            SELECT_STATUS: "Select Booking Status",
            CHECK_EXISTING: "Check for Existing",
            INVALID_BOOKING_DURATION: "Booking must be at least {0} hours"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Days", "Weeks"],
            REPEAT_ON: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
        }
    },
    MENU_BAR: {
        TOP: {
            COMMUNITY: "Community",
            CANDIDATE_COMMUNITY: "Candidate Community",
            MARKETPLACE: "Marketplace",
            MESSAGES: "Messages",
            SMS: "SMS",
            JOBS: "Jobs",
            LOGOUT: "Logout",
            DASHBOARD: "My Dashboard"
        },
        ADMIN: {
            USERS: {
                ROOT: "Users",
                CLIENTS: "Clients",
                CANDIDATES: "Candidates",
                ADMINISTRATORS: "Administrators"
            },
            JOBS_EVENTS: {
                ROOT: "Jobs & Calendar",
                SHIFT_JOB_CALENDAR: "Shift Job Calendar",
                PLACEMENT_JOBS: "Placement Jobs",
                PERSONAL_TO_DO: "Personal To Do"

            },
            TEMPLATES: {
                ROOT: "Templates",
                EMAIL: "Email Templates",
                SMS: "SMS Templates",
                DOCUMENT: "Document Templates",
                NOTE: "Note Templates",
                TASK: "Task Templates",
                PROFILE: "Profile Templates",
                PUSH_NOTIFICATION: "Push Notification Templates"
            },
            SETTINGS: {
                ROOT: "Settings",
                AGENCY: "Agency Settings",
                ADMIN: "Admin Settings"
            },
            BUILDERS: {
                ROOT: "Builders",
                PROFILE: "Application & Profile Builder",
                EVALUATION: "Evaluation Builder"
            },
            LOGS: {
                ROOT: "Logs",
                COMMUNICATION_LOG: "Communication Log",
                STATUS_CHANGES: "Status Changes",
                ACTIVITY_LOG: "Activity Log",
                APPLICATION_LOG: "Application Log",
                PAYMENT_LOG: "Payment Log",
                USER_MESSAGES_LOG: "User Chat Log"
            },
            OTHERS: {
                ROOT: "Others",
                RESOURCE_MANAGER: "Resource Manager",
                REFERENCES: "References",
                DOCUMENTS: "Documents",
                EMAIL_BLASTER: "Email Blaster",
                NOTIFICATION_CENTER: "Notification Center",
                SNAPSHOT: "Metrics & Analysis (Snapshot)",
                COMMUNITY: "Community",
                DAILY_RESOURCE_MANAGER: "Daily Resource Manager",
                GLOBAL_PREDEFINED_VALUES: "Global Predefined Values",
                BENEFIT_MANAGER: "Benefit Manager",
                BENEFITS: "Benefits",
                TRASH: "Trash Bin"
            }

        },
        CANDIDATES: {
            MY_PROFILE: "My Profile",
            AVAILABLE_JOBS: "Available Jobs",
            MY_SCHEDULE: "My Schedule",
            MY_JOBS: "My Jobs",
            MY_FAMILIES: "My Families",
            BENEFITS: "Benefits"
        },
        ADMIN_PANEL: {
            LISTS: "Lists",
            NOTES: "Notes",
            EMAIL_SMS: "Email/SMS",
            EVENT: "Schedule Event",
            PASSWORD: "Password",
            PAYMENTS: "Payments",
            PAYMENTS_CREDIT: "Payments/Credits",
            DOCUMENTS: "Documents",
            EVALUATIONS: "Evaluations",
            RELATIONSHIPS: "Assigned Candidates"
        },
        ADMIN_PANEL_SHORT: {
            EMAIL_SMS: "Email/ SMS",
            EVENT: "Event",
            PASSWORD: "Pass",
            DOCUMENTS: "Docs",
            EVALUATIONS: "Evals",
            PAYMENTS: "$$$",
            RELATIONSHIPS: "Assign Cands"
        }
    },
    NAV_BAR: {
        TOP: "Top",
        CHECKLIST: "Checklist",
        DOCUMENTS: "Documents",
        PHOTO_GALARY: "Photo Gallery",
        INTRODUCTION_VIDEO: "Introduction Video"
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Profile Builder Basics",
            REQUIRE_FIELD: "How to mark questions/field as required or not",
            NOTIFICATION_DESTINATION: "Edit Who is Notified of New Applicants",
            EDIT_APPLICATION: "How to edit application forms more easily",
            ADD_SECTION_QUESTION: "How to add a question to a section",
            ADD_CONFIRMATION_BOX: "How to add confirmation fields on client or candidate application forms"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Getting Started With Evaluations"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Getting Started With Email Templates",
            DEFAULT_EMAIL_FOOTER: "Setting Up Your Default Email Footer"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Getting Started With Document Templates",
            NOTIFICATION_WHEN_SIGNED: "Add Notification When Document Signed",
            ADD_DOCUMENT: "Manually Add a Document to a User"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Mapping Out Your Process Through Statuses, Checklists and Types",
            AGENCY_BRANDING_SETUP: "Agency Branding Set Up (Logo, Colors, Fonts)",
            PROFILE_COMPLETE_SETUP: "How to Add a \"My Profile is Complete\" Button Candidates can Click to Notify You They Have Completed Their Profile",
            CONFIGURE_MULTIPLE_LOCATIONS: "Configure Your Agency to Service Multiple Distinct Locations"
        },
        EMAIL_BLASTER: {
            HOW_TO: "How email blasts work"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "How to share a candidate's profile with a client"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Welcome to {0} Mission Control",
        PRO_TIP: {
            HEADER: "Check out what's new:",
            TEXT: "Bulk shift job broadcasting!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Order Clients By",
            ORDER_CANDIDATES_BY: "Order Candidates By"
        },
        BUTTONS: {
            ADD_CLIENT: "Add Client",
            ADD_CANDIDATE: "Add Candidate"
        }
    },
    ADD_USER_DIALOG: {
        HEADER: "Add New User",
        DESCRIPTION: "This is a mechanism to manually add a user to your database. A user\n        added in this way will be put into the \"Pre Application\" status\n        (meaning they have not yet completed an application form). A user in\n        this status can still be sent to complete the application form. If you\n        would like to automatically send an email to users added this way, you\n        can add an email template that is a \"Status Change Notification\"\n        triggering on a change to \"Pre Application\".",
        LABELS: {
            EMAIL: "Email",
            PHONE: "Phone Number",
            FIRST_NAME: "First Name",
            LAST_NAME: "Last Name",
            PROFILE_BUILDER: "Profile Builder",
            USER_TYPES: "User Types",
            LOCATIONS: "Locations"
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Your account has been successfully connected with Stripe.",
        FAILED_TO_CONECT: "There was a problem connecting your account with Stripe, please try again or contact Enginehire.",
        MISSING_INFO: "Your account has been connected but there is missing information on the Stripe application, please click the connect to stripe button to continue where you left off"
    },
    DATA_TABLE: {
        SHOW: "Show",
        ITEMS_PER_PAGE: "items per page",
        SHOWING_RANGE: "Showing {0} to {1} of {2} entries"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Admin",
            PROFILE: "Profile",
            INTAKE_NOTES: "Intake Notes",
            COMMUNICATION_LOG: "Communication Log",
            RECORDS: "Records",
            JOBS: "Jobs",
            INTAKE_NOTES_MOBILE: "Notes",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profile",
            NOTES: "Notes"
        },
        BUTTONS: {
            DELETE_CLIENT: "Delete Client"
        }
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Admin",
            PROFILE: "Profile",
            INTERVIEW: "Interview",
            COMMUNICATION_LOG: "Communication Log",
            RECORDS: "Records",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profile",
            INTERVIEW: "Interview"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Delete Candidate"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Types",
            BUTTON: "Save Types"
        },
        CHECKLIST: {
            TITLE: "Checklist",
            BUTTON: "Save Checklist"
        },
        TAGS: {
            TITLE: "Tags",
            BUTTON: "Save Tags"
        },
        LOCATIONS: {
            TITLE: "Locations",
            BUTTON: "Save Locations"
        },
        LANGUAGE: {
            TITLE: "Language",
            BUTTON: "Save Language"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Profile Type",
            BUTTON: "Update Profile Builder"
        },
        NOTES: {
            TITLE: "Notes",
            DESCRIPTION: "Notes taken here are for internal admin use only, not visible to users.",
            BUTTON: "Add Note"
        },
        EMAIL: {
            TITLE: "Send Email",
            BUTTON_SEND: "Send",
            BUTTON_LOAD: "Load",
            SELECT_TEMPLATE: "Select Template",
            FROM_EMAIL: "From Email",
            REPLY_TO: "Reply To",
            SUBJECT: "Subject"
        },
        SMS: {
            TITLE: "Send SMS",
            BUTTON: "Send"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "You can manually reset the user's password here",
            BUTTON: "Update Password"
        },
        EVENT: {
            TITLE: "Schedule Event (Interview, Meeting, etc.)",
            DESCRIPTION: "These events will appear in the user's dashboard.",
            EVENT_TITLE: "Event Title",
            EVENT_DATE: "Event Date",
            EVENT_TIME: "Event Time",
            INTERVIEW_LINK: "Interview Link",
            INTERVIEW_LINK_PLACE_HOLDER: "Zoom link or other call link",
            NOTES: "Notes",
            STATUS_UPDATE_TO: "{0} to Update User to",
            SEND_EMAIL_NOTIFICATION: "Send email notification of event being scheduled",
            ADD_TO_CALENDAR: "Add to Personal To Do Calendar",
            BUTTON: "Schedule Event"
        },
        CREDIT: {
            TITLE: "Credits",
            BUTTON_ADD: "Add Credit",
            BUTTON_EDIT: "Edit",
            EDIT_CREDIT_TITLE: "Edit Credit",
            ADD_CREDIT_TITLE: "Add Credit",
            PLACE_HOLDERS: {
                VALUE: "Value",
                NOTES: "Notes"
            }
        },
        STRIPE: {
            BILL_CLIENT: "You can manually bill clients through Stripe here",
            SEND_INVOICE: "You can manually send Stripe Invoices here",
            BUTTON_CHARGE: "Charge Through Stripe",
            BUTTON_RESET: "Reset Stripe Information",
            BUTTON_INVOICE: "Invoice Through Stripe",
            PAYMENT_LOGS: "Payment Logs"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "You can manually bill clients through Authorize.Net here",
            SEND_INVOICE: "You can manually send Authorize.Net Invoices here",
            BUTTON_CHARGE: "Charge Through Authorize.Net",
            BUTTON_RESET: "Reset Authorize.Net Information",
            BUTTON_INVOICE: "Invoice Through Authorize.Net",
            PAYMENT_LOGS: "Payment Logs"
        },
        REVIEW: {
            TITLE: "Reviews",
            RATING: "Rating",
            AVERAGE_RATING: "Average Rating",
            NO_DATA: "No reviews yet."
        },
        ADD_DOCUMENT: {
            TITLE: "Add Document",
            DESCRIPTION: "You can add any Document Template to the user from here, just select one\n            of your documents from the drop down:",
            BUTTON: "Add Document"
        },
        ADD_EVALUATION: {
            BUTTON: "Add Evaluation"
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Assigned Candidates",
                NO_CANDIDATE: "No candidates have been linked to this client."
            },
            CLIENT: {
                TITLE: "Assigned Clients",
                NO_CLIENT: "No clients have been linked to this candidate."
            },
            ADD_CANDIDATE: "Add Candidate"
        },
        LAST_CONTACTED_DATE: "Last Contacted Date",
        CANDIDATE_BADGES: {
            TITLE: "Badges",
            BUTTON: "Save badges"
        }
    },
    COMMUNICATION: {
        DATE: "Date",
        FROM: "From",
        TO: "To",
        SUBJECT: "Subject",
        MESSAGE: "Message",
        RE_SEND: "Re-Send",
        CANCEL_SCHEDULE: "Cancel Schedule",
        SCHEDULE_TIME: "Schedule Time",
        CC: "Cc",
        BCC: "Bcc"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Search by Poster Name, Job Title, Job ID, Schedule, City, State, or Description",
        JOB_HIDEN_DESCRIPTION: "Jobs in the status {0} do not appear on the job\n        board by default. To update a job's status please click \"Edit Job\".",
        CLIENT_POSTING_JOB_DESCRIPTION: "This is for posting longer term positions for this client.",
        ADMIN_POSTING_JOB_DESCRIPTION: "This is for posting longer term positions"
    },
    CONFIRM_DIALOGS: _en2.default,
    ERROR_DIALOGS: _en4.default,
    RESULT_DIALOGS: _en6.default,
    AGENCY_SETTINGS: _en8.default
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CHANGE_QUESTION_MODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CHANGE_QUESTION_MODE = {
    CHANGE_QUESTION_MODEL_CONFIRM_DIALOG: {
        MESSAGE: 'By changing the model of this question, any information answered already to this question will be lost. Contact Enginehire with any questions.',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this reference?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this experience?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this contact?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this education?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this child?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this pet?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this booking?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile builder {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this request?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this job?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this application?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the document {0}?',
        ACCEPT_LABEL: 'Delete Document',
        REJECT_LABEL: 'Close'
    },
    BULK_DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you absolutely sure you want to delete these documents?',
        ACCEPT_LABEL: 'Delete Documents',
        REJECT_LABEL: 'Close'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the file?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Close'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} template {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PHOTO_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the photo {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the picture?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0} {1}</p>\n        <p>{2}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_TIME_OFF_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove this timeoff request',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel this booking?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCELLATION_FEE_CONFIRM_DIALOG: {
        MESSAGE: 'Cancellation Fee is ${0}. Are you sure you want to continue?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close? Any changes will be lost.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to accept the job {0}?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DECLINE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to decline the job {0}?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your changes?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_OVERWRITE_DATA_CONFIRM_DIALOG: {
        INNER_HTML: '<h2>Are you sure you want to overwrite {0} of the selected users?</h2><h5 class="text-danger">This will overwrite these user\'s existing {0} with "{1}".</h5>',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_ADD_DATA_CONFIRM_DIALOG: {
        INNER_HTML: '<h2>Are you sure you want to add {0} to the selected users?</h2><h5 class="text-danger">This will add "{1}" to user\'s existing {0}.</h5>',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_ADD_USER_MAILCHIMP_CONFIRM_DIALOG: {
        INNER_HTML: '<h2>Are you sure you want to add the selected users to mailchimp?</h2>',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the video?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile picture?',
        ACCEPT_LABEL: 'Delete Picture',
        REJECT_LABEL: 'Close'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove the link between {0} and this client?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'You are committing to filling this job, are you sure?',
        ACCEPT_LABEL: 'Accept Job',
        REJECT_LABEL: 'Close'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark {0} as favorite?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you do not want {0} again?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete the note?</h3>\n        <p style="white-space: pre-wrap;">{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_EVENT_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete the event scheduler?</h3>\n        <p style="white-space: pre-wrap;">{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this credit?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_MULTI_ITEMS_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to delete the {0} selected {1}?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    UNASSIGN_JOBS_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to unassign {0} selected jobs? Their status will be put to "{1}".',
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_CHANGE_JOB_STATUS_CONFIMR_DIALOG: {
        MESSAGE: "Are you sure you want to change the status of the {0} selected jobs? Their status will be changed to {1}.",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    ASSIGN_JOB_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure you want to assign the job to the candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Are you sure you want to assign {0} selected jobs to the selected candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    BULK_TENTATIVELY_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Are you sure you want to tentatively assign {0} selected jobs to the selected candidate?",
        ACCEPT_LABEL: "Yes",
        REJECT_LABEL: "No"
    },
    PACKAGE_SELECTION_CONFIRMATION: {
        INNER_HTML: '<h2>Confirm Selection - {0}</h2>\n        <hr />\n        <h5>\n          I have read and am confident of the terms and conditions with the\n          package chosen.\n        </h5>',
        ACCEPT_LABEL: "Confirm Selection",
        REJECT_LABEL: "Cancel"
    },
    DELETE_EVALUATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this evaluation?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_QUESTION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this question?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_OPTION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this option?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    POST_WEEK_AVAILABLITY_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of the availability you have entered?',
        ACCEPT_LABEL: 'Confirm Availability',
        REJECT_LABEL: 'Wait, Let Me Check Again'
    },
    TIME_OFF_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your request?',
        ACCEPT_LABEL: 'Submit Request',
        REJECT_LABEL: 'Edit Request'
    },
    REMOVE_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '{0} ({1}) - Remove Availability',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_WEEK_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the weekly availability?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    RESET_WEEK_AVAILABILITY: {
        MESSAGE: 'Are you sure you want to reset the weekly availability?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "Are you sure of your request?",
        ACCEPT_LABEL: "Submit Request",
        REJECT_LABEL: "Edit Request"
    }
}, _defineProperty(_CHANGE_QUESTION_MODE, 'SUBMIT_REQUEST_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure of your request?",
    ACCEPT_LABEL: "Submit Request",
    REJECT_LABEL: "Edit Request"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'FORCE_LOGIN_CONFIRM_DIALOG', {
    INNER_HTML: '<h4>You are already logged in!</h4>' + '<h5>Sorry, it seems you are already logged in on another device! ' + 'Please log out from anywhere else and try again. ' + 'If you have any questions please <a href="https://share.hsforms.com/1yIx2IRKyQQaVcMJW8kLbJg39wil">contact us</a>.</h5>',
    ACCEPT_LABEL: 'Login Anyway',
    REJECT_LABEL: 'OK'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'MARK_ALL_AS_PUBLIC_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to mark all {0} as public (visible to everyone)?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BROADCAST_SMS_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to send SMS to {0} users",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CREATE_JOB_CONFIRM_DIALOG', {
    INNER_HTML: '<h4>Create Job</h4>' + '<hr>' + '<h5>If you are starting a job, but it is not listed on your schedule, please use this option.' + ' This will create a new job that you can clock in and out of, and we will fill in the other details later.' + ' When clocking in, please note which client you are working for and anything else we should know.</h5>',
    ACCEPT_LABEL: 'Create Job',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'ASSIGN_TO_NOT_MATCH_CANDIDATE', {
    MESSAGE: "There is a relationship 'Do Not Match' between client and candidate. Are you sure you want to assign the booking to this candidate?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'ASSIGN_TO_UNAVAILABLE_CANDIDATE', {
    MESSAGE: "Candidate is not available. Are you sure you want to assign the booking to this candidate?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'ASSIGN_TO_ALREADY_BOOKED_CANDIDATE', {
    MESSAGE: "Candidate is already booked at this time.. Are you sure you want to assign the booking to this candidate?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'ASSIGN_TO_TIME_OFF_CANDIDATE', {
    MESSAGE: "Candidate has time off at this time. Are you sure you want to assign the booking to this candidate?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'RELEASE_SCHEDULE_CONFIRM_DIALOG', {
    MESSAGE: "Are you ready to release the schedule?",
    ACCEPT_LABEL: 'Release Schedule',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_BOOKING_GROUP_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to delete the booking group?"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'ACCEPT_BOOKING_IN_GROUP_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>The booking belongs to a group. Are you sure you want to accept all of the bookings in that group?</h3>\n        <ul>{0}</ul>',
    ACCEPT_LABEL: "Accept All",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'UPDATE_JOB_POSTER_CONFRM_DIALOG', {
    MESSAGE: "Do you want to update address fields accordingly with new job poster?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CLIENT_CONFIRM_CLOCK_IN_OUT_MESSAGE', {
    INNER_HTML: "<h3>Clock in and clock out time of the candidate</h3>" + "<ul>{0}</ul>",
    ACCEPT_LABEL: 'Approve',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CLIENT_APPROVE_CLOCK_IN_OUT_MESSAGE', {
    INNER_HTML: "<h3>Are you sure you want to approve clock in and clock out time of the candidate</h3>" + "<ul>{0}</ul>",
    ACCEPT_LABEL: 'Approve',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CLIENT_DISSAPPROVE_CLOCK_IN_OUT_MESSAGE', {
    INNER_HTML: "<h3>Are you sure you want to disapprove clock in and clock out time of the candidate</h3>" + "<ul>{0}</ul>",
    ACCEPT_LABEL: 'Disapprove',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'SELECT_CREDIT_PACKAGE_CONFIRM_DIALOG', {
    MESSAGE: "You will be charged {0}{1} for {2} credits. Are you sure you want to continue",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'SELECT_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG', {
    MESSAGE: "You will be subscribed for {0} monthly credits. Are you sure you want to continue",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CHANGE_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG', {
    MESSAGE: "You will be subscribed for {0} monthly credits. Are you sure you want to update your current package",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'SELECT_STRIPE_SUBSCRIPTION_CONFIRM_DIALOG', {
    MESSAGE: "You will be subscribed to {0}. Do you want to continue?",
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'UNASSIGN_CANDIDATE_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to unassign this candidate?",
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'UPDATE_RATE_BASED_ON_BOOKING_SERVICE_CONFIRM_DIALOG', {
    MESSAGE: "Do you want to update the client rate and candidate rate accordingly?",
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_BREAK_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to delete this break?",
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BULK_CHARGE_CLIENT_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>Are you sure you want to charge clients for the following jobs?</h3>\n        <ul>{0}</ul>',
    ACCEPT_LABEL: "Charge",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BULK_INVOICE_STRIPE_CLIENT_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>Are you sure you want to send invoice to clients through Stripe for the following jobs?</h3>\n        <ul>{0}</ul>',
    ACCEPT_LABEL: "Send Invoice",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BULK_CHARGE_PAYOUT_STRIPE_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>Are you sure you want to charge clients and payout candidates through Stripe for the following jobs?</h3>\n        <ul>{0}</ul>',
    ACCEPT_LABEL: "Transfer",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BULK_COPY_SUGGESTED_CHARGE_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>Are you sure you want to copy suggested charge to total client charge for the following jobs?</h3>\n        <ul>{0}</ul>',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'SHARE_JOB_MARKET_PLACE_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>Are you sure you want to share this job to the agency marketplace with the following fee?</h3>\n        <ul>{0}</ul>',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CLOSE_VIEW_TAB_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to close the view {0}',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_TODO_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete this To Do?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_BENEFIT_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete the benefit {0}?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'TRANSER_MONEY_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to send {0}{1} to {2}? ',
    ACCEPT_LABEL: 'Yes',
    REJECT_LABEL: 'No'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'MARK_JOB_COMPLETED_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to mark this job as completed?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_PACKAGE_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete this package?',
    ACCEPT_LABEL: 'Delete',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'REPORT_PROBLEM_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to report the problem?',
    ACCEPT_LABEL: "Report",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'COPY_FIELD_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to copy data from {0} to {1}?',
    INNER_HTML: '<h3>Are you sure you want to copy data?</h3>\n        <h4>From Field: {0}</h4>\n        <h4>To Field: {1}</h4>\n        <h5>All of the existing data of {1} will be overwritten</h5>',
    ACCEPT_LABEL: "Copy",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'CANCEL_SCHEDULE_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to cancel the email?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_REVIEW_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete this review?',
    ACCEPT_LABEL: 'Delete',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_BLOCK_TEXT_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete this block of text?',
    ACCEPT_LABEL: 'Delete',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_STRIPE_ACCOUNT_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete stripe account of this user?',
    ACCEPT_LABEL: 'Delete',
    REJECT_LABEL: 'Cancel'
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DEDUPLICATE_CHILDREN_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to remove duplicated children?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'HIDE_FIELD_FROM_CLIENT_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to hide this field from client?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'SHOW_FIELD_TO_CLIENT_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to show this field to client?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BOOKING_IN_PAST_DATE_CONFIRM_DIALOG', {
    MESSAGE: 'Booking is in a past date. Do you want to continue?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'RESTORE_RESOURCE_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to restore the {0}?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'PERMANENT_DELETE_RESOURCE_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to permanently delete the {0}?',
    ACCEPT_LABEL: "Delete",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BULK_DELETE_RESOURCE_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete {0} selected {1}?',
    ACCEPT_LABEL: "Delete",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'BULK_SHIFT_JOB_UPDATE_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to update {0} jobs",
    ACCEPT_LABEL: "Update",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'INVALID_INPUT_WARNING_CONFIRM_DIALOG', {
    INNER_HTML: '\n        <h2>Warning, you have not filled some required fields</h2>\n        <h4 class="error-message main-message">\n        These are the missing fields:\n        </h4>\n        <ul>{0}</ul>\n        <h5 class="mt-2">Click Continue to ignore the warning</h5>\n        ',
    ACCEPT_LABEL: "Continue",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'SEND_REPEAT_BLAST_TEMPLATE_CONFIRM_DIALOG', {
    INNER_HTML: '\n        <h2>Are you sure you want to send repeated {0} to {1}</h2>\n        <h5>Template: {2}</h5>\n        <h5>Repeat every {3} days {4}</h5>',
    ACCEPT_LABEL: "Send",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DUPLICATE_FIELD_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to duplicate the field?',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_FIELD_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete this field?',
    ACCEPT_LABEL: "Delete",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'DELETE_PROFILE_FIELD_CONFIRM_DIALOG', {
    MESSAGE: 'Are you sure you want to delete this field? This will delete it from the profile overall (not just for this one person!)',
    ACCEPT_LABEL: "Delete",
    REJECT_LABEL: "Cancel"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'MAKE_FIELD_VISIBLE_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to set this field to be visible to client",
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'MAKE_FIELD_HIDDEN_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to set this field to be hidden from client",
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'HIDE_BENEFIT_CONFIRM_DIALOG', {
    MESSAGE: "Are you sure you want to hide this benefit for your agency",
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _defineProperty(_CHANGE_QUESTION_MODE, 'ASSIGN_JOB_DETAIL_CONFIRM_DIALOG', {
    INNER_HTML: '<h3>Are you sure you want to {0} the job to the candidate?</h3>\n        <p>Job: {1}</p>\n        <p>Poster: {2}</p>\n        <p>Candidate: {3}</p>',
    ACCEPT_LABEL: "Yes",
    REJECT_LABEL: "No"
}), _CHANGE_QUESTION_MODE);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requiredValues = __webpack_require__(58);

exports.default = {
    NETWORK_ERROR: {
        TITLE: "Network Error",
        MESSAGE: "Please check your internet connection and make sure it is good. If it seems fine please wait a couple of minutes, close this message and try again (do not refresh or you may lose what you entered)."
    },
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: 'Missing field for Email Address',
        MESSAGE: 'Please add at least 1 field for email address!'
    },
    INVALID_INPUT_ERROR: {
        INNER_HTML: "\n        <h2>A required field is missing or a field is invalid.</h2>\n        <h4 class=\"error-message main-message\">\n        Please review the form for error messages!\n        </h4>\n        <h5>{0}</h5>\n        "
    },
    LOGIN_MISSING_EMAIL_ERROR: {
        TITLE: 'Email address is missing',
        MESSAGE: 'Please input email address!'
    },
    LOGIN_MISSING_PASSWORD_ERROR: {
        TITLE: 'Password is missing',
        MESSAGE: 'Please input password!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Booking time is missing',
        MESSAGE: 'Please add booking time (Start Time and End Time)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'A document is not signed',
        MESSAGE: 'Please review the form for error messages and sign all documents!'
    },
    MISSING_EVALUATION_ERROR: {
        TITLE: 'An evaluation is not complete',
        MESSAGE: 'Please review the form for error messages and complete all evaluation!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'An input field is invalid',
        MESSAGE: 'There is an input field which is invalid'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'There is no field for the builder',
        MESSAGE: 'Please add at least one field!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'Cannot use same option between {0} and {1}',
        MESSAGE: 'Please unselect option(s) {2} in {0} or {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: 'Please add more {0}!',
        MESSAGE: 'You must have at least {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Experience is lacking',
        MESSAGE: 'You must have at least 1 experience.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Statuses is lacking',
        MESSAGE: _requiredValues.LIST_REQUIRED_STATUSES.join(" and ") + " are required statuses"
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some statuses which are duplicated'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Multi fields using the same model',
        MESSAGE: 'There is a model which is assigned to at least 2 fields'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some items which are duplicated'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'Employer type is duplicated',
        MESSAGE: 'There are some employer type which are duplicated'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'Candidate type is duplicated',
        MESSAGE: 'There are some candidate type which are duplicated'
    },
    DUPLICATE_JOB_TYPE_ERROR: {
        TITLE: 'Job types is duplicated',
        MESSAGE: 'There are some job types which are duplicated'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a PNG or JPG image.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a DOC or DOCX or PDF file.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: 'File is empty!',
        MESSAGE: 'Please upload a non empty file'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: 'File too big!',
        MESSAGE: 'Please upload a file with a size below the maximum upload size.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Invalid File',
        MESSAGE: 'Invalid input file'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Your professional childcare resume is missing',
        MESSAGE: 'Please upload your professional childcare resume'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'End date must be after start date',
        MESSAGE: 'Please change start date or end date'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Bookings must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Your profile picture is missing',
        MESSAGE: 'Please upload a recent photo of yourself!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'No text selected',
        MESSAGE: 'Please select some text'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Your application has been submitted! BUT',
        MESSAGE: 'There was an error processing your references. Can you please email them to us? Thanks!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Failed to submit your application',
        MESSAGE: 'There was an error processing your application'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Missing item in status list',
        MESSAGE: 'Status {0} is required'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'There is an incomplete section',
        MESSAGE: 'Section {0} is incomplete. Please update that section'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Passwords do not match.'
    },
    INVALID_PHONE_NUMBER_ERROR: {
        TITLE: "Invalid phone number",
        MESSAGE: "The phone number {0} is invalid. Please correct it"
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'Unable to find nearby Candidates',
        MESSAGE: 'Job is missing a full address. To search for candidates Edit Job and fill missing address info'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'The profile builder is in used',
        MESSAGE: 'The profile builder is being used by the profile builder {0}.\n' + 'Please remove that profile builder first'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'A signature is missing',
        MESSAGE: 'Please type your name to sign'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'A required field is missing',
        MESSAGE: 'Please fill all of the required fields (Please check the red border fields)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: "\n        <h2>It looks like you are already in our system!</h2>\n        <h4 class=\"error-message main-message\">\n        Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!\n        </h4>\n        "
    },
    FORCE_LOGOUT_ERROR_DIALOG: {
        TITLE: 'You were logged out!',
        MESSAGE: 'Sorry, you were logged out by a log into this account by another device.'
    },
    WEEK_AVAILABILITY_BLOCK_END_TIME_BEFORE_START_TIME_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time of block {0} of {1}'
    },
    WEEK_AVAILABILITY_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Block must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time of block {1} of {2}'
    },
    WEEK_AVAILABILITY_EMPTY_REQUIRED_FIELD_ERROR: {
        TITLE: 'Empty required field',
        MESSAGE: 'Please fill both start time and end time of block {0} of {1}'
    },
    PAYMENT_INFORMATION_REQUIRED: {
        TITLE: "Payment Information is required",
        MESSAGE: "Please input payment information"
    },
    INVALID_PAYMENT_INFORMATION: {
        TITLE: "Invalid Payment Information",
        MESSAGE: "Please update payment information: {0}"
    },
    PAYMENT_INFORMATION_INVALID: {
        TITLE: "Invalid Payment Information",
        MESSAGE: "Please update payment information"
    },
    LIST_INPUT_CONTAINS_BLANK: {
        TITLE: "{0} contains blank value",
        MESSAGE: "Please remove the blank {0}"
    },
    DUPLICATE_HEADER_IMPORT_CSV: {
        TITLE: "There are some duplicated headers.",
        MESSAGE: "List of duplicate headers: {0}.\nIf the duplicated headers are imported, the corresponding fields may not be imported"
    },
    CANNOT_EDIT_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Cannot Edit the Booking",
        MESSAGE: "Sorry, changed cannot be made less than {0} hours before a job starts. If you require a change, please contact us directly. Thank you!"
    },
    CANNOT_ADD_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Cannot Add the Booking",
        MESSAGE: "Sorry, cannot book less than {0} hours before a job starts. If you really need this, please contact us directly. Thank you!"
    },
    PAYMENT_FIELD_REQUIRED_IN_APPLICATION_FORM: {
        TITLE: "Payment field is required",
        MESSAGE: "Please add payment field to be able to charge user when submit application form"
    },
    MISSING_NUMBER_OF_ROWS: {
        TITLE: 'Please specify number of rows for partial import'
    },
    SCHEDULE_CONFLICT_CANDIDATE_ERROR_DIALOG: {
        TITLE: "Schedule conflict",
        MESSAGE: "You are already assigned to another job during that time"
    },
    JOB_NO_LONGER_AVAILABLE_ERROR_DIALOG: {
        TITLE: "This job is no longer available"
    },
    CLIENT_CONFIRM_INCORRECT_PASSWORD: {
        TITLE: "Incorrect password",
        MESSAGE: "Failed to approve the clock in/out time. Client password is incorrect"
    },
    HAS_MISSING_SECTION_BUILDER_ERROR_DIALOG: {
        TITLE: "There is a missing section builder",
        MESSAGE: "The profile builder was imported successfully. However, there is a missing selection of the section builder (field label: {0}). Please Edit the builder to correct it"
    },
    CLOCK_OUT_CLIENT_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Thanks!",
        MESSAGE: "Client did not input payment information. We will process the payment later.\n" + " If there were any issues with recording the time, or anything else, please let us know."
    },
    CLOCK_OUT_CANDIDATE_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Thanks!",
        MESSAGE: "Candidate did not input payment information. We will process the payment later. Please input your payment information to get paid through Stripe\n" + " If there were any issues with recording the time, or anything else, please let us know."
    },
    CLOCK_OUT_MISSING_PAYMENT_INFORMATION: {
        TITLE: "Thanks!",
        MESSAGE: "Missing payment information. We will process the payment later.\n" + " If there were any issues with recording the time, or anything else, please let us know."
    },
    SCHEDULE_TIME_IN_PAST: {
        TITLE: "The specified time is in the past. Please select another time"
    },
    ACTION_MISSING_DATE_FIELD: {
        TITLE: "Please select date"
    },
    APPLICATION_FORM_DUPLICATED_PHONE: {
        TITLE: "Warning!",
        MESSAGE: "Your phone number is already in the system, have you worked with us before? If so, please contact us and we can help you access your existing account!"
    },
    APPLICATION_FORM_DUPLICATED_EMAIL: {
        TITLE: "Warning!",
        MESSAGE: "Your email address is already in the system, have you worked with us before? If so, please contact us and we can help you access your existing account!"
    },
    INVALID_AMOUNT_ERROR: {
        TITLE: "Invalid amount"
    },
    NON_NUMBER_INPUT_ERROR: {
        TITLE: "Please input a number"
    },
    SEND_EMAIL_TOO_LONG_DURATION_ERROR_DIALOG: {
        TITLE: "Scheduling more than 8 hours is not supported"
    },
    APPLICATION_FORM_USER_SUBMITTED: {
        TITLE: "User submitted the application form"
    },
    APPLICATION_FORM_USER_INCORRECT_USER_ID: {
        TITLE: "Incorrect user id",
        MESSAGE: "Please contact your agency to get the correct URL"
    },
    NO_JOB_POSTER_ERROR_DIALOG: {
        TITLE: "Job has no poster information"
    },
    RETURNING_APPLICANT_EMAIL_NOT_FOUND: {
        TITLE: "Email Address is not found",
        MESSAGE: "Sorry, we could not find this in our system. Please try a different email or contact us if you have any questions"
    },
    RETURNING_APPLICANT_INCORRECT_CODE: {
        TITLE: "Incorrect Code",
        MESSAGE: "The inputted verification code is incorrect. Please try again later"
    },
    SHIFT_JOB_REPORT_IS_REQUIRED: {
        TITLE: "Shift Job Report required",
        MESSAGE: "Please submit shift job report before clocking out"
    },
    TIMEOFF_REQUEST_ON_ASSIGNED_DATES_ERROR: {
        TITLE: "Failed to submit timeoff request",
        MESSAGE: "You are assigned to a job on {0}! Please contact us directly if you need time off then."
    },
    NOT_ALLOW_MOVE_FIELD_ERROR_DIALOG: {
        TITLE: "Cannot move that field",
        MESSAGE: "That is a special field, and cannot be moved in the application form"
    },
    INVALID_LINK_ERROR_DIALOG: {
        TITLE: "The link is invalid"
    },
    MISSING_DATE_OF_ADDITIONAL_DATES_ERROR_DIALOG: {
        TITLE: "Missing date of additional dates",
        MESSAGE: "Please specify date of each additional dates"
    },
    CAPTCHA_NOT_COMPLETED: {
        TITLE: "Please complete the Captcha"
    }
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Thank you for your application to join our team!',
        MESSAGE: 'We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Thank you for your information!',
        MESSAGE: 'The reference information you submitted is very important for us. You can safely close this window now.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: '\n        <h2>Thank you for submitting your registration!</h2>\n        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>\n        '
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Thanks for letting us know, we will be in touch with you shortly!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: '\n        <h2>Video is uploaded successfully!</h2>\n        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class="material-icons" style=\'position: absolute;\'>refresh</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;) button</h5>\n        '
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Section Saved',
        MESSAGE: 'Saved {0} section!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Family Form Updated',
        MESSAGE: 'Updated Family Form successfully'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Status updated.'
    },
    STATUS_UPDATED_RESULT_DIALOG_WITH_NO_EMAIL_TEMPLATE: {
        INNER_HTML: '<h2>Status Updated</h2>\n        <h5>Would you like to trigger an email on a change to this status? <button class="btn btn-secondary" id="add-template-button">Add email</button></h5>'
    },
    STATUS_UPDATED_REFUND_RESULT_DIALOG: {
        TITLE: 'Status updated. Refund to client 1 credit'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Broadcast sent!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
        MESSAGE: 'Please proceed to the {0} notification.'
    },
    NANNY_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!'
    },
    NANNY_ASSIGNED_CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned and Client charged!',
        MESSAGE: 'Please proceed to the {0} notification.'
    },
    NANNY_ASSIGNED_CLIENT_CHARGED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: 'Candidate assigned and Client charged!'
    },
    NANNY_BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Candidate assigned to the selected jobs",
        MESSAGE: "Please proceed to the {0} notification."
    },
    NANNY_BULK_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: "Candidate assigned to the selected jobs"
    },
    BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Candidates assigned"
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Job updated!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: 'Job created!'
    },
    JOB_ACCEPTANCE_TYPE_RESULT_DIALOG: {
        TITLE: 'Acceptance Type updated'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client charged and job status updated!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    CLIENT_CHARGED_STRIPE_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    CLIENT_CHARGED_AUTHORIZE_NET_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Authorize.Net!'
    },
    BULK_JOBS_CHARGED_RESULT_DIALOG: {
        TITLE: 'Clients charged and jobs status updated!'
    },
    BULK_JOBS_CHARGED_WARNING_RESULT_DIALOG: {
        INNER_HTML: '<h2>Clients charged and jobs status updated!</h2>\n        <div>Failed to charge the following bookings</div>\n        <ul>{0}</ul>'
    },
    BULK_INVOICE_RESULT_DIALOG: {
        TITLE: "Clients Invoiced!"
    },
    BULK_TRANSFER_RESULT_DIALOG: {
        TITLE: "Clients charged and candidate paid and jobs status updated!"
    },
    BULK_TRANSFER_WARNING_RESULT_DIALOG: {
        INNER_HTML: '<h2>Clients charged and candidate paid and jobs status updated!</h2>\n       {0}'
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Message sent.'
    },
    MESSAGE_SCHEDULED_SEND_RESULT_DIALOG: {
        TITLE: 'Message is scheduled to send'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Password has been reset successfully.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been saved successfully.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been deleted successfully.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documents uploaded.',
        MESSAGE: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Your document has been signed.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Your document has been saved.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'The additional information of the document {0} is updated'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Template created.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Template updated'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Template deleted'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Template duplicated.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Password reset',
        MESSAGE: 'Password reset to {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Profile builder updated'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Email footer is saved'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Notification settings saved'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Additional admin settings saved'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Manager updated.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrator added'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrator updated'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrator deleted'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Locations updated'
    },
    BULK_DATA_UPDATED_RESULT_DIALOG: {
        TITLE: '{0} updated'
    },
    BULK_DATA_ADDED_RESULT_DIALOG: {
        TITLE: '{0} Added'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Language updated'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Broadcast sent to {0} candidates!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Job views',
        MESSAGE: 'Number of times viewed: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: 'Blast Off!',
        MESSAGE: "Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: 'Note saved!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} saved, please add another one!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Thanks for letting us know!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Congrats, you've accepted this job!",
        MESSAGE: 'All the details will appear in your dashboard under "My Jobs".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'Visibility scope of the {0} is updated to {1}'
    },
    CHECK_FORM_UPDATED: {
        TITLE: '{0} check form is updated'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Changes Saved!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Price Created.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Price Updated.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Price Deleted.'
    },
    BULK_RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidates to Client links created!'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link created!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Offer Updated!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for leaving a review!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Marked as favorite!',
        MESSAGE: 'We will do our best to match you with them in the future.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Thank you for letting us know.',
        MESSAGE: 'We will do our best to connect you with others in the future'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for submitting your payment information!'
    },
    PACKAGE_SELECTED_RESULT_DIALOG: {
        TITLE: 'Your package has been selected, thanks!',
        MESSAGE: "Our search is underway, we'll be in touch soon!"
    },
    EVALUATION_CREATED_RESULT_DIALOG: {
        TITLE: "Evaluation created."
    },
    EVALUATION_UPDATED_RESULT_DIALOG: {
        TITLE: "Evaluation updated."
    },
    EVALUATION_DELETED_RESULT_DIALOG: {
        TITLE: "Evaluation deleted."
    },
    QUESTION_CREATED_RESULT_DIALOG: {
        TITLE: "Question created."
    },
    BLOCKTEXT_CREATED_RESULT_DIALOG: {
        TITLE: "Block of text created"
    },
    QUESTION_UPDATED_RESULT_DIALOG: {
        TITLE: "Question updated."
    },
    BLOCKTEXT_UPDATED_RESULT_DIALOG: {
        TITLE: "Block of text updated"
    },
    QUESTION_DELETED_RESULT_DIALOG: {
        TITLE: "Question deleted."
    },
    BLOCKTEXT_DELETED_RESULT_DIALOG: {
        TITLE: "Block of text deleted"
    },
    EVALUATION_ADDED_RESULT_DIALOG: {
        TITLE: "Evaluation added!"
    },
    EVALUATION_COMPLETED_RESULT_DIALOG: {
        TITLE: "{0} completed, thanks!",
        CLOSE_LABEL: "Done"
    },
    TIME_OFF_REQUEST_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Your time off request has been submitted, we'll review it and confirm when it's approved!",
        CLOSE_LABEL: "Done"
    },
    AVAILABILITY_NOTES_UPDATED_RESULT_DIALOG: {
        TITLE: "Notes updated!",
        CLOSE_LABEL: "Continue"
    },
    BUFFER_TIME_UPDATED_RESULT_DIALOG: {
        TITLE: "Buffer Time updated!"
    },
    MAX_BOOKING_NUMBER_UPDATED_RESULT_DIALOG: {
        TITLE: "Maximum number of booking per day updated!"
    },
    SCHEDULE_UPDATED_RESULT_DIALOG: {
        TITLE: "Schedule updated."
    },
    DOCUMENT_SEND_TO_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Document is sent to candidate"
    },
    DOCUMENT_MARK_AS_DRAFT_RESULT_DIALOG: {
        TITLE: "Document is marked as draft"
    },
    DOCUMENT_PUBLISH_RESULT_DIALOG: {
        TITLE: "Document is published"
    },
    DOCUMENT_UPDATED_RESULT_DIALOG: {
        TITLE: "Document is updated"
    },
    BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG: {
        TITLE: "Our apologies, we are booked up for this date! We will add you to our cancelation list and inform you of any changes ASAP.",
        CLOSE_LABEL: "Continue"
    },
    CHECKLIST_SAVED_RESULT_DIALOG: {
        TITLE: "Checklist is saved"
    },
    FEEDBACK_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Thanks, we will be in touch shortly."
    },
    FEEDBACK_SUBMITTED_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks for submitting the feedback"
    },
    USER_ALERT_BLOCKED_POPUP_DIALOG: {
        TITLE: "If a new window has not opened please check if pop-ups were blocked",
        CLOSE_LABEL: "Cancel"
    },
    CLOCK_OUT_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks!",
        MESSAGE: "If there were any issues with recording the time, or anything else, please let us know.",
        CLOSE_LABEL: "Done"
    },
    CLOCK_OUT_TRANSFER_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks!",
        MESSAGE: "You will be paid directly through Stripe. If there were any issues with recording the times or anything else, please let us know.",
        CLOSE_LABEL: "Done"
    },
    CLOCK_IN_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks!",
        MESSAGE: "Don't forget to clock out when you are finished!",
        CLOSE_LABEL: "Done"
    },
    SCHEDULE_RELEASED_RESULT_DIALOG: {
        TITLE: "The schedule has been released!"
    },
    EVENT_BOOKED_RESULT_DIALOG: {
        TITLE: "Event booked!"
    },
    DOCUMENT_ADDED_RESULT_DIALOG: {
        TITLE: "Document added!"
    },
    MAILCHIMP_ADDED_RESULT_DIALOG: {
        TITLE: "Successfully subscribed to Mailchimp List!"
    },
    TENTATIVE_ASSIGN_RESULT_DIALOG: {
        TITLE: "Nanny tentatively assigned."
    },
    TENTATIVE_ASSIGN_HAS_BIG_RED_BTN_RESULT_DIALOG: {
        TITLE: "Nanny tentatively assigned.",
        MESSAGE: "Nobody has been notified, they will be when you push the big red button"
    },
    SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} information submitted",
        MESSAGE: "Thank you for submitting {0} information. Please close the window or submit another {1}"
    },
    USER_SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} information submitted",
        MESSAGE: "Thank you for submitting {0} information. Please close the window"
    },
    CANDIDATE_SELECTED_RESULT_DIALOG: {
        TITLE: "Thank you for selecting candidate"
    },
    CLOCK_IN_OUT_APPROVED_RESULT_DIALOG: {
        TITLE: "Clock in and clock out times are approved"
    },
    CLOCK_IN_OUT_DISAPPROVED_RESULT_DIALOG: {
        TITLE: "Clock in and clock out times are disapproved"
    },
    PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '{0} Credits added, thanks!'
    },
    MONTHLY_PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '{0} Monthly Credits added, thanks!'
    },
    STRIPE_SUBSCRIPTION_SELECTED_RESULT_DIALOG: {
        TITLE: "Subscription started, thank you!"
    },
    UNASSIGN_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Candidate unassigned"
    },
    SAVED_ADVANCE_SEARCH_RESULT_DIALOG: {
        TITLE: "Saved advance search"
    },
    BOOKING_ADDED_RESULT_DIALOG: {
        TITLE: "Booking added"
    },
    JOB_TIP_ADDED_RESULT_DIALOG: {
        TITLE: "Tip added"
    },
    BULK_COPY_SUGGESTED_CHARGE_RESULT_DIALOG: {
        TITLE: "Copied Suggested Charge to Total Client Charge"
    },
    CANDIDATES_NO_LONGER_AVAILABLES: {
        TITLE: 'The selected candidate is no longer available',
        MESSAGE: 'The selected candidate ({0}) is no longer available. Please select another candidate',
        CLOSE_LABEL: 'OK'
    },
    RESELECT_JOB_FILLER_RESULT_DIALOG: {
        TITLE: "Booking date/time is changed. Please reselect candidate for the booking",
        CLOSE_LABEL: "OK"
    },
    REQUEST_TIMEOFF_APPROVED_RESULT_DIALOG: {
        TITLE: "Request approved"
    },
    REQUEST_TIMEOFF_DECLINED_RESULT_DIALOG: {
        TITLE: "Request declined"
    },
    MARK_SELECTED_TASK_COMPETED_RESULT_DIALOG: {
        TITLE: "Marked selected tasks as complete"
    },
    SCRAPER_STATUS_RESULT_DIALOG: {
        TITLE: "This may take a few minutes, please continue what you are doing and refresh in a few minutes."
    },
    SHIFT_JOB_REPORT_SUBMITTED: {
        TITLE: "{0} report submitted successfully"
    },
    MANUAL_TRANSFER_SUCCESS: {
        TITLE: "Transfer successfully",
        MESSAGE: "Transfer ID: {0}"
    },
    EMAIL_SENT_RESULT_DIALOG: {
        TITLE: "Emails sent"
    },
    MARK_JOB_COMPLETED_RESULT_DIALOG: {
        TITLE: "Marked job as completed"
    },
    PACKAGE_CREATED_RESULT_DIALOG: {
        TITLE: "Package created."
    },
    PACKAGE_UPDATED_RESULT_DIALOG: {
        TITLE: "Package updated."
    },
    PACKAGE_DELETED_RESULT_DIALOG: {
        TITLE: "Package deleted."
    },
    TIP_CHARGE_RESULT_DIALOG: {
        TITLE: "Your tip has been sent to {0}, thank you so much!"
    },
    REPORT_PROBLEM_RESULT_DIALOG: {
        TITLE: "Problem is reported successfully"
    },
    COPY_USER_FIELD_RESULT_DIALOG: {
        TITLE: "Fields are copied successfully",
        MESSAGE: "Data is copied from {0} to {1}"
    },
    CANCEL_EMAIL_RESULT_DIALOG: {
        TITLE: "Email is cancelled"
    },
    REVIEW_DELETED_RESULT_DIALOG: {
        TITLE: "Review deleted."
    },
    NEED_AGENCY_PHONE_RESULT_DIALOG: {
        TITLE: "You don't have SMS set up yet!",
        MESSAGE: "Please contact our team to get started."
    },
    ADDITIONAL_DATE_ADDED_RESULT_DIALOG: {
        TITLE: "Booking(s) added"
    },
    INVOICE_SENT_RESULT_DIALOG: {
        TITLE: "Invoice sent"
    },
    STRIPE_ACCOUNT_DELETED: {
        TITLE: "Stripe account deleted"
    },
    SUBMITTED_MODAL_RESULT_DIALOG: {
        TITLE: "Thanks, we will be in touch shortly!"
    },
    NO_CANDIDATE_AVAILABLE_FOR_ALL_BOOKING: {
        TITLE: "There is no candidate who is available for all open bookings"
    },
    RETURNING_APPLICANT_RESULT_DIALOG: {
        TITLE: "Your previously entered information has been loaded, please continue!"
    },
    JOB_SHARE_MARKET_PLACE_RESULT_DIALOG: {
        TITLE: "Job is shared with the agency marketplace"
    },
    CANDIDATE_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Candidate is submitted to the job"
    },
    BULK_RESOURCE_DELETED_RESULT_DIALOG: {
        TITLE: "{0} {1} deleted"
    },
    REPEAT_BLASTER_BEING_SENT_RESULT_DIALOG: {
        TITLE: "{0}s are being sent"
    },
    BOOKING_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Your booking are submitted, you can close the window"
    },
    FILLED_JOB_RESULT_DIALOG: {
        TITLE: "This job has been filled!"
    }
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _EMPLOYER_STATUSES$EM;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_EMPLOYER_STATUSES$EM = {
    'EMPLOYER_STATUSES': {
        LABEL: 'Client Statuses',
        DESCRIPTION: 'Drag and drop statuses to re-order.'
    },
    EMPLOYER_STATUS_CHANGE_REASON: {
        LABEL: "Select statuses which need a reason when client status was changed to"
    },
    'CANDIDATE_STATUSES': {
        LABEL: 'Candidate Statuses',
        DESCRIPTION: 'Drag and drop statuses to re-order.'
    },
    'CANDIDATE_TYPES': {
        LABEL: 'Candidate Types',
        DESCRIPTION: 'Do you have different types/categories of candidates? Please input them here.'
    },
    'EMPLOYER_TYPES': {
        LABEL: 'Client Types',
        DESCRIPTION: 'Do you have different types/categories of clients? Please input them here.'
    },
    'CANDIDATE_TAGS': {
        LABEL: 'Candidate Taglist',
        DESCRIPTION: 'A list of tags to keep track of for candidates.'
    },
    'EMPLOYER_TAGS': {
        LABEL: 'Client Taglist',
        DESCRIPTION: 'A list of tags to keep track of for clients.'
    },
    'CANDIDATE_ADMIN_CHECKLIST': {
        LABEL: 'Candidate Admin Checklist',
        DESCRIPTION: 'A list of items to keep track of for candidates. This checklist will appear in the admin tab for each candidate. Drag and drop an item to re-order..'
    },
    'EMPLOYER_ADMIN_CHECKLIST': {
        LABEL: 'Client Admin Checklist',
        DESCRIPTION: 'A list of items to keep track of for clients. This checklist will appear in the admin tab for each client. Drag and drop an item to re-order..'
    },
    'AGENCY_LOCATIONS': {
        LABEL: 'Does your agency serve multiple distinct locations and would you like to divide the system by location? If so, please enter your different locations'
    },
    CANDIDATE_STATUS_CHANGE_REASON: {
        LABEL: "Select statuses which need a reason when candidate status was changed to"
    },
    EMPLOYER_SECOND_STATUSES: {
        LABEL: 'Client Secondary Statuses'
    },
    CANDIDATE_SECOND_STATUSES: {
        LABEL: 'Candidate Secondary Statuses'
    },
    'CANDIDATE_TABLE_FIELD': {
        LABEL: 'Fields which are showed in the Candidate table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    'EMPLOYER_TABLE_FIELD': {
        LABEL: 'Fields which are showed in the Client table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    'REFERENCE_TABLE_FIELD': {
        LABEL: 'Fields which are showed in the Reference table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    PLACEMENT_JOB_TABLE_FIELDS: {
        LABEL: 'Fields which are showed in the Placement Job table of agency dashboard',
        DESCRIPTION: 'Drag and drop fields to re-order.'
    },
    USE_ADMIN_NOTES_IN_INTAKE_NOTES: {
        LABEL: "Use admin notes in Client Intake Notes areas"
    },
    USE_ADMIN_NOTES_IN_INTERVIEW_NOTES: {
        LABEL: "Use admin notes in Candidate Intake Notes areas"
    },
    EMPLOYER_ADMIN_SHARE_VIEWS: {
        LABEL: "Use same views of employer table for all admin"
    },
    CANDIDATE_CAN_NOT_MODIFY_EXPIRE_DATE: {
        LABEL: "Candidate cannot modify expire date of document"
    },
    CANDIDATE_ADMIN_SHARE_VIEWS: {
        LABEL: "Use same views of candidate table for all admin"
    },
    'JOB_CSV_EXPORT_FIELD': {
        LABEL: 'Select Fields on Job CSV Export',
        DESCRIPTION: 'If left empty default fields will be used on exports'
    },
    'FULFILLMENT_EXCLUDE_STATUSES': {
        LABEL: 'Select Statuses to exclude for fulfillment calculation',
        DESCRIPTION: 'If left empty all statuses will be used in fulfillment calculation'
    },
    'SELECT_FIELDS_TABLE_VIEW': {
        LABEL: 'Select fields of table view',
        DESCRIPTION: 'If left empty default fields will be used on table'
    },
    'REVERSE_DEFAULT_DATE_SORT_ORDER_SHIFT_JOB_CALENDAR_TABLE_VIEW': {
        LABEL: 'Sort shift jobs in order of ascending date (old to new)'
    },
    'SHIFT_JOB_PAST_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the past to load job in Shift Job Calendar',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'SHIFT_JOB_FUTURE_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the future to load job in Shift Job Calendar',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'CANDIDATE_MY_JOBS_PAST_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the past to load job in My Job',
        DESCRIPTION: 'If not specified, the default value is 14'
    },
    'CANDIDATE_MY_JOBS_FUTURE_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the future to load job in My Job',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'CANDIDATE_MY_SCHEDULE_PAST_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the past to load job in My Schedule',
        DESCRIPTION: 'If not specified, the default value is 14'
    },
    'CANDIDATE_MY_SCHEDULE_FUTURE_DATE_RANGE_FILTER': {
        LABEL: 'Number of days in the future to load job in My Schedule',
        DESCRIPTION: 'If not specified, the default value is 28'
    },
    'CANDIDATE_TABLE_SEARCH_FIELD': {
        LABEL: 'Quick search field for Candidate table of agency dashboard'
    },
    'EMPLOYER_TABLE_SEARCH_FIELD': {
        LABEL: 'Quick search field for Client table of agency dashboard'
    },
    'CANDIDATE_DEFAULT_SORT_FIELD': {
        LABEL: 'Default sort field for Candidate table of agency dashboard'
    },
    'EMPLOYER_DEFAULT_SORT_FIELD': {
        LABEL: 'Default sort field for Client table of agency dashboard'
    },
    'CANDIDATE_LAST_LOGIN_RETRIEVAL_DAYS': {
        LABEL: 'Number of last login retrieval days for Candidate table of agency dashboard'
    },
    'EMPLOYER_LAST_LOGIN_RETRIEVAL_DAYS': {
        LABEL: 'Number of last login retrieval days for Client table of agency dashboard'
    },
    'USER_STATUS_STATISTICAL_BREAKDOWN': {
        LABEL: 'Show user status statistical breakdowns'
    },
    HAS_SECOND_ADMIN_MANAGER: {
        LABEL: "Has Second Admin Manager"
    },
    LABEL_OF_ADMIN_MANAGER: {
        LABEL: "Label of Admin Manager"
    },
    STATUSES_INCLUDED_CANDIDATE_STATISTICS: {
        LABEL: 'Statuses to include in candidate status statistics'
    },
    STATUSES_INCLUDED_EMPLOYER_STATISTICS: {
        LABEL: 'Statuses to include in employer status statistics'
    },
    LABEL_OF_SECOND_ADMIN_MANAGER: {
        LABEL: "Label of Second Admin Manager"
    },
    'CANDIDATE_EACH_TYPE_COLOR': {
        LABEL: 'Color for each type in Candidate table'
    },
    'EMPLOYER_EACH_TYPE_COLOR': {
        LABEL: 'Color for each type in Client table'
    },
    'CANDIDATE_EACH_TAG_COLOR': {
        LABEL: 'Color for each tag in Candidate table'
    },
    'EMPLOYER_EACH_TAG_COLOR': {
        LABEL: 'Color for each tag in Client table'
    },
    'CANDIDATE_EACH_STATUS_COLOR': {
        LABEL: 'Color for each status in Candidate table'
    },
    'CANDIDATE_EACH_STATUS_APPLICATION_COLOR': {
        LABEL: 'Color for each status in applications table'
    },
    'EMPLOYER_EACH_STATUS_COLOR': {
        LABEL: 'Color for each status in Client table'
    },
    'PLACEMENT_JOB_TYPES_FIELD': {
        LABEL: 'Placement Job Types',
        DESCRIPTION: 'Do you have different types/categories of jobs? Please input them here.'
    },
    'PLACEMENT_JOB_STATUSES_FIELD': {
        LABEL: 'Placement Job Statuses',
        DESCRIPTION: 'Statuses that a placement (long term) job can have'
    },
    'SHIFT_JOB_STATUSES_FIELD': {
        LABEL: "Shift Job Statuses",
        DESCRIPTION: 'Statuses that a shift (short term) job can have'
    },
    REASON_FOR_CANCELLATION_SHIFT_JOB: {
        LABEL: "Reason for Cancellation Shift Job"
    },
    SHIFT_JOB_STATUSES_DO_NOT_BLOCK_AVAILABILTIY: {
        LABEL: "Shift job statuses which do not block an assigned candidate’s availability"
    },
    DO_NOT_ASK_FOR_REASON_CANCELLING_SHIFT_JOB: {
        LABEL: "Do not ask for reason when client cancels shift job"
    },
    'CANDIDATE_STATUS_TO_HIDE_DASHBOARD': {
        LABEL: 'Candidates in these Statuses will be hidden in the Candidates dashboard table.'
    },
    'EMPLOYER_STATUS_TO_HIDE_DASHBOARD': {
        LABEL: 'Clients in these statuses will be hidden in the Clients dashboard table.'
    },
    SHOW_CANDIDATE_DIALOG_IN_RIGHT_PANEL: {
        LABEL: "Do not show candidate dialog in full screen"
    },
    SHOW_EMPLOYER_DIALOG_IN_RIGHT_PANEL: {
        LABEL: "Do not show client dialog in full screen"
    },
    'EVALUATION_BUILDER_OUTCOME': {
        LABEL: 'Enable candidates to see outcome of evaluation'
    },
    'REQUEST_TIME_OFF_CATEGORIES': {
        LABEL: 'Time Off Request Categories'
    },
    'CANDIDATE_TOGGLE_TABLE_VIEW': {
        LABEL: 'Make candidate view of available jobs default to "Table view"'
    },
    'DO_NOT_SHOW_DUPLICATED_DOCUMENTS': {
        LABEL: 'Do not show duplicated document templates when updating status'
    },
    DEFAULT_FILTER_CANDIDATE_STATUS_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate statuses for shift job broadcast"
    },
    DEFAULT_FILTER_CANDIDATE_TYPES_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate types for shift job broadcast"
    },
    INITIAL_FILTER_LOCATION_BY_CLIENT_LOCATION: {
        LABEL: "Pre-set location in the location filter by job poster's location"
    },
    DEFAULT_FILTER_CANDIDATE_TAGS_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate tags for shift job broadcast"
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_ALREADY_BOOKED: {
        LABEL: "When broadcasting shift job, check 'Already booked at this time' option by default"
    },
    DISABLE_SHIFT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST: {
        LABEL: "Disable distance based search for shift jobs by default"
    },
    DISABLE_PLACEMENT_JOB_DEFAULT_DISTANCE_SEARCH_ON_BROADCAST: {
        LABEL: "Disable distance based search for placement jobs by default"
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_TIME_OFF: {
        LABEL: "When broadcasting shift job, check 'Who have time off at this time' option by default"
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NOT_AVAILABLE: {
        LABEL: "When broadcasting shift job, check 'Who are not available at this time' option by default"
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_NO_MATCHING_TAG: {
        LABEL: "When broadcasting shift job, check 'Who's tags don't match' option by default"
    },
    HIDE_CANDIDATES_SHIFT_JOB_BROADCAST_DO_NOT_MATCH_LIST: {
        LABEL: "When broadcasting shift job, check 'Who are on Do Not Match list' option by default"
    },
    DEFAULT_JOB_STATUS_SHIFT_JOB_CALENDAR: {
        LABEL: "Select default filter job statuses for Shift Job Calendar"
    },
    USE_MODAL_IN_APPLICATION_FORM: {
        LABEL: "Use pop up windows for adding information (eg. references, children, etc.) in application form"
    },
    DISBABLE_CONFIRM_CANCAL_POPUP_APPLICATION_FORM: {
        LABEL: "Disable confirm for cancelling popup in application form"
    },
    SHOW_MINIMUM_ENTRIES_REQUIRED_APPLICATION_FORM: {
        LABEL: "Show minimum number of entries (eg: references, children, etc.) in application form by default"
    },
    SELECT_FIELDS_MY_JOBS_TABLE: {
        LABEL: 'Select fields of "My Jobs" Table',
        DESCRIPTIONS: "If left empty default fields will be used on table"
    },
    CANDIDATE_CUSTOM_CLOCKOUT_MESSAGE: {
        LABEL: "Custom message for candidates on clockout"
    },
    HAS_REPORT_PROBLEM_BUTTON: {
        LABEL: "Has a button to let candidate report a problem for assigned shift job"
    },
    REPORT_PROBLEM_BUTTON_TEXT: {
        LABEL: "Text of the report problem button"
    },
    REPORT_PROBLEM_UPLOAD_FILE_LABEL: {
        LABEL: "Label of the upload files field in report problem dialog"
    },
    REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION: {
        LABEL: "Description of the upload files field in report problem dialog"
    },
    REPORT_PROBLEM_NOTE_LABEL: {
        LABEL: "Label of the note field in report problem dialog"
    },
    REPORT_PROBLEM_NOTIFICATION_EMAILS: {
        LABEL: "Notification emails when candidate report problem"
    },
    REPORT_PROBLEM_NEW_JOB_STATUS: {
        LABEL: "Job status to change to when candidate report problem",
        DESCRIPTION: "If don't change status, let it blank"
    },
    CLIENT_HAS_REPORT_PROBLEM_BUTTON: {
        LABEL: "Has a button to let client report a problem for posted shift job"
    },
    CLIENT_REPORT_PROBLEM_NOTIFICATION_EMAILS: {
        LABEL: "Notification emails when client report problem"
    },
    CLIENT_REPORT_PROBLEM_NEW_JOB_STATUS: {
        LABEL: "Job status to change to when client report problem",
        DESCRIPTION: "If don't change status, let it blank"
    },
    CUSTOM_CONFIRM_TEXT_ACCEPT_JOB: {
        LABEL: "Custom warning text before candidate accepts shift job"
    },
    CUSTOM_CONFIRM_TEXT_ACCEPT_JOB_BUTTON: {
        LABEL: 'Custom "Accept Job" button text'
    },
    CANDIDATE_CAN_MARK_CLIENT_AS_FAV: {
        LABEL: 'Candidates can mark clients as "Favorite"'
    },
    CANDIDATE_CAN_MARK_CLIENT_AS_DO_NOT_WANT_AGAIN: {
        LABEL: 'Candidates can mark clients as "Do not want again"'
    },
    EMPLOYER_CSV_EXPORT_SETTINGS: {
        LABEL: "Select Employer Fields on User Export",
        DESCRIPTION: "Drag and drop to reorder columns on the CSV"
    },
    EXPORT_DURATION_STATUS: {
        LABEL: "Select status to calculate Time in Status column"
    },
    CANDIDATE_CSV_EXPORT_SETTINGS: {
        LABEL: "Select Candidate Fields on User Export",
        DESCRIPTION: "Drag and drop to reorder columns on the CSV"
    },
    EMPLOYER_ANALYTICS_DASHBOARD_FIELDS: {
        LABEL: "Select default fields of analytics dashboard for client"
    },
    PLACEMENT_JOB_ANALYTICS_DASHBOARD_FIELDS: {
        LABEL: "Select default fields of analytics dashboard for placement job"
    },
    CANDIDATE_ANALYTICS_DASHBOARD_FIELDS: {
        LABEL: "Select default fields of analytics dashboard candidate"
    },
    QUICK_SEARCH_FIELDS_SHIFT_JOB_CALENDAR: {
        LABEL: "Quick search field for Shift Job Calendar"
    },
    INCLUDE_CANCELLING_REASON_CANDIDATE_EMAIL_SHIFT_JOB: {
        LABEL: "Include Cancellation Reason In Candidate Email when client cancels shift job"
    },
    DEFAULT_FILTER_CANDIDATE_STATUS_PLACEMENT_JOB_BROADCAST: {
        LABEL: "Placement job broadcast statuses",
        DESCRIPTION: "If this is empty, all candidates will receive placement job broadcasts."
    },
    DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_SHIFT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate hide statuses for shift job broadcast"
    },
    DEFAULT_FILTER_CANDIDATE_HIDE_STATUS_PLACEMENT_JOB_BROADCAST: {
        LABEL: "Select default filter candidate hide statuses for placement job broadcast"
    },
    SEND_EMAIL_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email to client when candidate assigned to shift job"
    },
    SEND_EMAIL_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email to candidate when assigned to shift job"
    },
    SEND_SMS_TO_CLIENT_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS to client when candidate assigned to shift job"
    },
    SEND_SMS_TO_CANDIDATE_CANDIDATE_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS to candidate when assigned to shift job"
    },
    SEND_EMAIL_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email notification to client when bulk assign shift job"
    },
    SEND_EMAIL_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send email notification to candidate when bulk assign shift job"
    },
    SEND_SMS_TO_CLIENT_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS notification to client when bulk assign shift job"
    },
    SEND_SMS_TO_CANDIDATE_BULK_ASSIGNED_SHIFT_JOB: {
        LABEL: "Send SMS notification to candidate when bulk assign shift job"
    },
    DO_NOT_WARN_ABOUT_CANDIDATE_GENERAL_AVAILABILITY: {
        LABEL: "Do not warn about candidate general availability (you will still be warned about conflicts)"
    },
    SELECT_SHIFT_JOB_CALENDAR_FIELDS: {
        LABEL: "Select Fields of Shift Job Calendar"
    },
    SHIFT_JOB_CALENDAR_FIELDS_JOB_RESULT_INFO: {
        LABEL: "Select Fields of Shift Job Calendar (Job Result Information)"
    },
    CANDIDATE_STATUSES_SEE_PLACEMENT_JOBS: {
        LABEL: "Candidate statuses that can see placement jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able see placement jobs'
    },
    CANDIDATE_STATUSES_SEE_SHIFT_JOBS: {
        LABEL: "Candidate statuses that can see shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able see shift jobs'
    },

    CANDIDATE_TAGS_SEE_SHIFT_JOBS: {
        LABEL: "Candidate tags that can see shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all tags will be able see shift jobs'
    },
    CANDIDATE_TYPES_SEE_SHIFT_JOBS: {
        LABEL: "Candidate types that can see shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all types will be able see shift jobs'
    },
    CANDIDATE_STATUSES_REQUEST_WORK_SHIFT_JOBS: {
        LABEL: "Candidate statuses that can request to work shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able to express interest in shift jobs.'
    },
    DEFAULT_VIEW_AVAILABLE_SHIFT_JOB_CALENDAR: {
        LABEL: "Default view of available shift job opportunities calendar"
    },
    CANDIDATE_TYPES_REQUEST_WORK_SHIFT_JOBS: {
        LABEL: "Candidate types that can request to work shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all types will be able to express interest in shift jobs.'
    },
    CANDIDATE_SELF_ASSIGN_THEMSELVES_SHIFT_JOBS: {
        LABEL: "Candidates can self assign themselves to shift jobs"
    },
    ONLY_ALLOW_CANDIDATE_TO_SEE_MATCHING_CATEGORY: {
        LABEL: "Only allow candidates to see jobs if their types includes the job category"
    },
    ONLY_ALLOW_CANDIDATE_TO_ACCEPT_MATCHING_CATEGORY: {
        LABEL: "Only allow candidates to accept jobs if their types includes the job category"
    },
    CANDIDATE_STATUSES_ACCEPT_SHIFT_JOBS: {
        LABEL: "Candidate statuses that can accept shift jobs",
        DESCRIPTION: 'If this is empty, candidates in all statuses will be able to accept shift jobs.'
    },
    SCHEDULE_EVENT_TYPES: {
        LABEL: "Event Types"
    },
    BROADCAST_STATUSES_PLACEMENT_JOBS: {
        LABEL: "Placement job broadcast statuses",
        DESCRIPTION: 'If this is empty, all candidates will receive placement job broadcasts.'
    },
    HIDE_DISTANCE_FROM_JOB_CANDIDATE_VIEW_PLACEMENT_JOBS: {
        LABEL: 'Hide "Distance from job" when candidate views placement job'
    },
    JOB_FULL_WIDTH_BAR_STYLE_MODE: {
        LABEL: 'Job board full width bar styling (no photos and one job on one line)'
    },
    SHOW_JOB_IMAGE_IN_FULL_WIDTH_BAR_STYLE_MODE: {
        LABEL: 'Show image with job in full width bar styling mode'
    },
    SHOW_HIRED_BADGE_ON_JOB_BOARD: {
        LABEL: 'Show hired badge on job board'
    },
    SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD_SHIFT_JOB: {
        LABEL: 'Show map with shift job locations on job board'
    },
    SHOW_MAP_WITH_LOCATIONS_ON_JOB_BOARD: {
        LABEL: 'Show map with placement job locations on job board'
    },
    SHOW_NOT_INTERESTED_PLACEMENT_JOBS: {
        LABEL: 'Show "I\'m not interested" button for placement job'
    },
    SHOW_MIGHT_BE_INTERESTED_PLACEMENT_JOBS: {
        LABEL: 'Show "I might be interested" button for placement job'
    },
    NOTIFICATION_CLIENT_EXPRESS_INTEREST_CANDIDATE_PLACEMENT_JOBS: {
        LABEL: "Send notification email to client when a candidate expresses interest in their placement job"
    },
    CANDIDATE_SEE_PLACEMENT_JOBS_OUTSIDE_LOCATION: {
        LABEL: "Candidates can see placement jobs outside their location"
    },
    CANDIDATES_ACCEPT_JOB_WHEN_JOB_IS_BROADCASTED: {
        LABEL: "Candidates can accept job when job is broadcasted"
    },
    JOB_BOARD_LONG_TERM_PLACEMENT_JOBS_HEADING: {
        LABEL: "Job Board Long Term (Placement) Jobs Heading"
    },
    AVAILABLE_JOB_WITHIN_MILE_RADIUS_PLACEMENT_JOBS: {
        LABEL: "Show candidates placement jobs on the Available Job Board within this mile radius of their address",
        DESCRIPTION: 'If not specified, jobs in any distance will be showed'
    },
    EDITABLE_VIEW_DEFAULT: {
        LABEL: "Make editable view default"
    },
    SELECT_FIELDS_PLACEMENT_JOBS_DETAIL_VIEW: {
        LABEL: "Select fields for placement job detail view"
    },
    HAS_CLOCK_IN_CLOCK_OUT_BUTTON: {
        LABEL: "Hide clock in and clock out button"
    },
    MANUALLY_CLOCK_IN_CLOCK_OUT_JOBS: {
        LABEL: "Candidates manually clock in and out of jobs"
    },
    GET_USER_LOCATIONS_WHEN_CLOCK_IN_OUT: {
        LABEL: "Get candidate location clock in and out of jobs"
    },
    MINUTES_INTERVAL_CANDIDATE_CLOCK_IN_CLOCK_OUT: {
        LABEL: "Minutes Interval when candidate clock in and out"
    },
    HIDE_MILEAGE_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB: {
        LABEL: "Hide mileage question when candidate clocks out of shift job"
    },
    CHARGE_TRANSFER_PRICE_PER_MILE: {
        LABEL: "How much they get per mile"
    },
    CHARGE_TRANSFER_INCLUDE_MILEAGE: {
        LABEL: "Include mileage when charge and transfer shift job"
    },
    HIDE_REIMBURSEMENT_QUESTION_CANDIDATE_CLOCK_OUT_SHIFT_JOB: {
        LABEL: "Hide reimbursement question when candidate clocks out of shift job"
    },
    CHARGE_TRANSFER_INCLUDE_REIMBURSEMENT: {
        LABEL: "Include reimbursement when charge and transfer shift job"
    },
    CANDIDATE_ABLE_CREATE_JOBS_TO_CLOCK_IN_OUT: {
        LABEL: "Do you want candidates to be able to create jobs for themselves to clock in and out of"
    },
    CLIENT_CAN_CONFIRM_CLOCK_IN_OUT_CANDIDATE_PHONE: {
        LABEL: "Client can confirm clock in/out on the candidate’s phone"
    },
    STATUS_JOB_CLIENT_CONFIRM_CLOCK_IN_OUT_TIME: {
        LABEL: "Status of Job after client confirm clock in and clock out time"
    },
    STATUS_JOB_CLIENT_DISAPPROVE_CLOCK_IN_OUT_TIME: {
        LABEL: "Status of Job after client disapprove clock in and clock out time"
    },
    CANDIDATE_CAN_MARK_JOB_AS_COMPLETED: {
        LABEL: "Candidates can mark jobs as completed"
    },
    MARK_JOB_COMPLETED_BUTTON_TEXT: {
        LABEL: "Text of the mark job as completed button"
    },
    STATUS_JOB_CANDIDATE_MARK_COMPLETED: {
        LABEL: "Status of Job after candidate mark job as completed"
    },
    NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS: {
        LABEL: "Notify a candidate of a shift job starting in X hours",
        DESCRIPTION: "If not set, don't notify candidate before shift job starting"
    },
    METHOD_NOTIFY_CANDIDATE_SHIFT_JOB_STARTING_IN_X_HOURS: {
        LABEL: "Method to Notify",
        DESCRIPTION: "Select Method to Notify candidate via"
    },
    NOTIFY_CANDIDATE_FOR_CLOCK_IN_MINUTES: {
        LABEL: "Send a reminder to candidate X minutes after scheduled clock in time if they have not done so",
        DESCRIPTION: "If not set, don't notify candidate for clock in"
    },
    NOTIFY_CANDIDATE_FOR_CLOCK_OUT_MINUTES: {
        LABEL: "Send a reminder to candidate X minutes after scheduled clock out time if they have not done so",
        DESCRIPTION: "If not set, don't notify candidate for clock out"
    },
    METHOD_NOTIFY_CLOCK_IN_OUT: {
        LABEL: "Method to Notify Candidate for Clock In/Out",
        DESCRIPTION: "Select Method to Notify candidate via"
    },
    RECORD_BREAK_ITEMS_DURING_SHIFTS: {
        LABEL: "Add option to record break times during shifts"
    },
    CANDIDATE_CAN_SUBMIT_SHIFT_JOB_REPORT: {
        LABEL: "Candidate can submit shift job report"
    },
    SUBMIT_SHIFT_JOB_REPORT_MANDATORY_BEFORE_CLOCKOUT: {
        LABEL: "Shift job report is mandatory BEFORE clock-out"
    },
    CANDIDATE_NOT_ALLOW_REVIEW: {
        LABEL: "Don’t allow candidates to leave reviews"
    },
    SHIFT_JOB_REPORT_ADMIN_ONLY: {
        LABEL: "Shift job report is admin only"
    },
    CUSTOMIZE_SUBMIT_REPORT_BUTTON_LABEL: {
        LABEL: 'Customize "Submit Report" button label'
    },
    ADMIN_EMAIL_NOTIFICATION_SHIFT_JOB_REPORT: {
        LABEL: "Admin emails notified when shift job report submitted"
    },
    SELECT_DEFAULT_CANDIDATE_STATUSES_APPEAR_ASSIGNING_CANDIDATE: {
        LABEL: "Select candidate Statuses which appear in shift job candidate assignment dropdown"
    },
    SELECT_DEFAULT_CANDIDATE_TYPES_APPEAR_ASSIGNING_CANDIDATE: {
        LABEL: "Select candidate Types which appear in shift job candidate assignment dropdown"
    },
    PREVENT_CANDIDATE_FROM_INPUTTING_DAILY_AVAILABILITY: {
        LABEL: "Prevent candidates from inputting daily availability"
    },
    USE_TIMEOFF_CREDIT: {
        LABEL: "Use Timeoff Credit"
    },
    SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE: {
        LABEL: "Show Price Manager on administrators table"
    },
    NOTIFY_EMAILS_RECURRING_AVAILABILITY: {
        LABEL: "Emails that receive a notification when recurring availability is entered or edited"
    },
    ALLOW_CANDIDATE_TO_EDIT_RECURRING_AVAILABILITY: {
        LABEL: "Allow candidates to edit recurring availability"
    },
    NUMBER_OF_WEEKS_CANDIDATE_CANNOT_CHANGE_WEEK_AVAILABILITY: {
        LABEL: "Number of weeks in which candidate cannot change week availability?",
        DESCRIPTION: "Default value is 0"
    },
    WORD_USED_FOR_MY_PROFILE: {
        LABEL: 'Word used for "My Profile"'
    },
    WORD_USED_FOR_AVAILABLE_JOBS: {
        LABEL: 'Word used for "Available Jobs"'
    },
    WORD_USED_FOR_MY_SCHEDULE: {
        LABEL: 'Word used for "My Schedule"'
    },
    WORD_USED_FOR_MY_JOBS: {
        LABEL: 'Word used for "My Jobs"'
    },
    WORD_USED_FOR_MY_FAMILIES: {
        LABEL: 'Word used for "My Families"'
    },
    WORD_USED_FOR_SHIFT_JOB_CALENDAR: {
        LABEL: 'Word used for "Shift Job Calendar"'
    },
    WORD_USED_FOR_PLACEMENT_JOB: {
        LABEL: 'Word used for "Placement Jobs"'
    },
    WORD_USED_FOR_CANDIDATE: {
        LABEL: 'Word used for "Candidate"'
    },
    WORD_USED_FOR_CANDIDATES: {
        LABEL: 'Word used for "Candidates" (Plural)'
    },
    WORD_USED_FOR_CLIENT: {
        LABEL: 'Word used for "Client"'
    },
    WORD_USED_FOR_CLIENTS: {
        LABEL: 'Word used for "Clients" (Plural)'
    },
    CUSTOMIZE_CANDIDATE_CLIENT_RELATIONSHIP_STATUS: {
        LABEL: "Customize candidate-client relationship status"
    },
    PLACEMENT_JOB_APPLICATION_STATUS_TO_ADD_RELATIONSHIP: {
        LABEL: "Default statuses of placement job application in which a corresponding relationship will be created when adding/editing job application"
    },
    DO_NOT_AUTO_POPULATE_ADDRESS: {
        LABEL: 'Do not auto populate address'
    },
    SELECT_MINUTES_INTERVAL_BOOKING_TIME: {
        LABEL: 'Select Minutes Interval for booking time in Client Profile or Application Form'
    },
    SELECT_MINUTES_INTERVAL_SHIFT_JOB_CALENDAR: {
        LABEL: "Minutes Interval when Admins Add new Bookings in the Shift Job Calendar"
    },
    PLACEMENT_JOB_REVENUE_FIELD: {
        LABEL: "Select revenue field of placement job"
    },
    CANDIDATE_CAN_EDIT_BUFFER_TIME: {
        LABEL: "Candidates can edit buffer time"
    },
    FILLER_IN_MONTH_START_DAY: {
        LABEL: "Start day of month to calculate filler number in month"
    },
    CANDIDATE_TAGS_MATCHING_OPTIONS_SCHEDULER_VIEW: {
        LABEL: "How to use candidate tags filter in scheduler view"
    },
    CANDIDATE_TAGS_MATCHING_CANDIDATE_TABLE_SETTINGS: {
        LABEL: "How to use candidate tags filter in Candidate table"
    },
    PUBLIC_JOB_START_DATE_LABEL: {
        LABEL: "Start Date Label"
    },
    PUBLIC_JOB_END_DATE_LABEL: {
        LABEL: "End Date Label"
    },
    PUBLIC_JOB_START_TIME_LABEL: {
        LABEL: "Start Time Label"
    },
    PUBLIC_JOB_END_TIME_LABEL: {
        LABEL: "End Time Label"
    },
    JOB_STATUSES_TO_HIDE_FROM_SCHEDULER_VIEW: {
        LABEL: 'Select jobs statuses to hide from scheduler view'
    },
    DEFAULT_FILTER_CANDIDATE_TYPES_SCHEDULER_VIEW: {
        LABEL: 'Select default filter candidate types for scheduler view'
    },
    DEFAULT_FILTER_CANDIDATE_STATUSES_SCHEDULER_VIEW: {
        LABEL: 'Select default filter candidate statuses for scheduler view'
    },
    DEFAULT_FILTER_CANDIDATE_TAGS_SCHEDULER_VIEW: {
        LABEL: 'Select default filter candidate tags for scheduler view '
    },
    SHIFT_JOB_STATUS_AFTER_DRAG_DROP_TO_ASSIGN: {
        LABEL: "Shift job status after drag and drop a job to candidate in scheduler view"
    },
    USE_BOOKED_TIME_IF_NO_CLOCKED_TIME: {
        LABEL: "Use booked times if no clocked times"
    },
    CUSTOM_CONFIRM_TEXT_CLIENT_CANCEL_SHIFT_JOB: {
        LABEL: "Custom text when a client cancels a shift job"
    },
    CUSTOM_TEXT_MESSAGE_SHIFT_JOB_ACCEPTED: {
        LABEL: "Custom text message when a shift job is accepted"
    },
    DISCLAIMER_TEXT_ADDING_BOOKING: {
        LABEL: "Disclaimer text when adding a booking"
    }
}, _defineProperty(_EMPLOYER_STATUSES$EM, 'CUSTOM_CONFIRM_TEXT_CLIENT_CANCEL_SHIFT_JOB', {
    LABEL: "Custom text when a client cancels a shift job"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON', {
    LABEL: "Remove option for candidates to upload additional documents"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT', {
    LABEL: "Agency gets notified when candidate upload any document"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'REMOVE_CLIENT_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON', {
    LABEL: "Remove option for clients to upload additional documents"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SHIFT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS', {
    LABEL: 'Fields which are visible in candidate table when broadcasting a shift job',
    DESCRIPTION: 'Drag and drop fields to re-order.'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'PLACEMENT_JOB_BROADCAST_CANDIDATE_TABLE_FIELDS', {
    LABEL: 'Fields which are visible in candidate table when broadcasting a placement job',
    DESCRIPTION: 'Drag and drop fields to re-order.'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'PLACEMENT_OF_PRICE_INFO_FIELDS', {
    LABEL: 'Rearrange the order the rates appear for clients in a booking',
    DESCRIPTION: 'Drag and drop fields to re-order.'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'DEFAULT_HIDDEN_PLACEMENT_JOB_STATUSES', {
    LABEL: "Placement job statuses that are hidden from the job board"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'NOTIFY_AGENCY_USER_EDIT_DOCUMENT_ADDITIONAL_INFO', {
    LABEL: "Notify agency when user edits a document that has an expiration date"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SELECT_ZOOM_LEVEL_OF_JOB_MAP', {
    LABEL: 'Select Zoom Level of the Map',
    DESCRIPTION: 'Select a number between 1 to 20 (far to closer), Default value is 13.'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE', {
    LABEL: "Select Fields of Client Shift Job Profile"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SELECT_FIELDS_OF_CLIENT_SHIFT_JOB_PROFILE_TO_ASSIGNEE', {
    LABEL: "Select Fields of Client Shift Job Profile (Show to assignee)"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SHOW_CLIENT_PROFILE_ON_JOB_LISTING', {
    LABEL: "Show client profile on job listings"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SHOW_CLIENT_PROFILE_ON_JOB_LISTING_TO_ASSIGNEE_ONLY', {
    LABEL: "Show client profile on job listings ONLY to assigned candidate"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CANDIDATE_STATUSES_CAN_VIEW_CLIENT_PROFILE', {
    LABEL: "Candidate statuses which can view client profile",
    DESCRIPTION: "If none are selected then they all will"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CANDIDATE_TYPES_CAN_VIEW_CLIENT_PROFILE', {
    LABEL: "Candidate types which can view client profile",
    DESCRIPTION: "If none are selected then they all will"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SELECT_FIELDS_OF_SHIFT_JOB_CANDIDATE_VIEW', {
    LABEL: "Select fields of shift job for candidate view"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'STATUS_HIDDEN_PAST_DATE_SHIFT_JOB_CALENDAR', {
    LABEL: "Shift job statuses hidden for past dates on shift job calendar"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SHIFT_JOB_FIELD_TO_SHOW_TO_CANDIDATE', {
    LABEL: "Shift job fields to show to candidate"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CLIENT_ADD_NOTE_ASSIGNED_CANDIDATE_NOTIFICATION_EMAILS', {
    LABEL: "Notification emails when client adds a note about an assigned candidate "
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'WORD_USED_FOR_SCHEDULE_INTERVIEW_RELATIONSHIP', {
    LABEL: 'Word used for "Schedule Interview"'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SHOW_SHAREABLE_LINK_FOR_MY_CANDIDATES_SECTION', {
    LABEL: 'Show shareable link for "My Candidates" section'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'HIDE_SHIFT_JOB_DUPLICATE_BUTTON', {
    LABEL: 'Hide shift job duplicate button'
}), _defineProperty(_EMPLOYER_STATUSES$EM, "SHIFT_JOB_CALENDAR_HIDE_UNAVAILABLE_CANDIDATES", {
    LABEL: "For candidate list in shift job calendar, hide unavailable candidates by default"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'HIDE_SHIFT_JOB_UPDATE_MANAGER_SECTION', {
    LABEL: 'Hide shift job update manager section'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'HIDE_SHIFT_JOB_NOTES_SECTION', {
    LABEL: 'Hide shift job notes section'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE', {
    LABEL: "Emails that receive a notification when package is selected or changed"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'DEFAULT_FILTER_CLIENT_TYPES_SHIFT_JOB_CALENDAR', {
    LABEL: 'Select default filter client types for Shift Job Calendar'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'DEFAULT_FILTER_CLIENT_STATUSES_SHIFT_JOB_CALENDAR', {
    LABEL: 'Select default filter client statuses for Shift Job Calendar'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SEND_EMAIL_NOTIFICATION_WHEN_UNASSIGN_CANDIDATE', {
    LABEL: "Send email notification to candidate when unassigning job"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CANDIDATE_TYPES_CANNOT_EDIT_RECURRING_AVAILABILITY', {
    LABEL: "Candidate types that cannot edit their recurring availability.",
    DESCRIPTION: "If this is empty, candidates in all types will be able to edit their recurring availability"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'SHOW_ANALYTICS_BY_DEFAULT_PLACEMENT_JOBS', {
    LABEL: "Show analytics by default"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'PLACEMENT_JOB_CUSTOM_FILTER', {
    LABEL: "Select fields for custom filter for placement jobs"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CANDIDATE_STATUSES_SEE_PLACEMENT_JOBS', {
    LABEL: "Candidate statuses that can see placement jobs",
    DESCRIPTION: 'If this is empty, candidates in all statuses will be able see placement jobs'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CANDIDATE_TYPES_SEE_PLACEMENT_JOBS', {
    LABEL: "Candidate types that can see placement jobs",
    DESCRIPTION: 'If this is empty, candidates in all types will be able see placement jobs'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'RELATIONSHIP_STATUSES_HIDDEN_IN_MY_CANDIDATES', {
    LABEL: "Candidate client relationship statuses which are not showed in 'My Candidates' section"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'RELATIONSHIP_STATUSES_WHERE_EXTEND_OFFER_BUTTON_APPEARS', {
    LABEL: 'Candidate client relationship statuses where the Extend Offer button appears for the client'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'HIDE_VIEW_PREVIOUS_JOB_APPLICATIONS', {
    LABEL: 'Hide "View Previous Job Applications" in "Available Jobs"'
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'ALLOW_USE_MOBILE_APP', {
    LABEL: "Allow client and candidate to use android & ios mobile app"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'ENABLE_PLACEMENT_JOB_MOBILE_APP', {
    LABEL: "Enable placement jobs in mobile app"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CANDIDATE_SEARCH_BAR_OPEN_BY_DEFAULT', {
    LABEL: "The 'Search and Tool' panel of Candidate dashboard opens by default"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'EMPLOYER_SEARCH_BAR_OPEN_BY_DEFAULT', {
    LABEL: "The 'Search and Tool' panel of Employer dashboard opens by default"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'USE_CHAT_FEATURE', {
    LABEL: "Use chat feature"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CHAT_BETWEEN_CLIENT_AND_CANDIDATE_SHIFT_JOB', {
    LABEL: "Enable chat between candidate and client when candidate assigned to shift job"
}), _defineProperty(_EMPLOYER_STATUSES$EM, 'CHAT_BETWEEN_CLIENT_AND_CANDIDATE_PLACEMENT_JOB', {
    LABEL: "Enable chat between candidate and client when candidate assigned to placement job"
}), _EMPLOYER_STATUSES$EM);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(137)["default"];
var toPrimitive = __webpack_require__(704);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(93),
    stackClear = __webpack_require__(716),
    stackDelete = __webpack_require__(717),
    stackGet = __webpack_require__(718),
    stackHas = __webpack_require__(719),
    stackSet = __webpack_require__(720);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 247 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(727),
    mapCacheDelete = __webpack_require__(734),
    mapCacheGet = __webpack_require__(736),
    mapCacheHas = __webpack_require__(737),
    mapCacheSet = __webpack_require__(738);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(739),
    arraySome = __webpack_require__(742),
    cacheHas = __webpack_require__(743);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(755),
    isArguments = __webpack_require__(252),
    isArray = __webpack_require__(97),
    isBuffer = __webpack_require__(141),
    isIndex = __webpack_require__(253),
    isTypedArray = __webpack_require__(143);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(756),
    isObjectLike = __webpack_require__(67);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(145),
    eq = __webpack_require__(75);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(255);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(251),
    baseKeysIn = __webpack_require__(785),
    isArrayLike = __webpack_require__(98);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component is used to show for a list of form (textbox, radio button, checkbox, datepicker ...)
Each element of form group will be layout by each row, from top to bottom
*/


var _customDefineType = __webpack_require__(6);

var _TextBoxWithLabel = __webpack_require__(288);

var _TextBoxWithLabel2 = _interopRequireDefault(_TextBoxWithLabel);

var _TextAreaWithLabel = __webpack_require__(847);

var _TextAreaWithLabel2 = _interopRequireDefault(_TextAreaWithLabel);

var _DatePickerWithLabel = __webpack_require__(289);

var _DatePickerWithLabel2 = _interopRequireDefault(_DatePickerWithLabel);

var _YearPickerWithLabel = __webpack_require__(852);

var _YearPickerWithLabel2 = _interopRequireDefault(_YearPickerWithLabel);

var _TimePickerWithLabel = __webpack_require__(282);

var _TimePickerWithLabel2 = _interopRequireDefault(_TimePickerWithLabel);

var _MonthPickerWithLabel = __webpack_require__(858);

var _MonthPickerWithLabel2 = _interopRequireDefault(_MonthPickerWithLabel);

var _RadioGroup = __webpack_require__(292);

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _RadioIconGroup = __webpack_require__(863);

var _RadioIconGroup2 = _interopRequireDefault(_RadioIconGroup);

var _CheckboxIconGroup = __webpack_require__(867);

var _CheckboxIconGroup2 = _interopRequireDefault(_CheckboxIconGroup);

var _DropdownWithLabel = __webpack_require__(871);

var _DropdownWithLabel2 = _interopRequireDefault(_DropdownWithLabel);

var _CheckboxGroup = __webpack_require__(293);

var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);

var _MultiSelectWithLabel = __webpack_require__(876);

var _MultiSelectWithLabel2 = _interopRequireDefault(_MultiSelectWithLabel);

var _FileWithLabel = __webpack_require__(228);

var _FileWithLabel2 = _interopRequireDefault(_FileWithLabel);

var _FileUpload = __webpack_require__(134);

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _dataModelLength = __webpack_require__(880);

var _modelByTypes = __webpack_require__(91);

var _CheckboxItem = __webpack_require__(220);

var _CheckboxItem2 = _interopRequireDefault(_CheckboxItem);

var _vuex = __webpack_require__(11);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = {
  name: "FormGroupRowLayout",
  components: {
    TextBoxWithLabel: _TextBoxWithLabel2.default,
    TextAreaWithLabel: _TextAreaWithLabel2.default,
    DatePickerWithLabel: _DatePickerWithLabel2.default,
    YearPickerWithLabel: _YearPickerWithLabel2.default,
    TimePickerWithLabel: _TimePickerWithLabel2.default,
    MonthPickerWithLabel: _MonthPickerWithLabel2.default,
    DateTimePickerWithLabel: function DateTimePickerWithLabel() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 911));
    },
    RadioGroup: _RadioGroup2.default,
    RadioIconGroup: _RadioIconGroup2.default,
    CheckboxIconGroup: _CheckboxIconGroup2.default,
    DropdownWithLabel: _DropdownWithLabel2.default,
    CheckboxGroup: _CheckboxGroup2.default,
    DayHoursInput: function DayHoursInput() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 912));
    },
    SalaryRange: function SalaryRange() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 913));
    },
    MultiSelectWithLabel: _MultiSelectWithLabel2.default,
    FileWithLabel: _FileWithLabel2.default,
    FileUpload: _FileUpload2.default,
    RatingGroup: function RatingGroup() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 914));
    },
    RadioTable: function RadioTable() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 915));
    },
    CheckboxTable: function CheckboxTable() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 283));
    },
    LanguageInput: function LanguageInput() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 916));
    },
    TextEditor: function TextEditor() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 894));
    },
    MultiDatePicker: function MultiDatePicker() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 917));
    },
    ProductSelection: function ProductSelection() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 918));
    },
    StarRating: function StarRating() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 131));
    },
    VSwatches: function VSwatches() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 149));
    },
    HtmlSelection: function HtmlSelection() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 919));
    },
    ComputedExpression: function ComputedExpression() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 920));
    },
    CheckboxItem: _CheckboxItem2.default,
    LogItem: function LogItem() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 921));
    },
    PasswordWithLabel: function PasswordWithLabel() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 922));
    },
    CroppedFileUpload: function CroppedFileUpload() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 923));
    },
    TextFieldWithConfirmation: function TextFieldWithConfirmation() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 924));
    },
    CreditPackageSelection: function CreditPackageSelection() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 925));
    },
    PlacementJobSelection: function PlacementJobSelection() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 926));
    },
    EmailAttachment: function EmailAttachment() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 927));
    },
    VideoInput: function VideoInput() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 928));
    },
    SignatureField: function SignatureField() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 929));
    },
    ListDateTimesPickerInput: function ListDateTimesPickerInput() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 930));
    }
  },
  props: {
    listFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelData: Object,
    tagData: Object,
    submitClicked: {
      type: Boolean,
      default: false
    },
    // In some case, admin access the form as annonymous view
    isAnnonymousAccess: {
      type: Boolean,
      default: false
    },
    // Info if submit file to server after upload
    submitInfo: Object,
    isDragEnabled: {
      type: Boolean,
      default: false
    },
    hasFileAccessControlBtn: Boolean,
    listAllRelatedFields: Array
  },
  data: function data() {
    return {
      FORM_TYPE: _customDefineType.FORM_TYPE,
      highestTouchIndex: 0, // Last focus, filled fields
      listFieldsVal: [],
      isShowSectionBuilderUpSertDialog: false,
      selectedBuilderId: null
    };
  },
  watch: {
    listFields: {
      handler: function handler(val) {
        var _this = this;

        this.listFieldsVal = val || [];
        if (val) {
          val.forEach(function (field) {
            if (field.model === "timezone") {
              field.optionList = Intl.supportedValuesOf("timeZone");
            }
            if (field.predefinedOptionKey && _this.agencyPredefinedOptionList) {
              var optionItem = _this.agencyPredefinedOptionList.find(function (item) {
                return item.key === field.predefinedOptionKey;
              });
              if (optionItem) {
                field.optionList = optionItem.value;
              }
            }
          });
        }
      },

      immediate: true
    }
  },
  computed: _extends({}, (0, _vuex.mapGetters)(["phoneDefaultFormat", "agencyLanguages", "agencyPredefinedOptionList", "isAgent"]), {
    language: function language() {
      return this.$store.getters.language;
    }
  }),
  methods: _extends({}, (0, _vuex.mapActions)(["reloadProfileBuilderList"]), {
    handleSelect: function handleSelect(val, model) {
      // Use in import user dialog
      this.$emit("changed", [[model, val]]);
    },
    handleUserSelect: function handleUserSelect(modelVal, el, index) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.handleInputField(el, index);
      });
    },
    handleChange: function handleChange(modelVal) {
      var selectedFieldsData = Object.entries(this.modelData).filter(function (item) {
        return item[1] == modelVal;
      });
      this.$emit("changed", selectedFieldsData);
    },
    getClassList: function getClassList(el) {
      var bootstrapClassList = this.getBootstrapClassList(el);
      return bootstrapClassList;
    },
    getBootstrapClassList: function getBootstrapClassList(el) {
      if (!el || [_customDefineType.FORM_TYPE.ARRAY_OBJECT, _customDefineType.FORM_TYPE.SLOT, _customDefineType.FORM_TYPE.SECTION, _customDefineType.FORM_TYPE.BOOKING_SECTION, _customDefineType.FORM_TYPE.HEADER, _customDefineType.FORM_TYPE.SEPARATOR, _customDefineType.FORM_TYPE.SIGN_DOCUMENT, _customDefineType.FORM_TYPE.EVALUATION, _customDefineType.FORM_TYPE.PAYMENT, _customDefineType.FORM_TYPE.HTML, _customDefineType.FORM_TYPE.DATA, _customDefineType.FORM_TYPE.RETURNING_APPLICANT_BTN].includes(el.type)) {
        return "col-lg-12";
      }
      if (Array.isArray(el)) {
        return "col-lg-12";
      }
      var itemPerRow = el.itemPerRow;
      if (itemPerRow === 0) {
        return "col";
      }
      var result = "";
      if (itemPerRow == null || itemPerRow === 1) {
        result = "col-lg-12";
      } else {
        result = "col-lg-" + String(12 / itemPerRow);
      }
      if (el.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
        result = result + " col-6";
      }
      return result;
    },
    getMaxLength: function getMaxLength(el) {
      if (el.maxLength) {
        return el.maxLength;
      }
      if (Object.keys(_dataModelLength.DATA_MODEL_MAX_LENGTH).includes(el.model)) {
        return _dataModelLength.DATA_MODEL_MAX_LENGTH[el.model];
      }
      if (el.model && el.model.includes("selector")) {
        return 255;
      }
      return null;
    },
    getFieldLabel: function getFieldLabel(item) {
      var label = this.getFieldProperty(item, "label");
      if (item.transformLabel) {
        return item.transformLabel(this.modelData, label);
      }
      return label;
    },
    getFieldProperty: function getFieldProperty(item, key) {
      if (item == null) {
        return "";
      }
      if (this.language) {
        if (item[key + "_lang_" + this.language]) {
          return item[key + "_lang_" + this.language];
        }
      }
      if (key === "label" && !item[key] && item.keyLangLabel) {
        if (item.keyLangLabelParams) {
          return this.getLabelByKeys.apply(this, [item.keyLangLabel].concat(_toConsumableArray(item.keyLangLabelParams)));
        } else {
          return this.getLabelByKeys(item.keyLangLabel);
        }
      }
      return item[key];
    },
    getMapOptionListByLanguage: function getMapOptionListByLanguage(item) {
      if (!item.optionList) {
        return {};
      }
      var listOptionsByLangs = void 0;
      if (item.keyLangOptions) {
        listOptionsByLangs = this.getLabelByKeys(item.keyLangOptions);
      } else {
        if (!this.language) {
          return {};
        }
        if (!item["optionList_lang_" + this.language]) {
          return {};
        }
        listOptionsByLangs = this.convertStringToArray(item["optionList_lang_" + this.language]);
      }
      var listOptions = this.convertStringToArray(item.optionList);
      var result = {};
      for (var index = 0; index < listOptions.length; index++) {
        result[listOptions[index]] = listOptionsByLangs[index];
      }
      return result;
    },
    getInputType: function getInputType(el) {
      if (el.isIntegerField) {
        return _customDefineType.TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER;
      }
      if (el.isFloatField) {
        return _customDefineType.TEXTBOX_INPUT_TYPE.DOUBLE;
      }
      return el.inputType;
    },
    is24HoursFormat: function is24HoursFormat(el) {
      if (el.others) {
        return el.others.includes("is 24 Hour Format") ? true : false;
      }
      return false;
    },
    isAppendToBody: function isAppendToBody(el) {
      if (el.others) {
        return el.others.includes("Show Datepicker Over Modal") ? true : false;
      }
      return false;
    },
    defaultTime: function defaultTime(el) {
      if (el.others && el.others.includes("Default Time") && el.defaultTime && el.defaultTime["hh"] && el.defaultTime["mm"]) {
        return el.defaultTime;
      }
      return null;
    },
    getOptionListByConditions: function getOptionListByConditions(el) {
      var optionList = el.optionListAll;
      if (!optionList) {
        return [];
      }
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = optionList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          if (!option.show_condition || !option.show_condition.showIf || !option.show_condition.showIfValue) {
            result.push(option);
            continue;
          }
          var value = this.modelData[option.show_condition.showIf];
          if (value == null) {
            continue;
          }
          if (option.show_condition.showIfValue.includes(value)) {
            result.push(option);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    getDefaultPlaceHolder: function getDefaultPlaceHolder(el) {
      if (_modelByTypes.MODEL_USER_PHONE_FIELD.includes(el.model)) {
        return this.phoneDefaultFormat;
      }
    },
    getOptionList: function getOptionList(el) {
      var optionList = el.optionList;
      if (!optionList) {
        if (el.model === "language") {
          return this.agencyLanguages;
        }
      }
      if (this.language) {
        if (el["optionList_lang_" + this.language]) {
          return el["optionList_lang_" + this.language];
        }
      }
      return optionList;
    },
    isHightlightError: function isHightlightError(index) {
      if (this.submitClicked) {
        return true;
      }
      if (index < this.highestTouchIndex) {
        return true;
      }
      return false;
    },
    handleInputField: function handleInputField(el, index) {
      if (this.modelData && this.modelData[el.model]) {
        if (index > this.highestTouchIndex) {
          this.highestTouchIndex = index;
        }
      }
      if (el.isShareModel && Array.isArray(this.modelData[el.model])) {
        this.$emit("reloadData");
      } else if ([_customDefineType.FORM_TYPE.RADIO, _customDefineType.FORM_TYPE.CHECKBOX, _customDefineType.FORM_TYPE.DROPDOWN, _customDefineType.FORM_TYPE.MULTI_SELECT].includes(el.type)) {
        this.$emit("updatedSelection", el.model);
      } else if (el.type === _customDefineType.FORM_TYPE.DATEPICKER) {
        this.$emit("updatedDate");
      } else if (el.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
        this.$emit("updatedTime");
      }
    }
  })
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customDefineType = __webpack_require__(6);

var _regex = __webpack_require__(46);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _SpeechInput = __webpack_require__(264);

var _SpeechInput2 = _interopRequireDefault(_SpeechInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a textbox
Any error of textbox (for example: required field, invalid character, exceed length ...) is showed in this component */
exports.default = {
  name: "TextBoxWithLabel",
  components: {
    SpeechInput: _SpeechInput2.default
  },
  props: {
    /* Name of the textbox component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Number],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // Type of input: text or number
    type: {
      type: String,
      default: _customDefineType.TEXTBOX_INPUT_TYPE.TEXT
    },
    // Validation for input
    validation: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    // Max length of input
    maxLength: {
      type: Number
    },
    //used if type is a number enforce a max input
    maxNumber: {
      type: Number
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Initial value
    defaultValue: String,
    hasSpaceTop: {
      type: Boolean,
      default: true
    },
    labelSpaceBottom: {
      type: Boolean,
      default: false
    },
    builderField: Object,
    buttonGroups: Array, // List of buttons attached by the end of textbox
    formData: Object // data of all fields of the form
  },
  created: function created() {
    if (this.defaultValue && !this.value) {
      this.$emit("input", this.defaultValue);
    }
  },
  data: function data() {
    return {
      isBlur: false,
      isInvalidPhone: false
    };
  },

  // created() {
  //   if (this.validation.length > 0) {
  //     this.$emit("input", "thuy@enginehire.ca");
  //   } else {
  //     this.$emit("input", this.label);
  //   }
  // },
  computed: {
    isPhoneField: function isPhoneField() {
      if (!this.builderField) {
        return false;
      }
      if (this.builderField.isAPhoneNumber) {
        return true;
      }
      if (this.builderField.model && this.builderField.model.includes("info__custom_phone")) {
        return true;
      }
      return ["phone", "phone2"].includes(this.builderField.model);
    },
    listDisplayButtons: function listDisplayButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return null;
      }
      if (this.inputVal) {
        return this.buttonGroups;
      }
      return this.buttonGroups.filter(function (button) {
        return !button.showIfSelect;
      });
    },

    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    },
    validationErrorMessage: function validationErrorMessage() {
      if (!this.inputVal) {
        return;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.validation[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var validateItem = _step.value;

          try {
            if (validateItem && validateItem.regex) {
              if (!validateItem.regex.test(this.inputVal)) {
                return validateItem.message;
              }
            }
          } catch (e) {}
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  methods: {
    handleBlurField: function handleBlurField() {
      var res;
      return regeneratorRuntime.async(function handleBlurField$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$emit("blur");
              this.isBlur = true;
              // Check if phone number is invalid

              if (!this.isPhoneField) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.post(this.appendBackgroundParam("/validate-phone-number/"), {
                phone: this.inputVal,
                agency: this.$store.getters.agencyID,
                country: this.formData ? this.formData.country : null
              }));

            case 5:
              res = _context.sent;

              if (res && res.data) {
                this.isInvalidPhone = res.data.code === -1;
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    handleOnInput: function handleOnInput() {
      var _this = this;

      if (this.type && _regex.REGEX_VALID_NUMBER[this.type]) {
        var oldVal = this.inputVal;
        this.$nextTick(function () {
          if (!_regex.REGEX_VALID_NUMBER[_this.type].test(_this.inputVal)) {
            _this.inputVal = oldVal;
            _this.$refs.input.blur();
            setTimeout(function () {
              _this.$refs.input.focus();
            });
          }
          if (_this.type && _this.type != "TEXT" && _this.maxNumber) {
            if (Number(_this.inputVal) > Number(_this.maxNumber)) {
              _this.inputVal = oldVal;
              _this.$refs.input.blur();
              setTimeout(function () {
                _this.$refs.input.focus();
              });
            }
          }
        });
      }
    },
    handleClickButton: function handleClickButton(button) {
      this.$emit("clickBtn", button.id);
    },
    handleSpeechInput: function handleSpeechInput(inputText) {
      this.inputVal = inputText;
    }
  }
};

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechInput_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechInput_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechInput_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechInput_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90138ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpeechInput_vue__ = __webpack_require__(845);
function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e90138ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpeechInput_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90138ac_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpeechInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "SpeechInput",
  props: {
    field: Object
  },
  data: function data() {
    return {
      runtimeTranscription: "",
      isRecording: false
    };
  },

  computed: {
    lang: function lang() {
      return "en_US";
    },
    isEmbed: function isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  },
  methods: {
    startSpeechToText: function startSpeechToText() {
      var _this = this;

      this.isRecording = true;
      // initial of voice
      window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      var recognition = new window.SpeechRecognition();
      recognition.lang = this.lang;
      recognition.interimResults = true;

      // event current voice record word
      recognition.addEventListener("result", function (event) {
        var text = Array.from(event.results).map(function (result) {
          return result[0];
        }).map(function (result) {
          return result.transcript;
        }).join("");
        _this.runtimeTranscription = text;
        _this.emitResult();
      });
      // end of transcription
      recognition.addEventListener("end", function () {
        _this.emitResult();
        _this.runtimeTranscription = "";
        recognition.stop();
        _this.isRecording = false;
        _this.submitTrackingClick("Speech To Text", "Speech To Text", null, _this.field ? { label: _this.field.label } : null);
      });
      recognition.start();
    },
    emitResult: function emitResult() {
      this.$emit("input", this.runtimeTranscription);
    }
  }
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SpeechInput = __webpack_require__(264);

var _SpeechInput2 = _interopRequireDefault(_SpeechInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* This component includes a label, and a textarea
Any error of textarea (for example: required field, invalid character, exceed length ...) is showed in this component */
exports.default = {
  name: "TextAreaWithLabel",
  components: {
    SpeechInput: _SpeechInput2.default
  },
  props: {
    /* Name of the textarea component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: String,
    // Number of rows of textarea
    rows: {
      type: Number,
      default: 4
    },
    // Max length of input
    maxLength: {
      type: Number
    },
    placeholder: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isCounter: {
      type: Boolean,
      default: false
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Initial value
    defaultValue: String,
    builderField: Object,
    showTemplateLoader: {
      type: Boolean,
      default: false
    },
    templateType: {
      type: String,
      default: null
    },
    templateSelector: {
      type: String,
      default: null
    }
  },
  created: function created() {
    if (this.defaultValue && !this.value) {
      this.$emit("input", this.defaultValue);
    }
  },

  // created() {
  //   this.$emit("input", this.label);
  // },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    handleSpeechInput: function handleSpeechInput(inputText) {
      this.inputVal = inputText;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a date picker
Any error of user input for the date picker (for example: required field, invalid day ...) is showed in this component */

var _vue2Datepicker = __webpack_require__(102);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "DatePickerWithLabel",
  components: {
    DatePicker: _vue2Datepicker2.default
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    dateFormat: {
      type: String
    },
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: [String, Date],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Initial view: year or month
    initialView: {
      type: String,
      default: "year"
    },
    // Allow to input date in the past
    allowPastDate: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    minDate: Date,
    builderField: Object
  },
  // created() {
  //   this.$emit("input", this.dateInDjangoFormat(new Date()));
  // },
  computed: _extends({}, (0, _vuex.mapGetters)(["startDayOfWeekCalendar", "datepickerDefaultFormat", "datepickerDefaultPlaceholder"]), {
    datePickerFormat: function datePickerFormat() {
      return this.dateFormat || this.datepickerDefaultFormat || "YYYY-MM-DD";
    },
    isShowAge: function isShowAge() {
      var _this = this;

      return this.tryGet(function () {
        return _this.builderField.others.includes("Show Age");
      });
    },
    datePickerPlaceholder: function datePickerPlaceholder() {
      return this.placeholder || this.datepickerDefaultPlaceholder || this.dateFormat || "YYYY-MM-DD";
    },

    inputVal: {
      get: function get() {
        if (this.value == null) {
          return null;
        }
        return new Date(this.value + "T12:00:00"); // This is to prevent the date from going one day behind
      },
      set: function set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    },
    lang: function lang() {
      return {
        formatLocale: {
          firstDayOfWeek: this.startDayOfWeekCalendar
        }
      };
    }
  }),
  methods: {
    disableDates: function disableDates(date) {
      if (this.minDate) {
        this.minDate.setHours(0, 0, 0, 0);
        return date < this.minDate;
      }
      if (this.allowPastDate) {
        return false;
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    }
  }
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue2Datepicker = __webpack_require__(102);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "YearPickerWithLabel",
  components: {
    DatePicker: _vue2Datepicker2.default
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Date],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    builderField: Object
  },
  // created() {
  //   this.$emit("input", this.dateInDjangoFormat(new Date()));
  // },
  computed: {
    inputVal: {
      get: function get() {
        if (this.value == null) {
          return null;
        }
        return new Date(this.value + "T00:00:00"); // This is to prevent the date from going one day behind
      },
      set: function set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a date picker
Any error of user input for the date picker (for example: required field, invalid day ...) is showed in this component */

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a time picker
Any error of user input for the time picker (for example: required field, invalid time ...) is showed in this component */


var _vue2Timepicker = __webpack_require__(290);

var _vue2Timepicker2 = _interopRequireDefault(_vue2Timepicker);

__webpack_require__(291);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "TimePickerWithLabel",
  components: {
    VueTimepicker: _vue2Timepicker2.default
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Object],
    defaultValue: {
      type: Object,
      default: null
    },
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // true if disable the timepicker
    isDisabled: {
      type: Boolean,
      default: false
    },
    minutesInterval: {
      type: Number,
      default: 15
    },
    is24HoursFormat: {
      type: Boolean,
      default: false
    },
    builderField: Object
  },
  computed: {
    inputVal: {
      get: function get() {
        var value = this.value ? this.value : this.defaultValue;
        if (this.is24HoursFormat) {
          if (value && value.A) {
            return this.convertAMPMto24Format(value);
          }
          return;
        }
        if (typeof value === "string") {
          return this.convertTimeStringToStringAMPM(value);
        }
        return value;
      },
      set: function set(val) {
        // Check if all elements are filled
        if (val && (typeof val === "undefined" ? "undefined" : _typeof(val)) === "object") {
          if (Object.values(val).includes("") && Object.values(val).some(function (item) {
            return item;
          })) {
            return;
          }
        }
        if (this.is24HoursFormat && val) {
          this.$emit("input", this.convertTimeToAMPM(val));
          return;
        }
        this.$emit("input", val);
      }
    }
  }
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue2Datepicker = __webpack_require__(102);

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "MonthPickerWithLabel",
  props: {
    /* Name of the month picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Date],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Validate if date has to be after this value
    after: {
      type: String
    },
    // Initial view: year or month
    initialView: {
      type: String,
      default: "month"
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    builderField: Object
  },
  components: {
    DatePicker: _vue2Datepicker2.default
  },
  data: function data() {
    return {
      month: "",
      year: ""
    };
  },

  // created() {
  //   this.$emit("input", this.dateInDjangoFormat(new Date()));
  // },
  computed: {
    inputVal: {
      get: function get() {
        if (this.value == null) {
          return null;
        }
        return new Date(this.value + "T00:00:00"); // This is to prevent the date from going one day behind
      },
      set: function set(val) {
        this.$emit("input", this.dateInDjangoFormat(val));
      }
    },
    showErrorEndAfterStartDate: function showErrorEndAfterStartDate() {
      console.log(this.dateInDjangoFormat(this.inputVal));
      if (this.after == null) {
        return false;
      }
      if (!this.inputVal) {
        return false;
      }
      var tokens = this.after.split("-");
      if (tokens.length < 3) {
        return false;
      }
      return this.compareMonthYear(this.dateInDjangoFormat(this.inputVal), this.after) < 0;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a month picker
Any error of user input for the month picker (for example: required field, invalid day ...) is showed in this component */

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = __webpack_require__(99);

/* This component includes a label, and a radio group, which includes radio buttons and its label
Any error of the radio group (for example: required field) is showed in this component */
exports.default = {
  name: "RadioGroup",
  props: {
    /* Name of the radio component, it is used in id of each radio button,
    therefore it need to be different between RadioGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Description below all options
    bottomDescription: String,
    // Input value, which is used for v-model
    value: [String, Boolean],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for radio buttons (the label of each radio buttons)
    optionList: {
      type: [Array, String],
      default: function _default() {
        return ["Yes", "No"];
      }
    },
    hasOther: {
      type: Boolean,
      default: false
    },
    // Index of default selected option
    defaultValue: [Number, String],
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // field will be saved by boolean_selector
    isBooleanModel: {
      type: Boolean,
      default: false
    },
    // Display options in multiple columns
    numberOfColumn: {
      type: Number,
      default: 1
    },
    // Radio option display in HTML format
    isHtml: {
      type: Boolean,
      default: false
    },
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: function _default() {}
    },
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    builderField: Object
  },
  created: function created() {
    var _this = this;

    if (!this.isBooleanModel && !this.hasOther && this.value) {
      // Reset value if it is not included in option list
      if (!this.tryGet(function () {
        return _this.builderField.usePredefinedOption;
      })) {
        if (!this.normalizedOptionList.includes(this.value)) {
          this.$emit("input", "");
        }
      }
    }
    if (this.defaultValue != null && this.value == null) {
      this.$emit("input", this.normalizedOptionList[this.defaultValue]);
    }
  },

  // created() {
  //   this.$emit("input", this.normalizedOptionList[0]);
  // },
  computed: {
    hasAddOptionBtn: function hasAddOptionBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some(function (button) {
        return button.id === "add-option";
      });
    },
    listDisplayButtons: function listDisplayButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return null;
      }
      var result = this.buttonGroups.filter(function (button) {
        return !button.showIfSelect && button.id !== "add-option";
      });
      if (this.inputVal) {
        return result;
      }
      return result.filter(function (button) {
        return !button.showIfSelect;
      });
    },
    normalizedOptionList: function normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      return this.optionList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    displayOptionList: function displayOptionList() {
      if (!this.normalizedOptionList) {
        return [];
      }
      if (!this.numberOfColumn) {
        this.numberOfColumn = 1;
      }
      return this.splitArrayIntoChunks(this.normalizedOptionList, this.numberOfColumn);
    },
    getOtherValue: function getOtherValue() {
      if (!this.value) {
        return "";
      }
      if (!this.optionListExcludeOther.includes(this.value)) {
        return this.removeOtherRadioPrefix(this.value);
      }
    },
    optionListExcludeOther: function optionListExcludeOther() {
      return this.normalizedOptionList.slice(0, -1);
    },
    optionsPerColumn: function optionsPerColumn() {
      if (this.normalizedOptionList == null) {
        return 0;
      }
      if (!this.numberOfColumn) {
        return this.normalizedOptionList.length;
      }
      return Math.ceil(this.normalizedOptionList.length / this.numberOfColumn);
    },
    columnClass: function columnClass() {
      if (this.numberOfColumn == null || this.numberOfColumn === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / this.numberOfColumn);
    },
    isOtherSelected: function isOtherSelected() {
      if (!this.value) {
        return false;
      }
      if (!this.optionListExcludeOther.includes(this.value)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    getOptionId: function getOptionId(index) {
      return "Radion-Option-" + this._uid + "-" + this.name + "-" + index;
    },
    isCheck: function isCheck(option, index) {
      if (this.isBooleanModel) {
        if (this.value === true) {
          return option === "Yes";
        } else if (this.value === false) {
          return option === "No";
        }
      } else {
        if (this.hasOther) {
          if (index === this.normalizedOptionList.length - 1) {
            return this.isOtherSelected;
          }
        }
        return option === this.value;
      }
    },
    handleOnChange: function handleOnChange(option, index) {
      console.log("onChange", option, index);
      if (this.isBooleanModel) {
        this.$emit("input", option === "Yes");
      } else {
        if (this.hasOther && index === this.normalizedOptionList.length - 1) {
          this.$emit("input", _prefix.RADIO_OTHER_OPTIONS_PREFIX);
        } else {
          this.$emit("input", option);
        }
      }
    },
    handleOtherTextboxInput: function handleOtherTextboxInput(event) {
      this.$emit("input", _prefix.RADIO_OTHER_OPTIONS_PREFIX + event.target.value);
    },
    getDisplayOption: function getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    },
    handleClickButton: function handleClickButton(button) {
      this.$emit("clickBtn", button.id);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a radio group, which includes radio buttons and its label
Any error of the radio group (for example: required field) is showed in this component */
exports.default = {
  name: "RadioIconGroup",
  props: {
    /* Name of the radio component, it is used in id of each radio button,
    therefore it need to be different between RadioGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Description below all options
    bottomDescription: String,
    // Input value, which is used for v-model
    value: [String, Boolean],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for radio buttons (the label of each radio buttons)
    optionList: {
      type: [Array, String],
      default: function _default() {
        return ["Yes", "No"];
      }
    },
    iconList: String,
    hasOther: {
      type: Boolean,
      default: false
    },
    // Index of default selected option
    defaultValue: [Number, String],
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // field will be saved by boolean_selector
    isBooleanModel: {
      type: Boolean,
      default: false
    },
    // Display options in multiple columns
    numberOfColumn: {
      type: Number,
      default: 1
    },
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: function _default() {}
    }
  },
  created: function created() {
    if (!this.hasOther && this.value) {
      // Reset value if it is not included in option list
      if (!this.normalizedOptionList.includes(this.value)) {
        this.$emit("input", null);
      }
    }
    if (this.defaultValue != null && this.value == null) {
      this.$emit("input", this.normalizedOptionList[this.defaultValue]);
    }
  },

  // created() {
  //   this.$emit("input", this.normalizedOptionList[0]);
  // },
  computed: {
    normalizedOptionList: function normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      return this.optionList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    normalizedIconList: function normalizedIconList() {
      if (Array.isArray(this.iconList)) {
        return this.iconList;
      }
      return this.iconList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    getOtherValue: function getOtherValue() {
      if (!this.optionListExcludeOther.includes(this.value)) {
        return this.value;
      }
    },
    optionListExcludeOther: function optionListExcludeOther() {
      return this.normalizedOptionList.slice(0, -1);
    },
    optionsPerColumn: function optionsPerColumn() {
      if (this.normalizedOptionList == null) {
        return 0;
      }
      if (!this.numberOfColumn) {
        return this.normalizedOptionList.length;
      }
      return Math.ceil(this.normalizedOptionList.length / this.numberOfColumn);
    },
    columnClass: function columnClass() {
      if (this.numberOfColumn == null || this.numberOfColumn === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / this.numberOfColumn);
    }
  },
  methods: {
    getOptionId: function getOptionId(index) {
      return "Radion-Option-" + this.name + "-" + index;
    },
    isCheck: function isCheck(option, index) {
      if (this.isBooleanModel) {
        if (this.value === true) {
          return option === "Yes";
        } else if (this.value === false) {
          return option === "No";
        }
      } else {
        if (this.hasOther && this.value != null) {
          if (index === this.normalizedOptionList.length - 1) {
            if (!this.optionListExcludeOther.includes(this.value)) {
              return true;
            }
          }
        }
        return option === this.value;
      }
    },
    handleOnChange: function handleOnChange(option, index) {
      console.log("onChange", option, index);
      if (this.isBooleanModel) {
        this.$emit("input", option === "Yes");
      } else {
        if (this.hasOther && index === this.normalizedOptionList.length - 1) {
          this.$emit("input", "");
        } else {
          this.$emit("input", option);
        }
      }
    },
    handleOtherTextboxInput: function handleOtherTextboxInput(event) {
      this.$emit("input", event.target.value);
    },
    getDisplayOption: function getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    }
  }
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a radio group, which includes radio buttons and its label
Any error of the radio group (for example: required field) is showed in this component */
exports.default = {
  name: "CheckboxIconGroup",
  props: {
    /* Name of the checkbox component, it is used in id of each checkbox, 
    therefore it need to be different between CheckboxGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    iconList: String,
    // Index of option which has textbox
    textboxOption: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasOther: {
      type: Boolean,
      default: false
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Index of default selected option
    defaultValue: Array,
    // Checkbox option display in HTML format
    isHtml: {
      type: Boolean,
      default: false
    },
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      listCheckedOption: this.value
    };
  },

  // created() {
  //   this.listCheckedOption.push(this.normalizedOptionList[0]);
  //   this.$emit("input", this.listCheckedOption);
  // },
  created: function created() {
    var _this = this;

    if (this.listCheckedOption && this.listCheckedOption.length > 0) {
      // Filter out the option which is not in option list
      this.listCheckedOption = [];
      this.value.forEach(function (option) {
        if (_this.normalizedOptionList.includes(option)) {
          _this.listCheckedOption.push(option);
        }
      });
      this.$emit("input", this.listCheckedOption);
    }
    if (this.defaultValue && (this.value == null || this.value.length === 0)) {
      this.listCheckedOption = this.defaultValue.map(function (val) {
        return _this.normalizedOptionList[val];
      });
      this.$emit("input", this.listCheckedOption);
    }
  },

  computed: {
    normalizedOptionList: function normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      return this.optionList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    normalizedIconList: function normalizedIconList() {
      if (Array.isArray(this.iconList)) {
        return this.iconList;
      }
      return this.iconList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    columnClass: function columnClass() {
      if (this.numberOfColumn == null || this.numberOfColumn === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / this.numberOfColumn);
    }
  },
  methods: {
    onChangeCheck: function onChangeCheck(option, isCheck, index) {
      if (this.hasOther && index === this.normalizedOptionList.length - 1) {
        if (isCheck) {
          this.listCheckedOption.push("other:");
        } else {
          this.listCheckedOption = this.listCheckedOption.filter(function (checkedOption) {
            return checkedOption.indexOf("other:") !== 0;
          });
        }
      } else {
        if (isCheck) {
          this.listCheckedOption.push(option);
        } else {
          this.listCheckedOption = this.listCheckedOption.filter(function (checkedOption) {
            return checkedOption !== option;
          });
        }
      }
      this.$emit("input", this.listCheckedOption);
    },
    isOptionCheck: function isOptionCheck(option) {
      return this.listCheckedOption.includes(option);
    },
    getDisplayOption: function getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    }
  }
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a dropdown list
Any error of the dropdown list (for example: required field) is showed in this component */
exports.default = {
  name: "DropdownWithLabel",
  props: {
    /* Name of the dropdown component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Input value, which is used for v-model
    value: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // Index of default selected option
    defaultValue: [Number, String],
    optionList: {
      type: [Array, String]
    },
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: function _default() {}
    },
    builderField: Object
  },
  // created() {
  //   this.$emit("input", this.normalizedOptionList[0]);
  // },
  created: function created() {
    if (this.value) {
      // Reset value if it is not included in option list
      if (!this.normalizedOptionList.includes(this.value)) {
        this.$emit("input", null);
      }
    }
    if (this.defaultValue != null && this.value == null) {
      this.$emit("input", this.normalizedOptionList[this.defaultValue]);
    }
  },

  computed: {
    normalizedOptionList: function normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      return this.optionList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },

    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    getDisplayOption: function getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regex = __webpack_require__(46);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This component includes a label, and a checkbox group, which includes  checkboxes and its label
Any error of the checkbox group (for example: required field) is showed in this component */


exports.default = {
  name: "CheckboxGroup",
  props: {
    /* Name of the checkbox component, it is used in id of each checkbox, 
    therefore it need to be different between CheckboxGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    // Index of option which has textbox
    textboxOption: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasOther: {
      type: Boolean,
      default: false
    },
    hasCheckAll: {
      type: Boolean,
      default: false
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Index of default selected option
    defaultValue: Array,
    // Checkbox option display in HTML format
    isHtml: {
      type: Boolean,
      default: false
    },
    // Display options in multiple columns
    numberOfColumn: {
      type: Number,
      default: 1
    },
    // Index of exclusive options
    exclusiveOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    messageDialogs: Array,
    tagData: Object,
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: function _default() {}
    },
    mapDisplayedOptions: Object,
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    builderField: Object,
    markAllAsChecked: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  // created() {
  //   this.listCheckedOption.push(this.normalizedOptionList[0]);
  //   this.$emit("input", this.listCheckedOption);
  // },
  created: function created() {
    var _this = this;

    if (this.defaultValue && (this.value == null || this.value.length === 0)) {
      this.listCheckedOption = this.defaultValue.map(function (val) {
        return _this.normalizedOptionList[val];
      });
    }
    // mark all as checked by default
    if (this.markAllAsChecked) {
      this.handleClickCheckAll(true);
    }
  },

  computed: {
    listCheckedOption: {
      get: function get() {
        var _this2 = this;

        var result = [];
        if (!this.value) {
          return result;
        }
        this.value.forEach(function (option) {
          if (!option) {
            return;
          }
          if (_this2.normalizedOptionList.includes(option) || option.indexOf("textboxOption") === 0 || option.indexOf("other:") === 0 || _this2.useDuplicateModel) {
            result.push(option);
          }
        });
        return result;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    },
    hasAddOptionBtn: function hasAddOptionBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some(function (button) {
        return button.id === "add-option";
      });
    },
    hasAgencySettingBtn: function hasAgencySettingBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some(function (button) {
        return button.id === "agency-setting";
      });
    },
    agencySettingBtn: function agencySettingBtn() {
      if (!this.hasAgencySettingBtn) {
        return {};
      }
      return this.buttonGroups.find(function (button) {
        return button.id === "agency-setting";
      });
    },
    listDisplayButtons: function listDisplayButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return null;
      }
      var result = this.buttonGroups.filter(function (button) {
        return !button.showIfSelect && button.id !== "add-option" && button.id !== "agency-setting";
      });
      if (this.inputVal) {
        return result;
      }
      return result.filter(function (button) {
        return !button.showIfSelect;
      });
    },
    normalizedOptionList: function normalizedOptionList() {
      var _this3 = this;

      var optionList = void 0;
      if (Array.isArray(this.optionList)) {
        optionList = this.optionList;
      } else {
        optionList = this.optionList.split("\n").map(function (option) {
          return option.trim();
        }).filter(function (option) {
          return option.length > 0;
        });
      }
      // Replace tag
      return optionList.map(function (option) {
        if (_this3.tagData && option.includes("[[")) {
          return _this3.replaceTagValue(option, _this3.tagData);
        } else {
          return option;
        }
      });
    },
    mapParentOptions: function mapParentOptions() {
      if (!this.normalizedOptionList) {
        return {};
      }
      var result = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.normalizedOptionList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          if (!option) {
            continue;
          }
          if (String(option).includes("data-parent=")) {
            var match = option.match(_regex.REGEX_EXTRACT_CHECKBOX_PARENT_OPTION);
            if (match) {
              if (!isNaN(match[1])) {
                var parentOption = this.normalizedOptionList[Number(match[1])];
                if (parentOption) {
                  result[option] = parentOption;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    displayOptionList: function displayOptionList() {
      if (!this.normalizedOptionList) {
        return [];
      }
      if (!this.numberOfColumn) {
        this.numberOfColumn = 1;
      }
      return this.splitArrayIntoChunks(this.normalizedOptionList, this.numberOfColumn);
    },
    getOtherValue: function getOtherValue() {
      var otherOption = this.listCheckedOption.find(function (option) {
        return option.indexOf("other:") === 0;
      });
      if (otherOption) {
        return otherOption.substr(6);
      }
      return "";
    },
    hasOtherOption: function hasOtherOption() {
      if (this.listCheckedOption == null) {
        return false;
      }
      return this.listCheckedOption.some(function (option) {
        return option.indexOf("other:") === 0;
      });
    },
    optionsPerColumn: function optionsPerColumn() {
      if (this.normalizedOptionList == null) {
        return 0;
      }
      if (!this.numberOfColumn) {
        return this.normalizedOptionList.length;
      }
      return Math.ceil(this.normalizedOptionList.length / this.numberOfColumn);
    },
    columnClass: function columnClass() {
      if (this.numberOfColumn == null || this.numberOfColumn === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / this.numberOfColumn);
    },
    idCheckAll: function idCheckAll() {
      return "checkbox-checkall-" + this._uid;
    },
    useDuplicateModel: function useDuplicateModel() {
      return this.builderField && this.builderField.useDuplicateModel;
    }
  },
  methods: {
    /*
    Parse textbox from input value (v-model)
    Structure of input value:
    [selectedOption1, selectedOption2, ..., otherOption, textboxOption1, textboxOption2, ...]
    with:
      otherOption: 'other:' + text
      textboxOption1: 'textboxOption1:' + text
    This method will extract text from textboxOption
    */
    getTextboxOptionValue: function getTextboxOptionValue(index) {
      var textboxOption = this.listCheckedOption.find(function (option) {
        return option.indexOf("textboxOption" + index + ":") === 0;
      });
      if (textboxOption) {
        return textboxOption.substr(("textboxOption" + index + ":").length);
      }
      return "";
    },

    // This method will calculate textboxOption based on input text
    handleTextboxOptionInput: function handleTextboxOptionInput(event, index) {
      var indexOfOption = this.listCheckedOption.findIndex(function (option) {
        return option.indexOf("textboxOption" + index + ":") === 0;
      });
      if (indexOfOption >= 0) {
        // Update
        this.listCheckedOption[indexOfOption] = "textboxOption" + index + ":" + event.target.value;
      } else {
        // Insert
        this.listCheckedOption.push("textboxOption" + index + ":" + event.target.value);
      }
      this.listCheckedOption = Object.assign([], this.listCheckedOption);
    },
    onChangeCheck: function onChangeCheck(option, isCheck, index) {
      // Check to show message dialog
      if (this.messageDialogs && isCheck) {
        var messageDialog = this.messageDialogs.find(function (item) {
          return item.options && item.options.includes(index);
        });
        if (messageDialog) {
          this.showResultDialog({ innerHtml: messageDialog.message });
          if (!messageDialog.isSelectable) {
            return;
          }
        }
      }

      if (this.hasOther && index === this.normalizedOptionList.length - 1) {
        if (isCheck) {
          this.listCheckedOption.push("other:");
          this.listCheckedOption = [].concat(_toConsumableArray(this.listCheckedOption));
        } else {
          this.listCheckedOption = this.listCheckedOption.filter(function (checkedOption) {
            return checkedOption.indexOf("other:") !== 0;
          });
        }
      } else {
        if (isCheck) {
          this.listCheckedOption.push(option);
          this.listCheckedOption = [].concat(_toConsumableArray(this.listCheckedOption));
        } else {
          this.listCheckedOption = this.listCheckedOption.filter(function (checkedOption) {
            return checkedOption !== option;
          });
        }
      }
      this.$emit("reloadData");
    },
    handleOtherTextboxInput: function handleOtherTextboxInput(event) {
      var indexOfOther = this.listCheckedOption.findIndex(function (option) {
        return option.indexOf("other:") === 0;
      });
      this.listCheckedOption[indexOfOther] = "other:" + event.target.value;
      this.listCheckedOption = [].concat(_toConsumableArray(this.listCheckedOption));
    },
    handleClickCheckAll: function handleClickCheckAll(isCheck) {
      if (isCheck) {
        this.listCheckedOption = Object.assign([], this.normalizedOptionList);
      } else {
        this.listCheckedOption = [];
      }
    },
    isOptionCheck: function isOptionCheck(option) {
      // Check for other option
      if (this.hasOther && this.getOtherValue && this.normalizedOptionList && this.normalizedOptionList.length > 0 && option === this.normalizedOptionList[this.normalizedOptionList.length - 1]) {
        return true;
      }
      return this.listCheckedOption.includes(option);
    },

    // Check if option is disabled
    isOptionDisabled: function isOptionDisabled(index) {
      // There is no exclusive option => always enable
      if (!this.exclusiveOptions || !this.exclusiveOptions.length) {
        return false;
      }
      // The option is selected option => enable
      if (this.listCheckedOption && this.listCheckedOption.includes(this.normalizedOptionList[index])) {
        return false;
      }
      // Exclusive option is checked
      var hasExclusiveOptionChecked = false;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.exclusiveOptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var optionIndex = _step2.value;

          if (this.listCheckedOption && this.listCheckedOption.includes(this.normalizedOptionList[optionIndex])) {
            hasExclusiveOptionChecked = true;
          }
        }
        // If exclusive option is checked, all other options is disabled
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (hasExclusiveOptionChecked) {
        return true;
      }
      // Exclusive option is disabled if any other option is checked
      if (this.exclusiveOptions.includes(index)) {
        if (this.listCheckedOption && this.listCheckedOption.length) {
          return true;
        }
      }
      return false;
    },
    getDisplayOption: function getDisplayOption(option) {
      var mapOptions = this.mapDisplayedOptions || this.mapOptionListByLang;
      if (!mapOptions) {
        return option;
      }
      if (mapOptions[option]) {
        return mapOptions[option];
      }
      return option;
    },

    // Check to show/hide option by parent option (In some case, option is only showed if parent option is checked)
    isOptionShow: function isOptionShow(option) {
      if (!this.mapParentOptions || !this.mapParentOptions[option]) {
        return true;
      }
      if (!this.listCheckedOption) {
        return false;
      }
      return this.listCheckedOption.includes(this.mapParentOptions[option]);
    },
    handleClickButton: function handleClickButton(button) {
      this.$emit("clickBtn", button.id);
    },
    getCheckboxId: function getCheckboxId(chunkIndex, index) {
      return "checkbox-" + this.name + "-" + this._uid + "-" + this.optionsPerColumn * chunkIndex + index;
    }
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(11);

var _MultiSelect = __webpack_require__(150);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

var _prefix = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* This component includes a label, and a multiselect with its label
Any error of the checkbox group (for example: required field) is showed in this component */
exports.default = {
  name: "MultiSelectWithLabel",
  props: {
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: [String, Array, Number],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: [Array, String, Object],
      default: function _default() {
        return [];
      }
    },
    isMulti: {
      type: Boolean,
      default: false
    },
    // Single select, but value is saved in an array
    isArrayModel: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    // Index of default selected option
    defaultValue: [Array, Number],
    optionLabel: String,
    optionModel: String,
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: function _default() {}
    },
    // key to get optionList (in case option list is an array)
    optionKey: {
      type: [String, Array]
    },
    hasClearButton: {
      type: Boolean,
      default: false
    },
    formObject: Object, // data of all form
    optionListTransformFunc: Function, // Transform function of option list
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    additionalSelectedInfoFunc: Function, // Function to display additional information of the selected item
    builderField: Object,
    infoLinkId: {
      type: String,
      default: null
    },
    hasOther: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MultiSelect: _MultiSelect2.default
  },
  data: function data() {
    var value = this.value;
    if (!this.isMulti && this.isArrayModel) {
      // Single select but result is saved in first element of array
      if (Array.isArray(this.value)) {
        if (this.value.length === 0) {
          value = null;
        } else {
          value = this.value[0];
        }
      }
    }
    return {
      inputVal: value,
      otherValue: ""
    };
  },
  created: function created() {
    var _this = this;

    if (this.defaultValue != null && this.value == null) {
      if (this.isMulti) {
        if (Array.isArray(this.defaultValue)) {
          this.inputVal = this.defaultValue.map(function (val) {
            return _this.normalizedOptionList[val];
          });
        } else {
          this.inputVal = this.normalizedOptionList[this.defaultValue];
        }
      } else {
        if (Array.isArray(this.defaultValue) && this.defaultValue.length > 0) {
          this.inputVal = this.normalizedOptionList[this.defaultValue[0]];
        } else {
          this.inputVal = this.normalizedOptionList[this.defaultValue];
        }
      }
    }
    if (!this.isMulti && this.hasOther && this.value && this.value.indexOf(_prefix.RADIO_OTHER_OPTIONS_PREFIX) === 0) {
      // Other option is selected
      this.inputVal = this.otherOption;
      this.otherValue = this.removeOtherRadioPrefix(this.value);
    }
  },

  //   created() {
  //     if (this.isMulti) {
  //       this.$emit("input", [this.normalizedOptionList[0]]);
  //     } else {
  //       this.$emit("input", this.normalizedOptionList[0]);
  //     }
  //   },
  computed: _extends({}, (0, _vuex.mapGetters)(["getImportFieldChanged"]), {
    isValueInputted: function isValueInputted() {
      if (!this.inputVal) {
        return false;
      }
      if (this.isMulti) {
        if (Array.isArray(this.inputVal)) {
          if (!this.inputVal.length) {
            return false;
          }
        }
      }
      return true;
    },
    hasAddOptionBtn: function hasAddOptionBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some(function (button) {
        return button.id === "add-option";
      });
    },
    hasAgencySettingBtn: function hasAgencySettingBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some(function (button) {
        return button.id === "agency-setting";
      });
    },
    agencySettingBtn: function agencySettingBtn() {
      if (!this.hasAgencySettingBtn) {
        return {};
      }
      return this.buttonGroups.find(function (button) {
        return button.id === "agency-setting";
      });
    },
    normalizedOptionList: function normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      if (this.optionList == null) {
        return [];
      }
      if (_typeof(this.optionList) === "object") {
        if (this.optionKey && this.optionList[this.optionKey]) {
          return this.optionList[this.optionKey];
        } else {
          return [];
        }
      }
      return this.optionList.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },
    customizeInputOption: function customizeInputOption() {
      return this.mapOptionListByLang && Object.keys(this.mapOptionListByLang).length && !this.optionLabel && !this.optionModel;
    },
    displayedOptionList: function displayedOptionList() {
      var _this2 = this;

      if (this.optionListTransformFunc) {
        return this.optionListTransformFunc(this.formObject, this.normalizedOptionList);
      }
      if (this.customizeInputOption) {
        return Object.keys(this.mapOptionListByLang).map(function (key) {
          return {
            original: key,
            display: _this2.mapOptionListByLang[key]
          };
        });
      } else {
        return this.normalizedOptionList;
      }
    },
    displayOptionLabel: function displayOptionLabel() {
      if (this.customizeInputOption) {
        return "display";
      }
      return this.optionLabel;
    },
    displayOptionModel: function displayOptionModel() {
      if (this.customizeInputOption) {
        return "original";
      }
      return this.optionModel;
    },
    isOtherSelected: function isOtherSelected() {
      if (!this.inputVal) {
        return false;
      }
      if (!this.optionListExcludeOther.includes(this.inputVal)) {
        return true;
      }
      return false;
    },
    optionListExcludeOther: function optionListExcludeOther() {
      return this.normalizedOptionList.slice(0, -1);
    },
    otherOption: function otherOption() {
      return this.normalizedOptionList[this.normalizedOptionList.length - 1];
    }
  }),
  watch: {
    inputVal: {
      handler: function handler(val, oldVal) {
        if (val === null || val === "types" || val === "tags" || val === "locations") {
          var valIndex = this.getImportFieldChanged.indexOf(val);
          var oldValIndex = this.getImportFieldChanged.indexOf(oldVal);
          if (val && valIndex == -1) {
            this.addImportFieldChanged(val);
          }
          if (oldValIndex !== -1 && val === null || oldValIndex !== -1 && val) {
            this.deleteImportFieldChanged(oldValIndex);
          }
        }
        if (!this.isMulti && this.isArrayModel) {
          this.$emit("input", [val]);
        } else {
          if (this.hasOther && this.otherValue && this.isOtherSelected) {
            this.$emit("input", _prefix.RADIO_OTHER_OPTIONS_PREFIX + this.otherValue);
          } else {
            this.$emit("input", val);
          }
        }
        if (val === null || val) {
          this.$emit("changed", val);
        }
      },

      immediate: true
    },
    value: {
      handler: function handler() {
        if (!this.isMulti && !this.isArrayModel) {
          if (this.value !== this.inputVal) {
            if (this.hasOther && this.value && this.value.indexOf(_prefix.RADIO_OTHER_OPTIONS_PREFIX) === 0) {
              // Other option is selected
              this.inputVal = this.otherOption;
            } else {
              this.inputVal = this.value;
            }
          }
        }
        if (this.builderField && this.builderField.setOutside) {
          this.inputVal = this.value;
        }
      },

      immediate: true
    }
  },
  methods: _extends({}, (0, _vuex.mapActions)(["addImportFieldChanged"]), (0, _vuex.mapActions)(["deleteImportFieldChanged"]), {
    getDisplayOption: function getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    },
    handleOtherTextboxInput: function handleOtherTextboxInput(event) {
      this.$emit("input", _prefix.RADIO_OTHER_OPTIONS_PREFIX + event.target.value);
    }
  })
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vuex = __webpack_require__(11);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: "EditLabelSetting",
  props: {
    title: {
      type: String,
      default: "Edit Label"
    },
    modelKey: String,
    defaultValue: String,
    useSmallIcon: {
      type: Boolean,
      default: false
    },
    onSubmitCallback: null,
    onSubmitCallbackData: {},
    tagName: {
      type: String,
      default: "label"
    },
    classList: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    additionalFields: Array
  },
  data: function data() {
    return {
      isShowInputDialog: false,
      originalData: {},
      listFields: []
    };
  },

  computed: _extends({}, (0, _vuex.mapGetters)(["isAgent", "agencyID", "agencyPublic", "agency"]), {
    displayLabel: function displayLabel() {
      var tokens = this.modelKey.split(".");
      var container = tokens[0] === "advance_setting" ? this.agency : this.agencyPublic;
      return this.tryGet(function () {
        return container[tokens[0]][tokens[1]];
      }) || this.defaultValue;
    },
    displayLabelTag: function displayLabelTag() {
      var disableToken = this.disabled ? "disabled=\"" + this.disabled + "\"" : "";
      return "<" + this.tagName + " class=\"" + this.classList + "\" " + disableToken + "\">" + this.displayLabel + "</" + this.tagName + ">";
    }
  }),
  methods: {
    showSettingDialog: function showSettingDialog() {
      var _this = this;

      var listKeys, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, field, res, listFields, initialData, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _field;

      return regeneratorRuntime.async(function showSettingDialog$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              listKeys = [this.modelKey];

              if (!(this.additionalFields && this.additionalFields.length)) {
                _context.next = 21;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 5;

              for (_iterator = this.additionalFields[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                field = _step.value;

                listKeys.push(field.modelKey);
              }
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](5);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 13:
              _context.prev = 13;
              _context.prev = 14;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 16:
              _context.prev = 16;

              if (!_didIteratorError) {
                _context.next = 19;
                break;
              }

              throw _iteratorError;

            case 19:
              return _context.finish(16);

            case 20:
              return _context.finish(13);

            case 21:
              _context.next = 23;
              return regeneratorRuntime.awrap(_axios2.default.get("/agency-settings/" + this.agencyID + "/?fields=" + listKeys.join(",")));

            case 23:
              res = _context.sent;
              listFields = [{
                type: _customDefineType.FORM_TYPE.TEXTBOX,
                model: this.modelKey
              }];
              initialData = _defineProperty({}, this.modelKey, res.data[this.modelKey] || this.defaultValue);

              if (!(this.additionalFields && this.additionalFields.length)) {
                _context.next = 46;
                break;
              }

              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 30;

              for (_iterator2 = this.additionalFields[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                _field = _step2.value;

                if (_field.modelKey === this.modelKey) {
                  // If the current setting is specified in the additionalFields, use the one in additional field
                  listFields = listFields.filter(function (field) {
                    return field.model !== _this.modelKey;
                  });
                }
                listFields.push({
                  type: _customDefineType.FORM_TYPE.TEXTBOX,
                  model: _field.modelKey,
                  label: _field.label
                });
                initialData[_field.modelKey] = res.data[_field.modelKey] || _field.defaultValue;
              }
              _context.next = 38;
              break;

            case 34:
              _context.prev = 34;
              _context.t1 = _context["catch"](30);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 38:
              _context.prev = 38;
              _context.prev = 39;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 41:
              _context.prev = 41;

              if (!_didIteratorError2) {
                _context.next = 44;
                break;
              }

              throw _iteratorError2;

            case 44:
              return _context.finish(41);

            case 45:
              return _context.finish(38);

            case 46:
              this.showInputDialog({
                title: this.title,
                listFields: listFields,
                data: initialData,
                onSubmitCallback: this.handleUpdateSetting
              });

            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[5, 9, 13, 21], [14,, 16, 20], [30, 34, 38, 46], [39,, 41, 45]]);
    },
    handleUpdateSetting: function handleUpdateSetting(info) {
      var res;
      return regeneratorRuntime.async(function handleUpdateSetting$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.patch("/agency-settings/" + this.agencyID + "/", info));

            case 2:
              res = _context2.sent;

              if (!(res && res.data)) {
                _context2.next = 11;
                break;
              }

              this.$toasted.show("Updated label");
              this.setAgency(res.data);

              if (!this.onSubmitCallback) {
                _context2.next = 10;
                break;
              }

              this.showInputDialog(null);
              _context2.next = 10;
              return regeneratorRuntime.awrap(this.onSubmitCallback(this.onSubmitCallbackData));

            case 10:
              this.$emit("settingUpdated", info);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "EditButtonSetting",
  props: {
    modelKey: String,
    defaultValue: String,
    classList: String,
    disabled: {
      type: Boolean,
      default: false
    },
    additionalFields: Array
  },
  computed: {
    convertedAdditionalFields: function convertedAdditionalFields() {
      if (!this.additionalFields) {
        return [];
      }
      return this.additionalFields.map(function (item) {
        return _extends({}, item, {
          modelKey: "public_advance_setting." + item.modelKey
        });
      });
    }
  }
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a961cb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailSectionRowLayout_vue__ = __webpack_require__(532);
function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33a961cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailSectionRowLayout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a961cb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailSectionRowLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "enginehire logo thin dark 1.0 letterpaths.svg?6d758ca065fd88057074c1ae99a6a422";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_FONT = exports.DEFAULT_FONT = {
  ROOT: "Open Sans",
  HEADINGS: "Open Sans"
};

var LIST_FONTS = exports.LIST_FONTS = ["Alegreya", "Antic Slab", "Arial", "Century Gothic", "Arizonia", "Assistant", "Avenir", "Baskerville", "Bree Serif", "Brush Script MT", "Cabin", "Cinzel", "Cormorant Garamond", "Courier New", "Impact", "Crimson Text", "Domine", "Fira Sans", "Gabriela", "Garamond", "Georgia", "Glacial Indifference", "Helvetica", "Josefin Sans", "Josefin Slab", "Lato", "Montserrat", "Mr Dafoe", "Mukta", "Open Sans", "perpetua-titling-mt", "Playfair Display", "Poppins", "PringleandTweed", "Articulat Demibold", "articulatcf-demibold", "articulatcf-regular", "articulatcf-demiboldoblique", "articulatcf-heavy", "Quicksand", "Rajdhani", "Raleway", "Roboto", "Source Sans Pro", "Tahoma", "Times New Roman", "Trebuchet MS", "Ubuntu", "Verdana", "white_gardenregular", "white_garden_wideregular", "optimaregular", "silver_south_scriptregular", "bell_mtbold", "bellezaregular", "dancing_scriptbold", "Calibri", "Lucida", "gothambold", "gothamblack", "gothambook", "gothammedium"];

var LIST_FONTS_MAIL = exports.LIST_FONTS_MAIL = ["Arial", "Courier New", "Garamond", "Georgia", "Helvetica", "Impact", "Times New Roman", "Tahoma", "Trebuchet MS", "Verdana"];

var LIST_FONT_SIZES = exports.LIST_FONT_SIZES = ["6px", "7px", "8px", "9px", "10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "22px", "24px", "26px", "28px", "30px", "36px", "40px", "48px", "60px", "80px"];

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac485b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimePickerWithLabel_vue__ = __webpack_require__(857);
function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ac485b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimePickerWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac485b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimePickerWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["CalendarView"] = factory();
	else
		root["CalendarView"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");
var isObject = __webpack_require__("861d");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2af1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var sign = __webpack_require__("f748");

// `Math.sign` method
// https://tc39.github.io/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "46c8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".cv-header{display:flex;flex:0 1 auto;flex-flow:row nowrap;align-items:center;min-height:2.5em;border-width:1px 1px 0 1px}.cv-header .periodLabel{display:flex;flex:1 1 auto;flex-flow:row nowrap;min-height:1.5em;line-height:1;font-size:1.5em}.cv-header,.cv-header button{border-style:solid;border-color:#ddd}.cv-header-nav,.cv-header .periodLabel{margin:.1em .6em}.cv-header-nav button,.cv-header .periodLabel{padding:.4em .6em}.cv-header button{box-sizing:border-box;line-height:1em;font-size:1em;border-width:1px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var aFunction = __webpack_require__("1c0b");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var bind = __webpack_require__("0538");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.github.io/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "608f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e412");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarViewHeader_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");

// `Array.prototype.fill` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    if (document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a45d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6ad");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarView_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c23c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".cv-wrapper{display:flex;flex-direction:column;flex-grow:1;height:100%;min-height:100%;max-height:100%;overflow-x:hidden;overflow-y:hidden}.cv-wrapper,.cv-wrapper div{box-sizing:border-box;line-height:1em;font-size:1em}.cv-header-days{flex-grow:0;flex-basis:auto;border-width:0 0 0 1px}.cv-header-day,.cv-header-days{display:flex;flex-shrink:0;flex-flow:row nowrap}.cv-header-day{flex-grow:1;flex-basis:0;align-items:center;justify-content:center;text-align:center;border-width:1px 1px 0 0}.cv-weeks{flex-shrink:1;flex-basis:auto;flex-flow:column nowrap;border-width:0 0 1px 1px}.cv-week,.cv-weeks{display:flex;flex-grow:1;overflow-y:auto;-ms-overflow-style:none}.cv-week{flex-flow:row nowrap;min-height:3em;border-width:0;position:relative;width:100%}.cv-day,.cv-week{flex-shrink:0;flex-basis:0;direction:ltr}.cv-day{display:flex;flex-grow:1;position:relative;position:-webkit-sticky;position:sticky;top:0;border-width:1px 1px 0 0}.cv-day,_:-ms-lang(x){position:relative}/ .cv-day-number{position:absolute;right:0}.cv-event{position:absolute;white-space:nowrap;overflow:hidden;background-color:#f7f7f7;border-width:1px;direction:ltr}.cv-wrapper.wrap-event-title-on-hover .cv-event:hover{white-space:normal;z-index:1}.cv-day,.cv-event,.cv-header-day,.cv-header-days,.cv-week,.cv-weeks{border-style:solid;border-color:#ddd}.cv-event .endTime:before{content:\"-\"}.cv-day-number,.cv-event,.cv-header-day{padding:.2em}.cv-day-number:before{margin-right:.5em}.cv-event.offset0{left:0}.cv-event.offset1{left:14.28571%}.cv-event.offset2{left:28.57143%}.cv-event.offset3{left:42.85714%}.cv-event.offset4{left:57.14286%}.cv-event.offset5{left:71.42857%}.cv-event.offset6{left:85.71429%}.cv-event.span1{width:calc(14.28571% - .05em)}.cv-event.span2{width:calc(28.57143% - .05em)}.cv-event.span3{width:calc(42.85714% - .05em);text-align:center}.cv-event.span4{width:calc(57.14286% - .05em);text-align:center}.cv-event.span5{width:calc(71.42857% - .05em);text-align:center}.cv-event.span6{width:calc(85.71429% - .05em);text-align:center}.cv-event.span7{width:calc(100% - .05em);text-align:center}.cv-week::-webkit-scrollbar,.cv-weeks::-webkit-scrollbar{width:0;background:transparent}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6ad":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c23c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("78370484", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e412":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("46c8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2953b5c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f748":
/***/ (function(module, exports) {

// `Math.sign` method implementation
// https://tc39.github.io/ecma262/#sec-math.sign
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"52d30776-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarView.vue?vue&type=template&id=3431d526&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'cv-wrapper',
		'locale-' + _vm.languageCode(_vm.displayLocale),
		'locale-' + _vm.displayLocale,
		'y' + _vm.periodStart.getFullYear(),
		'm' + _vm.paddedMonth(_vm.periodStart),
		'period-' + _vm.displayPeriodUom,
		'periodCount-' + _vm.displayPeriodCount,
		{
			past: _vm.isPastMonth(_vm.periodStart),
			future: _vm.isFutureMonth(_vm.periodStart),
			noIntl: !_vm.supportsIntl,
		} ]},[_vm._t("header",null,{"headerProps":_vm.headerProps}),_c('div',{staticClass:"cv-header-days"},[_vm._l((_vm.weekdayNames),function(label,index){return [_vm._t("dayHeader",[_c('div',{key:_vm.getColumnDOWClass(index),staticClass:"cv-header-day",class:_vm.getColumnDOWClass(index)},[_vm._v(" "+_vm._s(label)+" ")])],{"index":_vm.getColumnDOWClass(index),"label":label})]})],2),_c('div',{staticClass:"cv-weeks"},_vm._l((_vm.weeksOfPeriod),function(weekStart,weekIndex){return _c('div',{key:(weekIndex + "-week"),class:[
				'cv-week',
				'week' + (weekIndex + 1),
				'ws' + _vm.isoYearMonthDay(weekStart) ]},[_vm._l((_vm.daysOfWeek(weekStart)),function(day,dayIndex){return _c('div',{key:_vm.getColumnDOWClass(dayIndex),class:[
					'cv-day',
					_vm.getColumnDOWClass(dayIndex),
					'd' + _vm.isoYearMonthDay(day),
					'd' + _vm.isoMonthDay(day),
					'd' + _vm.paddedDay(day),
					'instance' + _vm.instanceOfMonth(day),
					{
						today: _vm.isSameDate(day, _vm.today()),
						outsideOfMonth: !_vm.isSameMonth(day, _vm.defaultedShowDate),
						past: _vm.isInPast(day),
						future: _vm.isInFuture(day),
						last: _vm.isLastDayOfMonth(day),
						lastInstance: _vm.isLastInstanceOfMonth(day),
					} ].concat( ((_vm.dateClasses && _vm.dateClasses[_vm.isoYearMonthDay(day)]) || null) ),on:{"click":function($event){return _vm.onClickDay(day, $event)},"drop":function($event){$event.preventDefault();return _vm.onDrop(day, $event)},"dragover":function($event){$event.preventDefault();return _vm.onDragOver(day, $event)},"dragenter":function($event){$event.preventDefault();return _vm.onDragEnter(day, $event)},"dragleave":function($event){$event.preventDefault();return _vm.onDragLeave(day, $event)}}},[_c('div',{staticClass:"cv-day-number"},[_vm._v(_vm._s(day.getDate()))]),_vm._t("dayContent",null,{"day":day})],2)}),_vm._l((_vm.getWeekItems(weekStart)),function(e){return [_vm._t("event",[_c('div',{key:e.id,staticClass:"cv-event",class:e.classes,style:(("top:" + (_vm.getItemTop(e)) + ";" + (e.originalEvent.style))),attrs:{"draggable":_vm.enableDragDrop,"title":e.title},domProps:{"innerHTML":_vm._s(_vm.getItemTitle(e))},on:{"dragstart":function($event){return _vm.onDragStart(e, $event)},"mouseenter":function($event){return _vm.onMouseEnterItem(e, $event)},"mouseleave":function($event){return _vm.onMouseLeaveItem(e, $event)},"click":function($event){$event.stopPropagation();return _vm.onClickItem(e, $event)}}})],{"event":e,"weekStartDate":weekStart,"top":_vm.getItemTop(e)})]})],2)}),0)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CalendarView.vue?vue&type=template&id=3431d526&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.sign.js
var es_math_sign = __webpack_require__("2af1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js



function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/construct.js



function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct;
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: ./src/components/CalendarMathMixin.js












/*
***********************************************************
This mix-in includes a computed properties and methods that
are useful in displaying a calendar. It has no state.
***********************************************************
*/
/* harmony default export */ var CalendarMathMixin = ({
  methods: {
    // ******************************
    // Series
    // ******************************
    today: function today() {
      return this.dateOnly(new Date());
    },
    beginningOfPeriod: function beginningOfPeriod(d, periodUom, startDow) {
      switch (periodUom) {
        case "year":
          return new Date(d.getFullYear(), 0);

        case "month":
          return new Date(d.getFullYear(), d.getMonth());

        case "week":
          return this.beginningOfWeek(d, startDow);

        default:
          return null;
      }
    },
    daysOfWeek: function daysOfWeek(weekStart) {
      var _this = this;

      return Array(7).fill().map(function (_, i) {
        return _this.addDays(weekStart, i);
      });
    },
    // ********************************************
    // Date transforms that retain time of day
    // ********************************************
    addDays: function addDays(d, days) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() + days, d.getHours(), d.getMinutes(), d.getSeconds());
    },
    beginningOfWeek: function beginningOfWeek(d, startDow) {
      return this.addDays(d, (startDow - d.getDay() - 7) % -7);
    },
    endOfWeek: function endOfWeek(d, startDow) {
      return this.addDays(this.beginningOfWeek(d, startDow), 7);
    },
    // ********************************************
    // Date transforms that ignore/wipe time of day
    // ********************************************
    beginningOfMonth: function beginningOfMonth(d) {
      return new Date(d.getFullYear(), d.getMonth());
    },
    instanceOfMonth: function instanceOfMonth(d) {
      return Math.ceil(d.getDate() / 7);
    },
    // This function increments a date by a given number of date units. Accepted units are: year, month, week. For year and month,
    // the day of the month is unchanged. This could cause an unexpected result if the units are "month" and the starting day is
    // higher than the number of days in the destination month. The count can be positive or negative.
    incrementPeriod: function incrementPeriod(d, uom, count) {
      return new Date(d.getFullYear() + (uom == "year" ? count : 0), d.getMonth() + (uom == "month" ? count : 0), d.getDate() + (uom == "week" ? count * 7 : 0));
    },
    // ******************************
    // Date formatting
    // ******************************
    paddedMonth: function paddedMonth(d) {
      return ("0" + String(d.getMonth() + 1)).slice(-2);
    },
    paddedDay: function paddedDay(d) {
      return ("0" + String(d.getDate())).slice(-2);
    },
    isoYearMonth: function isoYearMonth(d) {
      return d.getFullYear() + "-" + this.paddedMonth(d);
    },
    isoYearMonthDay: function isoYearMonthDay(d) {
      return this.isoYearMonth(d) + "-" + this.paddedDay(d);
    },
    isoMonthDay: function isoMonthDay(d) {
      return this.paddedMonth(d) + "-" + this.paddedDay(d);
    },
    formattedTime: function formattedTime(d, locale, options) {
      // Assume midnight = "all day" or indeterminate time
      if (d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0) return ""; // If Intl is not supported, send back the 24-hour, zero-padded
      // hours and minutes, expressed as local time.

      if (!this.supportsIntl()) {
        var ms = new Date().getTimezoneOffset() * 60000; // TZ offset in milliseconds

        return new Date(d - ms).toISOString().slice(11, 16);
      }

      return d.toLocaleTimeString(locale, options);
    },
    // Formats a date period in long English style. Examples supported:
    // May 2018
    // May – June 2018
    // December 2018 – January 2019
    // May 6 – 26, 2018
    // May 13 – June 2, 2018
    // December 16, 2018 – January 5, 2019
    formattedPeriod: function formattedPeriod(startDate, endDate, periodUom, monthNames) {
      var singleYear = startDate.getFullYear() === endDate.getFullYear();
      var singleMonth = this.isSameMonth(startDate, endDate);
      var isYear = periodUom === "year";
      var isMonth = periodUom === "month";
      var isWeek = !isYear && !isMonth;
      var s = [];
      s.push(monthNames[startDate.getMonth()]);

      if (isWeek) {
        s.push(" ");
        s.push(startDate.getDate());
      }

      if (!singleYear) {
        s.push(isWeek ? ", " : " ");
        s.push(startDate.getFullYear());
      }

      if (!singleMonth || !singleYear) {
        s.push(" \u2013 ");

        if (!singleMonth) {
          s.push(monthNames[endDate.getMonth()]);
        }

        if (isWeek) s.push(" ");
      } else if (isWeek) {
        s.push(" \u2013 ");
      }

      if (isWeek) {
        s.push(endDate.getDate());
        s.push(", ");
      } else {
        s.push(" ");
      }

      s.push(endDate.getFullYear());
      return s.join("");
    },
    // ******************************
    // Date comparisons
    // ******************************
    // Number of whole days between two dates. If present, time of day is ignored.
    // Treats dates as UTC to avoid DST changes within the perioud leading to incorrect
    // answers (#150).
    dayDiff: function dayDiff(d1, d2) {
      var endDate = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate()),
          startDate = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
      return (endDate - startDate) / 86400000;
    },
    isSameDate: function isSameDate(d1, d2) {
      // http://stackoverflow.com/questions/492994/compare-two-dates-with-javascript
      return this.dayDiff(d1, d2) === 0;
    },
    isSameDateTime: function isSameDateTime(d1, d2) {
      return d1.getTime() === d2.getTime();
    },
    isSameMonth: function isSameMonth(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
    },
    isPastMonth: function isPastMonth(d) {
      return this.beginningOfMonth(d) < this.beginningOfMonth(this.today());
    },
    isFutureMonth: function isFutureMonth(d) {
      return this.beginningOfMonth(d) > this.beginningOfMonth(this.today());
    },
    isInFuture: function isInFuture(d) {
      return this.dateOnly(d) > this.today();
    },
    isInPast: function isInPast(d) {
      return this.dateOnly(d) < this.today();
    },
    isLastInstanceOfMonth: function isLastInstanceOfMonth(d) {
      return d.getMonth() !== this.addDays(d, 7).getMonth();
    },
    isLastDayOfMonth: function isLastDayOfMonth(d) {
      return d.getMonth() !== this.addDays(d, 1).getMonth();
    },
    isSelectedDay: function isSelectedDay(d) {
      var _this2 = this;

      var day = Object.keys(this.dateClasses).find(function (day) {
        return _this2.isSameDate(_this2.fromIsoStringToLocalDate(day), d);
      });
      return day ? this.dateClasses[day] : undefined;
    },
    // Courtesy https://stackoverflow.com/questions/33908299/javascript-parse-a-string-to-date-as-local-time-zone/42626876#42626876
    fromIsoStringToLocalDate: function fromIsoStringToLocalDate(s) {
      var ds = s.split(/\D/).map(function (s) {
        return Number(s);
      });
      ds[1]--; // adjust month

      return construct_construct(Date, _toConsumableArray(ds));
    },
    toLocalDate: function toLocalDate(d) {
      return typeof d === "string" ? this.fromIsoStringToLocalDate(d) : new Date(d);
    },
    dateOnly: function dateOnly(d) {
      // Always use a copy, setHours mutates argument
      var d2 = new Date(d);
      d2.setHours(0, 0, 0, 0);
      return d2;
    },
    // ******************************
    // Localization
    // ******************************
    languageCode: function languageCode(l) {
      return l.substring(0, 2);
    },
    supportsIntl: function supportsIntl() {
      return typeof Intl !== "undefined";
    },
    getFormattedMonthNames: function getFormattedMonthNames(locale, format) {
      // Use the provided locale and format if possible to obtain the name of the month
      if (!this.supportsIntl()) return Array(12).fill("");
      var formatter = new Intl.DateTimeFormat(locale, {
        month: format
      }); // The year doesn't matter, using 2017 for convenience

      return Array(12).fill().map(function (_, i) {
        return formatter.format(new Date(2017, i, 1));
      });
    },
    getFormattedWeekdayNames: function getFormattedWeekdayNames(locale, format, startingDayOfWeek) {
      // Use the provided locale and format if possible to obtain the name of the days of the week
      if (!this.supportsIntl()) return Array(7).fill("");
      var formatter = new Intl.DateTimeFormat(locale, {
        weekday: format
      }); // 2017 starts on Sunday, so use it as the baseline date

      return Array(7).fill().map(function (_, i) {
        return formatter.format(new Date(2017, 0, (i + 1 + startingDayOfWeek) % 7));
      });
    },
    getDefaultBrowserLocale: function getDefaultBrowserLocale() {
      // If not running in the browser, cannot determine a default, return the code for unknown (blank is invalid)
      if (typeof navigator === "undefined") return "unk"; // Return the browser's language setting, implementation is browser-specific

      return (navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.browserLanguage).toLowerCase();
    },
    // ******************************
    // Events
    // ******************************
    normalizeEvent: function normalizeEvent(event, isHovered) {
      // Classes may be a string, an array, or null. Normalize to an array
      var eventClasses = event.classes ? Array.isArray(event.classes) ? _toConsumableArray(event.classes) : [event.classes] : []; // Provides support for pseudo-hover of entire event when one part of it is hovered

      if (isHovered) eventClasses.push("isHovered");
      return {
        originalEvent: event,
        startDate: this.toLocalDate(event.startDate),
        // For an event without an end date, the end date is the start date
        endDate: this.toLocalDate(event.endDate || event.startDate),
        classes: eventClasses,
        // Events without a title are untitled
        title: event.title || "Untitled",
        // An ID is *required*. Auto-generating leads to weird bugs because these are used as keys and passed in events
        id: event.id
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarView.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CalendarViewvue_type_script_lang_js_ = ({
  name: "CalendarView",
  mixins: [CalendarMathMixin],
  props: {
    showDate: {
      type: Date,
      default: undefined
    },
    displayPeriodUom: {
      type: String,
      default: "month"
    },
    displayPeriodCount: {
      type: Number,
      default: 1
    },
    locale: {
      type: String,
      default: undefined
    },
    monthNameFormat: {
      type: String,
      default: "long"
    },
    weekdayNameFormat: {
      type: String,
      default: "short"
    },
    showEventTimes: {
      type: Boolean,
      default: false
    },
    timeFormatOptions: {
      type: Object,
      default: function _default() {}
    },
    disablePast: {
      type: Boolean,
      default: false
    },
    disableFuture: {
      type: Boolean,
      default: false
    },
    enableDragDrop: {
      type: Boolean,
      default: false
    },
    startingDayOfWeek: {
      type: Number,
      default: 0
    },
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dateClasses: {
      type: Object,
      default: function _default() {}
    },
    eventTop: {
      type: String,
      default: "1.4em"
    },
    eventContentHeight: {
      type: String,
      default: "1.4em"
    },
    eventBorderHeight: {
      type: String,
      default: "2px"
    },
    periodChangedCallback: {
      type: Function,
      default: undefined
    },
    currentPeriodLabel: {
      type: String,
      default: ""
    },
    currentPeriodLabelIcons: {
      type: String,
      default: "⇤-⇥"
    },
    doEmitItemMouseEvents: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentDragItem: null,
      currentHoveredItemId: undefined
    };
  },
  computed: {
    /*
    Props cannot default to computed/method returns, so create defaulted version of this
    property and use it rather than the bare prop (Vue Issue #6013).
    */
    displayLocale: function displayLocale() {
      return this.locale || this.getDefaultBrowserLocale();
    },

    /*
    ShowDate, but defaulted to today. Needed both for periodStart below and for the
    "outside of month" class. Any time component passed as part of showDate is discarded.
    */
    defaultedShowDate: function defaultedShowDate() {
      if (this.showDate) return this.dateOnly(this.showDate);
      return this.today();
    },

    /*
    Given the showDate, defaulted to today, computes the beginning and end of the period
    that the date falls within.
    */
    periodStart: function periodStart() {
      return this.beginningOfPeriod(this.defaultedShowDate, this.displayPeriodUom, this.startingDayOfWeek);
    },
    periodEnd: function periodEnd() {
      return this.addDays(this.incrementPeriod(this.periodStart, this.displayPeriodUom, this.displayPeriodCount), -1);
    },

    /*
    For month and year views, the first and last dates displayed in the grid may not
    be the same as the intended period, since the period may not start and stop evenly
    on the starting day of the week.
    */
    displayFirstDate: function displayFirstDate() {
      return this.beginningOfWeek(this.periodStart, this.startingDayOfWeek);
    },
    displayLastDate: function displayLastDate() {
      return this.endOfWeek(this.periodEnd, this.startingDayOfWeek);
    },

    /*
    Create an array of dates, where each date represents the beginning of a week that
    should be rendered in the view for the current period.
    */
    weeksOfPeriod: function weeksOfPeriod() {
      var _this = this;

      // Returns an array of object representing the date of the beginning of each week
      // included in the view.
      var numWeeks = Math.floor((this.dayDiff(this.displayFirstDate, this.displayLastDate) + 1) / 7);
      return Array(numWeeks).fill().map(function (_, i) {
        return _this.addDays(_this.displayFirstDate, i * 7);
      });
    },
    // Cache the names based on current locale and format settings
    monthNames: function monthNames() {
      return this.getFormattedMonthNames(this.displayLocale, this.monthNameFormat);
    },
    weekdayNames: function weekdayNames() {
      return this.getFormattedWeekdayNames(this.displayLocale, this.weekdayNameFormat, this.startingDayOfWeek);
    },
    // Ensure all item properties have suitable default
    fixedItems: function fixedItems() {
      var self = this;
      return this.events.map(function (e) {
        return self.normalizeEvent(e, self.currentHoveredItemId && e.id === self.currentHoveredItemId);
      });
    },
    // Creates the HTML to render the date range for the calendar header.
    periodLabel: function periodLabel() {
      return this.formattedPeriod(this.periodStart, this.periodEnd, this.displayPeriodUom, this.monthNames);
    },
    // Period that today's date sits within
    currentPeriodStart: function currentPeriodStart() {
      return this.beginningOfPeriod(this.today(), this.displayPeriodUom, this.startingDayOfWeek);
    },
    currentPeriodEnd: function currentPeriodEnd() {
      return this.addDays(this.incrementPeriod(this.currentPeriodStart, this.displayPeriodUom, this.displayPeriodCount), -1);
    },
    currentPeriodLabelFinal: function currentPeriodLabelFinal() {
      var c = this.currentPeriodStart;
      var s = this.periodStart;
      if (!this.currentPeriodLabel) return this.formattedPeriod(c, this.currentPeriodEnd, this.displayPeriodUom, this.monthNames);
      if (this.currentPeriodLabel === "icons") return this.currentPeriodLabelIcons[Math.sign(c - s) + 1];
      return this.currentPeriodLabel;
    },
    headerProps: function headerProps() {
      return {
        // Dates for UI navigation
        previousYear: this.getIncrementedPeriod(-12),
        previousPeriod: this.getIncrementedPeriod(-1),
        nextPeriod: this.getIncrementedPeriod(1),
        previousFullPeriod: this.getIncrementedPeriod(-this.displayPeriodCount),
        nextFullPeriod: this.getIncrementedPeriod(this.displayPeriodCount),
        nextYear: this.getIncrementedPeriod(12),
        currentPeriod: this.currentPeriodStart,
        currentPeriodLabel: this.currentPeriodLabelFinal,
        // Dates for header display
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        // Extra information that could be useful to a custom header
        displayLocale: this.displayLocale,
        displayFirstDate: this.displayFirstDate,
        displayLastDate: this.displayLastDate,
        monthNames: this.monthNames,
        fixedEvents: this.fixedItems,
        periodLabel: this.periodLabel
      };
    },
    periodRange: function periodRange() {
      return {
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        displayFirstDate: this.displayFirstDate,
        displayLastDate: this.displayLastDate
      };
    }
  },
  watch: {
    periodRange: {
      immediate: true,
      handler: function handler(newVal) {
        if (this.periodChangedCallback) {
          this.$emit("period-changed");
          this.periodChangedCallback(newVal, "watch");
        }
      }
    }
  },
  methods: {
    // ******************************
    // UI Events
    // ******************************
    onClickDay: function onClickDay(day, windowEvent) {
      if (this.disablePast && this.isInPast(day)) return;
      if (this.disableFuture && this.isInFuture(day)) return;
      this.$emit("click-date", day, windowEvent);
    },
    onClickItem: function onClickItem(calendarItem, windowEvent) {
      this.$emit("click-event", calendarItem, windowEvent);
    },

    /*
    The day name header needs to know the dow for class assignment, and this value should
    not change based on startingDayOfWeek (i.e., Sunday is always 0). This function
    computes the dow for a given day index.
    */
    getColumnDOWClass: function getColumnDOWClass(dayIndex) {
      return "dow" + (dayIndex + this.startingDayOfWeek) % 7;
    },
    // ******************************
    // Date Periods
    // ******************************

    /*
    Returns a date for the current display date moved forward or backward by a given
    number of the current display units. Returns null if said move would result in a
    disallowed display period.
    */
    getIncrementedPeriod: function getIncrementedPeriod(count) {
      var newStartDate = this.incrementPeriod(this.periodStart, this.displayPeriodUom, count);
      var newEndDate = this.incrementPeriod(newStartDate, this.displayPeriodUom, this.displayPeriodCount);
      if (this.disablePast && newEndDate <= this.today()) return null;
      if (this.disableFuture && newStartDate > this.today()) return null;
      return newStartDate;
    },
    // ******************************
    // Hover items (#95, #136)
    // ******************************
    onMouseEnterItem: function onMouseEnterItem(calendarItem, windowEvent) {
      this.currentHoveredItemId = calendarItem.id;

      if (this.doEmitItemMouseEvents) {
        this.$emit("item-mouseenter", calendarItem, windowEvent);
      }
    },
    onMouseLeaveItem: function onMouseLeaveItem(calendarItem, windowEvent) {
      this.currentHoveredItemId = undefined;

      if (this.doEmitItemMouseEvents) {
        this.$emit("item-mouseleave", calendarItem, windowEvent);
      }
    },
    // ******************************
    // Drag and drop items
    // ******************************
    onDragStart: function onDragStart(calendarItem, windowEvent) {
      if (!this.enableDragDrop) return false; // Not using dataTransfer.setData to store the item ID because it (a) doesn't allow access to the data being
      // dragged during dragover, dragenter, and dragleave events, and because storing an ID requires an unnecessary
      // lookup. This does limit the drop zones to areas within this instance of this component.

      this.currentDragItem = calendarItem; // Firefox and possibly other browsers require dataTransfer to be set, even if the value is not used. IE11
      // requires that the first argument be exactly "text" (not "text/plain", etc.).

      windowEvent.dataTransfer.setData("text", "foo");
      this.$emit("drag-start", calendarItem, windowEvent);
      return true;
    },
    handleDragEvent: function handleDragEvent(bubbleEventName, bubbleParam, windowEvent) {
      if (!this.enableDragDrop) return false; // If the user drags an event FROM this calendar TO this calendar, currentDragItem will be initialized to the
      // most recent item with a dragStart event. If not, we still emit the event, and the caller will need to
      // determine what to do based on the third argument (windowEvent, which gives them access to `dataTransfer`).
      // This allows developers to create custom calendars where things can be dragged in from the outside. This
      // also allows developers using scoped slots for items to handle the drag and drop themselves.

      this.$emit(bubbleEventName, this.currentDragItem, bubbleParam, windowEvent);
      return true;
    },
    onDragOver: function onDragOver(day, windowEvent) {
      this.handleDragEvent("drag-over-date", day, windowEvent);
    },
    onDragEnter: function onDragEnter(day, windowEvent) {
      if (!this.handleDragEvent("drag-enter-date", day, windowEvent)) return;
      windowEvent.target.classList.add("draghover");
    },
    onDragLeave: function onDragLeave(day, windowEvent) {
      if (!this.handleDragEvent("drag-leave-date", day, windowEvent)) return;
      windowEvent.target.classList.remove("draghover");
    },
    onDrop: function onDrop(day, windowEvent) {
      if (!this.handleDragEvent("drop-on-date", day, windowEvent)) return;
      windowEvent.target.classList.remove("draghover");
    },
    // ******************************
    // Calendar Items
    // ******************************
    findAndSortItemsInWeek: function findAndSortItemsInWeek(weekStart) {
      var _this2 = this;

      // Return a list of items that INCLUDE any day of a week starting on a
      // particular day. Sorted so the items that start earlier are always
      // shown first.
      var items = this.fixedItems.filter(function (item) {
        return item.startDate < _this2.addDays(weekStart, 7) && item.endDate >= weekStart;
      }, this).sort(function (a, b) {
        if (a.startDate < b.startDate) return -1;
        if (b.startDate < a.startDate) return 1;
        if (a.endDate > b.endDate) return -1;
        if (b.endDate > a.endDate) return 1;
        return a.id < b.id ? -1 : 1;
      });
      return items;
    },
    getWeekItems: function getWeekItems(weekStart) {
      // Return a list of items that CONTAIN the week starting on a day.
      // Sorted so the items that start earlier are always shown first.
      var items = this.findAndSortItemsInWeek(weekStart);
      var results = [];
      var itemRows = [[], [], [], [], [], [], []];

      for (var i = 0; i < items.length; i++) {
        var ep = Object.assign({}, items[i], {
          classes: _toConsumableArray(items[i].classes),
          eventRow: 0
        });
        var continued = ep.startDate < weekStart;
        var startOffset = continued ? 0 : this.dayDiff(weekStart, ep.startDate);
        var span = Math.min(7 - startOffset, this.dayDiff(this.addDays(weekStart, startOffset), ep.endDate) + 1);
        if (continued) ep.classes.push("continued");
        if (this.dayDiff(weekStart, ep.endDate) > 6) ep.classes.push("toBeContinued");
        if (this.isInPast(ep.endDate)) ep.classes.push("past");
        if (ep.originalEvent.url) ep.classes.push("hasUrl");

        for (var d = 0; d < 7; d++) {
          if (d === startOffset) {
            var s = 0;

            while (itemRows[d][s]) {
              s++;
            }

            ep.eventRow = s;
            itemRows[d][s] = true;
          } else if (d < startOffset + span) {
            itemRows[d][ep.eventRow] = true;
          }
        }

        ep.classes.push("offset".concat(startOffset));
        ep.classes.push("span".concat(span));
        results.push(ep);
      }

      return results;
    },

    /*
    Creates the HTML to prefix the item title showing the item's start and/or
    end time. Midnight is not displayed.
    */
    getFormattedTimeRange: function getFormattedTimeRange(e) {
      var startTime = this.formattedTime(e.startDate, this.displayLocale, this.timeFormatOptions);
      var endTime = "";

      if (!this.isSameDateTime(e.startDate, e.endDate)) {
        endTime = this.formattedTime(e.endDate, this.displayLocale, this.timeFormatOptions);
      }

      return (startTime !== "" ? "<span class=\"startTime\">".concat(startTime, "</span>") : "") + (endTime !== "" ? "<span class=\"endTime\">".concat(endTime, "</span>") : "");
    },
    getItemTitle: function getItemTitle(e) {
      if (!this.showEventTimes) return e.title;
      return this.getFormattedTimeRange(e) + " " + e.title;
    },
    getItemTop: function getItemTop(e) {
      // Compute the top position of the item based on its assigned row within the given week.
      var r = e.eventRow;
      var h = this.eventContentHeight;
      var b = this.eventBorderHeight;
      return "calc(".concat(this.eventTop, " + ").concat(r, "*").concat(h, " + ").concat(r, "*").concat(b, ")");
    }
  }
});
// CONCATENATED MODULE: ./src/components/CalendarView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarViewvue_type_script_lang_js_ = (CalendarViewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarView.vue?vue&type=style&index=0&lang=css&
var CalendarViewvue_type_style_index_0_lang_css_ = __webpack_require__("a45d");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/CalendarView.vue






/* normalize component */

var component = normalizeComponent(
  components_CalendarViewvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarView = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"52d30776-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarViewHeader.vue?vue&type=template&id=1b0c0f08&
var CalendarViewHeadervue_type_template_id_1b0c0f08_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cv-header"},[_c('div',{staticClass:"cv-header-nav"},[_c('button',{staticClass:"previousYear",attrs:{"disabled":!_vm.headerProps.previousYear},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.previousYear)}}},[_vm._v(" << ")]),_c('button',{staticClass:"previousPeriod",attrs:{"disabled":!_vm.headerProps.previousPeriod},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.previousPeriod)}}},[_vm._v(" < ")]),_c('button',{staticClass:"currentPeriod",on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.currentPeriod)}}},[_vm._v(" "+_vm._s(_vm.headerProps.currentPeriodLabel)+" ")]),_c('button',{staticClass:"nextPeriod",attrs:{"disabled":!_vm.headerProps.nextPeriod},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.nextPeriod)}}},[_vm._v(" > ")]),_c('button',{staticClass:"nextYear",attrs:{"disabled":!_vm.headerProps.nextYear},on:{"click":function($event){$event.preventDefault();return _vm.onInput(_vm.headerProps.nextYear)}}},[_vm._v(" >> ")])]),_c('div',{staticClass:"periodLabel"},[_vm._t("label",[_vm._v(_vm._s(_vm.headerProps.periodLabel))])],2)])}
var CalendarViewHeadervue_type_template_id_1b0c0f08_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CalendarViewHeader.vue?vue&type=template&id=1b0c0f08&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarViewHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var CalendarViewHeadervue_type_script_lang_js_ = ({
  name: "CalendarViewHeader",
  props: {
    headerProps: {
      type: Object,
      required: true
    }
  },
  methods: {
    onInput: function onInput(d) {
      this.$emit("input", d);
    }
  }
});
// CONCATENATED MODULE: ./src/components/CalendarViewHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarViewHeadervue_type_script_lang_js_ = (CalendarViewHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarViewHeader.vue?vue&type=style&index=0&lang=css&
var CalendarViewHeadervue_type_style_index_0_lang_css_ = __webpack_require__("608f");

// CONCATENATED MODULE: ./src/components/CalendarViewHeader.vue






/* normalize component */

var CalendarViewHeader_component = normalizeComponent(
  components_CalendarViewHeadervue_type_script_lang_js_,
  CalendarViewHeadervue_type_template_id_1b0c0f08_render,
  CalendarViewHeadervue_type_template_id_1b0c0f08_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarViewHeader = (CalendarViewHeader_component.exports);
// CONCATENATED MODULE: ./src/components/bundle.js


 // Export the compiled Vue components, and also the mixin for those who wish to use
// those methods in their own custom headers, etc.


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js
/* concated harmony reexport CalendarView */__webpack_require__.d(__webpack_exports__, "CalendarView", function() { return CalendarView; });
/* concated harmony reexport CalendarViewHeader */__webpack_require__.d(__webpack_exports__, "CalendarViewHeader", function() { return CalendarViewHeader; });
/* concated harmony reexport CalendarMathMixin */__webpack_require__.d(__webpack_exports__, "CalendarMathMixin", function() { return CalendarMathMixin; });




/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
});
//# sourceMappingURL=CalendarView.umd.js.map

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var Language =
/*#__PURE__*/
function () {
  function Language(language, months, monthsAbbr, days) {
    _classCallCheck(this, Language);

    this.language = language;
    this.months = months;
    this.monthsAbbr = monthsAbbr;
    this.days = days;
    this.rtl = false;
    this.ymd = false;
    this.yearSuffix = '';
  }

  _createClass(Language, [{
    key: "language",
    get: function get() {
      return this._language;
    },
    set: function set(language) {
      if (typeof language !== 'string') {
        throw new TypeError('Language must be a string');
      }

      this._language = language;
    }
  }, {
    key: "months",
    get: function get() {
      return this._months;
    },
    set: function set(months) {
      if (months.length !== 12) {
        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
      }

      this._months = months;
    }
  }, {
    key: "monthsAbbr",
    get: function get() {
      return this._monthsAbbr;
    },
    set: function set(monthsAbbr) {
      if (monthsAbbr.length !== 12) {
        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
      }

      this._monthsAbbr = monthsAbbr;
    }
  }, {
    key: "days",
    get: function get() {
      return this._days;
    },
    set: function set(days) {
      if (days.length !== 7) {
        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
      }

      this._days = days;
    }
  }]);

  return Language;
}(); // eslint-disable-next-line

var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']) // eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,

  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear(date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth(date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth();
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate(date) {
    return this.useUtc ? date.getUTCDate() : date.getDate();
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay(date) {
    return this.useUtc ? date.getUTCDay() : date.getDay();
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours(date) {
    return this.useUtc ? date.getUTCHours() : date.getHours();
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes(date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear(date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth(date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate(date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates(date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }

    return d1.getTime() === d2.getTime();
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }

    return !isNaN(date.getTime());
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if (_typeof(date) !== 'object') {
      throw TypeError('Invalid Type');
    }

    return days[this.getDay(date)];
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }

    if (_typeof(month) === 'object') {
      return months[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return months[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }

    if (_typeof(month) === 'object') {
      return monthsAbbr[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return monthsAbbr[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth(year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31;
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';

      case 2:
      case 22:
        return 'nd';

      case 3:
      case 23:
        return 'rd';

      default:
        return 'th';
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray(start, end) {
    var dates = [];

    while (start <= end) {
      dates.push(new Date(start));
      start = this.setDate(new Date(start), this.getDate(new Date(start)) + 1);
    }

    return dates;
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput(val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
  }
};
var makeDateUtils = function makeDateUtils(useUtc) {
  return _objectSpread({}, utils, {
    useUtc: useUtc
  });
};
var utils$1 = _objectSpread({}, utils) // eslint-disable-next-line
;

var script = {
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }

      if (this.typedDate) {
        return this.typedDate;
      }

      return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
    },
    computedInputClass: function computedInputClass() {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ');
        }

        return _objectSpread({
          'form-control': true
        }, this.inputClass);
      }

      return this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate() {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar() {
      this.$emit('showCalendar');
    },

    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate(event) {
      // close calendar if escape or enter are pressed
      if ([27, // escape
      13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);

        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred() {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },

    /**
     * emit a clearDate event
     */
    clearDate: function clearDate() {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted() {
    this.input = this.$el.querySelector('input');
  }
} // eslint-disable-next-line
;

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: { "input-group": _vm.bootstrapStyling } },
    [
      _vm.calendarButton
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__calendar-button",
              class: { "input-group-prepend": _vm.bootstrapStyling },
              style: { "cursor:not-allowed;": _vm.disabled },
              on: { click: _vm.showCalendar }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.calendarButtonIcon }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.calendarButtonIconContent) +
                        "\n        "
                    ),
                    !_vm.calendarButtonIcon
                      ? _c("span", [_vm._v("…")])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: _vm.refName,
        class: _vm.computedInputClass,
        attrs: {
          type: _vm.inline ? "hidden" : "text",
          name: _vm.name,
          id: _vm.id,
          "open-date": _vm.openDate,
          placeholder: _vm.placeholder,
          "clear-button": _vm.clearButton,
          disabled: _vm.disabled,
          required: _vm.required,
          readonly: !_vm.typeable,
          autocomplete: "off"
        },
        domProps: { value: _vm.formattedValue },
        on: {
          click: _vm.showCalendar,
          keyup: _vm.parseTypedDate,
          blur: _vm.inputBlurred
        }
      }),
      _vm._v(" "),
      _vm.clearButton && _vm.selectedDate
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__clear-button",
              class: { "input-group-append": _vm.bootstrapStyling },
              on: {
                click: function($event) {
                  return _vm.clearDate()
                }
              }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.clearButtonIcon }, [
                    !_vm.clearButtonIcon ? _c("span", [_vm._v("×")]) : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("afterDateInput")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DateInput = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      "default": function _default(day) {
        return day.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }

      return this.translation.days;
    },

    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = this.pageDate;
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());

      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
      }

      return this.utils.getDay(dObj);
    },

    /**
     * @return {Object[]}
     */
    days: function days() {
      var d = this.pageDate;
      var days = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));

      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj),
          isHighlightStart: this.isHighlightStart(dObj),
          isHighlightEnd: this.isHighlightEnd(dObj),
          isToday: this.utils.compareDates(dObj, new Date()),
          isWeekend: this.utils.getDay(dObj) === 0 || this.utils.getDay(dObj) === 6,
          isSaturday: this.utils.getDay(dObj) === 6,
          isSunday: this.utils.getDay(dObj) === 0
        });
        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
      }

      return days;
    },

    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName() {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
    },

    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd() {
      return this.translation.ymd && this.translation.ymd === true;
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function selectDate(date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false;
      }

      this.$emit('selectDate', date);
    },

    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth() {
      return this.utils.getMonth(this.pageDate);
    },

    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar() {
      this.$emit('showMonthCalendar');
    },

    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth(incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },

    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth() {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },

    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
    },

    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth() {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },

    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
    },

    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
    },

    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate(date) {
      var _this = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (_this.utils.compareDates(date, d)) {
            disabledDates = true;
            return true;
          }
        });
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true;
            }
          }
        });
      }

      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    },

    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate(date) {
      var _this2 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (_this2.utils.compareDates(date, d)) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted;
    },
    dayClasses: function dayClasses(day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      };
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart(date) {
      return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd(date) {
      return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
    },

    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDayView,
          expression: "showDayView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "day__month_btn",
            class: _vm.allowedToShowView("month") ? "up" : "",
            on: { click: _vm.showMonthCalendar }
          },
          [
            _vm._v(
              _vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) +
                " " +
                _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.isRtl ? "flex-rtl" : "" },
        [
          _vm._l(_vm.daysOfWeek, function(d) {
            return _c(
              "span",
              { key: d.timestamp, staticClass: "cell day-header" },
              [_vm._v(_vm._s(d))]
            )
          }),
          _vm._v(" "),
          _vm.blankDays > 0
            ? _vm._l(_vm.blankDays, function(d) {
                return _c("span", {
                  key: d.timestamp,
                  staticClass: "cell day blank"
                })
              })
            : _vm._e(),
          _vm._l(_vm.days, function(day) {
            return _c("span", {
              key: day.timestamp,
              staticClass: "cell day",
              class: _vm.dayClasses(day),
              domProps: { innerHTML: _vm._s(_vm.dayCellContent(day)) },
              on: {
                click: function($event) {
                  return _vm.selectDate(day)
                }
              }
            })
          })
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerDay = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
var script$2 = {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    months: function months() {
      var d = this.pageDate;
      var months = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 12; i++) {
        months.push({
          month: this.utils.getMonthName(i, this.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
      }

      return months;
    },

    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }

      this.$emit('selectMonth', month);
    },

    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },

    /**
     * Decrements the year
     */
    previousYear: function previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },

    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Increments the year
     */
    nextYear: function nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },

    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar() {
      this.$emit('showYearCalendar');
    },

    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMonthView,
          expression: "showMonthView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "month__year_btn",
            class: _vm.allowedToShowView("year") ? "up" : "",
            on: { click: _vm.showYearCalendar }
          },
          [_vm._v(_vm._s(_vm.pageYearName))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.months, function(month) {
        return _c(
          "span",
          {
            key: month.timestamp,
            staticClass: "cell month",
            class: { selected: month.isSelected, disabled: month.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectMonth(month)
              }
            }
          },
          [_vm._v(_vm._s(month.month))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerMonth = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years() {
      var d = this.pageDate;
      var years = []; // set up a new date object to the beginning of the current 'page'7

      var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 10; i++) {
        years.push({
          year: this.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
      }

      return years;
    },

    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade() {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(decadeStart, " - ").concat(decadeEnd).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  methods: {
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }

      this.$emit('selectYear', year);
    },
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade() {
      if (this.isPreviousDecadeDisabled()) {
        return false;
      }

      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage;
    },
    nextDecade: function nextDecade() {
      if (this.isNextDecadeDisabled()) {
        return false;
      }

      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage;
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
    },

    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showYearView,
          expression: "showYearView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.getPageDecade))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.years, function(year) {
        return _c(
          "span",
          {
            key: year.timestamp,
            staticClass: "cell year",
            class: { selected: year.isSelected, disabled: year.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectYear(year)
              }
            }
          },
          [_vm._v(_vm._s(year.year))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerYear = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
var script$4 = {
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      "default": 'dd MMM yyyy'
    },
    language: {
      type: Object,
      "default": function _default() {
        return en;
      }
    },
    openDate: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      "default": 'day'
    },
    maximumView: {
      type: String,
      "default": 'year'
    }
  },
  data: function data() {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,

      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,

      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,

      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    };
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView() {
      if (!this.initialView) {
        return this.minimumView;
      }

      return this.initialView;
    },
    pageDate: function pageDate() {
      return new Date(this.pageTimestamp);
    },
    translation: function translation() {
      return this.language;
    },
    calendarStyle: function calendarStyle() {
      return {
        position: this.isInline ? 'static' : undefined
      };
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return !!this.inline;
    },
    isRtl: function isRtl() {
      return this.translation.rtl === true;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }

      this.setPageDate(this.selectedDate);
    },

    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar() {
      if (this.disabled || this.isInline) {
        return false;
      }

      if (this.isOpen) {
        return this.close(true);
      }

      this.setInitialView();
    },

    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView() {
      var initialView = this.computedInitialView;

      if (!this.allowedToShowView(initialView)) {
        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
      }

      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break;

        case 'month':
          this.showMonthCalendar();
          break;

        default:
          this.showDayCalendar();
          break;
      }
    },

    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView(view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);
      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
    },

    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar() {
      if (!this.allowedToShowView('day')) {
        return false;
      }

      this.close();
      this.showDayView = true;
      return true;
    },

    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar() {
      if (!this.allowedToShowView('month')) {
        return false;
      }

      this.close();
      this.showMonthView = true;
      return true;
    },

    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar() {
      if (!this.allowedToShowView('year')) {
        return false;
      }

      this.close();
      this.showYearView = true;
      return true;
    },

    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate(timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },

    /**
     * Clear the selected date
     */
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },

    /**
     * @param {Object} date
     */
    selectDate: function selectDate(date) {
      this.setDate(date.timestamp);

      if (!this.isInline) {
        this.close(true);
      }

      this.resetTypedDate = new Date();
    },

    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate(date) {
      this.$emit('selectedDisabled', date);
    },

    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      var date = new Date(month.timestamp);

      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },

    /**
     * @param {Object} year
     */
    selectYear: function selectYear(year) {
      var date = new Date(year.timestamp);

      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },

    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue(date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }

      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return;
      }

      this.selectedDate = date;
      this.setPageDate(date);
    },

    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate(date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }

      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },

    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },

    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate(date) {
      this.setDate(date.getTime());
    },

    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close(emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;

      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }

        document.removeEventListener('click', this.clickOutside, false);
      }
    },

    /**
     * Initiate the component
     */
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }

      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
} // eslint-disable-next-line
;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vdp-datepicker",
      class: [_vm.wrapperClass, _vm.isRtl ? "rtl" : ""]
    },
    [
      _c(
        "date-input",
        {
          attrs: {
            selectedDate: _vm.selectedDate,
            resetTypedDate: _vm.resetTypedDate,
            format: _vm.format,
            translation: _vm.translation,
            inline: _vm.inline,
            id: _vm.id,
            name: _vm.name,
            refName: _vm.refName,
            openDate: _vm.openDate,
            placeholder: _vm.placeholder,
            inputClass: _vm.inputClass,
            typeable: _vm.typeable,
            clearButton: _vm.clearButton,
            clearButtonIcon: _vm.clearButtonIcon,
            calendarButton: _vm.calendarButton,
            calendarButtonIcon: _vm.calendarButtonIcon,
            calendarButtonIconContent: _vm.calendarButtonIconContent,
            disabled: _vm.disabled,
            required: _vm.required,
            bootstrapStyling: _vm.bootstrapStyling,
            "use-utc": _vm.useUtc
          },
          on: {
            showCalendar: _vm.showCalendar,
            closeCalendar: _vm.close,
            typedDate: _vm.setTypedDate,
            clearDate: _vm.clearDate
          }
        },
        [_vm._t("afterDateInput", null, { slot: "afterDateInput" })],
        2
      ),
      _vm._v(" "),
      _vm.allowedToShowView("day")
        ? _c(
            "picker-day",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showDayView: _vm.showDayView,
                fullMonthName: _vm.fullMonthName,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                highlighted: _vm.highlighted,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                pageTimestamp: _vm.pageTimestamp,
                isRtl: _vm.isRtl,
                mondayFirst: _vm.mondayFirst,
                dayCellContent: _vm.dayCellContent,
                "use-utc": _vm.useUtc
              },
              on: {
                changedMonth: _vm.handleChangedMonthFromDayPicker,
                selectDate: _vm.selectDate,
                showMonthCalendar: _vm.showMonthCalendar,
                selectedDisabled: _vm.selectDisabledDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("month")
        ? _c(
            "picker-month",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showMonthView: _vm.showMonthView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: {
                selectMonth: _vm.selectMonth,
                showYearCalendar: _vm.showYearCalendar,
                changedYear: _vm.setPageDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("year")
        ? _c(
            "picker-year",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showYearView: _vm.showYearView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: { selectYear: _vm.selectYear, changedDecade: _vm.setPageDate }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-64ca2bb5_0", { source: ".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n", map: {"version":3,"sources":["Datepicker.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB","file":"Datepicker.vue","sourcesContent":[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  

  
  var Datepicker = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    browser,
    undefined
  );

/* harmony default export */ __webpack_exports__["default"] = (Datepicker);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFButton_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFButton_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFButton_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFButton_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348868dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFButton_vue__ = __webpack_require__(605);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFButton_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_348868dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "marker-icon.png?2273e3d8ad9264b7daa5bdbf8e6b47f8";

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14976853_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBoxWithLabel_vue__ = __webpack_require__(846);
function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14976853"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBoxWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14976853_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBoxWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea72e802_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePickerWithLabel_vue__ = __webpack_require__(851);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DatePickerWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea72e802_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DatePickerWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "45fc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $some = __webpack_require__("b727").some;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('some');
var USES_TO_LENGTH = arrayMethodUsesToLength('some');

// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isRegExp = __webpack_require__("44e7");
var getFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var setInternalState = __webpack_require__("69f3").set;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    if (document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aab0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fd6f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_vue_timepicker_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"08a1de70-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-timepicker.vue?vue&type=template&id=7502c349&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vue__time-picker time-picker",style:(_vm.inputWidthStyle)},[_c('input',{ref:"input",staticClass:"display-time",class:[_vm.inputClass, {'is-empty': _vm.inputIsEmpty, 'invalid': _vm.hasInvalidInput, 'all-selected': _vm.allValueSelected, 'disabled': _vm.disabled, 'has-custom-icon': _vm.$slots && _vm.$slots.icon }],style:(_vm.inputWidthStyle),attrs:{"type":"text","id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder ? _vm.placeholder : _vm.formatString,"tabindex":_vm.disabled ? -1 : _vm.tabindex,"disabled":_vm.disabled,"readonly":!_vm.manualInput,"autocomplete":_vm.autocomplete},domProps:{"value":_vm.inputIsEmpty ? null : _vm.customDisplayTime},on:{"focus":_vm.onFocus,"change":_vm.onChange,"blur":function($event){_vm.debounceBlur(); _vm.blurEvent()},"mousedown":_vm.onMouseDown,"keydown":[_vm.keyDownHandler,function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.escBlur($event)}],"compositionstart":_vm.onCompostionStart,"compositionend":_vm.onCompostionEnd,"paste":_vm.pasteHandler}}),(_vm.showClearBtn || _vm.showDropdownBtn)?_c('div',{staticClass:"controls",attrs:{"tabindex":"-1"}},[(!_vm.isActive && _vm.showClearBtn)?_c('span',{staticClass:"clear-btn",class:{'has-custom-btn': _vm.$slots && _vm.$slots.clearButton },attrs:{"tabindex":"-1"},on:{"click":_vm.clearTime}},[_vm._t("clearButton",[_c('span',{staticClass:"char"},[_vm._v("×")])])],2):_vm._e(),(_vm.showDropdownBtn)?_c('span',{staticClass:"dropdown-btn",class:{'has-custom-btn': _vm.$slots && _vm.$slots.dropdownButton },attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.setDropdownState(_vm.fixedDropdownButton ? !_vm.showDropdown : true, true)},"mousedown":_vm.keepFocusing}},[_vm._t("dropdownButton",[_c('span',{staticClass:"char"},[_vm._v("▾")])])],2):_vm._e()]):_vm._e(),(_vm.$slots && _vm.$slots.icon)?_c('div',{staticClass:"custom-icon"},[_vm._t("icon")],2):_vm._e(),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",attrs:{"tabindex":"-1"},on:{"click":_vm.toggleActive}}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],ref:"dropdown",staticClass:"dropdown",class:[_vm.dropdownDirClass],style:(_vm.inputWidthStyle),attrs:{"tabindex":"-1"},on:{"mouseup":_vm.keepFocusing,"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"select-list",style:(_vm.inputWidthStyle),attrs:{"tabindex":"-1"}},[(!_vm.advancedKeyboard)?[_vm._l((_vm.columnsSequence),function(column){return [(column === 'hour')?_c('ul',{key:column,staticClass:"hours",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourLabelText)}}),_vm._l((_vm.hours),function(hr,hIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('hour', hr)))?_c('li',{key:hIndex,class:{active: _vm.hour === hr},attrs:{"disabled":_vm.isDisabled('hour', hr),"data-key":hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){return _vm.select('hour', hr)}}}):_vm._e()]})],2):_vm._e(),(column === 'minute')?_c('ul',{key:column,staticClass:"minutes",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteLabelText)}}),_vm._l((_vm.minutes),function(m,mIndex){return [(!_vm.opts.hideDisabledMinutes || (_vm.opts.hideDisabledMinutes && !_vm.isDisabled('minute', m)))?_c('li',{key:mIndex,class:{active: _vm.minute === m},attrs:{"disabled":_vm.isDisabled('minute', m),"data-key":m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){return _vm.select('minute', m)}}}):_vm._e()]})],2):_vm._e(),(column === 'second')?_c('ul',{key:column,staticClass:"seconds",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondLabelText)}}),_vm._l((_vm.seconds),function(s,sIndex){return [(!_vm.opts.hideDisabledSeconds || (_vm.opts.hideDisabledSeconds && !_vm.isDisabled('second', s)))?_c('li',{key:sIndex,class:{active: _vm.second === s},attrs:{"disabled":_vm.isDisabled('second', s),"data-key":s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){return _vm.select('second', s)}}}):_vm._e()]})],2):_vm._e(),(column === 'apm')?_c('ul',{key:column,staticClass:"apms",on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmLabelText)}}),_vm._l((_vm.apms),function(a,aIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('apm', a)))?_c('li',{key:aIndex,class:{active: _vm.apm === a},attrs:{"disabled":_vm.isDisabled('apm', a),"data-key":a},domProps:{"textContent":_vm._s(_vm.apmDisplayText(a))},on:{"click":function($event){return _vm.select('apm', a)}}}):_vm._e()]})],2):_vm._e()]})]:_vm._e(),(_vm.advancedKeyboard)?[_vm._l((_vm.columnsSequence),function(column){return [(column === 'hour')?_c('ul',{key:column,staticClass:"hours",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.hourLabelText)}}),_vm._l((_vm.hours),function(hr,hIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('hour', hr)))?_c('li',{key:hIndex,class:{active: _vm.hour === hr},attrs:{"tabindex":_vm.isDisabled('hour', hr) ? -1 : _vm.tabindex,"data-key":hr,"disabled":_vm.isDisabled('hour', hr)},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){return _vm.select('hour', hr)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab('hour', hr, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('hour', hr)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('hour')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('hour')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e(),(column === 'minute')?_c('ul',{key:column,staticClass:"minutes",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.minuteLabelText)}}),_vm._l((_vm.minutes),function(m,mIndex){return [(!_vm.opts.hideDisabledMinutes || (_vm.opts.hideDisabledMinutes && !_vm.isDisabled('minute', m)))?_c('li',{key:mIndex,class:{active: _vm.minute === m},attrs:{"tabindex":_vm.isDisabled('minute', m) ? -1 : _vm.tabindex,"data-key":m,"disabled":_vm.isDisabled('minute', m)},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){return _vm.select('minute', m)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab('minute', m, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('minute', m)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('minute')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('minute')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e(),(column === 'second')?_c('ul',{key:column,staticClass:"seconds",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.secondLabelText)}}),_vm._l((_vm.seconds),function(s,sIndex){return [(!_vm.opts.hideDisabledSeconds || (_vm.opts.hideDisabledSeconds && !_vm.isDisabled('second', s)))?_c('li',{key:sIndex,class:{active: _vm.second === s},attrs:{"tabindex":_vm.isDisabled('second', s) ? -1 : _vm.tabindex,"data-key":s,"disabled":_vm.isDisabled('second', s)},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){return _vm.select('second', s)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab('second', s, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('second', s)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('second')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('second')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e(),(column === 'apm')?_c('ul',{key:column,staticClass:"apms",attrs:{"tabindex":"-1"},on:{"scroll":_vm.keepFocusing}},[_c('li',{staticClass:"hint",attrs:{"tabindex":"-1"},domProps:{"textContent":_vm._s(_vm.apmLabelText)}}),_vm._l((_vm.apms),function(a,aIndex){return [(!_vm.opts.hideDisabledHours || (_vm.opts.hideDisabledHours && !_vm.isDisabled('apm', a)))?_c('li',{key:aIndex,class:{active: _vm.apm === a},attrs:{"tabindex":_vm.isDisabled('apm', a) ? -1 : _vm.tabindex,"data-key":a,"disabled":_vm.isDisabled('apm', a)},domProps:{"textContent":_vm._s(_vm.apmDisplayText(a))},on:{"click":function($event){return _vm.select('apm', a)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.onTab('apm', a, $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.select('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.select('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.prevItem('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.nextItem('apm', a)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }$event.preventDefault();return _vm.toLeftColumn('apm')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }$event.preventDefault();return _vm.toRightColumn('apm')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.debounceBlur($event)}],"blur":_vm.debounceBlur,"focus":_vm.keepFocusing}}):_vm._e()]})],2):_vm._e()]})]:_vm._e()],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/vue-timepicker.vue?vue&type=template&id=7502c349&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("45fc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js








function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/vue-timepicker.vue?vue&type=script&lang=js&


























var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a'],
  BASIC_TYPES: ['hour', 'minute', 'second', 'apm']
};
var DEFAULT_OPTIONS = {
  format: 'HH:mm',
  minuteInterval: 1,
  secondInterval: 1,
  hourRange: null,
  minuteRange: null,
  secondRange: null,
  hideDisabledHours: false,
  hideDisabledMinutes: false,
  hideDisabledSeconds: false,
  hideDisabledItems: false,
  hideDropdown: false,
  blurDelay: 300,
  manualInputTimeout: 1000,
  dropOffsetHeight: 160
};
/* harmony default export */ var vue_timepickervue_type_script_lang_js_ = ({
  name: 'VueTimepicker',
  props: {
    value: {
      type: [Object, String]
    },
    format: {
      type: String
    },
    minuteInterval: {
      type: [Number, String]
    },
    secondInterval: {
      type: [Number, String]
    },
    hourRange: {
      type: Array
    },
    minuteRange: {
      type: Array
    },
    secondRange: {
      type: Array
    },
    hideDisabledHours: {
      type: Boolean,
      default: false
    },
    hideDisabledMinutes: {
      type: Boolean,
      default: false
    },
    hideDisabledSeconds: {
      type: Boolean,
      default: false
    },
    hideDisabledItems: {
      type: Boolean,
      default: false
    },
    hideClearButton: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeOnComplete: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    inputClass: {
      type: [String, Object, Array]
    },
    placeholder: {
      type: String
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    inputWidth: {
      type: String
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    hourLabel: {
      type: String
    },
    minuteLabel: {
      type: String
    },
    secondLabel: {
      type: String
    },
    apmLabel: {
      type: String
    },
    amText: {
      type: String
    },
    pmText: {
      type: String
    },
    blurDelay: {
      type: [Number, String]
    },
    advancedKeyboard: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    autoScroll: {
      type: Boolean,
      default: false
    },
    dropDirection: {
      type: String,
      default: 'down'
    },
    dropOffsetHeight: {
      type: [Number, String]
    },
    containerId: {
      type: String
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    manualInput: {
      type: Boolean,
      default: false
    },
    manualInputTimeout: {
      type: [Number, String]
    },
    hideDropdown: {
      type: Boolean,
      default: false
    },
    fixedDropdownButton: {
      type: Boolean,
      default: false
    },
    debugMode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      timeValue: {},
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      isActive: false,
      showDropdown: false,
      isFocusing: false,
      debounceTimer: undefined,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined,
      bakDisplayTime: undefined,
      doClearApmChecking: false,
      selectionTimer: undefined,
      kbInputTimer: undefined,
      kbInputLog: '',
      bakCurrentPos: undefined,
      forceDropOnTop: false
    };
  },
  computed: {
    opts: function opts() {
      var options = Object.assign({}, DEFAULT_OPTIONS);

      if (this.format && this.format.length) {
        options.format = String(this.format);
      }

      if (this.isNumber(this.minuteInterval)) {
        options.minuteInterval = +this.minuteInterval;
      } // minuteInterval failsafe


      if (!options.minuteInterval || options.minuteInterval < 1 || options.minuteInterval > 60) {
        if (this.debugMode) {
          if (options.minuteInterval > 60) {
            this.debugLog("\"minute-interval\" should be less than 60. Current value is ".concat(this.minuteInterval));
          } else if (options.minuteInterval === 0 || options.minuteInterval < 1) {
            this.debugLog("\"minute-interval\" should be NO less than 1. Current value is ".concat(this.minuteInterval));
          }
        }

        if (options.minuteInterval === 0) {
          options.minuteInterval = 60;
        } else {
          options.minuteInterval = 1;
        }
      }

      if (this.isNumber(this.secondInterval)) {
        options.secondInterval = +this.secondInterval;
      } // secondInterval failsafe


      if (!options.secondInterval || options.secondInterval < 1 || options.secondInterval > 60) {
        if (this.debugMode) {
          if (options.secondInterval > 60) {
            this.debugLog("\"second-interval\" should be less than 60. Current value is ".concat(this.secondInterval));
          } else if (options.secondInterval === 0 || options.secondInterval < 1) {
            this.debugLog("\"second-interval\" should be NO less than 1. Current value is ".concat(this.secondInterval));
          }
        }

        if (options.secondInterval === 0) {
          options.secondInterval = 60;
        } else {
          options.secondInterval = 1;
        }
      }

      if (this.hourRange && Array.isArray(this.hourRange)) {
        options.hourRange = JSON.parse(JSON.stringify(this.hourRange));

        if (!this.hourRange.length && this.debugMode) {
          this.debugLog('The "hour-range" array is empty (length === 0)');
        }
      }

      if (this.minuteRange && Array.isArray(this.minuteRange)) {
        options.minuteRange = JSON.parse(JSON.stringify(this.minuteRange));

        if (!this.minuteRange.length && this.debugMode) {
          this.debugLog('The "minute-range" array is empty (length === 0)');
        }
      }

      if (this.secondRange && Array.isArray(this.secondRange)) {
        options.secondRange = JSON.parse(JSON.stringify(this.secondRange));

        if (!this.secondRange.length && this.debugMode) {
          this.debugLog('The "second-range" array is empty (length === 0)');
        }
      }

      if (this.hideDisabledItems) {
        options.hideDisabledItems = true;
      }

      if (this.hideDisabledHours || this.hideDisabledItems) {
        options.hideDisabledHours = true;
      }

      if (this.hideDisabledMinutes || this.hideDisabledItems) {
        options.hideDisabledMinutes = true;
      }

      if (this.hideDisabledSeconds || this.hideDisabledItems) {
        options.hideDisabledSeconds = true;
      }

      if (this.hideDropdown) {
        if (this.manualInput) {
          options.hideDropdown = true;
        } else if (this.debugMode) {
          this.debugLog('"hide-dropdown" only works with "manual-input" mode');
        }
      }

      if (this.blurDelay && +this.blurDelay > 0) {
        options.blurDelay = +this.blurDelay;
      }

      if (this.manualInputTimeout && +this.manualInputTimeout > 0) {
        options.manualInputTimeout = +this.manualInputTimeout;
      }

      if (this.dropOffsetHeight && +this.dropOffsetHeight > 0) {
        options.dropOffsetHeight = +this.dropOffsetHeight;
      }

      return options;
    },
    useStringValue: function useStringValue() {
      return typeof this.value === 'string';
    },
    formatString: function formatString() {
      return this.opts.format || DEFAULT_OPTIONS.format;
    },
    inUse: function inUse() {
      var _this = this;

      var typesInUse = CONFIG.BASIC_TYPES.filter(function (type) {
        return _this.getTokenByType(type);
      }); // Sort types and tokens by their sequence in the "format" string

      typesInUse.sort(function (l, r) {
        return _this.formatString.indexOf(_this.getTokenByType(l) || null) - _this.formatString.indexOf(_this.getTokenByType(r) || null);
      });
      var tokensInUse = typesInUse.map(function (type) {
        return _this.getTokenByType(type);
      });
      return {
        hour: !!this.hourType,
        minute: !!this.minuteType,
        second: !!this.secondType,
        apm: !!this.apmType,
        types: typesInUse || [],
        tokens: tokensInUse || []
      };
    },
    displayTime: function displayTime() {
      var formatString = String(this.formatString);

      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }

      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }

      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }

      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }

      return formatString;
    },
    customDisplayTime: function customDisplayTime() {
      if (!this.amText && !this.pmText) {
        return this.displayTime;
      }

      return this.displayTime.replace(new RegExp(this.apm, 'g'), this.apmDisplayText(this.apm));
    },
    inputIsEmpty: function inputIsEmpty() {
      return this.formatString === this.displayTime;
    },
    allValueSelected: function allValueSelected() {
      if (this.inUse.hour && !this.hour || this.inUse.minute && !this.minute || this.inUse.second && !this.second || this.inUse.apm && !this.apm) {
        return false;
      }

      return true;
    },
    columnsSequence: function columnsSequence() {
      return this.inUse.types.map(function (type) {
        return type;
      }) || [];
    },
    showClearBtn: function showClearBtn() {
      if (this.hideClearButton || this.disabled) {
        return false;
      }

      return !this.inputIsEmpty;
    },
    showDropdownBtn: function showDropdownBtn() {
      if (this.fixedDropdownButton) {
        return true;
      }

      if (this.opts.hideDropdown && this.isActive && !this.showDropdown) {
        return true;
      }

      return false;
    },
    baseOn12Hours: function baseOn12Hours() {
      return this.hourType === 'h' || this.hourType === 'hh';
    },
    hourRangeIn24HrFormat: function hourRangeIn24HrFormat() {
      var _this2 = this;

      if (!this.hourType || !this.opts.hourRange) {
        return false;
      }

      if (!this.opts.hourRange.length) {
        return [];
      }

      var range = [];
      this.opts.hourRange.forEach(function (value) {
        if (value instanceof Array) {
          if (value.length > 2 && _this2.debugMode) {
            _this2.debugLog("Nested array within \"hour-range\" must contain no more than two items. Only the first two items of ".concat(JSON.stringify(value), " will be taken into account."));
          }

          var start = value[0];
          var end = value[1] || value[0];

          if (_this2.is12hRange(start)) {
            start = _this2.translate12hRange(start);
          }

          if (_this2.is12hRange(end)) {
            end = _this2.translate12hRange(end);
          }

          for (var i = +start; i <= +end; i++) {
            if (i < 0 || i > 24) {
              continue;
            }

            if (!range.includes(i)) {
              range.push(i);
            }
          }
        } else {
          if (_this2.is12hRange(value)) {
            value = _this2.translate12hRange(value);
          } else {
            value = +value;
          }

          if (value < 0 || value > 24) {
            return;
          }

          if (!range.includes(value)) {
            range.push(value);
          }
        }
      });
      range.sort(function (l, r) {
        return l - r;
      });
      return range;
    },
    restrictedHourRange: function restrictedHourRange() {
      // No restriction
      if (!this.hourRangeIn24HrFormat) {
        return false;
      } // 12-Hour


      if (this.baseOn12Hours) {
        var range = this.hourRangeIn24HrFormat.map(function (value) {
          if (value === 12) {
            return '12p';
          } else if (value === 24 || value === 0) {
            return '12a';
          }

          return value > 12 ? "".concat(value % 12, "p") : "".concat(value, "a");
        });
        return range;
      } // 24-Hour


      return this.hourRangeIn24HrFormat;
    },
    validHoursList: function validHoursList() {
      var _this3 = this;

      if (!this.manualInput) {
        return false;
      }

      if (this.restrictedHourRange) {
        var list = [];

        if (this.baseOn12Hours) {
          list = this.restrictedHourRange.map(function (hr) {
            var l = hr.substr(0, hr.length - 1);
            var r = hr.substr(-1);
            return "".concat(_this3.formatValue(_this3.hourType, l)).concat(r);
          });
          var am12Index = list.indexOf('12a');

          if (am12Index > 0) {
            // Make '12a' the first item in h/hh
            list.unshift(list.splice(am12Index, 1)[0]);
          }

          return list;
        }

        list = this.restrictedHourRange.map(function (hr) {
          return _this3.formatValue(_this3.hourType, hr);
        });

        if (list.length > 1 && list[0] && list[0] === '24') {
          // Make '24' the last item in k/kk
          list.push(list.shift());
        }

        return list;
      }

      if (this.baseOn12Hours) {
        return [].concat([], this.hours.map(function (hr) {
          return "".concat(hr, "a");
        }), this.hours.map(function (hr) {
          return "".concat(hr, "p");
        }));
      }

      return this.hours;
    },
    has: function has() {
      var result = {
        customApmText: false
      };
      var apmEnabled = !!this.apmType;

      if (apmEnabled && this.hourRangeIn24HrFormat && this.hourRangeIn24HrFormat.length) {
        var range = [].concat([], this.hourRangeIn24HrFormat);
        result.am = range.some(function (value) {
          return value < 12 || value === 24;
        });
        result.pm = range.some(function (value) {
          return value >= 12 && value < 24;
        });
      } else {
        result.am = apmEnabled;
        result.pm = apmEnabled;
      }

      if (this.amText && this.amText.length || this.pmText && this.pmText.length) {
        result.customApmText = true;
      }

      return result;
    },
    minuteRangeList: function minuteRangeList() {
      if (!this.minuteType || !this.opts.minuteRange) {
        return false;
      }

      if (!this.opts.minuteRange.length) {
        return [];
      }

      return this.renderRangeList(this.opts.minuteRange, 'minute');
    },
    secondRangeList: function secondRangeList() {
      if (!this.secondType || !this.opts.secondRange) {
        return false;
      }

      if (!this.opts.secondRange.length) {
        return [];
      }

      return this.renderRangeList(this.opts.secondRange, 'second');
    },
    hourLabelText: function hourLabelText() {
      return this.hourLabel || this.hourType;
    },
    minuteLabelText: function minuteLabelText() {
      return this.minuteLabel || this.minuteType;
    },
    secondLabelText: function secondLabelText() {
      return this.secondLabel || this.secondType;
    },
    apmLabelText: function apmLabelText() {
      return this.apmLabel || this.apmType;
    },
    inputWidthStyle: function inputWidthStyle() {
      if (!this.inputWidth || !this.inputWidth.length) {
        return;
      }

      return {
        width: this.inputWidth
      };
    },
    tokenRegexBase: function tokenRegexBase() {
      return this.inUse.tokens.join('|');
    },
    tokenChunks: function tokenChunks() {
      if (!this.manualInput && !this.useStringValue) {
        return false;
      }

      var formatString = String(this.formatString);
      var tokensRegxStr = "(".concat(this.tokenRegexBase, ")+?");
      var tokensMatchAll = this.getMatchAllByRegex(formatString, tokensRegxStr);
      var tokenChunks = [];

      var _iterator = _createForOfIteratorHelper(tokensMatchAll),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tkMatch = _step.value;
          var rawToken = tkMatch[0];
          var tokenMatchItem = {
            index: tkMatch.index,
            token: rawToken,
            type: this.getTokenType(rawToken),
            needsCalibrate: rawToken.length < 2,
            len: (rawToken || '').length
          };
          tokenChunks.push(tokenMatchItem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return tokenChunks;
    },
    needsPosCalibrate: function needsPosCalibrate() {
      if (!this.manualInput) {
        return false;
      }

      return this.tokenChunks.some(function (chk) {
        return chk.needsCalibrate;
      });
    },
    tokenChunksPos: function tokenChunksPos() {
      var _this4 = this;

      if (!this.manualInput) {
        return false;
      }

      if (!this.needsPosCalibrate) {
        return this.tokenChunks.map(function (chk) {
          return {
            token: chk.token,
            type: chk.type,
            start: chk.index,
            end: chk.index + chk.len
          };
        });
      }

      var list = [];
      var calibrateLen = 0;
      this.tokenChunks.forEach(function (chk) {
        var chunkCurrentLen; // Adjust for customized AM/PM text

        if (chk.type === 'apm' && _this4.has.customApmText) {
          if (_this4.apm && _this4.apm.length) {
            var customApmText = _this4.apm.toLowerCase() === 'am' ? _this4.amText : _this4.pmText;
            chunkCurrentLen = customApmText && customApmText.length ? customApmText.length : chk.len;
          } else {
            chunkCurrentLen = chk.len;
          } // Others

        } else {
          chunkCurrentLen = _this4[chk.type] && _this4[chk.type].length ? _this4[chk.type].length : chk.len;
        }

        list.push({
          token: chk.token,
          type: chk.type,
          start: chk.index + calibrateLen,
          end: chk.index + calibrateLen + chunkCurrentLen
        });

        if (chk.needsCalibrate && chunkCurrentLen > chk.len) {
          calibrateLen += chunkCurrentLen - chk.len;
        }
      });
      return list;
    },
    invalidValues: function invalidValues() {
      if (this.inputIsEmpty) {
        return [];
      }

      if (!this.restrictedHourRange && !this.minuteRangeList && !this.secondRangeList && this.opts.minuteInterval === 1 && this.opts.secondInterval === 1) {
        return [];
      }

      var result = [];

      if (this.inUse.hour && !this.isEmptyValue(this.hourType, this.hour) && (!this.isValidValue(this.hourType, this.hour) || this.isDisabled('hour', this.hour))) {
        result.push('hour');
      }

      if (this.inUse.minute && !this.isEmptyValue(this.minuteType, this.minute) && (!this.isValidValue(this.minuteType, this.minute) || this.isDisabled('minute', this.minute) || this.notInInterval('minute', this.minute))) {
        result.push('minute');
      }

      if (this.inUse.second && !this.isEmptyValue(this.secondType, this.second) && (!this.isValidValue(this.secondType, this.second) || this.isDisabled('second', this.second) || this.notInInterval('second', this.second))) {
        result.push('second');
      }

      if (this.inUse.apm && !this.isEmptyValue(this.apmType, this.apm) && (!this.isValidValue(this.apmType, this.apm) || this.isDisabled('apm', this.apm))) {
        result.push('apm');
      }

      if (result.length) {
        return result;
      }

      return [];
    },
    hasInvalidInput: function hasInvalidInput() {
      return Boolean(this.invalidValues && this.invalidValues.length);
    },
    autoDirectionEnabled: function autoDirectionEnabled() {
      return this.dropDirection === 'auto';
    },
    dropdownDirClass: function dropdownDirClass() {
      if (this.autoDirectionEnabled) {
        return this.forceDropOnTop ? 'drop-up' : 'drop-down';
      }

      return this.dropDirection === 'up' ? 'drop-up' : 'drop-down';
    }
  },
  watch: {
    'opts.format': function optsFormat(newValue) {
      this.renderFormat(newValue);
    },
    'opts.minuteInterval': function optsMinuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    'opts.secondInterval': function optsSecondInterval(newInteval) {
      this.renderList('second', newInteval);
    },
    value: {
      deep: true,
      handler: function handler() {
        this.readValues();
      }
    },
    displayTime: function displayTime() {
      this.fillValues();
    },
    disabled: function disabled(toDisabled) {
      if (toDisabled) {
        // Force close dropdown and reset status when disabled
        if (this.isActive) {
          this.isActive = false;
        }

        if (this.showDropdown) {
          this.showDropdown = false;
        }
      }
    },
    'invalidValues.length': function invalidValuesLength(newLength, oldLength) {
      if (newLength && newLength >= 1) {
        this.$emit('error', this.invalidValues);
      } else if (oldLength && oldLength >= 1) {
        this.$emit('error', []);
      }
    }
  },
  methods: {
    formatValue: function formatValue(token, i) {
      if (!this.isNumber(i)) {
        return '';
      }

      i = +i;

      switch (token) {
        case 'H':
        case 'h':
        case 'k':
        case 'm':
        case 's':
          if (['h', 'k'].includes(token) && i === 0) {
            return token === 'k' ? '24' : '12';
          }

          return String(i);

        case 'HH':
        case 'mm':
        case 'ss':
        case 'hh':
        case 'kk':
          if (['hh', 'kk'].includes(token) && i === 0) {
            return token === 'kk' ? '24' : '12';
          }

          return i < 10 ? "0".concat(i) : String(i);

        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }

      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }

      return '';
    },
    renderFormat: function renderFormat(newFormat) {
      var _this5 = this;

      newFormat = newFormat || this.opts.format || DEFAULT_OPTIONS.format;
      var hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat);
      var minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat);
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat); // Failsafe checking

      if (!hourType && !minuteType && !this.secondType && !this.apmType) {
        if (this.debugMode && this.format) {
          this.debugLog("No valid tokens found in your defined \"format\" string \"".concat(this.format, "\". Fallback to the default \"HH:mm\" format."));
        }

        hourType = 'HH';
        minuteType = 'mm';
      }

      this.hourType = hourType;
      this.minuteType = minuteType;
      this.hourType ? this.renderHoursList() : this.hours = [];
      this.minuteType ? this.renderList('minute') : this.minutes = [];
      this.secondType ? this.renderList('second') : this.seconds = [];
      this.apmType ? this.renderApmList() : this.apms = [];
      this.$nextTick(function () {
        _this5.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.baseOn12Hours ? 12 : 24;
      var hours = [];

      for (var i = 0; i < hoursCount; i++) {
        if (this.hourType === 'k' || this.hourType === 'kk') {
          hours.push(this.formatValue(this.hourType, i + 1));
        } else {
          hours.push(this.formatValue(this.hourType, i));
        }
      }

      this.hours = hours;
    },
    renderList: function renderList(listType, interval) {
      if (!this.isMinuteOrSecond(listType)) {
        return;
      }

      var isMinute = listType === 'minute';
      interval = interval || (isMinute ? this.opts.minuteInterval || DEFAULT_OPTIONS.minuteInterval : this.opts.secondInterval || DEFAULT_OPTIONS.secondInterval);
      var result = [];

      for (var i = 0; i < 60; i += interval) {
        result.push(this.formatValue(isMinute ? this.minuteType : this.secondType, i));
      }

      isMinute ? this.minutes = result : this.seconds = result;
    },
    renderApmList: function renderApmList() {
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (this.useStringValue) {
        if (this.debugMode) {
          this.debugLog("Received a string value: \"".concat(this.value, "\""));
        }

        this.readStringValues(this.value);
      } else {
        if (this.debugMode) {
          this.debugLog("Received an object value: \"".concat(JSON.stringify(this.value || {}), "\""));
        }

        this.readObjectValues(this.value);
      }
    },
    readObjectValues: function readObjectValues(objValue) {
      var _this6 = this;

      var timeValue = JSON.parse(JSON.stringify(objValue || {}));
      var values = Object.keys(timeValue); // Failsafe for empty `v-model` object

      if (values.length === 0) {
        this.addFallbackValues();
        return;
      }

      CONFIG.BASIC_TYPES.forEach(function (type) {
        var token = _this6.getTokenByType(type);

        if (values.indexOf(token) > -1) {
          var sanitizedValue = _this6.sanitizedValue(token, timeValue[token]);

          _this6[type] = sanitizedValue;
          timeValue[token] = sanitizedValue;
        } else {
          _this6[type] = '';
        }
      });
      this.timeValue = timeValue;
    },
    getMatchAllByRegex: function getMatchAllByRegex(testString, regexString) {
      var str = 'polyfillTest';
      var needsPolyfill = Boolean(!str.matchAll || typeof str.matchAll !== 'function');
      return needsPolyfill ? this.polyfillMatchAll(testString, regexString) : testString.matchAll(new RegExp(regexString, 'g'));
    },
    readStringValues: function readStringValues(stringValue) {
      var _this7 = this;

      // Failsafe for empty `v-model` string
      if (!stringValue || !stringValue.length) {
        this.addFallbackValues();
        return;
      }

      var formatString = String(this.formatString);
      var tokensRegxStr = "(".concat(this.tokenRegexBase, ")+?");
      var othersRegxStr = "[^(".concat(this.tokenRegexBase, ")]+");
      var tokensMatchAll = this.getMatchAllByRegex(formatString, tokensRegxStr);
      var othersMatchAll = this.getMatchAllByRegex(formatString, othersRegxStr);
      var chunks = [];
      var tokenChunks = [];

      var _iterator2 = _createForOfIteratorHelper(tokensMatchAll),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tkMatch = _step2.value;
          var tokenMatchItem = {
            index: tkMatch.index,
            token: tkMatch[0],
            isValueToken: true
          };
          chunks.push(tokenMatchItem);
          tokenChunks.push(tokenMatchItem);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(othersMatchAll),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var otMatch = _step3.value;
          chunks.push({
            index: otMatch.index,
            token: otMatch[0]
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      chunks.sort(function (l, r) {
        return l.index < r.index ? -1 : 1;
      });
      var regexCombo = '';
      chunks.forEach(function (chunk) {
        if (chunk.isValueToken) {
          var tokenRegex = _this7.getTokenRegex(chunk.token) || '';
          regexCombo += tokenRegex;
        } else {
          var safeChars = chunk.token.replace(/\\{0}(\*|\?|\.|\+)/g, '\\$1');
          regexCombo += "(?:".concat(safeChars, ")");
        }
      });
      var comboReg = new RegExp(regexCombo); // Do test before match

      if (comboReg.test(stringValue)) {
        var matchResults = stringValue.match(new RegExp(regexCombo));
        var valueResults = matchResults.slice(1, tokenChunks.length + 1);
        var timeValue = {};
        valueResults.forEach(function (value, vrIndex) {
          if (tokenChunks[vrIndex]) {
            var targetToken = tokenChunks[vrIndex].token;
            timeValue[targetToken] = _this7.setValueFromString(value, targetToken);
          }
        });
        this.timeValue = timeValue;

        if (this.debugMode) {
          var tokenChunksForLog = tokenChunks.map(function (tChunk) {
            return tChunk && tChunk.token;
          });
          this.debugLog("Successfully parsed values ".concat(JSON.stringify(valueResults), "\nfor ").concat(JSON.stringify(tokenChunksForLog), "\nin format pattern '").concat(this.formatString, "'"));
        }
      } else {
        if (this.debugMode) {
          this.debugLog("The input string in \"v-model\" does NOT match the \"format\" pattern\nformat: ".concat(this.formatString, "\nv-model: ").concat(stringValue));
        }
      }
    },
    polyfillMatchAll: function polyfillMatchAll(targetString, regxStr) {
      var matchesList = targetString.match(new RegExp(regxStr, 'g'));
      var result = [];
      var indicesReg = [];

      if (matchesList && matchesList.length) {
        matchesList.forEach(function (matchedItem) {
          var existIndex = indicesReg.findIndex(function (idxItem) {
            return idxItem.str === matchedItem;
          });
          var index;

          if (existIndex >= 0) {
            if (indicesReg[existIndex] && indicesReg[existIndex].regex) {
              index = indicesReg[existIndex].regex.exec(targetString).index;
            }
          } else {
            var itemIndicesRegex = new RegExp(matchedItem, 'g');
            index = itemIndicesRegex.exec(targetString).index;
            indicesReg.push({
              str: String(matchedItem),
              regex: itemIndicesRegex
            });
          }

          result.push({
            0: String(matchedItem),
            index: index
          });
        });
      }

      return result;
    },
    addFallbackValues: function addFallbackValues() {
      var _this8 = this;

      var timeValue = {};
      this.inUse.types.forEach(function (type) {
        timeValue[_this8.getTokenByType(type)] = '';
      });
      this.timeValue = timeValue;
    },
    setValueFromString: function setValueFromString(parsedValue, token) {
      if (!token || !parsedValue) {
        return '';
      }

      var tokenType = this.getTokenType(token);

      if (!tokenType || !tokenType.length) {
        return '';
      }

      var stdValue = parsedValue !== this.getTokenByType(tokenType) ? parsedValue : '';
      this[tokenType] = stdValue;
      return stdValue;
    },
    fillValues: function fillValues(forceEmit) {
      var _this9 = this;

      var fullValues = {};
      var baseHour = this.hour;
      var baseHourType = this.hourType;
      var apmValue; // Hour type or hour value is NOT set in the "format" string

      if (!baseHourType || !this.isNumber(baseHour)) {
        CONFIG.HOUR_TOKENS.forEach(function (token) {
          return fullValues[token] = '';
        });
        apmValue = this.lowerCasedApm(this.apm || '');
        fullValues.a = apmValue;
        fullValues.A = apmValue.toUpperCase(); // Both Hour type and value are set
      } else {
        var hourValue = +baseHour;

        var _apmValue = this.baseOn12Hours && this.apm ? this.lowerCasedApm(this.apm) : false;

        CONFIG.HOUR_TOKENS.forEach(function (token) {
          if (token === baseHourType) {
            fullValues[token] = baseHour;
            return;
          }

          var value;
          var apm;

          switch (token) {
            case 'H':
            case 'HH':
            case 'k':
            case 'kk':
              if (_this9.baseOn12Hours) {
                if (_apmValue === 'pm') {
                  value = hourValue < 12 ? hourValue + 12 : hourValue;
                } else if (['k', 'kk'].includes(token)) {
                  value = hourValue === 12 ? 24 : hourValue;
                } else {
                  value = hourValue % 12;
                }
              } else {
                if (['k', 'kk'].includes(token)) {
                  value = hourValue === 0 ? 24 : hourValue;
                } else {
                  value = hourValue % 24;
                }
              }

              fullValues[token] = _this9.formatValue(token, value);
              break;

            case 'h':
            case 'hh':
              // h <-> hh
              if (_this9.baseOn12Hours) {
                value = hourValue;
                apm = _apmValue || ''; // Read from other hour formats
              } else {
                if (hourValue > 11 && hourValue < 24) {
                  apm = 'pm';
                  value = hourValue === 12 ? 12 : hourValue % 12;
                } else {
                  apm = 'am';
                  value = hourValue % 12 === 0 ? 12 : hourValue;
                }
              }

              fullValues[token] = _this9.formatValue(token, value);
              fullValues.a = apm;
              fullValues.A = apm.toUpperCase();
              break;
          }
        });
      }

      fullValues.m = this.formatValue('m', this.minute);
      fullValues.mm = this.formatValue('mm', this.minute);
      fullValues.s = this.formatValue('s', this.second);
      fullValues.ss = this.formatValue('ss', this.second);
      this.fullValues = fullValues; // On lazy mode, emit `input` and `change` events only when:
      // - The user pick a new value and then close the dropdown
      // - The user click the ("x") clear button

      if (!this.lazy || forceEmit) {
        this.emitTimeValue();
      }

      if (this.closeOnComplete && this.allValueSelected && this.showDropdown) {
        this.toggleActive();
      }
    },
    getFullData: function getFullData() {
      if (!this.fullValues) {
        this.fillValues();
      }

      return {
        data: JSON.parse(JSON.stringify(this.fullValues)),
        displayTime: this.inputIsEmpty ? '' : String(this.displayTime)
      };
    },
    emitTimeValue: function emitTimeValue() {
      if (this.lazy && this.bakDisplayTime === this.displayTime) {
        if (this.debugMode) {
          this.debugLog('The value does not change on `lazy` mode. Skip the emitting `input` and `change` event.');
        }

        return;
      }

      var fullData = this.getFullData();

      if (this.useStringValue) {
        this.$emit('input', fullData.displayTime);
      } else {
        var fullValues = fullData.data;
        var tokensInUse = this.inUse.tokens || [];
        var timeValue = {};
        tokensInUse.forEach(function (token) {
          timeValue[token] = fullValues[token] || '';
        });
        this.$emit('input', JSON.parse(JSON.stringify(timeValue)));
      }

      this.$emit('change', fullData);
    },
    translate12hRange: function translate12hRange(value) {
      var valueT = this.match12hRange(value);

      if (+valueT[1] === 12) {
        return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 0 : 12);
      }

      return +valueT[1] + (valueT[2].toLowerCase() === 'p' ? 12 : 0);
    },
    isDisabled: function isDisabled(type, value) {
      if (!this.isBasicType(type) || !this.inUse[type]) {
        return true;
      }

      switch (type) {
        case 'hour':
          return this.isDisabledHour(value);

        case 'minute':
        case 'second':
          if (!this["".concat(type, "RangeList")]) {
            return false;
          }

          return !this["".concat(type, "RangeList")].includes(value);

        case 'apm':
          if (!this.restrictedHourRange) {
            return false;
          }

          return !this.has[this.lowerCasedApm(value)];

        default:
          return true;
      }
    },
    isDisabledHour: function isDisabledHour(value) {
      if (!this.restrictedHourRange) {
        return false;
      }

      if (this.baseOn12Hours) {
        if (!this.apm || !this.apm.length) {
          return false;
        } else {
          var token = this.apm.toLowerCase() === 'am' ? 'a' : 'p';
          return !this.restrictedHourRange.includes("".concat(+value).concat(token));
        }
      } // Fallback for 'HH' and 'H hour format with a `hour-range` in a 12-hour form


      if ((this.hourType === 'HH' || this.hourType === 'H') && +value === 0 && this.restrictedHourRange.includes(24)) {
        return false;
      }

      return !this.restrictedHourRange.includes(+value);
    },
    notInInterval: function notInInterval(section, value) {
      if (!section || !this.isMinuteOrSecond(section)) {
        return;
      }

      if (this.opts["".concat(section, "Interval")] === 1) {
        return false;
      }

      return +value % this.opts["".concat(section, "Interval")] !== 0;
    },
    renderRangeList: function renderRangeList(rawRange, section) {
      var _this10 = this;

      if (!rawRange || !section || !this.isMinuteOrSecond(section)) {
        return [];
      }

      var range = [];
      var formatedValue;
      rawRange.forEach(function (value) {
        if (value instanceof Array) {
          if (value.length > 2 && _this10.debugMode) {
            _this10.debugLog("Nested array within \"".concat(section, "-range\" must contain no more than two items. Only the first two items of ").concat(JSON.stringify(value), " will be taken into account."));
          }

          var start = value[0];
          var end = value[1] || value[0];

          for (var i = +start; i <= +end; i++) {
            if (i < 0 || i > 59) {
              continue;
            }

            formatedValue = _this10.formatValue(_this10.getTokenByType(section), i);

            if (!range.includes(formatedValue)) {
              range.push(formatedValue);
            }
          }
        } else {
          if (+value < 0 || +value > 59) {
            return;
          }

          formatedValue = _this10.formatValue(_this10.getTokenByType(section), value);

          if (!range.includes(formatedValue)) {
            range.push(formatedValue);
          }
        }
      });
      range.sort(function (l, r) {
        return l - r;
      }); // Debug Mode

      if (this.debugMode) {
        var fullList = (section === 'minute' ? this.minutes : this.seconds) || [];
        var validItems = fullList.filter(function (item) {
          return range.includes(item);
        });

        if (!validItems || !validItems.length) {
          if (section === 'minute') {
            this.debugLog("The minute list is empty due to the \"minute-range\" config\nminute-range: ".concat(JSON.stringify(this.minuteRange), "\nminute-interval: ").concat(this.opts.minuteInterval));
          } else {
            this.debugLog("The second list is empty due to the \"second-range\" config\nsecond-range: ".concat(JSON.stringify(this.secondRange), "\nsecond-interval: ").concat(this.opts.secondInterval));
          }
        }
      }

      return range;
    },
    forceApmSelection: function forceApmSelection() {
      if (this.manualInput) {
        // Skip this to allow users to paste a string value from the clipboard in Manual Input mode
        return;
      }

      if (this.apmType && !this.apm) {
        if (this.has.am || this.has.pm) {
          this.doClearApmChecking = true;
          var apmValue = this.has.am ? 'am' : 'pm';
          this.apm = this.apmType === 'A' ? apmValue.toUpperCase() : apmValue;
        }
      }
    },
    emptyApmSelection: function emptyApmSelection() {
      if (this.doClearApmChecking && this.hour === '' && this.minute === '' && this.second === '') {
        this.apm = '';
      }

      this.doClearApmChecking = false;
    },
    apmDisplayText: function apmDisplayText(apmValue) {
      if (this.amText && this.lowerCasedApm(apmValue) === 'am') {
        return this.amText;
      }

      if (this.pmText && this.lowerCasedApm(apmValue) === 'pm') {
        return this.pmText;
      }

      return apmValue;
    },
    toggleActive: function toggleActive() {
      var _this11 = this;

      if (this.disabled) {
        return;
      }

      this.isActive = !this.isActive;

      if (this.isActive) {
        this.isFocusing = true;

        if (this.manualInput) {
          this.$emit('focus');
        }

        if (!this.opts.hideDropdown) {
          this.setDropdownState(true);
        } // Record to check if value did change in the later phase


        if (this.lazy) {
          this.bakDisplayTime = String(this.displayTime || '');
        }

        if (this.manualInput && !this.inputIsEmpty) {
          this.$nextTick(function () {
            if (_this11.$refs.input && _this11.$refs.input.selectionStart === 0 && _this11.$refs.input.selectionEnd === _this11.displayTime.length) {
              // Select the first slot instead of the whole value string when tabbed in
              _this11.selectFirstSlot();
            }
          });
        }
      } else {
        if (this.showDropdown) {
          this.setDropdownState(false);
        } else if (this.manualInput) {
          this.$emit('blur', this.getFullData());
        }

        this.isFocusing = false;

        if (this.lazy) {
          this.fillValues(true);
          this.bakDisplayTime = undefined;
        }
      }

      if (this.restrictedHourRange && this.baseOn12Hours) {
        this.showDropdown ? this.forceApmSelection() : this.emptyApmSelection();
      }

      if (this.showDropdown) {
        this.checkForAutoScroll();
      }
    },
    setDropdownState: function setDropdownState(toShow) {
      var fromUserClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (toShow) {
        if (this.appendToBody) {
          this.appendDropdownToBody();
        }

        this.keepFocusing();

        if (this.autoDirectionEnabled) {
          this.checkDropDirection();
        }

        this.showDropdown = true;
        this.$emit('open');

        if (fromUserClick) {
          if (this.fixedDropdownButton) {
            this.isActive = true;
          }

          this.$emit('blur', this.getFullData());
          this.checkForAutoScroll();
        }
      } else {
        this.showDropdown = false;
        this.$emit('close', this.getFullData());

        if (this.appendToBody) {
          this.removeDropdownFromBody();
        }
      }
    },
    appendDropdownToBody: function appendDropdownToBody() {
      var dropdown = this.$refs && this.$refs.dropdown;
      var body = document.getElementsByTagName('body')[0];

      if (body && dropdown) {
        window.addEventListener('scroll', this.updateDropdownPos);
        dropdown.classList.add('vue__time-picker-dropdown');
        this.updateDropdownPos();
        body.appendChild(dropdown);
      }
    },
    updateDropdownPos: function updateDropdownPos() {
      if (!this.appendToBody) {
        return;
      }

      var dropdown = this.$refs && this.$refs.dropdown;
      var body = document.getElementsByTagName('body')[0];

      if (body && dropdown) {
        var box = this.$el.getBoundingClientRect();

        if (this.dropdownDirClass === 'drop-up') {
          dropdown.style.bottom = "".concat(window.innerHeight - box.y, "px");
          dropdown.style.top = 'auto';
        } else {
          dropdown.style.top = "".concat(box.y + box.height, "px");
          dropdown.style.bottom = 'auto';
        }

        dropdown.style.left = "".concat(box.x, "px");
      }
    },
    removeDropdownFromBody: function removeDropdownFromBody() {
      var dropdown = this.$refs && this.$refs.dropdown;
      var body = document.getElementsByTagName('body')[0];

      if (body && dropdown && body.contains(dropdown)) {
        body.removeChild(dropdown);
      }

      if (dropdown) {
        dropdown.classList.remove('vue__time-picker-dropdown');
        dropdown.style.top = '';
        dropdown.style.bottom = '';
        dropdown.style.left = '';
        this.$el.appendChild(dropdown);
      }

      window.removeEventListener('scroll', this.updateDropdownPos);
    },
    blurEvent: function blurEvent() {
      if (this.manualInput && !this.opts.hideDropdown) {
        // hideDropdown's `blur` event is handled somewhere else
        this.$emit('blur', this.getFullData());
      }
    },
    select: function select(type, value) {
      if (this.isBasicType(type) && !this.isDisabled(type, value)) {
        this[type] = value;

        if (this.doClearApmChecking) {
          this.doClearApmChecking = false;
        }
      }
    },
    clearTime: function clearTime() {
      if (this.disabled) {
        return;
      }

      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';

      if (this.manualInput && this.$refs && this.$refs.input && this.$refs.input.value.length) {
        this.$refs.input.value = '';
      }

      if (this.lazy) {
        this.fillValues(true);
      }
    },
    //
    // Auto-Scroll
    //
    checkForAutoScroll: function checkForAutoScroll() {
      var _this12 = this;

      if (this.inputIsEmpty) {
        return;
      }

      if (this.autoScroll) {
        this.$nextTick(function () {
          _this12.scrollToSelectedValues();
        });
      } else if (this.advancedKeyboard) {
        // Auto-focus on selected value in the first column for advanced-keyboard
        this.$nextTick(function () {
          var firstColumn = _this12.inUse.types[0];

          _this12.scrollToSelected(firstColumn, true);
        });
      }
    },
    scrollToSelected: function scrollToSelected(column) {
      var allowFallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.timeValue || this.inputIsEmpty) {
        return;
      }

      var targetList;

      if (this.appendToBody && this.$refs && this.$refs.dropdown) {
        targetList = this.$refs.dropdown.querySelectorAll("ul.".concat(column, "s"))[0];
      } else {
        targetList = this.$el.querySelectorAll("ul.".concat(column, "s"))[0];
      }

      var targetValue = this.activeItemInCol(column)[0];

      if (!targetValue && allowFallback) {
        // No value selected in the target column, fallback to the first found valid item
        targetValue = this.validItemsInCol(column)[0];
      }

      if (targetList && targetValue) {
        targetList.scrollTop = targetValue.offsetTop || 0;

        if (this.advancedKeyboard) {
          targetValue.focus();
        }
      }
    },
    scrollToSelectedValues: function scrollToSelectedValues() {
      var _this13 = this;

      if (!this.timeValue || this.inputIsEmpty) {
        return;
      }

      this.inUse.types.forEach(function (section) {
        _this13.scrollToSelected(section);
      });
    },
    //
    // Additional Keyboard Navigation
    //
    onFocus: function onFocus() {
      if (this.disabled) {
        return;
      }

      if (!this.isFocusing) {
        this.isFocusing = true;
      }

      if (!this.isActive) {
        this.toggleActive();
      }
    },
    escBlur: function escBlur() {
      if (this.disabled) {
        return;
      }

      window.clearTimeout(this.debounceTimer);
      this.isFocusing = false;
      var inputBox = this.$el.querySelectorAll('input.display-time')[0];

      if (inputBox) {
        inputBox.blur();
      }
    },
    debounceBlur: function debounceBlur() {
      var _this14 = this;

      if (this.disabled) {
        return;
      }

      this.isFocusing = false;
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(function () {
        window.clearTimeout(_this14.debounceTimer);

        _this14.onBlur();
      }, this.opts.blurDelay);
    },
    onBlur: function onBlur() {
      if (!this.disabled && !this.isFocusing && this.isActive) {
        this.toggleActive();
      }
    },
    keepFocusing: function keepFocusing() {
      if (this.disabled) {
        return;
      }

      window.clearTimeout(this.debounceTimer);

      if (!this.isFocusing) {
        this.isFocusing = true;
      }
    },
    onTab: function onTab(column, value, evt) {
      if (this.appendToBody && evt.shiftKey) {
        var firstColumn = this.inUse.types[0];

        if (column !== firstColumn) {
          return;
        }

        var firstValidValue = this.validItemsInCol(firstColumn)[0]; // Is the first valid item in the first column

        if (firstValidValue && firstValidValue.getAttribute('data-key') === String(value)) {
          evt.preventDefault(); // Focus back on <input>

          if (this.$refs && this.$refs.input) {
            this.$refs.input.focus();
          }
        }
      }
    },
    validItemsInCol: function validItemsInCol(column) {
      var columnClass = "".concat(column, "s");

      if (this.appendToBody && this.$refs && this.$refs.dropdown) {
        return this.$refs.dropdown.querySelectorAll("ul.".concat(columnClass, " > li:not(.hint):not([disabled])"));
      }

      return this.$el.querySelectorAll("ul.".concat(columnClass, " > li:not(.hint):not([disabled])"));
    },
    activeItemInCol: function activeItemInCol(column) {
      var columnClass = "".concat(column, "s");

      if (this.appendToBody && this.$refs && this.$refs.dropdown) {
        return this.$refs.dropdown.querySelectorAll("ul.".concat(columnClass, " > li.active:not(.hint)"));
      }

      return this.$el.querySelectorAll("ul.".concat(columnClass, " > li.active:not(.hint)"));
    },
    getClosestSibling: function getClosestSibling(column, dataKey) {
      var getPrevious = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var siblingsInCol = this.validItemsInCol(column);
      var selfIndex = Array.prototype.findIndex.call(siblingsInCol, function (sbl) {
        return sbl.getAttribute('data-key') === dataKey;
      }); // Already the first item

      if (getPrevious && selfIndex === 0) {
        return siblingsInCol[siblingsInCol.length - 1];
      } // Already the last item


      if (!getPrevious && selfIndex === siblingsInCol.length - 1) {
        return siblingsInCol[0];
      } // Selected value not in the valid values list


      if (selfIndex < 0) {
        return siblingsInCol[0];
      }

      if (getPrevious) {
        return siblingsInCol[selfIndex - 1];
      }

      return siblingsInCol[selfIndex + 1];
    },
    prevItem: function prevItem(column, dataKey) {
      var isManualInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var targetItem = this.getClosestSibling(column, dataKey, true);

      if (targetItem) {
        return isManualInput ? targetItem : targetItem.focus();
      }
    },
    nextItem: function nextItem(column, dataKey) {
      var isManualInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var targetItem = this.getClosestSibling(column, dataKey, false);

      if (targetItem) {
        return isManualInput ? targetItem : targetItem.focus();
      }
    },
    getSideColumnName: function getSideColumnName(currentColumn) {
      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var currentColumnIndex = this.inUse.types.indexOf(currentColumn);

      if (toLeft && currentColumnIndex <= 0) {
        if (this.debugMode) {
          this.debugLog('You\'re in the leftmost list already');
        }

        return;
      } else if (!toLeft && currentColumnIndex === this.inUse.types.length - 1) {
        if (this.debugMode) {
          this.debugLog('You\'re in the rightmost list already');
        }

        return;
      }

      return this.inUse.types[toLeft ? currentColumnIndex - 1 : currentColumnIndex + 1];
    },
    getFirstItemInSideColumn: function getFirstItemInSideColumn(currentColumn) {
      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var targetColumn = this.getSideColumnName(currentColumn, toLeft);

      if (!targetColumn) {
        return;
      }

      var listItems = this.validItemsInCol(targetColumn);

      if (listItems && listItems[0]) {
        return listItems[0];
      }
    },
    getActiveItemInSideColumn: function getActiveItemInSideColumn(currentColumn) {
      var toLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var targetColumn = this.getSideColumnName(currentColumn, toLeft);

      if (!targetColumn) {
        return;
      }

      var activeItems = this.activeItemInCol(targetColumn);

      if (activeItems && activeItems[0]) {
        return activeItems[0];
      }
    },
    toLeftColumn: function toLeftColumn(currentColumn) {
      var targetItem = this.getActiveItemInSideColumn(currentColumn, true) || this.getFirstItemInSideColumn(currentColumn, true);

      if (targetItem) {
        targetItem.focus();
      }
    },
    toRightColumn: function toRightColumn(currentColumn) {
      var targetItem = this.getActiveItemInSideColumn(currentColumn, false) || this.getFirstItemInSideColumn(currentColumn, false);

      if (targetItem) {
        targetItem.focus();
      }
    },
    //
    // Manual Input
    //
    onMouseDown: function onMouseDown() {
      var _this15 = this;

      if (!this.manualInput) {
        return;
      }

      window.clearTimeout(this.selectionTimer);
      this.selectionTimer = window.setTimeout(function () {
        window.clearTimeout(_this15.selectionTimer);

        if (_this15.$refs && _this15.$refs.input) {
          var nearestSlot = _this15.getNearestChunkByPos(_this15.$refs.input.selectionStart || 0);

          _this15.debounceSetInputSelection(nearestSlot);
        }
      }, 50);
    },
    keyDownHandler: function keyDownHandler(evt) {
      if (evt.isComposing || evt.keyCode === 229) {
        // Skip IME inputs
        evt.preventDefault();
        evt.stopPropagation();
        return false;
      } // Numbers


      if (evt.keyCode >= 48 && evt.keyCode <= 57 || evt.keyCode >= 96 && evt.keyCode <= 105) {
        evt.preventDefault();
        this.keyboardInput(evt.key); // A|P|M
      } else if ([65, 80, 77].includes(evt.keyCode)) {
        evt.preventDefault();
        this.keyboardInput(evt.key, true); // Arrow keys
      } else if (evt.keyCode >= 37 && evt.keyCode <= 40) {
        evt.preventDefault();
        this.clearKbInputLog();
        this.arrowHandler(evt); // Delete|Backspace
      } else if (evt.keyCode === 8 || evt.keyCode === 46) {
        evt.preventDefault();
        this.clearKbInputLog();
        this.clearTime(); // Tab
      } else if (evt.keyCode === 9) {
        this.clearKbInputLog();
        this.tabHandler(evt); // Colon|Space
      } else if (evt.keyCode === 186 || evt.keyCode === 32) {
        evt.preventDefault();
        this.clearKbInputLog();
        this.toNextSlot(); // Prevent any Non-ESC and non-pasting inputs
      } else if (evt.keyCode !== 27 && !(evt.metaKey || evt.ctrlKey)) {
        evt.preventDefault();
      }
    },
    onCompostionStart: function onCompostionStart(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.bakCurrentPos = this.getCurrentTokenChunk();
      return false;
    },
    onCompostionEnd: function onCompostionEnd(evt) {
      var _this16 = this;

      evt.preventDefault();
      evt.stopPropagation();
      var cpsData = evt.data;
      var inputIsCustomApmText = false;

      if (this.has.customApmText) {
        inputIsCustomApmText = this.isCustomApmText(cpsData);
      }

      if (inputIsCustomApmText) {
        this.setSanitizedValueToSection('apm', inputIsCustomApmText);
      }

      this.$refs.input.value = this.has.customApmText ? this.customDisplayTime : this.displayTime;
      this.$nextTick(function () {
        if (_this16.bakCurrentPos) {
          var bakPos = JSON.parse(JSON.stringify(_this16.bakCurrentPos));

          if (inputIsCustomApmText) {
            bakPos.end = bakPos.start + cpsData.length;
          }

          _this16.debounceSetInputSelection(bakPos);

          _this16.bakCurrentPos = null;
        }
      });
      return false;
    },
    pasteHandler: function pasteHandler(evt) {
      evt.preventDefault();
      var pastingText = (evt.clipboardData || window.clipboardData).getData('text');

      if (this.debugMode) {
        this.debugLog("Pasting value \"".concat(pastingText, "\" from clipboard"));
      }

      if (!pastingText || !pastingText.length) {
        return;
      } // Replace custom AM/PM text (if any)


      if (this.has.customApmText) {
        pastingText = this.replaceCustomApmText(pastingText);
      }

      if (this.inputIsEmpty) {
        this.readStringValues(pastingText);
      } else {
        this.kbInputLog = pastingText.substr(-2, 2);
        this.setKbInput();
        this.debounceClearKbLog();
      }
    },
    arrowHandler: function arrowHandler(evt) {
      var direction = {
        37: 'L',
        38: 'U',
        39: 'R',
        40: 'D'
      }[evt.keyCode];

      if (direction === 'U' || direction === 'D') {
        if (this.inputIsEmpty) {
          this.selectFirstValidValue();
        } else {
          var currentChunk = this.getCurrentTokenChunk();

          if (!currentChunk) {
            this.selectFirstValidValue();
            return;
          }

          var tokenType = currentChunk.type;
          this.getClosestValidItemInCol(tokenType, this[tokenType], direction);
          var newChunkPos = this.getCurrentTokenChunk();
          this.debounceSetInputSelection(newChunkPos);
        }
      } else if (direction === 'R') {
        this.toLateralToken(false);
      } else if (direction === 'L') {
        this.toLateralToken(true);
      }
    },
    tabHandler: function tabHandler(evt) {
      if (!this.inputIsEmpty && this.tokenChunksPos && this.tokenChunksPos.length) {
        var currentChunk = this.getCurrentTokenChunk();

        if (!currentChunk) {
          return;
        }

        var firstChunk = this.tokenChunksPos[0];
        var lastChunk = this.tokenChunksPos[this.tokenChunksPos.length - 1];

        if (evt.shiftKey && currentChunk.token !== firstChunk.token || !evt.shiftKey && currentChunk.token !== lastChunk.token) {
          evt.preventDefault();
          this.toLateralToken(evt.shiftKey);
        }
      } else if (this.appendToBody && this.advancedKeyboard) {
        if (evt.shiftKey) {
          return;
        }

        evt.preventDefault();

        if (this.inputIsEmpty) {
          var firstColumn = this.inUse.types[0];
          var targetValue = this.validItemsInCol(firstColumn)[0];

          if (targetValue) {
            targetValue.focus();
          }
        }
      }
    },
    keyboardInput: function keyboardInput(newChar) {
      var isApm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var currentChunk = this.getCurrentTokenChunk();

      if (!currentChunk || currentChunk.type !== 'apm' && isApm || currentChunk.type === 'apm' && !isApm) {
        return;
      }

      this.kbInputLog = "".concat(this.kbInputLog.substr(-1)).concat(newChar);
      this.setKbInput();
      this.debounceClearKbLog();
    },
    clearKbInputLog: function clearKbInputLog() {
      window.clearTimeout(this.kbInputTimer);
      this.kbInputLog = '';
    },
    debounceClearKbLog: function debounceClearKbLog() {
      var _this17 = this;

      window.clearTimeout(this.kbInputTimer);
      this.kbInputTimer = window.setTimeout(function () {
        _this17.clearKbInputLog();
      }, this.opts.manualInputTimeout);
    },
    setKbInput: function setKbInput(value) {
      value = value || this.kbInputLog;
      var currentChunk = this.getCurrentTokenChunk();

      if (!currentChunk || !value || !value.length) {
        return;
      }

      var chunkType = currentChunk.type;
      var chunkToken = currentChunk.token;
      var validValue;

      if (chunkType === 'apm') {
        if (this.lowerCasedApm(value).includes('a')) {
          validValue = 'am';
        } else if (this.lowerCasedApm(value).includes('p')) {
          validValue = 'pm';
        }

        if (validValue) {
          validValue = chunkToken === 'A' ? validValue.toUpperCase() : validValue;
        }
      } else {
        if (this.isValidValue(chunkToken, value)) {
          validValue = value;
        } else {
          var lastInputValue = this.formatValue(chunkToken, value.substr(-1));

          if (this.isValidValue(chunkToken, lastInputValue)) {
            validValue = lastInputValue;
          }
        }
      }

      if (validValue) {
        this.setSanitizedValueToSection(chunkType, validValue);
        var newChunkPos = this.getCurrentTokenChunk();
        this.debounceSetInputSelection(newChunkPos);
      }

      if (this.debugMode) {
        if (validValue) {
          this.debugLog("Successfully set value \"".concat(validValue, "\" from latest input \"").concat(value, "\" for the \"").concat(chunkType, "\" slot"));
        } else {
          this.debugLog("Value \"".concat(value, "\" is invalid in the \"").concat(chunkType, "\" slot"));
        }
      }
    },
    // Form Autofill
    onChange: function onChange() {
      if (!this.manualInput || !this.$refs || !this.$refs.input) {
        return;
      }

      var autoFillValue = this.$refs.input.value || '';

      if (autoFillValue && autoFillValue.length) {
        this.readStringValues(autoFillValue);
      }
    },
    getNearestChunkByPos: function getNearestChunkByPos(startPos) {
      if (!this.tokenChunksPos || !this.tokenChunksPos.length) {
        return;
      }

      var nearest;
      var nearestDelta = -1;

      for (var i = 0; i < this.tokenChunksPos.length; i++) {
        var chunk = JSON.parse(JSON.stringify(this.tokenChunksPos[i]));

        if (chunk.start === startPos) {
          return chunk;
        }

        var delta = Math.abs(chunk.start - startPos);

        if (nearestDelta < 0) {
          nearest = chunk;
          nearestDelta = delta;
        } else {
          if (nearestDelta <= delta) {
            return nearest;
          }

          nearestDelta = delta;
          nearest = chunk;
        }
      }

      return nearest;
    },
    selectFirstValidValue: function selectFirstValidValue() {
      if (!this.tokenChunksPos || !this.tokenChunksPos.length) {
        return;
      }

      var firstSlotType = this.tokenChunksPos[0].type;

      if (firstSlotType === 'hour') {
        this.getClosestHourItem();
      } else {
        this.getClosestValidItemInCol(firstSlotType, this[firstSlotType]);
      }

      this.selectFirstSlot();
    },
    getClosestHourItem: function getClosestHourItem(currentValue) {
      var _this18 = this;

      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'U';

      if (!this.validHoursList || !this.validHoursList.length) {
        if (this.debugMode) {
          this.debugLog("No valid hour values found, please check your \"hour-range\" config\nhour-range: ".concat(JSON.stringify(this.hourRange)));
        }

        return;
      }

      if (!currentValue) {
        this.setManualHour(this.validHoursList[0]);
        return;
      }

      var currentIndex = this.validHoursList.findIndex(function (item) {
        if (!_this18.baseOn12Hours) {
          return item === currentValue;
        } else {
          var valueKey = "".concat(currentValue).concat(_this18.lowerCasedApm(_this18.apm) === 'pm' ? 'p' : 'a');
          return item === valueKey;
        }
      });
      var nextIndex;

      if (currentIndex === -1) {
        nextIndex = 0;
      } else if (direction === 'D') {
        nextIndex = currentIndex === 0 ? this.validHoursList.length - 1 : currentIndex - 1;
      } else {
        nextIndex = (currentIndex + 1) % this.validHoursList.length;
      }

      var nextItem = this.validHoursList[nextIndex];
      this.setManualHour(nextItem);
    },
    getClosestValidItemInCol: function getClosestValidItemInCol(column, currentValue) {
      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'U';

      if (column === 'hour') {
        this.getClosestHourItem(currentValue, direction);
      } else {
        var nextItem = direction === 'D' ? this.prevItem(column, this[column], true) : this.nextItem(column, this[column], true);

        if (nextItem) {
          this.select(column, nextItem.getAttribute('data-key'));
        }
      }
    },
    setSanitizedValueToSection: function setSanitizedValueToSection(section, inputValue) {
      if (!section || !this.getTokenByType(section)) {
        return;
      } // NOTE: Disabled values are allowed here, followed by an 'error' event, though


      var sanitizedValue = this.sanitizedValue(this.getTokenByType(section), inputValue);
      this[section] = sanitizedValue;
    },
    setManualHour: function setManualHour(nextItem) {
      if (this.is12hRange(nextItem)) {
        var hourT = this.match12hRange(nextItem);
        var apmValue = hourT[2] === 'a' ? 'AM' : 'PM';
        this.setSanitizedValueToSection('apm', this.apmType === 'a' ? apmValue.toLowerCase() : apmValue);
        this.setSanitizedValueToSection('hour', hourT[1]);
      } else {
        this.setSanitizedValueToSection('hour', nextItem);
      }
    },
    debounceSetInputSelection: function debounceSetInputSelection(_ref) {
      var _this19 = this;

      var _ref$start = _ref.start,
          start = _ref$start === void 0 ? 0 : _ref$start,
          _ref$end = _ref.end,
          end = _ref$end === void 0 ? 0 : _ref$end;
      this.$nextTick(function () {
        _this19.setInputSelectionRange(start, end);
      });
      window.clearTimeout(this.selectionTimer);
      this.selectionTimer = window.setTimeout(function () {
        window.clearTimeout(_this19.selectionTimer); // Double-check selection for 12hr format

        if (_this19.$refs.input && (_this19.$refs.input.selectionStart !== start || _this19.$refs.input.selectionEnd !== end)) {
          _this19.setInputSelectionRange(start, end);
        }
      }, 30);
    },
    setInputSelectionRange: function setInputSelectionRange(start, end) {
      if (this.$refs && this.$refs.input) {
        this.$refs.input.setSelectionRange(start, end);
      }
    },
    getCurrentTokenChunk: function getCurrentTokenChunk() {
      return this.getNearestChunkByPos(this.$refs.input && this.$refs.input.selectionStart || 0);
    },
    selectFirstSlot: function selectFirstSlot() {
      var firstChunkPos = this.getNearestChunkByPos(0);
      this.debounceSetInputSelection(firstChunkPos);
    },
    toNextSlot: function toNextSlot() {
      if (!this.inputIsEmpty && this.tokenChunksPos && this.tokenChunksPos.length) {
        var currentChunk = this.getCurrentTokenChunk();

        if (!currentChunk) {
          return;
        }

        var lastChunk = this.tokenChunksPos[this.tokenChunksPos.length - 1];

        if (currentChunk.token !== lastChunk.token) {
          this.toLateralToken(false);
        }
      }
    },
    toLateralToken: function toLateralToken(toLeft) {
      var currentChunk = this.getCurrentTokenChunk();

      if (!currentChunk) {
        this.selectFirstValidValue();
        return;
      }

      var currentChunkIndex = this.tokenChunksPos.findIndex(function (chk) {
        return chk.token === currentChunk.token;
      });

      if (!toLeft && currentChunkIndex >= this.tokenChunksPos.length - 1 || toLeft && currentChunkIndex === 0) {
        if (this.debugMode) {
          if (toLeft) {
            this.debugLog('You\'re in the leftmost slot already');
          } else {
            this.debugLog('You\'re in the rightmost slot already');
          }
        }

        return;
      }

      var targetSlotPos = toLeft ? this.tokenChunksPos[currentChunkIndex - 1] : this.tokenChunksPos[currentChunkIndex + 1];
      this.debounceSetInputSelection(targetSlotPos);
    },
    isCustomApmText: function isCustomApmText(inputData) {
      if (!inputData || !inputData.length) {
        return false;
      }

      if (this.amText && this.amText === inputData) {
        return this.apmType === 'A' ? 'AM' : 'am';
      }

      if (this.pmText && this.pmText === inputData) {
        return this.apmType === 'A' ? 'PM' : 'pm';
      }

      return false;
    },
    replaceCustomApmText: function replaceCustomApmText(inputString) {
      if (this.amText && this.amText.length && inputString.includes(this.amText)) {
        return inputString.replace(new RegExp(this.amText, 'g'), this.apmType === 'A' ? 'AM' : 'am');
      } else if (this.pmText && this.pmText.length && inputString.includes(this.pmText)) {
        return inputString.replace(new RegExp(this.pmText, 'g'), this.apmType === 'A' ? 'PM' : 'pm');
      }

      return inputString;
    },
    checkDropDirection: function checkDropDirection() {
      if (!this.$el) {
        return;
      }

      var container;

      if (this.containerId && this.containerId.length) {
        container = document.getElementById(this.containerId);

        if (!container && this.debugMode) {
          this.debugLog("Container with id \"".concat(this.containerId, "\" not found. Fallback to document body."));
        }
      }

      var el = this.$el;
      var spaceDown;

      if (container && container.offsetHeight) {
        // Valid container found
        spaceDown = container.offsetTop + container.offsetHeight - (el.offsetTop + el.offsetHeight);
      } else {
        // Fallback to document body
        var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
        spaceDown = docHeight - (el.offsetTop + el.offsetHeight);
      }

      this.forceDropOnTop = this.opts.dropOffsetHeight > spaceDown;
    },
    //
    // Helpers
    //
    is12hRange: function is12hRange(value) {
      return /^\d{1,2}(a|p|A|P)$/.test(value);
    },
    match12hRange: function match12hRange(value) {
      return value.match(/^(\d{1,2})(a|p|A|P)$/);
    },
    isNumber: function isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    isBasicType: function isBasicType(type) {
      return CONFIG.BASIC_TYPES.includes(type);
    },
    lowerCasedApm: function lowerCasedApm(apmValue) {
      return (apmValue || '').toLowerCase();
    },
    getTokenRegex: function getTokenRegex(token) {
      switch (token) {
        case 'HH':
          return '([01][0-9]|2[0-3]|H{2})';

        case 'H':
          return '([0-9]{1}|1[0-9]|2[0-3]|H{1})';

        case 'hh':
          return '(0[1-9]|1[0-2]|h{2})';

        case 'h':
          return '([1-9]{1}|1[0-2]|h{1})';

        case 'kk':
          return '(0[1-9]|1[0-9]|2[0-4]|k{2})';

        case 'k':
          return '([1-9]{1}|1[0-9]|2[0-4]|k{1})';

        case 'mm':
          return '([0-5][0-9]|m{2})';

        case 'ss':
          return '([0-5][0-9]|s{2})';

        case 'm':
          return '([0-9]{1}|[1-5][0-9]|m{1})';

        case 's':
          return '([0-9]{1}|[1-5][0-9]|s{1})';

        case 'A':
          return '(AM|PM|A{1})';

        case 'a':
          return '(am|pm|a{1})';

        default:
          return '';
      }
    },
    isEmptyValue: function isEmptyValue(targetToken, testValue) {
      return !testValue || !testValue.length || testValue && testValue === targetToken;
    },
    isValidValue: function isValidValue(targetToken, testValue) {
      if (!targetToken || this.isEmptyValue(targetToken, testValue)) {
        return false;
      }

      var tokenRegexStr = this.getTokenRegex(targetToken);

      if (!tokenRegexStr || !tokenRegexStr.length) {
        return false;
      }

      return new RegExp("^".concat(tokenRegexStr, "$")).test(testValue);
    },
    sanitizedValue: function sanitizedValue(targetToken, inputValue) {
      if (this.isValidValue(targetToken, inputValue)) {
        return inputValue;
      }

      return '';
    },
    getTokenType: function getTokenType(token) {
      return this.inUse.types[this.inUse.tokens.indexOf(token)] || '';
    },
    getTokenByType: function getTokenByType(type) {
      return this["".concat(type, "Type")] || '';
    },
    isMinuteOrSecond: function isMinuteOrSecond(type) {
      return ['minute', 'second'].includes(type);
    },
    debugLog: function debugLog(logText) {
      var _this20 = this;

      if (!logText || !logText.length) {
        return;
      }

      var identifier = '';

      if (this.id) {
        identifier += "#".concat(this.id);
      }

      if (this.name) {
        identifier += "[name=".concat(this.name, "]");
      }

      if (this.inputClass) {
        var inputClasses = [];

        if (typeof this.inputClass === 'string') {
          inputClasses = this.inputClass.split(/\s/g);
        } else if (Array.isArray(this.inputClass)) {
          inputClasses = [].concat([], this.inputClass);
        } else if (_typeof(this.inputClass) === 'object') {
          Object.keys(this.inputClass).forEach(function (clsName) {
            if (_this20.inputClass[clsName]) {
              inputClasses.push(clsName);
            }
          });
        }

        var _iterator4 = _createForOfIteratorHelper(inputClasses),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var inputClass = _step4.value;

            if (inputClass && inputClass.trim().length) {
              identifier += ".".concat(inputClass.trim());
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      var finalLogText = "DEBUG: ".concat(logText).concat(identifier ? "\n\t(".concat(identifier, ")") : '');

      if (window.console.debug && typeof window.console.debug === 'function') {
        window.console.debug(finalLogText);
      } else {
        window.console.log(finalLogText);
      }
    }
  },
  mounted: function mounted() {
    window.clearTimeout(this.debounceTimer);
    window.clearTimeout(this.selectionTimer);
    window.clearTimeout(this.kbInputTimer);
    this.renderFormat();
  },
  beforeDestroy: function beforeDestroy() {
    window.clearTimeout(this.debounceTimer);
    window.clearTimeout(this.selectionTimer);
    window.clearTimeout(this.kbInputTimer);
  }
});
// CONCATENATED MODULE: ./src/vue-timepicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_vue_timepickervue_type_script_lang_js_ = (vue_timepickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/vue-timepicker.vue?vue&type=style&index=0&lang=css&
var vue_timepickervue_type_style_index_0_lang_css_ = __webpack_require__("aab0");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/vue-timepicker.vue






/* normalize component */

var component = normalizeComponent(
  src_vue_timepickervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var vue_timepicker = (component.exports);
// CONCATENATED MODULE: ./src/index.js

/* harmony default export */ var src_0 = (vue_timepicker);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fd6f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=VueTimepicker.common.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8d8f7da8", content, true, {});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7f31c24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioGroup_vue__ = __webpack_require__(862);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioGroup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7f31c24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525696c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroup_vue__ = __webpack_require__(875);
function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-525696c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525696c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(295);
module.exports = __webpack_require__(497);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(296);

__webpack_require__(493);

__webpack_require__(494);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(297);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(124);
__webpack_require__(401);
__webpack_require__(170);
__webpack_require__(402);
__webpack_require__(171);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(174);
__webpack_require__(176);
__webpack_require__(177);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
module.exports = __webpack_require__(29);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(7);
var has = __webpack_require__(23);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(20);
var META = __webpack_require__(43).KEY;
var $fails = __webpack_require__(8);
var shared = __webpack_require__(68);
var setToStringTag = __webpack_require__(61);
var uid = __webpack_require__(48);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(152);
var wksDefine = __webpack_require__(105);
var enumKeys = __webpack_require__(299);
var isArray = __webpack_require__(79);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(10);
var toObject = __webpack_require__(16);
var toIObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(35);
var createDesc = __webpack_require__(47);
var _create = __webpack_require__(51);
var gOPNExt = __webpack_require__(155);
var $GOPD = __webpack_require__(25);
var $GOPS = __webpack_require__(78);
var $DP = __webpack_require__(15);
var $keys = __webpack_require__(49);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(52).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(70).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(42)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(19)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(68)('native-function-to-string', Function.toString);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(49);
var gOPS = __webpack_require__(78);
var pIE = __webpack_require__(70);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(51) });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(15).f });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(154) });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(24);
var $getOwnPropertyDescriptor = __webpack_require__(25).f;

__webpack_require__(37)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(16);
var $getPrototypeOf = __webpack_require__(26);

__webpack_require__(37)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(16);
var $keys = __webpack_require__(49);

__webpack_require__(37)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(37)('getOwnPropertyNames', function () {
  return __webpack_require__(155).f;
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(43).onFreeze;

__webpack_require__(37)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(43).onFreeze;

__webpack_require__(37)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(43).onFreeze;

__webpack_require__(37)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(10);

__webpack_require__(37)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(10);

__webpack_require__(37)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(10);

__webpack_require__(37)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(156) });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(157) });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(109).set });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(62);
var test = {};
test[__webpack_require__(12)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(20)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(158) });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(26);
var HAS_INSTANCE = __webpack_require__(12)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(15).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(160);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(161);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7);
var has = __webpack_require__(23);
var cof = __webpack_require__(31);
var inheritIfRequired = __webpack_require__(111);
var toPrimitive = __webpack_require__(35);
var fails = __webpack_require__(8);
var gOPN = __webpack_require__(52).f;
var gOPD = __webpack_require__(25).f;
var dP = __webpack_require__(15).f;
var $trim = __webpack_require__(63).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(51)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(20)(global, NUMBER, $Number);
}


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(32);
var aNumberValue = __webpack_require__(162);
var repeat = __webpack_require__(112);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(8)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(8);
var aNumberValue = __webpack_require__(162);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(7).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(163) });


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(163);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(161);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(160);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(164);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(113);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(114);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(165) });


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(8)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(164) });


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(113) });


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(114);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(8)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(114);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(50);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(24);
var toLength = __webpack_require__(13);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(63)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(80)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(115)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(80)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(13);
var context = __webpack_require__(117);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(118)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(117);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(118)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(112)
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(13);
var context = __webpack_require__(117);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(118)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(21)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(21)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(21)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(21)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(21)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(21)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(21)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(21)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(21)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(21)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(21)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(21)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(21)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(35);

$export($export.P + $export.F * __webpack_require__(8)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(376);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(8);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(20)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(12)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(19)(proto, TO_PRIMITIVE, __webpack_require__(379));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(35);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(79) });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(30);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var call = __webpack_require__(166);
var isArrayIter = __webpack_require__(119);
var toLength = __webpack_require__(13);
var createProperty = __webpack_require__(120);
var getIterFn = __webpack_require__(121);

$export($export.S + $export.F * !__webpack_require__(82)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(120);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(8)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(24);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(69) != Object || !__webpack_require__(33)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(108);
var cof = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(50);
var toLength = __webpack_require__(13);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(8)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(18);
var toObject = __webpack_require__(16);
var fails = __webpack_require__(8);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(33)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(38)(0);
var STRICT = __webpack_require__(33)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var isArray = __webpack_require__(79);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(38)(1);

$export($export.P + $export.F * !__webpack_require__(33)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(38)(2);

$export($export.P + $export.F * !__webpack_require__(33)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(38)(3);

$export($export.P + $export.F * !__webpack_require__(33)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(38)(4);

$export($export.P + $export.F * !__webpack_require__(33)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(167);

$export($export.P + $export.F * !__webpack_require__(33)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(167);

$export($export.P + $export.F * !__webpack_require__(33)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(77)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(33)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(24);
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(13);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(33)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(168) });

__webpack_require__(44)('copyWithin');


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(123) });

__webpack_require__(44)('fill');


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(38)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(44)(KEY);


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(38)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(44)(KEY);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Array');


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var inheritIfRequired = __webpack_require__(111);
var dP = __webpack_require__(15).f;
var gOPN = __webpack_require__(52).f;
var isRegExp = __webpack_require__(81);
var $flags = __webpack_require__(71);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(8)(function () {
  re2[__webpack_require__(12)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(20)(global, 'RegExp', $RegExp);
}

__webpack_require__(53)('RegExp');


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(171);
var anObject = __webpack_require__(5);
var $flags = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(14);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(20)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(8)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var toLength = __webpack_require__(13);
var advanceStringIndex = __webpack_require__(126);
var regExpExec = __webpack_require__(83);

// @@match logic
__webpack_require__(84)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var toInteger = __webpack_require__(32);
var advanceStringIndex = __webpack_require__(126);
var regExpExec = __webpack_require__(83);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(84)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(5);
var sameValue = __webpack_require__(157);
var regExpExec = __webpack_require__(83);

// @@search logic
__webpack_require__(84)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(81);
var anObject = __webpack_require__(5);
var speciesConstructor = __webpack_require__(72);
var advanceStringIndex = __webpack_require__(126);
var toLength = __webpack_require__(13);
var callRegExpExec = __webpack_require__(83);
var regexpExec = __webpack_require__(125);
var fails = __webpack_require__(8);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(84)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(42);
var global = __webpack_require__(7);
var ctx = __webpack_require__(30);
var classof = __webpack_require__(62);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(10);
var aFunction = __webpack_require__(18);
var anInstance = __webpack_require__(54);
var forOf = __webpack_require__(55);
var speciesConstructor = __webpack_require__(72);
var task = __webpack_require__(127).set;
var microtask = __webpack_require__(128)();
var newPromiseCapabilityModule = __webpack_require__(129);
var perform = __webpack_require__(172);
var userAgent = __webpack_require__(85);
var promiseResolve = __webpack_require__(173);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(56)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(61)($Promise, PROMISE);
__webpack_require__(53)(PROMISE);
Wrapper = __webpack_require__(29)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(82)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(178);
var validate = __webpack_require__(57);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(86)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(87);
var buffer = __webpack_require__(130);
var anObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(50);
var toLength = __webpack_require__(13);
var isObject = __webpack_require__(10);
var ArrayBuffer = __webpack_require__(7).ArrayBuffer;
var speciesConstructor = __webpack_require__(72);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(8)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(53)(ARRAY_BUFFER);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(87).ABV, {
  DataView: __webpack_require__(130).DataView
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(18);
var anObject = __webpack_require__(5);
var rApply = (__webpack_require__(7).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(8)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(51);
var aFunction = __webpack_require__(18);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(10);
var fails = __webpack_require__(8);
var bind = __webpack_require__(158);
var rConstruct = (__webpack_require__(7).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(15);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(35);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(8)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(25).f;
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(116)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(25);
var getPrototypeOf = __webpack_require__(26);
var has = __webpack_require__(23);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(5);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(25);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(26);
var anObject = __webpack_require__(5);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(180) });


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(5);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(15);
var gOPD = __webpack_require__(25);
var getPrototypeOf = __webpack_require__(26);
var has = __webpack_require__(23);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(47);
var anObject = __webpack_require__(5);
var isObject = __webpack_require__(10);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(109);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(77)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(44)('includes');


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(181);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var aFunction = __webpack_require__(18);
var arraySpeciesCreate = __webpack_require__(122);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(44)('flatMap');


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(181);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var toInteger = __webpack_require__(32);
var arraySpeciesCreate = __webpack_require__(122);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(44)('flatten');


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(80)(true);
var $fails = __webpack_require__(8);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(182);
var userAgent = __webpack_require__(85);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(182);
var userAgent = __webpack_require__(85);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(63)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(63)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(36);
var toLength = __webpack_require__(13);
var isRegExp = __webpack_require__(81);
var getFlags = __webpack_require__(71);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(116)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('asyncIterator');


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('observable');


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(180);
var toIObject = __webpack_require__(24);
var gOPD = __webpack_require__(25);
var createProperty = __webpack_require__(120);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(183)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(183)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(18);
var $defineProperty = __webpack_require__(15);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(14) && $export($export.P + __webpack_require__(88), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(18);
var $defineProperty = __webpack_require__(15);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(14) && $export($export.P + __webpack_require__(88), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(26);
var getOwnPropertyDescriptor = __webpack_require__(25).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(88), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(26);
var getOwnPropertyDescriptor = __webpack_require__(25).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(88), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(184)('Map') });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(184)('Set') });


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(89)('Map');


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(89)('Set');


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(89)('WeakMap');


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(89)('WeakSet');


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(90)('Map');


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(90)('Set');


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(90)('WeakMap');


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(90)('WeakSet');


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(7) });


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(7) });


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(31);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(186);
var fround = __webpack_require__(165);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(186) });


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(29);
var global = __webpack_require__(7);
var speciesConstructor = __webpack_require__(72);
var promiseResolve = __webpack_require__(173);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(129);
var perform = __webpack_require__(172);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(26);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(176);
var from = __webpack_require__(185);
var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(26);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var getPrototypeOf = __webpack_require__(26);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(41);
var anObject = __webpack_require__(5);
var aFunction = __webpack_require__(18);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(128)();
var process = __webpack_require__(7).process;
var isNode = __webpack_require__(31)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(7);
var core = __webpack_require__(29);
var microtask = __webpack_require__(128)();
var OBSERVABLE = __webpack_require__(12)('observable');
var aFunction = __webpack_require__(18);
var anObject = __webpack_require__(5);
var anInstance = __webpack_require__(54);
var redefineAll = __webpack_require__(56);
var hide = __webpack_require__(19);
var forOf = __webpack_require__(55);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(53)('Observable');


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(7);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(85);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(127);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(124);
var getKeys = __webpack_require__(49);
var redefine = __webpack_require__(20);
var global = __webpack_require__(7);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(64);
var wks = __webpack_require__(12);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(495);
module.exports = __webpack_require__(29).RegExp.escape;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(496)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // Lecture 346
// https://vue-multiselect.js.org/

// import CKEditor from '@ckeditor/ckeditor5-vue'; // https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs.html
// import VueCkeditor from 'vueckeditor';
// https://www.npmjs.com/package/vue-youtube-embed


// import Vue from 'vue'


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(500);

var _App2 = _interopRequireDefault(_App);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vueMultiselect = __webpack_require__(651);

var _vueMultiselect2 = _interopRequireDefault(_vueMultiselect);

var _router = __webpack_require__(103);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(136);

var _store2 = _interopRequireDefault(_store);

var _vueRouter = __webpack_require__(197);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vTooltip = __webpack_require__(702);

var _vTooltip2 = _interopRequireDefault(_vTooltip);

__webpack_require__(796);

__webpack_require__(801);

__webpack_require__(803);

__webpack_require__(805);

__webpack_require__(806);

__webpack_require__(807);

__webpack_require__(809);

__webpack_require__(811);

__webpack_require__(812);

__webpack_require__(813);

__webpack_require__(814);

__webpack_require__(816);

__webpack_require__(817);

__webpack_require__(818);

__webpack_require__(819);

__webpack_require__(820);

__webpack_require__(821);

__webpack_require__(822);

__webpack_require__(823);

__webpack_require__(824);

__webpack_require__(825);

__webpack_require__(826);

__webpack_require__(827);

__webpack_require__(828);

__webpack_require__(829);

__webpack_require__(830);

__webpack_require__(831);

__webpack_require__(832);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

__webpack_require__(833);

var _vueToasted = __webpack_require__(834);

var _vueToasted2 = _interopRequireDefault(_vueToasted);

var _js = __webpack_require__(835);

var _js2 = _interopRequireDefault(_js);

var _pluginVue = __webpack_require__(837);

var _pluginVue2 = _interopRequireDefault(_pluginVue);

var _FormGroupRowLayout = __webpack_require__(838);

var _FormGroupRowLayout2 = _interopRequireDefault(_FormGroupRowLayout);

var _DetailSectionRowLayout = __webpack_require__(279);

var _DetailSectionRowLayout2 = _interopRequireDefault(_DetailSectionRowLayout);

var _BookingSectionWithDialog = __webpack_require__(202);

var _BookingSectionWithDialog2 = _interopRequireDefault(_BookingSectionWithDialog);

var _InputDialog = __webpack_require__(147);

var _InputDialog2 = _interopRequireDefault(_InputDialog);

var _EditLabelSetting = __webpack_require__(882);

var _EditLabelSetting2 = _interopRequireDefault(_EditLabelSetting);

var _EditButtonSetting = __webpack_require__(886);

var _EditButtonSetting2 = _interopRequireDefault(_EditButtonSetting);

var _vueSignaturePad = __webpack_require__(888);

var _vueSignaturePad2 = _interopRequireDefault(_vueSignaturePad);

__webpack_require__(891);

var _urlParams = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bugsnagClient = _js2.default.start({
  apiKey: "cbc3ac7119706b464870c888fd1bacc0",
  plugins: [new _pluginVue2.default()]
});

_js2.default.getPlugin("vue").installVueErrorHandler(_vue2.default);

var BugsnagPlugin = {
  install: function install(Vue) {
    Vue.prototype.$bugsnag = bugsnagClient;
  }
};

// https://vsupalov.com/avoid-csrf-errors-axios-django/
_axios2.default.defaults.xsrfCookieName = "csrftoken";
_axios2.default.defaults.xsrfHeaderName = "X-CSRFTOKEN";

_axios2.default.defaults.baseURL = _urlParams.BASE_URL;
_vue2.default.use(_vTooltip2.default, {
  defaultPlacement: 'auto'
});
_vue2.default.component("multiselect", _vueMultiselect2.default); // https://vue-multiselect.js.org
_vue2.default.component("FormGroupRowLayout", _FormGroupRowLayout2.default);
_vue2.default.component("DetailSectionRowLayout", _DetailSectionRowLayout2.default);
_vue2.default.component("InputDialog", _InputDialog2.default);
_vue2.default.component('BookingSectionWithDialog', _BookingSectionWithDialog2.default);
_vue2.default.component('EditLabelSetting', _EditLabelSetting2.default);
_vue2.default.component('EditButtonSetting', _EditButtonSetting2.default);
_vue2.default.use(BugsnagPlugin);
_vue2.default.use(_vueSignaturePad2.default);

_vue2.default.prototype.tryGet = _tryGet2.default;

// Vue.use( CKEditor );
// Vue.use( VueCkeditor );

var toastOption = {
  icon: "check",
  className: "success-toast",
  containerClass: "container-toast",
  duration: 5000,
  type: "success"
};
_vue2.default.use(_vueToasted2.default, toastOption);

// https://scotch.io/tutorials/how-to-create-filters-in-vuejs-with-examples
_vue2.default.filter("trimSeconds", function (value) {
  // Used for trimming the seconds off an event time (turn 18:00:00 into 18:00)
  return value.slice(0, -3); // https://stackoverflow.com/questions/952924/javascript-chop-slice-trim-off-last-character-in-string
});
// https://stackoverflow.com/questions/44538110/how-to-format-numbers-in-vuejs
// http://numeraljs.com/
var numeral = __webpack_require__(893);
_vue2.default.filter("noDecimal", function (value) {
  // Used for making something no decimal (good for credits)
  return numeral(value).format("0");
});

_vue2.default.filter("singleDecimal", function (value) {
  // Used for making something 1 decimal (good for actual distances)
  return numeral(value).format("0.0");
});

_vue2.default.filter("twoDecimals", function (value) {
  // Used for making something 2 decimals (good for length in hours of a job)
  return numeral(value).format("0.00");
});

// Overwrite $router.replace function to ignore error navigation duplicated
var originalPush = _vueRouter2.default.prototype.replace;
_vueRouter2.default.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(function (err) {
    console.log(err.name);
    console.log(typeof err === "undefined" ? "undefined" : _typeof(err));
    if (err.name === "NavigationDuplicated") {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};

new _vue2.default({
  el: "#app",
  router: _router2.default,
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(499);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(148)))

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8167f170_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8167f170_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("85f4c2d8", content, true, {});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.i(__webpack_require__(503), "");
exports.i(__webpack_require__(504), "");

// module
exports.push([module.i, ":root{--coredarkcolor:#1f4e78;--coredarkercolor:#183c5c;--corelightcolor:#fff;--bootstrapgrey:#e9ecef;--skyblue:#bfe7ff;--thrivehiregrey:#d9d9da;--nannycogreen:#0c4524;--gcnorange:#e79271;--gcnteal:#85a2a8;--rootfontfamily:\"Open Sans\";--headingsfontfamily:\"Open Sans\";--profiletextcolor:#212529;--cancelbuttoncolor:#5f7478;--cancelbuttonhovercolor:#85a2a8;touch-action:pan-x pan-y;height:100%}body{font-family:var(--rootfontfamily)!important;background-color:transparent}h1,h2,h3,h4,h5{font-family:var(--headingsfontfamily)!important}#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.top-panel{padding:.5rem 2.5%}.top-level-div{padding-bottom:125px;padding-left:12.5%;padding-right:12.5%}.invert-top-level-div{margin-bottom:-125px}.center{text-align:center;display:block;margin-left:auto;margin-right:auto}h1{text-transform:var(--headingOneCase)!important}h1,h2{color:var(--coredarkcolor);font-weight:500}h2{text-transform:var(--headingTwoCase)!important}h3{color:var(--coredarkcolor);text-transform:var(--headingThreeCase)!important}.heavy-font{font-weight:600}p,pre{margin-bottom:0}pre{font-size:100%;white-space:pre-wrap;font-family:var(--rootfontfamily)!important}pre p{margin-bottom:10px}pre h3,pre h4,pre h5{margin-top:15px}pre img{margin-top:8px;margin-bottom:8px}ul{margin-bottom:0}a:hover{text-decoration:none}.delete-text{color:red;cursor:pointer}.edit-text{color:var(--coredarkcolor);cursor:pointer}.warning-text{color:red;font-weight:600}.profile-page{color:var(--profiletextcolor)}.btn{border:none}.btn-lg{font-size:1.1rem}.btn-primary{background-color:var(--coredarkcolor);font-weight:600}.btn-primary:hover{background-color:var(--thrivehiregrey);color:var(--coredarkcolor)}.btn-outline-primary{color:#5289b9}.btn-secondary{background-color:var(--bootstrapgrey);color:var(--coredarkcolor)}.btn-secondary:hover{background-color:var(--thrivehiregrey);color:var(--coredarkcolor)}.btn-grey{background-color:var(--bootstrapgrey);color:var(--coredarkcolor)}.btn-grey:hover{background-color:var(--coredarkcolor);color:var(--corelightcolor)}.buttons{display:inline-block;transition:all .2s ease;overflow:hidden;border-radius:3px;line-height:16px;font-weight:700}.header-button{align-items:center;height:50px}.header-button button{padding:15px 25px}.button-1{color:var(--coredarkcolor);border:none;background:#fff;font-size:14px}.button-1:hover{color:#fff;cursor:pointer}.button-1-dark,.button-1:hover{background:var(--coredarkcolor)}.button-1-dark{color:var(--corelightcolor);border:none;font-size:14px}.button-1-dark:hover{color:var(--coredarkcolor);cursor:pointer;background:var(--thrivehiregrey)}.landing-button{min-width:165px;font-weight:800;margin-top:20px}.mylisting-button{min-width:135px;text-align:center;font-weight:600;padding:13px 25px;border-radius:0;font-size:12px;-webkit-box-align:center;align-items:center;position:relative;z-index:0;-webkit-box-pack:center;justify-content:center;white-space:nowrap;border:2px solid #0c4524;border:none}a.mylisting-button:hover{text-decoration:none}a.mylisting-button{display:inline-block}.dark-button{color:#fff;background:linear-gradient(90deg,var(--coredarkercolor) 50%,var(--coredarkcolor) 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.dark-button:hover{color:#fff;background-position:0 100%}.secondary-button{color:#fff;background:linear-gradient(90deg,#5f7478 50%,var(--gcnteal) 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.secondary-button:hover{color:#fff;background-position:0 100%}.notransition *{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}.noHover{pointer-events:none}.danger-button{color:#fff;background:linear-gradient(90deg,#c00 50%,red 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.danger-button:hover{color:#fff;background-position:0 100%}.primary-button{color:#fff;background:linear-gradient(90deg,#007bff 50%,#2f00ff 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.primary-button:hover{color:#fff;background-position:0 100%}.light-button{color:var(--coredarkcolor);border:2px solid var(--coredarkcolor);background:linear-gradient(90deg,var(--coredarkcolor) 50%,#fff 0);background-size:200% 100%;background-position:100% 100%;transition:all .25s ease-out}.light-button:hover{color:#fff;background-position:0 100%}.cancel-button{background:linear-gradient(90deg,var(--cancelbuttonhovercolor) 50%,var(--cancelbuttoncolor) 0);background-size:200% 100%;background-position:100% 100%}.actions-btn{color:#007bff;padding:0 4px}.nav-item{margin-right:15px;font-size:13px;color:var(--corelightcolor)}.dropleft{position:absolute;top:4px;right:0;margin-top:4px;z-index:9999}.dropleft .dropdown-toggle:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent;border:none}.footer p{margin-bottom:0}.profile-tile{border-radius:6px;box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important;padding:1.5rem;margin-top:40px}.is-agent .profile-tile{scroll-margin-top:70px}.profile-tile:empty{display:none}.profile-tile>h3{text-transform:none;font-size:1.5rem}.profile-form label,.profile label{font-weight:600;margin-top:15px}.profile label{margin-bottom:2px}.profile .top-label{margin-top:0}.field-of-fields label{color:var(--coredarkcolor);font-weight:600;margin-top:22px;margin-bottom:4px;color:var(--labelcolor,var(--coredarkcolor))}.field-of-fields .top-label{margin-top:0}.small-label-help-text{display:block;margin-bottom:3px}.form-check label{font-weight:400;margin-top:2px;color:var(--coredarkcolor)}.invalid label,.invalid small{color:red}.social-icon{margin-right:2px;margin-left:2px;height:25px}.shaded-label{background-color:var(--bootstrapgrey);width:100%;padding:10px;border-bottom:7px solid var(--corelightcolor)}.profile-section{margin-left:10px;margin-right:10px}.section-header{text-transform:none;font-size:1.5rem}.dashboard-button{border-right:2px solid #fff;padding-top:6px;padding-bottom:6px;cursor:pointer;font-weight:700}.dashboard-button,.dashboard-button-active{background-color:var(--thrivehiregrey);color:var(--corelightcolor)}.dashboard-button-active{background-color:var(--coredarkcolor)}.editor__content{border:1px solid #ced4da;padding:.375rem .75rem;border-radius:.25rem;color:#495057;font-size:1rem}.ProseMirror:focus{outline:none}.ProseMirror{min-height:100px}.editor__content p{margin-bottom:0}.vdp-datepicker input{border-width:0;width:100%}.vdp-datepicker input[type=text]:focus{box-shadow:none;border:none}.registration-form{height:100vh;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding-top:40px;padding-bottom:40px;background-color:#f5f5f5}.form-signup{width:100%;max-width:330px;padding:15px;margin:auto}.form-signup .checkbox{font-weight:400}.form-signup .form-control{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.form-control,.form-control:focus{font-size:16px}.form-control.signing-field{display:inline-block;width:unset;resize:both}.v--modal-overlay.scrollable .v--modal-box{max-height:90vh;overflow-y:auto}.content-block{max-width:650px;display:block;margin-left:auto;margin-right:auto;margin-top:15px}.content-block img{max-width:100%}.informational-heading,.informational-subheading{margin-top:25px}.informational-list,.informational-text-block{margin-bottom:10px}.multiselect__tag{margin-bottom:0;background-color:var(--coredarkcolor)}.listing-tile{background-color:var(--bootstrapgrey);padding:20px 30px}.document{padding:3% 10%}.document p{margin-bottom:10px}.agency-logo-container{text-align:center;margin-bottom:50px}.agency-logo-container>img{max-width:400px}.mobile-only{display:none}@media (max-width:768px){.mobile-only{display:inherit}.web-only{display:none}.landing .dropdown-item{color:var(--coredarkcolor);font-size:13px}.navbar{padding-left:0;padding-right:0}h1{font-size:2rem;line-height:1.1}.v--modal-overlay.scrollable .v--modal-box{max-height:80vh;overflow-y:auto}.grouped-buttons{display:flex;flex-direction:column;align-items:center}}.required-field{color:red!important;font-weight:600!important;margin-top:2px}.required-message{color:red;font-weight:600;margin-top:2px}.vld-overlay.is-full-page{z-index:100000}.submit-button-section{margin-top:30px;display:flex;justify-content:flex-end}.text-require-notice{font-size:.8rem;color:var(--coredarkcolor)}h3,h4,h5{position:relative}.edit-button{opacity:.8;z-index:1000}.add-button,.edit-button{position:absolute;right:0;cursor:pointer;width:24px}.add-button{opacity:1}.add-button>i{font-size:30px}.form-control-file{font-size:.8rem}.time-picker>input{border:1px solid #ced4da;border-radius:.25rem}.time-picker{padding:0;border:none}.description{font-size:80%;font-weight:400;margin-bottom:5px;white-space:pre-line}.description>div,.description>span{white-space:normal}.one-line-description{font-size:80%;font-weight:400;margin-bottom:5px;margin-top:3px}.admin-description{font-size:80%;font-weight:700;margin-bottom:5px;white-space:pre-line}.icon-button{cursor:pointer}.container-toast.toasted-container.top-right{right:0}.toasted-container{z-index:1000000}.container-toast>.toasted.success-toast.toasted-primary{background-color:#47d78a;border-radius:4px;padding:1em}.success-toast>i{background-color:#fff;color:#47d78a;border-radius:100%;padding:.1em;margin:.2em}.vue-swatches__trigger{border:1px solid grey}.date-picker{padding:0!important}.date-picker input{height:calc(1.5em + .75rem)!important;border-radius:4px!important;padding-left:.75rem}.field-container,.item-container{display:flex;align-items:center;margin:1em;flex-wrap:wrap}.field-title,.item-title{flex-basis:13em;flex-shrink:0}.field-value,.item-value{flex-grow:1;flex-basis:20em;flex-shrink:0}.space-left{flex-basis:4em;display:flex}.space-right{flex-basis:2em;text-align:center}.field-value,.item-value{display:flex;align-items:center;padding-left:2em}.collapse-button,.expand-button{display:flex;align-items:center;cursor:pointer;flex-basis:1.8em}.delete-button{cursor:pointer;color:red}.option-list-container{width:100%}.option-list-container>.multiselect .multiselect__tag{white-space:pre-wrap}.button-group-container{display:flex}.cancel-btn{flex-grow:1}.multiselect-option{display:flex;align-items:center}.multiselect-icon{flex-basis:20px}.multiselect-icon>.material-icons{width:30px}.collapse-expand-button-container{display:flex}.expand-btn{margin-right:1em;margin-bottom:1em}.field-type-icon>.material-icons{width:30px}.edit-form-icon{cursor:pointer}li .invalid-option{color:red;opacity:.5}.drag-drop-item,.drag-drop-item :not(button){cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.drag-drop-item:active,.drag-drop-item :not(button):active{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.booking-detail label{margin-top:2px!important}.booking-detail .admin-description,.booking-detail .description{display:none}.calendar .cv-event{white-space:normal}.calendar .cv-event:not(.unclickable){cursor:pointer}.theme-default .cv-event.continued:before,.theme-default .cv-event.toBeContinued:after{color:#000}.theme-default .cv-day.past{opacity:.7}.profile-view-only .description{display:none}.info-key{font-weight:700;margin-right:.5em;color:var(--coredarkcolor)}.inherit-color-section .info-key,.inherit-color-section h3,.inherit-color-section label{color:inherit}.inherit-color-section .dialog-container .info-key,.inherit-color-section .dialog-container h3,.inherit-color-section .dialog-container label{color:var(--coredarkcolor)}.inherit-color-link{color:inherit}.in-embed .agency-logo-container,.in-embed .agency-owner,.in-embed nav{display:none}.in-embed{margin:0}.col-lg-custom-24,.col-lg-custom-48,.col-lg-custom-72{position:relative;width:100%;padding-right:15px;padding-left:15px}.header-calendar .cv-weeks{display:none}@media (min-width:992px){.col-lg-custom-24{flex:0 0 20%;max-width:20%}.col-lg-custom-48{flex:0 0 40%;max-width:40%}.col-lg-custom-72{flex:0 0 60%;max-width:60%}}.field-of-fields label.checkbox-container,label.checkbox-container{display:block;position:relative;padding-left:35px;margin-bottom:0;cursor:pointer;font-weight:400;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-top:0}.checkbox-container input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.checkmark{position:absolute;top:0;left:0;height:25px;width:25px;background-color:#eee;border:2px solid #2196f3}.checkbox-container:hover input~.checkmark{background-color:#ccc}.checkbox-container input:checked~.checkmark{background-color:#2196f3}.checkmark:after{content:\"\";position:absolute;display:none}.checkbox-container input:checked~.checkmark:after{display:block}.checkbox-container .checkmark:after{left:8px;top:3px;width:8px;height:14px;border:solid #fff;border-width:0 4px 4px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.email-textbox>input{text-transform:lowercase}.delete-icon{color:red;cursor:pointer}.label-no-margin-top label{margin-top:0}.label-no-margin-top .field-of-fields.input-dialog-container label:not(.checkbox-label){margin-top:22px}.label-small-margin-top label{margin-top:.5em}.form-check-input:checked+label .highlight-selected{font-weight:700}.vue-tooltip-visible{z-index:20000}.align-left{text-align:left}.align-center{text-align:center}.vdp-datepicker .vdp-datepicker__clear-button{font-weight:700;position:absolute;right:8px}.blaster-email-component .data-table,.broadcast-dialog .data-table{max-height:500px;overflow:auto;display:block}button:disabled,button[disabled]{opacity:.5}.inline-edit-icon{cursor:pointer}.day-month-picker .mx-input-wrapper{height:100%}.day-month-picker .mx-input-wrapper>div{height:100%;display:flex;align-items:center;padding-left:.5em}.day-month-picker-popup .mx-calendar-header,.day-month-picker-popup .mx-table-date thead{display:none}.form-control.mx-datepicker{display:block;width:100%}.form-control.mx-datepicker input{border:none}.mx-datepicker-popup{z-index:20000}.submit-clicked .is-required:invalid{outline:2px solid red}.login-page{background-color:#f5f5f5}.login-page .footer-panel{display:none}.application-form-container{width:75%}h3.dialog-title{display:flex;flex-wrap:wrap}h3.dialog-title span:first-child{padding-right:.25em}.checkbox-option-profile-builder+div>label:first-child{margin-top:10px}.button-link{color:#007bff!important;cursor:pointer}.inline-answer{display:inline}.inline-answer>p{display:inline-flex}.enginehow-list-item{margin-top:4px}.other-buttons>span:not(:last-child):after{content:\"|\";color:var(--coredarkcolor)}.hide-logo .logo,.view-only-access .edit-access-buttons{display:none}.copy-button{margin-left:.5em;cursor:pointer}.copy-button:active{color:#007bff}.timepicker-container .vue__time-picker .dropdown,.timepicker-container .vue__time-picker .dropdown .select-list{height:27em}.section-template-container ul{display:inline-block}@media (max-width:992px){.dialog-container>.p-5,.dialog-content-container>.p-5{padding:2em!important}.top-level-div{padding-left:2em;padding-right:2em}.calendar .cv-day-number,.calendar .cv-event{font-size:.9em}.application-form-container{width:80%}}.form-label-btn{display:flex}.form-label-btn>i{cursor:pointer}@media (min-width:769px){.col-md-custom-24{flex:0 0 20%;max-width:20%}}@media (max-width:768px){.dialog-container>.p-5,.dialog-content-container>.p-5{padding:1.5em!important}.top-level-div{padding-left:1em;padding-right:1em}.calendar .cv-event{font-size:.8em}.calendar .cv-day-number{font-size:.85em}.calendar .cv-header .periodLabel{font-size:1.2em}.application-form-container{width:85%}h3.dialog-title{font-size:1.5em}.hide-editor-button-mobile .text-editor-component>.button-containers{display:none}h4.mobile-smaller{font-size:1.3em}}@media (max-width:600px){.dialog-container>.p-5,.dialog-content-container>.p-5{padding:1.2em 1em!important}.top-level-div{padding-left:.5em;padding-right:.5em}.row>.calendar{padding:0 4px}.calendar .cv-event{font-size:.7em}.calendar .cv-day-number{font-size:.75em}.application-form-container{width:90%}.row .timepicker-container .vue__time-picker,.row .timepicker-container .vue__time-picker input.display-time{width:9em}h3.dialog-title{font-size:1.35em}.mylisting-button{padding:12px 15px}}@media (max-width:400px){.row .timepicker-container .vue__time-picker,.row .timepicker-container .vue__time-picker input.display-time{width:6em}h3.dialog-title{font-size:1.2em}h4.description{font-size:1.1em}h5.sub-title{font-size:1.08em}}.enginehow-tooltip{left:-28px!important}.cropper-crop-box,.cropper-view-box{border-radius:50%}.cropper-view-box{box-shadow:0 0 0 1px #39f;outline:0}.cursor-pointer{cursor:pointer}.section-body .section-template-container .display-content font{line-height:19.2px}#application-form-font-color .description,#application-form-font-color .item-label,#application-form-font-color .item-option,#application-form-font-color .list-item,#application-form-font-color .step-status-text,#application-form-font-color div b,#application-form-font-color h2,#application-form-font-color h3,#application-form-font-color h4,#application-form-font-color label{color:var(--appFormFontColor)!important}.enginehire-help{position:fixed;bottom:4px;right:4px;z-index:100000}.enginehire-help>i{font-size:40px}.display-flex{display:flex}.display-block{display:block}.display-none{display:none}.clear-button{display:block;cursor:pointer}.item-label.header-label{padding-left:.5em}.close-toast-btn{color:#fff!important}.distance-remark{font-style:italic}.space-item{flex-grow:1}.button-loading{border:12px solid #f3f3f3;border-top:12px solid var(--coredarkcolor);border-radius:50%;width:44px;height:44px;animation:spin 1.5s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.button-done{font-size:44px;color:var(--coredarkcolor)}.transparent-btn{display:flex;padding-top:0;padding-bottom:0;border:none;background:none;outline:none!important;cursor:default!important}.broadcast-dialog .data-table .table .table-sticky-header{top:-2px!important}.topic-description img{max-width:100%}h2.mobile-smaller{font-size:3em}@media (max-width:600px){h2.mobile-smaller{font-size:2em}}.refresh-button{cursor:pointer}.menu-bar-panel.sticky-summary{top:88px!important}@media (max-width:768px){.menu-bar-panel.sticky-summary{top:66px!important}}.overflow-x-auto{overflow-x:auto}.end-date-filter,.start-date-filter{padding-right:.5em;flex-grow:1}.spacing{flex-grow:1}.full-width{width:100%}.visible-icon{color:#adadad;cursor:pointer}.edit-builder-icon{cursor:pointer;display:flex;align-items:center;font-size:18px}.add-option-icon{font-size:12px}.checkbox-column-header.inline-content{display:none}.checkbox-column-content.inline-content{display:inline}.checkbox-column-header.inline-content:after{content:\": \"}.checkbox-column-content.inline-content:not(:last-child):after{content:\", \"}.checkbox-column-content.inline-content:last-child:after{content:\".\"}.document-container.submit-clicked .is-required.StripeElement--empty:after{content:\"This field is required\";display:block;color:red;font-weight:700;margin-top:.5rem}.tooltip{display:block!important;z-index:10000}.tooltip .tooltip-inner{background:#000;color:#fff;border-radius:16px;padding:5px 10px 4px}.tooltip .tooltip-arrow{width:0;height:0;border-style:solid;position:absolute;margin:5px;border-color:#000;z-index:1}.tooltip[x-placement^=top]{margin-bottom:5px}.tooltip[x-placement^=top] .tooltip-arrow{border-width:5px 5px 0;border-left-color:transparent!important;border-right-color:transparent!important;border-bottom-color:transparent!important;bottom:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0}.tooltip[x-placement^=bottom]{margin-top:5px}.tooltip[x-placement^=bottom] .tooltip-arrow{border-width:0 5px 5px;border-left-color:transparent!important;border-right-color:transparent!important;border-top-color:transparent!important;top:-5px;left:calc(50% - 5px);margin-top:0;margin-bottom:0}.tooltip[x-placement^=right]{margin-left:5px}.tooltip[x-placement^=right] .tooltip-arrow{border-width:5px 5px 5px 0;border-left-color:transparent!important;border-top-color:transparent!important;border-bottom-color:transparent!important;left:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0}.tooltip[x-placement^=left]{margin-right:5px}.tooltip[x-placement^=left] .tooltip-arrow{border-width:5px 0 5px 5px;border-top-color:transparent!important;border-right-color:transparent!important;border-bottom-color:transparent!important;right:-5px;top:calc(50% - 5px);margin-left:0;margin-right:0}.tooltip.popover .popover-inner{background:#f9f9f9;color:#000;padding:24px;border-radius:5px;box-shadow:0 5px 30px rgba(black,.1)}.tooltip.popover .popover-arrow{border-color:#f9f9f9}.tooltip[aria-hidden=true]{visibility:hidden;opacity:0;transition:opacity .15s,visibility .15s}.tooltip[aria-hidden=false]{visibility:visible;opacity:1;transition:opacity .15s}", ""]);

// exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#search-result-container .delete-image-icon,#search-result-container .form-check:not(.in-search-result),#search-result-container .predefined-option-list label:not(.in-search-result):not(.non-search-label)+.list-field-container,#search-result-container .update-button-container:not(.in-search-result),#search-result-container :not(label):not(small)+small,#search-result-container button.mylisting-button:not(.section-button):not(.in-search-result),#search-result-container h3:not(.in-search-result):not(.non-search-header),#search-result-container h3:not(.in-search-result):not(.non-search-header)+div,#search-result-container h4:not(.in-search-result):not(.non-search-header),#search-result-container h4:not(.in-search-result):not(.non-search-header)+div,#search-result-container hr,#search-result-container img,#search-result-container input[type=file],#search-result-container label:not(.in-search-result):not(.non-search-label),#search-result-container label:not(.in-search-result):not(.non-search-label)+.badges-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+.day-hour-list,#search-result-container label:not(.in-search-result):not(.non-search-label)+.font-picker-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+.input-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+.list-fields-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+.multiselect,#search-result-container label:not(.in-search-result):not(.non-search-label)+.multiselect-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+.multiselect-container+.list-fields-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+.row,#search-result-container label:not(.in-search-result):not(.non-search-label)+.text-editor-component,#search-result-container label:not(.in-search-result):not(.non-search-label)+.text-editor-component+.small,#search-result-container label:not(.in-search-result):not(.non-search-label)+.vdp-datepicker,#search-result-container label:not(.in-search-result):not(.non-search-label)+input,#search-result-container label:not(.in-search-result):not(.non-search-label)+small,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.input-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.list-fields-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.multiselect,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.multiselect-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.multiselect-container+.list-fields-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.row,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+.text-editor-component,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+input,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+small+.multiselect-container,#search-result-container label:not(.in-search-result):not(.non-search-label)+small+textarea,#search-result-container label:not(.in-search-result):not(.non-search-label)+textarea{display:none}#search-result-container .expandable-section-container .expandable-section{display:none!important}#search-result-container .expandable-section-container .non-expand-panel{display:block}#search-result-container .color-picker-container:not(.in-search-result){display:none}#search-result-container .agency-type-section{margin-top:0}#search-result-container br{display:none}#search-result-container .dialog-container .input-container,#search-result-container .dialog-container .multiselect,#search-result-container .dialog-container .multiselect-container,#search-result-container .dialog-container .text-editor,#search-result-container .dialog-container button,#search-result-container .dialog-container h3,#search-result-container .dialog-container hr,#search-result-container .dialog-container input.form-control,#search-result-container .dialog-container label,#search-result-container .dialog-container small,#search-result-container .dialog-container textarea{display:block!important}#search-result-container .update-button-container.in-search-result>button.mylisting-button{display:inline-block}", ""]);

// exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-striped tbody tr:nth-of-type(odd){background-color:#f8f9fa}", ""]);

// exports


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3d26e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(523);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3d26e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var bind = __webpack_require__(189);
var Axios = __webpack_require__(508);
var mergeConfig = __webpack_require__(195);
var defaults = __webpack_require__(192);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(196);
axios.CancelToken = __webpack_require__(521);
axios.isCancel = __webpack_require__(191);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(522);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var buildURL = __webpack_require__(190);
var InterceptorManager = __webpack_require__(509);
var dispatchRequest = __webpack_require__(510);
var mergeConfig = __webpack_require__(195);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);
var transformData = __webpack_require__(511);
var isCancel = __webpack_require__(191);
var defaults = __webpack_require__(192);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(194);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(516);
var combineURLs = __webpack_require__(517);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(22);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(196);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white","text-align":"center","padding-top":"3.5vh","padding-bottom":"6.5vh"}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"px-4"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8b9554_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationForm_vue__ = __webpack_require__(609);
function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a8b9554"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApplicationForm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a8b9554_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApplicationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(526);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b317edda", content, true, {});

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".application-form-container[data-v-7a8b9554]{margin-top:48px;display:block;margin-left:auto;margin-right:auto}.agency-owner[data-v-7a8b9554]{text-transform:unset}.result-section[data-v-7a8b9554]{color:var(--coredarkcolor);font-weight:600;text-align:center}.checkbox-condition-require[data-v-7a8b9554]{margin-top:0;margin-bottom:4px;margin-left:-1.5rem}.previous-button[data-v-7a8b9554]{margin-right:1em}.progress-container[data-v-7a8b9554]{border-radius:20px;border:1px solid #1e7ac4;height:20px}.current-progress[data-v-7a8b9554]{border-radius:20px;height:100%;background-color:var(--coredarkcolor)}.step-status-text[data-v-7a8b9554]{padding-bottom:5px;padding-left:7px;font-weight:600}.file-with-info-container[data-v-7a8b9554]{background-color:#fff}.undo-redo-btn[data-v-7a8b9554]:not(.disabled){cursor:pointer}.undo-redo-btn.disabled[data-v-7a8b9554]{opacity:.5;cursor:context-menu}.undo-redo-panel[data-v-7a8b9554]{position:sticky;top:0;background:#fff;background-color:#fff;z-index:100}.undo-redo-panel>div[data-v-7a8b9554]{align-items:center}.modify-builder-property[data-v-7a8b9554]{cursor:pointer;font-size:.6em}.modify-builder-instruction[data-v-7a8b9554]{position:absolute;top:0;right:0;cursor:pointer;font-size:20px}.instruction-container[data-v-7a8b9554]{position:relative}", ""]);

// exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("781b05c4", content, true, {});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".detail-info[data-v-33a961cb]{white-space:pre-wrap}.header-detail[data-v-33a961cb],.sub-header-detail[data-v-33a961cb]{margin-top:1.25em;margin-bottom:-.5em;padding-left:15px}.sub-header-detail>h5[data-v-33a961cb]{margin-bottom:0}.label-no-margin-top .header-detail[data-v-33a961cb],.label-no-margin-top .sub-header-detail[data-v-33a961cb]{margin-bottom:.5em}.col-lg-12>.sub-header-detail[data-v-33a961cb]{padding-left:0}.image-display[data-v-33a961cb]{max-width:100%;max-height:10em}.image-at-top[data-v-33a961cb]{max-width:100%;max-height:10em;position:absolute;top:0;right:1.5em}.field-of-fields[data-v-33a961cb]{position:relative}.space-empty-label[data-v-33a961cb]{margin-top:12px}.display-label[data-v-33a961cb]{display:inline-flex;align-items:center}.display-label>i.material-icons[data-v-33a961cb]{font-size:18px}.field-of-fields.no-label-margin label[data-v-33a961cb]{margin-top:5px}", ""]);

// exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f49b5f16", content, true, {});

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".rating-container{display:flex;align-items:center;flex-wrap:wrap;width:fit-content}.rating-item{cursor:pointer}.rating-container.disabled .rating-item{cursor:default}.star-description{margin-left:1em;min-width:130px;padding:.5em;text-align:center;font-weight:700;color:#fff}.active{color:#f3d23e}.star-poor{background:#bababa}.star-belowAverage{background:#f5c357}.star-average{background:#ffac5a}.star-good{background:#c1d759}.star-excellent{background:#48964d}.rating-result{margin-left:.5em;font-family:Segoe UI,Tahoma,Geneva,Verdana,sans-serif}.star-hover{color:#f3d23e}", ""]);

// exports


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rating-container",class:{ disabled: _vm.disabled },style:({ minWidth: 5 * _vm.starSize + 'px' })},[_vm._l((_vm.maxStars),function(star){return _c('div',{key:star,staticClass:"rating-item",class:[{ active: star <= _vm.stars }],on:{"mouseover":function($event){return _vm.hoverStar(star)},"mouseleave":_vm.mouseLeftStar,"click":function($event){return _vm.rate(star)}}},[_c('span',{staticClass:"rate-star"},[(star <= _vm.stars)?_c('i',{staticClass:"material-icons",style:({ 'font-size': _vm.starSize + 'px' })},[_vm._v("\n          grade\n        ")]):_c('i',{staticClass:"material-icons",class:{ 'star-hover': _vm.hoverItem && _vm.hoverItem >= star },style:({ 'font-size': _vm.starSize + 'px' })},[_vm._v("\n          star_outline\n        ")])])])}),_vm._v(" "),(_vm.starDesc.text && _vm.showRating)?_c('span',{staticClass:"star-description",class:_vm.starDesc.class},[_vm._v(_vm._s(_vm.starDesc.text))]):_vm._e()],2),_vm._v(" "),(!_vm.stars && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-of-fields",class:{ 'no-label-margin': _vm.hideLabelSpacing }},_vm._l((_vm.listRowInput),function(rowInput,rowIndex){return _c('div',{key:'row' + rowIndex,staticClass:"row"},_vm._l((rowInput),function(item,index){return _c('div',{key:item.model + rowIndex + index,class:_vm.getClassList(item)},[(item.type === _vm.FORM_TYPE.ARRAY_OBJECT)?[(!isNaN(_vm.modelData[item.size]))?[_vm._l((Number(_vm.modelData[item.size])),function(childRowIndex){return [_c('DetailSectionRowLayout',{key:'childRowIndex-' + childRowIndex,attrs:{"user":_vm.user,"modelData":_vm.modelData[item.model][childRowIndex - 1],"isInlineAnswer":_vm.isInlineAnswer,"labelKey":"labelDetail","listFields":item.items}})]})]:_vm._e()]:(
          [
            _vm.FORM_TYPE.SLOT,
            _vm.FORM_TYPE.SECTION,
            _vm.FORM_TYPE.BOOKING_SECTION ].includes(item.type)
        )?[(_vm.isItemShow(_vm.modelData, item, _vm.listFields))?_vm._t(item.name):_vm._e()]:(item.type === _vm.FORM_TYPE.TAG_HTML)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.replaceTagValue(item.model, _vm.modelData))}})]:(item.type === _vm.FORM_TYPE.CHECKBOX)?[(_vm.isDisplayItem(item))?_c('CheckboxGroupDetail',{attrs:{"label":_vm.getDisplayLabel(item),"isInlineAnswer":_vm.isInlineAnswer,"classList":"","name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"optionList":_vm.getOptionsListByLanguage(item),"mapOptionListByLang":_vm.getMapOptionListByLanguage(item),"hasOther":item.hasOther,"hiddenIconTooltip":_vm.hiddenIconTooltip,"visibleIconTooltip":_vm.visibleIconTooltip,"hasHiddenIcon":_vm.listHiddenIconFields.includes(item.model),"isHtml":item.isHtml,"numberOfColumn":item.numberOfColumn,"textboxOption":item.textboxOption,"tagData":_vm.tagData,"builderField":_vm.builderField,"value":_vm.modelData[item.model]},on:{"toggleVisible":function($event){return _vm.handleClickToggleVisibility(item, $event)}}}):_vm._e()]:(item.type === _vm.FORM_TYPE.RATING_GROUP)?[(_vm.isDisplayItem(item))?_c('RatingGroupDetail',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"itemList":item.itemList,"gradeList":item.gradeList,"numberOfColumn":item.numberOfColumn,"value":_vm.modelData[item.model]}}):_vm._e()]:(item.type === _vm.FORM_TYPE.RATING)?[(_vm.isDisplayItem(item))?_c('StarRating',{attrs:{"classList":"","disabled":true,"label":_vm.getDisplayLabel(item),"name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"hasOther":item.hasOther,"defaultValue":item.defaultValue,"value":_vm.modelData[item.model],"isRequired":item.isRequired}}):_vm._e()]:(item.type === _vm.FORM_TYPE.PRODUCT_SELECTION)?[(_vm.isDisplayItem(item))?_c('ProductSelectionDetail',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"productList":item.productList,"descriptionList":item.descriptionList,"priceList":item.priceList,"iconList":item.iconList,"value":_vm.modelData[item.model]}}):_vm._e()]:(item.type === _vm.FORM_TYPE.RADIO_TABLE)?[(_vm.isDisplayItem(item))?_c('RadioTableDetail',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"optionList":_vm.getOptionsListByLanguage(item),"itemList":item.itemList,"headerList":item.headerList,"value":_vm.modelData[item.model]}}):_vm._e()]:(item.type === _vm.FORM_TYPE.CHECKBOX_TABLE)?[(_vm.isDisplayItem(item))?_c('CheckboxTable',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"optionList":_vm.getOptionsListByLanguage(item),"itemList":item.itemList,"headerList":item.headerList,"hasNote":item.hasNote,"noteHeader":item.noteHeader,"isRequired":false,"isViewOnly":true},model:{value:(_vm.modelData[item.model]),callback:function ($$v) {_vm.$set(_vm.modelData, item.model, $$v)},expression:"modelData[item.model]"}}):_vm._e()]:(item.type === _vm.FORM_TYPE.DAY_HOURS_SELECTOR)?[(_vm.isDisplayItem(item))?_c('DayHourSelectorDetail',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"field":item,"value":_vm.modelData[item.model]}}):_vm._e()]:(item.type === _vm.FORM_TYPE.SIGNATURE_FIELD)?[(_vm.isDisplayItem(item))?_c('SignatureDetail',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"field":item,"value":_vm.modelData[item.model]}}):_vm._e()]:(item.type === _vm.FORM_TYPE.TEXT_EDITOR)?[(_vm.isDisplayItem(item))?_c('div',[(_vm.getDisplayLabel(item) != null)?_c('label',[_vm._v("\n            "+_vm._s(_vm.getDisplayLabel(item))+"\n          ")]):_vm._e(),_vm._v(" "),(item.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getFieldProperty(item, 'description'))}})]):_vm._e(),_vm._v(" "),(_vm.isDisplayItem(item))?_c('p',{staticClass:"detail-info",domProps:{"innerHTML":_vm._s(_vm.modelData[item.model])}}):_vm._e()]):_vm._e()]:(item.type === _vm.FORM_TYPE.HEADER)?[_c('h4',{staticClass:"header-detail mb-1"},[_vm._v("\n          "+_vm._s(_vm.getDisplayLabel(item))+"\n        ")]),_vm._v(" "),(item.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getFieldProperty(item, 'description'))}})]):_vm._e()]:(item.type === _vm.FORM_TYPE.SUB_HEADER)?[(
            !(item.isPrivate && _vm.editAccess === false) &&
            _vm.isItemShow(_vm.modelData, item, _vm.listFields)
          )?_c('div',{staticClass:"sub-header-detail"},[_c('h5',[_vm._v("\n            "+_vm._s(_vm.getDisplayLabel(item))+"\n          ")]),_vm._v(" "),(item.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getFieldProperty(item, 'description'))}})]):_vm._e()]):_vm._e()]:(item.type === _vm.FORM_TYPE.HTML)?[_c('div',{style:({ margin: item.noMargin ? '0' : '0 15px' }),domProps:{"innerHTML":_vm._s(item.html)}})]:(item.type === _vm.FORM_TYPE.SEPARATOR)?[_c('hr',{staticStyle:{"margin-bottom":"0"}})]:(item.type === _vm.FORM_TYPE.HTML_SELECTION)?[(_vm.isDisplayItem(item))?_c('HtmlSelectionDetail',{attrs:{"label":_vm.getDisplayLabel(item),"classList":"","name":item.model,"description":_vm.getFieldProperty(item, 'description'),"adminDescription":_vm.getFieldProperty(item, 'adminDescription'),"optionList":_vm.getOptionsListByLanguage(item),"htmlList":item.htmlList,"isMulti":item.isMulti,"numberOfColumn":item.numberOfColumn,"value":_vm.modelData[item.model]}}):_vm._e()]:(item.type === _vm.FORM_TYPE.FILE)?[(_vm.isDisplayItem(item))?_c('div',[(item.fileType === _vm.FILE_TYPES.IMAGE)?_c('div',[(item.showAtTop)?_c('div',[_c('img',{staticClass:"image-at-top",attrs:{"src":_vm.getDisplayValue(item, item.model)}})]):_c('div',[(_vm.getDisplayLabel(item) != null)?_c('label',[_vm._v("\n                "+_vm._s(_vm.getDisplayLabel(item))+"\n              ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"detail-info"},[_c('img',{staticClass:"image-display",attrs:{"src":_vm.getDisplayValue(item, item.model)}})])])]):_c('div',[(_vm.getDisplayLabel(item) != null)?_c('label',[_vm._v("\n              "+_vm._s(_vm.getDisplayLabel(item))+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"view-document"},[(typeof _vm.modelData[item.model] === 'object')?_c('div',[_vm._v("\n                File: "+_vm._s(_vm.modelData[item.model].name)+"\n              ")]):_c('div',[_c('a',{attrs:{"href":_vm.convertToAbsolutePath(_vm.modelData[item.model]),"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button view-button mt-2"},[_vm._v("\n                    View\n                  ")])]),_vm._v(" "),(_vm.showDeleteFile(item))?_c('button',{staticClass:"mylisting-button secondary-button mt-2",on:{"click":function($event){return _vm.showDeleteFileConfirmDialog(item.model)}}},[_vm._v("\n                  "+_vm._s(_vm.getLabelByKeys("BUTTONS.DELETE"))+"\n                ")]):_vm._e()])])])]):_vm._e()]:(item.type === _vm.FORM_TYPE.LIST_TEXTBOX)?[(
            _vm.modelData[item.labelModel] &&
            _vm.modelData[item.labelModel].length > 0
          )?_c('div',[_c('label',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"-8px"}},_vm._l((_vm.modelData[item.labelModel]),function(label,index){return _c('div',{key:'textbox-' + index,staticClass:"col-lg-6"},[_c('label',[_vm._v("\n                "+_vm._s(label)+"\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.modelData[item.model][index])+"\n              ")])])}),0)]):_vm._e()]:[(_vm.isDisplayItem(item))?_c('div',[(item.hideDetailLabel)?_c('div',{staticClass:"space-empty-label"}):_vm._e(),_vm._v(" "),(_vm.getDisplayLabel(item) != null)?_c('label',[(_vm.showAge(item))?_c('span',[_vm._v("Age")]):_c('span',{staticClass:"display-label"},[_vm._v(_vm._s(_vm.getDisplayLabel(item))),(_vm.listAdminOnlyIconFields.includes(item.model))?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Admin Only'),expression:"'Admin Only'"}],staticClass:"hidden-icon material-icons ml-2"},[_vm._v("\n                admin_panel_settings\n              ")]):_vm._e(),_vm._v(" "),(_vm.listHiddenIconFields.includes(item.model))?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.hiddenIconTooltip),expression:"hiddenIconTooltip"}],staticClass:"hidden-icon material-icons ml-2",on:{"click":function($event){return _vm.handleClickToggleVisibility(item, true)}}},[_vm._v("\n                visibility_off\n              ")]):_vm._e(),_vm._v(" "),(item.additionalIcon)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(item.additionalIconTooltip),expression:"item.additionalIconTooltip"}],staticClass:"hidden-icon material-icons ml-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('additionalIconClick', item)}}},[_vm._v("\n                "+_vm._s(item.additionalIcon)+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.isInlineAnswer)?_c('span',[_vm._v(":")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isInlineAnswer)?_c('div',{staticClass:"inline-answer"},[(['phone', 'phone2'].includes(item.model))?_c('p',{staticClass:"detail-info"},[_c('a',{attrs:{"href":("tel:" + (_vm.getDisplayValue(item, item.model)))}},[_vm._v(_vm._s(_vm.getDisplayValue(item, item.model)))])]):(item.type === _vm.FORM_TYPE.RADIO && item.isHtml)?_c('p',{staticClass:"detail-info"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getDisplayValue(item, item.model))}})]):_c('p',{staticClass:"detail-info"},[_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(item, item.model)))])])]):_vm._e(),_vm._v(" "),(item.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getFieldProperty(item, 'description'))}})]):_vm._e(),_vm._v(" "),(!_vm.isInlineAnswer)?_c('div',[(['phone', 'phone2'].includes(item.model))?_c('p',{staticClass:"detail-info"},[_c('a',{attrs:{"href":("tel:" + (_vm.getDisplayValue(item, item.model)))}},[_vm._v(_vm._s(_vm.getDisplayValue(item, item.model)))])]):(item.type === _vm.FORM_TYPE.RADIO && item.isHtml)?_c('p',{staticClass:"detail-info"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getDisplayValue(item, item.model))}})]):_c('p',{staticClass:"detail-info"},[_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(item, item.model)))])])]):_vm._e()]):_vm._e()]],2)}),0)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(534);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2b0c6630", content, true, {});

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".overlay-panel[data-v-dc823762]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.2);opacity:1}.dialog-container[data-v-dc823762]{position:fixed;z-index:1;background:#fff;animation:anime-data-v-dc823762 .5s cubic-bezier(.16,1,.3,1) forwards;border-radius:4px;max-height:90vh}.in-embed .dialog-container[data-v-dc823762]{animation:unset}.closing-dialog[data-v-dc823762]{animation:anime-close-data-v-dc823762 .5s cubic-bezier(.16,1,.3,1) forwards}.dialog-content-container[data-v-dc823762]{overflow:auto;max-height:90vh;background-color:#fff}.close-button-container[data-v-dc823762]{z-index:2;position:absolute}.close-button-container>i[data-v-dc823762]{font-size:36px;cursor:pointer;color:var(--coredarkcolor)}.btn-bg-white[data-v-dc823762]{background-color:#fff;height:36px;border-radius:50px}@media (max-width:768px){.dialog-container[data-v-dc823762]{width:calc(100vw - 1em)!important;left:.5em!important}.close-button-container[data-v-dc823762]{right:0!important}}@media (min-width:769px){.overlay-panel-right>.dialog-container.closing-dialog[data-v-dc823762]{animation:anime-right-close-data-v-dc823762 .5s cubic-bezier(.16,1,.3,1) forwards}.overlay-panel-right[data-v-dc823762]{position:relative;height:0}.overlay-panel-right>.dialog-container[data-v-dc823762]{top:0!important;height:100vh!important;left:15vw!important;width:calc(85vw - 16px)!important;box-shadow:-2px 0 8px #00000026;animation:anime-right-open-data-v-dc823762 .5s cubic-bezier(.16,1,.3,1) forwards}.overlay-panel-right>.dialog-container>.dialog-content-container[data-v-dc823762]{max-height:100vh}.overlay-panel-left[data-v-dc823762]{position:relative;height:0}.overlay-panel-left>.dialog-container[data-v-dc823762]{left:0!important;width:calc(50vw - 16px)!important;box-shadow:-2px 0 8px #00000026}.overlay-panel-left>.dialog-container>.dialog-content-container[data-v-dc823762]{max-height:100vh}}@keyframes anime-data-v-dc823762{0%{width:60px;height:60px;left:50%;top:50%;background:#f8f8f8;box-shadow:10px 10px 10px #ccc,10px 10px 10px #fff,inset 0 0 0 #ccc,inset 0 0 0 #fff;overflow:hidden}to{background:#fafafa;box-shadow:40px 40px 40px #ccc,0 0 0 #fff,inset 0 0 0 #ccc,inset 2px 2px 2px #fff}}@keyframes anime-close-data-v-dc823762{0%{background:#fafafa;box-shadow:40px 40px 40px #ccc,0 0 0 #fff,inset 0 0 0 #ccc,inset 2px 2px 2px #fff;overflow:hidden}40%{height:60px;top:50%;background:#f8f8f8;box-shadow:10px 10px 10px #ccc,10px 10px 10px #fff,inset 0 0 0 #ccc,inset 0 0 0 #fff;overflow:hidden}to{width:60px;height:60px;left:50%;top:50%;background:#f8f8f8;box-shadow:10px 10px 10px #ccc,10px 10px 10px #fff,inset 0 0 0 #ccc,inset 0 0 0 #fff;overflow:hidden}}@keyframes anime-right-close-data-v-dc823762{0%{margin-left:0;overflow:hidden}to{margin-left:85vw;overflow:hidden}}@keyframes anime-right-open-data-v-dc823762{0%{margin-left:85vw;overflow:hidden}to{margin-left:0;overflow:hidden}}.is_hidden[data-v-dc823762]{visibility:hidden}", ""]);

// exports


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow || _vm.isInlinePin)?_c('div',{class:_vm.isHidden ? 'is_hidden' : ''},[(_vm.isInline || _vm.isInlinePin)?_c('div',[_vm._t("dialog-content")],2):_c('div',{staticClass:"overlay-panel",class:{
      'overlay-panel-right': _vm.showInRight,
      'overlay-panel-left': _vm.showInLeft,

    },style:({ zIndex: _vm.baseZIndex }),attrs:{"data-index":_vm.baseZIndex,"data-uid":_vm._uid}},[_c('div',{staticClass:"dialog-container",style:({
        top: _vm.dialogContentTop,
        width: _vm.width + 'vw !important',
        left:  _vm.left + 'vw !important',
      }),attrs:{"id":_vm.dialogId},on:{"scroll":function($event){return _vm.handleScrollDialog($event)}}},[_vm._t("sticky-bar"),_vm._v(" "),_c('div',{ref:"dialogContent",staticClass:"dialog-content-container",style:(_vm.isEmbed && _vm.iframeParentHeight
            ? ("max-height: " + _vm.maxHeightDialogContent + "px;")
            : ''),on:{"scroll":function($event){return _vm.handleScrollDialog($event)}}},[_vm._t("dialog-content")],2),_vm._v(" "),(!_vm.hideCloseBtn)?_c('div',{staticClass:"close-button-container",class:{ 'btn-bg-white': _vm.useWhiteBgCloseButton },style:({
          zIndex: _vm.baseZIndex,
          top: _vm.topCloseBtn,
          right: _vm.rightCloseBtn,
        })},[_c('i',{staticClass:"material-icons close-button-tour-handle",on:{"click":function($event){return _vm.handleCloseDialog()}}},[_vm._v(" cancel ")])]):_vm._e()],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2d9e6aac", content, true, {});

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".description[data-v-480ead33]{font-size:80%;font-weight:400}.booking-detail-container[data-v-480ead33]{max-height:440px;overflow-y:auto}.booking-detail[data-v-480ead33]{width:100%}.booking-container[data-v-480ead33]{display:flex}.icon-containers[data-v-480ead33]{padding-top:.7em}.hide-past-booking[data-v-480ead33]{padding-left:20px}.hide-past-booking>.form-check-label[data-v-480ead33]{margin-top:0}.hide-past-booking .past-booking-filter[data-v-480ead33]{margin-left:-20px}.booking-calendar-container[data-v-480ead33]{flex-wrap:wrap-reverse}.add-booking[data-v-480ead33]{margin-top:.5em}.credit-info[data-v-480ead33]{margin-top:.4em}.booking-group[data-v-480ead33]{display:flex}.booking-group-info[data-v-480ead33]{flex-grow:1}.delete-group[data-v-480ead33]{flex-basis:20px}.booking-buttons-container[data-v-480ead33]{margin-top:5px;font-weight:700}.booking-button[data-v-480ead33]{cursor:pointer}.calendar-parent-container[data-v-480ead33]{background:#fff;background-clip:content-box,padding-box}.price-info-container[data-v-480ead33]{line-height:1}.relative[data-v-480ead33]{position:relative}.top-2[data-v-480ead33]{top:2px}.calendar-btns>button[data-v-480ead33]{border:solid 1px var(--coredarkcolor)}.nav-button[data-v-480ead33]{cursor:pointer;display:flex;align-items:center}", ""]);

// exports


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBookingDialog_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBookingDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBookingDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBookingDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBookingDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04fd67d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBookingDialog_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04fd67d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateBookingDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04fd67d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateBookingDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("21d9aa43", content, true, {});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".button-containers[data-v-04fd67d4]{flex-wrap:wrap}.button-containers[data-v-04fd67d4],.left-side-button[data-v-04fd67d4]{display:flex;flex-direction:row-reverse}.right-side-button[data-v-04fd67d4]{flex-grow:1;text-align:right}.danger-button[data-v-04fd67d4]{margin-left:.5em}@media (max-width:600px){.button-containers[data-v-04fd67d4]{display:block;text-align:center}.left-side-button[data-v-04fd67d4]{margin-top:8px;display:block}.right-side-button[data-v-04fd67d4]{text-align:center}.danger-button[data-v-04fd67d4]{margin-left:0;margin-bottom:8px}}.selected-candidate[data-v-04fd67d4]{background-color:rgb(227 226 226)}", ""]);

// exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(542);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("01887b49", content, true, {});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"0.5em"},attrs:{"id":_vm.id}}),_vm._v(" "),_c('div',{staticClass:"mt-2",staticStyle:{"font-size":"1rem","font-weight":"700","color":"red"},attrs:{"id":"card-errors","role":"alert"}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.submitClicked && _vm.isRequired),expression:"submitClicked && isRequired"}],staticClass:"required-message"},[_c('span',{attrs:{"id":"payment-info-error"}},[_c('span',{attrs:{"id":_vm.STRIPE_PAYMENT_ERROR_IDS.EMPTY}},[_vm._v("The field is required.")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2677289c", content, true, {});

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceValueItem_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceValueItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceValueItem_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceValueItem_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceValueItem_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67394dd1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceValueItem_vue__ = __webpack_require__(549);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67394dd1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceValueItem_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67394dd1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceValueItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1c3df8d4", content, true, {});

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".edit-icon[data-v-67394dd1]{cursor:pointer;color:#007bff}", ""]);

// exports


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('p',{class:_vm.columnLayout ? 'col-lg-6' : ''},[_c('label',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.agencyCurrencySign)+_vm._s(_vm._f("twoDecimals")(_vm.value))+"\n    "+_vm._s(_vm.isPerHourRate ? _vm.getLabelByKeys("LABELS.PER_HOUR") : "")+"\n  ")]),_vm._v(" "),(_vm.isAgent && !_vm.viewOnly)?_c('i',{staticClass:"material-icons edit-icon",on:{"click":function($event){return _vm.showUpdatePriceDialog()}}},[_vm._v("\n    edit\n  ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showCombinePrice)?_c('div',{class:_vm.columnLayout ? 'row' : ''},_vm._l((_vm.pricingInfoList),function(item){return _c('div',{key:item},[(_vm.getItemPlacement(item, 'Booking Rate'))?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Booking Rate'),"viewOnly":true,"columnLayout":_vm.columnLayout,"isPerHourRate":true},model:{value:(_vm.totalHourlyRate),callback:function ($$v) {_vm.totalHourlyRate=$$v},expression:"totalHourlyRate"}}):_vm._e(),_vm._v(" "),(_vm.getItemPlacement(item, 'Booking Fee'))?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Booking Fee'),"viewOnly":true,"columnLayout":_vm.columnLayout},model:{value:(_vm.totalFlatRate),callback:function ($$v) {_vm.totalFlatRate=$$v},expression:"totalFlatRate"}}):_vm._e(),_vm._v(" "),(_vm.perBookingFlatRate && _vm.getItemPlacement(item, 'Per Booking Fee'))?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Per Booking Fee'),"viewOnly":true,"columnLayout":_vm.columnLayout},model:{value:(_vm.perBookingFlatRate),callback:function ($$v) {_vm.perBookingFlatRate=$$v},expression:"perBookingFlatRate"}}):_vm._e()],1)}),0):_vm._e(),_vm._v(" "),(!_vm.showCombinePrice || _vm.isAgent)?_c('div',{class:_vm.columnLayout ? 'row' : ''},_vm._l((_vm.pricingInfoList),function(item,index){return _c('div',{key:index},[(_vm.showTotalBookingFee && _vm.getItemPlacement(item, 'Booking Fee'))?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Booking Fee'),"viewOnly":true,"columnLayout":_vm.columnLayout},model:{value:(_vm.totalFlatRate),callback:function ($$v) {_vm.totalFlatRate=$$v},expression:"totalFlatRate"}}):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Client Rate')) &&
          _vm.getItemPlacement(item, 'Client Rate')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Client Rate'),"viewOnly":true,"columnLayout":_vm.columnLayout,"isPerHourRate":true},model:{value:(_vm.clientRate),callback:function ($$v) {_vm.clientRate=$$v},expression:"clientRate"}}):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Candidate Rate')) &&
          _vm.getItemPlacement(item, 'Candidate Rate')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Candidate Rate'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout,"isPerHourRate":true},model:{value:(_vm.candidateRate),callback:function ($$v) {_vm.candidateRate=$$v},expression:"candidateRate"}}):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Agency Fee')) &&
          _vm.getItemPlacement(item, 'Agency Fee')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Agency Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout,"isPerHourRate":true},model:{value:(_vm.agencyRate),callback:function ($$v) {_vm.agencyRate=$$v},expression:"agencyRate"}}):_vm._e(),_vm._v(" "),(
          _vm.numberOfBookingUsingCredit &&
          _vm.numberOfBookingNotUsingCredit === 0 &&
          _vm.calculateFee('agency_fee', _vm.calculateAgencyFee) &&
          _vm.getItemPlacement(item, 'Agency Fee')
        )?_c('p',{class:_vm.columnLayout ? 'col-lg-6' : ''},[_c('label',[_vm._v(_vm._s(_vm.getLabel("Agency Fee"))+":")]),_vm._v(" "),_c('span',[_vm._v(" Use Booking Credit ")])]):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Travel Fee')) &&
          _vm.getItemPlacement(item, 'Travel Fee')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Travel Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.travelFee),callback:function ($$v) {_vm.travelFee=$$v},expression:"travelFee"}}):_vm._e(),_vm._v(" "),(_vm.isAgent && _vm.getItemPlacement(item, 'Rush Fee'))?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Rush Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.rushFee),callback:function ($$v) {_vm.rushFee=$$v},expression:"rushFee"}}):_vm._e(),_vm._v(" "),(_vm.getItemPlacement(item, 'Candidate Rush Fee'))?_c('div',[(_vm.isAgent)?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Candidate Rush Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.candidateRushFee),callback:function ($$v) {_vm.candidateRushFee=$$v},expression:"candidateRushFee"}}):_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Rush Fee'),"viewOnly":true,"columnLayout":_vm.columnLayout,"value":_vm.totalRushFee}})],1):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Per Booking Agency Fee')) &&
          _vm.getItemPlacement(item, 'Per Booking Agency Fee')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Per Booking Agency Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.perBookingAgencyFee),callback:function ($$v) {_vm.perBookingAgencyFee=$$v},expression:"perBookingAgencyFee"}}):_vm._e(),_vm._v(" "),(
          _vm.numberOfBookingUsingCredit &&
          _vm.numberOfBookingNotUsingCredit === 0 &&
          _vm.calculateFee('per_booking_agency_fee', _vm.getPerBookingAgencyFee) &&
          _vm.getItemPlacement(item, 'Per Booking Agency Fee')
        )?_c('p',{class:_vm.columnLayout ? 'col-lg-6' : ''},[_c('label',[_vm._v(_vm._s(_vm.getLabel("Per Booking Agency Fee"))+":")]),_vm._v(" "),_c('span',[_vm._v(" Use Booking Credit ")])]):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Per Booking Candidate Fee')) &&
          _vm.getItemPlacement(item, 'Per Booking Candidate Fee')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Per Booking Candidate Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.perBookingCandidateFee),callback:function ($$v) {_vm.perBookingCandidateFee=$$v},expression:"perBookingCandidateFee"}}):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Admin Fee')) &&
          _vm.getItemPlacement(item, 'Admin Fee')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Admin Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.adminFee),callback:function ($$v) {_vm.adminFee=$$v},expression:"adminFee"}}):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Admin Percentage Fee')) &&
          _vm.getItemPlacement(item, 'Admin Percentage Fee')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Admin Percentage Fee'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.adminFeeSubstraction),callback:function ($$v) {_vm.adminFeeSubstraction=$$v},expression:"adminFeeSubstraction"}}):_vm._e(),_vm._v(" "),(
          (_vm.isAgent || _vm.getIsShowPriceToClient('Additional Fees')) &&
          _vm.getItemPlacement(item, 'Additional Fees')
        )?_c('PriceValueItem',{attrs:{"label":_vm.getLabel('Additional Fees'),"viewOnly":_vm.viewOnly,"columnLayout":_vm.columnLayout},model:{value:(_vm.job.additional_fee),callback:function ($$v) {_vm.$set(_vm.job, "additional_fee", $$v)},expression:"job.additional_fee"}}):_vm._e(),_vm._v(" "),(
          _vm.totalDiscount && _vm.getItemPlacement(item, 'Booking Total Discount')
        )?_c('PriceValueItem',{attrs:{"label":"Booking Total Discount","viewOnly":true,"columnLayout":_vm.columnLayout},model:{value:(_vm.totalDiscount),callback:function ($$v) {_vm.totalDiscount=$$v},expression:"totalDiscount"}}):_vm._e()],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("38af41ab", content, true, {});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".favorite-candidate[data-v-3fcf4eac]{color:gold}", ""]);

// exports


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[(_vm.isShowProfilePicture)?_c('div',{staticClass:"col-lg-3",staticStyle:{"max-width":"180px"}},[(
        _vm.jobFiller.profile_pic ==
          'https://d10217p7vdlmii.cloudfront.net/media/profile_pics/default_avatar.jpg' &&
        _vm.jobFiller.external_profile_pic
      )?_c('div',[_c('img',{staticStyle:{"max-width":"150px"},attrs:{"src":_vm.convertToAbsolutePath(_vm.jobFiller.external_profile_pic)}})]):_c('div',[_c('img',{staticStyle:{"max-width":"150px","border-radius":"3px"},attrs:{"src":_vm.convertToAbsolutePath(_vm.jobFiller.profile_pic)}})])]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.isShowProfilePicture ? 'col-lg-9' : 'col-lg-12',staticStyle:{"width":"100%"}},[_c('h3',{staticClass:"mt-2",staticStyle:{"margin-bottom":"0"}},[_vm._v("\n      "+_vm._s(_vm.jobFiller.first_name)+"\n      "),(!_vm.hideCandidateLastNameForShiftJobs)?_c('span',[_vm._v(_vm._s(_vm.jobFiller.last_name))]):_vm._e(),_vm._v(" "),(_vm.isFavorite)?_c('i',{staticClass:"material-icons favorite-candidate"},[_vm._v("\n        star\n      ")]):_vm._e()]),_vm._v(" "),(_vm.shiftViewFullProfile)?_c('div',{staticClass:"mt-2"},[_c('button',{staticClass:"mylisting-button dark-button mt-1",on:{"click":function($event){return _vm.showUserProfileDialog(_vm.jobFiller.id, true)}}},[_vm._v("\n        View Profile\n      ")])]):_c('DetailSectionRowLayout',{attrs:{"modelData":_vm.jobFillerInfo,"labelKey":"displayLabel","listFields":_vm.listVisibleFields,"hideDescription":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFillerDialog_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFillerDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFillerDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFillerDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFillerDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635e6024_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectFillerDialog_vue__ = __webpack_require__(557);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-635e6024"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFillerDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635e6024_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectFillerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(556);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("77eb712b", content, true, {});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".selected-candidate[data-v-635e6024]{background-color:rgb(227 226 226)}.button-container[data-v-635e6024]{display:flex}.left-button[data-v-635e6024]{flex-grow:1}", ""]);

// exports


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"width":90,"closeByClickOutside":true,"level":2},on:{"close":function($event){return _vm.hideModal()}},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5 field-of-fields",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[_c('h3',[_vm._v("\n      Select Candidate for\n      "+_vm._s(_vm.addTimeToDate(_vm.startDate).toDateString())+"\n    ")]),_vm._v(" "),(_vm.listAvailableCandidates.length)?_c('h4',{staticClass:"mt-2 mb-2"},[_c('strong',[_vm._v("Available "+_vm._s(_vm.wordUsedForCandidates))])]):_c('h4',[_vm._v("\n      "+_vm._s(_vm.textSelfSelectNobodyAvailable)+"\n    ")]),_vm._v(" "),_vm._l((_vm.listAvailableCandidates),function(candidate){return _c('div',{key:'Sorted candidate ' + candidate.id,class:{
        'selected-candidate': _vm.hasUnselectCandidateBtn(candidate),
      }},[_c('hr'),_vm._v(" "),_c('JobFillerInfo',{attrs:{"jobFiller":candidate,"listFields":_vm.shiftJobSelectionProfileFields,"listAdditionalInfo":_vm.candidateInfoSelectionFields,"isFavorite":_vm.listFavoriteCandidateIds.includes(candidate.id)}}),_vm._v(" "),(_vm.candidatesCanSetRate && candidate.rate)?_c('div',[_c('b',[_vm._v("Rate:")]),_vm._v(" $"+_vm._s(candidate.rate)+"/h\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasUnselectCandidateBtn(candidate))?_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.handleUnselectCandidates(candidate)}}},[_vm._v("\n        Unselect\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasSelectCandidateBtn(candidate))?_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.listSelectedCandidates.push(candidate)}}},[_vm._v("\n        Select\n      ")]):_vm._e()],1)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('div',{staticClass:"left-button"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.CANCEL"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"right-button"},[(_vm.bookingIndex < _vm.maxBookingIndex)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.handleClickNext()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.NEXT"))+"\n        ")]):_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.handleClickSubmit()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.SUBMIT"))+"\n        ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelectionSection_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelectionSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelectionSection_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelectionSection_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelectionSection_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63176324_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateSelectionSection_vue__ = __webpack_require__(578);
function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63176324"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CandidateSelectionSection_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63176324_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CandidateSelectionSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(560);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("57b762d2", content, true, {});

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".selected-candidate[data-v-63176324]{background-color:rgb(227 226 226)}", ""]);

// exports


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badges_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badges_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badges_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badges_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badges_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b76720a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Badges_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b76720a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Badges_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b76720a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Badges_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(563);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8081268c", content, true, {});

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".badges-container .badges-header[data-v-8b76720a]{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--bootstrapgrey);padding-bottom:1.3rem}.badges-container .badges-card[data-v-8b76720a]{border:1px solid #d3d3d3;padding:15px;display:flex;flex-direction:column;align-items:center;height:100%}.badges-container h2[data-v-8b76720a]{font-size:1.5rem;margin-bottom:0;line-height:1.5rem}.badges-card .badge-img[data-v-8b76720a]{width:7rem;height:7rem;display:flex;justify-content:center;margin:.8rem 0}.badges-card .badge-img img[data-v-8b76720a]{width:100%;height:100%;object-fit:contain}.badges-card .title[data-v-8b76720a]{font-size:1.25rem;margin-top:.5rem;width:100%;text-align:center}.delete-badge[data-v-8b76720a]{margin-left:100%}.message[data-v-8b76720a]{margin:0 auto;color:grey}@media (min-width:768px) and (max-width:1368px){.badges-card .badge-img[data-v-8b76720a]{height:4rem;width:4rem}.badges-card p[data-v-8b76720a]{font-size:.8rem;font-weight:700}}@media (min-width:992px) and (max-width:1110px){.badges-card p[data-v-8b76720a]{font-size:.6rem;font-weight:700}}", ""]);

// exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a2b403dc", content, true, {});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".input-dialog-container[data-v-d6a9d738]{text-align:left;line-height:1.5}.label-input-dialog[data-v-d6a9d738]{margin-top:0}.checkbox-element[data-v-d6a9d738]{margin-left:20px;margin-top:.5em}.color-picker-container[data-v-d6a9d738]{display:flex;align-items:center}.color-picker-label>label[data-v-d6a9d738]{margin-top:0;margin-bottom:0}.color-picker-label[data-v-d6a9d738]{flex-basis:33em}.description[data-v-d6a9d738]{font-size:1.2em}", ""]);

// exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5edb6f0b", content, true, {});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".multiselect-container[data-v-10f43d33]{width:100%}.inline-container[data-v-10f43d33]{display:flex}.inline-container>.item-selection[data-v-10f43d33]{flex-grow:1;padding-right:.5em}.inline-button[data-v-10f43d33]{display:flex;justify-content:center;align-items:center;padding:7px;border-radius:4px;cursor:pointer;border:none}.clear-button[data-v-10f43d33]{margin-top:-.3rem}.select-all-button[data-v-10f43d33]{float:right;cursor:pointer}", ""]);

// exports


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiselect-container",class:_vm.listDisplayInlineButtons.length ? ' inline-container' : ''},[_c('multiselect',{class:_vm.listDisplayInlineButtons.length
        ? _vm.multiSelectClass + ' item-selection'
        : _vm.multiSelectClass,attrs:{"id":_vm.id,"disabled":_vm.isDisabled,"options":_vm.optionList,"multiple":_vm.isMultiple,"customLabel":_vm.customLabel,"searchable":true,"close-on-select":_vm.closeOnSelect,"show-labels":false,"placeholder":_vm.placeholder || _vm.getLabelByKeys('PLACE_HOLDERS.TYPE_TO_FILTER'),"max-height":_vm.maxHeight,"track-by":_vm.optionModel,"label":_vm.optionLabel},on:{"open":_vm.onMultiselectOpen,"close":_vm.onMultiselectClose,"input":function($event){return _vm.handleOnInput($event)},"select":function($event){return _vm.handleSelect($event)},"remove":function($event){return _vm.handleRemove($event)}},scopedSlots:_vm._u([{key:"option",fn:function(ref){
        var option = ref.option;
return [_vm._t("option",null,{"option":option})]}}],null,true),model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(_vm.listDisplayInlineButtons.length)?_c('div',{},_vm._l((_vm.listDisplayInlineButtons),function(button){return _c('button',{key:'button-' + button.id,class:button.class ? button.class : 'btn btn-secondary',staticStyle:{"width":"100px"},on:{"click":function($event){return _vm.handleClickButton(button)}}},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys(button.keyLangLabel))+"\n    ")])}),0):_vm._e(),_vm._v(" "),(
      _vm.additionalSelectedInfoFunc &&
      _vm.inputVal &&
      _vm.additionalSelectedInfoFunc(_vm.inputVal)
    )?_c('div',{staticClass:"mb-2"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.additionalSelectedInfoFunc(_vm.inputVal))}})]):_vm._e(),_vm._v(" "),_c('div',[(_vm.hasSelectAllBtn && _vm.isMultiple)?_c('small',{staticClass:"select-all-button",on:{"click":function($event){return _vm.selectAll()}}},[_vm._v("\n      Select All\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasClearButton)?_c('small',{staticClass:"clear-button",on:{"click":function($event){return _vm.clearSelection()}}},[_vm._v("\n      Clear\n    ")]):_vm._e()]),_vm._v(" "),(_vm.listDisplayButtons && _vm.listDisplayButtons.length)?_c('div',{staticClass:"button-group"},_vm._l((_vm.listDisplayButtons),function(button){return _c('button',{key:'button-' + button.id,class:button.class ? button.class : 'btn btn-secondary mr-1',on:{"click":function($event){return _vm.handleClickButton(button)}}},[_vm._v("\n      "+_vm._s(button.keyLabelParams? _vm.getLabelByKeys.apply(void 0, [ button.keyLangLabel ].concat( button.keyLabelParams )): _vm.getLabelByKeys(button.keyLangLabel))+"\n    ")])}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1bd73224", content, true, {});

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".file-upload-container[data-v-3414d127]{margin-bottom:1em}.file-upload-section[data-v-3414d127]{margin-top:0;border:2px dashed #dfdfdf;background:#e9ecef;display:flex;flex-direction:column;align-items:center;padding:1em}.file-upload-icon[data-v-3414d127]{font-size:2em}.file-upload-label[data-v-3414d127]{font-size:1.3em;font-weight:500;text-align:center}.notice-label[data-v-3414d127]{text-align:center}.file-label[data-v-3414d127]{font-weight:600}.image-preview-container[data-v-3414d127]{position:relative;text-align:center}.image-preview[data-v-3414d127]{max-width:100%;max-height:225px}.edit-image-button[data-v-3414d127]{position:absolute;right:0;cursor:pointer;width:27px;opacity:.8;z-index:1000;background-color:#fff;border-radius:50%;height:27px;border:1px solid grey;color:var(--profiletextcolor)}.btn-container[data-v-3414d127]{text-align:left}.admin-description[data-v-3414d127],.description[data-v-3414d127]{word-break:break-all}.download-blank-template[data-v-3414d127]{position:absolute;right:15px}", ""]);

// exports


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload-container",class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v("\n    "+_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.blankFileUrl)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Download Blank Template'),expression:"'Download Blank Template'"}],staticClass:"download-blank-template",attrs:{"href":_vm.blankFileUrl,"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v(" download ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isImage)?_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.uploadFileId,"accept":"image/x-png,image/jpeg","disabled":_vm.isDisabled},on:{"change":_vm.onChange}}):(_vm.isDoc)?_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.uploadFileId,"accept":".pdf,.doc,.docx","disabled":_vm.isDisabled},on:{"change":_vm.onChange}}):_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.uploadFileId,"disabled":_vm.isDisabled},on:{"change":_vm.onChange}}),_vm._v(" "),(_vm.imageUrl)?_c('div',{staticClass:"image-preview-container",attrs:{"id":"preview"}},[(_vm.isImage)?_c('div',[(_vm.imageUrl)?_c('img',{staticClass:"image-preview",attrs:{"src":_vm.imageUrl}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"edit-image-button",on:{"click":function($event){return _vm.$refs.file.click()}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" edit ")])])]):_c('div',{staticClass:"btn-container"},[_c('a',{attrs:{"href":_vm.imageUrl,"target":"_blank"}},[_c('button',{staticClass:"mylisting-button dark-button view-button"},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.VIEW"))+"\n        ")])]),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$refs.file.click()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.UPLOAD"))+"\n      ")]),_vm._v(" "),(_vm.hasAccessControlBtn)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$emit('accessControl')}}},[_vm._v("\n        Access Control\n      ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.imageUrl)?_c('label',{staticClass:"file-upload-section",attrs:{"for":_vm.uploadFileId},on:{"dragover":_vm.dragover,"drop":_vm.drop}},[_c('i',{staticClass:"material-icons file-upload-icon"},[_vm._v("file_upload")]),_vm._v(" "),_c('div',{staticClass:"file-upload-label"},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys("FILE_UPLOAD.UPLOAD_INSTRUCTION"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"notice-label"},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys("FILE_UPLOAD.MAXIMUM_UPLOAD_SIZE", _vm.maxSize))+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.selectFile != null && _vm.selectFile.name != null)?_c('div',{staticClass:"result-section"},[_c('span',{staticClass:"file-label"},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys("FILE_UPLOAD.FILE"))+":\n    ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectFile.name))])]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),(
      _vm.selectFile == null && _vm.initialUrl == null && _vm.submitClicked && _vm.isRequired
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e(),_vm._v(" "),(
      _vm.selectFile != null && _vm.selectFile.size > _vm.maxSizeInByte && _vm.submitClicked
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("FILE_UPLOAD.FILE_EXCEED_MAXIMUM", _vm.maxSize))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.remark)?_c('div',{staticClass:"remark",domProps:{"innerHTML":_vm._s(_vm.remark)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModalDialog',{attrs:{"width":90,"level":3},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5 field-of-fields input-dialog-container",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(_vm.title)?_c('h3',{staticClass:"dialog-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('h4',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(_vm.title && !_vm.hideHr)?_c('hr',{style:(_vm.hasDistanceTop ? null : 'margin-bottom: 0')}):_vm._e(),_vm._v(" "),_vm._t("custom-field"),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"listFields":_vm.listFields,"modelData":_vm.applicationData,"tagData":_vm.tagData,"submitClicked":_vm.submitClicked},on:{"changed":_vm.handleChange}},[_vm._l((_vm.listFields),function(field,index){return [(field.slotTag)?_c('div',{key:'field-' + index,attrs:{"slot":field.slotTag},slot:field.slotTag},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.handleShowInsertTagDialog(field)}}},[_vm._v("\n              Insert Tag\n            ")])]):_vm._e()]})],2),_vm._v(" "),_vm._t("custom-map-fields"),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"mylisting-button secondary-button cancel-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.CANCEL"))+"\n        ")]),_vm._v(" "),_vm._t("custom-buttons"),_vm._v(" "),(_vm.isShowSubmitButton)?_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},attrs:{"type":"button","disabled":_vm.isRecordingVideo},on:{"click":function($event){return _vm.handleSubmit()}}},[_vm._v("\n          "+_vm._s(_vm.submitButton)+"\n        ")]):_vm._e()],2)],2)]),_vm._v(" "),(_vm.title !== 'Input Tag Information')?_c('InputDialog',{attrs:{"title":"Input Tag Information","listFields":_vm.listFieldsInputTag},on:{"submit":function($event){return _vm.handleInsertTag($event)}},model:{value:(_vm.isShowTagInputDialog),callback:function ($$v) {_vm.isShowTagInputDialog=$$v},expression:"isShowTagInputDialog"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badges-container"},[_c('div',{staticClass:"badges-header"},[_c('h2',[_vm._v(_vm._s(_vm.header ? _vm.header : "Badges"))]),_vm._v(" "),(
        _vm.$store.getters.isCandidate &&
        _vm.unassignedBadges.length > 0 &&
        _vm.$store.getters.candidatesCanAssignBadge
      )?_c('div',{staticClass:"input-group mb-2",staticStyle:{"max-width":"450px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.candidateSelectedBadge),expression:"candidateSelectedBadge"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.candidateSelectedBadge=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.unassignedBadges),function(badge){return _c('option',{key:badge.id,domProps:{"value":badge}},[_vm._v("\n          "+_vm._s(badge.badge_name)+"\n        ")])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.assignBadge()}}},[_vm._v("\n        Add Badge\n      ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.candidateBadgesList.length == 0)?_c('p',{staticClass:"message"},[_vm._v("\n      No Badges Assigned\n    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.candidateBadgesList),function(badge){return _c('div',{key:badge.id,staticClass:"col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 py-4 px-3"},[_c('div',{staticClass:"badges-card"},[_c('div',{staticClass:"badge-img"},[_c('img',{attrs:{"src":badge.badge_image,"alt":""}})]),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(badge.badge_name))])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewInfo_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewInfo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewInfo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewInfo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc479c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewInfo_vue__ = __webpack_require__(577);
function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbc479c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewInfo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc479c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("15f9d05d", content, true, {});

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".reviewer-info[data-v-dbc479c0]{font-weight:700}", ""]);

// exports


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-container mb-3"},[_c('h2',[_vm._v(_vm._s(_vm.header ? _vm.header : "Reviews"))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"review-info"},_vm._l((_vm.reviewInfo),function(review){return _c('div',{key:review.id,staticClass:"mb-3"},[_c('div',{staticClass:"reviewer-info"},[_vm._v(_vm._s(_vm.getReviewerInfo(review)))]),_vm._v(" "),_c('StarRating',{attrs:{"classList":"","disabled":true,"value":review.rating,"starSize":20}}),_vm._v(" "),_c('div',{staticClass:"review-text"},[_vm._v("\n        "+_vm._s(review.text)+"\n      ")])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasTimeInputted)?_c('div',[(_vm.listAvailableCandidates.length)?_c('div',{staticClass:"mt-5 mb-2"},[_c('h4',[_c('strong',[_vm._v("Available "+_vm._s(_vm.wordUsedForCandidates))])]),_vm._v(" "),(_vm.isSelectInterestedCandidate)?_c('h5',[_vm._v("\n        Please select "+_vm._s(_vm.wordUsedForCandidates)+" who you are interested in\n      ")]):_vm._e()]):_c('div',{staticClass:"mt-3"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.textSelfSelectNobodyAvailable)+"\n      ")]),_vm._v(" "),(
          _vm.listPartlyAvailableCandidates &&
          _vm.listPartlyAvailableCandidates.length
        )?_c('div',[_c('h4',[_vm._v("\n          Here are some candidates who have availability at other times on\n          this date\n        ")]),_vm._v(" "),_vm._l((_vm.listPartlyAvailableCandidates),function(candidateBlock,index){return _c('div',{key:'partly-available-' + index},[_c('hr'),_vm._v(" "),_c('JobFillerInfo',{attrs:{"jobFiller":candidateBlock.candidate,"listFields":_vm.shiftJobSelectionProfileFields,"listAdditionalInfo":_vm.candidateInfoSelectionFields,"isFavorite":_vm.listFavoriteCandidateIds.includes(candidateBlock.candidate.id)}}),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('ul',_vm._l((candidateBlock.blocks),function(block,blockIndex){return _c('li',{key:'block-' + index + '-' + blockIndex},[_vm._v("\n              From "+_vm._s(_vm.djangotimeformatAMPM(block.startTime))+" to\n              "+_vm._s(_vm.djangotimeformatAMPM(block.endTime))+"\n            ")])}),0),_vm._v(" "),(candidateBlock.isExceed)?_c('p',{staticClass:"warning-text mt-1"},[_vm._v("\n            Warning: Exceed maximum number of daily jobs\n          ")]):_vm._e()],1)})],2):_vm._e()]),_vm._v(" "),(_vm.listAvailableCandidates.length >= 2 && _vm.isMultiSelection)?_c('div',{staticClass:"collapse-expand-button-container"},[_c('div',{staticClass:"expand-btn mb-0"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){_vm.listSelectedCandidates = _vm.listAvailableCandidates}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.SELECT_ALL"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"collapse-btn mb-0"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){_vm.listSelectedCandidates = []}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.UNSELECT_ALL"))+"\n        ")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.listAvailableCandidates),function(candidate){return _c('div',{key:'Sorted candidate ' + candidate.id,class:{
        'selected-candidate': _vm.hasUnselectCandidateBtn(candidate),
      }},[_c('hr'),_vm._v(" "),_c('JobFillerInfo',{attrs:{"jobFiller":candidate,"listFields":_vm.shiftJobSelectionProfileFields,"listAdditionalInfo":_vm.candidateInfoSelectionFields,"isFavorite":_vm.listFavoriteCandidateIds.includes(candidate.id)}}),_vm._v(" "),(_vm.candidatesCanSetRate && candidate.rate)?_c('div',[_c('b',[_vm._v("Rate:")]),_vm._v(" $"+_vm._s(candidate.rate)+"/h\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasUnselectCandidateBtn(candidate))?_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.handleUnselectCandidates(candidate)}}},[_vm._v("\n        Unselect\n      ")]):_vm._e(),_vm._v(" "),(_vm.hasSelectCandidateBtn(candidate))?_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.handleSelectCandidate(candidate)}}},[_vm._v("\n        Select\n      ")]):_vm._e()],1)}),_vm._v(" "),(_vm.numberOfBooking > 1 && !_vm.isSelectInterestedCandidate)?_c('button',{staticClass:"submit-button mylisting-button dark-button mt-2",attrs:{"data-index":"1"},on:{"click":function($event){return _vm.$emit('selectIndividual')}}},[_vm._v("\n      Select candidate for each individual booking\n    ")]):_vm._e()],2):_c('div',{staticClass:"mt-3"},[(
        _vm.listPartlyAvailableCandidates && _vm.listPartlyAvailableCandidates.length
      )?_c('div',[_c('h4',[_c('strong',[_vm._v("Available "+_vm._s(_vm.wordUsedForCandidates))])]),_vm._v(" "),(_vm.isSelectInterestedCandidate)?_c('h5',[_vm._v("\n        Please select "+_vm._s(_vm.wordUsedForCandidates)+" who you are interested in\n      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.listPartlyAvailableCandidates),function(candidateBlock,index){return _c('div',{key:'partly-available-' + index,class:{
          'selected-candidate': _vm.hasUnselectCandidateBtn(
            candidateBlock.candidate
          ),
        }},[_c('hr'),_vm._v(" "),_c('JobFillerInfo',{attrs:{"jobFiller":candidateBlock.candidate,"listFields":_vm.shiftJobSelectionProfileFields,"listAdditionalInfo":_vm.candidateInfoSelectionFields,"isFavorite":_vm.listFavoriteCandidateIds.includes(candidateBlock.candidate.id)}}),_vm._v(" "),(
            _vm.mapUserIdBadgeIds &&
            _vm.mapUserIdBadgeIds[candidateBlock.candidate.id]
          )?_c('div',[_c('Badges',{attrs:{"badgeIds":_vm.mapUserIdBadgeIds[candidateBlock.candidate.id]}})],1):_vm._e(),_vm._v(" "),(
            _vm.mapUserIdReviews && _vm.mapUserIdReviews[candidateBlock.candidate.id]
          )?_c('div',[_c('ReviewInfo',{attrs:{"reviewInfo":_vm.mapUserIdReviews[candidateBlock.candidate.id]}})],1):_vm._e(),_vm._v(" "),_vm._m(1,true),_vm._v(" "),_c('ul',_vm._l((candidateBlock.blocks),function(block,blockIndex){return _c('li',{key:'block-' + index + '-' + blockIndex},[_vm._v("\n            From "+_vm._s(_vm.djangotimeformatAMPM(block.startTime))+" to\n            "+_vm._s(_vm.djangotimeformatAMPM(block.endTime))+"\n          ")])}),0),_vm._v(" "),(_vm.candidatesCanSetRate && _vm.candidate.rate)?_c('div',[_c('b',[_vm._v("Rate:")]),_vm._v(" $"+_vm._s(_vm.candidate.rate)+"/h\n        ")]):_vm._e(),_vm._v(" "),(candidateBlock.isExceed)?_c('p',{staticClass:"warning-text mt-1"},[_vm._v("\n          Warning: Exceed maximum number of daily jobs\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasUnselectCandidateBtn(candidateBlock.candidate))?_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.handleUnselectCandidates(candidateBlock.candidate)}}},[_vm._v("\n          Unselect\n        ")]):_vm._e(),_vm._v(" "),(_vm.hasSelectCandidateBtn(candidateBlock.candidate))?_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.handleSelectCandidate(candidateBlock.candidate)}}},[_vm._v("\n          Select\n        ")]):_vm._e()],1)})],2):_c('div',[_c('h4',[_vm._v("\n        "+_vm._s(_vm.textSelfSelectNobodyAvailable)+"\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('b',[_vm._v("Available time")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('b',[_vm._v("Available time")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CANDIDATE_DASHBOARD_STATS_SETTING = exports.EMPLOYER_DASHBOARD_STATS_SETTING = exports.EMPLOYER_DASHBOARD_SEARCH_BAR_SETTING = exports.CANDIDATE_DASHBOARD_SEARCH_BAR_SETTING = exports.EMPLOYER_STATUS_TO_HIDE_DASHBOARD_SETTING = exports.CANDIDATE_STATUS_TO_HIDE_DASHBOARD_SETTING = exports.CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS = exports.CANDIDATE_ADMIN_NOTES_SETTING = exports.EDITABLE_VIEW_CANDIDATE = exports.EDITABLE_VIEW_CLIENT = exports.CLIENT_ADMIN_NOTES_SETTING = exports.REFERENCE_TABLE_SETTINGS = exports.USER_SECOND_MANAGER_SETTING_OPTIONS = exports.USER_MANAGER_SETTING_OPTIONS = exports.CANDIDATE_ANALYTICS_DASHBOARD_SETTING_OPTIONS = exports.EMPLOYER_ANALYTICS_DASHBOARD_SETTING_OPTIONS = exports.CANDIDATE_CSV_EXPORT_SETTINGS_OPTIONS = exports.EMPLOYER_CSV_EXPORT_SETTINGS_OPTIONS = exports.EMPLOYER_TABLE_SETTINGS = exports.CANDIDATE_VIEWS_SETTING = exports.EMPLOYER_VIEWS_SETTING = exports.CANDIDATE_TABLE_SETTINGS = undefined;

var _customDefineType = __webpack_require__(6);

var _defaultValues = __webpack_require__(17);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var CANDIDATE_TABLE_SETTINGS = exports.CANDIDATE_TABLE_SETTINGS = [{
    key: "CANDIDATE_TABLE_FIELD",
    model: "candidate_table_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: _defaultValues.DEFAULT_TABLE_FIELDS_OPTIONS,
    hasAdminLevelSetting: true
}, {
    key: "CANDIDATE_TABLE_SEARCH_FIELD",
    model: "advance_setting.candidate_search_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: _defaultValues.DEFAULT_TABLE_FIELDS_OPTIONS
}, {
    key: "CANDIDATE_DEFAULT_SORT_FIELD",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    model: 'sort_candidates_by',
    optionList: [],
    optionLabel: "label",
    optionModel: "model"
}, {
    key: "CANDIDATE_LAST_LOGIN_RETRIEVAL_DAYS",
    isIntegerField: true,
    model: 'candidate_last_login_retrieval_days'
}, {
    key: "USER_STATUS_STATISTICAL_BREAKDOWN",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'show_user_status_stats'
}, {
    key: "CANDIDATE_EACH_STATUS_COLOR",
    type: _customDefineType.FORM_TYPE.STATUS_COLOR_INPUT,
    fieldLabel: "Status",
    optionListModel: 'candidate_statuses',
    hasInitElement: false,
    model: "candidate_table_status_color"
}, {
    key: "CANDIDATE_EACH_TYPE_COLOR",
    type: _customDefineType.FORM_TYPE.COLOR_INPUT,
    fieldLabel: "Type",
    optionListModel: 'candidate_types',
    hasInitElement: false,
    model: "advance_setting.candidate_table_types_color"
}, {
    key: "CANDIDATE_EACH_TAG_COLOR",
    type: _customDefineType.FORM_TYPE.COLOR_INPUT,
    fieldLabel: "Tag",
    optionListModel: 'candidate_tags',
    hasInitElement: false,
    model: "advance_setting.candidate_table_tags_color"
}, {
    key: "CANDIDATE_STATUS_TO_HIDE_DASHBOARD",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'candidate_statuses_to_hide',
    isMulti: true,
    searchable: true,
    closeOnSelect: true,
    optionListModel: 'candidate_statuses'
}, {
    key: "SHOW_CANDIDATE_DIALOG_IN_RIGHT_PANEL",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.show_candidate_dialog_in_right'
}];

var EMPLOYER_VIEWS_SETTING = exports.EMPLOYER_VIEWS_SETTING = [{
    key: 'EMPLOYER_ADMIN_SHARE_VIEWS',
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "advance_setting.employer_admin_share_views",
    default: false
}];

var CANDIDATE_VIEWS_SETTING = exports.CANDIDATE_VIEWS_SETTING = [{
    key: 'CANDIDATE_ADMIN_SHARE_VIEWS',
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "advance_setting.candidate_admin_share_views",
    default: false
}];

var EMPLOYER_TABLE_SETTINGS = exports.EMPLOYER_TABLE_SETTINGS = [{
    key: "EMPLOYER_TABLE_FIELD",
    model: "employer_table_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: _defaultValues.DEFAULT_TABLE_FIELDS_OPTIONS,
    hasAdminLevelSetting: true
}, {
    key: "EMPLOYER_TABLE_SEARCH_FIELD",
    model: "advance_setting.employer_search_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: _defaultValues.DEFAULT_TABLE_FIELDS_OPTIONS
}, {
    key: "EMPLOYER_DEFAULT_SORT_FIELD",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: false,
    model: 'sort_clients_by',
    optionList: [],
    optionLabel: "label",
    optionModel: "model"
}, {
    key: "EMPLOYER_LAST_LOGIN_RETRIEVAL_DAYS",
    isIntegerField: true,
    model: 'client_last_login_retrieval_days'
}, {
    key: "USER_STATUS_STATISTICAL_BREAKDOWN",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'show_user_status_stats'
}, {
    key: "EMPLOYER_EACH_STATUS_COLOR",
    type: _customDefineType.FORM_TYPE.STATUS_COLOR_INPUT,
    fieldLabel: "Status",
    optionListModel: 'employer_statuses',
    hasInitElement: false,
    model: "client_table_status_color"
}, {
    key: "EMPLOYER_EACH_TYPE_COLOR",
    type: _customDefineType.FORM_TYPE.COLOR_INPUT,
    fieldLabel: "Type",
    optionListModel: 'employer_types',
    hasInitElement: false,
    model: "advance_setting.client_table_types_color"

}, {
    key: "EMPLOYER_EACH_TAG_COLOR",
    type: _customDefineType.FORM_TYPE.COLOR_INPUT,
    fieldLabel: "Tag",
    optionListModel: 'employer_tags',
    hasInitElement: false,
    model: "advance_setting.client_table_tags_color"
}, {
    key: "EMPLOYER_STATUS_TO_HIDE_DASHBOARD",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'employer_statuses_to_hide',
    isMulti: true,
    searchable: true,
    closeOnSelect: true,
    optionListModel: 'employer_statuses'
}, {
    key: "SHOW_EMPLOYER_DIALOG_IN_RIGHT_PANEL",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.show_employer_dialog_in_right'
}];

var EMPLOYER_CSV_EXPORT_SETTINGS_OPTIONS = exports.EMPLOYER_CSV_EXPORT_SETTINGS_OPTIONS = [{
    key: "EMPLOYER_CSV_EXPORT_SETTINGS",
    model: "advance_setting.client_mailing_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: _defaultValues.DEFAULT_USER_EXPORT_OPTIONS,
    optionList: _defaultValues.USER_EXPORT_OPTIONS,
    predefinedOptionList: []
}, {
    key: "EXPORT_DURATION_STATUS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.export_employer_duration_status',
    isMulti: false,
    searchable: true,
    closeOnSelect: true,
    optionListModel: 'employer_statuses'
}];

var CANDIDATE_CSV_EXPORT_SETTINGS_OPTIONS = exports.CANDIDATE_CSV_EXPORT_SETTINGS_OPTIONS = [{
    key: "CANDIDATE_CSV_EXPORT_SETTINGS",
    model: "advance_setting.candidate_mailing_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    default: _defaultValues.DEFAULT_USER_EXPORT_OPTIONS,
    optionList: _defaultValues.USER_EXPORT_OPTIONS,
    predefinedOptionList: []
}, {
    key: "EXPORT_DURATION_STATUS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'advance_setting.export_candidate_duration_status',
    isMulti: false,
    searchable: true,
    closeOnSelect: true,
    optionListModel: 'candidate_statuses'
}];

var EMPLOYER_ANALYTICS_DASHBOARD_SETTING_OPTIONS = exports.EMPLOYER_ANALYTICS_DASHBOARD_SETTING_OPTIONS = [{
    key: "EMPLOYER_ANALYTICS_DASHBOARD_FIELDS",
    model: "advance_setting.client_analytics_dashboard_fields",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: _defaultValues.DEFAULT_ANALYTICS_DASHBOARD_SELECTION,
    optionListType: _customDefineType.OPTION_LIST_TYPES.EMPLOYER_LIST_FIELDS,
    onlySelectionField: true,
    predefinedOptionList: _defaultValues.ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS,
    optionLabel: "label",
    optionModel: "model"
}];

var CANDIDATE_ANALYTICS_DASHBOARD_SETTING_OPTIONS = exports.CANDIDATE_ANALYTICS_DASHBOARD_SETTING_OPTIONS = [{
    key: "CANDIDATE_ANALYTICS_DASHBOARD_FIELDS",
    model: "advance_setting.candidate_analytics_dashboard_fields",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: _defaultValues.DEFAULT_ANALYTICS_DASHBOARD_SELECTION,
    optionListType: _customDefineType.OPTION_LIST_TYPES.CANDIDATE_LIST_FIELDS,
    onlySelectionField: true,
    predefinedOptionList: _defaultValues.ANALYTICS_DASHBOARD_PREDEFINED_OPTIONS,
    optionLabel: "label",
    optionModel: "model"
}];

var USER_MANAGER_SETTING_OPTIONS = exports.USER_MANAGER_SETTING_OPTIONS = [{
    key: "LABEL_OF_ADMIN_MANAGER",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    model: 'public_advance_setting.admin_manager_label'
}, {
    key: "HAS_SECOND_ADMIN_MANAGER",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.has_second_admin_manager'
}];

var USER_SECOND_MANAGER_SETTING_OPTIONS = exports.USER_SECOND_MANAGER_SETTING_OPTIONS = [{
    key: "LABEL_OF_SECOND_ADMIN_MANAGER",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    model: 'public_advance_setting.second_admin_manager_label'
}];

var REFERENCE_TABLE_SETTINGS = exports.REFERENCE_TABLE_SETTINGS = [{
    key: "REFERENCE_TABLE_FIELD",
    model: "advance_setting.reference_table_fields",
    type: _customDefineType.FORM_TYPE.BUILDER_FIELD_SELECTOR,
    predefinedOptionList: [].concat(_toConsumableArray(_defaultValues.DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS)),
    hasAdminLevelSetting: true,
    default: _defaultValues.DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS
}];

var CLIENT_ADMIN_NOTES_SETTING = exports.CLIENT_ADMIN_NOTES_SETTING = [{
    key: "USE_ADMIN_NOTES_IN_INTAKE_NOTES",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.use_admin_notes_in_client_intake_note'
}];

var EDITABLE_VIEW_CLIENT = exports.EDITABLE_VIEW_CLIENT = [{
    key: "EDITABLE_VIEW_DEFAULT",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.set_editable_view_default_client'
}];

var EDITABLE_VIEW_CANDIDATE = exports.EDITABLE_VIEW_CANDIDATE = [{
    key: "EDITABLE_VIEW_DEFAULT",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.set_editable_view_default_candidate'
}];

var CANDIDATE_ADMIN_NOTES_SETTING = exports.CANDIDATE_ADMIN_NOTES_SETTING = [{
    key: "USE_ADMIN_NOTES_IN_INTERVIEW_NOTES",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.use_admin_notes_in_candidate_interview_note'
}];

var CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS = exports.CANDIDATE_TAGS_CANDIDATE_TABLE_SETTINGS = [{
    key: "CANDIDATE_TAGS_MATCHING_OPTIONS_SCHEDULER_VIEW",
    model: "advance_setting.candiate_tags_matching_options_candidate_table",
    type: _customDefineType.FORM_TYPE.RADIO,
    default: 'All Of',
    optionList: ['All Of', 'Any Of', 'None Of']
}];

var CANDIDATE_STATUS_TO_HIDE_DASHBOARD_SETTING = exports.CANDIDATE_STATUS_TO_HIDE_DASHBOARD_SETTING = [{
    key: "CANDIDATE_STATUS_TO_HIDE_DASHBOARD",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'candidate_statuses_to_hide',
    isMulti: true,
    searchable: true,
    closeOnSelect: true,
    optionListModel: 'candidate_statuses'
}];

var EMPLOYER_STATUS_TO_HIDE_DASHBOARD_SETTING = exports.EMPLOYER_STATUS_TO_HIDE_DASHBOARD_SETTING = [{
    key: "EMPLOYER_STATUS_TO_HIDE_DASHBOARD",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: 'employer_statuses_to_hide',
    isMulti: true,
    searchable: true,
    closeOnSelect: true,
    optionListModel: 'employer_statuses'
}];

var CANDIDATE_DASHBOARD_SEARCH_BAR_SETTING = exports.CANDIDATE_DASHBOARD_SEARCH_BAR_SETTING = [{
    key: "CANDIDATE_SEARCH_BAR_OPEN_BY_DEFAULT",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.candidate_search_bar_open_by_default'
}];

var EMPLOYER_DASHBOARD_SEARCH_BAR_SETTING = exports.EMPLOYER_DASHBOARD_SEARCH_BAR_SETTING = [{
    key: "EMPLOYER_SEARCH_BAR_OPEN_BY_DEFAULT",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.employer_search_bar_open_by_default'
}];

var EMPLOYER_DASHBOARD_STATS_SETTING = exports.EMPLOYER_DASHBOARD_STATS_SETTING = [{
    key: "STATUSES_INCLUDED_EMPLOYER_STATISTICS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    searchable: true,
    optionListModel: "employer_statuses",
    model: 'public_advance_setting.employer_statistic_status'
}];

var CANDIDATE_DASHBOARD_STATS_SETTING = exports.CANDIDATE_DASHBOARD_STATS_SETTING = [{
    key: "STATUSES_INCLUDED_CANDIDATE_STATISTICS",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    searchable: true,
    optionListModel: "candidate_statuses",
    model: 'public_advance_setting.candidate_statistic_status'
}];

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5 field-of-fields",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[_c('div',{staticClass:"d-flex"},[_c('h3',{staticClass:"dialog-title"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"submitClicked":_vm.submitClicked,"modelData":_vm.data,"listFields":_vm.listVisibleFields},on:{"updatedTime":function($event){return _vm.refreshData()},"updatedDate":function($event){return _vm.refreshData()},"updatedSelection":function($event){return _vm.handleUpdateSelection($event)},"clickMultiSelectBtn":function($event){return _vm.handleClickUserButton($event)},"clickTextboxBtn":function($event){return _vm.handleClickTextboxButton($event)}}},[(_vm.isInvalidBookingDuration)?_c('p',{staticClass:"warning-text",attrs:{"slot":"Warning Message"},slot:"Warning Message"},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys(
            "BOOKING_DIALOG.LABEL.INVALID_BOOKING_DURATION",
            _vm.shiftRequestMinimumHoursPerClient
          ))+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"Candidate Selection"},slot:"Candidate Selection"},[(_vm.hasFillerSelection)?_c('CandidateSelectionSection',{attrs:{"listAvailableCandidates":_vm.listAvailableCandidates,"listPartlyAvailableCandidates":_vm.listPartlyAvailableCandidates,"listFavoriteCandidateIds":_vm.listFavoriteCandidateIds,"numberOfBooking":_vm.numberOfBooking,"booking":_vm.data},on:{"selectIndividual":function($event){return _vm.handleClickSelectIndividualBooking()}},model:{value:(_vm.listSelectedCandidates),callback:function ($$v) {_vm.listSelectedCandidates=$$v},expression:"listSelectedCandidates"}}):_vm._e(),_vm._v(" "),(_vm.hasSelectInterestedCandidateSelection)?_c('CandidateSelectionSection',{attrs:{"listAvailableCandidates":_vm.listAvailableCandidates,"listPartlyAvailableCandidates":_vm.listPartlyAvailableCandidates,"listFavoriteCandidateIds":_vm.listFavoriteCandidateIds,"numberOfBooking":_vm.numberOfBooking,"booking":_vm.data,"isSelectInterestedCandidate":true},model:{value:(_vm.listInterestedCandidates),callback:function ($$v) {_vm.listInterestedCandidates=$$v},expression:"listInterestedCandidates"}}):_vm._e()],1)]),_vm._v(" "),_c('BookingPriceInfo',{ref:"priceInfo",attrs:{"job":_vm.data,"originalJob":_vm.passedData,"listPrices":_vm.listPricesUpsertBooking,"user":_vm.user,"categoryList":_vm.categoryList,"numberOfAllowedChildren":_vm.numberOfAllowedChildren,"selectedDate":_vm.startDate,"columnLayout":false,"numberOfBooking":_vm.numberOfBooking,"numberOfBookingUsingCredit":_vm.numberOfBookingUsingCredit,"listDateTimesOfJobs":_vm.listDateTimesOfJobs,"listBookingDates":_vm.listBookingDates,"isInApplicationForm":_vm.isInApplicationForm}}),_vm._v(" "),(_vm.chargeClientWhenBooking && _vm.$refs.priceInfo)?_c('h4',{staticClass:"mt-3 mb-0"},[_vm._v("\n      Total being charged: "+_vm._s(_vm.agencyCurrencySign)+_vm._s(_vm.includeCandidatePayment ? _vm.getTotalFee() : _vm.getAgencyFee())+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasPaymentField)?_c('StripePayment',{ref:"stripePayment",attrs:{"user":_vm.user,"isRequired":true,"id":"card-element2","label":"Please enter your payment information","submitClicked":_vm.submitClicked}}):_vm._e(),_vm._v(" "),(!_vm.hasPresetCandidateSelection)?_c('div',{staticClass:"p-0"},[(_vm.hasFillerSelection)?_c('CandidateSelectionSection',{attrs:{"listAvailableCandidates":_vm.listAvailableCandidates,"listPartlyAvailableCandidates":_vm.listPartlyAvailableCandidates,"listFavoriteCandidateIds":_vm.listFavoriteCandidateIds,"numberOfBooking":_vm.numberOfBooking,"booking":_vm.data},on:{"selectIndividual":function($event){return _vm.handleClickSelectIndividualBooking()}},model:{value:(_vm.listSelectedCandidates),callback:function ($$v) {_vm.listSelectedCandidates=$$v},expression:"listSelectedCandidates"}}):_vm._e(),_vm._v(" "),(_vm.hasSelectInterestedCandidateSelection)?_c('CandidateSelectionSection',{attrs:{"listAvailableCandidates":_vm.listAvailableCandidates,"listPartlyAvailableCandidates":_vm.listPartlyAvailableCandidates,"listFavoriteCandidateIds":_vm.listFavoriteCandidateIds,"numberOfBooking":_vm.numberOfBooking,"booking":_vm.data,"isSelectInterestedCandidate":true},model:{value:(_vm.listInterestedCandidates),callback:function ($$v) {_vm.listInterestedCandidates=$$v},expression:"listInterestedCandidates"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-containers"},[_c('div',{staticClass:"right-side-button"},[_c('button',{staticClass:"submit-button mylisting-button dark-button",attrs:{"data-index":"1"},on:{"click":function($event){return _vm.handleClickSaveButton()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys(_vm.isAdd ? "BUTTONS.SUBMIT" : "BUTTONS.SAVE"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"left-side-button"},[_c('div',{staticClass:"delete-btn-container"},[(!_vm.isAdd)?_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.showDeleteBookingConfirmDialog()}}},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("BUTTONS.DELETE"))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cancel-button-container"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.handleClickCloseButton()}}},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("BUTTONS.CLOSE"))+"\n          ")])])])]),_vm._v(" "),_c('SelectFillerDialog',{attrs:{"listDateTimesOfJobs":_vm.listDateTimesOfJobs,"bookingInfo":_vm.bookingDateTimeInfo,"listCandidates":_vm.listAvailableCandidatesAllBookings,"listRelatedAvailabilities":_vm.listRelatedAvailabilities,"weekAvailabilities":_vm.weekAvailabilities,"listRelatedJobs":_vm.listRelatedJobs,"listFavoriteCandidateIds":_vm.listFavoriteCandidateIds},on:{"selected":function($event){_vm.mapSelectedCandidates = $event}},model:{value:(_vm.isShowSelectFillerDialog),callback:function ($$v) {_vm.isShowSelectFillerDialog=$$v},expression:"isShowSelectFillerDialog"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportProblemButtons_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportProblemButtons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportProblemButtons_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportProblemButtons_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportProblemButtons_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebf1b2a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportProblemButtons_vue__ = __webpack_require__(582);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportProblemButtons_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebf1b2a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportProblemButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasReportProblemButtonCheck(_vm.job))?_c('button',{staticClass:"mylisting-button danger-button",staticStyle:{"margin-right":"1px"},on:{"click":function($event){return _vm.handleClickReportProblemButton(_vm.job)}}},[_vm._v("\n    "+_vm._s(_vm.clientReportProblemButtonText)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.hasReviewReportButtonCheck(_vm.job))?_c('button',{key:'BUTTONS.REVIEW_REPORT_BUTTON',staticClass:"mylisting-button dark-button",staticStyle:{"margin-right":"1px"},on:{"click":function($event){return _vm.showReviewReportsDialog(_vm.job)}}},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys('BUTTONS.REVIEW_REPORT_BUTTON'))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0b7361bc", content, true, {});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".checkbpx-input[data-v-9acb1b44]{margin-top:4px}.checkbox-label[data-v-9acb1b44]{text-align:left;cursor:pointer;margin-top:0}", ""]);

// exports


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group form-check mb-0",class:_vm.hasMarginTop ? 'mt-3' : ''},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],staticClass:"form-check-input checkbpx-input",attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id,"disabled":_vm.isDisabled},domProps:{"value":true,"checked":Array.isArray(_vm.inputVal)?_vm._i(_vm.inputVal,true)>-1:(_vm.inputVal)},on:{"change":[function($event){var $$a=_vm.inputVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inputVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inputVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inputVal=$$c}},function($event){return _vm.onChangeCheck($event.target.checked)}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label checkbox-label",attrs:{"for":_vm.id},domProps:{"innerHTML":_vm._s(_vm.displayLabel)}}),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b1f3f82a", content, true, {});

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".pagination-panel .pagination .page-item:not(.active) .page-link[data-v-7fed8aaa]{color:var(--coredarkcolor)}.pagination-panel .pagination .page-item.active .page-link[data-v-7fed8aaa]{background-color:var(--coredarkcolor);border-color:var(--coredarkcolor)}.pagination-panel[data-v-7fed8aaa]{display:flex;flex-wrap:wrap}.page-info-container[data-v-7fed8aaa]{display:flex;align-items:center;justify-content:end}.paging-container[data-v-7fed8aaa]{display:flex;align-items:center;flex-grow:1;justify-content:start}.top-row[data-v-7fed8aaa]{display:flex}.candidate-table .top-row[data-v-7fed8aaa],.client-table .top-row[data-v-7fed8aaa]{padding-top:10px}.item-per-page[data-v-7fed8aaa]{display:flex;align-items:center}.item-per-page-selection[data-v-7fed8aaa]{margin-left:.5em;margin-right:.5em}.pagination-lg .page-link[data-v-7fed8aaa]{font-size:16px;padding:8px 16px}.page-item[data-v-7fed8aaa]:not(.active){cursor:pointer}.cell-content[data-v-7fed8aaa]{white-space:pre-wrap}.break-all[data-v-7fed8aaa]{word-break:break-all}.change-icon[data-v-7fed8aaa]{color:#d1b515}.group-header[data-v-7fed8aaa]{text-align:left;background-color:var(--coredarkcolor);color:var(--corelightcolor)}.group-header>h4[data-v-7fed8aaa]{font-weight:700}.badge-group-header[data-v-7fed8aaa]{font-size:1.5em}.sort-button[data-v-7fed8aaa]{cursor:pointer}.table-sticky-header[data-v-7fed8aaa]{position:sticky;top:0;z-index:1}.multiselect--active[data-v-7fed8aaa]{z-index:3}.view-applicants-table .table td[data-v-7fed8aaa]{vertical-align:middle!important}.sum-info[data-v-7fed8aaa]{margin-left:.5em;font-size:.9em;font-weight:400}.in-used-builder .delete-icon[data-v-7fed8aaa],.redundant-builder .edit-form-icon[data-v-7fed8aaa],.redundant-builder>td[data-v-7fed8aaa]:not(.action-column){opacity:.3}", ""]);

// exports


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCell_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCell_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCell_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCell_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c43c28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCell_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31c43c28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCell_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c43c28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("36fb431e", content, true, {});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".cell-content[data-v-31c43c28]{white-space:pre-wrap}.break-all[data-v-31c43c28]{word-break:break-all}.picture-cell[data-v-31c43c28]{text-align:center}.profile-picture[data-v-31c43c28]{border-radius:50%;width:60px;height:60px;object-fit:cover}", ""]);

// exports


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-content"},[(_vm.field.model === 'LeftHeader')?_c('p',[_c('b',[(_vm.field.isHtml)?_c('span',{staticClass:"cell-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('span',{staticClass:"cell-content"},[_vm._v(_vm._s(_vm.content))])])]):(_vm.field.model === 'profile_pic')?_c('p',{staticClass:"picture-cell"},[(_vm.row[_vm.field.model])?_c('img',{staticClass:"profile-picture",attrs:{"src":_vm.convertToAbsolutePath(_vm.row[_vm.field.model])}}):_vm._e()]):(_vm.field.model === 'date' && _vm.isJobTable)?_c('p',[_vm._v("\n    "+_vm._s(_vm.jobDateString)+"\n  ")]):(_vm.field.model === 'birthday' && _vm.field.displayLabel == 'Age')?_c('p',[_vm._v("\n    "+_vm._s(_vm.getAge(_vm.row[_vm.field.model]))+"\n  ")]):(_vm.row[_vm.field.model] !== null && _vm.fieldUseCurrency && _vm.isJobTable)?_c('p',[_vm._v("\n    "+_vm._s(_vm.agencyCurrencySign)+_vm._s(_vm.row[_vm.field.model].toFixed(2))+"\n  ")]):(_vm.field.model === 'stripe_connect_id')?_c('p',[_vm._v("\n    "+_vm._s(_vm.row[_vm.field.model] ? "Yes" : "No")+"\n  ")]):(_vm.field.model === 'date' && _vm.isApplicantTable && _vm.row[_vm.field.model])?_c('p',[_vm._v("\n    "+_vm._s(new Date(_vm.row[_vm.field.model]).toDateString())+" at\n    "+_vm._s(new Date(_vm.row[_vm.field.model]).toLocaleTimeString())+"\n  ")]):((_vm.field.model === 'applicant_name' || _vm.field.model === 'applicant_name_status') && _vm.isApplicantTable)?_c('p',{staticClass:"d-flex align-items-center"},[(_vm.row['applicant_profile_pic'])?_c('img',{staticClass:"profile-picture mr-2",attrs:{"src":_vm.convertToAbsolutePath(_vm.row['applicant_profile_pic'])}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.row[_vm.field.model])+"\n    "),(_vm.row.is_from_marketplace)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('External Agency'),expression:"'External Agency'"}],staticClass:"material-icons manual-added pl-1 text-danger"},[_vm._v("\n      public\n    ")]):_vm._e(),_vm._v(" "),(_vm.row.manually_added)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Manually Added'),expression:"'Manually Added'"}],staticClass:"material-icons manual-added pl-1"},[_vm._v("\n      add_circle\n    ")]):_vm._e()]):(_vm.field.model === 'name' && _vm.isTemplateTable)?_c('span',[_vm._v("\n    "+_vm._s(_vm.row[_vm.field.model])+"\n    "),(_vm.row.deactivated)?_c('span',[_vm._v("(Deactivated)")]):_vm._e()]):(
      _vm.field.model === 'redirect_link' &&
      _vm.row[_vm.field.showIfModal] == _vm.field.showIfValue
    )?_c('p',[_c('a',{staticClass:"icon-button-table",attrs:{"href":("application-form/" + (_vm.row.agency) + "/" + (_vm.row.id)),"target":"blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v(" launch ")])])]):(_vm.field.model === 'type' && _vm.field.showSectionType)?_c('span',[_vm._v("\n    "+_vm._s(_vm.row[_vm.field.model])+"\n    "),(_vm.getSectionType(_vm.row.api))?_c('span',[_vm._v("("+_vm._s(_vm.getSectionType(_vm.row.api))+")")]):_vm._e()]):_c('p',[(_vm.field.isHtml && _vm.field.onClick)?_c('span',{staticClass:"cell-content",class:{ 'break-all': _vm.field.breakAll },domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":function($event){return _vm.field.onClick($event)}}}):(_vm.field.isHtml)?_c('span',{staticClass:"cell-content",class:{ 'break-all': _vm.field.breakAll },domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('span',{staticClass:"cell-content",class:{ 'break-all': _vm.field.breakAll }},[_vm._v(_vm._s(_vm.displayContent)+" ")]),_vm._v(" "),(_vm.noteModelOfField && _vm.row[_vm.noteModelOfField])?_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.showNote(_vm.row)}}},[_c('i',{staticClass:"material-icons mt-1 sticky-note-icon"},[_vm._v("\n        "+_vm._s(_vm.field.noteIcon || "sticky_note_2")+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.hasDiffWarning)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.field.diffCheckTooltip),expression:"field.diffCheckTooltip"}]},[_c('i',{staticClass:"material-icons mt-1 change-icon"},[_vm._v(" warning ")])]):_vm._e(),_vm._v(" "),(_vm.hasShowMoreLessButton && !_vm.isDisplayFull)?_c('span',{staticClass:"d-block",on:{"click":function($event){$event.stopPropagation();_vm.isDisplayFull = true}}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_double_arrow_down")])]):_vm._e(),_vm._v(" "),(_vm.hasShowMoreLessButton && _vm.isDisplayFull)?_c('span',{staticClass:"d-block",on:{"click":function($event){$event.stopPropagation();_vm.isDisplayFull = false}}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_double_arrow_up")])]):_vm._e()]),_vm._v(" "),(_vm.field.previewModel && _vm.row[_vm.field.previewModel])?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.getHtmlText(_vm.row[_vm.field.previewModel])),expression:"getHtmlText(row[field.previewModel])"}],staticClass:"material-icons manual-added pl-1"},[_vm._v("\n    preview\n  ")]):_vm._e(),_vm._v(" "),(_vm.transformNoteContent)?_c('p',{staticClass:"description"},[_c('span',[_vm._v(_vm._s(_vm.transformNoteContent))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCellBadge_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCellBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCellBadge_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCellBadge_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCellBadge_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71923207_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCellBadge_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71923207"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableCellBadge_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71923207_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableCellBadge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d00f8936", content, true, {});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.content.split(',')),function(item,itemIndex){return _c('span',{key:_vm.name + '-' + itemIndex},[_c('span',{staticClass:"badge badge-pill mx-1",style:({ backgroundColor: _vm.getColor(item, _vm.name) })},[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-table mt-2"},[(_vm.showPageCounter)?_c('div',{staticClass:"top-row align-items-center position-sticky"},[_c('div',{staticClass:"item-per-page"},[_c('span',[_vm._v(_vm._s(_vm.getLabelByKeys("DATA_TABLE.SHOW")))]),_vm._v(" "),_c('div',{staticClass:"item-per-page-selection"},[_c('multiselect',{attrs:{"options":[10, 20, 50, 100, 2500, 'All'],"multiple":false,"searchable":true,"close-on-select":true,"show-labels":false,"allow-empty":false,"placeholder":_vm.getLabelByKeys('PLACE_HOLDERS.NUMBER')},on:{"open":_vm.onMultiselectOpen,"close":_vm.onMultiselectClose,"input":function($event){_vm.currentPage = 1}},model:{value:(_vm.itemPerPage),callback:function ($$v) {_vm.itemPerPage=$$v},expression:"itemPerPage"}})],1),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.getLabelByKeys("DATA_TABLE.ITEMS_PER_PAGE")))])]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 pl-2"},[_vm._t("inside-top")],2),_vm._v(" "),_c('div',{staticClass:"page-info-container"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys(
            "DATA_TABLE.SHOWING_RANGE",
            _vm.startNumber,
            _vm.endNumber,
            _vm.listAllRows.length
          ))+"\n      ")])]),_vm._v(" "),_vm._t("inside-top-right")],2):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-striped mt-2 border"},[_c('thead',{class:{ 'table-sticky-header': _vm.hasStickyHeader },staticStyle:{"background-color":"var(--coredarkcolor)","color":"var(--corelightcolor)"}},[(_vm.categoryHeaders.length > 0)?_c('tr',{},[(_vm.LeftHeader2DTable)?_c('th',{staticClass:"table-header",attrs:{"scope":"col"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.categoryHeaders),function(category,index){return _c('th',{key:'categoryHeaders' + index,staticClass:"table-header",attrs:{"scope":"col","colspan":category.span}},[_vm._v("\n          "+_vm._s(category.displayLabel)+"\n        ")])})],2):_vm._e(),_vm._v(" "),_c('tr',{},[(_vm.showCheckbox)?_c('th',{staticClass:"table-header",attrs:{"scope":"col"}},[_c('div',{staticClass:"form-group form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSelectAll),expression:"isSelectAll"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isSelectAll)?_vm._i(_vm.isSelectAll,null)>-1:(_vm.isSelectAll)},on:{"change":[function($event){var $$a=_vm.isSelectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSelectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSelectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSelectAll=$$c}},function($event){return _vm.handleClickSelectAll($event.target.checked)}]}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.mergedHeaders),function(field,index){return _c('th',{key:'header' + index,staticClass:"table-header",attrs:{"scope":"col"}},[(field.hideSort)?_c('span',{staticClass:"max-content"},[_vm._v("\n            "+_vm._s(field.displayLabel_lang_English || field.displayLabel)+"\n            "),(_vm.hasSumHeader)?_c('span',{staticClass:"sum-info"},[_vm._v(_vm._s(_vm.getSum(field)))]):_vm._e()]):_c('span',{staticClass:"max-content"},[_vm._v("\n            "+_vm._s(field.displayLabel_lang_English || field.displayLabel)+"\n            "),(_vm.hasSumHeader)?_c('span',{staticClass:"sum-info"},[_vm._v(_vm._s(_vm.getSum(field)))]):_vm._e(),_vm._v(" "),(_vm.sortModel !== _vm.getSortModel(field))?_c('i',{staticClass:"material-icons sort-button",on:{"click":function($event){return _vm.handleSortColumn(field, 1)}}},[_vm._v("\n              unfold_more\n            ")]):_vm._e(),_vm._v(" "),(_vm.sortModel === _vm.getSortModel(field) && _vm.sortOrder === 1)?_c('i',{staticClass:"material-icons sort-button",on:{"click":function($event){return _vm.handleSortColumn(field, -1)}}},[_vm._v("\n              arrow_drop_up\n            ")]):_vm._e(),_vm._v(" "),(_vm.sortModel === _vm.getSortModel(field) && _vm.sortOrder === -1)?_c('i',{staticClass:"material-icons sort-button",on:{"click":function($event){return _vm.handleSortColumn(field, 1)}}},[_vm._v("\n              arrow_drop_down\n            ")]):_vm._e()])])}),_vm._v(" "),_vm._t("header")],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.displayData),function(row,rowIndex){return _c('tr',{key:'row-' + row.id + '-index-' + rowIndex,class:{
          newEntryRow: row.status == 'Applied',
          'redundant-builder': _vm.isRedundantBuilder(row),
          'in-used-builder': _vm.findUsingBuilder(row),
        },staticStyle:{"cursor":"pointer"},style:({ backgroundColor: _vm.getColor(row), color: _vm.getTextColor(row) })},[(row.isGroupHeader)?[_c('td',{staticClass:"group-header pt-4 pl-4",attrs:{"colspan":_vm.numberOfColumns + 3}},[(!row.header)?_c('h4',[_vm._v("Unspecify")]):(['types', 'tags'].includes(row.model))?_c('TableCellBadge',{staticClass:"badge-group-header",attrs:{"content":row.header,"name":row.model,"getColor":_vm.getColor}}):_c('h4',[_vm._v(_vm._s(row.header))])],1)]:[(_vm.showCheckbox)?_c('td',{on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"form-group form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedRows),expression:"checkedRows"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"value":row.id,"checked":Array.isArray(_vm.checkedRows)?_vm._i(_vm.checkedRows,row.id)>-1:(_vm.checkedRows)},on:{"change":function($event){var $$a=_vm.checkedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=row.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedRows=$$c}}}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.mergedHeaders),function(field,index){return _c('td',{key:'cell' + row.id + '-' + index,staticClass:"max-content",class:_vm.LeftHeader2DTable && index === 1 ? 'table-header' : '',on:{"click":function($event){return _vm.$emit('clickRow', row)}}},[(field.model === 'custom-actions-slot')?_vm._t("custom-actions",null,{"data":row}):(field.model === 'job-details-slot')?_vm._t("job-details",null,{"data":row}):(field.model === 'custom-column-slot')?_vm._t("custom-column",null,{"data":row}):(field.displayCheckMark)?_c('p',[(_vm.getCellContent(row, field))?_c('i',{staticClass:"material-icons"},[_vm._v("\n                check_circle\n              ")]):_vm._e()]):(field.model === 'poster_name' && _vm.isShowUserDialog)?_c('p',[(row[field.model])?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.showUserProfileDialog(row['poster_id'] || row.poster, false)}}},[_vm._v("\n                "+_vm._s(row[field.model])+"\n              ")]):_vm._e()]):(['types', 'tags'].includes(field.model))?_c('p',[_c('TableCellBadge',{attrs:{"content":_vm.getCellContent(row, field),"name":field.model,"getColor":_vm.getColor}})],1):(field.model === 'files')?_c('p',_vm._l((row[field.model]),function(field,index){return _c('a',{key:'header' + index,staticClass:"d-block",attrs:{"href":field,"target":"_blank"}},[_vm._v("\n                "+_vm._s(field.split("==/")[1])+"\n              ")])}),0):_c('TableCell',{attrs:{"field":field,"row":row,"listStatusColors":_vm.listStatusColors,"isJobTable":_vm.isJobTable,"isApplicantTable":_vm.isApplicantTable,"isTemplateTable":_vm.isTemplateTable,"content":_vm.getCellContent(row, field)}})],2)}),_vm._v(" "),_vm._t("actions",null,{"data":row})]],2)}),_vm._v(" "),_vm._t("footerRow",null,{"currentPage":_vm.currentPage,"totalPage":_vm.totalPage})],2)]),_vm._v(" "),(_vm.showPageCounter)?_c('div',{staticClass:"pagination-panel mb-3"},[_c('div',{staticClass:"paging-container"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys(
            "DATA_TABLE.SHOWING_RANGE",
            _vm.startNumber,
            _vm.endNumber,
            _vm.listAllRows.length
          ))+"\n      ")])]),_vm._v(" "),(_vm.itemPerPage !== 'All')?_c('ul',{staticClass:"pagination pagination-lg"},[(_vm.currentPage > 1)?_c('li',{staticClass:"page-item",on:{"click":function($event){return _vm.handleClickPrevious()}}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":_vm.getLabelByKeys('BUTTONS.PREVIOUS')}},[_c('span',[_vm._v(_vm._s(_vm.getLabelByKeys("BUTTONS.PREVIOUS")))])])]):_vm._e(),_vm._v(" "),(_vm.currentPage > 3 && _vm.currentPage === _vm.totalPage)?_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage - 3}}},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(_vm.currentPage - 3))])]):_vm._e(),_vm._v(" "),(_vm.currentPage > 2)?_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage - 2}}},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(_vm.currentPage - 2))])]):_vm._e(),_vm._v(" "),(_vm.currentPage > 1)?_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage - 1}}},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(_vm.currentPage - 1))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"page-item active"},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(_vm.currentPage))])]),_vm._v(" "),_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage + 1}}},[(_vm.currentPage < _vm.totalPage)?_c('a',{staticClass:"page-link"},[_vm._v("\n          "+_vm._s(_vm.currentPage + 1)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage + 2}}},[(_vm.currentPage < _vm.totalPage - 1)?_c('a',{staticClass:"page-link"},[_vm._v("\n          "+_vm._s(_vm.currentPage + 2)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage + 3}}},[(_vm.currentPage < _vm.totalPage - 2 && _vm.currentPage === 1)?_c('a',{staticClass:"page-link"},[_vm._v("\n          "+_vm._s(_vm.currentPage + 3)+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.currentPage < _vm.totalPage)?_c('li',{staticClass:"page-item",on:{"click":function($event){return _vm.handleClickNext()}}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":_vm.getLabelByKeys('BUTTONS.NEXT')}},[_c('span',[_vm._v(_vm._s(_vm.getLabelByKeys("BUTTONS.NEXT")))])])]):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e850df4a", content, true, {});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".theme-default .cv-header,.theme-default .cv-header-day{background-color:#f0f0f0}.theme-default .cv-header .periodLabel{font-size:1.5em}.theme-default .cv-header button{color:#7f7f7f}.theme-default .cv-header button:disabled{color:#ccc;background-color:#f7f7f7}.theme-default .cv-day.past{background-color:#fafafa}.theme-default .cv-day.outsideOfMonth{background-color:#f7f7f7}.theme-default .cv-day.today{background-color:#ffe}.theme-default .cv-event{border-color:#e0e0f0;border-radius:.5em;background-color:#e7e7ff;text-overflow:ellipsis}.theme-default .cv-event.purple{background-color:#f0e0ff;border-color:#e7d7f7}.theme-default .cv-event.orange{background-color:#ffe7d0;border-color:#f7e0c7}.theme-default .cv-event.continued:before,.theme-default .cv-event.toBeContinued:after{content:\" \\21E2   \";color:#999}.theme-default .cv-event.toBeContinued{border-right-style:none;border-top-right-radius:0;border-bottom-right-radius:0}.theme-default .cv-event.isHovered.hasUrl{text-decoration:underline}.theme-default .cv-event.continued{border-left-style:none;border-top-left-radius:0;border-bottom-left-radius:0}.theme-default .cv-event .endTime,.theme-default .cv-event .startTime{font-weight:700;color:#666}.theme-default .cv-day.draghover{box-shadow:inset 0 0 .2em .2em #ff0}", ""]);

// exports


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList,attrs:{"id":_vm.id}},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h3',{staticClass:"d-flex"},[_vm._v("\n      "+_vm._s(_vm.sectionTitle)+"\n    ")])]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0"}}),_vm._v(" "),(_vm.user && _vm.user.id)?_c('div',{staticClass:"one-line-description"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.DESCRIPTION.CLICK_ON_BOOKING"))+"\n    ")])]):_vm._e(),_vm._v(" "),(_vm.description && _vm.description !== '')?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.id)?_c('CheckboxItem',{attrs:{"label":"Toggle Table View","name":"table-view-shift-job"},model:{value:(_vm.isTableView),callback:function ($$v) {_vm.isTableView=$$v},expression:"isTableView"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row booking-calendar-container"},[(!_vm.isTableView)?_c('div',{staticClass:"col-lg-8 mb-5 mt-3"},[_c('div',{staticClass:"mb-2 calendar-btns"},[_c('button',{staticClass:"mylisting-button",class:{ 'dark-button': _vm.tab == 'week' },on:{"click":function($event){_vm.tab = 'week'}}},[_vm._v("\n          Week View\n        ")]),_vm._v(" "),_c('button',{staticClass:"mylisting-button",class:{ 'dark-button': _vm.tab == 'month' },on:{"click":function($event){_vm.tab = 'month'}}},[_vm._v("\n          Month View\n        ")])]),_vm._v(" "),_c('div',{staticClass:"calendar calendar-parent-container"},[(_vm.tab == 'month')?_c('calendar-view',{staticClass:"theme-default holiday-us-traditional holiday-us-official",staticStyle:{"min-height":"550px"},attrs:{"show-date":_vm.showDate,"event-content-height":"2.4em","events":_vm.listShowCalendarJobs},on:{"click-date":_vm.onClickDate,"click-event":_vm.onClickItem},scopedSlots:_vm._u([{key:"dayContent",fn:function(ref){
var day = ref.day;
return _c('div',{},[_c('div',{staticStyle:{"padding":"0.2em 0"}},[_vm._v(_vm._s(_vm.getNumberOfJob(day)))])])}},{key:"header",fn:function(t){return _c('calendar-view-header',{attrs:{"header-props":t.headerProps},on:{"input":_vm.setShowDate}})}}],null,false,1650293708)}):_vm._e(),_vm._v(" "),(_vm.tab == 'week')?_c('calendar-view',{staticClass:"theme-default holiday-us-traditional holiday-us-official",staticStyle:{"min-height":"550px"},attrs:{"show-date":_vm.showDate,"display-period-uom":"week","event-content-height":"5em","events":_vm.listShowCalendarJobs},on:{"click-date":_vm.onClickDate,"click-event":_vm.onClickItem},scopedSlots:_vm._u([{key:"dayContent",fn:function(ref){
var day = ref.day;
return _c('div',{},[_c('div',{staticStyle:{"padding":"0.2em 0"}},[_vm._v(_vm._s(_vm.getNumberOfJob(day)))])])}},{key:"header",fn:function(t){return _c('calendar-view-header',{attrs:{"header-props":t.headerProps},on:{"input":_vm.setShowDate}})}}],null,false,1650293708)}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.isTableView ? 'col-lg-12' : 'col-lg-4'},[_c('h4',{staticClass:"pt-3"},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.LABEL.BOOKINGS"))+"\n      ")]),_vm._v(" "),(_vm.bookingData && _vm.bookingData.length > 0)?_c('div',{staticClass:"hide-past-booking"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hidePastBooking),expression:"hidePastBooking"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"past-booking"},domProps:{"value":true,"checked":Array.isArray(_vm.hidePastBooking)?_vm._i(_vm.hidePastBooking,true)>-1:(_vm.hidePastBooking)},on:{"change":function($event){var $$a=_vm.hidePastBooking,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=true,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.hidePastBooking=$$a.concat([$$v]))}else{$$i>-1&&(_vm.hidePastBooking=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.hidePastBooking=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"past-booking"}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.LABEL.HIDE_PAST_BOOKINGS"))+"\n        ")]),_vm._v(" "),(!_vm.hidePastBooking)?_c('div',{staticClass:"past-booking-filter mt-1"},[_c('label',[_vm._v(" Number of days in the past to load past booking")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numberOfPastDays),expression:"numberOfPastDays"}],staticClass:"form-control",attrs:{"type":"Number"},domProps:{"value":(_vm.numberOfPastDays)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numberOfPastDays=$event.target.value}}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isTableView)?_c('div',{staticClass:"booking-detail-container"},[(_vm.minCount && _vm.bookingData.length < _vm.minCount && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys(
              _vm.minCount == 1? "BOOKING_SECTION.LABEL.MIN_BOOKING_REQUIRE" : "BOOKING_SECTION.LABEL.MIN_BOOKINGS_REQUIRE",
              _vm.minCount
            ))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.listShowBooking && _vm.listShowBooking.length)?_c('div',{staticClass:"row label-no-margin-top mb-2 field-of-fields"},[_c('div',{staticClass:"col"},[_c('datepicker',{attrs:{"placeholder":_vm.getLabelByKeys('PLACE_HOLDERS.FILTER_BY_START_DATE'),"clear-button":true,"bootstrap-styling":true},model:{value:(_vm.filterStart),callback:function ($$v) {_vm.filterStart=$$v},expression:"filterStart"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('datepicker',{attrs:{"placeholder":_vm.getLabelByKeys('PLACE_HOLDERS.FILTER_BY_END_DATE'),"clear-button":true,"bootstrap-styling":true},model:{value:(_vm.filterEnd),callback:function ($$v) {_vm.filterEnd=$$v},expression:"filterEnd"}})],1)]):_vm._e(),_vm._v(" "),_c('DataTable',{attrs:{"listHeaders":_vm.listTableFieldsBooking,"listData":_vm.listShowBookingTableView,"isCandidateTable":false,"showCheckbox":false,"sortInfo":{ model: 'date', order: 1 }},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('th',[_vm._v(_vm._s(_vm.getLabelByKeys("TABLE_HEADERS.ACTIONS")))])]},proxy:true},{key:"actions",fn:function(ref){
            var data = ref.data;
return [_c('td',{staticClass:"align-center"},[(
                  (data.status !== _vm.JOB_STATUSES.CANCELLED &&
                    !_vm.isPastBooking(data) &&
                    _vm.canEditBooking(data.status)) ||
                  _vm.isAgent
                )?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Edit'),expression:"'Edit'"}],staticClass:"icon-button-table",on:{"click":function($event){return _vm.handleClickEditBooking(data)}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" edit ")])]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Duplicate'),expression:"'Duplicate'"}],staticClass:"icon-button-table",on:{"click":function($event){return _vm.handleClickDuplicateBooking(data)}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" control_point_duplicate ")])]):_vm._e(),_vm._v(" "),_c('ReportProblemButtons',{attrs:{"job":data,"user":_vm.user}})],1)]}}],null,false,1025005952)})],1):_c('div',{staticClass:"booking-detail-container"},[(!_vm.bookingData.length)?_c('p',[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.DESCRIPTION.CLICK_ON_DATE"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.minCount && _vm.bookingData.length < _vm.minCount && _vm.submitClicked)?_c('p',{staticClass:"required-message"},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys(
              _vm.minCount == 1? "BOOKING_SECTION.LABEL.MIN_BOOKING_REQUIRE" : "BOOKING_SECTION.LABEL.MIN_BOOKINGS_REQUIRE",
              _vm.minCount
            ))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.listShowBookingCurrentPage),function(job,index){return _c('div',{key:'job' + index,staticClass:"booking-container"},[_c('div',{staticClass:"icon-containers"},[(job.isExpand)?_c('span',{staticClass:"expand-button",on:{"click":function($event){job.isExpand = false}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" arrow_drop_down ")])]):_c('span',{staticClass:"expand-button",on:{"click":function($event){return _vm.expandBooking(job)}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" arrow_right ")])])]),_vm._v(" "),_c('div',{staticClass:"px-3 py-2 mx-1 my-1 booking-detail",staticStyle:{"background-color":"var(--bootstrapgrey)"}},[(job.date)?_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("\n              "+_vm._s(_vm.getTitle(job))+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(job.isExpand),expression:"job.isExpand"}]},[(job.start_time && job.end_time)?_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("\n                "+_vm._s(_vm.convertTimeStringToStringAMPM(job.start_time))+" -\n                "+_vm._s(_vm.convertTimeStringToStringAMPM(job.end_time))+"\n              ")]):_vm._e(),_vm._v(" "),(job.status)?_c('p',{staticClass:"field-of-fields"},[_c('label',[_vm._v("Status:")]),_vm._v(" "+_vm._s(job.status)+"\n              ")]):_vm._e(),_vm._v(" "),_c('DetailSectionRowLayout',{attrs:{"modelData":job,"user":_vm.user,"labelKey":"labelDetail","listFields":_vm.listDisplayBookingFields,"listExcludeFields":['start_time', 'end_time', 'end_date']}}),_vm._v(" "),(job.filler)?_c('div',[_c('label',[_vm._v("\n                  "+_vm._s(_vm.getLabelByKeys(
                      "BOOKING_SECTION.LABEL.SELECTED_CANDIDATE"
                    ))+":\n                ")]),_vm._v("\n                "+_vm._s(_vm.getBookingFillerName(job))+"\n              ")]):_vm._e(),_vm._v(" "),_c('BookingPriceInfo',{ref:"priceInfo",refInFor:true,staticClass:"mt-2 price-info-container",attrs:{"job":job,"originalJob":job,"listPrices":_vm.priceList,"user":_vm.user,"categoryList":_vm.categoryList,"numberOfAllowedChildren":_vm.numberOfAllowedChildren,"numberOfBooking":_vm.api ? 1 : _vm.getListDateOfRepeatBooking(job).length,"listDateTimesOfJobs":_vm.getListDateTimeOfJobs(job),"viewOnly":true}}),_vm._v(" "),(!_vm.isViewOnly)?_c('p',{staticClass:"booking-buttons-container"},[(
                    (job.status !== _vm.JOB_STATUSES.CANCELLED &&
                      !_vm.isPastBooking(job) &&
                      _vm.canEditBooking(job.status)) ||
                    _vm.isAgent
                  )?_c('span',{staticClass:"booking-button",on:{"click":function($event){return _vm.handleClickEditBooking(job, index)}}},[_vm._v("\n                  "+_vm._s(_vm.getLabelByKeys("BUTTONS.EDIT"))+"\n                ")]):_vm._e(),_vm._v(" "),(
                    (job.status !== _vm.JOB_STATUSES.CANCELLED &&
                      !_vm.isPastBooking(job) &&
                      _vm.canEditBooking(job.status) &&
                      _vm.editAccess) ||
                    _vm.isAgent
                  )?_c('span',[_vm._v("\n                  |\n                ")]):_vm._e(),_vm._v(" "),(_vm.editAccess)?_c('span',{staticClass:"booking-button",on:{"click":function($event){return _vm.handleClickDuplicateBooking(job)}}},[_vm._v("\n                  "+_vm._s(_vm.getLabelByKeys("BUTTONS.DUPLICATE"))+"\n                ")]):_vm._e()]):_vm._e()],1)])])}),_vm._v(" "),(_vm.totalPage > 1)?_c('div',{staticClass:"text-center mt-2"},[_c('ul',{staticClass:"pagination justify-content-center"},[(_vm.currentPage > 1)?_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage - 1}}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.currentPage < _vm.totalPage)?_c('li',{staticClass:"page-item",on:{"click":function($event){_vm.currentPage = _vm.currentPage + 1}}},[_vm._m(1)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.calculateTotalBookingFee() && !_vm.auth)?_c('div',[_c('label',{staticClass:"mt-2"},[_vm._v("\n            "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.LABEL.TOTAL_BOOKING_FEE"))+":\n          ")]),_vm._v("\n          $"+_vm._s(_vm._f("twoDecimals")(_vm.calculateTotalBookingFee()))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.bookingData.length)?_c('small',{staticClass:"mt-3"},[_c('div',{staticClass:"d-inline",domProps:{"innerHTML":_vm._s(_vm.disclaimerText)}})]):_vm._e()],2),_vm._v(" "),(!_vm.isTableView && _vm.bookingData.length && !_vm.isViewOnly)?_c('p',{staticClass:"mt-3 mb-3"},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.DESCRIPTION.CLICK_ON_OTHER_DATE"))+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly)?_c('button',{staticClass:"mylisting-button dark-button add-booking",on:{"click":function($event){return _vm.clickAddBooking()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.ADD_A_BOOKING"))+"\n      ")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.acceptJobsByGroup)?_c('div',[_c('h4',[_vm._v(_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.LABEL.BOOKING_GROUPS")))]),_vm._v(" "),_c('small',[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BOOKING_SECTION.DESCRIPTION.BOOKING_GROUP"))+"\n        ")]),_vm._v(" "),_c('div',_vm._l((_vm.mapBookingGroup),function(jobs,group_id){return _c('div',{key:'group' + group_id},[_c('div',{staticClass:"booking-group"},[_c('div',{staticClass:"booking-group-info"},_vm._l((jobs),function(job){return _c('div',{key:'job-in-group-' + group_id + '-' + job.id,staticClass:"mt-2"},[_c('div',[_vm._v(_vm._s(_vm.getTitle(job)))]),_vm._v(" "),_c('small',[_vm._v("\n                    "+_vm._s(_vm.convertTimeStringToStringAMPM(job.start_time))+" -\n                    "+_vm._s(_vm.convertTimeStringToStringAMPM(job.end_time))+"\n                  ")])])}),0),_vm._v(" "),(!_vm.isViewOnly)?_c('span',{staticClass:"delete-group delete-icon",on:{"click":function($event){return _vm.showDeleteGroupConfirm(group_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" delete ")])]):_vm._e()]),_vm._v(" "),_c('hr')])}),0),_vm._v(" "),(!_vm.isViewOnly)?_c('button',{staticClass:"mylisting-button dark-button add-booking",on:{"click":function($event){return _vm.showAddGroupDialog()}}},[_vm._v("\n          "+_vm._s(_vm.getLabelByKeys("BUTTONS.ADD_A_GROUP"))+"\n        ")]):_vm._e(),_vm._v(" "),_c('hr')]):_vm._e()])]),_vm._v(" "),_c('UpdateBookingDialog',{ref:"updateBookingDialog",attrs:{"name":"Booking","header":"Booking","listFields":_vm.listUpSertBookingFields,"title":_vm.dialogTitle,"keyTitles":_vm.keyTitles,"passedData":_vm.booking,"selectedDate":_vm.dateInDjangoFormat(_vm.selectedDate),"isAdd":_vm.isAddBookingDialog,"showCancel":!!_vm.api,"user":_vm.user,"passedCreditCount":_vm.creditCount,"bookingRequirePaymentInfo":_vm.bookingRequirePaymentInfo,"listPrices":_vm.priceList,"listPriceServices":_vm.listPriceServices,"categoryList":_vm.categoryList,"candidateList":_vm.candidateList,"numberOfAllowedChildren":_vm.numberOfAllowedChildren,"chargeClientWhenBooking":_vm.chargeClientWhenBooking,"chargeClientWhenAssign":_vm.chargeClientWhenAssign,"includeCandidatePayment":_vm.includeCandidatePayment,"employerTypesNotCharge":_vm.employerTypesNotCharge,"listBookings":_vm.bookingData,"cancellationPolicy":_vm.cancellationPolicy,"passedBookingField":_vm.bookingField,"isInApplicationForm":_vm.isInApplicationForm,"profileBuilderID":_vm.profileBuilderID,"isFixedPoster":true},on:{"saved":function($event){return _vm.handleUpdateObjects($event)},"reloadUser":function($event){return _vm.$emit('reloadUser')}},model:{value:(_vm.isShowBookingDialog),callback:function ($$v) {_vm.isShowBookingDialog=$$v},expression:"isShowBookingDialog"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"page-link nav-button"},[_c('i',{staticClass:"material-icons"},[_vm._v("skip_previous")]),_vm._v("Previous\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"page-link nav-button"},[_vm._v("\n                Next"),_c('i',{staticClass:"material-icons"},[_vm._v("skip_next")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format__ = __webpack_require__(601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(602);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__parse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(135);
/* unused harmony reexport isDate */
/* unused harmony reexport toDate */
/* unused harmony reexport isValidDate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["a"]; });




/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en__ = __webpack_require__(226);


var REGEX_FORMAT = /\[([^\]]+)]|YYYY|YY?|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|Z{1,2}|S{1,3}|w{1,2}|x|X|a|A/g;

function pad(val) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var output = "".concat(Math.abs(val));
  var sign = val < 0 ? '-' : '';

  while (output.length < len) {
    output = "0".concat(output);
  }

  return sign + output;
}

function getOffset(date) {
  return Math.round(date.getTimezoneOffset() / 15) * 15;
}

function formatTimezone(offset) {
  var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + pad(hours, 2) + delimeter + pad(minutes, 2);
}

var meridiem = function meridiem(h, _, isLowercase) {
  var word = h < 12 ? 'AM' : 'PM';
  return isLowercase ? word.toLocaleLowerCase() : word;
};

var formatFlags = {
  Y: function Y(date) {
    var y = date.getFullYear();
    return y <= 9999 ? "".concat(y) : "+".concat(y);
  },
  // Year: 00, 01, ..., 99
  YY: function YY(date) {
    return pad(date.getFullYear(), 4).substr(2);
  },
  // Year: 1900, 1901, ..., 2099
  YYYY: function YYYY(date) {
    return pad(date.getFullYear(), 4);
  },
  // Month: 1, 2, ..., 12
  M: function M(date) {
    return date.getMonth() + 1;
  },
  // Month: 01, 02, ..., 12
  MM: function MM(date) {
    return pad(date.getMonth() + 1, 2);
  },
  MMM: function MMM(date, locale) {
    return locale.monthsShort[date.getMonth()];
  },
  MMMM: function MMMM(date, locale) {
    return locale.months[date.getMonth()];
  },
  // Day of month: 1, 2, ..., 31
  D: function D(date) {
    return date.getDate();
  },
  // Day of month: 01, 02, ..., 31
  DD: function DD(date) {
    return pad(date.getDate(), 2);
  },
  // Hour: 0, 1, ... 23
  H: function H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH: function HH(date) {
    return pad(date.getHours(), 2);
  },
  // Hour: 1, 2, ..., 12
  h: function h(date) {
    var hours = date.getHours();

    if (hours === 0) {
      return 12;
    }

    if (hours > 12) {
      return hours % 12;
    }

    return hours;
  },
  // Hour: 01, 02, ..., 12
  hh: function hh() {
    var hours = formatFlags.h.apply(formatFlags, arguments);
    return pad(hours, 2);
  },
  // Minute: 0, 1, ..., 59
  m: function m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm: function mm(date) {
    return pad(date.getMinutes(), 2);
  },
  // Second: 0, 1, ..., 59
  s: function s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss: function ss(date) {
    return pad(date.getSeconds(), 2);
  },
  // 1/10 of second: 0, 1, ..., 9
  S: function S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS: function SS(date) {
    return pad(Math.floor(date.getMilliseconds() / 10), 2);
  },
  // Millisecond: 000, 001, ..., 999
  SSS: function SSS(date) {
    return pad(date.getMilliseconds(), 3);
  },
  // Day of week: 0, 1, ..., 6
  d: function d(date) {
    return date.getDay();
  },
  // Day of week: 'Su', 'Mo', ..., 'Sa'
  dd: function dd(date, locale) {
    return locale.weekdaysMin[date.getDay()];
  },
  // Day of week: 'Sun', 'Mon',..., 'Sat'
  ddd: function ddd(date, locale) {
    return locale.weekdaysShort[date.getDay()];
  },
  // Day of week: 'Sunday', 'Monday', ...,'Saturday'
  dddd: function dddd(date, locale) {
    return locale.weekdays[date.getDay()];
  },
  // AM, PM
  A: function A(date, locale) {
    var meridiemFunc = locale.meridiem || meridiem;
    return meridiemFunc(date.getHours(), date.getMinutes(), false);
  },
  // am, pm
  a: function a(date, locale) {
    var meridiemFunc = locale.meridiem || meridiem;
    return meridiemFunc(date.getHours(), date.getMinutes(), true);
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z: function Z(date) {
    return formatTimezone(getOffset(date), ':');
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ: function ZZ(date) {
    return formatTimezone(getOffset(date));
  },
  // Seconds timestamp: 512969520
  X: function X(date) {
    return Math.floor(date.getTime() / 1000);
  },
  // Milliseconds timestamp: 512969520900
  x: function x(date) {
    return date.getTime();
  },
  w: function w(date, locale) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* getWeek */])(date, {
      firstDayOfWeek: locale.firstDayOfWeek,
      firstWeekContainsDate: locale.firstWeekContainsDate
    });
  },
  ww: function ww(date, locale) {
    return pad(formatFlags.w(date, locale), 2);
  }
};
function format(val, str) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var formatStr = str ? String(str) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* toDate */])(val);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* isValidDate */])(date)) {
    return 'Invalid Date';
  }

  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en__["a" /* default */];
  return formatStr.replace(REGEX_FORMAT, function (match, p1) {
    if (p1) {
      return p1;
    }

    if (typeof formatFlags[match] === 'function') {
      return "".concat(formatFlags[match](date, locale));
    }

    return match;
  });
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(135);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var formattingTokens = /(\[[^\[]*\])|(MM?M?M?|Do|DD?|ddd?d?|w[o|w]?|YYYY|YY|a|A|hh?|HH?|mm?|ss?|S{1,3}|x|X|ZZ?|.)/g;
var match1 = /\d/; // 0 - 9

var match2 = /\d\d/; // 00 - 99

var match3 = /\d{3}/; // 000 - 999

var match4 = /\d{4}/; // 0000 - 9999

var match1to2 = /\d\d?/; // 0 - 99

var matchShortOffset = /[+-]\d\d:?\d\d/; // +00:00 -00:00 +0000 or -0000

var matchSigned = /[+-]?\d+/; // -inf - inf

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
// const matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i; // Word

var YEAR = 'year';
var MONTH = 'month';
var DAY = 'day';
var HOUR = 'hour';
var MINUTE = 'minute';
var SECOND = 'second';
var MILLISECOND = 'millisecond';
var parseFlags = {};

var addParseFlag = function addParseFlag(token, regex, callback) {
  var tokens = Array.isArray(token) ? token : [token];
  var func;

  if (typeof callback === 'string') {
    func = function func(input) {
      var value = parseInt(input, 10);
      return _defineProperty({}, callback, value);
    };
  } else {
    func = callback;
  }

  tokens.forEach(function (key) {
    parseFlags[key] = [regex, func];
  });
};

var escapeStringRegExp = function escapeStringRegExp(str) {
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

var matchWordRegExp = function matchWordRegExp(localeKey) {
  return function (locale) {
    var array = locale[localeKey];

    if (!Array.isArray(array)) {
      throw new Error("Locale[".concat(localeKey, "] need an array"));
    }

    return new RegExp(array.map(escapeStringRegExp).join('|'));
  };
};

var matchWordCallback = function matchWordCallback(localeKey, key) {
  return function (input, locale) {
    var array = locale[localeKey];

    if (!Array.isArray(array)) {
      throw new Error("Locale[".concat(localeKey, "] need an array"));
    }

    var index = array.indexOf(input);

    if (index < 0) {
      throw new Error('Invalid Word');
    }

    return _defineProperty({}, key, index);
  };
};

addParseFlag('Y', matchSigned, YEAR);
addParseFlag('YY', match2, function (input) {
  var year = new Date().getFullYear();
  var cent = Math.floor(year / 100);
  var value = parseInt(input, 10);
  value = (value > 68 ? cent - 1 : cent) * 100 + value;
  return _defineProperty({}, YEAR, value);
});
addParseFlag('YYYY', match4, YEAR);
addParseFlag('M', match1to2, function (input) {
  return _defineProperty({}, MONTH, parseInt(input, 10) - 1);
});
addParseFlag('MM', match2, function (input) {
  return _defineProperty({}, MONTH, parseInt(input, 10) - 1);
});
addParseFlag('MMM', matchWordRegExp('monthsShort'), matchWordCallback('monthsShort', MONTH));
addParseFlag('MMMM', matchWordRegExp('months'), matchWordCallback('months', MONTH));
addParseFlag('D', match1to2, DAY);
addParseFlag('DD', match2, DAY);
addParseFlag(['H', 'h'], match1to2, HOUR);
addParseFlag(['HH', 'hh'], match2, HOUR);
addParseFlag('m', match1to2, MINUTE);
addParseFlag('mm', match2, MINUTE);
addParseFlag('s', match1to2, SECOND);
addParseFlag('ss', match2, SECOND);
addParseFlag('S', match1, function (input) {
  return _defineProperty({}, MILLISECOND, parseInt(input, 10) * 100);
});
addParseFlag('SS', match2, function (input) {
  return _defineProperty({}, MILLISECOND, parseInt(input, 10) * 10);
});
addParseFlag('SSS', match3, MILLISECOND);

function matchMeridiem(locale) {
  return locale.meridiemParse || /[ap]\.?m?\.?/i;
}

function defaultIsPM(input) {
  return "".concat(input).toLowerCase().charAt(0) === 'p';
}

addParseFlag(['A', 'a'], matchMeridiem, function (input, locale) {
  var isPM = typeof locale.isPM === 'function' ? locale.isPM(input) : defaultIsPM(input);
  return {
    isPM: isPM
  };
});

function offsetFromString(str) {
  var _ref8 = str.match(/([+-]|\d\d)/g) || ['-', '0', '0'],
      _ref9 = _slicedToArray(_ref8, 3),
      symbol = _ref9[0],
      hour = _ref9[1],
      minute = _ref9[2];

  var minutes = parseInt(hour, 10) * 60 + parseInt(minute, 10);

  if (minutes === 0) {
    return 0;
  }

  return symbol === '+' ? -minutes : +minutes;
}

addParseFlag(['Z', 'ZZ'], matchShortOffset, function (input) {
  return {
    offset: offsetFromString(input)
  };
});
addParseFlag('x', matchSigned, function (input) {
  return {
    date: new Date(parseInt(input, 10))
  };
});
addParseFlag('X', matchTimestamp, function (input) {
  return {
    date: new Date(parseFloat(input) * 1000)
  };
});
addParseFlag('d', match1, 'weekday');
addParseFlag('dd', matchWordRegExp('weekdaysMin'), matchWordCallback('weekdaysMin', 'weekday'));
addParseFlag('ddd', matchWordRegExp('weekdaysShort'), matchWordCallback('weekdaysShort', 'weekday'));
addParseFlag('dddd', matchWordRegExp('weekdays'), matchWordCallback('weekdays', 'weekday'));
addParseFlag('w', match1to2, 'week');
addParseFlag('ww', match2, 'week');

function to24hour(hour, isPM) {
  if (hour !== undefined && isPM !== undefined) {
    if (isPM) {
      if (hour < 12) {
        return hour + 12;
      }
    } else if (hour === 12) {
      return 0;
    }
  }

  return hour;
}

function getFullInputArray(input) {
  var backupDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var result = [0, 0, 1, 0, 0, 0, 0];
  var backupArr = [backupDate.getFullYear(), backupDate.getMonth(), backupDate.getDate(), backupDate.getHours(), backupDate.getMinutes(), backupDate.getSeconds(), backupDate.getMilliseconds()];
  var useBackup = true;

  for (var i = 0; i < 7; i++) {
    if (input[i] === undefined) {
      result[i] = useBackup ? backupArr[i] : result[i];
    } else {
      result[i] = input[i];
      useBackup = false;
    }
  }

  return result;
}

function createDate(y, m, d, h, M, s, ms) {
  var date;

  if (y < 100 && y >= 0) {
    date = new Date(y + 400, m, d, h, M, s, ms);

    if (isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
  } else {
    date = new Date(y, m, d, h, M, s, ms);
  }

  return date;
}

function createUTCDate() {
  var date;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var y = args[0];

  if (y < 100 && y >= 0) {
    args[0] += 400;
    date = new Date(Date.UTC.apply(Date, args)); // eslint-disable-next-line no-restricted-globals

    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
  } else {
    date = new Date(Date.UTC.apply(Date, args));
  }

  return date;
}

function makeParser(dateString, format, locale) {
  var tokens = format.match(formattingTokens);

  if (!tokens) {
    throw new Error();
  }

  var length = tokens.length;
  var mark = {};

  for (var i = 0; i < length; i += 1) {
    var token = tokens[i];
    var parseTo = parseFlags[token];

    if (!parseTo) {
      var word = token.replace(/^\[|\]$/g, '');

      if (dateString.indexOf(word) === 0) {
        dateString = dateString.substr(word.length);
      } else {
        throw new Error('not match');
      }
    } else {
      var regex = typeof parseTo[0] === 'function' ? parseTo[0](locale) : parseTo[0];
      var parser = parseTo[1];
      var value = (regex.exec(dateString) || [])[0];
      var obj = parser(value, locale);
      mark = _objectSpread({}, mark, {}, obj);
      dateString = dateString.replace(value, '');
    }
  }

  return mark;
}

function parse(str, format) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  try {
    var _options$locale = options.locale,
        _locale = _options$locale === void 0 ? __WEBPACK_IMPORTED_MODULE_0__locale_en__["a" /* default */] : _options$locale,
        _options$backupDate = options.backupDate,
        backupDate = _options$backupDate === void 0 ? new Date() : _options$backupDate;

    var parseResult = makeParser(str, format, _locale);
    var year = parseResult.year,
        month = parseResult.month,
        day = parseResult.day,
        hour = parseResult.hour,
        minute = parseResult.minute,
        second = parseResult.second,
        millisecond = parseResult.millisecond,
        isPM = parseResult.isPM,
        date = parseResult.date,
        offset = parseResult.offset,
        weekday = parseResult.weekday,
        week = parseResult.week;

    if (date) {
      return date;
    }

    var inputArray = [year, month, day, hour, minute, second, millisecond];
    inputArray[3] = to24hour(inputArray[3], isPM); // check week

    if (week !== undefined && month === undefined && day === undefined) {
      // new Date(year, 3) make sure in current year
      var firstDate = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* startOfWeekYear */])(year === undefined ? backupDate : new Date(year, 3), {
        firstDayOfWeek: _locale.firstDayOfWeek,
        firstWeekContainsDate: _locale.firstWeekContainsDate
      });
      return new Date(firstDate.getTime() + (week - 1) * 7 * 24 * 3600 * 1000);
    }

    var parsedDate;
    var result = getFullInputArray(inputArray, backupDate);

    if (offset !== undefined) {
      result[6] += offset * 60 * 1000;
      parsedDate = createUTCDate.apply(void 0, _toConsumableArray(result));
    } else {
      parsedDate = createDate.apply(void 0, _toConsumableArray(result));
    } // check weekday


    if (weekday !== undefined && parsedDate.getDay() !== weekday) {
      return new Date(NaN);
    }

    return parsedDate;
  } catch (e) {
    return new Date(NaN);
  }
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1d83316b", content, true, {});

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".hidden-normal{display:none}@media print{.no-pagebreak{break-inside:avoid-page}.no-print,.no-print *{display:none}.hidden-normal{display:inline}}", ""]);

// exports


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonClass + ' d-print-none',style:(_vm.buttonStyle),on:{"click":function($event){return _vm.$emit('buttonInput')}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.urlLink}},[_c('button',{class:_vm.buttonClass + ' hidden-normal',style:(_vm.buttonStyle)},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(607);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("037b9184", content, true, {});

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".check-icon[data-v-65e443d3]{font-size:14px;margin-left:5px;color:green}@media (max-width:480px){.btn-desktop-visible[data-v-65e443d3]{display:none}}@media (min-width:481px){.btn-mobile-visible[data-v-65e443d3]{display:none}}.document-section[data-v-65e443d3]{border:1px solid var(--bootstrapgrey);border-radius:3px;position:relative}.required-section[data-v-65e443d3]{border:1px solid red}.required-star[data-v-65e443d3]{color:red}.view-button[data-v-65e443d3]{color:#fff}.uploaded-button-container[data-v-65e443d3]{margin-top:-4px}.view-button-container[data-v-65e443d3]{display:inline-block;margin-top:4px}.delete-doc-button[data-v-65e443d3]{margin-top:13px}.view-file-button[data-v-65e443d3],.view-info-button[data-v-65e443d3]{width:12em;margin-top:1em}.expiration-info[data-v-65e443d3]{margin-top:-.5rem;margin-bottom:.8rem}.expiration-info>span[data-v-65e443d3]{color:var(--coredarkercolor);border-radius:.4rem;padding:.3rem}.expiration-info.expired>span[data-v-65e443d3]{border:1px solid red;color:red}.uploaded-time[data-v-65e443d3]{font-size:.8em;margin-top:-.3em;margin-bottom:.5em}.download-blank-template[data-v-65e443d3]{top:0;right:0;cursor:pointer;position:absolute}.download-blank-template.second-btn[data-v-65e443d3]{right:22px}.background-check-section .background-check[data-v-65e443d3]{border:1px solid var(--bootstrapgrey);border-radius:3px;width:fit-content;padding:1rem 2rem;text-align:center}.background-check-section .background-check .image[data-v-65e443d3]{width:200px}.background-check-section .background-check .image img[data-v-65e443d3]{width:100%}.background-check-modal-text[data-v-65e443d3]{font-size:1.5rem}.background-modal-buttons[data-v-65e443d3]{display:flex;justify-content:space-between}.powered-text[data-v-65e443d3]{font-size:12px}@media print{.no-pagebreak[data-v-65e443d3]{break-inside:avoid}}.expired-info[data-v-65e443d3]{font-weight:700;color:red}", ""]);

// exports


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload-container",class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v("\n    "+_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isFileSubmitted)?_c('span',[_c('i',{staticClass:"material-icons check-icon"},[_vm._v(" check_circle ")])]):(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.blankFileUrl)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Download Blank Template'),expression:"'Download Blank Template'"}],staticClass:"download-blank-template",attrs:{"href":_vm.blankFileUrl,"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v(" download ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),(_vm.isImage)?_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.uploadFileId,"accept":"image/x-png,image/jpeg","disabled":_vm.isDisabled},on:{"change":_vm.onChange}}):(_vm.isDoc)?_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.uploadFileId,"accept":".pdf,.doc,.docx","disabled":_vm.isDisabled},on:{"change":_vm.onChange}}):_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.uploadFileId,"disabled":_vm.isDisabled},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"center py-4 px-3",class:{
      'document-section': !_vm.hideBorder,
      'required-section': _vm.isRequired && _vm.submitClicked && !_vm.isFileSubmitted,
    }},[_c('div',{staticClass:"download-blank-template"},[(_vm.blankFileUrl)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Download Blank Template'),expression:"'Download Blank Template'"}],attrs:{"href":_vm.blankFileUrl,"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v(" download ")])]):_vm._e(),_vm._v(" "),(_vm.isFileSubmitted)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Open in New Tab'),expression:"'Open in New Tab'"}],attrs:{"href":_vm.convertToAbsolutePath(_vm.inputVal),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v(" launch ")])]):_vm._e()]),_vm._v(" "),(_vm.isFileSubmitted)?_c('div',{staticClass:"uploaded-button-container"},[_c('PDFButton',{attrs:{"buttonClass":"mylisting-button dark-button view-button","urlLink":_vm.convertToAbsolutePath(_vm.inputVal),"buttonText":"View"},on:{"buttonInput":function($event){_vm.showFilePreviewDialog({
            url: _vm.convertToAbsolutePath(_vm.inputVal),
          })}}}),_vm._v(" "),_c('p',{staticClass:"delete-text delete-doc-button",on:{"click":function($event){return _vm.showDeleteDocumentConfirmDialog()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.DELETE"))+"\n      ")])],1):_c('div',[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.$refs.file.click()}}},[_vm._v("\n        "+_vm._s(_vm.uploadLabel || "Upload")+"\n      ")])])]),_vm._v(" "),(_vm.selectFile != null && _vm.selectFile.name != null)?_c('div',{staticClass:"result-section"},[_c('span',{staticClass:"file-label"},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys("FILE_UPLOAD.FILE"))+":\n    ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectFile.name))])]):_vm._e(),_vm._v(" "),(!_vm.isFileSubmitted && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e(),_vm._v(" "),(
      _vm.selectFile != null && _vm.selectFile.size > _vm.maxSizeInByte && _vm.submitClicked
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("FILE_UPLOAD.FILE_EXCEED_MAXIMUM", _vm.maxSize))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.remark)?_c('div',{staticClass:"remark",domProps:{"innerHTML":_vm._s(_vm.remark)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 field-of-fields p-2",class:{ 'application-form-container': !_vm.isEmbed },staticStyle:{"max-width":"100%"},style:(_vm.applicationFormColors),attrs:{"id":_vm.hasFontColor ? 'application-form-font-color' : ''}},[_c('div',{staticClass:"agency-logo-container"},[_c('img',{style:({ maxHeight: _vm.agencyLogoHeightInPx }),attrs:{"src":_vm.customizeLogo || _vm.$store.getters.agencyPublic.logo}})]),_vm._v(" "),(_vm.isBookingOnly && _vm.registeredUserId)?_c('div',[_c('h2',{staticClass:"center mt-4 mb-3 heavy-font"},[_vm._v("\n      "+_vm._s(_vm.applicationData.first_name)+" "+_vm._s(_vm.applicationData.last_name)+"\n    ")]),_vm._v(" "),_c('p',[_vm._v("Please add bookings, then click Submit button")])]):_vm._e(),_vm._v(" "),(!_vm.hideFormTitle)?_c('h2',{staticClass:"center mt-4 mb-3 heavy-font"},[_vm._v("\n    "+_vm._s(_vm.getApplicationProperty("name"))+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.hideFormTitle)?_c('hr'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowFormSubmitted),expression:"isShowFormSubmitted"}],staticClass:"center mt-5"},[_c('h3',[_vm._v(_vm._s(_vm.getLabelByKeys("APPLICATION_FORM.WAIT_FOR_PROCESSING")))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isShowFormSubmitted),expression:"!isShowFormSubmitted"}],staticClass:"instruction-container"},[_c('div',{staticClass:"instructions-section center mb-2",domProps:{"innerHTML":_vm._s(_vm.getApplicationProperty('instructions'))}}),_vm._v(" "),(_vm.profile.is_multi_steps_form)?_c('div',{staticClass:"multi-step-progress"},[_c('div',{ref:"stepInfo",staticClass:"step-status-text"},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys(
            "APPLICATION_FORM.STEP_OF",
            _vm.currentStep,
            _vm.numberOfStep
          ))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"current-progress",style:({ width: (_vm.currentStep / _vm.numberOfStep) * 100 + '%' })})])]):_vm._e(),_vm._v(" "),(_vm.hasParseCVButton)?_c('div',{staticClass:"text-center"},[_c('FileWithLabel',{attrs:{"isRequired":false,"submitInfo":{
            profileBuilder: _vm.profileID,
            email: _vm.applicationData.email,
          },"uploadLabel":_vm.parseCVLabel,"hideBorder":true},on:{"input":function($event){return _vm.handleUploadFile($event)}}})],1):_vm._e(),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"listFields":_vm.listDisplayFields,"modelData":_vm.applicationData,"submitClicked":_vm.submitClicked,"submitInfo":{
        profileBuilder: _vm.profileID,
        email: _vm.applicationData.email,
      },"isDragEnabled":true,"listAllRelatedFields":_vm.profile && _vm.profile.is_multi_steps_form? _vm.listFields: null},on:{"reloadData":function($event){return _vm.reloadApplicationData()},"blur":function($event){return _vm.handleBlurField($event)}}},[_vm._l((_vm.listDialogSections),function(dialogSection){return _c('template',{slot:dialogSection.label},[(dialogSection.type === _vm.FORM_TYPE.BOOKING_SECTION)?_c('BookingSectionWithDialog',{key:dialogSection.name,ref:"bookingSection",refInFor:true,attrs:{"id":dialogSection.label,"classList":"mt-4","user":_vm.applicationData,"sectionTitle":_vm.getFieldProperty(dialogSection, 'label'),"description":_vm.getFieldProperty(dialogSection, 'description'),"adminDescription":_vm.getFieldProperty(dialogSection, 'adminDescription'),"name":dialogSection.label,"categoryList":dialogSection.categoryList,"numberOfAllowedChildren":dialogSection.numberOfAllowedChildren,"minCount":_vm.getMinCount(dialogSection),"excludeChildrenQuestion":dialogSection.excludeChildrenQuestion,"excludeAddressQuestion":dialogSection.excludeAddressQuestion,"excludeRepeatBooking":dialogSection.excludeRepeatBooking,"hasNumberCandidateQuestion":dialogSection.hasNumberCandidateQuestion,"hideAdditionalDateQuestion":dialogSection.hideAdditionalDateQuestion,"submitClicked":_vm.submitClicked,"listFields":dialogSection.list_fields,"bookingField":dialogSection,"isInApplicationForm":true,"multipleBookingSections":_vm.hasMultipleBooking,"profileBuilderID":_vm.profileID},model:{value:(_vm.listBookingJobs),callback:function ($$v) {_vm.listBookingJobs=$$v},expression:"listBookingJobs"}}):_c('div',{key:dialogSection.name},[(_vm.useModalInApplicationForm)?_c('ApplicationSectionWithDialog',{attrs:{"sectionTitle":_vm.getFieldProperty(dialogSection, 'label'),"name":dialogSection.name,"header":_vm.getFieldProperty(dialogSection, 'label'),"description":_vm.getFieldProperty(dialogSection, 'description'),"adminDescription":_vm.getFieldProperty(dialogSection, 'adminDescription'),"listModelsAdminOnly":dialogSection.listModelsAdminOnly,"listModelsAdminClient":dialogSection.listModelsAdminClient,"data":_vm.mapDependentObjects[dialogSection.label],"minCount":_vm.getMinCount(dialogSection),"submitClicked":_vm.submitClicked,"listFields":dialogSection.list_fields,"keyTitles":_vm.getKeyTitles(
                dialogSection.list_fields,
                dialogSection.titleModels
              ),"field":dialogSection,"profileBuilderID":_vm.profileID,"applicationData":_vm.applicationData}}):_c('ApplicationSectionInput',{attrs:{"sectionTitle":_vm.getFieldProperty(dialogSection, 'label'),"name":dialogSection.name,"header":_vm.getFieldProperty(dialogSection, 'label'),"description":_vm.getFieldProperty(dialogSection, 'description'),"adminDescription":_vm.getFieldProperty(dialogSection, 'adminDescription'),"listModelsAdminOnly":dialogSection.listModelsAdminOnly,"listModelsAdminClient":dialogSection.listModelsAdminClient,"minCount":_vm.getMinCount(dialogSection),"submitClicked":_vm.submitClicked,"listFields":dialogSection.list_fields,"keyTitles":_vm.getKeyTitles(
                dialogSection.list_fields,
                dialogSection.titleModels
              ),"field":dialogSection,"profileBuilderID":_vm.profileID,"applicationData":_vm.applicationData},model:{value:(_vm.mapDependentObjects[dialogSection.label]),callback:function ($$v) {_vm.$set(_vm.mapDependentObjects, dialogSection.label, $$v)},expression:"mapDependentObjects[dialogSection.label]"}})],1)],1)}),_vm._v(" "),_vm._l((_vm.listSignDocumentField),function(signField){return _c('template',{slot:signField.documentTemplateId + '-' + signField.label},[_c('SigningDocument',{key:signField.label,attrs:{"label":_vm.getFieldProperty(signField, 'label'),"description":_vm.getFieldProperty(signField, 'description'),"id":signField.documentTemplateId,"template":_vm.mapDocumentTemplates[_vm.getKeySigningField(signField)],"hideLabel":signField.hideLabel,"submitClicked":_vm.submitClicked,"user":_vm.applicationData,"mapDependentObjects":_vm.mapDependentObjects,"mapDependentLabelName":_vm.mapDependentLabelName,"listOriginal":_vm.listOriginalDocuments},on:{"signed":function($event){return _vm.handleSignDocument(signField, $event)}}})],1)}),_vm._v(" "),_vm._l((_vm.listEvaluationField),function(evaluationField){return _c('template',{slot:evaluationField.label},[_c('EvaluationInApplicationForm',{key:evaluationField.label,attrs:{"label":_vm.getFieldProperty(evaluationField, 'label'),"evaluationField":evaluationField,"submitClicked":_vm.submitClicked,"listOriginal":_vm.listOriginalEvaluations},on:{"submitted":function($event){return _vm.handleSubmitEvaluation($event)}}})],1)}),_vm._v(" "),_vm._l((_vm.listFileInfoFields),function(fileInfoField){return _c('template',{slot:fileInfoField.label},[_c('div',{key:'file' + fileInfoField.label,staticClass:"file-with-info-container"},[_c('FileWithInfo',{attrs:{"field":fileInfoField,"submitClicked":_vm.submitClicked,"applicationData":_vm.applicationData},model:{value:(_vm.mapFileInfo[fileInfoField.label]),callback:function ($$v) {_vm.$set(_vm.mapFileInfo, fileInfoField.label, $$v)},expression:"mapFileInfo[fileInfoField.label]"}})],1)])}),_vm._v(" "),(_vm.paymentField)?_c('template',{slot:_vm.paymentField.label},[(_vm.hasAuthorizePayment)?_c('AuthorizeNetPayment',{ref:"authorizeNetPayment",attrs:{"isRequired":_vm.paymentField.isRequired,"submitClicked":_vm.submitClicked},model:{value:(_vm.authorizePaymentInfo),callback:function ($$v) {_vm.authorizePaymentInfo=$$v},expression:"authorizePaymentInfo"}}):(_vm.hasQuickbooksPayment)?_c('QuickbooksPayment',{ref:"quickbooksPayment",attrs:{"isRequired":_vm.paymentField.isRequired,"submitClicked":_vm.submitClicked},model:{value:(_vm.quickbooksPaymentInfo),callback:function ($$v) {_vm.quickbooksPaymentInfo=$$v},expression:"quickbooksPaymentInfo"}}):_c('StripePayment',{ref:"stripePayment",attrs:{"user":_vm.applicationData,"isRequired":_vm.paymentField.isRequired,"label":_vm.getFieldProperty(_vm.paymentField, 'label'),"description":_vm.getFieldProperty(_vm.paymentField, 'description'),"adminDescription":_vm.getFieldProperty(_vm.paymentField, 'adminDescription'),"submitClicked":_vm.submitClicked}})],1):_vm._e(),_vm._v(" "),(_vm.returningApplicantBtnField)?_c('template',{slot:_vm.returningApplicantBtnField.label},[_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.handleClickReturningApplicantBtn()}}},[_vm._v("\n            "+_vm._s(_vm.returningApplicantBtnField.label ||
              _vm.getLabelByKeys("BUTTONS.RETURNING_APPLICANT"))+"\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.stripeSubscriptionSelectionField)?_c('template',{slot:'stripe-subscription-selection' +
          _vm.stripeSubscriptionSelectionField.label},[_c('StripeSubscriptionSelection',{attrs:{"classList":"","label":_vm.stripeSubscriptionSelectionField.label,"description":_vm.stripeSubscriptionSelectionField.description,"adminDescription":_vm.stripeSubscriptionSelectionField.adminDescription,"headerList":_vm.stripeSubscriptionSelectionField.headerList,"descriptionList":_vm.stripeSubscriptionSelectionField.descriptionList,"planIdList":_vm.stripeSubscriptionSelectionField.planIdList,"submitClicked":_vm.submitClicked,"isRequired":_vm.stripeSubscriptionSelectionField.isRequired},model:{value:(_vm.stripeSubscriptionSelected),callback:function ($$v) {_vm.stripeSubscriptionSelected=$$v},expression:"stripeSubscriptionSelected"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.listCheckboxConditionFields),function(field){return _c('template',{slot:'checkbox-condition' + field.label},[_c('div',{key:'checkbox-condition' + field.label,staticClass:"col-lg-12"},_vm._l((_vm.convertStringToArray(field.optionList)),function(option,index){return _c('div',{key:'condition-option-' + index,staticClass:"form-check pl-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mapCheckboxCondition[field.label + index]),expression:"mapCheckboxCondition[field.label + index]"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":'checkbox-' + field.label + option + '-' + index},domProps:{"value":option,"checked":Array.isArray(_vm.mapCheckboxCondition[field.label + index])?_vm._i(_vm.mapCheckboxCondition[field.label + index],option)>-1:(_vm.mapCheckboxCondition[field.label + index])},on:{"change":[function($event){var $$a=_vm.mapCheckboxCondition[field.label + index],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.mapCheckboxCondition, field.label + index, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.mapCheckboxCondition, field.label + index, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.mapCheckboxCondition, field.label + index, $$c)}},function($event){return _vm.onChangeCheckboxCondition()}]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":'checkbox-' + field.label + option + '-' + index},domProps:{"innerHTML":_vm._s(option)}}),_vm._v(" "),(
                _vm.submitClicked && !_vm.mapCheckboxCondition[field.label + index]
              )?_c('p',{staticClass:"required-message checkbox-condition-require"},[_vm._v("\n              "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n            ")]):_vm._e()])}),0)])})],2),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.isShowSubmitButton && _vm.hasCaptcha)?_c('GoogleCaptcha',{on:{"verified":function($event){_vm.isVerifiedCaptcha = true}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"submit-button-section"},[(_vm.isShowPreviousButton)?_c('button',{staticClass:"previous-button mylisting-button secondary-button",attrs:{"id":"submit-button","data-index":"0"},on:{"click":function($event){return _vm.handleClickPreviousButton()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.PREVIOUS"))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isShowNextButton)?_c('button',{staticClass:"next-button mylisting-button dark-button",attrs:{"id":"submit-button","data-index":"0"},on:{"click":function($event){return _vm.handleClickNextButton()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.NEXT"))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isShowSubmitButton)?_c('button',{staticClass:"submit-button mylisting-button dark-button",attrs:{"id":"submit-button","data-index":"0"},on:{"click":function($event){_vm.submitApplication(), _vm.jobViewApplicationSubmitted()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.SUBMIT"))+"\n      ")]):_vm._e()])],1),_vm._v(" "),(
      _vm.$store.getters.agencyPublic &&
      !_vm.$store.getters.agencyPublic
        .hide_enginehire_branding_from_application_forms
    )?_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"href":"https://staffing.enginehire.io/","target":"_blank"}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.hasSpaceBottomEmbedded && _vm.isEmbed)?_c('div',{style:({ height: (_vm.spaceHeightBottomEmbedded + "px") })}):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center",staticStyle:{"color":"#aaa","margin-top":"70px"}},[_c('small',{staticStyle:{"display":"block"}},[_vm._v("Powered by Enginehire")]),_vm._v(" "),_c('img',{staticClass:"mt-2",staticStyle:{"width":"100px","max-width":"85%"},attrs:{"src":__webpack_require__(280),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6ab5e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorDialog_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d6ab5e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6ab5e2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(612);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("39ab51f5", content, true, {});

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".error-section[data-v-1d6ab5e2]{margin-top:.5rem}.error-message[data-v-1d6ab5e2]{text-transform:none}.main-message[data-v-1d6ab5e2]{white-space:pre-line}@media (max-width:768px){h2[data-v-1d6ab5e2]{font-size:24px}h4[data-v-1d6ab5e2]{font-size:20px}}", ""]);

// exports


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"targetClass":_vm.isEmbed ? 'submit-button' : null,"level":10},on:{"close":function($event){return _vm.closeErrorDialog()}},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(_vm.innerHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.formatContent.apply(void 0, [ _vm.innerHtml ].concat( _vm.params )))},on:{"click":function($event){return _vm.handleClickContent($event)}}}):_vm._e(),_vm._v(" "),(!_vm.innerHtml && _vm.title)?_c('h2',[_vm._v(_vm._s(_vm.formatContent.apply(void 0, [ _vm.title ].concat( _vm.params ))))]):_vm._e(),_vm._v(" "),(!_vm.innerHtml && _vm.message)?_c('h4',{staticClass:"error-message main-message"},[_c('p',[_vm._v(_vm._s(_vm.formatContent.apply(void 0, [ _vm.message ].concat( _vm.params ))))])]):_vm._e(),_vm._v(" "),(_vm.errorObj && typeof _vm.errorObj !== 'object')?_c('div',[_vm._v("\n      "+_vm._s(_vm.extractErrorContent(_vm.errorObj))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.errorObj && typeof _vm.errorObj === 'object')?_c('div',_vm._l((Object.keys(_vm.errorObj)),function(key,index){return _c('div',{key:index,staticClass:"error-section"},[_c('h4',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.getDisplayKey(key)))]),_vm._v(" "),(Array.isArray(_vm.errorObj[key]))?_c('div',_vm._l((_vm.errorObj[key]),function(value,valIndex){return _c('li',{key:'val-' + valIndex},[_c('span',{domProps:{"innerHTML":_vm._s(value)}})])}),0):_c('div',[_c('li',[_vm._v(_vm._s(_vm.errorObj[key]))])])])}),0):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.closeErrorDialog()}}},[_vm._v("\n      "+_vm._s(_vm.closeLabel)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a24ae29_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__ = __webpack_require__(617);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a24ae29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a24ae29_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("48406420", content, true, {});

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@media (max-width:768px){h2[data-v-5a24ae29]{font-size:24px}h4[data-v-5a24ae29]{font-size:20px}}.button-container[data-v-5a24ae29]{display:flex;flex-wrap:wrap}.spacing[data-v-5a24ae29]{flex-grow:1}.accept-btn-container[data-v-5a24ae29],.reject-btn-container[data-v-5a24ae29]{text-align:center}@media (max-width:400px){.button-container[data-v-5a24ae29]{display:block}}", ""]);

// exports


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"targetClass":_vm.isEmbed ? 'submit-button' : null,"level":10},on:{"close":function($event){return _vm.onReject()}},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(_vm.innerHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.formatContent.apply(void 0, [ _vm.innerHtml ].concat( _vm.params )))}}):_c('h2',[_vm._v(_vm._s(_vm.formatContent.apply(void 0, [ _vm.message ].concat( _vm.params ))))]),_vm._v(" "),(_vm.showReasonInput)?_c('div',[_c('label',[_vm._v(_vm._s(_vm.reasonOnConfirmLabel))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmReason),expression:"confirmReason"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.confirmReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmReason=$event.target.value}}}),_vm._v(" "),(_vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n        *Please fill out a reason\n      ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('div',{staticClass:"reject-btn-container"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.onReject()}}},[_vm._v("\n          "+_vm._s(_vm.rejectLabel)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"spacing"}),_vm._v(" "),_c('div',{staticClass:"accept-btn-container"},[(_vm.acceptLabel2)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.onAccept2()}}},[_vm._v("\n          "+_vm._s(_vm.acceptLabel2)+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mylisting-button danger-button",on:{"click":function($event){return _vm.onAccept()}}},[_vm._v("\n          "+_vm._s(_vm.acceptLabel)+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd9deb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultDialog_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dd9deb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd9deb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0befbf9c", content, true, {});

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".additional-items[data-v-1dd9deb8]{display:inline}.result-message[data-v-1dd9deb8]{margin-top:1em;white-space:pre-wrap}@media (max-width:768px){h2[data-v-1dd9deb8]{font-size:24px}h4[data-v-1dd9deb8]{font-size:20px}}", ""]);

// exports


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"blockBackgroundScroll":false,"targetClass":_vm.isEmbed ? 'submit-button' : null,"level":10,"hideCloseBtn":_vm.hideButton},on:{"close":function($event){return _vm.closeResultDialog()}},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(_vm.innerHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.formatContent.apply(void 0, [ _vm.innerHtml ].concat( _vm.params )))},on:{"click":function($event){return _vm.handleClickContent($event)}}}):_vm._e(),_vm._v(" "),(!_vm.innerHtml && _vm.title)?_c('h2',{},[_c('span',[_vm._v(_vm._s(_vm.formatContent.apply(void 0, [ _vm.title ].concat( _vm.params ))))])]):_vm._e(),_vm._v(" "),(!_vm.innerHtml && _vm.message)?_c('h4',{staticClass:"result-message"},[_c('p',[_vm._v(_vm._s(_vm.formatContent.apply(void 0, [ _vm.message ].concat( _vm.params ))))])]):_vm._e(),_vm._v(" "),(!_vm.hideButton)?_c('hr'):_vm._e(),_vm._v(" "),(!_vm.hideButton)?_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.closeResultDialog()}}},[_vm._v("\n      "+_vm._s(_vm.closeLabel)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.additionalFooter)?_c('div',{staticClass:"additional-items",domProps:{"innerHTML":_vm._s(_vm.additionalFooter)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDialog_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8e560a2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoDialog_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(623)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8e560a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8e560a2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(624);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d83760a0", content, true, {});

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@media (max-width:768px){h2[data-v-b8e560a2]{font-size:24px}h4[data-v-b8e560a2]{font-size:20px}}.button-group[data-v-b8e560a2]{text-align:right}.button-group-optional[data-v-b8e560a2]{text-align:left}.edit-icon-button[data-v-b8e560a2]{position:absolute;right:0}.edit-button-container[data-v-b8e560a2]{position:relative}.edit-button-container .edit-button.no-notes[data-v-b8e560a2]{top:-14px}", ""]);

// exports


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"level":9},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5",attrs:{"slot":"dialog-content"},on:{"click":function($event){return _vm.handleClickContent($event)}},slot:"dialog-content"},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('h4',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(_vm.title)?_c('hr',{class:{ 'mb-0': _vm.title !== 'Note' }}):_vm._e(),_vm._v(" "),(_vm.onEditCallback)?_c('div',{staticClass:"edit-button-container"},[_c('div',{staticClass:"edit-button",class:{ 'no-notes': _vm.title == 'Note' && !_vm.data.client_notes },on:{"click":function($event){return _vm.handleClickEditButton()}}},[_c('i',{staticClass:"material-icons"},[_vm._v(" edit ")])])]):_vm._e(),_vm._v(" "),(_vm.listFields && _vm.listFields.length)?_c('DetailSectionRowLayout',{attrs:{"modelData":_vm.data,"labelKey":"displayLabel","listFields":_vm.listFields}}):_vm._e(),_vm._v(" "),(_vm.listTableHeaders && _vm.listTableHeaders.length)?_c('DataTable',{attrs:{"listHeaders":_vm.listTableHeaders,"listData":_vm.listRows,"isCandidateTable":false,"defaultItemPerPage":50,"showCheckbox":false}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.optionalButton)?_c('div',{staticClass:"col-lg-2"},[_c('div',{staticClass:"button-group-optional"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.optionalInfoButton()}}},[_vm._v("\n            "+_vm._s(_vm.optionalButton)+"\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.optionalButton2)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"button-group-optional"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.optionalInfoButton2()}}},[_vm._v("\n            "+_vm._s(_vm.optionalButton2)+"\n          ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"mylisting-button secondary-button",on:{"click":function($event){return _vm.closeInfoDialog()}}},[_vm._v("\n            "+_vm._s(_vm.closeLabel)+"\n          ")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad29b24_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDialog_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ad29b24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad29b24_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(628);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9882d444", content, true, {});

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "@media (max-width:768px){h2[data-v-3ad29b24]{font-size:24px}h4[data-v-3ad29b24]{font-size:20px}}", ""]);

// exports


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"level":_vm.level || 9},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-5 field-of-fields",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('h4',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(_vm.title)?_c('hr',{style:(_vm.hasDistanceTop ? null : 'margin-bottom: 0')}):_vm._e(),_vm._v(" "),_c('FormGroupRowLayout',{attrs:{"listFields":_vm.listFields,"modelData":_vm.applicationData,"submitInfo":{
        type: _vm.dialogId,
      },"submitClicked":_vm.submitClicked}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"mylisting-button secondary-button cancel-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("\n        "+_vm._s(_vm.cancelLabel)+"\n      ")]),_vm._v(" "),(_vm.hasDeleteBtn)?_c('button',{staticClass:"mylisting-button danger-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleClickDeleteBtn()}}},[_vm._v("\n        "+_vm._s(_vm.deleteLabel)+"\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mylisting-button dark-button",staticStyle:{"float":"right"},attrs:{"type":"button","disabled":_vm.isRecordingVideo},on:{"click":function($event){return _vm.handleSubmit()}}},[_vm._v("\n        "+_vm._s(_vm.submitLabel)+"\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreviewDialog_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreviewDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreviewDialog_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreviewDialog_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreviewDialog_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40656534_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilePreviewDialog_vue__ = __webpack_require__(637);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40656534"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreviewDialog_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40656534_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilePreviewDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("bd009adc", content, true, {});

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".image-preview-container[data-v-40656534],.pdf-preview-container[data-v-40656534]{height:calc(90vh - 2rem - 44px);overflow:auto}.download-button[data-v-40656534]{position:absolute;bottom:2rem;right:2rem}", ""]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreview_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreview_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreview_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreview_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b9c9376_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilePreview_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b9c9376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilePreview_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b9c9376_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(635);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("60a3cf3b", content, true, {});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".image-preview-container[data-v-4b9c9376],.pdf-preview-container[data-v-4b9c9376]{height:calc(90vh - 2rem - 44px);overflow:auto}", ""]);

// exports


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[(_vm.isImage)?_c('div',{staticClass:"image-preview-container"},[_c('embed',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"auto"}})]):(_vm.isPdf)?_c('div',{staticClass:"pdf-preview-container"},[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"100%"}})]):(_vm.isOfficeDoc)?_c('div',{staticClass:"doc-preview-container"},[_c('VueDocPreview',{attrs:{"value":_vm.url,"type":"office"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalDialog',{attrs:{"useWhiteBgCloseButton":true,"level":9.1,"showInLeft":_vm.showInLeft},on:{"close":function($event){return _vm.hideModal()}},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('div',{staticClass:"p-2",attrs:{"slot":"dialog-content"},slot:"dialog-content"},[_c('FilePreview',{attrs:{"url":_vm.url}}),_vm._v(" "),_c('div',{staticClass:"pl-4 pr-4 d-flex",class:_vm.isImage || _vm.isPdf || _vm.isOfficeDoc ? 'pt-2 pb-2' : 'pb-4'},[(_vm.additionalBtn && _vm.additionalBtn.label)?_c('button',{staticClass:"mylisting-button dark-button",on:{"click":_vm.additionalBtn.onClick}},[_vm._v("\n        "+_vm._s(_vm.additionalBtn.label)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"space-item"}),_vm._v(" "),_c('button',{staticClass:"mylisting-button secondary-button cancel-button",on:{"click":function($event){return _vm.hideModal()}}},[_vm._v("\n        "+_vm._s(_vm.getLabelByKeys("BUTTONS.CLOSE"))+"\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoading_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39cd04d5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerLoading_vue__ = __webpack_require__(641);
function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39cd04d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39cd04d5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(640);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7e043716", content, true, {});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".overlay-panel[data-v-39cd04d5]{position:fixed;top:0;left:0;bottom:0;right:0;background:#fff;opacity:.5;z-index:100000000;display:flex;justify-content:center;align-items:center}#svg-spinner[data-v-39cd04d5]{-webkit-transition-property:-webkit-transform;-webkit-transition-duration:1.2s;-webkit-animation-name:rotate-data-v-39cd04d5;-webkit-animation-iteration-count:infinite;-webkit-animation-timing-function:linear;-moz-transition-property:-moz-transform;-moz-animation-name:rotate-data-v-39cd04d5;-moz-animation-duration:1.2s;-moz-animation-iteration-count:infinite;-moz-animation-timing-function:linear;transition-property:transform;animation-name:rotate-data-v-39cd04d5;animation-duration:1.2s;animation-iteration-count:infinite;animation-timing-function:linear}@-webkit-keyframes rotate-data-v-39cd04d5{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@-moz-keyframes rotate-data-v-39cd04d5{0%{-moz-transform:rotate(0deg)}to{-moz-transform:rotate(1turn)}}@keyframes rotate-data-v-39cd04d5{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay-panel"},[_c('svg',{attrs:{"id":"svg-spinner","xmlns":"http://www.w3.org/2000/svg","width":"96","height":"96","viewBox":"0 0 48 48"}},[_c('circle',{attrs:{"cx":"24","cy":"4","r":"4","fill":"#000"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12.19","cy":"7.86","r":"3.7","fill":"#171717"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5.02","cy":"17.68","r":"3.4","fill":"#2f2f2f"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5.02","cy":"30.32","r":"3.1","fill":"#464646"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12.19","cy":"40.14","r":"2.8","fill":"#5e5e5e"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"24","cy":"44","r":"2.5","fill":"#757575"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"35.81","cy":"40.14","r":"2.2","fill":"#8d8d8d"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"42.98","cy":"30.32","r":"1.9","fill":"#a4a4a4"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"42.98","cy":"17.68","r":"1.6","fill":"#bcbcbc"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"35.81","cy":"7.86","r":"1.3","fill":"#d3d3d3"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADMIN_MENU_ALL_ITEMS = exports.ADMIN_MENU_ALL_ITEMS = [{
  key: "MENU_BAR.ADMIN.USERS.CLIENTS",
  id: "Clients"
}, {
  key: "MENU_BAR.ADMIN.USERS.CANDIDATES",
  id: "Candidates"
}, {
  key: "MENU_BAR.ADMIN.JOBS_EVENTS.SHIFT_JOB_CALENDAR",
  id: "Shift Job Calendar"
}, {
  key: "MENU_BAR.ADMIN.JOBS_EVENTS.PLACEMENT_JOBS",
  id: "Jobs"
}, {
  key: "MENU_BAR.ADMIN.TEMPLATES.ROOT",
  subItems: [{
    key: "MENU_BAR.ADMIN.TEMPLATES.EMAIL",
    id: "Email Templates"
  }, {
    key: "MENU_BAR.ADMIN.TEMPLATES.SMS",
    id: "SMS Templates"
  }, {
    key: "MENU_BAR.ADMIN.TEMPLATES.DOCUMENT",
    id: "Document Templates"
  }, {
    key: "MENU_BAR.ADMIN.TEMPLATES.NOTE",
    id: "Note Templates"
  }, {
    key: "MENU_BAR.ADMIN.TEMPLATES.TASK",
    id: "Task Templates"
  }, {
    key: "MENU_BAR.ADMIN.TEMPLATES.PROFILE",
    id: "Profile Templates"
  }, {
    key: "MENU_BAR.ADMIN.TEMPLATES.PUSH_NOTIFICATION",
    id: "Push Notification Templates"
  }]
}, {
  key: "MENU_BAR.ADMIN.SETTINGS.ROOT",
  subItems: [{
    key: "MENU_BAR.ADMIN.SETTINGS.AGENCY",
    id: "Agency"
  }, {
    key: "MENU_BAR.ADMIN.SETTINGS.ADMIN",
    id: "Admin Setting"
  }]
}, {
  key: "MENU_BAR.ADMIN.BUILDERS.ROOT",
  subItems: [{
    key: "MENU_BAR.ADMIN.BUILDERS.PROFILE",
    id: "Application & Profile Builder"
  }, {
    key: "MENU_BAR.ADMIN.BUILDERS.EVALUATION",
    id: "Evaluation Builder"
  }]
}, {
  key: "MENU_BAR.ADMIN.LOGS.ROOT",
  subItems: [{
    key: "MENU_BAR.ADMIN.LOGS.COMMUNICATION_LOG",
    id: "Communication Log"
  }, {
    key: "MENU_BAR.ADMIN.LOGS.USER_MESSAGES_LOG",
    id: "User Messages Log"
  }, {
    key: "MENU_BAR.ADMIN.LOGS.STATUS_CHANGES",
    id: "Status Changes"
  }, {
    key: "MENU_BAR.ADMIN.LOGS.ACTIVITY_LOG",
    id: "Activity Log"
  }, {
    key: "MENU_BAR.ADMIN.LOGS.APPLICATION_LOG",
    id: "Application Log"
  }, {
    key: "MENU_BAR.ADMIN.LOGS.PAYMENT_LOG",
    id: "Payment Log"
  }]
}, {
  key: "MENU_BAR.ADMIN.OTHERS.ROOT",
  subItems: [{
    key: "MENU_BAR.ADMIN.OTHERS.RESOURCE_MANAGER",
    id: "Resource Manager"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.REFERENCES",
    id: "References"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.DOCUMENTS",
    id: "Documents"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.EMAIL_BLASTER",
    id: "Email Blaster"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.NOTIFICATION_CENTER",
    id: "Notification Center"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.SNAPSHOT",
    id: "Metrics & Analysis (Snapshot)"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.COMMUNITY",
    id: "Community"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.DAILY_RESOURCE_MANAGER",
    id: "Daily Resource Manager"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.GLOBAL_PREDEFINED_VALUES",
    id: "Global Predefined Values"
  }, {
    key: "MENU_BAR.ADMIN.USERS.ADMINISTRATORS",
    id: "Administrators"
  }, {
    key: "MENU_BAR.ADMIN.JOBS_EVENTS.PERSONAL_TO_DO",
    id: "Personal To Do"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.BENEFIT_MANAGER",
    id: "Benefit Manager"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.BENEFITS",
    id: "Benefits"
  }, {
    key: "MENU_BAR.ADMIN.OTHERS.TRASH",
    id: "Trash"
  }]
}];

var TOP_MENU_ALL_ITEMS = exports.TOP_MENU_ALL_ITEMS = [{
  key: "MENU_BAR.TOP.MARKETPLACE",
  id: "Marketplace"
}, {
  key: "MENU_BAR.TOP.CANDIDATE_COMMUNITY",
  id: "Enginehire Candidate Community"
}, {
  key: "MENU_BAR.TOP.COMMUNITY",
  id: "Enginehire Community"
}, {
  key: "MENU_BAR.TOP.MESSAGES",
  id: "Users Messages"
}, {
  key: "MENU_BAR.TOP.SMS",
  id: "SMS Communication"
},
// {
//   key: "MENU_BAR.TOP.JOBS",
//   id: "Agency Job Board"
// },
{
  key: "MENU_BAR.TOP.LOGOUT",
  id: "Logout"
}, {
  key: "MENU_BAR.TOP.DASHBOARD",
  id: "Dashboard"
}];

var ENGINEHOW_MENU_ITEMS = exports.ENGINEHOW_MENU_ITEMS = ["Application & Profile Builder", "Evaluation Builder", "Clients", "Email Templates", "Document Templates", "Agency", "Email Blaster"];
var CANDIDATE_MENU_ALL_ITEMS = exports.CANDIDATE_MENU_ALL_ITEMS = [{
  key: "MENU_BAR.CANDIDATES.MY_PROFILE",
  id: "My Profile",
  icon: "contact_page"
}, {
  key: "MENU_BAR.CANDIDATES.AVAILABLE_JOBS",
  id: "Available Jobs",
  icon: "work_outline"
}, {
  key: "MENU_BAR.CANDIDATES.MY_SCHEDULE",
  id: "My Schedule",
  icon: "event_available"
}, {
  key: "MENU_BAR.CANDIDATES.MY_JOBS",
  id: "My Jobs",
  icon: "work"
}, {
  key: "MENU_BAR.CANDIDATES.MY_FAMILIES",
  id: "My Families",
  icon: "house"
}, {
  key: "MENU_BAR.CANDIDATES.BENEFITS",
  id: "Benefits",
  icon: "emoji_events"
}];

var LIST_ALL_MENU_IDS = exports.LIST_ALL_MENU_IDS = ["Clients", "Candidates", "Personal To Do", "Shift Job Calendar", "Jobs", "References", "Documents", "Email Blaster", "Admin Setting", "Email Templates", "SMS Templates", "Document Templates", "Note Templates", "Task Templates", "Profile Templates", "Push Notification Templates", "Resource Manager", "Evaluation Builder", "Communication Log", "User Messages Log", "Payment Log", "Administrators", "Agency", "Application & Profile Builder", "Notification Center", "Status Changes", "Activity Log", "Application Log", "Metrics & Analysis (Snapshot)", "Home", "Community", "Trash"];

var USER_PANEL_MENU_ITEMS = exports.USER_PANEL_MENU_ITEMS = [{
  key: 'MENU_BAR.ADMIN_PANEL.LISTS',
  tab: 'lists',
  icon: 'checklist'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.NOTES',
  tab: 'notes',
  icon: 'note'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.EMAIL_SMS',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.EMAIL_SMS',
  tab: 'email_sms',
  icon: 'mail'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.EVENT',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.EVENT',
  tab: 'event',
  icon: 'event'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.PASSWORD',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.PASSWORD',
  tab: 'password',
  icon: 'password'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.PAYMENTS',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.PAYMENTS',
  tab: 'payments',
  icon: 'payment'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.PAYMENTS_CREDIT',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.PAYMENTS',
  tab: 'payments',
  hasCredit: true,
  icon: 'payment'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.DOCUMENTS',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.DOCUMENTS',
  tab: 'documents',
  icon: 'text_snippet'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.EVALUATIONS',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.EVALUATIONS',
  tab: 'evaluations',
  icon: 'quiz'
}, {
  key: 'MENU_BAR.ADMIN_PANEL.RELATIONSHIPS',
  keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.RELATIONSHIPS',
  tab: 'relationships',
  icon: 'group_add'
}];

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    // BASE_URL: 'http://127.0.0.1:8000',
    BASE_URL: 'https://apiroot.enginehire.io'
    // BASE_WS_URL: "ws://127.0.0.1:5000"
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BASE_URL: 'https://apiweb.enginehire.io',
    BASE_WS_URL: "wss://chat.enginehire.io"
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ERROR_CODE = exports.ERROR_CODE = {
    USER_EXISTED: '409001'
};

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(647);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("dc57f6d2", content, true, {});

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue-simple-context-menu{top:0;left:0;margin:0;padding:0;display:none;list-style:none;position:absolute;z-index:1000000;background-color:#ecf0f1;border-bottom-width:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;box-shadow:0 3px 6px 0 rgba(51,51,51,.2);border-radius:4px}.vue-simple-context-menu--active{display:block}.vue-simple-context-menu__item{display:flex;color:#333;cursor:pointer;padding:5px 15px;align-items:center}.vue-simple-context-menu__item:hover{background-color:#007aff;color:#fff}.vue-simple-context-menu__divider{box-sizing:content-box;height:2px;background-color:#c0cdd1;padding:4px 0;background-clip:content-box;pointer-events:none}.vue-simple-context-menu li:first-of-type{margin-top:4px}.vue-simple-context-menu li:last-of-type{margin-bottom:4px}", ""]);

// exports


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_click_outside__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_click_outside__);



//
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_v_click_outside___default.a);

var script = {
  name: "VueSimpleContextMenu",
  props: {
    elementId: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      item: null,
      menuWidth: null,
      menuHeight: null
    };
  },
  methods: {
    showMenu: function showMenu(event, item) {
      this.item = item;

      var menu = document.getElementById(this.elementId);
      if (!menu) {
        return;
      }

      if (!this.menuWidth || !this.menuHeight) {
        menu.style.visibility = "hidden";
        menu.style.display = "block";
        this.menuWidth = menu.offsetWidth;
        this.menuHeight = menu.offsetHeight;
        menu.removeAttribute("style");
      }

      if (this.menuWidth + event.pageX >= window.innerWidth) {
        menu.style.left = event.pageX - this.menuWidth + 2 + "px";
      } else {
        menu.style.left = event.pageX - 2 + "px";
      }

      if (this.menuHeight + event.pageY >= window.innerHeight) {
        menu.style.top = event.pageY - this.menuHeight + 2 + "px";
      } else {
        menu.style.top = event.pageY - 2 + "px";
      }

      menu.classList.add("vue-simple-context-menu--active");
    },
    hideContextMenu: function hideContextMenu() {
      var element = document.getElementById(this.elementId);
      if (element) {
        element.classList.remove("vue-simple-context-menu--active");
        this.$emit("menu-closed");
      }
    },
    onClickOutside: function onClickOutside() {
      this.hideContextMenu();
    },
    optionClicked: function optionClicked(option) {
      this.hideContextMenu();
      this.$emit("option-clicked", {
        item: this.item,
        option: option
      });
    },
    onEscKeyRelease: function onEscKeyRelease(event) {
      if (event.keyCode === 27) {
        this.hideContextMenu();
      }
    }
  },
  mounted: function mounted() {
    document.body.addEventListener("keyup", this.onEscKeyRelease);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("keyup", this.onEscKeyRelease);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [
    _c(
      "ul",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.onClickOutside,
            expression: "onClickOutside"
          }
        ],
        staticClass: "vue-simple-context-menu",
        attrs: { id: _vm.elementId }
      },
      _vm._l(_vm.options, function(option, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "vue-simple-context-menu__item",
            class: [
              option.class,
              option.type === "divider"
                ? "vue-simple-context-menu__divider"
                : ""
            ],
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.optionClicked(option)
              }
            }
          },
          [_c("span", { domProps: { innerHTML: _vm._s(option.name) } })]
        )
      }),
      0
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

// Import vue component

// install function executed by Vue.use()
function install (Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('VueSimpleContextMenu', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// To auto-install when vue is found
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

/* harmony default export */ __webpack_exports__["default"] = (__vue_component__);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):e["v-click-outside"]=n()}(this,function(){var e="__v-click-outside",n="undefined"!=typeof window,t="undefined"!=typeof navigator,i=n&&("ontouchstart"in window||t&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function r(n,t){var r=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||i,isActive:!(!1===e.isActive)}}(t.value),o=r.handler,d=r.middleware;r.isActive&&(n[e]=r.events.map(function(e){return{event:e,handler:function(e){return function(e){var n=e.el,t=e.event,i=e.handler,r=e.middleware;t.target!==n&&!n.contains(t.target)&&r(t,n)&&i(t,n)}({event:e,el:n,handler:o,middleware:d})}}}),n[e].forEach(function(e){var n=e.event,t=e.handler;return setTimeout(function(){return document.documentElement.addEventListener(n,t,!1)},0)}))}function o(n){(n[e]||[]).forEach(function(e){return document.documentElement.removeEventListener(e.event,e.handler,!1)}),delete n[e]}var d={bind:r,update:function(e,n){var t=n.value,i=n.oldValue;JSON.stringify(t)!==JSON.stringify(i)&&(o(e),r(e,{value:t}))},unbind:o};return{install:function(e){e.directive("click-outside",d)},directive:d}});
//# sourceMappingURL=v-click-outside.min.min.umd.js.map


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.getters.getDashboardV2)?_c('div',{class:{
      'in-embed': _vm.isEmbed,
      'hide-logo': _vm.hideLogo,
      'login-page':
        _vm.$router.history.current.path &&
        _vm.$router.history.current.path.indexOf('/login/') === 0,
      'is-agent': _vm.isAgent,
    },attrs:{"id":"app"},on:{"click":function($event){return _vm.handleClickApp($event)}}},[_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),(!_vm.isEmbed)?_c('app-footer',{staticClass:"footer-panel"}):_vm._e(),_vm._v(" "),_c('ErrorDialog'),_vm._v(" "),_c('ResultDialog'),_vm._v(" "),_c('ConfirmDialog'),_vm._v(" "),_c('InfoDialog'),_vm._v(" "),_c('InputDialog'),_vm._v(" "),_c('FilePreviewDialog'),_vm._v(" "),(_vm.isLoading)?_c('SpinnerLoading'):_vm._e(),_vm._v(" "),_c('vue-simple-context-menu',{ref:"contextMenu",attrs:{"elementId":"context-menu","options":_vm.$store.getters.contextMenu.options},on:{"option-clicked":_vm.contextMenuOptionClicked}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customDefineType = __webpack_require__(6);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _queryHandling = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    importFieldChanged: [],
    pageScrollTop: 0,
    dialogScrollTop: 0,
    screenResizeCount: 0,
    emailSending: null,
    filePreview: null,
    monthNumbers: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
    upcomingYears: ["2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033", "2034", "2035", "2036", "2037", "2038", "2039", "2040", "2041"],
    hourOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
    minuteOptionsByFive: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
    minuteOptionsByFifteen: ['00', '15', '30', '45'],
    ampmOptions: ['AM', 'PM'],
    lastClickY: 0,
    displayingProfileUserId: null, // Use for normal user
    displayingProfileUser: null, // Use for normal user
    displayingCandidateId: null, // Use for admin
    displayingEmployerId: null, // Use for admin
    displayingCandidate: null, // Use for admin
    displayingEmployer: null, // Use for admin
    agent: null, // Login agent
    loadProfileTemplateListReqNumber: 0,
    reloadProfileTemplateListReqNumber: 0,
    loadCandidateProfileTemplateListReqNumber: 0,
    loadClientProfileTemplateListReqNumber: 0,
    isLoadingProfileTemplate: true, // After it is loaded => set to false
    profileTemplateList: [],
    candidateProfileTemplateList: [], // Profile template list for candidate
    clientProfileTemplateList: [], // Profile template list for client
    adminList: [],
    adminSetting: {},
    contextMenu: { options: [] },
    openProfileSectionId: null,
    loadPackageListReqNumber: 0,
    packageList: null,
    listDaysOfWeek: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
    hasMessage: false,
    totalNewMessages: 0,
    totalNewSMS: 0,
    totalNewTopics: 0,
    minutesIntervalOptionList: [{
        label: "5 minutes",
        model: 5
    }, {
        label: "10 minutes",
        model: 10
    }, {
        label: "15 minutes",
        model: 15
    }, {
        label: "30 minutes",
        model: 30
    }],
    languageDashboardOptions: ["English", "French", "Spanish"],
    addProfileTemplateErrors: [],
    evaluationTemplatesList: [],
    evaluationTemplateErrors: [],
    newFeature: {},
    noteTemplates: [],
    noteTemplatesErrors: [],
    windowWidth: 0,
    hideMenuBar: false,
    iframePositionTop: null, // Position for iframe (embedded site),
    iframeParentHeight: null, // Windows height (embedded site)
    windowHeight: null, // Windows height (embedded site)
    iframeScaleY: null
};

var mutations = {
    setImportFieldChanged: function setImportFieldChanged(state) {
        state.importFieldChanged = [];
    },
    addImportFieldChanged: function addImportFieldChanged(state, fieldData) {
        state.importFieldChanged.push(fieldData);
    },
    deleteImportFieldChanged: function deleteImportFieldChanged(state, index) {
        state.importFieldChanged.splice(index, 1);
    },
    setPageScrollTop: function setPageScrollTop(state, payload) {
        state.pageScrollTop = payload;
    },
    setDialogScrollTop: function setDialogScrollTop(state, payload) {
        state.dialogScrollTop = payload;
    },
    increaseScreenResizeCount: function increaseScreenResizeCount(state, payload) {
        state.screenResizeCount += payload;
    },
    setEmailSending: function setEmailSending(state, payload) {
        state.emailSending = payload;
    },
    setFilePreview: function setFilePreview(state, payload) {
        state.filePreview = payload;
    },
    setLastClickY: function setLastClickY(state, payload) {
        state.lastClickY = payload;
    },
    setDisplayingProfileUserId: function setDisplayingProfileUserId(state, payload) {
        state.displayingProfileUserId = payload;
    },
    setDisplayingProfileUser: function setDisplayingProfileUser(state, payload) {
        state.displayingProfileUser = payload;
    },
    setDisplayingCandidateId: function setDisplayingCandidateId(state, payload) {
        state.displayingCandidateId = payload;
    },
    setDisplayingEmployerId: function setDisplayingEmployerId(state, payload) {
        state.displayingEmployerId = payload;
    },
    setDisplayingCandidate: function setDisplayingCandidate(state, payload) {
        state.displayingCandidate = payload;
    },
    setDisplayingEmployer: function setDisplayingEmployer(state, payload) {
        state.displayingEmployer = payload;
    },
    setAgent: function setAgent(state, payload) {
        state.agent = payload;
    },
    increaseLoadProfileTemplateListReqNumber: function increaseLoadProfileTemplateListReqNumber(state, payload) {
        state.loadProfileTemplateListReqNumber += payload;
    },
    increaseReloadProfileTemplateListReqNumber: function increaseReloadProfileTemplateListReqNumber(state, payload) {
        state.reloadProfileTemplateListReqNumber += payload;
    },
    increaseLoadCandidateProfileTemplateListReqNumber: function increaseLoadCandidateProfileTemplateListReqNumber(state, payload) {
        state.loadCandidateProfileTemplateListReqNumber += payload;
    },
    increaseLoadClientProfileTemplateListReqNumber: function increaseLoadClientProfileTemplateListReqNumber(state, payload) {
        state.loadClientProfileTemplateListReqNumber += payload;
    },
    setIsLoadingProfileTemplate: function setIsLoadingProfileTemplate(state, payload) {
        state.isLoadingProfileTemplate = payload;
    },
    setProfileTemplateList: function setProfileTemplateList(state, payload) {
        console.log(payload);
        if (payload == null) {
            state.profileTemplateList = [];
            state.candidateProfileTemplateList = [];
            state.clientProfileTemplateList = [];
        } else {
            state.profileTemplateList = payload;
            state.candidateProfileTemplateList = payload.filter(function (builder) {
                return builder.user_type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
            });
            state.clientProfileTemplateList = payload.filter(function (builder) {
                return builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
            });
        }
    },
    setCandidateProfileTemplateList: function setCandidateProfileTemplateList(state, payload) {
        if (payload == null) {
            state.candidateProfileTemplateList = [];
        } else {
            state.candidateProfileTemplateList = payload;
        }
    },
    setClientProfileTemplateList: function setClientProfileTemplateList(state, payload) {
        if (payload == null) {
            state.clientProfileTemplateList = [];
        } else {
            state.clientProfileTemplateList = payload;
        }
    },
    setAdminList: function setAdminList(state, payload) {
        if (payload == null) {
            state.adminList = [];
        } else {
            state.adminList = payload;
        }
    },
    setAdminSetting: function setAdminSetting(state, payload) {
        if (payload == null) {
            state.adminSetting = {};
        } else {
            state.adminSetting = payload;
        }
    },
    setContextMenu: function setContextMenu(state, payload) {
        if (payload == null) {
            state.contextMenu = {
                options: []
            };
        } else {
            state.contextMenu = payload;
        }
    },
    setOpenProfileSectionId: function setOpenProfileSectionId(state, payload) {
        state.openProfileSectionId = payload;
    },
    increaseLoadPackageListReqNumber: function increaseLoadPackageListReqNumber(state, payload) {
        state.loadPackageListReqNumber += payload;
    },
    setPackageList: function setPackageList(state, payload) {
        if (payload == null) {
            state.packageList = [];
        } else {
            state.packageList = payload;
        }
    },
    setHasMessage: function setHasMessage(state, payload) {
        state.hasMessage = payload;
    },
    setTotalNewMessage: function setTotalNewMessage(state, payload) {
        state.totalNewMessages = payload;
    },
    setTotalNewSMS: function setTotalNewSMS(state, payload) {
        state.totalNewSMS = payload;
    },
    setTotalNewTopics: function setTotalNewTopics(state, payload) {
        state.totalNewTopics = payload;
    },
    resetProfileTemplateErrors: function resetProfileTemplateErrors(state) {
        state.addProfileTemplateErrors = [];
    },
    setProfileTemplate: function setProfileTemplate(state, payload) {
        return regeneratorRuntime.async(function setProfileTemplate$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.post("/api/profiletemplates/", payload).catch(function (error) {
                            state.addProfileTemplateErrors.push(error);
                        }));

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, null, this);
    },
    setEvaluationTemplatesByUserType: function setEvaluationTemplatesByUserType(state, userType) {
        state.evaluationTemplatesList = userType;
    },
    setEvaluationTemplateErrors: function setEvaluationTemplateErrors(state, userTypeErrors) {
        state.evaluationTemplateErrors.push(userTypeErrors);
    },
    setNewFeatures: function setNewFeatures(state, payload) {
        state.newFeature = payload;
    },
    resetNoteTemplatesErrors: function resetNoteTemplatesErrors(state) {
        state.noteTemplatesErrors = [];
    },
    setNoteTemplates: function setNoteTemplates(state, notes) {
        state.noteTemplates = notes;
    },
    setNoteTemplatesErrors: function setNoteTemplatesErrors(state, error) {
        state.noteTemplatesErrors.push(error);
    },
    setWindowWidth: function setWindowWidth(state, payload) {
        state.windowWidth = payload;
    },
    setHideMenuBar: function setHideMenuBar(state, payload) {
        state.hideMenuBar = payload;
    },
    setIframePositionTop: function setIframePositionTop(state, payload) {
        state.iframePositionTop = payload;
    },
    setWindowHeight: function setWindowHeight(state, payload) {
        state.windowHeight = payload;
    },
    setIframeParentHeight: function setIframeParentHeight(state, payload) {
        state.iframeParentHeight = payload;
    },
    setIframeScaleY: function setIframeScaleY(state, payload) {
        state.iframeScaleY = payload;
    }
};

var actions = {
    setHideMenuBar: function setHideMenuBar(_ref, isHide) {
        var commit = _ref.commit;

        commit("setHideMenuBar", isHide);
    },
    addImportFieldChanged: function addImportFieldChanged(_ref2, fieldData) {
        var commit = _ref2.commit;

        commit("addImportFieldChanged", fieldData);
    },
    resetImportFieldChanged: function resetImportFieldChanged(_ref3) {
        var commit = _ref3.commit;

        commit("setImportFieldChanged");
    },
    deleteImportFieldChanged: function deleteImportFieldChanged(_ref4, index) {
        var commit = _ref4.commit;

        commit("deleteImportFieldChanged", index);
    },
    setPageScrollTop: function setPageScrollTop(_ref5, payload) {
        var commit = _ref5.commit;

        commit("setPageScrollTop", payload);
    },
    setDialogScrollTop: function setDialogScrollTop(_ref6, payload) {
        var commit = _ref6.commit;

        commit("setDialogScrollTop", payload);
    },
    increaseScreenResizeCount: function increaseScreenResizeCount(_ref7) {
        var commit = _ref7.commit;

        commit("increaseScreenResizeCount", 1);
    },
    setEmailSending: function setEmailSending(_ref8, payload) {
        var commit = _ref8.commit;

        commit("setEmailSending", payload);
    },
    setFilePreview: function setFilePreview(_ref9, payload) {
        var commit = _ref9.commit;

        commit("setFilePreview", payload);
    },
    setLastClickY: function setLastClickY(_ref10, payload) {
        var commit = _ref10.commit;

        commit("setLastClickY", payload);
    },
    setDisplayingProfileUserId: function setDisplayingProfileUserId(_ref11, payload) {
        var commit = _ref11.commit;

        commit("setDisplayingProfileUserId", payload);
    },
    setDisplayingProfileUser: function setDisplayingProfileUser(_ref12, payload) {
        var commit = _ref12.commit;

        commit("setDisplayingProfileUser", payload);
    },
    setDisplayingCandidateId: function setDisplayingCandidateId(_ref13, payload) {
        var commit = _ref13.commit;

        commit("setDisplayingCandidateId", payload);
    },
    setDisplayingEmployerId: function setDisplayingEmployerId(_ref14, payload) {
        var commit = _ref14.commit;

        commit("setDisplayingEmployerId", payload);
    },
    setDisplayingCandidate: function setDisplayingCandidate(_ref15, payload) {
        var commit = _ref15.commit;

        commit("setDisplayingCandidate", payload);
    },
    setDisplayingEmployer: function setDisplayingEmployer(_ref16, payload) {
        var commit = _ref16.commit;

        commit("setDisplayingEmployer", payload);
    },
    setAgent: function setAgent(_ref17, payload) {
        var commit = _ref17.commit;

        commit("setAgent", payload);
    },
    increaseLoadProfileTemplateListReqNumber: function increaseLoadProfileTemplateListReqNumber(_ref18, payload) {
        var commit = _ref18.commit;

        commit("increaseLoadProfileTemplateListReqNumber", payload);
    },
    increaseReloadProfileTemplateListReqNumber: function increaseReloadProfileTemplateListReqNumber(_ref19, payload) {
        var commit = _ref19.commit;

        commit("increaseReloadProfileTemplateListReqNumber", payload);
    },
    increaseLoadCandidateProfileTemplateListReqNumber: function increaseLoadCandidateProfileTemplateListReqNumber(_ref20, payload) {
        var commit = _ref20.commit;

        commit("increaseLoadCandidateProfileTemplateListReqNumber", payload);
    },
    increaseLoadClientProfileTemplateListReqNumber: function increaseLoadClientProfileTemplateListReqNumber(_ref21, payload) {
        var commit = _ref21.commit;

        commit("increaseLoadClientProfileTemplateListReqNumber", payload);
    },
    setIsLoadingProfileTemplate: function setIsLoadingProfileTemplate(_ref22, payload) {
        var commit = _ref22.commit;

        commit("setIsLoadingProfileTemplate", payload);
    },
    setProfileTemplateList: function setProfileTemplateList(_ref23, payload) {
        var commit = _ref23.commit;

        commit("setProfileTemplateList", payload);
    },
    setCandidateProfileTemplateList: function setCandidateProfileTemplateList(_ref24, payload) {
        var commit = _ref24.commit;

        commit("setCandidateProfileTemplateList", payload);
    },
    setClientProfileTemplateList: function setClientProfileTemplateList(_ref25, payload) {
        var commit = _ref25.commit;

        commit("setClientProfileTemplateList", payload);
    },
    setAdminList: function setAdminList(_ref26, payload) {
        var commit = _ref26.commit;

        commit("setAdminList", payload);
    },
    setAdminSetting: function setAdminSetting(_ref27, payload) {
        var commit = _ref27.commit;

        commit("setAdminSetting", payload);
    },
    setContextMenu: function setContextMenu(_ref28, payload) {
        var commit = _ref28.commit;

        commit("setContextMenu", payload);
    },
    setOpenProfileSectionId: function setOpenProfileSectionId(_ref29, payload) {
        var commit = _ref29.commit;

        commit("setOpenProfileSectionId", payload);
    },
    increaseLoadPackageListReqNumber: function increaseLoadPackageListReqNumber(_ref30, payload) {
        var commit = _ref30.commit;

        commit("increaseLoadPackageListReqNumber", payload);
    },
    setPackageList: function setPackageList(_ref31, payload) {
        var commit = _ref31.commit;

        commit("setPackageList", payload);
    },
    setHasMessage: function setHasMessage(_ref32, payload) {
        var commit = _ref32.commit;

        commit("setHasMessage", payload);
    },
    loadAdminList: function loadAdminList(_ref33) {
        var _this = this;

        var commit = _ref33.commit,
            state = _ref33.state,
            rootState = _ref33.rootState;

        return new Promise(function _callee(resolve) {
            var res;
            return regeneratorRuntime.async(function _callee$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(state.adminList && state.adminList.length)) {
                                _context2.next = 3;
                                break;
                            }

                            resolve();
                            return _context2.abrupt('return');

                        case 3:
                            _context2.next = 5;
                            return regeneratorRuntime.awrap(_axios2.default.get("/api/people/?is_agent=true&agency=" + rootState.authentication.agencyID.toString()));

                        case 5:
                            res = _context2.sent;

                            res.data.sort(function (x) {
                                return x.id == rootState.authentication.userId ? -1 : 0;
                            });
                            commit("setAdminList", res.data);
                            resolve();

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, null, _this);
        });
    },
    reloadAdminList: function reloadAdminList(_ref34) {
        var _this2 = this;

        var commit = _ref34.commit,
            rootState = _ref34.rootState;

        return new Promise(function _callee2(resolve) {
            var res;
            return regeneratorRuntime.async(function _callee2$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return regeneratorRuntime.awrap(_axios2.default.get("/get-users/?user_type=admins&agency=" + rootState.authentication.agencyID.toString()));

                        case 2:
                            res = _context3.sent;

                            commit("setAdminList", res.data.users);
                            resolve();

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, null, _this2);
        });
    },
    setTotalNewMessage: function setTotalNewMessage(_ref35, payload) {
        var commit = _ref35.commit;

        commit("setTotalNewMessage", payload);
    },
    setTotalNewSMS: function setTotalNewSMS(_ref36, payload) {
        var commit = _ref36.commit;

        commit("setTotalNewSMS", payload);
    },
    setTotalNewTopics: function setTotalNewTopics(_ref37, payload) {
        var commit = _ref37.commit;

        commit("setTotalNewTopics", payload);
    },
    reduceTotalNewSMS: function reduceTotalNewSMS(_ref38, payload) {
        var commit = _ref38.commit,
            state = _ref38.state;

        var newSMSCount = state.totalNewSMS - payload;
        if (newSMSCount < 0) {
            newSMSCount = 0;
        }
        commit("setTotalNewSMS", newSMSCount);
    },
    loadMessagesSummary: function loadMessagesSummary(_ref39) {
        var commit = _ref39.commit,
            rootState = _ref39.rootState;
        var res;
        return regeneratorRuntime.async(function loadMessagesSummary$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        if (!(rootState.authentication.userToken && rootState.authentication.userId)) {
                            _context4.next = 5;
                            break;
                        }

                        _context4.next = 3;
                        return regeneratorRuntime.awrap(_axios2.default.get((0, _queryHandling.appendBackgroundParam)("/chat/summary/")));

                    case 3:
                        res = _context4.sent;

                        if (res && res.data) {
                            commit("setHasMessage", res.data.has_message);
                            commit("setTotalNewMessage", res.data.count_new_messages);
                            commit('setTotalNewSMS', res.data.count_new_sms);
                            commit('setTotalNewTopics', res.data.count_new_topics);
                        }

                    case 5:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, null, this);
    },
    addProfileTemplate: function addProfileTemplate(_ref40, template) {
        var commit = _ref40.commit;

        commit("resetProfileTemplateErrors");
        commit("setProfileTemplate", template);
    },
    getNotesByUserType: function getNotesByUserType(_ref41, userType) {
        var commit = _ref41.commit,
            rootGetters = _ref41.rootGetters;
        var res;
        return regeneratorRuntime.async(function getNotesByUserType$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get('get-notes?agency=' + rootGetters.agencyID + '&type=user_' + userType));

                    case 2:
                        res = _context5.sent;

                        if (!(res && res.data)) {
                            _context5.next = 5;
                            break;
                        }

                        return _context5.abrupt('return', res.data.notes);

                    case 5:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, null, this);
    },
    getEvaluationTemplatesByUserType: function getEvaluationTemplatesByUserType(_ref42, userType) {
        var commit = _ref42.commit,
            rootState = _ref42.rootState;
        var url;
        return regeneratorRuntime.async(function getEvaluationTemplatesByUserType$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        url = '/api/evaluationtemplates/?agency=' + rootState.authentication.agencyID;

                        if (userType) {
                            url = url + '&user_type=' + userType;
                        }
                        _context6.next = 4;
                        return regeneratorRuntime.awrap(_axios2.default.get(url).then(function (res) {
                            commit("setEvaluationTemplatesByUserType", res.data);
                        }).catch(function (error) {
                            commit("setEvaluationTemplateErrors", error.message);
                        }));

                    case 4:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, null, this);
    },
    addEvaluationTemplateToUser: function addEvaluationTemplateToUser(_ref43, template) {
        var commit = _ref43.commit;
        return regeneratorRuntime.async(function addEvaluationTemplateToUser$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.post("/api/evaluations/", template).catch(function (error) {
                            commit("setEvaluationTemplateErrors", error.message);
                        }));

                    case 2:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, null, this);
    },
    fetchFeatures: function fetchFeatures(_ref44) {
        var commit = _ref44.commit;

        return new Promise(function (resolve, reject) {
            _axios2.default.get("/api/bank_features").then(function (response) {
                if (response.status == 200) {
                    commit('setNewFeatures', response.data);
                    resolve(response);
                }
            }).catch(function (err) {
                reject(err);
            });
        });
    },
    getNoteTemplatesByType: function getNoteTemplatesByType(_ref45, templateSelector) {
        var commit = _ref45.commit,
            rootGetters = _ref45.rootGetters;
        return regeneratorRuntime.async(function getNoteTemplatesByType$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        commit("resetNoteTemplatesErrors");
                        _context8.next = 3;
                        return regeneratorRuntime.awrap(_axios2.default.get('/api/richtemplates/?agency=' + rootGetters.agencyID.toString() + '&selector2=' + templateSelector).then(function (res) {
                            commit("setNoteTemplates", res.data);
                        }).catch(function (error) {
                            commit("setNoteTemplatesErrors", error.message);
                        }));

                    case 3:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, null, this);
    },
    setWindowWidth: function setWindowWidth(_ref46, payload) {
        var commit = _ref46.commit;

        commit('setWindowWidth', payload);
    },
    getUserDetailsById: function getUserDetailsById(_ref47, userId) {
        var _this3 = this;

        var commit = _ref47.commit;

        if (!userId) {
            return null;
        }
        return new Promise(function _callee3(resolve) {
            return regeneratorRuntime.async(function _callee3$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            _context9.next = 2;
                            return regeneratorRuntime.awrap(_axios2.default.get('/api/people/' + userId + '/').then(function (res) {
                                if (res && res.data) {
                                    resolve(res.data);
                                }
                            }).catch(function (error) {
                                reject();
                            }));

                        case 2:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, null, _this3);
        });
    },
    setIframePositionTop: function setIframePositionTop(_ref48, payload) {
        var commit = _ref48.commit;

        commit('setIframePositionTop', payload);
    },
    setWindowHeight: function setWindowHeight(_ref49, payload) {
        var commit = _ref49.commit;

        commit('setWindowHeight', payload);
    },
    setIframeParentHeight: function setIframeParentHeight(_ref50, payload) {
        var commit = _ref50.commit;

        commit('setIframeParentHeight', payload);
    },
    setIframeScaleY: function setIframeScaleY(_ref51, payload) {
        var commit = _ref51.commit;

        commit('setIframeScaleY', payload);
    }
};

var getters = {
    getImportFieldChanged: function getImportFieldChanged(state) {
        return (0, _tryGet2.default)(function () {
            return state.importFieldChanged;
        }) || '';
    },
    profileTemplateErrors: function profileTemplateErrors(state) {
        return (0, _tryGet2.default)(function () {
            return state.addProfileTemplateErrors;
        }) || [];
    },
    evaluationTemplatesList: function evaluationTemplatesList(state) {
        return (0, _tryGet2.default)(function () {
            return state.evaluationTemplatesList;
        }) || [];
    },
    evaluationTemplateErrors: function evaluationTemplateErrors(state) {
        return (0, _tryGet2.default)(function () {
            return state.evaluationTemplateErrors;
        }) || [];
    },
    noteTemplates: function noteTemplates(state) {
        return (0, _tryGet2.default)(function () {
            return state.noteTemplates;
        }) || [];
    },
    noteTemplatesErrors: function noteTemplatesErrors(state) {
        return (0, _tryGet2.default)(function () {
            return state.noteTemplatesErrors;
        }) || [];
    },
    pageScrollTop: function pageScrollTop(state) {
        return state.pageScrollTop;
    },
    dialogScrollTop: function dialogScrollTop(state) {
        return state.dialogScrollTop;
    },
    hourOptions: function hourOptions(state) {
        return state.hourOptions;
    },
    minuteOptions: function minuteOptions(state) {
        return state.minuteOptions;
    },
    minuteOptionsByFive: function minuteOptionsByFive(state) {
        return state.minuteOptionsByFive;
    },
    minuteOptionsByFifteen: function minuteOptionsByFifteen(state) {
        return state.minuteOptionsByFifteen;
    },
    ampmOptions: function ampmOptions(state) {
        return state.ampmOptions;
    },
    lastClickY: function lastClickY(state) {
        return state.lastClickY;
    },
    agent: function agent(state) {
        return state.agent;
    },
    profileTemplateList: function profileTemplateList(state) {
        return state.profileTemplateList;
    },
    candidateProfileTemplateList: function candidateProfileTemplateList(state) {
        return state.candidateProfileTemplateList;
    },
    clientProfileTemplateList: function clientProfileTemplateList(state) {
        return state.clientProfileTemplateList;
    },
    isLoadingProfileTemplate: function isLoadingProfileTemplate(state) {
        return state.isLoadingProfileTemplate;
    },
    adminList: function adminList(state) {
        return state.adminList || [];
    },
    adminSetting: function adminSetting(state) {
        return state.adminSetting;
    },
    listTempHelpIdHidden: function listTempHelpIdHidden(state) {
        var adminSetting = state.adminSetting;
        if (!adminSetting || !adminSetting.setting) {
            return [];
        }
        return adminSetting.setting.list_temp_help_id_hidden || [];
    },
    contextMenu: function contextMenu(state) {
        return state.contextMenu;
    },
    packageList: function packageList(state) {
        return state.packageList;
    },
    listDaysOfWeek: function listDaysOfWeek(state) {
        return state.listDaysOfWeek;
    },
    monthNumbers: function monthNumbers(state) {
        return state.monthNumbers;
    },
    upcomingYears: function upcomingYears(state) {
        return state.upcomingYears;
    },
    hasMessage: function hasMessage(state) {
        return state.hasMessage;
    },
    totalNewMessages: function totalNewMessages(state) {
        return state.totalNewMessages;
    },
    totalNewSMS: function totalNewSMS(state) {
        return state.totalNewSMS;
    },
    totalNewTopics: function totalNewTopics(state) {
        return state.totalNewTopics;
    },
    minutesIntervalOptionList: function minutesIntervalOptionList(state) {
        return state.minutesIntervalOptionList;
    },
    languageDashboardOptions: function languageDashboardOptions(state) {
        return state.languageDashboardOptions;
    },
    dashboardLanguage: function dashboardLanguage(state, getters, rootState) {
        var agency = rootState.agency.agencyPublic;
        if (agency.public_advance_setting) {
            var result = agency.public_advance_setting.dashboard_language;
            if (result) {
                return result;
            }
        }
        return "English"; // Default is english
    },
    getNewFeatures: function getNewFeatures(state) {
        return state.newFeature;
    },
    adminOptionList: function adminOptionList(state) {
        if (!state.adminList) {
            return [];
        }
        return state.adminList.map(function (admin) {
            return {
                label: admin.first_name + ' ' + admin.last_name + ' - ' + admin.email,
                id: admin.id,
                email: admin.email
            };
        });
    },
    adminOptionListByEmail: function adminOptionListByEmail(state) {
        if (!state.adminList) {
            return [];
        }
        return state.adminList.map(function (admin) {
            return {
                label: admin.first_name + ' ' + admin.last_name + ' - ' + admin.email,
                model: admin.email
            };
        });
    },
    windowWidth: function windowWidth(state) {
        return state.windowWidth;
    },
    isMobileScreen: function isMobileScreen(state) {
        return state.windowWidth <= 768;
    },
    hideMenuBar: function hideMenuBar(state) {
        return state.hideMenuBar;
    },
    iframePositionTop: function iframePositionTop(state) {
        return state.iframePositionTop;
    },
    windowHeight: function windowHeight(state) {
        return state.windowHeight;
    },
    iframeScaleY: function iframeScaleY(state) {
        return state.iframeScaleY;
    },
    iframeParentHeight: function iframeParentHeight(state) {
        return state.iframeParentHeight;
    }
};

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _router = __webpack_require__(103);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(136);

var _store2 = _interopRequireDefault(_store);

var _urlParams = __webpack_require__(65);

var _defaultValues = __webpack_require__(17);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lecture 364
var state = {
  userToken: null,
  userId: null,
  isAgent: null,
  isCandidate: null,
  isEmployer: null,
  userEmail: null,
  // userProfile: null,
  // agencyID: 20,
  // agencyName: 'GoldCoastNannies',
  agencyID: null,
  agencyName: "",
  agency: {},
  userProfile: {},
  loggedinUser: null,
  listJobIdFillers: [], // List of job ID the current login user (candidate only) is assigned to (in case of multi-filler = true)
  stripeAccountID: "" //
};

var mutations = {
  authUser: function authUser(state, userData) {
    console.log("Storing Authentication Data");
    state.userToken = userData.token;
    state.userId = userData.user_id;
    state.isAgent = userData.is_agent;
    state.isCandidate = userData.is_candidate;
    state.isEmployer = userData.is_employer;
    state.agencyID = userData.agency_id;
    state.agencyName = userData.agency_owner;
    state.userEmail = userData.email;
    if (userData.agency) {
      state.agency = userData.agency;
    }
  },
  storeUser: function storeUser(state, userData) {
    state.userProfile = userData;
  },
  clearAuthData: function clearAuthData(state) {
    state.userToken = null;
    // state.userProfile = null
    state.userId = null;
    state.isAgent = null;
    state.isCandidate = null;
    state.isEmployer = null;
    state.loggedinUser = null;
  },
  setAgency: function setAgency(state, agency) {
    state.agency = agency;
  },
  setAgencyID: function setAgencyID(state, payload) {
    state.agencyID = payload;
  },
  setLoggedinUser: function setLoggedinUser(state, payload) {
    state.loggedinUser = payload;
  },
  setListJobIdFillers: function setListJobIdFillers(state, payload) {
    state.listJobIdFillers = payload;
  }
};

var actions = {
  setAgencyID: function setAgencyID(_ref, payload) {
    var commit = _ref.commit;

    commit("setAgencyID", payload);
  },
  setAgency: function setAgency(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setAgency", payload);
  },
  setListJobIdFillers: function setListJobIdFillers(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setListJobIdFillers", payload);
  },
  setLoggedinUser: function setLoggedinUser(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    commit("setLoggedinUser", payload);
    dispatch("loadMessagesSummary", null, { root: true });
  },
  tryAutoLogin: function tryAutoLogin(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    // Lecture 366
    var stored_token = localStorage.getItem("token");
    if (!stored_token) {
      return;
    }
    // const expirationDate = localStorage.getItem('expirationDate')
    // const now = new Date()
    // if (now >= expirationDate) {
    //   return
    // }
    var is_agent = false;
    var is_candidate = false;
    var is_employer = false;
    var stored_user_id = Number(localStorage.getItem("user_id"));
    var stored_is_agent = localStorage.getItem("is_agent");
    if (stored_is_agent === "true") {
      is_agent = true;
    }
    var stored_is_candidate = localStorage.getItem("is_candidate");
    if (stored_is_candidate === "true") {
      is_candidate = true;
    }
    var stored_is_employer = localStorage.getItem("is_employer");
    if (stored_is_employer === "true") {
      is_employer = true;
    }
    var stored_agency_id = localStorage.getItem("agency_id");
    var stored_agency_owner = localStorage.getItem("agency_owner");
    var stored_agency = localStorage.getItem("agency");
    var user_email = localStorage.getItem("user_email");

    commit("authUser", {
      token: stored_token,
      user_id: stored_user_id,
      is_agent: is_agent,
      is_candidate: is_candidate,
      is_employer: is_employer,
      agency_id: stored_agency_id,
      agency_owner: stored_agency_owner,
      agency: stored_agency,
      email: user_email
    });

    dispatch("increaseReloadAgencyReqNumber", 1); // Load agency data
    dispatch("loadRecentAccessLog");
  },
  saveAuthUser: function saveAuthUser(_ref6, payload) {
    var commit = _ref6.commit;

    var agencyID = payload.agency_id;
    var agencyName = payload.agency_name;
    commit("authUser", {
      token: payload.token,
      user_id: payload.user_id,
      is_agent: payload.is_agent,
      is_candidate: payload.is_candidate,
      is_employer: payload.is_employer,
      agency_id: agencyID,
      agency_owner: agencyName,
      email: payload.email,
      category: payload.category
    });
    // Need to save both of these for the authUser mutation
    try {
      localStorage.setItem("token", payload.token); // Lecture 366
      localStorage.setItem("user_id", payload.user_id);
      localStorage.setItem("is_agent", payload.is_agent);
      localStorage.setItem("is_candidate", payload.is_candidate);
      localStorage.setItem("is_employer", payload.is_employer);
      localStorage.setItem("agency_id", agencyID);
      localStorage.setItem("agency_owner", agencyName);
      localStorage.setItem("user_email", payload.email);
      localStorage.setItem("admin_category", payload.category);
    } catch (error) {
      console.log(error);
    }
  },
  login: function login(_ref7, authData) {
    var _this = this;

    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    // Reset some lists (in case user login for user of another agency)
    dispatch("setPriceList", null, { root: true });
    dispatch("setAvailabilities", null, { root: true });
    dispatch("setWeekAvailabilities", null, { root: true });
    dispatch("setCandidateListMainInfo", null, { root: true });
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    console.log(authData);
    var hide_error = authData.hide_error ? true : false;
    return new Promise(function (resolve, reject) {
      _axios2.default.post("/api-token-auth/?" + _urlParams.PARAM_LOGIN + "&" + _urlParams.PARAM_HIDE_ERROR_MODAL + "=" + hide_error, {
        username: authData.email,
        password: authData.password,
        // agency: state.agencyID,
        agency: authData.agency,
        force: authData.force
      }).then(function _callee(res) {
        var agencyID;
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("Successful Login");

                if (res) {
                  _context.next = 4;
                  break;
                }

                resolve("failed");
                return _context.abrupt("return");

              case 4:
                if (!(res.response && res.response.status == 409)) {
                  _context.next = 7;
                  break;
                }

                resolve("multi-login");
                return _context.abrupt("return");

              case 7:

                // In case user just created, it response default agencyID, we need to load old agency
                agencyID = res.data.agency_id;

                if (agencyID === 1 && state.agencyID) {
                  agencyID = state.agencyID;
                }
                commit("authUser", {
                  token: res.data.token,
                  user_id: res.data.user_id,
                  is_agent: res.data.is_agent,
                  is_candidate: res.data.is_candidate,
                  is_employer: res.data.is_employer,
                  agency_id: agencyID,
                  agency_owner: res.data.agency_owner,
                  email: res.data.email
                });
                dispatch("loadRecentAccessLog");
                // Need to save both of these for the authUser mutation
                try {
                  localStorage.setItem("token", res.data.token); // Lecture 366
                  localStorage.setItem("user_id", res.data.user_id);
                  localStorage.setItem("is_agent", res.data.is_agent);
                  localStorage.setItem("is_candidate", res.data.is_candidate);
                  localStorage.setItem("is_employer", res.data.is_employer);
                  localStorage.setItem("agency_id", agencyID);
                  localStorage.setItem("agency_owner", res.data.agency_owner);
                  localStorage.setItem("user_email", res.data.email);
                } catch (error) {
                  console.log(error);
                }

                if (res.data.agency_id != 1) {
                  // The agency ID is 1 when doing the login on registration, because the agency ID hasn't been set yet
                  dispatch("increaseReloadAgencyReqNumber", 1); // Load agency data
                }

                // const now = new Date()
                // const expirationDate = new Date(now.getTime() + 3600000) // Covert the date to milliseconds, add an hour, then convert back to a date
                // localStorage.setItem('expirationDate', expirationDate)
                resolve("sucess");

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, null, _this);
      })
      // Problem logging in, likely incorrect email or password, or account doesn't exist
      .catch(function (error) {
        console.log(error);
        resolve("failed");
      });
    });
  },
  updateUser: function updateUser(_ref8, payload) {
    var commit = _ref8.commit;
    var res;
    return regeneratorRuntime.async(function updateUser$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return regeneratorRuntime.awrap(_axios2.default.patch("/api/people/" + payload.userId, payload.body));

          case 2:
            res = _context2.sent;

            if (res && res.data) {
              commit("setLoggedinUser", res.data);
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, null, this);
  },
  logout: function logout(_ref9, redirect) {
    var commit = _ref9.commit;

    commit("clearAuthData");
    // router.replace('/login') // After someone logs out send them to the login page - Lecture 364
    // router.push({name: 'Login'}) // https://router.vuejs.org/guide/essentials/navigation.html
    if (redirect != "no-redirect") {
      _router2.default.push({ name: "Login", params: { agencyID: state.agencyID } }).catch(function () {}); // https://router.vuejs.org/guide/essentials/navigation.html
    }

    // When someone logs out we want to clear their auth details from the browser, so they have to log back in - Lecture 366
    // localStorage.removeItem('expirationDate')
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("is_agent");
      localStorage.removeItem("agency_id");
      localStorage.removeItem("agency_owner");
      localStorage.removeItem("agency");
      localStorage.removeItem("user_email");
      localStorage.removeItem("show_app_popup");
    } catch (error) {
      console.log(error);
    }
  },
  loadLoggedinUser: function loadLoggedinUser(_ref10) {
    var _this2 = this;

    var commit = _ref10.commit,
        state = _ref10.state;

    return new Promise(function _callee2(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (state.userId) {
                _context3.next = 3;
                break;
              }

              resolve();
              return _context3.abrupt("return");

            case 3:
              if (!state.loggedinUser) {
                _context3.next = 6;
                break;
              }

              resolve();
              return _context3.abrupt("return");

            case 6:
              _context3.next = 8;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + state.userId));

            case 8:
              res = _context3.sent;

              if (res && res.data) {
                commit("setLoggedinUser", res.data);
              }
              resolve();

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, null, _this2);
    });
  },
  test: function test(_ref11) {
    var commit = _ref11.commit;

    console.log("Test successful.");
  },
  getAgency: function getAgency(_ref12, agencyID) {
    var commit = _ref12.commit;

    //
    // This updates the global agency object for use throughout
    // Initially set up for getting the agency on registration for a direct redirect to the user dashboard (for some reason the agency object was not being set on login)
    //
    console.log(agencyID);
    _axios2.default.get("/api/agencies/?id=" + agencyID).then(function (res) {
      state.agency = res.data[0];
      try {
        localStorage.setItem("agency", res.data[0]);
        console.log(res.data[0]);
      } catch (error) {
        console.log(error);
      }
    }).catch(function (error) {
      return console.log(error);
    });
  }
};

var getters = {
  clientSelfSelectsCandidateForShiftJobEmails: function clientSelfSelectsCandidateForShiftJobEmails(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.client_self_selects_candidate_for_shift_job_emails;
    }) || [];
  },
  hideMileageQuestion: function hideMileageQuestion(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.hide_mileage_question;
    }) || false;
  },
  hideReimbursementQuestion: function hideReimbursementQuestion(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.hide_reimbursement_question;
    }) || false;
  },
  disableCandidateAssignManagerEmail: function disableCandidateAssignManagerEmail(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.disable_candidate_assign_manager_email;
    }) || false;
  },
  selectedTimeSheetTableColumns: function selectedTimeSheetTableColumns(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.time_sheet_table_columns;
    }) || [];
  },
  showSquareProfilePic: function showSquareProfilePic(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.public_advance_setting.show_square_profile_pic;
    }) || false;
  },
  showIdClientSideShiftJobCalendar: function showIdClientSideShiftJobCalendar(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.show_id_client_side_shift_job_calendar;
    }) || false;
  },
  clientTableTypesColorList: function clientTableTypesColorList(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.client_table_types_color;
    }) || [];
  },
  clientTableTagsColorList: function clientTableTagsColorList(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.client_table_tags_color;
    }) || [];
  },
  candidateTableTypesColorList: function candidateTableTypesColorList(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.candidate_table_types_color;
    }) || [];
  },
  candidateTableTagsColorList: function candidateTableTagsColorList(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.candidate_table_tags_color;
    }) || [];
  },
  candidateMarkedAsFavoriteDoNotWantAgain: function candidateMarkedAsFavoriteDoNotWantAgain(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.candidate_marked_as_favorite_do_not_want_again;
    }) || [];
  },
  useHomeScreen: function useHomeScreen(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.public_advance_setting.use_new_home_screen;
    }) || false;
  },
  usingExperiencesAsReference: function usingExperiencesAsReference(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.public_advance_setting.using_experience_as_reference;
    }) || false;
  },
  useCandidateCommunity: function useCandidateCommunity(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.public_advance_setting.use_candidate_community;
    }) || false;
  },
  getAgentClassification: function getAgentClassification(state) {
    return (0, _tryGet2.default)(function () {
      return state.agentClassification;
    });
  },
  showPriceManagerOnAdministratorsTable: function showPriceManagerOnAdministratorsTable(state) {
    return (0, _tryGet2.default)(function () {
      return state.agency.advance_setting.show_price_manager_on_administrators_table;
    }) || false;
  },
  userID: function userID(state) {
    return state.userId;
  },
  userToken: function userToken(state) {
    return state.userToken;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.userToken !== null;
  },
  isAgent: function isAgent(state) {
    return state.isAgent;
  },
  isCandidate: function isCandidate(state) {
    return state.isCandidate;
  },
  isEmployer: function isEmployer(state) {
    return state.isEmployer;
  },
  userAPIURL: function userAPIURL(state) {
    return "/api/people/".concat(state.userId.toString()).concat("/");
  },
  agencyID: function agencyID(state) {
    return state.agencyID;
  },
  agencyName: function agencyName(state) {
    return state.agencyName;
  },
  agency: function agency(state) {
    return state.agency;
  },
  stripeAccountID: function stripeAccountID(state) {
    return state.stripeAccountID;
  },
  userEmail: function userEmail(state) {
    return state.userEmail;
  },
  loggedinUser: function loggedinUser(state) {
    return state.loggedinUser;
  },
  listJobIdFillers: function listJobIdFillers(state) {
    return state.listJobIdFillers;
  },
  userSettings: function userSettings(state) {
    return state.userSettings;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(136);

var _store2 = _interopRequireDefault(_store);

var _regex = __webpack_require__(46);

var _queryHandling = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Parse list email (If it is a String separated by ;, convert to list)
var convertEmailList = function convertEmailList(inputString) {
  var listEmail = [];
  if (inputString) {
    if (Array.isArray(inputString)) {
      listEmail = inputString;
    } else if (typeof inputString === 'string') {
      listEmail = inputString.split(';').map(function (email) {
        return email.trim();
      }).filter(function (email) {
        return email.length;
      });
    }
  }
  return listEmail.join(',');
};

var state = {
  // agencyFromEmail: 'householdstaffingjobs@enginehire.io',
  agencyFromEmail: "agency@enginehire.io",
  enginehireFromEmail: "agency@enginehire.io", // If an email is coming from Enginehire (from the platform, as opposed to the agency), this is the email it will come from
  agencyReplyEmail: "",
  enginehireReplyEmail: "aakash@enginehire.ca", // If someone replies to an email from Enginehire, this is where the reply should go
  enginehireAdminEmail: "aakash@enginehire.ca",
  enginehireLoggingEmail: 'enginehirelogs@gmail.com',

  agencyAdminEmail: "aakash@enginehire.io",
  agencyAdminEmail2: "aakash@enginehire.io"
};

var mutations = {
  setAgencyFromEmail: function setAgencyFromEmail(state, payload) {
    state.agencyFromEmail = payload;
  },
  setAgencyReplyEmail: function setAgencyReplyEmail(state, payload) {
    state.agencyReplyEmail = payload;
  },
  setAgencyAdminEmail: function setAgencyAdminEmail(state, payload) {
    state.agencyAdminEmail = payload;
  },
  setAgencyAdminEmail2: function setAgencyAdminEmail2(state, payload) {
    state.agencyAdminEmail2 = payload;
  }
};

var actions = {
  setAgencyEmails: function setAgencyEmails(_ref, payload) {
    var commit = _ref.commit;

    if (payload.fromEmail && _regex.REGEX_VALIDATE_EMAIL.test(payload.fromEmail)) {
      commit("setAgencyFromEmail", payload.fromEmail);
    }
    if (payload.replyEmail && _regex.REGEX_VALIDATE_EMAIL.test(payload.replyEmail)) {
      commit("setAgencyReplyEmail", payload.replyEmail);
    }
    if (payload.adminEmail && _regex.REGEX_VALIDATE_EMAIL.test(payload.adminEmail)) {
      commit("setAgencyAdminEmail", payload.adminEmail);
      commit("setAgencyAdminEmail2", payload.adminEmail2);
    }
  },
  sendEmail: function sendEmail(_ref2, emailInfo) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    console.log(emailInfo);
    // console.log(emailInfo.userID);

    var message = emailInfo.message;
    // If we are sending an html email we want to add the tags and the footer
    if (emailInfo.html) {
      message = "<html><head></head><body>" + emailInfo.message +
      // '<img src="https://s3-us-west-1.amazonaws.com/trustednannymatch.enginehire.io/Deniz+Hanson_Canva+signature+PNG2.png"></body></html>';
      "</body></html>";
    }
    // Parse list CC (If it is a String separated by ;, convert to list)
    var listCC = convertEmailList(emailInfo.cc);
    // Parse list BCC (If it is a String separated by ;, convert to list)
    var listBcc = convertEmailList(emailInfo.bcc);

    _axios2.default.post("/optimum/email/", {
      subject: emailInfo.subject,
      // message: emailInfo.message,
      message: message,
      file_urls: emailInfo.file_urls,
      from_address: emailInfo.from,
      to_address: emailInfo.email,
      reply_address: emailInfo.reply || emailInfo.from,
      user_id: emailInfo.userID,
      reference_id: emailInfo.referenceID,
      cc: listCC,
      bcc: listBcc,
      log: true,
      agency_id: _store2.default.getters.agencyID,
      type: emailInfo.type
    }).then(function (res) {
      console.log("Email Sent");
      console.log(res);
    }).catch(function (error) {
      return console.log(error);
    });
  },
  sendEmailSync: function sendEmailSync(_ref3, emailInfo) {
    var _this = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new Promise(function _callee(resolve) {
      var message, listCC, listBcc;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(emailInfo);
              // console.log(emailInfo.userID);

              message = emailInfo.message;
              // If we are sending an html email we want to add the tags and the footer

              if (emailInfo.html) {
                message = "<html><head></head><body>" + emailInfo.message +
                // '<img src="https://s3-us-west-1.amazonaws.com/trustednannymatch.enginehire.io/Deniz+Hanson_Canva+signature+PNG2.png"></body></html>';
                "</body></html>";
              }
              // Parse list CC (If it is a String separated by ;, convert to list)
              listCC = convertEmailList(emailInfo.cc);
              // Parse list BCC (If it is a String separated by ;, convert to list)

              listBcc = convertEmailList(emailInfo.bcc);
              _context.next = 7;
              return regeneratorRuntime.awrap(_axios2.default.post("/optimum/email/", {
                subject: emailInfo.subject,
                // message: emailInfo.message,
                message: message,
                file_urls: emailInfo.file_urls,
                from_address: emailInfo.from,
                to_address: emailInfo.email,
                reply_address: emailInfo.reply || emailInfo.from,
                user_id: emailInfo.userID,
                reference_id: emailInfo.referenceID,
                cc: listCC,
                bcc: listBcc,
                log: true,
                agency_id: _store2.default.getters.agencyID,
                type: emailInfo.type
              }));

            case 7:
              resolve();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    });
  },
  sendEmails: function sendEmails(_ref4, emailInfo) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    //
    // Send the same email to a list of several emails
    //
    // console.log(emailInfo.emails);
    // console.log(emailInfo.userID);

    // Parse list CC (If it is a String separated by ;, convert to list)
    var listCCOriginal = convertEmailList(emailInfo.cc);
    // Parse list BCC (If it is a String separated by ;, convert to list)
    var listBccOriginal = convertEmailList(emailInfo.bcc);

    for (var emailIndex in emailInfo.emails) {
      if (emailInfo.emails[emailIndex] === state.enginehireLoggingEmail) {
        continue;
      }
      // console.log(emailInfo.emails)
      // console.log(emailIndex)
      // console.log(emailInfo.emails[emailIndex])

      var message = emailInfo.message;
      // If we are sending an html email we want to add the tags and the footer
      if (emailInfo.html) {
        message = "<html><head></head><body>" + emailInfo.message +
        // '<img src="https://s3-us-west-1.amazonaws.com/trustednannymatch.enginehire.io/Deniz+Hanson_Canva+signature+PNG2.png"></body></html>';
        "</body></html>";
      }

      // Don't use CC, BCC option if sending email to enginehire log
      var listCC = listCCOriginal;
      var listBcc = listBccOriginal;
      var url = "/optimum/email/";
      if (emailInfo.in_background) {
        url = (0, _queryHandling.appendBackgroundParam)(url);
      }
      _axios2.default.post(url, {
        subject: emailInfo.subject,
        // message: emailInfo.message,
        message: message,
        file_urls: emailInfo.file_urls,
        from_address: emailInfo.from,
        to_address: emailInfo.emails[emailIndex],
        reply_address: emailInfo.reply || emailInfo.from,
        user_id: emailInfo.userID,
        reference_id: emailInfo.referenceID,
        cc: listCC,
        bcc: listBcc,
        log: true,
        agency_id: _store2.default.getters.agencyID,
        type: emailInfo.type,
        status: emailInfo.status,
        countdown: emailInfo.countdown
      }).then(function (res) {
        console.log("Email Sent to " + res.data.email);
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },
  logEmail: function logEmail(_ref5, emailInfo) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    console.log("Logging Email");
    console.log(emailInfo);
    console.log(emailInfo.to_address);
    console.log(_store2.default.getters.userID);
    if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) {
      // Don't want to log emails sent to enginehire admin or logging
      _axios2.default.post("/api/emaillogs/", {
        recipient: emailInfo.user_id,
        sender: _store2.default.getters.userID,
        subject: emailInfo.subject,
        body: emailInfo.message,
        to_email: emailInfo.to_address,
        from_email: emailInfo.from_address,
        reply_email: emailInfo.reply_address,
        recipient_name: emailInfo.recipient_name,
        job: emailInfo.job,
        type: emailInfo.type,
        cc: emailInfo.cc,
        bcc: emailInfo.bcc,
        agency_owner: _store2.default.getters.agencyName,
        agency: _store2.default.getters.agencyID
      }).then(function (res) {
        console.log(res);
        console.log("Email logged!");
      }).catch(function (error) {
        return console.log(error);
      });
    }
  },


  // sendAndLogEmail({ commit, dispatch }, emailInfo) {
  //   console.log("Logging Email");
  //   console.log(emailInfo);
  //   console.log(emailInfo.to_address);
  //   console.log(store.getters.userID);
  //   // if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) {
  //     // Don't want to log emails sent to enginehire admin or logging
  //     axios
  //       // .post("/api/emaillogs/", {
  //       .post("/send-and-log-email/", {
  //         recipient: emailInfo.user_id ? emailInfo.user_id : null,
  //         sender: store.getters.userID ? store.getters.userID : null,
  //         subject: emailInfo.subject ? emailInfo.subject : '',
  //         body: emailInfo.message ? emailInfo.message: '',
  //         to_email: emailInfo.to_address ? emailInfo.to_address : '',
  //         from_email: emailInfo.from_address ? emailInfo.from_address : '',
  //         reply_email: emailInfo.reply_address ? emailInfo.reply_address : '',
  //         recipient_name: emailInfo.recipient_name ? emailInfo.recipient_name : '',
  //         job: emailInfo.job ? emailInfo.job : null,
  //         type: emailInfo.type ? emailInfo.type : '',
  //         agency_owner: store.getters.agencyName ? store.getters.agencyName : '',
  //         agency: store.getters.agencyID ? store.getters.agencyID : null
  //       })
  //       .then(res => {
  //         console.log(res);
  //         console.log("Email Sent and logged!");
  //       })
  //       .catch(error => console.log(error));
  //   // }
  // },

  sendSMS: function sendSMS(_ref6, SMSInfo) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    console.log(SMSInfo);
    _axios2.default.post("/optimum/message/", {
      message: SMSInfo.textMessage,
      phone: SMSInfo.phone,
      user_id: SMSInfo.id,
      from_phone: SMSInfo.from_phone ? SMSInfo.from_phone : "",
      job_id: SMSInfo.jobId,
      log: true
    }).then(function (res) {
      console.log('SMS Sent');
      console.log(res);
    }).catch(function (error) {
      return console.log(error);
    });
  }
};

var getters = {
  agencyFromEmail: function agencyFromEmail(state) {
    return state.agencyFromEmail;
  },
  agencyReplyEmail: function agencyReplyEmail(state) {
    return state.agencyReplyEmail;
  },
  enginehireFromEmail: function enginehireFromEmail(state) {
    return state.agencyFromEmail;
  },
  enginehireReplyEmail: function enginehireReplyEmail(state) {
    return state.agencyReplyEmail;
  },
  enginehireAdminEmail: function enginehireAdminEmail(state) {
    return state.enginehireAdminEmail;
  },
  enginehireLoggingEmail: function enginehireLoggingEmail(state) {
    return state.enginehireLoggingEmail;
  },
  agencyAdminEmail: function agencyAdminEmail(state) {
    return state.agencyAdminEmail;
  },
  agencyAdminEmail2: function agencyAdminEmail2(state) {
    return state.agencyAdminEmail2;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  transportationConsent: '<p>We, <strong>the Parents </strong>of<strong> the Children</strong>, do hereby authorize and direct the scheduled employee of The Nanny Company to transport our child(ren) to and from the frequent pick-up points and/or any other designated destinations, within reason. All transportation is to be consented of in advance by the parents.</p><p></p><p>Further, the Employee has agreed to comply with the Employee Handbook, including that there will be no cell phone use while driving with the child/ren, they have a valid drivers license, and will regularly maintain the reliable vehicle, with the appropriate insurance. The Clients will ensure the car seats are installed properly and the Employee will use them accordingly.</p><p></p><p>We understand and acknowledge that The Nanny Company Inc. assumes no responsibility, obligation or liability of any kind.</p>',
  useofClientVehicle: '<p>Whereas the Client has retained The Nanny Company (“TNC”) to provide care for the Client’s child(ren) (the “services”), which services are provided by qualified employees of the Company and governed by a contract for services between the Client and TNC;&nbsp;</p><p></p><p>And whereas the Employee is subject to an employment agreement and TNC’s policies and employee handbook;&nbsp;</p><p></p><p>The Client and TNC agree as follows:&nbsp;</p><p></p><ol><li><p>The Client expressly authorizes the Employee to use the Client’s vehicle(s) in order to transport the Client’s child(ren) as may be required during the performance of the services.&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will have no liability to the Client or any other party for any loss, damage or injury (whether direct, indirect, or consequential) occasioned by any act or omission of the Employee in operating the vehicle(s). The Client agrees that it will indemnify TNC for any claim or action against TNC in respect of the Employee’s use of the vehicle(s).&nbsp;</p></li><li><p>The Client acknowledges and agrees that the vehicle(s) will be in good working condition and the Client is responsible for maintaining insurance for the vehicle(s). The Client must provide proof of valid insurance to TNC upon the signing of this agreement. The Client acknowledges and agrees that it is responsible for maintaining the vehicle(s), repairing any damage to the vehicle(s), and paying any deductible that may be required in respect of the vehicle(s).&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will not be responsible for any driving violations, parking tickets, and traffic tickets (whether by photo radar or otherwise) that may be incurred are a result of the Employee using the vehicle(s).&nbsp;</p></li><li><p>The Client may revoke its authorization and/or consent to have the Employee use the vehicle(s), on notice to TNC. All communication in respect of these matters shall be between the Client and TNC.&nbsp;</p></li><li><p>TNC retains the right to revoke its agreement to allow the Employee to use the vehicle(s), without notice and in the sole discretion of TNC, following which revocation the prohibition of the use of the vehicle(s) will immediately be operative without exception.&nbsp;</p></li></ol>',
  transportChildrenEmployeeVehicle: '<p>Whereas the Client has retained The Nanny Company (“TNC”) to provide care for the Client’s child(ren) (the “services”), which services are provided by a qualified employee of the Company and governed by a contract for services between the Client and TNC;&nbsp;</p><p></p><p>And whereas the Employee is subject to an employment agreement and TNC’s policies and employee handbook;&nbsp;</p><p></p><p>The Client and TNC agree as follows:&nbsp;</p><p></p><ol><li><p>The Client expressly authorizes the Employee to use their own vehicle(s) in order to transport the Client’s child(ren) as may be required during the performance of the services.&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will have no liability to the Client or any other party for any loss, damage or injury (whether direct, indirect, or consequential) occasioned by any act or omission of the Employee in operating their own vehicle(s). The Client agrees that it will indemnify TNC for any claim or action against TNC in respect of the Employee’s use of their own vehicle(s) to transport the Client’s child(ren).&nbsp;</p></li><li><p>TNC acknowledges that the Employee’s application requires the Employee to have access to and maintain a reliable vehicle and to carry a valid driver’s license in the jurisdiction in which the child(ren) are being transported.&nbsp;</p></li><li><p>The Client agrees to reimburse the Employee for all reasonable and necessary expenses, as set out in the Nanny Company Client Contract.&nbsp;</p></li><li><p>The Client acknowledges and agrees that TNC will not be responsible for any driving violations, parking tickets, and traffic tickets (whether by photo radar or otherwise) that may be incurred are a result of the Employee using their own vehicle(s) to transport the Client’s child(ren).&nbsp;</p></li><li><p>The Client may revoke its authorization and/or consent to have the Employee use their own vehicle(s), on notice to TNC. All communication in respect of these matters shall be between the Client and TNC.&nbsp;</p></li><li><p>TNC retains the right to revoke its agreement to allow the Employee to use their own vehicle(s), without notice and in the sole discretion of TNC, following which revocation the prohibition of the use of the Employee’s vehicle(s) will immediately be operative without exception.&nbsp;&nbsp;</p></li></ol>',
  medicalRelease: '<p>CONSENT:</p><ol><li><p>Employee agrees to notify a parent when a child is ill or needs medical attention. Occasionally we cannot contact parents and we need to get immediate help for the child. Our procedure is to call for an ambulance, should the situation require.</p></li><li><p>Please sign the consent below so that we can take the appropriate action on behalf of your child.</p></li><li><p>I hereby give consent for my child to be taken to the nearest emergency center when I cannot be contacted, in the care of the employee shifted by the Company or the listed emergency contacts.</p></li><li><p>I hereby give consent for my child named above to receive medical treatment.</p></li></ol>',

  familyAgencyContract: "<p>1. Placements:</p><p>Gold Coast Nannies will refer All Applicants (hereinafter referred to as Candidate) to the Client, as they become available for consideration as a full-time or part-time live in or out Nanny, Household Manager, Personal Assistant, Baby Nurse, or Event Planner. Applicants are screened prior to their referral to the Client only to the extent that they meet the Agency's criteria for a qualified Applicant. Client agrees to screen and interview applicants carefully to determine whether they meet the Client's criteria and can fulfill the Clients expectations for their position. Offers of employment should not be made by Clients before carefully interviewing and screening applicants, and getting authorization to do so by the agency.</p><p>2. Interviewing/Hiring:</p><p>A) The Client agrees that all communication will be facilitated by Gold Coast Nannies during the interview process. All trial days should also be scheduled by a Gold Coast Nannies team member.</p><p>B) Gold Coast Nannies agrees to present at a minimum three qualified candidates. If Client does not hire within the first five Candidates that are presented, a reevaluation meeting will be conducted to decide if Client and Agency should continue working together. At this time, the Agency may require an additional fee of $250 to continue the search based on the circumstances. This placement fee will still remain $2700 for a single family, $3500 for a nanny share.</p><p>C) The Client agrees that all job offers must be made by a Gold Coast Nannies team member. All contract negotiations and signing will be facilitated by Gold Coast Nannies. Clients are welcome to edit our Nanny/Family contract as they feel needed.</p><p>D) If Client initiates contact with our Candidates outside of Gold Coast Nannies, Gold Coast Nannies reserves the right to end the working relationship and not refund fees.</p><p>3. Fees:</p><p>A) The Client agrees to pay the Agency a start up fee of $250 and a placement fee of $2,700 for any Candidate referred by Agency and hired by Client. Placement Fees previously agreed upon as of the date of the execution of this Agreement. Client acknowledges the receipt of said Placement Fee, understands the entirety and agrees to fees stated therein.</p><p>B.) The Client agrees to pay the placement fee in full to Gold Coast Nannies before the candidate begins employment in the Client’s home. This fee will be paid in full once the Client has been given authorization to employ the applicant. Clients who employ their candidate before paying the appropriate placement fee as stated in this agreement will be subject to pay an additional $150 service fee for each week that the referral is late in addition to the agreed upon fee.</p><p>Non Payment of Fees:</p><p>A.) If at any time within one year after an initial meeting between a client and any applicant referred by the agency that the applicant becomes a direct or indirect provider of services to the Client, and the Client does not notify the Agency of the candidate’s employment and/or does not pay the appropriate fee, the client agrees to pay the Agency a $2,500 termination fee in addition to any legal fees or court costs incurred by Gold Coast Nannies in collecting such fees.</p><p>B.) The client agrees to pay the fee in full before the candidate begins employment. If the Client fails to pay the placement fee to the agency before the candidate begins employment, Gold Coast Nannies will have the right to obtain full payment of the placement fee from client, along with attorney's fees and court costs incurred, and will not be obligated to provide the Client with any replacement or guarantee services as specified below in this agreement.</p><p>Refund Policies:</p><p>A.) All fees are non refundable. As for Placement Fees, Gold Coast Nannies has a 4 month guarantee policy, if the Client decides to end the employment agreement for cause, as outlined in their specific Nanny/Family contract, Agency will find a new candidate ASAP for Client. The Client agrees that if they choose to come back to the Agency for a new candidate after the four month period, at this time they will have to re-contract with the Agency and pay the appropriate fees for a new candidate.</p><p>B.) Should Candidate terminate employment agreement without providing the notice Client requires in executed employment contract, Gold Coast Nannies will waive daily temporary placement fee and assist Client free of charge with a finding a temporary Nanny until a replacement Nanny is hired. Client will still be responsible for paying Nanny’s hourly rate. However, if Candidate terminates employment because Client has not upheld their stipulations in the Nanny/Family contract (i.e. not being paid, not following scheduled hours, etc.), Gold Coast Nannies will be not responsible for replacing the Candidate, even within the 4 month period.</p><p>Relationship to Client and Candidate:</p><p>A.) Gold Coast Nannies is a referral service, and does not train, employ, or exercise control, authority or discretion over applicants referred to clients. Gold Coast Nannies disclaims any and all responsibility for any conduct or omissions of any applicant, including any applicant hired by the</p><p>client. The agency is not responsible for losses or damages resulting directly or indirectly from its Clients relationship with any applicant or candidate. Gold Coast Nannies is not responsible for providing insurance or withholding any payroll taxes, and has no employment relationship with its applicants.</p><p>B.) Clients are responsible for making sure their candidates are aware of all the household rules they want the candidate to follow as well as safety concerns and hazards.</p><p>C.) The Client, by signing this agreement, agrees to pay the appropriate fees and follow the appropriate policies in the event the Client hires any of the applicants referred by the Agency. This agreement embodies the entire agreement between Gold Coast Nannies and the Client. There are no other contracts, agreements, understanding, promises, conditions or obligations made or entered by Gold Coast Nannies and its Client other than those contained herein. No Modifications to this Agreement shall be Valid unless they are in writing and signed by both parties.</p>",
  userDocuments: [],
  userDocumentsErrors: []
};

var mutations = {
  resetUserDocuments: function resetUserDocuments(state) {
    state.userDocuments = [];
  },
  setUserDocuments: function setUserDocuments(state, payload) {
    state.userDocuments = payload;
  },
  resetUserDocumentsErrors: function resetUserDocumentsErrors(state) {
    state.userDocumentsErrors = [];
  }
};

var actions = {
  getDocumentsByUserID: function getDocumentsByUserID(_ref, userID) {
    var commit = _ref.commit;
    return regeneratorRuntime.async(function getDocumentsByUserID$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit("resetUserDocuments");
            commit("resetUserDocumentsErrors");
            _context.next = 4;
            return regeneratorRuntime.awrap(_axios2.default.get('/api/documents/?signing_user=' + userID).then(function (res) {
              commit("setUserDocuments", res.data);
            }).catch(function (error) {
              state.userDocumentsErrors.push(error);
            }));

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, null, this);
  }
};

var getters = {
  userDocuments: function userDocuments(state) {
    return (0, _tryGet2.default)(function () {
      return state.userDocuments;
    }) || [];
  },
  userDocumentsErrors: function userDocumentsErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.userDocumentsErrors;
    }) || [];
  },
  transportationConsent: function transportationConsent(state) {
    return state.transportationConsent;
  },
  useofClientVehicle: function useofClientVehicle(state) {
    return state.useofClientVehicle;
  },
  transportChildrenEmployeeVehicle: function transportChildrenEmployeeVehicle(state) {
    return state.transportChildrenEmployeeVehicle;
  },
  medicalRelease: function medicalRelease(state) {
    return state.medicalRelease;
  },
  familyAgencyContract: function familyAgencyContract(state) {
    return state.familyAgencyContract;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultValues = __webpack_require__(17);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _datetimeHandling = __webpack_require__(92);

var _dataHandling = __webpack_require__(73);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _dataHandling2 = __webpack_require__(73);

var _queryHandling = __webpack_require__(66);

var _arrayHandling = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var state = {
  candidateStatuses: _defaultValues.DEFAULT_CANDIDATE_STATUSES,
  candidateAdminChecklist: [],
  experienceOptions: ["2-5 years", "5-10 years", "10 plus years"],
  commitmentOptions: ["Long Term (longer than 1 year)", "Short Term (1 year or less)", "Temporary"],
  availabilityOptions: ["Full Time", "Part Time", "Come and Go", "Live In"],
  drvingStatuses: ["D.L. and Car", "Driver's License only", "Neither"],
  certificationStatuses: ["Yes", "Willing to get certified", "No"],
  vaccinationStatuses: ["Yes", "Willing to get", "No"],
  petsOptions: ["Dog", "Cat", "Neither"],
  travelOptions: ["Domestic", "International", "No travel"],
  activeStatus: "Profile Complete",
  candidateList: [],
  candidateListMainInfo: null,
  candidateListIdNames: null,
  candidateLastLoginFilter: null,
  availabilities: null, // List all availabilities of all candidates
  weekAvailabilities: null, // List all week availabilities of all candidates
  candidateInfoSelectionFields: null, // List information of candidates to show in the available candidates
  publicCandidateList: null,
  candidateListDateInfo: null, // List of start date, end date information of candidates
  selectedCandidate: null
};

var mutations = {
  setCandidateStatuses: function setCandidateStatuses(state, candidateStatuses) {
    state.candidateStatuses = candidateStatuses;
  },
  setCandidateAdminChecklist: function setCandidateAdminChecklist(state, candidateAdminChecklist) {
    state.candidateAdminChecklist = candidateAdminChecklist;
  },
  setCandidateList: function setCandidateList(state, candidateList) {
    state.candidateList = candidateList;
  },
  setCandidateListMainInfo: function setCandidateListMainInfo(state, candidateListMainInfo) {
    state.candidateListMainInfo = candidateListMainInfo;
  },
  setCandidateListIdNames: function setCandidateListIdNames(state, candidateListIdNames) {
    state.candidateListIdNames = candidateListIdNames;
  },
  setPublicCandidateList: function setPublicCandidateList(state, payload) {
    state.publicCandidateList = payload;
  },
  setCandidateLastLoginFilter: function setCandidateLastLoginFilter(state, payload) {
    state.candidateLastLoginFilter = payload;
  },
  setAvailabilities: function setAvailabilities(state, payload) {
    state.availabilities = payload;
  },
  setWeekAvailabilities: function setWeekAvailabilities(state, payload) {
    state.weekAvailabilities = payload;
  },
  setCandidateInfoSelectionFields: function setCandidateInfoSelectionFields(state, payload) {
    state.candidateInfoSelectionFields = payload;
  },
  setCandidateListDateInfo: function setCandidateListDateInfo(state, payload) {
    state.candidateListDateInfo = payload;
  },
  setSelectedCandidate: function setSelectedCandidate(state, payload) {
    state.selectedCandidate = payload;
  }
};

var actions = {
  setCandidateStatuses: function setCandidateStatuses(_ref, payload) {
    var commit = _ref.commit;

    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setCandidateStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default candidate statuses are used
      commit("setCandidateStatuses", _defaultValues.DEFAULT_CANDIDATE_STATUSES);
    }
  },
  setCandidateAdminChecklist: function setCandidateAdminChecklist(_ref2, payload) {
    var commit = _ref2.commit;

    if (payload && Array.isArray(payload)) {
      commit("setCandidateAdminChecklist", payload);
    } else {
      // If payload is invalid (not an array), checklist is empty array
      commit("setCandidateAdminChecklist", []);
    }
  },
  setCandidateList: function setCandidateList(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setCandidateList", payload);
  },
  setCandidateListMainInfo: function setCandidateListMainInfo(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setCandidateListMainInfo", payload);
  },
  setPublicCandidateList: function setPublicCandidateList(_ref5, payload) {
    var commit = _ref5.commit;

    commit("setPublicCandidateList", payload);
  },
  setAvailabilities: function setAvailabilities(_ref6, payload) {
    var commit = _ref6.commit;

    commit("setAvailabilities", payload);
  },
  setWeekAvailabilities: function setWeekAvailabilities(_ref7, payload) {
    var commit = _ref7.commit;

    commit("setWeekAvailabilities", payload);
  },
  setCandidateInfoSelectionFields: function setCandidateInfoSelectionFields(_ref8, payload) {
    var commit = _ref8.commit;

    commit("setCandidateInfoSelectionFields", payload);
  },
  setCandidateLastLoginFilter: function setCandidateLastLoginFilter(_ref9, payload) {
    var commit = _ref9.commit;

    commit("setCandidateLastLoginFilter", payload);
  },
  setCandidateLastLoginRetrievalDays: function setCandidateLastLoginRetrievalDays(_ref10, numberOfDay) {
    var commit = _ref10.commit;

    if (!numberOfDay || isNaN(numberOfDay)) {
      commit("setCandidateLastLoginFilter", null);
      return;
    }
    var date = new Date();
    date.setDate(date.getDate() - numberOfDay);
    var dateString = date.getFullYear().toString() + "-" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + date.getDate().toString()).slice(-2);
    commit("setCandidateLastLoginFilter", dateString);
  },
  reloadCandidateList: function reloadCandidateList(_ref11, params) {
    var _this = this;

    var commit = _ref11.commit,
        state = _ref11.state,
        rootState = _ref11.rootState,
        getters = _ref11.getters;

    var loadAllFields = params && params.loadAllFields;
    var loadExportFields = params && params.loadExportFields;
    var inBackground = params && params.inBackground;
    return new Promise(function _callee(resolve) {
      var url, lastUpdated, lastItem, listModels, setFields, exportFields, res, listUsers;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "/get-users/?user_type=candidates&agency=" + rootState.authentication.agencyID;

              if (inBackground) {
                url = (0, _queryHandling.appendBackgroundParam)(url);
                lastUpdated = null;

                if (getters.candidateList.length) {
                  lastItem = getters.candidateList.reduce(function (max, user) {
                    return max.last_updated_date > user.last_updated_date ? max : user;
                  });

                  if (lastItem) {
                    lastUpdated = lastItem.last_updated_date;
                  }
                }
                if (lastUpdated) {
                  url = url + "&last_updated=" + lastUpdated;
                }
              }
              if (!loadAllFields) {
                listModels = [].concat(_toConsumableArray(getters.candidateTableFields), _toConsumableArray(getters.candidateSearchFields)).map(function (field) {
                  return field.model;
                });

                listModels = listModels.filter(function (model) {
                  return model !== 'first_name_last_name' && model !== 'secondary_first_name_secondary_last_name' && model !== 'adminNotes';
                });
                listModels = [].concat(_toConsumableArray(listModels), ['created_date', 'id', 'status', 'types', 'first_name', 'last_name', 'locations', 'last_login', 'last_updated_date', 'last_activity', 'email', 'phone', 'address1', 'is_candidate', 'marketing_source', 'secondary_first_name', 'secondary_last_name', 'tags', 'user_latitude', 'user_longitude', 'country']);
                listModels = [].concat(_toConsumableArray(new Set(listModels)));

                if (loadExportFields) {
                  if (rootState.agency.advance_setting && rootState.agency.advance_setting.candidate_mailing_fields) {
                    setFields = rootState.agency.advance_setting.candidate_mailing_fields;
                    exportFields = [].concat(_toConsumableArray(setFields)).map(function (field) {
                      return field.model;
                    });

                    listModels = [].concat(_toConsumableArray(listModels), _toConsumableArray(exportFields));
                  }
                }
                // Add filter param (last login date)
                url += "&fields=" + listModels.join(',');
              }
              if (state.candidateLastLoginFilter) {
                url += "&recent_activity_filter=" + state.candidateLastLoginFilter;
              }
              _context.next = 6;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 6:
              res = _context.sent;
              listUsers = res.data.users;

              if (inBackground) {
                listUsers = (0, _arrayHandling.mergeArrayOfObject)(getters.candidateList, listUsers);
              }
              commit("setCandidateList", listUsers);
              resolve();
              return _context.abrupt("return");

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    });
  },
  loadCandidateListByModels: function loadCandidateListByModels(_ref12, listModels) {
    var _this2 = this;

    var rootState = _ref12.rootState;
    return regeneratorRuntime.async(function loadCandidateListByModels$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function _callee2(resolve) {
              var url, res;
              return regeneratorRuntime.async(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      url = "/get-users/?user_type=candidates&agency=" + rootState.authentication.agencyID + "&fields=" + listModels.join(',');
                      _context2.next = 3;
                      return regeneratorRuntime.awrap(_axios2.default.get(url));

                    case 3:
                      res = _context2.sent;

                      resolve(res.data.users);

                    case 5:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, null, _this2);
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, null, this);
  },
  loadAvailabilities: function loadAvailabilities(_ref13) {
    var _this3 = this;

    var commit = _ref13.commit,
        state = _ref13.state,
        rootState = _ref13.rootState;

    return new Promise(function _callee3(resolve) {
      var startDate, res;
      return regeneratorRuntime.async(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!state.availabilities) {
                _context4.next = 3;
                break;
              }

              resolve();
              return _context4.abrupt("return");

            case 3:
              // Only load availability start from last month
              startDate = (0, _datetimeHandling.dateInDjangoFormat)((0, _datetimeHandling.addDaysToDate)(-30));
              _context4.next = 6;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/availabilities/?agency=" + rootState.authentication.agencyID + "&start_date=" + startDate));

            case 6:
              res = _context4.sent;

              commit("setAvailabilities", res.data);
              resolve();

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, null, _this3);
    });
  },
  loadWeekAvailabilities: function loadWeekAvailabilities(_ref14) {
    var _this4 = this;

    var commit = _ref14.commit,
        state = _ref14.state,
        rootState = _ref14.rootState;

    return new Promise(function _callee4(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!state.weekAvailabilities) {
                _context5.next = 3;
                break;
              }

              resolve();
              return _context5.abrupt("return");

            case 3:
              _context5.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/weekavailabilities/?agency=" + rootState.authentication.agencyID.toString()));

            case 5:
              res = _context5.sent;

              commit("setWeekAvailabilities", res.data);
              resolve();

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, null, _this4);
    });
  },
  loadCandidateListMainInfo: function loadCandidateListMainInfo(_ref15, params) {
    var _this5 = this;

    var commit = _ref15.commit,
        state = _ref15.state,
        rootState = _ref15.rootState;

    return new Promise(function _callee5(resolve) {
      var isReload, isBackground, url, res;
      return regeneratorRuntime.async(function _callee5$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              isReload = false;
              isBackground = false;

              if (params) {
                isReload = params.isReload;
                isBackground = params.isBackground;
              }

              if (!(!isReload && state.candidateListMainInfo)) {
                _context6.next = 6;
                break;
              }

              resolve();
              return _context6.abrupt("return");

            case 6:
              url = "/get-users/?user_type=candidates&names_and_emails_only=true&agency=" + rootState.authentication.agencyID;

              if (isBackground) {
                url = url + "&in_background=true";
              }
              _context6.next = 10;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 10:
              res = _context6.sent;

              if (res && res.data) {
                commit("setCandidateListMainInfo", res.data.users);
              }
              resolve();

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, null, _this5);
    });
  },
  loadCandidateListIdNames: function loadCandidateListIdNames(_ref16, params) {
    var _this6 = this;

    var commit = _ref16.commit,
        state = _ref16.state,
        rootState = _ref16.rootState;

    return new Promise(function _callee6(resolve) {
      var isReload, isBackground, url, res;
      return regeneratorRuntime.async(function _callee6$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              isReload = false;
              isBackground = false;

              if (params) {
                isReload = params.isReload;
                isBackground = params.isBackground;
              }

              if (!(!isReload && state.candidateListIdNames)) {
                _context7.next = 6;
                break;
              }

              resolve();
              return _context7.abrupt("return");

            case 6:
              url = "/get-users/?agency=" + rootState.authentication.agencyID.toString() + "&user_type=candidates&fields=id,first_name,last_name";

              if (isBackground) {
                url = url + "&in_background=true";
              }
              _context7.next = 10;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 10:
              res = _context7.sent;

              if (res && res.data) {
                commit("setCandidateListIdNames", res.data.users);
              }
              resolve();

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, null, _this6);
    });
  },
  loadCandidateInfoSelectionFields: function loadCandidateInfoSelectionFields(_ref17) {
    var _this7 = this;

    var commit = _ref17.commit,
        state = _ref17.state,
        getters = _ref17.getters,
        rootState = _ref17.rootState;

    return new Promise(function _callee7(resolve) {
      var usersRes;
      return regeneratorRuntime.async(function _callee7$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!state.candidateInfoSelectionFields) {
                _context8.next = 3;
                break;
              }

              resolve();
              return _context8.abrupt("return");

            case 3:
              if (!(!getters.shiftJobSelectionProfileFields || !getters.shiftJobSelectionProfileFields.length)) {
                _context8.next = 6;
                break;
              }

              resolve();
              return _context8.abrupt("return");

            case 6:
              _context8.next = 8;
              return regeneratorRuntime.awrap(_axios2.default.get("/get-public-candidates-list/?agency=" + rootState.authentication.agencyID.toString()));

            case 8:
              usersRes = _context8.sent;

              if (usersRes && usersRes.data) {
                commit("setCandidateInfoSelectionFields", usersRes.data.users);
              }
              resolve();

            case 11:
            case "end":
              return _context8.stop();
          }
        }
      }, null, _this7);
    });
  },
  loadCandidateListDateInfo: function loadCandidateListDateInfo(_ref18, params) {
    var _this8 = this;

    var commit = _ref18.commit,
        state = _ref18.state,
        getters = _ref18.getters,
        rootState = _ref18.rootState;

    return new Promise(function _callee8(resolve) {
      var isReload, isBackground, fieldModels, url, usersRes;
      return regeneratorRuntime.async(function _callee8$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              isReload = false;
              isBackground = false;

              if (params) {
                isReload = params.isReload;
                isBackground = params.isBackground;
              }

              if (!(!isReload && state.candidateListDateInfo)) {
                _context9.next = 6;
                break;
              }

              resolve();
              return _context9.abrupt("return");

            case 6:
              if (!(getters.candidateStartDateModel || getters.candidateEndDateModel)) {
                _context9.next = 15;
                break;
              }

              fieldModels = getters.candidateStartDateModel || getters.candidateEndDateModel;

              if (getters.candidateStartDateModel && getters.candidateEndDateModel) {
                fieldModels = getters.candidateStartDateModel + "," + getters.candidateEndDateModel;
              }
              url = "/get-users/?agency=" + rootState.authentication.agencyID.toString() + "&fields=id," + fieldModels;

              if (isBackground) {
                url = url + "&in_background=true";
              }
              _context9.next = 13;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 13:
              usersRes = _context9.sent;

              commit("setCandidateListDateInfo", usersRes.data.users);

            case 15:
              resolve();

            case 16:
            case "end":
              return _context9.stop();
          }
        }
      }, null, _this8);
    });
  },
  reloadCandidateListMainInfo: function reloadCandidateListMainInfo(_ref19) {
    var commit = _ref19.commit;
    var res;
    return regeneratorRuntime.async(function reloadCandidateListMainInfo$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return regeneratorRuntime.awrap(_axios2.default.get("/get-users/?user_type=candidates&names_and_emails_only=true"));

          case 2:
            res = _context10.sent;

            if (res) {
              commit('setCandidateListMainInfo', res.data.users);
            }

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, null, this);
  },
  getCandidateList: function getCandidateList(_, payload) {
    return regeneratorRuntime.async(function getCandidateList$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
              var url = 'optimize/get-candidates/?';
              if (payload) {
                url = url + "&" + (0, _dataHandling2.getRequestUrlParams)(payload);
              }
              _axios2.default.get(url).then(function (response) {
                if (response.status === 200) {
                  resolve(response);
                }
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 2:
            return _context11.abrupt("return", _context11.sent);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, null, this);
  },
  setSelectedCandidate: function setSelectedCandidate(_ref20, payload) {
    var commit = _ref20.commit;

    commit("setSelectedCandidate", payload);
  }
};

var getters = {
  candidateListIncludeDateInfo: function candidateListIncludeDateInfo(state) {
    var candidateListMainInfo = state.candidateListMainInfo;
    var candidateListDateInfo = state.candidateListDateInfo;
    if (!candidateListMainInfo || !candidateListDateInfo) {
      return candidateListMainInfo || candidateListDateInfo;
    }

    var mapUserInfo = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = candidateListDateInfo[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var user = _step.value;

        mapUserInfo[user.id] = user;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var result = [];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = candidateListMainInfo[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var candidate = _step2.value;

        if (mapUserInfo[candidate.id]) {
          var dateInfo = mapUserInfo[candidate.id];
          result.push(_extends({}, candidate, dateInfo));
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return result;
  },
  candidateStatuses: function candidateStatuses(state, getters, rootState) {
    var result = (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.candidate_statuses;
    });
    if (result && result.length) {
      return result;
    }
    return _defaultValues.DEFAULT_CANDIDATE_STATUSES;
  },
  candidateAdminChecklist: function candidateAdminChecklist(state) {
    return state.candidateAdminChecklist;
  },
  experienceOptions: function experienceOptions(state) {
    return state.experienceOptions;
  },
  commitmentOptions: function commitmentOptions(state) {
    return state.commitmentOptions;
  },
  availabilityOptions: function availabilityOptions(state) {
    return state.availabilityOptions;
  },
  drvingStatuses: function drvingStatuses(state) {
    return state.drvingStatuses;
  },
  certificationStatuses: function certificationStatuses(state) {
    return state.certificationStatuses;
  },
  vaccinationStatuses: function vaccinationStatuses(state) {
    return state.vaccinationStatuses;
  },
  petsOptions: function petsOptions(state) {
    return state.petsOptions;
  },
  travelOptions: function travelOptions(state) {
    return state.travelOptions;
  },
  activeStatus: function activeStatus(state) {
    return state.activeStatus;
  },
  candidateList: function candidateList(state) {
    return state.candidateList || [];
  },
  candidateListMainInfo: function candidateListMainInfo(state) {
    return state.candidateListMainInfo;
  },
  candidateListIdNames: function candidateListIdNames(state) {
    return state.candidateListIdNames;
  },
  publicCandidateList: function publicCandidateList(state) {
    return state.publicCandidateList;
  },
  candidateLastLoginFilter: function candidateLastLoginFilter(state) {
    return state.candidateLastLoginFilter;
  },
  candidateTypes: function candidateTypes(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.candidate_types;
    }) || [];
  },
  candidateTags: function candidateTags(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.candidate_tags;
    }) || [];
  },
  availabilities: function availabilities(state) {
    return state.availabilities;
  },
  weekAvailabilities: function weekAvailabilities(state) {
    return state.weekAvailabilities;
  },
  shiftJobSelectionProfileFields: function shiftJobSelectionProfileFields(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.shift_selection_profile_fields) {
      return agency.public_advance_setting.shift_selection_profile_fields;
    }
    return [];
  },
  shiftViewFullProfile: function shiftViewFullProfile(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.shift_view_full_profile) {
      return agency.public_advance_setting.shift_view_full_profile;
    }
    return false;
  },
  candidateInfoSelectionFields: function candidateInfoSelectionFields(state) {
    return state.candidateInfoSelectionFields;
  },
  defaultCandidateBufferTime: function defaultCandidateBufferTime(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.default_candidate_buffer_time != null) {
      return agency.advance_setting.default_candidate_buffer_time;
    }
    return 1;
  },
  hideMyJobsCandidate: function hideMyJobsCandidate(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.hide_my_jobs_candidate != null) {
      return agency.advance_setting.hide_my_jobs_candidate;
    }
    return false;
  },
  candidateCanEditBufferTime: function candidateCanEditBufferTime(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.candidate_can_edit_buffer_time != null) {
      return agency.advance_setting.candidate_can_edit_buffer_time;
    }
    return false;
  },
  candidatesCanSetRate: function candidatesCanSetRate(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.candidates_can_set_rate != null) {
      return agency.public_advance_setting.candidates_can_set_rate;
    }
    return false;
  },
  adminCanSetCandidateRate: function adminCanSetCandidateRate(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.admin_can_set_candidate_rate != null) {
      return agency.public_advance_setting.admin_can_set_candidate_rate;
    }
    return false;
  },
  hideCandidateShareableLink: function hideCandidateShareableLink(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.hide_candidate_shareable_link != null) {
      return agency.public_advance_setting.hide_candidate_shareable_link;
    }
    return false;
  },
  candidateTypesSetSchedule: function candidateTypesSetSchedule(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.set_schedule_types != null) {
      return agency.advance_setting.set_schedule_types;
    }
    return [];
  },
  candidateStatusesSetSchedule: function candidateStatusesSetSchedule(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.set_schedule_statuses != null) {
      return agency.set_schedule_statuses;
    }
    return [];
  },
  candidateCanSetSchedule: function candidateCanSetSchedule(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.candidates_set_schedules != null) {
      return agency.candidates_set_schedules;
    }
    return false;
  },
  candidateStartDateModel: function candidateStartDateModel(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.candidate_start_date_model != null) {
      return agency.advance_setting.candidate_start_date_model;
    }
    return null;
  },
  candidateEndDateModel: function candidateEndDateModel(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.candidate_end_date_model != null) {
      return agency.advance_setting.candidate_end_date_model;
    }
    return null;
  },
  numberDaysCannotRequestTimeOff: function numberDaysCannotRequestTimeOff(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.number_days_cannot_request_time_off != null) {
      return agency.advance_setting.number_days_cannot_request_time_off;
    }
    return 0;
  },
  defaultViewAvailableJobsCalendar: function defaultViewAvailableJobsCalendar(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.default_view_available_jobs_calendar != null) {
      return agency.advance_setting.default_view_available_jobs_calendar;
    }
    return 'Week';
  },
  candidateStatusRequireReason: function candidateStatusRequireReason(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.candidate_status_require_reason != null) {
      return agency.public_advance_setting.candidate_status_require_reason;
    }
    return _defaultValues.DEFAULT_STATUS_REQUIRE_REASON_CHANGE;
  },
  minChildrenAgeField: function minChildrenAgeField(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.min_children_age_field) {
      return agency.public_advance_setting.min_children_age_field;
    }
    return null;
  },
  candidateStatusReasonOptions: function candidateStatusReasonOptions(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.candidate_status_reason_options) {
      return agency.public_advance_setting.candidate_status_reason_options;
    }
    return {};
  },
  candidateSecondStatuses: function candidateSecondStatuses(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.candidate_second_statuses) {
      return agency.public_advance_setting.candidate_second_statuses;
    }
    return [];
  },
  candidateTableFields: function candidateTableFields(state, getters, rootState) {
    // Check admin level setting
    var adminSetting = rootState.general.adminSetting;
    if (adminSetting && adminSetting.setting && adminSetting.setting.use_admin_level__candidate_table_fields) {
      var adminLevelSetting = adminSetting.setting.admin_level__candidate_table_fields;
      if (adminLevelSetting && adminLevelSetting.length) {
        return adminLevelSetting;
      }
    }
    var agency = rootState.authentication.agency;
    var listFields = agency.candidate_table_fields;
    if (listFields && listFields.length) {
      return listFields;
    }
    return _defaultValues.DEFAULT_DASHBOARD_TABLE_FIELDS_CANDIDATE;
  },
  candidateSearchFields: function candidateSearchFields(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var listFields = agency.advance_setting.candidate_search_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return [];
  },
  candidateAnalyticsDashboardFields: function candidateAnalyticsDashboardFields(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var listFields = agency.advance_setting.candidate_analytics_dashboard_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return _defaultValues.DEFAULT_ANALYTICS_DASHBOARD_SELECTION;
  },
  candidateStatisticsStatuses: function candidateStatisticsStatuses(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.public_advance_setting.candidate_statistic_status) {
      return agency.public_advance_setting.candidate_statistic_status;
    }
    return _defaultValues.DEFAULT_CANDIDATE_STATUSES;
  },
  selectedCandidate: function selectedCandidate(state) {
    return state.selectedCandidate;
  },

  candidateTableStatusColors: function candidateTableStatusColors(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.candidate_table_status_color;
    }) || [];
  },
  labelCandidateStatuses: function labelCandidateStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.label_candidate_statuses;
    });
  },
  labelCandidateSecondStatuses: function labelCandidateSecondStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.label_candidate_second_statuses;
    });
  },
  candidateDocumentDefaultScope: function candidateDocumentDefaultScope(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_default_document_scope;
    }) || 'private';
  },
  hideMyScheduleCandidate: function hideMyScheduleCandidate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_my_schedule_candidate;
    }) || false;
  },
  filterTypesThatCanSetSchedule: function filterTypesThatCanSetSchedule(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.filter_types_that_can_set_schedule;
    }) || [];
  },
  hideMyFamiliesCandidate: function hideMyFamiliesCandidate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_my_families_candidate;
    }) || false;
  },
  candidateCanUploadJobFile: function candidateCanUploadJobFile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_can_upload_job_file;
    }) || false;
  },
  hideCandidateDashboardMenuBar: function hideCandidateDashboardMenuBar(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_candidate_dashboard_menu_bar;
    }) || false;
  },
  candidateProfileTopWelcomeText: function candidateProfileTopWelcomeText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_profile_top_welcome_text;
    }) || '';
  },
  candidateCanRequestTimeOff: function candidateCanRequestTimeOff(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_can_request_timeoff;
    }) || false;
  },
  candidateProfileCompleteButtonText: function candidateProfileCompleteButtonText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_profile_complete_button_text;
    }) || 'My Profile is Complete, Notify Agency';
  },
  secondaryCandidateProfileCompleteButtonText: function secondaryCandidateProfileCompleteButtonText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.secondary_candidate_profile_complete_button_text;
    }) || 'My Profile is Complete, Notify Agency';
  },
  doNotAllowCandidatesDeleteUploadedDocuments: function doNotAllowCandidatesDeleteUploadedDocuments(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.do_not_allow_candidates_delete_uploaded_documents;
    }) || false;
  },
  wordUsedForMyProfile: function wordUsedForMyProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.word_used_for_my_profile;
    }) || "My Profile";
  },
  wordUsedForAvailableJobs: function wordUsedForAvailableJobs(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.word_used_for_available_jobs;
    }) || "Available Jobs ";
  },
  wordUsedForMySchedule: function wordUsedForMySchedule(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.word_used_for_my_schedule;
    }) || "My Schedule";
  },
  wordUsedForMyJobs: function wordUsedForMyJobs(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.word_used_for_my_jobs;
    }) || "My Jobs";
  },
  wordUsedForMyFamilies: function wordUsedForMyFamilies(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.word_used_for_my_families;
    }) || "My Families";
  },
  thirdCandidateProfileCompleteButtonText: function thirdCandidateProfileCompleteButtonText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.third_candidate_profile_complete_button_text;
    }) || 'My Profile is Complete, Notify Agency';
  },
  timeOffCategories: function timeOffCategories(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.time_off_categories;
    }) || _defaultValues.DEFAULT_REQUEST_TIME_OFF_CATEGORIES;
  },
  candidateDefaultTableView: function candidateDefaultTableView(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.candidate_default_table_view;
    }) || false;
  },
  candidateAvailableJobsTableFields: function candidateAvailableJobsTableFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_available_jobs_table_columns;
    }) || _defaultValues.DEFAULT_CANDIDATE_AVAILABLE_JOBS_TABLE_FIELDS;
  },
  notifyEmailsCandidateRequestTimeOff: function notifyEmailsCandidateRequestTimeOff(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.notify_emails_candidate_request_time_off;
    }) || [];
  },
  notifyEmailsCandidateChangeRecurringAvailability: function notifyEmailsCandidateChangeRecurringAvailability(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.notify_emails_candidate_change_recurring_availability;
    }) || [];
  },
  candidateTypesCanNotEditRecurringAvailability: function candidateTypesCanNotEditRecurringAvailability(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_types_cannot_edit_recurring_availability;
    }) || [];
  },
  allowCandidateToEditRecurringAvailability: function allowCandidateToEditRecurringAvailability(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.allow_candidate_to_edit_recurring_availability;
    }) || false;
  },
  preventCandidatesInputtingDailyAvailability: function preventCandidatesInputtingDailyAvailability(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.prevent_candidates_inputting_daily_availability;
    }) || false;
  },
  hideViewPreviousJobApplications: function hideViewPreviousJobApplications(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_view_previous_job_applications;
    }) || false;
  },
  candidatesCanAssignBadge: function candidatesCanAssignBadge(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_can_assign_badge;
    }) || false;
  },
  useTimeoffCredit: function useTimeoffCredit(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.use_timeoff_credit;
    }) || false;
  },
  updateCandidateStatusWhenAllDocumentSigned: function updateCandidateStatusWhenAllDocumentSigned(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.update_candidate_status_when_all_document_signed;
    }) || false;
  },
  candidateStatusToUpdateWhenAllDocumentSigned: function candidateStatusToUpdateWhenAllDocumentSigned(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_status_to_update_when_all_documents_signed;
    }) || '';
  },
  candidateCannotModifyExpireDate: function candidateCannotModifyExpireDate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_cannot_modify_expire_date;
    }) || false;
  },
  removeCandidateUploadAdditionalDocumentButton: function removeCandidateUploadAdditionalDocumentButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.remove_candidate_upload_additional_document_button;
    }) || false;
  },
  showCandidatePdfButtonOfClientProfile: function showCandidatePdfButtonOfClientProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.public_advance_setting.show_candidate_pdf_button_of_client_profile;
    }) || false;
  },
  hideBufferTimeCandidateProfile: function hideBufferTimeCandidateProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_buffer_time_from_candidate_profile;
    }) || false;
  },
  hideMaximumBookingsUserCanHaveCandidateProfile: function hideMaximumBookingsUserCanHaveCandidateProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_maximum_bookings_user_can_have_from_candidate_profile;
    }) || false;
  },
  hideOptionCandidateEditProfileHeader: function hideOptionCandidateEditProfileHeader(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_option_candidate_edit_profile_header;
    }) || false;
  },
  showCandidateDialogInRight: function showCandidateDialogInRight(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.show_candidate_dialog_in_right;
    }) || false;
  },
  candidateReapplicationStatuses: function candidateReapplicationStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.candidate_reapplication_statuses;
    }) || [];
  },
  notifyAgencyWhenCandidateUploadAnyDocument: function notifyAgencyWhenCandidateUploadAnyDocument(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.agency_gets_notified_when_candidate_upload_any_document;
    }) || false;
  },
  interviewNote1: function interviewNote1(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.public_advance_setting.interview_heading_candidate_1;
    }) || "Phone Screen Note";
  },
  interviewNote2: function interviewNote2(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.public_advance_setting.interview_heading_candidate_2;
    }) || "Interview Note";
  },
  candidateSearchBarOpenByDefault: function candidateSearchBarOpenByDefault(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.candidate_search_bar_open_by_default;
    }) || false;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultValues = __webpack_require__(17);

var _datetimeHandling = __webpack_require__(92);

var _dataHandling = __webpack_require__(73);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _dataHandling2 = __webpack_require__(73);

var _queryHandling = __webpack_require__(66);

var _arrayHandling = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var state = {
  employerStatuses: _defaultValues.DEFAULT_EMPLOYER_STATUSES,
  employerAdminChecklist: [],
  employerList: [],
  employerListMainInfo: [], //id, names, email
  employerListIdNames: null,
  employerLastLoginFilter: null,
  listNumberChildren: null
};

var mutations = {
  setEmployerStatuses: function setEmployerStatuses(state, employerStatuses) {
    state.employerStatuses = employerStatuses;
  },
  setEmployerAdminChecklist: function setEmployerAdminChecklist(state, employerAdminChecklist) {
    state.employerAdminChecklist = employerAdminChecklist;
  },
  setEmployerList: function setEmployerList(state, employerList) {
    state.employerList = employerList;
  },
  setEmployerListMainInfo: function setEmployerListMainInfo(state, employerListMainInfo) {
    state.employerListMainInfo = employerListMainInfo;
  },
  setEmployerListIdNames: function setEmployerListIdNames(state, employerListIdNames) {
    state.employerListIdNames = employerListIdNames;
  },
  setEmployerLastLoginFilter: function setEmployerLastLoginFilter(state, payload) {
    state.employerLastLoginFilter = payload;
  },
  setListNumberChildren: function setListNumberChildren(state, payload) {
    state.listNumberChildren = payload;
  }
};

var actions = {
  setEmployerStatuses: function setEmployerStatuses(_ref, payload) {
    var commit = _ref.commit;

    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setEmployerStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default employer statuses are used
      commit("setEmployerStatuses", _defaultValues.DEFAULT_EMPLOYER_STATUSES);
    }
  },
  setEmployerAdminChecklist: function setEmployerAdminChecklist(_ref2, payload) {
    var commit = _ref2.commit;

    if (payload && Array.isArray(payload)) {
      commit("setEmployerAdminChecklist", payload);
    } else {
      // If payload is invalid (not an array), checklist is empty array
      commit("setEmployerAdminChecklist", []);
    }
  },
  setEmployerList: function setEmployerList(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setEmployerList", payload);
  },
  setEmployerListMainInfo: function setEmployerListMainInfo(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setEmployerListMainInfo", payload);
  },
  setEmployerListIdNames: function setEmployerListIdNames(_ref5, payload) {
    var commit = _ref5.commit;

    commit("setEmployerListIdNames", payload);
  },
  setEmployerLastLoginFilter: function setEmployerLastLoginFilter(_ref6, payload) {
    var commit = _ref6.commit;

    commit("setEmployerLastLoginFilter", payload);
  },
  setEmployerLastLoginRetrievalDays: function setEmployerLastLoginRetrievalDays(_ref7, numberOfDay) {
    var commit = _ref7.commit;

    if (!numberOfDay || isNaN(numberOfDay)) {
      commit("setEmployerLastLoginFilter", null);
      return;
    }
    var date = new Date();
    date.setDate(date.getDate() - numberOfDay);
    var dateString = date.getFullYear().toString() + "-" + ("0" + (date.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + date.getDate().toString()).slice(-2);
    commit("setEmployerLastLoginFilter", dateString);
  },
  reloadEmployerList: function reloadEmployerList(_ref8, params) {
    var _this = this;

    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState,
        getters = _ref8.getters;

    return new Promise(function _callee(resolve) {
      var loadAllFields, loadExportFields, url, inBackground, lastId, lastItem, listModels, setFields, exportFields, res, listUsers;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loadAllFields = params && params.loadAllFields;
              loadExportFields = params && params.loadExportFields;
              url = "/get-users/?user_type=clients&agency=" + rootState.authentication.agencyID;
              inBackground = params && params.inBackground;

              if (inBackground) {
                url = (0, _queryHandling.appendBackgroundParam)(url);
                lastId = null;

                if (getters.employerList.length) {
                  lastItem = getters.employerList.reduce(function (max, user) {
                    return max.last_updated_date > user.last_updated_date ? max : user;
                  });

                  if (lastItem) {
                    lastId = lastItem.id;
                  }
                }
                if (lastId) {
                  url = url + "&last_id=" + lastId;
                }
              }
              if (!loadAllFields) {
                listModels = [].concat(_toConsumableArray(getters.employerTableFields), _toConsumableArray(getters.employerSearchFields)).map(function (field) {
                  return field.model;
                });

                listModels = listModels.filter(function (model) {
                  return model !== 'first_name_last_name' && model !== 'secondary_first_name_secondary_last_name' && model !== 'adminNotes';
                });
                listModels = [].concat(_toConsumableArray(listModels), ['created_date', 'id', 'status', 'types', 'first_name', 'last_name', 'locations', 'last_login', 'last_updated_date', 'last_activity', 'email', 'phone', 'address1', 'is_employer', 'marketing_source', 'secondary_first_name', 'secondary_last_name']);
                if (loadExportFields) {
                  if (rootState.agency.advance_setting && rootState.agency.advance_setting.client_mailing_fields) {
                    setFields = rootState.agency.advance_setting.client_mailing_fields;
                    exportFields = [].concat(_toConsumableArray(setFields)).map(function (field) {
                      return field.model;
                    });

                    console.log(exportFields);
                    listModels = [].concat(_toConsumableArray(listModels), _toConsumableArray(exportFields));
                  }
                }
                listModels = [].concat(_toConsumableArray(new Set(listModels)));
                url += "&fields=" + listModels.join(',');
              }
              // Add filter param (last login date)
              if (state.employerLastLoginFilter) {
                url += "&recent_activity_filter=" + state.employerLastLoginFilter;
              }
              _context.next = 9;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 9:
              res = _context.sent;
              listUsers = res.data.users;

              if (inBackground) {
                listUsers = (0, _arrayHandling.mergeArrayOfObject)(getters.employerList, listUsers);
              }
              commit("setEmployerList", listUsers);
              resolve();
              return _context.abrupt("return");

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    });
  },
  loadClientListByModels: function loadClientListByModels(_ref9, listModels) {
    var _this2 = this;

    var rootState = _ref9.rootState;
    return regeneratorRuntime.async(function loadClientListByModels$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function _callee2(resolve) {
              var url, res;
              return regeneratorRuntime.async(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      url = "/get-users/?user_type=clients&agency=" + rootState.authentication.agencyID + "&fields=" + listModels.join(',');
                      _context2.next = 3;
                      return regeneratorRuntime.awrap(_axios2.default.get(url));

                    case 3:
                      res = _context2.sent;

                      resolve(res.data.users);

                    case 5:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, null, _this2);
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, null, this);
  },
  reloadEmployerListMainInfo: function reloadEmployerListMainInfo(_ref10) {
    var commit = _ref10.commit;
    var res;
    return regeneratorRuntime.async(function reloadEmployerListMainInfo$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return regeneratorRuntime.awrap(_axios2.default.get("/get-users/?user_type=clients&names_and_emails_only=true"));

          case 2:
            res = _context4.sent;

            if (res) {
              commit('setEmployerListMainInfo', res.data.users);
            }

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, null, this);
  },
  loadListNumberChildren: function loadListNumberChildren(_ref11) {
    var _this3 = this;

    var commit = _ref11.commit,
        rootState = _ref11.rootState;
    return regeneratorRuntime.async(function loadListNumberChildren$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", new Promise(function _callee3(resolve) {
              var res;
              return regeneratorRuntime.async(function _callee3$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return regeneratorRuntime.awrap(_axios2.default.get("/get-all-number-children/?agency=" + rootState.authentication.agencyID));

                    case 2:
                      res = _context5.sent;

                      if (res) {
                        commit('setListNumberChildren', res.data);
                      }
                      resolve();

                    case 5:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, null, _this3);
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, null, this);
  },
  loadEmployerListIdNames: function loadEmployerListIdNames(_ref12, params) {
    var _this4 = this;

    var commit = _ref12.commit,
        state = _ref12.state,
        rootState = _ref12.rootState;

    return new Promise(function _callee4(resolve) {
      var isReload, isBackground, url, res;
      return regeneratorRuntime.async(function _callee4$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              isReload = false;
              isBackground = false;

              if (params) {
                isReload = params.isReload;
                isBackground = params.isBackground;
              }

              if (!(!isReload && state.employerListIdNames)) {
                _context7.next = 6;
                break;
              }

              resolve();
              return _context7.abrupt("return");

            case 6:
              url = "/get-users/?agency=" + rootState.authentication.agencyID.toString() + "&user_type=clients&fields=id,first_name,last_name";

              if (isBackground) {
                url = url + "&in_background=true";
              }
              _context7.next = 10;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 10:
              res = _context7.sent;

              if (res && res.data) {
                commit("setEmployerListIdNames", res.data.users);
              }
              resolve();

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, null, _this4);
    });
  },
  getClientList: function getClientList(_, payload) {
    return regeneratorRuntime.async(function getClientList$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
              var url = 'optimize/get-clients/?';
              if (payload) {
                url = url + "&" + (0, _dataHandling2.getRequestUrlParams)(payload);
              }
              _axios2.default.get(url).then(function (response) {
                if (response.status === 200) {
                  resolve(response);
                }
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, null, this);
  }
};

var getters = {
  employerStatuses: function employerStatuses(state, getters, rootState) {
    var result = (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.employer_statuses;
    });
    if (result && result.length) {
      return result;
    }
    return _defaultValues.DEFAULT_EMPLOYER_STATUSES;
  },
  employerAdminChecklist: function employerAdminChecklist(state) {
    return state.employerAdminChecklist;
  },
  employerList: function employerList(state) {
    return state.employerList;
  },
  employerListMainInfo: function employerListMainInfo(state) {
    return state.employerListMainInfo || [];
  },
  employerListIdNames: function employerListIdNames(state) {
    return state.employerListIdNames;
  },
  employerLastLoginFilter: function employerLastLoginFilter(state) {
    return state.employerLastLoginFilter;
  },
  listNumberChildren: function listNumberChildren(state) {
    return state.listNumberChildren;
  },
  employerTypes: function employerTypes(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.employer_types;
    }) || [];
  },
  employerTags: function employerTags(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.employer_tags;
    }) || [];
  },
  employerTableFields: function employerTableFields(state, getters, rootState) {
    // Check admin level setting
    var adminSetting = rootState.general.adminSetting;
    if (adminSetting && adminSetting.setting && adminSetting.setting.use_admin_level__employer_table_fields) {
      var adminLevelSetting = adminSetting.setting.admin_level__employer_table_fields;
      if (adminLevelSetting && adminLevelSetting.length) {
        return adminLevelSetting;
      }
    }
    // Check agency level setting
    var agency = rootState.authentication.agency;
    var listFields = agency.employer_table_fields;
    if (listFields && listFields.length) {
      return listFields;
    }
    return _defaultValues.DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER;
  },
  employerSearchFields: function employerSearchFields(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var listFields = agency.advance_setting.employer_search_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return [];
  },
  employerStatusRequireReason: function employerStatusRequireReason(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.employer_status_require_reason != null) {
      return agency.public_advance_setting.employer_status_require_reason;
    }
    return _defaultValues.DEFAULT_STATUS_REQUIRE_REASON_CHANGE;
  },
  employerStatusReasonOptions: function employerStatusReasonOptions(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.employer_status_reason_options) {
      return agency.public_advance_setting.employer_status_reason_options;
    }
    return {};
  },
  employerSecondStatuses: function employerSecondStatuses(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.employer_second_statuses) {
      return agency.public_advance_setting.employer_second_statuses;
    }
    return [];
  },
  showCandidateRateToClient: function showCandidateRateToClient(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.show_candidate_rate_to_client;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is false
  },
  showClientRateToClient: function showClientRateToClient(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.show_client_rate_to_client;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  clientTypeNotPutPaymentInfo: function clientTypeNotPutPaymentInfo(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_types_not_put_payment_info) {
      return agency.advance_setting.client_types_not_put_payment_info;
    }
    return [];
  },
  clientTypeNotChargeRegistrationFee: function clientTypeNotChargeRegistrationFee(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_types_not_charge_registration_fee) {
      return agency.advance_setting.client_types_not_charge_registration_fee;
    }
    return [];
  },
  clientAnalyticsDashboardFields: function clientAnalyticsDashboardFields(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var listFields = agency.advance_setting.client_analytics_dashboard_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return _defaultValues.DEFAULT_ANALYTICS_DASHBOARD_SELECTION;
  },
  clientTypesUseBookingCredits: function clientTypesUseBookingCredits(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_types_use_booking_credits) {
      return agency.advance_setting.client_types_use_booking_credits;
    }
    return [];
  },
  agencyUseBookingCredits: function agencyUseBookingCredits(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.use_booking_credits) {
      return agency.use_booking_credits;
    }
    return false;
  },
  employerStatisticsStatuses: function employerStatisticsStatuses(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.public_advance_setting.employer_statistic_status) {
      return agency.public_advance_setting.employer_statistic_status;
    }
    return _defaultValues.DEFAULT_EMPLOYER_STATUSES;
  },

  clientTableStatusColors: function clientTableStatusColors(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.client_table_status_color;
    }) || [];
  },
  clientShiftJobProfile: function clientShiftJobProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_shift_job_profile;
    }) || [];
  },
  clientShiftJobProfileAssigneeView: function clientShiftJobProfileAssigneeView(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_shift_job_profile_assignee;
    }) || [];
  },
  useEmployerNameInHeaderTemplate: function useEmployerNameInHeaderTemplate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.use_employer_name_in_header_template;
    }) || false;
  },
  hideClientShareableLink: function hideClientShareableLink(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_client_shareable_link;
    }) || false;
  },
  showClientPdfButtonOfCandidateProfile: function showClientPdfButtonOfCandidateProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.show_client_pdf_button_of_candidate_profile;
    }) || false;
  },
  showClientGeneratePdfButton: function showClientGeneratePdfButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.show_client_generate_pdf_button;
    }) || false;
  },
  labelEmployerStatuses: function labelEmployerStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.label_employer_statuses;
    });
  },
  labelEmployerSecondStatuses: function labelEmployerSecondStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.label_employer_second_statuses;
    });
  },
  clientTypesViewOnlyBooking: function clientTypesViewOnlyBooking(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_types_view_only_booking;
    }) || [];
  },
  hideExtendOfferButton: function hideExtendOfferButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_extend_offer_button;
    }) || false;
  },
  employerDocumentDefaultScope: function employerDocumentDefaultScope(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_default_document_scope;
    }) || 'private';
  },
  disableClientAssignManagerEmail: function disableClientAssignManagerEmail(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.disable_client_assign_manager_email;
    }) || false;
  },
  hideNotInterestedButton: function hideNotInterestedButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_not_interested_button;
    }) || false;
  },
  clientTagsRelevantMatching: function clientTagsRelevantMatching(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_tags_relevant_matching;
    }) || [];
  },
  hideGuideTextMyCandidateSection: function hideGuideTextMyCandidateSection(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_guide_text_my_candidate_section;
    }) || false;
  },
  clientPostPlacementJobDefaultStatus: function clientPostPlacementJobDefaultStatus(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_post_placement_job_default_status;
    }) || 'Posted';
  },
  clientsCanMakePlacementJobRequests: function clientsCanMakePlacementJobRequests(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.clients_can_make_placement_job_requests;
    }) || false;
  },
  notifyEmailsClientPostPlacementJob: function notifyEmailsClientPostPlacementJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.notify_emails_client_post_placement_job;
    }) || [];
  },
  clientProfileTopWelcomeText: function clientProfileTopWelcomeText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_profile_top_welcome_text;
    }) || '';
  },
  notifyEmailsClientUpdatesCreditCard: function notifyEmailsClientUpdatesCreditCard(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.notify_emails_client_updates_credit_card;
    }) || [];
  },
  relationshipStatusAccessibleClientProfilePic: function relationshipStatusAccessibleClientProfilePic(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.relationship_status_accessible_client_profile_pic;
    }) || [];
  },
  clientProfilePicVisibleToFiller: function clientProfilePicVisibleToFiller(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_profile_pic_visible_to_filler;
    }) || false;
  },
  updateClientStatusWhenAllDocumentSigned: function updateClientStatusWhenAllDocumentSigned(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.update_client_status_when_all_document_signed;
    }) || false;
  },
  clientStatusToUpdateWhenAllDocumentSigned: function clientStatusToUpdateWhenAllDocumentSigned(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.client_status_to_update_when_all_documents_signed;
    }) || '';
  },
  clientProfileCompleteButtonText: function clientProfileCompleteButtonText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_profile_complete_button_text;
    }) || 'My Profile is Complete, Notify Agency';
  },
  showAssignedCandidateShareableLinkClient: function showAssignedCandidateShareableLinkClient(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.show_assigned_candidate_shareable_link_client;
    }) || false;
  },
  clientAddNoteAssignedCandidateNotificationEmails: function clientAddNoteAssignedCandidateNotificationEmails(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.client_add_note_assigned_candidate_notification_emails;
    }) || [];
  },
  removeClientUploadAdditionalDocumentButton: function removeClientUploadAdditionalDocumentButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.remove_client_upload_additional_document_button;
    }) || false;
  },
  wordUsedForScheduleInterview: function wordUsedForScheduleInterview(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.word_used_for_schedule_interview_relationship;
    }) || 'Schedule Interview';
  },
  showEmployerDialogInRight: function showEmployerDialogInRight(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.show_employer_dialog_in_right;
    }) || false;
  },
  notifyEmailsPackageSelectOrChange: function notifyEmailsPackageSelectOrChange(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.notify_emails_package_select_or_change;
    }) || [];
  },
  showShareableLinkForMyCandidatesSection: function showShareableLinkForMyCandidatesSection(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.show_shareable_link_for_my_candidates_section;
    }) || false;
  },
  relationshipStatusesWhereExtendedOfferButtonAppears: function relationshipStatusesWhereExtendedOfferButtonAppears(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.relationship_statuses_where_extended_offer_button_appears;
    }) || ['Interested'];
  },
  relationshipStatusesHiddenMyCandidates: function relationshipStatusesHiddenMyCandidates(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.relationship_statuses_hidden_my_candidates;
    }) || _defaultValues.DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES;
  },
  clientReapplicationStatuses: function clientReapplicationStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.client_reapplication_statuses;
    }) || [];
  },
  employerSearchBarOpenByDefault: function employerSearchBarOpenByDefault(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.employer_search_bar_open_by_default;
    }) || false;
  },
  registrationFeeStripeDescription: function registrationFeeStripeDescription(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.registration_fee_stripe_description;
    }) || 'Application form fee';
  },
  isEmployerEditableViewDefault: function isEmployerEditableViewDefault(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.set_editable_view_default_client;
    }) || false;
  }

};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _defaultValues = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  listNotMatchRelationships: [],
  listFavoriteRelationships: [],
  listPreviousMatchCandidatesOfEmployer: [], // Of Employer
  listNotMatchEmployerIds: null // List not match employer ids of current candidate
};

var mutations = {
  loadListNotMatchRelationships: function loadListNotMatchRelationships(state, relationships) {
    state.listNotMatchRelationships = relationships;
  },
  loadListFavoriteRelationships: function loadListFavoriteRelationships(state, relationships) {
    state.listFavoriteRelationships = relationships;
  },
  setListPreviousMatchCandidatesOfEmployer: function setListPreviousMatchCandidatesOfEmployer(state, payload) {
    state.listPreviousMatchCandidatesOfEmployer = payload;
  },
  setListNotMatchEmployerIds: function setListNotMatchEmployerIds(state, payload) {
    state.listNotMatchEmployerIds = payload;
  }
};

var actions = {
  loadListFavoriteAndNotMatchRelationships: function loadListFavoriteAndNotMatchRelationships(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    return new Promise(function _callee(resolve) {
      var res, listRelationships;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get('/get-relationships/?agency=' + rootState.authentication.agencyID + '&main_info_only=true&statuses=Do Not Match,Favorite'));

            case 2:
              res = _context.sent;
              listRelationships = res.data.relationships;

              commit("loadListFavoriteRelationships", listRelationships.filter(function (item) {
                return item.status === 'Favorite';
              }));
              commit("loadListNotMatchRelationships", listRelationships.filter(function (item) {
                return item.status === 'Do Not Match';
              }));
              resolve();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, null, _this);
    });
  },
  getPreviousMatchList: function getPreviousMatchList(_ref2, _ref3) {
    var _this2 = this;

    var commit = _ref2.commit;
    var candidateId = _ref3.candidateId;

    return new Promise(function _callee2(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get('/get-previous-match-list/?candidate=' + candidateId));

            case 2:
              res = _context2.sent;

              if (res && res.data && res.data.employers) {
                resolve(res.data.employers);
              } else {
                resolve([]);
              }

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, null, _this2);
    });
  },
  getRelationshipsByCandidate: function getRelationshipsByCandidate(_ref4, _ref5) {
    var _this3 = this;

    var commit = _ref4.commit;
    var id = _ref5.id,
        status = _ref5.status;

    return new Promise(function _callee3(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get('/api/relationships/?candidate=' + id + '&status=' + status));

            case 2:
              res = _context3.sent;

              if (res && res.data) {
                resolve(res.data);
              } else {
                resolve([]);
              }

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, null, _this3);
    });
  },
  getRelationshipsByEmployer: function getRelationshipsByEmployer(_ref6, _ref7) {
    var _this4 = this;

    var commit = _ref6.commit;
    var id = _ref7.id,
        status = _ref7.status;

    return new Promise(function _callee4(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get('/api/relationships/?employer=' + id + '&status=' + status));

            case 2:
              res = _context4.sent;

              if (res && res.data) {
                resolve(res.data);
              } else {
                resolve([]);
              }

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, null, _this4);
    });
  },
  loadPreviousMatchCandidatesByEmployer: function loadPreviousMatchCandidatesByEmployer(_ref8, employerId) {
    var _this5 = this;

    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return new Promise(function _callee5(resolve) {
      var result, res;
      return regeneratorRuntime.async(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              result = [];

              if (!employerId) {
                _context5.next = 6;
                break;
              }

              _context5.next = 4;
              return regeneratorRuntime.awrap(_axios2.default.get('/get-fillers-by-poster/?poster=' + employerId));

            case 4:
              res = _context5.sent;

              if (res && res.data && res.data.fillers) {
                result = res.data.fillers;
              }

            case 6:
              commit('setListPreviousMatchCandidatesOfEmployer', result);
              resolve();

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, null, _this5);
    });
  },
  loadListNotMatchEmployerIds: function loadListNotMatchEmployerIds(_ref9, userId) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch,
        state = _ref9.state,
        rootGetters = _ref9.rootGetters;
    var listRelationships, listNotMatchEmployerIds;
    return regeneratorRuntime.async(function loadListNotMatchEmployerIds$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!userId) {
              userId = rootGetters.userID;
            }

            if (!(rootGetters.userID === userId)) {
              _context6.next = 4;
              break;
            }

            if (!state.listNotMatchEmployerIds) {
              _context6.next = 4;
              break;
            }

            return _context6.abrupt('return', state.listNotMatchEmployerIds);

          case 4:
            _context6.next = 6;
            return regeneratorRuntime.awrap(dispatch('getRelationshipsByCandidate', {
              id: userId,
              status: "Do Not Match"
            }));

          case 6:
            listRelationships = _context6.sent;
            listNotMatchEmployerIds = listRelationships.map(function (relationship) {
              return relationship.employer;
            });

            if (rootGetters.userID === userId) {
              commit('setListNotMatchEmployerIds', listNotMatchEmployerIds);
            }
            return _context6.abrupt('return', listNotMatchEmployerIds);

          case 10:
          case 'end':
            return _context6.stop();
        }
      }
    }, null, this);
  }
};

var getters = {
  listNotMatchEmployerIds: function listNotMatchEmployerIds(state) {
    return state.listNotMatchEmployerIds || [];
  },
  listNotMatchRelationships: function listNotMatchRelationships(state) {
    return state.listNotMatchRelationships;
  },

  listFavoriteRelationships: function listFavoriteRelationships(state) {
    return (0, _tryGet2.default)(function () {
      return state.listFavoriteRelationships;
    }) || [];
  },
  candidateEmployerRelationshipStatuses: function candidateEmployerRelationshipStatuses(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.candidate_client_relationship_status;
      if (result && result.length) {
        return result;
      }
    }
    return _defaultValues.DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS;
  },

  candidateCanMarkClientAsFavorite: function candidateCanMarkClientAsFavorite(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_can_mark_client_favorite;
    }) || false;
  },
  candidateCanMarkClientAsDoNotWantAgain: function candidateCanMarkClientAsDoNotWantAgain(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_can_mark_client_do_not_want_again;
    }) || false;
  },
  listPreviousMatchCandidatesOfEmployer: function listPreviousMatchCandidatesOfEmployer(state) {
    return state.listPreviousMatchCandidatesOfEmployer;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _datetimeHandling = __webpack_require__(92);

var _options = __webpack_require__(132);

var _defaultValues = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import store from '../store'
var state = {
  website: 'https://nanny.enginehire.io/',
  platformURL: 'https://agency.enginehire.io/',
  agencyHumanName: 'Enginehire',
  agencyPublic: {},
  loadAgencyReqNumber: 0,
  reloadAgencyReqNumber: 0,
  dashboardv2: false
};

var mutations = {
  setAgencyPublic: function setAgencyPublic(state, agencyPublic) {
    state.agencyPublic = agencyPublic;
  },
  increaseLoadAgencyReqNumber: function increaseLoadAgencyReqNumber(state, payload) {
    state.loadAgencyReqNumber += payload;
  },
  increaseReloadAgencyReqNumber: function increaseReloadAgencyReqNumber(state, payload) {
    state.reloadAgencyReqNumber += payload;
  },
  changeAgencyType: function changeAgencyType(state, payload) {
    state.agencyPublic.type = payload;
  },
  setDashboardV2: function setDashboardV2(state, payload) {
    state.dashboardv2 = payload;
  }
};

var actions = {
  setAgencyPublic: function setAgencyPublic(_ref, payload) {
    var commit = _ref.commit;

    commit("setAgencyPublic", payload);
  },
  increaseLoadAgencyReqNumber: function increaseLoadAgencyReqNumber(_ref2, payload) {
    var commit = _ref2.commit;

    commit("increaseLoadAgencyReqNumber", payload);
  },
  increaseReloadAgencyReqNumber: function increaseReloadAgencyReqNumber(_ref3, payload) {
    var commit = _ref3.commit;

    commit("increaseReloadAgencyReqNumber", payload);
  },
  setAgencyType: function setAgencyType(context, payload) {
    var response;
    return regeneratorRuntime.async(function setAgencyType$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return regeneratorRuntime.awrap(_axios2.default.put("/optimum/agency_type/update/" + payload.agencyId + "/", { type: payload.agencyType }));

          case 2:
            response = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 6;
              break;
            }

            context.commit("changeAgencyType", response.data.type);
            return _context.abrupt("return", response);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, null, this);
  }
};

var getters = {
  website: function website(state) {
    return state.website;
  },
  platformURL: function platformURL(state) {
    return state.platformURL;
  },
  agencyPublic: function agencyPublic(state) {
    return state.agencyPublic;
  },
  agencyLocations: function agencyLocations(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.locations;
    }
    return null;
  },
  agencyHolidays: function agencyHolidays(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.holidays;
    }
    return null;
  },
  hasCandidateIntroVideo: function hasCandidateIntroVideo(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.candidate_intro_videos;
    }
    return false;
  },
  businessHours: function businessHours(state) {
    if (state.agencyPublic && state.agencyPublic.public_advance_setting) {
      return state.agencyPublic.public_advance_setting.business_hours;
    }
    return null;
  },

  // List of holiday by MM-dd
  agencyHolidayDates: function agencyHolidayDates(state, getters) {
    var holidays = getters.agencyHolidays;
    if (!holidays) {
      return [];
    }
    return holidays.filter(function (item) {
      return item.date;
    }).map(function (item) {
      return (0, _datetimeHandling.getDayMonthFromDate)(item.date);
    });
  },
  agencyHumanName: function agencyHumanName(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.human_name;
    }
    return "";
  },
  agencyCurrency: function agencyCurrency(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.currency;
    }
    return "USD"; // Default is USD
  },
  agencyLanguages: function agencyLanguages(state) {
    if (state.agencyPublic) {
      return state.agencyPublic.languages;
    }
    return null;
  },

  authorizeNetClientKey: function authorizeNetClientKey(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.authorize_net_params.clientKey;
    }) || '';
  },
  authorizeNetAPILoginID: function authorizeNetAPILoginID(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.authorize_net_params.loginID;
    }) || '';
  },
  disclaimerTextBookingSection: function disclaimerTextBookingSection(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.disclaimer_text_booking_section;
    }) || '';
  },
  doNotShowDuplicatedDocumentsUpdatingStatus: function doNotShowDuplicatedDocumentsUpdatingStatus(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.do_not_show_duplicated_documents_updating_status;
    }) || false;
  },
  agencyCurrencySign: function agencyCurrencySign(state, getters) {
    var agencyCurrency = getters.agencyCurrency;
    var symbol = void 0;
    switch (agencyCurrency) {
      case "USD":
        symbol = "$";
        break;
      case "AUD":
        symbol = "A$";
        break;
      case "BGN":
        symbol = "Лв.";
        break;
      case "BRL":
        symbol = "R$";
        break;
      case "CAD":
        symbol = "C$";
        break;
      case "CZK":
        symbol = "Kč";
        break;
      case "DKK":
        symbol = "kr";
        break;
      case "EUR":
        symbol = "€";
        break;
      case "GBP":
        symbol = "£";
        break;
      case "HKD":
        symbol = "HK$";
        break;
      case "HUF":
        symbol = "Ft";
        break;
      case "INR":
        symbol = "₹";
        break;
      case "JPY":
        symbol = "¥";
        break;
      case "MXN":
        symbol = "Mex$";
        break;
      case "MYR":
        symbol = "RM";
        break;
      case "NOK":
        symbol = "kr";
        break;
      case "NZD":
        symbol = "NZ$";
        break;
      case "PLN":
        symbol = "zł";
        break;
      case "RON":
        symbol = "L";
        break;
      case "SEK":
        symbol = "kr";
        break;
      case "SGD":
        symbol = "S$";
        break;
      default:
        symbol = agencyCurrency ? agencyCurrency : "$";
        break;
    }
    return symbol;
  },
  agencyLogoHeight: function agencyLogoHeight(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.logo_height) {
      return agency.logo_height;
    }
    return 60; // Default is 60px
  },
  agencyLogoHeightInPx: function agencyLogoHeightInPx(state, getters) {
    return getters.agencyLogoHeight + 'px';
  },
  stripeAccountId: function stripeAccountId(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.stripe_account_id) {
      return agency.stripe_account_id;
    }
    return '';
  },
  useModalInApplicationForm: function useModalInApplicationForm(state) {
    var agency = state.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.use_modal_application_form != null) {
      return agency.public_advance_setting.use_modal_application_form;
    }
    return true; // deafult is true
  },
  chooseAddOptionSelectively: function chooseAddOptionSelectively(state) {
    var agency = state.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.choose_add_option_selectively != null) {
      return agency.public_advance_setting.choose_add_option_selectively;
    }
    return false; // deafult is false
  },
  disableWarningCancelPopupApplicationForm: function disableWarningCancelPopupApplicationForm(state) {
    var agency = state.agencyPublic;
    if (agency && agency.public_advance_setting && agency.public_advance_setting.disable_confirm_cancel_popup_application_form != null) {
      return agency.public_advance_setting.disable_confirm_cancel_popup_application_form;
    }
    return false; // deafult is false
  },
  twilioPhoneNumber: function twilioPhoneNumber(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.twilio_phone_number) {
      return agency.twilio_phone_number;
    }
    return "";
  },
  agencyType: function agencyType(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.type) {
      return agency.type;
    }
    return "";
  },
  agencyCountries: function agencyCountries(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.countries) {
      return agency.countries.map(function (country) {
        var countryObj = rootState.listCountries.find(function (item) {
          return item.code === country;
        });
        if (countryObj) {
          return countryObj.name;
        }
        return country;
      });
    }
    return [];
  },
  agencyDistanceUnitLabel: function agencyDistanceUnitLabel(state, getters) {
    var option = _options.DISTANCE_UNITS.find(function (option) {
      return option.value === getters.agencyDistanceUnit;
    });
    if (option) {
      return option.label;
    }
    return "Mile";
  },
  getDashboardV2: function getDashboardV2(state, _) {
    return state.dashboardv2;
  },

  wordUsedForCandidate: function wordUsedForCandidate(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.word_used_for_candidate;
    }) || 'Candidate';
  },
  wordUsedForClient: function wordUsedForClient(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.word_used_for_client;
    }) || 'Client';
  },
  wordUsedForCandidates: function wordUsedForCandidates(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.word_used_for_candidates;
    }) || 'Candidates';
  },
  wordUsedForClients: function wordUsedForClients(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.word_used_for_clients;
    }) || 'Clients';
  },
  wordUsedForShiftJobCalendar: function wordUsedForShiftJobCalendar(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.word_used_for_shift_job_calendar;
    }) || "Shift Job Calendar";
  },
  wordUsedForJobPlacement: function wordUsedForJobPlacement(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.word_used_for_job_placement;
    }) || "Placement Jobs";
  },
  agencyDistanceUnit: function agencyDistanceUnit(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.distance_unit;
    }) || "miles";
  },
  datepickerDefaultFormat: function datepickerDefaultFormat(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.datepicker_default_format;
    }) || _defaultValues.DEFAULT_DATEPICKER_FIELD.FORMAT;
  },
  datepickerDefaultPlaceholder: function datepickerDefaultPlaceholder(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.datepicker_default_placeholder;
    }) || _defaultValues.DEFAULT_DATEPICKER_FIELD.PLACEHOLDER;
  },
  phoneDefaultFormat: function phoneDefaultFormat(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.phone_default_format;
    });
  },
  agencyPredefinedOptionList: function agencyPredefinedOptionList(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.predefined_option_list;
    });
  },
  notifyAgencyUserEditDocumentAdditionalInfo: function notifyAgencyUserEditDocumentAdditionalInfo(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.notify_agency_user_edit_document_additional_info;
    }) || false;
  },
  showMinEntriesRequiredApplicationForm: function showMinEntriesRequiredApplicationForm(state) {
    return (0, _tryGet2.default)(function () {
      return state.agencyPublic.public_advance_setting.show_min_entries_required_application_form;
    }) || false;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  errorDialog: null,
  confirmDialog: null,
  resultDialog: null,
  infoDialog: null,
  inputDialog: null,
  loadingReqNumber: 0,
  showStatusDialog: true,
  isRecordingVideo: false,
  toastCountDownConfirm: null,
  editBuilderFieldDialog: null
};

var mutations = {
  setErrorDialog: function setErrorDialog(state, payload) {
    state.errorDialog = payload;
  },
  setConfirmDialog: function setConfirmDialog(state, payload) {
    state.confirmDialog = payload;
  },
  setResultDialog: function setResultDialog(state, payload) {
    state.resultDialog = payload;
  },
  setInfoDialog: function setInfoDialog(state, payload) {
    state.infoDialog = payload;
  },
  setInputDialog: function setInputDialog(state, payload) {
    state.inputDialog = payload;
  },
  increaseLoadingReqNumber: function increaseLoadingReqNumber(state, payload) {
    state.loadingReqNumber += payload;
  },
  setShowStatusDialog: function setShowStatusDialog(state, payload) {
    state.showStatusDialog = payload;
  },
  setIsRecordingVideo: function setIsRecordingVideo(state, payload) {
    state.isRecordingVideo = payload;
  },
  setToastCountDownConfirm: function setToastCountDownConfirm(state, payload) {
    state.toastCountDownConfirm = payload;
  },
  setEditBuilderFieldDialog: function setEditBuilderFieldDialog(state, payload) {
    state.editBuilderFieldDialog = payload;
  }
};

var actions = {
  setErrorDialog: function setErrorDialog(_ref, payload) {
    var commit = _ref.commit;

    commit("setErrorDialog", payload);
  },
  setConfirmDialog: function setConfirmDialog(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setConfirmDialog", payload);
  },
  setResultDialog: function setResultDialog(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setResultDialog", payload);
  },
  setInfoDialog: function setInfoDialog(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setInfoDialog", payload);
  },
  setInputDialog: function setInputDialog(_ref5, payload) {
    var commit = _ref5.commit;

    commit("setInputDialog", payload);
  },
  increaseLoadingReqNumber: function increaseLoadingReqNumber(_ref6, payload) {
    var commit = _ref6.commit;

    commit("increaseLoadingReqNumber", payload);
  },
  updateShowStatusDialog: function updateShowStatusDialog(_ref7, payload) {
    var commit = _ref7.commit;

    commit("setShowStatusDialog", payload);
  },
  setIsRecordingVideo: function setIsRecordingVideo(_ref8, payload) {
    var commit = _ref8.commit;

    commit("setIsRecordingVideo", payload);
  },
  setToastCountDownConfirm: function setToastCountDownConfirm(_ref9, payload) {
    var commit = _ref9.commit;

    commit("setToastCountDownConfirm", payload);
  },
  setEditBuilderFieldDialog: function setEditBuilderFieldDialog(_ref10, payload) {
    var commit = _ref10.commit;

    commit("setEditBuilderFieldDialog", payload);
  }
};

var getters = {
  loadingReqNumber: function loadingReqNumber(state) {
    return state.loadingReqNumber;
  },
  errorDialog: function errorDialog(state) {
    return state.errorDialog;
  },

  showStatusDialog: function showStatusDialog(state) {
    return state.showStatusDialog;
  },
  isRecordingVideo: function isRecordingVideo(state) {
    return state.isRecordingVideo;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state, _getters;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var state = (_state = {
    submitSuccessNannyForm: {
        title: "Thank you for your application to join our team!",
        message: "We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.",
        isDefault: true
    },
    submitSuccessReferenceForm: {
        title: "Thank you for your information!",
        message: "The reference information you submitted is very important for us. You can safely close this window now."
    },
    submitSuccessFamilyForm: {
        innerHtml: "\n        <h2>Thank you for submitting your registration!</h2>\n        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>\n        ",
        isDefault: true
    },
    profileCompleteResultDialog: {
        message: "Thanks for letting us know, we will be in touch with you shortly!"
    },
    videoUploadeResultDialog: {
        innerHtml: "\n        <h2>Video is uploaded successfully!</h2>\n        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class=\"material-icons\" style='position: absolute;'>refresh</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;) button</h5>\n        "
    },
    updateSectionSuccess: {
        title: "Section Saved",
        message: "Saved {0} section!"
    },
    updateBookingSectionSuccess: {
        title: "Your booking has been {0}"
    },
    updateFamilyFormSuccess: {
        title: "Family Form Updated",
        message: "Updated Family Form successfully"
    },
    updateSectionReject: {
        title: "Thank you",
        // message: "Information of Section {0} is rejected!"
        message: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    submitRejectForm: {
        title: "Thank you",
        message: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    statusUpdatedResultDialog: {
        title: "Status updated."
    },
    successfullyBroadcastResultDialog: {
        title: "Broadcast sent!"
    },
    nannyAssignedResultDialog: {
        title: "Candidate assigned!",
        message: "Please proceed to the client and candidate notification."
    },
    nannyAssignedToMultipleResultDialog: {
        title: "Candidate assigned to the selected jobs",
        message: "Please proceed to the client and candidate notification."
    },
    nannyAssignedChargedResultDialog: {
        title: "Candidate assigned and Client charged!",
        message: "Please proceed to the client and candidate notification."
    },
    jobUpdatedResultDialog: {
        title: "Job updated!"
    },
    jobPostedResultDialog: {
        title: "Job created!"
    },
    jobChargedResultDialog: {
        title: "Client charged and job status updated!"
    },
    jobInvoicedResultDialog: {
        title: "Client Invoiced!"
    },
    clientChargedResultDialog: {
        title: "Client has been charged through Stripe!"
    },
    messageSentResultDialog: {
        title: "Message sent."
    },
    changePasswordResultDialog: {
        title: "Password has been reset successfully."
    },
    saveProfilePictureResultDialog: {
        title: "Profile picture has been saved successfully."
    },
    deleteProfilePictureResultDialog: {
        title: "Profile picture has been deleted successfully."
    },
    documentUploadedResultDialog: {
        title: "Documents uploaded.",
        message: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    documentSignedResultDialog: {
        title: "Your document has been signed."
    },
    documentSavedResultDialog: {
        title: "Your document has been saved."
    },
    documentInformationUpdatedResultDialog: {
        title: "The additional information of the document {0} is updated"
    },
    templateCreatedResultDialog: {
        title: "Template created."
    },
    templateUpdatedResultDialog: {
        title: "Template updated"
    },
    templateDeletedResultDialog: {
        title: "Template deleted"
    },
    templateDuplicatedResultDialog: {
        title: "Template duplicated."
    },
    passwordResetResultDialog: {
        title: "Password reset",
        message: "Password reset to {0}"
    }
}, _defineProperty(_state, "messageSentResultDialog", {
    title: "Message sent."
}), _defineProperty(_state, "profileBuilderUpdatedResultDialog", {
    title: "Profile builder updated"
}), _defineProperty(_state, "emailFooterSavedResultDialog", {
    title: "Email footer is saved"
}), _defineProperty(_state, "smsFooterSavedResultDialog", {
    title: "SMS footer is saved"
}), _defineProperty(_state, "notificationSettingSavedResultDialog", {
    title: "Notification settings saved"
}), _defineProperty(_state, "additionalAdminSettingsSavedResultDialog", {
    title: "Additional admin settings saved"
}), _defineProperty(_state, "managerUpdatedResultDialog", {
    title: "Manager updated."
}), _defineProperty(_state, "adminAddedResultDialog", {
    title: "Administrator added"
}), _defineProperty(_state, "adminUpdatedResultDialog", {
    title: "Administrator updated"
}), _defineProperty(_state, "adminDeletedResultDialog", {
    title: "Administrator deleted"
}), _defineProperty(_state, "locationsUpdatedResultDialog", {
    title: "Locations updated"
}), _defineProperty(_state, "languageUpdatedResultDialog", {
    title: "Language updated"
}), _defineProperty(_state, "jobBroadcastSentResultDialog", {
    title: "Broadcast sent to {0} candidates!"
}), _defineProperty(_state, "jobViewsResultDialog", {
    title: "Job views",
    message: "Number of times viewed: {0}"
}), _defineProperty(_state, "blastOffResultDialog", {
    title: "Blast Off!",
    message: "Your {0}s are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the global communication log and the individual user's communication logs as they are sent."
}), _defineProperty(_state, "blastOffPushNotificationDialog", {
    title: "Blast Off!",
    message: "Push Notifications have been blasted"
}), _defineProperty(_state, "noteSavedResultDialog", {
    title: "Note saved!"
}), _defineProperty(_state, "saveAndAddNewObject", {
    title: "{0} saved, please add another one!",
    closeLabel: "OK"
}), _defineProperty(_state, "applicationStatusUpdatedResultDialog", {
    title: "Thanks for letting us know!"
}), _defineProperty(_state, "jobAcceptedResultDialog", {
    title: "Congrats, you've accepted this job!",
    message: 'All the details will appear in your dashboard under "My Jobs".'
}), _defineProperty(_state, "updateVisibilityScopeResultDialog", {
    title: "Visibility scope of the {0} is updated to {1}"
}), _defineProperty(_state, "checkFormUpdated", {
    title: "{0} check form is updated"
}), _defineProperty(_state, "savedChangesResultDialog", {
    title: "Changes Saved!"
}), _defineProperty(_state, "priceCreatedResultDialog", {
    title: "Price Created."
}), _defineProperty(_state, "priceUpdatedResultDialog", {
    title: "Price Updated."
}), _defineProperty(_state, "priceDeletedResultDialog", {
    title: "Price Deleted."
}), _defineProperty(_state, "relationshipCreatedResultDialog", {
    title: "Candidate to Client link created!"
}), _defineProperty(_state, "relationshipUpdatedResultDialog", {
    title: "Candidate to Client link updated!"
}), _defineProperty(_state, "offerUpdatedResultDialog", {
    title: "Offer Updated!"
}), _defineProperty(_state, "reviewSubmittedResultDialog", {
    title: "Thank you for leaving a review!"
}), _defineProperty(_state, "markedFavoriteResultDialog", {
    title: "Marked as favorite!",
    message: "We will do our best to match you with them in the future."
}), _defineProperty(_state, "markedDontWantResultDialog", {
    title: "Thank you for letting us know.",
    message: "We will do our best to connect you with other caregivers in the future"
}), _defineProperty(_state, "paymentSubmittedResultDialog", {
    title: "Thank you for submitting your payment information!"
}), _state);

var mutations = {};

var actions = {};

var getters = (_getters = {
    nannyAssignedToMultipleResultDialog: function nannyAssignedToMultipleResultDialog(state) {
        return state.nannyAssignedToMultipleResultDialog;
    },
    submitSuccessNannyForm: function submitSuccessNannyForm(state) {
        return state.submitSuccessNannyForm;
    },
    submitSuccessReferenceForm: function submitSuccessReferenceForm(state) {
        return state.submitSuccessReferenceForm;
    },
    submitSuccessFamilyForm: function submitSuccessFamilyForm(state) {
        return state.submitSuccessFamilyForm;
    },
    profileCompleteResultDialog: function profileCompleteResultDialog(state) {
        return state.profileCompleteResultDialog;
    },
    videoUploadeResultDialog: function videoUploadeResultDialog(state) {
        return state.videoUploadeResultDialog;
    },
    updateSectionSuccess: function updateSectionSuccess(state) {
        return state.updateSectionSuccess;
    },
    updateBookingSectionSuccess: function updateBookingSectionSuccess(state) {
        return state.updateBookingSectionSuccess;
    },
    updateFamilyFormSuccess: function updateFamilyFormSuccess(state) {
        return state.updateFamilyFormSuccess;
    },
    updateSectionReject: function updateSectionReject(state) {
        return state.updateSectionReject;
    },
    submitRejectForm: function submitRejectForm(state) {
        return state.submitRejectForm;
    },
    statusUpdatedResultDialog: function statusUpdatedResultDialog(state) {
        return state.statusUpdatedResultDialog;
    },
    successfullyBroadcastResultDialog: function successfullyBroadcastResultDialog(state) {
        return state.successfullyBroadcastResultDialog;
    },
    nannyAssignedResultDialog: function nannyAssignedResultDialog(state) {
        return state.nannyAssignedResultDialog;
    },
    nannyAssignedChargedResultDialog: function nannyAssignedChargedResultDialog(state) {
        return state.nannyAssignedChargedResultDialog;
    },
    jobUpdatedResultDialog: function jobUpdatedResultDialog(state) {
        return state.jobUpdatedResultDialog;
    },
    jobPostedResultDialog: function jobPostedResultDialog(state) {
        return state.jobPostedResultDialog;
    },
    jobChargedResultDialog: function jobChargedResultDialog(state) {
        return state.jobChargedResultDialog;
    },
    jobInvoicedResultDialog: function jobInvoicedResultDialog(state) {
        return state.jobInvoicedResultDialog;
    },
    clientChargedResultDialog: function clientChargedResultDialog(state) {
        return state.clientChargedResultDialog;
    },
    messageSentResultDialog: function messageSentResultDialog(state) {
        return state.messageSentResultDialog;
    },
    changePasswordResultDialog: function changePasswordResultDialog(state) {
        return state.changePasswordResultDialog;
    },
    saveProfilePictureResultDialog: function saveProfilePictureResultDialog(state) {
        return state.saveProfilePictureResultDialog;
    },
    deleteProfilePictureResultDialog: function deleteProfilePictureResultDialog(state) {
        return state.deleteProfilePictureResultDialog;
    },
    documentUploadedResultDialog: function documentUploadedResultDialog(state) {
        return state.documentUploadedResultDialog;
    },
    documentSignedResultDialog: function documentSignedResultDialog(state) {
        return state.documentSignedResultDialog;
    },
    documentSavedResultDialog: function documentSavedResultDialog(state) {
        return state.documentSavedResultDialog;
    },
    documentInformationUpdatedResultDialog: function documentInformationUpdatedResultDialog(state) {
        return state.documentInformationUpdatedResultDialog;
    },
    templateCreatedResultDialog: function templateCreatedResultDialog(state) {
        return state.templateCreatedResultDialog;
    },
    templateUpdatedResultDialog: function templateUpdatedResultDialog(state) {
        return state.templateUpdatedResultDialog;
    },
    templateDeletedResultDialog: function templateDeletedResultDialog(state) {
        return state.templateDeletedResultDialog;
    },
    templateDuplicatedResultDialog: function templateDuplicatedResultDialog(state) {
        return state.templateDuplicatedResultDialog;
    },
    passwordResetResultDialog: function passwordResetResultDialog(state) {
        return state.passwordResetResultDialog;
    }
}, _defineProperty(_getters, "messageSentResultDialog", function messageSentResultDialog(state) {
    return state.messageSentResultDialog;
}), _defineProperty(_getters, "profileBuilderUpdatedResultDialog", function profileBuilderUpdatedResultDialog(state) {
    return state.profileBuilderUpdatedResultDialog;
}), _defineProperty(_getters, "emailFooterSavedResultDialog", function emailFooterSavedResultDialog(state) {
    return state.emailFooterSavedResultDialog;
}), _defineProperty(_getters, "smsFooterSavedResultDialog", function smsFooterSavedResultDialog(state) {
    return state.smsFooterSavedResultDialog;
}), _defineProperty(_getters, "notificationSettingSavedResultDialog", function notificationSettingSavedResultDialog(state) {
    return state.notificationSettingSavedResultDialog;
}), _defineProperty(_getters, "additionalAdminSettingsSavedResultDialog", function additionalAdminSettingsSavedResultDialog(state) {
    return state.additionalAdminSettingsSavedResultDialog;
}), _defineProperty(_getters, "managerUpdatedResultDialog", function managerUpdatedResultDialog(state) {
    return state.managerUpdatedResultDialog;
}), _defineProperty(_getters, "adminAddedResultDialog", function adminAddedResultDialog(state) {
    return state.adminAddedResultDialog;
}), _defineProperty(_getters, "adminUpdatedResultDialog", function adminUpdatedResultDialog(state) {
    return state.adminUpdatedResultDialog;
}), _defineProperty(_getters, "adminDeletedResultDialog", function adminDeletedResultDialog(state) {
    return state.adminDeletedResultDialog;
}), _defineProperty(_getters, "locationsUpdatedResultDialog", function locationsUpdatedResultDialog(state) {
    return state.locationsUpdatedResultDialog;
}), _defineProperty(_getters, "languageUpdatedResultDialog", function languageUpdatedResultDialog(state) {
    return state.languageUpdatedResultDialog;
}), _defineProperty(_getters, "jobBroadcastSentResultDialog", function jobBroadcastSentResultDialog(state) {
    return state.jobBroadcastSentResultDialog;
}), _defineProperty(_getters, "jobViewsResultDialog", function jobViewsResultDialog(state) {
    return state.jobViewsResultDialog;
}), _defineProperty(_getters, "blastOffResultDialog", function blastOffResultDialog(state) {
    return state.blastOffResultDialog;
}), _defineProperty(_getters, "noteSavedResultDialog", function noteSavedResultDialog(state) {
    return state.noteSavedResultDialog;
}), _defineProperty(_getters, "saveAndAddNewObject", function saveAndAddNewObject(state) {
    return state.saveAndAddNewObject;
}), _defineProperty(_getters, "applicationStatusUpdatedResultDialog", function applicationStatusUpdatedResultDialog(state) {
    return state.applicationStatusUpdatedResultDialog;
}), _defineProperty(_getters, "jobAcceptedResultDialog", function jobAcceptedResultDialog(state) {
    return state.jobAcceptedResultDialog;
}), _defineProperty(_getters, "updateVisibilityScopeResultDialog", function updateVisibilityScopeResultDialog(state) {
    return state.updateVisibilityScopeResultDialog;
}), _defineProperty(_getters, "checkFormUpdated", function checkFormUpdated(state) {
    return state.checkFormUpdated;
}), _defineProperty(_getters, "savedChangesResultDialog", function savedChangesResultDialog(state) {
    return state.savedChangesResultDialog;
}), _defineProperty(_getters, "priceCreatedResultDialog", function priceCreatedResultDialog(state) {
    return state.priceCreatedResultDialog;
}), _defineProperty(_getters, "priceUpdatedResultDialog", function priceUpdatedResultDialog(state) {
    return state.priceUpdatedResultDialog;
}), _defineProperty(_getters, "priceDeletedResultDialog", function priceDeletedResultDialog(state) {
    return state.priceDeletedResultDialog;
}), _defineProperty(_getters, "relationshipCreatedResultDialog", function relationshipCreatedResultDialog(state) {
    return state.relationshipCreatedResultDialog;
}), _defineProperty(_getters, "relationshipUpdatedResultDialog", function relationshipUpdatedResultDialog(state) {
    return state.relationshipUpdatedResultDialog;
}), _defineProperty(_getters, "offerUpdatedResultDialog", function offerUpdatedResultDialog(state) {
    return state.offerUpdatedResultDialog;
}), _defineProperty(_getters, "reviewSubmittedResultDialog", function reviewSubmittedResultDialog(state) {
    return state.reviewSubmittedResultDialog;
}), _defineProperty(_getters, "markedFavoriteResultDialog", function markedFavoriteResultDialog(state) {
    return state.markedFavoriteResultDialog;
}), _defineProperty(_getters, "markedDontWantResultDialog", function markedDontWantResultDialog(state) {
    return state.markedDontWantResultDialog;
}), _defineProperty(_getters, "paymentSubmittedResultDialog", function paymentSubmittedResultDialog(state) {
    return state.paymentSubmittedResultDialog;
}), _defineProperty(_getters, "blastOffPushNotificationDialog", function blastOffPushNotificationDialog(state) {
    return state.blastOffPushNotificationDialog;
}), _getters);

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  deleteReferenceConfirmDialog: {
    message: "Are you sure you want to delete this reference?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteExperienceConfirmDialog: {
    message: "Are you sure you want to delete this experience?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteContactConfirmDialog: {
    message: "Are you sure you want to delete this contact?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteEducationConfirmDialog: {
    message: "Are you sure you want to delete this education?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteChildrenConfirmDialog: {
    message: "Are you sure you want to delete this child?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deletePetConfirmDialog: {
    message: "Are you sure you want to delete this pet?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteBookingConfirmDialog: {
    message: "Are you sure you want to delete this booking?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteProfileBuilderConfirmDialog: {
    message: "Are you sure you want to delete the profile builder {0}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteRequestConfirmDialog: {
    message: "Are you sure you want to delete this request?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteJobConfirmDialog: {
    message: "Are you sure you want to delete this job?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteApplicationConfirmDialog: {
    message: "Are you sure you want to delete this application?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteDocumentConfirmDialog: {
    message: "Are you sure you want to delete the document {0}?",
    acceptLabel: "Delete Document",
    rejectLabel: "Close"
  },
  deleteFileConfirmDialog: {
    message: "Are you sure you want to delete the file?",
    acceptLabel: "Delete",
    rejectLabel: "Close"
  },
  deleteTemplateConfirmDialog: {
    message: "Are you sure you want to delete the {0} template {1}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deletePriceConfirmDialog: {
    message: "Are you sure you want to delete the {0} {1}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteUserConfirmDialog: {
    innerHtml: "<h3>Are you sure you want to delete this user?</h3>\n    <h4>It may be better to set their status to Rejected or Inactive so you retain the information.</h4>\n    <p>{0} {1}</p>\n    <p>{2}</p>",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteAdminConfirmDialog: {
    innerHtml: "<h3>Are you sure you want to delete this user?</h3>\n    <p>{0}</p>",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteResourceConfirmDialog: {
    message: "Are you sure you want to remove {0}?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  cancelBookingConfirmDialog: {
    message: "Are you sure you want to cancel this booking? {0}",
    showReasonInput: true,
    reasonOnConfirmLabel: "Please explain why you are canceling this booking?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  cancelConfirmDialog: {
    message: "Are you sure you want to close? Any changes will be lost.",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  editConfirmDialog: {
    message: "Are you sure of your changes?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  bulkStatusChangeConfirmDialog: {
    message: "Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  overwriteVideoConfirmDialog: {
    message: "There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?",
    acceptLabel: "Continue",
    rejectLabel: "Cancel"
  },
  deleteProfilePictureConfirmDialog: {
    message: "Are you sure you want to delete the profile picture?",
    acceptLabel: "Delete Picture",
    rejectLabel: "Close"
  },
  deleteRelationshipConfirmDialog: {
    message: "Are you sure you want to remove the link between {0} and this client?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  candidateAcceptJobConfirmDialog: {
    message: "You are committing to filling this job, are you sure?",
    acceptLabel: "Accept Job",
    rejectLabel: "Close"
  },
  markAsFavoriteConfirmDialog: {
    message: "Are you sure you want to mark {0} as favorite?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  markAsDoNotWantConfirmDialog: {
    message: "Are you sure you do not want {0} again?",
    acceptLabel: "Yes",
    rejectLabel: "No"
  },
  deleteNoteConfirmDialog: {
    innerHtml: "<h3>Are you sure you want to delete the note?</h3>\n    <p style=\"white-space: pre-wrap;\">{0}</p>",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteCreditConfirmDialog: {
    message: "Are you sure you want to delete this credit?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  }
};

var mutations = {};

var actions = {};

var getters = {
  deleteReferenceConfirmDialog: function deleteReferenceConfirmDialog(state) {
    return state.deleteReferenceConfirmDialog;
  },
  deleteExperienceConfirmDialog: function deleteExperienceConfirmDialog(state) {
    return state.deleteExperienceConfirmDialog;
  },
  deleteContactConfirmDialog: function deleteContactConfirmDialog(state) {
    return state.deleteContactConfirmDialog;
  },
  deleteEducationConfirmDialog: function deleteEducationConfirmDialog(state) {
    return state.deleteEducationConfirmDialog;
  },
  deleteChildrenConfirmDialog: function deleteChildrenConfirmDialog(state) {
    return state.deleteChildrenConfirmDialog;
  },
  deleteBookingConfirmDialog: function deleteBookingConfirmDialog(state) {
    return state.deleteBookingConfirmDialog;
  },
  deletePetConfirmDialog: function deletePetConfirmDialog(state) {
    return state.deletePetConfirmDialog;
  },
  deleteProfileBuilderConfirmDialog: function deleteProfileBuilderConfirmDialog(state) {
    return state.deleteProfileBuilderConfirmDialog;
  },
  deleteRequestConfirmDialog: function deleteRequestConfirmDialog(state) {
    return state.deleteRequestConfirmDialog;
  },
  deleteJobConfirmDialog: function deleteJobConfirmDialog(state) {
    return state.deleteJobConfirmDialog;
  },
  deleteApplicationConfirmDialog: function deleteApplicationConfirmDialog(state) {
    return state.deleteApplicationConfirmDialog;
  },
  deleteDocumentConfirmDialog: function deleteDocumentConfirmDialog(state) {
    return state.deleteDocumentConfirmDialog;
  },
  deleteFileConfirmDialog: function deleteFileConfirmDialog(state) {
    return state.deleteFileConfirmDialog;
  },
  deleteTemplateConfirmDialog: function deleteTemplateConfirmDialog(state) {
    return state.deleteTemplateConfirmDialog;
  },
  deletePriceConfirmDialog: function deletePriceConfirmDialog(state) {
    return state.deletePriceConfirmDialog;
  },
  deleteUserConfirmDialog: function deleteUserConfirmDialog(state) {
    return state.deleteUserConfirmDialog;
  },
  deleteAdminConfirmDialog: function deleteAdminConfirmDialog(state) {
    return state.deleteAdminConfirmDialog;
  },
  deleteResourceConfirmDialog: function deleteResourceConfirmDialog(state) {
    return state.deleteResourceConfirmDialog;
  },
  cancelBookingConfirmDialog: function cancelBookingConfirmDialog(state) {
    return state.cancelBookingConfirmDialog;
  },
  cancelConfirmDialog: function cancelConfirmDialog(state) {
    return state.cancelConfirmDialog;
  },
  editConfirmDialog: function editConfirmDialog(state) {
    return state.editConfirmDialog;
  },
  bulkStatusChangeConfirmDialog: function bulkStatusChangeConfirmDialog(state) {
    return state.bulkStatusChangeConfirmDialog;
  },
  overwriteVideoConfirmDialog: function overwriteVideoConfirmDialog(state) {
    return state.overwriteVideoConfirmDialog;
  },
  deleteProfilePictureConfirmDialog: function deleteProfilePictureConfirmDialog(state) {
    return state.deleteProfilePictureConfirmDialog;
  },
  deleteRelationshipConfirmDialog: function deleteRelationshipConfirmDialog(state) {
    return state.deleteRelationshipConfirmDialog;
  },
  candidateAcceptJobConfirmDialog: function candidateAcceptJobConfirmDialog(state) {
    return state.candidateAcceptJobConfirmDialog;
  },
  markAsFavoriteConfirmDialog: function markAsFavoriteConfirmDialog(state) {
    return state.markAsFavoriteConfirmDialog;
  },
  markAsDoNotWantConfirmDialog: function markAsDoNotWantConfirmDialog(state) {
    return state.markAsDoNotWantConfirmDialog;
  },
  deleteNoteConfirmDialog: function deleteNoteConfirmDialog(state) {
    return state.deleteNoteConfirmDialog;
  },
  deleteCreditConfirmDialog: function deleteCreditConfirmDialog(state) {
    return state.deleteCreditConfirmDialog;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requiredValues = __webpack_require__(58);

var state = {
  missingEmailFieldError: {
    title: "Missing field for Email Address",
    message: "Please add at least 1 field for email address!"
  },
  invalidInputError: {
    title: "A required field is missing or a field is invalid.",
    message: "Please review the form for error messages!"
  },
  missingBookingTimeError: {
    title: "Booking time is missing",
    message: "Please add booking time (Start Time and End Time)!"
  },
  missingSignatureError: {
    title: "A document is not signed",
    message: "Please review the form for error messages and sign all documents!"
  },
  inputConditionError: {
    title: "An input field is invalid",
    message: "There is an input field which is invalid"
  },
  builderNoFieldError: {
    title: "There is no field for the builder",
    message: "Please add at least one field!"
  },
  exclusiveOptionsUseSameValue: {
    title: "Cannot use same option between {0} and {1}",
    message: "Please unselect option(s) {2} in {0} or {1}"
  },
  missingDependencyObjectError: {
    title: "Please add more {0}!",
    message: "You must have at least {1} {0}"
  },
  missingExperienceError: {
    title: "Experience is lacking",
    message: "You must have at least 1 experience."
  },
  missingStatusError: {
    title: "Statuses is lacking",
    message: _requiredValues.LIST_REQUIRED_STATUSES.join(" and ") + " are required statuses"
  },
  duplicateStatusError: {
    title: "Statuses is duplicated",
    message: "There are some statuses which are duplicated"
  },
  duplicateModelError: {
    title: "Multi fields using the same model",
    message: "There is a model which is assigned to at least 2 fields"
  },
  duplicateChecklistItemError: {
    title: "Statuses is duplicated",
    message: "There are some items which are duplicated"
  },
  duplicateEmployerTypeError: {
    title: "Employer type is duplicated",
    message: "There are some employer type which are duplicated"
  },
  duplicateCandidateTypeError: {
    title: "Candidate type is duplicated",
    message: "There are some candidate type which are duplicated"
  },
  invalidImageFileTypeError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a PNG or JPG image."
  },
  invalidDocFileTypeError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a DOC or DOCX or PDF file."
  },
  emptyFileError: {
    title: "File is empty!",
    message: "Please upload a non empty file"
  },
  fileSizeExceedLimitError: {
    title: "File too big!",
    message: "Please upload a file with a size below the maximum upload size."
  },
  invalidInputFile: {
    title: "Invalid File",
    message: "Invalid input file"
  },
  missingResumeError: {
    title: "Your professional childcare resume is missing",
    message: "Please upload your professional childcare resume"
  },
  endDateBeforeStartDateError: {
    title: "End date must be after start date",
    message: "Please change start date or end date"
  },
  endHourBeforeStartHourError: {
    title: "End time must be after start time",
    message: "Please change start time or end time"
  },
  bookingDurationTooShortError: {
    title: "Bookings must be at least {0} hours.",
    message: "Please change start time or end time"
  },
  missingProfilePictureError: {
    title: "Your profile picture is missing",
    message: "Please upload a recent photo of yourself!"
  },
  noTextSelect: {
    title: "No text selected",
    message: "Please select some text"
  },
  submitReferenceError: {
    title: "Your application has been submitted! BUT",
    message: "There was an error processing your references. Can you please email them to us? Thanks!"
  },
  submitError: {
    title: "Failed to submit your application",
    message: "There was an error processing your application"
  },
  missingItemInJobStatusList: {
    title: "Missing item in status list",
    message: "Status {0} is required"
  },
  hasIncompleteSection: {
    title: "There is an incomplete section",
    message: "Section {0} is incomplete. Please update that section"
  },
  passwordUnmatchError: {
    title: "Passwords do not match."
  },
  missingAddressErrorDialog: {
    title: "Unable to find nearby Candidates",
    message: "Job is missing a full address. To search for candidates Edit Job and fill missing address info"
  },
  profileBuilderInUsed: {
    title: "The profile builder is in used",
    message: "The profile builder is being used by the profile builder {0}.\nPlease remove that profile builder first"
  },
  missingSignatureErrorDialog: {
    title: "A signature is missing",
    message: "Please type your name to sign"
  },
  missingRequiredFieldSigningErrorDialog: {
    title: "A required field is missing",
    message: "Please fill all of the required fields (Please check the red border fields)"
  },
  userExistedErrorDialog: {
    innerHtml: "\n                <h2>It looks like you are already in our system!</h2>\n                <h4 class=\"error-message main-message\">\n                Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!\n                </h4>\n                "
  }
};

var mutations = {};

var actions = {};

var getters = {
  missingEmailFieldError: function missingEmailFieldError(state) {
    return state.missingEmailFieldError;
  },
  invalidInputError: function invalidInputError(state) {
    return state.invalidInputError;
  },
  missingBookingTimeError: function missingBookingTimeError(state) {
    return state.missingBookingTimeError;
  },
  missingSignatureError: function missingSignatureError(state) {
    return state.missingSignatureError;
  },
  inputConditionError: function inputConditionError(state) {
    return state.inputConditionError;
  },
  builderNoFieldError: function builderNoFieldError(state) {
    return state.builderNoFieldError;
  },
  exclusiveOptionsUseSameValue: function exclusiveOptionsUseSameValue(state) {
    return state.exclusiveOptionsUseSameValue;
  },
  missingDependencyObjectError: function missingDependencyObjectError(state) {
    return state.missingDependencyObjectError;
  },
  missingExperienceError: function missingExperienceError(state) {
    return state.missingExperienceError;
  },
  missingStatusError: function missingStatusError(state) {
    return state.missingStatusError;
  },
  duplicateStatusError: function duplicateStatusError(state) {
    return state.duplicateStatusError;
  },
  duplicateChecklistItemError: function duplicateChecklistItemError(state) {
    return state.duplicateChecklistItemError;
  },
  duplicateEmployerTypeError: function duplicateEmployerTypeError(state) {
    return state.duplicateEmployerTypeError;
  },
  duplicateCandidateTypeError: function duplicateCandidateTypeError(state) {
    return state.duplicateCandidateTypeError;
  },
  duplicateModelError: function duplicateModelError(state) {
    return state.duplicateModelError;
  },
  invalidImageFileTypeError: function invalidImageFileTypeError(state) {
    return state.invalidImageFileTypeError;
  },
  invalidDocFileTypeError: function invalidDocFileTypeError(state) {
    return state.invalidDocFileTypeError;
  },
  emptyFileError: function emptyFileError(state) {
    return state.emptyFileError;
  },
  fileSizeExceedLimitError: function fileSizeExceedLimitError(state) {
    return state.fileSizeExceedLimitError;
  },
  invalidInputFile: function invalidInputFile(state) {
    return state.invalidInputFile;
  },
  missingResumeError: function missingResumeError(state) {
    return state.missingResumeError;
  },
  endHourBeforeStartHourError: function endHourBeforeStartHourError(state) {
    return state.endHourBeforeStartHourError;
  },
  endDateBeforeStartDateError: function endDateBeforeStartDateError(state) {
    return state.endDateBeforeStartDateError;
  },
  bookingDurationTooShortError: function bookingDurationTooShortError(state) {
    return state.bookingDurationTooShortError;
  },
  missingProfilePictureError: function missingProfilePictureError(state) {
    return state.missingProfilePictureError;
  },
  noTextSelect: function noTextSelect(state) {
    return state.noTextSelect;
  },
  submitReferenceError: function submitReferenceError(state) {
    return state.submitReferenceError;
  },
  submitError: function submitError(state) {
    return state.submitError;
  },
  missingItemInJobStatusList: function missingItemInJobStatusList(state) {
    return state.missingItemInJobStatusList;
  },
  hasIncompleteSection: function hasIncompleteSection(state) {
    return state.hasIncompleteSection;
  },
  passwordUnmatchError: function passwordUnmatchError(state) {
    return state.passwordUnmatchError;
  },
  missingAddressErrorDialog: function missingAddressErrorDialog(state) {
    return state.missingAddressErrorDialog;
  },
  profileBuilderInUsed: function profileBuilderInUsed(state) {
    return state.profileBuilderInUsed;
  },
  missingSignatureErrorDialog: function missingSignatureErrorDialog(state) {
    return state.missingSignatureErrorDialog;
  },
  missingRequiredFieldSigningErrorDialog: function missingRequiredFieldSigningErrorDialog(state) {
    return state.missingRequiredFieldSigningErrorDialog;
  },
  userExistedErrorDialog: function userExistedErrorDialog(state) {
    return state.userExistedErrorDialog;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  emailTemplates: [],
  listEmailTemplates: [],
  listIdNameEmailTemplates: null,
  listSampleEmailTemplates: [],
  applicationFormSubmissionUserEmailTemplate: {
    subject: "Form Submission Summary - {2}",
    message: "Dear {0} {1}<br/><br/>\n    Thank you for your form submission to {2}, please find the details of your submission below:\n    <br/>{3}<br/>\n    ",
    isHtml: true
  },
  profileSectionFormSubmissionEmailTemplate: {
    subject: "Section {0} of a {1} is {8}",
    message: "Section {0} of the {1}: {2} {3} is {8}<br/>\n      Email Address: {4}<br/>\n      Details of the submission:\n      <br/>{7}<br/>\n      Please log into the administrator dashboard ({6}/login/{5}) to view it!\n      "
  },
  profileSectionWithDialogAddedEmailTemplate: {
    subject: "{0} {1} added a new item in the {2} section",
    message: "{0} {1} added a new item in the {2} section\n      Title: {3}\n      Please log into the administrator dashboard ({5}/login/{4}) to view it!\n      "
  },
  profileSectionWithDialogUpdatedEmailTemplate: {
    subject: "{0} {1} updated an item in the {2} section",
    message: "{0} {1} updated an item in the {2} section\n      Title: {3}\n      Please log into the administrator dashboard ({5}/login/{4}) to view it!\n      "
  },
  jobAssignedEmployerNotificationEmailTemplate: {
    subject: "You're All Set! Care Request for {0} Confirmed",
    message: "Hello {1}," + "<br/><br/>" + "{2} {3} has been scheduled to care for your family on {0}.<br/>" + "To learn more about {2} or to view additional booking details please log into your dashboard and click on your service request: ({4})<br/><br/>" + "In the meantime, we are here for you if you need anything else!<br/><br/>" + "With Care,<br/>" + "The {5} Team"
  },
  jobAssignedAdminNotificationEmailTemplate: {
    subject: "Client {0} {1} {8} shift job on {6} {7} for candidate {3} {4}",
    message: "Hello," + "<br/><br/>" + "The client {0} {1} ({2}) {8} shift job on {6} {7} for candidate {3} {4} ({5})"
  },
  jobAcceptedAdminNotificationEmailTemplate: {
    subject: "Job for {0} on {1} accepted by {2}",
    message: "<p>Hello,</p>" + "<p></p>" + "<p>A job has been filled!</p>" + "<p>Client: {0}</p>" + "<p>Details: {1}, {5} - {6}</p>" + "<p>Candidate: {2} {3}, {4}</p>"
  },
  jobInterestedAdminNotificationEmailTemplate: {
    subject: "Job for [[clientfname]] [[clientlname]] on [[date]] marked as \"[[status]]\" by [[candidatefname]] [[candidatelname]]",
    message: "Hello, <br/><br/>" + "A job has been marked as [[statusLowerCase]] <br/><br/>" + "Client: [[clientfname]] [[clientlname]]<br/><br/>" + "Details: [[date]], [[starttime]] - [[endtime]] <br/><br/>" + "Candidate: [[candidatefname]] [[candidatelname]], [[candidateemail]]  <br/><br/>" + "Message: [[applicationNotes]] <br/><br/>" + "Job ID: [[jobid]]"
  },
  jobCandidateReminderEmailTemplate: {
    subject: "Job starts in [[notifyhours]] hours",
    message: "Dear [[candidatefname]], <br/><br/>" + "You have an assigned job, which will start in [[notifyhours]] hours.<br/>" + "Job information<br/>" + "Poster: [[clientfname]] [[clientlname]]<br/>" + "Date: [[date]]<br/>" + "Time: [[starttime]]-[[endtime]]"
  },
  jobClientReminderEmailTemplate: {
    subject: "Job starts in [[notifyhours]] hours",
    message: "Dear [[clientfname]], <br/><br/>" + "You have a posted job, which will start in [[notifyhours]] hours.<br/>" + "Job information<br/>" + "Candidate: [[candidatefname]] [[candidatelname]]<br/>" + "Date: [[date]]<br/>" + "Time: [[starttime]]-[[endtime]]"
  },
  jobClockInReminderEmailTemplate: {
    subject: "Clock In Reminder",
    message: "Dear [[candidatefname]], <br/><br/>" + "Please clock in for the job<br/>" + "Poster: [[clientfname]] [[clientlname]]<br/>" + "Date: [[date]]<br/>" + "Time: [[starttime]]-[[endtime]]"
  },
  jobClockOutReminderEmailTemplate: {
    subject: "Clock Out Reminder",
    message: "Dear [[candidatefname]], <br/><br/>" + "Please clock out for the job<br/>" + "Poster: [[clientfname]] [[clientlname]]<br/>" + "Date: [[date]]<br/>" + "Time: [[starttime]]-[[endtime]]"
  },
  applicationSubmittedShiftJobAdminNotificationEmailTemplate: {
    subject: "Job {0} - {5} ({8})",
    message: "<p>Hello,</p>\n    <p></p>\n    <p>New application submitted.</p>\n    <p>Client: {1}</p>\n    <p>Details: {2}, {3} - {4}</p>\n    <p>Candidate: {5} {6}, {7}</p>\n    <p>Status: {8}</p>\n    <p>Message: {9}</p>\n    <p>Job ID: {10}</p>\n    <p>Job Link: {11}</p>\n    "
  },
  applicationSubmittedPlacementJobAdminNotificationEmailTemplate: {
    subject: "Job {0} - {3} ({6})",
    message: "<p>Hello,</p>\n    <p></p>\n    <p>New application submitted.</p>\n    <p>Job: {0} ({1}, {2})</p>\n    <p>Candidate: {3} {4}, {5}</p>\n    <p>Status: {6}</p>\n    <p>Message: {7}</p>\n    <p>Job ID: {8}</p>\n    <p>Job Link: {9}</p>\n    "
  },
  nannyAssignedEmployerNotificationEmailTemplate: {
    subject: "Candidate Assigned for {0}",
    message: "Hello {1}," + "<br/><br/>" + "{2} {3} has been assigned to your service request on {0}.<br/>" + "To view more details about them, please log into your dashboard ({6}/login/{4}) and click on your service request.<br/><br/>" + "Please don't hesitate to reach out if you have any questions or issues!<br/><br/>" + "Thank you,<br/>" + "{5} Team"
  },
  nannyAssignedCandidateNotificationEmailTemplate: {
    subject: "Job Assigned for {0}",
    message: "Hello {1}," + "<br/><br/>" + "You have been assigned to a job on {0}.<br/>" + "To view more details about the job, please log into your dashboard ({2}/login/{3}) and click on the \"My Jobs\" tab.<br/><br/>" + "Please don't hesitate to reach out if you have any questions or issues!<br/><br/>" + "Thank you,<br/>" + "{4} Team"
  },
  jobBookingAddedAgencyNotificationEmailTemplate: {
    subject: "New Booking - {1} {2} {0}",
    message: "The client {1} {2} ({3}) has just made a new booking request for {0} {4} - {5}.\n{6}\n\n" + "{7}"
  },
  jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate: {
    subject: "New Bookings - {0} {1}",
    message: "The client {0} {1} ({2}) has just made new booking requests for the following days:\n\n{3}\n\n" + "Please go to the shift job calendar to view all of the details."
  },
  bookingGroupCreatedAgencyNotificationEmailTemplate: {
    subject: "New Booking Group of {1} {2}",
    message: "The client {1} {2} ({3}) has just created a new booking group of the following jobs:\n{0}.\n\n" + "Please go to the shift job calendar to view all of the details."
  },
  jobBookingUpdatedAgencyNotificationEmailTemplate: {
    subject: "Booking updated - {1} {2} {0}",
    message: "The client {1} {2} ({3}) has just updated the booking request for {0} {4} - {5}.\n\n" + "Detail update:\n{6}\n\n" + "Please go to the shift job calendar to view all of the details."
  },
  jobBookingUpdatedFillerNotificationEmailTemplate: {
    subject: "Booking updated - {1} {2} {0}",
    message: "The client {1} {2} ({3}) has just updated the booking request for {0} {4} - {5}.\n\n" + "Detail update:\n{6}\n\n"
  },
  jobBookingCancelledAgencyNotificationEmailTemplate: {
    subject: "Booking cancelled - {1} {2} {0}",
    message: "The client {1} {2} ({3}) has just cancelled the booking request for {0} {4} - {5}{7}.\n\n{8}" + "The client's reason for canceling is: \n {6}\n\n" + "Please go to the shift job calendar to view all of the details."
  },
  jobBookingCancelledFillerNotificationEmailTemplate: {
    subject: "Booking cancelled - {1} {2} {0}",
    message: "The client {1} {2} ({3}) has just cancelled the booking request for {0} {4} - {5}.\n{6}\n"
  },
  createdRelationshipNotificationEmailTemplate: {
    subject: "New candidate for you to consider - {0}",
    message: "Hello {1}," + "<br/><br/>" + "We have found a great new candidate for you to consider: {0}!<br/>" + "Please log into your dashboard ({4}/login/{2}) to view their profile and let us know what you think.<br/><br/>" + "Thanks!<br/>" + "{3}"
  },
  bulkCreatedRelationshipsNotificationEmailTemplate: {
    subject: "New candidates for you to consider - {0}",
    message: "Hello {1}," + "<br/><br/>" + "We have found a great new candidates for you to consider: {0}!<br/>" + "Please log into your dashboard ({4}/login/{2}) to view their profile and let us know what you think.<br/><br/>" + "Thanks!<br/>" + "{3}"
  },
  updatedRelationshipNotificationEmailTemplate: {
    subject: "New candidate for you to consider - {0}",
    message: "Hello {1}," + "<br/><br/>" + "We have found a great new candidate for you to consider: {0}!<br/>" + "Please log into your dashboard ({4}/login/{2}) to view their profile and let us know what you think.<br/><br/>" + "Sincerely,<br/>{3}"
  },
  scheduleEventNotificationEmailTemplate: {
    subject: "Event Scheduled - [[title]], [[date]], [[time]]",
    message: "Hi [[fname]], <br/><br/>" + "You have a new event scheduled: [[title]] \n" + "Date: [[date]] <br/>" + "Time: [[time]] <br/>" + "Link: [[scheduling_link]] <br/>" + "Notes: [[notes]] <br/><br/>" + "You can view this event in your dashboard as well ([[root_url]]/login/[[agency_id]]). Please let us know if you have any questions! <br/><br/>" + "Thanks, <br/>" + "[[agency_name]]"
  },
  referenceCheckFormEmailTemplate: {
    subject: "Reference Check For {0} {1}",
    message: "Hi {2} {3} <br/><br/>\n    Please fill the form {4} to give us the reference check information about {0} {1}<br/>\n    Sincerely,<br/>{5}\n    "
  },
  shiftJobBroadcastEmailTemplate: {
    subject: "New shift available on [[date]], [[starttime]] - [[endtime]]",
    message: "Hi [[fname]],<br/><br/>\n    There is a new shift available on [[date]] from [[starttime]] to [[endtime]]<br/>\n    If you are interested please go to [[joblink]] for more details.<br/><br/>\n    Thanks!"
  },
  shiftJobBulkBroadcastEmailTemplate: {
    subject: "New Bookings to review",
    message: "[[candidatefname]], <br/><br/>" + "We have new jobs for you to review: <br/>" + "[[linkstojobs]] <br/><br/>" + 'To Review more information about these jobs, please log into your profile and review them under "Available Jobs". <br/>' + "Thank you."
  },
  placementJobBroadcastEmailTemplate: {
    subject: "New Opportunity - {0}",
    message: "<p>Hi [[fname]],</p>" + "<p></p>" + "<p>There is a new opportunity available that may be of interest to you, to see all of the details please visit: {3}/job/{2}/{1}</p>"
  },
  placementJobBulkBroadcastEmailTemplate: {
    subject: "New Jobs to review",
    message: "[[candidatefname]], <br/><br/>" + "We have new jobs for you to review: <br/>" + "[[linkstojobs]] <br/><br/><br/>" + 'To Review more information about these jobs, please log into your profile and review them under "Available Jobs". <br/>' + "Thank you."
  },
  shareClientProfileNotificationEmailTemplate: {
    subject: "New client profile shared with you - {0}",
    message: "Hello {1}," + "<br/><br/>" + "There is a new client profile shared with you: {0}!<br/>" + "Please log into your dashboard ({4}/login/{2}) to view the profile and let us know what you think.<br/><br/>" + "Thanks!<br/>" + "{3}"
  },
  clientInterestedPreliminaryAgencyNotificationEmailTemplate: {
    subject: "Client {0} Interested in {1}",
    message: "Hello {2}," + "\n\n" + "The client {0} is interested in the candidate {1}!\n" + "They should submit the follow up form shortly!\n\n" + "Cheers!"
  },
  clientInterestedAgencyNotificationEmailTemplate: {
    subject: "Client {0} Interested in {1}",
    message: "Hello {4}," + "\n\n" + "The client {0} is interested in the candidate {1}!\n" + "Client meeting preference: {2}\n" + "Client availability: {3}\n\n" + "Cheers!"
  },
  clientNotInterestedAgencyNotificationEmailTemplate: {
    subject: "Client {0} NOT Interested in {1}",
    message: "Hello {2}," + "\n\n" + "The client {0} is NOT interested in the candidate {1}!\n"
  },
  clientNotInterestedFeedbackAgencyNotificationEmailTemplate: {
    subject: "Client {0} NOT Interested in {1}",
    message: "Hello {2}," + "\n\n" + "The client {0} is NOT interested in the candidate {1}!\n" + "Feedback: {3}\n"
  },
  clientExtendedOfferAgencyNotificationEmailTemplate: {
    subject: "Client {0} extended offer to {1}",
    message: "Hello," + "\n\n" + "The client {0} has extended an offer to the candidate {1}!\n" + "Detail Offer:\n{2}\n" + "Cheers!"
  },
  candidateInterestedAgencyNotificationEmailTemplate: {
    subject: "Candidate {0} Interested in {1}",
    message: "Hello," + "\n\n" + "The candidate {0} is interested in the client {1}!\n" + "Cheers!"
  },
  candidateNotInterestedAgencyNotificationEmailTemplate: {
    subject: "Candidate {0} NOT Interested in {1}",
    message: "Hello," + "\n\n" + "The candidate {0} is NOT interested in the client {1}!\n"
  },
  feedbackCandidateNotInterestedAgencyNotificationEmailTemplate: {
    subject: "Candidate Feedback - {0} NOT Interested in {1}",
    message: "Hello," + "\n\n" + "The candidate {0} is NOT interested in the client {1}!\n" + 'Feedback:\n{2}'
  },
  reviewSubmittedAgencyNotificationEmailTemplate: {
    subject: "New Review from {0} for {1}",
    message: "New Review from {0} for {1}\n" + "Text: {2}\n" + "Rating: {3} \n"
  },
  shiftJobAcceptedCandidateNotificationEmailTemplate: {
    subject: "You have accepted a shift for the {0} {1} family",
    message: "Hi {2},\nYou have accepted a shift for the {0} {1} family on {3} from {4} to {5}. All of the details are in your dashboard under \"My Jobs\".\nPlease let us know ASAP if you have any questions or concerns!\nSincerely,\n{6}"
  },
  shiftJobAcceptedClientNotificationEmailTemplate: {
    subject: "Your request has been accepted",
    message: "Hi {0},\nYour request on {2} from {3} to {4} has been accepted by {1}! To view a bit for information, please click on the booking in the booking calendar in your family dashboard. Please don't forget to leave a review afterwards!\nPlease let us know if you have any questions or concerns.\nSincerely,\n{5}"
  },
  packageSelectedNotificationEmailTemplate: {
    subject: "Package Selected - {0} {1} | {2}",
    message: "Hello," + "\n\n" + "{0} {1} just selected the following package: {2}\n\n" + "Cheers!"
  },
  timeOffRequestNotificationEmailTemplate: {
    subject: "New time off request - {0} {1}",
    message: "New time off request from {0} {1}\n\n" + "Please log into the admin dashboard ({2}/login/{3}) to view it!"
  },
  paymentSubmittedEmailNotification: {
    subject: "Payment Submitted - [[fname]] [[lname]]",
    message: "Hello <br/><br/>\n    [[fname]] [[lname]] ([[email]]) has just submitted payment information.\n    "
  },
  creditCardInfoUpdatedEmailNotification: {
    subject: "Credit Card Info Updated - {0} {1}",
    message: "Hello \n\n" + "Client {0} {1} ({2}) updated credit card information."
  },
  referenceCheckFormSubmitedAdminNotification: {
    subject: "Reference Check Form Submitted for [[fname]] [[lname]] by [[ref_fname]] [[ref_lname]]",
    message: "Hello,<br/><br/>" + "Reference Check Form Submitted for [[fname]] [[lname]] ([[email]]) by [[ref_fname]] [[ref_lname]]<br/>" + "Application Details:<br/>" + "[[application_content]]"
  },
  bookingOnBlockedDateAdminNotification: {
    subject: "{0} {1} tried to book full date {2}",
    message: "{0} {1} ({3}) tried to book full date {2}<br/>" + "{4}"
  },
  assignedAsManagerAdminNotification: {
    subject: "[[agfname]] [[aglname]] assigned you to manage [[fname]] [[lname]]",
    message: "[[agfname]] [[aglname]] assigned you to manage [[fname]] [[lname]]\n[[userType]] Email: [[email]]"
  },
  adminNoteNotificationDefaultEmailTemplate: {
    subject: "{0} {1} tagged you in a note for {2}",
    message: "{5}{0} {1} tagged you in a note for {2} <br/><br/>{3}<br/><br/>" + "Please click at the link to view: <a href=\"{4}\">{4}</a>"
  },
  candidateDeclineJobAdminNotification: {
    subject: "Candidate {0} {1} declined the shift job on {6} {7}-{8}",
    message: "Candidate {0} {1} ({2}) declined the shift job on {6} {7}-{8} of the client {3} {4} ({5})"
  },
  candidateDeclineJobClientNotification: {
    subject: "Candidate {0} {1} declined your shift job",
    message: "Candidate {0} {1} declined your shift job on {2} {3}-{4}"
  },
  scheduleReleaseClientNotificationEmailTemplate: {
    subject: "Schedule For this Week",
    message: "Hi {0}<br/>" + "Here is your schedule for this week!<br/><br/>{1}<br/><br/>" + "Please log into your dashboard at {4}/login/{2} to view all of the details!<br/>" + "The {3} Team"
  },
  scheduleReleaseCandidateNotificationEmailTemplate: {
    subject: "Schedule For this Week",
    message: "Hi {0}<br/>" + "Here is your schedule for this week!<br/><br/>{1}<br/><br/>" + "Please log into your dashboard at {4}/login/{2} to view all of the details!<br/>" + "The {3} Team"
  },
  notifyClientOnAssigningCandidateToMultipleJobs: {
    subject: "Requests Filled",
    message: "Hi {0}\n\n{1} {2} has been assigned to your service request(s) on {3}\n" + "To view more details about them, please log into your dashboard at <a href=\"{4}/login/{5}\">{4}/login/{5}</a> and click on your service request. \n\n" + "Please don't hesitate to reach out if you have any questions or issues! \n\nThank you, \n{6} Team"
  },
  notifyCandidateOnAssigningToMultipleJobs: {
    subject: "Jobs Assigned",
    message: "Hi {0}\n\nYou have been assigned to jobs on {1}\n" + "To view more details about the job, please log into your dashboard at <a href=\"{2}/login/{3}\">{2}/login/{3}</a> and click on the \"My Jobs\" tab. \n\n" + "Please don't hesitate to reach out if you have any questions or issues! \n\nThank you, \n{4} Team"
  },
  applicationDeclinedCandidateNotificationEmailTemplate: {
    subject: "Shift Application Declined for [[date]], [[starttime]] - [[endtime]], [[clientfname]], [[jobtitle]]",
    message: "Hi [[candidatefname]], <br /><br/>" + "Your application for the following shift was declined: <br/>" + "Date: [[date]] <br/>" + "Start Time: [[starttime]] <br/>" + "End Time: [[endtime]] <br/>" + "Type: [[jobtitle]] <br/>" + "Client: [[clientfname]] <br/>" + "Please reach out to the scheduling dept if you have any questions! <br/>" + "Thanks! <br/><br/>" + "The [[agencyName]] Team"
  },
  addedNewAdminNotification: {
    subject: "New Administrator Added to {0}",
    message: "A new admin is added to {0}\nAgency ID: {1}\nAdmin Name: {2}\nAdmin Email: {3}"
  },
  resourceIsViewedNotificationEmailTemplate: {
    subject: "Resource {0} Viewed",
    message: "Resource {0} is viewed by user {1} (<a href=\"mailto:{2}\">{2}</a>)"
  },
  markedAsNotificationEmailTemplate: {
    subject: "Marked as {0}",
    message: "{1} marked {2} as {0}."
  },
  clientPostNewPlacementJobEmailTemplate: {
    subject: "A new job is posted.",
    message: "\n      Job Title: {0}\n      Job poster: {1} {2}\n      Status: {3}\n      Job Type: \"Long Term\"\n    "
  },
  topicDeletedEmailTemplate: {
    subject: "Topic Deleted",
    message: "A topic has been deleted"
  },
  commentAddedEmailTemplate: {
    subject: "New Comment Added",
    message: "\n    A new comment has been added:<br><br>\n    Click on the link below to view the comment <br> {0}"
  },
  commentUpdatedEmailTemplate: {
    subject: "Comment Updated",
    message: "\n    A comment has been updated:<br><br>\n    Click on the link below to view the updated comment <br> {0}"
  },
  commentDeletedEmailTemplate: {
    subject: "Comment Deleted",
    message: "A comment has been deleted"
  },
  timeOffRequestDeclinedEmailTemplate: {
    subject: "Time Off Request Has Been DECLINED",
    message: "Your time off request for {0} has been declined. \n\nNote: {1}"
  },
  timeOffRequestApprovedEmailTemplate: {
    subject: "Your Time Off Request Has Been Approved",
    message: "Your Time Off Request for {0} Has Been Approved!" + '\n\n'
  },
  notifyClientWhenAssignedCandidateEmailTemplate: {
    subject: "New candidate for you to consider - [[candidatefname]] [[candidatelname]]",
    message: "Hello [[fname]],<br/><br/>" + "We have found a great new candidate for you to consider: [[candidatefname]] [[candidatelname]]!<br/>" + "Please log into your dashboard ({0}/login/{1}) to view their profile and let us know what you think.<br/><br/>" + "Thanks!<br/>" + "{2}"
  },
  notifyClientOnBulkAssignEmailTemplate: {
    subject: "Requests Filled",
    message: "Hi [[clientfname]]<br/><br/>[[candidatefname]] [[candidatelname]] has been assigned to your service request(s) on [[jobdates]]<br/>" + "To view more details about them, please log into your dashboard at <a href=\"{0}/login/{1}\">{0}/login/{1}</a> and click on your service request. <br/><br/>" + "Please don't hesitate to reach out if you have any questions or issues! <br/><br/>Thank you, <br/>[[agencyName]] Team"
  },
  notifyCandidateOnBulkAssignEmailTemplate: {
    subject: "Jobs Assigned",
    message: "Hi [[candidatefname]]<br/><br/>You have been assigned to jobs on [[jobdates]]<br/>" + "To view more details about the job, please log into your dashboard at <a href=\"{0}/login/{1}\">{0}/login/{1}</a> and click on the \"My Jobs\" tab. <br/><br/>" + "Please don't hesitate to reach out if you have any questions or issues! <br/><br/>Thank you, <br/>[[agencyName]] Team"
  },
  reportProblemEmailTemplate: {
    subject: "{0} - {1}",
    message: "The candidate {1} (ID: {2}) clicked the {0} button of the shift job on {5} (ID: {6} - Poster {7})<br/>\n    <b>{3}:</b><br/> {4}"
  },
  clientReportProblemEmailTemplate: {
    subject: "{0} - {1}",
    message: "The client {1} (ID: {2}) clicked the {0} button of the shift job on {5} (ID: {6})<br/>\n    <b>{3}:</b><br/> {4}"
  },
  candidateChangeRecurringAvailabilityEmailTemplate: {
    subject: "Candidate Schedule Updated",
    message: "Candidate {0} {1} has {2} Recurring Availability"
  },
  defaultShiftJobReportClientNotificationEmailTemplate: {
    subject: "[[candidatefname]] [[candidatelname]] submitted a shift job report for your job on [[date]]",
    message: "\n            Dear [[clientfname]]<br/><br/>\n            [[candidatefname]] [[candidatelname]] submitted a shift job report for your job on [[date]]<br/>\n            Shift Job Report Details:\n            <br/>[[report_detail]]<br/>\n        "
  },
  clientAddedNoteAssignedCandidateEmailTemplate: {
    subject: "New Note added to an assigned candidate",
    message: "The client {0} (ID: {1}) has added a note for the candidate {2} (ID: {3})<br/>\n    Note: {4}"
  },
  userClickGuideNotificationEmailTemplate: {
    subject: "{2} {0} from {1} viewed today’s activity guide!",
    message: "Agency ID: {2}<br/>\n    Agency Name: {1}<br/>\n    User ID: {3}<br/>\n    Name: {4} {5}<br/>\n    Email: {0}\n    "
  },
  dailyGuideFeedbackEmailTemplate: {
    subject: "{2} Feedback for today’s activity guide! from {0} of {1}",
    message: "Agency ID: {2}<br/>\n    Agency Name: {1}<br/>\n    User ID: {3}<br/>\n    Name: {4} {5}<br/>\n    Email: {0}<br/>\n    Template: {6}<br/>\n    Feedback: {7}\n    "
  },
  userClickBenefitNotificationEmailTemplate: {
    subject: "Benefit: {0}, {1}: {2}",
    message: "Agency ID: {2}<br/>\n    Agency Name: {1}<br/>\n    User ID: {3}<br/>\n    Name: {4} {5}<br/>\n    Email: {0}<br/>\n    Benefit: {6} (ID: {7})\n    "
  },

  userClickNotInterestedBenefitNotificationEmailTemplate: {
    subject: "Not Interested in Benefit: {0}, {1}: {2}",
    message: "Agency ID: {2}<br/>\n    Agency Name: {1}<br/>\n    User ID: {3}<br/>\n    Name: {4} {5}<br/>\n    Email: {0}<br/>\n    Benefit: {6} (ID: {7})\n    "
  },
  hideBenefitNotificationEmailTemplate: {
    subject: "Hide Benefit from agency: {0}, {1}: {2}",
    message: "Agency ID: {2}<br/>\n    Agency Name: {1}<br/>\n    User ID: {3}<br/>\n    Name: {4} {5}<br/>\n    Email: {0}<br/>\n    Benefit: {6} (ID: {7})\n    "
  },
  benefitFeedbackNotificationEmailTemplate: {
    subject: "Benefits feedback {0} {1}",
    message: "\n    Feedback: {6}<br/>\n    Agency ID: {2}<br/>\n    Agency Name: {1}<br/>\n    User ID: {3}<br/>\n    Name: {4} {5}<br/>\n    Email: {0}<br/>\n    "
  },
  errorCalculatingPrice: {
    subject: "Error when calculating price {0}",
    message: "\n    Agency ID: {0}<br/>\n    User ID: {1}<br/>\n    Expression: {2}<br/>\n    Error: {3}\n    "
  }
};

var mutations = {
  SET_EMAIL_TEMPLATES: function SET_EMAIL_TEMPLATES(state, tempaltes) {
    state.emailTemplates = tempaltes;
  },
  SET_ERRORS: function SET_ERRORS(state, error) {
    state.errors.push(error);
  },
  RESET_ERRORS: function RESET_ERRORS(state) {
    state.errors = [];
  },
  setListEmailTemplates: function setListEmailTemplates(state, payload) {
    state.listEmailTemplates = payload;
  },
  setListIdNameEmailTemplates: function setListIdNameEmailTemplates(state, payload) {
    state.listIdNameEmailTemplates = payload;
  },
  setListSampleEmailTemplates: function setListSampleEmailTemplates(state, payload) {
    state.listSampleEmailTemplates = payload;
  }
};
var actions = {
  fetchEmailTemplates: function fetchEmailTemplates(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
    var type = _ref2.type,
        selector1 = _ref2.selector1;
    return regeneratorRuntime.async(function fetchEmailTemplates$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function _callee(resolve) {
              var agencyID, res;
              return regeneratorRuntime.async(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      agencyID = rootGetters["agencyID"];
                      _context.next = 3;
                      return regeneratorRuntime.awrap(_axios2.default.get("/api/emailtemplates/?agency=" + agencyID + "&type=" + type + "&selector1=" + selector1));

                    case 3:
                      res = _context.sent;

                      if (!(res && res.data)) {
                        _context.next = 7;
                        break;
                      }

                      resolve(res.data);
                      return _context.abrupt("return");

                    case 7:
                      resolve([]);

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, null, _this);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, null, this);
  },
  setListEmailTemplates: function setListEmailTemplates(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setListEmailTemplates", payload);
  },
  setListIdNameEmailTemplates: function setListIdNameEmailTemplates(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setListIdNameEmailTemplates", payload);
  },
  setListSampleEmailTemplates: function setListSampleEmailTemplates(_ref5, payload) {
    var commit = _ref5.commit;

    commit("setListSampleEmailTemplates", payload);
  },
  getListEmailTemplates: function getListEmailTemplates(_ref6) {
    var _this2 = this;

    var rootGetters = _ref6.rootGetters,
        state = _ref6.state,
        commit = _ref6.commit;

    return new Promise(function _callee2(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(state.listEmailTemplates && state.listEmailTemplates.length)) {
                _context3.next = 3;
                break;
              }

              resolve(state.listEmailTemplates);
              return _context3.abrupt("return");

            case 3:
              _context3.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/emailtemplates/?agency=" + rootGetters.agencyID));

            case 5:
              res = _context3.sent;

              if (!(res && res.data)) {
                _context3.next = 10;
                break;
              }

              commit('setListEmailTemplates', res.data);
              resolve(res.data);
              return _context3.abrupt("return");

            case 10:
              commit('setListEmailTemplates', []);
              resolve([]);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, null, _this2);
    });
  },
  getListSampleEmailTemplates: function getListSampleEmailTemplates(_ref7) {
    var _this3 = this;

    var rootGetters = _ref7.rootGetters,
        state = _ref7.state,
        commit = _ref7.commit;
    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return new Promise(function _callee3(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!reload && state.listSampleEmailTemplates && state.listSampleEmailTemplates.length)) {
                _context4.next = 3;
                break;
              }

              resolve(state.listSampleEmailTemplates);
              return _context4.abrupt("return");

            case 3:
              _context4.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/sampleemailtemplates/"));

            case 5:
              res = _context4.sent;

              if (!(res && res.data)) {
                _context4.next = 10;
                break;
              }

              commit('setListSampleEmailTemplates', res.data);
              resolve(res.data);
              return _context4.abrupt("return");

            case 10:
              commit('setListSampleEmailTemplates', []);
              resolve([]);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, null, _this3);
    });
  },
  getListIdNameEmailTemplates: function getListIdNameEmailTemplates(_ref8) {
    var _this4 = this;

    var rootGetters = _ref8.rootGetters,
        state = _ref8.state,
        getters = _ref8.getters,
        commit = _ref8.commit;

    return new Promise(function _callee4(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!state.listIdNameEmailTemplates) {
                _context5.next = 3;
                break;
              }

              resolve(state.listIdNameEmailTemplates);
              return _context5.abrupt("return");

            case 3:
              _context5.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/emailtemplates/?agency=" + rootGetters.agencyID + "&id_name=true"));

            case 5:
              res = _context5.sent;

              if (!(res && res.data)) {
                _context5.next = 10;
                break;
              }

              commit('setListIdNameEmailTemplates', res.data);
              resolve(res.data);
              return _context5.abrupt("return");

            case 10:
              commit('setListIdNameEmailTemplates', null);
              resolve(null);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, null, _this4);
    });
  }
};

var getters = {
  listEmailTemplates: function listEmailTemplates(state) {
    return state.listEmailTemplates;
  },
  listIdNameEmailTemplates: function listIdNameEmailTemplates(state) {
    if (state.listEmailTemplates && state.listEmailTemplates.length) {
      return state.listEmailTemplates;
    }
    return state.listIdNameEmailTemplates || [];
  },
  listSampleEmailTemplates: function listSampleEmailTemplates(state) {
    return state.listSampleEmailTemplates;
  },

  addedNewAdminNotification: function addedNewAdminNotification(state) {
    return state.addedNewAdminNotification;
  },
  topicDeletedEmailTemplate: function topicDeletedEmailTemplate(state) {
    return state.topicDeletedEmailTemplate;
  },
  commentAddedEmailTemplate: function commentAddedEmailTemplate(state) {
    return state.commentAddedEmailTemplate;
  },
  commentUpdatedEmailTemplate: function commentUpdatedEmailTemplate(state) {
    return state.commentUpdatedEmailTemplate;
  },
  commentDeletedEmailTemplate: function commentDeletedEmailTemplate(state) {
    return state.commentDeletedEmailTemplate;
  },
  clientNotInterestedFeedbackAgencyNotificationEmailTemplate: function clientNotInterestedFeedbackAgencyNotificationEmailTemplate(state) {
    return state.clientNotInterestedFeedbackAgencyNotificationEmailTemplate;
  },
  emailTemplates: function emailTemplates(state) {
    return state.emailTemplates;
  },
  notifyClientOnAssigningCandidateToMultipleJobs: function notifyClientOnAssigningCandidateToMultipleJobs(state) {
    return state.notifyClientOnAssigningCandidateToMultipleJobs;
  },
  notifyCandidateOnAssigningToMultipleJobs: function notifyCandidateOnAssigningToMultipleJobs(state) {
    return state.notifyCandidateOnAssigningToMultipleJobs;
  },
  resourceIsViewedNotificationEmailTemplate: function resourceIsViewedNotificationEmailTemplate(state) {
    return state.resourceIsViewedNotificationEmailTemplate;
  },
  markedAsNotificationEmailTemplate: function markedAsNotificationEmailTemplate(state) {
    return state.markedAsNotificationEmailTemplate;
  },
  shiftJobBulkBroadcastEmailTemplate: function shiftJobBulkBroadcastEmailTemplate(state) {
    return state.shiftJobBulkBroadcastEmailTemplate;
  },
  placementJobBulkBroadcastEmailTemplate: function placementJobBulkBroadcastEmailTemplate(state) {
    return state.placementJobBulkBroadcastEmailTemplate;
  },
  jobInterestedAdminNotificationEmailTemplate: function jobInterestedAdminNotificationEmailTemplate(state) {
    return state.jobInterestedAdminNotificationEmailTemplate;
  },
  jobCandidateReminderEmailTemplate: function jobCandidateReminderEmailTemplate(state) {
    return state.jobCandidateReminderEmailTemplate;
  },
  jobClockInReminderEmailTemplate: function jobClockInReminderEmailTemplate(state) {
    return state.jobClockInReminderEmailTemplate;
  },
  jobClockOutReminderEmailTemplate: function jobClockOutReminderEmailTemplate(state) {
    return state.jobClockOutReminderEmailTemplate;
  },
  jobClientReminderEmailTemplate: function jobClientReminderEmailTemplate(state) {
    return state.jobClientReminderEmailTemplate;
  },
  applicationSubmittedShiftJobAdminNotificationEmailTemplate: function applicationSubmittedShiftJobAdminNotificationEmailTemplate(state) {
    return state.applicationSubmittedShiftJobAdminNotificationEmailTemplate;
  },
  applicationSubmittedPlacementJobAdminNotificationEmailTemplate: function applicationSubmittedPlacementJobAdminNotificationEmailTemplate(state) {
    return state.applicationSubmittedPlacementJobAdminNotificationEmailTemplate;
  },
  applicationFormSubmissionAdminEmailTemplate: function applicationFormSubmissionAdminEmailTemplate(state) {
    return state.applicationFormSubmissionAdminEmailTemplate;
  },
  applicationFormSubmissionUserEmailTemplate: function applicationFormSubmissionUserEmailTemplate(state) {
    return state.applicationFormSubmissionUserEmailTemplate;
  },
  profileSectionFormSubmissionEmailTemplate: function profileSectionFormSubmissionEmailTemplate(state) {
    return state.profileSectionFormSubmissionEmailTemplate;
  },
  profileSectionWithDialogAddedEmailTemplate: function profileSectionWithDialogAddedEmailTemplate(state) {
    return state.profileSectionWithDialogAddedEmailTemplate;
  },
  profileSectionWithDialogUpdatedEmailTemplate: function profileSectionWithDialogUpdatedEmailTemplate(state) {
    return state.profileSectionWithDialogUpdatedEmailTemplate;
  },
  jobAssignedEmployerNotificationEmailTemplate: function jobAssignedEmployerNotificationEmailTemplate(state) {
    return state.jobAssignedEmployerNotificationEmailTemplate;
  },
  jobAssignedAdminNotificationEmailTemplate: function jobAssignedAdminNotificationEmailTemplate(state) {
    return state.jobAssignedAdminNotificationEmailTemplate;
  },
  jobAcceptedAdminNotificationEmailTemplate: function jobAcceptedAdminNotificationEmailTemplate(state) {
    return state.jobAcceptedAdminNotificationEmailTemplate;
  },
  nannyAssignedEmployerNotificationEmailTemplate: function nannyAssignedEmployerNotificationEmailTemplate(state) {
    return state.nannyAssignedEmployerNotificationEmailTemplate;
  },
  nannyAssignedCandidateNotificationEmailTemplate: function nannyAssignedCandidateNotificationEmailTemplate(state) {
    return state.nannyAssignedCandidateNotificationEmailTemplate;
  },
  jobBookingAddedAgencyNotificationEmailTemplate: function jobBookingAddedAgencyNotificationEmailTemplate(state) {
    return state.jobBookingAddedAgencyNotificationEmailTemplate;
  },
  jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate: function jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate(state) {
    return state.jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate;
  },
  bookingGroupCreatedAgencyNotificationEmailTemplate: function bookingGroupCreatedAgencyNotificationEmailTemplate(state) {
    return state.bookingGroupCreatedAgencyNotificationEmailTemplate;
  },
  jobBookingUpdatedAgencyNotificationEmailTemplate: function jobBookingUpdatedAgencyNotificationEmailTemplate(state) {
    return state.jobBookingUpdatedAgencyNotificationEmailTemplate;
  },
  jobBookingUpdatedFillerNotificationEmailTemplate: function jobBookingUpdatedFillerNotificationEmailTemplate(state) {
    return state.jobBookingUpdatedFillerNotificationEmailTemplate;
  },
  jobBookingCancelledAgencyNotificationEmailTemplate: function jobBookingCancelledAgencyNotificationEmailTemplate(state) {
    return state.jobBookingCancelledAgencyNotificationEmailTemplate;
  },
  jobBookingCancelledFillerNotificationEmailTemplate: function jobBookingCancelledFillerNotificationEmailTemplate(state) {
    return state.jobBookingCancelledFillerNotificationEmailTemplate;
  },
  createdRelationshipNotificationEmailTemplate: function createdRelationshipNotificationEmailTemplate(state) {
    return state.createdRelationshipNotificationEmailTemplate;
  },
  bulkCreatedRelationshipsNotificationEmailTemplate: function bulkCreatedRelationshipsNotificationEmailTemplate(state) {
    return state.bulkCreatedRelationshipsNotificationEmailTemplate;
  },
  updatedRelationshipNotificationEmailTemplate: function updatedRelationshipNotificationEmailTemplate(state) {
    return state.updatedRelationshipNotificationEmailTemplate;
  },
  scheduleEventNotificationEmailTemplate: function scheduleEventNotificationEmailTemplate(state) {
    return state.scheduleEventNotificationEmailTemplate;
  },
  referenceCheckFormEmailTemplate: function referenceCheckFormEmailTemplate(state) {
    return state.referenceCheckFormEmailTemplate;
  },
  shiftJobBroadcastEmailTemplate: function shiftJobBroadcastEmailTemplate(state) {
    return state.shiftJobBroadcastEmailTemplate;
  },
  placementJobBroadcastEmailTemplate: function placementJobBroadcastEmailTemplate(state) {
    return state.placementJobBroadcastEmailTemplate;
  },
  shareClientProfileNotificationEmailTemplate: function shareClientProfileNotificationEmailTemplate(state) {
    return state.shareClientProfileNotificationEmailTemplate;
  },
  clientInterestedAgencyNotificationEmailTemplate: function clientInterestedAgencyNotificationEmailTemplate(state) {
    return state.clientInterestedAgencyNotificationEmailTemplate;
  },
  clientInterestedPreliminaryAgencyNotificationEmailTemplate: function clientInterestedPreliminaryAgencyNotificationEmailTemplate(state) {
    return state.clientInterestedPreliminaryAgencyNotificationEmailTemplate;
  },
  clientNotInterestedAgencyNotificationEmailTemplate: function clientNotInterestedAgencyNotificationEmailTemplate(state) {
    return state.clientNotInterestedAgencyNotificationEmailTemplate;
  },
  candidateInterestedAgencyNotificationEmailTemplate: function candidateInterestedAgencyNotificationEmailTemplate(state) {
    return state.candidateInterestedAgencyNotificationEmailTemplate;
  },
  candidateNotInterestedAgencyNotificationEmailTemplate: function candidateNotInterestedAgencyNotificationEmailTemplate(state) {
    return state.candidateNotInterestedAgencyNotificationEmailTemplate;
  },
  feedbackCandidateNotInterestedAgencyNotificationEmailTemplate: function feedbackCandidateNotInterestedAgencyNotificationEmailTemplate(state) {
    return state.feedbackCandidateNotInterestedAgencyNotificationEmailTemplate;
  },
  clientExtendedOfferAgencyNotificationEmailTemplate: function clientExtendedOfferAgencyNotificationEmailTemplate(state) {
    return state.clientExtendedOfferAgencyNotificationEmailTemplate;
  },
  reviewSubmittedAgencyNotificationEmailTemplate: function reviewSubmittedAgencyNotificationEmailTemplate(state) {
    return state.reviewSubmittedAgencyNotificationEmailTemplate;
  },
  shiftJobAcceptedCandidateNotificationEmailTemplate: function shiftJobAcceptedCandidateNotificationEmailTemplate(state) {
    return state.shiftJobAcceptedCandidateNotificationEmailTemplate;
  },
  shiftJobAcceptedClientNotificationEmailTemplate: function shiftJobAcceptedClientNotificationEmailTemplate(state) {
    return state.shiftJobAcceptedClientNotificationEmailTemplate;
  },
  packageSelectedNotificationEmailTemplate: function packageSelectedNotificationEmailTemplate(state) {
    return state.packageSelectedNotificationEmailTemplate;
  },
  timeOffRequestNotificationEmailTemplate: function timeOffRequestNotificationEmailTemplate(state) {
    return state.timeOffRequestNotificationEmailTemplate;
  },
  paymentSubmittedEmailNotification: function paymentSubmittedEmailNotification(state) {
    return state.paymentSubmittedEmailNotification;
  },
  creditCardInfoUpdatedEmailNotification: function creditCardInfoUpdatedEmailNotification(state) {
    return state.creditCardInfoUpdatedEmailNotification;
  },
  referenceCheckFormSubmitedAdminNotification: function referenceCheckFormSubmitedAdminNotification(state) {
    return state.referenceCheckFormSubmitedAdminNotification;
  },
  bookingOnBlockedDateAdminNotification: function bookingOnBlockedDateAdminNotification(state) {
    return state.bookingOnBlockedDateAdminNotification;
  },
  assignedAsManagerAdminNotification: function assignedAsManagerAdminNotification(state) {
    return state.assignedAsManagerAdminNotification;
  },
  adminNoteNotificationDefaultEmailTemplate: function adminNoteNotificationDefaultEmailTemplate(state) {
    return state.adminNoteNotificationDefaultEmailTemplate;
  },
  candidateDeclineJobAdminNotification: function candidateDeclineJobAdminNotification(state) {
    return state.candidateDeclineJobAdminNotification;
  },
  candidateDeclineJobClientNotification: function candidateDeclineJobClientNotification(state) {
    return state.candidateDeclineJobClientNotification;
  },
  scheduleReleaseClientNotificationEmailTemplate: function scheduleReleaseClientNotificationEmailTemplate(state) {
    return state.scheduleReleaseClientNotificationEmailTemplate;
  },
  scheduleReleaseCandidateNotificationEmailTemplate: function scheduleReleaseCandidateNotificationEmailTemplate(state) {
    return state.scheduleReleaseCandidateNotificationEmailTemplate;
  },
  applicationDeclinedCandidateNotificationEmailTemplate: function applicationDeclinedCandidateNotificationEmailTemplate(state) {
    return state.applicationDeclinedCandidateNotificationEmailTemplate;
  },
  clientPostNewPlacementJobEmailTemplate: function clientPostNewPlacementJobEmailTemplate(state) {
    return state.clientPostNewPlacementJobEmailTemplate;
  },
  timeOffRequestDeclinedEmailTemplate: function timeOffRequestDeclinedEmailTemplate(state) {
    return state.timeOffRequestDeclinedEmailTemplate;
  },
  timeOffRequestApprovedEmailTemplate: function timeOffRequestApprovedEmailTemplate(state) {
    return state.timeOffRequestApprovedEmailTemplate;
  },
  notifyClientWhenAssignedCandidateEmailTemplate: function notifyClientWhenAssignedCandidateEmailTemplate(state) {
    return state.notifyClientWhenAssignedCandidateEmailTemplate;
  },
  notifyCandidateOnBulkAssignEmailTemplate: function notifyCandidateOnBulkAssignEmailTemplate(state) {
    return state.notifyCandidateOnBulkAssignEmailTemplate;
  },
  notifyClientOnBulkAssignEmailTemplate: function notifyClientOnBulkAssignEmailTemplate(state) {
    return state.notifyClientOnBulkAssignEmailTemplate;
  },
  reportProblemEmailTemplate: function reportProblemEmailTemplate(state) {
    return state.reportProblemEmailTemplate;
  },
  candidateChangeRecurringAvailabilityEmailTemplate: function candidateChangeRecurringAvailabilityEmailTemplate(state) {
    return state.candidateChangeRecurringAvailabilityEmailTemplate;
  },
  defaultShiftJobReportClientNotificationEmailTemplate: function defaultShiftJobReportClientNotificationEmailTemplate(state) {
    return state.defaultShiftJobReportClientNotificationEmailTemplate;
  },
  clientAddedNoteAssignedCandidateEmailTemplate: function clientAddedNoteAssignedCandidateEmailTemplate(state) {
    return state.clientAddedNoteAssignedCandidateEmailTemplate;
  },
  userClickGuideNotificationEmailTemplate: function userClickGuideNotificationEmailTemplate(state) {
    return state.userClickGuideNotificationEmailTemplate;
  },
  dailyGuideFeedbackEmailTemplate: function dailyGuideFeedbackEmailTemplate(state) {
    return state.dailyGuideFeedbackEmailTemplate;
  },
  userClickBenefitNotificationEmailTemplate: function userClickBenefitNotificationEmailTemplate(state) {
    return state.userClickBenefitNotificationEmailTemplate;
  },
  userClickNotInterestedBenefitNotificationEmailTemplate: function userClickNotInterestedBenefitNotificationEmailTemplate(state) {
    return state.userClickNotInterestedBenefitNotificationEmailTemplate;
  },
  hideBenefitNotificationEmailTemplate: function hideBenefitNotificationEmailTemplate(state) {
    return state.hideBenefitNotificationEmailTemplate;
  },
  benefitFeedbackNotificationEmailTemplate: function benefitFeedbackNotificationEmailTemplate(state) {
    return state.benefitFeedbackNotificationEmailTemplate;
  },
  errorCalculatingPrice: function errorCalculatingPrice(state) {
    return state.errorCalculatingPrice;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  shiftJobBroadcastSMSTemplate: {
    message: "New shift available: [[date]], [[starttime]] - [[endtime]], learn more [[joblink]]"
  },
  placementJobBroadcastSMSTemplate: {
    message: "Hi [[fname]].\n" + 'There is a new opportunity available that may be of interest to you, to see all of the details please visit: {3}/job/{2}/{1}'
  },
  jobBookingCancelledFillerSMSTemplate: {
    message: "The client {1} {2} ({3}) has just cancelled the booking request for {0} {4} - {5}.\n{6}\n"
  },
  referenceCheckFormSMSTemplate: {
    message: 'Hi {2} {3}\n' + 'Please fill the form {4} to give us the reference check information about {0} {1}\n' + 'Sincerely,\n{5}'
  },
  notifyClientOnBulkAssignSmsTemplate: {
    message: "Hi [[clientfname]]\n[[candidatefname]] [[candidatelname]] has been assigned to your service request(s) on [[jobdates]]"
  },
  notifyCandidateOnBulkAssignSmsTemplate: {
    message: "Hi [[candidatefname]]\nYou have been assigned to jobs on [[jobdates]]"
  },
  nannyAssignedEmployerNotificationSMSTemplate: {
    message: 'Hello {1},\n' + '{2} {3} has been assigned to your service request on {0}.'
  },
  nannyAssignedCandidateNotificationSMSTemplate: {
    message: 'Hello {1},\n' + 'You have been assigned to a job on {0}.'
  },
  SMSTemplates: [],
  SMSTemplateErrors: [],
  statusChangeSMSTemplates: [],
  statusChangeSMSTemplatesErrors: [],
  listSmsTemplates: [],
  listIdNameSmsTemplates: []
};

var mutations = {
  setSMSTemplates: function setSMSTemplates(state, templates) {
    state.SMSTemplates = templates;
  },
  resetSMSTemplateErrors: function resetSMSTemplateErrors(state) {
    state.SMSTemplateErrors = [];
  },
  loadStatusChangeSMSTemplate: function loadStatusChangeSMSTemplate(state, templates) {
    state.statusChangeSMSTemplates = templates;
  },
  resetStatusChangeSMSTemplatesErrors: function resetStatusChangeSMSTemplatesErrors(state) {
    state.statusChangeSMSTemplatesErrors = [];
  },
  setListSmsTemplates: function setListSmsTemplates(state, payload) {
    state.listSmsTemplates = payload;
  },
  setListIdNameSmsTemplates: function setListIdNameSmsTemplates(state, payload) {
    state.listIdNameSmsTemplates = payload;
  }
};
var actions = {
  getStatusChangeSMSTemplate: function getStatusChangeSMSTemplate(_ref, SMSInfo) {
    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;
    return regeneratorRuntime.async(function getStatusChangeSMSTemplate$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return regeneratorRuntime.awrap(_axios2.default.get('/api/smstemplates/?agency=' + rootState.authentication.agencyID + '&status=' + encodeURIComponent(SMSInfo.status) + '&type=' + SMSInfo.type + '&selector1=' + SMSInfo.user + '&deactivated=false').then(function (res) {
              commit("resetStatusChangeSMSTemplatesErrors");
              commit("loadStatusChangeSMSTemplate", res.data);
            }).catch(function (error) {
              state.statusChangeSMSTemplatesErrors.push(error);
            }));

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, null, this);
  },
  getSMSTemplates: function getSMSTemplates(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;
    return regeneratorRuntime.async(function getSMSTemplates$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return regeneratorRuntime.awrap(_axios2.default.get('/api/smstemplates/?agency=' + rootState.authentication.agencyID).then(function (res) {
              commit("resetSMSTemplateErrors");
              commit("setSMSTemplates", res.data);
            }).catch(function (error) {
              state.SMSTemplateErrors.push(error);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, null, this);
  },
  setListSmsTemplates: function setListSmsTemplates(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setListSmsTemplates", payload);
  },
  setListIdNameSmsTemplates: function setListIdNameSmsTemplates(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setListIdNameSmsTemplates", payload);
  },
  getListSmsTemplates: function getListSmsTemplates(_ref5) {
    var _this = this;

    var rootGetters = _ref5.rootGetters,
        state = _ref5.state,
        commit = _ref5.commit;

    return new Promise(function _callee(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(state.listSmsTemplates && state.listSmsTemplates.length)) {
                _context3.next = 3;
                break;
              }

              resolve(state.listSmsTemplates);
              return _context3.abrupt('return');

            case 3:
              _context3.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get('/api/smstemplates/?agency=' + rootGetters.agencyID));

            case 5:
              res = _context3.sent;

              if (!(res && res.data)) {
                _context3.next = 10;
                break;
              }

              commit('setListSmsTemplates', res.data);
              resolve(res.data);
              return _context3.abrupt('return');

            case 10:
              commit('setListSmsTemplates', []);
              resolve([]);

            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, null, _this);
    });
  },
  getListIdNameSmsTemplates: function getListIdNameSmsTemplates(_ref6) {
    var _this2 = this;

    var rootGetters = _ref6.rootGetters,
        getters = _ref6.getters,
        commit = _ref6.commit;

    return new Promise(function _callee2(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee2$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(getters.listIdNameSmsTemplates && getters.listIdNameSmsTemplates.length)) {
                _context4.next = 3;
                break;
              }

              resolve(getters.listIdNameSmsTemplates);
              return _context4.abrupt('return');

            case 3:
              _context4.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get('/api/smstemplates/?agency=' + rootGetters.agencyID + '&id_name=true'));

            case 5:
              res = _context4.sent;

              if (!(res && res.data)) {
                _context4.next = 10;
                break;
              }

              commit('setListIdNameSmsTemplates', res.data);
              resolve(res.data);
              return _context4.abrupt('return');

            case 10:
              commit('setListIdNameSmsTemplates', []);
              resolve([]);

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, null, _this2);
    });
  }
};

var getters = {
  shiftJobBroadcastSMSTemplate: function shiftJobBroadcastSMSTemplate(state) {
    return state.shiftJobBroadcastSMSTemplate;
  },
  placementJobBroadcastSMSTemplate: function placementJobBroadcastSMSTemplate(state) {
    return state.placementJobBroadcastSMSTemplate;
  },
  jobBookingCancelledFillerSMSTemplate: function jobBookingCancelledFillerSMSTemplate(state) {
    return state.jobBookingCancelledFillerSMSTemplate;
  },
  referenceCheckFormSMSTemplate: function referenceCheckFormSMSTemplate(state) {
    return state.referenceCheckFormSMSTemplate;
  },
  notifyClientOnBulkAssignSmsTemplate: function notifyClientOnBulkAssignSmsTemplate(state) {
    return state.notifyClientOnBulkAssignSmsTemplate;
  },
  notifyCandidateOnBulkAssignSmsTemplate: function notifyCandidateOnBulkAssignSmsTemplate(state) {
    return state.notifyCandidateOnBulkAssignSmsTemplate;
  },
  nannyAssignedEmployerNotificationSMSTemplate: function nannyAssignedEmployerNotificationSMSTemplate(state) {
    return state.nannyAssignedEmployerNotificationSMSTemplate;
  },
  nannyAssignedCandidateNotificationSMSTemplate: function nannyAssignedCandidateNotificationSMSTemplate(state) {
    return state.nannyAssignedCandidateNotificationSMSTemplate;
  },

  SMSTemplates: function SMSTemplates(state) {
    return (0, _tryGet2.default)(function () {
      return state.SMSTemplates;
    }) || [];
  },
  SMSTemplateErrors: function SMSTemplateErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.SMSTemplateErrors;
    }) || [];
  },
  statusChangeSMSTemplates: function statusChangeSMSTemplates(state) {
    return (0, _tryGet2.default)(function () {
      return state.statusChangeSMSTemplates;
    }) || [];
  },
  statusChangeSMSTemplatesErrors: function statusChangeSMSTemplatesErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.statusChangeSMSTemplatesErrors;
    }) || [];
  },
  listSmsTemplates: function listSmsTemplates(state) {
    return state.listSmsTemplates;
  },
  listIdNameSmsTemplates: function listIdNameSmsTemplates(state) {
    if (state.listSmsTemplates && state.listSmsTemplates.length) {
      return state.listSmsTemplates;
    }
    return state.listIdNameSmsTemplates;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    listDocumentTemplates: [],
    listIdNameDocumentTemplates: null
};

var mutations = {
    setListDocumentTemplates: function setListDocumentTemplates(state, payload) {
        state.listDocumentTemplates = payload;
    },
    setListIdNameDocumentTemplates: function setListIdNameDocumentTemplates(state, payload) {
        state.listIdNameDocumentTemplates = payload;
    }
};

var actions = {
    setListDocumentTemplates: function setListDocumentTemplates(_ref, payload) {
        var commit = _ref.commit;

        commit("setListDocumentTemplates", payload);
    },
    setListIdNameDocumentTemplates: function setListIdNameDocumentTemplates(_ref2, payload) {
        var commit = _ref2.commit;

        commit("setListIdNameDocumentTemplates", payload);
    },
    getListDocumentTemplates: function getListDocumentTemplates(_ref3) {
        var _this = this;

        var rootGetters = _ref3.rootGetters,
            state = _ref3.state,
            commit = _ref3.commit;

        return new Promise(function _callee(resolve) {
            var res;
            return regeneratorRuntime.async(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(state.listDocumentTemplates && state.listDocumentTemplates.length)) {
                                _context.next = 3;
                                break;
                            }

                            resolve(state.listDocumentTemplates);
                            return _context.abrupt("return");

                        case 3:
                            _context.next = 5;
                            return regeneratorRuntime.awrap(_axios2.default.get("/api/documenttemplates/?agency=" + rootGetters.agencyID));

                        case 5:
                            res = _context.sent;

                            if (!(res && res.data)) {
                                _context.next = 10;
                                break;
                            }

                            commit('setListDocumentTemplates', res.data);
                            resolve(res.data);
                            return _context.abrupt("return");

                        case 10:
                            commit('setListDocumentTemplates', []);
                            resolve([]);

                        case 12:
                        case "end":
                            return _context.stop();
                    }
                }
            }, null, _this);
        });
    },
    getListIdNameDocumentTemplates: function getListIdNameDocumentTemplates(_ref4) {
        var _this2 = this;

        var rootGetters = _ref4.rootGetters,
            getters = _ref4.getters,
            commit = _ref4.commit,
            state = _ref4.state;
        var isReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return new Promise(function _callee2(resolve) {
            var res;
            return regeneratorRuntime.async(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (isReload) {
                                _context2.next = 4;
                                break;
                            }

                            if (!state.listIdNameDocumentTemplates) {
                                _context2.next = 4;
                                break;
                            }

                            resolve(getters.listIdNameDocumentTemplates);
                            return _context2.abrupt("return");

                        case 4:
                            _context2.next = 6;
                            return regeneratorRuntime.awrap(_axios2.default.get("/api/documenttemplates/?agency=" + rootGetters.agencyID + "&id_name=true"));

                        case 6:
                            res = _context2.sent;

                            if (!(res && res.data)) {
                                _context2.next = 11;
                                break;
                            }

                            commit('setListIdNameDocumentTemplates', res.data);
                            resolve(res.data);
                            return _context2.abrupt("return");

                        case 11:
                            commit('setListIdNameDocumentTemplates', []);
                            resolve([]);

                        case 13:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, null, _this2);
        });
    },
    getDocumentTemplateById: function getDocumentTemplateById(_, templateId) {
        var res;
        return regeneratorRuntime.async(function getDocumentTemplateById$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/documenttemplates/" + templateId));

                    case 2:
                        res = _context3.sent;

                        if (!(res && res.data)) {
                            _context3.next = 5;
                            break;
                        }

                        return _context3.abrupt("return", res.data);

                    case 5:
                    case "end":
                        return _context3.stop();
                }
            }
        }, null, this);
    }
};

var getters = {
    listDocumentTemplates: function listDocumentTemplates(state) {
        return state.listDocumentTemplates;
    },
    listIdNameDocumentTemplates: function listIdNameDocumentTemplates(state) {
        if (state.listDocumentTemplates && state.listDocumentTemplates.length) {
            return state.listDocumentTemplates;
        }
        return state.listIdNameDocumentTemplates || [];
    }
};

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  primaryColor: "",
  secondaryColor: "",
  primaryDarkerColor: "",
  secondaryDarkerColor: "",
  profileTextColor: "",
  cancelButtonColor: "",
  cancelButtonHoverColor: "",
  labelColor: null
};

var mutations = {
  setPrimaryColor: function setPrimaryColor(state, payload) {
    state.primaryColor = payload;
  },
  setSecondaryColor: function setSecondaryColor(state, payload) {
    state.secondaryColor = payload;
  },
  setPrimaryDarkerColor: function setPrimaryDarkerColor(state, payload) {
    state.primaryDarkerColor = payload;
  },
  setSecondaryDarkerColor: function setSecondaryDarkerColor(state, payload) {
    state.secondaryDarkerColor = payload;
  },
  setProfileTextColor: function setProfileTextColor(state, payload) {
    state.profileTextColor = payload;
  },
  setCancelButtonColor: function setCancelButtonColor(state, payload) {
    state.cancelButtonColor = payload;
  },
  setCancelButtonHoverColor: function setCancelButtonHoverColor(state, payload) {
    state.cancelButtonHoverColor = payload;
  },
  setLabelColor: function setLabelColor(state, payload) {
    state.labelColor = payload;
  }
};

var actions = {
  setPrimaryColor: function setPrimaryColor(_ref, payload) {
    var commit = _ref.commit;

    commit("setPrimaryColor", payload);
  },
  setSecondaryColor: function setSecondaryColor(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setSecondaryColor", payload);
  },
  setPrimaryDarkerColor: function setPrimaryDarkerColor(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setPrimaryDarkerColor", payload);
  },
  setSecondaryDarkerColor: function setSecondaryDarkerColor(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setSecondaryDarkerColor", payload);
  },
  setProfileTextColor: function setProfileTextColor(_ref5, payload) {
    var commit = _ref5.commit;

    commit("setProfileTextColor", payload);
  },
  setLabelColor: function setLabelColor(_ref6, payload) {
    var commit = _ref6.commit;

    commit("setLabelColor", payload);
  },
  setColor: function setColor(_ref7, payload) {
    var commit = _ref7.commit;

    commit("setPrimaryColor", payload.primaryColor);
    commit("setSecondaryColor", payload.secondaryColor);
    commit("setPrimaryDarkerColor", payload.primaryDarkerColor);
    commit("setSecondaryDarkerColor", payload.secondaryDarkerColor);
    commit("setProfileTextColor", payload.profileTextColor);
    commit("setCancelButtonColor", payload.cancelButtonColor);
    commit("setCancelButtonHoverColor", payload.cancelButtonHoverColor);
    commit("setLabelColor", payload.labelColor);
  }
};

var getters = {
  primaryColor: function primaryColor(state) {
    return state.primaryColor;
  },
  secondaryColor: function secondaryColor(state) {
    return state.secondaryColor;
  },
  primaryDarkerColor: function primaryDarkerColor(state) {
    return state.primaryDarkerColor;
  },
  secondaryDarkerColor: function secondaryDarkerColor(state) {
    return state.secondaryDarkerColor;
  },
  profileTextColor: function profileTextColor(state) {
    return state.profileTextColor;
  },
  cancelButtonColor: function cancelButtonColor(state) {
    return state.cancelButtonColor;
  },
  cancelButtonHoverColor: function cancelButtonHoverColor(state) {
    return state.cancelButtonHoverColor;
  },
  labelColor: function labelColor(state) {
    return state.labelColor;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  rootFont: "",
  headingsFont: "",
  headingOneCase: "",
  headingTwoCase: "",
  headingThreeCase: ""
};

var mutations = {
  setRootFont: function setRootFont(state, payload) {
    state.rootFont = payload;
  },
  setHeadingsFont: function setHeadingsFont(state, payload) {
    state.headingsFont = payload;
  },
  setHeadingOneCase: function setHeadingOneCase(state, payload) {
    if (payload || typeof payload === "undefined") {
      state.headingOneCase = "uppercase";
    } else {
      state.headingOneCase = "lowercase";
    }
  },
  setHeadingTwoCase: function setHeadingTwoCase(state, payload) {
    if (payload || typeof payload === "undefined") {
      state.headingTwoCase = "uppercase";
    } else {
      state.headingTwoCase = "lowercase";
    }
  },
  setHeadingThreeCase: function setHeadingThreeCase(state, payload) {
    if (payload || typeof payload === "undefined") {
      state.headingThreeCase = "uppercase";
    } else {
      state.headingThreeCase = "lowercase";
    }
  },
  capitalizeHeadingOne: function capitalizeHeadingOne(state, payload) {
    if (payload) {
      state.headingOneCase = "capitalize";
    }
  },
  capitalizeHeadingTwo: function capitalizeHeadingTwo(state, payload) {
    if (payload) {
      state.headingTwoCase = "capitalize";
    }
  },
  capitalizeHeadingThree: function capitalizeHeadingThree(state, payload) {
    if (payload) {
      state.headingThreeCase = "capitalize";
    }
  }
};

var actions = {
  setRootFont: function setRootFont(_ref, payload) {
    var commit = _ref.commit;

    commit("setRootFont", payload);
  },
  setHeadingsFont: function setHeadingsFont(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setHeadingsFont", payload);
  },
  headingOneCase: function headingOneCase(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setHeadingOneCase", payload);
  },
  headingTwoCase: function headingTwoCase(_ref4, payload) {
    var commit = _ref4.commit;

    commit("setHeadingTwoCase", payload);
  },
  headingThreeCase: function headingThreeCase(_ref5, payload) {
    var commit = _ref5.commit;

    commit("setHeadingThreeCase", payload);
  },
  headingOneCapitalize: function headingOneCapitalize(_ref6, payload) {
    var commit = _ref6.commit;

    commit("capitalizeHeadingOne", payload);
  },
  headingTwoCapitalize: function headingTwoCapitalize(_ref7, payload) {
    var commit = _ref7.commit;

    commit("capitalizeHeadingTwo", payload);
  },
  headingThreeCapitalize: function headingThreeCapitalize(_ref8, payload) {
    var commit = _ref8.commit;

    commit("capitalizeHeadingThree", payload);
  }
};

var getters = {
  rootFont: function rootFont(state) {
    return state.rootFont;
  },
  headingsFont: function headingsFont(state) {
    return state.headingsFont;
  },
  headingOneCase: function headingOneCase(state) {
    return state.headingOneCase;
  },
  headingTwoCase: function headingTwoCase(state) {
    return state.headingTwoCase;
  },
  headingThreeCase: function headingThreeCase(state) {
    return state.headingThreeCase;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultValues = __webpack_require__(17);

var _customDefineType = __webpack_require__(6);

var _listFields = __webpack_require__(670);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _arrayHandling = __webpack_require__(74);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

var _dataHandling = __webpack_require__(73);

var _queryHandling = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var state = {
  shiftJobStatuses: _defaultValues.DEFAULT_SHIFT_JOB_STATUSES,
  placementJobStatuses: _defaultValues.DEFAULT_PLACEMENT_JOB_STATUSES,
  jobApplications: [], // All job applications of an agency
  defaultJobBoardFields: [],
  jobBoardFieldErrors: [],
  defaultJobBoardFieldsOptions: [],
  defaultJobBoardFieldsOptionsErrors: [],
  jobPoster: {},
  jobPosterErrors: [],
  jobFiller: {},
  jobFillerErrors: [],
  mapJobNumberOfMonth: {},
  jobsNotes: [],
  jobsNotesErrors: [],
  jobId: undefined
};

var mutations = {
  setShiftJobStatuses: function setShiftJobStatuses(state, payload) {
    state.shiftJobStatuses = payload;
  },
  setPlacementJobStatuses: function setPlacementJobStatuses(state, payload) {
    state.placementJobStatuses = payload;
  },
  setJobApplications: function setJobApplications(state, payload) {
    state.jobApplications = payload;
  },
  setDefaultJobBoardFields: function setDefaultJobBoardFields(state, jobData) {
    state.defaultJobBoardFields = jobData;
  },
  setJobBoardFieldErrors: function setJobBoardFieldErrors(state, error) {
    state.jobBoardFieldErrors.push(error);
  },
  resetJobBoardFieldErrors: function resetJobBoardFieldErrors(state) {
    state.jobBoardFieldErrors = [];
  },
  setDefaultJobBoardFieldsOptions: function setDefaultJobBoardFieldsOptions(state, jobFieldsData) {
    state.defaultJobBoardFieldsOptions = jobFieldsData.map(function (field) {
      var text = field.replaceAll("_", " ");
      var words = text.split(" ");
      var capitalizedText = words.map(function (word) {
        return word[0].toUpperCase() + word.substring(1);
      }).join(" ");
      return {
        label: capitalizedText,
        model: field,
        displayLabel: capitalizedText,
        itemPerRow: 2
      };
    }).filter(function (option) {
      return option.model !== "title";
    });;
  },
  setJobBoardFieldsOptionsErrors: function setJobBoardFieldsOptionsErrors(state, error) {
    state.defaultJobBoardFieldsOptionsErrors.push(error);
  },
  resetJobBoardFieldsOptionsErrors: function resetJobBoardFieldsOptionsErrors(state) {
    state.defaultJobBoardFieldsOptionsErrors = [];
  },
  setJobPoster: function setJobPoster(state, jobPosterInfo) {
    state.jobPoster = jobPosterInfo;
  },
  resetJobPosterErrors: function resetJobPosterErrors(state) {
    state.jobPosterErrors = [];
  },
  setJobFiller: function setJobFiller(state, jobFillerInfo) {
    state.jobFiller = jobFillerInfo;
  },
  resetJobFillerErrors: function resetJobFillerErrors(state) {
    state.jobFillerErrors = [];
  },
  setMapJobNumberOfMonth: function setMapJobNumberOfMonth(state, payload) {
    state.mapJobNumberOfMonth = payload;
  },
  resetJobsNotesErrors: function resetJobsNotesErrors(state) {
    state.jobsNotesErrors = [];
  },
  setJobsNotes: function setJobsNotes(state, notes) {
    state.jobsNotes = notes;
  },
  setJobsNotesErrors: function setJobsNotesErrors(state, error) {
    state.jobsNotesErrors.push(error);
  },
  setJobIdForChat: function setJobIdForChat(state, jobId) {
    state.jobId = jobId;
  }
};

var actions = {
  setShiftJobStatuses: function setShiftJobStatuses(_ref, payload) {
    var commit = _ref.commit;

    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setShiftJobStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default job statuses are used
      commit("setShiftJobStatuses", _defaultValues.DEFAULT_SHIFT_JOB_STATUSES);
    }
  },
  setJobPoster: function setJobPoster(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setJobPoster", payload);
  },
  setPlacementJobStatuses: function setPlacementJobStatuses(_ref3, payload) {
    var commit = _ref3.commit;

    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setPlacementJobStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default job statuses are used
      commit("setPlacementJobStatuses", _defaultValues.DEFAULT_PLACEMENT_JOB_STATUSES);
    }
  },
  getDefaultJobBoardFieldsOptions: function getDefaultJobBoardFieldsOptions(_ref4) {
    var commit = _ref4.commit;
    return regeneratorRuntime.async(function getDefaultJobBoardFieldsOptions$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit("resetJobBoardFieldsOptionsErrors");
            _context.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.get('/get-job-fields').then(function (res) {
              commit("setDefaultJobBoardFieldsOptions", res.data);
            }).catch(function (error) {
              commit("setJobBoardFieldsOptionsErrors", error);
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, null, this);
  },
  createShiftJob: function createShiftJob(_ref5, jobInfo) {
    var _this = this;

    var commit = _ref5.commit,
        getters = _ref5.getters;

    return new Promise(function _callee(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (getters.multipleFillersShiftJob) {
                if (jobInfo.filler) {
                  jobInfo.fillers = [jobInfo.filler];
                }
                jobInfo.filler = null;
                jobInfo.filler_name = "";
              }
              _context2.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.post("/api/jobs/", jobInfo));

            case 3:
              res = _context2.sent;

              resolve(res.data);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, null, _this);
    });
  },
  updateShiftJob: function updateShiftJob(_ref6, _ref7) {
    var _this2 = this;

    var commit = _ref6.commit,
        getters = _ref6.getters;
    var id = _ref7.id,
        jobInfo = _ref7.jobInfo;

    return new Promise(function _callee2(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (getters.multipleFillersShiftJob) {
                if (jobInfo.filler) {
                  jobInfo.fillers = [jobInfo.filler];
                }
              }
              _context3.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + id + "/", jobInfo));

            case 3:
              res = _context3.sent;

              resolve(res.data);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, null, _this2);
    });
  },
  addABreak: function addABreak(_ref8, _ref9) {
    var _this3 = this;

    var commit = _ref8.commit,
        getters = _ref8.getters;
    var job = _ref9.job,
        breakInfo = _ref9.breakInfo;

    return new Promise(function _callee3(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!job.breaks) {
                job.breaks = [];
              }
              job.breaks.push(breakInfo);
              _context4.next = 4;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + job.id + "/", { breaks: job.breaks }));

            case 4:
              res = _context4.sent;

              resolve(res.data);

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, null, _this3);
    });
  },
  removeABreak: function removeABreak(_ref10, _ref11) {
    var _this4 = this;

    var commit = _ref10.commit,
        getters = _ref10.getters;
    var job = _ref11.job,
        index = _ref11.index;

    return new Promise(function _callee4(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!job.breaks) {
                resolve();
              }
              job.breaks.splice(index, 1);
              _context5.next = 4;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + job.id + "/", { breaks: job.breaks }));

            case 4:
              res = _context5.sent;

              resolve();

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, null, _this4);
    });
  },
  updateFillersOfJob: function updateFillersOfJob(_ref12, _ref13) {
    var _this5 = this;

    var commit = _ref12.commit,
        getters = _ref12.getters;
    var job = _ref13.job,
        filled = _ref13.filled,
        filler = _ref13.filler,
        fillers = _ref13.fillers,
        status = _ref13.status,
        notAllowStatus = _ref13.notAllowStatus;

    return new Promise(function _callee5(resolve) {
      return regeneratorRuntime.async(function _callee5$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.patch("/job-fillers/" + job.id + "/", {
                job_id: job.id,
                filler_id: filler ? filler.id : null,
                filled: filled,
                filler_ids: fillers ? fillers.map(function (filler) {
                  return filler.id;
                }) : null,
                info: { status: status },
                not_allowed_status: notAllowStatus
              }));

            case 2:
              resolve();

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, null, _this5);
    });
  },
  assignShiftJob: function assignShiftJob(_ref14, _ref15) {
    var _this6 = this;

    var commit = _ref14.commit,
        getters = _ref14.getters;
    var job = _ref15.job,
        filler = _ref15.filler,
        checkJobStatus = _ref15.checkJobStatus,
        additionalInfo = _ref15.additionalInfo;

    return new Promise(function _callee6(resolve) {
      var res, requestBody, _res;

      return regeneratorRuntime.async(function _callee6$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!getters.multipleFillersShiftJob) {
                _context7.next = 7;
                break;
              }

              _context7.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.post('/job-fillers/', {
                job_id: job.id,
                filler_id: filler.id,
                check_job_status: true, // Check if job was accepted by other user
                additional_info: additionalInfo
              }));

            case 3:
              res = _context7.sent;

              if (!res) {
                resolve(false);
              }
              _context7.next = 13;
              break;

            case 7:
              requestBody = {
                status: "Assigned",
                filled: true,
                filler: filler.id,
                filler_name: filler.first_name + " " + filler.last_name,
                filled_date: new Date(),
                action_type: 'Assign Job',
                check_job_status: checkJobStatus // Check if job was accepted by other user
              };

              if (additionalInfo) {
                requestBody = _extends({}, requestBody, additionalInfo);
              }
              _context7.next = 11;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + job.id + "/", requestBody));

            case 11:
              _res = _context7.sent;

              if (!_res) {
                resolve(false);
              }

            case 13:
              resolve(true);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, null, _this6);
    });
  },
  unassignShiftJob: function unassignShiftJob(_ref16, _ref17) {
    var _this7 = this;

    var commit = _ref16.commit,
        getters = _ref16.getters;
    var job = _ref17.job,
        fillerId = _ref17.fillerId;

    return new Promise(function _callee7(resolve) {
      var unassignStatus;
      return regeneratorRuntime.async(function _callee7$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!getters.multipleFillersShiftJob) {
                _context8.next = 10;
                break;
              }

              if (!fillerId) {
                _context8.next = 6;
                break;
              }

              _context8.next = 4;
              return regeneratorRuntime.awrap(_axios2.default.delete("/job-fillers/" + job.id + "/" + fillerId + "/"));

            case 4:
              _context8.next = 8;
              break;

            case 6:
              _context8.next = 8;
              return regeneratorRuntime.awrap(_axios2.default.delete("/job-fillers/" + job.id + "/"));

            case 8:
              _context8.next = 13;
              break;

            case 10:
              unassignStatus = getters.shiftJobCandidateUnassignStatus ? getters.shiftJobCandidateUnassignStatus : 'Requested';
              _context8.next = 13;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + job.id + "/", {
                status: unassignStatus,
                filled: false,
                filler: null,
                filler_name: "",
                filled_date: null,
                action_type: 'Unassign Job'
              }));

            case 13:
              resolve();

            case 14:
            case "end":
              return _context8.stop();
          }
        }
      }, null, _this7);
    });
  },
  getShiftJobsMainInfo: function getShiftJobsMainInfo(_ref18, _ref19) {
    var _this8 = this;

    var commit = _ref18.commit,
        getters = _ref18.getters;
    var startDate = _ref19.startDate,
        endDate = _ref19.endDate,
        includeDateRange = _ref19.includeDateRange,
        isBackground = _ref19.isBackground;

    return new Promise(function _callee8(resolve) {
      var additionalUrlParam, jobFillers, jobFillerRes, res, listJobs;
      return regeneratorRuntime.async(function _callee8$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              additionalUrlParam = includeDateRange ? '&include_date_range=true' : '';

              if (isBackground) {
                additionalUrlParam = additionalUrlParam + "&in_background=true";
              }
              // Get job fillers
              jobFillers = [];

              if (!getters.multipleFillersShiftJob) {
                _context9.next = 8;
                break;
              }

              _context9.next = 6;
              return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/?start_date=" + startDate + "&end_date=" + endDate + additionalUrlParam));

            case 6:
              jobFillerRes = _context9.sent;

              jobFillers = jobFillerRes.data.job_fillers;

            case 8:
              _context9.next = 10;
              return regeneratorRuntime.awrap(_axios2.default.get("/get-jobs/?job_type=" + getters.jobTypeShortTermQuery + "&start_date=" + startDate + "&end_date=" + endDate + "&main_info_only=true" + additionalUrlParam));

            case 10:
              res = _context9.sent;
              listJobs = Array.isArray(res.data) ? res.data : res.data.jobs;

              if (getters.multipleFillersShiftJob) {
                listJobs.forEach(function (job) {
                  // Get fillers and fillers name for each job
                  var listFillers = jobFillers.filter(function (jobFiller) {
                    return jobFiller.job === job.id;
                  });
                  job.fillers = listFillers.map(function (filler) {
                    return filler.filler;
                  });
                  job.filler_name = listFillers.map(function (filler) {
                    return filler.filler_name;
                  }).join(', ');
                  job.filler = null;
                  job.fillers_info = listFillers.map(function (filler) {
                    return _extends({}, filler, filler.info);
                  });
                });
              }
              resolve(listJobs);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, null, _this8);
    });
  },
  getJobFullInfo: function getJobFullInfo(_ref20, inputJob) {
    var _this9 = this;

    var commit = _ref20.commit,
        getters = _ref20.getters;

    return new Promise(function _callee9(resolve) {
      var job, res;
      return regeneratorRuntime.async(function _callee9$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              job = inputJob;
              _context10.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/jobs/" + inputJob.id + "/"));

            case 3:
              res = _context10.sent;

              if (res && res.data) {
                job = res.data;
              }
              resolve(job);

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, null, _this9);
    });
  },
  getFillersOfJob: function getFillersOfJob(_ref21, job) {
    var _this10 = this;

    var commit = _ref21.commit,
        getters = _ref21.getters;

    return new Promise(function _callee10(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee10$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (job.id) {
                _context11.next = 3;
                break;
              }

              resolve([]);
              return _context11.abrupt("return");

            case 3:
              _context11.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/" + job.id + "/?filler_detail=true"));

            case 5:
              res = _context11.sent;

              resolve(res.data.job_fillers);

            case 7:
            case "end":
              return _context11.stop();
          }
        }
      }, null, _this10);
    });
  },
  getJobFiller: function getJobFiller(_ref22, job) {
    var _this11 = this;

    var commit = _ref22.commit,
        getters = _ref22.getters;

    return new Promise(function _callee11(resolve) {
      var res, listJobFillers;
      return regeneratorRuntime.async(function _callee11$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/" + job.id + "/"));

            case 2:
              res = _context12.sent;
              listJobFillers = res.data.job_fillers;

              listJobFillers.forEach(function (jobFiller) {
                return jobFiller.id = jobFiller.filler_id;
              });
              listJobFillers = listJobFillers.sort(function (filler1, filler2) {
                return filler1.id < filler2.id ? 1 : -1;
              });
              resolve(listJobFillers);

            case 7:
            case "end":
              return _context12.stop();
          }
        }
      }, null, _this11);
    });
  },
  updateJobFiller: function updateJobFiller(_ref23, _ref24) {
    var _this12 = this;

    var commit = _ref23.commit,
        getters = _ref23.getters;
    var jobId = _ref24.jobId,
        fillerId = _ref24.fillerId,
        info = _ref24.info;

    return new Promise(function _callee12(resolve) {
      var requestBody;
      return regeneratorRuntime.async(function _callee12$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!getters.multipleFillersShiftJob) {
                _context13.next = 7;
                break;
              }

              requestBody = { info: info };

              if (info.status) {
                requestBody.status = info.status;
              }
              _context13.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.patch("/job-fillers/" + jobId + "/" + fillerId + "/", requestBody));

            case 5:
              _context13.next = 9;
              break;

            case 7:
              _context13.next = 9;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + jobId + "/", info));

            case 9:
              resolve();

            case 10:
            case "end":
              return _context13.stop();
          }
        }
      }, null, _this12);
    });
  },
  updateJob: function updateJob(_ref25, _ref26) {
    var _this13 = this;

    var commit = _ref25.commit,
        getters = _ref25.getters;
    var jobId = _ref26.jobId,
        info = _ref26.info;

    return new Promise(function _callee13(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee13$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + jobId + "/", info));

            case 2:
              res = _context14.sent;

              if (res && res.data) {
                resolve(res.data);
              } else {
                resolve();
              }

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, null, _this13);
    });
  },
  getJobById: function getJobById(_ref27, jobId) {
    var _this14 = this;

    var commit = _ref27.commit,
        getters = _ref27.getters;

    return new Promise(function _callee14(resolve) {
      var res, job;
      return regeneratorRuntime.async(function _callee14$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/jobs/" + jobId + "/"));

            case 2:
              res = _context15.sent;
              job = res.data;

              if (getters.multipleFillersShiftJob) {
                if (job.fillers) {
                  job.filler_name = job.fillers.map(function (filler) {
                    return filler.first_name + " " + filler.last_name;
                  }).join(', ');
                } else {
                  job.filler_name = null;
                }
                if (!job.filled) {
                  job.filler = null;
                }
              }
              resolve(job);

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, null, _this14);
    });
  },
  getJobsByFiller: function getJobsByFiller(_ref28, fillerId) {
    var _this15 = this;

    var commit = _ref28.commit,
        getters = _ref28.getters;

    return new Promise(function _callee15(resolve) {
      var jobFillerRes, jobFillers, res, listJobs, _jobFillerRes, _jobFillers;

      return regeneratorRuntime.async(function _callee15$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!getters.multipleFillersShiftJob) {
                _context16.next = 10;
                break;
              }

              _context16.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/?filler=" + fillerId + "&job_detail=true"));

            case 3:
              jobFillerRes = _context16.sent;
              jobFillers = jobFillerRes.data.job_fillers;

              jobFillers.forEach(function (job) {
                if (!job.fillers) {
                  job.fillers = [{
                    id: fillerId
                  }];
                }
              });
              resolve(jobFillers);
              return _context16.abrupt("return");

            case 10:
              _context16.next = 12;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/jobs/?filler=" + fillerId));

            case 12:
              res = _context16.sent;
              listJobs = res.data;

              if (!getters.clientCanSelectMultipleCandidates) {
                _context16.next = 22;
                break;
              }

              _context16.next = 17;
              return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/?filler=" + fillerId + "&job_detail=true"));

            case 17:
              _jobFillerRes = _context16.sent;
              _jobFillers = _jobFillerRes.data.job_fillers;

              resolve((0, _arrayHandling.deduplicateArrayOfObject)([].concat(_toConsumableArray(listJobs), _toConsumableArray(_jobFillers)), 'id'));
              _context16.next = 23;
              break;

            case 22:
              resolve(listJobs);

            case 23:
            case "end":
              return _context16.stop();
          }
        }
      }, null, _this15);
    });
  },
  getJobsByFillerWithFilter: function getJobsByFillerWithFilter(_ref29, payload) {
    var _this16 = this;

    var commit = _ref29.commit,
        getters = _ref29.getters;
    var queryParams;
    return regeneratorRuntime.async(function getJobsByFillerWithFilter$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            queryParams = "filler=" + payload.fillerId;

            if (payload.startDate) {
              queryParams += "&start_date=" + payload.startDate;
            }
            if (payload.endDate) {
              queryParams += "&end_date=" + payload.endDate;
            }
            if (payload.reports) {
              queryParams += "&reports=true";
            }
            if (payload.additionalFields) {
              queryParams += "&additional_fields=" + payload.additionalFields.join(',');
            }
            return _context18.abrupt("return", new Promise(function _callee16(resolve) {
              var jobFillerRes, jobFillers, res, listJobs, _jobFillerRes2, _jobFillers2;

              return regeneratorRuntime.async(function _callee16$(_context17) {
                while (1) {
                  switch (_context17.prev = _context17.next) {
                    case 0:
                      if (!getters.multipleFillersShiftJob) {
                        _context17.next = 13;
                        break;
                      }

                      _context17.next = 3;
                      return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/?job_detail=true&" + queryParams));

                    case 3:
                      jobFillerRes = _context17.sent;

                      if (!(!jobFillerRes || !jobFillerRes.data)) {
                        _context17.next = 7;
                        break;
                      }

                      resolve([]);
                      return _context17.abrupt("return");

                    case 7:
                      jobFillers = jobFillerRes.data.job_fillers;

                      if (payload.fillerId) {
                        jobFillers.forEach(function (job) {
                          job.fillers = [{ id: payload.fillerId }];
                        });
                      }
                      resolve(jobFillers);
                      return _context17.abrupt("return");

                    case 13:
                      _context17.next = 15;
                      return regeneratorRuntime.awrap(_axios2.default.get("/get-jobs/?" + queryParams));

                    case 15:
                      res = _context17.sent;

                      if (!(!res || !res.data)) {
                        _context17.next = 19;
                        break;
                      }

                      resolve([]);
                      return _context17.abrupt("return");

                    case 19:
                      listJobs = res.data.jobs;

                      if (!getters.clientCanSelectMultipleCandidates) {
                        _context17.next = 28;
                        break;
                      }

                      _context17.next = 23;
                      return regeneratorRuntime.awrap(_axios2.default.get("/job-fillers/?job_detail=true&" + queryParams));

                    case 23:
                      _jobFillerRes2 = _context17.sent;
                      _jobFillers2 = _jobFillerRes2.data.job_fillers;

                      resolve((0, _arrayHandling.deduplicateArrayOfObject)([].concat(_toConsumableArray(listJobs), _toConsumableArray(_jobFillers2)), 'id'));
                      _context17.next = 29;
                      break;

                    case 28:
                      resolve(listJobs);

                    case 29:
                    case "end":
                      return _context17.stop();
                  }
                }
              }, null, _this16);
            }));

          case 6:
          case "end":
            return _context18.stop();
        }
      }
    }, null, this);
  },
  getJobsByGroup: function getJobsByGroup(_ref30, groupId) {
    var _this17 = this;

    var commit = _ref30.commit,
        getters = _ref30.getters;

    return new Promise(function _callee17(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee17$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/jobs/?job_group=" + groupId));

            case 2:
              res = _context19.sent;

              resolve(res.data);

            case 4:
            case "end":
              return _context19.stop();
          }
        }
      }, null, _this17);
    });
  },
  getJobApplications: function getJobApplications(_ref31, additionalInfo) {
    var _this18 = this;

    var commit = _ref31.commit,
        getters = _ref31.getters;

    return new Promise(function _callee18(resolve) {
      var jobApplications, url, res;
      return regeneratorRuntime.async(function _callee18$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              jobApplications = [];
              url = '/get-job-applications/';

              if (additionalInfo) {
                if (additionalInfo.clientId && additionalInfo.candidateId) {
                  url = url + "?client=" + additionalInfo.clientId + "&candidate=" + additionalInfo.candidateId;
                }
              }
              _context20.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get(url));

            case 5:
              res = _context20.sent;

              if (res && res.data && res.data.jobapplications) {
                jobApplications = res.data.jobapplications;
                jobApplications = jobApplications.filter(function (application) {
                  return application.status !== "Declined";
                });
              }
              commit('setJobApplications', jobApplications);
              resolve(jobApplications);

            case 9:
            case "end":
              return _context20.stop();
          }
        }
      }, null, _this18);
    });
  },
  getJobPosterById: function getJobPosterById(_ref32, posterId) {
    var commit = _ref32.commit;
    return regeneratorRuntime.async(function getJobPosterById$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            commit('resetJobPosterErrors');

            if (posterId) {
              _context21.next = 3;
              break;
            }

            return _context21.abrupt("return");

          case 3:
            _context21.next = 5;
            return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + posterId + "/").then(function (res) {
              commit('setJobPoster', res.data);
            }).catch(function (error) {
              state.jobPosterErrors.push(error);
            }));

          case 5:
          case "end":
            return _context21.stop();
        }
      }
    }, null, this);
  },
  getJobFillerById: function getJobFillerById(_ref33, fillerId) {
    var commit = _ref33.commit;
    return regeneratorRuntime.async(function getJobFillerById$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            commit('resetJobFillerErrors');

            if (fillerId) {
              _context22.next = 3;
              break;
            }

            return _context22.abrupt("return");

          case 3:
            _context22.next = 5;
            return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + fillerId + "/").then(function (res) {
              console.log('res filler ===>', res, res.data);
              commit('setJobFiller', res.data);
            }).catch(function (error) {
              state.jobPosterErrors.push(error);
            }));

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, null, this);
  },
  setMapJobNumberOfMonth: function setMapJobNumberOfMonth(_ref34, payload) {
    var commit = _ref34.commit;

    commit('setMapJobNumberOfMonth', payload);
  },
  getUserDeviceId: function getUserDeviceId(_ref35, userId) {
    var _this19 = this;

    var commit = _ref35.commit;

    return new Promise(function _callee19(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee19$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + userId + "/"));

            case 2:
              res = _context23.sent;

              resolve(res.data.device_id);

            case 4:
            case "end":
              return _context23.stop();
          }
        }
      }, null, _this19);
    });
  },
  addAdditionalDates: function addAdditionalDates(_ref36, payload) {
    var _this20 = this;

    var commit = _ref36.commit;
    return regeneratorRuntime.async(function addAdditionalDates$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            return _context25.abrupt("return", new Promise(function _callee20(resolve) {
              var res;
              return regeneratorRuntime.async(function _callee20$(_context24) {
                while (1) {
                  switch (_context24.prev = _context24.next) {
                    case 0:
                      _context24.next = 2;
                      return regeneratorRuntime.awrap(_axios2.default.post("/api/jobs/" + payload.jobId + "/add_additional_dates/", payload));

                    case 2:
                      res = _context24.sent;

                      resolve(res.data);

                    case 4:
                    case "end":
                      return _context24.stop();
                  }
                }
              }, null, _this20);
            }));

          case 1:
          case "end":
            return _context25.stop();
        }
      }
    }, null, this);
  },
  getJobsNotes: function getJobsNotes(_ref37) {
    var commit = _ref37.commit,
        rootGetters = _ref37.rootGetters;
    return regeneratorRuntime.async(function getJobsNotes$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            commit("resetJobsNotesErrors");
            _context26.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.get("get-notes?agency=" + rootGetters.agencyID + "&type=job").then(function (res) {
              commit("setJobsNotes", res.data.notes);
            }).catch(function (error) {
              commit("setJobsNotesErrors", error.message);
            }));

          case 3:
          case "end":
            return _context26.stop();
        }
      }
    }, null, this);
  },
  sendNotificationEnginehireApp: function sendNotificationEnginehireApp(_ref38, payload) {
    var _this21 = this;

    var commit = _ref38.commit;
    return regeneratorRuntime.async(function sendNotificationEnginehireApp$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            return _context28.abrupt("return", new Promise(function _callee21(resolve) {
              var res;
              return regeneratorRuntime.async(function _callee21$(_context27) {
                while (1) {
                  switch (_context27.prev = _context27.next) {
                    case 0:
                      _context27.next = 2;
                      return regeneratorRuntime.awrap(_axios2.default.post((0, _queryHandling.appendBackgroundParam)('/optimum/send_notification_app/'), payload));

                    case 2:
                      res = _context27.sent;

                      resolve(res.data);

                    case 4:
                    case "end":
                      return _context27.stop();
                  }
                }
              }, null, _this21);
            }));

          case 1:
          case "end":
            return _context28.stop();
        }
      }
    }, null, this);
  },
  getActionList: function getActionList(_, payload) {
    return regeneratorRuntime.async(function getActionList$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
              var url = "optimum/optimize/actions/?";
              if (payload) {
                url = url + "&" + (0, _dataHandling.getRequestUrlParams)(payload);
              }
              _axios2.default.get(url).then(function (response) {
                if (response.status === 200) {
                  resolve(response);
                }
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 2:
            return _context29.abrupt("return", _context29.sent);

          case 3:
          case "end":
            return _context29.stop();
        }
      }
    }, null, this);
  },
  getJobList: function getJobList(_, payload) {
    return regeneratorRuntime.async(function getJobList$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
              var url = "optimize/get-all-jobs/?";
              if (payload) {
                url = url + "&" + (0, _dataHandling.getRequestUrlParams)(payload);
              }
              _axios2.default.get(url).then(function (response) {
                if (response.status === 200) {
                  resolve(response);
                }
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 2:
            return _context30.abrupt("return", _context30.sent);

          case 3:
          case "end":
            return _context30.stop();
        }
      }
    }, null, this);
  },
  getJobApplicationList: function getJobApplicationList(_, payload) {
    return regeneratorRuntime.async(function getJobApplicationList$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
              var url = "optimize/get-jobapplication/?";
              if (payload) {
                url = url + "&" + (0, _dataHandling.getRequestUrlParams)(payload);
              }
              _axios2.default.get(url).then(function (response) {
                if (response.status === 200) {
                  resolve(response);
                }
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 2:
            return _context31.abrupt("return", _context31.sent);

          case 3:
          case "end":
            return _context31.stop();
        }
      }
    }, null, this);
  },
  updateBroadcastedCandidateId: function updateBroadcastedCandidateId(_ref39, broadcastpayload) {
    var commit = _ref39.commit;
    var payload;
    return regeneratorRuntime.async(function updateBroadcastedCandidateId$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            payload = {
              "broadcasted_candidates_ids": [].concat(_toConsumableArray(broadcastpayload.broadcastIds)),
              "broadcasted": true
            };
            _context32.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.patch("/api/jobs/" + broadcastpayload.jobId + "/", payload));

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, null, this);
  },
  setJobIdForChat: function setJobIdForChat(_ref40, jobId) {
    var commit = _ref40.commit;

    commit('setJobIdForChat', jobId);
  }
};

var getters = {
  mapJobNumberOfMonth: function mapJobNumberOfMonth(state) {
    return state.mapJobNumberOfMonth || {};
  },
  jobPoster: function jobPoster(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobPoster;
    }) || {};
  },
  jobFiller: function jobFiller(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobFiller;
    }) || {};
  },
  jobPosterErrors: function jobPosterErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobPosterErrors;
    }) || [];
  },
  jobFillerErrors: function jobFillerErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobFillerErrors;
    }) || [];
  },
  jobTypeShortTermQuery: function jobTypeShortTermQuery(state, getters) {
    // For agency 16 (thenannycompany), job_type is not Short Term and Long Term
    if (Number(getters.agencyID) === 16) {
      return '';
    }
    return 'Short Term';
  },
  shiftJobStatuses: function shiftJobStatuses(state) {
    var result = state.shiftJobStatuses;
    if (!result.some(function (item) {
      return item.status === 'Charged';
    })) {
      result.push({ status: "Charged", color: _defaultValues.DEFAULT_LIST_COLORS[7] });
    }
    return result;
  },

  defaultJobBoardFields: function defaultJobBoardFields(state) {
    return (0, _tryGet2.default)(function () {
      return state.defaultJobBoardFields;
    }) || [];
  },
  jobBoardFieldErrors: function jobBoardFieldErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobBoardFieldErrors;
    }) || [];
  },
  defaultJobBoardFieldsOptions: function defaultJobBoardFieldsOptions(state) {
    return (0, _tryGet2.default)(function () {
      return state.defaultJobBoardFieldsOptions;
    }) || [];
  },
  defaultJobBoardFieldsOptionsErrors: function defaultJobBoardFieldsOptionsErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.defaultJobBoardFieldsOptionsErrors;
    }) || [];
  },
  jobApplications: function jobApplications(state) {
    return state.jobApplications;
  },
  placementJobStatuses: function placementJobStatuses(state) {
    return state.placementJobStatuses;
  },
  jobTypes: function jobTypes(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.job_types && agency.job_types.length) {
      return agency.job_types;
    }
    return Object.values(_customDefineType.JOB_TYPES);
  },
  listPlacementJobTypes: function listPlacementJobTypes(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency) {
      if (agency.public_advance_setting) {
        var listTypes = agency.public_advance_setting.placement_job_types;
        if (listTypes) {
          return listTypes;
        }
      }
    }
    return [];
  },
  clientCanAssignShiftJob: function clientCanAssignShiftJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_can_assign_shift_job) {
      return agency.advance_setting.client_can_assign_shift_job;
    }
    return false;
  },
  clientCanExpressInterestShiftJob: function clientCanExpressInterestShiftJob(state, getters, rootState) {
    if (getters.clientCanAssignShiftJob) {
      return false;
    }
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_can_express_interest_shift_job) {
      return agency.advance_setting.client_can_express_interest_shift_job;
    }
    return false;
  },
  clientCanAcceptCandidateShiftJob: function clientCanAcceptCandidateShiftJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_can_accept_candidate_shift_job) {
      return agency.advance_setting.client_can_accept_candidate_shift_job;
    }
    return false;
  },
  clientCanAssignShiftJobApplicationForm: function clientCanAssignShiftJobApplicationForm(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.client_can_assign_shift_job_application_form;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  multipleFillersShiftJob: function multipleFillersShiftJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.multiple_fillers_shift_job) {
      return agency.advance_setting.multiple_fillers_shift_job;
    }
    return false;
  },
  sendNotificationToFillerOnChange: function sendNotificationToFillerOnChange(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.send_notification_to_filler_on_change != null) {
      return agency.advance_setting.send_notification_to_filler_on_change;
    }
    return true;
  },
  canSeeShiftJobOutsideLocation: function canSeeShiftJobOutsideLocation(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.can_see_shift_job_outside_location;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  canSeePlacementJobOutsideLocation: function canSeePlacementJobOutsideLocation(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.can_see_placement_job_outside_location;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  isManualClocking: function isManualClocking(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.manual_clocking) {
      return agency.manual_clocking;
    }
    return false;
  },
  minuteIntervalClockInOut: function minuteIntervalClockInOut(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.minute_interval_clock_in_out) {
      return agency.advance_setting.minute_interval_clock_in_out;
    }
    return 15; // Default is 15 minutes
  },
  listShiftJobStatuses: function listShiftJobStatuses(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    var listItems = _defaultValues.DEFAULT_SHIFT_JOB_STATUSES;
    if (agency && agency.shift_job_statuses && agency.shift_job_statuses.length) {
      listItems = agency.shift_job_statuses;
    }
    return listItems.map(function (item) {
      return item.status;
    });
  },
  startDayOfWeekCalendar: function startDayOfWeekCalendar(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.start_day_of_week;
      if (result != null) {
        return result;
      }
    }
    return 0; // Default is 0
  },
  shiftJobCalendarClientNameModel: function shiftJobCalendarClientNameModel(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.shift_job_calendar_client_name_model) {
      return agency.advance_setting.shift_job_calendar_client_name_model;
    }
    return 'name'; // Default is name (first_name + last_name)
  },
  canOnlySeeShiftJobMatchedTags: function canOnlySeeShiftJobMatchedTags(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.can_only_see_shift_job_matched_tags;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  canOnlySeeShiftJobMatchedTypesCategory: function canOnlySeeShiftJobMatchedTypesCategory(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.can_only_see_shift_job_matched_types_category;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  showChildrenShiftJob: function showChildrenShiftJob(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.show_children_shift_job;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  showPetsShiftJob: function showPetsShiftJob(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.show_pets_shift_job;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  showPosterTagShiftJobBoard: function showPosterTagShiftJobBoard(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.show_poster_tag_shift_job_board;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  customTextCancelingShiftJob: function customTextCancelingShiftJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.custom_text_canceling_shift_job) {
      return agency.advance_setting.custom_text_canceling_shift_job;
    }
  },
  candidateCanDeclinedShiftJobs: function candidateCanDeclinedShiftJobs(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.candidate_can_declined_shift_jobs) {
      return agency.advance_setting.candidate_can_declined_shift_jobs;
    }
    return false;
  },
  clientCanReceiveEmailDeclinedJobs: function clientCanReceiveEmailDeclinedJobs(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.client_can_recieve_email_declined_jobs;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  jobStatusesCandidateCanDecline: function jobStatusesCandidateCanDecline(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.job_statuses_candidate_can_decline) {
      return agency.advance_setting.job_statuses_candidate_can_decline;
    }
    return ['Assigned'];
  },
  numberOfHoursCanDeclineShiftJobs: function numberOfHoursCanDeclineShiftJobs(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.number_hours_can_decline_jobs) {
      return agency.advance_setting.number_hours_can_decline_jobs;
    }
    return 24;
  },
  onlyShowMatchedTags: function onlyShowMatchedTags(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.only_show_matched_tags) {
      return agency.advance_setting.only_show_matched_tags;
    }
    return false;
  },
  onlyShowMatchedLocations: function onlyShowMatchedLocations(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.only_show_matched_locations;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  clientSelectionCandidateTypes: function clientSelectionCandidateTypes(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.client_selection_candidate_types;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  clientSelectionCandidateStatuses: function clientSelectionCandidateStatuses(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.client_selection_candidate_statuses;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  hideUnavailableCandidatesDefaultForAdmin: function hideUnavailableCandidatesDefaultForAdmin(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.admin_default_hide_unavailable_candidates;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  hideUnavailableCandidatesDefaultSchedulerView: function hideUnavailableCandidatesDefaultSchedulerView(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.scheduler_view_default_hide_unavailable_candidates;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  hasShiftJobApproveButton: function hasShiftJobApproveButton(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.has_shift_job_approve_button;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  showIdShiftJobCalendar: function showIdShiftJobCalendar(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.show_id_shift_job_calendar;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  statusOnApproving: function statusOnApproving(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.status_on_approving;
      if (result) {
        return result;
      }
    }
    return "Approved";
  },
  shiftJobActiveTypes: function shiftJobActiveTypes(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.shift_job_active_types;
      if (result != null) {
        return result;
      }
    }
    if (agency && agency.candidate_types) {
      return agency.candidate_types;
    }
    return [];
  },
  initFilterStatusCandidateListAdmin: function initFilterStatusCandidateListAdmin(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.init_filter_status_candidate_list_admin;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  showWeeklyScheduleReleaseButton: function showWeeklyScheduleReleaseButton(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.show_weekly_schedule_release_button;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  clientCanSelectMultipleCandidates: function clientCanSelectMultipleCandidates(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.client_can_select_multiple_candidates;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  jobStatusesRefund: function jobStatusesRefund(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.job_statuses_refund;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  onlyRefundForNonFilledJob: function onlyRefundForNonFilledJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.only_refund_non_filled_job;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  onlyRefundForFilledJob: function onlyRefundForFilledJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.only_refund_filled_job;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  jobStatusAfterClientSelectCandidate: function jobStatusAfterClientSelectCandidate(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.job_status_after_client_select_candidate;
      if (result != null) {
        return result;
      }
    }
    return "Assigned";
  },
  tentativeAssignStatus: function tentativeAssignStatus(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.tentative_assign_status;
      if (result != null) {
        return result;
      }
    }
    return "Tentatively Assigned";
  },
  preReleaseShiftJobStatus: function preReleaseShiftJobStatus(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.pre_release_shift_job_status;
      if (result != null) {
        return result;
      }
    }
    return "Tentatively Assigned";
  },
  hideCandidatePreReleaseStatus: function hideCandidatePreReleaseStatus(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.hide_candidate_pre_realease;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  postReleaseShiftJobStatus: function postReleaseShiftJobStatus(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.post_release_shift_job_status;
      if (result != null) {
        return result;
      }
    }
    return "Assigned";
  },
  shiftJobStatusClientCanCancel: function shiftJobStatusClientCanCancel(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.shift_job_status_client_can_cancel;
      if (result) {
        return result;
      }
    }
    return getters.listShiftJobStatuses;
  },
  JobStatusClientCantEditShiftBookings: function JobStatusClientCantEditShiftBookings(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.job_status_client_cant_edit_shift_booking;
      if (result) {
        return result;
      }
    }
    return [];
  },
  defaultCandidateStatusShiftJobBroadcast: function defaultCandidateStatusShiftJobBroadcast(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var result = agency.advance_setting.default_candidate_statuses_shift_job_broadcast;
      if (result) {
        return result;
      }
    }
    return [];
  },
  isEmailCandidateJobAcceptted: function isEmailCandidateJobAcceptted(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.send_email_candidate_accept_job;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  isEmailClientJobAcceptted: function isEmailClientJobAcceptted(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.send_email_client_accept_job;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  acceptJobsByGroup: function acceptJobsByGroup(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.accept_jobs_by_group;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  shiftRequestMinimumHours: function shiftRequestMinimumHours(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency) {
      var result = agency.shift_request_minimum_hours;
      if (result && !isNaN(result)) {
        return Number(result);
      }
    }
    return 4; // Default is false
  },

  // Min between all client types
  shiftRequestMinimumHoursAllTypes: function shiftRequestMinimumHoursAllTypes(state, getters, rootState) {
    var min = getters.shiftRequestMinimumHours;
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var minPerTypes = agency.advance_setting.minimum_hours_per_types;
      if (minPerTypes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = minPerTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var hourType = _step.value;

            if (hourType.minimun_hours && !isNaN(hourType.minimun_hours)) {
              var hours = Number(hourType.minimun_hours);
              if (hours < min) {
                min = hours;
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
    return min;
  },
  employerShiftRequestEmails: function employerShiftRequestEmails(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (!agency || !agency.employer_shift_request_emails) {
      return [];
    }
    // Don't send notification email to admin if she is the one who created the booking
    var userEmail = rootState.authentication.userEmail;
    return agency.employer_shift_request_emails.filter(function (email) {
      return email !== userEmail;
    });
  },
  hideHourlyRateFromCandidates: function hideHourlyRateFromCandidates(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.hide_hourly_rate_from_candidates;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  autoAssignCandidate: function autoAssignCandidate(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.auto_assign_candidate;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  messageNobodyAvailable: function messageNobodyAvailable(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.message_nobody_available;
      if (result) {
        return result;
      }
    }
    return _defaultValues.DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE;
  },
  textSelfSelectNobodyAvailable: function textSelfSelectNobodyAvailable(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.text_nobody_available;
      if (result) {
        return result;
      }
    }
    return _defaultValues.DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE;
  },
  visibleToAssignCandidates: function visibleToAssignCandidates(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.visible_to_assign_candidates;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  checkHideBookedCandidatesBroadcast: function checkHideBookedCandidatesBroadcast(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.check_hide_booked_candidates_broadcast;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  showAnalyticsByDefaultPlacementJob: function showAnalyticsByDefaultPlacementJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.show_analytics_by_default_placement_job;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  customFilterFieldsPlacementJob: function customFilterFieldsPlacementJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.placement_job_custom_filter_fields;
      if (result && result.length) {
        return result;
      }
    }
    return _defaultValues.DEFAULT_PLACEMENT_JOB_FILTER_FIELDS;
  },
  checkHideTimeOffCandidatesBroadcast: function checkHideTimeOffCandidatesBroadcast(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.check_hide_timeoff_candidates_broadcast;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  checkHideUnavailableCandidatesBroadcast: function checkHideUnavailableCandidatesBroadcast(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.check_hide_unavailable_candidates_broadcast;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  jobStatusAfterBroadcasting: function jobStatusAfterBroadcasting(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.job_status_after_broadcasting;
      if (result) {
        return result;
      }
    }
    return "Broadcasted"; // Default is Broadcasted
  },
  shiftJobDistanceToShowOnJobBoard: function shiftJobDistanceToShowOnJobBoard(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      return agency.public_advance_setting.shift_job_distance_to_show_on_job_board;
    }
    return null; // Default is null
  },
  placementJobDistanceToShowOnJobBoard: function placementJobDistanceToShowOnJobBoard(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      return agency.public_advance_setting.placement_job_distance_to_show_on_job_board;
    }
    return null; // Default is null
  },
  shiftJobCalendarResultFields: function shiftJobCalendarResultFields(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      var result = agency.advance_setting.shift_job_calendar_result_fields;
      if (result && result.length) {
        return result;
      }
    }
    return _defaultValues.BOOKING_RESULT_DEFAULT_FIELDS;
  },
  notifyClientWhenInterestShift: function notifyClientWhenInterestShift(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.notify_client_when_interest_shift;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  notifyClientWhenInterestPlacement: function notifyClientWhenInterestPlacement(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.notify_client_when_interest_placement;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  listBreakDurationOptionList: function listBreakDurationOptionList() {
    return [{
      label: "15 minutes",
      id: 0.25
    }, {
      label: "30 minutes",
      id: 0.5
    }, {
      label: "45 minutes",
      id: 0.75
    }, {
      label: "1 hour",
      id: 1
    }, {
      label: "1 hour and 15 minutes",
      id: 1.25
    }, {
      label: "1 hour and 30 minutes",
      id: 1.5
    }, {
      label: "1 hour and 45 minutes",
      id: 1.75
    }, {
      label: "2 hours",
      id: 2
    }];
  },
  addBreakListFields: function addBreakListFields(state, getters) {
    return [{
      label: "Start Time of the break",
      model: "start_time",
      type: _customDefineType.FORM_TYPE.TIME_PICKER,
      itemPerRow: 2
    }, {
      label: "How long",
      model: "duration",
      type: _customDefineType.FORM_TYPE.MULTI_SELECT,
      optionLabel: "label",
      optionModel: "id",
      optionList: getters.listBreakDurationOptionList,
      itemPerRow: 2
    }, {
      label: "Note",
      isRequired: false,
      model: "note",
      type: _customDefineType.FORM_TYPE.TEXTAREA
    }];
  },
  shiftJobCalendarSearchFields: function shiftJobCalendarSearchFields(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var listFields = agency.advance_setting.shift_job_calendar_search_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return [];
  },
  defaultHiddenPlacementJobStatus: function defaultHiddenPlacementJobStatus(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting) {
      var listFields = agency.public_advance_setting.default_hidden_placement_job_status;
      if (listFields) {
        return listFields;
      }
    }
    return ["Filled", "Closed", "Draft"];
  },
  placementJobTableFields: function placementJobTableFields(state, getters, rootState, rootGetters) {
    var result = _defaultValues.DEFAULT_PLACEMENT_JOB_TABLE_FIELDS;
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      var listFields = agency.advance_setting.placement_job_table_fields;
      if (listFields) {
        result = listFields;
      }
    }
    var listTypes = rootGetters.listPlacementJobTypes;
    // Check to display job categories column
    if (!listTypes || !listTypes.length) {
      result = result.filter(function (item) {
        return item.model !== 'types';
      });
    }
    return result;
  },
  hasNotifyCandidateAssignShiftJob: function hasNotifyCandidateAssignShiftJob(state, getters) {
    return getters.sendCandidateAssignConfirmationEmailShiftJob || getters.sendSMSCandidateNotificationOnAssignJob;
  },
  hasNotifyClientAssignShiftJob: function hasNotifyClientAssignShiftJob(state, getters) {
    return getters.sendClientAssignConfirmationEmailShiftJob || getters.sendSMSClientNotificationOnAssignJob;
  },
  sendCandidateAssignConfirmationEmailShiftJob: function sendCandidateAssignConfirmationEmailShiftJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.hasOwnProperty('send_candidate_assign_confirmation_email_shift_job')) {
      return agency.advance_setting.send_candidate_assign_confirmation_email_shift_job;
    }
    return true;
  },
  sendClientAssignConfirmationEmailShiftJob: function sendClientAssignConfirmationEmailShiftJob(state, getters, rootState) {
    var agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.hasOwnProperty('send_client_assign_confirmation_email_shift_job')) {
      return agency.advance_setting.send_client_assign_confirmation_email_shift_job;
    }
    return true;
  },
  listPlacementJobStatuses: function listPlacementJobStatuses(state, getters, rootState) {
    var agency = rootState.agency;
    if (agency && agency.agencyPublic && agency.agencyPublic.placement_job_statuses && agency.agencyPublic.placement_job_statuses.length != 0) {
      return agency.agencyPublic.placement_job_statuses;
    } else {
      return _defaultValues.DEFAULT_PLACEMENT_JOB_STATUSES;
    }
  },
  sendSMStoCandidateWhenJobIsCancelled: function sendSMStoCandidateWhenJobIsCancelled(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty('send_sms_to_candidate_when_job_is_cancelled')) {
      return agency.public_advance_setting.send_sms_to_candidate_when_job_is_cancelled;
    } else {
      return true;
    }
  },
  sendSMStoClientWhenJobIsCancelled: function sendSMStoClientWhenJobIsCancelled(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty("send_sms_to_client_when_job_is_cancelled")) {
      return agency.public_advance_setting.send_sms_to_client_when_job_is_cancelled;
    } else {
      return true;
    }
  },
  sendEmailtoCandidateWhenJobIsCancelled: function sendEmailtoCandidateWhenJobIsCancelled(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty('send_email_to_candidate_when_job_is_cancelled')) {
      return agency.public_advance_setting.send_email_to_candidate_when_job_is_cancelled;
    } else {
      return true;
    }
  },
  sendEmailtoClientWhenJobIsCancelled: function sendEmailtoClientWhenJobIsCancelled(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty('send_email_to_client_when_job_is_cancelled')) {
      return agency.public_advance_setting.send_email_to_client_when_job_is_cancelled;
    } else {
      return true;
    }
  },
  mapShiftJobCategoryColor: function mapShiftJobCategoryColor(state, getters, rootState) {
    var listCategoryColor = (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.shift_job_category_color;
    });
    if (!listCategoryColor) {
      return {};
    }
    var result = {};
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = listCategoryColor[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item = _step2.value;

        result[item.category] = item.color;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return result;
  },
  mapShiftJobLocationColor: function mapShiftJobLocationColor(state, getters, rootState) {
    var listLocationColor = (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.shift_job_location_color;
    });
    if (!listLocationColor) {
      return {};
    }
    var result = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = listLocationColor[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var item = _step3.value;

        result[item.location] = item.color;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return result;
  },

  jobsNotes: function jobsNotes(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobsNotes;
    }) || [];
  },
  jobsNotesErrors: function jobsNotesErrors(state) {
    return (0, _tryGet2.default)(function () {
      return state.jobsNotesErrors;
    }) || [];
  },
  hasReportProblemButton: function hasReportProblemButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.has_report_problem_button;
    }) || false;
  },
  reportProblemButtonText: function reportProblemButtonText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.report_problem_button_text;
    }) || _defaultValues.DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT;
  },
  reportProblemUploadFilesLabel: function reportProblemUploadFilesLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.report_problem_upload_file_label;
    }) || _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL;
  },
  reportProblemUploadFilesDescription: function reportProblemUploadFilesDescription(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.report_problem_upload_file_description;
    }) || _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION;
  },
  reportProblemNoteLabel: function reportProblemNoteLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.report_problem_note_label;
    }) || _defaultValues.DEFAULT_REPORT_PROBLEM_NOTE_LABEL;
  },
  reportProblemNotificationEmails: function reportProblemNotificationEmails(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.report_problem_notification_emails;
    }) || [];
  },
  reportProblemNewJobStatus: function reportProblemNewJobStatus(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.report_problem_new_job_status;
    }) || "";
  },
  clientHasReportProblemButton: function clientHasReportProblemButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.has_report_problem_button_for_client;
    }) || false;
  },
  clientReportProblemButtonText: function clientReportProblemButtonText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_report_problem_button_text;
    }) || _defaultValues.DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT;
  },
  clientReportProblemUploadFilesLabel: function clientReportProblemUploadFilesLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_report_problem_upload_file_label;
    }) || _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL;
  },
  clientReportProblemUploadFilesDescription: function clientReportProblemUploadFilesDescription(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_report_problem_upload_file_description;
    }) || _defaultValues.DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION;
  },
  clientReportProblemNoteLabel: function clientReportProblemNoteLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_report_problem_note_label;
    }) || _defaultValues.DEFAULT_REPORT_PROBLEM_NOTE_LABEL;
  },
  clientReportProblemNotificationEmails: function clientReportProblemNotificationEmails(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_report_problem_notification_emails;
    }) || [];
  },
  clientReportProblemNewJobStatus: function clientReportProblemNewJobStatus(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.client_report_problem_new_job_status;
    }) || "";
  },
  shiftJobCancellationReasonList: function shiftJobCancellationReasonList(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.shift_job_cancellation_reason_list;
    }) || _defaultValues.DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST;
  },
  listShiftJobStatusesCancelled: function listShiftJobStatusesCancelled(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.list_shift_job_statuses_cancelled;
    }) || ["Cancelled"];
  },
  disableLocationFilterShiftJob: function disableLocationFilterShiftJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.disable_location_filter_shift_job;
    }) || false;
  },
  hideLocationFilterShiftJob: function hideLocationFilterShiftJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_location_filter_shift_job;
    }) || false;
  },
  broadcastOnCreateJob: function broadcastOnCreateJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.broadcast_on_create_job;
    }) || false;
  },
  jobBoardBackgroundColor: function jobBoardBackgroundColor(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.job_board_bg_color;
    }) || '#ffffff';
  },
  jobBoardFontColor: function jobBoardFontColor(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.job_board_font_color;
    }) || '#000000';
  },
  jobBoardVisibleFields: function jobBoardVisibleFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.job_board_visible_fields;
    }) || [];
  },
  notifyAllApplicants: function notifyAllApplicants(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.notify_all_applicants;
    }) || false;
  },
  jobBoardFullWidthBarMode: function jobBoardFullWidthBarMode(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.job_board_full_width_bar_mode;
    }) || false;
  },
  showImageJobBoardFullWidthBarMode: function showImageJobBoardFullWidthBarMode(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.show_image_job_board_full_width_bar_mode;
    }) || false;
  },
  showHiredBadgeOnJobBoard: function showHiredBadgeOnJobBoard(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.show_hired_badge_on_job_board;
    }) || false;
  },
  hideCandidateLastNameForShiftJobs: function hideCandidateLastNameForShiftJobs(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.hide_candidate_last_name_for_shift_jobs;
    }) || false;
  },
  filterTimeSheetsByWeekDay: function filterTimeSheetsByWeekDay(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.filter_time_sheets_by_week_day;
    }) || false;
  },
  hideDistanceViewingPlacementJob: function hideDistanceViewingPlacementJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_distance_viewing_placement_job;
    }) || false;
  },
  hideDistanceViewingShiftJob: function hideDistanceViewingShiftJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_distance_viewing_shift_job;
    }) || false;
  },
  hideChangeResponseShiftJob: function hideChangeResponseShiftJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_change_response_shift_job;
    }) || false;
  },
  hideChangeResponsePlacementJob: function hideChangeResponsePlacementJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_change_response_placement_job;
    }) || false;
  },
  placementJobBroadcastStatuses: function placementJobBroadcastStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.placement_job_broadcast_statuses;
    }) || [];
  },
  placementJobViewingStatuses: function placementJobViewingStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.placement_job_viewing_statuses;
    }) || [];
  },
  placementJobViewingTypes: function placementJobViewingTypes(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.placement_job_viewing_types;
    }) || [];
  },
  shiftJobViewingStatuses: function shiftJobViewingStatuses(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.shift_job_viewing_statuses;
    }) || [];
  },
  shiftJobViewingTags: function shiftJobViewingTags(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.shift_job_viewing_tags;
    }) || [];
  },
  createBookingGroupNotificationEmails: function createBookingGroupNotificationEmails(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.create_booking_group_emails;
    }) || [];
  },
  doNotWantAgainText: function doNotWantAgainText(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.custom_do_not_want_again_text;
    }) || _defaultValues.DEFAULT_DO_NOT_WANT_AGAIN_TEXT;
  },
  shiftJobCandidateUnassignStatus: function shiftJobCandidateUnassignStatus(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.shift_job_candidate_unassign_status;
    }) || '';
  },
  showAddressShiftJobCalendar: function showAddressShiftJobCalendar(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.show_address_shift_job_calendar;
    }) || false;
  },
  jobStatusesToHideSchedulerView: function jobStatusesToHideSchedulerView(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.job_statuses_to_hide_scheduler_view;
    }) || ['Assigned'];
  },
  shiftJobStatusesWhereJobStatusVisible: function shiftJobStatusesWhereJobStatusVisible(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.shift_job_statuses_where_job_status_visible_to_client;
    }) || ['Cancelled'];
  },
  jobDetailViewVisibleFields: function jobDetailViewVisibleFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.job_board_detail_view_fields;
    }) || _defaultValues.DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS;
  },
  hideFromJobBoardCheckedByDefault: function hideFromJobBoardCheckedByDefault(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_from_job_board_checked_by_default;
    }) || false;
  },
  selectedMyJobsTableColumns: function selectedMyJobsTableColumns(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.my_jobs_table_columns;
    }) || [];
  },
  hideClientNameCandidateViewAvailableShiftJob: function hideClientNameCandidateViewAvailableShiftJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.hide_client_name_candidate_viewing_available_shift_job;
    }) || false;
  },
  doNotAutoPopulateAddress: function doNotAutoPopulateAddress(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.do_not_auto_populate_address;
    }) || false;
  },
  wordUsedForInterestedInJobLabel: function wordUsedForInterestedInJobLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.word_used_for_intereseted_in_opportunity;
    }) || "Interested in this opportunity?";
  },
  wordUsedForApplyNowButton: function wordUsedForApplyNowButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.word_used_for_apply_now_btn;
    }) || "Apply Now";
  },
  wordUsedForAlreadySubmittedLabel: function wordUsedForAlreadySubmittedLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.word_used_for_already_submitted_label;
    }) || "Already submitted an application previously?";
  },
  wordUsedForLoginToSubmitApplicationButton: function wordUsedForLoginToSubmitApplicationButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.word_used_for_login_to_submit_btn;
    }) || "Log in to Submit your Application";
  },
  customTextShiftJobAccepted: function customTextShiftJobAccepted(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.custom_text_shift_job_accepted;
    }) || "";
  },
  defaultCandidateTypesShiftJobBroadcast: function defaultCandidateTypesShiftJobBroadcast(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.default_candidate_types_shift_job_broadcast;
    }) || [];
  },
  defaultCandidateTagsShiftJobBroadcast: function defaultCandidateTagsShiftJobBroadcast(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.default_candidate_tags_shift_job_broadcast;
    }) || [];
  },
  doNotAskReasonClientCancelsShiftJob: function doNotAskReasonClientCancelsShiftJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.do_not_ask_reason_client_cancels_shift_job;
    }) || false;
  },
  checkHideCandidateWithNoMatchingTags: function checkHideCandidateWithNoMatchingTags(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.hide_candidates_no_matching_tag_broadcast;
    }) || false;
  },
  checkHideCandidateDoNotMatchList: function checkHideCandidateDoNotMatchList(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.hide_candidates_do_not_match_list;
    }) || true;
  },
  defaultFilterJobStatusesShiftJobCalendar: function defaultFilterJobStatusesShiftJobCalendar(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.default_filter_job_statuses_shift_job_calendar;
    }) || [];
  },
  customizeConfirmTextAcceptJob: function customizeConfirmTextAcceptJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.custom_confirm_text_accept_job;
    }) || _defaultValues.DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE;
  },
  customizeConfirmTextAcceptJobButton: function customizeConfirmTextAcceptJobButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.custom_confirm_text_accept_job_button;
    }) || _defaultValues.DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT;
  },
  showShiftJobBoardInternally: function showShiftJobBoardInternally(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.show_shift_job_board_internally;
    }) || false;
  },
  customClockoutMessage: function customClockoutMessage(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.candidate_custom_clockout_message;
    }) || false;
  },
  showPlacedJobsOnJobBoard: function showPlacedJobsOnJobBoard(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.show_placed_jobs_on_job_board;
    }) || false;
  },
  shiftJobViewingTypes: function shiftJobViewingTypes(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.shift_job_viewing_types;
    }) || [];
  },
  includeBookingCancelReasonInCandidateEmail: function includeBookingCancelReasonInCandidateEmail(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.include_booking_cancel_reason_candidate_email;
    }) || false;
  },
  defaultCandidateStatusesAppearAssigningCandidate: function defaultCandidateStatusesAppearAssigningCandidate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.default_candidate_statuses_appear_assigning_candidate;
    }) || [];
  },
  defaultCandidateTypesAppearAssigningCandidate: function defaultCandidateTypesAppearAssigningCandidate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.default_candidate_types_appear_assigning_candidate;
    }) || [];
  },
  doNotWarnAboutCandidateAvailability: function doNotWarnAboutCandidateAvailability(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.do_not_warn_about_candidate_availability;
    }) || false;
  },
  skipCandidateConflictCheck: function skipCandidateConflictCheck(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.skip_candidate_conflict_check;
    }) || false;
  },
  candidateCanMarkJobAsCompleted: function candidateCanMarkJobAsCompleted(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_can_mark_job_as_completed;
    }) || false;
  },
  buttonTextCandidateMarkJobCompleted: function buttonTextCandidateMarkJobCompleted(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.mark_job_completed_button_text;
    }) || _defaultValues.DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED;
  },
  statusCandidateMarkJobCompleted: function statusCandidateMarkJobCompleted(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.job_status_after_candidate_mark_job_completed;
    }) || _defaultValues.DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED;
  },
  chargeTransferIncludeMileage: function chargeTransferIncludeMileage(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.charge_transfer_include_mileage;
    }) || false;
  },
  chargeTransferPricePerMile: function chargeTransferPricePerMile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return Number(rootState.authentication.agency.advance_setting.charge_transfer_price_per_mile);
    }) || 0.625;
  },
  chargeTransferIncludeReimbersement: function chargeTransferIncludeReimbersement(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.charge_transfer_include_reimbersement;
    }) || false;
  },
  shiftJobReportAdminOnly: function shiftJobReportAdminOnly(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.shift_job_report_admin_only;
    }) || false;
  },
  allowTip: function allowTip(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.allow_tipping;
    }) || false;
  },
  notAllowTipAfterCharge: function notAllowTipAfterCharge(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.not_allow_tip_after_charge;
    }) || false;
  },
  candidateTagsMatchingOptionSchedulerView: function candidateTagsMatchingOptionSchedulerView(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candiate_tags_matching_options_scheduler_view;
    }) || 'All Of';
  },
  disableDefaultShiftJobDistanceSearch: function disableDefaultShiftJobDistanceSearch(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.disable_shift_job_default_distance_search;
    }) || false;
  },
  disableDefaultPlacementDistanceSearch: function disableDefaultPlacementDistanceSearch(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.disable_placement_job_default_distance_search;
    }) || false;
  },
  candidateNotAllowReview: function candidateNotAllowReview(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_not_allow_review;
    }) || false;
  },
  publicJobStartDateLabel: function publicJobStartDateLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.public_job_start_date_label;
    }) || 'Start Date';
  },
  publicJobEndDateLabel: function publicJobEndDateLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.public_job_end_date_label;
    }) || 'End Date';
  },
  publicJobStartTimeLabel: function publicJobStartTimeLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.public_job_start_time_label;
    }) || 'Start Time';
  },
  publicJobEndTimeLabel: function publicJobEndTimeLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.public_job_end_time_label;
    }) || 'End Time';
  },
  sendSMSCandidateNotificationOnAssignJob: function sendSMSCandidateNotificationOnAssignJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.send_candidate_assign_confirmation_sms_shift_job;
    }) || false;
  },
  sendSMSClientNotificationOnAssignJob: function sendSMSClientNotificationOnAssignJob(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.send_client_assign_confirmation_sms_shift_job;
    }) || false;
  },
  useBookedTimeIfNoClockedTime: function useBookedTimeIfNoClockedTime(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.use_booked_time_if_no_clocked_time;
    }) || false;
  },
  defaultPlacementJobImage: function defaultPlacementJobImage(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.default_placement_job_image;
    }) || '';
  },
  customMinutesIntervalBookingTime: function customMinutesIntervalBookingTime(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.custom_minute_interval_booking_time;
    }) || 15;
  },
  bookingMinutesIntervalShiftJobCalendar: function bookingMinutesIntervalShiftJobCalendar(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.booking_minutes_interval;
    }) || 15;
  },
  customizeSubmitReportButtonLabel: function customizeSubmitReportButtonLabel(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.customize_submit_report_button_label;
    }) || '';
  },
  allowBookOnBlockedDate: function allowBookOnBlockedDate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.allow_book_on_blocked_date;
    }) || false;
  },
  jobStatusForBlockedDate: function jobStatusForBlockedDate(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.job_status_blocked_out_date;
    }) || 'Requested';
  },
  customMessageRequestForBlockedDates: function customMessageRequestForBlockedDates(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.custom_text_job_blocked_dates;
    }) || _defaultValues.DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES;
  },
  candidateAcceptMatchingCategory: function candidateAcceptMatchingCategory(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_accept_matching_category;
    }) || false;
  },
  candidateSeeMatchingCategory: function candidateSeeMatchingCategory(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_see_matching_category;
    }) || false;
  },
  shiftJobBroadcastCandidateTableFields: function shiftJobBroadcastCandidateTableFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.shift_job_broadcast_candidate_table_fields;
    }) || [];
  },
  placementJobBroadcastCandidateTableFields: function placementJobBroadcastCandidateTableFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.placement_job_broadcast_candidate_table_fields;
    }) || [];
  },
  placementOfPriceInfoFields: function placementOfPriceInfoFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.placement_of_price_info_fields;
    }) || [];
  },
  labelForShiftJobInterestedButton: function labelForShiftJobInterestedButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.customize_label_for_shift_job_interested_button;
    }) || "I'M INTERESTED";
  },
  labelForShiftJobNotInterestedButton: function labelForShiftJobNotInterestedButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.customize_label_for_shift_job_not_interested_button;
    }) || "I'M NOT INTERESTED";
  },
  labelForShiftJobMightBeInterestedButton: function labelForShiftJobMightBeInterestedButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.customize_label_for_shift_job_might_be_interested_button;
    }) || "I MIGHT BE INTERESTED";
  },
  initFilterLocationByClientLocation: function initFilterLocationByClientLocation(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.initial_filter_location_by_client_location;
    }) || false;
  },
  statusHiddenPastDateShiftJobCalendar: function statusHiddenPastDateShiftJobCalendar(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.status_hidden_past_date_shift_job_calendar;
    }) || [];
  },
  zoomLevelOfJobMap: function zoomLevelOfJobMap(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.zoom_level_of_job_map;
    }) || 13;
  },
  placementJobAnalyticsDashboardFields: function placementJobAnalyticsDashboardFields(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.placement_job_analytics_dashboard_fields;
    }) || ['status'];
  },
  defaultCandidateHideStatusesShiftJobBroadcast: function defaultCandidateHideStatusesShiftJobBroadcast(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.default_candidate_hide_statuses_shift_job_broadcast;
    }) || [];
  },
  defaultCandidateHideStatusesPlacementJobBroadcast: function defaultCandidateHideStatusesPlacementJobBroadcast(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.default_candidate_hide_statuses_placement_job_broadcast;
    }) || [];
  },
  hideShiftJobDuplicateButton: function hideShiftJobDuplicateButton(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_shift_job_duplicate_button;
    }) || false;
  },
  reverseDefaultDateSortOrderShiftJobTable: function reverseDefaultDateSortOrderShiftJobTable(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.reverse_default_date_sort_order_shift_table_view;
    }) || false;
  },
  hideShiftJobUpdateManagerSection: function hideShiftJobUpdateManagerSection(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.hide_shift_job_update_manager;
    }) || false;
  },
  getUserLocationWhenClockInOut: function getUserLocationWhenClockInOut(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.get_user_location_when_clock_in_out;
    }) || false;
  },
  shiftJobCalendarTitleAvailableJobBoard: function shiftJobCalendarTitleAvailableJobBoard(state, getters, rootState) {
    var result = (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.shift_job_calendar_title_available_job_board;
    }) || _defaultValues.DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD;
    if (getters.hideClientNameCandidateViewAvailableShiftJob) {
      result = result.replace('[[poster_first_name]] ', '');
    }
    return result;
  },
  showMapLocations: function showMapLocations(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.show_map_job_board;
    }) || false;
  },
  showShiftMapLocations: function showShiftMapLocations(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.show_map_shift_job_board;
    }) || false;
  },
  showClientProfileOnJobListings: function showClientProfileOnJobListings(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.show_client_profile_on_job_listings;
    }) || false;
  },
  candidateTypesCanViewClientProfile: function candidateTypesCanViewClientProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_types_can_view_client_profile;
    }) || [];
  },
  candidateStatusesCanViewClientProfile: function candidateStatusesCanViewClientProfile(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_statuses_can_view_client_profile;
    }) || [];
  },
  isCandidateEditableViewDefault: function isCandidateEditableViewDefault(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.advance_setting.set_editable_view_default_candidate;
    }) || false;
  },
  jobId: function jobId(state) {
    return state.jobId || undefined;
  },
  candidateDeclinedShiftJobNotificationTarget: function candidateDeclinedShiftJobNotificationTarget(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.candidate_declined_shift_job_notification_target;
    }) || [];
  },
  doNotBookOutsideOfficeHours: function doNotBookOutsideOfficeHours(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.do_not_book_outside_office_hours;
    }) || false;
  },
  warningBookOutsideOfficeHours: function warningBookOutsideOfficeHours(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.warning_book_outside_office_hours;
    }) || _defaultValues.DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR;
  },
  shiftJobStatusAfterDragDropToAssign: function shiftJobStatusAfterDragDropToAssign(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.authentication.agency.advance_setting.shift_job_status_after_drag_drop_to_assign;
    }) || 'Assigned';
  },
  candidateMatchingCategoryField: function candidateMatchingCategoryField(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.candidate_matching_category_field;
    }) || null;
  },
  onlyShowMatchedZipcodes: function onlyShowMatchedZipcodes(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.only_show_matched_zipcodes;
    }) || false;
  },
  minDurationPerTypes: function minDurationPerTypes(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.minimum_hours_per_types;
    }) || null;
  },
  minDurationPerCategories: function minDurationPerCategories(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.minimum_hours_per_categories;
    }) || null;
  },
  minDurationPerLocations: function minDurationPerLocations(state, getters, rootState) {
    return (0, _tryGet2.default)(function () {
      return rootState.agency.agencyPublic.public_advance_setting.minimum_hours_per_locations;
    }) || null;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LIST_BOOKING_ADDRESS_FIELDS = undefined;

var _customDefineType = __webpack_require__(6);

var LIST_BOOKING_ADDRESS_FIELDS = exports.LIST_BOOKING_ADDRESS_FIELDS = [{
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.BOOKING_ADDRESS",
    model: "address1"
}, {
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.ADDRESS_LINE2",
    model: "address2",
    isRequired: false
}, {
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.CITY",
    itemPerRow: 3,
    model: "city"
}, {
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.STATE",
    itemPerRow: 3,
    model: "provincestate"
}, {
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.ZIP_CODE",
    itemPerRow: 3,
    model: "postal_code"
}];

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var state = {
  applicationStateData: {},
  mapUploadedFileUrlName: {},
  mapUploadedFileUrlSize: {}
};

var mutations = {
  setApplicationStateData: function setApplicationStateData(state, payload) {
    state.applicationStateData = payload;
  },
  addUploadedFileUrlName: function addUploadedFileUrlName(state, payload) {
    if (!state.mapUploadedFileUrlName) {
      state.mapUploadedFileUrlName = {};
    }
    state.mapUploadedFileUrlName[payload.url] = payload.name;
  },
  addUploadedFileUrlSize: function addUploadedFileUrlSize(state, payload) {
    if (!state.mapUploadedFileUrlSize) {
      state.mapUploadedFileUrlSize = {};
    }
    state.mapUploadedFileUrlSize[payload.url] = payload.size;
    state.mapUploadedFileUrlSize = _extends({}, state.mapUploadedFileUrlSize);
  }
};

var actions = {
  setApplicationStateData: function setApplicationStateData(_ref, payload) {
    var commit = _ref.commit;

    commit("setApplicationStateData", payload);
  },
  addUploadedFileUrlName: function addUploadedFileUrlName(_ref2, payload) {
    var commit = _ref2.commit;

    commit("addUploadedFileUrlName", payload);
  },
  addUploadedFileUrlSize: function addUploadedFileUrlSize(_ref3, payload) {
    var commit = _ref3.commit;

    commit("addUploadedFileUrlSize", payload);
  }
};

var getters = {
  applicationStateData: function applicationStateData(state) {
    return state.applicationStateData;
  },
  mapUploadedFileUrlName: function mapUploadedFileUrlName(state) {
    return state.mapUploadedFileUrlName;
  },
  mapUploadedFileUrlSize: function mapUploadedFileUrlSize(state) {
    return state.mapUploadedFileUrlSize;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(239);

var _en2 = _interopRequireDefault(_en);

var _pt = __webpack_require__(673);

var _pt2 = _interopRequireDefault(_pt);

var _fr = __webpack_require__(677);

var _fr2 = _interopRequireDefault(_fr);

var _de = __webpack_require__(681);

var _de2 = _interopRequireDefault(_de);

var _es = __webpack_require__(685);

var _es2 = _interopRequireDefault(_es);

var _nl = __webpack_require__(689);

var _nl2 = _interopRequireDefault(_nl);

var _el = __webpack_require__(690);

var _el2 = _interopRequireDefault(_el);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    language: ""
};

var mutations = {
    setLanguage: function setLanguage(state, payload) {
        state.language = payload;
    }
};

var actions = {
    setLanguage: function setLanguage(_ref, payload) {
        var commit = _ref.commit;

        commit("setLanguage", payload);
    }
};

var getters = {
    language: function language(state) {
        return state.language;
    },
    listMultiLanguages: function listMultiLanguages() {
        return [{
            key: 'en',
            labels: ['english', 'en'],
            local: 'en-US',
            value: _en2.default
        }, {
            key: 'fr',
            labels: ['french', 'fr', 'française', 'français'],
            local: 'fr-FR',
            value: _fr2.default
        }, {
            key: 'pt',
            labels: ['portugal', 'português', 'portuguese'],
            local: 'pt-PT',
            value: _pt2.default
        }, {
            key: 'de',
            labels: ['deutsch', 'de', 'german', 'germany'],
            local: 'de-DE',
            value: _de2.default
        }, {
            key: 'es',
            labels: ['spanish', 'es', 'español'],
            local: 'es-ES',
            value: _es2.default
        }, {
            key: 'nl',
            labels: ['dutch', 'nl', 'nederlands'],
            local: 'nl-NL',
            value: _nl2.default
        }, {
            key: 'el',
            labels: ['greek', 'el', 'greece', 'hellenic'],
            local: 'el-GR',
            value: _el2.default
        }];
    },
    multiLanguageObjects: function multiLanguageObjects(state, getters, rootState, rootGetters) {
        // Find multi language value;
        var listLanguages = getters.listMultiLanguages;
        var lang = void 0;
        // User language
        if (state.language) {
            lang = state.language;
        }
        // Agency language
        if (!lang) {
            if (rootGetters.dashboardLanguage) {
                lang = rootGetters.dashboardLanguage;
            }
        }
        var result = listLanguages[0];
        if (lang) {
            var langObj = listLanguages.find(function (langObj) {
                return langObj.labels.includes(lang.toLowerCase());
            });
            if (langObj) {
                result = langObj;
            }
        }
        return result;
    },
    multiLanguageValues: function multiLanguageValues(state, getters) {
        return getters.multiLanguageObjects.value;
    },
    languageLocal: function languageLocal(state, getters) {
        return getters.multiLanguageObjects.local;
    }
};

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pt = __webpack_require__(674);

var _pt2 = _interopRequireDefault(_pt);

var _pt3 = __webpack_require__(675);

var _pt4 = _interopRequireDefault(_pt3);

var _pt5 = __webpack_require__(676);

var _pt6 = _interopRequireDefault(_pt5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Enviar",
        PREVIOUS: "Anterior",
        NEXT: "Próxima",
        VIEW: "Ver",
        UPLOAD: "Upload",
        CLOSE: "Fechar",
        DELETE: "Excluir",
        CANCEL: "Cancelar",
        YES: "Sim",
        NO: "Não",
        OK: "Ok",
        ADD: "Acrescentar"
    },
    OPTIONS: {
        YES: "Sim",
        NO: "Não"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Este campo é obrigatório."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Processando ... Por favor aguarde...",
        STEP_OF: "Etapa {0} de {1}"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Solte um arquivo aqui ou clique para fazer o upload",
        MAXIMUM_UPLOAD_SIZE: "Tamanho máximo de upload {0}MB",
        FILE_EXCEED_MAXIMUM: "O tamanho do arquivo excede {0}MB.",
        FILE: "Arquivo"
    },
    BOOKING_DIALOG: {
        LABEL: {
            REPEAT: "Repete?",
            REPEAT_UNTIL: "Repetir até",
            REPEAT_EVERY: "Repetir a cada",
            REPEAT_ON: "Repetir Ligado",
            BOOKING_ADDRESS: "Endereço de reserva",
            ADDRESS_LINE2: "Linha de endereço 2",
            CITY: "Cidade",
            STATE: "Estado",
            ZIP_CODE: "CEP",
            NUMBER_CHILDREN: "Quantas crianças serão cuidadas?",
            SELECT_JOB_CATEGORY: "Selecione a categoria de trabalho"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Dias", "Semanas"],
            REPEAT_ON: ["Segunda-feira", "Terça", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado", "Domingo"]
        }
    },
    CONFIRM_DIALOGS: _pt2.default,
    ERROR_DIALOGS: _pt4.default,
    RESULT_DIALOGS: _pt6.default
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this reference?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this experience?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this contact?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this education?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this child?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this pet?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this booking?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile builder {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this request?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this job?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this application?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the document {0}?',
        ACCEPT_LABEL: 'Delete Document',
        REJECT_LABEL: 'Close'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the file?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Close'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} template {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0} {1}</p>\n        <p>{2}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel this booking?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close? Any changes will be lost.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your changes?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile picture?',
        ACCEPT_LABEL: 'Delete Picture',
        REJECT_LABEL: 'Close'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove the link between {0} and this client?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'You are committing to filling this job, are you sure?',
        ACCEPT_LABEL: 'Accept Job',
        REJECT_LABEL: 'Close'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark {0} as favorite?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you do not want {0} again?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete the note?</h3>\n        <p style="white-space: pre-wrap;">{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this credit?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    }
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requiredValues = __webpack_require__(58);

exports.default = {
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: "Campo ausente para endereço de e-mail",
        MESSAGE: "Por favor, adicione pelo menos 1 campo para o endereço de e-mail!"
    },
    INVALID_INPUT_ERROR: {
        TITLE: "Um campo obrigatório está faltando ou um campo é inválido.",
        MESSAGE: "Por favor, reveja o formulário para mensagens de erro!"
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Booking time is missing',
        MESSAGE: 'Please add booking time (Start Time and End Time)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'A document is not signed',
        MESSAGE: 'Please review the form for error messages and sign all documents!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'An input field is invalid',
        MESSAGE: 'There is an input field which is invalid'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'There is no field for the builder',
        MESSAGE: 'Please add at least one field!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'Cannot use same option between {0} and {1}',
        MESSAGE: 'Please unselect option(s) {2} in {0} or {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: 'Please add more {0}!',
        MESSAGE: 'You must have at least {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Experience is lacking',
        MESSAGE: 'You must have at least 1 experience.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Statuses is lacking',
        MESSAGE: _requiredValues.LIST_REQUIRED_STATUSES.join(" and ") + " are required statuses"
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some statuses which are duplicated'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Multi fields using the same model',
        MESSAGE: 'There is a model which is assigned to at least 2 fields'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some items which are duplicated'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'Employer type is duplicated',
        MESSAGE: 'There are some employer type which are duplicated'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'Candidate type is duplicated',
        MESSAGE: 'There are some candidate type which are duplicated'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a PNG or JPG image.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a DOC or DOCX or PDF file.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: 'File is empty!',
        MESSAGE: 'Please upload a non empty file'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: 'File too big!',
        MESSAGE: 'Please upload a file with a size below the maximum upload size.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Invalid File',
        MESSAGE: 'Invalid input file'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Your professional childcare resume is missing',
        MESSAGE: 'Please upload your professional childcare resume'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'End date must be after start date',
        MESSAGE: 'Please change start date or end date'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Bookings must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Your profile picture is missing',
        MESSAGE: 'Please upload a recent photo of yourself!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'No text selected',
        MESSAGE: 'Please select some text'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Your application has been submitted! BUT',
        MESSAGE: 'There was an error processing your references. Can you please email them to us? Thanks!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Failed to submit your application',
        MESSAGE: 'There was an error processing your application'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Missing item in status list',
        MESSAGE: 'Status {0} is required'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'There is an incomplete section',
        MESSAGE: 'Section {0} is incomplete. Please update that section'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Passwords do not match.'
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'Unable to find nearby Candidates',
        MESSAGE: 'Job is missing a full address. To search for candidates Edit Job and fill missing address info'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'The profile builder is in used',
        MESSAGE: 'The profile builder is being used by the profile builder {0}.\n' + 'Please remove that profile builder first'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'A signature is missing',
        MESSAGE: 'Please type your name to sign'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'A required field is missing',
        MESSAGE: 'Please fill all of the required fields (Please check the red border fields)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: "\n        <h2>It looks like you are already in our system!</h2>\n        <h4 class=\"error-message main-message\">\n        Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!\n        </h4>\n        "
    }
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Thank you for your application to join our team!',
        MESSAGE: 'We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Thank you for your information!',
        MESSAGE: 'The reference information you submitted is very important for us. You can safely close this window now.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: '\n        <h2>Thank you for submitting your registration!</h2>\n        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>\n        '
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Thanks for letting us know, we will be in touch with you shortly!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: '\n        <h2>Video is uploaded successfully!</h2>\n        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class="material-icons" style=\'position: absolute;\'>refresh</i>&nbsp;&nbsp;) button</h5>\n        '
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Section Saved',
        MESSAGE: 'Saved {0} section!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Family Form Updated',
        MESSAGE: 'Updated Family Form successfully'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Status updated.'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Broadcast sent!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
        MESSAGE: 'Please proceed to the client and candidate notification.'
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Job updated!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: 'Job created!'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client charged and job status updated!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Message sent.'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Password has been reset successfully.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been saved successfully.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been deleted successfully.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documents uploaded.',
        MESSAGE: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Your document has been signed.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Your document has been saved.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'The additional information of the document {0} is updated'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Template created.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Template updated'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Template deleted'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Template duplicated.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Password reset',
        MESSAGE: 'Password reset to {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Profile builder updated'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Email footer is saved'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Notification settings saved'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Additional admin settings saved'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Manager updated.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrator added'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrator updated'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrator deleted'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Locations updated'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Language updated'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Broadcast sent to {0} candidates!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Job views',
        MESSAGE: 'Number of times viewed: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: 'Blast Off!',
        MESSAGE: "Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: 'Note saved!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} saved, please add another one!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Thanks for letting us know!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Congrats, you've accepted this job!",
        MESSAGE: 'All the details will appear in your dashboard under "My Jobs".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'Visibility scope of the {0} is updated to {1}'
    },
    CHECK_FORM_UPDATED: {
        TITLE: '{0} check form is updated'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Changes Saved!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Price Created.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Price Updated.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Price Deleted.'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Offer Updated!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for leaving a review!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Marked as favorite!',
        MESSAGE: 'We will do our best to match you with them in the future.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Thank you for letting us know.',
        MESSAGE: 'We will do our best to connect you with others in the future'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for submitting your payment information!'
    }
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fr = __webpack_require__(678);

var _fr2 = _interopRequireDefault(_fr);

var _fr3 = __webpack_require__(679);

var _fr4 = _interopRequireDefault(_fr3);

var _fr5 = __webpack_require__(680);

var _fr6 = _interopRequireDefault(_fr5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Soumettre",
        PREVIOUS: "Précédent",
        NEXT: "Prochain",
        VIEW: "Voir",
        UPLOAD: "Télécharger",
        CLOSE: "Fermé",
        DELETE: "Effacer",
        CANCEL: "Annuler",
        YES: "Oui",
        NO: "Non",
        OK: "D'accord",
        ADD: "Add",
        UPDATE_STATUS: "État de la mise à jour",
        RETURN_DASHBOARD: "Revenir au tableau de bord",
        REFRESH: "Actualiser",
        BULK_UPDATE_STATUS: "Mettre à jour l'état de la sélection",
        BULK_UPDATE: "Mise à jour groupée",
        BULK_DELETE: "Supprimer la sélection",
        BULK_UNASSIGNED: "Désattribuer la sélection",
        EXPORT_EMPLOYERS: "Exporter la liste de diffusion des clients",
        UPDATE_MANAGER: "Gestionnaire de mise à jour",
        VIEW_PROFILE: "Afficher le profil",
        VIEW_OFFER: "Afficher l'offre",
        SAVE: "Enregistrer",
        EXPAND_ALL: "Tout développer",
        COLLAPSE_ALL: "Tout réduire",
        RESET_FILTERS: "Réinitialiser les filtres",
        CLOCK_IN: "Horloge d'arrivée",
        CLOCK_OUT: "Horloge terminée",
        LEAVE_REVIEW: "Laisser un avis",
        DECLINE: "Refuser",
        ACCEPT: "Accepter",
        CHECK_PAYMENT: "Paiement par chèque"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Nouveau statut",
        FILTER_BY_STATUS: "Filtrer par statut",
        FILTER_BY_STATUSES: "Filtrer par statuts",
        STATUSES_TO_HIDE: "Statuts à masquer",
        FILTER_BY_LOCATIONS: "Filtrer par emplacements",
        FILTER_BY_TYPES: "Filtrer par types",
        FILTER_BY_MANAGER: "Filtrer par responsable",
        FILTER_BY_CATEGORIES: "Filtrer par catégories",
        FILTER_BY_START_DATE: "Filtrer par date de début",
        FILTER_BY_END_DATE: "Filtrer par date de fin",
        FILTER_BY_CLIENTS: "Filtrer par clients",
        FILTER_BY_CLIENT_STATUSES: "Filtrer par statuts de client",
        FILTER_BY_CLIENT_TYPES: "Filtrer par types de clients",
        FILTER_BY_CANDIDATES: "Filtrer par candidat(s)",
        FILTER_BY_JOB_TYPES: "Filtrer par type de travail",
        FILTER_BY_JOB_STATUSES: "Filtrer par statuts de travail",
        FILTER_BY_USER_TYPE: "Filtrer par type d'utilisateur",
        KEYWORD_SEARCH_USER_PROFILE: "Recherchez un mot-clé/une phrase n'importe où sur le profil de l'utilisateur, appuyez sur Entrée pour appliquer la recherche",
        SEARCH_BY_NAME_EMAIL_PHONE: "Recherche par nom, e-mail ou numéro de téléphone",
        FILTER_BY_RECENT_ACTIVE: "Filtrer par activité récente",
        SELECT_LOCATIONS: "Sélectionner des emplacements",
        SELECT_OPTION: "Sélectionner une option",
        SELECT_CLIENT: "Sélectionner un client",
        SELECT_CANDIDATE: "Sélectionner un candidat",
        SELECT_CANDIDATES: "Sélectionner des candidats",
        SELECT_CANDIDATE_SEARCHABLE: "Sélectionner le candidat (saisir pour rechercher)",
        SELECT_ADMINS: "Sélectionner les administrateurs",
        SELECT_ADMIN_RECEIVE_EMAIL: "Sélectionner les administrateurs qui reçoivent des e-mails",
        SELECT_STATUS: "Sélectionner le statut",
        SELECT_LANGUAGES: "Sélectionner les langues",
        SELECT_TYPES: "Sélectionner les types",
        SELECT_TYPE: "Sélectionner le type",
        SELECT_USER_TYPE: "Sélectionner le type d'utilisateur",
        SELECT_USER_TYPES: "Sélectionner les types d'utilisateurs",
        SELECT_CATEGORY: "Sélectionner une catégorie",
        SELECT_CATEGORY_ADMIN_ONLY: "Sélectionner une catégorie (administrateur uniquement)",
        SELECT_TRIGGER: "Sélectionner le déclencheur",
        SELECT_ONE: "Sélectionnez-en un",
        SELECT_PROFILE_BUILDER: "Sélectionner le créateur de profil",
        SELECT_TIME_OFF_CATEOGRY: "Sélectionner la catégorie de temps libre",
        SELECT_DESTINATION: "Sélectionner la destination",
        SELECT_ACCESS_LEVEL: "Sélectionner le niveau d'accès",
        SELECT_VISIBILITY_SCOPE: "Sélectionner l'étendue de la visibilité",
        SELECT_AREAS: "Sélectionner des zones",
        NUMBER: "Numéro",
        DESCRIPTION_CHARGE: "Description des frais"
    },
    LABELS: {
        SELECT_TEMPLATE: "Sélectionner un modèle",
        FILTER_BY_LOCATIONS: "Filtrer par emplacements",
        FILTER_BY_TYPES: "Filtrer par types",
        FILTER_BY_MANAGER: "Filtrer par gestionnaire",
        FILTER_BY_CATEGORIES: "Filtrer par catégories",
        FILTER_BY_STATUS: "Filtrer par statut",
        ADDRESS: "Adresse",
        CITY: "Ville",
        STATE: "État",
        COUNTRY: "Pays",
        ZIP_CODE: "Code postal",
        LOCATIONS: "Lieux",
        DESCRIPTION: "Description",
        ADD_ITEM: "Ajouter {0}",
        EDIT_ITEM: "Éditer {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Sauvegarder et ajouter un autre {0}",
        WELCOME_TEXT: "Bienvenue sur {0}"
    },
    HEADERS: {
        EMAIL_LOG: "Journal des e-mails",
        SMS_LOG: "Journal SMS"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Comment masquer les statuts par défaut",
        HOW_TO_CHANGE_STATUS: "Comment ajouter/modifier des statuts"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Séparez plusieurs e-mails avec ; (par exemple : nanny1@hotmail.com ; nanny2@hotmail.com )",
        SMS_NOTE: "Veuillez noter qu'il y a un co\xFBt de 0,0115 $ (1,15 \xA2) par SMS. S'il te pla\xEEt\n         notez \xE9galement qu'il est actuellement impossible de r\xE9pondre aux SMS.",
        CLIENT_NOT_ENTERED_STRIPE: "Le client n'a pas saisi les informations Stripe.",
        INTERVIEW_PANEL: "Remarque\xA0: ces notes sont destin\xE9es \xE0 l'administrateur interne uniquement et ne sont pas\n         partag\xE9 avec les candidats ou les clients.",
        CANDIDATE_SHAREABLE_LINK: "Ceci est un lien partageable du profil du candidat. Si tu veux\n         pour voir ce qu'un client verra, assurez-vous de vous d\xE9connecter, puis\n         afficher le lien (ou l'ouvrir dans un autre navigateur).",
        CLIENT_SHAREABLE_LINK: "Ceci est un lien partageable du profil du client. Si tu veux\n         voir ce qu'un candidat verra, assurez-vous de vous d\xE9connecter, puis\n         afficher le lien (ou l'ouvrir dans un autre navigateur).",
        TYPE_YOUR_NAME_TO_SIGN: 'Veuillez taper votre nom (vous acceptez à ce titre que cela équivaut à une signature manuscrite)'
    },
    TABLE_HEADERS: {
        ACTIONS: "Actions",
        NOTES: "Remarques",
        VALUE: "Valeur"
    },
    OPTIONS: {
        YES: "Oui",
        NO: "Non"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Ce champ est requis."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Traitement en cours, veuillez patienter...",
        STEP_OF: "Étape {0} de {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Veuillez nous aider à remplir le formulaire ci-dessous",
        REFERENCE_FOR: "Référence pour {0} {1}",
        REFERENCE_INPUT_BY: "Informations de référence saisies par {0} {1}",
        FORM_SUBMITTED: "Le formulaire de vérification des références a été soumis !"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Déposez un fichier ici ou cliquez pour télécharger",
        MAXIMUM_UPLOAD_SIZE: "Taille d'importation maximale {0}MB",
        FILE_EXCEED_MAXIMUM: "La taille du fichier dépasse {0}MB.",
        FILE: "Ficher"
    },
    BOOKING_DIALOG: {
        LABEL: {
            START_TIME: "Heure de début",
            END_TIME: "Heure de fin",
            END_DATE: "Date de fin",
            SELECT_CLIENT: "Sélectionner un client",
            ASSIGNED_CANDIDATE: "Voulez-vous attribuer ce poste ?",
            REPEAT: "Voulez-vous ce service plus d'une fois (répétitive/récurrente) ?",
            REPEAT_UNTIL: "Répéter jusqu'à",
            REPEAT_EVERY: "Répéter chaque",
            REPEAT_ON: "Répéter activé",
            BOOKING_ADDRESS: "Adresse de réservation",
            ADDRESS_LINE2: "Ligne d'adresse 2",
            CITY: "Ville",
            STATE: "État/Province",
            ZIP_CODE: "Code postal",
            NUMBER_CHILDREN: "Combien d'enfants seront pris en charge ?",
            SELECT_JOB_CATEGORY: "Sélectionner la catégorie d'emploi",
            SELECT_DATE: "Date de réservation",
            SELECT_SERVICE: "Sélectionner le service"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Jours", "Semaines"],
            REPEAT_ON: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]
        }
    },
    MENU_BAR: {
        TOP: {
            MESSAGES: "Messages",
            SMS: "SMS",
            JOBS: "Tâches",
            LOGOUT: "Déconnexion",
            DASHBOARD: "Mon tableau de bord"
        },
        ADMIN: {
            USERS: {
                ROOT: "Utilisateurs",
                CLIENTS: "Client",
                CANDIDATES: "Candidats",
                ADMINISTRATORS: "Administrateurs"
            },
            JOBS_EVENTS: {
                ROOT: "Emplois et événements",
                SHIFT_JOB_CALENDAR: "Calendrier des tâches d'équipe",
                PLACEMENT_JOBS: "Emplois de placement",
                PERSONAL_TO_DO: "Personnel à faire"

            },
            TEMPLATES: {
                ROOT: "Modèles",
                EMAIL: "Modèles d'e-mail",
                DOCUMENT: "Modèles de documents",
                NOTE: "Modèles de notes",
                PROFILE: "Modèles de profil"
            },
            SETTINGS: {
                ROOT: "Paramètres",
                AGENCY: "Paramètre de l'agence",
                ADMIN: "Paramètre d'administration"
            },
            BUILDERS: {
                ROOT: "Constructeurs",
                PROFILE: "Constructeur de profil",
                EVALUATION: "Constructeur d'évaluation"
            },
            LOGS: {
                ROOT: "Journaux",
                COMMUNICATION_LOG: "Journal des communications",
                STATUS_CHANGES: "Changements de statut",
                ACTIVITY_LOG: "Journal d'activité"
            },
            OTHERS: {
                ROOT: "Autres",
                RESOURCE_MANAGER: "Gestionnaire de ressources",
                REFERENCES: "Références",
                DOCUMENTS: "Documents",
                EMAIL_BLASTER: "Email Blaster",
                NOTIFICATION_CENTER: "Centre de notifications",
                SNAPSHOT: "Instantané"
            }

        }
    },
    NAV_BAR: {
        TOP: "Haut",
        CHECKLIST: "Liste de contrôle",
        DOCUMENTS: "Documents",
        PHOTO_GALARY: "Galerie de photos",
        INTRODUCTION_VIDEO: "Vidéo de présentation"
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Bases du générateur de profils",
            REQUIRE_FIELD: "Comment marquer les questions/champs comme obligatoires ou non",
            NOTIFICATION_DESTINATION: "Modifier qui est informé des nouveaux candidats",
            EDIT_APPLICATION: "Comment modifier plus facilement les formulaires de candidature",
            ADD_SECTION_QUESTION: "Comment ajouter une question à une section",
            ADD_CONFIRMATION_BOX: "Comment ajouter des champs de confirmation sur les formulaires de candidature"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Commencer avec les évaluations"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: " Premiers pas avec les modèles d'e-mail ",
            DEFAULT_EMAIL_FOOTER: "Configuration de votre pied de page d'e-mail par défaut"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Démarrer avec les modèles de documents",
            NOTIFICATION_WHEN_SIGNED: "Ajouter une notification lorsque le document est signé",
            ADD_DOCUMENT: "Ajouter manuellement un document à un utilisateur"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Cartographier votre processus via des statuts, des listes de contrôle et des types",
            AGENCY_BRANDING_SETUP: "Configuration de la marque de l'agence (logo, couleurs, polices)",
            PROFILE_COMPLETE_SETUP: "Comment ajouter un bouton \"Mon profil est complet\" sur lequel les candidats peuvent cliquer pour vous informer qu'ils ont compl\xE9t\xE9 leur profil",
            CONFIGURE_MULTIPLE_LOCATIONS: "Configurez votre agence pour desservir plusieurs emplacements distincts"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Comment fonctionnent les envois d'e-mails ?"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "Comment partager le profil d'un candidat avec un client"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Bienvenue dans {0} Mission Control",
        PRO_TIP: {
            HEADER: "Astuce de pro !",
            TEXT: "Apprenez à personnaliser les colonnes/informations que vous voyez dans les tableaux des candidats et des clients"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Order les clients par",
            ORDER_CANDIDATES_BY: "Trier les candidats par"
        },
        BUTTONS: {
            ADD_CLIENT: "Ajouter un client",
            ADD_CANDIDATE: "Ajouter un candidat"
        }
    },
    ADD_USER_DIALOG: {
        HEADER: "Ajouter un nouvel utilisateur",
        DESCRIPTION: "Il s'agit d'un m\xE9canisme permettant d'ajouter manuellement un utilisateur \xE0 votre base de donn\xE9es. Un utilisateur\n        ajout\xE9 de cette mani\xE8re sera mis dans le statut \"Pre Application\"\n         (ce qui signifie qu'ils n'ont pas encore rempli de formulaire de demande). Un utilisateur dans\n        ce statut peut toujours \xEAtre envoy\xE9 pour compl\xE9ter le formulaire de candidature. Si tu\n        souhaite envoyer automatiquement un e-mail aux utilisateurs ajout\xE9s de cette fa\xE7on, vous\n        peut ajouter un mod\xE8le d'e-mail qui est une \"Notification de changement de statut\"\n        triggering lors d'un passage \xE0 \"Pre Application\".",
        LABELS: {
            EMAIL: "E-mail",
            PHONE: "Numéro de téléphone",
            FIRST_NAME: "Prénom",
            LAST_NAME: "Nom de famille",
            PROFILE_BUILDER: "Constructeur de profil",
            USER_TYPES: "Types d'utilisateurs",
            LOCATIONS: "Lieux"
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Votre compte a été connecté avec succès à Stripe.",
        FAILED_TO_CONECT: "Un problème est survenu lors de la connexion de votre compte à Stripe, veuillez réessayer ou contacter Enginehire.",
        MISSING_INFO: "Votre compte a été connecté mais il manque des informations sur l'application Stripe, veuillez cliquer sur le bouton se connecter à Stripe pour continuer là où vous vous étiez arrêté"
    },
    DATA_TABLE: {
        SHOW: "Afficher",
        ITEMS_PER_PAGE: "éléments par page",
        SHOWING_RANGE: "Affichage de {0} à {1} entrées sur {2}"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Administrateur",
            PROFILE: "Profil",
            INTAKE_NOTES: "Notes d'admission",
            COMMUNICATION_LOG: "Journal des communications",
            INTAKE_NOTES_MOBILE: "Notes",
            COMMUNICATION_LOG_MOBILE: "Com"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profil",
            NOTES: "Remarques"
        },
        BUTTONS: {
            DELETE_CLIENT: "Supprimer le client"
        }
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Administrateur",
            PROFILE: "Profil",
            INTERVIEW: "Entretien",
            COMMUNICATION_LOG: "Journal des communications",
            RECORDS: "Enregistrements",
            COMMUNICATION_LOG_MOBILE: "Com"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profil",
            INTERVIEW: "Entretien"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Supprimer le candidat"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Types",
            BUTTON: "Enregistrer les types"
        },
        CHECKLIST: {
            TITLE: "Liste de contrôle",
            BUTTON: "Enregistrer la liste de contrôle"
        },
        TAGS: {
            TITLE: "Gestionnaire de balises",
            BUTTON: "Enregistrer les balises"
        },
        LOCATIONS: {
            TITLE: "Lieux",
            BUTTON: "Enregistrer les positions"
        },
        LANGUAGE: {
            TITLE: "Langue",
            BUTTON: "Enregistrer la langue"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Type de profil",
            BUTTON: "Mettre à jour le générateur de profil"
        },
        NOTES: {
            TITLE: "Remarques",
            DESCRIPTION: "Les notes prises ici sont réservées à l'usage interne de l'administrateur, elles ne sont pas visibles pour les utilisateurs.",
            BUTTON: "Ajouter une note"
        },
        EMAIL: {
            TITLE: "Envoyer un e-mail",
            BUTTON_SEND: "Envoyer",
            BUTTON_LOAD: "Charger",
            SELECT_TEMPLATE: "Sélectionner un modèle",
            FROM_EMAIL: "Depuis un e-mail"
        },
        SMS: {
            TITLE: "Envoyer des SMS",
            BUTTON: "Envoyer"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "Vous pouvez réinitialiser manuellement le mot de passe de l'utilisateur ici",
            BUTTON: "Mettre à jour le mot de passe"
        },
        EVENT: {
            TITLE: "Planifier un événement (entretien, réunion, etc.)",
            DESCRIPTION: "Ces événements apparaîtront dans le tableau de bord de l'utilisateur.",
            EVENT_TITLE: "Titre de l'événement",
            EVENT_DATE: "Date de l'événement",
            EVENT_TIME: "Heure de l'événement",
            INTERVIEW_LINK: "Lien de l'entretien",
            INTERVIEW_LINK_PLACE_HOLDER: "Lien Zoom ou autre lien d'appel",
            NOTES: "Remarques",
            STATUS_UPDATE_TO: "Statut vers lequel mettre à jour l'utilisateur",
            SEND_EMAIL_NOTIFICATION: "Envoyer une notification par e-mail de l'événement en cours de planification",
            ADD_TO_CALENDAR: "Ajouter au calendrier personnel des tâches",
            BUTTON: "Planifier un événement"
        },
        CREDIT: {
            TITLE: "Crédits",
            BUTTON_ADD: "Ajouter un crédit",
            BUTTON_EDIT: "Modifier",
            EDIT_CREDIT_TITLE: "Modifier le crédit",
            PLACE_HOLDERS: {
                VALUE: "Valeur",
                NOTES: "Remarques"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Vous pouvez facturer manuellement les clients via Stripe ici",
            SEND_INVOICE: "Vous pouvez envoyer manuellement des factures Stripe ici",
            BUTTON_CHARGE: "Charger via Stripe",
            BUTTON_RESET: "Réinitialiser les informations de bande",
            BUTTON_INVOICE: "Facture via Stripe",
            PAYMENT_LOGS: "Journaux de paiement"
        },
        REVIEW: {
            TITLE: "Commentaires",
            RATING: "Note",
            AVERAGE_RATING: "Note moyenne",
            NO_DATA: "Aucun avis pour le moment."
        },
        ADD_DOCUMENT: {
            TITLE: "Ajouter un document",
            DESCRIPTION: "Vous pouvez ajouter n'importe quel mod\xE8le de document \xE0 l'utilisateur \xE0 partir d'ici, s\xE9lectionnez-en un\n            de vos documents dans le menu d\xE9roulant\xA0:",
            BUTTON: "Ajouter un document"
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Candidats désignés",
                NO_CANDIDATE: "Aucun candidat n'a été associé à ce client."
            },
            CLIENT: {
                TITLE: "Clients assignés",
                NO_CLIENT: "Aucun client n'a été lié à ce candidat."
            },
            ADD_CANDIDATE: "Ajouter un candidat"
        },
        LAST_CONTACTED_DATE: "Dernière contactée"
    },
    COMMUNICATION: {
        DATE: "Date",
        FROM: "De",
        TO: "À",
        SUBJECT: "Objet",
        MESSAGE: "Message",
        RE_SEND: "Renvoyer"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Rechercher par intitulé de poste, ID de poste, horaire, ville, état ou description",
        JOB_HIDEN_DESCRIPTION: "Les offres d'emploi au statut \"Brouillon\", \"Ferm\xE9\" ou \"Compl\xE9t\xE9\" n'apparaissent pas sur l'offre\n        board par d\xE9faut. Pour mettre \xE0 jour le statut d'une t\xE2che, cliquez sur \"Modifier la t\xE2che\".",
        CLIENT_POSTING_JOB_DESCRIPTION: "Ceci est pour publier des postes à plus long terme pour ce client."
    },
    CONFIRM_DIALOGS: _fr2.default,
    ERROR_DIALOGS: _fr4.default,
    RESULT_DIALOGS: _fr6.default
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this reference?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this experience?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this contact?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this education?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this child?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this pet?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this booking?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile builder {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this request?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this job?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this application?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the document {0}?',
        ACCEPT_LABEL: 'Delete Document',
        REJECT_LABEL: 'Close'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the file?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Close'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} template {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0} {1}</p>\n        <p>{2}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel this booking?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close? Any changes will be lost.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your changes?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile picture?',
        ACCEPT_LABEL: 'Delete Picture',
        REJECT_LABEL: 'Close'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove the link between {0} and this client?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'You are committing to filling this job, are you sure?',
        ACCEPT_LABEL: 'Accept Job',
        REJECT_LABEL: 'Close'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark {0} as favorite?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you do not want {0} again?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete the note?</h3>\n        <p style="white-space: pre-wrap;">{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this credit?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    }
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requiredValues = __webpack_require__(58);

exports.default = {
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: "Campo ausente para endereço de e-mail",
        MESSAGE: "Por favor, adicione pelo menos 1 campo para o endereço de e-mail!"
    },
    INVALID_INPUT_ERROR: {
        TITLE: "Um campo obrigatório está faltando ou um campo é inválido.",
        MESSAGE: "Por favor, reveja o formulário para mensagens de erro!"
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Booking time is missing',
        MESSAGE: 'Please add booking time (Start Time and End Time)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'A document is not signed',
        MESSAGE: 'Please review the form for error messages and sign all documents!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'An input field is invalid',
        MESSAGE: 'There is an input field which is invalid'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'There is no field for the builder',
        MESSAGE: 'Please add at least one field!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'Cannot use same option between {0} and {1}',
        MESSAGE: 'Please unselect option(s) {2} in {0} or {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: 'Please add more {0}!',
        MESSAGE: 'You must have at least {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Experience is lacking',
        MESSAGE: 'You must have at least 1 experience.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Statuses is lacking',
        MESSAGE: _requiredValues.LIST_REQUIRED_STATUSES.join(" and ") + " are required statuses"
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some statuses which are duplicated'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Multi fields using the same model',
        MESSAGE: 'There is a model which is assigned to at least 2 fields'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some items which are duplicated'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'Employer type is duplicated',
        MESSAGE: 'There are some employer type which are duplicated'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'Candidate type is duplicated',
        MESSAGE: 'There are some candidate type which are duplicated'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a PNG or JPG image.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a DOC or DOCX or PDF file.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: 'File is empty!',
        MESSAGE: 'Please upload a non empty file'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: 'File too big!',
        MESSAGE: 'Please upload a file with a size below the maximum upload size.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Invalid File',
        MESSAGE: 'Invalid input file'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Your professional childcare resume is missing',
        MESSAGE: 'Please upload your professional childcare resume'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'End date must be after start date',
        MESSAGE: 'Please change start date or end date'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Bookings must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Your profile picture is missing',
        MESSAGE: 'Please upload a recent photo of yourself!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'No text selected',
        MESSAGE: 'Please select some text'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Your application has been submitted! BUT',
        MESSAGE: 'There was an error processing your references. Can you please email them to us? Thanks!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Failed to submit your application',
        MESSAGE: 'There was an error processing your application'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Missing item in status list',
        MESSAGE: 'Status {0} is required'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'There is an incomplete section',
        MESSAGE: 'Section {0} is incomplete. Please update that section'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Passwords do not match.'
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'Unable to find nearby Candidates',
        MESSAGE: 'Job is missing a full address. To search for candidates Edit Job and fill missing address info'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'The profile builder is in used',
        MESSAGE: 'The profile builder is being used by the profile builder {0}.\n' + 'Please remove that profile builder first'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'A signature is missing',
        MESSAGE: 'Please type your name to sign'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'A required field is missing',
        MESSAGE: 'Please fill all of the required fields (Please check the red border fields)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: "\n        <h2>It looks like you are already in our system!</h2>\n        <h4 class=\"error-message main-message\">\n        Please <a href='{0}/login/{1}'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!\n        </h4>\n        "
    }
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Thank you for your application to join our team!',
        MESSAGE: 'We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITRE: 'Merci pour vos informations !',
        MESSAGE: "Les informations de référence que vous avez fournies sont très importantes pour nous. Vous pouvez fermer cette fenêtre en toute sécurité maintenant."
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: '\n        <h2>Thank you for submitting your registration!</h2>\n        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>\n        '
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Thanks for letting us know, we will be in touch with you shortly!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: '\n        <h2>Video is uploaded successfully!</h2>\n        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class="material-icons" style=\'position: absolute;\'>refresh</i>&nbsp;&nbsp;) button</h5>\n        '
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Section Saved',
        MESSAGE: 'Saved {0} section!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Family Form Updated',
        MESSAGE: 'Updated Family Form successfully'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Status updated.'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Broadcast sent!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
        MESSAGE: 'Please proceed to the client and candidate notification.'
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Job updated!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: 'Job created!'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client charged and job status updated!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Message sent.'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Password has been reset successfully.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been saved successfully.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been deleted successfully.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documents uploaded.',
        MESSAGE: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Your document has been signed.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Your document has been saved.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'The additional information of the document {0} is updated'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Template created.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Template updated'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Template deleted'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Template duplicated.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Password reset',
        MESSAGE: 'Password reset to {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Profile builder updated'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Email footer is saved'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Notification settings saved'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Additional admin settings saved'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Manager updated.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrator added'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrator updated'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrator deleted'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Locations updated'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Language updated'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Broadcast sent to {0} candidates!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Job views',
        MESSAGE: 'Number of times viewed: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: 'Blast Off!',
        MESSAGE: "Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: 'Note saved!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} saved, please add another one!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Thanks for letting us know!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Congrats, you've accepted this job!",
        MESSAGE: 'All the details will appear in your dashboard under "My Jobs".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'Visibility scope of the {0} is updated to {1}'
    },
    CHECK_FORM_UPDATED: {
        TITLE: '{0} check form is updated'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Changes Saved!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Price Created.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Price Updated.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Price Deleted.'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Offer Updated!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for leaving a review!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Marked as favorite!',
        MESSAGE: 'We will do our best to match you with them in the future.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Thank you for letting us know.',
        MESSAGE: 'We will do our best to connect you with others in the future'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for submitting your payment information!'
    }
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _de = __webpack_require__(682);

var _de2 = _interopRequireDefault(_de);

var _de3 = __webpack_require__(683);

var _de4 = _interopRequireDefault(_de3);

var _de5 = __webpack_require__(684);

var _de6 = _interopRequireDefault(_de5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Absenden",
        PREVIOUS: "Zurück",
        NEXT: "Weiter",
        VIEW: "Ansicht",
        UPLOAD: "Hochladen",
        CLOSE: "Schließen",
        DELETE: "Löschen",
        CANCEL: "Abbrechen",
        YES: "Ja",
        NO: "Nein",
        OK: "OK"
    },
    OPTIONS: {
        YES: "Ja",
        NO: "Nein"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Dieses Feld ist erforderlich."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Wird verarbeitet, bitte warten...",
        STEP_OF: "Schritt {0} von {1}"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Eine Datei hier ablegen oder zum Hochladen klicken",
        MAXIMUM_UPLOAD_SIZE: "Maximale Uploadgröße {0}MB",
        FILE_EXCEED_MAXIMUM: "Dateigröße überschreitet {0}MB.",
        FILE: "Datei"
    },
    BOOKING_DIALOG: {
        LABEL: {
            START_TIME: "Startzeit",
            END_TIME: "Endzeit",
            END_DATE: "Enddatum",
            SELECT_CLIENT: "Client auswählen",
            ASSIGNED_CANDIDATE: "Möchten Sie diesen Job zuweisen?",
            REPEAT: "Wiederholen?",
            REPEAT_UNTIL: "Wiederholen bis",
            REPEAT_EVERY: "Alle wiederholen",
            REPEAT_ON: "Wiederholen ein",
            BOOKING_ADDRESS: "Buchungsadresse",
            ADDRESS_LINE2: "Adresszeile 2",
            CITY: "Stadt",
            STATE: "Staat",
            ZIP_CODE: "Postleitzahl",
            NUMBER_CHILDREN: "Wie viele Kinder werden betreut?",
            SELECT_JOB_CATEGORY: "Jobkategorie auswählen"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Tage", "Wochen"],
            REPEAT_ON: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"]
        }
    },
    CONFIRM_DIALOGS: _de2.default,
    ERROR_DIALOGS: _de4.default,
    RESULT_DIALOGS: _de6.default
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this reference?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this experience?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this contact?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this education?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this child?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this pet?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this booking?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile builder {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this request?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this job?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this application?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the document {0}?',
        ACCEPT_LABEL: 'Delete Document',
        REJECT_LABEL: 'Close'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the file?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Close'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} template {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the {0} {1}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0} {1}</p>\n        <p>{2}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete this user?</h3>\n        <p>{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove {0}?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to cancel this booking?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to close? Any changes will be lost.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure of your changes?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to change the status of the {0} selected users? Their status will be changed to {1}.',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'There is a recorded video. If you record new video, the existed video will be overwritten. Are you sure to continue?',
        ACCEPT_LABEL: 'Continue',
        REJECT_LABEL: 'Cancel'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete the profile picture?',
        ACCEPT_LABEL: 'Delete Picture',
        REJECT_LABEL: 'Close'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to remove the link between {0} and this client?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'You are committing to filling this job, are you sure?',
        ACCEPT_LABEL: 'Accept Job',
        REJECT_LABEL: 'Close'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to mark {0} as favorite?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you do not want {0} again?',
        ACCEPT_LABEL: 'Yes',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>Are you sure you want to delete the note?</h3>\n        <p style="white-space: pre-wrap;">{0}</p>',
        ACCEPT_LABEL: "Delete",
        REJECT_LABEL: "Cancel"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Are you sure you want to delete this credit?',
        ACCEPT_LABEL: 'Delete',
        REJECT_LABEL: 'Cancel'
    }
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requiredValues = __webpack_require__(58);

exports.default = {
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: 'Missing field for Email Address',
        MESSAGE: 'Please add at least 1 field for email address!'
    },
    INVALID_INPUT_ERROR: {
        TITLE: 'A required field is missing or a field is invalid.',
        MESSAGE: 'Please review the form for error messages!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Booking time is missing',
        MESSAGE: 'Please add booking time (Start Time and End Time)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'A document is not signed',
        MESSAGE: 'Please review the form for error messages and sign all documents!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'An input field is invalid',
        MESSAGE: 'There is an input field which is invalid'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'There is no field for the builder',
        MESSAGE: 'Please add at least one field!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'Cannot use same option between {0} and {1}',
        MESSAGE: 'Please unselect option(s) {2} in {0} or {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: 'Please add more {0}!',
        MESSAGE: 'You must have at least {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Experience is lacking',
        MESSAGE: 'You must have at least 1 experience.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Statuses is lacking',
        MESSAGE: _requiredValues.LIST_REQUIRED_STATUSES.join(" and ") + ' are required statuses'
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some statuses which are duplicated'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Multi fields using the same model',
        MESSAGE: 'There is a model which is assigned to at least 2 fields'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Statuses is duplicated',
        MESSAGE: 'There are some items which are duplicated'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'Employer type is duplicated',
        MESSAGE: 'There are some employer type which are duplicated'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'Candidate type is duplicated',
        MESSAGE: 'There are some candidate type which are duplicated'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a PNG or JPG image.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: 'Sorry, that file type is invalid!',
        MESSAGE: 'Please upload a DOC or DOCX or PDF file.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: 'File is empty!',
        MESSAGE: 'Please upload a non empty file'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: 'File too big!',
        MESSAGE: 'Please upload a file with a size below the maximum upload size.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Invalid File',
        MESSAGE: 'Invalid input file'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Your professional childcare resume is missing',
        MESSAGE: 'Please upload your professional childcare resume'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'End date must be after start date',
        MESSAGE: 'Please change start date or end date'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'End time must be after start time',
        MESSAGE: 'Please change start time or end time'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Bookings must be at least {0} hours.',
        MESSAGE: 'Please change start time or end time'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Your profile picture is missing',
        MESSAGE: 'Please upload a recent photo of yourself!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'No text selected',
        MESSAGE: 'Please select some text'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Your application has been submitted! BUT',
        MESSAGE: 'There was an error processing your references. Can you please email them to us? Thanks!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Failed to submit your application',
        MESSAGE: 'There was an error processing your application'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Missing item in status list',
        MESSAGE: 'Status {0} is required'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'There is an incomplete section',
        MESSAGE: 'Section {0} is incomplete. Please update that section'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Passwords do not match.'
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'Unable to find nearby Candidates',
        MESSAGE: 'Job is missing a full address. To search for candidates Edit Job and fill missing address info'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'The profile builder is in used',
        MESSAGE: 'The profile builder is being used by the profile builder {0}.\n' + 'Please remove that profile builder first'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'A signature is missing',
        MESSAGE: 'Please type your name to sign'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'A required field is missing',
        MESSAGE: 'Please fill all of the required fields (Please check the red border fields)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: '\n        <h2>It looks like you are already in our system!</h2>\n        <h4 class="error-message main-message">\n        Please <a href=\'{0}/login/{1}\'>log into your dashboard</a> to continue, or contact us if you have questions. Thank you!\n        </h4>\n        '
    }
};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Thank you for your application to join our team!',
        MESSAGE: 'We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Thank you for your information!',
        MESSAGE: 'The reference information you submitted is very important for us. You can safely close this window now.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: '\n        <h2>Thank you for submitting your registration!</h2>\n        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>\n        '
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Thanks for letting us know, we will be in touch with you shortly!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: '\n        <h2>Video is uploaded successfully!</h2>\n        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class="material-icons" style=\'position: absolute;\'>refresh</i>&nbsp;&nbsp;) button</h5>\n        '
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Section Saved',
        MESSAGE: 'Saved {0} section!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Family Form Updated',
        MESSAGE: 'Updated Family Form successfully'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Status updated.'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Broadcast sent!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
        MESSAGE: 'Please proceed to the client and candidate notification.'
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Job updated!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: 'Job created!'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client charged and job status updated!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Message sent.'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Password has been reset successfully.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been saved successfully.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been deleted successfully.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documents uploaded.',
        MESSAGE: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Your document has been signed.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Your document has been saved.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'The additional information of the document {0} is updated'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Template created.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Template updated'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Template deleted'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Template duplicated.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Password reset',
        MESSAGE: 'Password reset to {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Profile builder updated'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Email footer is saved'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Notification settings saved'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Additional admin settings saved'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Manager updated.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrator added'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrator updated'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrator deleted'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Locations updated'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Language updated'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Broadcast sent to {0} nannies!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Job views',
        MESSAGE: 'Number of times viewed: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: 'Blast Off!',
        MESSAGE: "Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: 'Note saved!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} saved, please add another one!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Thanks for letting us know!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Congrats, you've accepted this job!",
        MESSAGE: 'All the details will appear in your dashboard under "My Jobs".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'Visibility scope of the {0} is updated to {1}'
    },
    CHECK_FORM_UPDATED: {
        TITLE: '{0} check form is updated'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Changes Saved!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Price Created.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Price Updated.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Price Deleted.'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Offer Updated!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for leaving a review!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Marked as favorite!',
        MESSAGE: 'We will do our best to match you with them in the future.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Thank you for letting us know.',
        MESSAGE: 'We will do our best to connect you with others in the future'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for submitting your payment information!'
    }
};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _es = __webpack_require__(686);

var _es2 = _interopRequireDefault(_es);

var _es3 = __webpack_require__(687);

var _es4 = _interopRequireDefault(_es3);

var _es5 = __webpack_require__(688);

var _es6 = _interopRequireDefault(_es5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Enviar",
        PREVIOUS: "Anterior",
        NEXT: "Siguiente",
        VIEW: "Ver",
        UPLOAD: "Subir",
        UPLOAD_FILE: "Subir archivo",
        VIEW_FILE: "Ver archivo",
        DELETE_FILE: "Eliminar archivo",
        CLOSE: "Cerrar",
        DELETE: "Eliminar",
        CANCEL: "Cancelar",
        YES: "Sí",
        NO: "No",
        OK: "Está bien",
        ADD: "Agregar",
        UPDATE_STATUS: "Estado de actualización",
        RETURN_DASHBOARD: "Volver al panel",
        REFRESH: "Actualizar",
        BULK_UPDATE_STATUS: "Actualizar estado de seleccionado",
        BULK_UPDATE_LOCATIONS: "Actualizar ubicaciones de seleccionados",
        BULK_UPDATE: "Actualización masiva",
        CHARGE_THROUGH_AUTHORIZE_NET: "Cobro a través de Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Carga a través de banda",
        INVOICE_THROUGH_STRIPE: "Factura a través de Stripe",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Cargar cliente y candidato de pago",
        BULK_DELETE: "Eliminar seleccionado",
        BULK_UNASSIGNED: "Desasignar seleccionado",
        EXPORT_EMPLOYERS: "Exportar lista de correo de clientes",
        EXPORT_CANDIDATES: "Exportar lista de distribución de candidatos",
        UPDATE_MANAGER: "Administrador de actualizaciones",
        VIEW_PROFILE: "Ver perfil",
        VIEW_OFFER: "Ver oferta",
        SAVE: "Guardar",
        EXPAND_ALL: "Expandir todo",
        COLLAPSE_ALL: "Contraer todo",
        SELECT_ALL: "Seleccionar todo",
        UNSELECT_ALL: "Deseleccionar todo",
        RESET_FILTERS: "Restablecer filtros",
        CLOCK_IN: "Reloj de entrada",
        ADD_A_BREAK: "Agregar un descanso",
        CLOCK_OUT: "Reloj de salida",
        CONFIRM_CLOCK_IN_OUT: "Confirmación del cliente",
        LEAVE_REVIEW: "Dejar una reseña",
        DECLINE: "Rechazar",
        DECLINE_WITHOUT_NOTIFICATION: "Rechazar sin notificación",
        UNDECLINE: "No declive",
        ACCEPT: "Aceptar",
        CHECK_PAYMENT: "Expresión de cheque de pago",
        ASSIGN: "Asignar",
        TENTATIVELY_ASSIGN: "Asignar tentativamente",
        SIGN: "Firmar",
        EDIT: "Editar",
        DUPLICATE: "Duplicado",
        ADD_A_BOOKING: "Añadir una Reserva",
        ADD_A_GROUP: "Agregar un grupo"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Nuevo Estado",
        NEW_LOCATIONS: "Nuevas ubicaciones",
        FILTER_BY_STATUS: "Filtrar por estado",
        FILTER_BY_STATUSES: "Filtrar por Estados",
        STATUSES_TO_HIDE: "Estados para Ocultar",
        FILTER_BY_LOCATIONS: "Filtrar por Ubicaciones",
        FILTER_BY_TYPES: "Filtrar por Tipos",
        FILTER_BY_MANAGER: "Filtrar por Gerente",
        FILTER_BY_CATEGORIES: "Filtrar por Categorías",
        FILTER_BY_START_DATE: "Filtrar por fecha de inicio",
        FILTER_BY_END_DATE: "Filtrar por fecha de finalización",
        FILTER_BY_WEEK_DAY: "Filtrar por día de la semana",
        FILTER_BY_CLIENTS: "Filtrar por Clientes",
        FILTER_BY_CLIENT_STATUSES: "Filtrar por Estados del Cliente",
        FILTER_BY_CLIENT_TYPES: "Filtrar por tipos de clientes",
        FILTER_BY_CANDIDATES: "Filtrar por candidato(s)",
        FILTER_BY_JOB_TYPES: "Filtrar por tipos de trabajo",
        FILTER_BY_JOB_STATUSES: "Filtrar por estado de trabajo",
        FILTER_BY_JOB_ID: "Filtrar por ID de trabajo",
        SELECT_SCRAPER_ACCOUNTS: "Sélectionnez les comptes Scraper",
        FILTER_BY_USER_TYPE: "Filtrar por tipo de usuario",
        KEYWORD_SEARCH_USER_PROFILE: "Busque la palabra clave/frase en cualquier parte del perfil de usuario, presione Intro para aplicar la búsqueda",
        SEARCH_BY_NAME_EMAIL_PHONE: "Buscar por nombre, correo electrónico o número de teléfono",
        FILTER_BY_RECENT_ACTIVE: "Filtrar por activos recientes",
        SELECT_LOCATIONS: "Seleccionar ubicaciones",
        SELECT_OPTION: "Seleccionar opción",
        SELECT_CLIENT: "Seleccionar Cliente",
        SELECT_CANDIDATE: "Seleccionar candidato",
        SELECT_CANDIDATES: "Seleccionar candidatos",
        SELECT_CANDIDATE_SEARCHABLE: "Seleccionar Candidato (Escribir para buscar)",
        SELECT_ADMINS: "Seleccionar administradores",
        SELECT_ADMIN_RECEIVE_EMAIL: "Seleccionar administradores que reciben correos electrónicos",
        SELECT_STATUS: "Seleccionar Estado",
        SELECT_LANGUAGES: "Seleccionar idiomas",
        SELECT_TYPES: "Seleccionar tipos",
        SELECT_TYPE: "Seleccionar tipo",
        SELECT_USER_TYPE: "Seleccionar tipo de usuario",
        SELECT_USER_TYPES: "Seleccionar tipos de usuarios",
        SELECT_CATEGORY: "Seleccionar categoría",
        SELECT_CATEGORY_ADMIN_ONLY: "Seleccionar categoría (solo administrador)",
        SELECT_TRIGGER: "Seleccionar disparador",
        SELECT_ONE: "Seleccionar uno",
        SELECT_PROFILE_BUILDER: "Seleccionar Creador de perfiles",
        SELECT_TIME_OFF_CATEOGRY: "Seleccionar categoría de tiempo libre",
        SELECT_DESTINATION: "Seleccionar destino",
        SELECT_ACCESS_LEVEL: "Seleccionar nivel de acceso",
        SELECT_VISIBILITY_SCOPE: "Seleccionar alcance de visibilidad",
        SELECT_AREAS: "Seleccionar Áreas",
        NUMBER: "Número",
        DESCRIPTION_CHARGE: "Descripción del cargo"
    },
    LABELS: {
        SELECT_TEMPLATE: "Seleccionar plantilla",
        FILTER_BY_LOCATIONS: "Filtrar por Ubicaciones",
        FILTER_BY_TYPES: "Filtrar por Tipos",
        FILTER_BY_MANAGER: "Filtrar por Gerente",
        FILTER_BY_CATEGORIES: "Filtrar por Categorías",
        FILTER_BY_STATUS: "Filtrar por estado",
        ADDRESS: "Dirección",
        CITY: "Ciudad",
        STATE: "Estado",
        COUNTRY: "País",
        ZIP_CODE: "Código postal",
        LOCATIONS: "Ubicaciones",
        DESCRIPTION: "Descripción",
        PER_HOUR: "por hora"
    },
    HEADERS: {
        EMAIL_LOG: "Registro de correo electrónico",
        SMS_LOG: "Registro de SMS"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Cómo ocultar estados por defecto",
        HOW_TO_CHANGE_STATUS: "Cómo agregar/cambiar estados"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Separar varios correos electrónicos con ; (p. ej.: nanny1@hotmail.com; nanny2@hotmail.com)",
        SMS_NOTE: "Tenga en cuenta que hay un costo de $0.0115 (1.15\xA2) por SMS.",
        CLIENT_NOT_ENTERED_STRIPE: "El cliente no ha ingresado la información de Stripe.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "El cliente no ha ingresado la información de Authorize.Net.",
        CANDIDATE_NOT_ENTERED_STRIPE: "El candidato no ha ingresado la información de Stripe",
        INTERVIEW_PANEL: "Nota: estas notas son solo para uso del administrador interno y no son\n        compartido con candidatos o clientes.",
        CANDIDATE_SHAREABLE_LINK: "Este es un enlace para compartir del perfil del candidato. Si tu quieres\n        para ver lo que ver\xE1 un cliente, <strong>aseg\xFArese de cerrar la sesi\xF3n</strong> y luego\n        ver el enlace (o abrirlo en un navegador diferente). Este <strong>no</strong> es un enlace para que su candidato inicie sesi\xF3n. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">M\xE1s informaci\xF3n</a>",
        CLIENT_SHAREABLE_LINK: "Este es un enlace para compartir del perfil del cliente. Si quieres\n        ver lo que ver\xE1 un candidato, <strong>aseg\xFArese de cerrar la sesi\xF3n</strong> y luego\n        ver el enlace (o abrirlo en un navegador diferente). Este <strong>no</strong> es un enlace para que sus clientes inicien sesi\xF3n. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">M\xE1s informaci\xF3n</a>"
    },
    TABLE_HEADERS: {
        ACTIONS: "Acciones",
        NOTES: "Notas",
        VALUE: "Valor",
        EFFECTIVE_FROM: "Efectivo desde",
        EFFECTIVE_UNTIL: "Efectivo hasta",
        TYPE: "Tipo"
    },
    OPCIONES: {
        "YES": "Sí",
        "NO": "No"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Este campo es obligatorio"
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "¡Gracias!",
        STEP_OF: "Paso {0} de {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Por favor, ayúdenos a completar el formulario a continuación",
        REFERENCE_FOR: "Referencia para {0} {1}",
        REFERENCE_INPUT_BY: "Información de referencia ingresada por {0} {1}",
        FORM_SUBMITTED: "¡El formulario de verificación de referencia ha sido enviado!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Soltar un archivo aquí o hacer clic para cargar",
        MAXIMUM_UPLOAD_SIZE: "Tamaño máximo de carga {0} MB",
        FILE_EXCEED_MAXIMUM: "El tamaño del archivo supera los {0} MB.",
        FILE: "Archivo"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Reservas",
            HIDE_PAST_BOOKINGS: "Ocultar reservas anteriores",
            BOOKING_CREDIT_LEFT: "Quedan {0} créditos de reserva",
            MIN_BOOKINGS_REQUIRE: "¡Necesitas al menos {0} reservas!",
            SELECTED_CANDIDATE: "Candidato seleccionado",
            TOTAL_BOOKING_FEE: "Tarifa de reserva total",
            BOOKING_GROUPS: "Reservar Grupos"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Haga clic en la reserva (en el calendario) para obtener más información sobre su proveedor de servicios asignado y dejar una reseña",
            CLICK_ON_DATE: "Haga clic en una fecha para agregar una reserva.",
            CLICK_ON_OTHER_DATE: "Haga clic en otra fecha en el calendario para agregar una reserva",
            BOOKING_GROUP: "Todas las reservas en el mismo grupo deben asignarse a un asignado"
        },
        PRICES: {
            BOOKING_RATE: "Tarifa de reserva",
            BOOKING_FEE: "Tarifa de reserva",
            PER_BOOKING_FEE: "Por tarifa de reserva",
            CLIENT_RATE: "Tarifa Cliente",
            CANDIDATE_RATE: "Tarifa de candidato",
            AGENCY_FEE: "Tarifa de agencia",
            TRAVEL_FEE: "Tarifa de viaje",
            RUSH_FEE: "Tarifa urgente",
            CANDIDATE_RUSH_FEE: "Tarifa urgente de candidato",
            PER_BOOKING_AGENCY_FEE: "Tarifa por agencia de reservas",
            PER_BOOKING_CANDIDATE_FEE: "Tarifa de candidato por reserva",
            ADMIN_FEE: "Tarifa administrativa",
            ADDITIONAL_FEES: "Tarifas adicionales"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            START_TIME: "Hora de inicio",
            END_TIME: "Hora de finalización",
            END_DATE: "Fecha de finalización",
            SELECT_CLIENT: "Seleccionar Cliente",
            ASSIGNED_CANDIDATE: "¿Desea asignar este trabajo?",
            TENTATIVELY_ASSIGN_CANDIDATE: "¿Desea asignar provisionalmente este trabajo?",
            REPEAT: "¿Quieres este servicio más de una vez (repetitivo/recurrente)?",
            REPEAT_UNTIL: "Repetir hasta",
            REPEAT_EVERY: "Repetir cada",
            REPEAT_ON: "Repetir en",
            BOOKING_ADDRESS: "Dirección de reserva",
            ADDRESS_LINE2: "Línea de dirección 2",
            CITY: "Ciudad",
            STATE: "Estado/Provincia",
            ZIP_CODE: "Código postal",
            NUMBER_CHILDREN: "¿Cuántos niños se cuidarán?",
            SELECT_JOB_CATEGORY: "Seleccionar categoría de trabajo",
            SELECT_DATE: "Fecha de reserva",
            SELECT_SERVICE: "Seleccionar servicio"
        },
        OPCIONES: {
            REPEAT_TYPE: ["Días", "Semanas"],
            REPEAT_ON: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"]
        }
    },
    MENU_BAR: {
        TOP: {
            MESSAGES: "Mensajes",
            SMS: "SMS",
            JOBS: "Trabajos",
            LOGOUT: "Cerrar sesión",
            DASHBOARD: "Mi panel de control"
        },
        ADMIN: {
            USERS: {
                ROOT: "Usuarios",
                CLIENTS: "Clientes",
                CANDIDATES: "Candidatos",
                ADMINISTRATORS: "Administradores"
            },
            JOBS_EVENTS: {
                ROOT: "Trabajos y Calendario",
                SHIFT_JOB_CALENDAR: "Calendario de trabajo por turnos",
                PLACEMENT_JOBS: "Trabajos de colocación",
                PERSONAL_TO_DO: "Personal para hacer"

            },
            TEMPLATES: {
                ROOT: "Plantillas",
                EMAIL: "Plantillas de correo electrónico",
                SMS: "Plantillas de SMS",
                DOCUMENT: "Plantillas de documentos",
                NOTE: "Plantillas de notas",
                PROFILE: "Plantillas de perfil"
            },
            AÑADIR_CLAVE_RANDOM_AJUSTES: {
                ROOT: "Configuración",
                AGENCY: "Configuración de la agencia",
                ADMIN: "Configuración de administrador"
            },
            BUILDERS: {
                ROOT: "Constructores",
                PROFILE: "Generador de perfiles",
                EVALUATION: "Generador de evaluación"
            },
            LOGS: {
                ROOT: "Registros",
                COMMUNICATION_LOG: "Registro de comunicación",
                STATUS_CHANGES: "Cambios de estado",
                ACTIVITY_LOG: "Registro de actividad",
                PAYMENT_LOG: "Registro de pagos"
            },
            OTHERS: {
                ROOT: "Otros",
                RESOURCE_MANAGER: "Administrador de recursos",
                REFERENCES: "Referencias",
                DOCUMENTS: "Documentos",
                EMAIL_BLASTER: "Blaster de correo electrónico",
                NOTIFICATION_CENTER: "Centro de notificaciones",
                SNAPSHOT: "Instantánea",
                COMMUNITY: "Comunidad"
            }

        },
        CANDIDATOS: {
            MY_PROFILE: "Mi perfil",
            AVAILABLE_JOBS: "Trabajos disponibles",
            MY_SCHEDULE: "Mi horario",
            MY_JOBS: "Mis trabajos",
            MY_FAMILIES: "Mis familias"
        }
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Conceptos básicos del generador de perfiles",
            REQUIRE_FIELD: "Cómo marcar preguntas/campos como obligatorios o no",
            NOTIFICATION_DESTINATION: "Editar a quién se notifican los nuevos solicitantes",
            EDIT_APPLICATION: "C\xF3mo editar formularios de solicitud m\xE1s f\xE1cilmente",
            ADD_SECTION_QUESTION: "Cómo agregar una pregunta a una sección",
            ADD_CONFIRMATION_BOX: "Cómo agregar campos de confirmación en los formularios de solicitud"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Primeros pasos con las evaluaciones"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Primeros pasos con las plantillas de correo electrónico",
            DEFAULT_EMAIL_FOOTER: "Configuración de su pie de página de correo electrónico predeterminado"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Primeros pasos con las plantillas de documentos",
            NOTIFICATION_WHEN_SIGNED: "Agregar notificación cuando se firma el documento",
            ADD_DOCUMENT: "Agregar manualmente un documento a un usuario"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Mapeo de su proceso a través de estados, listas de verificación y tipos",
            AGENCY_BRANDING_SETUP: "Configuración de la marca de la agencia (logotipo, colores, fuentes)",
            PROFILE_COMPLETE_SETUP: "C\xF3mo agregar un bot\xF3n \"Mi perfil est\xE1 completo\" Los candidatos pueden hacer clic para notificarle que han completado su perfil",
            CONFIGURE_MULTIPLE_LOCATIONS: "Configurar su agencia para atender varias ubicaciones distintas"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Cómo funcionan los envíos masivos de correo electrónico"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "Cómo compartir el perfil de una candidata con una cliente."
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Bienvenido a {0} Control de Misión",
        PRO_CONSEJO: {
            HEADER: "Novedades de esta semana:",
            TEXT: "¡Enlaces directos para dejar reseñas!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Ordenar Clientes Por",
            ORDER_CANDIDATES_BY: "Ordenar candidatos por"
        },
        BUTTONS: {
            ADD_CLIENT: "Agregar Cliente",
            ADD_CANDIDATE: "Agregar candidato"
        }
    },
    ADD_USER_DIALOG: {
        HEADER: "Agregar Nuevo Usuario",
        DESCRIPTION: "Este es un mecanismo para agregar manualmente un usuario a su base de datos. Un usuario\n        agregado de esta manera se pondr\xE1 en el estado \"Aplicaci\xF3n previa\"\n         (lo que significa que a\xFAn no han completado un formulario de solicitud). un usuario en\n        este estado todav\xEDa se puede enviar para completar el formulario de solicitud. Si usted\n        le gustar\xEDa enviar autom\xE1ticamente un correo electr\xF3nico a los usuarios agregados de esta manera, usted\n        puede agregar una plantilla de correo electr\xF3nico que sea una \"Notificaci\xF3n de cambio de estado\"\n        triggering en un cambio a \"Aplicaci\xF3n previa\".",
        LABELS: {
            EMAIL: "Correo electrónico",
            PHONE: "Número de teléfono",
            FIRST_NAME: "Nombre",
            LAST_NAME: "Apellido",
            PROFILE_BUILDER: "Generador de perfiles",
            USER_TYPES: "Tipos de Usuario",
            LOCATIONS: "Ubicaciones"
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Su cuenta se ha conectado correctamente con Stripe",
        FAILED_TO_CONECT: "Hubo un problema al conectar su cuenta con Stripe, intente nuevamente o comuníquese con Enginehire",
        MISSING_INFO: "Su cuenta ha sido conectada pero falta información en la aplicación de Stripe, haga clic en el botón de conexión a Stripe para continuar donde lo dejó"
    },
    DATA_TABLE: {
        SHOW: "Mostrar",
        ITEMS_PER_PAGE: "elementos por página",
        SHOWING_RANGE: "Mostrando {0} a {1} de {2} entradas"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Administrador",
            PROFILE: "Perfil",
            INTAKE_NOTES: "Notas de admisión",
            COMMUNICATION_LOG: "Registro de comunicación",
            RECORDS: "Registros",
            INTAKE_NOTES_MOBILE: "Notas",
            COMMUNICATION_LOG_MOBILE: "Comu"
        },
        INTERVIEW_TABS: {
            PROFILE: "Perfil",
            NOTES: "Notas"
        },
        BUTTONS: {
            DELETE_CLIENT: "Eliminar Cliente"
        }
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Administrador",
            PROFILE: "Perfil",
            INTERVIEW: "Entrevista",
            COMMUNICATION_LOG: "Registro de comunicación",
            RECORDS: "Registros",
            COMMUNICATION_LOG_MOBILE: "Com"
        },
        INTERVIEW_TABS: {
            PROFILE: "Perfil",
            INTERVIEW: "Entrevista"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Eliminar candidato"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Tipos",
            BUTTON: "Guardar tipos"
        },
        CHECKLIST: {
            TITLE: "Lista de verificación",
            BUTTON: "Guardar lista de control"
        },
        TAGS: {
            TITLE: "Administrador de etiquetas",
            BUTTON: "Guardar etiquetas"
        },
        LOCATIONS: {
            TITLE: "Ubicaciones",
            BUTTON: "Guardar ubicaciones"
        },
        LANGUAGE: {
            TITLE: "Idioma",
            BUTTON: "Guardar idioma"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Tipo de perfil",
            BUTTON: "Actualizar generador de perfiles"
        },
        NOTAS: {
            TITLE: "Notas",
            DESCRIPTION: "Las notas tomadas aquí son solo para uso interno del administrador, no visibles para los usuarios",
            BUTTON: "Agregar nota"
        },
        EMAIL: {
            TITLE: "Enviar correo electrónico",
            BUTTON_SEND: "Enviar",
            BUTTON_LOAD: "Cargar",
            SELECT_TEMPLATE: "Seleccionar plantilla",
            FROM_EMAIL: "De correo electrónico"
        },
        SMS: {
            TITLE: "Enviar SMS",
            BUTTON: "Enviar"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "Puede restablecer manualmente la contraseña del usuario aquí",
            BUTTON: "Actualizar contraseña"
        },
        EVENT: {
            TITLE: "Programar Evento (Entrevista, Reunión, etc.)",
            DESCRIPTION: "Estos eventos aparecerán en el tablero del usuario.",
            EVENT_TITLE: "Título del evento",
            EVENT_DATE: "Fecha del evento",
            EVENT_TIME: "Hora del evento",
            INTERVIEW_LINK: "Enlace de entrevista",
            INTERVIEW_LINK_PLACE_HOLDER: "Enlace de zoom u otro enlace de llamada",
            NOTES: "Notas",
            STATUS_UPDATE_TO: "Estado para actualizar usuario a",
            SEND_EMAIL_NOTIFICATION: "Enviar notificación por correo electrónico del evento programado",
            ADD_TO_CALENDAR: "Agregar al calendario personal de tareas pendientes",
            BUTTON: "Programar evento"
        },
        CREDIT: {
            TITLE: "Créditos",
            BUTTON_ADD: "Agregar crédito",
            BUTTON_EDIT: "Editar",
            EDIT_CREDIT_TITLE: "Editar crédito",
            PLACE_HOLDERS: {
                VALUE: "Valor",
                NOTES: "Notas"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Puede facturar manualmente a los clientes a través de Stripe aquí",
            SEND_INVOICE: "Puede enviar facturas Stripe manualmente aquí",
            BUTTON_CHARGE: "Cargar a través de Stripe",
            BUTTON_RESET: "Restablecer información de banda",
            BUTTON_INVOICE: "Factura a través de Stripe",
            PAYMENT_LOGS: "Registros de pago"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "Puede facturar manualmente a los clientes a través de Authorize.Net aquí",
            SEND_INVOICE: "Puede enviar facturas de Authorize.Net manualmente aquí",
            BUTTON_CHARGE: "Cobro a través de Authorize.Net",
            BUTTON_RESET: "Restablecer información de Authorize.Net",
            BUTTON_INVOICE: "Facturar a través de Authorize.Net",
            PAYMENT_LOGS: "Registros de pago"
        },
        REVIEW: {
            TITLE: "Reseñas",
            RATING: "Clasificación",
            AVERAGE_RATING: "Calificación promedio",
            NO_DATA: "Todavía no hay reseñas"
        },
        ADD_DOCUMENTO: {
            TITLE: "Agregar Documento",
            DESCRIPTION: "Puede agregar cualquier plantilla de documento al usuario desde aqu\xED, solo seleccione una\n            of sus documentos del men\xFA desplegable:",
            BUTTON: "Agregar documento"
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Candidatos asignados",
                NO_CANDIDATE: "No se han vinculado candidatos a este cliente"
            },
            CLIENTE: {
                TITLE: "Clientes asignados",
                NO_CLIENT: "No se han vinculado clientes a este candidato"
            },
            ADD_CANDIDATE: "Agregar candidato"
        },
        LAST_CONTACTED_DATE: "Última fecha de contacto",
        CANDIDATE_BADGES: {
            TITLE: "Insignias de candidatos",
            BUTTON: "Guardar insignias"
        }
    },
    COMMUNICATION: {
        DATE: "Fecha",
        FROM: "Desde",
        TO: "Para",
        SUBJECT: "Asunto",
        MESSAGE: "Mensaje",
        RE_SEND: "Reenviar"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Buscar por título de trabajo, ID de trabajo, horario, ciudad, estado o descripción",
        JOB_HIDEN_DESCRIPTION: "Los trabajos en el estado \"Borrador\", \"Cerrado\" o \"Llenado\" no aparecen en el trabajo\n        board por defecto. Para actualizar el estado de un trabajo, haga clic en \"Editar trabajo\".",
        CLIENT_POSTING_JOB_DESCRIPTION: "Esto es para publicar posiciones a largo plazo para este cliente."
    },
    CONFIRM_DIALOGS: _es2.default,
    ERROR_DIALOGS: _es4.default,
    RESULT_DIALOGS: _es6.default
};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    CHANGE_QUESTION_MODEL_CONFIRM_DIALOG: {
        MESSAGE: 'Al cambiar el modelo de esta pregunta, se perderá cualquier información ya respondida a esta pregunta. Póngase en contacto con Enginehire si tiene alguna pregunta.',
        ACCEPT_LABEL: 'Continuar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta referencia?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta experiencia?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar este contacto?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta educación?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar a este niño?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta mascota?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta reserva?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el creador de perfiles {0}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta solicitud?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar este trabajo?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta aplicación?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el documento {0}?',
        ACCEPT_LABEL: 'Eliminar documento',
        REJECT_LABEL: 'Cerrar'
    },
    BULK_DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está absolutamente seguro de que desea eliminar estos documentos?',
        ACCEPT_LABEL: 'Eliminar documentos',
        REJECT_LABEL: 'Cerrar'
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el archivo?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cerrar'
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la {0} plantilla {1}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar {0} {1}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PHOTO_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la foto {0}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la imagen?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>\xBFEst\xE1 seguro de que desea eliminar este usuario?</h3>\n        <p>{0} {1}</p>\n        <p>{2}</p>',
        ACCEPT_LABEL: "Borrar",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>\xBFEst\xE1 seguro de que desea eliminar este usuario?</h3>\n        <p>{0}</p>',
        ACCEPT_LABEL: "Borrar",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar {0}?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cancelar esta reserva?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cerrar? Cualquier cambio se perderá.',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea aceptar el trabajo {0}?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    DECLINE_JOB_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea rechazar el trabajo {0}?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de tus cambios?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    BULK_UPDATE_LOCATIONS_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cambiar las ubicaciones de los {0} usuarios seleccionados? Sus ubicaciones se cambiarán a {1}.',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea cambiar el estado de los {0} usuarios seleccionados? Su estado cambiará a {1}.',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Hay un video grabado. Si graba un video nuevo, el video existente se sobrescribirá. ¿Estás seguro de continuar?',
        ACCEPT_LABEL: 'Continuar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de que quieres eliminar la foto de perfil?',
        ACCEPT_LABEL: 'Borrar imagen',
        REJECT_LABEL: 'Cerrar'
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar el enlace entre {0} y este cliente?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Te comprometes a ocupar este puesto, ¿estás seguro?',
        ACCEPT_LABEL: 'Aceptar trabajo',
        REJECT_LABEL: 'Cerrar'
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de que quieres marcar a {0} como favorito?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    MARK_AS_DO_NO_WANT_CONFIRM_DIALOG: {
        MESSAGE: '¿Estás seguro de que no quieres volver a {0}?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>\xBFEst\xE1 seguro de que desea eliminar la nota?</h3>\n        <p style="espacio en blanco: ajuste previo;">{0}</p>',
        ACCEPT_LABEL: "Borrar",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar este crédito?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_MULTI_ITEMS_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar los {0} {1} seleccionados?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    UNASSIGN_JOBS_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea anular la asignación de {0} trabajos seleccionados? Su estado se pondrá en "{1}".',
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    BULK_CHANGE_JOB_STATUS_CONFIMR_DIALOG: {
        MESSAGE: "¿Está seguro de que desea cambiar el estado de los {0} trabajos seleccionados? Su estado cambiará a {1}.",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    BULK_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "¿Está seguro de que desea asignar {0} trabajos seleccionados al candidato seleccionado?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    PACKAGE_SELECTION_CONFIRMACIÓN: {
        INNER_HTML: '<h2>Confirmar selecci\xF3n - {0}</h2>\n        <hr />\n        <h5>\n          He le\xEDdo y conf\xEDo en los t\xE9rminos y condiciones con el\n          paquete elegido.\n        </h5>',
        ACCEPT_LABEL: "Confirmar selección",
        REJECT_LABEL: "Cancelar"
    },
    DELETE_EVALUATION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta evaluación?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_QUESTION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta pregunta?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_OPTION_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar esta opción?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    POST_WEEK_DISPONIBILIDAD_CONFIRMACIÓN_DIÁLOGO: {
        MESSAGE: '¿Está seguro de la disponibilidad que ha introducido?',
        ACCEPT_LABEL: 'Confirmar disponibilidad',
        REJECT_LABEL: 'Espera, déjame comprobar de nuevo'
    },
    TIME_OFF_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de su solicitud?',
        ACCEPT_LABEL: 'Enviar solicitud',
        REJECT_LABEL: 'Solicitud de edición'
    },
    REMOVE_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '{0} ({1}) - Eliminar disponibilidad',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_WEEK_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '¿Está seguro de que desea eliminar la disponibilidad semanal?',
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    RESET_WEEK_DISPONIBILIDAD: {
        MESSAGE: '¿Está seguro de que desea restablecer la disponibilidad semanal?',
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de su solicitud?",
        ACCEPT_LABEL: "Enviar solicitud",
        REJECT_LABEL: "Solicitud de edición"
    },
    DELETE_TIME_OFF_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar el tiempo libre?",
        ACCEPT_LABEL: 'Eliminar',
        REJECT_LABEL: 'Cancelar'
    },
    MARK_ALL_AS_PUBLIC_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea marcar todos los {0} como públicos (visibles para todos)?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    BROADCAST_SMS_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea enviar SMS a {0} usuarios",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    CREATE_JOB_CONFIRM_DIALOG: {
        INNER_HTML: '<h4>Crear trabajo</h4>' + '<hr>' + '<h5>Si está comenzando un trabajo, pero no figura en su horario, utilice esta opción.' + ' Esto creará un nuevo trabajo en el que podrá marcar la entrada y la salida, y completaremos los demás detalles más adelante.' + ' Al registrarte, ten en cuenta para qué familia trabajas y cualquier otra cosa que debamos saber.</h5>',
        ACCEPT_LABEL: 'Crear trabajo',
        REJECT_LABEL: 'Cancelar'
    },
    ASSIGN_TO_NO_MATCH_CANDIDATE: {
        MESSAGE: "Existe una relación 'No coincide' entre cliente y candidato. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_UNAVAILABLE_CANDIDATE: {
        MESSAGE: "El candidato no está disponible. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_ALREADY_BOOKED_CANDIDATE: {
        MESSAGE: "El candidato ya está reservado en este momento. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    ASSIGN_TO_TIME_OFF_CANDIDATE: {
        MESSAGE: "El candidato tiene tiempo libre en este momento. ¿Está seguro de que desea asignar la reserva a este candidato?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    RELEASE_SCHEDULE_CONFIRM_DIALOG: {
        MESSAGE: "¿Estás listo para publicar el horario?",
        ACCEPT_LABEL: 'Calendario de lanzamiento',
        REJECT_LABEL: 'Cancelar'
    },
    DELETE_BOOKING_GROUP_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar el grupo de reserva?"
    },
    ACCEPT_BOOKING_IN_GROUP_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>La reserva pertenece a un grupo. \xBFEst\xE1 seguro de que desea aceptar todas las reservas de ese grupo?</h3>\n        <ul>{0}</ul>',
        ACCEPT_LABEL: "Aceptar todo",
        REJECT_LABEL: "Cancelar"
    },
    UPDATE_JOB_POSTER_CONFRM_DIALOG: {
        MESSAGE: "¿Desea actualizar los campos de dirección de acuerdo con el nuevo anuncio de trabajo?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    CLIENT_CONFIRM_CLOCK_IN_OUT_MESSAGE: {
        INNER_HTML: "<h3>¿Está seguro de que desea aprobar la hora de entrada y salida del candidato</h3>" + "<ul><li>Hora de entrada: {0}</li><li>Hora de salida: {1}</li></ul>",
        ACCEPT_LABEL: 'Aprobar',
        REJECT_LABEL: 'Cancelar'
    },
    SELECT_CREDIT_PACKAGE_CONFIRM_DIALOG: {
        MESSAGE: "Se le cobrará {0}{1} por {2} créditos. ¿Está seguro de que desea continuar?",
        ACCEPT_LABEL: 'Sí',
        REJECT_LABEL: 'No'
    },
    UNASSIGN_CANDIDATE_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea cancelar la asignación de este candidato?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    UPDATE_RATE_BASED_ON_BOOKING_SERVICE_CONFIRM_DIALOG: {
        MESSAGE: "¿Desea actualizar la tarifa del cliente y la tarifa del candidato en consecuencia?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    DELETE_BREAK_CONFIRM_DIALOG: {
        MESSAGE: "¿Está seguro de que desea eliminar este descanso?",
        ACCEPT_LABEL: "Sí",
        REJECT_LABEL: "No"
    },
    BULK_CHARGE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>\xBFEst\xE1 seguro de que desea cobrar a los clientes por los siguientes trabajos?</h3>\n        <ul>{0}</ul>',
        ACCEPT_LABEL: "Cargo",
        REJECT_LABEL: "Cancelar"
    },
    BULK_INVOICE_STRIPE_CLIENT_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>\xBFEst\xE1 seguro de que desea enviar la factura a los clientes a trav\xE9s de Stripe para los siguientes trabajos?</h3>\n        <ul>{0}</ul>',
        ACCEPT_LABEL: "Enviar Factura",
        REJECT_LABEL: "Cancelar"
    },
    BULK_CHARGE_PAYOUT_STRIPE_CONFIRM_DIALOG: {
        INNER_HTML: '<h3>\xBFEst\xE1 seguro de que desea cobrar a los clientes y pagar a los candidatos a trav\xE9s de Stripe para los siguientes trabajos?</h3>\n        <ul>{0}</ul>',
        ACCEPT_LABEL: "Transferir",
        REJECT_LABEL: "Cancelar"
    }
};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requiredValues = __webpack_require__(58);

exports.default = {
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: 'Campo faltante para la dirección de correo electrónico',
        MESSAGE: '¡Agregue al menos 1 campo para la dirección de correo electrónico!'
    },
    INVALID_INPUT_ERROR: {
        TITLE: 'Falta un campo obligatorio o un campo no es válido.',
        MESSAGE: '¡Revise el formulario en busca de mensajes de error!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Falta tiempo de reserva',
        MESSAGE: '¡Agregue la hora de reserva (hora de inicio y hora de finalización)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: 'Un documento no está firmado',
        MESSAGE: '¡Revise el formulario en busca de mensajes de error y firme todos los documentos!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: 'Un campo de entrada no es válido',
        MESSAGE: 'Hay un campo de entrada que no es válido'
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: 'No hay campo para el constructor',
        MESSAGE: '¡Agregue al menos un campo!'
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: 'No se puede usar la misma opción entre {0} y {1}',
        MESSAGE: 'Por favor, anule la selección de la(s) opción(es) {2} en {0} o {1}'
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: '¡Agregue más {0}!',
        MESSAGE: 'Debe tener al menos {1} {0}'
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Falta experiencia',
        MESSAGE: 'Debes tener al menos 1 experiencia.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: 'Falta estado',
        MESSAGE: _requiredValues.LIST_REQUIRED_STATUSES.join(" y ") + ' son estados obligatorios'
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: 'Estados duplicados',
        MESSAGE: 'Hay algunos estados que están duplicados'
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: 'Múltiples campos usando el mismo modelo',
        MESSAGE: 'Hay un modelo que está asignado a al menos 2 campos'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: 'Estados duplicados',
        MESSAGE: 'Hay algunos elementos que están duplicados'
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: 'El tipo de empleador está duplicado',
        MESSAGE: 'Hay algunos tipos de empleadores que están duplicados'
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: 'El tipo de candidato está duplicado',
        MESSAGE: 'Hay algunos tipos de candidatos que están duplicados'
    },
    DUPLICATE_JOB_TYPE_ERROR: {
        TITLE: 'Los tipos de trabajo están duplicados',
        MESSAGE: 'Hay algunos tipos de trabajo que están duplicados'
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: '¡Lo siento, ese tipo de archivo no es válido!',
        MESSAGE: 'Cargue una imagen PNG o JPG.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: '¡Lo siento, ese tipo de archivo no es válido!',
        MESSAGE: 'Cargue un archivo DOC, DOCX o PDF.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: '¡El archivo está vacío!',
        MESSAGE: 'Cargue un archivo que no esté vacío'
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: '¡Archivo demasiado grande!',
        MESSAGE: 'Cargue un archivo con un tamaño inferior al tamaño máximo de carga'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Archivo no válido',
        MESSAGE: 'Archivo de entrada no válido'
    },
    MISSING_RESUME_ERROR: {
        TITLE: 'Falta tu currículum profesional de cuidado de niños',
        MESSAGE: 'Cargue su currículum profesional de cuidado de niños'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: 'La fecha de finalización debe ser posterior a la fecha de inicio',
        MESSAGE: 'Por favor, cambie la fecha de inicio o la fecha de finalización'
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: 'La hora de finalización debe ser posterior a la hora de inicio',
        MESSAGE: 'Por favor, cambie la hora de inicio o la hora de finalización'
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'Las reservas deben ser de al menos {0} horas.',
        MESSAGE: 'Por favor, cambie la hora de inicio o la hora de finalización'
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: 'Falta tu foto de perfil',
        MESSAGE: '¡Sube una foto tuya reciente!'
    },
    NO_TEXT_SELECT: {
        TITLE: 'Ningún texto seleccionado',
        MESSAGE: 'Seleccione algún texto'
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: '¡Su solicitud ha sido enviada! PERO',
        MESSAGE: 'Hubo un error al procesar sus referencias. ¿Puedes por favor enviárnoslos por correo electrónico? ¡Gracias!'
    },
    SUBMIT_ERROR: {
        TITLE: 'Error al enviar su solicitud',
        MESSAGE: 'Hubo un error al procesar su solicitud'
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Elemento faltante en la lista de estado',
        MESSAGE: 'El estado {0} es obligatorio'
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: 'Hay una sección incompleta',
        MESSAGE: 'La sección {0} está incompleta. Por favor actualice esa sección'
    },
    CONTRASEÑA_UNMATCH_ERROR: {
        TITLE: 'Las contraseñas no coinciden.'
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: 'No se pueden encontrar candidatos cercanos',
        MESSAGE: 'Al trabajo le falta una dirección completa. Para buscar candidatos, edite el trabajo y complete la información de la dirección que falta.'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: 'El generador de perfiles está en uso',
        MESSAGE: 'El creador de perfiles está siendo utilizado por el creador de perfiles {0}.\n' + 'Elimine primero ese creador de perfiles'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: 'Falta una firma',
        MESSAGE: 'Escriba su nombre para firmar'
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: 'Falta un campo obligatorio',
        MESSAGE: 'Complete todos los campos obligatorios (consulte los campos con borde rojo)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: '\n        <h2>\xA1Parece que ya est\xE1 en nuestro sistema!</h2>\n        <h4 class="mensaje-de-error-mensaje-principal">\n        Por favor, <a href=\'{0}/login/{1}\'>inicie sesi\xF3n en su panel de control</a> para continuar, o comun\xEDquese con nosotros si tiene preguntas. \xA1Gracias!\n        </h4>\n        '
    },
    WEEK_AVAILABILITY_BLOCK_END_TIME_BEFORE_START_TIME_ERROR: {
        TITLE: 'La hora de finalización debe ser posterior a la hora de inicio',
        MESSAGE: 'Cambie la hora de inicio o la hora de finalización del bloque {0} de {1}'
    },
    WEEK_AVAILABILITY_DURATION_TOO_SHORT_ERROR: {
        TITLE: 'El bloque debe ser de al menos {0} horas.',
        MESSAGE: 'Cambie la hora de inicio o la hora de finalización del bloque {1} de {2}'
    },
    WEEK_AVAILABILITY_EMPTY_REQUIRED_FIELD_ERROR: {
        TITLE: 'Campo obligatorio vacío',
        MESSAGE: 'Indique la hora de inicio y la hora de finalización del bloque {0} de {1}'
    },
    PAYMENT_INFORMATION_REQUIRED: {
        TITLE: "Se requiere información de pago",
        MESSAGE: "Ingrese la información de pago"
    },
    INVALID_PAYMENT_INFORMATION: {
        TITLE: "Información de pago no válida",
        MESSAGE: "Actualice la información de pago: {0}"
    },
    LIST_INPUT_CONTAINS_BLANK: {
        TITLE: "{0} contiene un valor en blanco",
        MESSAGE: "Elimine el espacio en blanco {0}"
    },
    DUPLICATE_HEADER_IMPORT_CSV: {
        TITLE: "Hay algunos encabezados duplicados.",
        MESSAGE: "Lista de encabezados duplicados: {0}.\nSi se importan los encabezados duplicados, es posible que no se importen los campos correspondientes"
    },
    CANNOT_EDIT_BOOKING_WITHIN_X_HOURS: {
        TITLE: "No se puede editar la reserva",
        MESSAGE: "Lo sentimos, el cambio no se puede hacer menos de {0} horas antes de que comience un trabajo. Si necesita un cambio, contáctenos directamente. ¡Gracias!"
    },
    CANNOT_ADD_BOOKING_WITHIN_X_HOURS: {
        TITLE: "No se puede agregar la reserva",
        MESSAGE: "Lo sentimos, no se puede reservar menos de {0} horas antes de que comience un trabajo. Si realmente necesita esto, contáctenos directamente. ¡Gracias!"
    },
    PAYMENT_FIELD_REQUIRED_IN_APPLICATION_FORM: {
        TITLE: "El campo de pago es obligatorio",
        MESSAGE: "Agregue un campo de pago para poder cobrar al usuario cuando envíe el formulario de solicitud"
    },
    MISSING_NUMBER_OF_ROWS: {
        TITLE: 'Por favor, especifique el número de filas para la importación parcial'
    },
    SCHEDULE_CONFLICT_CANDIDATE_ERROR_DIALOG: {
        TITLE: "Conflicto de horario",
        MESSAGE: "Ya estás asignado a otro trabajo durante ese tiempo"
    },
    CLIENT_CONFIRM_INCORRECT_PASSWORD: {
        TITLE: "Contraseña incorrecta",
        MESSAGE: "Error al aprobar la hora de entrada/salida. La contraseña del cliente es incorrecta"
    }
};

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: '¡Gracias por su solicitud para unirse a nuestro equipo!',
        MESSAGE: '¡Revisaremos detenidamente su solicitud y nos pondremos en contacto con usted pronto si parece encajar bien en nuestro equipo! Debido al alto volumen de solicitudes que recibimos, solo podemos responder a los candidatos que seleccionamos. ¡Gracias por su comprensión! Ahora puede cerrar esta ventana de forma segura'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: '¡Gracias por su información!',
        MESSAGE: 'La información de referencia que envió es muy importante para nosotros. Puedes cerrar esta ventana con seguridad ahora'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: '\n        <h2>\xA1Gracias por enviar su registro!</h2>\n        <h5>\xA1Nos pondremos en contacto contigo en breve! Ahora puede cerrar esta ventana de forma segura.</h5>\n        '
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: '¡Gracias por informarnos, nos pondremos en contacto con usted en breve!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: '\n        <h2>\xA1El v\xEDdeo se subi\xF3 correctamente!</h2>\n        <h5>Gracias por enviar el video de presentaci\xF3n. Si no se muestra en la pantalla, espere un momento y luego haga clic manualmente en Actualizar (<i class="material-icons" style=\'position: absolute;\'>refresh</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp ;&nbsp;)</h5>\n        '
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Sección guardada',
        MESSAGE: '¡Se guardó la sección {0}!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Formulario familiar actualizado',
        MESSAGE: 'Formulario familiar actualizado con éxito'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Gracias',
        MESSAGE: "Revisaremos la información que ha enviado y nos pondremos en contacto con usted si deseamos seguir adelante"
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Gracias',
        MESSAGE: "Revisaremos la información que ha enviado y nos pondremos en contacto con usted si deseamos seguir adelante"
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Estado actualizado'
    },
    STATUS_UPDATED_REFUND_RESULT_DIALOG: {
        TITLE: 'Estado actualizado. Reembolso al cliente 1 crédito'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Transmisión enviada!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: '¡Candidato asignado!',
        MESSAGE: 'Proceda a la notificación de cliente y candidato.'
    },
    BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Candidatos asignados"
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Trabajo actualizado!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: '¡Trabajo publicado!'
    },
    JOB_ACCEPTANCE_TYPE_RESULT_DIALOG: {
        TITLE: 'Tipo de aceptación actualizado'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: '¡El cliente cargó y el estado del trabajo se actualizó!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: '¡Se ha cobrado al cliente a través de Stripe!'
    },
    BULK_JOBS_CHARGED_RESULT_DIALOG: {
        TITLE: '¡Clientes cobrados y estado de trabajos actualizado!'
    },
    BULK_INVOICE_RESULT_DIALOG: {
        TITLE: "¡Clientes facturados!"
    },
    BULK_TRANSFER_RESULT_DIALOG: {
        TITLE: "¡Clientes cobrados y candidatos pagados y estado de trabajos actualizado!"
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Mensaje enviado.'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'La contraseña se ha restablecido correctamente.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'La imagen de perfil se ha guardado correctamente.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'La imagen de perfil se ha eliminado correctamente.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documentos cargados.',
        MESSAGE: "Podrían tardar unos segundos en procesarse. Si no se actualizan de inmediato, intente actualizar en un minuto"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Su documento ha sido firmado.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Su documento ha sido guardado.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'Se actualiza la información adicional del documento {0}'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Plantilla creada.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Plantilla actualizada'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Plantilla eliminada'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Plantilla duplicada.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Restablecimiento de contraseña',
        MESSAGE: 'Contraseña restablecida a {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Creador de perfiles actualizado'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Se guardó el pie de página del correo electrónico'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Configuración de notificación guardada'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Configuración de administrador adicional guardada'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrador actualizado.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrador agregado'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrador actualizado'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrador eliminado'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Ubicaciones actualizadas'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Idioma actualizado'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: '¡Transmisión enviada a {0} candidatos!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Visualizaciones de trabajos',
        MESSAGE: 'Número de veces visto: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: '¡Despegue!',
        MESSAGE: "¡Sus correos electrónicos están en camino! Puede tomar algunos minutos, dependiendo de cuántos se envíen. Aparecerán en el registro de correo electrónico general y en los registros de correo electrónico del usuario individual a medida que se envían"
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: '¡Nota guardada!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} guardado, ¡agrega otro!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Gracias por informarnos!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "¡Felicitaciones, has aceptado este trabajo!",
        MESSAGE: 'Todos los detalles aparecerán aquí y en su tablero en "Mis trabajos".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'El alcance de visibilidad de {0} se actualizó a {1}'
    },
    CHECK_FORM_ACTUALIZADO: {
        TITLE: '{0} formulario de verificación actualizado'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: '¡Cambios guardados!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Precio creado.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Precio actualizado'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Precio eliminado.'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: '¡Enlace de candidato a cliente actualizado!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Enlace de candidato a cliente actualizado!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: '¡Oferta actualizada!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: '¡Gracias por dejar una reseña!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: '¡Marcado como favorito!',
        MESSAGE: 'Haremos todo lo posible para emparejarlo con ellos en el futuro.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Gracias por informarnos',
        MESSAGE: 'Haremos todo lo posible para conectarlo con otros en el futuro'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: '¡Gracias por enviar su información de pago!'
    },
    PACKAGE_SELECTED_RESULT_DIALOG: {
        TITLE: 'Su paquete ha sido seleccionado, ¡gracias!',
        MESSAGE: "Nuestra búsqueda está en marcha, ¡nos pondremos en contacto pronto!"
    },
    EVALUACIÓN_CREATED_RESULTADO_DIÁLOGO: {
        TITLE: "Evaluación creada"
    },
    EVALUACIÓN_ACTUALIZADO_RESULTADO_DIÁLOGO: {
        TITLE: "Evaluación actualizada"
    },
    EVALUACIÓN_ELIMINADO_RESULTADO_DIÁLOGO: {
        TITLE: "Evaluación eliminada"
    },
    QUESTION_CREATED_RESULT_DIALOG: {
        TITLE: "Pregunta creada"
    },
    QUESTION_UPDATED_RESULT_DIALOG: {
        TITLE: "Pregunta actualizada"
    },
    QUESTION_DELETED_RESULT_DIALOG: {
        TITLE: "Pregunta eliminada"
    },
    EVALUACIÓN_AÑADIDA_RESULTADO_DIÁLOGO: {
        TITLE: "¡Evaluación agregada!"
    },
    EVALUACIÓN_COMPLETA_RESULTADO_DIÁLOGO: {
        TITLE: "{0} completado, ¡gracias!",
        CLOSE_LABEL: "Listo"
    },
    TIME_OFF_REQUEST_SUBMITTED_RESULT_DIALOG: {
        TITLE: "¡Su solicitud de tiempo libre ha sido enviada, la revisaremos y confirmaremos cuando se apruebe!",
        CLOSE_LABEL: "Listo"
    },
    AVAILABILITY_NOTES_UPDATED_RESULT_DIALOG: {
        TITLE: "¡Notas actualizadas!",
        CLOSE_LABEL: "Continuar"
    },
    BUFFER_TIME_UPDATED_RESULT_DIALOG: {
        TITLE: "¡Tiempo de búfer actualizado!"
    },
    SCHEDULE_UPDATED_RESULT_DIALOG: {
        TITLE: "Horario actualizado"
    },
    DOCUMENT_SEND_TO_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Documento enviado al candidato"
    },
    DOCUMENT_MARK_AS_DRAFT_RESULT_DIALOG: {
        TITLE: "El documento está marcado como borrador"
    },
    DOCUMENT_PUBLISH_RESULT_DIALOG: {
        TITLE: "Documento publicado"
    },
    DOCUMENT_UPDATED_RESULT_DIALOG: {
        TITLE: "El documento está actualizado"
    },
    RESERVA_EN_BLOCKED_DATES_RESULT_DIALOG: {
        TITLE: "Nuestras disculpas, ¡estamos reservados para esta fecha! Lo agregaremos a nuestra lista de cancelaciones y le informaremos de cualquier cambio lo antes posible",
        CLOSE_LABEL: "Continuar"
    },
    CHECKLIST_SAVED_RESULT_DIALOG: {
        TITLE: "Lista de verificación guardada"
    },
    FEEDBACK_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Gracias, nos pondremos en contacto en breve"
    },
    USER_ALERT_BLOCKED_POPUP_DIALOG: {
        TITLE: "Si no se ha abierto una nueva ventana, verifique si se bloquearon las ventanas emergentes",
        CLOSE_LABEL: "Cancelar"
    },
    CLOCK_OUT_SUCCESS_RESULT_DIALOG: {
        TITLE: "¡Gracias!",
        MESSAGE: "Si hubo algún problema con el registro de la hora o cualquier otra cosa, háganoslo saber",
        CLOSE_LABEL: "Listo"
    },
    CLOCK_IN_SUCCESS_RESULT_DIALOG: {
        TITLE: "¡Gracias!",
        MESSAGE: "¡No olvides marcar la salida cuando hayas terminado!",
        CLOSE_LABEL: "Listo"
    },
    SCHEDULE_RELEASED_RESULT_DIALOG: {
        TITLE: "¡Se ha publicado el horario!"
    },
    EVENT_BOOKED_RESULT_DIALOG: {
        TITLE: "¡Evento reservado!"
    },
    DOCUMENT_ADDED_RESULT_DIALOG: {
        TITLE: "¡Documento agregado!"
    },
    TENTATIVE_ASSIGN_RESULT_DIALOG: {
        TITLE: "Niñera asignada tentativamente.",
        MESSAGE: "Nadie ha sido notificado, lo serán cuando presiones el botón rojo grande"
    },
    SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} información enviada",
        MESSAGE: "Gracias por enviar la información de {0}. Cierre la ventana o envíe otra {1}"
    },
    CANDIDATE_SELECTED_RESULT_DIALOG: {
        TITLE: "Gracias por seleccionar candidato"
    },
    CLOCK_IN_OUT_APPROVED_RESULT_DIALOG: {
        TITLE: "Las horas de entrada y salida están aprobadas"
    },
    PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '¡{0} Créditos añadidos, gracias!'
    },
    UNASSIGN_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Candidato no asignado"
    },
    SAVED_ADVANCE_SEARCH_RESULT_DIALOG: {
        TITLE: "Búsqueda avanzada guardada"
    },
    REQUEST_TIMEOFF_APPROVED_RESULT_DIALOG: {
        TITLE: "Solicitud aprobada"
    },
    REQUEST_TIMEOFF_DECLINED_RESULT_DIALOG: {
        TITLE: "Solicitud rechazada"
    }
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(240);

var _en2 = _interopRequireDefault(_en);

var _en3 = __webpack_require__(241);

var _en4 = _interopRequireDefault(_en3);

var _en5 = __webpack_require__(242);

var _en6 = _interopRequireDefault(_en5);

var _en7 = __webpack_require__(243);

var _en8 = _interopRequireDefault(_en7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Verzenden",
        PREVIOUS: "Vorige",
        NEXT: "Volgende",
        VIEW: "Bekijken",
        UPLOAD: "Uploaden",
        UPLOAD_FILE: "Bestand uploaden",
        VIEW_FILE: "Bestand bekijken",
        DELETE_FILE: "Bestand verwijderen",
        CLOSE: "Sluiten",
        DELETE: "Verwijderen",
        CANCEL: "Annuleren",
        YES: "Ja",
        NO: "Nee",
        OK: "Ok",
        ADD: "Toevoegen",
        UPDATE_STATUS: "Status bijwerken",
        RETURN_DASHBOARD: "Terug naar dashboard",
        REFRESH: "Vernieuwen",
        BULK_UPDATE_STATUS: "Update status van geselecteerd",
        BULK_OVERWRITE_LOCATIONS: "Locaties overschrijven",
        BULK_OVERWRITE_TYPES: "Typen overschrijven",
        BULK_OVERWRITE_TAGS: "Tags overschrijven",
        BULK_ADD_LOCATIONS: "Locaties toevoegen",
        BULK_ADD_TYPES: "Typen toevoegen",
        BULK_ADD_TAGS: "Tags toevoegen",
        BULK_UPDATE: "Bulk-update",
        CHARGE_THROUGH_AUTHORIZE_NET: "Opladen via Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Opladen via streep",
        INVOICE_THROUGH_STRIPE: "Factuur via streep",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Klant en uitbetalingskandidaat in rekening brengen",
        BULK_COPY_SUGGESTED_CHARGE: "Voorgestelde kosten voor bulkkopie naar totale klantkosten",
        BULK_DELETE: "Geselecteerde verwijderen",
        BULK_UNASSIGNED: "Toewijzing selectie ongedaan maken",
        EXPORT_EMPLOYERS: "Exporteer mailinglijst voor klanten",
        EXPORT_CANDIDATES: "Mailinglijst van kandidaten exporteren",
        UPDATE_MANAGER: "Update {0} Manager",
        VIEW_PROFILE: "Bekijk profiel",
        VIEW_OFFER: "Bekijk aanbieding",
        SAVE: "Opslaan",
        EXPAND_ALL: "Alles uitvouwen",
        COLLAPSE_ALL: "Alles samenvouwen",
        SELECT_ALL: "Alles selecteren",
        UNSELECT_ALL: "Alles deselecteren",
        RESET_FILTERS: "Filters resetten",
        CLOCK_IN: "Inklokken",
        ADD_A_BREAK: "Voeg een pauze toe",
        CLOCK_OUT: "Uitklokken",
        CONFIRM_CLOCK_IN_OUT: "Klant bevestigen",
        LEAVE_REVIEW: "Laat een recensie achter",
        DECLINE: "Weigeren",
        DECLINE_WITHOUT_NOTIFICATION: "Weigeren zonder kennisgeving",
        UNDECLINE: "Ongedaan maken",
        ACCEPT: "Accepteren",
        CHECK_PAYMENT: "Betalingsuitdrukking controleren",
        ASSIGN: "Toewijzen",
        TENTATIVELY_ASSIGN: "Voorlopig toewijzen",
        SIGN: "Teken",
        EDIT: "Bewerken",
        DUPLICATE: "Dupliceren",
        ADD_A_BOOKING: "Voeg een boeking toe",
        ADD_A_GROUP: "Een groep toevoegen",
        MESSAGE: "Bericht",
        UPDATE_CUSTOM_STATUS: "Update {0}-status",
        UPDATE: "Bijwerken",
        ADD_OPTION: "Optie toevoegen",
        EDIT_SETTING: "Instellingen bewerken",
        DONE: "Gereed"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Nieuwe status",
        NEW_LOCATIONS: "Nieuwe locaties",
        NEW_TYPES: "Nieuwe typen",
        NEW_TAGS: "Nieuwe tags",
        FILTER_BY_STATUS: "Filteren op status",
        FILTER_BY_STATUSES: "Filteren op status",
        STATUSES_TO_HIDE: "Statussen om te verbergen",
        FILTER_BY_LOCATIONS: "Filteren op locaties",
        FILTER_BY_TYPES: "Filteren op type",
        FILTER_BY_TAGS: "Filteren op tags",
        FILTER_BY_MANAGER: "Filteren op beheerder",
        FILTER_BY_CATEGORIES: "Filteren op categorieën",
        FILTER_BY_START_DATE: "Filteren op startdatum",
        FILTER_BY_END_DATE: "Filteren op einddatum",
        FILTER_BY_WEEK_DAY: "Filteren op weekdag",
        FILTER_BY_CLIENTS: "Filteren op klanten",
        FILTER_BY_CLIENT_STATUSES: "Filteren op klantstatus",
        FILTER_BY_CLIENT_TYPES: "Filteren op clienttypes",
        FILTER_BY_CANDIDATES: "Filter op kandidaat(s)",
        FILTER_BY_JOB_TYPES: "Filter op taaktype",
        FILTER_BY_JOB_STATUSES: "Filteren op taakstatus",
        FILTER_BY_JOB_ID: "Filteren op taak-ID",
        SELECT_SCRAPER_ACCOUNTS: "Selecteer Scraper-accounts",
        FILTER_BY_USER_TYPE: "Filteren op gebruikerstype",
        KEYWORD_SEARCH_USER_PROFILE: "Zoek naar trefwoord/zin ergens in het gebruikersprofiel, druk op Enter om de zoekopdracht toe te passen",
        SEARCH_BY_NAME_EMAIL_PHONE: "Zoeken op naam, e-mail of telefoonnummer",
        FILTER_BY_RECENT_ACTIVE: "Filteren op recent actief",
        SELECT_LOCATIONS: "Selecteer locaties",
        SELECT_OPTION: "Selecteer optie",
        SELECT_CLIENT: "Klant selecteren",
        SELECT_CANDIDATE: "Kandidaat selecteren",
        SELECT_CANDIDATES: "Kandidaten selecteren",
        SELECT_CANDIDATE_SEARCHABLE: "Selecteer kandidaat (type om te zoeken)",
        SELECT_ADMINS: "Selecteer beheerders",
        SELECT_ADMIN_RECEIVE_EMAIL: "Selecteer beheerders die e-mails ontvangen",
        SELECT_STATUS: "Selecteer status",
        SELECT_LANGUAGES: "Selecteer talen",
        SELECT_TYPES: "Selecteer typen",
        SELECT_TYPE: "Selecteer Type",
        SELECT_TAGS: "Selecteer tags",
        SELECT_USER_TYPE: "Selecteer gebruikerstype",
        SELECT_USER_TYPES: "Selecteer gebruikerstypes",
        SELECT_CATEGORY: "Selecteer categorie",
        SELECT_CATEGORY_ADMIN_ONLY: "Selecteer categorie (alleen beheerder)",
        SELECT_TRIGGER: "Selecteer trigger",
        SELECT_ONE: "Kies er een",
        SELECT_PROFILE_BUILDER: "Selecteer profielbouwer",
        SELECT_TIME_OFF_CATEOGRY: "Selecteer vrije tijd categorie",
        SELECT_DESTINATION: "Selecteer bestemming",
        SELECT_ACCESS_LEVEL: "Selecteer toegangsniveau",
        SELECT_VISIBILITY_SCOPE: "Selecteer zichtbaarheidsbereik",
        SELECT_AREAS: "Selecteer gebieden",
        NUMBER: "Nummer",
        DESCRIPTION_CHARGE: "Beschrijving van kosten"
    },
    LABELS: {
        SELECT_TEMPLATE: "Sjabloon selecteren",
        SELECT_ANALYTICS_DASHBOARD_FIELDS: "Selecteer velden voor analyse",
        FILTER_BY_LOCATIONS: "Filteren op locaties",
        FILTER_BY_TYPES: "Filteren op type",
        FILTER_BY_MANAGER: "Filteren op beheerder",
        FILTER_BY_CATEGORIES: "Filteren op categorieën",
        FILTER_BY_STATUS: "Filteren op status",
        ADDRESS: "Adres",
        CITY: "Stad",
        STATE: "Staat",
        COUNTRY: "Land",
        ZIP_CODE: "Postcode",
        LOCATIONS: "Locaties",
        DESCRIPTION: "Beschrijving",
        PER_HOUR: "per uur",
        ADD_ITEM: "Voeg {0} toe",
        EDIT_ITEM: "Bewerken {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Opslaan en nog een {0} toevoegen",
        WELCOME_TEXT: "Welkom bij {0}"
    },
    HEADERS: {
        EMAIL_LOG: "E-maillogboek",
        SMS_LOG: "SMS-logboek"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Hoe statussen standaard te verbergen",
        HOW_TO_CHANGE_STATUS: "Hoe statussen toevoegen/wijzigen"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Scheid meerdere e-mails met ; (bijv.: nanny1@hotmail.com; nanny2@hotmail.com )",
        SMS_NOTE: "Houd er rekening mee dat er een prijs van $ 0,0115 (1,15 ) per 160 tekens verzonden/ontvangen SMS is.",
        SMS_COUNTER_NOTE: "Het exacte aantal tekens hangt af van de informatie die in het eigenlijke bericht is ingevoegd.",
        CLIENT_NOT_ENTERED_STRIPE: "Klant heeft geen Stripe-informatie ingevoerd.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "Klant heeft geen Authorize.Net-informatie ingevoerd.",
        CANDIDATE_NOT_ENTERED_STRIPE: "Kandidaat heeft geen Stripe-informatie ingevoerd.",
        INTERVIEW_PANEL: "Opmerking: deze opmerkingen zijn alleen voor intern beheerdersgebruik en zijn dat niet\n        gedeeld met kandidaten of opdrachtgevers.",
        CANDIDATE_SHAREABLE_LINK: "Dit is een deelbare link van het kandidatenprofiel. Als je wil\n        om te zien wat een klant te zien krijgt, <strong>zorg ervoor dat u uitlogt</strong> en dan\n        bekijk de link (of open deze in een andere browser). Dit is <strong>geen</strong> een link waarmee uw kandidaat kan inloggen. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">Meer informatie.</a>",
        CLIENT_SHAREABLE_LINK: "Dit is een deelbare link van het klantprofiel. Als je wilt\n        zie wat een kandidaat te zien krijgt, <strong>zorg ervoor dat je uitlogt</strong> en dan\n        bekijk de link (of open deze in een andere browser). Dit is <strong>geen</strong> een link waarmee uw klanten kunnen inloggen. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">Meer informatie.</a>",
        CLIENT_PUBLIC_PAYMENT_LINK: "Dit is een openbare betalingslink. Klant heeft toegang tot deze link om betalingsinformatie in te voeren zonder in te loggen",
        TYPE_YOUR_NAME_TO_SIGN: 'Typ uw naam om te ondertekenen (u gaat ermee akkoord dat dit het equivalent is van het ondertekenen van een fysiek document)'
    },
    TABLE_HEADERS: {
        ACTIES: "Acties",
        NOTES: "Opmerkingen",
        VALUE: "Waarde",
        EFFECTIEF_FROM: "Effectief vanaf",
        EFFECTIVE_UNTIL: "Effectief tot",
        TYPE: "Type"
    },
    OPTIONS: {
        "JA": "Ja",
        "NEE": "Nee"
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Dit veld is verplicht."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Bedankt!",
        STEP_OF: "Stap {0} van {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Help ons het onderstaande formulier in te vullen",
        REFERENCE_FOR: "Referentie voor {0} {1}",
        REFERENCE_INPUT_BY: "Referentie-informatie ingevoerd door {0} {1}",
        FORM_SUBMITTED: "Het referentiecontroleformulier is verzonden!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Slaat hier een bestand neer of klik om te uploaden",
        MAXIMUM_UPLOAD_SIZE: "Maximale uploadgrootte {0}MB",
        FILE_EXCEED_MAXIMUM: "Bestandsgrootte is groter dan {0}MB.",
        FILE: "Bestand"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Boekingen",
            HIDE_PAST_BOOKINGS: "Verberg eerdere boekingen",
            BOOKING_CREDIT_LEFT: "{0} boekingstegoed over",
            MIN_BOOKINGS_REQUIRE: "Je hebt minimaal {0} boekingen nodig!",
            SELECTED_CANDIDATE: "Geselecteerde kandidaat",
            TOTAL_BOOKING_FEE: "Totale boekingskosten",
            BOOKING_GROUPS: "Boekingsgroepen"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Klik op de boeking (in de kalender) om meer te weten te komen over de aan u toegewezen serviceprovider en om een ​​beoordeling achter te laten.",
            CLICK_ON_DATE: "Klik op een datum om een ​​boeking toe te voegen.",
            CLICK_ON_OTHER_DATE: "Klik op een andere datum in de kalender om een ​​boeking toe te voegen.",
            BOOKING_GROUP: "Alle boekingen in dezelfde groep moeten aan één toegewezen persoon worden toegewezen"
        },
        PRICES: {
            BOOKING_RATE: "Reserveringstarief",
            BOOKING_FEE: "Boekingskosten",
            PER_BOOKING_FEE: "Per boekingskosten",
            CLIENT_RATE: "Klantpercentage",
            CANDIDATE_RATE: "Kandidaattarief",
            AGENCY_FEE: "Bureaukosten",
            TRAVEL_FEE: "Reiskosten",
            RUSH_FEE: "Spoedkosten",
            CANDIDATE_RUSH_FEE: "Kandidaat Rush Fee",
            PER_BOOKING_AGENCY_FEE: "Vergoeding per boekingsbureau",
            PER_BOOKING_CANDIDATE_FEE: "Per boekingskandidaatvergoeding",
            ADMIN_FEE: "Administratieve kosten",
            ADDITIONAL_FEES: "Extra kosten"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            ADDITIONAL_DATES: "Extra datums toevoegen",
            START_TIME: "Begintijd",
            END_TIME: "Eindtijd",
            END_DATE: "Einddatum",
            SELECT_CLIENT: "Klant selecteren",
            ASSIGNED_CANDIDATE: "Wilt u deze taak toewijzen?",
            TENTATIVELY_ASSIGN_CANDIDATE: "Wilt u deze taak voorlopig toewijzen?",
            REPEAT: "Wilt u deze service meer dan eens (herhalend/terugkerend)?",
            REPEAT_UNTIL: "Herhaal tot",
            REPEAT_EVERY: "Herhaal elke",
            REPEAT_ON: "Herhalen aan",
            BOOKING_ADDRESS: "Reserveringsadres",
            ADDRESS_LINE2: "Adresregel 2",
            CITY: "Stad",
            STATE: "Staat/Provincie",
            ZIP_CODE: "Postcode",
            NUMBER_CHILDREN: "Voor hoeveel kinderen wordt gezorgd?",
            SELECT_JOB_CATEGORY: "Selecteer functiecategorie",
            SELECT_DATE: "Reserveringsdatum",
            SELECT_SERVICE: "Selecteer dienst",
            NUMBER_CANDIDATE: "Aantal {0} nodig",
            SELECT_STATUS: "Selecteer boekingsstatus",
            CHECK_EXISTING: "Controleer op bestaand",
            INVALID_BOOKING_DURATION: "Reservering moet minimaal {0} uur zijn"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Dagen", "Weken"],
            REPEAT_ON: ["Maandag", "Dinsdag", "woensdag", "Donderdag", "Vrijdag", "Zaterdag", "zondag"]
        }
    },
    MENU_BAR: {
        TOP: {
            MESSAGES: "Berichten",
            SMS: "SMS",
            JOBS: "Vacatures",
            LOGOUT: "Uitloggen",
            DASHBOARD: "Mijn dashboard"
        },
        ADMIN: {
            USERS: {
                ROOT: "Gebruikers",
                CLIENTS: "Klanten",
                CANDIDATES: "Kandidaten",
                ADMINISTRATORS: "Beheerders"
            },
            JOBS_EVENTS: {
                ROOT: "Vacatures en agenda",
                SHIFT_JOB_CALENDAR: "Shift Job Kalender",
                PLACEMENT_JOBS: "Vacatures plaatsen",
                PERSONAL_TO_DO: "Persoonlijke taak"

            },
            TEMPLATES: {
                ROOT: "Sjablonen",
                EMAIL: "E-mailsjablonen",
                SMS: "SMS-sjablonen",
                DOCUMENT: "Documentsjablonen",
                NOTE: "Notitiesjablonen",
                PROFILE: "Profielsjablonen"
            },
            SETTINGS: {
                ROOT: "Instellingen",
                AGENCY: "Instellingen Agentschap",
                ADMIN: "Beheerdersinstellingen"
            },
            BUILDERS: {
                ROOT: "Bouwers",
                PROFILE: "Profielbouwer",
                EVALUATION: "Evaluatie Builder"
            },
            LOGS: {
                ROOT: "Logboeken",
                COMMUNICATION_LOG: "Communicatielogboek",
                STATUS_CHANGES: "Statuswijzigingen",
                ACTIVITY_LOG: "Activiteitenlogboek",
                PAYMENT_LOG: "Betalingslogboek",
                USER_MESSAGES_LOG: "Logboek gebruikersberichten"
            },
            OTHERS: {
                ROOT: "Anderen",
                RESOURCE_MANAGER: "Bronnenbeheer",
                REFERENCES: "Referenties",
                DOCUMENTS: "Documenten",
                EMAIL_BLASTER: "E-mailblaster",
                NOTIFICATION_CENTER: "Meldingscentrum",
                SNAPSHOT: "Momentopname",
                COMMUNITY: "Gemeenschap"
            }

        },
        CANDIDATES: {
            MY_PROFILE: "Mijn profiel",
            AVAILABLE_JOBS: "Beschikbare banen",
            MY_SCHEDULE: "Mijn schema",
            MY_JOBS: "Mijn banen",
            MY_FAMILIES: "Mijn gezinnen"
        }
    },
    NAV_BAR: {
        TOP: "Bovenste",
        CHECKLIST: "Checklist",
        DOCUMENTS: "Documenten",
        PHOTO_GALARY: "Fotogalerij",
        INTRODUCTION_VIDEO: "Introductievideo"
    },
    ENGINEHOW: {
        PROFILE_BUILDER: {
            BASIC: "Basisprincipes voor het maken van profielen",
            REQUIRE_FIELD: "Hoe kan ik vragen/veld markeren als verplicht of niet",
            NOTIFICATION_DESTINATION: "Bewerken wie op de hoogte wordt gesteld van nieuwe kandidaten"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Aan de slag met evaluaties"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Aan de slag met e-mailsjablonen",
            DEFAULT_EMAIL_FOOTER: "Uw standaard e-mailvoettekst instellen"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Aan de slag met documentsjablonen",
            NOTIFICATION_WHEN_SIGNED: "Notificatie toevoegen wanneer document is ondertekend",
            ADD_DOCUMENT: "Handmatig een document toevoegen aan een gebruiker"
        },
        AGENTSCHAP: {
            STATUSES_CHECKLISTS_TYPES: "Uw proces in kaart brengen via statussen, checklists en typen",
            AGENCY_BRANDING_SETUP: "Branding instellen voor bureaus (logo, kleuren, lettertypen)",
            PROFILE_COMPLETE_SETUP: "Hoe een \"Mijn profiel is voltooid\"-knop toevoegen Kandidaten kunnen klikken om u te laten weten dat ze hun profiel hebben voltooid",
            CONFIGURE_MULTIPLE_LOCATIONS: "Configureer uw bureau om meerdere verschillende locaties te bedienen"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Hoe e-mailexplosies werken"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "Het profiel van een kandidaat delen met een klant"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Welkom bij {0} Mission Control",
        PRO_TIP: {
            HEADER: "Bekijk wat er nieuw is:",
            TEXT: "Bulkploeg uitzenden!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Klanten bestellen door",
            ORDER_CANDIDATES_BY: "Bestel kandidaten op"
        },
        BUTTONS: {
            ADD_CLIENT: "Klant toevoegen",
            ADD_CANDIDATE: "Kandidaat toevoegen"
        }
    },
    ADD_USER_DIALOG: {
        HEADER: "Nieuwe gebruiker toevoegen",
        DESCRIPTION: "Dit is een mechanisme om handmatig een gebruiker aan uw database toe te voegen. Een gebruiker\n        toegevoegd op deze manier wordt in de status \"Pre-aanvraag\" geplaatst\n        (wat betekent dat ze nog geen aanvraagformulier hebben ingevuld). Een gebruiker in\n        deze status kan nog steeds worden verzonden om het aanvraagformulier in te vullen. als jij\n        wil automatisch een e-mail sturen naar gebruikers die op deze manier zijn toegevoegd, jij\n        kan een e-mailsjabloon toevoegen dat een \"Statuswijzigingsmelding\" is\n        triggering bij een wijziging in \"Pre Application\".",
        LABELS: {
            EMAIL: "E-mail",
            PHONE: "Telefoonnummer",
            FIRST_NAME: "Voornaam",
            LAST_NAME: "Achternaam",
            PROFILE_BUILDER: "Profielbouwer",
            USER_TYPES: "Gebruikerstypen",
            LOCATIONS: "Locaties"
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Je account is succesvol gekoppeld aan Stripe.",
        FAILED_TO_CONECT: "Er is een probleem opgetreden bij het verbinden van je account met Stripe, probeer het opnieuw of neem contact op met Enginehire.",
        MISSING_INFO: "Je account is gekoppeld, maar er ontbreekt informatie over de Stripe-applicatie, klik op de knop Verbinden met stripe om verder te gaan waar je was gebleven"
    },
    DATA_TABLE: {
        SHOW: "Toon",
        ITEMS_PER_PAGE: "items per pagina",
        SHOWING_RANGE: "Toon {0} tot {1} van {2} items"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Beheerder",
            PROFILE: "Profiel",
            INTAKE_NOTES: "Intake-aantekeningen",
            COMMUNICATION_LOG: "Communicatielogboek",
            RECORDS: "Records",
            INTAKE_NOTES_MOBILE: "Opmerkingen",
            COMMUNICATION_LOG_MOBILE: "Com-logboek"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profiel",
            NOTES: "Opmerkingen"
        },
        BUTTONS: {
            DELETE_CLIENT: "Client verwijderen"
        }
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Beheerder",
            PROFILE: "Profiel",
            INTERVIEW: "Interview",
            COMMUNICATION_LOG: "Communicatielogboek",
            RECORDS: "Records",
            COMMUNICATION_LOG_MOBILE: "Com-logboek"
        },
        INTERVIEW_TABS: {
            PROFILE: "Profiel",
            INTERVIEW: "Interview"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Kandidaat verwijderen"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Soorten",
            BUTTON: "Typen opslaan"
        },
        CHECKLIST: {
            TITLE: "Checklist",
            BUTTON: "Checklist opslaan"
        },
        TAGS: {
            TITLE: "Tagbeheer",
            BUTTON: "Tags opslaan"
        },
        LOCATIONS: {
            TITLE: "Locaties",
            BUTTON: "Locaties opslaan"
        },
        LANGUAGE: {
            TITLE: "Taal",
            BUTTON: "Taal opslaan"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Profieltype",
            BUTTON: "Profielbouwer bijwerken"
        },
        NOTES: {
            TITLE: "Opmerkingen",
            DESCRIPTION: "De hier gemaakte notities zijn alleen voor intern gebruik door beheerders, niet zichtbaar voor gebruikers.",
            BUTTON: "Notitie toevoegen"
        },
        EMAIL: {
            TITLE: "E-mail verzenden",
            BUTTON_SEND: "Verzenden",
            BUTTON_LOAD: "Laden",
            SELECT_TEMPLATE: "Sjabloon selecteren",
            FROM_EMAIL: "Van e-mail"
        },
        SMS: {
            TITLE: "Sms versturen",
            BUTTON: "Verzenden"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "U kunt hier handmatig het wachtwoord van de gebruiker opnieuw instellen",
            BUTTON: "Wachtwoord bijwerken"
        },
        EVENT: {
            TITLE: "Evenement plannen (interview, vergadering, enz.)",
            DESCRIPTION: "Deze gebeurtenissen verschijnen in het gebruikersdashboard.",
            EVENT_TITLE: "Evenementtitel",
            EVENT_DATE: "Gebeurtenisdatum",
            EVENT_TIME: "Gebeurtenistijd",
            INTERVIEW_LINK: "Interviewlink",
            INTERVIEW_LINK_PLACE_HOLDER: "Zoomlink of andere bellink",
            NOTES: "Opmerkingen",
            STATUS_UPDATE_TO: "Status om gebruiker bij te werken naar",
            SEND_EMAIL_NOTIFICATION: "Stuur een e-mailmelding van het geplande evenement",
            ADD_TO_CALENDAR: "Toevoegen aan persoonlijke takenagenda",
            BUTTON: "Evenement plannen"
        },
        CREDIT: {
            TITLE: "Tegoeden",
            BUTTON_ADD: "Tegoed toevoegen",
            BUTTON_EDIT: "Bewerken",
            EDIT_CREDIT_TITLE: "Tegoed bewerken",
            PLACE_HOLDERS: {
                VALUE: "Waarde",
                NOTES: "Opmerkingen"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Je kunt klanten hier handmatig factureren via Stripe",
            SEND_INVOICE: "Je kunt hier handmatig Stripe-facturen verzenden",
            BUTTON_CHARGE: "Opladen via streep",
            BUTTON_RESET: "Reset streepinformatie",
            BUTTON_INVOICE: "Factuur via streep",
            PAYMENT_LOGS: "Betalingslogboeken"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "Je kunt klanten hier handmatig factureren via Authorize.Net",
            SEND_INVOICE: "U kunt hier handmatig Authorize.Net-facturen verzenden",
            BUTTON_CHARGE: "Opladen via Authorize.Net",
            BUTTON_RESET: "Reset Authorize.Net-informatie",
            BUTTON_INVOICE: "Factuur via Authorize.Net",
            PAYMENT_LOGS: "Betalingslogboeken"
        },
        REVIEW: {
            TITLE: "Recensies",
            RATING: "Beoordeling",
            AVERAGE_RATING: "Gemiddelde beoordeling",
            NO_DATA: "Nog geen beoordelingen."
        },
        ADD_DOCUMENT: {
            TITLE: "Document toevoegen",
            DESCRIPTION: "Je kunt hier elk documentsjabloon aan de gebruiker toevoegen, selecteer er gewoon een\n            van uw documenten uit de vervolgkeuzelijst:",
            BUTTON: "Document toevoegen"
        },
        ADD_EVALUATIE: {
            BUTTON: "Evaluatie toevoegen"
        },
        RELATIONSHIP: {
            CANDIDATE: {
                TITLE: "Toegewezen kandidaten",
                NO_CANDIDATE: "Er zijn geen kandidaten gekoppeld aan deze klant."
            },
            CLIENT: {
                TITLE: "Toegewezen klanten",
                NO_CLIENT: "Er zijn geen klanten gelinkt aan deze kandidaat."
            },
            ADD_CANDIDATE: "Kandidaat toevoegen"
        },
        LAST_CONTACTED_DATE: "Laatste contactdatum",
        CANDIDATE_BADGES: {
            TITLE: "Kandidaatbadges",
            BUTTON: "Badges opslaan"
        }
    },
    COMMUNICATIE: {
        DATE: "Datum",
        FROM: "Van",
        TO: "Aan",
        SUBJECT: "Onderwerp",
        MESSAGE: "Bericht",
        RE_SEND: "Opnieuw verzenden"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Zoeken op functietitel, functie-ID, planning, stad, staat of beschrijving",
        JOB_HIDEN_DESCRIPTION: "Vacatures met de status \"Concept\", \"Gesloten\" of \"Gevuld\" verschijnen niet op de taak\n        board standaard. Om de status van een vacature bij te werken, klikt u op \"Vacature bewerken\".",
        CLIENT_POSTING_JOB_DESCRIPTION: "Dit is voor het plaatsen van langere termijn posities voor deze klant."
    },
    CONFIRM_DIALOGS: _en2.default,
    ERROR_DIALOGS: _en4.default,
    RESULT_DIALOGS: _en6.default,
    AGENCY_SETTINGS: _en8.default
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _el = __webpack_require__(691);

var _el2 = _interopRequireDefault(_el);

var _el3 = __webpack_require__(692);

var _el4 = _interopRequireDefault(_el3);

var _el5 = __webpack_require__(693);

var _el6 = _interopRequireDefault(_el5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    BUTTONS: {
        SUBMIT: "Υποβολή",
        PREVIOUS: "Προηγούμενο",
        NEXT: "Επόμενο",
        VIEW: "Προβολή",
        UPLOAD: "Μεταφόρτωση",
        UPLOAD_FILE: "Μεταφόρτωση αρχείου",
        VIEW_FILE: "Προβολή αρχείου",
        DELETE_FILE: "Διαγραφή αρχείου",
        CLOSE: "Κλείσιμο",
        DELETE: "Διαγραφή",
        CANCEL: "Ακύρωση",
        YES: "Ναι",
        NO: "Όχι",
        OK: "Εντάξει",
        ADD: "Προσθήκη",
        UPDATE_STATUS: "Κατάσταση ενημέρωσης",
        RETURN_DASHBOARD: "Επιστροφή στον Πίνακα ελέγχου",
        REFRESH: "Ανανέωση",
        BULK_UPDATE_STATUS: "Ενημέρωση κατάστασης επιλεγμένων",
        BULK_OVERWRITE_LOCATIONS: "Αντικατάσταση τοποθεσιών",
        BULK_OVERWRITE_TYPES: "Τύποι αντικατάστασης",
        BULK_OVERWRITE_TAGS: "Αντικατάσταση ετικετών",
        BULK_ADD_LOCATIONS: "Προσθήκη τοποθεσιών",
        BULK_ADD_TYPES: "Προσθήκη τύπων",
        BULK_ADD_TAGS: "Προσθήκη ετικετών",
        BULK_UPDATE: "Μαζική ενημέρωση",
        CHARGE_THROUGH_AUTHORIZE_NET: "Χρέωση μέσω Authorize.Net",
        CHARGE_THROUGH_STRIPE: "Φόρτιση μέσω Stripe",
        INVOICE_THROUGH_STRIPE: "Τιμολόγιο μέσω Stripe",
        ADD_USER_TO_MAILCHIMP: "Προσθήκη {0} χρηστών στο Mailchimp",
        CHARGE_CLIENT_AND_PAYOUT_CANDIDATE: "Χρέωση πελάτη και υποψήφιος πληρωμής",
        BULK_COPY_SUGGESTED_CHARGE: "Προτεινόμενη χρέωση μαζικής αντιγραφής στη συνολική χρέωση πελάτη",
        BULK_DELETE: "Διαγραφή επιλεγμένων",
        BULK_UNASSIGNED: "Κατάργηση ανάθεσης επιλεγμένων",
        EXPORT_EMPLOYERS: "Εξαγωγή λίστας αλληλογραφίας πελατών",
        EXPORT_CANDIDATES: "Export Candidate Mailing List",
        UPDATE_MANAGER: "Ενημέρωση {0}",
        VIEW_PROFILE: "Προβολή προφίλ",
        VIEW_OFFER: "Προβολή προσφοράς",
        SAVE: "Αποθήκευση",
        EXPAND_ALL: "Ανάπτυξη όλων",
        COLLAPSE_ALL: "Σύμπτυξη όλων",
        SELECT_ALL: "Επιλογή όλων",
        UNSELECT_ALL: "Κατάργηση επιλογής όλων",
        RESET_FILTERS: "Επαναφορά φίλτρων",
        CLOCK_IN: "Ρολόι μέσα",
        ADD_A_BREAK: "Προσθήκη διαλείμματος",
        CLOCK_OUT: "Clock Out",
        CONFIRM_CLOCK_IN_OUT: "Επιβεβαίωση πελάτη",
        LEAVE_REVIEW: "Αφήστε μια κριτική",
        DECLINE: "Απόρριψη",
        DECLINE_WITHOUT_NOTIFICATION: "Απόρριψη χωρίς ειδοποίηση",
        UNDECLINE: "Απόρριψη",
        ACCEPT: "Αποδοχή",
        CHECK_PAYMENT: "Έλεγχος έκφρασης πληρωμής",
        CREATE_SNAPSHOT_APPLICATION_FORM: "Αποθήκευση τρέχουσας φόρμας αίτησης",
        RESTORE_APPLICATION_FORM: "Επαναφορά αποθηκευμένης έκδοσης εφαρμογής",
        RETURNING_APPLICANT: "Είμαι υποψήφιος που επιστρέφει",
        AAASSIGN: "Ανάθεση",
        TENTATIVELY_ASSIGN: "Προσωπικά εκχώρηση",
        SIGN: "Sign",
        EDIT: "Επεξεργασία",
        DUPLICATE: "Διπλότυπο",
        ADD_ADDITIONAL_DATES: "Προσθήκη πρόσθετων ημερομηνιών",
        ADD_A_BOOKING: "Προσθήκη κράτησης",
        ADD_A_GROUP: "Προσθήκη ομάδας",
        MESSAGE: "Μήνυμα",
        UPDATE_CUSTOM_STATUS: "Ενημέρωση κατάστασης {0}",
        UPDATE: "Ενημέρωση",
        ADD_OPTION: "Προσθήκη επιλογής",
        EDIT_SETTING: "Επεξεργασία ρυθμίσεων",
        AADONE: "Τέλος",
        SUBMIT_REPORT: "Υποβολή αναφοράς",
        REVIEW_REPORT_BUTTON: "Προβολή προβλημάτων που έχουν αναφερθεί",
        SEARCH_CANDIDATES_FOR_ALL_BOOKING: "Αναζήτηση για υποψήφιους διαθέσιμους για όλες τις ανοιχτές κρατήσεις",
        SHARE_WITH_MARKET_PLACE: "Κοινή χρήση με το Agency Marketplace",
        CUSTOMIZE_TEMPLATE: "Προσαρμογή προτύπου"
    },
    PLACE_HOLDERS: {
        NEW_STATUS: "Νέα κατάσταση",
        NEW_LOCATIONS: "Νέες τοποθεσίες",
        NEW_TYPES: "Νέοι τύποι",
        NEW_TAGS: "Νέες ετικέτες",
        FILTER_BY_STATUS: "Φιλτράρισμα κατά κατάσταση",
        FILTER_BY_STATUSES: "Φιλτράρισμα κατά καταστάσεις",
        FILTER_BY: "Φιλτράρισμα κατά {0}",
        STATUSES_TO_HIDE: "Καταστάσεις προς απόκρυψη",
        FILTER_BY_LOCATIONS: "Φιλτράρισμα κατά τοποθεσίες",
        FILTER_BY_DURATIONS: "Φιλτράρισμα κατά Διάρκεια",
        FILTER_BY_ROLES: "Φιλτράρισμα κατά ρόλους",
        FILTER_BY_TYPES: "Φιλτράρισμα κατά τύπους",
        FILTER_BY_TAGS: "Φιλτράρισμα κατά ετικέτες",
        FILTER_BY_MANAGER: "Φιλτράρισμα κατά διαχειριστή",
        FILTER_BY_CLIENT: "Φίλτρο ανά πελάτη",
        FILTER_BY_CATEGORIES: "Φιλτράρισμα κατά κατηγορίες",
        FILTER_BY_START_DATE: "Φιλτράρισμα κατά ημερομηνία έναρξης",
        FILTER_BY_END_DATE: "Φιλτράρισμα κατά ημερομηνία λήξης",
        FILTER_BY_WEEK_DAY: "Φιλτράρισμα ανά εβδομάδα ημέρας",
        FILTER_BY_CLIENTS: "Φιλτράρισμα κατά πελάτες",
        FILTER_BY_CLIENT_STATUSES: "Filter by Client Statuses",
        FILTER_BY_CLIENT_TYPES: "Φιλτράρισμα κατά τύπους πελατών",
        FILTER_BY_CANDIDATES: "Φίλτρο κατά υποψήφιο(ους)",
        FILTER_BY_JOB_TYPES: "Φιλτράρισμα κατά τύπους εργασίας",
        FILTER_BY_JOB_STATUSES: "Φιλτράρισμα κατά καταστάσεις εργασίας",
        FILTER_BY_JOB_ID: "Φιλτράρισμα κατά αναγνωριστικό εργασίας",
        SELECT_SCRAPER_ACCOUNTS: "Select Scraper Accounts",
        FILTER_BY_USER_TYPE: "Φιλτράρισμα κατά τύπο χρήστη",
        KEYWORD_SEARCH_USER_PROFILE: "Αναζήτηση λέξης-κλειδιού/φράσης οπουδήποτε στο προφίλ χρήστη, πατήστε Enter για εφαρμογή αναζήτησης",
        SEARCH_BY_NAME_EMAIL_PHONE: "Αναζήτηση κατά όνομα, email ή αριθμό τηλεφώνου",
        FILTER_BY_RECENT_ACTIVE: "Filter by Recently Active",
        SELECT_LOCATIONS: "Επιλογή τοποθεσιών",
        SELECT_OPTION: "Επιλογή επιλογής",
        SELECT_CLIENT: "Επιλογή πελάτη",
        SELECT_CANDIDATE: "Επιλέξτε υποψήφιο",
        SELECT_CANDIDATES: "Επιλογή υποψηφίων",
        SELECT_CANDIDATE_SEARCHABLE: "Επιλέξτε υποψήφιο (Τύπος για αναζήτηση)",
        SELECT_ADMINS: "Επιλογή διαχειριστών",
        SELECT_ADMIN_RECEIVE_EMAIL: "Επιλέξτε διαχειριστές που λαμβάνουν μηνύματα ηλεκτρονικού ταχυδρομείου",
        SELECT_STATUS: "Επιλογή κατάστασης",
        SELECT_LANGUAGES: "Επιλογή γλωσσών",
        SELECT_TYPES: "Επιλέξτε τύπους",
        SELECT_TYPE: "Επιλέξτε τύπο",
        SELECT_AUDIENCE: "Επιλογή κοινού",
        SELECT_TAGS: "Επιλογή ετικετών",
        SELECT_USER_TYPE: "Επιλογή τύπου χρήστη",
        SELECT_USER_TYPES: "Επιλογή τύπων χρηστών",
        SELECT_CATEGORY: "Επιλογή κατηγορίας",
        SELECT_CATEGORY_ADMIN_ONLY: "Επιλογή κατηγορίας (Μόνο διαχειριστής)",
        SELECT_TRIGGER: "Επιλογή ενεργοποίησης",
        SELECT_ONE: "Επιλέξτε ένα",
        SELECT_PROFILE_BUILDER: "Επιλέξτε το πρόγραμμα δημιουργίας προφίλ",
        SELECT_TIME_OFF_CATEOGRY: "Επιλογή κατηγορίας χρόνου απενεργοποίησης",
        SELECT_DESTINATION: "Επιλογή προορισμού",
        SELECT_ACCESS_LEVEL: "Επιλογή επιπέδου πρόσβασης",
        SELECT_VISIBILITY_SCOPE: "Επιλογή εύρους ορατότητας",
        SELECT_AREAS: "Επιλογή Περιοχών",
        NUMBER: "Αριθμός",
        DESCRIPTION_CHARGE: "Περιγραφή χρέωσης (αυτή η περιγραφή θα περιλαμβάνεται στην απόδειξη του χρήστη)"
    },
    LABELS: {
        SELECT_TEMPLATE: "Επιλογή προτύπου",
        SELECT_ANALYTICS_DASHBOARD_FIELDS: "Επιλογή πεδίων για αναλυτικά στοιχεία",
        FILTER_BY_LOCATIONS: "Φιλτράρισμα κατά τοποθεσίες",
        FILTER_BY_TYPES: "Φιλτράρισμα κατά τύπους",
        FILTER_BY_MANAGER: "Φιλτράρισμα κατά διαχειριστή",
        FILTER_BY_CLIENT: "Φίλτρο ανά πελάτη",
        FILTER_BY_CATEGORIES: "Φιλτράρισμα κατά κατηγορίες",
        FILTER_BY_STATUS: "Φιλτράρισμα κατά κατάσταση",
        ADDRESS: "Διεύθυνση",
        CITY: "Πόλη",
        AASTATE: "Πολιτεία",
        COUNTRY: "Χώρα",
        ZIP_CODE: "Ταχυδρομικός κώδικας",
        LOCATIONS: "Τοποθεσίες",
        DESCRIPTION: "Περιγραφή",
        PER_HOUR: "ανά ώρα",
        ADD_ITEM: "Προσθήκη {0}",
        EDIT_ITEM: "Επεξεργασία {0}",
        SAVE_AND_ADD_ANOTHER_ITEM: "Αποθήκευση και προσθήκη άλλου {0}",
        WELCOME_TEXT: "Καλώς ήρθατε στο {0}"
    },
    HEADERS: {
        EMAIL_LOG: "Αρχείο ηλεκτρονικού ταχυδρομείου",
        SMS_LOG: "Αρχείο SMS"
    },
    LINK_TEXT: {
        HIDE_STATUS_BY_DEFAULT: "Πώς να αποκρύψετε τις καταστάσεις από προεπιλογή",
        HOW_TO_CHANGE_STATUS: "Πώς να προσθέσετε/αλλάξετε καταστάσεις"
    },
    DESCRIPTIONS: {
        SEPARATE_MULTIPLE_EMAIL: "Διαχωρίστε πολλαπλά μηνύματα ηλεκτρονικού ταχυδρομείου με ; (π.χ.: nanny1@hotmail.com; nanny2@hotmail.com )",
        SMS_NOTE: "\u039B\u03AC\u03B2\u03B5\u03C4\u03B5 \u03C5\u03C0\u03CC\u03C8\u03B7 \u03CC\u03C4\u03B9 \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03BA\u03CC\u03C3\u03C4\u03BF\u03C2 0,0115 $ (1,15\xA2) \u03B1\u03BD\u03AC 160 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2 \u03C4\u03C9\u03BD \u03B1\u03C0\u03B5\u03C3\u03C4\u03B1\u03BB\u03BC\u03AD\u03BD\u03C9\u03BD/\u03BB\u03B7\u03C6\u03B8\u03AD\u03BD\u03C4\u03C9\u03BD SMS.",
        SMS_COUNTER_NOTE: "Ο ακριβής αριθμός χαρακτήρων θα εξαρτηθεί από τις πληροφορίες που εισάγονται στο πραγματικό μήνυμα.",
        CLIENT_NOT_ENTERED_STRIPE: "Ο πελάτης δεν έχει εισαγάγει πληροφορίες Stripe.",
        CLIENT_NOT_ENTERED_AUTHORIZE_NET: "Ο πελάτης δεν έχει καταχωρίσει πληροφορίες Authorize.Net.",
        CANDIDATE_NOT_ENTERED_STRIPE: "Ο υποψήφιος δεν έχει εισαγάγει πληροφορίες Stripe.",
        INTERVIEW_PANEL: "\u03A3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7: \u0391\u03C5\u03C4\u03AD\u03C2 \u03BF\u03B9 \u03C3\u03B7\u03BC\u03B5\u03B9\u03CE\u03C3\u03B5\u03B9\u03C2 \u03C0\u03C1\u03BF\u03BF\u03C1\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03BC\u03CC\u03BD\u03BF \u03B3\u03B9\u03B1 \u03B5\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03AE \u03C7\u03C1\u03AE\u03C3\u03B7 \u03B4\u03B9\u03B1\u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9\n         \u03BA\u03BF\u03B9\u03BD\u03CC\u03C7\u03C1\u03B7\u03C3\u03C4\u03BF \u03BC\u03B5 \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C5\u03C2 \u03AE \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2.",
        CANDIDATE_SHAREABLE_LINK: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03BC\u03B5 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03BF\u03B9\u03BD\u03AE\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03BF\u03C5. \u0391\u03BD \u03B8\u03AD\u03BB\u03B5\u03B9\u03C2\n         \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B9 \u03B8\u03B1 \u03B4\u03B5\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2, <strong>\u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B1\u03C0\u03BF\u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF</strong> \u03BA\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1\n         \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF (\u03AE \u03B1\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03B7\u03C2). \u0391\u03C5\u03C4\u03CC\u03C2 <strong>\u03B4\u03B5\u03BD</strong> \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BF\u03C0\u03BF\u03AF\u03BF \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF \u03BF \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2 \u03C3\u03B1\u03C2. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1.</a>",
        CLIENT_SHAREABLE_LINK: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03BC\u03B5 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03BF\u03B9\u03BD\u03AE\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7. \u0391\u03BD \u03B8\u03AD\u03BB\u03B5\u03B9\u03C2\n         \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B9 \u03B8\u03B1 \u03B4\u03B5\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C2, <strong>\u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B1\u03C0\u03BF\u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF</strong> \u03BA\u03B1\u03B9 \u03BC\u03B5\u03C4\u03AC\n         \u03B4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF (\u03AE \u03B1\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03B5 \u03B4\u03B9\u03B1\u03C6\u03BF\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03B7\u03C2). \u0391\u03C5\u03C4\u03CC\u03C2 <strong>\u03B4\u03B5\u03BD</strong> \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03BC\u03B5 \u03C4\u03BF\u03BD \u03BF\u03C0\u03BF\u03AF\u03BF \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03BF\u03CD\u03BD \u03BF\u03B9 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2 \u03C3\u03B1\u03C2. <a href=\"https://youtu.be/WXjyLdF12O0\" target=\"_blank\">\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1.</a>",
        CLIENT_PUBLIC_PAYMENT_LINK: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03B4\u03B7\u03BC\u03CC\u03C3\u03B9\u03BF\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2. \u039F \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03B9 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C7\u03C9\u03C1\u03AF\u03C2 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF",
        TYPE_YOUR_NAME_TO_SIGN: 'Πληκτρολογήστε το όνομά σας για υπογραφή (συμφωνείτε ότι αυτό ισοδυναμεί με την υπογραφή ενός φυσικού εγγράφου)',
        JOB_BOARD_ADMIN_VIEW_WARNING: "Βλέπετε αυτόν τον πίνακα εργασιών ως διαχειριστής. Εάν θέλετε να το δείτε από την οπτική γωνία ενός υποψηφίου, ανοίξτε το σε διαφορετικό παράθυρο προγράμματος περιήγησης ή ανώνυμης περιήγησης. Εάν χρειάζεστε βοήθεια για την ενσωμάτωση αυτού στον ιστότοπό σας, επικοινωνήστε μαζί μας!"
    },
    TABLE_HEADERS: {
        ACTIONS: "Ενέργειες",
        NOTES: "Σημειώσεις",
        VALUE: "Αξία",
        EFFECTIVE_FROM: "Εφαρμόζεται από",
        EFFECTIVE_UNTIL: "Ισχύει μέχρι",
        TYPE: "Τύπος",
        CATEGORIES: "Κατηγορίες"
    },
    OPTIONS: {
        "YES": "Ναι",
        "NO": "Όχι"
    },
    ERROR_ΜΗΝΥΜΑΤΑ: {
        FIELD_REQUIRED: "Αυτό το πεδίο είναι υποχρεωτικό."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Ευχαριστώ!",
        STEP_OF: "Βήμα {0} από {1}"
    },
    REFERENCE_CHECK_FORM: {
        FILL_THE_FORM_REQUEST: "Βοηθήστε μας να συμπληρώσουμε την παρακάτω φόρμα",
        REFERENCE_FOR: "Reference for {0} {1}",
        REFERENCE_INPUT_BY: "Πληροφορίες αναφοράς που εισάγονται από τον χρήστη {0} {1}",
        FORM_SUBMITTED: "Η φόρμα ελέγχου αναφοράς έχει υποβληθεί!"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Αποθέστε ένα αρχείο εδώ ή κάντε κλικ για μεταφόρτωση",
        MAXIMUM_UPLOAD_SIZE: "Μέγιστο μέγεθος μεταφόρτωσης {0}MB",
        FILE_EXCEED_MAXIMUM: "Το μέγεθος αρχείου υπερβαίνει τα {0}MB.",
        FILE: "Αρχείο"
    },
    BOOKING_SECTION: {
        LABEL: {
            BOOKINGS: "Κρατήσεις",
            HIDE_PAST_BOOKINGS: "Απόκρυψη προηγούμενων κρατήσεων",
            BOOKING_CREDIT_LEFT: "Απομένουν {0} πιστώσεις κράτησης",
            MIN_BOOKINGS_REQUIRE: "Χρειάζεστε τουλάχιστον {0} κράτηση!",
            SELECTED_CANDIDATE: "Επιλεγμένος υποψήφιος",
            TOTAL_BOOKING_FEE: "Συνολική χρέωση κράτησης",
            BOOKING_GROUPS: "Ομάδες κρατήσεων"
        },
        DESCRIPTION: {
            CLICK_ON_BOOKING: "Κάντε κλικ στην κράτηση (στο ημερολόγιο) για να μάθετε περισσότερα σχετικά με τον παροχέα υπηρεσιών που σας έχει ανατεθεί και να αφήσετε μια κριτική.",
            CLICK_ON_DATE: "Παρακαλώ κάντε κλικ σε μια ημερομηνία για να προσθέσετε μια κράτηση.",
            CLICK_ON_OTHER_DATE: "Παρακαλώ κάντε κλικ σε άλλη ημερομηνία στο ημερολόγιο για να προσθέσετε μια κράτηση.",
            BOOKING_GROUP: "Όλες οι κρατήσεις στην ίδια ομάδα πρέπει να ανατεθούν σε έναν εκδοχέα"
        },
        PRICES: {
            BOOKING_RATE: "Ποσοστό κράτησης",
            BOOKING_FEE: "Χρέωση κράτησης",
            PER_BOOKING_FEE: "Ανά κράτηση",
            CLIENT_RATE: "Ποσοστό πελάτη",
            CANDIDATE_RATE: "Ποσοστό υποψηφίου",
            AGENCY_FEE: "Χρέωση πρακτορείου",
            TRAVEL_FEE: "Τέλη ταξιδιού",
            RUSH_FEE: "Χρέωση αιχμής",
            CANDIDATE_RUSH_FEE: "Τέλος βιασύνης υποψηφίου",
            PER_BOOKING_AGENCY_FEE: "Χρέωση πρακτορείου ανά κράτηση",
            PER_BOOKING_CANDIDATE_FEE: "Τέλη ανά κράτηση υποψηφίου",
            ADMIN_FEE: "Χρέωση διαχειριστή",
            ADMIN_PERCENTAGE: "Ποσοστό διαχειριστή",
            ADDITIONAL_FEES: "Πρόσθετες χρεώσεις"
        }
    },
    BOOKING_DIALOG: {
        LABEL: {
            ADDITIONAL_DATES: "Προσθήκη πρόσθετων ημερομηνιών",
            START_TIME: "Ώρα έναρξης",
            END_TIME: "Ώρα λήξης",
            END_DATE: "Ημερομηνία λήξης",
            SELECT_CLIENT: "Επιλογή πελάτη",
            ASSIGNED_CANDIDATE: "Θέλετε να αναθέσετε αυτήν την εργασία;",
            TENTATIVELY_ASSIGN_CANDIDATE: "Θέλετε να αναθέσετε προσωρινά αυτήν την εργασία;",
            REPEAT: "Θέλετε αυτήν την υπηρεσία περισσότερες από μία φορές (επαναλαμβανόμενη/επαναλαμβανόμενη);",
            REPEAT_UNTIL: "Επανάληψη μέχρι",
            REPEAT_EVERY: "Επανάληψη κάθε",
            REPEAT_ON: "Επανάληψη ενεργό",
            BOOKING_ADDRESS: "Διεύθυνση κράτησης",
            ADDRESS_LINE2: "Γραμμή διεύθυνσης 2",
            CITY: "Πόλη",
            STATE: "Πολιτεία/Επαρχία",
            ZIP_CODE: "Ταχυδρομικός κώδικας",
            NUMBER_CHILDREN: "Πόσα παιδιά θα φροντίσουν;",
            SELECT_JOB_CATEGORY: "Επιλέξτε κατηγορία εργασίας",
            SELECT_DATE: "Ημερομηνία κράτησης",
            SELECT_SERVICE: "Επιλογή υπηρεσίας",
            SELECT_QUICKBOOKS_PRICE: "Επιλογή τιμής",
            NUMBER_CANDIDATE: "Αριθμός {0} που χρειάζονται",
            SELECT_STATUS: "Επιλογή κατάστασης κράτησης",
            CHECK_EXISTING: "Έλεγχος για υπάρχοντα",
            INVALID_BOOKING_DURATION: "Η κράτηση πρέπει να είναι τουλάχιστον {0} ώρες"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Ημέρες", "Εβδομάδες"],
            REPEAT_ON: ["Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο", "Κυριακή"]
        }
    },
    MENU_BAR: {
        TOP: {
            COMMUNITY: "Κοινότητα",
            CANDIDATE_COMMUNITY: "Υποψήφια Κοινότητα",
            MARKETPLACE: "Marketplace",
            MESSAGES: "Μηνύματα",
            SMS: "SMS",
            JOBS: "Δουλειές",
            LOGOUT: "Αποσύνδεση",
            DASHBOARD: "Ο πίνακας ελέγχου μου"
        },
        ADMIN: {
            USERS: {
                ROOT: "Χρήστες",
                CLIENTS: "Πελάτες",
                CANDIDATES: "Υποψήφιοι",
                ADMINISTRATORS: "Διαχειριστές"
            },
            JOBS_EVENTS: {
                ROOT: "Εργασίες και Ημερολόγιο",
                SHIFT_JOB_CALENDAR: "Shift Job Calendar",
                PLACEMENT_JOBS: "Εργασίες τοποθέτησης",
                PERSONAL_TO_DO: "Personal To Do"

            },
            TEMPLATES: {
                ROOT: "Πρότυπα",
                EMAIL: "Πρότυπα email",
                SMS: "Πρότυπα SMS",
                DOCUMENT: "Πρότυπα εγγράφων",
                NOTE: "Πρότυπα σημειώσεων",
                TASK: "Πρότυπα εργασιών",
                PROFILE: "Πρότυπα προφίλ",
                PUSH_NOTIFICATION: "Πρότυπα ειδοποιήσεων Push"
            },
            SETTINGS: {
                ROOT: "Ρυθμίσεις",
                AGENCY: "Ρυθμίσεις πρακτορείου",
                ADMIN: "Ρυθμίσεις διαχειριστή"
            },
            BUILDERS: {
                AAROOT: "Builders",
                PROFILE: "Application & Profile Builder",
                EVALUATION: "Evaluation Builder"
            },
            LOGS: {
                ROOT: "Καταγραφή",
                COMMUNICATION_LOG: "Αρχείο επικοινωνίας",
                STATUS_CHANGES: "Αλλαγές κατάστασης",
                ACTIVITY_LOG: "Αρχείο καταγραφής δραστηριότητας",
                APPLICATION_LOG: "Αρχείο καταγραφής εφαρμογής",
                PAYMENT_LOG: "Αρχείο πληρωμών",
                USER_MESSAGES_LOG: "Αρχείο συνομιλίας χρήστη"
            },
            OTHERS: {
                AAROOT: "Άλλα",
                RESOURCE_MANAGER: "Διαχειριστής πόρων",
                REFERENCES: "Αναφορές",
                DOCUMENTS: "Documents",
                EMAIL_BLASTER: "Email Blaster",
                NOTIFICATION_CENTER: "Κέντρο ειδοποιήσεων",
                SNAPSHOT: "Μετρήσεις και ανάλυση (στιγμιότυπο)",
                COMMUNITY: "Κοινότητα",
                DAILY_RESOURCE_MANAGER: "Daily Resource Manager",
                GLOBAL_PREDEFINED_VALUES: "Συνολικές προκαθορισμένες τιμές",
                BENEFIT_MANAGER: "Benefit Manager",
                BENEFITS: "Πλεονεκτήματα",
                TRASH: "Κάδος απορριμμάτων"
            }

        },
        CANDIDATES: {
            MY_PROFILE: "Το προφίλ μου",
            AVAILABLE_JOBS: "Διαθέσιμες εργασίες",
            MY_SCHEDULE: "Το πρόγραμμά μου",
            MY_JOBS: "Οι δουλειές μου",
            MY_FAMILIES: "Οι οικογένειές μου",
            BENEFITS: "Πλεονεκτήματα"
        },
        ADMIN_PANEL: {
            LISTS: "Λίστες",
            NOTES: "Σημειώσεις",
            EMAIL_SMS: "Email/SMS",
            EVENT: "Προγραμματισμός εκδήλωσης",
            PASSWORD: "Κωδικός πρόσβασης",
            PAYMENTS: "Πληρωμές",
            PAYMENTS_CREDIT: "Πληρωμές/Πιστώσεις",
            DOCUMENTS: "Documents",
            EVALUATIONS: "Αξιολογήσεις",
            RELATIONSHIPS: "Ανατεθέντες υποψήφιοι"
        },
        ADMIN_PANEL_SHORT: {
            EMAIL_SMS: "Email/SMS",
            EVENT: "Εκδήλωση",
            PASSWORD: "Pass",
            DOCUMENTS: "Έγγραφα",
            EVALUATIONS: "Evals",
            PAYMENTS: "$$$",
            RELATIONSHIPS: "Assign Cands"
        }
    },
    NAV_BAR: {
        TOP: "Κορυφαία",
        CHECKLIST: "Λίστα ελέγχου",
        DOCUMENTS: "Documents",
        PHOTO_GALARY: "Photo Gallery",
        INTRODUCTION_VIDEO: "Introduction Video"
    },
    ENGINEWHO: {
        PROFILE_BUILDER: {
            BASIC: "Βασικά στοιχεία του προγράμματος δημιουργίας προφίλ",
            REQUIRE_FIELD: "Πώς να επισημάνετε ερωτήσεις/πεδίο ως απαιτούμενο ή όχι",
            NOTIFICATION_DESTINATION: "Επεξεργασία Ποιος ειδοποιείται για νέους αιτούντες",
            EDIT_APPLICATION: "Πώς να επεξεργαστείτε φόρμες αιτήσεων πιο εύκολα",
            ADD_SECTION_QUESTION: "Πώς να προσθέσετε μια ερώτηση σε μια ενότητα",
            ADD_CONFIRMATION_BOX: "Πώς να προσθέσετε πεδία επιβεβαίωσης σε φόρμες αίτησης πελάτη ή υποψηφίου"
        },
        EVALUATION_BUILDER: {
            GETTING_STARTED: "Ξεκινώντας με τις αξιολογήσεις"
        },
        EMAIL_TEMPLATES: {
            GETTING_STARTED: "Ξεκινώντας με τα πρότυπα ηλεκτρονικού ταχυδρομείου",
            DEFAULT_EMAIL_FOOTER: "Ρύθμιση του προεπιλεγμένου υποσέλιδου ηλεκτρονικού ταχυδρομείου"
        },
        DOCUMENT_TEMPLATES: {
            GETTING_STARTED: "Ξεκινώντας με τα πρότυπα εγγράφων",
            NOTIFICATION_WHEN_SIGNED: "Προσθήκη ειδοποίησης όταν υπογράφεται το έγγραφο",
            ADD_DOCUMENT: "Μη αυτόματη προσθήκη εγγράφου σε χρήστη"
        },
        AGENCY: {
            STATUSES_CHECKLISTS_TYPES: "Χαρτογράφηση της διαδικασίας σας μέσω καταστάσεων, λιστών ελέγχου και τύπων",
            AGENCY_BRANDING_SETUP: "Ρύθμιση επωνυμίας εταιρείας (λογότυπο, χρώματα, γραμματοσειρές)",
            PROFILE_COMPLETE_SETUP: 'Πώς να προσθέσετε ένα κουμπί "Το προφίλ μου είναι πλήρες" Οι υποψήφιοι μπορούν να κάνουν κλικ για να σας ειδοποιήσουν ότι έχουν ολοκληρώσει το προφίλ τους',
            CONFIGURE_MULTIPLE_LOCATIONS: "Διαμόρφωση της εταιρείας σας ώστε να εξυπηρετεί πολλές διακριτές τοποθεσίες"
        },
        EMAIL_BLASTER: {
            HOW_TO: "Πώς λειτουργούν οι εκρήξεις email"
        },
        CLIENTS: {
            SHARE_CANDIDATE_PROFILE: "Πώς να μοιραστείτε το προφίλ ενός υποψηφίου με έναν πελάτη"
        }
    },
    ADMIN_DASHBOARD: {
        WELCOME_HEADER: "Καλώς ήρθατε στο Έλεγχος αποστολής {0}",
        PRO_TIP: {
            HEADER: "Δείτε τι νέο υπάρχει:",
            TEXT: "Μαζική μετάδοση εργασιών με βάρδιες!"
        },
        PLACE_HOLDERS: {
            ORDER_CLIENTS_BY: "Παραγγελία πελατών από",
            ORDER_CANDIDATES_BY: "Παραγγελία υποψηφίων κατά"
        },
        BUTTONS: {
            ADD_CLIENT: "Προσθήκη πελάτη",
            ADD_CANDIDATE: "Προσθήκη υποψηφίου"
        }
    },
    ADD_USER_DIALOG: {
        HEADER: "Προσθήκη νέου χρήστη",
        DESCRIPTION: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1\u03C2 \u03BC\u03B7\u03C7\u03B1\u03BD\u03B9\u03C3\u03BC\u03CC\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03BC\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B7 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03BD\u03CC\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7 \u03C3\u03C4\u03B7 \u03B2\u03AC\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C3\u03B1\u03C2. \u0388\u03BD\u03B1\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7\u03C2\n         \u03A4\u03BF addded \u03BC\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF \u03B8\u03B1 \u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \"Pre Application\".\n         (\u03C0\u03BF\u03C5 \u03C3\u03B7\u03BC\u03B1\u03AF\u03BD\u03B5\u03B9 \u03CC\u03C4\u03B9 \u03B4\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03B9 \u03B1\u03BA\u03CC\u03BC\u03B7 \u03BC\u03B9\u03B1 \u03B1\u03AF\u03C4\u03B7\u03C3\u03B7). \u0388\u03BD\u03B1\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7\u03C2 \u03C3\u03B5\n         \u03B1\u03C5\u03C4\u03AE \u03B7 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03B1\u03BA\u03CC\u03BC\u03B1 \u03BD\u03B1 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03C3\u03C5\u03BC\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C6\u03CC\u03C1\u03BC\u03B1\u03C2 \u03B1\u03AF\u03C4\u03B7\u03C3\u03B7\u03C2. \u0391\u03BD \u03B5\u03C3\u03CD\n         would \u03BD\u03B1 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03B9 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03AD\u03BD\u03B1 email \u03C3\u03C4\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2 \u03C0\u03BF\u03C5 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03BC\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C4\u03C1\u03CC\u03C0\u03BF, \u03B5\u03C3\u03B5\u03AF\u03C2\n         \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03B9 \u03AD\u03BD\u03B1 \u03C0\u03C1\u03CC\u03C4\u03C5\u03C0\u03BF email \u03C0\u03BF\u03C5 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B9\u03B1 \"\u0395\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2\"\n         triggering \u03C3\u03B5 \u03BC\u03B9\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \"\u03A0\u03C1\u03BF \u0395\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\".",
        LABELS: {
            EMAIL: "Email",
            PHONE: "Αριθμός τηλεφώνου",
            FIRST_NAME: "Όνομα",
            LAST_NAME: "Επώνυμο",
            PROFILE_BUILDER: "Profile Builder",
            USER_TYPES: "Τύποι χρηστών",
            LOCATIONS: "Τοποθεσίες"
        }
    },
    STRIPE: {
        CONNECTED_SUCCESS: "Ο λογαριασμός σας συνδέθηκε επιτυχώς με το Stripe.",
        FAILED_TO_CONECT: "Παρουσιάστηκε πρόβλημα με τη σύνδεση του λογαριασμού σας με το Stripe, δοκιμάστε ξανά ή επικοινωνήστε με την Enginehire.",
        MISSING_INFO: "Ο λογαριασμός σας έχει συνδεθεί, αλλά λείπουν πληροφορίες από την εφαρμογή Stripe, κάντε κλικ στο κουμπί σύνδεση με τη λωρίδα για να συνεχίσετε από εκεί που σταματήσατε"
    },
    DATA_TABLE: {
        SHOW: "Εμφάνιση",
        ITEMS_PER_PAGE: "στοιχεία ανά σελίδα",
        SHOWING_RANGE: "Εμφάνιση {0} έως {1} από {2} καταχωρήσεις"
    },
    EMPLOYER_DIALOG: {
        TABS: {
            ADMIN: "Διαχειριστής",
            PROFILE: "Προφίλ",
            INTAKE_NOTES: "Σημειώσεις εισαγωγής",
            COMMUNICATION_LOG: "Αρχείο επικοινωνίας",
            RECORDS: "Records",
            JOBS: "Δουλειές",
            INTAKE_NOTES_MOBILE: "Σημειώσεις",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Προφίλ",
            AANOTES: "Σημειώσεις"
        },
        BUTTONS: {
            DELETE_CLIENT: "Διαγραφή πελάτη"
        }
    },
    CANDIDATE_DIALOG: {
        TABS: {
            ADMIN: "Διαχειριστής",
            PROFILE: "Προφίλ",
            INTERVIEW: "Συνέντευξη",
            COMMUNICATION_LOG: "Αρχείο επικοινωνίας",
            RECORDS: "Records",
            COMMUNICATION_LOG_MOBILE: "Com Log"
        },
        INTERVIEW_TABS: {
            PROFILE: "Προφίλ",
            INTERVIEW: "Συνέντευξη"
        },
        BUTTONS: {
            DELETE_CANDIDATE: "Διαγραφή υποψηφίου"
        }
    },
    ADMIN_PANEL: {
        TYPES: {
            TITLE: "Τύποι",
            BUTTON: "Αποθήκευση τύπων"
        },
        CHECKLIST: {
            TITLE: "Λίστα ελέγχου",
            BUTTON: "Αποθήκευση λίστας ελέγχου"
        },
        TAGS: {
            TITLE: "Ετικέτες",
            BUTTON: "Αποθήκευση ετικετών"
        },
        ΑΑΑΑΑΑΑΑΑΑΑΑΑ_ΤΟΠΟΘΕΣΙΕΣ: {
            TITLE: "Τοποθεσίες",
            BUTTON: "Αποθήκευση τοποθεσιών"
        },
        LANGUAGE: {
            TITLE: "Γλώσσα",
            BUTTON: "Αποθήκευση γλώσσας"
        },
        SET_PROFILE_BUILDER: {
            TITLE: "Τύπος προφίλ",
            BUTTON: "Ενημέρωση προγράμματος δημιουργίας προφίλ"
        },
        NOTES: {
            TITLE: "Σημειώσεις",
            DESCRIPTION: "Οι σημειώσεις που λαμβάνονται εδώ προορίζονται μόνο για εσωτερική χρήση διαχειριστή, δεν είναι ορατές στους χρήστες.",
            BUTTON: "Προσθήκη Σημείωσης"
        },
        AAEMAIL: {
            TITLE: "Αποστολή email",
            BUTTON_SEND: "Αποστολή",
            BUTTON_LOAD: "Φόρτωση",
            SELECT_TEMPLATE: "Επιλογή προτύπου",
            FROM_EMAIL: "Από email",
            REPLY_TO: "Απάντηση σε",
            SUBJECT: "Θέμα"
        },
        SMS: {
            TITLE: "Αποστολή SMS",
            BUTTON: "Αποστολή"
        },
        RESET_PASSWORD: {
            DESCRIPTION: "Μπορείτε να επαναφέρετε μη αυτόματα τον κωδικό πρόσβασης του χρήστη εδώ",
            BUTTON: "Ενημέρωση κωδικού πρόσβασης"
        },
        EVENT: {
            TITLE: "Προγραμματισμός εκδήλωσης (Συνέντευξη, Συνάντηση, κ.λπ.)",
            DESCRIPTION: "Αυτά τα συμβάντα θα εμφανιστούν στον πίνακα ελέγχου του χρήστη.",
            EVENT_TITLE: "Τίτλος εκδήλωσης",
            EVENT_DATE: "Ημερομηνία εκδήλωσης",
            EVENT_TIME: "Ώρα εκδήλωσης",
            INTERVIEW_LINK: "Σύνδεσμος συνέντευξης",
            INTERVIEW_LINK_PLACE_HOLDER: "Σύνδεσμος ζουμ ή άλλος σύνδεσμος κλήσης",
            NOTES: "Σημειώσεις",
            STATUS_UPDATE_TO: "{0} για ενημέρωση χρήστη σε",
            SEND_EMAIL_NOTIFICATION: "Αποστολή ειδοποίησης μέσω email για προγραμματισμένη εκδήλωση",
            ADD_TO_CALENDAR: "Προσθήκη στο Personal To Do Calendar",
            BUTTON: "Προγραμματισμός εκδήλωσης"
        },
        CREDIT: {
            TITLE: "Credits",
            BUTTON_ADD: "Προσθήκη πίστωσης",
            BUTTON_EDIT: "Επεξεργασία",
            EDIT_CREDIT_TITLE: "Επεξεργασία πίστωσης",
            ADD_CREDIT_TITLE: "Προσθήκη πίστωσης",
            PLACE_HOLDERS: {
                VALUE: "Αξία",
                AANOTES: "Σημειώσεις"
            }
        },
        STRIPE: {
            BILL_CLIENT: "Μπορείτε να χρεώνετε με μη αυτόματο τρόπο πελάτες μέσω Stripe εδώ",
            SEND_INVOICE: "Μπορείτε να στείλετε με μη αυτόματο τρόπο τιμολόγια Stripe εδώ",
            BUTTON_CHARGE: "Φόρτιση μέσω Stripe",
            BUTTON_RESET: "Επαναφορά πληροφοριών λωρίδας",
            BUTTON_INVOICE: "Τιμολόγιο μέσω Stripe",
            PAYMENT_LOGS: "Αρχεία καταγραφής πληρωμών"
        },
        AUTHORIZE_NET: {
            BILL_CLIENT: "Μπορείτε να χρεώνετε μη αυτόματα πελάτες μέσω του Authorize.Net εδώ",
            SEND_INVOICE: "Μπορείτε να στείλετε μη αυτόματα τιμολόγια Authorize.Net εδώ",
            BUTTON_CHARGE: "Φόρτιση μέσω Authorize.Net",
            BUTTON_RESET: "Επαναφορά πληροφοριών Authorize.Net",
            BUTTON_INVOICE: "Τιμολόγιο μέσω Authorize.Net",
            PAYMENT_LOGS: "Αρχεία καταγραφής πληρωμών"
        },
        REVIEW: {
            TITLE: "Κριτικές",
            RATING: "Βαθμολογία",
            AVERAGE_RATING: "Μέση βαθμολογία",
            NO_DATA: "Δεν υπάρχουν ακόμη κριτικές."
        },
        ADD_DOCUMENT: {
            TITLE: "Προσθήκη εγγράφου",
            DESCRIPTION: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03BF\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03A0\u03C1\u03CC\u03C4\u03C5\u03C0\u03BF \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5 \u03C3\u03C4\u03BF\u03BD \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7 \u03B1\u03C0\u03CC \u03B5\u03B4\u03CE, \u03B1\u03C0\u03BB\u03CE\u03C2 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03AD\u03BD\u03B1\n            \u03C4\u03C9\u03BD \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03C9\u03BD \u03C3\u03B1\u03C2 \u03B1\u03C0\u03CC \u03C4\u03BF \u03B1\u03BD\u03B1\u03C0\u03C4\u03C5\u03C3\u03C3\u03CC\u03BC\u03B5\u03BD\u03BF \u03BC\u03B5\u03BD\u03BF\u03CD:",
            BUTTON: "Προσθήκη εγγράφου"
        },
        ADD_EVALUATION: {
            BUTTON: "Προσθήκη αξιολόγησης"
        },
        RELATIONSHIP: {
            ΑΑΑΑΑΑΑΑΑΑΑΑ_ΥΠΟΨΗΦΙΟΣ: {
                TITLE: "Ανατεθέντες υποψήφιοι",
                NO_CANDIDATE: "Κανένας υποψήφιος δεν έχει συνδεθεί με αυτόν τον πελάτη."
            },
            CLIENT: {
                TITLE: "Ανατεθέντες πελάτες",
                NO_CLIENT: "Δεν έχουν συνδεθεί πελάτες με αυτόν τον υποψήφιο."
            },
            ADD_CANDIDATE: "Προσθήκη υποψηφίου"
        },
        LAST_CONTACTED_DATE: "Ημερομηνία τελευταίας επικοινωνίας",
        CANDIDATE_BADGES: {
            TITLE: "Σήματα",
            BUTTON: "Αποθήκευση σημάτων"
        }
    },
    COMMUNICATION: {
        DATE: "Ημερομηνία",
        FROM: "Από",
        AATO: "Προς",
        SUBJECT: "Θέμα",
        MESSAGE: "Μήνυμα",
        RE_SEND: "Επαναποστολή",
        CANCEL_SCHEDULE: "Ακύρωση χρονοδιαγράμματος",
        SCHEDULE_TIME: "Προγραμματισμός ώρας"
    },
    PLACEMENT_JOB: {
        SEARCH_TEXT: "Αναζήτηση κατά όνομα αφίσας, τίτλο εργασίας, αναγνωριστικό εργασίας, χρονοδιάγραμμα, πόλη, πολιτεία ή περιγραφή",
        JOB_HIDEN_DESCRIPTION: "\u039F\u03B9 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2 \u03C3\u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 {0} \u03B4\u03B5\u03BD \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\n        board \u03B1\u03C0\u03CC \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03BC\u03B9\u03B1\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2\".",
        CLIENT_POSTING_JOB_DESCRIPTION: "Αυτό είναι για τη δημοσίευση μακροπρόθεσμων θέσεων για αυτόν τον πελάτη.",
        ADMIN_POSTING_JOB_DESCRIPTION: "Αυτό είναι για τη δημοσίευση μακροπρόθεσμων θέσεων"
    },
    CONFIRM_DIALOGS: _el2.default,
    ERROR_DIALOGS: _el4.default,
    RESULT_DIALOGS: _el6.default
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CHANGE_QUESTION_MODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_CHANGE_QUESTION_MODE = {
    CHANGE_QUESTION_MODEL_CONFIRM_DIALOG: {
        MESSAGE: 'Αλλάζοντας το μοντέλο αυτής της ερώτησης, οποιεσδήποτε πληροφορίες έχουν ήδη απαντηθεί σε αυτήν την ερώτηση θα χαθούν. Επικοινωνήστε με την Enginehire για τυχόν ερωτήσεις.',
        ACCEPT_LABEL: "Συνέχεια",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_REFERENCE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την αναφορά;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EXPERIENCE_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εμπειρία;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_CONTACT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την επαφή;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EDUCATION_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εκπαίδευση;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_CHILDREN_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το παιδί;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PET_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το κατοικίδιο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την κράτηση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PROFILE_BUILDER_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το εργαλείο δημιουργίας προφίλ {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το αίτημα;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εργασία;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_APPLICATION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την εφαρμογή;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το έγγραφο {0};',
        ACCEPT_LABEL: "Διαγραφή εγγράφου",
        REJECT_LABEL: "Κλείσιμο"
    },
    BULK_DELETE_DOCUMENT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε απολύτως βέβαιοι ότι θέλετε να διαγράψετε αυτά τα έγγραφα;',
        ACCEPT_LABEL: "Διαγραφή εγγράφων",
        REJECT_LABEL: "Κλείσιμο"
    },
    DELETE_FILE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το αρχείο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Κλείσιμο"
    },
    DELETE_TEMPLATE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το πρότυπο {0} {1};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PRICE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το {0} {1};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PHOTO_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε τη φωτογραφία {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε την εικόνα;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_USER_CONFIRM_DIALOG: {
        INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7;</h3>\n         <p>{0} {1}</p>\n         <p>{2}</p>",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_ADMIN_CONFIRM_DIALOG: {
        INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC\u03BD \u03C4\u03BF\u03BD \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7;</h3>\n         <p>{0}</p>",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_RESOURCE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε το {0};',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_TIME_OFF_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε αυτό το αίτημα χρονικού ορίου',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    CANCEL_BOOKING_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτήν την κράτηση;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CANCELLATION_FEE_CONFIRM_DIALOG: {
        MESSAGE: 'Το τέλος ακύρωσης είναι ${0}. Εισαι σιγουρος οτι θελεις να συνεχισεις?',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    CANCEL_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να κλείσετε; Οποιεσδήποτε αλλαγές θα χαθούν.',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αποδεχτείτε την εργασία {0};',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    DECLINE_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να απορρίψετε την εργασία {0};',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    EDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε σίγουροι για τις αλλαγές σας;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_OVERWRITE_DATA_CONFIRM_DIALOG: {
        INNER_HTML: "<h2>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 {0} \u03B1\u03C0\u03CC \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2;</h2><h5 class=\"text-danger\">\u0391\u03C5\u03C4\u03CC \u03B8\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03C3\u03B5\u03B9 \u03C4\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD\u03C4\u03B1 {0} \u03B1\u03C5\u03C4\u03CE\u03BD \u03C4\u03C9\u03BD \u03C7\u03C1\u03B7\u03C3\u03C4\u03CE\u03BD \u03BC\u03B5 \"{1}\" .</h5>",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_ADD_DATA_CONFIRM_DIALOG: {
        INNER_HTML: "<h2>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF {0} \u03C3\u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2;</h2><h5 class=\"text-danger\">\u0391\u03C5\u03C4\u03CC \u03B8\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03B9 \u03C4\u03BF \"{1}\" \u03C3\u03C4\u03BF \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD {0} \u03C4\u03BF\u03C5 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7. </h5>",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_STATUS_CHANGE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αλλάξετε την κατάσταση των {0} επιλεγμένων χρηστών; Η κατάστασή τους θα αλλάξει σε {1}.',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    BULK_ADD_USER_MAILCHIMP_CONFIRM_DIALOG: {
        INNER_HTML: "<h2>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2 \u03C3\u03C4\u03BF mailchimp;</h2>",
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    OVERWRITE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Υπάρχει ένα ηχογραφημένο βίντεο. Εάν εγγράψετε νέο βίντεο, το υπάρχον βίντεο θα αντικατασταθεί. Είστε σίγουροι ότι θα συνεχίσετε;',
        ACCEPT_LABEL: "Συνέχεια",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_VIDEO_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το βίντεο;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_PROFILE_PICTURE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε την εικόνα προφίλ;',
        ACCEPT_LABEL: "Διαγραφή εικόνας",
        REJECT_LABEL: "Κλείσιμο"
    },
    DELETE_RELATIONSHIP_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να καταργήσετε τη σύνδεση μεταξύ του {0} και αυτού του πελάτη;",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    CANDIDATE_ACCEPT_JOB_CONFIRM_DIALOG: {
        MESSAGE: 'Δεσμεύεστε να ολοκληρώσετε αυτήν τη θέση εργασίας, είστε σίγουροι;',
        ACCEPT_LABEL: "Αποδοχή εργασίας",
        REJECT_LABEL: "Κλείσιμο"
    },
    MARK_AS_FAVORITE_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να επισημάνετε το {0} ως αγαπημένο;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    MARK_AS_DO_NOT_WANT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι δεν θέλετε ξανά το {0};',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    DELETE_NOTE_CONFIRM_DIALOG: {
        INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7;</h3>\n         <p style=\"white-space: pre-wrap;\">{0}</p>",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EVENT_CONFIRM_DIALOG: {
        INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03B9\u03C3\u03C4\u03AE \u03C3\u03C5\u03BC\u03B2\u03AC\u03BD\u03C4\u03C9\u03BD;</h3>\n        <p style=\"white-space: pre-wrap;\">{0}</p>",
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_CREDIT_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την πίστωση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_MULTI_ITEMS_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε τα {0} επιλεγμένα {1};",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    UNASSIGN_JOBS_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να καταργήσετε την ανάθεση {0} επιλεγμένων εργασιών; Η κατάστασή τους θα τεθεί σε "{1}".',
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_CHANGE_JOB_STATUS_CONFIMR_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αλλάξετε την κατάσταση των {0} επιλεγμένων εργασιών; Η κατάστασή τους θα αλλάξει σε {1}.",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    ASSIGN_JOB_CONFIRM_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αναθέσετε την εργασία στον υποψήφιο;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αναθέσετε {0} επιλεγμένες εργασίες στον επιλεγμένο υποψήφιο;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    BULK_TENTATIVELY_ASSIGN_CANDIDIATES_TO_MULTIPLE_JOBS_DIALOG: {
        MESSAGE: "Είστε βέβαιοι ότι θέλετε να αναθέσετε προσωρινά {0} επιλεγμένες εργασίες στον επιλεγμένο υποψήφιο;",
        ACCEPT_LABEL: "Ναι",
        REJECT_LABEL: "Όχι"
    },
    PACKAGE_SELECTION_CONFIRMATION: {
        INNER_HTML: "<h2>\u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2 - {0}</h2>\n        <hr />\n        \u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391_<h5>\n          \u0388\u03C7\u03C9 \u03B4\u03B9\u03B1\u03B2\u03AC\u03C3\u03B5\u03B9 \u03BA\u03B1\u03B9 \u03B5\u03AF\u03BC\u03B1\u03B9 \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03BF\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03CC\u03C1\u03BF\u03C5\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03C4\u03BF\u03C5\n          \u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03C4\u03B7\u03BA\u03B5 package.\n        </h5>",
        ACCEPT_LABEL: "Επιβεβαίωση επιλογής",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_EVALUATION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την αξιολόγηση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_QUESTION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ερώτηση;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_OPTION_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την επιλογή;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    POST_WEEK_AVAILABLITY_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε σίγουροι για τη διαθεσιμότητα που έχετε καταχωρίσει;',
        ACCEPT_LABEL: 'Επιβεβαίωση διαθεσιμότητας',
        REJECT_LABEL: "Περιμένετε, επιτρέψτε μου να ελέγξω ξανά"
    },
    TIME_OFF_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε σίγουροι για το αίτημά σας;',
        ACCEPT_LABEL: 'Υποβολή αιτήματος',
        REJECT_LABEL: "Αίτημα επεξεργασίας"
    },
    REMOVE_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: '{0} ({1}) - Κατάργηση διαθεσιμότητας',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    DELETE_WEEK_AVAILABILITY_CONFIRM_DIALOG: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε την εβδομαδιαία διαθεσιμότητα;',
        ACCEPT_LABEL: "Διαγραφή",
        REJECT_LABEL: "Ακύρωση"
    },
    RESET_WEEK_AVAILABILITY: {
        MESSAGE: 'Είστε βέβαιοι ότι θέλετε να επαναφέρετε την εβδομαδιαία διαθεσιμότητα;',
        ACCEPT_LABEL: 'Ναι',
        REJECT_LABEL: "Όχι"
    },
    SUBMIT_REQUEST_CONFIRM_DIALOG: {
        MESSAGE: "Είστε σίγουροι για το αίτημά σας;",
        ACCEPT_LABEL: "Υποβολή αιτήματος",
        REJECT_LABEL: "Αίτημα επεξεργασίας"
    }
}, _defineProperty(_CHANGE_QUESTION_MODE, "SUBMIT_REQUEST_CONFIRM_DIALOG", {
    MESSAGE: "Είστε σίγουροι για το αίτημά σας;",
    ACCEPT_LABEL: "Υποβολή αιτήματος",
    REJECT_LABEL: "Αίτημα επεξεργασίας"
}), _defineProperty(_CHANGE_QUESTION_MODE, "FORCE_LOGIN_CONFIRM_DIALOG", {
    INNER_HTML: '<h4>Είστε ήδη συνδεδεμένοι!</h4>' + '<h5>Λυπούμαστε, φαίνεται ότι είστε ήδη συνδεδεμένοι σε άλλη συσκευή! ' + 'Παρακαλώ αποσυνδεθείτε από οπουδήποτε αλλού και δοκιμάστε ξανά. ' + 'Εάν έχετε ερωτήσεις, <a href="https://share.hsforms.com/1yIx2IRKyQQaVcMJW8kLbJg39wil">επικοινωνήστε μαζί μας</a>.</h5>',
    ACCEPT_LABEL: 'Είσοδος πάντως',
    REJECT_LABEL: "ΟΚ"
}), _defineProperty(_CHANGE_QUESTION_MODE, "MARK_ALL_AS_PUBLIC_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να επισημάνετε όλα τα {0} ως δημόσια (ορατά σε όλους);",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BROADCAST_SMS_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να στείλετε SMS σε χρήστες {0}",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CREATE_JOB_CONFIRM_DIALOG", {
    INNER_HTML: '<h4>Δημιουργία εργασίας</h4>' + '<hr>' + '<h5>Εάν ξεκινάτε μια δουλειά, αλλά δεν αναφέρεται στο πρόγραμμά σας, χρησιμοποιήστε αυτήν την επιλογή.' + ' Αυτό θα δημιουργήσει μια νέα εργασία στην οποία μπορείτε να εισέλθετε και να αποχωρήσετε, και θα συμπληρώσουμε τις άλλες λεπτομέρειες αργότερα.' + ' Κατά την είσοδο, σημειώστε σε ποιον πελάτη εργάζεστε και οτιδήποτε άλλο πρέπει να γνωρίζουμε.</h5>',
    ACCEPT_LABEL: "Δημιουργία εργασίας",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "ASSIGN_TO_NOT_MATCH_CANDIDATE", {
    MESSAGE: 'Υπάρχει μια σχέση "Δεν ταιριάζει" μεταξύ πελάτη και υποψηφίου. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;',
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "ASSIGN_TO_UNAVAILABLE_CANDIDATE", {
    MESSAGE: "Ο υποψήφιος δεν είναι διαθέσιμος. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "ASSIGN_TO_ALREADY_BOOKED_CANDIDATE", {
    MESSAGE: "Ο υποψήφιος έχει ήδη κρατηθεί αυτήν τη στιγμή. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "ASSIGN_TO_TIME_OFF_CANDIDATE", {
    MESSAGE: "Ο υποψήφιος έχει άδεια αυτήν τη στιγμή. Είστε βέβαιοι ότι θέλετε να αναθέσετε την κράτηση σε αυτόν τον υποψήφιο;",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "RELEASE_SCHEDULE_CONFIRM_DIALOG", {
    MESSAGE: "Είστε έτοιμοι να δημοσιεύσετε το πρόγραμμα;",
    ACCEPT_LABEL: 'Πρόγραμμα κυκλοφορίας',
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_BOOKING_GROUP_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε την ομάδα κρατήσεων;"
}), _defineProperty(_CHANGE_QUESTION_MODE, "ACCEPT_BOOKING_IN_GROUP_CONFIRM_DIALOG", {
    INNER_HTML: "<h3>\u0397 \u03BA\u03C1\u03AC\u03C4\u03B7\u03C3\u03B7 \u03B1\u03BD\u03AE\u03BA\u03B5\u03B9 \u03C3\u03B5 \u03BC\u03B9\u03B1 \u03BF\u03BC\u03AC\u03B4\u03B1. \u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03B4\u03B5\u03C7\u03C4\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03BF\u03BC\u03AC\u03B4\u03B1;</h3>\n        <ul>{0}</ul>",
    ACCEPT_LABEL: "Αποδοχή όλων",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "UPDATE_JOB_POSTER_CONFRM_DIALOG", {
    MESSAGE: "Θέλετε να ενημερώσετε ανάλογα τα πεδία διεύθυνσης με νέα αφίσα εργασίας;",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CLIENT_CONFIRM_CLOCK_IN_OUT_MESSAGE", {
    INNER_HTML: "<h3>Χρόνος εισόδου και χρονομέτρησης του υποψηφίου</h3>" + "<ul>{0}</ul>",
    ACCEPT_LABEL: 'Έγκριση',
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CLIENT_APPROVE_CLOCK_IN_OUT_MESSAGE", {
    INNER_HTML: "<h3>Είστε βέβαιοι ότι θέλετε να εγκρίνετε την ώρα εισόδου και χρόνου του υποψηφίου</h3>" + "<ul>{0}</ul>",
    ACCEPT_LABEL: 'Έγκριση',
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CLIENT_DISSAPPROVE_CLOCK_IN_OUT_MESSAGE", {
    INNER_HTML: "<h3>Είστε βέβαιοι ότι θέλετε να απορρίψετε την ώρα εισόδου και χρόνου του υποψηφίου</h3>" + "<ul>{0}</ul>",
    ACCEPT_LABEL: "Απόρριψη",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "SELECT_CREDIT_PACKAGE_CONFIRM_DIALOG", {
    MESSAGE: "Θα χρεωθείτε {0}{1} για {2} πιστώσεις. Είστε βέβαιοι ότι θέλετε να συνεχίσετε",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "SELECT_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG", {
    MESSAGE: "Θα εγγραφείτε για {0} μηνιαίες πιστώσεις. Είστε βέβαιοι ότι θέλετε να συνεχίσετε",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CHANGE_SUBSCRIPTION_CREDIT_PACKAGE_CONFIRM_DIALOG", {
    MESSAGE: "Θα εγγραφείτε για {0} μηνιαίες πιστώσεις. Είστε βέβαιοι ότι θέλετε να ενημερώσετε το τρέχον πακέτο σας",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "SELECT_STRIPE_SUBSCRIPTION_CONFIRM_DIALOG", {
    MESSAGE: "Θα εγγραφείτε στο {0}. Θέλετε να συνεχίσετε;",
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "UNASSIGN_CANDIDATE_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να καταργήσετε την ανάθεση αυτού του υποψηφίου;",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "UPDATE_RATE_BASED_ON_BOOKING_SERVICE_CONFIRM_DIALOG", {
    MESSAGE: "Θέλετε να ενημερώσετε το ποσοστό πελάτη και το ποσοστό υποψηφίων ανάλογα;",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_BREAK_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το διάλειμμα;",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BULK_CHARGE_CLIENT_CONFIRM_DIALOG", {
    INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2;</h3>\n         <ul>{0}</ul>",
    ACCEPT_LABEL: "Χρέωση",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BULK_INVOICE_STRIPE_CLIENT_CONFIRM_DIALOG", {
    INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03C4\u03B5 \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF \u03C3\u03B5 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2 \u03BC\u03AD\u03C3\u03C9 Stripe \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2;</h3>\n         <ul>{0}</ul>",
    ACCEPT_LABEL: "Αποστολή τιμολογίου",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BULK_CHARGE_PAYOUT_STRIPE_CONFIRM_DIALOG", {
    INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C7\u03C1\u03B5\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C8\u03AE\u03C6\u03B9\u03BF\u03C5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03CE\u03BD \u03BC\u03AD\u03C3\u03C9 Stripe \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2;</h3>\n         <ul>{0}</ul>",
    ACCEPT_LABEL: "Μεταφορά",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BULK_COPY_SUGGESTED_CHARGE_CONFIRM_DIALOG", {
    INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C4\u03B5\u03B9\u03BD\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03AE \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B5\u03C2;</h3>\n         <ul>{0}</ul>",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "SHARE_JOB_MARKET_PLACE_CONFIRM_DIALOG", {
    INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BC\u03BF\u03B9\u03C1\u03B1\u03C3\u03C4\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC \u03C4\u03B7\u03C2 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2 \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7;</h3>\n         <ul>{0}</ul>",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CLOSE_VIEW_TAB_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να κλείσετε την προβολή {0}',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_TODO_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το To Do;',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_BENEFIT_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το πλεονέκτημα {0};',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "TRANSER_MONEY_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να στείλετε το {0}{1} στο {2}; ',
    ACCEPT_LABEL: 'Ναι',
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "MARK_JOB_COMPLETED_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να επισημάνετε αυτήν την εργασία ως ολοκληρωμένη;',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_PACKAGE_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πακέτο;',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "REPORT_PROBLEM_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αναφέρετε το πρόβλημα;',
    ACCEPT_LABEL: "Αναφορά",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "COPY_FIELD_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αντιγράψετε δεδομένα από το {0} στο {1};',
    INNER_HTML: "<h3>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1;</h3>\n         <h4>\u0391\u03C0\u03CC \u03C4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF: {0}</h4>\n         <h4>\u03A0\u03C1\u03BF\u03C2 \u03C0\u03B5\u03B4\u03AF\u03BF: {1}</h4>\n         <h5>\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03BD\u03C4\u03B1 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03C4\u03BF\u03C5 {1} \u03B8\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03B1\u03B8\u03BF\u03CD\u03BD</h5>",
    ACCEPT_LABEL: "Αντιγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "CANCEL_SCHEDULE_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε το email;',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_REVIEW_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την κριτική;',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_BLOCK_TEXT_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το μπλοκ κειμένου;',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_STRIPE_ACCOUNT_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το stripe λογαριασμό αυτού του χρήστη;',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DEDUPLICATE_CHILDREN_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να αφαιρέσετε τα διπλότυπα παιδιά;",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "HIDE_FIELD_FROM_CLIENT_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αποκρύψετε αυτό το πεδίο από τον πελάτη;',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "SHOW_FIELD_TO_CLIENT_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να εμφανίσετε αυτό το πεδίο στον πελάτη;',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BOOKING_IN_PAST_DATE_CONFIRM_DIALOG", {
    MESSAGE: 'Η κράτηση είναι σε προηγούμενη ημερομηνία. Θέλετε να συνεχίσετε?',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "RESTORE_RESOURCE_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να επαναφέρετε το {0};",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "PERMANENT_DELETE_RESOURCE_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε οριστικά το {0};',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BULK_DELETE_RESOURCE_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε το {0} επιλεγμένο {1};',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "BULK_SHIFT_JOB_UPDATE_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να ενημερώσετε {0} εργασίες",
    ACCEPT_LABEL: "Ενημέρωση",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "INVALID_INPUT_WARNING_CONFIRM_DIALOG", {
    INNER_HTML: "\n         <h2>\u03A0\u03C1\u03BF\u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7, \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03B9 \u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03B1 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AC \u03C0\u03B5\u03B4\u03AF\u03B1</h2>\n         <h4 class=\"error-message main-message\">\n         \u0391\u03C5\u03C4\u03AC \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03B1 \u03C0\u03B5\u03B4\u03AF\u03B1 \u03C0\u03BF\u03C5 \u03BB\u03B5\u03AF\u03C0\u03BF\u03C5\u03BD:\n         </h4>\n         <ul>{0}</ul>\n         <h5 class=\"mt-2\">\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF Continue \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B1\u03B3\u03BD\u03BF\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B5\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7</h5>\n         ",
    ACCEPT_LABEL: "Συνέχεια",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "SEND_REPEAT_BLAST_TEMPLATE_CONFIRM_DIALOG", {
    INNER_HTML: "\n         <h2>\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9 \u03CC\u03C4\u03B9 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C4\u03B5\u03AF\u03BB\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B1\u03BD\u03B1\u03BB\u03B1\u03BC\u03B2\u03B1\u03BD\u03CC\u03BC\u03B5\u03BD\u03B1 {0} \u03C3\u03C4\u03BF {1}</h2>\n         <h5>\u03A0\u03C1\u03CC\u03C4\u03C5\u03C0\u03BF: {2}</h5>\n         <h5>\u0395\u03C0\u03B1\u03BD\u03AC\u03BB\u03B7\u03C8\u03B7 \u03BA\u03AC\u03B8\u03B5 {3} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2 {4}</h5>",
    ACCEPT_LABEL: "Αποστολή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DUPLICATE_FIELD_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να αντιγράψετε το πεδίο;',
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_FIELD_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο;',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "DELETE_PROFILE_FIELD_CONFIRM_DIALOG", {
    MESSAGE: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πεδίο; Αυτό θα το διαγράψει από το προφίλ συνολικά (όχι μόνο για αυτό το άτομο!)',
    ACCEPT_LABEL: "Διαγραφή",
    REJECT_LABEL: "Ακύρωση"
}), _defineProperty(_CHANGE_QUESTION_MODE, "MAKE_FIELD_VISIBLE_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να ορίσετε αυτό το πεδίο ώστε να είναι ορατό στον πελάτη",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "MAKE_FIELD_HIDDEN_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να ορίσετε αυτό το πεδίο ώστε να είναι κρυφό από τον πελάτη",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _defineProperty(_CHANGE_QUESTION_MODE, "HIDE_BENEFIT_CONFIRM_DIALOG", {
    MESSAGE: "Είστε βέβαιοι ότι θέλετε να αποκρύψετε αυτό το όφελος για την εταιρεία σας",
    ACCEPT_LABEL: "Ναι",
    REJECT_LABEL: "Όχι"
}), _CHANGE_QUESTION_MODE);

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _requiredValues = __webpack_require__(58);

exports.default = {
    NETWORK_ERROR: {
        TITLE: "Σφάλμα δικτύου",
        MESSAGE: "Ελέγξτε τη σύνδεσή σας στο Διαδίκτυο και βεβαιωθείτε ότι είναι καλή. Εάν φαίνεται εντάξει, περιμένετε μερικά λεπτά, κλείστε αυτό το μήνυμα και δοκιμάστε ξανά (μην ανανεώσετε διαφορετικά μπορεί να χάσετε αυτό που εισαγάγατε)."
    },
    MISSING_EMAIL_FIELD_ERROR: {
        TITLE: "Λείπει το πεδίο για τη διεύθυνση email",
        MESSAGE: "Προσθέστε τουλάχιστον 1 πεδίο για διεύθυνση email!"
    },
    INVALID_INPUT_ERROR: {
        INNER_HTML: "\n         <h2>\u039B\u03B5\u03AF\u03C0\u03B5\u03B9 \u03AD\u03BD\u03B1 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03CC \u03C0\u03B5\u03B4\u03AF\u03BF \u03AE \u03AD\u03BD\u03B1 \u03C0\u03B5\u03B4\u03AF\u03BF \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF.</h2>\n         <h4 class=\"error-message main-message\">\n         \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03B1 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1\u03C4\u03BF\u03C2!\n         </h4>\n         <h5>{0}</h5>\n         "
    },
    LOGIN_MISSING_EMAIL_ERROR: {
        TITLE: 'Η διεύθυνση ηλεκτρονικού ταχυδρομείου λείπει',
        MESSAGE: 'Παρακαλώ εισάγετε τη διεύθυνση email!'
    },
    LOGIN_MISSING_PASSWORD_ERROR: {
        TITLE: "Λείπει ο κωδικός πρόσβασης",
        MESSAGE: 'Παρακαλώ εισάγετε τον κωδικό πρόσβασης!'
    },
    MISSING_BOOKING_TIME_ERROR: {
        TITLE: 'Λείπει η ώρα κράτησης',
        MESSAGE: 'Παρακαλώ προσθέστε την ώρα κράτησης (Ώρα έναρξης και ώρα λήξης)!'
    },
    MISSING_SIGNATURE_ERROR: {
        TITLE: "Ένα έγγραφο δεν έχει υπογραφεί",
        MESSAGE: "Διαβάστε τη φόρμα για μηνύματα σφάλματος και υπογράψτε όλα τα έγγραφα!"
    },
    MISSING_EVALUATION_ERROR: {
        TITLE: "Μια αξιολόγηση δεν έχει ολοκληρωθεί",
        MESSAGE: 'Ελέγξτε τη φόρμα για μηνύματα σφάλματος και ολοκληρώστε όλη την αξιολόγηση!'
    },
    INPUT_CONDITION_ERROR: {
        TITLE: "Ένα πεδίο εισαγωγής δεν είναι έγκυρο",
        MESSAGE: "Υπάρχει ένα πεδίο εισαγωγής που δεν είναι έγκυρο"
    },
    BUILDER_NO_FIELD_ERROR: {
        TITLE: "Δεν υπάρχει πεδίο για τον κατασκευαστή",
        MESSAGE: "Προσθέστε τουλάχιστον ένα πεδίο!"
    },
    EXCLUSIVE_OPTIONS_USE_SAME_VALUE: {
        TITLE: "Δεν είναι δυνατή η χρήση της ίδιας επιλογής μεταξύ {0} και {1}",
        MESSAGE: "Αποεπιλέξτε τις επιλογές {2} σε {0} ή {1}"
    },
    MISSING_DEPENDENCY_OBJECT_ERROR: {
        TITLE: "Προσθέστε περισσότερα {0}!",
        MESSAGE: "Πρέπει να έχετε τουλάχιστον {1} {0}"
    },
    MISSING_EXPERIENCE_ERROR: {
        TITLE: 'Λείπει η εμπειρία',
        MESSAGE: 'Πρέπει να έχετε τουλάχιστον 1 εμπειρία.'
    },
    MISSING_STATUS_ERROR: {
        TITLE: "Λείπουν καταστάσεις",
        MESSAGE: _requiredValues.LIST_REQUIRED_STATUSES.join(" και ") + " \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C5\u03C0\u03BF\u03C7\u03C1\u03B5\u03C9\u03C4\u03B9\u03BA\u03AD\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2"
    },
    DUPLICATE_STATUS_ERROR: {
        TITLE: "Οι καταστάσεις είναι διπλότυπες",
        MESSAGE: "Υπάρχουν ορισμένες καταστάσεις που είναι διπλότυπες"
    },
    DUPLICATE_MODEL_ERROR: {
        TITLE: "Πολλά πεδία που χρησιμοποιούν το ίδιο μοντέλο",
        MESSAGE: 'Υπάρχει ένα μοντέλο που έχει εκχωρηθεί σε τουλάχιστον 2 πεδία'
    },
    DUPLICATE_CHECKLIST_ITEM_ERROR: {
        TITLE: "Οι καταστάσεις είναι διπλότυπες",
        MESSAGE: "Υπάρχουν ορισμένα αντικείμενα που είναι διπλότυπα"
    },
    DUPLICATE_EMPLOYER_TYPE_ERROR: {
        TITLE: "Ο τύπος εργοδότη είναι διπλότυπος",
        MESSAGE: "Υπάρχουν ορισμένοι τύποι εργοδότη που είναι διπλότυποι"
    },
    DUPLICATE_CANDIDATE_TYPE_ERROR: {
        TITLE: "Ο τύπος υποψηφίου είναι διπλότυπος",
        MESSAGE: "Υπάρχουν ορισμένοι υποψήφιοι τύποι που είναι διπλότυποι"
    },
    DUPLICATE_JOB_TYPE_ERROR: {
        TITLE: "Οι τύποι εργασίας είναι διπλότυποι",
        MESSAGE: "Υπάρχουν ορισμένοι τύποι εργασιών που είναι διπλότυποι"
    },
    INVALID_IMAGE_FILE_TYPE_ERROR: {
        TITLE: "Λυπούμαστε, αυτός ο τύπος αρχείου δεν είναι έγκυρος!",
        MESSAGE: 'Παρακαλώ ανεβάστε μια εικόνα PNG ή JPG.'
    },
    INVALID_DOC_FILE_TYPE_ERROR: {
        TITLE: "Λυπούμαστε, αυτός ο τύπος αρχείου δεν είναι έγκυρος!",
        MESSAGE: 'Παρακαλώ ανεβάστε ένα αρχείο DOC ή DOCX ή PDF.'
    },
    EMPTY_FILE_ERROR: {
        TITLE: "Το αρχείο είναι κενό!",
        MESSAGE: "Μεταφορτώστε ένα μη κενό αρχείο"
    },
    FILE_SIZE_EXCEED_LIMIT_ERROR: {
        TITLE: "Πολύ μεγάλο αρχείο!",
        MESSAGE: 'Παρακαλώ μεταφορτώστε ένα αρχείο με μέγεθος κάτω από το μέγιστο μέγεθος μεταφόρτωσης.'
    },
    INVALID_INPUT_FILE: {
        TITLE: 'Μη έγκυρο αρχείο',
        MESSAGE: 'Μη έγκυρο αρχείο εισαγωγής'
    },
    MISSING_RESUME_ERROR: {
        TITLE: "Λείπει το επαγγελματικό σας βιογραφικό φύλαξης παιδιών",
        MESSAGE: 'Παρακαλώ ανεβάστε το επαγγελματικό σας βιογραφικό φύλαξης παιδιών'
    },
    END_DATE_BEFORE_START_DATE_ERROR: {
        TITLE: "Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης",
        MESSAGE: "Παρακαλώ αλλάξτε ημερομηνία έναρξης ή ημερομηνία λήξης"
    },
    END_HOUR_BEFORE_START_HOUR_ERROR: {
        TITLE: "Η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης",
        MESSAGE: "Παρακαλώ αλλάξτε ώρα έναρξης ή ώρα λήξης"
    },
    BOOKING_DURATION_TOO_SHORT_ERROR: {
        TITLE: "Οι κρατήσεις πρέπει να είναι τουλάχιστον {0} ώρες.",
        MESSAGE: "Παρακαλώ αλλάξτε ώρα έναρξης ή ώρα λήξης"
    },
    MISSING_PROFILE_PICTURE_ERROR: {
        TITLE: "Λείπει η φωτογραφία του προφίλ σας",
        MESSAGE: 'Παρακαλώ ανεβάστε μια πρόσφατη φωτογραφία σας!'
    },
    NO_TEXT_SELECT: {
        TITLE: "Δεν έχει επιλεγεί κείμενο",
        MESSAGE: "Παρακαλώ επιλέξτε κάποιο κείμενο"
    },
    SUBMIT_REFERENCE_ERROR: {
        TITLE: 'Η αίτησή σας υποβλήθηκε! ΑΛΛΑ',
        MESSAGE: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία των αναφορών σας. Μπορείτε να μας τα στείλετε μέσω email; Ευχαριστώ!'
    },
    SUBMIT_ERROR: {
        TITLE: "Αποτυχία υποβολής της αίτησής σας",
        MESSAGE: "Παρουσιάστηκε σφάλμα κατά την επεξεργασία της αίτησής σας"
    },
    MISSING_ITEM_IN_JOB_STATUS_LIST: {
        TITLE: 'Λείπει στοιχείο στη λίστα κατάστασης',
        MESSAGE: "Απαιτείται η κατάσταση {0}"
    },
    HAS_INCOMPLETE_SECTION: {
        TITLE: "Υπάρχει μια ημιτελής ενότητα",
        MESSAGE: 'Η ενότητα {0} δεν είναι ολοκληρωμένη. Ενημερώστε αυτήν την ενότητα'
    },
    PASSWORD_UNMATCH_ERROR: {
        TITLE: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν.'
    },
    INVALID_PHONE_NUMBER_ERROR: {
        TITLE: "Μη έγκυρος αριθμός τηλεφώνου",
        MESSAGE: "Ο αριθμός τηλεφώνου {0} δεν είναι έγκυρος. Διορθώστε τον"
    },
    MISSING_ADDRESS_ERROR_DIALOG: {
        TITLE: "Δεν είναι δυνατή η εύρεση κοντινών υποψηφίων",
        MESSAGE: 'Λείπει μια πλήρης διεύθυνση από την εργασία.Για αναζήτηση υποψηφίων Επεξεργαστείτε την εργασία και συμπληρώστε τα στοιχεία διεύθυνσης που λείπουν'
    },
    PROFILE_BUILDER_IN_USED: {
        TITLE: "Το πρόγραμμα δημιουργίας προφίλ χρησιμοποιείται",
        MESSAGE: 'Το εργαλείο δημιουργίας προφίλ χρησιμοποιείται από το πρόγραμμα δημιουργίας προφίλ {0}.\n' + 'Καταργήστε πρώτα αυτό το πρόγραμμα δημιουργίας προφίλ'
    },
    MISSING_SIGNATURE_ERROR_DIALOG: {
        TITLE: "Λείπει μια υπογραφή",
        MESSAGE: "Πληκτρολογήστε το όνομά σας για υπογραφή"
    },
    MISSING_REQUIRED_FIELD_SIGNING_ERROR_DIALOG: {
        TITLE: "Λείπει ένα υποχρεωτικό πεδίο",
        MESSAGE: 'Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία (Ελέγξτε τα πεδία με κόκκινο περίγραμμα)'
    },
    USER_EXISTED_ERROR_DIALOG: {
        INNER_HTML: "\n         <h2>\u03A6\u03B1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03CC\u03C4\u03B9 \u03B5\u03AF\u03C3\u03C4\u03B5 \u03AE\u03B4\u03B7 \u03C3\u03C4\u03BF \u03C3\u03CD\u03C3\u03C4\u03B7\u03BC\u03AC \u03BC\u03B1\u03C2!</h2>\n         <h4 class=\"error-message main-message\">\n         \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 <a href='{0}/login/{1}'>\u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03C0\u03AF\u03BD\u03B1\u03BA\u03B1 \u03B5\u03BB\u03AD\u03B3\u03C7\u03BF\u03C5 \u03C3\u03B1\u03C2</a> \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03AE \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B1\u03B6\u03AF \u03BC\u03B1\u03C2 \u03B5\u03AC\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B5\u03C1\u03C9\u03C4\u03AE\u03C3\u03B5\u03B9\u03C2. \u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03CE!\n         </h4>\n         "
    },
    FORCE_LOGOUT_ERROR_DIALOG: {
        TITLE: "Έχετε αποσυνδεθεί!",
        MESSAGE: "Λυπούμαστε, αποσυνδεθήκατε μέσω σύνδεσης σε αυτόν τον λογαριασμό από άλλη συσκευή."
    },
    WEEK_AVAILABILITY_BLOCK_END_TIME_BEFORE_START_TIME_ERROR: {
        TITLE: "Η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης",
        MESSAGE: "Αλλάξτε την ώρα έναρξης ή λήξης του μπλοκ {0} από {1}"
    },
    WEEK_AVAILABILITY_DURATION_TOO_SHORT_ERROR: {
        TITLE: "Ο αποκλεισμός πρέπει να είναι τουλάχιστον {0} ώρες.",
        MESSAGE: "Παρακαλώ αλλάξτε την ώρα έναρξης ή λήξης του μπλοκ {1} από {2}"
    },
    WEEK_AVAILABILITY_EMPTY_REQUIRED_FIELD_ERROR: {
        TITLE: "Κενό υποχρεωτικό πεδίο",
        MESSAGE: "Παρακαλώ συμπληρώστε και την ώρα έναρξης και την ώρα λήξης του μπλοκ {0} από {1}"
    },
    PAYMENT_INFORMATION_REQUIRED: {
        TITLE: "Απαιτούνται στοιχεία πληρωμής",
        MESSAGE: "Παρακαλώ εισάγετε τα στοιχεία πληρωμής"
    },
    INVALID_PAYMENT_INFORMATION: {
        TITLE: "Μη έγκυρα στοιχεία πληρωμής",
        MESSAGE: "Ενημερώστε τα στοιχεία πληρωμής: {0}"
    },
    LIST_INPUT_CONTAINS_BLANK: {
        TITLE: "{0} περιέχει κενή τιμή",
        MESSAGE: "Παρακαλώ αφαιρέστε το κενό {0}"
    },
    DUPLICATE_HEADER_IMPORT_CSV: {
        TITLE: "Υπάρχουν μερικές διπλότυπες κεφαλίδες.",
        MESSAGE: "Λίστα διπλότυπων κεφαλίδων: {0}.\nΕάν εισαχθούν οι διπλότυπες κεφαλίδες, τα αντίστοιχα πεδία ενδέχεται να μην εισαχθούν"
    },
    CANNOT_EDIT_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Δεν είναι δυνατή η επεξεργασία της κράτησης",
        MESSAGE: "Λυπούμαστε, η αλλαγή δεν μπορεί να γίνει λιγότερο από {0} ώρες πριν από την έναρξη μιας εργασίας. Εάν χρειάζεστε μια αλλαγή, επικοινωνήστε απευθείας μαζί μας. Ευχαριστούμε!"
    },
    CANNOT_ADD_BOOKING_WITHIN_X_HOURS: {
        TITLE: "Δεν είναι δυνατή η προσθήκη της κράτησης",
        MESSAGE: "Λυπούμαστε, δεν μπορείτε να κάνετε κράτηση λιγότερο από {0} ώρες πριν από την έναρξη μιας εργασίας. Εάν το χρειάζεστε πραγματικά, επικοινωνήστε μαζί μας απευθείας. Ευχαριστούμε!"
    },
    PAYMENT_FIELD_REQUIRED_IN_APPLICATION_FORM: {
        TITLE: "Απαιτείται πεδίο πληρωμής",
        MESSAGE: "Προσθέστε πεδίο πληρωμής για να μπορείτε να χρεώνετε τον χρήστη κατά την υποβολή της αίτησης"
    },
    MISSING_NUMBER_OF_ROWS: {
        TITLE: "Παρακαλώ καθορίστε τον αριθμό των σειρών για μερική εισαγωγή"
    },
    SCHEDULE_CONFLICT_CANDIDATE_ERROR_DIALOG: {
        TITLE: "Προγραμματισμός διένεξης",
        MESSAGE: "Έχετε ήδη ανατεθεί σε άλλη εργασία κατά τη διάρκεια αυτής της περιόδου"
    },
    JOB_NO_LONGER_AVAILABLE_ERROR_DIALOG: {
        TITLE: "Αυτή η εργασία δεν είναι πλέον διαθέσιμη"
    },
    CLIENT_CONFIRM_INCORRECT_PASSWORD: {
        TITLE: "Λανθασμένος κωδικός πρόσβασης",
        MESSAGE: "Απέτυχε η έγκριση της ώρας εισόδου/εξόδου του ρολογιού. Ο κωδικός πρόσβασης πελάτη είναι λάθος"
    },
    HAS_MISSING_SECTION_BUILDER_ERROR_DIALOG: {
        TITLE: "Λείπει ένα εργαλείο δημιουργίας ενότητας",
        MESSAGE: "Το εργαλείο δημιουργίας προφίλ εισήχθη με επιτυχία. Ωστόσο, λείπει μια επιλογή του εργαλείου δημιουργίας ενότητας (ετικέτα πεδίου: {0}). Επεξεργαστείτε το εργαλείο δημιουργίας για να το διορθώσετε"
    },
    CLOCK_OUT_CLIENT_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Ο πελάτης δεν εισήγαγε στοιχεία πληρωμής. Θα επεξεργαστούμε την πληρωμή αργότερα.\n" + " Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας."
    },
    CLOCK_OUT_CANDIDATE_NOT_INPUT_PAYMENT_INFORMATION: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Ο υποψήφιος δεν εισήγαγε στοιχεία πληρωμής. Θα επεξεργαστούμε την πληρωμή αργότερα. Εισαγάγετε τα στοιχεία πληρωμής σας για να πληρωθείτε μέσω Stripe\n" + " Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας."
    },
    CLOCK_OUT_MISSING_PAYMENT_INFORMATION: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Λείπουν στοιχεία πληρωμής. Θα επεξεργαστούμε την πληρωμή αργότερα.\n" + " Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας."
    },
    SCHEDULE_TIME_IN_PAST: {
        TITLE: "Η καθορισμένη ώρα είναι παρελθόν. Επιλέξτε άλλη ώρα"
    },
    ACTION_MISSING_DATE_FIELD: {
        TITLE: "Παρακαλώ επιλέξτε ημερομηνία"
    },
    APPLICATION_FORM_DUPLICATED_PHONE: {
        TITLE: "Προειδοποίηση!",
        MESSAGE: "Ο αριθμός τηλεφώνου σας είναι ήδη στο σύστημα, έχετε συνεργαστεί μαζί μας στο παρελθόν; Εάν ναι, επικοινωνήστε μαζί μας και μπορούμε να σας βοηθήσουμε να αποκτήσετε πρόσβαση στον υπάρχοντα λογαριασμό σας!"
    },
    APPLICATION_FORM_DUPLICATED_EMAIL: {
        TITLE: "Προειδοποίηση!",
        MESSAGE: "Η διεύθυνση email σας είναι ήδη στο σύστημα, έχετε συνεργαστεί μαζί μας στο παρελθόν; Εάν ναι, επικοινωνήστε μαζί μας και μπορούμε να σας βοηθήσουμε να αποκτήσετε πρόσβαση στον υπάρχοντα λογαριασμό σας!"
    },
    INVALID_AMOUNT_ERROR: {
        TITLE: "Μη έγκυρο ποσό"
    },
    NON_NUMBER_INPUT_ERROR: {
        TITLE: "Παρακαλώ εισάγετε έναν αριθμό"
    },
    SEND_EMAIL_TOO_LONG_DURATION_ERROR_DIALOG: {
        TITLE: "Ο προγραμματισμός για περισσότερες από 8 ώρες δεν υποστηρίζεται"
    },
    APPLICATION_FORM_USER_SUBMITTED: {
        TITLE: "Ο χρήστης υπέβαλε τη φόρμα αίτησης"
    },
    APPLICATION_FORM_USER_INCORRECT_USER_ID: {
        TITLE: "Λανθασμένο αναγνωριστικό χρήστη",
        MESSAGE: "Επικοινωνήστε με την εταιρεία σας για να λάβετε τη σωστή διεύθυνση URL"
    },
    NO_JOB_POSTER_ERROR_DIALOG: {
        TITLE: "Η εργασία δεν έχει πληροφορίες αφίσας"
    },
    RETURNING_APPLICANT_EMAIL_NOT_FOUND: {
        TITLE: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου δεν βρέθηκε",
        MESSAGE: "Λυπούμαστε, δεν μπορέσαμε να το βρούμε στο σύστημά μας. Δοκιμάστε ένα διαφορετικό email ή επικοινωνήστε μαζί μας εάν έχετε ερωτήσεις"
    },
    RETURNING_APPLICANT_INCORRECT_CODE: {
        TITLE: "Εσφαλμένος κωδικός",
        MESSAGE: "Ο εισαγόμενος κωδικός επαλήθευσης είναι λανθασμένος. Δοκιμάστε ξανά αργότερα"
    },
    SHIFT_JOB_REPORT_IS_REQUIRED: {
        TITLE: "Απαιτείται αναφορά εργασίας αλλαγής",
        MESSAGE: "Παρακαλώ υποβάλετε αναφορά εργασίας βάρδιας πριν από το ρολόι"
    },
    TIMEOFF_REQUEST_ON_ASSIGNED_DATES_ERROR: {
        TITLE: "Αποτυχία υποβολής αιτήματος χρονικού ορίου",
        MESSAGE: "Έχετε ανατεθεί σε μια εργασία στο {0}! Επικοινωνήστε απευθείας μαζί μας εάν χρειάζεστε ελεύθερο χρόνο."
    },
    NOT_ALLOW_MOVE_FIELD_ERROR_DIALOG: {
        TITLE: "Δεν είναι δυνατή η μετακίνηση αυτού του πεδίου",
        MESSAGE: "Αυτό είναι ένα ειδικό πεδίο και δεν μπορεί να μετακινηθεί στη φόρμα αίτησης"
    },
    INVALID_LINK_ERROR_DIALOG: {
        TITLE: "Ο σύνδεσμος δεν είναι έγκυρος"
    }
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Σας ευχαριστούμε για την αίτησή σας να γίνετε μέλος της ομάδας μας!',
        MESSAGE: 'Θα εξετάσουμε προσεκτικά την αίτησή σας και θα έρθουμε σε επαφή μαζί σας σύντομα, εάν φαίνεστε ότι ταιριάζει στην ομάδα μας! Λόγω του μεγάλου όγκου των αιτήσεων που λαμβάνουμε, μπορούμε να απαντήσουμε μόνο στους υποψηφίους που θα επιλέξουμε. Ευχαριστώ για την κατανόηση! Τώρα μπορείτε να κλείσετε με ασφάλεια αυτό το παράθυρο.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Σας ευχαριστούμε για τις πληροφορίες σας!',
        MESSAGE: 'Οι πληροφορίες αναφοράς που υποβάλατε είναι πολύ σημαντικές για εμάς. Μπορείτε να κλείσετε με ασφάλεια αυτό το παράθυρο τώρα.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: '\n        <h2>\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B2\u03AC\u03BB\u03B1\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2!</h2>\n        <h5>\u0398\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BC\u03B1\u03B6\u03AF \u03C3\u03B1\u03C2 \u03C3\u03CD\u03BD\u03C4\u03BF\u03BC\u03B1! \u03A4\u03CE\u03C1\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03BC\u03B5 \u03B1\u03C3\u03C6\u03AC\u03BB\u03B5\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03B1\u03C1\u03AC\u03B8\u03C5\u03C1\u03BF.</h5>\n        \u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391_'
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Ευχαριστούμε που μας ενημερώσατε, θα επικοινωνήσουμε μαζί σας σύντομα!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: '\n        <h2>\u03A4\u03BF \u03B2\u03AF\u03BD\u03C4\u03B5\u03BF \u03B1\u03BD\u03AD\u03B2\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1!</h2>\n        <h5>\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03C0\u03BF\u03C5 \u03C5\u03C0\u03BF\u03B2\u03AC\u03BB\u03B1\u03C4\u03B5 \u03C4\u03BF \u03B5\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03B9\u03BA\u03CC \u03B2\u03AF\u03BD\u03C4\u03B5\u03BF. \u0395\u03AC\u03BD \u03B4\u03B5\u03BD \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03BF\u03B8\u03CC\u03BD\u03B7, \u03C0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BB\u03AF\u03B3\u03BF \u03BA\u03B1\u03B9, \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03BC\u03B5 \u03BC\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03BF \u03C4\u03C1\u03CC\u03C0\u03BF \u0391\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7 (<i class="material-icons" style=\'position: absolute;\'>\u03B1\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp ;&nbsp;) \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF</h5>\n        \u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391\u0391_'
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: "Η ενότητα αποθηκεύτηκε",
        MESSAGE: "Αποθηκευμένη ενότητα {0}!"
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: "Η φόρμα οικογένειας ενημερώθηκε",
        MESSAGE: "Η φόρμα οικογένειας ενημερώθηκε με επιτυχία"
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Ευχαριστώ',
        MESSAGE: "Θα εξετάσουμε τις πληροφορίες που έχετε υποβάλει και θα επικοινωνήσουμε μαζί σας εάν θέλουμε να προχωρήσουμε."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Ευχαριστώ',
        MESSAGE: "Θα εξετάσουμε τις πληροφορίες που έχετε υποβάλει και θα επικοινωνήσουμε μαζί σας εάν θέλουμε να προχωρήσουμε."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η κατάσταση ενημερώθηκε.'
    },
    STATUS_UPDATED_RESULT_DIALOG_WITH_NO_EMAIL_TEMPLATE: {
        INNER_HTML: '<h2>\u0397 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5</h2>\n        <h5>\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03B3\u03B9\u03B1 \u03BC\u03B9\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7; <button class="btn btn-secondary" id="add-template-button">\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 email</button></h5>'
    },
    STATUS_UPDATED_REFUND_RESULT_DIALOG: {
        TITLE: 'Η κατάσταση ενημερώθηκε. Επιστροφή χρημάτων στον πελάτη 1 πίστωση'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Η εκπομπή εστάλη!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Ο υποψήφιος εκχωρήθηκε!',
        MESSAGE: "Προχωρήστε στην ειδοποίηση {0}."
    },
    NANNY_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: 'Ο υποψήφιος εκχωρήθηκε!'
    },
    NANNY_BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος ανατέθηκε στις επιλεγμένες εργασίες",
        MESSAGE: "Προχωρήστε στην ειδοποίηση {0}."
    },
    NANNY_BULK_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος ανατέθηκε στις επιλεγμένες εργασίες"
    },
    BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Οι υποψήφιοι έχουν εκχωρηθεί"
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η εργασία ενημερώθηκε!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκε θέση εργασίας!"
    },
    JOB_ACCEPTANCE_TYPE_RESULT_DIALOG: {
        TITLE: "Ο τύπος αποδοχής ενημερώθηκε"
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: "Χρέωση πελάτη και ενημερωμένη κατάσταση εργασίας!"
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: "Ο πελάτης χρεώθηκε μέσω Stripe!"
    },
    CLIENT_CHARGED_STRIPE_RESULT_DIALOG: {
        TITLE: "Ο πελάτης χρεώθηκε μέσω Stripe!"
    },
    CLIENT_CHARGED_AUTHORIZE_NET_RESULT_DIALOG: {
        TITLE: "Ο πελάτης χρεώθηκε μέσω του Authorize.Net!"
    },
    BULK_JOBS_CHARGED_RESULT_DIALOG: {
        TITLE: "Χρέωση πελατών και ενημερωμένη κατάσταση θέσεων εργασίας!"
    },
    BULK_JOBS_CHARGED_WARNING_RESULT_DIALOG: {
        INNER_HTML: '<h2>\u039F\u03B9 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B5\u03C2 \u03C7\u03C1\u03B5\u03CE\u03B8\u03B7\u03BA\u03B1\u03BD \u03BA\u03B1\u03B9 \u03B7 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B8\u03AD\u03C3\u03B5\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5!</h2>\n         <div>\u0391\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5 \u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03BA\u03C1\u03B1\u03C4\u03AE\u03C3\u03B5\u03C9\u03BD</div>\n         <ul>{0}</ul>'
    },
    BULK_INVOICE_RESULT_DIALOG: {
        TITLE: "Πελάτες τιμολογήθηκαν!"
    },
    BULK_TRANSFER_RESULT_DIALOG: {
        TITLE: "Οι πελάτες χρεώθηκαν και οι υποψήφιοι πληρώθηκαν και η κατάσταση των θέσεων εργασίας ενημερώθηκε!"
    },
    BULK_TRANSFER_WARNING_RESULT_DIALOG: {
        INNER_HTML: '<h2>\u03A7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03BA\u03B1\u03B9 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE \u03C4\u03C9\u03BD \u03C5\u03C0\u03BF\u03C8\u03B7\u03C6\u03AF\u03C9\u03BD \u03BA\u03B1\u03B9 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03C9\u03BC\u03AD\u03BD\u03B7 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03B8\u03AD\u03C3\u03B5\u03C9\u03BD \u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2!</h2>\n        {0}'
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Το μήνυμα εστάλη.'
    },
    MESSAGE_SCHEDULED_SEND_RESULT_DIALOG: {
        TITLE: "Το μήνυμα έχει προγραμματιστεί για αποστολή"
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Ο κωδικός πρόσβασης επαναφέρθηκε με επιτυχία.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Η εικόνα προφίλ αποθηκεύτηκε με επιτυχία.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Η εικόνα προφίλ διαγράφηκε με επιτυχία.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Έγγραφα μεταφορτώθηκαν.',
        MESSAGE: "Μπορεί να χρειαστούν μερικά δευτερόλεπτα για να επεξεργαστούν, αν δεν ενημερωθούν αμέσως, δοκιμάστε να κάνετε ανανέωση σε ένα λεπτό!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Το έγγραφό σας έχει υπογραφεί.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Το έγγραφό σας έχει αποθηκευτεί.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: "Οι πρόσθετες πληροφορίες του εγγράφου {0} ενημερώθηκαν"
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Το πρότυπο δημιουργήθηκε.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: "Το πρότυπο ενημερώθηκε"
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: "Το πρότυπο διαγράφηκε"
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: "Το πρότυπο είναι διπλό"
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Επαναφορά κωδικού πρόσβασης',
        MESSAGE: 'Επαναφορά κωδικού πρόσβασης σε {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: "Το πρόγραμμα δημιουργίας προφίλ ενημερώθηκε"
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: "Το υποσέλιδο ηλεκτρονικού ταχυδρομείου έχει αποθηκευτεί"
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: "Οι ρυθμίσεις ειδοποιήσεων αποθηκεύτηκαν"
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: "Πρόσθετες ρυθμίσεις διαχειριστή αποθηκεύτηκαν"
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Ο διαχειριστής ενημερώθηκε.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: "Προστέθηκε ο διαχειριστής"
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: "Ο διαχειριστής ενημερώθηκε"
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: "Ο διαχειριστής διαγράφηκε"
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: "Οι τοποθεσίες ενημερώθηκαν"
    },
    BULK_DATA_UPDATED_RESULT_DIALOG: {
        TITLE: "{0} ενημερώθηκε"
    },
    BULK_DATA_ADDED_RESULT_DIALOG: {
        TITLE: "{0} Προστέθηκε"
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: "Η γλώσσα ενημερώθηκε"
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Η εκπομπή εστάλη σε {0} υποψηφίους!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: "Προβολές εργασίας",
        MESSAGE: "Αριθμός προβολών: {0}"
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: "Εκρηκτική έκρηξη!",
        MESSAGE: "Τα email σας είναι καθ' οδόν! Μπορεί να χρειαστούν μερικά λεπτά, ανάλογα με τον αριθμό που αποστέλλονται. Θα εμφανιστούν στο γενικό αρχείο καταγραφής email και στα αρχεία καταγραφής email του μεμονωμένου χρήστη κατά την αποστολή τους."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: "Η σημείωση αποθηκεύτηκε!"
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} αποθηκεύτηκαν, προσθέστε άλλο ένα!',
        CLOSE_LABEL: "OK"
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Ευχαριστούμε που μας ενημερώσατε!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Συγχαρητήρια, αποδεχτήκατε αυτήν τη δουλειά!",
        MESSAGE: 'Όλες οι λεπτομέρειες θα εμφανιστούν στον πίνακα ελέγχου σας στην ενότητα "Οι δουλειές μου".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: "Το εύρος ορατότητας του {0} ενημερώθηκε σε {1}"
    },
    CHECK_FORM_UPDATED: {
        TITLE: "Η φόρμα επιταγής {0} ενημερώθηκε"
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Οι αλλαγές αποθηκεύτηκαν!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: "Η τιμή δημιουργήθηκε"
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η τιμή ενημερώθηκε.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Η τιμή διαγράφηκε.'
    },
    BULK_RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκαν σύνδεσμοι υποψηφίων για πελάτες!"
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκε σύνδεσμος υποψήφιος προς πελάτη!"
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: "Ο σύνδεσμος Υποψήφιος προς Πελάτη ενημερώθηκε!"
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Η προσφορά ενημερώθηκε!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Σας ευχαριστούμε που γράψατε μια κριτική!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Επισημάνθηκε ως αγαπημένο!',
        MESSAGE: "Θα κάνουμε το καλύτερο δυνατό για να σας ταιριάξουμε μαζί τους στο μέλλον."
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Ευχαριστούμε που μας ενημερώσατε.',
        MESSAGE: "Θα κάνουμε το καλύτερο δυνατό για να σας συνδέσουμε με άλλους στο μέλλον"
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Σας ευχαριστούμε που υποβάλατε τα στοιχεία πληρωμής σας!"
    },
    PACKAGE_SELECTED_RESULT_DIALOG: {
        TITLE: 'Το πακέτο σας επιλέχθηκε, ευχαριστώ!',
        MESSAGE: "Η αναζήτησή μας βρίσκεται σε εξέλιξη, θα επικοινωνήσουμε σύντομα!"
    },
    EVALUATION_CREATED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση δημιουργήθηκε."
    },
    EVALUATION_UPDATED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση ενημερώθηκε."
    },
    EVALUATION_DELETED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση διαγράφηκε."
    },
    QUESTION_CREATED_RESULT_DIALOG: {
        TITLE: "Η ερώτηση δημιουργήθηκε."
    },
    BLOCKTEXT_CREATED_RESULT_DIALOG: {
        TITLE: "Δημιουργήθηκε μπλοκ κειμένου"
    },
    QUESTION_UPDATED_RESULT_DIALOG: {
        TITLE: "Η ερώτηση ενημερώθηκε."
    },
    BLOCKTEXT_UPDATED_RESULT_DIALOG: {
        TITLE: "Το μπλοκ κειμένου ενημερώθηκε"
    },
    QUESTION_DELETED_RESULT_DIALOG: {
        TITLE: "Η ερώτηση διαγράφηκε."
    },
    BLOCKTEXT_DELETED_RESULT_DIALOG: {
        TITLE: "Το μπλοκ κειμένου διαγράφηκε"
    },
    EVALUATION_ADDED_RESULT_DIALOG: {
        TITLE: "Η αξιολόγηση προστέθηκε!"
    },
    EVALUATION_COMPLETED_RESULT_DIALOG: {
        TITLE: "{0} ολοκληρώθηκε, ευχαριστώ!",
        CLOSE_LABEL: "Τέλος"
    },
    TIME_OFF_REQUEST_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Το αίτημά σας για άδεια έχει υποβληθεί, θα το εξετάσουμε και θα επιβεβαιώσουμε όταν εγκριθεί!",
        CLOSE_LABEL: "Τέλος"
    },
    AVAILABILITY_NOTES_UPDATED_RESULT_DIALOG: {
        TITLE: "Οι σημειώσεις ενημερώθηκαν!",
        CLOSE_LABEL: "Συνέχεια"
    },
    BUFFER_TIME_UPDATED_RESULT_DIALOG: {
        TITLE: "Η ώρα buffer ενημερώθηκε!"
    },
    MAX_BOOKING_NUMBER_UPDATED_RESULT_DIALOG: {
        TITLE: "Ενημερώθηκε ο μέγιστος αριθμός κρατήσεων ανά ημέρα!"
    },
    SCHEDULE_UPDATED_RESULT_DIALOG: {
        TITLE: "Το χρονοδιάγραμμα ενημερώθηκε."
    },
    DOCUMENT_SEND_TO_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Το έγγραφο αποστέλλεται στον υποψήφιο"
    },
    DOCUMENT_MARK_AS_DRAFT_RESULT_DIALOG: {
        TITLE: "Το έγγραφο έχει επισημανθεί ως πρόχειρο"
    },
    DOCUMENT_PUBLISH_RESULT_DIALOG: {
        TITLE: "Το έγγραφο δημοσιεύτηκε"
    },
    DOCUMENT_UPDATED_RESULT_DIALOG: {
        TITLE: "Το έγγραφο ενημερώθηκε"
    },
    BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG: {
        TITLE: "Ζητούμε συγγνώμη, έχουμε κρατηθεί για αυτήν την ημερομηνία! Θα σας προσθέσουμε στη λίστα ακύρωσης και θα σας ενημερώσουμε για τυχόν αλλαγές το συντομότερο δυνατό.",
        CLOSE_LABEL: "Συνέχεια"
    },
    CHECKLIST_SAVED_RESULT_DIALOG: {
        TITLE: "Η λίστα ελέγχου έχει αποθηκευτεί"
    },
    FEEDBACK_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Ευχαριστούμε, θα επικοινωνήσουμε σύντομα."
    },
    FEEDBACK_SUBMITTED_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστούμε για την υποβολή των σχολίων"
    },
    USER_ALERT_BLOCKED_POPUP_DIALOG: {
        TITLE: "Εάν δεν έχει ανοίξει ένα νέο παράθυρο, ελέγξτε εάν τα αναδυόμενα παράθυρα έχουν αποκλειστεί",
        CLOSE_LABEL: "Ακύρωση"
    },
    CLOCK_OUT_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Εάν υπήρχαν προβλήματα με την εγγραφή της ώρας ή οτιδήποτε άλλο, ενημερώστε μας.",
        CLOSE_LABEL: "Τέλος"
    },
    CLOCK_OUT_TRANSFER_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Θα πληρωθείτε απευθείας μέσω Stripe. Εάν υπήρχαν προβλήματα με την καταγραφή των ωρών ή οτιδήποτε άλλο, ενημερώστε μας.",
        CLOSE_LABEL: "Τέλος"
    },
    CLOCK_IN_SUCCESS_RESULT_DIALOG: {
        TITLE: "Ευχαριστώ!",
        MESSAGE: "Μην ξεχάσετε να παρακολουθήσετε όταν τελειώσετε!",
        CLOSE_LABEL: "Τέλος"
    },
    SCHEDULE_RELEASED_RESULT_DIALOG: {
        TITLE: "Το πρόγραμμα κυκλοφόρησε!"
    },
    EVENT_BOOKED_RESULT_DIALOG: {
        TITLE: "Η εκδήλωση έγινε κράτηση!"
    },
    DOCUMENT_ADDED_RESULT_DIALOG: {
        TITLE: "Το έγγραφο προστέθηκε!"
    },
    MAILCHIMP_ADDED_RESULT_DIALOG: {
        TITLE: "Έγινε επιτυχής εγγραφή στη λίστα Mailchimp!"
    },
    TENTATIVE_ASSIGN_RESULT_DIALOG: {
        TITLE: "Η νταντά ανατέθηκε προσωρινά."
    },
    TENTATIVE_ASSIGN_HAS_BIG_RED_BTN_RESULT_DIALOG: {
        TITLE: "Η νταντά ανατέθηκε προσωρινά.",
        MESSAGE: "Κανείς δεν έχει ειδοποιηθεί, θα ενημερωθεί όταν πατήσετε το μεγάλο κόκκινο κουμπί"
    },
    SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} υποβλήθηκαν πληροφορίες",
        MESSAGE: "Σας ευχαριστούμε που υποβάλατε {0} πληροφορίες. Κλείστε το παράθυρο ή υποβάλετε ένα άλλο {1}"
    },
    USER_SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} υποβλήθηκαν πληροφορίες",
        MESSAGE: "Σας ευχαριστούμε που υποβάλατε {0} πληροφορίες. Κλείστε το παράθυρο"
    },
    CANDIDATE_SELECTED_RESULT_DIALOG: {
        TITLE: "Σας ευχαριστούμε που επιλέξατε τον υποψήφιο"
    },
    CLOCK_IN_OUT_APPROVED_RESULT_DIALOG: {
        TITLE: "Οι ώρες εισόδου και ρολογιού έχουν εγκριθεί"
    },
    CLOCK_IN_OUT_DISAPPROVED_RESULT_DIALOG: {
        TITLE: "Οι ώρες εισόδου και ρολογιού απορρίφθηκαν"
    },
    PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '{0} Προστέθηκαν πιστώσεις, ευχαριστώ!'
    },
    MONTHLY_PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: "{0} προστέθηκαν μηνιαίες πιστώσεις, ευχαριστούμε!"
    },
    STRIPE_SUBSCRIPTION_SELECTED_RESULT_DIALOG: {
        TITLE: "Η συνδρομή ξεκίνησε, σας ευχαριστώ!"
    },
    UNASSIGN_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος καταργήθηκε"
    },
    SAVED_ADVANCE_SEARCH_RESULT_DIALOG: {
        TITLE: "Αποθηκευμένη εκ των προτέρων αναζήτηση"
    },
    BOOKING_ADDED_RESULT_DIALOG: {
        TITLE: "Η κράτηση προστέθηκε"
    },
    JOB_TIP_ADDED_RESULT_DIALOG: {
        TITLE: "Η συμβουλή προστέθηκε"
    },
    BULK_COPY_SUGGESTED_CHARGE_RESULT_DIALOG: {
        TITLE: "Αντιγράφηκε η προτεινόμενη χρέωση στη συνολική χρέωση πελάτη"
    },
    CANDIDATES_NO_LONGER_AVAILABLES: {
        TITLE: "Ο επιλεγμένος υποψήφιος δεν είναι πλέον διαθέσιμος",
        MESSAGE: 'Ο επιλεγμένος υποψήφιος ({0}) δεν είναι πλέον διαθέσιμος. Επιλέξτε άλλον υποψήφιο',
        CLOSE_LABEL: "OK"
    },
    RESELECT_JOB_FILLER_RESULT_DIALOG: {
        TITLE: "Η ημερομηνία/ώρα κράτησης άλλαξε. Επιλέξτε ξανά υποψήφιο για την κράτηση",
        CLOSE_LABEL: "OK"
    },
    REQUEST_TIMEOFF_APPROVED_RESULT_DIALOG: {
        TITLE: "Το αίτημα εγκρίθηκε"
    },
    REQUEST_TIMEOFF_DECLINED_RESULT_DIALOG: {
        TITLE: "Το αίτημα απορρίφθηκε"
    },
    MARK_SELECTED_TASK_COMPETED_RESULT_DIALOG: {
        TITLE: "Επισημάνθηκαν επιλεγμένες εργασίες ως ολοκληρωμένες"
    },
    SCRAPER_STATUS_RESULT_DIALOG: {
        TITLE: "Αυτό μπορεί να διαρκέσει μερικά λεπτά, συνεχίστε αυτό που κάνετε και ανανεώστε το σε λίγα λεπτά."
    },
    SHIFT_JOB_REPORT_SUBMITTED: {
        TITLE: "{0} αναφορά υποβλήθηκε με επιτυχία"
    },
    MANUAL_TRANSFER_SUCCESS: {
        TITLE: "Η μεταφορά με επιτυχία",
        MESSAGE: "Αναγνωριστικό μεταφοράς: {0}"
    },
    EMAIL_SENT_RESULT_DIALOG: {
        TITLE: "Τα μηνύματα ηλεκτρονικού ταχυδρομείου εστάλησαν"
    },
    MARK_JOB_COMPLETED_RESULT_DIALOG: {
        TITLE: "Η εργασία επισημάνθηκε ως ολοκληρωμένη"
    },
    PACKAGE_CREATED_RESULT_DIALOG: {
        TITLE: "Το πακέτο δημιουργήθηκε."
    },
    PACKAGE_UPDATED_RESULT_DIALOG: {
        TITLE: "Το πακέτο ενημερώθηκε."
    },
    PACKAGE_DELETED_RESULT_DIALOG: {
        TITLE: "Το πακέτο διαγράφηκε."
    },
    TIP_CHARGE_RESULT_DIALOG: {
        TITLE: "Η συμβουλή σας έχει σταλεί στο {0}, σας ευχαριστούμε πολύ!"
    },
    REPORT_PROBLEM_RESULT_DIALOG: {
        TITLE: "Το πρόβλημα αναφέρθηκε με επιτυχία"
    },
    COPY_USER_FIELD_RESULT_DIALOG: {
        TITLE: "Τα πεδία αντιγράφηκαν με επιτυχία",
        MESSAGE: "Τα δεδομένα αντιγράφονται από {0} σε {1}"
    },
    CANCEL_EMAIL_RESULT_DIALOG: {
        TITLE: "Το email ακυρώθηκε"
    },
    REVIEW_DELETED_RESULT_DIALOG: {
        TITLE: "Η κριτική διαγράφηκε."
    },
    NEED_AGENCY_PHONE_RESULT_DIALOG: {
        TITLE: "Δεν έχετε ρυθμίσει ακόμα το SMS!",
        MESSAGE: "Επικοινωνήστε με την ομάδα μας για να ξεκινήσετε."
    },
    ADDITIONAL_DATE_ADDED_RESULT_DIALOG: {
        TITLE: "Προστέθηκαν κρατήσεις"
    },
    INVOICE_SENT_RESULT_DIALOG: {
        TITLE: "Το τιμολόγιο στάλθηκε"
    },
    STRIPE_ACCOUNT_DELETED: {
        TITLE: "Διαγράφηκε ο λογαριασμός Sripe"
    },
    SUBMITTED_MODAL_RESULT_DIALOG: {
        TITLE: "Ευχαριστούμε, θα επικοινωνήσουμε σύντομα!"
    },
    NO_CANDIDATE_AVAILABLE_FOR_ALL_BOOKING: {
        TITLE: "Δεν υπάρχει υποψήφιος που να είναι διαθέσιμος για όλες τις ανοιχτές κρατήσεις"
    },
    RETURNING_APPLICANT_RESULT_DIALOG: {
        TITLE: "Οι πληροφορίες που καταχωρίσατε προηγουμένως έχουν φορτωθεί, συνεχίστε!"
    },
    JOB_SHARE_MARKET_PLACE_RESULT_DIALOG: {
        TITLE: "Η εργασία μοιράζεται με την αγορά του πρακτορείου"
    },
    CANDIDATE_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Ο υποψήφιος υποβάλλεται στη θέση εργασίας"
    },
    BULK_RESOURCE_DELETED_RESULT_DIALOG: {
        TITLE: "{0} {1} διαγράφηκε"
    },
    REPEAT_BLASTER_BEING_SENT_RESULT_DIALOG: {
        TITLE: "{0} αποστέλλονται"
    },
    BOOKING_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Η κράτησή σας υποβλήθηκε, μπορείτε να κλείσετε το παράθυρο"
    },
    FILLED_JOB_RESULT_DIALOG: {
        TITLE: "Αυτή η θέση εργασίας έχει καλυφθεί!"
    }
};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  listKeapCustomFields: null,
  listKeapRelationship: null
};

var mutations = {
  setListKeapCustomFields: function setListKeapCustomFields(state, payload) {
    state.listKeapCustomFields = payload;
  },
  setListKeapRelationship: function setListKeapRelationship(state, payload) {
    state.listKeapRelationship = payload;
  }
};

var actions = {
  setListKeapCustomFields: function setListKeapCustomFields(_ref, payload) {
    var commit = _ref.commit;

    commit("setListKeapCustomFields", payload);
  },
  setListKeapRelationship: function setListKeapRelationship(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setListKeapRelationship", payload);
  }
};

var getters = {
  listKeapCustomFields: function listKeapCustomFields(state) {
    return state.listKeapCustomFields;
  },
  listKeapRelationship: function listKeapRelationship(state) {
    return state.listKeapRelationship;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customDefineType = __webpack_require__(6);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  priceList: null, // list prices of price manager
  rushFeeInfo: null // Save rush fee of repeated bookings (when rush fee of each booking can be different)
};

var mutations = {
  setPriceList: function setPriceList(state, payload) {
    state.priceList = payload;
  },
  setRushFeeInfo: function setRushFeeInfo(state, payload) {
    state.rushFeeInfo = payload;
  }
};

var actions = {
  loadPriceList: function loadPriceList(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    return new Promise(function _callee(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.priceList) {
                _context.next = 3;
                break;
              }

              resolve();
              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/prices/?agency=" + rootState.authentication.agencyID.toString()));

            case 5:
              res = _context.sent;

              commit("setPriceList", res.data.filter(function (item) {
                return !item.deactivated;
              }));
              resolve();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    });
  },
  setPriceList: function setPriceList(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setPriceList", payload);
  },
  setRushFeeInfo: function setRushFeeInfo(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setRushFeeInfo", payload);
  }
};

var getters = {
  priceList: function priceList(state) {
    return state.priceList || [];
  },
  hourlyServiceSelectionList: function hourlyServiceSelectionList(state) {
    if (!state.priceList) {
      return [];
    }
    var result = state.priceList.filter(function (price) {
      return price.type === _customDefineType.PRICE_TYPES.HOURLY_SERVICES_SELECTION;
    });
    // Sort by order (null items at the end)
    result = result.sort(function (item1, item2) {
      return (item2.order != null) - (item1.order != null) || item1.order - item2.order;
    });
    result.forEach(function (price) {
      var label = price.name;
      if (price.price2) {
        label = label + ", $" + price.price2 + " per hour";
      }
      price.label = label;
    });
    return result;
  },
  quickbooksPriceSelectionList: function quickbooksPriceSelectionList(state) {
    if (!state.priceList) {
      return [];
    }
    var result = state.priceList.filter(function (price) {
      return price.type === 'Quickbooks Desktop';
    });
    // Sort by order (null items at the end)
    result = result.sort(function (item1, item2) {
      return (item2.order != null) - (item1.order != null) || item1.order - item2.order;
    });
    return result;
  },
  turnOnSurgePricing: function turnOnSurgePricing(state, getters, rootState) {
    var agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      var result = agency.public_advance_setting.turn_on_surge_price;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  isRecalculatePriceOnAssignJob: function isRecalculatePriceOnAssignJob(state) {
    if (!state.priceList) {
      return false;
    }
    // Recalculate if price depends on candidate
    return state.priceList.some(function (price) {
      return price.is_price_expession && price.price_expression && (price.price_expression.includes('[[filler_number_job_in_month]]') || price.price_expression.includes('[[candidate_rate]]'));
    });
  },
  listModelRecalculatedWhenAssignJob: function listModelRecalculatedWhenAssignJob(state) {
    if (!state.priceList) {
      return [];
    }
    var result = [];
    var listRecalculatePrices = state.priceList.filter(function (price) {
      return price.is_price_expession && price.price_expression && (price.price_expression.includes('[[filler_number_job_in_month]]') || price.price_expression.includes('[[candidate_rate]]'));
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = listRecalculatePrices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var price = _step.value;

        if (price.type === _customDefineType.PRICE_TYPES.HOURLY_AGENCY_COMMISSION) {
          result.push('agency_fee');
        }
        if (price.type === _customDefineType.PRICE_TYPES.HOURLY_BOOKING_RATE) {
          result.push('candidate_rate');
          result.push('client_rate');
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return result;
  },
  rushFeeInfo: function rushFeeInfo(state) {
    return state.rushFeeInfo;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  agencyBadgesList: [],
  selectedCandidateBadges: []
};

var mutations = {
  setBadges: function setBadges(state, payload) {
    state.agencyBadgesList = payload;
  },
  addBadge: function addBadge(state, payload) {
    state.agencyBadgesList.push(payload);
  },
  updateBadge: function updateBadge(state, payload) {
    var index = state.agencyBadgesList.findIndex(function (element) {
      return element.id === payload.id;
    });
    state.agencyBadgesList[index] = payload;
  },
  removeBadge: function removeBadge(state, payload) {
    var index = state.agencyBadgesList.findIndex(function (element) {
      return element.id === payload.badgeId;
    });
    state.agencyBadgesList.splice(index, 1);
  },
  setSelectedCandidateBadges: function setSelectedCandidateBadges(state, payload) {
    state.selectedCandidateBadges = payload;
  }
};
var actions = {
  getAllBadges: function getAllBadges(context, payload) {
    var response;
    return regeneratorRuntime.async(function getAllBadges$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.get("/api/agency_badge/?agency_id=" + payload.agencyId));

          case 3:
            response = _context.sent;

            console.log(response);
            if (response.status === 200) {
              context.commit("setBadges", response.data);
            }
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);

            console.error(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, null, this, [[0, 8]]);
  },
  addNewBadge: function addNewBadge(context, payload) {
    var response;
    return regeneratorRuntime.async(function addNewBadge$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.post("/api/agency_badge/create/", payload));

          case 3:
            response = _context2.sent;

            if (response.status === 201) {
              context.commit("addBadge", response.data);
            }
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

            console.error(_context2.t0);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, null, this, [[0, 7]]);
  },
  updateBadge: function updateBadge(context, payload) {
    var form, response;
    return regeneratorRuntime.async(function updateBadge$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            form = new FormData();


            if (payload.badge_image instanceof File) {
              form.append("badge_image", payload.badge_image);
            }
            form.append("badge_name", payload.badge_name);
            form.append("review_required", payload.review_required);
            if (payload.review_required) {
              form.append("email", payload.email);
            }
            form.append("agency", payload.agency);
            _context3.next = 9;
            return regeneratorRuntime.awrap(_axios2.default.patch("/api/agency_badge/update/" + payload.id, form));

          case 9:
            response = _context3.sent;

            if (!(response.status === 200)) {
              _context3.next = 13;
              break;
            }

            context.commit("updateBadge", response.data);
            return _context3.abrupt("return", response);

          case 13:
            _context3.next = 18;
            break;

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](0);

            console.error(_context3.t0);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, null, this, [[0, 15]]);
  },
  deleteBadge: function deleteBadge(context, payload) {
    var response;
    return regeneratorRuntime.async(function deleteBadge$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.delete("/api/agency_badge/delete/" + payload.badgeId));

          case 3:
            response = _context4.sent;

            if (response.status === 204) {
              context.commit("removeBadge", payload);
            }
            _context4.next = 10;
            break;

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);

            console.error(_context4.t0);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, null, this, [[0, 7]]);
  },
  addCandidateBadges: function addCandidateBadges(_, payload) {
    return regeneratorRuntime.async(function addCandidateBadges$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.put("api/candidate_badge/update/", payload));

          case 3:
            return _context5.abrupt("return", _context5.sent);

          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](0);

            console.error(_context5.t0);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, null, this, [[0, 6]]);
  },
  getCandidateBadge: function getCandidateBadge(context, payload) {
    var response;
    return regeneratorRuntime.async(function getCandidateBadge$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.get("api/candidate_badge/?candidate_id=" + payload.candidateId));

          case 3:
            response = _context6.sent;

            context.commit("setSelectedCandidateBadges", response.data);
            _context6.next = 10;
            break;

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);

            console.log(_context6.t0);

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, null, this, [[0, 7]]);
  },
  deleteCandidateBadges: function deleteCandidateBadges(context, payload) {
    return regeneratorRuntime.async(function deleteCandidateBadges$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return regeneratorRuntime.awrap(_axios2.default.delete("api/candidate_badge/delete/" + payload.candidateId));

          case 3:
            context.commit("setSelectedCandidateBadges", []);
            _context7.next = 9;
            break;

          case 6:
            _context7.prev = 6;
            _context7.t0 = _context7["catch"](0);

            console.error(_context7.t0);

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, null, this, [[0, 6]]);
  }
};
var getters = {
  getBadges: function getBadges(state) {
    return state.agencyBadgesList;
  },
  getSelectedCandidateBadges: function getSelectedCandidateBadges(state) {
    return state.selectedCandidateBadges;
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _fieldTypes = __webpack_require__(45);

var _arrayHandling = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var state = {
  profileBuilderList: null,
  candidateBuilderList: null, // Profile builder list for candidate
  clientBuilderList: null // Profile builder list for client
};

var mutations = {
  setProfileBuilderList: function setProfileBuilderList(state, payload) {
    if (payload == null) {
      state.profileBuilderList = null;
      state.candidateBuilderList = null;
      state.clientBuilderList = null;
    } else {
      state.profileBuilderList = payload;
      state.candidateBuilderList = payload.filter(function (builder) {
        return builder.user_type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
      });
      state.clientBuilderList = payload.filter(function (builder) {
        return builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
      });
    }
  },
  setCandidateBuilderList: function setCandidateBuilderList(state, payload) {
    if (payload == null) {
      state.candidateBuilderList = null;
    } else {
      state.candidateBuilderList = payload;
      if (state.profileBuilderList == null || state.profileBuilderList.length === 0) {
        state.profileBuilderList = payload;
      }
    }
  },
  setClientBuilderList: function setClientBuilderList(state, payload) {
    if (payload == null) {
      state.clientBuilderList = null;
    } else {
      state.clientBuilderList = payload;
      if (state.profileBuilderList == null || state.profileBuilderList.length === 0) {
        state.profileBuilderList = payload;
      }
    }
  }
};

var actions = {
  setProfileBuilderList: function setProfileBuilderList(_ref, payload) {
    var commit = _ref.commit;

    commit("setProfileBuilderList", payload);
  },
  setCandidateBuilderList: function setCandidateBuilderList(_ref2, payload) {
    var commit = _ref2.commit;

    commit("setCandidateBuilderList", payload);
  },
  setClientBuilderList: function setClientBuilderList(_ref3, payload) {
    var commit = _ref3.commit;

    commit("setClientBuilderList", payload);
  },
  reloadProfileBuilderList: function reloadProfileBuilderList(_ref4) {
    var _this = this;

    var commit = _ref4.commit,
        rootState = _ref4.rootState;

    return new Promise(function _callee(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (rootState.authentication.agencyID) {
                _context.next = 4;
                break;
              }

              commit("setProfileBuilderList", null);
              resolve();
              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/profilesections/?agency=" + rootState.authentication.agencyID.toString()));

            case 6:
              res = _context.sent;

              commit("setProfileBuilderList", res.data);
              resolve();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, null, _this);
    });
  },
  loadProfileBuilderList: function loadProfileBuilderList(_ref5) {
    var _this2 = this;

    var state = _ref5.state,
        commit = _ref5.commit,
        rootState = _ref5.rootState;

    return new Promise(function _callee2(resolve) {
      var res;
      return regeneratorRuntime.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(state.profileBuilderList && state.profileBuilderList.length)) {
                _context2.next = 3;
                break;
              }

              resolve();
              return _context2.abrupt("return");

            case 3:
              if (rootState.authentication.agencyID) {
                _context2.next = 7;
                break;
              }

              commit("setProfileBuilderList", null);
              resolve();
              return _context2.abrupt("return");

            case 7:
              _context2.next = 9;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/profilesections/?agency=" + rootState.authentication.agencyID.toString()));

            case 9:
              res = _context2.sent;

              commit("setProfileBuilderList", res.data);
              resolve();

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, null, _this2);
    });
  }
};

var getters = {
  listScheduleMeetingFormFieldsDefault: function listScheduleMeetingFormFieldsDefault() {
    return [{
      label: "Header",
      type: _customDefineType.FORM_TYPE.HTML,
      html: "<h2>Thanks for letting us know you are interested!</h2>\n        <p>The next step is for us to schedule a meeting with you and the candidate. Please fill in this form:</p>"
    }, {
      label: "Would you prefer to start with a virtual meeting or in person? If virtual, please let us know if you have a preferred platform (Zoom, FaceTime, phone call, etc.)",
      labelDetail: "Client Interview Preference",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      model: "text1",
      isRequired: false,
      isOptional: true
    }, {
      label: "Please let us know some upcoming days and times when you are available",
      labelDetail: "Client Interview Availability",
      type: _customDefineType.FORM_TYPE.TEXTAREA,
      model: "text2",
      isRequired: false,
      isOptional: true
    }];
  },
  listJobApplicationFieldsDefault: function listJobApplicationFieldsDefault() {
    return [{
      label: "Application Notes",
      description: "This is optional, please mention anything specific you'd like us to know.",
      type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
      model: "message",
      isRequired: false,
      isOptional: true
    }, {
      type: _customDefineType.FORM_TYPE.VIDEO,
      model: "video_id",
      isRequired: false,
      isOptional: true,
      videoType: "Candidate Job Application",
      videoUrlModel: "video_url",
      label: "Application Video",
      description: ""
    }];
  },
  listPlacementJobFieldsDefault: function listPlacementJobFieldsDefault(state, getters, rootState, rootGetters) {
    var result = [{
      label: "How much revenue was generated from this job? (Admin Only)",
      model: "revenue",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true,
      isAdminOnly: true
    }, {
      label: "Date Revenue Generate? (Admin Only)",
      model: "date_revenue_generate",
      type: _customDefineType.FORM_TYPE.DATEPICKER,
      isOptional: true,
      isRequired: false,
      isAdminOnly: true
    }, {
      label: "Title",
      model: "title",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }];
    if (rootGetters.listPlacementJobTypes && rootGetters.listPlacementJobTypes.length) {
      result.push({
        label: "Job Categories",
        model: "types",
        optionList: rootGetters.listPlacementJobTypes,
        type: _customDefineType.FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        isRequired: false,
        isOptional: true
      });
    }
    result = [].concat(_toConsumableArray(result), [{
      keyLangLabel: "LABELS.ADDRESS",
      model: "address1",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }, {
      keyLangLabel: "LABELS.CITY",
      model: "city",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }, {
      keyLangLabel: "LABELS.STATE",
      model: "provincestate",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }, {
      keyLangLabel: "LABELS.COUNTRY",
      model: "country",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }, {
      keyLangLabel: "LABELS.ZIP_CODE",
      model: "postal_code",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }]);
    if (rootGetters.agencyLocations && rootGetters.agencyLocations.length) {
      result.push({
        keyLangLabel: "LABELS.LOCATIONS",
        model: "locations",
        optionList: rootGetters.agencyLocations,
        type: _customDefineType.FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        isRequired: false,
        isOptional: true
      });
    }
    result = [].concat(_toConsumableArray(result), [{
      label: "Compensation",
      model: "compensation",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }, {
      label: "Start Date",
      model: "start_date_text",
      type: _customDefineType.FORM_TYPE.TEXTBOX,
      isRequired: false,
      isOptional: true
    }]);

    if (rootGetters.agencyType === "Nanny and Household Staffing") {
      var list2 = [{
        label: "Children",
        type: _customDefineType.FORM_TYPE.TEXTAREA,
        model: "children_description",
        isRequired: false,
        isOptional: true
      }, {
        label: "Schedule",
        type: _customDefineType.FORM_TYPE.TEXTAREA,
        model: "text",
        isRequired: false,
        isOptional: true
      }];
      result = [].concat(_toConsumableArray(result), list2);
    }

    var list3 = [{
      keyLangLabel: "LABELS.DESCRIPTION",
      type: _customDefineType.FORM_TYPE.TEXT_EDITOR,
      model: "description",
      isRequired: false,
      isOptional: true
    }, {
      label: "Upload Picture",
      type: _customDefineType.FORM_TYPE.FILE,
      model: "file1",
      isRequired: false,
      isOptional: true
    }];
    result = [].concat(_toConsumableArray(result), list3);

    if (rootGetters.agencyType === "Nanny and Household Staffing") {
      result.push({
        type: _customDefineType.FORM_TYPE.HTML,
        html: "<a\n            href=\"https://drive.google.com/drive/folders/1sxMb-urKv_6AV6oAi0ULip_x5uwiETMS?usp=sharing\"\n            target=\"_blank\"\n            class=\"mylisting-button dark-button\"\n            >View Photo Bank</a\n          >"
      });
    }

    result.push({
      type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
      label: "Hide from job board",
      model: "hide_from_job_board",
      isRequired: false
    }, {
      type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
      label: "Make visible to candidates in dashboard",
      model: "visible_to_candidates",
      isRequired: false,
      showIf: "hide_from_job_board",
      showIfValue: "Yes"
    });
    return result;
  },
  placementJobBuilder: function placementJobBuilder(state, getters, rootState, rootGetters) {
    var builderList = rootGetters.profileBuilderList;
    if (builderList) {
      return builderList.find(function (builder) {
        return builder.type === _customDefineType.BUILDER_TYPE.PLACEMENT_JOB;
      });
    }
    return null;
  },
  listPlacementJobFields: function listPlacementJobFields(state, getters, rootState, rootGetters) {
    var builderList = rootGetters.profileBuilderList;
    if (builderList) {
      var placementJobBuilder = builderList.find(function (builder) {
        return builder.type === _customDefineType.BUILDER_TYPE.PLACEMENT_JOB;
      });
      if (placementJobBuilder && placementJobBuilder.list_fields && placementJobBuilder.list_fields.length) {
        return placementJobBuilder.list_fields;
      }
    }
    return getters.listPlacementJobFieldsDefault;
  },
  listReferenceFields: function listReferenceFields(state, getters, rootState, rootGetters) {
    var builderList = rootGetters.profileBuilderList;
    if (builderList) {
      var listReferenceBuilder = builderList.filter(function (builder) {
        return builder.type === _customDefineType.BUILDER_TYPE.SECTION && builder.api === _fieldTypes.MAP_DIALOG_SECTION.Reference.api;
      });
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = listReferenceBuilder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var builder = _step.value;

          if (builder.list_fields) {
            result = [].concat(_toConsumableArray(result), _toConsumableArray(builder.list_fields.filter(function (field) {
              return field.model;
            })));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return (0, _arrayHandling.deduplicateArrayOfObject)(result, 'model');
    }
    return [];
  },

  // map booking label field => booking category
  mapBookingFieldLabelCategory: function mapBookingFieldLabelCategory(state, getters, rootState, rootGetters) {
    var builderList = rootGetters.profileBuilderList;
    var result = {};
    if (builderList) {
      var profileBuilderList = builderList.filter(function (builder) {
        return builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
      });
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = profileBuilderList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var builder = _step2.value;

          if (builder.list_fields) {
            var bookingFields = builder.list_fields.filter(function (field) {
              return field.type === _customDefineType.FORM_TYPE.BOOKING_SECTION;
            });
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = bookingFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var bookingField = _step3.value;

                if (bookingField.categoryList) {
                  result[bookingField.label] = bookingField.categoryList;
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    return result;
  },
  listBuilderConditionKeys: function listBuilderConditionKeys() {
    return [{
      varKey: 'listRejectConditions',
      apiKey: 'reject_conditions'
    }, {
      varKey: 'listTypeConditions',
      apiKey: 'type_conditions'
    }, {
      varKey: 'listStatusConditions',
      apiKey: 'status_conditions'
    }, {
      varKey: 'listSecondStatusConditions',
      apiKey: 'second_status_conditions'
    }, {
      varKey: 'listTagConditions',
      apiKey: 'tag_conditions'
    }, {
      varKey: 'listKeapTagConditions',
      apiKey: 'keap_tag_conditions'
    }, {
      varKey: 'listLocationConditions',
      apiKey: 'location_conditions'
    }, {
      varKey: 'listManagerConditions',
      apiKey: 'manager_conditions'
    }, {
      varKey: 'listSecondManagerConditions',
      apiKey: 'second_manager_conditions'
    }, {
      varKey: 'listMembershipConditions',
      apiKey: 'membership_conditions'
    }, {
      varKey: 'listChecklistConditions',
      apiKey: 'checklist_conditions'
    }, {
      varKey: 'listBadgeConditions',
      apiKey: 'badge_conditions'
    }, {
      varKey: 'listErrorConditions',
      apiKey: 'error_conditions'
    }];
  },
  listExcludeFieldTypeInProfile: function listExcludeFieldTypeInProfile() {
    return [_customDefineType.FORM_TYPE.PLACEMENT_JOB_SELECTION];
  },
  profileBuilderList: function profileBuilderList(state) {
    return state.profileBuilderList || [];
  },
  candidateBuilderList: function candidateBuilderList(state) {
    return state.candidateBuilderList || [];
  },
  clientBuilderList: function clientBuilderList(state) {
    return state.clientBuilderList || [];
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaultValues = __webpack_require__(17);

var state = {};
var mutations = {};
var actions = {};
var getters = {
    referenceTableFields: function referenceTableFields(state, getters, rootState) {
        // Check admin level setting
        var adminSetting = rootState.general.adminSetting;
        if (adminSetting && adminSetting.setting && adminSetting.setting.use_admin_level__advance_setting_reference_table_fields) {
            var adminLevelSetting = adminSetting.setting.admin_level__advance_setting_reference_table_fields;
            if (adminLevelSetting && adminLevelSetting.length) {
                return adminLevelSetting;
            }
        }
        var agency = rootState.authentication.agency;
        if (agency && agency.advance_setting) {
            var listFields = agency.advance_setting.reference_table_fields;
            if (listFields && listFields.length) {
                return listFields;
            }
        }
        return _defaultValues.DEFAULT_REFERENCE_TABLE_FIELDS_OPTIONS;
    }
};

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {};
var mutations = {};
var actions = {};
var getters = {
    listExperienceTypes: function listExperienceTypes(state, getters, rootState) {
        return (0, _tryGet2.default)(function () {
            return rootState.agency.agencyPublic.public_advance_setting.exprience_types;
        });
    }
};

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _defaultValues = __webpack_require__(17);

var _tryGet = __webpack_require__(27);

var _tryGet2 = _interopRequireDefault(_tryGet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
    listPlacementJobs: [],
    mapPlacementJobIdTitle: {}
};

var mutations = {
    setListPlacementJobs: function setListPlacementJobs(state, payload) {
        state.listPlacementJobs = payload;
    },
    setMapPlacementJobIdTitle: function setMapPlacementJobIdTitle(state, payload) {
        state.mapPlacementJobIdTitle = payload;
    }
};

var actions = {
    setListPlacementJobs: function setListPlacementJobs(_ref, payload) {
        var commit = _ref.commit;

        commit("setListPlacementJobs", payload);
    },
    loadPlacementJobList: function loadPlacementJobList(_ref2) {
        var _this = this;

        var commit = _ref2.commit,
            state = _ref2.state,
            rootState = _ref2.rootState;

        return new Promise(function _callee(resolve) {
            var res, listJobs;
            return regeneratorRuntime.async(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(state.listPlacementJobs && state.listPlacementJobs.length)) {
                                _context.next = 3;
                                break;
                            }

                            resolve();
                            return _context.abrupt("return");

                        case 3:
                            _context.next = 5;
                            return regeneratorRuntime.awrap(_axios2.default.get("/get-jobs/?job_type=Long Term&agency=" + rootState.authentication.agencyID.toString()));

                        case 5:
                            res = _context.sent;

                            if (!(!res || !res.data)) {
                                _context.next = 9;
                                break;
                            }

                            resolve();
                            return _context.abrupt("return");

                        case 9:
                            listJobs = res.data.jobs;

                            listJobs = listJobs.sort(function (a, b) {
                                return a.id < b.id ? 1 : -1;
                            });
                            commit("setListPlacementJobs", listJobs);
                            resolve();

                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }
            }, null, _this);
        });
    },
    getPlacementJobById: function getPlacementJobById(_ref3, jobId) {
        var commit = _ref3.commit;
        var res;
        return regeneratorRuntime.async(function getPlacementJobById$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/jobs/" + jobId + "/"));

                    case 2:
                        res = _context2.sent;

                        if (!(res && res.data)) {
                            _context2.next = 5;
                            break;
                        }

                        return _context2.abrupt("return", res.data);

                    case 5:
                    case "end":
                        return _context2.stop();
                }
            }
        }, null, this);
    },
    addMapPlacementJobIdTitle: function addMapPlacementJobIdTitle(_ref4, listJobs) {
        var commit = _ref4.commit,
            state = _ref4.state;

        var currentMap = state.mapPlacementJobIdTitle || {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = listJobs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var job = _step.value;

                currentMap[job.id] = job.title;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        commit('setMapPlacementJobIdTitle', currentMap);
    }
};

var getters = {
    listPlacementJobs: function listPlacementJobs(state) {
        return state.listPlacementJobs;
    },
    mapPlacementJobIdTitle: function mapPlacementJobIdTitle(state) {
        return state.mapPlacementJobIdTitle || {};
    },
    defaultPlacementJobApplicationStatusAddingRelationship: function defaultPlacementJobApplicationStatusAddingRelationship(state, getters, rootState) {
        var agency = rootState.authentication.agency;
        if (agency && agency.advance_setting) {
            var listStatuses = agency.advance_setting.placement_application_status_auto_add_relationship_default;
            if (listStatuses) {
                return listStatuses;
            }
        }
        return [];
    },

    placementJobListDetailFields: function placementJobListDetailFields(state, getters, rootState) {
        return (0, _tryGet2.default)(function () {
            return rootState.authentication.agency.advance_setting.placement_job_list_detail_fields;
        }) || _defaultValues.DEFAULT_PLACEMENT_JOB_DETAIL_LIST_VIEW_FIELDS;
    }
};

exports.default = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  listCandidateEvaluationTemplates: null
};

var mutations = {
  setListCandidateEvaluationTemplates: function setListCandidateEvaluationTemplates(state, payload) {
    state.listCandidateEvaluationTemplates = payload;
  }
};

var actions = {
  setListCandidateEvaluationTemplates: function setListCandidateEvaluationTemplates(_ref, payload) {
    var commit = _ref.commit;

    commit("setListCandidateEvaluationTemplates", payload);
  },
  loadListCandidateEvaluationTemplates: function loadListCandidateEvaluationTemplates(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;
    var res;
    return regeneratorRuntime.async(function loadListCandidateEvaluationTemplates$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!state.listCandidateEvaluationTemplates) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return regeneratorRuntime.awrap(_axios2.default.get("/api/evaluationtemplates/?agency=" + rootState.authentication.agencyID + "&user_type=Candidate"));

          case 4:
            res = _context.sent;

            if (res && res.data) {
              commit('setListCandidateEvaluationTemplates', res.data);
            }

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, null, this);
  }
};

var getters = {
  listCandidateEvaluationTemplates: function listCandidateEvaluationTemplates(state) {
    return state.listCandidateEvaluationTemplates || [];
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.install = exports.destroyTooltip = exports.createTooltip = exports.VTooltip = exports.VPopover = exports.VClosePopover = undefined;

var _typeof2 = __webpack_require__(137);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(703);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(705);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(706);

var _createClass3 = _interopRequireDefault(_createClass2);

var _popper = __webpack_require__(707);

var _popper2 = _interopRequireDefault(_popper);

var _isEqual = __webpack_require__(708);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _vueResize = __webpack_require__(768);

var _merge = __webpack_require__(769);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGAnimatedString = function SVGAnimatedString() {};

if (typeof window !== 'undefined') {
  SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
  if (typeof value === 'string') {
    value = value.split(' ');
  }

  return value;
}
/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */

function addClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    if (classList.indexOf(newClass) === -1) {
      classList.push(newClass);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */

function removeClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    var index = classList.indexOf(newClass);

    if (index !== -1) {
      classList.splice(index, 1);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        (0, _defineProperty3.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}
var DEFAULT_OPTIONS = {
  container: false,
  delay: 0,
  html: false,
  placement: 'top',
  title: '',
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  trigger: 'hover focus',
  offset: 0
};
var openTooltips = [];

var Tooltip = /*#__PURE__*/function () {
  /**
   * Create a new Tooltip.js instance
   * @class Tooltip
   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
   * @param {Object} options
   * @param {String} options.placement=bottom
   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
   *      left(-start, -end)`
   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
   * @param {Number|Object} options.delay=0
   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
   *      If a number is supplied, delay is applied to both hide/show.
   *      Object structure is: `{ show: 500, hide: 100 }`
   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
   *      Base HTML to used when creating the tooltip.
   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
   *      The outermost wrapper element should have the `.tooltip` class.
   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
   * @param {String} [options.trigger='hover focus']
   *      How tooltip is triggered - click, hover, focus, manual.
   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
   * @param {HTMLElement} options.boundariesElement
   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
   *      [offset docs](https://popper.js.org/popper-documentation.html)
   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
   *      [options docs](https://popper.js.org/popper-documentation.html)
   * @param {string} [options.ariaId] Id used for accessibility
   * @return {Object} instance - The generated tooltip instance
   */
  function Tooltip(_reference, _options) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Tooltip);

    (0, _defineProperty3.default)(this, "_events", []);

    (0, _defineProperty3.default)(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
      var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

      var callback = function callback(evt2) {
        var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

        _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element


        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this._scheduleHide(reference, options.delay, options, evt2);
        }
      };

      if (_this._tooltipNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        _this._tooltipNode.addEventListener(evt.type, callback);

        return true;
      }

      return false;
    });

    // apply user options over default ones
    _options = _objectSpread$2(_objectSpread$2({}, DEFAULT_OPTIONS), _options);
    _reference.jquery && (_reference = _reference[0]);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this); // cache reference and options

    this.reference = _reference;
    this.options = _options; // set initial state

    this._isOpen = false;

    this._init();
  } //
  // Public methods
  //

  /**
   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
   * Tooltips with zero-length titles are never displayed.
   * @method Tooltip#show
   * @memberof Tooltip
   */

  (0, _createClass3.default)(Tooltip, [{
    key: "show",
    value: function show() {
      this._show(this.reference, this.options);
    }
    /**
     * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#hide
     * @memberof Tooltip
     */

  }, {
    key: "hide",
    value: function hide() {
      this._hide();
    }
    /**
     * Hides and destroys an element’s tooltip.
     * @method Tooltip#dispose
     * @memberof Tooltip
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#toggle
     * @memberof Tooltip
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isOpen) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classes) {
      this._classes = classes;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.options.title = content;

      if (this._tooltipNode) {
        this._setContent(content, this.options);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var classesUpdated = false;
      var classes = options && options.classes || directive.options.defaultClass;

      if (!(0, _isEqual2.default)(this._classes, classes)) {
        this.setClasses(classes);
        classesUpdated = true;
      }

      options = getOptions(options);
      var needPopperUpdate = false;
      var needRestart = false;

      if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
        needPopperUpdate = true;
      }

      if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
        needRestart = true;
      }

      for (var key in options) {
        this.options[key] = options[key];
      }

      if (this._tooltipNode) {
        if (needRestart) {
          var isOpen = this._isOpen;
          this.dispose();

          this._init();

          if (isOpen) {
            this.show();
          }
        } else if (needPopperUpdate) {
          this.popperInstance.update();
        }
      }
    } //
    // Private methods
    //

  }, {
    key: "_init",
    value: function _init() {
      // get events list
      var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
      this._isDisposed = false;
      this._enableDocumentTouch = events.indexOf('manual') === -1;
      events = events.filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }); // set event listeners

      this._setEventListeners(this.reference, events, this.options); // title attribute


      this.$_originalTitle = this.reference.getAttribute('title');
      this.reference.removeAttribute('title');
      this.reference.setAttribute('data-original-title', this.$_originalTitle);
    }
    /**
     * Creates a new tooltip node
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} reference
     * @param {String} template
     * @param {String|HTMLElement|TitleFunction} title
     * @param {Boolean} allowHtml
     * @return {HTMLelement} tooltipNode
     */

  }, {
    key: "_create",
    value: function _create(reference, template) {
      var _this2 = this;

      // create tooltip element
      var tooltipGenerator = window.document.createElement('div');
      tooltipGenerator.innerHTML = template.trim();
      var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

      tooltipNode.id = this.options.ariaId || "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
      // The attribute will be switched in a next frame so
      // CSS transitions can play

      tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
        tooltipNode.addEventListener('mouseenter', function (evt) {
          return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
        });
        tooltipNode.addEventListener('click', function (evt) {
          return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
        });
      } // return the generated tooltip node


      return tooltipNode;
    }
  }, {
    key: "_setContent",
    value: function _setContent(content, options) {
      var _this3 = this;

      this.asyncContent = false;

      this._applyContent(content, options).then(function () {
        if (!_this3.popperInstance) return;

        _this3.popperInstance.update();
      });
    }
  }, {
    key: "_applyContent",
    value: function _applyContent(title, options) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var allowHtml = options.html;
        var rootNode = _this4._tooltipNode;
        if (!rootNode) return;
        var titleNode = rootNode.querySelector(_this4.options.innerSelector);

        if (title.nodeType === 1) {
          // if title is a node, append it only if allowHtml is true
          if (allowHtml) {
            while (titleNode.firstChild) {
              titleNode.removeChild(titleNode.firstChild);
            }

            titleNode.appendChild(title);
          }
        } else if (typeof title === 'function') {
          // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
          var result = title();

          if (result && typeof result.then === 'function') {
            _this4.asyncContent = true;
            options.loadingClass && addClasses(rootNode, options.loadingClass);

            if (options.loadingContent) {
              _this4._applyContent(options.loadingContent, options);
            }

            result.then(function (asyncResult) {
              options.loadingClass && removeClasses(rootNode, options.loadingClass);
              return _this4._applyContent(asyncResult, options);
            }).then(resolve).catch(reject);
          } else {
            _this4._applyContent(result, options).then(resolve).catch(reject);
          }

          return;
        } else {
          // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
          allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
        }

        resolve();
      });
    }
  }, {
    key: "_show",
    value: function _show(reference, options) {
      if (options && typeof options.container === 'string') {
        var container = document.querySelector(options.container);
        if (!container) return;
      }

      clearTimeout(this._disposeTimer);
      options = Object.assign({}, options);
      delete options.offset;
      var updateClasses = true;

      if (this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
        updateClasses = false;
      }

      var result = this._ensureShown(reference, options);

      if (updateClasses && this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
      }

      addClasses(reference, ['v-tooltip-open']);
      return result;
    }
  }, {
    key: "_ensureShown",
    value: function _ensureShown(reference, options) {
      var _this5 = this;

      // don't show if it's already visible
      if (this._isOpen) {
        return this;
      }

      this._isOpen = true;
      openTooltips.push(this); // if the tooltipNode already exists, just show it

      if (this._tooltipNode) {
        this._tooltipNode.style.display = '';

        this._tooltipNode.setAttribute('aria-hidden', 'false');

        this.popperInstance.enableEventListeners();
        this.popperInstance.update();

        if (this.asyncContent) {
          this._setContent(options.title, options);
        }

        return this;
      } // get title


      var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

      if (!title) {
        return this;
      } // create tooltip node


      var tooltipNode = this._create(reference, options.template);

      this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

      reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

      var container = this._findContainer(options.container, reference);

      this._append(tooltipNode, container);

      var popperOptions = _objectSpread$2(_objectSpread$2({}, options.popperOptions), {}, {
        placement: options.placement
      });

      popperOptions.modifiers = _objectSpread$2(_objectSpread$2({}, popperOptions.modifiers), {}, {
        arrow: {
          element: this.options.arrowSelector
        }
      });

      if (options.boundariesElement) {
        popperOptions.modifiers.preventOverflow = {
          boundariesElement: options.boundariesElement
        };
      }

      this.popperInstance = new _popper2.default(reference, tooltipNode, popperOptions);

      this._setContent(title, options); // Fix position


      requestAnimationFrame(function () {
        if (!_this5._isDisposed && _this5.popperInstance) {
          _this5.popperInstance.update(); // Show the tooltip


          requestAnimationFrame(function () {
            if (!_this5._isDisposed) {
              _this5._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
            } else {
              _this5.dispose();
            }
          });
        } else {
          _this5.dispose();
        }
      });
      return this;
    }
  }, {
    key: "_noLongerOpen",
    value: function _noLongerOpen() {
      var index = openTooltips.indexOf(this);

      if (index !== -1) {
        openTooltips.splice(index, 1);
      }
    }
  }, {
    key: "_hide",
    value: function _hide()
    /* reference, options */
    {
      var _this6 = this;

      // don't hide if it's already hidden
      if (!this._isOpen) {
        return this;
      }

      this._isOpen = false;

      this._noLongerOpen(); // hide tooltipNode


      this._tooltipNode.style.display = 'none';

      this._tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this._disposeTimer);
      var disposeTime = directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this._disposeTimer = setTimeout(function () {
          if (_this6._tooltipNode) {
            _this6._tooltipNode.removeEventListener('mouseenter', _this6.hide);

            _this6._tooltipNode.removeEventListener('click', _this6.hide); // Don't remove popper instance, just the HTML element


            _this6._removeTooltipNode();
          }
        }, disposeTime);
      }

      removeClasses(this.reference, ['v-tooltip-open']);
      return this;
    }
  }, {
    key: "_removeTooltipNode",
    value: function _removeTooltipNode() {
      if (!this._tooltipNode) return;
      var parentNode = this._tooltipNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(this._tooltipNode);
        this.reference.removeAttribute('aria-describedby');
      }

      this._tooltipNode = null;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this7 = this;

      this._isDisposed = true;
      this.reference.removeAttribute('data-original-title');

      if (this.$_originalTitle) {
        this.reference.setAttribute('title', this.$_originalTitle);
      } // remove event listeners first to prevent any unexpected behaviour


      this._events.forEach(function (_ref) {
        var func = _ref.func,
            event = _ref.event;

        _this7.reference.removeEventListener(event, func);
      });

      this._events = [];

      if (this._tooltipNode) {
        this._hide();

        this._tooltipNode.removeEventListener('mouseenter', this.hide);

        this._tooltipNode.removeEventListener('click', this.hide); // destroy instance


        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          this._removeTooltipNode();
        }
      } else {
        this._noLongerOpen();
      }

      return this;
    }
  }, {
    key: "_findContainer",
    value: function _findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    }
    /**
     * Append tooltip to container
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} tooltip
     * @param {HTMLElement|String|false} container
     */

  }, {
    key: "_append",
    value: function _append(tooltipNode, container) {
      container.appendChild(tooltipNode);
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(reference, events, options) {
      var _this8 = this;

      var directEvents = [];
      var oppositeEvents = [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(evt) {
          if (_this8._isOpen === true) {
            return;
          }

          evt.usedByTooltip = true;

          _this8._scheduleShow(reference, options.delay, options, evt);
        };

        _this8._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(evt) {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this8._scheduleHide(reference, options.delay, options, evt);
        };

        _this8._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    }
  }, {
    key: "_onDocumentTouch",
    value: function _onDocumentTouch(event) {
      if (this._enableDocumentTouch) {
        this._scheduleHide(this.reference, this.options.delay, this.options, event);
      }
    }
  }, {
    key: "_scheduleShow",
    value: function _scheduleShow(reference, delay, options
    /*, evt */
    ) {
      var _this9 = this;

      // defaults to 0
      var computedDelay = delay && delay.show || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        return _this9._show(reference, options);
      }, computedDelay);
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide(reference, delay, options, evt) {
      var _this10 = this;

      // defaults to 0
      var computedDelay = delay && delay.hide || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        if (_this10._isOpen === false) {
          return;
        }

        if (!_this10._tooltipNode.ownerDocument.body.contains(_this10._tooltipNode)) {
          return;
        } // if we are hiding because of a mouseleave, we must check that the new
        // reference isn't the tooltip, because in this case we don't want to hide it


        if (evt.type === 'mouseleave') {
          var isSet = _this10._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
          // the new event will take care to hide it if necessary


          if (isSet) {
            return;
          }
        }

        _this10._hide(reference, options);
      }, computedDelay);
    }
  }]);

  return Tooltip;
}(); // Hide tooltips on touch devices

if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function (event) {
    for (var i = 0; i < openTooltips.length; i++) {
      openTooltips[i]._onDocumentTouch(event);
    }
  }, supportsPassive ? {
    passive: true,
    capture: true
  } : true);
}
/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        (0, _defineProperty3.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}
var state = {
  enabled: true
};
var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
var defaultOptions = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'top',
  // Default CSS classes applied to the tooltip element
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover focus',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: true,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: true,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5000,
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    // Class added when popover is open
    defaultOpenClass: 'open',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true
  }
};
function getOptions(options) {
  var result = {
    placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
    delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
    html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
    template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
    arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
    innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
    trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
    offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
    container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
    boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
    autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
    hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
    loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
    loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
    popperOptions: _objectSpread$1({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
  };

  if (result.offset) {
    var typeofOffset = (0, _typeof3.default)(result.offset);

    var offset = result.offset; // One value -> switch

    if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
      offset = "0, ".concat(offset);
    }

    if (!result.popperOptions.modifiers) {
      result.popperOptions.modifiers = {};
    }

    result.popperOptions.modifiers.offset = {
      offset: offset
    };
  }

  if (result.trigger && result.trigger.indexOf('click') !== -1) {
    result.hideOnTargetClick = false;
  }

  return result;
}
function getPlacement(value, modifiers) {
  var placement = value.placement;

  for (var i = 0; i < positions.length; i++) {
    var pos = positions[i];

    if (modifiers[pos]) {
      placement = pos;
    }
  }

  return placement;
}
function getContent(value) {
  var type = (0, _typeof3.default)(value);

  if (type === 'string') {
    return value;
  } else if (value && type === 'object') {
    return value.content;
  } else {
    return false;
  }
}
function createTooltip(el, value) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = getContent(value);
  var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;

  var opts = _objectSpread$1({
    title: content
  }, getOptions(_objectSpread$1(_objectSpread$1({}, (0, _typeof3.default)(value) === 'object' ? value : {}), {}, {
    placement: getPlacement(value, modifiers)
  })));

  var tooltip = el._tooltip = new Tooltip(el, opts);
  tooltip.setClasses(classes);
  tooltip._vueEl = el; // Class on target

  var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
  el._tooltipTargetClasses = targetClasses;
  addClasses(el, targetClasses);
  return tooltip;
}
function destroyTooltip(el) {
  if (el._tooltip) {
    el._tooltip.dispose();

    delete el._tooltip;
    delete el._tooltipOldShow;
  }

  if (el._tooltipTargetClasses) {
    removeClasses(el, el._tooltipTargetClasses);
    delete el._tooltipTargetClasses;
  }
}
function bind(el, _ref) {
  var value = _ref.value;
  _ref.oldValue;
  var modifiers = _ref.modifiers;
  var content = getContent(value);

  if (!content || !state.enabled) {
    destroyTooltip(el);
  } else {
    var tooltip;

    if (el._tooltip) {
      tooltip = el._tooltip; // Content

      tooltip.setContent(content); // Options

      tooltip.setOptions(_objectSpread$1(_objectSpread$1({}, value), {}, {
        placement: getPlacement(value, modifiers)
      }));
    } else {
      tooltip = createTooltip(el, value, modifiers);
    } // Manual show


    if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
      el._tooltipOldShow = value.show;
      value.show ? tooltip.show() : tooltip.hide();
    }
  }
}
var directive = {
  options: defaultOptions,
  bind: bind,
  update: bind,
  unbind: function unbind(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener('click', onClick);
  el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener('click', onClick);
  el.removeEventListener('touchstart', onTouchStart);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var vclosepopover = {
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === 'undefined' || value) {
      addListeners(el);
    }
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue,
        modifiers = _ref2.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === 'undefined' || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind: function unbind(el) {
    removeListeners(el);
  }
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty3.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function getDefault(key) {
  var value = directive.options.popover[key];

  if (typeof value === 'undefined') {
    return directive.options[key];
  }

  return value;
}

var isIOS = false;

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};

if (typeof window !== 'undefined') {
  Element = window.Element;
}

var script = {
  name: 'VPopover',
  components: {
    ResizeObserver: _vueResize.ResizeObserver
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: function _default() {
        return getDefault('defaultPlacement');
      }
    },
    delay: {
      type: [String, Number, Object],
      default: function _default() {
        return getDefault('defaultDelay');
      }
    },
    offset: {
      type: [String, Number],
      default: function _default() {
        return getDefault('defaultOffset');
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return getDefault('defaultTrigger');
      }
    },
    container: {
      type: [String, Object, Element, Boolean],
      default: function _default() {
        return getDefault('defaultContainer');
      }
    },
    boundariesElement: {
      type: [String, Element],
      default: function _default() {
        return getDefault('defaultBoundariesElement');
      }
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return getDefault('defaultPopperOptions');
      }
    },
    popoverClass: {
      type: [String, Array],
      default: function _default() {
        return getDefault('defaultClass');
      }
    },
    popoverBaseClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultBaseClass;
      }
    },
    popoverInnerClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultInnerClass;
      }
    },
    popoverWrapperClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultWrapperClass;
      }
    },
    popoverArrowClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultArrowClass;
      }
    },
    autoHide: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultAutoHide;
      }
    },
    handleResize: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultHandleResize;
      }
    },
    openGroup: {
      type: String,
      default: null
    },
    openClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultOpenClass;
      }
    },
    ariaId: {
      default: null
    }
  },
  data: function data() {
    return {
      isOpen: false,
      id: Math.random().toString(36).substr(2, 10)
    };
  },
  computed: {
    cssClass: function cssClass() {
      return (0, _defineProperty3.default)({}, this.openClass, this.isOpen);
    },
    popoverId: function popoverId() {
      return "popover_".concat(this.ariaId != null ? this.ariaId : this.id);
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
    disabled: function disabled(val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.hide();
        } else if (this.open) {
          this.show();
        }
      }
    },
    container: function container(val) {
      if (this.isOpen && this.popperInstance) {
        var popoverNode = this.$refs.popover;
        var reference = this.$refs.trigger;
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.popperInstance.scheduleUpdate();
      }
    },
    trigger: function trigger(val) {
      this.$_removeEventListeners();
      this.$_addEventListeners();
    },
    placement: function placement(val) {
      var _this = this;

      this.$_updatePopper(function () {
        _this.popperInstance.options.placement = val;
      });
    },
    offset: '$_restartPopper',
    boundariesElement: '$_restartPopper',
    popperOptions: {
      handler: '$_restartPopper',
      deep: true
    }
  },
  created: function created() {
    this.$_isDisposed = false;
    this.$_mounted = false;
    this.$_events = [];
    this.$_preventOpen = false;
  },
  mounted: function mounted() {
    var popoverNode = this.$refs.popover;
    popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
    this.$_init();

    if (this.open) {
      this.show();
    }
  },
  deactivated: function deactivated() {
    this.hide();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref2.event;
      _ref2.skipDelay;
      var _ref2$force = _ref2.force,
          force = _ref2$force === void 0 ? false : _ref2$force;

      if (force || !this.disabled) {
        this.$_scheduleShow(event);
        this.$emit('show');
      }

      this.$emit('update:open', true);
      this.$_beingShowed = true;
      requestAnimationFrame(function () {
        _this2.$_beingShowed = false;
      });
    },
    hide: function hide() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref3.event;
      _ref3.skipDelay;

      this.$_scheduleHide(event);
      this.$emit('hide');
      this.$emit('update:open', false);
    },
    dispose: function dispose() {
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({
        skipDelay: true
      });

      if (this.popperInstance) {
        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
        }
      }

      this.$_mounted = false;
      this.popperInstance = null;
      this.isOpen = false;
      this.$emit('dispose');
    },
    $_init: function $_init() {
      if (this.trigger.indexOf('manual') === -1) {
        this.$_addEventListeners();
      }
    },
    $_show: function $_show() {
      var _this3 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      clearTimeout(this.$_disposeTimer); // Already open

      if (this.isOpen) {
        return;
      } // Popper is already initialized


      if (this.popperInstance) {
        this.isOpen = true;
        this.popperInstance.enableEventListeners();
        this.popperInstance.scheduleUpdate();
      }

      if (!this.$_mounted) {
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.$_mounted = true;
        this.isOpen = false;

        if (this.popperInstance) {
          requestAnimationFrame(function () {
            if (!_this3.hidden) {
              _this3.isOpen = true;
            }
          });
        }
      }

      if (!this.popperInstance) {
        var popperOptions = _objectSpread(_objectSpread({}, this.popperOptions), {}, {
          placement: this.placement
        });

        popperOptions.modifiers = _objectSpread(_objectSpread({}, popperOptions.modifiers), {}, {
          arrow: _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow), {}, {
            element: this.$refs.arrow
          })
        });

        if (this.offset) {
          var offset = this.$_getOffset();
          popperOptions.modifiers.offset = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset), {}, {
            offset: offset
          });
        }

        if (this.boundariesElement) {
          popperOptions.modifiers.preventOverflow = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow), {}, {
            boundariesElement: this.boundariesElement
          });
        }

        this.popperInstance = new _popper2.default(reference, popoverNode, popperOptions); // Fix position

        requestAnimationFrame(function () {
          if (_this3.hidden) {
            _this3.hidden = false;

            _this3.$_hide();

            return;
          }

          if (!_this3.$_isDisposed && _this3.popperInstance) {
            _this3.popperInstance.scheduleUpdate(); // Show the tooltip


            requestAnimationFrame(function () {
              if (_this3.hidden) {
                _this3.hidden = false;

                _this3.$_hide();

                return;
              }

              if (!_this3.$_isDisposed) {
                _this3.isOpen = true;
              } else {
                _this3.dispose();
              }
            });
          } else {
            _this3.dispose();
          }
        });
      }

      var openGroup = this.openGroup;

      if (openGroup) {
        var popover;

        for (var i = 0; i < openPopovers.length; i++) {
          popover = openPopovers[i];

          if (popover.openGroup !== openGroup) {
            popover.hide();
            popover.$emit('close-group');
          }
        }
      }

      openPopovers.push(this);
      this.$emit('apply-show');
    },
    $_hide: function $_hide() {
      var _this4 = this;

      // Already hidden
      if (!this.isOpen) {
        return;
      }

      var index = openPopovers.indexOf(this);

      if (index !== -1) {
        openPopovers.splice(index, 1);
      }

      this.isOpen = false;

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this.$_disposeTimer);
      var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(function () {
          var popoverNode = _this4.$refs.popover;

          if (popoverNode) {
            // Don't remove popper instance, just the HTML element
            popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
            _this4.$_mounted = false;
          }
        }, disposeTime);
      }

      this.$emit('apply-hide');
    },
    $_findContainer: function $_findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    },
    $_getOffset: function $_getOffset() {
      var typeofOffset = (0, _typeof3.default)(this.offset);

      var offset = this.offset; // One value -> switch

      if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
        offset = "0, ".concat(offset);
      }

      return offset;
    },
    $_addEventListeners: function $_addEventListeners() {
      var _this5 = this;

      var reference = this.$refs.trigger;
      var directEvents = [];
      var oppositeEvents = [];
      var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }) : [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(event) {
          if (_this5.isOpen) {
            return;
          }

          event.usedByTooltip = true;
          !_this5.$_preventOpen && _this5.show({
            event: event
          });
          _this5.hidden = false;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this5.hide({
            event: event
          });

          _this5.hidden = true;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    },
    $_scheduleShow: function $_scheduleShow() {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_show();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
        this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
      }
    },
    $_scheduleHide: function $_scheduleHide() {
      var _this6 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_hide();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
        this.$_scheduleTimer = setTimeout(function () {
          if (!_this6.isOpen) {
            return;
          } // if we are hiding because of a mouseleave, we must check that the new
          // reference isn't the tooltip, because in this case we don't want to hide it


          if (event && event.type === 'mouseleave') {
            var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
            // the new event will take care to hide it if necessary


            if (isSet) {
              return;
            }
          }

          _this6.$_hide();
        }, computedDelay);
      }
    },
    $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
      var _this7 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

      var callback = function callback(event2) {
        var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

        popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this7.hide({
            event: event2
          });
        }
      };

      if (popoverNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        popoverNode.addEventListener(event.type, callback);
        return true;
      }

      return false;
    },
    $_removeEventListeners: function $_removeEventListeners() {
      var reference = this.$refs.trigger;
      this.$_events.forEach(function (_ref4) {
        var func = _ref4.func,
            event = _ref4.event;
        reference.removeEventListener(event, func);
      });
      this.$_events = [];
    },
    $_updatePopper: function $_updatePopper(cb) {
      if (this.popperInstance) {
        cb();
        if (this.isOpen) this.popperInstance.scheduleUpdate();
      }
    },
    $_restartPopper: function $_restartPopper() {
      if (this.popperInstance) {
        var isOpen = this.isOpen;
        this.dispose();
        this.$_isDisposed = false;
        this.$_init();

        if (isOpen) {
          this.show({
            skipDelay: true,
            force: true
          });
        }
      }
    },
    $_handleGlobalClose: function $_handleGlobalClose(event) {
      var _this8 = this;

      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.$_beingShowed) return;
      this.hide({
        event: event
      });

      if (event.closePopover) {
        this.$emit('close-directive');
      } else {
        this.$emit('auto-hide');
      }

      if (touch) {
        this.$_preventOpen = true;
        setTimeout(function () {
          _this8.$_preventOpen = false;
        }, 300);
      }
    },
    $_handleResize: function $_handleResize() {
      if (this.isOpen && this.popperInstance) {
        this.popperInstance.scheduleUpdate();
        this.$emit('resize');
      }
    }
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (isIOS) {
    document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener('click', handleGlobalClick, true);
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _loop = function _loop(i) {
    var popover = openPopovers[i];

    if (popover.$refs.popover) {
      var contains = popover.$refs.popover.contains(event.target);
      requestAnimationFrame(function () {
        if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
          popover.$_handleGlobalClose(event, touch);
        }
      });
    }
  };

  // Delay so that close directive has time to set values
  for (var i = 0; i < openPopovers.length; i++) {
    _loop(i);
  }
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  var options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  var hook = void 0;
  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "v-popover",
    class: _vm.cssClass
  }, [_c("div", {
    ref: "trigger",
    staticClass: "trigger",
    staticStyle: {
      display: "inline-block"
    },
    attrs: {
      "aria-describedby": _vm.isOpen ? _vm.popoverId : undefined,
      tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    ref: "popover",
    class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
    style: {
      visibility: _vm.isOpen ? "visible" : "hidden"
    },
    attrs: {
      id: _vm.popoverId,
      "aria-hidden": _vm.isOpen ? "false" : "true",
      tabindex: _vm.autoHide ? 0 : undefined
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.autoHide && _vm.hide();
      }
    }
  }, [_c("div", {
    class: _vm.popoverWrapperClass
  }, [_c("div", {
    ref: "inner",
    class: _vm.popoverInnerClass,
    staticStyle: {
      position: "relative"
    }
  }, [_c("div", [_vm._t("popover", null, {
    isOpen: _vm.isOpen
  })], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
    on: {
      notify: _vm.$_handleResize
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    ref: "arrow",
    class: _vm.popoverArrowClass
  })])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".resize-observer[data-v-8859cc6c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-8859cc6c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
styleInject(css_248z);

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;
  var finalOptions = {};
  (0, _merge2.default)(finalOptions, defaultOptions, options);
  plugin.options = finalOptions;
  directive.options = finalOptions;
  Vue.directive('tooltip', directive);
  Vue.directive('close-popover', vclosepopover);
  Vue.component('VPopover', __vue_component__);
}
var VTooltip = directive;
var VClosePopover = vclosepopover;
var VPopover = __vue_component__;
var plugin = {
  install: install,

  get enabled() {
    return state.enabled;
  },

  set enabled(value) {
    state.enabled = value;
  }

}; // Auto-install

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

exports.default = plugin;
exports.VClosePopover = VClosePopover;
exports.VPopover = VPopover;
exports.VTooltip = VTooltip;
exports.createTooltip = createTooltip;
exports.destroyTooltip = destroyTooltip;
exports.install = install;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(244);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(137)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 705 */
/***/ (function(module, exports) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(244);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

exports.default = Popper;
//# sourceMappingURL=popper.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(709);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(710),
    isObjectLike = __webpack_require__(67);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(245),
    equalArrays = __webpack_require__(249),
    equalByTag = __webpack_require__(744),
    equalObjects = __webpack_require__(747),
    getTag = __webpack_require__(763),
    isArray = __webpack_require__(97),
    isBuffer = __webpack_require__(141),
    isTypedArray = __webpack_require__(143);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(94);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(94);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(94);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(94);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(93);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 718 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 719 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(93),
    Map = __webpack_require__(138),
    MapCache = __webpack_require__(248);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(139),
    isMasked = __webpack_require__(724),
    isObject = __webpack_require__(60),
    toSource = __webpack_require__(247);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(140);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(725);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(39);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 726 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(728),
    ListCache = __webpack_require__(93),
    Map = __webpack_require__(138);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(729),
    hashDelete = __webpack_require__(730),
    hashGet = __webpack_require__(731),
    hashHas = __webpack_require__(732),
    hashSet = __webpack_require__(733);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(95);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(95);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(95);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(95);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(96);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(96);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(96);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(96);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(248),
    setCacheAdd = __webpack_require__(740),
    setCacheHas = __webpack_require__(741);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 741 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(140),
    Uint8Array = __webpack_require__(250),
    eq = __webpack_require__(75),
    equalArrays = __webpack_require__(249),
    mapToArray = __webpack_require__(745),
    setToArray = __webpack_require__(746);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(748);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(749),
    getSymbols = __webpack_require__(751),
    keys = __webpack_require__(754);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(750),
    isArray = __webpack_require__(97);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 750 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(752),
    stubArray = __webpack_require__(753);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(251),
    baseKeys = __webpack_require__(761),
    isArrayLike = __webpack_require__(98);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(76),
    isObjectLike = __webpack_require__(67);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(76),
    isLength = __webpack_require__(254),
    isObjectLike = __webpack_require__(67);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(246);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(144),
    nativeKeys = __webpack_require__(762);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(255);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(764),
    Map = __webpack_require__(138),
    Promise = __webpack_require__(765),
    Set = __webpack_require__(766),
    WeakMap = __webpack_require__(767),
    baseGetTag = __webpack_require__(76),
    toSource = __webpack_require__(247);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(59),
    root = __webpack_require__(39);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResizeObserver", function() { return __vue_component__; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
function getInternetExplorerVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return -1;
}

//
var isIE;

function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
    isIE = getInternetExplorerVersion() !== -1;
  }
}

var script = {
  name: 'ResizeObserver',
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    initCompat();
    this.$nextTick(function () {
      _this._w = _this.$el.offsetWidth;
      _this._h = _this.$el.offsetHeight;

      if (_this.emitOnMount) {
        _this.emitSize();
      }
    });
    var object = document.createElement('object');
    this._resizeObject = object;
    object.setAttribute('aria-hidden', 'true');
    object.setAttribute('tabindex', -1);
    object.onload = this.addResizeHandlers;
    object.type = 'text/html';

    if (isIE) {
      this.$el.appendChild(object);
    }

    object.data = 'about:blank';

    if (!isIE) {
      this.$el.appendChild(object);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify: function compareAndNotify() {
      if (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.emitSize();
      }
    },
    emitSize: function emitSize() {
      this.$emit('notify', {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers: function addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);

      this.compareAndNotify();
    },
    removeResizeHandlers: function removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
        }

        this.$el.removeChild(this._resizeObject);
        this._resizeObject.onload = null;
        this._resizeObject = null;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "resize-observer",
    attrs: {
      tabindex: "-1"
    }
  });
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-8859cc6c";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function install(Vue) {
  // eslint-disable-next-line vue/component-definition-name-casing
  Vue.component('resize-observer', __vue_component__);
  Vue.component('ResizeObserver', __vue_component__);
}

var plugin = {
  // eslint-disable-next-line no-undef
  version: "1.0.1",
  install: install
};

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

//# sourceMappingURL=vue-resize.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(770),
    createAssigner = __webpack_require__(787);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(245),
    assignMergeValue = __webpack_require__(256),
    baseFor = __webpack_require__(771),
    baseMergeDeep = __webpack_require__(773),
    isObject = __webpack_require__(60),
    keysIn = __webpack_require__(260),
    safeGet = __webpack_require__(259);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(772);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(256),
    cloneBuffer = __webpack_require__(774),
    cloneTypedArray = __webpack_require__(775),
    copyArray = __webpack_require__(777),
    initCloneObject = __webpack_require__(778),
    isArguments = __webpack_require__(252),
    isArray = __webpack_require__(97),
    isArrayLikeObject = __webpack_require__(780),
    isBuffer = __webpack_require__(141),
    isFunction = __webpack_require__(139),
    isObject = __webpack_require__(60),
    isPlainObject = __webpack_require__(781),
    isTypedArray = __webpack_require__(143),
    safeGet = __webpack_require__(259),
    toPlainObject = __webpack_require__(782);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(39);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)(module)))

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(776);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(250);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(779),
    getPrototype = __webpack_require__(258),
    isPrototype = __webpack_require__(144);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98),
    isObjectLike = __webpack_require__(67);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(76),
    getPrototype = __webpack_require__(258),
    isObjectLike = __webpack_require__(67);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(783),
    keysIn = __webpack_require__(260);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(784),
    baseAssignValue = __webpack_require__(145);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(145),
    eq = __webpack_require__(75);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(60),
    isPrototype = __webpack_require__(144),
    nativeKeysIn = __webpack_require__(786);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(788),
    isIterateeCall = __webpack_require__(795);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(261),
    overRest = __webpack_require__(789),
    setToString = __webpack_require__(791);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(790);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(792),
    shortOut = __webpack_require__(794);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(793),
    defineProperty = __webpack_require__(257),
    identity = __webpack_require__(261);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 793 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(75),
    isArrayLike = __webpack_require__(98),
    isIndex = __webpack_require__(253),
    isObject = __webpack_require__(60);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(797);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3e4275e3", content, true, {});

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(798);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".leaflet-image-layer,.leaflet-layer,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane,.leaflet-pane>canvas,.leaflet-pane>svg,.leaflet-tile,.leaflet-tile-container,.leaflet-zoom-box{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-tile::selection{background:transparent}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{width:1600px;height:1600px;-webkit-transform-origin:0 0}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,.leaflet-container .leaflet-tile,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer{max-width:none!important;max-height:none!important;width:auto;padding:0}.leaflet-container.leaflet-touch-zoom{-ms-touch-action:pan-x pan-y;touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{-ms-touch-action:pinch-zoom;touch-action:none;touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{-ms-touch-action:none;touch-action:none}.leaflet-container{-webkit-tap-highlight-color:transparent}.leaflet-container a{-webkit-tap-highlight-color:rgba(51,181,229,.4)}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{width:0;height:0;-moz-box-sizing:border-box;box-sizing:border-box;z-index:800}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:800;pointer-events:visiblePainted;pointer-events:auto}.leaflet-bottom,.leaflet-top{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup{opacity:0;-webkit-transition:opacity .2s linear;-moz-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}svg.leaflet-zoom-animated{will-change:transform}.leaflet-zoom-anim .leaflet-zoom-animated{-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,.25,1);-moz-transition:-moz-transform .25s cubic-bezier(0,0,.25,1);transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-pan-anim .leaflet-tile,.leaflet-zoom-anim .leaflet-tile{-webkit-transition:none;-moz-transition:none;transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-control,.leaflet-popup-pane{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.leaflet-image-layer,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-image-layer.leaflet-interactive,.leaflet-marker-icon.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container{background:#ddd;outline-offset:1px}.leaflet-container a{color:#0078a8}.leaflet-zoom-box{border:2px dotted #38f;background:hsla(0,0%,100%,.5)}.leaflet-container{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:12px;font-size:.75rem;line-height:1.5}.leaflet-bar{box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}.leaflet-bar a{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:focus,.leaflet-bar a:hover{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.leaflet-touch .leaflet-bar a:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:700 18px Lucida Console,Monaco,monospace;text-indent:1px}.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}.leaflet-control-layers{box-shadow:0 1px 5px rgba(0,0,0,.4);background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(" + escape(__webpack_require__(799)) + ");width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(" + escape(__webpack_require__(800)) + ");background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers-expanded .leaflet-control-layers-toggle,.leaflet-control-layers .leaflet-control-layers-list{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-scrollbar{overflow-y:scroll;overflow-x:hidden;padding-right:5px}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block;font-size:13px;font-size:1.08333em}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(" + escape(__webpack_require__(287)) + ")}.leaflet-container .leaflet-control-attribution{background:#fff;background:hsla(0,0%,100%,.8);margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333;line-height:1.4}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:focus,.leaflet-control-attribution a:hover{text-decoration:underline}.leaflet-attribution-flag{display:inline!important;vertical-align:baseline!important;width:1em;height:.6669em}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;white-space:nowrap;-moz-box-sizing:border-box;box-sizing:border-box;background:hsla(0,0%,100%,.8);text-shadow:1px 1px #fff}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers{box-shadow:none}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center;margin-bottom:20px}.leaflet-popup-content-wrapper{padding:1px;text-align:left;border-radius:12px}.leaflet-popup-content{margin:13px 24px 13px 20px;line-height:1.3;font-size:13px;font-size:1.08333em;min-height:1px}.leaflet-popup-content p{margin:17px 0;margin:1.3em 0}.leaflet-popup-tip-container{width:40px;height:20px;position:absolute;left:50%;margin-top:-1px;margin-left:-20px;overflow:hidden;pointer-events:none}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;pointer-events:auto;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;color:#333;box-shadow:0 3px 14px rgba(0,0,0,.4)}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:0;right:0;border:none;text-align:center;width:24px;height:24px;font:16px/24px Tahoma,Verdana,sans-serif;color:#757575;text-decoration:none;background:transparent}.leaflet-container a.leaflet-popup-close-button:focus,.leaflet-container a.leaflet-popup-close-button:hover{color:#585858}.leaflet-popup-scrolled{overflow:auto}.leaflet-oldie .leaflet-popup-content-wrapper{-ms-zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678,M12=0.70710678,M21=-0.70710678,M22=0.70710678)}.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{position:absolute;padding:6px;background-color:#fff;border:1px solid #fff;border-radius:3px;color:#222;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;box-shadow:0 1px 3px rgba(0,0,0,.4)}.leaflet-tooltip.leaflet-interactive{cursor:pointer;pointer-events:auto}.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before,.leaflet-tooltip-top:before{position:absolute;pointer-events:none;border:6px solid transparent;background:transparent;content:\"\"}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{left:50%;margin-left:-6px}.leaflet-tooltip-top:before{bottom:0;margin-bottom:-12px;border-top-color:#fff}.leaflet-tooltip-bottom:before{top:0;margin-top:-12px;margin-left:-6px;border-bottom-color:#fff}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{top:50%;margin-top:-6px}.leaflet-tooltip-left:before{right:0;margin-right:-12px;border-left-color:#fff}.leaflet-tooltip-right:before{left:0;margin-left:-12px;border-right-color:#fff}@media print{.leaflet-control{-webkit-print-color-adjust:exact;print-color-adjust:exact}}", ""]);

// exports


/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layers.png?a6137456ed160d7606981aa57c559898";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "layers-2x.png?4f0283c6ce28e888000e978e537a6a56";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _colors = __webpack_require__(802);

var _fonts = __webpack_require__(281);

var _customDefineType = __webpack_require__(6);

var _defaultValues = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
  methods: {
    showErrorDialog: function showErrorDialog(error) {
      if (typeof error === 'string') {
        this.$store.dispatch("setErrorDialog", { key: error });
      } else {
        this.$store.dispatch("setErrorDialog", error);
      }
    },
    hideErrorDialog: function hideErrorDialog() {
      this.$store.dispatch("setErrorDialog", null);
    },
    showConfirmDialog: function showConfirmDialog(confirm) {
      if (typeof confirm === 'string') {
        this.$store.dispatch("setConfirmDialog", { key: confirm });
      } else {
        this.$store.dispatch("setConfirmDialog", confirm);
      }
    },
    hideConfirmDialog: function hideConfirmDialog() {
      this.$store.dispatch("setConfirmDialog", null);
    },
    showResultDialog: function showResultDialog(result) {
      if (typeof result === 'string') {
        this.$store.dispatch("setResultDialog", { key: result });
      } else {
        this.$store.dispatch("setResultDialog", result);
      }
    },
    hideResultDialog: function hideResultDialog() {
      this.$store.dispatch("setResultDialog", null);
    },
    showInfoDialog: function showInfoDialog(infoObject) {
      this.$store.dispatch("setInfoDialog", infoObject);
    },
    hideInfoDialog: function hideInfoDialog() {
      this.$store.dispatch("setInfoDialog", null);
    },
    hideToastCountDownConfirm: function hideToastCountDownConfirm() {
      this.$store.dispatch("setToastCountDownConfirm", null);
    },
    showInputDialog: function showInputDialog(inputObject) {
      this.$store.dispatch("setInputDialog", inputObject);
    },
    hideInputDialog: function hideInputDialog() {
      this.$store.dispatch("setInputDialog", null);
    },
    showSendEmailDialog: function showSendEmailDialog(emailObject) {
      this.$store.dispatch("setEmailSending", emailObject);
    },
    hideSendEmailDialog: function hideSendEmailDialog() {
      this.$store.dispatch("setEmailSending", null);
    },
    showFilePreviewDialog: function showFilePreviewDialog(filePreviewObject) {
      this.$store.dispatch("setFilePreview", filePreviewObject);
    },
    hideFilePreviewDialog: function hideFilePreviewDialog() {
      this.$store.dispatch("setFilePreview", null);
    },
    showUserProfileDialog: function showUserProfileDialog(input) {
      var isCandidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // Input can be user or user ID
      var isUser = input && (typeof input === "undefined" ? "undefined" : _typeof(input)) === 'object';
      if (isUser) {
        if (this.$store.getters.isAgent) {
          if (input.is_candidate) {
            this.$store.dispatch("setDisplayingCandidateId", input.id);
          } else {
            this.$store.dispatch("setDisplayingEmployerId", input.id);
          }
          this.$store.dispatch('addRecentAccessLog', {
            type: input.is_candidate ? 'Candidate' : 'Client',
            id: input.id,
            name: input.first_name + " " + input.last_name
          });
        } else {
          this.$store.dispatch("setDisplayingProfileUser", input);
        }
      } else {
        if (this.$store.getters.isAgent) {
          if (isCandidate) {
            this.$store.dispatch("setDisplayingCandidateId", input);
          } else {
            this.$store.dispatch("setDisplayingEmployerId", input);
          }
          this.$store.dispatch('addRecentAccessLog', {
            type: input.is_candidate ? 'Candidate' : 'Client',
            id: input
          });
        } else {
          this.$store.dispatch("setDisplayingProfileUserId", input);
        }
      }
    },
    showLoading: function showLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", 1);
    },
    hideLoading: function hideLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", -1);
    },
    setAgency: function setAgency(agency) {
      if (agency == null) {
        agency = {};
      }
      this.$store.dispatch("setAgency", agency);
      try {
        localStorage.setItem("agency", agency);
      } catch (error) {
        console.log(error);
      }
      // Set candidate statuses
      this.$store.dispatch("setCandidateStatuses", agency.candidate_statuses);
      // Set client statuses
      this.$store.dispatch("setEmployerStatuses", agency.employer_statuses);
      // Set candidate checklist
      this.$store.dispatch("setCandidateAdminChecklist", agency.candidate_admin_checklist);
      // Set client checklist
      this.$store.dispatch("setEmployerAdminChecklist", agency.employer_admin_checklist);
      // Set job statuses
      this.$store.dispatch("setPlacementJobStatuses", agency.placement_job_statuses);
      this.$store.dispatch("setShiftJobStatuses", agency.shift_job_statuses);
      this.$store.dispatch("setEmployerLastLoginRetrievalDays", agency.client_last_login_retrieval_days);
      this.$store.dispatch("setCandidateLastLoginRetrievalDays", agency.candidate_last_login_retrieval_days);

      //Set badges
      if (agency) {
        this.$store.dispatch("getAllBadges", { agencyId: agency.id });
      }
      this.setPublicAgency(agency);
    },
    setPublicAgency: function setPublicAgency(agency) {
      // Store agency information
      this.$store.dispatch("setAgencyPublic", agency);
      // Load admin emails from agency profile
      var agencyEmails = {
        fromEmail: agency.from_email,
        replyEmail: agency.reply_email,
        adminEmail: agency.admin_email
      };
      this.$store.dispatch("setAgencyEmails", agencyEmails);

      // Load color variable from agency profile
      var color = {
        primaryColor: _colors.DEFAULT_COLORS.PRIMARY,
        secondaryColor: _colors.DEFAULT_COLORS.SECONDARY,
        primaryDarkerColor: _colors.DEFAULT_COLORS.PRIMARY_DARKER,
        secondaryDarkerColor: _colors.DEFAULT_COLORS.SECONDARY_DARKER,
        profileTextColor: _colors.DEFAULT_COLORS.PROFILE_TEXT,
        cancelButtonColor: _colors.DEFAULT_COLORS.CANCEL_BUTTON,
        cancelButtonHoverColor: _colors.DEFAULT_COLORS.CANCEL_BUTTON_HOVER
      };
      if (agency.primary_color !== "") {
        color.primaryColor = agency.primary_color;
      }
      if (agency.primary_darker_color !== "") {
        color.primaryDarkerColor = agency.primary_darker_color;
      }
      if (agency.secondary_color !== "") {
        color.secondaryColor = agency.secondary_color;
      }
      if (agency.secondary_darker_color !== "") {
        color.secondaryDarkerColor = agency.secondary_darker_color;
      }
      if (agency.candidate_profile_text_color !== "") {
        color.profileTextColor = agency.candidate_profile_text_color;
      }
      if (agency.public_advance_setting) {
        if (agency.public_advance_setting.cancel_button_color) {
          color.cancelButtonColor = agency.public_advance_setting.cancel_button_color;
        }
        if (agency.public_advance_setting.cancel_button_hover_color) {
          color.cancelButtonHoverColor = agency.public_advance_setting.cancel_button_hover_color;
        }
        if (agency.public_advance_setting.label_color) {
          color.labelColor = agency.public_advance_setting.label_color;
        }
      }
      this.$store.dispatch("setColor", color);
      // Load root font
      var rootFont = agency.root_font;
      if (!rootFont) {
        rootFont = _fonts.DEFAULT_FONT.ROOT;
      }
      // Load headings font
      var headingsFont = agency.headings_font;
      if (!headingsFont) {
        headingsFont = _fonts.DEFAULT_FONT.HEADINGS;
      }

      this.$store.dispatch("setRootFont", rootFont);
      this.$store.dispatch("setHeadingsFont", headingsFont);
      var headingOneCase = true;
      var headingTwoCase = true;
      var headingThreeCase = true;
      var headingOneCapitalize = false;
      var headingTwoCapitalize = false;
      var headingThreeCapitalize = false;

      if (agency.public_advance_setting) {
        //Load h1 heading transformation
        headingOneCase = agency.public_advance_setting.h1_uppercase;

        //Load h2 heading transformation
        headingTwoCase = agency.public_advance_setting.h2_uppercase;

        //Load h2 heading transformation
        headingThreeCase = agency.public_advance_setting.h3_uppercase;

        headingOneCapitalize = agency.public_advance_setting.h1_capitalize;

        headingTwoCapitalize = agency.public_advance_setting.h2_capitalize;

        headingThreeCapitalize = agency.public_advance_setting.h3_capitalize;
      }

      this.$store.dispatch("setRootFont", rootFont);
      this.$store.dispatch("setHeadingsFont", headingsFont);
      this.$store.dispatch("headingOneCase", headingOneCase);
      this.$store.dispatch("headingTwoCase", headingTwoCase);
      this.$store.dispatch("headingThreeCase", headingThreeCase);
      this.$store.dispatch("headingOneCapitalize", headingOneCapitalize);
      this.$store.dispatch("headingTwoCapitalize", headingTwoCapitalize);
      this.$store.dispatch("headingThreeCapitalize", headingThreeCapitalize);

      // Set favicon
      if (agency.favicon) {
        this.setFavicon(this.convertToAbsolutePath(agency.favicon));
      } else {
        this.setFavicon(_defaultValues.DEFAULT_FAVICON_URL);
      }

      // Set page title
      if (agency.human_name) {
        document.title = agency.human_name;
      } else {
        document.title = 'Enginehire';
      }
    },
    setFavicon: function setFavicon(faviconUrl) {
      var favicon = document.getElementById("favicon");
      favicon.href = faviconUrl;
    },

    // load package list
    loadPackageList: function loadPackageList() {
      this.$store.dispatch("increaseLoadPackageListReqNumber", 1);
    },
    submitTrackingClick: function submitTrackingClick(clickType, selector) {
      var objectId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var additionalInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (!selector) {
        selector = window.location.origin + window.location.pathname;
      }
      var userType = '';
      if (this.$store.getters.isCandidate) {
        userType = 'Candidate';
      } else if (this.$store.getters.isEmployer) {
        userType = 'Client';
      } else if (this.$store.getters.isAgent) {
        userType = 'Admin';
      }
      _axios2.default.post(this.appendBackgroundParam('/api/click-tracking/'), {
        user: this.$store.getters.userID,
        user_type: userType,
        agency: this.$store.getters.agencyID,
        click_type: clickType,
        selector: selector,
        object_id: objectId,
        additional_info: additionalInfo
      });
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_COLORS = exports.DEFAULT_COLORS = {
  PRIMARY: "#1f4e78",
  PRIMARY_DARKER: "#183c5c",
  SECONDARY: "#fff",
  SECONDARY_DARKER: "#d9d9da",
  PROFILE_TEXT: "#212529 ",
  CANCEL_BUTTON: "#5f7478",
  CANCEL_BUTTON_HOVER: "#85a2a8"
};

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _customDefineType = __webpack_require__(6);

var _conditionParams = __webpack_require__(804);

var _regex = __webpack_require__(46);

var _defaultValues = __webpack_require__(17);

var _prefix = __webpack_require__(99);

var _fieldTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
  methods: {
    getValueOfObjectKey: function getValueOfObjectKey(dataObject, key) {
      if (!key) {
        return null;
      }
      var tokens = key.split(/[\.\[\]]+/);
      var objValue = dataObject;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var token = _step.value;

          if (token.length === 0) {
            continue;
          }
          if (objValue == null && dataObject[key]) {
            return dataObject[key];
          }
          objValue = objValue[token];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return objValue;
    },
    isMissingField: function isMissingField(dataObject, field) {
      var type = field.type;
      if ([_customDefineType.FORM_TYPE.FILE_WITH_INFO, _customDefineType.FORM_TYPE.HTML, _customDefineType.FORM_TYPE.LABEL, _customDefineType.FORM_TYPE.SUB_HEADER, _customDefineType.FORM_TYPE.CREDIT_PACKAGE_SELECTION, _customDefineType.FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION, _customDefineType.FORM_TYPE.DATA].includes(type)) {
        return false;
      }
      if (_customDefineType.LIST_FIELDS_NO_MODEL.includes(type)) {
        return false;
      }
      var fieldName = field.model;
      // Ignore the file which has initialUrl
      if (type === _customDefineType.FORM_TYPE.FILE) {
        if (field.initialUrl != null) {
          return false;
        }
      }
      var objValue = this.getValueOfObjectKey(dataObject, fieldName);
      if (objValue == null) {
        console.log('isMissingField', fieldName);
        return true;
      }
      if (type === _customDefineType.FORM_TYPE.DAY_HOURS_SELECTOR) {
        /*
        objValue includes 5 element (corresponding with Monday -> Friday)
        Each row of day hours selector includes a checkbox, and two time picker
        If the checkbox is not check, the corresponding value is "" (empty string)
        If the checkbox is checked, but none of the time picker is filled, the value is ","
        If the checkbox is checked, but the 'from' time picker is not filled, the value is ",to"
        If the checkbox is checked, but the 'to' time picker is not filled, the value is "from,"
        */

        // Check if all checkbox is unchecked.
        if (!objValue.some(function (val) {
          return val != null && val !== "";
        })) {
          console.log('isMissingField objValue', objValue);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = objValue[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var val = _step2.value;

              // If value contains ',' => checkbox is checked.
              if (val && val.includes(",")) {
                var tokens = val.split(",");
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = tokens[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var token = _step3.value;

                    // Check if 'from' or 'to' is missing
                    if (token.trim().length === 0) {
                      console.log('isMissingField objValue val', val);
                      return true;
                    }
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }

      if (type === _customDefineType.FORM_TYPE.SALARY_RANGE) {
        // objValue of salary range includes 3 element (min salary, max salary, salary option)
        // If any of those value is empty => the field is not filled
        if (objValue == null) {
          console.log('isMissingField Salary range', field);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          var minSalary = objValue[0];
          var maxSalary = objValue[1];
          var period = objValue[2];
          // Check require for min value and max value
          if (!minSalary || !maxSalary) {
            console.log('isMissingField Salary range', objValue, field);
            return true;
          }
          // In case of period option is hidden, no need to check period value
          if (!field.hidePeriod && !period) {
            console.log('isMissingField Salary range period', field);
            return true;
          }
        }
      }

      // Check for time picker
      if (type === _customDefineType.FORM_TYPE.TIME_PICKER) {
        if (objValue == null) {
          console.log('isMissingField Timepicker', field, objValue);
          return true;
        }
        if ((typeof objValue === "undefined" ? "undefined" : _typeof(objValue)) === "object") {
          if (objValue.hh == null || objValue.hh === "") {
            console.log('isMissingField Timepicker 1', field, objValue);
            return true;
          }
          if (objValue.mm == null || objValue.mm === "") {
            console.log('isMissingField Timepicker 2', field, objValue);
            return true;
          }
          if (objValue.A == null || objValue.A === "") {
            console.log('isMissingField Timepicker 3', field, objValue);
            return true;
          }
        }
      }

      if (type === _customDefineType.FORM_TYPE.LANGUAGE_INPUT) {
        // Structure of each element in array is item: option1, option2
        if (objValue == null) {
          console.log('isMissingField language input', field, objValue);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          // Empty array
          if (objValue.length === 0) {
            console.log('isMissingField language input 1', field, objValue);
            return true;
          }
          var listHeaderIndex = this.findHeaderIndex(field);
          for (var index = 0; index < objValue.length; index++) {
            // Exclude header
            if (listHeaderIndex.includes(index)) {
              console.log('isMissingField language input 2', field, objValue);
              continue;
            }
            var _val = objValue[index];
            // Empty element
            if (!_val) {
              console.log('isMissingField language input 3', field, objValue);
              return true;
            }
            var _tokens = _val.split(":");
            if (_tokens.length < 2) {
              console.log('isMissingField language input 4', field, objValue);
              return true;
            }
            // Item is not inputted
            if (_tokens[0].trim().length === 0) {
              console.log('isMissingField language input 5', field, objValue);
              return true;
            }
            // No option is selected
            if (_tokens[1].trim().length === 0) {
              console.log('isMissingField language input 6', field, objValue);
              return true;
            }
          }
          return false;
        }
      }
      if (type === _customDefineType.FORM_TYPE.CHECKBOX_TABLE) {
        // Structure of each element in array is item: option1, option2
        if (objValue == null) {
          console.log('isMissingField checkbox table', field, objValue);
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          // Empty array
          if (objValue.length === 0) {
            console.log('isMissingField checkbox table 1', field, objValue);
            return true;
          }
          var _listHeaderIndex = this.findHeaderIndex(field);
          var hasCheckedValue = false;
          for (var _index = 0; _index < objValue.length; _index++) {
            // Exclude header
            if (_listHeaderIndex.includes(_index)) {
              continue;
            }
            var _val2 = objValue[_index];
            // Empty element
            if (!_val2) {
              continue;
            }
            var _tokens2 = _val2.split(":");
            if (_tokens2.length < 2) {
              continue;
            }
            // Item is not inputted
            if (_tokens2[0].trim().length === 0) {
              continue;
            }
            // No option is selected
            if (_tokens2[1].trim().length === 0) {
              continue;
            }
            hasCheckedValue = true;
          }
          if (!hasCheckedValue) {
            console.log('isMissingField checkbox table 2', field, objValue);
          }
          return !hasCheckedValue;
        }
      }
      return this.isEmptyValue(objValue);
    },

    /* Find index of header in list item
    For example: itemList: option1, option2, option3, option4
    headerList: option1, option3
    => header index: 0, 2
    */
    findHeaderIndex: function findHeaderIndex(field) {
      if (!field.headerList || !field.itemList) {
        return [];
      }
      var headerList = field.headerList.split("\n").map(function (header) {
        return header.trim();
      }).filter(function (header) {
        return header.length > 0;
      });
      var itemList = field.itemList.split("\n").map(function (item) {
        return item.trim();
      }).filter(function (item) {
        return item.length > 0;
      });
      var listHeaderIndex = [];
      for (var index = 0; index < itemList.length; index++) {
        var item = itemList[index];
        if (headerList.includes(item)) {
          listHeaderIndex.push(index);
        }
      }
      return listHeaderIndex;
    },
    isEmptyValue: function isEmptyValue(val) {
      // Check null
      if (val == null) {
        return true;
      }
      // Empty string
      if (typeof val === "string") {
        val = this.removeOtherRadioPrefix(val);
        if (val.trim().length === 0) {
          return true;
        }
      }
      if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === "object") {
        if (Array.isArray(val)) {
          // Empty array
          if (val.length === 0) {
            return true;
          }
        } else if (!(val instanceof Date) && !(val instanceof File)) {
          // Empty object
          if (Object.keys(val).length === 0) {
            return true;
          }
        }
      }
      return false;
    },
    hasInvalidField: function hasInvalidField(dataObject, listElement) {
      var ignoreMissing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = listElement[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var element = _step4.value;

          // Ignore the field which is not show
          if (!this.isItemShow(dataObject, element, listElement)) {
            continue;
          }
          if (element.validation) {
            var objValue = this.getValueOfObjectKey(dataObject, element.model);
            if (objValue != null && objValue !== "") {
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = element.validation[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var validateItem = _step5.value;

                  try {
                    if (!validateItem.regex.test(objValue)) {
                      console.log('hasInvalidField regex', objValue);
                      return {
                        field: element,
                        value: objValue,
                        type: 'Invalid Input'
                      };
                    }
                  } catch (e) {
                    continue;
                  }
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          }
          if (element.isRequired === false) {
            continue;
          }
          if (!element.model) {
            continue;
          }
          if (!ignoreMissing) {
            if (this.isMissingField(dataObject, element)) {
              console.log('Missing field', element);
              return {
                field: element,
                type: 'Required Field'
              };
            }
          }
          // Validate for start date and end date
          if (element.type === _customDefineType.FORM_TYPE.MONTH_PICKER) {
            // Validate for case of start date and end date
            if (element.after != null) {
              // End date
              var endDate = this.getValueOfObjectKey(dataObject, element.model);
              // Start date
              var startDate = this.getValueOfObjectKey(dataObject, element.after);
              if (this.compareMonthYear(endDate, startDate) < 0) {
                console.log('End date before start date', endDate, startDate);
                return {
                  message: 'End date before start date'
                };
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    getListMissingFields: function getListMissingFields(dataObject, listElement) {
      var result = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = listElement[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var element = _step6.value;

          // Ignore the field which is not show
          if (!this.isItemShow(dataObject, element, listElement)) {
            continue;
          }
          if (element.isRequired === false) {
            continue;
          }
          if (!element.model) {
            continue;
          }
          if (this.isMissingField(dataObject, element)) {
            result.push(element);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return result;
    },

    /* Compare month year of date1, date2
    Input format yyyy-MM-dd
    Return 1 if month-year of date1 > month-year of date2
    Return 0 if equal
    return -1 if  month-year of date1 < month-year of date2
    */
    compareMonthYear: function compareMonthYear(date1, date2) {
      var tokens1 = date1.split("-");
      var tokens2 = date2.split("-");
      // Compare year
      if (Number(tokens1[0]) > Number(tokens2[0])) {
        return 1;
      } else if (Number(tokens1[0]) < Number(tokens2[0])) {
        return -1;
      }
      // Compare month
      if (Number(tokens1[1]) > Number(tokens2[1])) {
        return 1;
      } else if (Number(tokens1[1]) < Number(tokens2[1])) {
        return -1;
      }
      return 0;
    },
    hasMissingRequireFieldByKeys: function hasMissingRequireFieldByKeys(dataObject, listRequiredField) {
      var listRequiredCheckbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = listRequiredField[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var requiredField = _step7.value;

          var _objValue = this.getValueOfObjectKey(dataObject, requiredField);
          if (_objValue == null) {
            return true;
          }
          // Empty string
          if (typeof _objValue === "string") {
            if (_objValue.length === 0) {
              return true;
            }
          }
          if ((typeof _objValue === "undefined" ? "undefined" : _typeof(_objValue)) === "object") {
            if (Array.isArray(_objValue)) {
              // Empty array
              if (_objValue.length === 0) {
                return true;
              }
            } else if (!(_objValue instanceof Date)) {
              // Empty object
              if (Object.keys(_objValue).length === 0) {
                return true;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      if (listRequiredCheckbox != null) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = listRequiredCheckbox[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var checkboxField = _step8.value;

            var objValue = this.getValueOfObjectKey(dataObject, checkboxField);
            if (objValue != true) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
      return false;
    },
    getFirstNameAndLastName: function getFirstNameAndLastName(name) {
      var trimedName = name.trim();
      if (trimedName.includes(" ")) {
        var spaceIndex = trimedName.indexOf(" ");
        var firstName = trimedName.substr(0, spaceIndex).trim();
        var lastName = trimedName.substr(spaceIndex + 1);
        return { firstName: firstName, lastName: lastName };
      } else {
        return { firstName: trimedName, lastName: "" };
      }
    },
    extractSelectedFields: function extractSelectedFields(inputObject, listFields) {
      var includeFileUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!inputObject) {
        return {};
      }
      var listFieldsExcludeUnchangeFile = listFields.filter(function (field) {
        if (field.type === _customDefineType.FORM_TYPE.FILE) {
          if (!includeFileUrl) {
            if (typeof inputObject[field.model] === "string") {
              return false;
            }
          }
          return true;
        } else {
          return true;
        }
      });
      var listSelectedKey = listFieldsExcludeUnchangeFile.map(function (field) {
        return field.model;
      });
      var result = {};
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = Object.keys(inputObject)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var key = _step9.value;

          if (listSelectedKey.includes(key)) {
            result[key] = inputObject[key];
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return result;
    },
    isUnchangedObject: function isUnchangedObject(objectOrigin1, objectOrigin2, listFields) {
      var object1 = objectOrigin1;
      var object2 = objectOrigin2;
      if (object1 == null) {
        object1 = {};
      }
      if (object2 == null) {
        object2 = {};
      }
      if (listFields == null) {
        var listModels = this.deduplicateArray([].concat(_toConsumableArray(Object.keys(object1)), _toConsumableArray(Object.keys(object2))));
        listFields = listModels.map(function (model) {
          return {
            model: model
          };
        });
      }
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = listFields[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var field = _step10.value;

          var key = field.model;
          if (!object1[key] && !object2[key]) {
            continue;
          }
          // First value is empty array, and second value is null => equal
          if (Array.isArray(object1[key])) {
            if (object1[key].length === 0 && object2[key] == null) {
              continue;
            }
          }

          // First value is null, second value is empty array => equal
          if (Array.isArray(object2[key])) {
            if (object2[key].length === 0 && object1[key] == null) {
              continue;
            }
          }

          // Both value are arrays
          if (Array.isArray(object1[key]) && Array.isArray(object2[key])) {
            if (object1[key].length !== object2[key].length) {
              return false;
            }
            for (var index = 0; index < object1[key].length; index++) {
              if (object1[key][index] !== object2[key][index]) {
                try {
                  if (JSON.stringify(object1[key][index]) == JSON.stringify(object2[key][index])) {
                    continue;
                  }
                } catch (_) {}
                return false;
              }
            }
          } else if (_typeof(object1[key]) === 'object' && _typeof(object2[key]) === 'object') {
            // Both value are object, compare value of all keys
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
              for (var _iterator11 = Object.keys(object1[key])[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var key1 = _step11.value;

                if (!object1[key][key1] && !object2[key][key1]) {
                  continue;
                }
                if (object1[key][key1] !== object2[key][key1]) {
                  return false;
                }
              }
            } catch (err) {
              _didIteratorError11 = true;
              _iteratorError11 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }
              } finally {
                if (_didIteratorError11) {
                  throw _iteratorError11;
                }
              }
            }
          } else if (object1[key] !== object2[key]) {
            // The field is changed by default value
            if (!this.isFieldChangeByDefaultValue(field, object1[key], object2[key])) {
              return false;
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return true;
    },
    isUnchangedList: function isUnchangedList(oldList, newList) {
      var listFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!oldList) {
        oldList = [];
      }
      if (!newList) {
        newList = [];
      }
      if (oldList.length != newList.length) {
        return false;
      }
      for (var index = 0; index < oldList.length; index++) {
        if (!this.isUnchangedObject(oldList[index], newList[index], listFields)) {
          return false;
        }
      }
      return true;
    },
    isFieldChangeByDefaultValue: function isFieldChangeByDefaultValue(field, oldVal, newVal) {
      if (!field || !field.defaultValue) {
        return false;
      }
      if (oldVal == null || oldVal === '') {
        if (newVal == field.defaultValue) {
          return true;
        }
      }
      return false;
    },

    // Get field which corresponding with Show If Condition
    getReferField: function getReferField(field, listFields) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'showIf';

      if (!field || !listFields) {
        return;
      }
      // Has no 'Show Condition'
      if (!field[key]) {
        return;
      }
      var listReferFields = listFields.filter(function (item) {
        return item.model === field[key];
      });
      if (!listReferFields.length) {
        return;
      }
      // Only one match
      if (listReferFields.length === 1) {
        return listReferFields[0];
      }
      // Multiple matches
      var fieldIndex = listFields.indexOf(field);
      if (fieldIndex === -1) {
        // Cannot find field inside listFields => get first item
        return listReferFields[0];
      }
      // Get the nearest field which is appeared before the field
      for (var index = fieldIndex - 1; index >= 0; index--) {
        if (listFields[index].model === field[key]) {
          return listFields[index];
        }
      }
      // Get the nearest field which is appeared after the field
      for (var _index2 = fieldIndex + 1; _index2 < listFields.length; _index2++) {
        if (listFields[_index2].model === field[key]) {
          return listFields[_index2];
        }
      }
      return listReferFields[0];
    },

    // Check if item is showed (Item may not showed if showIf is set)
    // If isAnnonymousAccess = true, logged in user access as annonymous
    isItemShow: function isItemShow(modelData, el, listElements) {
      var isAnnonymousAccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      // Admin only field
      if (el.isAdminOnly) {
        if (isAnnonymousAccess) {
          return false;
        }
        if (!this.$store.getters.isAgent) {
          return false;
        }
      }
      // Check combined show conditions
      if (el.combinedShowCondition) {
        if (this.hasSearchCondition(el.combinedShowCondition)) {
          if (!this.isMatchCombinedConditions([el.combinedShowCondition], modelData)) {
            return false;
          }
        }
      }
      if (el.combinedShowConditionContainer) {
        if (this.hasSearchCondition(el.combinedShowConditionContainer)) {
          if (!this.isMatchCombinedConditions([el.combinedShowConditionContainer], modelData)) {
            return false;
          }
        }
      }
      var isItemShowed = this.isItemShowByKey(modelData, el, listElements, 'showIf', 'showIfEmpty', 'showIfValue', 'showIfValueNot', 'showIfNotEmpty');
      var isItemShowedSecondary = this.isItemShowByKey(modelData, el, listElements, 'showIfSecondary', 'showIfEmptySecondary', 'showIfValueSecondary', 'showIfValueNotSecondary', 'showIfNotEmptySecondary');
      var isItemShowedThird = this.isItemShowByKey(modelData, el, listElements, 'showIfThird', 'showIfEmptyThird', 'showIfValueThird', 'showIfValueNotThird', 'showIfNotEmptyThird');
      var isContainerShowed = this.isItemShowByKey(modelData, el, listElements, 'showIfContainer', 'showIfEmptyContainer', 'showIfValueContainer', 'showIfValueNotContainer', 'showIfNotEmptyContainer');
      var isContainerShowedSecondary = this.isItemShowByKey(modelData, el, listElements, 'showIfSecondaryContainer', 'showIfEmptySecondaryContainer', 'showIfValueSecondaryContainer', 'showIfValueNotSecondaryContainer', 'showIfNotEmptySecondaryContainer');
      var isContainerShowedThird = this.isItemShowByKey(modelData, el, listElements, 'showIfThirdContainer', 'showIfEmptyThirdContainer', 'showIfValueThirdContainer', 'showIfValueNotThirdContainer', 'showIfNotEmptyThirdContainer');
      return isItemShowed && isContainerShowed && isItemShowedSecondary && isContainerShowedSecondary && isItemShowedThird && isContainerShowedThird;
    },
    isItemShowByKey: function isItemShowByKey(modelData, el, listElements, showIfKey, showIfEmptyKey, showIfValueKey, showIfValueNotKey, showIfNotEmptyKey) {
      // showIf is not set => item is showed
      if (el[showIfKey] == null && el.showIfs == null) {
        return true;
      }

      // Check if showIfNotEmpty is set (the field is filled)
      if (el[showIfNotEmptyKey]) {
        // Field is not filled
        if (!modelData[el[showIfKey]]) {
          return false;
        }
      } else {

        // showIfEmpty is set (No option is selected)
        if (el[showIfEmptyKey]) {
          // Check if showIf item is showed
          // If the refer element has the value, check if the refer element is showed
          var _referEl = this.getReferField(el, listElements, showIfKey);
          if (_referEl) {
            if (!this.isItemShow(modelData, _referEl, listElements)) {
              return false;
            }
          }
          if (el[showIfKey]) {
            var value = modelData[el[showIfKey]];
            if (value == null || value === '') {
              return true;
            }
            if (Array.isArray(value)) {
              if (!value.length) {
                return true;
              }
              // All item is null
              if (!value.some(function (item) {
                return item;
              })) {
                return true;
              }
            }
          }
          // Show one field if some other fields are empty
          if (el.showIfs) {
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = el.showIfs[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var showIfModel = _step12.value;

                var _value = modelData[showIfModel];
                if (_value != null && _value !== '') {
                  return false;
                }
                if (Array.isArray(_value)) {
                  if (_value.length) {
                    if (_value.some(function (item) {
                      return item;
                    })) {
                      return false;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }

            return true;
          }
          // The other condition is unset
          if (!el[showIfValueKey] && !el[showIfValueNotKey]) {
            return false;
          }
        }

        if (el[showIfValueNotKey]) {
          var _value2 = modelData[el[showIfKey]];
          if (!_value2) {
            return false;
          }
          if (Array.isArray(_value2)) {
            return !_value2.includes(el[showIfValueNotKey]);
          }
          return _value2 !== el[showIfValueNotKey];
        }

        /* showIfValue is not set =>
        item is only show if the corresponding value of model for showIf is true (Yes/No radio group)
        */
        if (el[showIfValueKey] == null) {
          if (!modelData[el[showIfKey]]) {
            return false;
          }
        } else {
          /* show if value of dropdown option is in list of option (showIfValue is an array)) */
          if (Array.isArray(el[showIfValueKey])) {
            // In case of checkbox, show if at least 1 checked option === el[showIfValueKey]
            if (el[showIfValueKey].length === 1 && Array.isArray(modelData[el[showIfKey]])) {
              if (modelData[el[showIfKey]].includes(el[showIfValueKey][0])) {
                return true;
              }
            }
            // In other case, it is not showed if the selected option is not in showIfValue
            var _value3 = modelData[el[showIfKey]];
            // Convert data type for Boolean radio
            if (_value3 === true) {
              _value3 = "Yes";
            }
            if (_value3 === false) {
              _value3 = "No";
            }
            var listCheckValues = el[showIfValueKey];
            // In case of multi languages
            if (modelData.language) {
              var _referEl2 = this.getReferField(el, listElements, showIfKey);
              if (_referEl2) {
                var mapOptions = this.getMapOptionListByLanguage(_referEl2, modelData.language);
                var listValueByLanguage = listCheckValues.map(function (val) {
                  return mapOptions[val];
                }).filter(function (val) {
                  return val;
                });
                listCheckValues = [].concat(_toConsumableArray(listCheckValues), _toConsumableArray(listValueByLanguage));
              }
            }
            if (Array.isArray(_value3)) {
              // Exclude the case value is an empty array, and showIfValue contains undefined
              // That is the case one field is showed if all checkbox options are unchecked
              if (!(_value3.length === 0 && listCheckValues.includes(undefined))) {
                if (!this.hasCommonElement(_value3, listCheckValues)) {
                  if (!this.isMatchingOtherOption(_value3, listCheckValues)) {
                    return false;
                  }
                }
              }
            } else {
              if (!listCheckValues.includes(_value3)) {
                return false;
              }
            }
          } else {
            /* show if value of dropdown option is one option (showIfValue is string) */
            // Check show if for boolean radio
            var _value4 = modelData[el[showIfKey]];
            // Convert data type for Boolean radio
            if (_value4 === true) {
              _value4 = "Yes";
            }
            if (_value4 === false) {
              _value4 = "No";
            }
            if (_value4 !== el[showIfValueKey]) {
              return false;
            }
          }
        }
      }
      // If the refer element has the value, check if the refer element is showed
      var referEl = this.getReferField(el, listElements, showIfKey);
      if (referEl == null) {
        return true;
      }
      return this.isItemShow(modelData, referEl, listElements);
    },
    getMapOptionListByLanguage: function getMapOptionListByLanguage(item, language) {
      if (!item.optionList) {
        return {};
      }
      if (!item["optionList_lang_" + language]) {
        return {};
      }
      var listOptions = this.convertStringToArray(item.optionList);
      var listOptionsByLangs = this.convertStringToArray(item["optionList_lang_" + language]);
      var result = {};
      for (var index = 0; index < listOptions.length; index++) {
        result[listOptions[index]] = listOptionsByLangs[index];
      }
      return result;
    },

    // Check if Other option of checkbox group
    isMatchingOtherOption: function isMatchingOtherOption(listCheckedOptions, listShowOptions) {
      if (!listCheckedOptions || !listShowOptions) {
        return false;
      }
      if (!listCheckedOptions.some(function (option) {
        return option && option.indexOf('other:') === 0;
      })) {
        return false;
      }
      if (!listShowOptions.some(function (option) {
        return option && option.toLowerCase() === 'other';
      })) {
        return false;
      }
      return true;
    },

    // Validate mising file, or file exceed maximum
    isFileValid: function isFileValid(file, isRequired) {
      var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

      if (file == null) {
        return !isRequired;
      }
      if (file.size > maxSize * 1024 * 1024) {
        return false;
      }
      return true;
    },

    // Validate if a list of file contains any invalid file (missing or file size exceed maximum)
    hasInvalidFile: function hasInvalidFile(uploadFiles, listFileInfo) {
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = listFileInfo[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var item = _step13.value;

          if (!this.isFileValid(uploadFiles[item.model], item.isRequired)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      return false;
    },

    /* This method receive a list of field,
    then filter out all field which is not corresponding with an option.
    In list field input, it contains information of showIf and showIfValue.
    The output will be filtered based on that.
    And it return list of the filtered fields.
    */
    getListFieldModelForOption: function getListFieldModelForOption(listField, option) {
      var _this = this;

      return listField.filter(function (field) {
        // Filter out the fields which does not have model property
        if (!field.model) {
          return false;
        }
        // If showIf is not set, that's mean the field is exist on all options
        if (!field.showIf) {
          return true;
        }
        // showIf is set and showIfValue is not set
        if (field.showIfValue == null) {
          // The existence of item depends on the existence of the refer field (field is specified by showIf)
          var referField = listField.find(function (field2) {
            return field2.model === field.showIf;
          });
          // Check if the refer field is exist,
          if (!referField.showIf) {
            return true;
          }
          if (!referField.showIfValue) {
            // showIfValue is not set => the yes/no radio
            return true;
          } else {
            // Check if the refer field is exist by value of showIfValue
            return _this.isFieldExistForOption(referField, option);
          }
        } else {
          return _this.isFieldExistForOption(field, option);
        }
      });
    },

    /*
    Check if field is exist based on it's showIfValue.
    The input field of this function has both showIf and showIfValue property
    */
    isFieldExistForOption: function isFieldExistForOption(field, option) {
      if (Array.isArray(field.showIfValue)) {
        return field.showIfValue.includes(option);
      } else {
        return field.showIfValue === option;
      }
    },

    // Check if there is duplicate element in array or not
    containsDuplicate: function containsDuplicate(arr) {
      return new Set(arr).size !== arr.length;
    },

    // Check if there is blank element in array or not
    containsBlank: function containsBlank(arr) {
      if (!arr) {
        return false;
      }
      return arr.some(function (el) {
        return !el || !el.trim();
      });
    },

    /* Check if a section is visible based on list of status and user types
    A section is visible if visible for both userTypes and userStatus
    For userTypes, section is visible if at least 1 type in userTypes belongs to listVisibleTypes of section
    For userStatus, section is visible if user status is set in listVisibleStatus
    or index of user status >= index of visible beyond status (in list statuses)
    */
    isSectionVisible: function isSectionVisible(dialogSection, user) {
      var userTypes = user.types;
      var userStatus = user.status;
      // Check invisible for userTypes
      if (dialogSection.listVisibleTypes && dialogSection.listVisibleTypes.length > 0) {
        if (userTypes == null || userTypes.length === 0) {
          return false;
        }
        // Check if listVisibleTypes and userTypes has no common element
        if (!dialogSection.listVisibleTypes.some(function (type) {
          return userTypes.includes(type);
        })) {
          return false;
        }
      }

      // If both list visible statuses and visible beyond status are not set, always show
      var listVisibleStatuses = dialogSection.listVisibleStatuses;
      var visibleBeyondStatus = dialogSection.visibleBeyondStatus;
      var listStatuses = user.is_candidate ? this.$store.getters.candidateStatuses : this.$store.getters.employerStatuses;
      if (!this.isVisibleByStatus(listVisibleStatuses, visibleBeyondStatus, userStatus, listStatuses)) {
        return false;
      }
      // Check visible beyond second statuses
      var listVisibleSecondStatuses = this.getBuilderAdditionalSettingByKey(dialogSection, 'visible_second_statuses');
      var visibleBeyondSecondStatus = this.getBuilderAdditionalSettingByKey(dialogSection, 'visible_beyond_second_status');
      var listSecondStatuses = user.is_candidate ? this.$store.getters.candidateSecondStatuses : this.$store.getters.employerSecondStatuses;
      if (!this.isVisibleByStatus(listVisibleSecondStatuses, visibleBeyondSecondStatus, user.second_status, listSecondStatuses)) {
        return false;
      }
      return true;
    },
    getBuilderAdditionalSettingByKey: function getBuilderAdditionalSettingByKey(builder, key) {
      if (!builder) {
        return null;
      }
      if (builder.additionalInformation && builder.additionalInformation[key]) {
        return builder.additionalInformation[key];
      }
      if (builder.additional_information && builder.additional_information[key]) {
        return builder.additional_information[key];
      }
      return null;
    },
    isVisibleByStatus: function isVisibleByStatus(listVisibleStatuses, visibleBeyondStatus, userStatus, listStatuses) {
      if ((!listVisibleStatuses || !listVisibleStatuses.length) && (visibleBeyondStatus == null || visibleBeyondStatus === "")) {
        return true;
      }
      if (listVisibleStatuses.includes(userStatus)) {
        return true;
      }

      var minIndexOfStatus = listStatuses.indexOf(visibleBeyondStatus);
      // If visible beyond status is set
      if (minIndexOfStatus !== -1) {
        var indexOfStatus = listStatuses.indexOf(userStatus);
        if (indexOfStatus >= minIndexOfStatus) {
          return true;
        }
      }
      return false;
    },

    /*
    Compare status and beyondStatus in listStatuses
    Return true if index of status > index of beyondStatus
    If beyondStatus is not in listStatuses, return default value
     */
    compareBeyondStatus: function compareBeyondStatus(status, beyondStatus, listStatuses, defaultValue) {
      var minIndexOfStatus = listStatuses.indexOf(beyondStatus);
      // If visible beyond status is not set or not in listStatuses
      if (minIndexOfStatus === -1) {
        return defaultValue;
      } else {
        // Compare 2 indices
        var indexOfStatus = listStatuses.indexOf(status);
        if (indexOfStatus >= minIndexOfStatus) {
          return true;
        }
      }
      return false;
    },

    /*
    Compare order of status1, status2 in listStatuses
    Return:
      1 if index of status 1 > index of status 2
      -1 if index of status 1 < index of status 2
      0 if index of status 1 == index of status 2
    */
    compareStatus: function compareStatus(status1, status2, listStatuses) {
      var index1 = listStatuses.indexOf(status1);
      var index2 = listStatuses.indexOf(status2);
      if (index1 > index2) {
        return 1;
      } else if (index1 === index2) {
        return 0;
      } else {
        return -1;
      }
    },

    /*
    If input is a string, convert it to array (separate by newline character)
     */
    normalizedArrayValue: function normalizedArrayValue(value) {
      if (!value) {
        return [];
      }
      if (Array.isArray(value)) {
        return value.filter(function (item) {
          return item != null;
        });
      }
      return value.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },

    /*
    Check if applicationData is match with searchData,
    for example: 
    searchData contains first_name: 'Test',
    applicationData contains first_name: 'Test Name' => return true
    */
    isMatchMasterViewSearch: function isMatchMasterViewSearch(applicationData, searchData) {
      var _this2 = this;

      if (!searchData || !Object.keys(searchData).length) {
        return true;
      }
      if (!applicationData) {
        return false;
      }
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = Object.keys(searchData)[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var key = _step14.value;

          if (key === 'selectedProfileBuilderId') {
            continue;
          }
          var searchValue = searchData[key];
          if (!searchData) {
            continue;
          }
          var value = applicationData[key];
          // Time Picker
          if ((typeof searchValue === "undefined" ? "undefined" : _typeof(searchValue)) === 'object') {
            if (searchValue.A && searchValue.hh && searchValue.mm) {
              searchValue = this.getTimeString(searchValue);
            }
          }
          if (Array.isArray(searchValue)) {
            // Empty array => match
            if (!searchValue.length) {
              continue;
            }
            if (Array.isArray(value)) {
              searchValue = searchValue.map(function (item) {
                return _this2.getHtmlText(item);
              });
              value = value.map(function (item) {
                return _this2.getHtmlText(item);
              });
              if (this.hasCommonElement(searchValue, value)) {
                continue;
              } else {
                return false;
              }
            } else if (['string', 'number'].includes(typeof value === "undefined" ? "undefined" : _typeof(value))) {
              if (searchValue.includes(value)) {
                continue;
              } else {
                return false;
              }
            }
            if (value == null) {
              return false;
            }
          } else if (typeof searchValue === 'string') {
            if (value == null) {
              return false;
            }
            if (String(value).toLowerCase().includes(searchValue.toLowerCase())) {
              continue;
            } else {
              return false;
            }
          }
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      return true;
    },
    hasSearchCondition: function hasSearchCondition(condition) {
      if (condition == null) {
        return false;
      }
      // Empty object
      if (Object.keys(condition).length === 0) {
        return false;
      }
      if (condition.listConditions == null) {
        return false;
      }
      if (condition.listConditions.length === 0) {
        return false;
      }
      return true;
    },

    /*
    Check if data inside applicationData is match with listCombinedCondition
    listCombinedCondition is an array of 1 or some list Condition (each list Condition is used for a section)
    */
    isMatchCombinedConditions: function isMatchCombinedConditions(listCombinedConditions, applicationData) {
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = listCombinedConditions[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var combinedCondition = _step15.value;

          if (combinedCondition.listConditions == null || combinedCondition.listConditions.length === 0) {
            continue;
          }
          var listConditions = combinedCondition.listConditions;
          var listGroupConditions = listConditions.filter(function (condition) {
            return condition.isGroup;
          });
          // Filter out incomplete conditions
          listConditions = listConditions.filter(function (condition) {
            if (condition.operator) {
              return condition.value || condition.highValue || condition.lowValue;
            } else {
              // Table condition
              return condition.value && condition.item;
            }
          });
          // Match if any condition is match
          if (combinedCondition.logic_combination === "ANY") {
            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
              for (var _iterator16 = listConditions[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                var condition = _step16.value;

                if (this.isMatchAtomicCondition(condition, applicationData[condition.model])) {
                  // 1 condition is match => match
                  return true;
                }
              }
            } catch (err) {
              _didIteratorError16 = true;
              _iteratorError16 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }
              } finally {
                if (_didIteratorError16) {
                  throw _iteratorError16;
                }
              }
            }

            var _iteratorNormalCompletion17 = true;
            var _didIteratorError17 = false;
            var _iteratorError17 = undefined;

            try {
              for (var _iterator17 = listGroupConditions[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                var groupCondition = _step17.value;

                if (this.isMatchCombinedConditions([groupCondition.condition], applicationData)) {
                  // 1 condition is match => match
                  return true;
                }
              }
            } catch (err) {
              _didIteratorError17 = true;
              _iteratorError17 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion17 && _iterator17.return) {
                  _iterator17.return();
                }
              } finally {
                if (_didIteratorError17) {
                  throw _iteratorError17;
                }
              }
            }
          } else {
            // Match if all condition is match
            var isMatch = true;
            var _iteratorNormalCompletion18 = true;
            var _didIteratorError18 = false;
            var _iteratorError18 = undefined;

            try {
              for (var _iterator18 = listConditions[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                var _condition = _step18.value;

                if (!this.isMatchAtomicCondition(_condition, applicationData[_condition.model])) {
                  // 1 condition is not match => not match
                  isMatch = false;
                }
              }
            } catch (err) {
              _didIteratorError18 = true;
              _iteratorError18 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion18 && _iterator18.return) {
                  _iterator18.return();
                }
              } finally {
                if (_didIteratorError18) {
                  throw _iteratorError18;
                }
              }
            }

            var _iteratorNormalCompletion19 = true;
            var _didIteratorError19 = false;
            var _iteratorError19 = undefined;

            try {
              for (var _iterator19 = listGroupConditions[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                var _groupCondition = _step19.value;

                if (!this.isMatchCombinedConditions([_groupCondition.condition], applicationData)) {
                  // 1 condition is not match => not match
                  isMatch = false;
                }
              }
            } catch (err) {
              _didIteratorError19 = true;
              _iteratorError19 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion19 && _iterator19.return) {
                  _iterator19.return();
                }
              } finally {
                if (_didIteratorError19) {
                  throw _iteratorError19;
                }
              }
            }

            if (isMatch) {
              return true;
            }
          }
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      return false;
    },

    /* Check if automic condition is match
    example:
    condition: {
      model: 'selector1',
      operator: 'IS'
      value: 'Yes'
    }
    If value is 'Yes'
    => return true (match)
    If value is 'No'
    => return false (not match)
    */
    isMatchAtomicCondition: function isMatchAtomicCondition(condition, value) {
      // Radtion table or checkbox table
      if (!condition.operator) {
        return this.isMatchTableCondition(condition, value);
      }
      // Boolean selector fields
      if (value === true) {
        value = "Yes";
      }
      if (value === false) {
        value = "No";
      }
      var conditionValue = condition.value;
      if (conditionValue === "PREDEFINED_BLANK_STRING") {
        condition.isBlank = true;
        conditionValue = "";
      }
      if (Array.isArray(conditionValue)) {
        if (conditionValue.includes("PREDEFINED_BLANK_STRING") && !conditionValue.includes("")) {
          conditionValue.push("");
        }
      }
      switch (condition.operator) {
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS.id:
          // Equal comparision
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(conditionValue) === Number(value);
          }
          if (Array.isArray(conditionValue) && typeof value === 'string') {
            return conditionValue.includes(value);
          }
          if (condition.isBlank) {
            if (value == null) {
              return true;
            }
          }
          return conditionValue === value;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS_NOT.id:
          // Unequal comparision
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(conditionValue) !== Number(value);
          }
          return conditionValue !== value;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS_IN.id:
          // Check if condition.values contains value
          var arrVal = this.normalizedArrayValue(conditionValue);
          return arrVal.includes(value);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS_NOT_IN.id:
          // Check if condition.values does not contains value
          arrVal = this.normalizedArrayValue(conditionValue);
          return !arrVal.includes(value);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.CONTAINS.id:
          // Check if value contains conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return value.toLowerCase().includes(conditionValue.toLowerCase());
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.NOT_CONTAINS.id:
          // Check if value contains conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return !value.toLowerCase().includes(conditionValue.toLowerCase());
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS_BLANK.id:
          return !value;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.UPLOADED.id:
          console.log(value);
          return !!value;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.FILE_INFO_UPLOADED.id:
          console.log(value);
          return !!value;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.START_WITH.id:
          // Check if value start with conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return value.toLowerCase().startsWith(conditionValue.toLowerCase());
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.END_WITH.id:
          // Check if value end with conditionValue
          if (value == null || conditionValue == null) {
            return false;
          }
          return value.toLowerCase().endsWith(conditionValue.toLowerCase());
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.GT.id:
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            // Check if value > conditionValue
            return Number(value) > Number(conditionValue);
          } else {
            return String(value || "") > String(conditionValue);
          }
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.LT.id:
          // Check if value < conditionValue
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(value) < Number(conditionValue);
          } else {
            return String(value || "") < String(conditionValue);
          }
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.GE.id:
          // Check if value >= conditionValue
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(value) >= Number(conditionValue);
          } else {
            return String(value || "") >= String(conditionValue);
          }
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.LE.id:
          // Check if value <= conditionValue
          if (value && conditionValue && !isNaN(value) && !isNaN(conditionValue)) {
            return Number(value) <= Number(conditionValue);
          } else {
            return String(value || "") <= String(conditionValue);
          }
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.BETWEEN.id:
          // Check if condition.lowValue <= value <= condition.highValue
          if (value && condition.lowValue && !isNaN(value) && !isNaN(condition.lowValue)) {
            return Number(value) <= Number(condition.highValue) && Number(value) >= Number(condition.lowValue);
          } else {
            return String(value || "") <= String(condition.highValue) && String(value || "") >= String(condition.lowValue);
          }
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS_DATE.id:
          // Check if value is a date (date comparision)
          return this.dateInDjangoFormat(value) === this.dateInDjangoFormat(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.IS_NOT_DATE.id:
          // Check if value is not a date (date comparision)
          return this.dateInDjangoFormat(value) !== this.dateInDjangoFormat(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.BEFORE.id:
          // Check if value is before conditionValue (date comparision)
          return this.dateInDjangoFormat(value) < this.dateInDjangoFormat(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.AFTER.id:
          // Check if value is after conditionValue (date comparision)
          return this.dateInDjangoFormat(value) > this.dateInDjangoFormat(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.BE.id:
          // Check if value is before or equal conditionValue (date comparision)
          return this.dateInDjangoFormat(value) <= this.dateInDjangoFormat(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.AE.id:
          // Check if value is after or equal conditionValue (date comparision)
          return this.dateInDjangoFormat(value) >= this.dateInDjangoFormat(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.BETWEEN_DATE.id:
          // Check if condition.lowValue <= value <= condition.highValue (compare date)
          return value && this.dateInDjangoFormat(value) <= this.dateInDjangoFormat(condition.highValue) && this.dateInDjangoFormat(value) >= this.dateInDjangoFormat(condition.lowValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.DAY_IS.id:
          return value && new Date(value).getDate() === conditionValue;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.MONTH_IS.id:
          return value && new Date(value).getMonth() === conditionValue - 1;
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.YEAR_IS.id:
          return value && new Date(value).getFullYear() === Number(conditionValue);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.HAS.id:
          if (!value) {
            return false;
          }
          // Check if value contains all value inside conditionValue
          arrVal = this.normalizedArrayValue(conditionValue);
          return arrVal.every(function (val) {
            return value.includes(val);
          });
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.HAS_NOT.id:
          if (!value) {
            return true;
          }
          // Check if value does not contains all value inside conditionValue
          arrVal = this.normalizedArrayValue(conditionValue);
          return !this.hasCommonElement(arrVal, value);
        case _conditionParams.CONDITION_OPERATOR_OPTIONS.HAS_PARTIAL.id:
          if (!value) {
            return false;
          }
          // Check if value contains all value inside conditionValue
          arrVal = this.normalizedArrayValue(conditionValue);
          return this.hasCommonElement(arrVal, value);
      }
    },
    isMatchTableCondition: function isMatchTableCondition(condition, value) {
      if (condition.value && condition.item) {
        if (!value) {
          return false;
        }
        if (!Array.isArray(value)) {
          return false;
        }
        var _iteratorNormalCompletion20 = true;
        var _didIteratorError20 = false;
        var _iteratorError20 = undefined;

        try {
          for (var _iterator20 = value[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
            var line = _step20.value;

            if (!line) {
              continue;
            }
            var tokens = line.split(':');
            if (tokens.length < 2) {
              continue;
            }
            if (!condition.item.includes(tokens[0].trim())) {
              continue;
            }
            var optionTokens = tokens[1].split(',');
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
              for (var _iterator21 = optionTokens[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                var optionToken = _step21.value;

                if (condition.value.includes(optionToken.trim())) {
                  return true;
                }
              }
            } catch (err) {
              _didIteratorError21 = true;
              _iteratorError21 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion21 && _iterator21.return) {
                  _iterator21.return();
                }
              } finally {
                if (_didIteratorError21) {
                  throw _iteratorError21;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError20 = true;
          _iteratorError20 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion20 && _iterator20.return) {
              _iterator20.return();
            }
          } finally {
            if (_didIteratorError20) {
              throw _iteratorError20;
            }
          }
        }
      }
      return false;
    },
    getConditionGroupTypeOfField: function getConditionGroupTypeOfField(field) {
      if (field == null) {
        // Default
        return "DEFAULT";
      }
      // For datepicker
      if (field.type === _customDefineType.FORM_TYPE.DATEPICKER) {
        return "DATE";
      }
      // For multiselect component
      if (field.type === _customDefineType.FORM_TYPE.MULTI_SELECT) {
        if (field.isMultiple || field.isMulti) {
          return "MULTI_SELECT";
        } else {
          return "SINGLE_SELECT";
        }
      }
      // For other single select item (dropdown, radio group)
      if ([_customDefineType.FORM_TYPE.DROPDOWN, _customDefineType.FORM_TYPE.RADIO].includes(field.type)) {
        return "SINGLE_SELECT";
      }
      // For other multi select item
      if ([_customDefineType.FORM_TYPE.CHECKBOX].includes(field.type)) {
        return "MULTI_SELECT";
      }
      // For table items
      if ([_customDefineType.FORM_TYPE.RADIO_TABLE, _customDefineType.FORM_TYPE.CHECKBOX_TABLE].includes(field.type)) {
        return "TABLE";
      }
      // Default
      return "DEFAULT";
    },

    /*
    Calculate user properties (user type, user tag) based on list of condition
    If data is match with type/tag condition, the array result will contains type/tag in condition.type/tag
    Structure of listPropertyConditions (It can be listTypeConditions or listTagConditions): 
      [
        {
          conditions: [
            {
              conditions: [
                {
                  listConditions: [
                    list of automic condition
                  ],
                  logic_combination: ALL/ANY
                }
              ],
              type: "type" // Or tag: "tag"
            }
          ]
        }
      ]
    */
    calculateUserProperties: function calculateUserProperties(listPropertyConditions, data, originalProperties, propertyName) {
      if (listPropertyConditions == null) {
        return [];
      }
      // Clear existing property if the clear existing property flag is set for at least 1 condition
      var keyClearExisting = 'clearExisting' + this.capitalizeFirstLetter(this.convertToPluralForm(propertyName));
      var keyClearExistingExclude = 'clearExistingExclude' + this.capitalizeFirstLetter(this.convertToPluralForm(propertyName));
      var clearExistingProperty = false;
      var clearExistingExclude = null;
      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = listPropertyConditions[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var propertyCondition = _step22.value;

          if (propertyCondition[keyClearExisting] === true) {
            clearExistingProperty = true;
            clearExistingExclude = propertyCondition[keyClearExistingExclude];
          }
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }

      var userProperties = [];
      if (originalProperties) {
        if (clearExistingProperty) {
          if (clearExistingExclude && clearExistingExclude.length) {
            // Keep the items which are in the exclude list
            userProperties = originalProperties.filter(function (item) {
              return clearExistingExclude.includes(item);
            });
          }
        } else {
          // Keep current properties if clearExistingProperty flag is not set
          userProperties = originalProperties;
        }
      }

      var hasCondition = false;
      var _iteratorNormalCompletion23 = true;
      var _didIteratorError23 = false;
      var _iteratorError23 = undefined;

      try {
        for (var _iterator23 = listPropertyConditions[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
          var _propertyCondition = _step23.value;

          if (_propertyCondition == null || _propertyCondition.conditions == null) {
            continue;
          }
          var _iteratorNormalCompletion24 = true;
          var _didIteratorError24 = false;
          var _iteratorError24 = undefined;

          try {
            for (var _iterator24 = _propertyCondition.conditions[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
              var condition = _step24.value;

              if (condition[propertyName]) {
                hasCondition = true;
                if (this.isMatchCombinedConditions([condition.conditions], data)) {
                  userProperties.push(condition[propertyName]);
                }
              }
            }
          } catch (err) {
            _didIteratorError24 = true;
            _iteratorError24 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion24 && _iterator24.return) {
                _iterator24.return();
              }
            } finally {
              if (_didIteratorError24) {
                throw _iteratorError24;
              }
            }
          }
        }
        // If does not have any condition, keep current properties
      } catch (err) {
        _didIteratorError23 = true;
        _iteratorError23 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion23 && _iterator23.return) {
            _iterator23.return();
          }
        } finally {
          if (_didIteratorError23) {
            throw _iteratorError23;
          }
        }
      }

      if (!hasCondition) {
        if (originalProperties == null) {
          return [];
        }
        return originalProperties;
      }
      return this.deduplicateArrayOfObject(userProperties);
    },

    // Apply for non array field property (for example: status, second_status)
    calculateUserProperty: function calculateUserProperty(listPropertyConditions, data, propertyName) {
      if (listPropertyConditions == null) {
        return null;
      }
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = listPropertyConditions[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var propertyCondition = _step25.value;

          if (propertyCondition == null || propertyCondition.conditions == null) {
            continue;
          }
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = propertyCondition.conditions[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var condition = _step26.value;

              if (condition[propertyName]) {
                if (this.isMatchCombinedConditions([condition.conditions], data)) {
                  return condition;
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }

      return null;
    },

    // Get error condition based on list of error condition
    // If there is not match any condition, return null
    getErrorFromCondition: function getErrorFromCondition(listErrorConditions, data) {
      if (listErrorConditions == null) {
        return [];
      }
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = listErrorConditions[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var errorCondition = _step27.value;

          if (errorCondition == null || errorCondition.conditions == null) {
            continue;
          }
          var _iteratorNormalCompletion28 = true;
          var _didIteratorError28 = false;
          var _iteratorError28 = undefined;

          try {
            for (var _iterator28 = errorCondition.conditions[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
              var condition = _step28.value;

              if (this.isMatchCombinedConditions([condition.conditions], data)) {
                return condition.errorMessage;
              }
            }
          } catch (err) {
            _didIteratorError28 = true;
            _iteratorError28 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion28 && _iterator28.return) {
                _iterator28.return();
              }
            } finally {
              if (_didIteratorError28) {
                throw _iteratorError28;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }

      return null;
    },
    getMembershipInfoFromCondition: function getMembershipInfoFromCondition(listMembershipConditions, data) {
      var _this3 = this;

      if (listMembershipConditions == null) {
        return [];
      }
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = listMembershipConditions[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var membershipCondition = _step29.value;

          if (membershipCondition == null || membershipCondition.conditions == null) {
            continue;
          }
          var _iteratorNormalCompletion30 = true;
          var _didIteratorError30 = false;
          var _iteratorError30 = undefined;

          try {
            var _loop = function _loop() {
              var condition = _step30.value;

              if (_this3.isMatchCombinedConditions([condition.conditions], data)) {
                var listKeys = ['type', 'amount', 'frequency', 'duration', 'freePrices'];
                var result = {};
                listKeys.forEach(function (key) {
                  result[key] = condition[key];
                });
                result.date = _this3.dateInDjangoFormat(new Date());
                return {
                  v: result
                };
              }
            };

            for (var _iterator30 = membershipCondition.conditions[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
              var _ret = _loop();

              if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
            }
          } catch (err) {
            _didIteratorError30 = true;
            _iteratorError30 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion30 && _iterator30.return) {
                _iterator30.return();
              }
            } finally {
              if (_didIteratorError30) {
                throw _iteratorError30;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      return null;
    },

    /*
    This function reset the field if it is not showed
    For example: if the field corresponding with model 'selector1' is not showed (because it depend on value of other field)
    it will reset value of 'selector1' in applicationData
    */
    resetValueOfHiddenField: function resetValueOfHiddenField(target, allInfo, listFields, model) {
      var keepKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      // Find the corresponding field based on model
      var listModelFields = listFields.filter(function (field) {
        return field.model === model;
      });
      // No field
      if (listModelFields.length === 0) {
        return;
      }
      var isShow = false;
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = listModelFields[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var field = _step31.value;

          // At least one field is showed
          if (this.isItemShow(allInfo, field, listFields)) {
            isShow = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      if (!isShow) {
        if (keepKey) {
          if (typeof target[model] === 'string') {
            target[model] = '';
          } else if (Array.isArray(target[model])) {
            target[model] = [];
          } else {
            delete target[model];
          }
        } else {
          delete target[model];
        }
      }
    },

    /*
    Check if there is no data for the section (user does not input any information for this section)
    Only check for non-document fields
    */
    isEmptySection: function isEmptySection(listFields) {
      var selectedData = this.extractSelectedFields(this.user, listFields.filter(function (field) {
        return field.type !== _customDefineType.FORM_TYPE.FILE && field.model != null;
      }));
      var _iteratorNormalCompletion32 = true;
      var _didIteratorError32 = false;
      var _iteratorError32 = undefined;

      try {
        for (var _iterator32 = Object.values(selectedData)[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
          var val = _step32.value;

          if (val != null) {
            if (!this.isEmptyValue(val)) {
              return false;
            }
          }
        }
      } catch (err) {
        _didIteratorError32 = true;
        _iteratorError32 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion32 && _iterator32.return) {
            _iterator32.return();
          }
        } finally {
          if (_didIteratorError32) {
            throw _iteratorError32;
          }
        }
      }

      return true;
    },

    /*
    Get document body from template body
    by replace preseved word by data value
    */
    getDocumentBodyFromTemplate: function getDocumentBodyFromTemplate(document, data) {
      var templateBody, signingDate, mapReplaceKey, documentBody, _iteratorNormalCompletion33, _didIteratorError33, _iteratorError33, _iterator33, _step33, _step33$value, presevedWord, objectKey, address, addressTag, listTags, _iteratorNormalCompletion34, _didIteratorError34, _iteratorError34, _iterator34, _step34, tag, value, normalizedTag, mapTypes, _parseTagField, model, shareIndex, displayStyle, defaultValue, searchRegExp;

      return regeneratorRuntime.async(function getDocumentBodyFromTemplate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              templateBody = document.body;
              signingDate = document.signing_date;
              // Replace first name, last name, email, phone

              mapReplaceKey = {
                fname: 'first_name',
                lname: 'last_name',
                email: 'email',
                phone: 'phone'
              };

              if (document.sign_by_both) {
                if (data.is_employer) {
                  mapReplaceKey = {
                    client_fname: 'first_name',
                    client_lname: 'last_name',
                    client_email: 'email',
                    client_phone: 'phone'
                  };
                } else {
                  mapReplaceKey = {
                    candidate_fname: 'first_name',
                    candidate_lname: 'last_name',
                    candidate_email: 'email',
                    candidate_phone: 'phone'
                  };
                }
              }
              documentBody = templateBody;
              _iteratorNormalCompletion33 = true;
              _didIteratorError33 = false;
              _iteratorError33 = undefined;
              _context.prev = 8;

              for (_iterator33 = Object.entries(mapReplaceKey)[Symbol.iterator](); !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
                _step33$value = _slicedToArray(_step33.value, 2), presevedWord = _step33$value[0], objectKey = _step33$value[1];

                documentBody = documentBody.split("[[" + presevedWord + "]]").join(data[objectKey]);
              }
              // Replace date 
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](8);
              _didIteratorError33 = true;
              _iteratorError33 = _context.t0;

            case 16:
              _context.prev = 16;
              _context.prev = 17;

              if (!_iteratorNormalCompletion33 && _iterator33.return) {
                _iterator33.return();
              }

            case 19:
              _context.prev = 19;

              if (!_didIteratorError33) {
                _context.next = 22;
                break;
              }

              throw _iteratorError33;

            case 22:
              return _context.finish(19);

            case 23:
              return _context.finish(16);

            case 24:
              if (signingDate) {
                documentBody = documentBody.split("[[date]]").join(new Date(signingDate).toDateString());
              } else {
                documentBody = documentBody.split("[[date]]").join(new Date().toDateString());
              }

              // Replace address
              address = data.address1;

              if (data.address2) {
                address = address + ' ' + data.address2;
              }
              address = address + ', ' + data.city + ', ' + data.provincestate + ', ' + data.postal_code;
              addressTag = "address";

              if (document.sign_by_both) {
                if (data.is_employer) {
                  addressTag = "client_address";
                } else {
                  addressTag = "candidate_address";
                }
              }
              documentBody = documentBody.split("[[" + addressTag + "]]").join(address);
              listTags = this.extractTagFromString(documentBody);
              // Replace other tags

              _iteratorNormalCompletion34 = true;
              _didIteratorError34 = false;
              _iteratorError34 = undefined;
              _context.prev = 35;
              _iterator34 = listTags[Symbol.iterator]();

            case 37:
              if (_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done) {
                _context.next = 79;
                break;
              }

              tag = _step34.value;

              if (!(tag.indexOf('field') === 0)) {
                _context.next = 41;
                break;
              }

              return _context.abrupt("continue", 76);

            case 41:
              if (!(tag.indexOf('api|') === 0)) {
                _context.next = 44;
                break;
              }

              documentBody = this.replaceAllText(documentBody, "[[" + tag + "]]", this.getReplacedApiTag(tag, data));
              return _context.abrupt("continue", 76);

            case 44:
              if (!(tag.indexOf("x ") === 0)) {
                _context.next = 46;
                break;
              }

              return _context.abrupt("continue", 76);

            case 46:
              value = void 0;
              normalizedTag = '';

              if (!document.sign_by_both) {
                _context.next = 64;
                break;
              }

              if (!data.is_employer) {
                _context.next = 57;
                break;
              }

              if (!(tag.indexOf('client-') === 0)) {
                _context.next = 54;
                break;
              }

              // Only replace client tag
              normalizedTag = tag.replace('client-', '');
              _context.next = 55;
              break;

            case 54:
              return _context.abrupt("continue", 76);

            case 55:
              _context.next = 62;
              break;

            case 57:
              if (!(tag.indexOf('candidate-') === 0)) {
                _context.next = 61;
                break;
              }

              // Only replace candidate tag
              normalizedTag = tag.replace('candidate-', '');
              _context.next = 62;
              break;

            case 61:
              return _context.abrupt("continue", 76);

            case 62:
              _context.next = 65;
              break;

            case 64:
              normalizedTag = tag;

            case 65:
              if (!['children', 'pets'].includes(normalizedTag)) {
                _context.next = 72;
                break;
              }

              mapTypes = {
                children: _fieldTypes.MAP_DIALOG_SECTION.Children,
                pets: _fieldTypes.MAP_DIALOG_SECTION.Pet
              };
              _context.next = 69;
              return regeneratorRuntime.awrap(this.getProfileSectionContent(data, data[normalizedTag], mapTypes[normalizedTag].name, false, true));

            case 69:
              value = _context.sent;

              documentBody = documentBody.split("[[" + normalizedTag + "]]").join(value);
              return _context.abrupt("continue", 76);

            case 72:
              _parseTagField = this.parseTagField(normalizedTag), model = _parseTagField.model, shareIndex = _parseTagField.shareIndex, displayStyle = _parseTagField.displayStyle, defaultValue = _parseTagField.defaultValue;

              console.log(model, shareIndex, displayStyle, defaultValue);
              value = this.getDisplayValueInline(data, model, shareIndex, displayStyle, defaultValue);
              if (value) {
                documentBody = documentBody.split("[[" + tag + "]]").join(value);
              } else {
                try {
                  // remove boundary text
                  searchRegExp = new RegExp("\\(\\(\\([^)]*[[" + tag + "]][^)]*\\)\\)\\)", 'gmi');

                  documentBody = documentBody.replace(searchRegExp, '');
                } catch (_) {}
                documentBody = documentBody.split("[[" + tag + "]]").join('');
              }

            case 76:
              _iteratorNormalCompletion34 = true;
              _context.next = 37;
              break;

            case 79:
              _context.next = 85;
              break;

            case 81:
              _context.prev = 81;
              _context.t1 = _context["catch"](35);
              _didIteratorError34 = true;
              _iteratorError34 = _context.t1;

            case 85:
              _context.prev = 85;
              _context.prev = 86;

              if (!_iteratorNormalCompletion34 && _iterator34.return) {
                _iterator34.return();
              }

            case 88:
              _context.prev = 88;

              if (!_didIteratorError34) {
                _context.next = 91;
                break;
              }

              throw _iteratorError34;

            case 91:
              return _context.finish(88);

            case 92:
              return _context.finish(85);

            case 93:
              documentBody = this.removeTextInString(documentBody, ['(((', ')))']);
              return _context.abrupt("return", documentBody);

            case 95:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[8, 12, 16, 24], [17,, 19, 23], [35, 81, 85, 93], [86,, 88, 92]]);
    },

    // Compare 2 input text by ignore space, punctuation (case insensitive)
    compareTextWithoutPunctuation: function compareTextWithoutPunctuation(input1, input2) {
      if (!input1 || !input2) {
        return false;
      }
      var normalizeInput1 = input1.toLowerCase().replace(_regex.REGEX_NORMALIZE_TEXT, "");
      var normalizeInput2 = input2.toLowerCase().replace(_regex.REGEX_NORMALIZE_TEXT, "");
      return normalizeInput1 === normalizeInput2;
    },

    // Get common value of the two arrays
    getArraysIntersection: function getArraysIntersection(a1, a2) {
      if (a1 == null || a2 == null) {
        return [];
      }
      return a1.filter(function (n) {
        return a2.includes(n);
      });
    },

    // Convert string to list of option (separator is space character) 
    convertStringToArray: function convertStringToArray(input) {
      if (Array.isArray(input)) {
        return input;
      }
      return input.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
    },

    // Check if a model is used for boolean radio
    isBooleanRadioModel: function isBooleanRadioModel(model) {
      if (model == null) {
        return false;
      }
      if (model.includes('boolean_selector')) {
        return true;
      }
      if (['current_role', "is_out_of_town", "sick_children", "graduated", "skip_charge", "hide_from_job_board", "visible_to_candidates"].includes(model)) {
        return true;
      }
      return false;
    },

    // Find duplicate elements in array
    findDuplicates: function findDuplicates(arr) {
      if (!arr) {
        console.log('CHECKING DUPLICATE: Empty Array');
      }
      var len = arr.length;
      // initialize ifPresent as false
      var ifPresent = false;

      // ArrayList to store the output
      var al = new Array();

      for (var i = 0; i < len - 1; i++) {
        for (var j = i + 1; j < len; j++) {
          if (arr[i] == arr[j]) {
            // checking if element is
            // present in the ArrayList
            // or not if present then break
            if (al.includes(arr[i])) {
              break;
            }

            // if element is not present in the
            // ArrayList then add it to ArrayList
            // and make ifPresent at true
            else {
                al.push(arr[i]);
                ifPresent = true;
              }
          }
        }
      }

      // if duplicates is present
      // then print ArrayList
      if (ifPresent == true) {
        console.log('CHECKING DUPLICATE: List of duplicates: ', al);
      } else {
        console.log("CHECKING DUPLICATE: No duplicates present in arrays");
      }
    },

    /* Check if inputString is in a mixed array
    Structure of mixed array: each element is String or Array of String
    For example: [["a", "b"], "c"]
    */
    isInMixedArray: function isInMixedArray(mixedArray, inputString) {
      if (!mixedArray) {
        return false;
      }
      var _iteratorNormalCompletion35 = true;
      var _didIteratorError35 = false;
      var _iteratorError35 = undefined;

      try {
        for (var _iterator35 = mixedArray[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
          var item = _step35.value;

          if (Array.isArray(item)) {
            if (item.includes(inputString)) {
              return true;
            }
          } else {
            if (item === inputString) {
              return true;
            }
          }
        }
      } catch (err) {
        _didIteratorError35 = true;
        _iteratorError35 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion35 && _iterator35.return) {
            _iterator35.return();
          }
        } finally {
          if (_didIteratorError35) {
            throw _iteratorError35;
          }
        }
      }

      return false;
    },

    /*
    Find list of email notification when user submit application form or submit profile section
    */
    getListEmailSubmissionNotification: function getListEmailSubmissionNotification(listEmails, listEmailLocations, userLocations) {
      var result = [];
      if (listEmails) {
        result = [].concat(_toConsumableArray(listEmails));
      }
      if (listEmailLocations) {
        var _iteratorNormalCompletion36 = true;
        var _didIteratorError36 = false;
        var _iteratorError36 = undefined;

        try {
          for (var _iterator36 = listEmailLocations[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
            var emailLocation = _step36.value;

            if (!emailLocation.email) {
              continue;
            }
            var locations = emailLocation.locations;
            // If locations are undefined, the email will be used for all locations
            if (!locations || !locations.length) {
              result.push(emailLocation.email);
              continue;
            }
            // locations and userlocations has at least one common item
            if (this.hasCommonElement(locations, userLocations)) {
              result.push(emailLocation.email);
            }
          }
        } catch (err) {
          _didIteratorError36 = true;
          _iteratorError36 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion36 && _iterator36.return) {
              _iterator36.return();
            }
          } finally {
            if (_didIteratorError36) {
              throw _iteratorError36;
            }
          }
        }
      }
      result = result.filter(function (item) {
        return item;
      }); // Remove empty item
      return [].concat(_toConsumableArray(new Set(result))); // Remove duplicated email
    },

    /* Check if row is fulled
     For example:
     1 row is full if it contains 1 item, which has 1 per row
     1 row is full if it contains 2 items, each take 1/2 row
     1 row is full if it contains 3 items, each take 1/3 row, or 1/2 + 1/4 + 1/4
     ...
    */
    isFullBootstrapRow: function isFullBootstrapRow(listItems) {
      var total = 0;
      var _iteratorNormalCompletion37 = true;
      var _didIteratorError37 = false;
      var _iteratorError37 = undefined;

      try {
        for (var _iterator37 = listItems[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
          var item = _step37.value;

          if (item.itemPerRow === 0) {
            if (item.isLast) {
              return true;
            }
            continue;
          }
          if (!item.itemPerRow) {
            item.itemPerRow = 1;
          }
          total += 12 / Number(item.itemPerRow);
        }
      } catch (err) {
        _didIteratorError37 = true;
        _iteratorError37 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion37 && _iterator37.return) {
            _iterator37.return();
          }
        } finally {
          if (_didIteratorError37) {
            throw _iteratorError37;
          }
        }
      }

      return total >= 12;
    },

    // Get display value of cell in table
    getTableCellContent: function getTableCellContent(row, field) {
      var _this4 = this;

      var listFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var listDateModel = ["created_date", "last_login", "last_updated_date", "recent_access", "last_activity", "last_contacted_date"];
      var listTimeModel = ["start_time", "end_time", "actual_start_time", "actual_end_time"];
      if (field.transformFunction) {
        return field.transformFunction(row);
      }
      if (field.model === "first_name_last_name") {
        return row["first_name"] + " " + row["last_name"];
      }
      if (field.model === "secondary_first_name_secondary_last_name") {
        return row["secondary_first_name"] + " " + row["secondary_last_name"];
      }
      var value = row[field.model];
      if (listDateModel.includes(field.model)) {
        if (!value) {
          return "";
        }
        return new Date(value).toDateString();
      }
      if (listTimeModel.includes(field.model)) {
        if (!value) {
          return "";
        }
        return this.djangotimeformatAMPM(value);
      }
      if (Array.isArray(value)) {
        if (field.model === 'modelMatches') {
          return value.map(function (model) {
            var label = void 0;
            if (listFields) {
              var _field = listFields.find(function (field) {
                return field.model === model;
              });
              if (_field) {
                label = _field.label;
              }
              if (!label) {
                label = _this4.convertUnderscoreToLabel(model);
              }
            }
            var fieldValue = row[model];
            if (listDateModel.includes(model)) {
              fieldValue = new Date(fieldValue).toDateString();
            }
            if (listTimeModel.includes(model)) {
              fieldValue = _this4.djangotimeformatAMPM(fieldValue);
            }

            return label + ': ' + fieldValue;
          }).join("\n");
        } else {
          // Find the list of options, based on that to prevent from displaying obsolete options
          var optionList = [];
          if (field.model === 'types') {
            if (row.is_candidate) {
              optionList = this.$store.getters.candidateTypes;
            } else if (row.is_employer) {
              optionList = this.$store.getters.employerTypes;
            }
          }
          if (optionList && optionList.length) {
            var result = [];
            var _iteratorNormalCompletion38 = true;
            var _didIteratorError38 = false;
            var _iteratorError38 = undefined;

            try {
              for (var _iterator38 = optionList[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                var option = _step38.value;

                if (value.includes(option)) {
                  result.push(option);
                }
              }
            } catch (err) {
              _didIteratorError38 = true;
              _iteratorError38 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion38 && _iterator38.return) {
                  _iterator38.return();
                }
              } finally {
                if (_didIteratorError38) {
                  throw _iteratorError38;
                }
              }
            }

            return this.deduplicateArrayOfObject(result).join(", ");
          } else {
            return this.deduplicateArrayOfObject(value).join(", ");
          }
        }
      }
      if ([_customDefineType.FORM_TYPE.RADIO, _customDefineType.FORM_TYPE.MULTI_SELECT].includes(field.type) && field.hasOther) {
        return this.removeOtherRadioPrefix(value);
      }
      return value;
    },
    isEffectiveObject: function isEffectiveObject(availability, date) {
      var normalizedDate = this.dateInDjangoFormat(date);
      if (availability.effective_date > normalizedDate) {
        return false;
      }
      if (availability.effective_until) {
        if (availability.effective_until < normalizedDate) {
          return false;
        }
      }
      return true;
    },
    isDocumentUploaded: function isDocumentUploaded(data) {
      if (!data) {
        return false;
      }
      if (this.convertToAbsolutePath(data).endsWith(_defaultValues.DEFAULT_PROFILE_IMAGE_SUFFIX)) {
        return false;
      }
      return true;
    },
    updateDerivedModel: function updateDerivedModel(objectData, listFields) {
      if (!listFields || !objectData) {
        return;
      }
      var _iteratorNormalCompletion39 = true;
      var _didIteratorError39 = false;
      var _iteratorError39 = undefined;

      try {
        for (var _iterator39 = listFields[Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
          var field = _step39.value;

          if (!field.derivedModel || !field.derivedOptionList) {
            continue;
          }
          if (!field.model) {
            continue;
          }
          var value = objectData[field.model];
          if (!value) {
            continue;
          }
          var optionList = this.convertStringToArray(field.optionList);
          var derivedOptionList = this.convertStringToArray(field.derivedOptionList);
          if (Array.isArray(value)) {
            // Multi selection
            var listDerivedValue = [];
            var _iteratorNormalCompletion40 = true;
            var _didIteratorError40 = false;
            var _iteratorError40 = undefined;

            try {
              for (var _iterator40 = value[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
                var item = _step40.value;

                // Find index of selection
                var indexOfSelection = optionList.indexOf(item);
                // Check if other option is selected
                if (indexOfSelection < 0 && item.indexOf('other:') === 0) {
                  indexOfSelection = optionList.length - 1;
                }
                if (indexOfSelection < 0) {
                  continue;
                }
                listDerivedValue.push(derivedOptionList[indexOfSelection]);
              }
            } catch (err) {
              _didIteratorError40 = true;
              _iteratorError40 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion40 && _iterator40.return) {
                  _iterator40.return();
                }
              } finally {
                if (_didIteratorError40) {
                  throw _iteratorError40;
                }
              }
            }

            objectData[field.derivedModel] = listDerivedValue;
          } else {
            // Single selection
            // Find index of selection
            var _indexOfSelection = optionList.indexOf(value);
            // Check if other option is selected
            if (_indexOfSelection < 0 && value.indexOf('other:') === 0) {
              _indexOfSelection = optionList.length - 1;
            }
            if (_indexOfSelection < 0 && value.indexOf(_prefix.RADIO_OTHER_OPTIONS_PREFIX) === 0) {
              _indexOfSelection = optionList.length - 1;
            }
            console.log(_indexOfSelection);
            if (_indexOfSelection < 0) {
              continue;
            }
            objectData[field.derivedModel] = derivedOptionList[_indexOfSelection];
          }
          console.log(objectData);
        }
      } catch (err) {
        _didIteratorError39 = true;
        _iteratorError39 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion39 && _iterator39.return) {
            _iterator39.return();
          }
        } finally {
          if (_didIteratorError39) {
            throw _iteratorError39;
          }
        }
      }
    },
    currencySign: function currencySign(agencyCurrency) {
      var symbol = void 0;
      switch (agencyCurrency) {
        case "USD":
          symbol = "$";
          break;
        case "AUD":
          symbol = "A$";
          break;
        case "BGN":
          symbol = "Лв.";
          break;
        case "BRL":
          symbol = "R$";
          break;
        case "CAD":
          symbol = "C$";
          break;
        case "CZK":
          symbol = "Kč";
          break;
        case "DKK":
          symbol = "kr";
          break;
        case "EUR":
          symbol = "€";
          break;
        case "GBP":
          symbol = "£";
          break;
        case "HKD":
          symbol = "HK$";
          break;
        case "HUF":
          symbol = "Ft";
          break;
        case "INR":
          symbol = "₹";
          break;
        case "JPY":
          symbol = "¥";
          break;
        case "MXN":
          symbol = "Mex$";
          break;
        case "MYR":
          symbol = "RM";
          break;
        case "NOK":
          symbol = "kr";
          break;
        case "NZD":
          symbol = "NZ$";
          break;
        case "PLN":
          symbol = "zł";
          break;
        case "RON":
          symbol = "L";
          break;
        case "SEK":
          symbol = "kr";
          break;
        case "SGD":
          symbol = "S$";
          break;
        default:
          symbol = agencyCurrency;
          break;
      }
      return symbol;
    },
    addAdditionalScheduling: function addAdditionalScheduling(adminSetting, mapReplaceValues) {
      var hasTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (adminSetting && adminSetting.additional_scheduling_links) {
        var _iteratorNormalCompletion41 = true;
        var _didIteratorError41 = false;
        var _iteratorError41 = undefined;

        try {
          for (var _iterator41 = adminSetting.additional_scheduling_links[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
            var linkObj = _step41.value;

            if (hasTag) {
              mapReplaceValues["[[" + linkObj.tag + "]]"] = linkObj.link;
            } else {
              mapReplaceValues[linkObj.tag] = linkObj.link;
            }
          }
        } catch (err) {
          _didIteratorError41 = true;
          _iteratorError41 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion41 && _iterator41.return) {
              _iterator41.return();
            }
          } finally {
            if (_didIteratorError41) {
              throw _iteratorError41;
            }
          }
        }
      }
    },
    isDisableConfirmCancellation: function isDisableConfirmCancellation() {
      if (this.$route && ["Application Form Builder", "Application Form Builder with Agency Name"].includes(this.$route.name)) {
        return this.$store.getters.disableWarningCancelPopupApplicationForm;
      }
      return false;
    },
    getErrorMessage: function getErrorMessage(errorInfo) {
      if (errorInfo.message) {
        return errorInfo.message;
      }
      var result = errorInfo.type;
      if (errorInfo.field) {
        result += ": " + errorInfo.field.label;
      }
      return result;
    },
    getMissingValueWarningMessage: function getMissingValueWarningMessage(listFields) {
      var _this5 = this;

      var listLabels = listFields.map(function (field) {
        return "<li>" + _this5.getFieldPropertyByLang(field, 'label') + "</li>";
      });
      return listLabels.join('');
    }
  }
});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMBINE_CONDITION_OPTIONS = exports.COMBINE_CONDITION_OPTIONS = {
  ANY: { label: "Or", id: "ANY" },
  ALL: { label: "And", id: "ALL" }
};

var CONDITION_OPERATOR_OPTIONS = exports.CONDITION_OPERATOR_OPTIONS = {
  IS: { label: "Is", id: "IS" },
  IS_NOT: { label: "Is not", id: "IS_NOT" },
  IS_IN: { label: "Is in", id: "IS_IN" },
  IS_NOT_IN: { label: "Is not in", id: "IS_NOT_IN" },
  CONTAINS: { label: "Contains", id: "CONTAINS" },
  NOT_CONTAINS: { label: "Doesn't contains", id: "NOT_CONTAINS" },
  START_WITH: { label: "Start with", id: "START_WITH" },
  END_WITH: { label: "End with", id: "END_WITH" },
  GT: { label: "Greater than", id: "GT" },
  LT: { label: "Less than", id: "LT" },
  GE: { label: "Greater than or equal to", id: "GE" },
  LE: { label: "Less than or equal to", id: "LE" },
  IS_BLANK: { label: "Is Blank", id: "IS_BLANK" },
  IS_DATE: { label: "Is", id: "IS_DATE" },
  IS_NOT_DATE: { label: "Is not", id: "IS_NOT_DATE" },
  BEFORE: { label: "Before", id: "BEFORE" },
  AFTER: { label: "After", id: "AFTER" },
  BE: { label: "Before or equal to", id: "BE" },
  AE: { label: "After or equal to", id: "AE" },
  BETWEEN: { label: "Between", id: "BETWEEN" },
  BETWEEN_DATE: { label: "Between", id: "BETWEEN_DATE" },
  HAS: { label: "Contains all", id: "HAS" },
  HAS_PARTIAL: { label: "Contains any", id: "HAS_PARTIAL" },
  HAS_NOT: { label: "Doesn't contains", id: "HAS_NOT" },
  DAY_IS: { label: "Day Is", id: "DAY_IS" },
  MONTH_IS: { label: "Month Is", id: "MONTH_IS" },
  YEAR_IS: { label: "Year Is", id: "YEAR_IS" },
  UPLOADED: { label: "Uploaded", id: "UPLOADED" },
  FILE_INFO_UPLOADED: { label: "Uploaded", id: "FILE_INFO_UPLOADED" }
};

var CONDITION_DATE_OPERATOR_OPTIONS_LIST = exports.CONDITION_DATE_OPERATOR_OPTIONS_LIST = [CONDITION_OPERATOR_OPTIONS.IS_DATE, CONDITION_OPERATOR_OPTIONS.IS_NOT_DATE, CONDITION_OPERATOR_OPTIONS.BEFORE, CONDITION_OPERATOR_OPTIONS.AFTER, CONDITION_OPERATOR_OPTIONS.BE, CONDITION_OPERATOR_OPTIONS.AE, CONDITION_OPERATOR_OPTIONS.BETWEEN_DATE, CONDITION_OPERATOR_OPTIONS.DAY_IS, CONDITION_OPERATOR_OPTIONS.MONTH_IS, CONDITION_OPERATOR_OPTIONS.YEAR_IS];

var CONDITION_SINGLE_SELECT_OPERATOR_OPTIONS_LIST = exports.CONDITION_SINGLE_SELECT_OPERATOR_OPTIONS_LIST = [CONDITION_OPERATOR_OPTIONS.IS, CONDITION_OPERATOR_OPTIONS.IS_NOT, CONDITION_OPERATOR_OPTIONS.IS_IN, CONDITION_OPERATOR_OPTIONS.IS_NOT_IN];

var CONDITION_MULTI_SELECT_OPERATOR_OPTIONS_LIST = exports.CONDITION_MULTI_SELECT_OPERATOR_OPTIONS_LIST = [CONDITION_OPERATOR_OPTIONS.HAS, CONDITION_OPERATOR_OPTIONS.HAS_PARTIAL, CONDITION_OPERATOR_OPTIONS.HAS_NOT];

var CONDITION_TEXT_OPERATOR_OPTIONS_LIST = exports.CONDITION_TEXT_OPERATOR_OPTIONS_LIST = [CONDITION_OPERATOR_OPTIONS.IS, CONDITION_OPERATOR_OPTIONS.IS_NOT, CONDITION_OPERATOR_OPTIONS.IS_IN, CONDITION_OPERATOR_OPTIONS.IS_NOT_IN, CONDITION_OPERATOR_OPTIONS.CONTAINS, CONDITION_OPERATOR_OPTIONS.NOT_CONTAINS, CONDITION_OPERATOR_OPTIONS.START_WITH, CONDITION_OPERATOR_OPTIONS.END_WITH, CONDITION_OPERATOR_OPTIONS.GT, CONDITION_OPERATOR_OPTIONS.GE, CONDITION_OPERATOR_OPTIONS.LT, CONDITION_OPERATOR_OPTIONS.LE, CONDITION_OPERATOR_OPTIONS.BETWEEN];

var CONDITION_OPERATOR_OPTIONS_BY_FIELD_TYPE = exports.CONDITION_OPERATOR_OPTIONS_BY_FIELD_TYPE = {
  DATE: CONDITION_DATE_OPERATOR_OPTIONS_LIST,
  SINGLE_SELECT: CONDITION_SINGLE_SELECT_OPERATOR_OPTIONS_LIST,
  MULTI_SELECT: CONDITION_MULTI_SELECT_OPERATOR_OPTIONS_LIST,
  DEFAULT: CONDITION_TEXT_OPERATOR_OPTIONS_LIST
};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _urlParams = __webpack_require__(65);

var _customDefineType = __webpack_require__(6);

var _queryHandling = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
  data: function data() {
    return {
      appendUrlParam: _queryHandling.appendUrlParam,
      appendBackgroundParam: _queryHandling.appendBackgroundParam,
      appendHideLoadingParam: _queryHandling.appendHideLoadingParam
    };
  },

  computed: {
    rootUrl: function rootUrl() {
      if (window.location.origin) {
        return window.location.origin;
      } else {
        return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
      }
    }
  },
  methods: {
    // Append query parameter at URL to use when handling error
    appendWarningUserCreated: function appendWarningUserCreated(apiPath, resource) {
      if (apiPath.includes("?")) {
        return apiPath + "&" + _urlParams.PARAM_USER_CREATED + "&" + _urlParams.PARAM_RESOURCE_INFO_KEY + "=" + resource;
      } else {
        return apiPath + "?" + _urlParams.PARAM_USER_CREATED + "&" + _urlParams.PARAM_RESOURCE_INFO_KEY + "=" + resource;
      }
    },

    // Get value of a query parameter by name
    // Example: URL: login?user=test
    // Name: user
    // Output: test
    getParameterByName: function getParameterByName(url, name) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return null;
      }
      return decodeURIComponent(results[2].replace(/\+/g, " ").replace("/", ""));
    },

    /*
    Send patch request to patchUrl (example: /api/people/)
    listFields may contains both file and non-file field
    Therefore, it need to separate into 2 request: multipart-form request for file and normal json request for non-file data
    */
    patchQueryForListFields: function patchQueryForListFields(patchUrl, applicationData, listFields, appendData) {
      var _this = this;

      return new Promise(function _callee(resolve, reject) {
        var listFileModels, formData, jsonData, hasFileData, hasNonFileData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, res;

        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Find all model fields
                listFileModels = listFields.filter(function (field) {
                  return field.type === _customDefineType.FORM_TYPE.FILE;
                }).map(function (field) {
                  return field.model;
                });

                // Separate file data and non file data

                formData = new FormData();
                jsonData = {};
                hasFileData = false;
                hasNonFileData = false;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 8;

                _loop = function _loop() {
                  var model = _step.value;

                  // Separate file and non-file field
                  if (listFileModels.includes(model)) {
                    if (applicationData[model] != null && _typeof(applicationData[model]) === "object") {
                      hasFileData = true;
                      formData.append(model, applicationData[model]);
                    }
                  } else {
                    hasNonFileData = true;
                    // Check timepicker field
                    var field = listFields.find(function (field) {
                      return field.model === model;
                    });
                    if (field && field.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
                      jsonData[model] = _this.getTimeString(applicationData[model]);
                    } else {
                      jsonData[model] = applicationData[model];
                    }
                  }
                };

                for (_iterator = Object.keys(applicationData)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _loop();
                }
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](8);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 17:
                _context.prev = 17;
                _context.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 20:
                _context.prev = 20;

                if (!_didIteratorError) {
                  _context.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context.finish(20);

              case 24:
                return _context.finish(17);

              case 25:
                res = void 0;
                // Patch non file data

                if (!(hasNonFileData || appendData)) {
                  _context.next = 31;
                  break;
                }

                _context.next = 29;
                return regeneratorRuntime.awrap(_axios2.default.patch(patchUrl, _extends({}, jsonData, appendData)));

              case 29:
                res = _context.sent;

                if (res == null) {
                  reject();
                }

              case 31:
                if (!hasFileData) {
                  _context.next = 36;
                  break;
                }

                _context.next = 34;
                return regeneratorRuntime.awrap(_axios2.default.patch(patchUrl, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 34:
                res = _context.sent;

                if (res == null) {
                  reject();
                }

              case 36:
                resolve(res);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, null, _this, [[8, 13, 17, 25], [18,, 20, 24]]);
      });
    },

    /*
    Send post request to create object, for example: children, pet, ...
    If there is a file (in case of profile image for pet), send post request to create object,
    then send patch request to submit file
    extraData: info send with the object, for example: agencyId, agency name, object type, ...
    */
    postQueryForListFields: function postQueryForListFields(url, resourceParm, applicationData, listFields, extraData) {
      var _this2 = this;

      return new Promise(function _callee2(resolve, reject) {
        var listFileModels, formData, jsonData, hasFileData, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop2, _iterator2, _step2, postURL, res, id, patchURL;

        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Find all model fields
                listFileModels = listFields.filter(function (field) {
                  return field.type === _customDefineType.FORM_TYPE.FILE;
                }).map(function (field) {
                  return field.model;
                });

                // Separate file data and non file data

                formData = new FormData();
                jsonData = {};
                hasFileData = false;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 7;

                _loop2 = function _loop2() {
                  var model = _step2.value;

                  if (listFileModels.includes(model)) {
                    if (applicationData[model] != null) {
                      hasFileData = true;
                      formData.append(model, applicationData[model]);
                    }
                  } else {
                    // Check timepicker field
                    var field = listFields.find(function (field) {
                      return field.model === model;
                    });
                    if (field && field.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
                      jsonData[model] = _this2.getTimeString(applicationData[model]);
                    } else {
                      jsonData[model] = applicationData[model];
                    }
                  }
                };

                for (_iterator2 = Object.keys(applicationData)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _loop2();
                }

                // Create object
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](7);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 16:
                _context2.prev = 16;
                _context2.prev = 17;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 19:
                _context2.prev = 19;

                if (!_didIteratorError2) {
                  _context2.next = 22;
                  break;
                }

                throw _iteratorError2;

              case 22:
                return _context2.finish(19);

              case 23:
                return _context2.finish(16);

              case 24:
                postURL = _this2.appendWarningUserCreated(url, resourceParm);
                _context2.next = 27;
                return regeneratorRuntime.awrap(_axios2.default.post(postURL, _extends({}, jsonData, extraData)));

              case 27:
                res = _context2.sent;

                if (res == null) {
                  reject();
                }
                id = void 0;

                if (Array.isArray(res.data)) {
                  id = res.data[0].id;
                } else if (res.data) {
                  id = res.data.id;
                }

                // Patch files

                if (!hasFileData) {
                  _context2.next = 37;
                  break;
                }

                patchURL = _this2.appendWarningUserCreated("" + url + id, resourceParm);
                _context2.next = 35;
                return regeneratorRuntime.awrap(_axios2.default.patch(patchURL, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 35:
                res = _context2.sent;

                if (res == null) {
                  reject();
                }

              case 37:
                resolve(id);

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, null, _this2, [[7, 12, 16, 24], [17,, 19, 23]]);
      });
    },
    getEmailTemplates: function getEmailTemplates(url) {
      var _this3 = this;

      return new Promise(function _callee3(resolve, reject) {
        var res, listEmailTemplates;
        return regeneratorRuntime.async(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return regeneratorRuntime.awrap(_axios2.default.get(url));

              case 2:
                res = _context3.sent;

                if (!(!res || !res.data)) {
                  _context3.next = 6;
                  break;
                }

                reject();
                return _context3.abrupt("return");

              case 6:
                listEmailTemplates = res.data;

                if (_this3.$store.getters.agent && _this3.$store.getters.agent.id) {
                  listEmailTemplates = listEmailTemplates.filter(function (template) {
                    return !template.agent_users || template.agent_users.length === 0 || template.agent_users.includes(_this3.$store.getters.agent.id);
                  });
                }
                resolve({
                  data: listEmailTemplates
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, null, _this3);
      });
    },
    getAdminSetting: function getAdminSetting() {
      var _this4 = this;

      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var userID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!userID) {
        userID = this.$store.getters.userID;
      }
      return new Promise(function _callee4(resolve) {
        var res, listAgentSetting, emailFooter, smsFooter, id, notificationScope, adminSetting;
        return regeneratorRuntime.async(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (userID) {
                  _context4.next = 3;
                  break;
                }

                resolve(null);
                return _context4.abrupt("return");

              case 3:
                if (_this4.$store.getters.isAgent) {
                  _context4.next = 6;
                  break;
                }

                resolve(null);
                return _context4.abrupt("return");

              case 6:
                if (!(!reload && _this4.$store.getters.adminSetting && Object.keys(_this4.$store.getters.adminSetting).length)) {
                  _context4.next = 9;
                  break;
                }

                resolve(_this4.$store.getters.adminSetting);
                return _context4.abrupt("return");

              case 9:
                _context4.next = 11;
                return regeneratorRuntime.awrap(_axios2.default.get("/api/agentsettings/?agent=" + userID));

              case 11:
                res = _context4.sent;

                if (!(res && res.data)) {
                  _context4.next = 30;
                  break;
                }

                listAgentSetting = res.data.sort(function (a, b) {
                  return a.id > b.id ? 1 : -1;
                });

                console.log(listAgentSetting);

                if (!(listAgentSetting.length > 0)) {
                  _context4.next = 27;
                  break;
                }

                emailFooter = listAgentSetting[0].email_footer;
                smsFooter = listAgentSetting[0].sms_footer;
                id = listAgentSetting[0].id;
                notificationScope = listAgentSetting[0].notification_scope;
                adminSetting = _extends({}, listAgentSetting[0], { emailFooter: emailFooter,
                  smsFooter: smsFooter, notificationScope: notificationScope
                });

                console.log(adminSetting);
                _this4.$store.dispatch('setAdminSetting', adminSetting);
                resolve(adminSetting);
                return _context4.abrupt("return");

              case 27:
                _this4.$store.dispatch('setAdminSetting', {});
                resolve(null);
                return _context4.abrupt("return");

              case 30:
                _this4.$store.dispatch('setAdminSetting', {});
                resolve(null);

              case 32:
              case "end":
                return _context4.stop();
            }
          }
        }, null, _this4);
      });
    },
    getShareableURL: function getShareableURL(user, isCandidate) {
      var _this5 = this;

      if (isCandidate == null) {
        isCandidate = user.is_candidate;
      }
      return new Promise(function _callee5(resolve) {
        var hashId, res;
        return regeneratorRuntime.async(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!user) {
                  resolve("");
                }
                hashId = user.hash_id;

                if (hashId) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 5;
                return regeneratorRuntime.awrap(_axios2.default.post("/hash-num", { id: user.id }));

              case 5:
                res = _context5.sent;

                if (!(res == null || res.data == null)) {
                  _context5.next = 9;
                  break;
                }

                resolve("");
                return _context5.abrupt("return");

              case 9:
                hashId = res.data.key;

              case 10:
                resolve(_this5.rootUrl + "/" + (isCandidate ? 'candidates' : 'employers') + "/" + hashId);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, null, _this5);
      });
    },
    getShareableDocumentUrl: function getShareableDocumentUrl(user, documentId) {
      var hashId;
      return regeneratorRuntime.async(function getShareableDocumentUrl$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (user) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return", "");

            case 2:
              _context6.next = 4;
              return regeneratorRuntime.awrap(this.getUserHashId(user));

            case 4:
              hashId = _context6.sent;
              return _context6.abrupt("return", this.rootUrl + "/sign-document/" + documentId + "/" + hashId);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    },
    getMyCandidateShareableUrl: function getMyCandidateShareableUrl(userId) {
      var _this6 = this;

      return new Promise(function _callee6(resolve) {
        var hashId;
        return regeneratorRuntime.async(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return regeneratorRuntime.awrap(_this6.getHashId(userId));

              case 2:
                hashId = _context7.sent;

                if (hashId) {
                  _context7.next = 6;
                  break;
                }

                resolve('');
                return _context7.abrupt("return");

              case 6:
                resolve(_this6.rootUrl + "/public-candidates-section/" + hashId);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, null, _this6);
      });
    },
    getRecurringAvailabilityShareableUrl: function getRecurringAvailabilityShareableUrl(userId) {
      var _this7 = this;

      return new Promise(function _callee7(resolve) {
        var hashId;
        return regeneratorRuntime.async(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return regeneratorRuntime.awrap(_this7.getHashId(userId + 21));

              case 2:
                hashId = _context8.sent;

                if (hashId) {
                  _context8.next = 6;
                  break;
                }

                resolve('');
                return _context8.abrupt("return");

              case 6:
                resolve(_this7.rootUrl + "/public-recurring-availability/" + userId + "/" + hashId);

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, null, _this7);
      });
    },
    getUserHashId: function getUserHashId(user) {
      return regeneratorRuntime.async(function getUserHashId$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (user) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return", null);

            case 2:
              if (!user.hash_id) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt("return", user.hash_id);

            case 4:
              _context9.next = 6;
              return regeneratorRuntime.awrap(this.getHashId(user.id));

            case 6:
              return _context9.abrupt("return", _context9.sent);

            case 7:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    },
    getHashId: function getHashId(id) {
      var _this8 = this;

      return new Promise(function _callee8(resolve) {
        var res;
        return regeneratorRuntime.async(function _callee8$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return regeneratorRuntime.awrap(_axios2.default.post("/hash-num", {
                  id: id
                }));

              case 2:
                res = _context10.sent;

                if (!(res == null || res.data == null)) {
                  _context10.next = 6;
                  break;
                }

                resolve(null);
                return _context10.abrupt("return");

              case 6:
                resolve(res.data.key);

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, null, _this8);
      });
    },

    // Send request to get total remaining credit at current time
    getCurrentCreditValue: function getCurrentCreditValue(userId) {
      var _this9 = this;

      return new Promise(function _callee9(resolve, reject) {
        var res, result;
        return regeneratorRuntime.async(function _callee9$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return regeneratorRuntime.awrap(_axios2.default.get("/get-user-credit/?user=" + userId + "&check_usable_currently=true"));

              case 2:
                res = _context11.sent;
                result = 0;

                if (res && res.data && res.data.credits && res.data.credits.length) {
                  result = _this9.calculateSumOfProperty(res.data.credits, 'value');
                }
                resolve(result);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, null, _this9);
      });
    },
    addCredits: function addCredits(user, creditNumber, note) {
      var _this10 = this;

      return regeneratorRuntime.async(function addCredits$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise(function _callee10(resolve) {
                return regeneratorRuntime.async(function _callee10$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.post('/add-user-credit/', {
                          user: user.id,
                          user_name: user.first_name + " " + user.last_name,
                          value: Number(creditNumber),
                          notes: note,
                          agency_owner: _this10.$store.getters.agencyName,
                          agency: _this10.$store.getters.agencyID
                        }));

                      case 2:
                        resolve();

                      case 3:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, null, _this10);
              }));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    },
    removeCredits: function removeCredits(user, creditNumber) {
      var _this11 = this;

      return regeneratorRuntime.async(function removeCredits$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", new Promise(function _callee11(resolve) {
                return regeneratorRuntime.async(function _callee11$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.post('/remove-user-credit/', {
                          user: user.id,
                          user_name: user.first_name + " " + user.last_name,
                          value: Number(creditNumber),
                          agency_owner: _this11.$store.getters.agencyName,
                          agency: _this11.$store.getters.agencyID
                        }));

                      case 2:
                        resolve();

                      case 3:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, null, _this11);
              }));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, null, this);
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _urlParams = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lecture 346
_vue2.default.mixin({
  computed: {
    auth: function auth() {
      // Lecture 363
      //
      // Check if someone is logged in
      //
      return this.$store.getters.isAuthenticated;
    },
    isAdminOrEmployer: function isAdminOrEmployer() {
      return this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true;
    }
  },
  methods: {
    logout: function logout() {
      this.$store.dispatch("logout");
    },
    handleLogin: function handleLogin(authData) {
      var hide_error, requestBody, res, info, agencyID, agencyName;
      return regeneratorRuntime.async(function handleLogin$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Reset some lists (in case user login for user of another agency)
              this.$store.dispatch("setPriceList", null, { root: true });
              this.$store.dispatch("setAvailabilities", null, { root: true });
              this.$store.dispatch("setWeekAvailabilities", null, { root: true });
              this.$store.dispatch("setCandidateListMainInfo", null, { root: true });
              hide_error = authData.hide_error ? true : false;
              requestBody = {
                username: authData.email,
                password: authData.password,
                // agency: state.agencyID,
                agency: authData.agency,
                force: authData.force
              };
              _context.next = 8;
              return regeneratorRuntime.awrap(_axios2.default.post("/v1/api-token-auth/?" + _urlParams.PARAM_LOGIN + "&" + _urlParams.PARAM_HIDE_ERROR_MODAL + "=" + hide_error, requestBody));

            case 8:
              res = _context.sent;

              if (!(res && res.data && res.data.user_list && res.data.user_list.length > 1)) {
                _context.next = 19;
                break;
              }

              _context.next = 12;
              return regeneratorRuntime.awrap(this.showInputDialogSync({
                title: "Please select user type",
                listFields: [{
                  label: "Please select which side do you want to use",
                  type: _customDefineType.FORM_TYPE.RADIO,
                  optionList: ["Candidate", "Client"],
                  model: "type"
                }],
                submitLabel: "Login"
              }));

            case 12:
              info = _context.sent;

              if (!(info && info.type)) {
                _context.next = 19;
                break;
              }

              requestBody.is_candidate = info.type === "Candidate";
              requestBody.is_employer = info.type === "Client";
              _context.next = 18;
              return regeneratorRuntime.awrap(_axios2.default.post("/v1/api-token-auth/?" + _urlParams.PARAM_LOGIN + "&" + _urlParams.PARAM_HIDE_ERROR_MODAL + "=" + hide_error, requestBody));

            case 18:
              res = _context.sent;

            case 19:
              if (res) {
                _context.next = 21;
                break;
              }

              return _context.abrupt("return", "failed");

            case 21:
              if (!(res.response && res.response.status == 409)) {
                _context.next = 23;
                break;
              }

              return _context.abrupt("return", "multi-login");

            case 23:

              // In case user just created, it response default agencyID, we need to load old agency
              agencyID = res.data.agency_list[0].agency_id;
              agencyName = res.data.agency_list[0].agency_name;

              if (agencyID === 1 && state.agencyID) {
                agencyID = state.agencyID;
              }
              this.$store.dispatch('saveAuthUser', {
                token: res.data.token,
                user_id: res.data.user_id,
                is_agent: res.data.is_agent,
                is_candidate: res.data.is_candidate,
                is_employer: res.data.is_employer,
                agency_id: agencyID,
                agency_name: agencyName,
                email: res.data.email,
                category: res.data.category
              });
              this.$store.dispatch("loadRecentAccessLog");

              if (res.data.agency_id != 1) {
                // The agency ID is 1 when doing the login on registration, because the agency ID hasn't been set yet
                this.$store.dispatch("increaseReloadAgencyReqNumber", 1); // Load agency data
              }
              return _context.abrupt("return", "success");

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    },
    dashboardRedirect: function dashboardRedirect() {
      //
      // Redirect a logged in user to their appropriate dashboard page
      //
      if (this.$store.getters.isAgent) {
        var redirectObj = { name: "Agent Dashboard" };
        var defaultSelector = null;
        if (this.$store.getters.adminCategory == 'community') {
          defaultSelector = "Community";
        } else if (this.$store.getters.adminCategory == 'reference checker') {
          defaultSelector = "References";
        } else if (this.$store.getters.adminCategory == 'event manager') {
          defaultSelector = "Events";
        } else if (this.$store.getters.adminCategory == 'candidate supplier') {
          defaultSelector = "Candidates";
        } else if (this.$store.getters.adminCategory == 'client supplier') {
          defaultSelector = "Clients";
        }
        if (defaultSelector) {
          redirectObj.query = { selector: defaultSelector };
        }
        console.log(redirectObj);
        this.$router.replace(redirectObj);
      } else if (this.$store.getters.isCandidate) {
        this.$router.replace({ name: "Candidate Dashboard" });
      } else if (this.$store.getters.isEmployer) {
        this.$router.replace({ name: "Employer Dashboard" });
      }
    }
  }
});

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _dateAndTime = __webpack_require__(808);

var _dateAndTime2 = _interopRequireDefault(_dateAndTime);

var _datetimeHandling = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dateAndTime2.default.extend({
  parser: {
    YY: function YY(str) {
      var result = this.exec(/^\d{1,2}/, str);
      result.value += result.value < 70 ? 2000 : result.value < 100 ? 1900 : 0;
      return result;
    }
  }
});

_vue2.default.mixin({
  data: function data() {
    return {
      dateInDjangoFormat: _datetimeHandling.dateInDjangoFormat,
      getPreviousDate: _datetimeHandling.getPreviousDate,
      getPreviousYear: _datetimeHandling.getPreviousYear,
      getDayMonthFromDate: _datetimeHandling.getDayMonthFromDate,
      addDaysToDate: _datetimeHandling.addDaysToDate
    };
  },

  computed: {
    todayDjangoFormat: function todayDjangoFormat() {
      // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      var today = new Date();
      return today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + today.getDate().toString()).slice(-2);
    },
    todayDatetimeDjangoFormat: function todayDatetimeDjangoFormat() {
      // Want to get today's date in the YYYY-MM-DD format for comparison with django dates
      var today = new Date();
      return today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + today.getDate().toString()).slice(-2) + "T" + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    }
  },
  methods: {
    getDateString: function getDateString(date) {
      if (!date) {
        return '';
      }
      var dateObj = this.addCurrentTimeToDate(date);
      var result = dateObj.toLocaleString(this.$store.getters.languageLocal, { month: 'short', year: 'numeric', weekday: 'short', day: '2-digit' });
      if (!result) {
        return dateObj.toDateString();
      }
      return this.replaceAllText(this.capitalizeFirstLetter(result), ', ', ' ');
    },
    getDateTimeString: function getDateTimeString(input) {
      var dateObj = new Date(input);
      return dateObj.toDateString() + ' at ' + dateObj.toLocaleTimeString();
    },
    compressDateFormat: function compressDateFormat(date) {
      var dateObject = this.addCurrentTimeToDate(date);
      var day = dateObject.getDate();
      var month = dateObject.getMonth() + 1;
      return month + "/" + day;
    },
    addCurrentTimeToDate: function addCurrentTimeToDate(date) {
      if ((typeof date === "undefined" ? "undefined" : _typeof(date)) === 'object') {
        return date;
      }
      var today = new Date();
      var hourNow = today.getHours();
      // https://stackoverflow.com/questions/18889548/javascript-change-gethours-to-2-digit
      // Need to make sure each of these values is 2 digits, otherwise it breaks the human date generation below
      hourNow = ("0" + hourNow).slice(-2);
      var minuteNow = today.getMinutes();
      minuteNow = ("0" + minuteNow).slice(-2);
      var secondNow = today.getMinutes();
      secondNow = ("0" + secondNow).slice(-2);

      return new Date(date.concat("T").concat(hourNow).concat(":").concat(minuteNow).concat(":").concat(secondNow));
    },
    convertTimeFormat: function convertTimeFormat(str) {
      //convert AM/PM to military time (ie. 19:00:00)
      var time = str;
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return sHours + ":" + sMinutes + ":00";
    },

    // https://stackoverflow.com/questions/8888491/how-do-you-display-javascript-datetime-in-12-hour-am-pm-format
    formatAMPM: function formatAMPM(date) {
      // Take a javascript date and spit out the time in AMPM format
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    djangotimeformatAMPM: function djangotimeformatAMPM(djangotime) {
      // Take a django 24 hour time and return it in AMPM format
      // console.log(djangotime)
      if (djangotime) {
        var hours = djangotime.split(":")[0];
        var minutes = djangotime.split(":")[1];
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        // minutes = minutes < 10 ? '0'+minutes : minutes; // minutes are already padded in django time
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      } else {
        return '';
      }
    },

    /*
    Input: 10:00:00 => Output: 10a
    Input: 10:30:00 => Output: 10:30a
    */
    compressTimeFormat: function compressTimeFormat(djangoTime) {
      var ampmFormat = this.djangotimeformatAMPM(djangoTime);
      if (!ampmFormat) {
        return '';
      }
      var result = ampmFormat;
      result = result.replace(':00', '');
      result = result.replace(' am', 'a');
      result = result.replace(' pm', 'p');
      return result;
    },

    // getAge(birthday) {
    //     var today = new Date();
    //     var birthDate = new Date(birthday);
    //     var age = today.getFullYear() - birthDate.getFullYear();
    //     var m = today.getMonth() - birthDate.getMonth();
    //     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    //     {
    //         age--;
    //     }
    //     return age;
    // },
    getAge: function getAge(birthday) {
      if (!birthday) {
        return "";
      }
      var today = new Date();
      var birthDate = new Date(birthday);

      if (birthDate > today) {
        return "Coming soon!";
      } else {
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
          // if we are in the same month as the birth month, need to check if the birthday has passed or not
          age--;
          m--; // This makes it say 11 months if we are in the birth month but before the birthday
        }
        if (m < 0) {
          m = 12 + m;
        }

        if (age >= 3) {
          return age + " years";
        } else if (age === 1) {
          return age + " year, " + m + " months";
        } else {
          return age + " years, " + m + " months";
        }
      }
    },
    getCompressedAge: function getCompressedAge(birthday) {
      var age = this.getAgeInYears(birthday);
      if (age < 0) {
        return "Coming soon!";
      }
      if (age >= 1) {
        return Math.floor(age) + 'yo';
      } else {
        return Math.round(age * 12) + 'mo';
      }
    },
    getAgeInYears: function getAgeInYears(birthday) {
      var today = new Date();
      var birthDate = new Date(birthday);

      if (birthDate > today) {
        // Don't need to care about exact number
        return -1;
      } else {
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
          // if we are in the same month as the birth month, need to check if the birthday has passed or not
          age--;
          m--; // This makes it say 11 months if we are in the birth month but before the birthday
        }
        if (m < 0) {
          m = 12 + m;
        }
        return age + m / 12;
      }
    },
    calculateAgeInMonthsAndYears: function calculateAgeInMonthsAndYears(birthDate) {
      var now = new Date();
      var bDate = new Date(birthDate);
      var diffInMilliseconds = now.getTime() - bDate.getTime();
      var diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365);
      if (diffInYears >= 0) {
        diffInYears = Math.floor(diffInYears);
      } else {
        diffInYears = Math.ceil(diffInYears);
      }
      var diffInMonths = Math.floor(diffInMilliseconds % (1000 * 60 * 60 * 24 * 365) / (1000 * 60 * 60 * 24 * 30));
      if (diffInYears === 0) {
        return diffInMonths + " months";
      }
      return diffInYears + " years, " + diffInMonths + " months";
    },
    convertTimeToAMPM: function convertTimeToAMPM(time) {
      var result = { mm: this.getNumberTwoDigits(time.mm) };
      result.A = time.HH >= 12 ? "PM" : "AM";
      if (time.HH >= 12) {
        if (time.HH === 12) {
          result.hh = "12";
        } else {
          result.hh = this.getNumberTwoDigits(time.HH - 12);
        }
        result.A = "PM";
      } else {
        if (time.HH === 0) {
          result.hh = "12";
        } else {
          result.hh = this.getNumberTwoDigits(time.HH);
        }
        result.A = "AM";
      }
      return result;
    },
    convertAMPMto24Format: function convertAMPMto24Format(time) {
      var result = { mm: this.getNumberTwoDigits(time.mm) };
      var hours = parseInt(time.hh);
      var AMPM = time.A;
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      result.HH = this.getNumberTwoDigits(hours);
      return result;
    },
    getNumberTwoDigits: function getNumberTwoDigits(num) {
      return ("0" + num).slice(-2);
    },
    revertTimeFromAMPM: function revertTimeFromAMPM(time) {
      if (!time) {
        return null;
      }
      if (time.A == null || time.hh == null || time.mm == null) {
        return null;
      }
      var result = { HH: Number(time.hh), mm: Number(time.mm) };
      if (time.A === "AM") {
        if (Number(time.hh) === 12) {
          result.HH = 0;
        }
      } else {
        if (Number(time.hh) === 12) {
          result.HH = 12;
        } else {
          result.HH = result.HH + 12;
        }
      }
      return result;
    },
    getTimeString: function getTimeString(timeAMPM) {
      if (!timeAMPM) {
        return null;
      }
      if (typeof timeAMPM === 'string') {
        if (timeAMPM.includes('AM') || timeAMPM.includes('PM')) {
          var timeAMPMObj = {
            A: timeAMPM.includes('AM') ? 'AM' : 'PM',
            hh: Number(timeAMPM.match(/^(\d+)/)[1])
          };
          var minutesMatch = timeAMPM.match(/:(\d+)/);
          if (minutesMatch && minutesMatch.length >= 2) {
            timeAMPMObj.mm = Number(minutesMatch[1]);
          } else {
            timeAMPMObj.mm = 0;
          }
          timeAMPM = timeAMPMObj;
        } else {
          return timeAMPM;
        }
      }
      var time = this.revertTimeFromAMPM(timeAMPM);
      if (!time) {
        return null;
      }
      return this.getNumberTwoDigits(time.HH) + ":" + this.getNumberTwoDigits(time.mm) + ":00";
    },
    getCurrentTimeString: function getCurrentTimeString() {
      var now = new Date();
      return this.getNumberTwoDigits(now.getHours()) + ":" + this.getNumberTwoDigits(now.getMinutes()) + ":00";
    },
    getTimeStringFromDateTime: function getTimeStringFromDateTime(date) {
      return this.getNumberTwoDigits(date.getHours()) + ":" + this.getNumberTwoDigits(date.getMinutes()) + ":00";
    },
    getTimeFromString: function getTimeFromString(timeString) {
      if (!timeString) {
        return null;
      }
      var tokens = timeString.split(":");
      return this.convertTimeToAMPM({
        HH: Number(tokens[0]),
        mm: Number(tokens[1])
      });
    },
    convertTimeStringToStringAMPM: function convertTimeStringToStringAMPM(timeString) {
      if (!timeString) {
        return null;
      }
      if (typeof timeString === 'string') {
        if (timeString.includes('AM') || timeString.includes('PM')) {
          return timeString;
        }
      }
      var timeAMPM = this.getTimeFromString(timeString);
      return this.convertTimeAMPMToString(timeAMPM);
    },
    convertTimeAMPMToString: function convertTimeAMPMToString(timeAMPM) {
      if (!timeAMPM) {
        return null;
      }
      if (typeof timeAMPM === 'string') {
        return timeAMPM;
      }
      return timeAMPM.hh + ":" + timeAMPM.mm + " " + timeAMPM.A;
    },
    compareTime: function compareTime(time1, time2) {
      if (time1.HH > time2.HH) {
        return 1;
      } else if (time1.HH < time2.HH) {
        return -1;
      } else {
        if (time1.mm > time2.mm) {
          return 1;
        } else if (time1.mm < time2.mm) {
          return -1;
        }
        return 0;
      }
    },
    compareTimeAMPM: function compareTimeAMPM(timeAMPM1, timeAMPM2) {
      var time1 = this.revertTimeFromAMPM(timeAMPM1);
      var time2 = this.revertTimeFromAMPM(timeAMPM2);
      return this.compareTime(time1, time2);
    },
    compareDuration: function compareDuration(startDate, startTimeAMPM, endDate, endTimeAMPM, duration) {
      if (!startDate) {
        startDate = this.dateInDjangoFormat(new Date());
      }
      if (!endDate) {
        endDate = startDate;
      }
      var date1 = new Date(startDate);
      var date2 = new Date(endDate);
      // Validate startDate <= endDate
      if (date1 > date2) {
        return -3;
      }
      // Undefined start time or end time
      if (!startTimeAMPM || !endTimeAMPM) {
        return 0;
      }
      var startTime = startTimeAMPM;
      var endTime = endTimeAMPM;
      if ((typeof startTime === "undefined" ? "undefined" : _typeof(startTime)) === "object") {
        startTime = this.getTimeString(startTimeAMPM);
        endTime = this.getTimeString(endTimeAMPM);
      }
      var startTimestamp = new Date(startDate + "T" + startTime).getTime();
      var endTimestamp = new Date(endDate + "T" + endTime).getTime();
      var diff = (endTimestamp - startTimestamp) / 3600000; // Diff in hour
      // Validate starTimestamp <= endTimestamp
      if (startTimestamp > endTimestamp) {
        return -2;
      }
      if (diff < duration) {
        return -1;
      }
      return diff;
    },

    // Calculate duration (from startDate-startTime to endDate-endTime)
    // limitDuration = true => limit booking duration <= 24 hours
    calculateDuration: function calculateDuration(startDate, startTime, endDate, endTime, breakInfo) {
      var limitDuration = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      if (!startDate) {
        startDate = this.dateInDjangoFormat(new Date());
      }
      startDate = this.dateInDjangoFormat(startDate);
      if (startTime) {
        startTime = this.getTimeString(startTime);
      }
      if (endTime) {
        endTime = this.getTimeString(endTime);
      }
      if (limitDuration) {
        if (startTime === endTime) {
          if (endDate && this.dateInDjangoFormat(endDate) === this.getNextDate(startDate)) {
            // 24 hours
            return 24;
          } else {
            // 0 hours
            return 0;
          }
        }
        if (!startTime || !endTime) {
          return null;
        }
        // End date is calculated based on start date. It will prevent the case of incorrect end date of shift job
        endDate = startDate;
      } else {
        if (!endDate || endDate < startDate) {
          endDate = startDate;
        }
      }
      var startTimestamp = new Date(startDate + "T" + startTime).getTime();
      var endTimestamp = new Date(endDate + "T" + endTime).getTime();
      var diff = (endTimestamp - startTimestamp) / 3600000; // Diff in hour
      if (diff < 0) {
        // In this case, endDate is the day after startDate
        diff = diff + 24;
      }
      // Subtract break times
      if (breakInfo && breakInfo.length) {
        var breakDuration = this.calculateSumOfProperty(breakInfo, 'duration');
        diff = diff - breakDuration;
      }
      return diff;
    },
    calculateHoursFromNow: function calculateHoursFromNow(date, time) {
      var currentTimestamp = new Date().getTime();
      date = this.dateInDjangoFormat(date);
      if (!time) {
        time = "00:00:00";
      } else {
        time = this.getTimeString(time);
      }
      var targetTimestamp = new Date(date + "T" + time);
      return (targetTimestamp - currentTimestamp) / 3600000; // Diff in hour
    },
    sleep: function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    timeDeltaHours: function timeDeltaHours(startHour, startMinute, startAMPM, endHour, endMinute, endAMPM) {
      //
      // Used for computing the difference in hours between 2 AMPM times, useful to prevent scheduling time blocks below a length threshold
      //
      var startTime = parseInt(startHour);
      if (startTime == 12) {
        startTime -= 12;
      }
      // else {
      //   this.startHour -= 1
      // }
      if (startAMPM == 'PM') {
        // console.log(this.startHour)
        startTime += 12;
        // console.log(this.startHour)
      }
      startTime += parseInt(startMinute) / 60;

      var endTime = parseInt(endHour);
      if (endTime == 12) {
        endTime -= 12;
      }
      // else {
      //   this.endHour -= 1
      // }
      if (endAMPM == 'PM') {
        endTime += 12;
      }
      endTime += parseInt(endMinute) / 60;

      return endTime - startTime;
    },
    timeDelta24Hours: function timeDelta24Hours(startTime, endTime) {
      //
      // Used for computing the difference in hours between 2 HH:MM:SS times, useful to calculate the length of a shift job
      //
      var startHours = parseInt(startTime.split(':')[0]) + parseInt(startTime.split(':')[1]) / 60;
      var endHours = parseInt(endTime.split(':')[0]) + parseInt(endTime.split(':')[1]) / 60;

      return endHours - startHours;
    },
    combineTime: function combineTime(hour, minutes, ampm) {
      //
      // Used to combine the pieces of a time into an HH:MM:SS time
      //
      var HH = parseInt(hour);

      // This is to turn 12AM (midnight) into OO (don't have to worry about 12pm, because that will get fixed in the next step)
      if (HH == 12) {
        HH -= 12;
      }
      if (ampm == 'PM') {
        HH += 12;
      }
      HH = ("0" + HH.toString()).slice(-2); // If the hour is a single digit, this pads it with a 0

      return HH + ":" + minutes + ":00";
    },
    dateDayOfTheWeek: function dateDayOfTheWeek(date, capitalCase) {
      // send true as 2nd parameter to get capital case dayName
      // This returns the text name of the day of the week today (eg. monday)
      // Expects the date in javascript format (not django)
      // The purpose of this is for checking candidate availability against a job (see master calendar)
      var dayNum = date.getDay();
      // They start the days of the week from Sunday (as 0)
      dayNum = dayNum - 1; // Want to turn Monday into 0
      if (dayNum === -1) {
        dayNum = 6; // Need Sunday to be 6
      }

      var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

      return capitalCase ? days[dayNum] : days[dayNum].toLowerCase();
    },

    // Convert date time from local timezone to UTC
    convertTimeToUTC: function convertTimeToUTC(inputTime) {
      var date = new Date(inputTime);
      var utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      return utc.getFullYear().toString() + "-" + ("0" + (utc.getMonth() + 1).toString()).slice(-2) + "-" + ("0" + utc.getDate().toString()).slice(-2) + "T" + ("0" + utc.getHours().toString()).slice(-2) + ":" + ("0" + utc.getMinutes().toString()).slice(-2) + ":" + ("0" + utc.getSeconds().toString()).slice(-2);
    },
    convertEventToLocalTime: function convertEventToLocalTime(event) {
      if (event.is_convert_datetime) {
        return new Date(event.datetime);
      } else {
        return this.convertUTCToLocalTime(event.datetime);
      }
    },
    convertUTCToLocalTime: function convertUTCToLocalTime(inputTime) {
      if (!inputTime) {
        return null;
      }
      // Check to remove last -04:00
      var tokens = inputTime.split('-');
      if (tokens.length >= 4) {
        inputTime = tokens[0] + '-' + tokens[1] + '-' + tokens[2];
      }
      if (inputTime.endsWith('Z')) {
        return new Date(inputTime);
      }
      return new Date(inputTime + 'Z');
    },

    // Calculate diff in years between two date
    calculateDiffYears: function calculateDiffYears(startDateString, endDateString) {
      var startDate = new Date(startDateString);
      var endDate = new Date(endDateString);
      var diffMonth = endDate.getFullYear() * 12 + endDate.getMonth() - (startDate.getFullYear() * 12 + startDate.getMonth());
      return Math.round(diffMonth / 12);
    },

    // Calculate diff time (input format: AMPM)
    calculateDiffTime: function calculateDiffTime(startTimeAMPM, endTimeAMPM) {
      if (!startTimeAMPM.hh || !startTimeAMPM.mm || !startTimeAMPM.A) {
        return null;
      }
      if (!endTimeAMPM.hh || !endTimeAMPM.mm || !endTimeAMPM.A) {
        return null;
      }
      var startTime = this.revertTimeFromAMPM(startTimeAMPM);
      var endTime = this.revertTimeFromAMPM(endTimeAMPM);
      var diffMinutes = endTime.HH * 60 + endTime.mm - (startTime.HH * 60 + startTime.mm);
      if (diffMinutes < 0) {
        return "---";
      }
      var hours = Math.floor(diffMinutes / 60);
      var minutes = diffMinutes % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return hours + ":" + minutes;
    },

    // Compare endTime - startTime with a number of hours (for example: 2 hours) - delta
    // Return
    //  null: missing information
    //  -1: startTime > endTime
    //  0: valid (endTime - startTime >= delta)
    // 1: invalid (endTime - startTime < delta)
    compareDiffTimeWithHours: function compareDiffTimeWithHours(startTimeAMPM, endTimeAMPM, delta) {
      if (!startTimeAMPM || !endTimeAMPM) {
        return null;
      }
      if (!startTimeAMPM.hh || !startTimeAMPM.mm || !startTimeAMPM.A) {
        return null;
      }
      if (!endTimeAMPM.hh || !endTimeAMPM.mm || !endTimeAMPM.A) {
        return null;
      }
      var startTime = this.revertTimeFromAMPM(startTimeAMPM);
      var endTime = this.revertTimeFromAMPM(endTimeAMPM);
      if (endTime.HH === 0 && endTime.mm === 0) {
        // In case 12pm of next day
        endTime.HH = 24;
      }
      var diffMinutes = endTime.HH * 60 + endTime.mm - (startTime.HH * 60 + startTime.mm);
      if (diffMinutes < 0) {
        return -1;
      }
      var hours = Math.floor(diffMinutes / 60);
      return hours >= delta ? 0 : 1;
    },
    getYearFromDate: function getYearFromDate(date) {
      if (date == null) {
        return null;
      }
      if (typeof date === 'string') {
        return date.split('-')[0];
      }
      return new Date(date).getFullYear();
    },
    convertTimeToInHours: function convertTimeToInHours(time) {
      if (!time) {
        return null;
      }
      return parseInt(time.split(":")[0]) + parseInt(time.split(":")[1]) / 60;
    },
    calculateDiffTimeInHours: function calculateDiffTimeInHours(time1, time2) {
      var inHours1 = this.convertTimeToInHours(time1);
      var inHours2 = this.convertTimeToInHours(time2);
      return inHours2 - inHours1;
    },

    // Check if the time range specified by [startTime1, endTime1] is overlap with time specified between 2 hour parameters
    isTimeRangeOverlap: function isTimeRangeOverlap(startTime1, endTime1, startTime2, endTime2) {
      // Convert from time to 'inHours'
      var startInHours1 = this.convertTimeToInHours(startTime1);
      var endInHours1 = this.convertTimeToInHours(endTime1);
      var startInHours2 = this.convertTimeToInHours(startTime2);
      var endInHours2 = this.convertTimeToInHours(endTime2);

      // If the start time or end time of either job falls within the time range of the other job, there is a conflict
      if (startInHours1 >= startInHours2 && startInHours1 <= endInHours2 || endInHours1 >= startInHours2 && endInHours1 <= endInHours2 || startInHours2 >= startInHours1 && startInHours2 <= endInHours1 || endInHours2 >= startInHours1 && endInHours2 <= endInHours1) {
        return true;
      }
      return false;
    },

    /*
    Check if time specified by checkDate-checkTime is in range which is specified by startDate-startTime and endDate-endTime
    */
    isTimeInRange: function isTimeInRange(startDate, startTime, endDate, endTime, checkDate, checkTime) {
      var time1 = new Date(startDate + "T" + this.getTimeString(startTime)).getTime();
      var time2 = new Date(endDate + "T" + this.getTimeString(endTime)).getTime();
      var time3 = new Date(checkDate + "T" + this.getTimeString(checkTime)).getTime();
      if (time1 <= time3 && time3 <= time2) {
        return true;
      }
      return false;
    },

    /*
    Split time range to find ranges between time1, time2
    */
    splitTimeRanges: function splitTimeRanges(startDate, startTime, endDate, endTime, time1, time2) {
      var time1String = this.getTimeString(time1);
      var time2String = this.getTimeString(time2);
      // Get list dates between startDate and endDate
      var listDates = this.getDatesInRange(startDate, endDate);
      var listPivot = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = listDates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var date = _step.value;

          if (this.isTimeInRange(startDate, startTime, endDate, endTime, date, time1)) {
            listPivot.push(date + "T" + this.getTimeString(time1));
          }
          if (this.isTimeInRange(startDate, startTime, endDate, endTime, date, time2)) {
            listPivot.push(date + "T" + this.getTimeString(time2));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!listPivot.includes(startDate + "T" + this.getTimeString(startTime))) {
        listPivot.push(startDate + "T" + this.getTimeString(startTime));
      }
      if (!listPivot.includes(endDate + "T" + this.getTimeString(endTime))) {
        listPivot.push(endDate + "T" + this.getTimeString(endTime));
      }
      listPivot.sort(function (date1, date2) {
        return date1 < date2 ? -1 : 1;
      });
      var listRanges = [];
      for (var index = 0; index < listPivot.length - 1; index++) {
        listRanges.push([listPivot[index], listPivot[index + 1]]);
      }
      var listValidRange = [];
      if (listRanges.length === 1) {
        // There is only one range, which is specified by start date - start time and end date - end time
        var start = listRanges[0][0];
        var end = listRanges[0][1];
        if (start.includes(time1String) && end.includes(time2String)) {
          listValidRange.push(listRanges[0]);
        }
      } else {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = listRanges[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var range = _step2.value;

            var _start = range[0];
            var _end = range[1];
            if (_start.includes(time2String) || _end.includes(time1String)) {
              continue;
            }
            listValidRange.push(range);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      return listValidRange;
    },

    // Get dates between startDate and endDate
    getDatesInRange: function getDatesInRange(startDate, endDate) {
      var excludeWeekends = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var result = [];
      if (!startDate || !endDate) {
        return [];
      }
      var currentDate = startDate;
      while (currentDate <= endDate) {
        if (excludeWeekends) {
          var dateObj = new Date(this.addCurrentTimeToDate(currentDate));
          var dayOfWeek = dateObj.getDay();
          if (dayOfWeek > 0 && dayOfWeek < 6) {
            result.push(currentDate);
          }
        } else {
          result.push(currentDate);
        }
        currentDate = this.getNextDate(currentDate);
      }
      return result;
    },
    getNextDate: function getNextDate(startDate) {
      var date = void 0;
      if ((typeof startDate === "undefined" ? "undefined" : _typeof(startDate)) === 'object') {
        date = new Date(startDate.getTime());
      } else {
        if (startDate.includes(':')) {
          date = new Date(startDate);
        } else {
          date = new Date(startDate + 'T00:00:00');
        }
      }
      date.setDate(date.getDate() + 1);
      return this.dateInDjangoFormat(date);
    },
    getDateAfterDays: function getDateAfterDays(startDate, numberOfDay) {
      var date = void 0;
      if ((typeof startDate === "undefined" ? "undefined" : _typeof(startDate)) === 'object') {
        date = new Date(startDate.getTime());
      } else {
        if (startDate.includes(':')) {
          date = new Date(startDate);
        } else {
          date = new Date(startDate + 'T00:00:00');
        }
      }
      date.setDate(date.getDate() + numberOfDay);
      return this.dateInDjangoFormat(date);
    },

    // Format of startTime, endTime: date + 'T' + time
    calculateDurationInHours: function calculateDurationInHours(startTime, endTime) {
      var time1 = new Date(startTime).getTime();
      var time2 = new Date(endTime).getTime();
      return (time2 - time1) / 3600000; // Diff in hour
    },
    calculateSecondDiffBetweenDates: function calculateSecondDiffBetweenDates(date1, date2) {
      var diff = date2.getTime() - date1.getTime();
      var seconds = Math.round(diff / 1000);
      return seconds;
    },
    calculateReadableSecondDiff: function calculateReadableSecondDiff(seconds) {
      var minutes = seconds / 60;
      var result = void 0;
      if (minutes >= 1) {
        minutes = Math.floor(minutes);
        var hours = minutes / 60;
        if (hours >= 1) {
          hours = Math.floor(hours);
          var days = hours / 24;
          if (days >= 1) {
            days = Math.floor(days);
            result = days + " days, " + hours % 24 + " hours";
          } else {
            result = hours + " hours, " + minutes % 60 + " minutes";
          }
        } else {
          result = minutes + " minutes, " + seconds % 60 + " seconds";
        }
      } else {
        result = seconds + " seconds";
      }
      // Handle singular word
      var tokens = result.split(',');
      var correctedTokens = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = tokens[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var token = _step3.value;

          var correctedToken = token.trim();
          if (correctedToken.startsWith('0 ')) {
            continue;
          }
          if (correctedToken.startsWith('1 ')) {
            // Remove ending s
            correctedToken = correctedToken.slice(0, -1);
          }
          correctedTokens.push(correctedToken);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return correctedTokens.join(', ');
    },

    // Input: yyyy-MM-dd, example: 2020-10-30
    // Output: MMM yyyy, example: Oct 2020
    getDisplayMonthYear: function getDisplayMonthYear(dateString) {
      var tokens = dateString.split("-");
      if (tokens.length < 2) {
        return dateString;
      }
      var monthShort = this.$store.getters.months.find(function (month) {
        return month.number === tokens[1];
      }).short;
      return monthShort + " " + tokens[0];
    },
    getDisplayMonthDay: function getDisplayMonthDay(dateString) {
      if (!dateString) {
        return "";
      }
      var tokens = dateString.split("-");
      if (tokens.length < 3) {
        return dateString;
      }
      var monthShort = this.$store.getters.months.find(function (month) {
        return month.number === tokens[1];
      }).short;
      return monthShort + " " + tokens[2];
    },
    getDisplayMonthDayYear: function getDisplayMonthDayYear(dateString) {
      if (!dateString) {
        return "";
      }
      var tokens = dateString.split("-");
      if (tokens.length < 3) {
        return dateString;
      }
      var monthShort = this.$store.getters.months.find(function (month) {
        return month.number === tokens[1];
      }).short;
      var day = tokens[2];
      var ordinal = this.getOrdinal(day);
      return monthShort + " " + day + ordinal + ", " + tokens[0];
    },
    getOrdinal: function getOrdinal(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },

    // Check if inputDate is in the past
    isPastDate: function isPastDate(inputDate) {
      if (!inputDate) {
        return null;
      }
      var date = new Date(inputDate + "T23:59:59");
      return date < new Date();
    },
    isTimeFilled: function isTimeFilled(time) {
      return time && time.hh && time.mm && time.A;
    },
    getDayOfWeek: function getDayOfWeek(date) {
      if (typeof date === 'string') {
        if (date.includes('T')) {
          date = new Date(date);
        } else {
          date = new Date(this.addCurrentTimeToDate(date));
        }
      }

      var dayNum = date.getDay(); // https://www.w3schools.com/jsref/jsref_getday.asp
      // Javscript starts the days of the week from Sunday (as 0)
      dayNum = dayNum - 1; // Want to turn Monday into 0
      if (dayNum === -1) {
        dayNum = 6; // Need Sunday to be 6
      }

      return this.$store.getters.days[dayNum].toLowerCase();
    },
    addTimeToDate: function addTimeToDate(date) {
      if (!date) {
        return null;
      }
      if ((typeof date === "undefined" ? "undefined" : _typeof(date)) === 'object') {
        return date;
      }
      if (date.includes('T')) {
        return new Date(date);
      }
      return new Date(date + "T00:00:00");
    },
    isAllDayBlock: function isAllDayBlock(startTime, endTime) {
      return startTime === '00:00:00' && endTime === '23:59:59';
    },
    convertDate: function convertDate(input, fromFormat, toFormat) {
      if (!input || !input.trim()) {
        return null;
      }
      if (!fromFormat || !toFormat) {
        return input;
      }
      try {
        var date = _dateAndTime2.default.parse(input, fromFormat);
        return _dateAndTime2.default.format(date, toFormat);
      } catch (e) {
        return input;
      }
    },

    // Check if date is between startDate and startDate + duration (duration is in months)
    isDateInRange: function isDateInRange(date, startDate, numberOfMonth) {
      var dateStr = this.dateInDjangoFormat(this.addTimeToDate(date));
      var startDateObj = this.addTimeToDate(startDate);
      var startDateStr = this.dateInDjangoFormat(startDateObj);
      if (dateStr < startDateStr) {
        return false;
      }
      var endDateObj = this.addMonthsToDate(numberOfMonth, startDateObj);
      var endDateStr = this.dateInDjangoFormat(endDateObj);
      return dateStr <= endDateStr;
    },
    addMonthsToDate: function addMonthsToDate(numberOfMonth, date) {
      if (!date) {
        date = new Date();
      } else {
        date = new Date(date.getTime());
      }
      // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
      date = date.setMonth(date.getMonth() + numberOfMonth); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
      return new Date(date);
    },

    // Split date by week, month or year
    // For example: [2022-01-01, 2022-02-01], [2022-02-01, 2022-03-01]
    // Unit: Week, Month, Year
    splitDateRange: function splitDateRange(startDate, numberOfMonth) {
      var startDateObj = this.addTimeToDate(startDate);
      var startDateStr = this.dateInDjangoFormat(startDateObj);
      var endDateObj = this.addMonthsToDate(numberOfMonth, startDateObj);
      var endDateStr = this.dateInDjangoFormat(endDateObj);
      var listPivot = [startDateStr];
      var pivot = this.addMonthsToDate(1, startDateObj);
      while (this.dateInDjangoFormat(pivot) < endDateStr) {
        listPivot.push(this.dateInDjangoFormat(pivot));
        pivot = this.addMonthsToDate(1, pivot);
      }
      listPivot.push(endDateStr);
      var result = [];
      for (var index = 0; index < listPivot.length - 1; index++) {
        result.push([listPivot[index], this.getPreviousDate(listPivot[index + 1])]);
      }
      return result;
    },
    subtractDateByHour: function subtractDateByHour(date, time, numberOfHours) {
      if (!time) {
        time = '00:00:00';
      }
      var dateObj = new Date(date + 'T' + time);
      var resultObj = new Date(dateObj.getTime() - Number(numberOfHours) * 3600000);
      return {
        date: this.dateInDjangoFormat(resultObj),
        time: this.getNumberTwoDigits(resultObj.getHours()) + ":" + this.getNumberTwoDigits(resultObj.getMinutes()) + ":" + this.getNumberTwoDigits(resultObj.getSeconds())
      };
    },
    addDateByHour: function addDateByHour(date, time, numberOfHours) {
      if (!time) {
        time = '00:00:00';
      }
      var dateObj = new Date(date + 'T' + time);
      var resultObj = new Date(dateObj.getTime() + Number(numberOfHours) * 3600000);
      return {
        date: this.dateInDjangoFormat(resultObj),
        time: this.getNumberTwoDigits(resultObj.getHours()) + ":" + this.getNumberTwoDigits(resultObj.getMinutes()) + ":" + this.getNumberTwoDigits(resultObj.getSeconds())
      };
    },
    getMonthsBetweenDates: function getMonthsBetweenDates(startDate, endDate) {
      var start = startDate.split('-');
      var end = endDate.split('-');
      var startYear = parseInt(start[0]);
      var endYear = parseInt(end[0]);
      var dates = [];

      for (var i = startYear; i <= endYear; i++) {
        var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
        var startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
        for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
          var month = j + 1;
          var displayMonth = month < 10 ? '0' + month : month;
          dates.push([i, displayMonth].join('-'));
        }
      }
      return dates;
    },
    getMonthYearFromDate: function getMonthYearFromDate(dateString) {
      var tokens = dateString.split('-');
      tokens.pop();
      return tokens.join('-');
    },
    getStartDayOfCurrentWeek: function getStartDayOfCurrentWeek(currentDate) {
      // This returns the Monday or Sunday (starting day) of the current week being viewed
      var startDate = new Date();
      if (currentDate) {
        startDate = new Date(currentDate.getTime());
      }
      // Need to put the days in order starting with the day of the week associated with the selected day
      var dayNum = startDate.getDay(); // https://www.w3schools.com/jsref/jsref_getday.asp
      if (this.$store.getters.startDayOfWeekCalendar === 1) {
        // They start the days of the week from Sunday (as 0)
        dayNum = dayNum - 1; // Want to turn Monday into 0
        if (dayNum === -1) {
          dayNum = 6; // Need Sunday to be 6
        }
      }

      // We want to subtract the number of days ahead of the current show date to bring us back to Monday
      // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
      // Start day of week is Monday
      startDate = startDate.setDate(startDate.getDate() - dayNum); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
      startDate = new Date(startDate);

      return startDate;
    },
    getEndDayOfCurrentWeek: function getEndDayOfCurrentWeek(currentDate) {
      // This returns the Sunday or Saturday (ending day) of the current week being viewed

      var endDate = new Date();
      if (currentDate) {
        endDate = new Date(currentDate.getTime());
      }

      // Need to put the days in order starting with the day of the week associated with the selected day
      var dayNum = endDate.getDay(); // https://www.w3schools.com/jsref/jsref_getday.asp
      // console.log(dayNum)
      // They start the days of the week from Sunday (as 0)
      if (this.$store.getters.startDayOfWeekCalendar === 1) {
        dayNum = dayNum - 1; // Want to turn Monday into 0
        if (dayNum === -1) {
          dayNum = 6; // Need Sunday to be 6
        }
      }

      // We want to add the number of days missing from the current show date to bring us forward to Sunday
      // https://stackoverflow.com/questions/3818193/how-to-add-number-of-days-to-todays-date
      // End day is Sunday
      endDate = endDate.setDate(endDate.getDate() + (6 - dayNum)); // https://stackoverflow.com/questions/11343939/how-to-add-weeks-to-date-using-javascript
      endDate = new Date(endDate);

      return endDate;
    },
    getDisplayTime: function getDisplayTime(timestamp) {
      var date = new Date(timestamp);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var time = hours + ":" + minutes + " " + ampm;
      // Check if it is today
      if (this.dateInDjangoFormat(date) === this.todayDjangoFormat) {
        return time;
      } else {
        return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(-2) + (" " + time);
      }
    },

    // Function to calculate the number of days between two dates
    getDaysBetweenDates: function getDaysBetweenDates(startDate, endDate) {
      var oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
      var start = new Date(startDate);
      var end = new Date(endDate);

      // Calculate the difference in days
      var diffDays = Math.round(Math.abs((start - end) / oneDay));

      return diffDays;
    }
  }
});

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return date$1; });
/**
 * @preserve date-and-time (c) KNOWLEDGECODE | MIT
 */

var locales = {},
    plugins = {},
    lang = 'en',
    _res = {
        MMMM: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        MMM: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        dddd: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        ddd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dd: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        A: ['AM', 'PM']
    },
    _formatter = {
        YYYY: function (d/*, formatString*/) { return ('000' + d.getFullYear()).slice(-4); },
        YY: function (d/*, formatString*/) { return ('0' + d.getFullYear()).slice(-2); },
        Y: function (d/*, formatString*/) { return '' + d.getFullYear(); },
        MMMM: function (d/*, formatString*/) { return this.res.MMMM[d.getMonth()]; },
        MMM: function (d/*, formatString*/) { return this.res.MMM[d.getMonth()]; },
        MM: function (d/*, formatString*/) { return ('0' + (d.getMonth() + 1)).slice(-2); },
        M: function (d/*, formatString*/) { return '' + (d.getMonth() + 1); },
        DD: function (d/*, formatString*/) { return ('0' + d.getDate()).slice(-2); },
        D: function (d/*, formatString*/) { return '' + d.getDate(); },
        HH: function (d/*, formatString*/) { return ('0' + d.getHours()).slice(-2); },
        H: function (d/*, formatString*/) { return '' + d.getHours(); },
        A: function (d/*, formatString*/) { return this.res.A[d.getHours() > 11 | 0]; },
        hh: function (d/*, formatString*/) { return ('0' + (d.getHours() % 12 || 12)).slice(-2); },
        h: function (d/*, formatString*/) { return '' + (d.getHours() % 12 || 12); },
        mm: function (d/*, formatString*/) { return ('0' + d.getMinutes()).slice(-2); },
        m: function (d/*, formatString*/) { return '' + d.getMinutes(); },
        ss: function (d/*, formatString*/) { return ('0' + d.getSeconds()).slice(-2); },
        s: function (d/*, formatString*/) { return '' + d.getSeconds(); },
        SSS: function (d/*, formatString*/) { return ('00' + d.getMilliseconds()).slice(-3); },
        SS: function (d/*, formatString*/) { return ('0' + (d.getMilliseconds() / 10 | 0)).slice(-2); },
        S: function (d/*, formatString*/) { return '' + (d.getMilliseconds() / 100 | 0); },
        dddd: function (d/*, formatString*/) { return this.res.dddd[d.getDay()]; },
        ddd: function (d/*, formatString*/) { return this.res.ddd[d.getDay()]; },
        dd: function (d/*, formatString*/) { return this.res.dd[d.getDay()]; },
        Z: function (d/*, formatString*/) {
            var offset = d.getTimezoneOffset() / 0.6 | 0;
            return (offset > 0 ? '-' : '+') + ('000' + Math.abs(offset - (offset % 100 * 0.4 | 0))).slice(-4);
        },
        post: function (str) { return str; },
        res: _res
    },
    _parser = {
        YYYY: function (str/*, formatString */) { return this.exec(/^\d{4}/, str); },
        Y: function (str/*, formatString */) { return this.exec(/^\d{1,4}/, str); },
        MMMM: function (str/*, formatString */) {
            var result = this.find(this.res.MMMM, str);
            result.value++;
            return result;
        },
        MMM: function (str/*, formatString */) {
            var result = this.find(this.res.MMM, str);
            result.value++;
            return result;
        },
        MM: function (str/*, formatString */) { return this.exec(/^\d\d/, str); },
        M: function (str/*, formatString */) { return this.exec(/^\d\d?/, str); },
        DD: function (str/*, formatString */) { return this.exec(/^\d\d/, str); },
        D: function (str/*, formatString */) { return this.exec(/^\d\d?/, str); },
        HH: function (str/*, formatString */) { return this.exec(/^\d\d/, str); },
        H: function (str/*, formatString */) { return this.exec(/^\d\d?/, str); },
        A: function (str/*, formatString */) { return this.find(this.res.A, str); },
        hh: function (str/*, formatString */) { return this.exec(/^\d\d/, str); },
        h: function (str/*, formatString */) { return this.exec(/^\d\d?/, str); },
        mm: function (str/*, formatString */) { return this.exec(/^\d\d/, str); },
        m: function (str/*, formatString */) { return this.exec(/^\d\d?/, str); },
        ss: function (str/*, formatString */) { return this.exec(/^\d\d/, str); },
        s: function (str/*, formatString */) { return this.exec(/^\d\d?/, str); },
        SSS: function (str/*, formatString */) { return this.exec(/^\d{1,3}/, str); },
        SS: function (str/*, formatString */) {
            var result = this.exec(/^\d\d?/, str);
            result.value *= 10;
            return result;
        },
        S: function (str/*, formatString */) {
            var result = this.exec(/^\d/, str);
            result.value *= 100;
            return result;
        },
        Z: function (str/*, formatString */) {
            var result = this.exec(/^[\+-]\d{2}[0-5]\d/, str);
            result.value = (result.value / 100 | 0) * -60 - result.value % 100;
            return result;
        },
        h12: function (h, a) { return (h === 12 ? 0 : h) + a * 12; },
        exec: function (re, str) {
            var result = (re.exec(str) || [''])[0];
            return { value: result | 0, length: result.length };
        },
        find: function (array, str) {
            var index = -1, length = 0;

            for (var i = 0, len = array.length, item; i < len; i++) {
                item = array[i];
                if (!str.indexOf(item) && item.length > length) {
                    index = i;
                    length = item.length;
                }
            }
            return { value: index, length: length };
        },
        pre: function (str) { return str; },
        res: _res
    },
    extend = function (base, props, override, res) {
        var obj = {}, key;

        for (key in base) {
            obj[key] = base[key];
        }
        for (key in props || {}) {
            if (!(!!override ^ !!obj[key])) {
                obj[key] = props[key];
            }
        }
        if (res) {
            obj.res = res;
        }
        return obj;
    },
    proto = {
        _formatter: _formatter,
        _parser: _parser
    },
    localized_proto,
    date;

/**
 * Compiling a format string
 * @param {string} formatString - a format string
 * @returns {Array.<string>} a compiled object
 */
proto.compile = function (formatString) {
    var re = /\[([^\[\]]|\[[^\[\]]*])*]|([A-Za-z])\2+|\.{3}|./g, keys, pattern = [formatString];

    while ((keys = re.exec(formatString))) {
        pattern[pattern.length] = keys[0];
    }
    return pattern;
};

/**
 * Formatting a Date and Time
 * @param {Date} dateObj - a Date object
 * @param {string|Array.<string>} arg - a format string or its compiled object
 * @param {boolean} [utc] - output as UTC
 * @returns {string} a formatted string
 */
proto.format = function (dateObj, arg, utc) {
    var ctx = this || date, pattern = typeof arg === 'string' ? ctx.compile(arg) : arg,
        offset = dateObj.getTimezoneOffset(),
        d = ctx.addMinutes(dateObj, utc ? offset : 0),
        formatter = ctx._formatter, str = '';

    d.getTimezoneOffset = function () { return utc ? 0 : offset; };
    for (var i = 1, len = pattern.length, token; i < len; i++) {
        token = pattern[i];
        str += formatter[token] ? formatter.post(formatter[token](d, pattern[0])) : token.replace(/\[(.*)]/, '$1');
    }
    return str;
};

/**
 * Pre-parsing a Date and Time string
 * @param {string} dateString - a date string
 * @param {string|Array.<string>} arg - a format string or its compiled object
 * @returns {Object} a date structure
 */
proto.preparse = function (dateString, arg) {
    var ctx = this || date, pattern = typeof arg === 'string' ? ctx.compile(arg) : arg,
        dt = { Y: 1970, M: 1, D: 1, H: 0, A: 0, h: 0, m: 0, s: 0, S: 0, Z: 0, _index: 0, _length: 0, _match: 0 },
        comment = /\[(.*)]/, parser = ctx._parser, offset = 0;

    dateString = parser.pre(dateString);
    for (var i = 1, len = pattern.length, token, result; i < len; i++) {
        token = pattern[i];
        if (parser[token]) {
            result = parser[token](dateString.slice(offset), pattern[0]);
            if (!result.length) {
                break;
            }
            offset += result.length;
            dt[result.token || token.charAt(0)] = result.value;
            dt._match++;
        } else if (token === dateString.charAt(offset) || token === ' ') {
            offset++;
        } else if (comment.test(token) && !dateString.slice(offset).indexOf(comment.exec(token)[1])) {
            offset += token.length - 2;
        } else if (token === '...') {
            offset = dateString.length;
            break;
        } else {
            break;
        }
    }
    dt.H = dt.H || parser.h12(dt.h, dt.A);
    dt._index = offset;
    dt._length = dateString.length;
    return dt;
};

/**
 * Parsing a Date and Time string
 * @param {string} dateString - a date string
 * @param {string|Array.<string>} arg - a format string or its compiled object
 * @param {boolean} [utc] - input as UTC
 * @returns {Date} a constructed date
 */
proto.parse = function (dateString, arg, utc) {
    var ctx = this || date, dt = ctx.preparse(dateString, arg);

    if (ctx.isValid(dt)) {
        dt.M -= dt.Y < 100 ? 22801 : 1; // 22801 = 1900 * 12 + 1
        if (utc || dt.Z) {
            return new Date(Date.UTC(dt.Y, dt.M, dt.D, dt.H, dt.m + dt.Z, dt.s, dt.S));
        }
        return new Date(dt.Y, dt.M, dt.D, dt.H, dt.m, dt.s, dt.S);
    }
    return new Date(NaN);
};

/**
 * Validation
 * @param {Object|string} arg1 - a date structure or a date string
 * @param {string|Array.<string>} [arg2] - a format string or its compiled object
 * @returns {boolean} whether the date string is a valid date
 */
proto.isValid = function (arg1, arg2) {
    var ctx = this || date, dt = typeof arg1 === 'string' ? ctx.preparse(arg1, arg2) : arg1,
        last = [31, 28 + ctx.isLeapYear(dt.Y) | 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][dt.M - 1];

    return !(
        dt._index < 1 || dt._length < 1 || dt._index - dt._length || dt._match < 1 ||
        dt.Y < 1 || dt.Y > 9999 || dt.M < 1 || dt.M > 12 || dt.D < 1 || dt.D > last ||
        dt.H < 0 || dt.H > 23 || dt.m < 0 || dt.m > 59 || dt.s < 0 || dt.s > 59 || dt.S < 0 || dt.S > 999 ||
        dt.Z < -720 || dt.Z > 840
    );
};

/**
 * Transforming a Date and Time string
 * @param {string} dateString - a date string
 * @param {string|Array.<string>} arg1 - a format string or its compiled object
 * @param {string|Array.<string>} arg2 - a transformed format string or its compiled object
 * @param {boolean} [utc] - output as UTC
 * @returns {string} a formatted string
 */
proto.transform = function (dateString, arg1, arg2, utc) {
    const ctx = this || date;
    return ctx.format(ctx.parse(dateString, arg1), arg2, utc);
};

/**
 * Adding years
 * @param {Date} dateObj - a date object
 * @param {number} years - number of years to add
 * @returns {Date} a date after adding the value
 */
proto.addYears = function (dateObj, years) {
    return (this || date).addMonths(dateObj, years * 12);
};

/**
 * Adding months
 * @param {Date} dateObj - a date object
 * @param {number} months - number of months to add
 * @returns {Date} a date after adding the value
 */
proto.addMonths = function (dateObj, months) {
    var d = new Date(dateObj.getTime());

    d.setMonth(d.getMonth() + months);
    return d;
};

/**
 * Adding days
 * @param {Date} dateObj - a date object
 * @param {number} days - number of days to add
 * @returns {Date} a date after adding the value
 */
proto.addDays = function (dateObj, days) {
    var d = new Date(dateObj.getTime());

    d.setDate(d.getDate() + days);
    return d;
};

/**
 * Adding hours
 * @param {Date} dateObj - a date object
 * @param {number} hours - number of hours to add
 * @returns {Date} a date after adding the value
 */
proto.addHours = function (dateObj, hours) {
    return (this || date).addMinutes(dateObj, hours * 60);
};

/**
 * Adding minutes
 * @param {Date} dateObj - a date object
 * @param {number} minutes - number of minutes to add
 * @returns {Date} a date after adding the value
 */
proto.addMinutes = function (dateObj, minutes) {
    return (this || date).addSeconds(dateObj, minutes * 60);
};

/**
 * Adding seconds
 * @param {Date} dateObj - a date object
 * @param {number} seconds - number of seconds to add
 * @returns {Date} a date after adding the value
 */
proto.addSeconds = function (dateObj, seconds) {
    return (this || date).addMilliseconds(dateObj, seconds * 1000);
};

/**
 * Adding milliseconds
 * @param {Date} dateObj - a date object
 * @param {number} milliseconds - number of milliseconds to add
 * @returns {Date} a date after adding the value
 */
proto.addMilliseconds = function (dateObj, milliseconds) {
    return new Date(dateObj.getTime() + milliseconds);
};

/**
 * Subtracting two dates
 * @param {Date} date1 - a Date object
 * @param {Date} date2 - a Date object
 * @returns {Object} a result object subtracting date2 from date1
 */
proto.subtract = function (date1, date2) {
    var delta = date1.getTime() - date2.getTime();

    return {
        toMilliseconds: function () {
            return delta;
        },
        toSeconds: function () {
            return delta / 1000;
        },
        toMinutes: function () {
            return delta / 60000;
        },
        toHours: function () {
            return delta / 3600000;
        },
        toDays: function () {
            return delta / 86400000;
        }
    };
};

/**
 * Whether year is leap year
 * @param {number} y - year
 * @returns {boolean} whether year is leap year
 */
proto.isLeapYear = function (y) {
    return (!(y % 4) && !!(y % 100)) || !(y % 400);
};

/**
 * Comparison of two dates
 * @param {Date} date1 - a Date object
 * @param {Date} date2 - a Date object
 * @returns {boolean} whether the two dates are the same day (time is ignored)
 */
proto.isSameDay = function (date1, date2) {
    return date1.toDateString() === date2.toDateString();
};

/**
 * Defining new locale
 * @param {string} code - language code
 * @param {Function} locale - locale installer
 * @returns {string} current language code
 */
proto.locale = function (code, locale) {
    if (!locales[code]) {
        locales[code] = locale;
    }
};

/**
 * Defining new plugin
 * @param {string} name - plugin name
 * @param {Function} plugin - plugin installer
 * @returns {void}
 */
proto.plugin = function (name, plugin) {
    if (!plugins[name]) {
        plugins[name] = plugin;
    }
};

localized_proto = extend(proto);
date = extend(proto);

/**
 * Changing locale
 * @param {Function|string} [locale] - locale object | language code
 * @returns {string} current language code
 */
date.locale = function (locale) {
    var install = typeof locale === 'function' ? locale : date.locale[locale];

    if (!install) {
        return lang;
    }
    lang = install(proto);

    var extension = locales[lang] || {};
    var res = extend(_res, extension.res, true);
    var formatter = extend(_formatter, extension.formatter, true, res);
    var parser = extend(_parser, extension.parser, true, res);

    date._formatter = localized_proto._formatter = formatter;
    date._parser = localized_proto._parser = parser;

    for (var plugin in plugins) {
        date.extend(plugins[plugin]);
    }

    return lang;
};

/**
 * Feature extension
 * @param {Object} extension - extension object
 * @returns {void}
 */
date.extend = function (extension) {
    var res = extend(date._parser.res, extension.res);
    var extender = extension.extender || {};

    date._formatter = extend(date._formatter, extension.formatter, false, res);
    date._parser = extend(date._parser, extension.parser, false, res);

    for (var key in extender) {
        if (!date[key]) {
            date[key] = extender[key];
        }
    }
};

/**
 * Importing plugin
 * @param {Function|string} plugin - plugin object | plugin name
 * @returns {void}
 */
date.plugin = function (plugin) {
    var install = typeof plugin === 'function' ? plugin : date.plugin[plugin];

    if (install) {
        date.extend(plugins[install(proto, localized_proto)] || {});
    }
};

var date$1 = date;




/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _pluralize = __webpack_require__(810);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _regex = __webpack_require__(46);

var _prefix = __webpack_require__(99);

var _separator = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
  methods: {
    // https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
    // Used for trying to seamlessly log people in with capitalized email addresses
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    convertToSingularForm: function convertToSingularForm(input) {
      if (!input) {
        return "";
      }
      return _pluralize2.default.singular(input);
    },
    convertToPluralForm: function convertToPluralForm(input) {
      if (!input) {
        return "";
      }
      return _pluralize2.default.plural(input);
    },

    // If input string ending by a number, remove that number
    removeLastNumberFromString: function removeLastNumberFromString(input) {
      var tokens = input.split(" ");
      if (isNaN(tokens[tokens.length - 1])) {
        return input;
      } else {
        tokens.pop();
        return tokens.join(" ");
      }
    },
    convertToAbsolutePath: function convertToAbsolutePath(path) {
      if (!path) {
        return "";
      }
      var prefix = "https://enginehireio-static-and-media8.s3.amazonaws.com/media/";
      if (path.indexOf("https://enginehireio-static-and-media") === 0) {
        return path;
      }
      return prefix + path;
    },
    convertToRelativePath: function convertToRelativePath(path) {
      if (!path) {
        return "";
      }
      if (path.indexOf("s3.amazonaws.com/media/user_upload_files/") > 0) {
        return path.split("s3.amazonaws.com/media/")[1];
      }
      if (path.indexOf("s3.amazonaws.com/media/files/") > 0) {
        return path.split("s3.amazonaws.com/media/")[1];
      }
      return path;
    },
    encodeSpecialCharsFileUrl: function encodeSpecialCharsFileUrl(inputStr) {
      var mapReplaced = {
        '+': '%2B',
        ',': '%2C',
        '@': '%40',
        '&': '%26',
        '$': '%24',
        '#': '%23'
      };
      return this.replaceAllByMap(inputStr, mapReplaced);
    },
    roundNumberTwoDigits: function roundNumberTwoDigits(input) {
      if (!input) {
        return input;
      }
      return Math.round(input * 100) / 100;
    },
    roundNumberOneDigits: function roundNumberOneDigits(input) {
      if (!input) {
        return input;
      }
      return Math.round(input * 10) / 10;
    },
    formatPrice: function formatPrice(value) {
      return this.roundNumberTwoDigits(Number(value)).toLocaleString('en-US');
    },

    /*
    Split an array into multiple chunks
    For example: 
      array: [a, b, c, d, e, f]
      numberOfChunk: 2
      ouput: [[a, b, c], [d, e, f]]
    */
    splitArrayIntoChunks: function splitArrayIntoChunks(array, numberOfChunk) {
      if (array == null) {
        return [];
      }
      var chunk = Math.ceil(array.length / numberOfChunk);
      var result = [];
      var i = void 0,
          j = void 0,
          temporary = void 0;
      for (i = 0, j = array.length; i < j; i += chunk) {
        temporary = array.slice(i, i + chunk);
        result.push(temporary);
      }
      return result;
    },

    // Name include: first name + last name
    // Output: Only show first character of last name
    hideLastName: function hideLastName(name) {
      var tokens = name.trim().split(/\s+/);
      var firstName = tokens[0];
      if (tokens.length > 1) {
        return firstName + " " + tokens[1][0].toUpperCase() + ".";
      } else {
        return firstName;
      }
    },
    getDisplayFileName: function getDisplayFileName(filePath) {
      var tokens = filePath.split("/");
      if (tokens.length) {
        return tokens[tokens.length - 1];
      }
    },

    // Extract content of html tag
    getHtmlText: function getHtmlText(htmlString) {
      var breakLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!htmlString) {
        return "";
      }
      if (breakLine) {
        var result = htmlString.replace(_regex.REGEX_REPLACE_HTML_TAG, '\n');
        return result;
      } else {
        return htmlString.replace(_regex.REGEX_REPLACE_HTML_TAG, '').trim();
      }
    },
    convertUnderscoreToLabel: function convertUnderscoreToLabel(input) {
      var _this = this;

      if (!input) {
        return "";
      }
      var tokens = input.split("_");
      return tokens.map(function (token) {
        return _this.capitalizeFirstLetter(token);
      }).join(' ');
    },
    getNumberFromString: function getNumberFromString(input) {
      if (!input) {
        return null;
      }
      var number = input.replace(/[^0-9\.]/g, '');
      if (number) {
        return Number(number);
      } else {
        return null;
      }
    },
    convertStringToBoolean: function convertStringToBoolean(input) {
      if (!input) {
        return null;
      }
      var lowerInput = input.trim().toLowerCase();
      if (lowerInput === 'yes') {
        return true;
      } else if (lowerInput === 'no') {
        return false;
      }
      return null;
    },
    removeOtherRadioPrefix: function removeOtherRadioPrefix(value) {
      if (typeof value === 'string' && value.indexOf(_prefix.RADIO_OTHER_OPTIONS_PREFIX) === 0) {
        return value.substring(_prefix.RADIO_OTHER_OPTIONS_PREFIX.length);
      }
      return value;
    },
    getDisplayTrigger: function getDisplayTrigger(template, type) {
      var isCandidate = template.selector1 === "Candidate" || template.selector3 === "Candidate";
      var isClient = template.selector1 === "Client" || template.selector3 === "Client";
      if (!isCandidate && !isClient) {
        return type;
      }
      if (["Status Change Notification", "Status Reminder"].includes(type)) {
        var labelStatus = isCandidate ? this.$store.getters.labelCandidateStatuses : this.$store.getters.labelEmployerStatuses;
        if (labelStatus) {
          return labelStatus + " " + type;
        }
        return type;
      }
      if (["Second Status Change Notification", "Second Status Reminder"].includes(type)) {
        var _labelStatus = isCandidate ? this.$store.getters.labelCandidateSecondStatuses : this.$store.getters.labelEmployerSecondStatuses;
        if (_labelStatus) {
          return "" + _labelStatus + type.replace("Second", "");
        }
        return type;
      }
      return type;
    },
    reverseString: function reverseString(str) {
      return str.split("").reverse().join("");
    },

    /*
    Ex:
    Input: +1234567890
    Format: (xxx) xxx xxx
    => Output: (234) 567 890
    */
    getDisplayPhone: function getDisplayPhone(phone) {
      var format = this.$store.getters.phoneDefaultFormat;
      if (!format || !phone) {
        return phone;
      }
      var mapReplacedVal = {
        ' ': '',
        '-': '',
        '(': '',
        ')': ''
      };
      var normalizedPhone = this.replaceAllByMap(phone, mapReplacedVal); //Remove all special characters
      var result = this.reverseString(format).toLowerCase();
      for (var index = normalizedPhone.length - 1; index >= 0; index--) {
        result = result.replace('x', normalizedPhone[index]);
      }
      return this.reverseString(result);
    },
    getClassListColLayout: function getClassListColLayout(itemPerRow) {
      if (itemPerRow === 0) {
        return "col";
      }
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    getDisplayDayHourSelector: function getDisplayDayHourSelector(value, listDays, field) {
      if (value == null || value.length === 0) {
        return [];
      }
      if (!listDays) {
        listDays = this.$store.getters.days;
      }
      // Convert list days from String to array
      var listWorkingDays = listDays.split("\n").map(function (option) {
        return option.trim();
      }).filter(function (option) {
        return option.length > 0;
      });
      var result = [];
      // Get string corresponding with each day with format Day: From To
      for (var index = 0; index < listWorkingDays.length; index++) {
        var timeValue = value[index];
        if (timeValue == null || timeValue.length === 0) {
          continue;
        }
        var timeTokens = void 0;
        if (timeValue.includes(_separator.TIME_FROM_TO_SEPARATOR)) {
          // New format (use with textbox)
          timeTokens = timeValue.split(_separator.TIME_FROM_TO_SEPARATOR);
        } else {
          // Old format (use with Timepicker)
          timeTokens = timeValue.split(",");
          if (timeTokens.length === 1) {
            timeTokens.push("");
          }
          timeTokens = timeTokens.slice(0, 2);
        }
        var mapReplacedValues = {
          ":AM": " AM",
          ":PM": " PM"
        };
        var timeFrom = timeTokens[0] ? this.replaceAllByMap(timeTokens[0], mapReplacedValues) : "";
        var timeTo = timeTokens[1] ? this.replaceAllByMap(timeTokens[1], mapReplacedValues) : "";
        var item = {
          day: listWorkingDays[index],
          from: timeFrom,
          to: timeTo
        };
        if (field) {
          if (field.hasTimeOff && timeTokens.length > 2) {
            item.timeOff = timeTokens[2];
          }
          if (field.hasNote) {
            if (field.hasTimeOff && timeTokens[3]) {
              item.note = timeTokens[3];
            } else if (timeTokens[2]) {
              item.note = timeTokens[2];
            }
          }
        }
        result.push(item);
      }
      return result;
    }
  }
});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (true) {
    // Node.
    module.exports = pluralize();
  } else if (typeof define === 'function' && define.amd) {
    // AMD, registers as an anonymous module.
    define(function () {
      return pluralize();
    });
  } else {
    // Browser global.
    root.pluralize = pluralize();
  }
})(this, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) return token;

    // Lower cased words. E.g. "hello".
    if (word === word.toLowerCase()) return token.toLowerCase();

    // Upper cased words. E.g. "WHISKY".
    if (word === word.toUpperCase()) return token.toUpperCase();

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */
  function replace (word, rule) {
    return word.replace(rule[0], function (match, index) {
      var result = interpolate(rule[1], arguments);

      if (match === '') {
        return restoreCase(word[index - 1], result);
      }

      return restoreCase(match, result);
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */
  function sanitizeWord (token, word, rules) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = rules.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = rules[len];

      if (rule[0].test(word)) return replace(word, rule);
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Check if a word is part of the map.
   */
  function checkWord (replaceMap, keepMap, rules, bool) {
    return function (word) {
      var token = word.toLowerCase();

      if (keepMap.hasOwnProperty(token)) return true;
      if (replaceMap.hasOwnProperty(token)) return false;

      return sanitizeWord(token, token, rules) === token;
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Check if a word is plural.
   *
   * @type {Function}
   */
  pluralize.isPlural = checkWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Check if a word is singular.
   *
   * @type {Function}
   */
  pluralize.isSingular = checkWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['passerby', 'passersby']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
    [/(test)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'adulthood',
    'advice',
    'agenda',
    'aid',
    'aircraft',
    'alcohol',
    'ammo',
    'analytics',
    'anime',
    'athletics',
    'audio',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'cod',
    'commerce',
    'cooperation',
    'corps',
    'debris',
    'diabetes',
    'digestion',
    'elk',
    'energy',
    'equipment',
    'excretion',
    'expertise',
    'firmware',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'hardware',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'mud',
    'manga',
    'news',
    'only',
    'personnel',
    'pike',
    'plankton',
    'pliers',
    'police',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'software',
    'species',
    'staff',
    'swine',
    'tennis',
    'traffic',
    'transportation',
    'trout',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    /pok[eé]mon$/i,
    // Regexes.
    /[^aeiou]ese$/i, // "chinese", "japanese"
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /measles$/i,
    /o[iu]s$/i, // "carnivorous"
    /pox$/i, // "chickpox", "smallpox"
    /sheep$/i
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
  methods: {
    formatContent: function formatContent(stringFormat) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return stringFormat.replace(/\{\{|\}\}|\{(\d+)\}/g, function (curlyBracket, index) {
        var replaceValue = args[index];
        if (replaceValue == null) {
          replaceValue = '';
        }
        return curlyBracket == "{{" ? "{" : curlyBracket == "}}" ? "}" : replaceValue;
      });
    },
    sendEmail: function sendEmail(_ref) {
      var _this = this;

      var subject = _ref.subject,
          message = _ref.message,
          file_urls = _ref.file_urls,
          recipients = _ref.recipients,
          from = _ref.from,
          cc = _ref.cc,
          bcc = _ref.bcc,
          reply = _ref.reply,
          userID = _ref.userID,
          isHtml = _ref.isHtml,
          type = _ref.type,
          referenceID = _ref.referenceID,
          status = _ref.status,
          countdown = _ref.countdown;

      if (recipients == null || recipients.length === 0) {
        return;
      }
      recipients = recipients.filter(function (recipient) {
        return recipient !== _this.$store.getters.enginehireLoggingEmail;
      });

      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var subjectString = this.formatContent.apply(this, [subject].concat(args));
      var messageString = this.formatContent.apply(this, [message].concat(args));
      // Find reply email
      var replyEmail = void 0;;
      if (reply && reply !== "aakash@enginehire.ca") {
        replyEmail = reply;
      } else if (from) {
        replyEmail = from;
      } else {
        replyEmail = this.$store.getters.agencyReplyEmail;
      }
      this.$store.dispatch("sendEmails", {
        subject: subjectString,
        message: messageString,
        file_urls: file_urls,
        from: from ? from : this.$store.getters.agencyFromEmail,
        cc: cc,
        bcc: bcc,
        emails: [].concat(_toConsumableArray(new Set(recipients))),
        reply: replyEmail,
        userID: userID ? userID : this.$store.getters.userID,
        html: isHtml,
        type: type,
        referenceID: referenceID,
        status: status,
        countdown: countdown
      });
    },
    sendEmailSync: function sendEmailSync(_ref2) {
      var _this2 = this;

      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      var subject = _ref2.subject,
          message = _ref2.message,
          file_urls = _ref2.file_urls,
          recipients = _ref2.recipients,
          from = _ref2.from,
          cc = _ref2.cc,
          bcc = _ref2.bcc,
          reply = _ref2.reply,
          userID = _ref2.userID,
          isHtml = _ref2.isHtml,
          type = _ref2.type,
          referenceID = _ref2.referenceID;

      return new Promise(function _callee(resolve) {
        var subjectString, messageString, replyEmail;
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(recipients == null || recipients.length === 0)) {
                  _context.next = 3;
                  break;
                }

                resolve();
                return _context.abrupt('return');

              case 3:
                recipients = recipients.filter(function (recipient) {
                  return recipient !== _this2.$store.getters.enginehireLoggingEmail;
                });
                subjectString = _this2.formatContent.apply(_this2, [subject].concat(args));
                messageString = _this2.formatContent.apply(_this2, [message].concat(args));
                // Find reply email

                replyEmail = void 0;
                ;
                if (reply && reply !== "aakash@enginehire.ca") {
                  replyEmail = reply;
                } else if (from) {
                  replyEmail = from;
                } else {
                  replyEmail = _this2.$store.getters.agencyReplyEmail;
                }
                _context.next = 11;
                return regeneratorRuntime.awrap(_this2.$store.dispatch("sendEmails", {
                  subject: subjectString,
                  message: messageString,
                  file_urls: file_urls,
                  from: from ? from : _this2.$store.getters.agencyFromEmail,
                  cc: cc,
                  bcc: bcc,
                  emails: [].concat(_toConsumableArray(new Set(recipients))),
                  reply: replyEmail,
                  userID: userID ? userID : _this2.$store.getters.userID,
                  html: isHtml,
                  type: type,
                  referenceID: referenceID
                }));

              case 11:
                resolve();

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, null, _this2);
      });
    },
    getEmailSenderFromEmailTemplate: function getEmailSenderFromEmailTemplate(emailTemplate) {
      var fromEmail = "";
      if (this.$store.getters.isAgent && emailTemplate.use_current_admin_email && this.$store.getters.userEmail) {
        fromEmail = this.$store.getters.userEmail;
      } else if (emailTemplate.from_email) {
        fromEmail = emailTemplate.from_email;
      } else {
        fromEmail = this.$store.getters.agency.from_email ? this.$store.getters.agency.from_email : this.$store.getters.agencyFromEmail;
      }
      return fromEmail;
    },
    getReplyToFromEmailTemplate: function getReplyToFromEmailTemplate(emailTemplate, emailObj) {
      // Use admin email
      if (emailTemplate && this.$store.getters.isAgent) {
        if (emailTemplate.use_current_admin_email && this.$store.getters.userEmail) {
          return this.$store.getters.userEmail;
        }
      }
      // Reply email is specified in the emailObj
      if (emailObj && emailObj.reply) {
        return emailObj.reply;
      }
      // Reply email is specified in the email templace
      if (emailTemplate && emailTemplate.reply_email) {
        return emailTemplate.reply_email;
      }
      // Reply email  = from email if it is not default from email
      var fromEmail = void 0;
      if (emailObj && emailObj.from) {
        fromEmail = emailObj.from;
      } else if (emailTemplate) {
        fromEmail = this.getEmailSenderFromEmailTemplate(emailTemplate);
      }
      if (fromEmail && fromEmail !== this.$store.getters.agencyFromEmail) {
        return fromEmail;
      }
      var agencyReplyEmail = this.$store.getters.agencyReplyEmail;
      if (agencyReplyEmail && agencyReplyEmail !== "aakash@enginehire.ca") {
        return agencyReplyEmail;
      }
      return this.$store.getters.agencyFromEmail;
    },
    sendBackgroundEmailToEnginehire: function sendBackgroundEmailToEnginehire(subject, message) {
      var recipients = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["aakash@enginehire.ca", "mary@enginehire.ca"];

      this.$store.dispatch("sendEmails", {
        subject: subject,
        message: message,
        from: "agency@enginehire.io",
        emails: recipients,
        reply: "agency@enginehire.io",
        html: true,
        in_background: true,
        userID: 4
      });
    }
  }
});

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _customDefineType = __webpack_require__(6);

var _separator = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
  methods: {
    getApplicationEmailContent: function getApplicationEmailContent(applicationData, listFields, mapDependentObjects, listBookingJobs) {
      var isOneItemPerRow = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var _this = this;

      var additionalInformation = arguments[5];
      var isEmailTemplate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

      // Hide hidden fields
      listFields = listFields.filter(function (field) {
        return !field.excludeFromSummaryEmail && _this.isItemShow(applicationData, field, listFields);
      });
      var content = "<div style='opacity: 1; border: solid 1px #f0f3f4; padding: 0.5em;'>";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.restructureListFields(listFields, isOneItemPerRow)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          content += "<div style='opacity: 1; display: table; width: 100%;'>";
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = row[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var field = _step2.value;

              // Ignore some complex type fields
              if ([_customDefineType.FORM_TYPE.FILE_WITH_INFO, _customDefineType.FORM_TYPE.RATING_GROUP, _customDefineType.FORM_TYPE.RADIO_TABLE, _customDefineType.FORM_TYPE.PASSWORD].includes(field.type)) {
                continue;
              }
              // Handle HTML type
              if (field.type === _customDefineType.FORM_TYPE.HTML) {
                content += field.html;
                continue;
              }
              // Handle separator
              if (field.type === _customDefineType.FORM_TYPE.SEPARATOR) {
                content += "<hr style='opacity: 1; margin-bottom: 0'/>";
                continue;
              }

              // Handle list textbox
              if (field.type === _customDefineType.FORM_TYPE.LIST_TEXTBOX) {
                content += this.getListTextboxContent(applicationData, field);
                continue;
              }

              // Handle dialog section (reference, experience, ...)
              if ([_customDefineType.FORM_TYPE.SLOT, _customDefineType.FORM_TYPE.SECTION, _customDefineType.FORM_TYPE.BOOKING_SECTION].includes(field.type)) {
                content += this.getSectionContent(field, mapDependentObjects, listBookingJobs, isOneItemPerRow, isEmailTemplate);
                continue;
              }
              var percentWidth = 100;
              if (!isOneItemPerRow && field.itemPerRow) {
                percentWidth = percentWidth / field.itemPerRow;
              }
              // Handle header and subheader
              if ([_customDefineType.FORM_TYPE.HEADER, _customDefineType.FORM_TYPE.SUB_HEADER].includes(field.type)) {
                var marginTop = field.type === _customDefineType.FORM_TYPE.HEADER ? '0.4em' : '0.2em';
                var fontSize = field.type === _customDefineType.FORM_TYPE.HEADER ? '2em' : '1.5em';
                content += "<div style='opacity: 1; display: table-cell; width:" + percentWidth + "%; padding-top: 4px'>" + ("<div style='opacity: 1; margin-top: " + marginTop + "; font-size: " + fontSize + ";'><b>" + this.getFieldPropertyByLang(field, 'label') + "</b></div></div>");
                continue;
              }
              if (field.type === _customDefineType.FORM_TYPE.PLACEMENT_JOB_SELECTION) {
                content += this.getPlacementJobSelectionContent(field, applicationData.selected_placement_jobs);
                continue;
              }
              var value = applicationData[field.model];
              // Skip empty value
              if (value == null || value === "") {
                continue;
              }
              if (field.type === _customDefineType.FORM_TYPE.FILE) {
                if (typeof value === 'string') {
                  var url = this.convertToAbsolutePath(value);
                  if (this.isFieldAnswerInline(field, additionalInformation)) {
                    content += "<div style='opacity: 1; display: table-cell; width:" + percentWidth + "%; padding-top: 4px'><div><b>" + this.getFieldPropertyByLang(field, 'label') + ": </b><a href=\"" + url + "\">View</a></div></div>";
                  } else {
                    content += "<div style='opacity: 1; display: table-cell; width:" + percentWidth + "%; padding-top: 4px'><div><b>" + this.getFieldPropertyByLang(field, 'label') + "</b></div><div><a href=\"" + url + "\">View</a></div></div>";
                  }
                }
                continue;
              }
              // Handle empty array
              if (Array.isArray(value)) {
                if (value.length === 0) {
                  continue;
                }
              }
              if (this.isFieldAnswerInline(field, additionalInformation)) {
                var fieldValue = this.getDisplayFieldValue(applicationData, field, field.model, ', ', isEmailTemplate);
                content += "<div style='opacity: 1; display: table-cell; width:" + percentWidth + "%; padding-top: 4px'><div><b>" + this.getFieldPropertyByLang(field, 'label') + ": </b>" + fieldValue + "</div></div>";
              } else {
                var _fieldValue = this.getDisplayFieldValue(applicationData, field, field.model, '<br/>', isEmailTemplate);
                content += "<div style='opacity: 1; display: table-cell; width:" + percentWidth + "%; padding-top: 4px'><div><b>" + this.getFieldPropertyByLang(field, 'label') + "</b></div><div>" + _fieldValue + "</div></div>";
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          content += "</div>";
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return content + "</div>";
    },
    getPlacementJobSelectionContent: function getPlacementJobSelectionContent(field, listSelectedIds) {
      if (!listSelectedIds || !listSelectedIds.length) {
        return "";
      }
      var listSelectedJobs = this.$store.getters.listPlacementJobs.filter(function (job) {
        return listSelectedIds.includes(job.id);
      });
      var content = listSelectedJobs.map(function (job) {
        return "<li>" + job.title + "</li>";
      }).join('');
      var result = "<div style='opacity: 1; display: table-cell; width:100%; padding-top: 4px'><div><b>" + this.getFieldPropertyByLang(field, 'label') + "</b></div><div><ul style=\"margin: 0;\">" + content + "</ul></div></div>";
      return result;
    },
    isFieldAnswerInline: function isFieldAnswerInline(field, additionalInformation) {
      console.log(additionalInformation);
      if (!field) {
        return false;
      }
      if (field.additionalInformation && field.additionalInformation.inline_answer) {
        return true;
      }
      if (field.additional_information && field.additional_information.inline_answer) {
        return true;
      }
      if (additionalInformation && additionalInformation.inline_answer) {
        return true;
      }
      return false;
    },

    // Get content for LIST_TEXTBOX
    getListTextboxContent: function getListTextboxContent(applicationData, field) {
      var content = "";
      if (applicationData[field.labelModel] == null || applicationData[field.labelModel].length === 0) {
        return content;
      }
      content += "<div><b>" + this.getFieldPropertyByLang(field, 'label') + "</b></div>";
      var listSubContent = [];
      for (var index = 0; index < applicationData[field.labelModel].length; index++) {
        var label = applicationData[field.labelModel][index];
        var value = applicationData[field.model][index];
        // Group each two in a row
        if (index % 2 === 0) {
          listSubContent.push("<div style='opacity: 1; display: table; width: 100%;'>");
        }
        listSubContent.push("<div style='opacity: 1; display: table-cell; width:50%; padding-top: 4px'><div><b>" + label + "</b></div><div>" + value + "</div></div>");
        if (index % 2 === 1) {
          listSubContent.push("</div>");
        }
      }
      if (applicationData[field.labelModel].length % 2 === 0) {
        // Add missing close tag
        listSubContent.push("</div>");
      }
      content += "" + listSubContent.join('');
      return content;
    },

    // Get content for sections: booking, experience, references, ...
    getSectionContent: function getSectionContent(field, mapDependentObjects, listBookingJobs) {
      var isOneItemPerRow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var isEmailTemplate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var ignoreHeader = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      var content = "";
      // Handle Booking
      if (field.name === "Booking") {
        if (listBookingJobs == null || listBookingJobs.length === 0) {
          return content;
        }
        if (!ignoreHeader) {
          var fontSize = isEmailTemplate ? '1em' : '2em';
          content += "<div><div style='opacity: 1; font-size: " + fontSize + "; margin-top: 0.4em; margin-bottom:0.4em; font-weight: bold;'>" + this.getFieldPropertyByLang(field, 'label') + "</div>";
        }
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = listBookingJobs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var bookingJob = _step3.value;

            var listFields = [{
              type: _customDefineType.FORM_TYPE.HTML,
              html: "<label style='opacity: 1; font-size: 1.1em;'><b>" + new Date(bookingJob.date + "T00:00:00").toDateString() + "</b></label>"
            }].concat(_toConsumableArray(field.list_fields), [{
              type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
              label: "Do you want this service more than once (repeating/recurring)?",
              model: "repeat",
              isRequired: false
            }, {
              type: _customDefineType.FORM_TYPE.DATEPICKER,
              label: "Repeat Until",
              model: "repeat_end_date",
              showIf: "repeat",
              minDate: this.selectedDate,
              initialView: "day"
            }, {
              type: _customDefineType.FORM_TYPE.LABEL,
              label: "Repeat Every *",
              showIf: "repeat"
            }, {
              type: _customDefineType.FORM_TYPE.MULTI_SELECT,
              model: "repeat_count",
              optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
              showIf: "repeat",
              itemPerRow: 2
            }, {
              type: _customDefineType.FORM_TYPE.MULTI_SELECT,
              model: "repeat_type",
              optionList: ["Days", "Weeks"],
              showIf: "repeat",
              itemPerRow: 2
            }, {
              type: _customDefineType.FORM_TYPE.CHECKBOX,
              model: "repeat_weekdays",
              label: "Repeat On",
              optionList: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
              showIf: "repeat_type",
              showIfValue: ["Weeks"]
            }, {
              type: _customDefineType.FORM_TYPE.TEXTBOX,
              label: "Booking Address",
              model: "address1"
            }, {
              type: _customDefineType.FORM_TYPE.TEXTBOX,
              label: "Address Line 2",
              model: "address2",
              isRequired: false
            }, {
              type: _customDefineType.FORM_TYPE.TEXTBOX,
              label: "City",
              itemPerRow: 3,
              model: "city"
            }, {
              type: _customDefineType.FORM_TYPE.TEXTBOX,
              label: "State",
              itemPerRow: 3,
              model: "provincestate"
            }, {
              type: _customDefineType.FORM_TYPE.TEXTBOX,
              label: "Zip Code",
              itemPerRow: 3,
              model: "postal_code"
            }, {
              type: _customDefineType.FORM_TYPE.MULTI_SELECT,
              label: "How many children will be cared for?",
              optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
              isMulti: false,
              model: "number_children"
            }]);
            if (bookingJob.filler) {
              listFields.push({
                type: _customDefineType.FORM_TYPE.TEXTBOX,
                label: "Selected Candidate",
                model: "filler_name",
                itemPerRow: 1
              });
            }
            content += this.getApplicationEmailContent(bookingJob, listFields, mapDependentObjects, listBookingJobs, isOneItemPerRow, field.additionalInformation, isEmailTemplate);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        content += "</div>";
        return content;
      }

      // None booking sections: reference, experience, ...
      var listDependentObjects = mapDependentObjects[field.label];
      if (listDependentObjects == null || listDependentObjects.length === 0) {
        return content;
      }
      if (!ignoreHeader) {
        var _fontSize = isEmailTemplate ? '1em' : '2em';
        content += "<div><div style='opacity: 1; font-size: " + _fontSize + "; margin-top: 0.4em; margin-bottom:0.4em; font-weight: bold;'>" + this.getFieldPropertyByLang(field, 'label') + "</div>";
      }
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = listDependentObjects[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var dependentObject = _step4.value;

          content += this.getApplicationEmailContent(dependentObject, field.list_fields, mapDependentObjects, listBookingJobs, isOneItemPerRow, field.additionalInformation, isEmailTemplate);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      content += "</div>";
      return content;
    },

    // Restructure listFields, by group each fields by rows
    restructureListFields: function restructureListFields(listFields, isOneItemPerRow) {
      var _this2 = this;

      return listFields.reduce(function (accResult, cur) {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (isOneItemPerRow || cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        var lastEl = accResult[accResult.length - 1];
        if (_this2.isFullBootstrapRow(lastEl)) {
          return [].concat(_toConsumableArray(accResult), [[cur]]);
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    },

    // Get display value for each field
    getDisplayFieldValue: function getDisplayFieldValue(applicationData, item, key, separator) {
      var _this3 = this;

      var isEmailTemplate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (item.type === _customDefineType.FORM_TYPE.TOTAL_YEARS) {
        return this.calculateDiffYears(applicationData.start_date, applicationData.end_date);
      }
      if (item.type === _customDefineType.FORM_TYPE.LABEL) {
        return item.model;
      }
      if (item.type === _customDefineType.FORM_TYPE.LIST_ITEMS) {
        return item.itemList;
      }
      var value = this.getValueOfObjectKey(applicationData, key);
      // Check share model
      if (item.isShareModel && Array.isArray(value)) {
        if (value[item.shareModelIndex]) {
          return value[item.shareModelIndex];
        } else {
          return "";
        }
      }
      if (item.type === _customDefineType.FORM_TYPE.DAY_HOURS_SELECTOR) {
        if (value == null || value.length === 0) {
          return "";
        }
        // Convert list days from String to array
        var listWorkingDays = item.listDays.split("\n").map(function (option) {
          return option.trim();
        }).filter(function (option) {
          return option.length > 0;
        });
        var listWorkingString = [];
        // Get string corresponding with each day with format Day: From hh:mm A To hh:mm A
        for (var index = 0; index < listWorkingDays.length; index++) {
          var timeValue = value[index];
          if (timeValue == null || timeValue.length === 0) {
            continue;
          }
          var timeTokens = void 0;
          if (timeValue.includes(_separator.TIME_FROM_TO_SEPARATOR)) {
            // New format (use with textbox)
            timeTokens = timeValue.split(_separator.TIME_FROM_TO_SEPARATOR);
          } else {
            // Old format (use with Timepicker)
            timeTokens = timeValue.split(",");
            if (timeTokens.length === 1) {
              timeTokens.push("");
            }
            timeTokens = timeTokens.slice(0, 2);
          }
          var mapReplacedValues = {
            ":AM": " AM",
            ":PM": " PM"
          };
          var timeFrom = timeTokens[0] ? this.replaceAllByMap(timeTokens[0], mapReplacedValues) : "";
          var timeTo = timeTokens[1] ? this.replaceAllByMap(timeTokens[1], mapReplacedValues) : "";
          var info = listWorkingDays[index] + (": From " + timeFrom + " To " + timeTo);
          if (item.hasTimeOff && timeTokens.length > 2) {
            info = info + " Time Off " + timeTokens[2];
          }
          if (item.hasNote) {
            if (item.hasTimeOff && timeTokens[3]) {
              info = info + " Note: " + timeTokens[3];
            } else if (timeTokens[2]) {
              info = info + " Note: " + timeTokens[2];
            }
          }
          listWorkingString.push(info);
        }
        return listWorkingString.join(separator).trim();
      } else if (item.type === _customDefineType.FORM_TYPE.SALARY_RANGE) {
        if (value == null || value.length < 3) {
          return "";
        }
        if (item.hidePeriod) {
          return "From: $" + value[0] + " To: $" + value[1];
        } else {
          return "From: $" + value[0] + " To: $" + value[1] + " per " + value[2];
        }
      } else if (item.type === _customDefineType.FORM_TYPE.MONTH_PICKER) {
        return this.getDisplayMonthYear(value);
      }

      if (Array.isArray(value)) {
        if (item.isHtml) {
          return value.map(function (token) {
            return _this3.getHtmlText(token);
          }).join(separator);
        } else {
          return value.join(separator);
        }
      }
      if (typeof value === "boolean") {
        return value ? "Yes" : "No";
      }
      if (typeof value === 'string') {
        if (item.isHtml) {
          value = this.getHtmlText(value);
        }
      }
      if (item.type === _customDefineType.FORM_TYPE.FILE) {
        if (item.fileType === _customDefineType.FILE_TYPES.IMAGE) {
          // If it is a image file, create URL to display image
          if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && value != null) {
            return URL.createObjectURL(value);
          }
        }
      } else if (item.type === _customDefineType.FORM_TYPE.TIME_PICKER) {
        if (typeof value === 'string') {
          return this.convertTimeStringToStringAMPM(value);
        } else {
          return this.convertTimeAMPMToString(value);
        }
      } else if (item.type === _customDefineType.FORM_TYPE.DATEPICKER) {
        try {
          var dateStr = new Date(value + "T00:00:00").toDateString();
          if (key === 'birthday') {
            if (isEmailTemplate) {
              return "Age: " + this.getAge(value);
            } else {
              return dateStr + " (Age: " + this.getAge(value) + ")";
            }
          }
          return dateStr;
        } catch (e) {
          return value;
        }
      } else if (item.type === _customDefineType.FORM_TYPE.DATETIME_PICKER) {
        try {
          return new Date(value).toUTCString();
        } catch (e) {
          return value;
        }
      } else if (item.type === _customDefineType.FORM_TYPE.YEAR_PICKER) {
        return this.getYearFromDate(value);
      }
      return value;
    },
    getFieldPropertyByLang: function getFieldPropertyByLang(item, key) {
      var language = this.$store.getters.language;
      if (language) {
        if (item[key + "_lang_" + language]) {
          return item[key + "_lang_" + language];
        }
      }
      if (item[key]) {
        return item[key];
      }
      if (key === "label" && item.keyLangLabel) {
        if (item.keyLangLabelParams) {
          return this.getLabelByKeys.apply(this, [item.keyLangLabel].concat(_toConsumableArray(item.keyLangLabelParams)));
        } else {
          return this.getLabelByKeys(item.keyLangLabel);
        }
      }
      return "";
    }
  }
});

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _customDefineType = __webpack_require__(6);

var _fieldTypes = __webpack_require__(45);

var _regex = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
  methods: {
    /*Get key of fields which is in title of an object
     For example:
     If the listField represent for a field of children, keyTitles will include first_name and last_name
     */
    getKeyTitles: function getKeyTitles(listFields, initValue) {
      if (!listFields) {
        return [];
      }
      if (Array.isArray(initValue) && initValue.length > 0) {
        return initValue;
      }
      // Check if first_name and last_name are existed in listFields
      var hasFirstNameField = listFields.some(function (field) {
        return field.model === "first_name";
      });
      var hasLastNameField = listFields.some(function (field) {
        return field.model === "last_name";
      });
      var hasMiddleNameField = listFields.some(function (field) {
        return field.model === "middle_name";
      });
      if (hasFirstNameField && hasLastNameField) {
        if (hasMiddleNameField) {
          return ["first_name", "middle_name", "last_name"];
        } else {
          return ["first_name", "last_name"];
        }
      }
      // Check if title is existed in listFields (in case of experience dialog)
      var hasTitleField = listFields.some(function (field) {
        return field.model === "title";
      });
      if (hasTitleField) {
        return ["title"];
      }

      // Check if name is existed in listFields (in case of reference dialog)
      var hasNameField = listFields.some(function (field) {
        return field.model === "name";
      });
      if (hasNameField) {
        return ["name"];
      }

      // Check if institution_type is existed in listFelds (in case of education dialog)
      var hasInstitutionType = listFields.some(
      // field => field.model === "institution_type"
      function (field) {
        return field.model === "area_of_study";
      });
      if (hasInstitutionType) {
        // return ["institution_type"];
        return ["area_of_study"];
      }

      // Check if employer name is existed in listFields (in case of experience dialog)
      var hasEmployerName = listFields.some(function (field) {
        return field.model === "person_worked_for_name";
      });
      if (hasEmployerName) {
        return ["person_worked_for_name"];
      }

      return [];
    },

    /*
    Merge multiple builders (by combine between multiple sections)
    For example: a builder for application form includes builders for 3 sections
    [{
        sectionBuilderId: 1,
        type: Dialog_Section,
        api: 'api1'
      },
      {
        sectionBuilderId: 2,
        type: Dialog_Section,
        api: 'api2'
      },
      {
        sectionBuilderId: 3,
        type: Dialog_Section,
        api: 'api3'
      }
    ],
    listBuilder contains detail information for each section Builder,
    [
      {
        id: 1,
        list_fields: [
          field1,
          field2
        ]
      },
      {
        id: 2,
        list_fields: [
          field3,
          field4
        ]
      },
      {
        id: 3,
        list_fields: [
          field5,
          field6
        ]
      },
    ]
     => Output:
    listRejectCondition: Combination of list reject condition of related builders (only with people API)
    listFields: [{
        sectionBuilderId: 1,
        type: Dialog_Section,
        api: 'api1',
        list_fields: [
          field1, field2
        ]
      },
      {
        sectionBuilderId: 2,
        type: Dialog_Section,
        api: 'api2',
        list_fields: [
          field3, field4
        ]
      },
      {
        sectionBuilderId: 3,
        type: Dialog_Section,
        api: 'api3',
        list_fields: [
          field5, field6
        ]
      }
    ]
    */
    mergeBuilders: function mergeBuilders(inputMainBuilder, listBuilder) {
      var keepPeopleSection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (inputMainBuilder == null || inputMainBuilder.list_fields == null || listBuilder == null) {
        return { listFields: [] };
      }
      var mainBuilder = JSON.parse(JSON.stringify(inputMainBuilder));
      var listFieldsOutput = [];
      var listModelsPrivate = [];
      var listModelsAdminClient = [];
      var listModelsAdminOnly = [];
      var listConditionKeys = this.$store.getters.listBuilderConditionKeys;
      var mapListConditions = {};
      listConditionKeys.forEach(function (item) {
        mapListConditions[item.varKey] = [];
        if (mainBuilder[item.apiKey] != null) {
          mapListConditions[item.varKey].push(mainBuilder[item.apiKey]);
        }
      });
      if (mainBuilder.list_models_private != null) {
        listModelsPrivate.push(mainBuilder.list_models_private);
      }
      if (mainBuilder.admin_and_client_only != null) {
        listModelsAdminClient.push(mainBuilder.admin_and_client_only);
      }
      if (mainBuilder.admin_only != null) {
        listModelsAdminOnly.push(mainBuilder.admin_only);
      }
      mainBuilder.list_fields.forEach(function (field, index) {
        if (field.type === _customDefineType.FORM_TYPE.SECTION) {
          var sectionBuilder = listBuilder.find(function (builder) {
            return builder.id === field.sectionBuilderId;
          });
          if (sectionBuilder == null) {
            return;
          }
          // Clone sectionBuilder to avoid modifying its property
          try {
            sectionBuilder = JSON.parse(JSON.stringify(sectionBuilder));
          } catch (e) {}
          sectionBuilder.list_fields.forEach(function (field, sectionFieldIndex) {
            // Add validation for email field
            if (field.model && ["email", "email2"].includes(field.model.toLowerCase())) {
              field.validation = [{
                regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
                message: "Please enter a valid email."
              }];
            }
          });
          // Check if it is people API
          if (sectionBuilder.api === _fieldTypes.MAP_DIALOG_SECTION.People.api) {
            if (keepPeopleSection && !field.hideSectionTitle) {
              // In case of other API (reference, children, experience, ...)
              field.list_fields = sectionBuilder.list_fields;
              // Find corresponding section type
              field.name = "People";
              field.status = sectionBuilder.status_change;
              field.visibleBeyondStatus = sectionBuilder.visible_beyond_status;
              field.noEditStatus = sectionBuilder.no_edit_status;
              field.hideFromOwnerStatus = sectionBuilder.hide_from_owner_status;
              field.listVisibleStatuses = sectionBuilder.visible_statuses;
              field.listVisibleTypes = sectionBuilder.visible_types;
              field.submissionNotification = sectionBuilder.submission_notification;
              field.submissionNotificationEmails = sectionBuilder.submission_notification_emails;
              field.submissionNotificationEmails2 = sectionBuilder.submission_notification_emails2;
              field.submissionConfirmation = sectionBuilder.submission_confirmation;
              field.rejectionMessage = sectionBuilder.rejection_message;
              listConditionKeys.forEach(function (item) {
                field[item.varKey] = sectionBuilder[item.apiKey];
              });
              field.listModelsPrivate = sectionBuilder.list_models_private;
              field.listModelsAdminClient = sectionBuilder.admin_and_client_only;
              field.listModelsAdminOnly = sectionBuilder.admin_only;
              if (field.isPrivate == null) {
                field.isPrivate = sectionBuilder.is_private;
              }
              field.additionalInformation = sectionBuilder.additional_information;
              field.scrollToSectionId = sectionBuilder.scroll_to_section_id;
              field.backgroundColor = sectionBuilder.background_color;
              field.id = sectionBuilder.id;
              listFieldsOutput.push(field);
            } else {
              var stepIndex = field.stepIndex;
              var isPreconditionCheck = field.isPreconditionCheck;
              var rejectionMessage = field.rejectionMessage;
              // Insert header
              if (!field.hideSectionTitle) {
                var headerField = {
                  type: _customDefineType.FORM_TYPE.HEADER,
                  label: field.label ? field.label : sectionBuilder.name,
                  description: field.description,
                  adminDescription: field.adminDescription,
                  visibleBeyondStatus: sectionBuilder.visible_beyond_status,
                  noEditStatus: sectionBuilder.no_edit_status,
                  hideFromOwnerStatus: sectionBuilder.hide_from_owner_status,
                  listVisibleStatuses: sectionBuilder.visible_statuses,
                  listVisibleTypes: sectionBuilder.visible_types,
                  stepIndex: stepIndex,
                  isPreconditionCheck: isPreconditionCheck,
                  rejectionMessage: rejectionMessage,
                  builderId: sectionBuilder.id
                };
                // Copy multi-languages label, description, admin description
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = Object.keys(field)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (key.includes('_lang_')) {
                      headerField[key] = field[key];
                    }
                  }
                  // Add show if and show if condition of parent field to sub list_fields
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                if (field.showIf) {
                  headerField.showIfContainer = field.showIf;
                  if (field.showIfValue) {
                    headerField.showIfValueContainer = field.showIfValue;
                  }
                  if (field.showIfEmpty) {
                    headerField.showIfEmptyContainer = field.showIfEmpty;
                  }
                }
                // Secondary show condition of container
                if (field.showIfSecondary) {
                  headerField.showIfSecondaryContainer = field.showIfSecondary;
                  if (field.showIfValueSecondary) {
                    headerField.showIfValueSecondaryContainer = field.showIfValueSecondary;
                  }
                  if (field.showIfEmptySecondary) {
                    headerField.showIfEmptySecondaryContainer = field.showIfEmptySecondary;
                  }
                }
                // Third show condition of container
                if (field.showIfThird) {
                  headerField.showIfThirdContainer = field.showIfThird;
                  if (field.showIfValueThird) {
                    headerField.showIfValueThirdContainer = field.showIfValueThird;
                  }
                  if (field.showIfEmptyThird) {
                    headerField.showIfEmptyThirdContainer = field.showIfEmptyThird;
                  }
                }
                // Combined show condition of container
                if (field.combinedShowCondition) {
                  headerField.combinedShowConditionContainer = field.combinedShowCondition;
                }
                listFieldsOutput.push(headerField);
              }
              sectionBuilder.list_fields.forEach(function (field) {
                field.visibleBeyondStatus = sectionBuilder.visible_beyond_status;
                field.noEditStatus = sectionBuilder.no_edit_status;
                field.hideFromOwnerStatus = sectionBuilder.hide_from_owner_status;
                field.listVisibleStatuses = sectionBuilder.visible_statuses;
                field.listVisibleTypes = sectionBuilder.visible_types;
                field.stepIndex = stepIndex;
                field.isPreconditionCheck = isPreconditionCheck;
                field.rejectionMessage = rejectionMessage;
                field.additionalInformation = sectionBuilder.additional_information;
                field.sectionBuilderName = sectionBuilder.name;
              });
              // Add show if and show if condition of parent field to sub list_fields
              if (field.showIf) {
                sectionBuilder.list_fields.forEach(function (subField) {
                  subField.showIfContainer = field.showIf;
                  if (field.showIfValue) {
                    subField.showIfValueContainer = field.showIfValue;
                  }
                  if (field.showIfEmpty) {
                    subField.showIfEmptyContainer = field.showIfEmpty;
                  }
                });
              }
              if (field.showIfSecondary) {
                sectionBuilder.list_fields.forEach(function (subField) {
                  subField.showIfSecondaryContainer = field.showIfSecondary;
                  if (field.showIfValueSecondary) {
                    subField.showIfValueSecondaryContainer = field.showIfValueSecondary;
                  }
                  if (field.showIfEmptySecondary) {
                    subField.showIfEmptySecondaryContainer = field.showIfEmptySecondary;
                  }
                });
              }
              if (field.showIfThird) {
                sectionBuilder.list_fields.forEach(function (subField) {
                  subField.showIfThirdContainer = field.showIfThird;
                  if (field.showIfValueThird) {
                    subField.showIfValueThirdContainer = field.showIfValueThird;
                  }
                  if (field.showIfEmptyThird) {
                    subField.showIfEmptyThirdContainer = field.showIfEmptyThird;
                  }
                });
              }
              if (field.combinedShowCondition) {
                sectionBuilder.list_fields.forEach(function (subField) {
                  subField.combinedShowConditionContainer = field.combinedShowCondition;
                });
              }
              listFieldsOutput = listFieldsOutput.concat(sectionBuilder.list_fields);
              listConditionKeys.forEach(function (item) {
                if (sectionBuilder[item.apiKey] != null) {
                  mapListConditions[item.varKey].push(_extends({}, sectionBuilder[item.apiKey], { id: sectionBuilder.id }));
                }
              });
              if (sectionBuilder.list_models_private != null) {
                listModelsPrivate.push(sectionBuilder.list_models_private);
              }
              if (sectionBuilder.is_private && sectionBuilder.list_fields) {
                sectionBuilder.list_fields.forEach(function (field) {
                  return field.isInPrivateSection = true;
                });
              }
              if (sectionBuilder.admin_and_client_only != null) {
                listModelsAdminClient.push(sectionBuilder.admin_and_client_only);
              }
              if (sectionBuilder.admin_only != null) {
                listModelsAdminOnly.push(sectionBuilder.admin_only);
              }
            }
          } else {
            // In case of other API (reference, children, experience, ...)
            field.list_fields = sectionBuilder.list_fields;
            // Find corresponding section type
            field.name = Object.values(_fieldTypes.MAP_DIALOG_SECTION).find(function (item) {
              return item.api === sectionBuilder.api;
            }).name;
            field.status = sectionBuilder.status_change;
            field.minCount = sectionBuilder.minimum_number_of_items;
            field.visibleBeyondStatus = sectionBuilder.visible_beyond_status;
            field.noEditStatus = sectionBuilder.no_edit_status;
            field.hideFromOwnerStatus = sectionBuilder.hide_from_owner_status;
            field.listVisibleStatuses = sectionBuilder.visible_statuses;
            field.listVisibleTypes = sectionBuilder.visible_types;
            field.submissionNotification = sectionBuilder.submission_notification;
            field.submissionNotificationEmails = sectionBuilder.submission_notification_emails;
            field.submissionNotificationEmails2 = sectionBuilder.submission_notification_emails2;
            field.submissionConfirmation = sectionBuilder.submission_confirmation;
            field.rejectionMessage = sectionBuilder.rejection_message;
            listConditionKeys.forEach(function (item) {
              field[item.varKey] = sectionBuilder[item.apiKey];
            });
            field.listModelsPrivate = sectionBuilder.list_models_private;
            field.listModelsAdminClient = sectionBuilder.admin_and_client_only;
            field.listModelsAdminOnly = sectionBuilder.admin_only;
            field.isPrivate = sectionBuilder.is_private;
            field.additionalInformation = sectionBuilder.additional_information;
            field.validation = sectionBuilder.validation;
            field.scrollToSectionId = sectionBuilder.scroll_to_section_id;
            field.backgroundColor = sectionBuilder.background_color;
            field.titleModels = sectionBuilder.title_models;
            // Add reference check form builder (if any)
            if (field.referenceCheckFormId) {
              var referenceCheckFormBuilder = listBuilder.find(function (builder) {
                return builder.id === field.referenceCheckFormId;
              });
              if (referenceCheckFormBuilder) {
                field.listFieldCheckForm = referenceCheckFormBuilder.list_fields;
                field.isPrivateCheckForm = referenceCheckFormBuilder.is_private;
                field.additionalInfoCheckForm = referenceCheckFormBuilder.additional_information;
              }
            }
            listFieldsOutput.push(field);
          }
        } else if (field.type === _customDefineType.FORM_TYPE.BOOKING_SECTION) {
          var _sectionBuilder = listBuilder.find(function (builder) {
            return builder.id === field.sectionBuilderId;
          });
          if (_sectionBuilder) {
            // In case of booking section
            field.list_fields = _sectionBuilder.list_fields;
            // Find corresponding section type
            field.name = Object.values(_fieldTypes.MAP_DIALOG_SECTION).find(function (item) {
              return item.api === _sectionBuilder.api;
            }).name;
            field.status = _sectionBuilder.status_change;
            field.minCount = _sectionBuilder.minimum_number_of_items;
            field.visibleBeyondStatus = _sectionBuilder.visible_beyond_status;
            field.noEditStatus = _sectionBuilder.no_edit_status;
            field.hideFromOwnerStatus = _sectionBuilder.hide_from_owner_status;
            field.listVisibleStatuses = _sectionBuilder.visible_statuses;
            field.listVisibleTypes = _sectionBuilder.visible_types;
            field.submissionNotification = _sectionBuilder.submission_notification;
            field.submissionNotificationEmails = _sectionBuilder.submission_notification_emails;
            field.submissionNotificationEmails2 = _sectionBuilder.submission_notification_emails2;
            field.submissionConfirmation = _sectionBuilder.submission_confirmation;
            field.rejectionMessage = _sectionBuilder.rejection_message;
            listConditionKeys.forEach(function (item) {
              field[item.varKey] = _sectionBuilder[item.apiKey];
            });
            field.listModelsPrivate = _sectionBuilder.list_models_private;
            field.listModelsAdminClient = _sectionBuilder.admin_and_client_only;
            field.listModelsAdminOnly = _sectionBuilder.admin_only;
            field.isPrivate = _sectionBuilder.is_private;
            field.additionalInformation = _sectionBuilder.additional_information;
            field.validation = _sectionBuilder.validation;
            field.scrollToSectionId = _sectionBuilder.scroll_to_section_id;
            field.backgroundColor = _sectionBuilder.background_color;
            listFieldsOutput.push(field);
          }
        } else {
          if (field.model && mainBuilder.id) {
            field.builderId = mainBuilder.id;
          }
          // Add validation for email field
          if (field.model && ["email", "email2"].includes(field.model.toLowerCase())) {
            field.validation = [{
              regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
              message: "Please enter a valid email."
            }];
          }
          listFieldsOutput.push(field);
        }
      });

      // Add list Fields for file with additional info field
      listFieldsOutput.forEach(function (field) {
        if (field.type === _customDefineType.FORM_TYPE.FILE_WITH_INFO) {
          var fileInfoBuilder = listBuilder.find(function (builder) {
            return builder.id === field.fileInfoBuilderId;
          });
          if (fileInfoBuilder) {
            field.list_fields = fileInfoBuilder.list_fields;
            field.listModelsPrivate = fileInfoBuilder.list_models_private;
            field.listModelsAdminClient = fileInfoBuilder.admin_and_client_only;
            field.listModelsAdminOnly = fileInfoBuilder.admin_only;
          }
        }
      });
      return _extends({
        listFields: listFieldsOutput
      }, mapListConditions, {
        listModelsPrivate: listModelsPrivate,
        listModelsAdminClient: listModelsAdminClient,
        listModelsAdminOnly: listModelsAdminOnly,
        locations: mainBuilder.locations,
        languages: mainBuilder.languages
      });
    },

    /*
    Based on a multi-line input string,
    get corresponding object for submission dialog with structure
    {
      title: first_line
      message: other_lines
    }
    If submissionString is not defined, defaultContent will be used
    */
    getSubmissionDialogContent: function getSubmissionDialogContent(submissionString, defaultContent) {
      if (submissionString && submissionString.trim().length > 0) {
        return {
          innerHtml: submissionString
        };
      } else {
        return defaultContent;
      }
    },

    /* extract the email within parentheses */
    extractEmail: function extractEmail(emailName) {
      var emailRegExp = /\(([^)]+)\)/;
      return emailRegExp.exec(emailName)[1];
    },

    // Get list fields corresponding with userType (Client or Candidate) based on listBuilders
    // Each builder contains list of fields. This function merge all fields of the corresponding builder
    // then remove the duplicate item
    // includeSection: Include reference, experience, children, ... section
    getListFieldsByUserType: function getListFieldsByUserType(listBuilders, userType) {
      var includeSection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Find profile builders corresponding with userType
      var listBuildersByUserType = listBuilders.filter(function (builder) {
        return [_customDefineType.BUILDER_TYPE.PROFILE, _customDefineType.BUILDER_TYPE.APPLICATION].includes(builder.type) && builder.user_type === userType;
      });
      var listFields = [];
      var listModels = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = listBuildersByUserType[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var profileBuilder = _step2.value;

          var mergedBuilder = this.mergeBuilders(profileBuilder, listBuilders, false);
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = mergedBuilder.listFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var field = _step3.value;

              if (field.type === _customDefineType.FORM_TYPE.SECTION) {
                var sectionModel = "section-" + field.label;
                // Avoid duplicate fields
                if (listModels.includes(sectionModel)) {
                  continue;
                }
                listFields.push(_extends({}, field, {
                  model: sectionModel
                }));
                listModels.push(sectionModel);
                continue;
              }
              if (!field.model) {
                continue;
              }
              // Exclude file with info fields
              if ([_customDefineType.FORM_TYPE.FILE_WITH_INFO].includes(field.type)) {
                continue;
              }
              // Avoid duplicate fields
              if (listModels.includes(field.model)) {
                continue;
              }
              listFields.push(field);
              listModels.push(field.model);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return listFields;
    },
    getListBookingFields: function getListBookingFields() {
      // Find all section booking for builders
      var listBookingBuilders = this.$store.getters.profileBuilderList.filter(function (builder) {
        return builder.api === _fieldTypes.MAP_DIALOG_SECTION.Booking.api;
      });
      var result = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = listBookingBuilders[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var bookingBuilder = _step4.value;

          if (bookingBuilder.list_fields) {
            result = [].concat(_toConsumableArray(result), _toConsumableArray(bookingBuilder.list_fields.filter(function (field) {
              return field.model;
            })));
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return result;
    },

    // Extract list of fields inside listFields, which has model is included in listModels.
    // The order of field in result is the same as the order of model in listModels
    extractFieldsByModels: function extractFieldsByModels(listFields, listModels) {
      var result = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        var _loop = function _loop() {
          var model = _step5.value;

          var field = listFields.find(function (field) {
            return field.model === model;
          });
          if (field) {
            result.push(field);
          }
        };

        for (var _iterator5 = listModels[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return result;
    },

    // Extract list of tag from input
    // For example: input: [[first_name]] and [[last_name]] and ...
    // Output: [first_name, last_name]
    extractTagFromString: function extractTagFromString(input) {
      var unique = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!input) {
        return [];
      }
      var listTags = input.match(_regex.REGEX_EXTRACT_FIELD_TAGS);
      if (listTags == null) {
        return [];
      }
      var result = listTags.map(function (tag) {
        return tag.replace('[[', '').replace(']]', '');
      });
      if (unique) {
        return [].concat(_toConsumableArray(new Set(result)));
      }
      return result;
    },

    // Extract list of tag from input
    // For example: input: [[first_name]] and [[last_name]] and ...
    // Output: [first_name, last_name]
    extractSubTagFromString: function extractSubTagFromString(input) {
      if (!input) {
        return [];
      }
      var listTags = input.match(_regex.REGEX_EXTRACT_FIELD_SUB_TAGS);
      if (listTags == null) {
        return [];
      }
      return listTags.map(function (tag) {
        return tag.replace('{{', '').replace('}}', '');
      });
    },

    // Replace tag in input string by value of object attributes
    // For example: input: [[first_name]] is A
    // Structure of tag: [[model(shareIndex)|displayStyle]]
    // Object: {first_name: 'Test'}
    // Mark boundary for each tag by pair of <<<  >>>
    // If listAllowedTags is specified, only replace tag in that list
    // Output: Test is A
    replaceTagValue: function replaceTagValue(input, object, hasEditButton, listModelsPrivate, keepValueFormat, listAllowedTags) {
      if (object == null || input == null) {
        return input;
      }
      var result = input;
      var listTags = this.extractTagFromString(input);
      if (listAllowedTags && listAllowedTags.length) {
        listTags = listTags.filter(function (tag) {
          return listAllowedTags.includes(tag);
        });
      }
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = listTags[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var tag = _step6.value;

          if (tag.indexOf('api|') === 0) {
            result = this.replaceAllText(result, "[[" + tag + "]]", this.getReplacedApiTag(tag, object));
            continue;
          }

          var _parseTagField = this.parseTagField(tag),
              _model = _parseTagField.model,
              shareIndex = _parseTagField.shareIndex,
              displayStyle = _parseTagField.displayStyle,
              defaultValue = _parseTagField.defaultValue;

          var value = void 0;
          if (keepValueFormat) {
            value = object[_model];
            if (value == null) {
              value = [];
            }
            if (Array.isArray(value)) {
              value = this.deduplicateArrayOfObject(value);
              value = JSON.stringify(value);
            }
          } else {
            if (object[_model]) {
              var _parseTagField2 = this.parseTagField(tag),
                  _model2 = _parseTagField2.model,
                  _shareIndex = _parseTagField2.shareIndex,
                  _displayStyle = _parseTagField2.displayStyle,
                  _defaultValue = _parseTagField2.defaultValue;

              value = this.getDisplayValueInline(object, _model2, _shareIndex, _displayStyle, _defaultValue);
            }
          }

          // Check tag is private field (private field and empty field are not showed in non-editable access)
          if (!hasEditButton) {
            if (this.isInMixedArray(listModelsPrivate, _model)) {
              value = "";
            }
          }
          var dataTag = void 0;
          if (shareIndex) {
            dataTag = "data-tag=\"" + _model + "(" + shareIndex + "})\"";
          } else {
            dataTag = "data-tag=\"" + _model + "\"";
          }
          if (value != null && value !== '') {
            if (hasEditButton) {
              // Insert edit button
              value += "<i class=\"material-icons inline-edit-icon\" " + dataTag + "> edit </i>";
            }
            result = this.replaceAllText(result, "[[" + tag + "]]", value);
          } else {
            if (hasEditButton) {
              // Insert edit button
              value = "<i class=\"material-icons inline-edit-icon\" " + dataTag + "> edit </i>";
            } else {
              value = "";
              try {
                // remove boundary text
                var searchRegExp = new RegExp("\\(\\(\\([^)]*[[" + tag + "]][^)]*\\)\\)\\)", 'gmi');
                result = result.replace(searchRegExp, '');
              } catch (_) {}
            }
            // replace tag (if any)
            result = this.replaceAllText(result, "[[" + tag + "]]", value);
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      result = this.removeTextInString(result, ['(((', ')))']);
      return result;
    },

    // Get replaced values for experiences, references, educations, ...
    // Structure of tags:
    // api|key|type</div>tag Data<div>
    // For example: api|experiences|Experience</div><h4><b>{{title}}</b></h4><h5>{{start_date}} - {{end_date}}</h5><div>{{note}}</div><div><br></div><div>
    getReplacedApiTag: function getReplacedApiTag(tag, object) {
      var _tag$split = tag.split("</div>"),
          _tag$split2 = _toArray(_tag$split),
          apiInfo = _tag$split2[0],
          tagData = _tag$split2.slice(1);

      tagData = tagData.join("</div>").replace(/<div>$/, "");;
      var tokens = apiInfo.split('|');
      if (tokens.length < 3) {
        return "";
      }
      var apiKey = tokens[1];
      var apiType = tokens[2].trim();
      apiType = apiType.split('<')[0].trim();

      // Get list data (for example: list of experiences)
      var listData = object[apiKey];
      if (!listData) {
        return "";
      }
      // In case of pets, type is used to save pet type
      // In case of children, apiType will not work for multilanguages
      if (!['pets', 'children'].includes(apiKey)) {
        // For old data, data.type is undefined
        listData = listData.filter(function (data) {
          return !data.type || data.type === apiType;
        });
      }
      if (listData && listData.length && this.$store.getters.profileBuilderList) {
        if (tokens.length >= 4) {
          var builderId = Number(tokens[3].split('<')[0]);
          var builder = this.$store.getters.profileBuilderList.find(function (builder) {
            return builder.id === builderId;
          });
          this.handleSortDependentSections(listData, builder);
        }
      }
      var result = [];
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = listData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var data = _step7.value;

          var entryContent = tagData;
          var listSubTags = this.extractSubTagFromString(tagData);
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = listSubTags[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var subTag = _step8.value;

              var _parseTagField3 = this.parseTagField(subTag),
                  _model3 = _parseTagField3.model,
                  shareIndex = _parseTagField3.shareIndex,
                  displayStyle = _parseTagField3.displayStyle,
                  defaultValue = _parseTagField3.defaultValue;

              var value = "";
              if (data[_model3]) {
                value = this.getDisplayValueInline(data, _model3, shareIndex, displayStyle, defaultValue);
              } else {
                if (defaultValue) {
                  value = defaultValue;
                }
              }
              if (value == "") {
                try {
                  // remove boundary text
                  var searchRegExp = new RegExp("\\(\\(\\([^)]*{{" + subTag + "}}[^)]*\\)\\)\\)", 'gmi');
                  entryContent = entryContent.replace(searchRegExp, '');
                } catch (_) {}
              }
              entryContent = this.replaceAllText(entryContent, "{{" + subTag + "}}", value);
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }

          result.push(entryContent);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return result.join("");
    },
    getDisplayCheckboxTableOneColumn: function getDisplayCheckboxTableOneColumn(model, value, builderId, isInline) {
      if (!builderId) {
        return;
      }
      if (!value) {
        return '';
      }
      // Find the field
      var builder = this.$store.getters.profileBuilderList.find(function (builder) {
        return builder.id === Number(builderId);
      });
      if (!builder || !builder.list_fields) {
        return;
      }
      var field = builder.list_fields.find(function (field) {
        return field.type === _customDefineType.FORM_TYPE.CHECKBOX_TABLE && field.model === model;
      });
      if (!field) {
        return;
      }
      // Get header list
      var headerList = this.convertStringToArray(field.headerList);
      // Get item list
      var itemList = this.convertStringToArray(field.itemList);
      var mapHeaderItems = {};
      var header = '';
      for (var index = 0; index < itemList.length; index++) {
        var item = itemList[index];
        if (headerList.includes(item)) {
          header = item;
          continue;
        }
        var valueItem = value[index];
        if (!valueItem) {
          continue;
        }
        if (valueItem.indexOf(item + ':') !== 0) {
          continue;
        }
        var remaining = valueItem.substring(item.length + 1).trim();
        if (!remaining) {
          continue;
        }
        // Item is selected
        var currentList = mapHeaderItems[header] || [];
        currentList.push(item);
        mapHeaderItems[header] = currentList;
      }
      var result = '';
      var inlineClass = isInline ? 'inline-content' : '';
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = Object.keys(mapHeaderItems)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var _header = _step9.value;

          result = result + "<div class=\"mt-2 checkbox-column-header " + inlineClass + "\"><b>" + _header + "</b></div>";
          var listCheckedItems = mapHeaderItems[_header];
          result = result + "<div class=\"checkbox-column-content " + inlineClass + "\">" + listCheckedItems.join(', ') + "</div>";
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return "<div>" + result + "</div>";
    },
    getDisplayValueInline: function getDisplayValueInline(data, model, shareIndex, displayStyle, defaultValue) {
      if (!data) {
        return "";
      }
      var value = data[model];
      if (["created_date", "last_login", "last_updated_date", "last_activity"].includes(model)) {
        return new Date(value).toDateString();
      }
      if (Array.isArray(value)) {
        if (displayStyle === 'day-hours') {
          value = this.getDisplayDayHourSelector(value, defaultValue);
          var listItems = value.map(function (item) {
            return "<li>" + item.day + ": From " + item.from + " To " + item.to + "</li>";
          });
          return '<ul>' + listItems.join('') + '</ul>';
        }
        if (displayStyle === 'checkbox_table_one_column') {
          var result = this.getDisplayCheckboxTableOneColumn(model, value, defaultValue);
          if (result != null) {
            return result;
          }
        }
        if (displayStyle === 'checkbox_table_one_column_inline') {
          var _result = this.getDisplayCheckboxTableOneColumn(model, value, defaultValue, true);
          if (_result != null) {
            return _result;
          }
        }
        value = this.deduplicateArrayOfObject(value);
        if (displayStyle === 'salary-range') {
          if (value.length === 3) {
            return "From $" + value[0] + " to $" + value[1] + " per " + value[2];
          }
        }
        if (shareIndex) {
          return this.getDisplayValueByStyle(value[shareIndex], displayStyle);
        }
        // Replace move prefix key word (other:)
        value = value.map(function (item) {
          if (typeof item === 'string' && item.indexOf('other:') === 0) {
            return item.substring(6);
          } else {
            return item;
          }
        });
        if (displayStyle === 'list') {
          var _listItems = value.map(function (item) {
            return "<li>" + item + "</li>";
          });
          return '<ul>' + _listItems.join('') + '</ul>';
        } else if (displayStyle === 'list_checked') {
          var _listItems2 = value.map(function (item) {
            return "<div style=\"display: flex\"><i class=\"material-icons material-icons-outlined\" style=\"width: 30px;\"> check_box </i><span> " + item + "</span></div>";
          });
          return '<div>' + _listItems2.join('') + '</div>';
        }
        return value.join(", ");
      }
      return this.getDisplayValueByStyle(value, displayStyle);
    },
    parseTagField: function parseTagField(tag) {
      // Parse display style
      var displayStyle = null;
      var modelShareIndex = tag; // model(shareIndex) or model
      var defaultValue = null;
      if (tag.includes('|')) {
        var tokens = tag.split('|');
        displayStyle = tokens[1];
        modelShareIndex = tokens[0];
        defaultValue = tokens[2];
      }
      // Parse share index
      var model = modelShareIndex;
      var shareIndex = null;
      if (modelShareIndex.includes('(')) {
        var _tokens = modelShareIndex.split('(');
        model = _tokens[0];
        shareIndex = _tokens[1].replace(')', '').trim();
      }
      return {
        model: model,
        shareIndex: shareIndex,
        displayStyle: displayStyle,
        defaultValue: defaultValue
      };
    },
    getDisplayValueByStyle: function getDisplayValueByStyle(value, style) {
      value = this.removeOtherRadioPrefix(value);
      if (!style) {
        return value;
      }
      if (style === 'star-5') {
        var numberVal = Number(value);
        if (numberVal < 1 && numberVal > 5) {
          numberVal = 0;
        }
        var result = '';
        for (var index = 0; index < 5; index++) {
          if (index + 1 <= numberVal) {
            result += "<i class=\"material-icons\"> star </i>";
          } else {
            result += "<i class=\"material-icons\"> star_outline </i>";
          }
        }
        return result;
      } else if (style === 'month-year') {
        return this.getDisplayMonthYear(value);
      } else if (style === 'month-day-year') {
        return this.getDisplayMonthDayYear(value);
      } else if (style === 'age') {
        if (!value) {
          return "";
        }
        return this.getAge(value);
      } else {
        return value;
      }
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lecture 346


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _generalSettings = __webpack_require__(815);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
  computed: {},
  methods: {
    updateUserStatus: function updateUserStatus(user, status, author) {
      var _this = this;

      var isShowResult = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var reason = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      return regeneratorRuntime.async(function updateUserStatus$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (author == null) {
                author = user;
              }
              return _context2.abrupt("return", new Promise(function _callee(resolve, reject) {
                var res, isEmailSent;
                return regeneratorRuntime.async(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.post("/set-user-status/", {
                          id: user.id,
                          status: status
                        }));

                      case 2:
                        res = _context.sent;

                        if (res == null) {
                          reject();
                        }
                        _context.next = 6;
                        return regeneratorRuntime.awrap(_this.handleAfterUserStatusChanged(user, status, author, reason));

                      case 6:
                        isEmailSent = _context.sent;

                        if (isShowResult) {
                          _this.showResultDialog('STATUS_UPDATED_RESULT_DIALOG');
                        }
                        resolve(isEmailSent);

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, null, _this);
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    },
    handleAfterUserStatusChanged: function handleAfterUserStatusChanged(user, status, author, reason, isSecondStatus) {
      var _this2 = this;

      var isInApplicationForm = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      if (author == null) {
        author = user;
      }
      return new Promise(function _callee2(resolve, reject) {
        var selector1, isEmailSent, res, evaluationTemplates, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, template, requestBody;

        return regeneratorRuntime.async(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                selector1 = "";

                if (!user.is_candidate) {
                  _context3.next = 7;
                  break;
                }

                selector1 = "Candidate";
                // Check to send reference check form
                _context3.next = 5;
                return regeneratorRuntime.awrap(_this2.sendCheckFormToUserReferences(user, status));

              case 5:
                _context3.next = 8;
                break;

              case 7:
                if (user.is_employer) {
                  selector1 = "Client";
                }

              case 8:
                isEmailSent = false;

                if (isInApplicationForm) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 12;
                return regeneratorRuntime.awrap(_this2.sendEmailToUserAfterStatusChange(user, author, status, selector1, isSecondStatus));

              case 12:
                isEmailSent = _context3.sent;
                _context3.next = 15;
                return regeneratorRuntime.awrap(_this2.sendUserStatusChangeNotificationToAdmin(user, status, isSecondStatus));

              case 15:
                _context3.next = 17;
                return regeneratorRuntime.awrap(_this2.sendEmailStatusChangeNotificationToReferences(user, status));

              case 17:
                _context3.next = 19;
                return regeneratorRuntime.awrap(_this2.sendSMSStatusChangeNotificationToReferences(user, status));

              case 19:
                _context3.next = 21;
                return regeneratorRuntime.awrap(_this2.sendUserStatusChangeNotificationSMS(user, status, isSecondStatus));

              case 21:
                if (isInApplicationForm) {
                  _context3.next = 61;
                  break;
                }

                _context3.next = 24;
                return regeneratorRuntime.awrap(_this2.addDocumentAfterStatusChange({ user: user, status: status, selector1: selector1, isSecondStatus: isSecondStatus, isShowStatusDialog: false }));

              case 24:
                _context3.next = 26;
                return regeneratorRuntime.awrap(_axios2.default.get("/api/evaluationtemplates/?agency=" + _this2.$store.getters.agencyID + "&status_trigger=" + encodeURIComponent(status) + "&user_type=" + selector1));

              case 26:
                res = _context3.sent;

                if (res == null) {
                  reject();
                }
                evaluationTemplates = _this2.filterTemplatesByUserTypes(user, res.data);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 32;
                _iterator = evaluationTemplates[Symbol.iterator]();

              case 34:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 41;
                  break;
                }

                template = _step.value;
                _context3.next = 38;
                return regeneratorRuntime.awrap(_axios2.default.post("/api/evaluations/", {
                  name: template.name,
                  template: template.id,
                  order: template.order,
                  user: user.id,
                  status: "Not Started",
                  agency_owner: _this2.$store.getters.agencyName,
                  agency: _this2.$store.getters.agencyID
                }));

              case 38:
                _iteratorNormalCompletion = true;
                _context3.next = 34;
                break;

              case 41:
                _context3.next = 47;
                break;

              case 43:
                _context3.prev = 43;
                _context3.t0 = _context3["catch"](32);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 47:
                _context3.prev = 47;
                _context3.prev = 48;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 50:
                _context3.prev = 50;

                if (!_didIteratorError) {
                  _context3.next = 53;
                  break;
                }

                throw _iteratorError;

              case 53:
                return _context3.finish(50);

              case 54:
                return _context3.finish(47);

              case 55:

                // Keep track of status changes when a status is updated. -  Posts status change, timestamp and changer.
                requestBody = {
                  user: user.id,
                  name: user.first_name + " " + user.last_name,
                  changer: author.id,
                  changer_name: author.first_name + " " + author.last_name,
                  is_candidate: user.is_candidate,
                  is_employer: user.is_employer,
                  reason: reason ? reason.reason : null,
                  reason_note: reason ? reason.note : null,
                  agency: _this2.$store.getters.agencyID,
                  agency_owner: _this2.$store.getters.agencyName
                };

                if (isSecondStatus) {
                  requestBody.second_status = status;
                } else {
                  requestBody.status = status;
                }
                _context3.next = 59;
                return regeneratorRuntime.awrap(_axios2.default.post("/api/statuschanges/", requestBody));

              case 59:
                res = _context3.sent;

                if (res == null) {
                  reject();
                }

              case 61:
                resolve(isEmailSent);

              case 62:
              case "end":
                return _context3.stop();
            }
          }
        }, null, _this2, [[32, 43, 47, 55], [48,, 50, 54]]);
      });
    },
    sendEmailToUserAfterStatusChange: function sendEmailToUserAfterStatusChange(user, author, status, selector1, isSecondStatus) {
      var _this3 = this;

      return new Promise(function _callee3(resolve, reject) {
        var templateType, res, hasSendEmailDialog, emailTemplates, emailTemplate, documentLinks, listDocumentLinks, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, templateId, _document, documentLink, mapReplaceValues, subject, message, emailObject;

        return regeneratorRuntime.async(function _callee3$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                templateType = isSecondStatus ? 'Second Status Change Notification' : 'Status Change Notification';
                // Get the email template corresponding to the new status

                _context5.next = 3;
                return regeneratorRuntime.awrap(_this3.getEmailTemplates("/api/emailtemplates/?agency=" + _this3.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=" + templateType + "&selector1=" + selector1 + "&deactivated=false"));

              case 3:
                res = _context5.sent;

                if (res == null || res.data == null) {
                  reject();
                }
                hasSendEmailDialog = false;

                if (!res.data.length) {
                  _context5.next = 68;
                  break;
                }

                // If there is an email template for this new status
                emailTemplates = res.data;
                emailTemplate = _this3.findEmailTemplatesByUserTypes(user, emailTemplates);

                if (!emailTemplate) {
                  _context5.next = 68;
                  break;
                }

                documentLinks = '';
                // Check to add document template

                if (!emailTemplate.list_document_template_ids) {
                  _context5.next = 46;
                  break;
                }

                listDocumentLinks = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 16;
                _iterator2 = emailTemplate.list_document_template_ids[Symbol.iterator]();

              case 18:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context5.next = 31;
                  break;
                }

                templateId = _step2.value;
                _context5.next = 22;
                return regeneratorRuntime.awrap(_this3.addDocumentToUser(null, user, templateId));

              case 22:
                _document = _context5.sent;

                if (!_document) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 26;
                return regeneratorRuntime.awrap(_this3.getShareableDocumentUrl(user, _document.id));

              case 26:
                documentLink = _context5.sent;

                listDocumentLinks.push("<a href=\"" + documentLink + "\" _target=\"blank\">" + _document.title + "</a>");

              case 28:
                _iteratorNormalCompletion2 = true;
                _context5.next = 18;
                break;

              case 31:
                _context5.next = 37;
                break;

              case 33:
                _context5.prev = 33;
                _context5.t0 = _context5["catch"](16);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 37:
                _context5.prev = 37;
                _context5.prev = 38;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 40:
                _context5.prev = 40;

                if (!_didIteratorError2) {
                  _context5.next = 43;
                  break;
                }

                throw _iteratorError2;

              case 43:
                return _context5.finish(40);

              case 44:
                return _context5.finish(37);

              case 45:
                documentLinks = listDocumentLinks.join(', ');

              case 46:
                _context5.t1 = user.first_name;
                _context5.t2 = user.last_name;
                _context5.t3 = user.email;
                _context5.t4 = user.id;
                _context5.next = 52;
                return regeneratorRuntime.awrap(_this3.getPublicVideoRecordingLink(user.id));

              case 52:
                _context5.t5 = _context5.sent;
                _context5.next = 55;
                return regeneratorRuntime.awrap(_this3.getRecurringAvailabilityShareableUrl(user.id));

              case 55:
                _context5.t6 = _context5.sent;
                _context5.next = 58;
                return regeneratorRuntime.awrap(_this3.getMyCandidateShareableUrl(user.id));

              case 58:
                _context5.t7 = _context5.sent;
                _context5.t8 = documentLinks;
                _context5.t9 = documentLinks;
                mapReplaceValues = {
                  fname: _context5.t1,
                  lname: _context5.t2,
                  email: _context5.t3,
                  id: _context5.t4,
                  video_recording_link: _context5.t5,
                  recurring_availability_link: _context5.t6,
                  my_candidates_shareable_link: _context5.t7,
                  document_link: _context5.t8,
                  document_links: _context5.t9
                };
                subject = _this3.replaceTagByMap(emailTemplate.subject, mapReplaceValues);

                subject = _this3.replaceTagValue(subject, user);
                message = _this3.replaceTagByMap(emailTemplate.body, mapReplaceValues);

                message = _this3.replaceTagValue(message, user);
                emailObject = {
                  subject: subject,
                  message: message,
                  file_urls: emailTemplate.attachment_urls,
                  userID: user.id,
                  from: _this3.getEmailSenderFromEmailTemplate(emailTemplate),
                  reply: _this3.getReplyToFromEmailTemplate(emailTemplate),
                  cc: emailTemplate.cc,
                  bcc: emailTemplate.bcc,
                  excludeFooter: emailTemplate.exclude_footer,
                  status: status,
                  template: emailTemplate,
                  mapReplaceValues: mapReplaceValues
                };

                if (author && author.is_agent) {
                  hasSendEmailDialog = true;
                  // Want to show the pop up to edit the email before it goes out
                  _this3.showSendEmailDialog(_extends({}, emailObject, {
                    destination: user.email,
                    secondaryEmail: user.email2,
                    logMessage: false,
                    onCloseCallback: function onCloseCallback() {
                      return regeneratorRuntime.async(function onCloseCallback$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              resolve(true);

                            case 1:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, null, _this3);
                    }
                  }));
                } else {
                  // Send email without popup
                  _this3.sendEmail(_extends({}, emailObject, {
                    recipients: [_this3.$store.getters.enginehireLoggingEmail, user.email],
                    isHtml: true
                  }));
                }

              case 68:
                if (!hasSendEmailDialog) {
                  resolve();
                }

              case 69:
              case "end":
                return _context5.stop();
            }
          }
        }, null, _this3, [[16, 33, 37, 45], [38,, 40, 44]]);
      });
    },
    addDocumentAfterStatusChange: function addDocumentAfterStatusChange(_ref) {
      var _this4 = this;

      var user = _ref.user,
          status = _ref.status,
          selector1 = _ref.selector1,
          isSecondStatus = _ref.isSecondStatus,
          isShowStatusDialog = _ref.isShowStatusDialog;

      this.$store.dispatch("updateShowStatusDialog", isShowStatusDialog);
      return new Promise(function _callee4(resolve, reject) {
        var statusTriggerKey, res, listTemplates, hasAddDocDialog, templates, listExistingDocTemplateIds, mapDisplayedOptions, listDefaultSelected, duplicatedTemplates, templateList;
        return regeneratorRuntime.async(function _callee4$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                statusTriggerKey = isSecondStatus ? 'second_status_trigger' : 'status_trigger';
                // Get any document templates that trigger on a change to this status

                _context7.next = 3;
                return regeneratorRuntime.awrap(_axios2.default.get("/api/documenttemplates/?agency=" + _this4.$store.getters.agencyID + "&" + statusTriggerKey + "=" + encodeURIComponent(status) + "&type=" + selector1));

              case 3:
                res = _context7.sent;

                if (res == null) {
                  reject();
                }
                listTemplates = res.data;
                // Filter in case both status and second_status is set

                if (isSecondStatus) {
                  listTemplates = listTemplates.filter(function (template) {
                    return !template.status_trigger || template.status_trigger === user.status;
                  });
                } else {
                  listTemplates = listTemplates.filter(function (template) {
                    return !template.second_status_trigger || template.second_status_trigger === user.second_status;
                  });
                }
                hasAddDocDialog = false;
                templates = _this4.filterTemplatesByUserTypes(user, listTemplates);

                if (!(templates && templates.length)) {
                  _context7.next = 28;
                  break;
                }

                if (!_this4.$store.getters.isAgent) {
                  _context7.next = 26;
                  break;
                }

                // Show dialog to let admin select documents to add to user
                listExistingDocTemplateIds = [];

                if (user.documents) {
                  listExistingDocTemplateIds = user.documents.map(function (document) {
                    return document.template;
                  });
                }
                mapDisplayedOptions = {};
                // Select non-duplicated items by default

                listDefaultSelected = [];
                duplicatedTemplates = [];

                templates.forEach(function (template) {
                  if (listExistingDocTemplateIds.includes(template.id)) {
                    mapDisplayedOptions[template.id] = template.name + " (<b>Duplicated</b>)";
                    duplicatedTemplates.push(template.id);
                  } else {
                    listDefaultSelected.push(template.id);
                    mapDisplayedOptions[template.id] = "" + template.name;
                  }
                });
                hasAddDocDialog = true;
                templateList = templates;

                if (_this4.$store.getters.doNotShowDuplicatedDocumentsUpdatingStatus) {
                  templateList = templateList.filter(function (template) {
                    return !duplicatedTemplates.includes(template.id);
                  });
                }

                if (!_this4.tryGet(function () {
                  return templateList.length;
                })) {
                  _context7.next = 23;
                  break;
                }

                _this4.showInputDialog({
                  title: "Select Documents",
                  listFields: [{
                    label: "Select Documents to Add to the User",
                    type: _customDefineType.FORM_TYPE.CHECKBOX,
                    model: "selectedTemplates",
                    optionList: templateList.map(function (template) {
                      return template.id;
                    }),
                    mapDisplayedOptions: mapDisplayedOptions,
                    isHtml: true,
                    isRequired: false,
                    buttonGroups: [{
                      id: "agency-setting",
                      useSmallIcon: true,
                      listSettings: _generalSettings.DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS,
                      onSubmitCallback: _this4.addDocumentAfterStatusChange,
                      onSubmitCallbackData: {
                        user: user,
                        status: status,
                        selector1: selector1,
                        isSecondStatus: isSecondStatus,
                        isShowStatusDialog: true
                      }
                    }]
                  }],
                  data: {
                    selectedTemplates: listDefaultSelected
                  },
                  onSubmitCallback: function onSubmitCallback(info) {
                    var listSelectedTemplates;
                    return regeneratorRuntime.async(function onSubmitCallback$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!info.selectedTemplates) {
                              _context6.next = 7;
                              break;
                            }

                            console.log(templates);
                            listSelectedTemplates = templates.filter(function (template) {
                              return info.selectedTemplates.includes(template.id);
                            });

                            console.log(info.selectedTemplates);
                            console.log(listSelectedTemplates);
                            _context6.next = 7;
                            return regeneratorRuntime.awrap(_this4.addDocumentsToUser(listSelectedTemplates, user));

                          case 7:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, null, _this4);
                  },
                  onCloseCallback: function onCloseCallback() {
                    if (!_this4.$store.getters.showStatusDialog) {
                      resolve();
                    }
                  }
                });
                return _context7.abrupt("return");

              case 23:
                resolve();
                _context7.next = 28;
                break;

              case 26:
                _context7.next = 28;
                return regeneratorRuntime.awrap(_this4.addDocumentsToUser(templates, user));

              case 28:
                if (!hasAddDocDialog) {
                  resolve();
                }

              case 29:
              case "end":
                return _context7.stop();
            }
          }
        }, null, _this4);
      });
    },
    addDocumentToUser: function addDocumentToUser(template, user) {
      var templateId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var templateRes, res;
      return regeneratorRuntime.async(function addDocumentToUser$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (template) {
                _context8.next = 5;
                break;
              }

              _context8.next = 3;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/documenttemplates/" + templateId));

            case 3:
              templateRes = _context8.sent;

              if (templateRes && templateRes.data) {
                template = templateRes.data;
              }

            case 5:
              if (template) {
                _context8.next = 7;
                break;
              }

              return _context8.abrupt("return");

            case 7:
              _context8.next = 9;
              return regeneratorRuntime.awrap(_axios2.default.post("/api/documents/", {
                template: template.id,
                title: template.name,
                signing_user: user.id,
                status: "Unsigned",
                body: template.body,
                fields_labels: template.fields,
                fields_required: template.fields_required,
                list_fields: template.list_fields,
                edit_access: template.edit_access,
                organization_signer: template.organization_signer,
                signer_labels: template.signer_labels,
                signing_notification_emails: template.signing_notification_emails,
                agency_owner: this.$store.getters.agencyName,
                agency: this.$store.getters.agencyID,
                sign_by_both: template.sign_by_both,
                status_to_update_to: template.status_to_update_to,
                signer_types: template.signer_types,
                order: template.order,
                use_image: template.use_image,
                params: template.params
              }));

            case 9:
              res = _context8.sent;

              if (!(res && res.data)) {
                _context8.next = 12;
                break;
              }

              return _context8.abrupt("return", res.data);

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    },
    addDocumentsToUser: function addDocumentsToUser(templates, user) {
      var _this5 = this;

      return new Promise(function _callee5(resolve) {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, template;

        return regeneratorRuntime.async(function _callee5$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context9.prev = 3;
                _iterator3 = templates[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context9.next = 12;
                  break;
                }

                template = _step3.value;
                _context9.next = 9;
                return regeneratorRuntime.awrap(_this5.addDocumentToUser(template, user));

              case 9:
                _iteratorNormalCompletion3 = true;
                _context9.next = 5;
                break;

              case 12:
                _context9.next = 18;
                break;

              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9["catch"](3);
                _didIteratorError3 = true;
                _iteratorError3 = _context9.t0;

              case 18:
                _context9.prev = 18;
                _context9.prev = 19;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 21:
                _context9.prev = 21;

                if (!_didIteratorError3) {
                  _context9.next = 24;
                  break;
                }

                throw _iteratorError3;

              case 24:
                return _context9.finish(21);

              case 25:
                return _context9.finish(18);

              case 26:
                if (_this5.$store.getters.showStatusDialog) {
                  _this5.showResultDialog(_this5.$store.getters.statusUpdatedResultDialog);
                }
                resolve();

              case 28:
              case "end":
                return _context9.stop();
            }
          }
        }, null, _this5, [[3, 14, 18, 26], [19,, 21, 25]]);
      });
    },
    sendCheckFormToUserReferences: function sendCheckFormToUserReferences(user, status) {
      var _this6 = this;

      return new Promise(function _callee6(resolve) {
        var applicationFormId, listBuilder, profileBuilder, listFields, listReferenceFields, listReferences, listExperiences, listData, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, referenceField, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, data;

        return regeneratorRuntime.async(function _callee6$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                applicationFormId = user.application_form;

                if (typeof applicationFormId !== "number") {
                  applicationFormId = user.application_form_id;
                }
                listBuilder = _this6.$store.getters.profileBuilderList.sort(function (a, b) {
                  return a.id - b.id;
                });
                profileBuilder = listBuilder.find(function (builder) {
                  return builder.id === applicationFormId;
                });

                if (!profileBuilder) {
                  // Find corresponding profile builder
                  profileBuilder = listBuilder.find(function (builder) {
                    return builder.application_builder_id === applicationFormId && builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
                  });
                }

                if (profileBuilder == null) {
                  // For old data, which is not set applicaiton_form, no profile builder => use application builder
                  profileBuilder = listBuilder.find(function (builder) {
                    return builder.type === _customDefineType.BUILDER_TYPE.APPLICATION && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
                  });
                }

                if (profileBuilder == null) {
                  // For old data, which is not set applicaiton_form, find one profile builder
                  profileBuilder = listBuilder.find(function (builder) {
                    return builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE;
                  });
                }

                if (!(profileBuilder == null)) {
                  _context10.next = 10;
                  break;
                }

                resolve();
                return _context10.abrupt("return");

              case 10:
                listFields = _this6.mergeBuilders(profileBuilder, listBuilder, true).listFields;

                if (listFields) {
                  _context10.next = 14;
                  break;
                }

                resolve();
                return _context10.abrupt("return");

              case 14:
                listReferenceFields = listFields.filter(function (field) {
                  return field.referenceCheckFormAutoSend && field.checkFormTriggerStatus === status;
                });
                listReferences = null;
                listExperiences = null;
                listData = null;
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context10.prev = 21;
                _iterator4 = listReferenceFields[Symbol.iterator]();

              case 23:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context10.next = 68;
                  break;
                }

                referenceField = _step4.value;

                if (!(referenceField.name === "Experience")) {
                  _context10.next = 33;
                  break;
                }

                if (!(listExperiences == null)) {
                  _context10.next = 30;
                  break;
                }

                _context10.next = 29;
                return regeneratorRuntime.awrap(_this6.getListExperiences(user));

              case 29:
                listExperiences = _context10.sent;

              case 30:
                listData = listExperiences;
                _context10.next = 38;
                break;

              case 33:
                if (!(listReferences == null)) {
                  _context10.next = 37;
                  break;
                }

                _context10.next = 36;
                return regeneratorRuntime.awrap(_this6.getListReferences(user));

              case 36:
                listReferences = _context10.sent;

              case 37:
                listData = listReferences;

              case 38:
                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context10.prev = 41;
                _iterator5 = listData[Symbol.iterator]();

              case 43:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context10.next = 51;
                  break;
                }

                data = _step5.value;

                if (!_this6.isMatchField(referenceField, data, listFields)) {
                  _context10.next = 48;
                  break;
                }

                _context10.next = 48;
                return regeneratorRuntime.awrap(_this6.sendReferenceCheckFormEmail(profileBuilder.id, data.id, referenceField, data, user));

              case 48:
                _iteratorNormalCompletion5 = true;
                _context10.next = 43;
                break;

              case 51:
                _context10.next = 57;
                break;

              case 53:
                _context10.prev = 53;
                _context10.t0 = _context10["catch"](41);
                _didIteratorError5 = true;
                _iteratorError5 = _context10.t0;

              case 57:
                _context10.prev = 57;
                _context10.prev = 58;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 60:
                _context10.prev = 60;

                if (!_didIteratorError5) {
                  _context10.next = 63;
                  break;
                }

                throw _iteratorError5;

              case 63:
                return _context10.finish(60);

              case 64:
                return _context10.finish(57);

              case 65:
                _iteratorNormalCompletion4 = true;
                _context10.next = 23;
                break;

              case 68:
                _context10.next = 74;
                break;

              case 70:
                _context10.prev = 70;
                _context10.t1 = _context10["catch"](21);
                _didIteratorError4 = true;
                _iteratorError4 = _context10.t1;

              case 74:
                _context10.prev = 74;
                _context10.prev = 75;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 77:
                _context10.prev = 77;

                if (!_didIteratorError4) {
                  _context10.next = 80;
                  break;
                }

                throw _iteratorError4;

              case 80:
                return _context10.finish(77);

              case 81:
                return _context10.finish(74);

              case 82:
                resolve();

              case 83:
              case "end":
                return _context10.stop();
            }
          }
        }, null, _this6, [[21, 70, 74, 82], [41, 53, 57, 65], [58,, 60, 64], [75,, 77, 81]]);
      });
    },
    sendReferenceCheckFormEmail: function sendReferenceCheckFormEmail(profileBuilderId, referenceId, referenceField, referenceData, user) {
      var _this7 = this;

      return new Promise(function _callee7(resolve) {
        var resHasNum, checkFormToken, refCheckUrl, hasEmailTemplate, res, emailTemplate, referenceName, mapReplaceValues, userShareableLink, subject, message;
        return regeneratorRuntime.async(function _callee7$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return regeneratorRuntime.awrap(_axios2.default.post("/hash-num", { id: referenceId }));

              case 2:
                resHasNum = _context11.sent;

                if (resHasNum == null || resHasNum.data == null) {
                  resolve();
                }
                checkFormToken = void 0;

                if (referenceField.name === "Experience") {
                  checkFormToken = "/experience-check-form/";
                } else {
                  checkFormToken = "/reference-check-form/";
                }
                refCheckUrl = _this7.rootUrl + checkFormToken + profileBuilderId + "/" + resHasNum.data.key;
                // Get email template if it is set

                hasEmailTemplate = false;

                if (!referenceField.referenceNotificationEmailTemplateId) {
                  _context11.next = 26;
                  break;
                }

                _context11.next = 11;
                return regeneratorRuntime.awrap(_axios2.default.get("/api/emailtemplates/" + referenceField.referenceNotificationEmailTemplateId + "/"));

              case 11:
                res = _context11.sent;

                if (!(res && res.data)) {
                  _context11.next = 26;
                  break;
                }

                emailTemplate = res.data;
                referenceName = referenceData.first_name;

                if (!referenceName) {
                  referenceName = referenceData.person_worked_for_name;
                }
                mapReplaceValues = {
                  reference_fname: referenceName,
                  user_fname: user.first_name,
                  user_lname: user.last_name,
                  reference_check_link: refCheckUrl
                };

                if (!(emailTemplate.subject && emailTemplate.subject.includes("[[user_shareable_link]]") || emailTemplate.body && emailTemplate.body.includes("[[user_shareable_link]]"))) {
                  _context11.next = 22;
                  break;
                }

                _context11.next = 20;
                return regeneratorRuntime.awrap(_this7.getShareableURL(user, true));

              case 20:
                userShareableLink = _context11.sent;

                mapReplaceValues["user_shareable_link"] = userShareableLink;

              case 22:
                subject = _this7.replaceTagByMap(emailTemplate.subject, mapReplaceValues);
                message = _this7.replaceTagByMap(emailTemplate.body, mapReplaceValues);

                _this7.sendEmail({
                  subject: subject,
                  message: message,
                  recipients: [referenceData.email],
                  isHtml: true
                });
                hasEmailTemplate = true;

              case 26:
                // Send predefined email template
                if (!hasEmailTemplate) {
                  _this7.sendEmail(_extends({}, _this7.$store.getters.referenceCheckFormEmailTemplate, {
                    recipients: [referenceData.email],
                    isHtml: true
                  }), user.first_name, user.last_name, referenceData.first_name, referenceData.last_name, refCheckUrl, _this7.$store.getters.agencyPublic.human_name);
                }
                resolve();

              case 28:
              case "end":
                return _context11.stop();
            }
          }
        }, null, _this7);
      });
    },

    // Check if a reference/experience is match with a reference field
    isMatchField: function isMatchField(field, data, listFields) {
      if (data.type === field.label) {
        return true;
      }
      // If there is only one reference or one experience field
      if (field.name === "Experience") {
        if (listFields.filter(function (field) {
          return field.name === "Experience";
        }).length === 1) {
          return true;
        }
      } else {
        if (listFields.filter(function (field) {
          return field.name === "Reference";
        }).length === 1) {
          return true;
        }
      }
      return false;
    },
    getListReferences: function getListReferences(user) {
      var _this8 = this;

      return regeneratorRuntime.async(function getListReferences$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise(function _callee8(resolve, reject) {
                var res;
                return regeneratorRuntime.async(function _callee8$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/references/?user=" + user.id));

                      case 2:
                        res = _context12.sent;

                        if (!res) {
                          reject();
                        }
                        resolve(res.data);

                      case 5:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, null, _this8);
              }));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    },
    getListExperiences: function getListExperiences(user) {
      var _this9 = this;

      return regeneratorRuntime.async(function getListExperiences$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", new Promise(function _callee9(resolve, reject) {
                var res;
                return regeneratorRuntime.async(function _callee9$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/experiences/?user=" + user.id));

                      case 2:
                        res = _context14.sent;

                        if (!res) {
                          reject();
                        }
                        resolve(res.data);

                      case 5:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, null, _this9);
              }));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, null, this);
    },
    sendUserStatusChangeNotificationToAdmin: function sendUserStatusChangeNotificationToAdmin(user, status, isSecondStatus) {
      var _this10 = this;

      return new Promise(function _callee10(resolve, reject) {
        var templateType, res, hasEmailPopup, emailTemplates, emailTemplate, candidateShareableLink, clientShareableLink, mapReplaceValues, subject, message, emailObject;
        return regeneratorRuntime.async(function _callee10$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                templateType = isSecondStatus ? 'Second Status Change Notification' : 'Status Change Notification';
                // Get the email template corresponding to the new status

                _context17.next = 3;
                return regeneratorRuntime.awrap(_this10.getEmailTemplates("/api/emailtemplates/?agency=" + _this10.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=" + templateType + "&selector1=Admin&deactivated=false"));

              case 3:
                res = _context17.sent;

                if (res == null || res.data == null) {
                  reject();
                }
                hasEmailPopup = false;

                if (!res.data.length) {
                  _context17.next = 20;
                  break;
                }

                // If there is an email template for this new status
                emailTemplates = res.data;
                emailTemplate = _this10.findEmailTemplatesByUserTypes(user, emailTemplates);
                candidateShareableLink = null;
                clientShareableLink = null;

                if (!user.is_candidate) {
                  _context17.next = 15;
                  break;
                }

                _context17.next = 14;
                return regeneratorRuntime.awrap(_this10.getShareableURL(user, true));

              case 14:
                candidateShareableLink = _context17.sent;

              case 15:
                if (!user.is_employer) {
                  _context17.next = 19;
                  break;
                }

                _context17.next = 18;
                return regeneratorRuntime.awrap(_this10.getShareableURL(user, false));

              case 18:
                clientShareableLink = _context17.sent;

              case 19:

                if (emailTemplate) {
                  mapReplaceValues = {
                    fname: user.first_name,
                    lname: user.last_name,
                    email: user.email,
                    id: user.id,
                    candidate_shareable_link: candidateShareableLink || '',
                    client_shareable_link: clientShareableLink || ''
                  };
                  subject = _this10.replaceTagByMap(emailTemplate.subject, mapReplaceValues);
                  message = _this10.replaceTagByMap(emailTemplate.body, mapReplaceValues);
                  emailObject = {
                    subject: subject,
                    message: message,
                    file_urls: emailTemplate.attachment_urls,
                    userID: user.id,
                    from: _this10.getEmailSenderFromEmailTemplate(emailTemplate),
                    reply: _this10.getReplyToFromEmailTemplate(emailTemplate),
                    cc: emailTemplate.cc,
                    bcc: emailTemplate.bcc,
                    excludeFooter: emailTemplate.exclude_footer,
                    status: status,
                    template: emailTemplate,
                    mapReplaceValues: mapReplaceValues
                  };

                  if (_this10.$store.getters.isAgent) {
                    hasEmailPopup = true;
                    // Send email with popup
                    _this10.showSendEmailDialog(_extends({}, emailObject, {
                      destination: emailTemplate.destinations.join(';'),
                      secondaryEmail: user.email2,
                      logMessage: true,
                      onCloseCallback: function onCloseCallback() {
                        return regeneratorRuntime.async(function onCloseCallback$(_context16) {
                          while (1) {
                            switch (_context16.prev = _context16.next) {
                              case 0:
                                resolve(true);

                              case 1:
                              case "end":
                                return _context16.stop();
                            }
                          }
                        }, null, _this10);
                      }
                    }));
                  } else {
                    // Send email without popup
                    _this10.sendEmail(_extends({}, emailObject, {
                      recipients: [_this10.$store.getters.enginehireLoggingEmail].concat(_toConsumableArray(emailTemplate.destinations)),
                      logMessage: true,
                      isHtml: true
                    }));
                  }
                }

              case 20:
                if (!hasEmailPopup) {
                  resolve();
                }

              case 21:
              case "end":
                return _context17.stop();
            }
          }
        }, null, _this10);
      });
    },
    sendEmailStatusChangeNotificationToReferences: function sendEmailStatusChangeNotificationToReferences(user, status) {
      var _this11 = this;

      return new Promise(function _callee11(resolve, reject) {
        var templateType, userType, res, emailTemplates, emailTemplate, listReferences, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, reference, mapReplaceValues;

        return regeneratorRuntime.async(function _callee11$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                templateType = 'Status Change Notification';
                userType = user.is_candidate ? 'Candidate' : 'Client';
                // Get the email template corresponding to the new status

                _context18.next = 4;
                return regeneratorRuntime.awrap(_this11.getEmailTemplates("/api/emailtemplates/?agency=" + _this11.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=" + templateType + "&selector1=Reference&selector3=" + userType + "&deactivated=false"));

              case 4:
                res = _context18.sent;

                if (res == null || res.data == null) {
                  reject();
                }

                if (!res.data.length) {
                  _context18.next = 40;
                  break;
                }

                // If there is an email template for this new status
                emailTemplates = res.data;
                emailTemplate = _this11.findEmailTemplatesByUserTypes(user, emailTemplates);

                if (!emailTemplate) {
                  _context18.next = 40;
                  break;
                }

                _context18.next = 12;
                return regeneratorRuntime.awrap(_this11.getListReferences(user));

              case 12:
                listReferences = _context18.sent;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context18.prev = 16;
                _iterator6 = listReferences[Symbol.iterator]();

              case 18:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context18.next = 26;
                  break;
                }

                reference = _step6.value;
                mapReplaceValues = {
                  fname: user.first_name,
                  lname: user.last_name,
                  email: user.email,
                  id: user.id,
                  reference_fname: reference.first_name,
                  reference_lname: reference.last_name
                };
                _context18.next = 23;
                return regeneratorRuntime.awrap(_this11.sendEmailToUser(reference, emailTemplate, mapReplaceValues, status));

              case 23:
                _iteratorNormalCompletion6 = true;
                _context18.next = 18;
                break;

              case 26:
                _context18.next = 32;
                break;

              case 28:
                _context18.prev = 28;
                _context18.t0 = _context18["catch"](16);
                _didIteratorError6 = true;
                _iteratorError6 = _context18.t0;

              case 32:
                _context18.prev = 32;
                _context18.prev = 33;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 35:
                _context18.prev = 35;

                if (!_didIteratorError6) {
                  _context18.next = 38;
                  break;
                }

                throw _iteratorError6;

              case 38:
                return _context18.finish(35);

              case 39:
                return _context18.finish(32);

              case 40:
                resolve();

              case 41:
              case "end":
                return _context18.stop();
            }
          }
        }, null, _this11, [[16, 28, 32, 40], [33,, 35, 39]]);
      });
    },
    sendSMSStatusChangeNotificationToReferences: function sendSMSStatusChangeNotificationToReferences(user, status) {
      var _this12 = this;

      return new Promise(function _callee12(resolve, reject) {
        var templateType, userType, res, emailTemplate, listReferences, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, reference, mapReplaceValues;

        return regeneratorRuntime.async(function _callee12$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                templateType = 'Status Change Notification';
                userType = user.is_candidate ? 'Candidate' : 'Client';
                // Get the email template corresponding to the new status

                _context19.next = 4;
                return regeneratorRuntime.awrap(_this12.getEmailTemplates("/api/smstemplates/?agency=" + _this12.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=" + templateType + "&selector1=Reference&selector3=" + userType + "&deactivated=false"));

              case 4:
                res = _context19.sent;

                if (res == null || res.data == null) {
                  reject();
                }

                if (!res.data.length) {
                  _context19.next = 39;
                  break;
                }

                // If there is an email template for this new status
                emailTemplate = _this12.findEmailTemplatesByUserTypes(user, res.data);

                if (!emailTemplate) {
                  _context19.next = 39;
                  break;
                }

                _context19.next = 11;
                return regeneratorRuntime.awrap(_this12.getListReferences(user));

              case 11:
                listReferences = _context19.sent;
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context19.prev = 15;
                _iterator7 = listReferences[Symbol.iterator]();

              case 17:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  _context19.next = 25;
                  break;
                }

                reference = _step7.value;
                mapReplaceValues = {
                  fname: user.first_name,
                  lname: user.last_name,
                  email: user.email,
                  id: user.id,
                  reference_fname: reference.first_name,
                  reference_lname: reference.last_name
                };
                _context19.next = 22;
                return regeneratorRuntime.awrap(_this12.sendSMSToUser(reference, emailTemplate, mapReplaceValues, user));

              case 22:
                _iteratorNormalCompletion7 = true;
                _context19.next = 17;
                break;

              case 25:
                _context19.next = 31;
                break;

              case 27:
                _context19.prev = 27;
                _context19.t0 = _context19["catch"](15);
                _didIteratorError7 = true;
                _iteratorError7 = _context19.t0;

              case 31:
                _context19.prev = 31;
                _context19.prev = 32;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 34:
                _context19.prev = 34;

                if (!_didIteratorError7) {
                  _context19.next = 37;
                  break;
                }

                throw _iteratorError7;

              case 37:
                return _context19.finish(34);

              case 38:
                return _context19.finish(31);

              case 39:
                resolve();

              case 40:
              case "end":
                return _context19.stop();
            }
          }
        }, null, _this12, [[15, 27, 31, 39], [32,, 34, 38]]);
      });
    },

    // General function to send email to client, candidate, admin, reference,
    sendEmailToUser: function sendEmailToUser(user, emailTemplate, mapReplaceValues, status) {
      var _this13 = this;

      return regeneratorRuntime.async(function sendEmailToUser$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              if (user.email) {
                _context22.next = 2;
                break;
              }

              return _context22.abrupt("return");

            case 2:
              return _context22.abrupt("return", new Promise(function _callee13(resolve) {
                var subject, message, emailObject;
                return regeneratorRuntime.async(function _callee13$(_context21) {
                  while (1) {
                    switch (_context21.prev = _context21.next) {
                      case 0:
                        subject = _this13.replaceTagByMap(emailTemplate.subject, mapReplaceValues);
                        message = _this13.replaceTagByMap(emailTemplate.body, mapReplaceValues);
                        emailObject = {
                          subject: subject,
                          message: message,
                          file_urls: emailTemplate.attachment_urls,
                          userID: user.id,
                          from: _this13.getEmailSenderFromEmailTemplate(emailTemplate),
                          reply: _this13.getReplyToFromEmailTemplate(emailTemplate),
                          cc: emailTemplate.cc,
                          bcc: emailTemplate.bcc,
                          excludeFooter: emailTemplate.exclude_footer,
                          status: status,
                          template: emailTemplate,
                          mapReplaceValues: mapReplaceValues
                        };

                        if (_this13.$store.getters.isAgent) {
                          // Send email with popup
                          _this13.showSendEmailDialog(_extends({}, emailObject, {
                            destination: user.email,
                            secondaryEmail: user.email2,
                            logMessage: true,
                            onCloseCallback: function onCloseCallback() {
                              return regeneratorRuntime.async(function onCloseCallback$(_context20) {
                                while (1) {
                                  switch (_context20.prev = _context20.next) {
                                    case 0:
                                      resolve();

                                    case 1:
                                    case "end":
                                      return _context20.stop();
                                  }
                                }
                              }, null, _this13);
                            }
                          }));
                        } else {
                          // Send email without popup
                          _this13.sendEmail(_extends({}, emailObject, {
                            recipients: [user.email],
                            logMessage: true,
                            isHtml: true
                          }));
                          resolve();
                        }

                      case 4:
                      case "end":
                        return _context21.stop();
                    }
                  }
                }, null, _this13);
              }));

            case 3:
            case "end":
              return _context22.stop();
          }
        }
      }, null, this);
    },
    sendSMSMessageToUser: function sendSMSMessageToUser(user, message) {
      var _this14 = this;

      return regeneratorRuntime.async(function sendSMSMessageToUser$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              if (user.phone) {
                _context25.next = 2;
                break;
              }

              return _context25.abrupt("return");

            case 2:
              return _context25.abrupt("return", new Promise(function _callee14(resolve) {
                return regeneratorRuntime.async(function _callee14$(_context24) {
                  while (1) {
                    switch (_context24.prev = _context24.next) {
                      case 0:
                        if (!_this14.$store.getters.isAgent) {
                          _context24.next = 4;
                          break;
                        }

                        _this14.showInputDialog({
                          title: "Send SMS Notification",
                          listFields: [{
                            label: "Phone",
                            type: _customDefineType.FORM_TYPE.LABEL,
                            model: user.phone
                          }, {
                            label: "Message",
                            type: _customDefineType.FORM_TYPE.TEXTAREA,
                            model: "message",
                            isCounter: true
                          }],
                          data: {
                            message: message
                          },
                          submitLabel: "Send",
                          onSubmitCallback: function onSubmitCallback(SMSInfo) {
                            return regeneratorRuntime.async(function onSubmitCallback$(_context23) {
                              while (1) {
                                switch (_context23.prev = _context23.next) {
                                  case 0:
                                    _context23.next = 2;
                                    return regeneratorRuntime.awrap(_axios2.default.post("/optimum/message/", {
                                      message: SMSInfo.message,
                                      phone: user.phone,
                                      user_id: user.id,
                                      from_phone: _this14.$store.getters.agency.twilio_phone_number ? _this14.$store.getters.agency.twilio_phone_number : "",
                                      agency_id: _this14.$store.getters.agencyID,
                                      log: true
                                    }));

                                  case 2:
                                  case "end":
                                    return _context23.stop();
                                }
                              }
                            }, null, _this14);
                          },
                          onCloseCallback: function onCloseCallback() {
                            resolve();
                          }
                        });
                        _context24.next = 7;
                        break;

                      case 4:
                        _context24.next = 6;
                        return regeneratorRuntime.awrap(_axios2.default.post("/optimum/message/", {
                          message: message,
                          phone: user.phone,
                          user_id: user.id,
                          from_phone: _this14.$store.getters.agency.twilio_phone_number ? _this14.$store.getters.agency.twilio_phone_number : "",
                          agency_id: _this14.$store.getters.agencyID,
                          log: true
                        }));

                      case 6:
                        resolve();

                      case 7:
                      case "end":
                        return _context24.stop();
                    }
                  }
                }, null, _this14);
              }));

            case 3:
            case "end":
              return _context25.stop();
          }
        }
      }, null, this);
    },
    sendSMSToUser: function sendSMSToUser(user, template, mapReplacedValues, tagInfo) {
      var _this15 = this;

      return regeneratorRuntime.async(function sendSMSToUser$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              if (user.phone) {
                _context27.next = 2;
                break;
              }

              return _context27.abrupt("return");

            case 2:
              return _context27.abrupt("return", new Promise(function _callee15(resolve) {
                var initialSMSMessage;
                return regeneratorRuntime.async(function _callee15$(_context26) {
                  while (1) {
                    switch (_context26.prev = _context26.next) {
                      case 0:
                        initialSMSMessage = _this15.replaceTagByMap(template.message, mapReplacedValues);

                        initialSMSMessage = _this15.replaceTagValue(initialSMSMessage, tagInfo);
                        _context26.next = 4;
                        return regeneratorRuntime.awrap(_this15.sendSMSMessageToUser(user, initialSMSMessage));

                      case 4:
                        resolve();

                      case 5:
                      case "end":
                        return _context26.stop();
                    }
                  }
                }, null, _this15);
              }));

            case 3:
            case "end":
              return _context27.stop();
          }
        }
      }, null, this);
    },
    sendJobSMSNotification: function sendJobSMSNotification(smsTemplate, job, client, candidate, target) {
      var _this16 = this;

      if (!target.phone) {
        return;
      }
      return new Promise(function _callee16(resolve) {
        var initialSMSMessage;
        return regeneratorRuntime.async(function _callee16$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (!smsTemplate) {
                  _context28.next = 9;
                  break;
                }

                _context28.next = 3;
                return regeneratorRuntime.awrap(_this16.makeJobStringSubstitutions(smsTemplate.message, job, client, candidate));

              case 3:
                initialSMSMessage = _context28.sent;
                _context28.next = 6;
                return regeneratorRuntime.awrap(_this16.sendSMSMessageToUser(target, initialSMSMessage));

              case 6:
                resolve();
                _context28.next = 10;
                break;

              case 9:
                resolve();

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, null, _this16);
      });
    },
    handleAfterBulkJobStatusChange: function handleAfterBulkJobStatusChange(listJobs, status) {
      var _this17 = this;

      return regeneratorRuntime.async(function handleAfterBulkJobStatusChange$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              return _context30.abrupt("return", new Promise(function _callee17(resolve, reject) {
                var res, listDates, listDatesCompressed, jobIds, jobLinks, mapReplaceValues, listUserEmails, listUserEmailsContent, emailTemplates, listPosterEmailTemplates, listFillerEmailTemplates, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, aJob, job, client, listFillers, posterEmailTemplate, subject, message, content, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, candidate, fillerEmailTemplate, _subject, _message, _content, _candidate, _posterEmailTemplate, _subject2, _message2, _content2, _fillerEmailTemplate, _subject3, _message3, _content3, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, userEmail;

                return regeneratorRuntime.async(function _callee17$(_context29) {
                  while (1) {
                    switch (_context29.prev = _context29.next) {
                      case 0:
                        _context29.next = 2;
                        return regeneratorRuntime.awrap(_this17.getEmailTemplates("/api/emailtemplates/?agency=" + _this17.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=Status Change Notification&selector1=Job&deactivated=false"));

                      case 2:
                        res = _context29.sent;

                        if (res == null || res.data == null) {
                          reject();
                        }

                        if (!res.data.length) {
                          _context29.next = 155;
                          break;
                        }

                        listDates = listJobs.map(function (job) {
                          return _this17.getDateString(job.date);
                        }).join(", ");
                        listDatesCompressed = listJobs.map(function (job) {
                          return _this17.compressDateFormat(job.date);
                        }).join(", ");
                        jobIds = listJobs.map(function (job) {
                          return job.id;
                        }).join(", ");
                        jobLinks = listJobs.map(function (job) {
                          return _this17.rootUrl + "/job/" + job.id;
                        }).join(', ');
                        mapReplaceValues = {
                          jobdates: listDates,
                          jobdates_compressed: listDatesCompressed,
                          jobdatestimes: _this17.getJobsDatesTimes(listJobs),
                          jobdatestimes_compressed: _this17.getJobsDatesTimesCompressed(listJobs),
                          jobids: jobIds,
                          joblinks: jobLinks
                        };
                        listUserEmails = [];
                        listUserEmailsContent = [];
                        // If there is an email template for this new status

                        emailTemplates = res.data;
                        listPosterEmailTemplates = emailTemplates.filter(function (template) {
                          return template.selector2 === "Job Poster";
                        });
                        listFillerEmailTemplates = emailTemplates.filter(function (template) {
                          return template.selector2 === "Job Filler";
                        });
                        _iteratorNormalCompletion8 = true;
                        _didIteratorError8 = false;
                        _iteratorError8 = undefined;
                        _context29.prev = 18;
                        _iterator8 = listJobs[Symbol.iterator]();

                      case 20:
                        if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                          _context29.next = 114;
                          break;
                        }

                        aJob = _step8.value;
                        _context29.next = 24;
                        return regeneratorRuntime.awrap(_this17.$store.dispatch('getJobFullInfo', aJob));

                      case 24:
                        job = _context29.sent;

                        // Send email to poster
                        client = void 0;

                        if (!job.poster) {
                          _context29.next = 31;
                          break;
                        }

                        _context29.next = 29;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/people/?id=" + job.poster));

                      case 29:
                        res = _context29.sent;

                        if (res && res.data && res.data.length) {
                          client = res.data[0];
                        }

                      case 31:
                        if (!_this17.$store.getters.multipleFillersShiftJob) {
                          _context29.next = 83;
                          break;
                        }

                        _context29.next = 34;
                        return regeneratorRuntime.awrap(_this17.$store.dispatch('getFillersOfJob', job));

                      case 34:
                        listFillers = _context29.sent;

                        if (!client) {
                          _context29.next = 46;
                          break;
                        }

                        posterEmailTemplate = _this17.findEmailTemplatesByUserTypes(client, listPosterEmailTemplates, job, client, listFillers.length ? listFillers[0] : {});

                        if (!posterEmailTemplate) {
                          _context29.next = 46;
                          break;
                        }

                        _context29.next = 40;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(posterEmailTemplate.subject, mapReplaceValues), job, client, listFillers.length ? listFillers[0] : {}));

                      case 40:
                        subject = _context29.sent;
                        _context29.next = 43;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(posterEmailTemplate.body, mapReplaceValues), job, client, listFillers.length ? listFillers[0] : {}));

                      case 43:
                        message = _context29.sent;
                        content = client.id + '-' + subject + message;

                        if (!listUserEmailsContent.includes(content)) {
                          listUserEmailsContent.push(content);
                          listUserEmails.push({
                            subject: subject,
                            message: message,
                            template: posterEmailTemplate,
                            user: client
                          });
                        }

                      case 46:
                        if (!listFillers.length) {
                          _context29.next = 81;
                          break;
                        }

                        _iteratorNormalCompletion10 = true;
                        _didIteratorError10 = false;
                        _iteratorError10 = undefined;
                        _context29.prev = 50;
                        _iterator10 = listFillers[Symbol.iterator]();

                      case 52:
                        if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                          _context29.next = 67;
                          break;
                        }

                        candidate = _step10.value;
                        fillerEmailTemplate = _this17.findEmailTemplatesByUserTypes(candidate, listFillerEmailTemplates, job, client || {}, candidate || {});

                        if (!fillerEmailTemplate) {
                          _context29.next = 64;
                          break;
                        }

                        _context29.next = 58;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(fillerEmailTemplate.subject, mapReplaceValues), job, client, candidate));

                      case 58:
                        _subject = _context29.sent;
                        _context29.next = 61;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(fillerEmailTemplate.body, mapReplaceValues), job, client, candidate));

                      case 61:
                        _message = _context29.sent;
                        _content = candidate.id + '-' + _subject + _message;

                        if (!listUserEmailsContent.includes(_content)) {
                          listUserEmailsContent.push(_content);
                          listUserEmails.push({
                            subject: _subject,
                            message: _message,
                            template: fillerEmailTemplate,
                            user: candidate
                          });
                        }

                      case 64:
                        _iteratorNormalCompletion10 = true;
                        _context29.next = 52;
                        break;

                      case 67:
                        _context29.next = 73;
                        break;

                      case 69:
                        _context29.prev = 69;
                        _context29.t0 = _context29["catch"](50);
                        _didIteratorError10 = true;
                        _iteratorError10 = _context29.t0;

                      case 73:
                        _context29.prev = 73;
                        _context29.prev = 74;

                        if (!_iteratorNormalCompletion10 && _iterator10.return) {
                          _iterator10.return();
                        }

                      case 76:
                        _context29.prev = 76;

                        if (!_didIteratorError10) {
                          _context29.next = 79;
                          break;
                        }

                        throw _iteratorError10;

                      case 79:
                        return _context29.finish(76);

                      case 80:
                        return _context29.finish(73);

                      case 81:
                        _context29.next = 111;
                        break;

                      case 83:
                        _candidate = void 0;

                        if (!job.filler) {
                          _context29.next = 89;
                          break;
                        }

                        _context29.next = 87;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/people/?id=" + job.filler));

                      case 87:
                        res = _context29.sent;

                        if (res && res.data && res.data.length) {
                          _candidate = res.data[0];
                        }

                      case 89:
                        if (!client) {
                          _context29.next = 100;
                          break;
                        }

                        _posterEmailTemplate = _this17.findEmailTemplatesByUserTypes(client, listPosterEmailTemplates, job, client, _candidate || {});

                        if (!_posterEmailTemplate) {
                          _context29.next = 100;
                          break;
                        }

                        _context29.next = 94;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(_posterEmailTemplate.subject, mapReplaceValues), job, client, _candidate));

                      case 94:
                        _subject2 = _context29.sent;
                        _context29.next = 97;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(_posterEmailTemplate.body, mapReplaceValues), job, client, _candidate));

                      case 97:
                        _message2 = _context29.sent;
                        _content2 = client.id + '-' + _subject2 + _message2;

                        if (!listUserEmailsContent.includes(_content2)) {
                          listUserEmailsContent.push(_content2);
                          listUserEmails.push({
                            subject: _subject2,
                            message: _message2,
                            template: _posterEmailTemplate,
                            user: client
                          });
                        }

                      case 100:
                        if (!_candidate) {
                          _context29.next = 111;
                          break;
                        }

                        _fillerEmailTemplate = _this17.findEmailTemplatesByUserTypes(_candidate, listFillerEmailTemplates, job, client || {}, _candidate || {});

                        if (!_fillerEmailTemplate) {
                          _context29.next = 111;
                          break;
                        }

                        _context29.next = 105;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(_fillerEmailTemplate.subject, mapReplaceValues), job, client, _candidate));

                      case 105:
                        _subject3 = _context29.sent;
                        _context29.next = 108;
                        return regeneratorRuntime.awrap(_this17.makeJobStringSubstitutions(_this17.replaceTagByMap(_fillerEmailTemplate.body, mapReplaceValues), job, client, _candidate));

                      case 108:
                        _message3 = _context29.sent;
                        _content3 = _candidate.id + '-' + _subject3 + _message3;

                        if (!listUserEmailsContent.includes(_content3)) {
                          listUserEmailsContent.push(_content3);
                          listUserEmails.push({
                            subject: _subject3,
                            message: _message3,
                            template: _fillerEmailTemplate,
                            user: _candidate
                          });
                        }

                      case 111:
                        _iteratorNormalCompletion8 = true;
                        _context29.next = 20;
                        break;

                      case 114:
                        _context29.next = 120;
                        break;

                      case 116:
                        _context29.prev = 116;
                        _context29.t1 = _context29["catch"](18);
                        _didIteratorError8 = true;
                        _iteratorError8 = _context29.t1;

                      case 120:
                        _context29.prev = 120;
                        _context29.prev = 121;

                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                          _iterator8.return();
                        }

                      case 123:
                        _context29.prev = 123;

                        if (!_didIteratorError8) {
                          _context29.next = 126;
                          break;
                        }

                        throw _iteratorError8;

                      case 126:
                        return _context29.finish(123);

                      case 127:
                        return _context29.finish(120);

                      case 128:
                        if (!listUserEmails.length) {
                          _context29.next = 155;
                          break;
                        }

                        _iteratorNormalCompletion9 = true;
                        _didIteratorError9 = false;
                        _iteratorError9 = undefined;
                        _context29.prev = 132;
                        _iterator9 = listUserEmails[Symbol.iterator]();

                      case 134:
                        if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                          _context29.next = 141;
                          break;
                        }

                        userEmail = _step9.value;
                        _context29.next = 138;
                        return regeneratorRuntime.awrap(_this17.sendEmailToJobUser(userEmail));

                      case 138:
                        _iteratorNormalCompletion9 = true;
                        _context29.next = 134;
                        break;

                      case 141:
                        _context29.next = 147;
                        break;

                      case 143:
                        _context29.prev = 143;
                        _context29.t2 = _context29["catch"](132);
                        _didIteratorError9 = true;
                        _iteratorError9 = _context29.t2;

                      case 147:
                        _context29.prev = 147;
                        _context29.prev = 148;

                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                          _iterator9.return();
                        }

                      case 150:
                        _context29.prev = 150;

                        if (!_didIteratorError9) {
                          _context29.next = 153;
                          break;
                        }

                        throw _iteratorError9;

                      case 153:
                        return _context29.finish(150);

                      case 154:
                        return _context29.finish(147);

                      case 155:
                        _context29.next = 157;
                        return regeneratorRuntime.awrap(_this17.sendSMSBulkJobStatusChange(listJobs, status));

                      case 157:
                        resolve();

                      case 158:
                      case "end":
                        return _context29.stop();
                    }
                  }
                }, null, _this17, [[18, 116, 120, 128], [50, 69, 73, 81], [74,, 76, 80], [121,, 123, 127], [132, 143, 147, 155], [148,, 150, 154]]);
              }));

            case 1:
            case "end":
              return _context30.stop();
          }
        }
      }, null, this);
    },
    sendSMSBulkJobStatusChange: function sendSMSBulkJobStatusChange(listJobs, status) {
      var _this18 = this;

      return regeneratorRuntime.async(function sendSMSBulkJobStatusChange$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              return _context32.abrupt("return", new Promise(function _callee18(resolve, reject) {
                var res, smsTemplates, listPosterSmsTemplates, listFillerSmsTemplates, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, aJob, job, client, listFillers, posterSmsTemplate, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, candidate, fillerSmsTemplate, _candidate2, _posterSmsTemplate, _fillerSmsTemplate;

                return regeneratorRuntime.async(function _callee18$(_context31) {
                  while (1) {
                    switch (_context31.prev = _context31.next) {
                      case 0:
                        _context31.next = 2;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/smstemplates/?agency=" + _this18.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=Status Change Notification&selector1=Job&deactivated=false"));

                      case 2:
                        res = _context31.sent;

                        if (res == null || res.data == null) {
                          reject();
                        }

                        if (!res.data.length) {
                          _context31.next = 97;
                          break;
                        }

                        // If there is an sms template for this new status
                        smsTemplates = res.data;
                        listPosterSmsTemplates = smsTemplates.filter(function (template) {
                          return template.selector2 === "Job Poster";
                        });
                        listFillerSmsTemplates = smsTemplates.filter(function (template) {
                          return template.selector2 === "Job Filler";
                        });
                        _iteratorNormalCompletion11 = true;
                        _didIteratorError11 = false;
                        _iteratorError11 = undefined;
                        _context31.prev = 11;
                        _iterator11 = listJobs[Symbol.iterator]();

                      case 13:
                        if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                          _context31.next = 83;
                          break;
                        }

                        aJob = _step11.value;
                        _context31.next = 17;
                        return regeneratorRuntime.awrap(_this18.$store.dispatch('getJobFullInfo', aJob));

                      case 17:
                        job = _context31.sent;

                        // Send sms to poster
                        client = void 0;

                        if (!job.poster) {
                          _context31.next = 24;
                          break;
                        }

                        _context31.next = 22;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/people/?id=" + job.poster));

                      case 22:
                        res = _context31.sent;

                        if (res && res.data && res.data.length) {
                          client = res.data[0];
                        }

                      case 24:
                        if (!_this18.$store.getters.multipleFillersShiftJob) {
                          _context31.next = 64;
                          break;
                        }

                        _context31.next = 27;
                        return regeneratorRuntime.awrap(_this18.$store.dispatch('getFillersOfJob', job));

                      case 27:
                        listFillers = _context31.sent;

                        if (!client) {
                          _context31.next = 33;
                          break;
                        }

                        posterSmsTemplate = _this18.findEmailTemplatesByUserTypes(client, listPosterSmsTemplates, job, client, listFillers.length ? listFillers[0] : {});

                        if (!posterSmsTemplate) {
                          _context31.next = 33;
                          break;
                        }

                        _context31.next = 33;
                        return regeneratorRuntime.awrap(_this18.sendJobSMSNotification(posterSmsTemplate, job, client, listFillers.length ? listFillers[0] : {}, client));

                      case 33:
                        if (!listFillers.length) {
                          _context31.next = 62;
                          break;
                        }

                        _iteratorNormalCompletion12 = true;
                        _didIteratorError12 = false;
                        _iteratorError12 = undefined;
                        _context31.prev = 37;
                        _iterator12 = listFillers[Symbol.iterator]();

                      case 39:
                        if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                          _context31.next = 48;
                          break;
                        }

                        candidate = _step12.value;
                        fillerSmsTemplate = _this18.findEmailTemplatesByUserTypes(candidate, listFillerSmsTemplates, job, client || {}, candidate || {});

                        if (!fillerSmsTemplate) {
                          _context31.next = 45;
                          break;
                        }

                        _context31.next = 45;
                        return regeneratorRuntime.awrap(_this18.sendJobSMSNotification(fillerSmsTemplate, job, client, candidate, candidate));

                      case 45:
                        _iteratorNormalCompletion12 = true;
                        _context31.next = 39;
                        break;

                      case 48:
                        _context31.next = 54;
                        break;

                      case 50:
                        _context31.prev = 50;
                        _context31.t0 = _context31["catch"](37);
                        _didIteratorError12 = true;
                        _iteratorError12 = _context31.t0;

                      case 54:
                        _context31.prev = 54;
                        _context31.prev = 55;

                        if (!_iteratorNormalCompletion12 && _iterator12.return) {
                          _iterator12.return();
                        }

                      case 57:
                        _context31.prev = 57;

                        if (!_didIteratorError12) {
                          _context31.next = 60;
                          break;
                        }

                        throw _iteratorError12;

                      case 60:
                        return _context31.finish(57);

                      case 61:
                        return _context31.finish(54);

                      case 62:
                        _context31.next = 80;
                        break;

                      case 64:
                        _candidate2 = void 0;

                        if (!job.filler) {
                          _context31.next = 70;
                          break;
                        }

                        _context31.next = 68;
                        return regeneratorRuntime.awrap(_axios2.default.get("/api/people/?id=" + job.filler));

                      case 68:
                        res = _context31.sent;

                        if (res && res.data && res.data.length) {
                          _candidate2 = res.data[0];
                        }

                      case 70:
                        if (!client) {
                          _context31.next = 75;
                          break;
                        }

                        _posterSmsTemplate = _this18.findEmailTemplatesByUserTypes(client, listPosterSmsTemplates, job, client || {}, _candidate2 || {});

                        if (!_posterSmsTemplate) {
                          _context31.next = 75;
                          break;
                        }

                        _context31.next = 75;
                        return regeneratorRuntime.awrap(_this18.sendJobSMSNotification(_posterSmsTemplate, job, client, _candidate2, client));

                      case 75:
                        if (!_candidate2) {
                          _context31.next = 80;
                          break;
                        }

                        _fillerSmsTemplate = _this18.findEmailTemplatesByUserTypes(_candidate2, listFillerSmsTemplates, job, client || {}, _candidate2 || {});

                        if (!_fillerSmsTemplate) {
                          _context31.next = 80;
                          break;
                        }

                        _context31.next = 80;
                        return regeneratorRuntime.awrap(_this18.sendJobSMSNotification(_fillerSmsTemplate, job, client, _candidate2, _candidate2));

                      case 80:
                        _iteratorNormalCompletion11 = true;
                        _context31.next = 13;
                        break;

                      case 83:
                        _context31.next = 89;
                        break;

                      case 85:
                        _context31.prev = 85;
                        _context31.t1 = _context31["catch"](11);
                        _didIteratorError11 = true;
                        _iteratorError11 = _context31.t1;

                      case 89:
                        _context31.prev = 89;
                        _context31.prev = 90;

                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                          _iterator11.return();
                        }

                      case 92:
                        _context31.prev = 92;

                        if (!_didIteratorError11) {
                          _context31.next = 95;
                          break;
                        }

                        throw _iteratorError11;

                      case 95:
                        return _context31.finish(92);

                      case 96:
                        return _context31.finish(89);

                      case 97:
                        resolve();

                      case 98:
                      case "end":
                        return _context31.stop();
                    }
                  }
                }, null, _this18, [[11, 85, 89, 97], [37, 50, 54, 62], [55,, 57, 61], [90,, 92, 96]]);
              }));

            case 1:
            case "end":
              return _context32.stop();
          }
        }
      }, null, this);
    },
    sendSMSJobStatusChangeNotification: function sendSMSJobStatusChangeNotification(job, client, listFillers, status) {
      var _this19 = this;

      return new Promise(function _callee19(resolve, reject) {
        var res, isSentPoster, isSentFiller, smsTemplates, listPosterSmsTemplates, listFillerSmsTemplates, posterSmsTemplate, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, candidate, fillerSmsTemplate, returnCode;

        return regeneratorRuntime.async(function _callee19$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return regeneratorRuntime.awrap(_axios2.default.get("/api/smstemplates/?agency=" + _this19.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=Status Change Notification&selector1=Job&deactivated=false"));

              case 2:
                res = _context33.sent;

                if (res == null || res.data == null) {
                  reject();
                }
                isSentPoster = false;
                isSentFiller = false;

                if (!res.data.length) {
                  _context33.next = 45;
                  break;
                }

                // If there is an email template for this new status
                smsTemplates = res.data;
                listPosterSmsTemplates = smsTemplates.filter(function (template) {
                  return template.selector2 === "Job Poster";
                });
                listFillerSmsTemplates = smsTemplates.filter(function (template) {
                  return template.selector2 === "Job Filler";
                });
                // Send sms to poster

                posterSmsTemplate = _this19.findEmailTemplatesByUserTypes(client, listPosterSmsTemplates, job, client, listFillers.length ? listFillers[0] : {});

                if (!posterSmsTemplate) {
                  _context33.next = 15;
                  break;
                }

                _context33.next = 14;
                return regeneratorRuntime.awrap(_this19.sendJobSMSNotification(posterSmsTemplate, job, client, listFillers.length ? listFillers[0] : {}, client));

              case 14:
                isSentPoster = true;

              case 15:
                if (!listFillers.length) {
                  _context33.next = 45;
                  break;
                }

                _iteratorNormalCompletion13 = true;
                _didIteratorError13 = false;
                _iteratorError13 = undefined;
                _context33.prev = 19;
                _iterator13 = listFillers[Symbol.iterator]();

              case 21:
                if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                  _context33.next = 30;
                  break;
                }

                candidate = _step13.value;
                fillerSmsTemplate = _this19.findEmailTemplatesByUserTypes(candidate, listFillerSmsTemplates, job, client || {}, candidate || {});

                if (!fillerSmsTemplate) {
                  _context33.next = 27;
                  break;
                }

                _context33.next = 27;
                return regeneratorRuntime.awrap(_this19.sendJobSMSNotification(fillerSmsTemplate, job, client, candidate, candidate));

              case 27:
                _iteratorNormalCompletion13 = true;
                _context33.next = 21;
                break;

              case 30:
                _context33.next = 36;
                break;

              case 32:
                _context33.prev = 32;
                _context33.t0 = _context33["catch"](19);
                _didIteratorError13 = true;
                _iteratorError13 = _context33.t0;

              case 36:
                _context33.prev = 36;
                _context33.prev = 37;

                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }

              case 39:
                _context33.prev = 39;

                if (!_didIteratorError13) {
                  _context33.next = 42;
                  break;
                }

                throw _iteratorError13;

              case 42:
                return _context33.finish(39);

              case 43:
                return _context33.finish(36);

              case 44:
                isSentFiller = true;

              case 45:
                returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.NONE;

                if (isSentPoster) {
                  if (isSentFiller) {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.POSTER_FILLER;
                  } else {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.POSTER;
                  }
                } else {
                  if (isSentFiller) {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.FILLER;
                  } else {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.NONE;
                  }
                }
                resolve(returnCode);

              case 48:
              case "end":
                return _context33.stop();
            }
          }
        }, null, _this19, [[19, 32, 36, 44], [37,, 39, 43]]);
      });
    },
    getListFillerOfJob: function getListFillerOfJob(job) {
      var _this20 = this;

      var candidates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return new Promise(function _callee20(resolve) {
        var candidate, resPeople, _listFillers, listFillers;

        return regeneratorRuntime.async(function _callee20$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                if (!job.filler) {
                  _context34.next = 11;
                  break;
                }

                candidate = candidates.find(function (candidate) {
                  return candidate.id === job.filler;
                });

                if (!candidate) {
                  _context34.next = 5;
                  break;
                }

                resolve([candidate]);
                return _context34.abrupt("return");

              case 5:
                _context34.next = 7;
                return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + job.filler + "/"));

              case 7:
                resPeople = _context34.sent;

                if (!(resPeople && resPeople.data)) {
                  _context34.next = 11;
                  break;
                }

                resolve([resPeople.data]);
                return _context34.abrupt("return");

              case 11:
                if (!_this20.$store.getters.multipleFillersShiftJob) {
                  _context34.next = 22;
                  break;
                }

                if (!(job.fillers && job.fillers.length)) {
                  _context34.next = 17;
                  break;
                }

                _listFillers = candidates.filter(function (candidate) {
                  return job.fillers.includes(candidate.id);
                });

                if (!(_listFillers && _listFillers.length)) {
                  _context34.next = 17;
                  break;
                }

                resolve(_listFillers || []);
                return _context34.abrupt("return");

              case 17:
                _context34.next = 19;
                return regeneratorRuntime.awrap(_this20.$store.dispatch('getFillersOfJob', job));

              case 19:
                listFillers = _context34.sent;

                resolve(listFillers || []);
                return _context34.abrupt("return");

              case 22:

                resolve([]);

              case 23:
              case "end":
                return _context34.stop();
            }
          }
        }, null, _this20);
      });
    },
    unassignShiftJobAndNotification: function unassignShiftJobAndNotification(job, client, fillerId) {
      var res, listEmailTemplates, listSMSTemplates, listFillers, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, candidate, emailTemplate, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, _candidate3, smsTemplate;

      return regeneratorRuntime.async(function unassignShiftJobAndNotification$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return regeneratorRuntime.awrap(this.getEmailTemplates("/api/emailtemplates/?agency=" + this.$store.getters.agencyID + "&type=Shift Job Unassigned Candidate Notification&selector1=Job&deactivated=false"));

            case 2:
              res = _context35.sent;
              listEmailTemplates = [];

              if (res && res.data) {
                listEmailTemplates = res.data;
              }

              _context35.next = 7;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/smstemplates/?agency=" + this.$store.getters.agencyID + "&type=Shift Job Unassigned Candidate Notification&selector1=Job&deactivated=false"));

            case 7:
              res = _context35.sent;
              listSMSTemplates = [];

              if (res && res.data) {
                listSMSTemplates = res.data;
              }
              listFillers = [];

              if (!(listEmailTemplates.length || listSMSTemplates.length)) {
                _context35.next = 30;
                break;
              }

              if (client) {
                _context35.next = 18;
                break;
              }

              if (!job.poster) {
                _context35.next = 18;
                break;
              }

              _context35.next = 16;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + job.poster + "/"));

            case 16:
              res = _context35.sent;

              if (res && res.data) {
                client = res.data;
              }

            case 18:
              if (!this.$store.getters.multipleFillersShiftJob) {
                _context35.next = 25;
                break;
              }

              _context35.next = 21;
              return regeneratorRuntime.awrap(this.$store.dispatch('getFillersOfJob', job));

            case 21:
              listFillers = _context35.sent;

              // Check for the case only unassign one filler (not all)
              if (fillerId) {
                listFillers = listFillers.filter(function (filler) {
                  return filler.id === fillerId;
                });
              }
              _context35.next = 30;
              break;

            case 25:
              if (!fillerId) {
                fillerId = job.filler;
              }
              _context35.next = 28;
              return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + fillerId + "/"));

            case 28:
              res = _context35.sent;

              if (res && res.data) {
                listFillers.push(res.data);
              }

            case 30:
              _context35.next = 32;
              return regeneratorRuntime.awrap(this.$store.dispatch('unassignShiftJob', { job: job, fillerId: fillerId }));

            case 32:
              if (!listFillers.length) {
                _context35.next = 91;
                break;
              }

              if (!listEmailTemplates.length) {
                _context35.next = 62;
                break;
              }

              _iteratorNormalCompletion14 = true;
              _didIteratorError14 = false;
              _iteratorError14 = undefined;
              _context35.prev = 37;
              _iterator14 = listFillers[Symbol.iterator]();

            case 39:
              if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                _context35.next = 48;
                break;
              }

              candidate = _step14.value;
              emailTemplate = this.findEmailTemplatesByUserTypes(candidate, listEmailTemplates, job, client || {}, candidate || {});

              if (!emailTemplate) {
                _context35.next = 45;
                break;
              }

              _context35.next = 45;
              return regeneratorRuntime.awrap(this.sendJobEmailNotification(emailTemplate, job, client, candidate, candidate));

            case 45:
              _iteratorNormalCompletion14 = true;
              _context35.next = 39;
              break;

            case 48:
              _context35.next = 54;
              break;

            case 50:
              _context35.prev = 50;
              _context35.t0 = _context35["catch"](37);
              _didIteratorError14 = true;
              _iteratorError14 = _context35.t0;

            case 54:
              _context35.prev = 54;
              _context35.prev = 55;

              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }

            case 57:
              _context35.prev = 57;

              if (!_didIteratorError14) {
                _context35.next = 60;
                break;
              }

              throw _iteratorError14;

            case 60:
              return _context35.finish(57);

            case 61:
              return _context35.finish(54);

            case 62:
              if (!listSMSTemplates.length) {
                _context35.next = 91;
                break;
              }

              _iteratorNormalCompletion15 = true;
              _didIteratorError15 = false;
              _iteratorError15 = undefined;
              _context35.prev = 66;
              _iterator15 = listFillers[Symbol.iterator]();

            case 68:
              if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                _context35.next = 77;
                break;
              }

              _candidate3 = _step15.value;
              smsTemplate = this.findEmailTemplatesByUserTypes(_candidate3, listSMSTemplates, job, client || {}, _candidate3 || {});

              if (!smsTemplate) {
                _context35.next = 74;
                break;
              }

              _context35.next = 74;
              return regeneratorRuntime.awrap(this.sendJobSMSNotification(smsTemplate, job, client, _candidate3, _candidate3));

            case 74:
              _iteratorNormalCompletion15 = true;
              _context35.next = 68;
              break;

            case 77:
              _context35.next = 83;
              break;

            case 79:
              _context35.prev = 79;
              _context35.t1 = _context35["catch"](66);
              _didIteratorError15 = true;
              _iteratorError15 = _context35.t1;

            case 83:
              _context35.prev = 83;
              _context35.prev = 84;

              if (!_iteratorNormalCompletion15 && _iterator15.return) {
                _iterator15.return();
              }

            case 86:
              _context35.prev = 86;

              if (!_didIteratorError15) {
                _context35.next = 89;
                break;
              }

              throw _iteratorError15;

            case 89:
              return _context35.finish(86);

            case 90:
              return _context35.finish(83);

            case 91:
            case "end":
              return _context35.stop();
          }
        }
      }, null, this, [[37, 50, 54, 62], [55,, 57, 61], [66, 79, 83, 91], [84,, 86, 90]]);
    },
    sendEmailJobStatusChangeNotification: function sendEmailJobStatusChangeNotification(job, client, listFillers, status) {
      var _this21 = this;

      return new Promise(function _callee21(resolve) {
        var res, isSentPoster, isSentFiller, emailTemplates, listPosterEmailTemplates, listFillerEmailTemplates, posterEmailTemplate, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, candidate, fillerEmailTemplate, returnCode;

        return regeneratorRuntime.async(function _callee21$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return regeneratorRuntime.awrap(_this21.getEmailTemplates("/api/emailtemplates/?agency=" + _this21.$store.getters.agencyID + "&status=" + encodeURIComponent(status) + "&type=Status Change Notification&selector1=Job&deactivated=false"));

              case 2:
                res = _context36.sent;

                if (res == null || res.data == null) {
                  reject();
                }
                isSentPoster = false;
                isSentFiller = false;

                if (!res.data.length) {
                  _context36.next = 45;
                  break;
                }

                // If there is an email template for this new status
                emailTemplates = res.data;
                listPosterEmailTemplates = emailTemplates.filter(function (template) {
                  return template.selector2 === "Job Poster";
                });
                listFillerEmailTemplates = emailTemplates.filter(function (template) {
                  return template.selector2 === "Job Filler";
                });
                // Send email to poster

                posterEmailTemplate = _this21.findEmailTemplatesByUserTypes(client, listPosterEmailTemplates, job, client, listFillers.length ? listFillers[0] : {});

                if (!posterEmailTemplate) {
                  _context36.next = 15;
                  break;
                }

                _context36.next = 14;
                return regeneratorRuntime.awrap(_this21.sendJobEmailNotification(posterEmailTemplate, job, client, listFillers.length ? listFillers[0] : {}, client));

              case 14:
                isSentPoster = true;

              case 15:
                if (!listFillers.length) {
                  _context36.next = 45;
                  break;
                }

                _iteratorNormalCompletion16 = true;
                _didIteratorError16 = false;
                _iteratorError16 = undefined;
                _context36.prev = 19;
                _iterator16 = listFillers[Symbol.iterator]();

              case 21:
                if (_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done) {
                  _context36.next = 31;
                  break;
                }

                candidate = _step16.value;
                fillerEmailTemplate = _this21.findEmailTemplatesByUserTypes(candidate, listFillerEmailTemplates, job, client || {}, candidate || {});

                if (!fillerEmailTemplate) {
                  _context36.next = 28;
                  break;
                }

                _context36.next = 27;
                return regeneratorRuntime.awrap(_this21.sendJobEmailNotification(fillerEmailTemplate, job, client, candidate, candidate));

              case 27:
                isSentFiller = true;

              case 28:
                _iteratorNormalCompletion16 = true;
                _context36.next = 21;
                break;

              case 31:
                _context36.next = 37;
                break;

              case 33:
                _context36.prev = 33;
                _context36.t0 = _context36["catch"](19);
                _didIteratorError16 = true;
                _iteratorError16 = _context36.t0;

              case 37:
                _context36.prev = 37;
                _context36.prev = 38;

                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }

              case 40:
                _context36.prev = 40;

                if (!_didIteratorError16) {
                  _context36.next = 43;
                  break;
                }

                throw _iteratorError16;

              case 43:
                return _context36.finish(40);

              case 44:
                return _context36.finish(37);

              case 45:
                // Find return code
                returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.NONE;

                if (isSentPoster) {
                  if (isSentFiller) {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.POSTER_FILLER;
                  } else {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.POSTER;
                  }
                } else {
                  if (isSentFiller) {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.FILLER;
                  } else {
                    returnCode = _customDefineType.JOB_UPDATE_STATUS_SENT.NONE;
                  }
                }

                resolve(returnCode);

              case 48:
              case "end":
                return _context36.stop();
            }
          }
        }, null, _this21, [[19, 33, 37, 45], [38,, 40, 44]]);
      });
    },
    sendEmailNotificationToFillerOnCancelJob: function sendEmailNotificationToFillerOnCancelJob(job, client, listFillers, reason) {
      var _this22 = this;

      return new Promise(function _callee22(resolve) {
        var _iteratorNormalCompletion17, _didIteratorError17, _iteratorError17, _iterator17, _step17, candidate;

        return regeneratorRuntime.async(function _callee22$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (!_this22.$store.getters.sendEmailtoCandidateWhenJobIsCancelled) {
                  _context37.next = 20;
                  break;
                }

                _iteratorNormalCompletion17 = true;
                _didIteratorError17 = false;
                _iteratorError17 = undefined;
                _context37.prev = 4;

                for (_iterator17 = listFillers[Symbol.iterator](); !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                  candidate = _step17.value;

                  _this22.sendEmail(_extends({}, _this22.$store.getters.jobBookingCancelledFillerNotificationEmailTemplate, {
                    recipients: [candidate.email],
                    userID: candidate.id
                  }), new Date(job.date + "T00:00:00").toDateString(), client.first_name, client.last_name, client.email, job.start_time ? _this22.convertTimeAMPMToString(job.start_time) : "Unspecified Start Time", job.end_time ? _this22.convertTimeAMPMToString(job.end_time) : "Unspecified End Time", reason);
                }
                _context37.next = 12;
                break;

              case 8:
                _context37.prev = 8;
                _context37.t0 = _context37["catch"](4);
                _didIteratorError17 = true;
                _iteratorError17 = _context37.t0;

              case 12:
                _context37.prev = 12;
                _context37.prev = 13;

                if (!_iteratorNormalCompletion17 && _iterator17.return) {
                  _iterator17.return();
                }

              case 15:
                _context37.prev = 15;

                if (!_didIteratorError17) {
                  _context37.next = 18;
                  break;
                }

                throw _iteratorError17;

              case 18:
                return _context37.finish(15);

              case 19:
                return _context37.finish(12);

              case 20:
                resolve();

              case 21:
              case "end":
                return _context37.stop();
            }
          }
        }, null, _this22, [[4, 8, 12, 20], [13,, 15, 19]]);
      });
    },
    sendSMSNotificationToFillerOnCancelJob: function sendSMSNotificationToFillerOnCancelJob(job, client, listFillers, reason) {
      var _this23 = this;

      return new Promise(function _callee23(resolve) {
        var message, _iteratorNormalCompletion18, _didIteratorError18, _iteratorError18, _iterator18, _step18, candidate;

        return regeneratorRuntime.async(function _callee23$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!_this23.$store.getters.sendSMStoCandidateWhenJobIsCancelled) {
                  _context38.next = 21;
                  break;
                }

                message = _this23.formatContent(_this23.$store.getters.jobBookingCancelledFillerSMSTemplate.message, new Date(job.date + "T00:00:00").toDateString(), client.first_name, client.last_name, client.email, job.start_time ? _this23.convertTimeAMPMToString(job.start_time) : "Unspecified Start Time", job.end_time ? _this23.convertTimeAMPMToString(job.end_time) : "Unspecified End Time", reason);
                _iteratorNormalCompletion18 = true;
                _didIteratorError18 = false;
                _iteratorError18 = undefined;
                _context38.prev = 5;

                for (_iterator18 = listFillers[Symbol.iterator](); !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  candidate = _step18.value;

                  if (candidate.phone) {
                    _this23.$store.dispatch("sendSMS", {
                      textMessage: message + _this23.smsFooter,
                      phone: candidate.phone,
                      id: candidate.id,
                      from_phone: _this23.$store.getters.agency.twilio_phone_number
                    });
                  }
                }
                _context38.next = 13;
                break;

              case 9:
                _context38.prev = 9;
                _context38.t0 = _context38["catch"](5);
                _didIteratorError18 = true;
                _iteratorError18 = _context38.t0;

              case 13:
                _context38.prev = 13;
                _context38.prev = 14;

                if (!_iteratorNormalCompletion18 && _iterator18.return) {
                  _iterator18.return();
                }

              case 16:
                _context38.prev = 16;

                if (!_didIteratorError18) {
                  _context38.next = 19;
                  break;
                }

                throw _iteratorError18;

              case 19:
                return _context38.finish(16);

              case 20:
                return _context38.finish(13);

              case 21:
                resolve();

              case 22:
              case "end":
                return _context38.stop();
            }
          }
        }, null, _this23, [[5, 9, 13, 21], [14,, 16, 20]]);
      });
    },
    notifyApplicantOnCancelJob: function notifyApplicantOnCancelJob(job, client, reason) {
      var _this24 = this;

      return new Promise(function _callee24(resolve) {
        var recipients;
        return regeneratorRuntime.async(function _callee24$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                recipients = job.applicants.map(function (applicant) {
                  return applicant.email;
                }).filter(function (email) {
                  return email;
                });

                if (_this24.tryGet(function () {
                  return recipients.length;
                })) {
                  if (_this24.$store.getters.sendEmailtoCandidateWhenJobIsCancelled) {
                    _this24.sendEmail(_extends({}, _this24.$store.getters.jobBookingCancelledFillerNotificationEmailTemplate, {
                      recipients: recipients
                    }), new Date(job.date + "T00:00:00").toDateString(), client.first_name, client.last_name, client.email, job.start_time ? _this24.convertTimeAMPMToString(job.start_time) : "Unspecified Start Time", job.end_time ? _this24.convertTimeAMPMToString(job.end_time) : "Unspecified End Time", reason);
                  }
                }
                resolve();

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, null, _this24);
      });
    },
    handleAfterJobStatusChanged: function handleAfterJobStatusChanged(aJob, client, candidates, status) {
      var _this25 = this;

      var reason = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

      return new Promise(function _callee25(resolve, reject) {
        var job, listFillers, emailSentCode, smsSentCode;
        return regeneratorRuntime.async(function _callee25$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                job = aJob;

                if (!job.id) {
                  _context40.next = 5;
                  break;
                }

                _context40.next = 4;
                return regeneratorRuntime.awrap(_this25.$store.dispatch('getJobFullInfo', aJob));

              case 4:
                job = _context40.sent;

              case 5:
                _context40.next = 7;
                return regeneratorRuntime.awrap(_this25.getListFillerOfJob(job, candidates));

              case 7:
                listFillers = _context40.sent;
                _context40.next = 10;
                return regeneratorRuntime.awrap(_this25.sendEmailJobStatusChangeNotification(job, client, listFillers, status));

              case 10:
                emailSentCode = _context40.sent;
                _context40.next = 13;
                return regeneratorRuntime.awrap(_this25.sendSMSJobStatusChangeNotification(job, client, listFillers, status));

              case 13:
                smsSentCode = _context40.sent;

                if (!(status === 'Cancelled')) {
                  _context40.next = 27;
                  break;
                }

                if (!listFillers.length) {
                  _context40.next = 24;
                  break;
                }

                if ([_customDefineType.JOB_UPDATE_STATUS_SENT.FILLER, _customDefineType.JOB_UPDATE_STATUS_SENT.POSTER_FILLER].includes(emailSentCode)) {
                  _context40.next = 19;
                  break;
                }

                _context40.next = 19;
                return regeneratorRuntime.awrap(_this25.sendEmailNotificationToFillerOnCancelJob(job, client, listFillers, reason));

              case 19:
                if (!(![_customDefineType.JOB_UPDATE_STATUS_SENT.FILLER, _customDefineType.JOB_UPDATE_STATUS_SENT.POSTER_FILLER].includes(smsSentCode) && _this25.$store.getters.agency.twilio_phone_number)) {
                  _context40.next = 22;
                  break;
                }

                _context40.next = 22;
                return regeneratorRuntime.awrap(_this25.sendSMSNotificationToFillerOnCancelJob(job, client, listFillers, reason));

              case 22:
                _context40.next = 27;
                break;

              case 24:
                if (!(_this25.$store.getters.notifyAllApplicants && _this25.tryGet(function () {
                  return job.applicants.length;
                }))) {
                  _context40.next = 27;
                  break;
                }

                _context40.next = 27;
                return regeneratorRuntime.awrap(_this25.notifyApplicantOnCancelJob(job, client, reason));

              case 27:
                resolve({
                  sms: smsSentCode,
                  email: emailSentCode
                });

              case 28:
              case "end":
                return _context40.stop();
            }
          }
        }, null, _this25);
      });
    },
    sendEmailToJobUser: function sendEmailToJobUser(_ref2) {
      var _this26 = this;

      var subject = _ref2.subject,
          message = _ref2.message,
          template = _ref2.template,
          user = _ref2.user;

      var emailTemplate = template;
      var target = user;
      return new Promise(function _callee26(resolve) {
        var emailObject;
        return regeneratorRuntime.async(function _callee26$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                emailObject = {
                  subject: subject,
                  message: message,
                  file_urls: emailTemplate.attachment_urls,
                  userID: target.id,
                  from: _this26.getEmailSenderFromEmailTemplate(emailTemplate),
                  reply: _this26.getReplyToFromEmailTemplate(emailTemplate),
                  cc: emailTemplate.cc,
                  bcc: emailTemplate.bcc,
                  excludeFooter: emailTemplate.exclude_footer,
                  template: emailTemplate
                };

                if (_this26.$store.getters.isAgent) {
                  setTimeout(function () {
                    // Want to show the pop up to edit the email before it goes out
                    _this26.showSendEmailDialog(_extends({}, emailObject, {
                      destination: target.email,
                      secondaryEmail: target.email2,
                      logMessage: false,
                      onCloseCallback: function onCloseCallback() {
                        resolve();
                      }
                    }));
                  }, 10);
                } else {
                  // Send email without popup
                  _this26.sendEmail(_extends({}, emailObject, {
                    recipients: [target.email],
                    isHtml: true
                  }));
                  resolve();
                }

              case 2:
              case "end":
                return _context41.stop();
            }
          }
        }, null, _this26);
      });
    },
    sendJobEmailNotification: function sendJobEmailNotification(emailTemplate, job, client, candidate, target) {
      var _this27 = this;

      return new Promise(function _callee27(resolve) {
        var emailObject;
        return regeneratorRuntime.async(function _callee27$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (!emailTemplate) {
                  _context42.next = 21;
                  break;
                }

                _context42.next = 3;
                return regeneratorRuntime.awrap(_this27.makeJobStringSubstitutions(emailTemplate.subject, job, client, candidate));

              case 3:
                _context42.t0 = _context42.sent;
                _context42.next = 6;
                return regeneratorRuntime.awrap(_this27.makeJobStringSubstitutions(emailTemplate.body, job, client, candidate));

              case 6:
                _context42.t1 = _context42.sent;
                _context42.t2 = emailTemplate.attachment_urls;
                _context42.t3 = target.id;
                _context42.t4 = _this27.getEmailSenderFromEmailTemplate(emailTemplate);
                _context42.t5 = _this27.getReplyToFromEmailTemplate(emailTemplate);
                _context42.t6 = emailTemplate.cc;
                _context42.t7 = emailTemplate.bcc;
                _context42.t8 = emailTemplate.exclude_footer;
                _context42.t9 = emailTemplate;
                _context42.t10 = _this27.makeJobStringSubstitutions;
                _context42.t11 = [job, client, candidate];
                emailObject = {
                  subject: _context42.t0,
                  message: _context42.t1,
                  file_urls: _context42.t2,
                  userID: _context42.t3,
                  from: _context42.t4,
                  reply: _context42.t5,
                  cc: _context42.t6,
                  bcc: _context42.t7,
                  excludeFooter: _context42.t8,
                  template: _context42.t9,
                  replaceFunc: _context42.t10,
                  replaceParams: _context42.t11
                };

                if (_this27.$store.getters.isAgent) {
                  setTimeout(function () {
                    // Want to show the pop up to edit the email before it goes out
                    _this27.showSendEmailDialog(_extends({}, emailObject, {
                      destination: target.email,
                      secondaryEmail: target.email2,
                      logMessage: false,
                      onCloseCallback: function onCloseCallback() {
                        resolve();
                      }
                    }));
                  }, 10);
                } else {
                  // Send email without popup
                  _this27.sendEmail(_extends({}, emailObject, {
                    recipients: [_this27.$store.getters.enginehireLoggingEmail, target.email],
                    isHtml: true
                  }));
                  resolve();
                }
                _context42.next = 22;
                break;

              case 21:
                resolve();

              case 22:
              case "end":
                return _context42.stop();
            }
          }
        }, null, _this27);
      });
    },
    filterTemplatesByMatchingConditions: function filterTemplatesByMatchingConditions(listTemplates, job, client, candidate) {
      var _this28 = this;

      if (!listTemplates) {
        return [];
      }
      return listTemplates.filter(function (template) {
        if (!template.advance_matching_conditions || !template.advance_matching_conditions) {
          return true;
        }
        var mapTypeObject = {};
        if (job) {
          mapTypeObject = {
            Job: job || {},
            Candidate: candidate || {},
            Client: client || {}
          };
        } else {
          mapTypeObject = {
            Candidate: client || candidate,
            Client: client || candidate
          };
        }
        var _iteratorNormalCompletion19 = true;
        var _didIteratorError19 = false;
        var _iteratorError19 = undefined;

        try {
          for (var _iterator19 = template.advance_matching_conditions[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
            var condition = _step19.value;

            var object = mapTypeObject[condition.type];
            if (object && condition.value && condition.value.length) {
              var value = object[condition.model];
              if (Array.isArray(value)) {
                if (!_this28.hasCommonElement(value, condition.value)) {
                  return false;
                }
              } else if (value) {
                if (!condition.value.includes(value)) {
                  return false;
                }
              } else {
                return false;
              }
            }
          }
        } catch (err) {
          _didIteratorError19 = true;
          _iteratorError19 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion19 && _iterator19.return) {
              _iterator19.return();
            }
          } finally {
            if (_didIteratorError19) {
              throw _iteratorError19;
            }
          }
        }

        template.matchingIndex += template.advance_matching_conditions.length * 0.1;
        return true;
      });
    },
    filterTemplatesByUserTypes: function filterTemplatesByUserTypes(user, listTemplates, job, client, candidate) {
      var _this29 = this;

      if (listTemplates == null) {
        return [];
      }
      // Use matching index to specify priority
      // If there are multiple matching templates, but only pick one, pick the one with the highest matching index
      listTemplates.forEach(function (template) {
        template.matchingIndex = 0;
      });

      // Filter by advance_matching_conditions
      if (job) {
        listTemplates = this.filterTemplatesByMatchingConditions(listTemplates, job, client, candidate);
      } else {
        listTemplates = this.filterTemplatesByMatchingConditions(listTemplates, job, user);
      }

      // Filter list templates by locations
      if (user.locations == null || user.locations.length === 0) {
        listTemplates = listTemplates.filter(function (template) {
          return template.locations == null || template.locations.length === 0;
        });
      } else {
        listTemplates = listTemplates.filter(function (template) {
          return template.locations == null || template.locations.length === 0 || _this29.hasCommonElement(user.locations, template.locations);
        });
        // Template with matching locations > template without locations
        listTemplates.forEach(function (template) {
          if (template.locations && template.locations.length) {
            template.matchingIndex += 1;
          }
        });
      }
      // Filter list templates by languages
      if (!user.language) {
        listTemplates = listTemplates.filter(function (template) {
          return template.languages == null || template.languages.length === 0;
        });
      } else {
        listTemplates = listTemplates.filter(function (template) {
          return template.languages == null || template.languages.length === 0 || template.languages.includes(user.language);
        });
        // Template with matching languages > template without languages
        listTemplates.forEach(function (template) {
          if (template.languages && template.languages.length) {
            template.matchingIndex += 1;
          }
        });
      }
      // Filter list templates by marketing_source
      if (!user.marketing_source) {
        listTemplates = listTemplates.filter(function (template) {
          return template.marketing_sources == null || template.marketing_sources.length === 0;
        });
      } else {
        listTemplates = listTemplates.filter(function (template) {
          return template.marketing_sources == null || template.marketing_sources.length === 0 || template.marketing_sources.includes(user.marketing_source);
        });
        // Template with matching languages > template without languages
        listTemplates.forEach(function (template) {
          if (template.marketing_sources && template.marketing_sources.length) {
            template.matchingIndex += 1;
          }
        });
      }
      if (user.types == null || user.types.length === 0) {
        return listTemplates.filter(function (template) {
          return template.user_types == null || template.user_types.length === 0;
        });
      }
      // Accept case: user types is not empty, and type of template = empty
      listTemplates = listTemplates.filter(function (template) {
        return template.user_types == null || template.user_types.length === 0 || _this29.hasCommonElement(user.types, template.user_types);
      });
      // Template with matching user types > template without user types
      listTemplates.forEach(function (template) {
        if (template.user_types && template.user_types.length) {
          template.matchingIndex += 1;
        }
      });
      return listTemplates;
    },
    filterDocumentByUserTypesAndTags: function filterDocumentByUserTypesAndTags(user, listFiles) {
      var _this30 = this;

      if (listFiles == null) {
        return [];
      }
      // Filter list files by locations
      if (user.locations == null || user.locations.length === 0) {
        listFiles = listFiles.filter(function (file) {
          return file.locations == null || file.locations.length === 0;
        });
      } else {
        listFiles = listFiles.filter(function (file) {
          return file.locations == null || file.locations.length === 0 || _this30.hasCommonElement(user.locations, file.locations);
        });
      }
      // Filter list files by languages
      if (!user.language) {
        listFiles = listFiles.filter(function (file) {
          return file.languages == null || file.languages.length === 0;
        });
      } else {
        listFiles = listFiles.filter(function (file) {
          return file.languages == null || file.languages.length === 0 || file.languages.includes(user.language);
        });
      }
      if (user.types == null || user.types.length === 0) {
        listFiles = listFiles.filter(function (file) {
          return file.types == null || file.types.length === 0;
        });
      } else {
        // Accept case: user types is not empty, and type of file = empty
        listFiles = listFiles.filter(function (file) {
          return file.types == null || file.types.length === 0 || _this30.hasCommonElement(user.types, file.types);
        });
      }
      if (user.tags == null || user.tags.length === 0) {
        listFiles = listFiles.filter(function (file) {
          return file.tags == null || file.tags.length === 0;
        });
      } else {
        // Accept case: user tags is not empty, and tag of file = empty
        listFiles = listFiles.filter(function (file) {
          return file.tags == null || file.tags.length === 0 || _this30.hasCommonElement(user.tags, file.tags);
        });
      }
      return listFiles;
    },

    // Job, client, candidate is optional
    // That is used for advance filter of email template of job type
    findEmailTemplatesByUserTypes: function findEmailTemplatesByUserTypes(user, listTemplates, job, client, candidate) {
      console.log('111');
      if (listTemplates == null) {
        console.log('111');
        return null;
      }
      console.log('111');
      var listMatchingTemplates = this.filterTemplatesByUserTypes(user, listTemplates, job, client, candidate);
      console.log('111');
      // No matching
      if (!listMatchingTemplates || !listMatchingTemplates.length) {
        console.log('111');
        return null;
      }
      // Pick the one with highest matching index
      console.log('111');
      return listMatchingTemplates.reduce(function (prev, current) {
        return prev.matchingIndex > current.matchingIndex ? prev : current;
      });
    },

    // Check if two array has at least 1 common element
    hasCommonElement: function hasCommonElement(arr1, arr2) {
      if (arr1 == null || arr2 == null) {
        return false;
      }
      return arr1.some(function (r) {
        return arr2.includes(r);
      });
    },
    downloadFile: function downloadFile(fileURL, fileName) {
      // for non-IE
      if (!window.ActiveXObject) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
        save.download = fileName || filename;
        if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
          document.location = save.href;
          // window event not working here
        } else {
          var evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false
          });
          save.dispatchEvent(evt);
          (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      }

      // for IE < 11
      else if (!!window.ActiveXObject && document.execCommand) {
          var _window = window.open(fileURL, "_blank");
          _window.document.close();
          _window.document.execCommand("SaveAs", true, fileName || fileURL);
          _window.close();
        }
    },

    // Copy content to clipboard
    copyContent: function copyContent(content) {
      var el = document.createElement("textarea");
      el.value = content;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    sendPaymentSubmittedNotificationToAdmin: function sendPaymentSubmittedNotificationToAdmin(user) {
      var _this31 = this;

      return new Promise(function _callee28(resolve, reject) {
        var res, excludeUserType, emailTemplates, emailTemplate, mapReplaceValues, subject, message, emailObject;
        return regeneratorRuntime.async(function _callee28$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return regeneratorRuntime.awrap(_this31.getEmailTemplates("/api/emailtemplates/?agency=" + _this31.$store.getters.agencyID + "&type=Payment Submitted Notification&selector1=Admin&deactivated=false"));

              case 2:
                res = _context43.sent;

                if (res == null || res.data == null) {
                  reject();
                }
                if (res.data.length) {
                  // If there is an email template
                  excludeUserType = user.is_candidate ? "Client" : "Candidate";
                  emailTemplates = res.data;

                  emailTemplates = emailTemplates.filter(function (template) {
                    return template.selector3 !== excludeUserType;
                  });
                  emailTemplate = _this31.findEmailTemplatesByUserTypes(user, emailTemplates);


                  if (emailTemplate) {
                    mapReplaceValues = {
                      fname: user.first_name,
                      lname: user.last_name,
                      email: user.email,
                      id: user.id
                    };
                    subject = _this31.replaceTagByMap(emailTemplate.subject, mapReplaceValues);
                    message = _this31.replaceTagByMap(emailTemplate.body, mapReplaceValues);
                    emailObject = {
                      subject: subject,
                      message: message,
                      file_urls: emailTemplate.attachment_urls,
                      userID: user.id,
                      from: _this31.getEmailSenderFromEmailTemplate(emailTemplate),
                      reply: _this31.getReplyToFromEmailTemplate(emailTemplate),
                      cc: emailTemplate.cc,
                      bcc: emailTemplate.bcc,
                      excludeFooter: emailTemplate.exclude_footer
                    };
                    // Send email without popup

                    _this31.sendEmail(_extends({}, emailObject, {
                      recipients: [_this31.$store.getters.enginehireLoggingEmail].concat(_toConsumableArray(emailTemplate.destinations)),
                      isHtml: true
                    }));
                  }
                }
                resolve();

              case 6:
              case "end":
                return _context43.stop();
            }
          }
        }, null, _this31);
      });
    },
    sendUserStatusChangeNotificationSMS: function sendUserStatusChangeNotificationSMS(user, status, isSecondStatus) {
      var _this32 = this;

      return new Promise(function _callee29(resolve, reject) {
        var statusTriggerKey, initialSMSMessage, hasSMSDialog, mapReplacedValues;
        return regeneratorRuntime.async(function _callee29$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if (!user.phone) {
                  resolve();
                }
                statusTriggerKey = isSecondStatus ? 'Second Status Change Notification' : 'Status Change Notification';
                _context45.next = 4;
                return regeneratorRuntime.awrap(_this32.$store.dispatch('getStatusChangeSMSTemplate', {
                  status: status,
                  type: statusTriggerKey,
                  user: user.is_candidate ? 'Candidate' : 'Client'
                }));

              case 4:
                initialSMSMessage = '';

                if (_this32.tryGet(function () {
                  return _this32.$store.getters.statusChangeSMSTemplatesErrors.length;
                })) {
                  _this32.showErrorDialog({
                    title: 'Error Loading SMS Templates, Please Try Again.'
                  });
                  reject();
                }
                hasSMSDialog = false;

                if (!(user.phone && _this32.tryGet(function () {
                  return _this32.$store.getters.statusChangeSMSTemplates.length;
                }))) {
                  _context45.next = 18;
                  break;
                }

                mapReplacedValues = {
                  '[[fname]]': user.first_name
                };

                initialSMSMessage = _this32.replaceAllByMap(_this32.$store.getters.statusChangeSMSTemplates[0].message, mapReplacedValues);
                initialSMSMessage = _this32.replaceTagValue(initialSMSMessage, user);

                if (!_this32.$store.getters.isAgent) {
                  _context45.next = 16;
                  break;
                }

                hasSMSDialog = true;
                _this32.showInputDialog({
                  title: "Send SMS Notification",
                  listFields: [{
                    label: "Phone",
                    type: _customDefineType.FORM_TYPE.LABEL,
                    model: user.phone
                  }, {
                    label: "Message",
                    type: _customDefineType.FORM_TYPE.TEXTAREA,
                    model: "message",
                    isCounter: true
                  }],
                  data: {
                    message: initialSMSMessage
                  },
                  submitLabel: "Send",
                  onSubmitCallback: function onSubmitCallback(SMSInfo) {
                    return regeneratorRuntime.async(function onSubmitCallback$(_context44) {
                      while (1) {
                        switch (_context44.prev = _context44.next) {
                          case 0:
                            _context44.next = 2;
                            return regeneratorRuntime.awrap(_axios2.default.post("/optimum/message/", {
                              message: SMSInfo.message,
                              phone: user.phone,
                              user_id: user.id,
                              from_phone: _this32.$store.getters.agency.twilio_phone_number ? _this32.$store.getters.agency.twilio_phone_number : "",
                              agency_id: _this32.$store.getters.agencyID,
                              log: true
                            }));

                          case 2:
                          case "end":
                            return _context44.stop();
                        }
                      }
                    }, null, _this32);
                  },
                  onCloseCallback: function onCloseCallback() {
                    resolve();
                  }
                });
                _context45.next = 18;
                break;

              case 16:
                _context45.next = 18;
                return regeneratorRuntime.awrap(_axios2.default.post("/optimum/message/", {
                  message: initialSMSMessage,
                  phone: user.phone,
                  user_id: user.id,
                  from_phone: _this32.$store.getters.agency.twilio_phone_number ? _this32.$store.getters.agency.twilio_phone_number : "",
                  agency_id: _this32.$store.getters.agencyID,
                  log: true
                }));

              case 18:
                if (!hasSMSDialog) {
                  resolve();
                }

              case 19:
              case "end":
                return _context45.stop();
            }
          }
        }, null, _this32);
      });
    },
    showInputDialogSync: function showInputDialogSync(inputObj) {
      var _this33 = this;

      return new Promise(function _callee30(resolve) {
        return regeneratorRuntime.async(function _callee30$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _this33.showInputDialog(_extends({}, inputObj, {
                  onSubmitCallback: function onSubmitCallback(info) {
                    setTimeout(function () {
                      resolve(info);
                    }, 100);
                  },
                  onCloseCallback: function onCloseCallback() {
                    setTimeout(function () {
                      resolve(null);
                    }, 110);
                  }
                }));

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, null, _this33);
      });
    },
    showConfirmDialogSync: function showConfirmDialogSync(confirmObj) {
      var _this34 = this;

      return new Promise(function _callee31(resolve) {
        return regeneratorRuntime.async(function _callee31$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _this34.showConfirmDialog(_extends({}, confirmObj, {
                  onAcceptCallback: function onAcceptCallback() {
                    setTimeout(function () {
                      resolve(true);
                    }, 0);
                  },
                  onRejectCallback: function onRejectCallback() {
                    setTimeout(function () {
                      resolve(false);
                    }, 0);
                  }
                }));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, null, _this34);
      });
    },
    validateBaseInputValues: function validateBaseInputValues(applicationData, listFields) {
      var _this35 = this;

      return new Promise(function _callee32(resolve) {
        var errorInfo;
        return regeneratorRuntime.async(function _callee32$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                errorInfo = _this35.hasInvalidField(applicationData, listFields, _this35.$store.getters.isAgent);

                if (!errorInfo) {
                  _context48.next = 5;
                  break;
                }

                _this35.showErrorDialog({
                  key: "INVALID_INPUT_ERROR",
                  params: [_this35.getErrorMessage(errorInfo)]
                });
                resolve(false);
                return _context48.abrupt("return");

              case 5:
                resolve(true);

              case 6:
              case "end":
                return _context48.stop();
            }
          }
        }, null, _this35);
      });
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WORD_USED_FOR_CLIENT_SETTINGS = exports.WORD_USED_FOR_CANDIDATE_SETTINGS = exports.WORD_USED_FOR_PLACEMENT_JOB_SETTINGS = exports.WORD_USED_FOR_SHIFT_JOB_CALENDAR_SETTINGS = exports.NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE_SETTINGS = exports.MY_CANDIDATES_SETTINGS = exports.AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT = exports.REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON_SETTING = exports.CANDIDATE_CAN_EDIT_BUFFER_TIME = exports.PLACEMENT_JOB_APPLICATION_AUTO_ADDING_RELATIONSHIP_SETTING = exports.CANDIDATE_CLIENT_RELATIONSHIP_STATUS_SETTINGS = exports.CANDIDATE_MENU_ITEMS_LABEL_SETTINGS = exports.SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE = exports.TIMEOFF_RECORD_SETTINGS = exports.DAILY_AVAILABILITY_SETTINGS = exports.NOTIFY_EMAILS_RECURRING_AVAILABILITY_SETTINGS = exports.SCHEDULE_EVENT_TYPE_SETTINGS = exports.DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS = exports.CANDIDATE_TOGGLE_TABLE_VIEW_SETTINGS = exports.REQUEST_TIME_OFF_CATEGORIES_SETTINGS = exports.EVALUATION_BUILDER_SETTINGS = undefined;

var _customDefineType = __webpack_require__(6);

var _defaultValues = __webpack_require__(17);

var EVALUATION_BUILDER_SETTINGS = exports.EVALUATION_BUILDER_SETTINGS = [{
    key: "EVALUATION_BUILDER_OUTCOME",
    model: "public_advance_setting.candidate_can_see_evaluation_outcome",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM
}];

var REQUEST_TIME_OFF_CATEGORIES_SETTINGS = exports.REQUEST_TIME_OFF_CATEGORIES_SETTINGS = [{
    key: "REQUEST_TIME_OFF_CATEGORIES",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'public_advance_setting.time_off_categories',
    default: _defaultValues.DEFAULT_REQUEST_TIME_OFF_CATEGORIES
}];

var CANDIDATE_TOGGLE_TABLE_VIEW_SETTINGS = exports.CANDIDATE_TOGGLE_TABLE_VIEW_SETTINGS = [{
    key: "CANDIDATE_TOGGLE_TABLE_VIEW",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.candidate_default_table_view'
}];

var DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS = exports.DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS = [{
    key: "DO_NOT_SHOW_DUPLICATED_DOCUMENTS",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'public_advance_setting.do_not_show_duplicated_documents_updating_status'
}];

var SCHEDULE_EVENT_TYPE_SETTINGS = exports.SCHEDULE_EVENT_TYPE_SETTINGS = [{
    key: "SCHEDULE_EVENT_TYPES",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'public_advance_setting.schedule_Event_types',
    default: _defaultValues.DEFAULT_SCHEDULE_EVENT_TYPES
}];

var NOTIFY_EMAILS_RECURRING_AVAILABILITY_SETTINGS = exports.NOTIFY_EMAILS_RECURRING_AVAILABILITY_SETTINGS = [{
    key: "NOTIFY_EMAILS_RECURRING_AVAILABILITY",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'advance_setting.notify_emails_candidate_change_recurring_availability'
}, {
    key: "ALLOW_CANDIDATE_TO_EDIT_RECURRING_AVAILABILITY",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: "advance_setting.allow_candidate_to_edit_recurring_availability",
    default: false
}, {
    key: "NUMBER_OF_WEEKS_CANDIDATE_CANNOT_CHANGE_WEEK_AVAILABILITY",
    isIntegerField: true,
    model: "advance_setting.number_weeks_change_schedule_effect",
    default: 0
}, {
    key: "CANDIDATE_TYPES_CANNOT_EDIT_RECURRING_AVAILABILITY",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    hasClearButton: true,
    closeOnSelect: false,
    model: 'advance_setting.candidate_types_cannot_edit_recurring_availability',
    optionListModel: 'candidate_types',
    default: []
}];

var DAILY_AVAILABILITY_SETTINGS = exports.DAILY_AVAILABILITY_SETTINGS = [{
    key: "PREVENT_CANDIDATE_FROM_INPUTTING_DAILY_AVAILABILITY",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.prevent_candidates_inputting_daily_availability'
}];

var TIMEOFF_RECORD_SETTINGS = exports.TIMEOFF_RECORD_SETTINGS = [{
    key: "USE_TIMEOFF_CREDIT",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.use_timeoff_credit'
}];

var SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE = exports.SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE = [{
    key: "SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.show_price_manager_on_administrators_table'
}];

var CANDIDATE_MENU_ITEMS_LABEL_SETTINGS = exports.CANDIDATE_MENU_ITEMS_LABEL_SETTINGS = [{
    key: "WORD_USED_FOR_MY_PROFILE",
    model: "public_advance_setting.word_used_for_my_profile",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}, {
    key: "WORD_USED_FOR_AVAILABLE_JOBS",
    model: "public_advance_setting.word_used_for_available_jobs",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}, {
    key: "WORD_USED_FOR_MY_SCHEDULE",
    model: "public_advance_setting.word_used_for_my_schedule",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}, {
    key: "WORD_USED_FOR_MY_JOBS",
    model: "public_advance_setting.word_used_for_my_jobs",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}, {
    key: "WORD_USED_FOR_MY_FAMILIES",
    model: "public_advance_setting.word_used_for_my_families",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

var CANDIDATE_CLIENT_RELATIONSHIP_STATUS_SETTINGS = exports.CANDIDATE_CLIENT_RELATIONSHIP_STATUS_SETTINGS = [{
    key: "CUSTOMIZE_CANDIDATE_CLIENT_RELATIONSHIP_STATUS",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'advance_setting.candidate_client_relationship_status',
    default: _defaultValues.DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS,
    hasInitElement: false
}];

var PLACEMENT_JOB_APPLICATION_AUTO_ADDING_RELATIONSHIP_SETTING = exports.PLACEMENT_JOB_APPLICATION_AUTO_ADDING_RELATIONSHIP_SETTING = [{
    key: "PLACEMENT_JOB_APPLICATION_STATUS_TO_ADD_RELATIONSHIP",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    model: "advance_setting.placement_application_status_auto_add_relationship_default",
    isMulti: true
}];

var CANDIDATE_CAN_EDIT_BUFFER_TIME = exports.CANDIDATE_CAN_EDIT_BUFFER_TIME = [{
    key: "CANDIDATE_CAN_EDIT_BUFFER_TIME",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.candidate_can_edit_buffer_time'
}];

var REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON_SETTING = exports.REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON_SETTING = [{
    key: "REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.remove_candidate_upload_additional_document_button'
}, {
    key: "REMOVE_CLIENT_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.remove_client_upload_additional_document_button'
}];

var AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT = exports.AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT = [{
    key: "AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM,
    model: 'advance_setting.agency_gets_notified_when_candidate_upload_any_document'
}];

var MY_CANDIDATES_SETTINGS = exports.MY_CANDIDATES_SETTINGS = [{
    key: "CLIENT_ADD_NOTE_ASSIGNED_CANDIDATE_NOTIFICATION_EMAILS",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'advance_setting.client_add_note_assigned_candidate_notification_emails',
    hasInitElement: false
}, {
    key: "WORD_USED_FOR_SCHEDULE_INTERVIEW_RELATIONSHIP",
    model: "public_advance_setting.word_used_for_schedule_interview_relationship",
    type: _customDefineType.FORM_TYPE.TEXTBOX,
    default: 'Schedule Interview'
}, {
    key: "SHOW_SHAREABLE_LINK_FOR_MY_CANDIDATES_SECTION",
    model: "public_advance_setting.show_shareable_link_for_my_candidates_section",
    type: _customDefineType.FORM_TYPE.CHECKBOX_ITEM
}, {
    key: "RELATIONSHIP_STATUSES_WHERE_EXTEND_OFFER_BUTTON_APPEARS",
    model: "advance_setting.relationship_statuses_where_extended_offer_button_appears",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: ['Interested'],
    optionListModel: 'advance_setting.candidate_client_relationship_status'
}, {
    key: "RELATIONSHIP_STATUSES_HIDDEN_IN_MY_CANDIDATES",
    model: "advance_setting.relationship_statuses_hidden_my_candidates",
    type: _customDefineType.FORM_TYPE.MULTI_SELECT,
    isMulti: true,
    default: _defaultValues.DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES,
    optionListModel: 'advance_setting.candidate_client_relationship_status'
}];

var NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE_SETTINGS = exports.NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE_SETTINGS = [{
    key: "NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE",
    type: _customDefineType.FORM_TYPE.LIST_TEXTFIELD_INPUT,
    model: 'advance_setting.notify_emails_package_select_or_change'
}];

var WORD_USED_FOR_SHIFT_JOB_CALENDAR_SETTINGS = exports.WORD_USED_FOR_SHIFT_JOB_CALENDAR_SETTINGS = [{
    key: "WORD_USED_FOR_SHIFT_JOB_CALENDAR",
    model: "public_advance_setting.word_used_for_shift_job_calendar",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

var WORD_USED_FOR_PLACEMENT_JOB_SETTINGS = exports.WORD_USED_FOR_PLACEMENT_JOB_SETTINGS = [{
    key: "WORD_USED_FOR_PLACEMENT_JOB",
    model: "public_advance_setting.word_used_for_job_placement",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

var WORD_USED_FOR_CANDIDATE_SETTINGS = exports.WORD_USED_FOR_CANDIDATE_SETTINGS = [{
    key: "WORD_USED_FOR_CANDIDATE",
    model: "public_advance_setting.word_used_for_candidate",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}, {
    key: "WORD_USED_FOR_CANDIDATES",
    model: "public_advance_setting.word_used_for_candidates",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

var WORD_USED_FOR_CLIENT_SETTINGS = exports.WORD_USED_FOR_CLIENT_SETTINGS = [{
    key: "WORD_USED_FOR_CLIENT",
    model: "public_advance_setting.word_used_for_client",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}, {
    key: "WORD_USED_FOR_CLIENTS",
    model: "public_advance_setting.word_used_for_clients",
    type: _customDefineType.FORM_TYPE.TEXTBOX
}];

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _customDefineType = __webpack_require__(6);

var _fieldTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        /*
        Replace tag with value defined in object
        listTags contains tag information: [[tag]] in input and corresponding model field in object
        otherMapValues contains map: key => value to replace
        */
        replacePredefinedTag: function replacePredefinedTag(input, object, listTags, otherMapValues) {
            if (!input) {
                return "";
            }
            var result = input;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = listTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tag = _step.value;

                    var value = "";
                    if (object) {
                        value = object[tag.model];
                    }
                    result = this.replaceAllText(result, "[[" + tag.tag + "]]", value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            result = this.replaceTagByMap(result, otherMapValues);
            return result;
        },

        /*
        mapValues contains map: key => value to replace
        key is in a tag, for example: tag is [[fname]] => key is fname
        */
        replaceTagByMap: function replaceTagByMap(input, mapValues) {
            if (!input) {
                return "";
            }
            var result = input;
            if (mapValues) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = Object.keys(mapValues)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var key = _step2.value;

                        var value = mapValues[key];
                        result = this.replaceAllText(result, "[[" + key + "]]", value);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            return result;
        },

        /*
        mapValues contains map: key => value to replace
        */
        replaceAllByMap: function replaceAllByMap(input, mapValues) {
            if (!input) {
                return "";
            }
            var result = input;
            if (mapValues) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = Object.keys(mapValues)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var key = _step3.value;

                        var value = mapValues[key];
                        result = this.replaceAllText(result, key, value);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return result;
        },

        // Remove all text in listText in input string
        removeTextInString: function removeTextInString(input, listText) {
            if (!input) {
                return "";
            }
            var result = input;
            if (listText) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = listText[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var text = _step4.value;

                        result = this.replaceAllText(result, text, "");
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            return result;
        },
        makeJobStringSubstitutions: function makeJobStringSubstitutions(string, job, client, candidate) {
            var _this = this;

            var keepCustomTags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            console.log(candidate);
            return new Promise(function _callee(resolve) {
                var jobDateString, compressedDate, listDateTimes, jobDates, jobDatesCompressed, startTime, endTime, clientRate, jobLink, hashPosterId, jobTipLink, jobReviewLink, address, candidateShareableLink, clientTags, clientShareableLink, listChildren, childrenContent, childrenText, mapReplaced, childrenAges, compressedChildrenAges, listPets, petsContent, associatedShiftJobs, _associatedShiftJobs;

                return regeneratorRuntime.async(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // In the job email templates need to substitute in all of the variables

                                // https://stackoverflow.com/questions/13340131/javascript-replaceall-not-working
                                jobDateString = '';
                                compressedDate = '';

                                if (job.date) {
                                    jobDateString = _this.getDateString(job.date);
                                    compressedDate = _this.compressDateFormat(job.date);
                                }
                                string = string.split("[[jobtitle]]").join(job.title);
                                string = string.split("[[date]]").join(jobDateString);
                                string = string.split("[[date_compressed]]").join(compressedDate);
                                // string = string.split(`[[start_time]]`).join(this.convertTimeToAMPM(job.start_time))
                                // string = string.split(`[[end_time]]`).join(this.convertTimeToAMPM(job.end_time))
                                // Replace job_dates tags
                                if (string.includes('[[jobdates')) {
                                    listDateTimes = _this.getListDateTimeOfJobs(job);

                                    listDateTimes.forEach(function (dateTime) {
                                        dateTime.start_time = dateTime.startTime;
                                        dateTime.end_time = dateTime.endTime;
                                    });
                                    jobDates = listDateTimes.map(function (jobDate) {
                                        return _this.getDateString(jobDate.date);
                                    }).join(", ");
                                    jobDatesCompressed = listDateTimes.map(function (jobDate) {
                                        return _this.compressDateFormat(jobDate.date);
                                    }).join(", ");

                                    string = string.split("[[jobdates]]").join(jobDates);
                                    string = string.split("[[jobdates_compressed]]").join(jobDatesCompressed);
                                    string = string.split("[[jobdatestimes]]").join(_this.getJobsDatesTimes(listDateTimes));
                                    string = string.split("[[jobdatestimes_compressed]]").join(_this.getJobsDatesTimesCompressed(listDateTimes));
                                }

                                startTime = job.start_time;

                                if ((typeof startTime === "undefined" ? "undefined" : _typeof(startTime)) === 'object') {
                                    startTime = _this.getTimeString(job.start_time);
                                }
                                string = string.split("[[starttime]]").join(_this.djangotimeformatAMPM(startTime));
                                string = string.split("[[start_time]]").join(_this.djangotimeformatAMPM(startTime));
                                string = string.split("[[starttime_compressed]]").join(_this.compressTimeFormat(startTime));
                                endTime = job.end_time;

                                if ((typeof endTime === "undefined" ? "undefined" : _typeof(endTime)) === 'object') {
                                    endTime = _this.getTimeString(job.end_time);
                                }
                                string = string.split("[[endtime]]").join(_this.djangotimeformatAMPM(endTime));
                                string = string.split("[[end_time]]").join(_this.djangotimeformatAMPM(endTime));
                                string = string.split("[[endtime_compressed]]").join(_this.compressTimeFormat(endTime));
                                string = string.split("[[candidaterate]]").join(job.candidate_rate ? job.candidate_rate : '');
                                clientRate = Number(job.client_rate) || 0;

                                if (!clientRate) {
                                    if (job.candidate_rate) {
                                        clientRate = Number(job.candidate_rate);
                                    }
                                    if (job.agency_fee) {
                                        clientRate = clientRate + Number(job.agency_fee);
                                    }
                                }
                                if (clientRate) {
                                    clientRate = clientRate.toFixed(2);
                                }
                                string = string.split("[[clientrate]]").join(clientRate || '');
                                string = string.split("[[agencyfee]]").join(job.agency_fee ? job.agency_fee : '');
                                string = string.split("[[travelfee]]").join(job.travel_fee ? job.travel_fee : '');
                                string = string.split("[[per_booking_agency_fee]]").join(job.per_booking_agency_fee || '');
                                string = string.split("[[clientnotes]]").join(job.text);
                                string = string.split("[[agencynotes]]").join(job.admin_notes);
                                string = string.split("[[jobid]]").join(job.id);
                                string = string.split("[[jobids]]").join(job.id);
                                string = string.split("[[address1]]").join(job.address1 || '');
                                string = string.split("[[address2]]").join(job.address2 || '');
                                string = string.split("[[city]]").join(job.city || '');
                                string = string.split("[[state_province]]").join(job.provincestate || '');
                                string = string.split("[[zip_postal_code]]").join(job.postal_code || '');
                                string = string.split("[[country]]").join(job.country || '');
                                // Job link
                                jobLink = _this.rootUrl + "/job/" + job.id;

                                string = string.split("[[joblink]]").join(jobLink);
                                string = string.split("[[joblinks]]").join(jobLink);
                                // Job Tipping link

                                if (!(string.includes('[[jobtiplink]]') || string.includes('[[jobtiplinks]]'))) {
                                    _context.next = 45;
                                    break;
                                }

                                _context.next = 41;
                                return regeneratorRuntime.awrap(_this.getHashId(job.poster + 1));

                            case 41:
                                hashPosterId = _context.sent;
                                jobTipLink = _this.rootUrl + "/job-tip/" + job.id + "/" + hashPosterId;

                                string = string.split("[[jobtiplink]]").join(jobTipLink);
                                string = string.split("[[jobtiplinks]]").join(jobTipLink);

                            case 45:

                                // Job Review Link 
                                if (job.id && string.includes('[[review_link]]')) {
                                    jobReviewLink = _this.rootUrl + "/job/" + _this.$store.getters.agencyID + "/" + job.id + "/add-review";

                                    string = string.split("[[review_link]]").join(jobReviewLink);
                                }

                                address = job.address1;

                                if (job.address2) {
                                    // Not everyone has a second line in their address, don't want an extra space if they don't
                                    address = address + " " + job.address2;
                                }
                                address = address + ", " + job.city + ", " + job.provincestate + ", " + job.postal_code;
                                string = string.split("[[address]]").join(address);

                                if (!candidate) {
                                    _context.next = 61;
                                    break;
                                }

                                console.log('candidate', candidate.first_name);
                                string = string.split("[[candidatefname]]").join(candidate.first_name);
                                string = string.split("[[candidatelname]]").join(candidate.last_name);
                                string = string.split("[[candidatephone]]").join(candidate.phone);
                                string = string.split("[[candidateemail]]").join(candidate.email);
                                // Replace candidate shareable link

                                if (!string.includes('[[candidate_shareable_link]]')) {
                                    _context.next = 61;
                                    break;
                                }

                                _context.next = 59;
                                return regeneratorRuntime.awrap(_this.getShareableURL(candidate, true));

                            case 59:
                                candidateShareableLink = _context.sent;

                                string = string.split("[[candidate_shareable_link]]").join(candidateShareableLink);

                            case 61:
                                if (!client) {
                                    _context.next = 90;
                                    break;
                                }

                                string = string.split("[[clientfname]]").join(client.first_name);
                                string = string.split("[[clientlname]]").join(client.last_name);
                                string = string.split("[[clientphone]]").join(client.phone);
                                string = string.split("[[clientsecondary_phone]]").join(client.phone2);
                                clientTags = '';

                                if (client.tags) {
                                    clientTags = client.tags.join(', ');
                                }
                                string = string.split("[[clienttags]]").join(clientTags);
                                // Replace client sharable link

                                if (!string.includes('[[client_shareable_link]]')) {
                                    _context.next = 74;
                                    break;
                                }

                                _context.next = 72;
                                return regeneratorRuntime.awrap(_this.getShareableURL(client, false));

                            case 72:
                                clientShareableLink = _context.sent;

                                string = string.split("[[client_shareable_link]]").join(clientShareableLink);

                            case 74:
                                if (!(string.includes('[[children]]') || string.includes('[[children_text]]') || string.includes('[[ages_of_children]]') || string.includes('[[ages_of_children_compressed]]'))) {
                                    _context.next = 90;
                                    break;
                                }

                                _context.next = 77;
                                return regeneratorRuntime.awrap(_this.getListChildren(client));

                            case 77:
                                listChildren = _context.sent;

                                if (!(string.includes('[[children]]') || string.includes('[[children_text]]'))) {
                                    _context.next = 88;
                                    break;
                                }

                                _context.next = 81;
                                return regeneratorRuntime.awrap(_this.getProfileSectionContent(client, listChildren, _fieldTypes.MAP_DIALOG_SECTION.Children.name, true));

                            case 81:
                                childrenContent = _context.sent;

                                console.log(childrenContent);
                                string = string.split("[[children]]").join(childrenContent);
                                childrenText = _this.getHtmlText(childrenContent, true).trim();
                                mapReplaced = {
                                    '\n\n\n\n\n\n\n\n\n': '\n',
                                    '\n\n\n\n\n\n\n\n': '\n',
                                    '\n\n\n\n\n\n\n': '\n',
                                    '\n\n\n\n\n\n': '\n',
                                    '\n\n\n': ': '
                                };

                                childrenText = _this.replaceAllByMap(childrenText, mapReplaced);
                                string = string.split("[[children_text]]").join(childrenText);

                            case 88:
                                if (string.includes('[[ages_of_children]]')) {
                                    childrenAges = listChildren.map(function (child) {
                                        return _this.getAge(child.birthday);
                                    }).join('; ');

                                    string = string.split("[[ages_of_children]]").join(childrenAges);
                                }
                                if (string.includes('[[ages_of_children_compressed]]')) {
                                    compressedChildrenAges = listChildren.map(function (child) {
                                        return _this.getCompressedAge(child.birthday);
                                    }).join(', ');

                                    string = string.split("[[ages_of_children_compressed]]").join(compressedChildrenAges);
                                }

                            case 90:
                                if (!string.includes('[[pets]]')) {
                                    _context.next = 98;
                                    break;
                                }

                                _context.next = 93;
                                return regeneratorRuntime.awrap(_this.getListPets(client));

                            case 93:
                                listPets = _context.sent;
                                _context.next = 96;
                                return regeneratorRuntime.awrap(_this.getProfileSectionContent(client, listPets, _fieldTypes.MAP_DIALOG_SECTION.Pet.name));

                            case 96:
                                petsContent = _context.sent;

                                string = string.split("[[pets]]").join(petsContent);

                            case 98:
                                if (!string.includes('[[associated_shift_jobs]]')) {
                                    _context.next = 103;
                                    break;
                                }

                                _context.next = 101;
                                return regeneratorRuntime.awrap(_this.getAssociatedBookingsInfo(job));

                            case 101:
                                associatedShiftJobs = _context.sent;

                                string = string.split("[[associated_shift_jobs]]").join(associatedShiftJobs);

                            case 103:
                                if (!string.includes('[[associated_shift_jobs_compressed]]')) {
                                    _context.next = 108;
                                    break;
                                }

                                _context.next = 106;
                                return regeneratorRuntime.awrap(_this.getCompressedAssociatedBookingsInfo(job));

                            case 106:
                                _associatedShiftJobs = _context.sent;

                                string = string.split("[[associated_shift_jobs_compressed]]").join(_associatedShiftJobs);

                            case 108:
                                // for replacing custom tags with their respective values e.g [[text2]]
                                string = _this.replaceTagValue(string, job, false, null, false, Object.keys(job));
                                // Replace custom client tags
                                if (client && Object.keys(client) && Object.keys(client).length) {
                                    string = _this.replaceAllText(string, '[[client_', '[[');
                                    string = _this.replaceTagValue(string, client, false, null, false, Object.keys(client));
                                }
                                // Replace custom candidate tags
                                if (candidate && Object.keys(candidate) && Object.keys(candidate).length) {
                                    string = _this.replaceAllText(string, '[[candidate_', '[[');
                                    string = _this.replaceTagValue(string, candidate, false, null, false, Object.keys(candidate));
                                }
                                resolve(string);

                            case 112:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, null, _this);
            });
        },
        getAssociatedBookingsInfo: function getAssociatedBookingsInfo(job) {
            var _this2 = this;

            return new Promise(function _callee2(resolve) {
                var res, result;
                return regeneratorRuntime.async(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (job.associated_job_group) {
                                    _context2.next = 3;
                                    break;
                                }

                                resolve('');
                                return _context2.abrupt("return");

                            case 3:
                                _context2.next = 5;
                                return regeneratorRuntime.awrap(_axios2.default.get("/get-associated-job/?group_id=" + job.associated_job_group));

                            case 5:
                                res = _context2.sent;
                                result = res.data.filter(function (booking) {
                                    return booking.id !== job.id;
                                }).map(function (booking) {
                                    return _this2.getDateString(booking.date);
                                }).join(', ');

                                resolve(result);
                                return _context2.abrupt("return");

                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, null, _this2);
            });
        },
        getCompressedAssociatedBookingsInfo: function getCompressedAssociatedBookingsInfo(job) {
            var _this3 = this;

            return new Promise(function _callee3(resolve) {
                var res, result;
                return regeneratorRuntime.async(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (job.associated_job_group) {
                                    _context3.next = 3;
                                    break;
                                }

                                resolve('');
                                return _context3.abrupt("return");

                            case 3:
                                _context3.next = 5;
                                return regeneratorRuntime.awrap(_axios2.default.get("/get-associated-job/?group_id=" + job.associated_job_group));

                            case 5:
                                res = _context3.sent;
                                result = res.data.filter(function (booking) {
                                    return booking.id !== job.id;
                                }).map(function (booking) {
                                    return _this3.compressDateFormat(booking.date);
                                }).join(', ');

                                resolve(result);
                                return _context3.abrupt("return");

                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, null, _this3);
            });
        },
        getProfileSectionContent: function getProfileSectionContent(user, listObjects, objectType) {
            var _this4 = this;

            var isEmailTemplate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            var ignoreHeader = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            return new Promise(function _callee4(resolve) {
                var applicationFormId, listBuilder, profileBuilder, listFields, fields, mapDependentObjects, content;
                return regeneratorRuntime.async(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                applicationFormId = user.application_form;

                                if (typeof applicationFormId !== 'number') {
                                    applicationFormId = user.application_form_id;
                                }
                                listBuilder = _this4.$store.getters.profileBuilderList.sort(function (a, b) {
                                    return a.id - b.id;
                                });

                                if (!(!listBuilder || listBuilder.length === 0)) {
                                    _context4.next = 7;
                                    break;
                                }

                                _context4.next = 6;
                                return regeneratorRuntime.awrap(_this4.$store.dispatch('reloadProfileBuilderList'));

                            case 6:
                                listBuilder = _this4.$store.getters.profileBuilderList.sort(function (a, b) {
                                    return a.id - b.id;
                                });

                            case 7:
                                // Find corresponding profile builder
                                profileBuilder = listBuilder.find(function (builder) {
                                    return builder.application_builder_id === applicationFormId && builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
                                });


                                if (profileBuilder == null) {
                                    // If There is no builder for profile, use builder for application instead
                                    profileBuilder = listBuilder.find(function (builder) {
                                        return builder.id === applicationFormId;
                                    });
                                }

                                if (profileBuilder == null) {
                                    // For old data, which is not set applicaiton_form, find one profile builder
                                    profileBuilder = listBuilder.find(function (builder) {
                                        return builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
                                    });
                                }

                                if (profileBuilder == null) {
                                    // For old data, which is not set applicaiton_form, no profile builder => use application builder
                                    profileBuilder = listBuilder.find(function (builder) {
                                        return builder.type === _customDefineType.BUILDER_TYPE.APPLICATION && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
                                    });
                                }

                                if (profileBuilder == null) {
                                    resolve('');
                                }

                                listFields = _this4.mergeBuilders(profileBuilder, listBuilder, true).listFields;

                                if (listFields) {
                                    _context4.next = 16;
                                    break;
                                }

                                resolve('');
                                return _context4.abrupt("return");

                            case 16:
                                fields = listFields.find(function (field) {
                                    return [_customDefineType.FORM_TYPE.SLOT, _customDefineType.FORM_TYPE.SECTION, _customDefineType.FORM_TYPE.BOOKING_SECTION].includes(field.type) && _this4.isItemShow(user, field, listFields) && field.name === objectType;
                                });

                                if (fields) {
                                    mapDependentObjects = {};

                                    mapDependentObjects[fields.label] = listObjects;

                                    content = _this4.getSectionContent(fields, mapDependentObjects, [], false, isEmailTemplate, ignoreHeader);

                                    resolve(content);
                                } else {
                                    resolve('');
                                }

                            case 18:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, null, _this4);
            });
        },
        getListChildren: function getListChildren(user) {
            var _this5 = this;

            return regeneratorRuntime.async(function getListChildren$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            return _context6.abrupt("return", new Promise(function _callee5(resolve, reject) {
                                var res;
                                return regeneratorRuntime.async(function _callee5$(_context5) {
                                    while (1) {
                                        switch (_context5.prev = _context5.next) {
                                            case 0:
                                                _context5.next = 2;
                                                return regeneratorRuntime.awrap(_axios2.default.get("/api/children/?user=" + user.id));

                                            case 2:
                                                res = _context5.sent;

                                                if (!res) {
                                                    reject();
                                                }
                                                resolve(res.data);

                                            case 5:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }
                                }, null, _this5);
                            }));

                        case 1:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, null, this);
        },
        getListPets: function getListPets(user) {
            var _this6 = this;

            return regeneratorRuntime.async(function getListPets$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            return _context8.abrupt("return", new Promise(function _callee6(resolve, reject) {
                                var res;
                                return regeneratorRuntime.async(function _callee6$(_context7) {
                                    while (1) {
                                        switch (_context7.prev = _context7.next) {
                                            case 0:
                                                _context7.next = 2;
                                                return regeneratorRuntime.awrap(_axios2.default.get("/api/pets/?user=" + user.id));

                                            case 2:
                                                res = _context7.sent;

                                                if (!res) {
                                                    reject();
                                                }
                                                resolve(res.data);

                                            case 5:
                                            case "end":
                                                return _context7.stop();
                                        }
                                    }
                                }, null, _this6);
                            }));

                        case 1:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, null, this);
        },

        // Replace all oldStr in inputStr by newStr
        replaceAllText: function replaceAllText(inputStr, oldStr, newStr) {
            if (!inputStr) {
                return "";
            }
            return inputStr.split(oldStr).join(newStr);
        },
        extractTextByPattern: function extractTextByPattern(input, pattern) {
            if (!input) {
                return null;
            }
            var result = input.match(pattern);
            if (result && result.length > 1) {
                return result[1];
            }
        }
    }
});

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _defaultValues = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
  methods: {
    getColorPickerOptions: function getColorPickerOptions() {
      var listUserDefinedColors = [this.$store.getters.primaryColor, this.$store.getters.primaryDarkerColor, this.$store.getters.secondaryColor, this.$store.getters.secondaryDarkerColor, this.$store.getters.profileTextColor, this.$store.getters.cancelButtonColor, this.$store.getters.cancelButtonHoverColor];
      if (this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.public_advance_setting) {
        if (this.$store.getters.agencyPublic.public_advance_setting.cancel_button_color) {
          listUserDefinedColors.push(this.$store.getters.agencyPublic.public_advance_setting.cancel_button_color);
        }
        if (this.$store.getters.agencyPublic.public_advance_setting.cancel_button_hover_color) {
          listUserDefinedColors.push(this.$store.getters.agencyPublic.public_advance_setting.cancel_button_hover_color);
        }
        if (this.$store.getters.agencyPublic.public_advance_setting.label_color) {
          listUserDefinedColors.push(this.$store.getters.agencyPublic.public_advance_setting.label_color);
        }
      }
      var result = [].concat(_toConsumableArray(listUserDefinedColors.filter(function (color) {
        return color;
      })), _toConsumableArray(_defaultValues.DEFAULT_COLOR_PICKER_OPTIONS));
      // Remove duplicate items
      result = [].concat(_toConsumableArray(new Set(result)));
      // Get first 16 items
      return result.slice(0, 16).map(function (color) {
        return { color: color, showBorder: true };
      });
    }
  }
});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _modelByTypes = __webpack_require__(91);

var _customDefineType = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lecture 346
_vue2.default.mixin({
    methods: {
        // Get max value of created_date, last_login, last_updated
        getLastAccessTime: function getLastAccessTime(user) {
            var lastAccess = null;
            var listAccessModels = ["created_date", "last_login", "last_updated_date", "last_activity"];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = listAccessModels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var accessModel = _step.value;

                    if (user[accessModel]) {
                        if (!lastAccess) {
                            lastAccess = user[accessModel];
                        } else if (user[accessModel] > lastAccess) {
                            lastAccess = user[accessModel];
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return lastAccess;
        },
        getAdminNameFromId: function getAdminNameFromId(id) {
            if (!this.$store.getters.adminList) {
                return null;
            }
            var admin = this.$store.getters.adminList.find(function (item) {
                return item.id === id;
            });
            if (!admin) {
                return null;
            }
            return admin.first_name + " " + admin.last_name;
        },
        generatePlaceholderEmail: function generatePlaceholderEmail(userInfo) {
            var result = void 0;
            if (userInfo.phone) {
                // For leaf cleanup we are not asking for an email address so making a fake one out of the phone number
                result = userInfo.phone.replace(/\s+/, "") + "@" + this.$store.getters.agencyHumanName.toLowerCase() + ".com";
            } else {
                var userName = userInfo.first_name + "+" + userInfo.last_name + "+" + new Date().toISOString();
                // If there is no email, no phone => user is created by first name, last name
                result = userName + "@" + this.$store.getters.agencyHumanName.toLowerCase() + ".com";
            }
            return result.replace(/\s+|\:|\!|\+|\;/g, "");
        },
        getPlaceholderPrefix: function getPlaceholderPrefix(userInfo) {
            var userName = userInfo.first_name + "+" + userInfo.last_name + "+20";
            return userName.replace(/\s+|\:|\!|\+|\;/g, "").toLowerCase();
        },
        getPlaceholderSuffix: function getPlaceholderSuffix() {
            var result = "@" + this.$store.getters.agencyHumanName.toLowerCase() + ".com";
            return result.replace(/\s+|\:|\!|\+|\;/g, "");
        },
        getPublicVideoRecordingLink: function getPublicVideoRecordingLink(userId) {
            var hashId;
            return regeneratorRuntime.async(function getPublicVideoRecordingLink$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (userId) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt("return", "");

                        case 2:
                            if (this.$store.getters.hasCandidateIntroVideo) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt("return", "");

                        case 4:
                            _context.next = 6;
                            return regeneratorRuntime.awrap(this.getHashId(Number(userId) + 10));

                        case 6:
                            hashId = _context.sent;
                            return _context.abrupt("return", this.rootUrl + "/candidate-video-recording/" + userId + "/" + hashId);

                        case 8:
                        case "end":
                            return _context.stop();
                    }
                }
            }, null, this);
        },
        convertPhoneInfo: function convertPhoneInfo(userObject) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = _modelByTypes.MODEL_USER_PHONE_FIELD[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var phoneField = _step2.value;

                    if (userObject[phoneField]) {
                        userObject[phoneField] = this.getDisplayPhone(userObject[phoneField]);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        getUserType: function getUserType(user) {
            var userType = "";
            if (user.is_employer) {
                userType = "Client";
            } else if (user.is_agent) {
                userType = "Admin";
            } else if (user.is_candidate) {
                userType = "Candidate";
            }
            return userType;
        },
        getUserProfileBuilder: function getUserProfileBuilder(user) {
            var listBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (listBuilder == null) {
                listBuilder = this.$store.getters.profileBuilderList;
            }
            var applicationFormId = user.application_form;
            if (typeof applicationFormId !== "number") {
                applicationFormId = user.application_form_id;
            }
            // Find corresponding profile builder
            var profileBuilder = listBuilder.find(function (builder) {
                return builder.application_builder_id === applicationFormId && builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
            });
            if (profileBuilder) {
                return profileBuilder;
            }
            // If There is no builder for profile, use builder for application instead
            profileBuilder = listBuilder.find(function (builder) {
                return builder.id === applicationFormId;
            });
            if (profileBuilder) {
                return profileBuilder;
            }
            // For old data, which is not set applicaiton_form, find one profile builder
            profileBuilder = listBuilder.find(function (builder) {
                return builder.type === _customDefineType.BUILDER_TYPE.PROFILE && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
            });
            if (profileBuilder) {
                return profileBuilder;
            }
            // For old data, which is not set applicaiton_form, no profile builder => use application builder
            profileBuilder = listBuilder.find(function (builder) {
                return builder.type === _customDefineType.BUILDER_TYPE.APPLICATION && builder.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT;
            });
            return profileBuilder;
        },
        getUserById: function getUserById(id) {
            var res;
            return regeneratorRuntime.async(function getUserById$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return regeneratorRuntime.awrap(_axios2.default.get("/api/people/" + id + "/"));

                        case 2:
                            res = _context2.sent;

                            if (!(res && res.data)) {
                                _context2.next = 5;
                                break;
                            }

                            return _context2.abrupt("return", res.data);

                        case 5:
                            return _context2.abrupt("return", null);

                        case 6:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, null, this);
        }
    }
});

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
  methods: {
    getNextRow: function getNextRow(element) {
      var parentNode = element;
      var nextSibling = void 0;
      while (true) {
        parentNode = parentNode.parentNode;
        nextSibling = parentNode.nextSibling;
        while (nextSibling) {
          var tagName = nextSibling.tagName;
          if (tagName && tagName.toLowerCase() !== "hr") {
            break;
          }
          nextSibling = nextSibling.nextSibling;
        }
        if (nextSibling) {
          break;
        }
      }
      return nextSibling;
    },
    onMultiselectOpen: function onMultiselectOpen(event) {
      if (event && event.target) {
        event.target.classList.add('multiselect--active');
      }
    },
    onMultiselectClose: function onMultiselectClose(event) {
      if (event && event.target) {
        if (event.target.classList) {
          event.target.classList.remove('multiselect--active');
        }
      }
    }
  }
});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _en = __webpack_require__(239);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        /*
        Example: obj: {key1: {key2: {key3: value}}}
        key: "key1.key2.key3"
        Return value
        */
        getValueOfNestedObject: function getValueOfNestedObject(obj, multiLevelKey) {
            var keys = multiLevelKey.split('.');
            var currentObj = obj;
            for (var index = 0; index < keys.length; index++) {
                var key = keys[index];
                if (currentObj[key]) {
                    if (index === keys.length - 1) {
                        return currentObj[key];
                    } else {
                        currentObj = currentObj[key];
                        if ((typeof currentObj === "undefined" ? "undefined" : _typeof(currentObj)) !== 'object') {
                            return "";
                        }
                    }
                } else {
                    return "";
                }
            }
            return "";
        },
        getLabelByKeys: function getLabelByKeys(key) {
            if (!key) {
                return '';
            }
            var label = this.getValueOfNestedObject(this.$store.getters.multiLanguageValues, key);
            if (!label) {
                // If phrase is not defined for the language, use phrase in English
                label = this.getValueOfNestedObject(_en2.default, key);
            }

            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            if (args && args.length) {
                return this.formatContent.apply(this, [label].concat(args));
            } else {
                return label;
            }
        }
    }
});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(4);

var _axios2 = _interopRequireDefault(_axios);

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(11);

var _customDefineType = __webpack_require__(6);

var _fieldTypes = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
    methods: _extends({}, (0, _vuex.mapActions)(["getUserDeviceId"]), {
        calculateHoursWorked: function calculateHoursWorked(job) {
            var savedModel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (savedModel && job[savedModel]) {
                return job[savedModel];
            }
            if (job.actual_start_time && job.actual_end_time) {
                var result = this.calculateDuration(job.actual_start_date, job.actual_start_time, job.actual_end_date, job.actual_end_time, job.breaks);
                // Hours worked of shift jobs cannot be greater than or equal to 24 hours
                // The result may incorrect because of incorrect actual_end_date
                if (result > 24) {
                    // Overnight booking
                    if (job.end_date && job.end_date >= job.actual_end_date) {
                        return result;
                    }
                    result = result - Math.floor(result / 24) * 24;
                }
                return result;
            }
            return null;
        },
        getJobCategory: function getJobCategory(job, categoryList) {
            if (job.category) {
                return job.category;
            }
            // If there is only one category, set it as job category
            if (categoryList && categoryList.length === 1) {
                return categoryList[0];
            }
            return "";
        },
        isCategoryEqual: function isCategoryEqual(job, price, categoryList) {
            var jobCategory = this.getJobCategory(job, categoryList);
            var jobCategoryPrices = price.job_categories;
            // Job category empty or undefined
            if (jobCategoryPrices == null || jobCategoryPrices.length === 0) {
                return true;
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = jobCategoryPrices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var jobCategoryPrice = _step.value;

                    if (this.compareTextWithoutPunctuation(jobCategory, jobCategoryPrice)) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        },
        isZipCodeEqual: function isZipCodeEqual(job, price) {
            var zipCodePrices = price.zip_codes;
            // Zip Code Prices is empty or undefined
            if (zipCodePrices == null || zipCodePrices.length === 0) {
                return true;
            }
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = zipCodePrices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var zipCodePrice = _step2.value;

                    if (this.compareTextWithoutPunctuation(job.postal_code, zipCodePrice)) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return false;
        },
        isJobMatchPrice: function isJobMatchPrice(job, price, categoryList) {
            // Compare category
            if (!this.isCategoryEqual(job, price, categoryList)) {
                return false;
            }
            // Compare Zip Code
            if (!this.isZipCodeEqual(job, price)) {
                return false;
            }
            // Compare out of town
            if (price.is_out_of_town) {
                if (job.is_out_of_town === false) {
                    return false;
                }
            }
            if (price.is_out_of_town === false) {
                if (job.is_out_of_town) {
                    return false;
                }
            }
            // Compare restricted date
            if (price.is_restrict_date && price.restrict_dates) {
                var bookingDay = this.dateInDjangoFormat(job.date || this.selectedDate);
                // Remove year
                bookingDay = bookingDay.substring(4);
                if (!price.restrict_dates.some(function (date) {
                    return date.includes(bookingDay);
                })) {
                    return false;
                }
            }
            // Price is used for job if it is created before job
            var compareDate = job.created_date;
            // If the price is created before the job's last update
            if (job.last_updated_date) {
                compareDate = job.last_updated_date;
            }
            if (compareDate && price.created_date) {
                return price.created_date <= compareDate;
            }
            return true;
        },
        getAdminFee: function getAdminFee(totalFee, job) {
            var _this = this;

            if (!job) {
                return 0;
            }
            if (job.admin_fee) {
                if (job.admin_fee === "0.00") {
                    return 0;
                }
                return job.admin_fee;
            }
            var priceItem = this.$store.getters.priceList.find(function (price) {
                return price.type === _customDefineType.PRICE_TYPES.ADMIN_FEE && _this.isJobMatchPrice(job, price);
            });
            if (!priceItem) {
                return 0;
            }
            return Number(totalFee) * Number(priceItem.percentage) / 100;
        },
        formatJobDate: function formatJobDate(job) {
            if (!job.date) {
                return '';
            }
            return this.addTimeToDate(job.date).toDateString();
        },
        calculateSuggestedHours: function calculateSuggestedHours(job, filler) {
            console.log(filler);
            var listActualModels = ['actual_start_date', 'actual_start_time', 'actual_end_date', 'actual_end_time', 'breaks'];
            var jobInfo = _extends({}, job);
            if (filler && filler.info) {
                listActualModels.forEach(function (model) {
                    if (filler.info[model]) {
                        jobInfo[model] = filler.info[model];
                    }
                });
            }
            return this.calculateHoursWorked(jobInfo) || this.calculateHoursBooked(jobInfo);
        },
        calculateSuggestedClientCharge: function calculateSuggestedClientCharge(job, listJobFillers) {
            var filler = null;
            if (listJobFillers && listJobFillers.length) {
                filler = listJobFillers[0];
            }
            //load values into variables to avoid null errors
            var total = 0;
            var hours = job.hours_worked ? parseFloat(job.hours_worked) : 0;
            if (!hours) {
                hours = this.calculateSuggestedHours(job, filler) || 0;
            }
            var clientRate = job.client_rate ? parseFloat(job.client_rate) : 0;
            var candidateRate = job.candidate_rate ? parseFloat(job.candidate_rate) : 0;
            var agencyRate = job.agency_fee ? parseFloat(job.agency_fee) : 0;
            var travelFee = job.travel_fee ? parseFloat(job.travel_fee) : 0;
            var rushFee = job.rush_fee ? parseFloat(job.rush_fee) : 0;
            var perBookingAgencyFee = job.per_booking_agency_fee ? parseFloat(job.per_booking_agency_fee) : 0;
            var perBookingCandidateFee = job.per_booking_candidate_fee ? parseFloat(job.per_booking_candidate_fee) : 0;
            var additionalFee = job.additional_fee ? parseFloat(job.additional_fee) : 0;
            var tip = job.tip ? parseFloat(job.tip) : 0;
            if (clientRate) {
                total += clientRate * hours;
            } else {
                total += candidateRate * hours;
                total += agencyRate * hours;
            }
            total += perBookingCandidateFee + travelFee + perBookingAgencyFee + rushFee + additionalFee + tip;
            var adminFee = this.getAdminFee(total, job);
            total += Number(adminFee);
            return total.toFixed(2);
        },
        calculateHoursBooked: function calculateHoursBooked(job) {
            var result = this.calculateDuration(job.date, job.start_time, job.end_date, job.end_time);
            if (result) {
                return this.roundNumberTwoDigits(result);
            }
            return null;
        },
        calculateRegularHoursWorked: function calculateRegularHoursWorked(job) {
            var hoursWorked = this.calculateHoursWorked(job);
            if (!hoursWorked) {
                return null;
            }
            var result = hoursWorked > 8 ? 8 : hoursWorked;
            return result.toFixed(2);
        },
        calculateOvertimeHoursWorked: function calculateOvertimeHoursWorked(job) {
            var hoursWorked = this.calculateHoursWorked(job);
            if (!hoursWorked) {
                return null;
            }
            var result = hoursWorked > 8 ? hoursWorked - 8 : 0;
            return result.toFixed(2);
        },
        calculateHoursWorkedFormatted: function calculateHoursWorkedFormatted(job) {
            var hoursWorked = this.calculateHoursWorked(job, 'hours_worked');
            if (!hoursWorked) {
                return null;
            }
            if (typeof hoursWorked == 'string') {
                return hoursWorked;
            }
            return hoursWorked.toFixed(2);
        },
        calculateCandidatePay: function calculateCandidatePay(job, filler) {
            var booking_fee = job.per_booking_candidate_fee ? job.per_booking_candidate_fee : 0;
            var tip = job && job.tip ? Number(job.tip) : 0;
            var candidate_pay = void 0;
            if (filler && filler.info) {
                if (job.actual_start_time && !filler.info.actual_start_time) {
                    filler.info.actual_start_time = job.actual_start_time;
                }
                if (job.actual_start_date && !filler.info.actual_start_date) {
                    filler.info.actual_start_date = job.actual_start_date;
                }
                candidate_pay = job.candidate_rate * this.calculateHoursWorked(filler.info) + parseFloat(booking_fee) + tip;
            } else {
                candidate_pay = job.candidate_rate * this.calculateHoursWorked(job) + parseInt(booking_fee) + tip;
            }
            if (!candidate_pay) {
                return null;
            }
            return this.roundNumberTwoDigits(candidate_pay);
        },

        // Calculate both agency fee and candidate fee
        calculateJobCharge: function calculateJobCharge(job, filler) {
            var passedHoursWorked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var excludeTip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var hoursWorked = 0;
            if (passedHoursWorked) {
                hoursWorked = passedHoursWorked;
            } else {
                if (filler && filler.info) {
                    if (job.actual_start_time && !filler.info.actual_start_time) {
                        filler.info.actual_start_time = job.actual_start_time;
                    }
                    if (job.actual_start_date && !filler.info.actual_start_date) {
                        filler.info.actual_start_date = job.actual_start_date;
                    }
                    hoursWorked = this.calculateHoursWorked(filler.info);
                } else {
                    hoursWorked = this.calculateHoursWorked(job);
                }
            }
            var agencyAmount = 0;
            var candidateAmount = 0;
            var hasAgencyFee = false;
            if (job.agency_fee && !isNaN(job.agency_fee)) {
                hasAgencyFee = true;
                agencyAmount = Number(job.agency_fee) * hoursWorked;
            }
            if (job.client_rate && !isNaN(job.client_rate)) {
                candidateAmount = Number(job.client_rate) * hoursWorked;
                if (job.candidate_rate && !isNaN(job.candidate_rate)) {
                    candidateAmount = Number(job.candidate_rate) * hoursWorked;
                    if (!hasAgencyFee) {
                        agencyAmount = (Number(job.client_rate) - Number(job.candidate_rate)) * hoursWorked;
                    }
                }
            }

            if (!candidateAmount) {
                if (this.$store.getters.adminCanSetCandidateRate) {
                    if (filler && filler.rate && !isNaN(filler.rate)) {
                        candidateAmount = Number(filler.rate) * hoursWorked;
                    }
                }
            }

            if (filler && filler.info) {
                if (this.$store.getters.chargeTransferIncludeMileage) {
                    var numberOfMiles = filler.info.mileage;
                    if (numberOfMiles) {
                        candidateAmount += Number(numberOfMiles) * this.$store.getters.chargeTransferPricePerMile;
                    }
                }
                if (this.$store.getters.chargeTransferIncludeReimbersement) {
                    var reimbursement = filler.info.reimbursement;
                    if (reimbursement) {
                        candidateAmount += Number(reimbursement);
                    }
                }
            }

            var listFeeModelAgency = ["rush_fee", "per_booking_agency_fee", "admin_fee", "admin_fee_subtraction", "additional_fee"];
            var listFeeModelCandidate = ["travel_fee", "candidate_rush_fee", "per_booking_candidate_fee"];
            if (!excludeTip) {
                listFeeModelCandidate.push("tip");
            }
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = listFeeModelAgency[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var feeModel = _step3.value;

                    if (job[feeModel] && !isNaN(job[feeModel])) {
                        agencyAmount += Number(job[feeModel]);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = listFeeModelCandidate[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _feeModel = _step4.value;

                    if (job[_feeModel] && !isNaN(job[_feeModel])) {
                        candidateAmount += Number(job[_feeModel]);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            if (job.admin_fee_subtraction && !isNaN(job.admin_fee_subtraction)) {
                candidateAmount = candidateAmount - Number(job.admin_fee_subtraction);
            }
            return {
                candidateAmount: this.roundNumberTwoDigits(candidateAmount),
                agencyAmount: this.roundNumberTwoDigits(agencyAmount)
            };
        },
        getListDateTimeOfJobs: function getListDateTimeOfJobs(job) {
            var _this2 = this;

            if (!job.date) {
                return [];
            }
            // Repeat booking or multiple bookings
            var listStartDateTimes = this.getListDateOfRepeatBooking(job, null);
            // Get list dates from start_date to end_date of the booking
            var jobStartDate = this.dateInDjangoFormat(job.date);
            var startTimeString = this.getTimeString(job.start_time);
            var endTimeString = this.getTimeString(job.end_time);
            var endingByMidnight = false;
            if (endTimeString === "00:00:00") {
                endingByMidnight = true;
                endTimeString = "23:59:59";
            }
            if (job.end_date && this.dateInDjangoFormat(job.end_date) > jobStartDate) {
                var listDates = this.getDatesInRange(jobStartDate, job.end_date);
                if (endingByMidnight) {
                    listDates.pop();
                }
                var result = [];
                listStartDateTimes.forEach(function (dateTimes, bookingIndex) {
                    var date = dateTimes.date;
                    for (var index = 0; index < listDates.length; index++) {
                        var dateObj = new Date(date + 'T12:00:00');
                        // Find start and end in hours of job
                        var startTime = void 0;
                        var endTime = void 0;
                        if (index === 0) {
                            startTime = _this2.getTimeString(dateTimes.start_time);
                        } else {
                            startTime = "00:00:00";
                        }
                        if (index === listDates.length - 1) {
                            endTime = _this2.getTimeString(dateTimes.end_time);
                        } else {
                            endTime = "23:59:59";
                        }
                        if (!endTime || endTime === "00:00:00") {
                            endTime = "23:59:59";
                        }
                        result.push({
                            date: _this2.dateInDjangoFormat(_this2.addDaysToDate(index, dateObj)),
                            startTime: startTime,
                            endTime: endTime,
                            index: bookingIndex
                        });
                    }
                });
                console.log(result);
                return result;
            } else {
                // Not overnight booking
                if (!startTimeString || !endTimeString || startTimeString < endTimeString) {
                    return listStartDateTimes.map(function (dateTimes, index) {
                        var endTimeString = _this2.getTimeString(dateTimes.end_time);
                        if (endTimeString === "00:00:00") {
                            endTimeString = "23:59:59";
                        }
                        return {
                            date: dateTimes.date,
                            startTime: _this2.getTimeString(dateTimes.start_time) || "00:00:00",
                            endTime: endTimeString || "23:59:59",
                            index: index
                        };
                    });
                }
                // Overnight booking
                var _result = [];
                listStartDateTimes.forEach(function (dateTimes, index) {
                    var endTimeString = _this2.getTimeString(dateTimes.end_time);
                    if (endTimeString === "00:00:00") {
                        endTimeString = "23:59:59";
                    }
                    _result.push({
                        date: dateTimes.date,
                        startTime: _this2.getTimeString(dateTimes.start_time) || "00:00:00",
                        endTime: "23:59:59",
                        index: index // Index to track for the same booking
                    });
                    _result.push({
                        date: _this2.getNextDate(dateTimes.date),
                        startTime: "00:00:00",
                        endTime: endTimeString,
                        index: index
                    });
                });
                return _result;
            }
        },
        isTimeOffConflict: function isTimeOffConflict(candidate, listRelatedAvailabilities, listDateTimesOfJobs) {
            var _this3 = this;

            var listCandidateTimeOff = listRelatedAvailabilities.filter(function (availability) {
                return availability.user === candidate.id && availability.type === "Time Off" && availability.status !== "Declined";
            });
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                var _loop = function _loop() {
                    var dateTimes = _step5.value;

                    if (listCandidateTimeOff.some(function (timeOff) {
                        return timeOff.date === dateTimes.date && (timeOff.unavailable || _this3.isTimeRangeOverlap(timeOff.start_time, timeOff.end_time, dateTimes.startTime, dateTimes.endTime));
                    })) {
                        return {
                            v: true
                        };
                    }
                };

                for (var _iterator5 = listDateTimesOfJobs[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _ret = _loop();

                    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return false;
        },
        filterJobsOfCandidate: function filterJobsOfCandidate(jobs, candidateId) {
            var _this4 = this;

            var result = jobs.filter(function (job) {
                return !_this4.$store.getters.listShiftJobStatusesCancelled.includes(job.status);
            });
            if (this.$store.getters.multipleFillersShiftJob) {
                return this.filterJobsOfCandidateMultiFiller(result, candidateId);
            } else {
                return this.filterJobsOfCandidateOneFiller(result, candidateId);
            }
        },
        filterJobsOfCandidateMultiFiller: function filterJobsOfCandidateMultiFiller(jobs, candidateId) {
            return jobs.filter(function (job) {
                if (Array.isArray(job.fillers)) {
                    if (!job.fillers || !job.fillers.length) {
                        return false;
                    }
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = job.fillers[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var filler = _step6.value;

                            if (filler === candidateId) {
                                return true;
                            }
                            if ((typeof filler === "undefined" ? "undefined" : _typeof(filler)) === 'object') {
                                if (filler.id === candidateId) {
                                    return true;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }

                    return false;
                } else {
                    return job.fillers === candidateId;
                }
            });
        },
        filterJobsOfCandidateOneFiller: function filterJobsOfCandidateOneFiller(jobs, candidateId) {
            return jobs.filter(function (job) {
                return Number(job.filler) === candidateId;
            });
        },
        isExceedMaxJobDaily: function isExceedMaxJobDaily(candidate, jobs, targetJob, listDateTimesOfJobs) {
            var _this5 = this;

            if (this.$store.getters.hideMaximumBookingsUserCanHaveCandidateProfile) {
                return false;
            }
            var maxNumber = candidate.max_booking_number_daily;
            if (!maxNumber) {
                return false;
            }
            var listCandidateJobs = this.filterJobsOfCandidate(jobs, candidate.id);
            if (targetJob && targetJob.id) {
                listCandidateJobs = listCandidateJobs.filter(function (job) {
                    return job.id !== targetJob.id;
                });
            }
            var listDates = listDateTimesOfJobs.map(function (dateTime) {
                return _this5.dateInDjangoFormat(dateTime.date);
            });
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                var _loop2 = function _loop2() {
                    var date = _step7.value;

                    var numberJobs = listCandidateJobs.filter(function (job) {
                        return job.date === date;
                    }).length;
                    if (numberJobs >= maxNumber) {
                        return {
                            v: true
                        };
                    }
                };

                for (var _iterator7 = listDates[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _ret2 = _loop2();

                    if ((typeof _ret2 === "undefined" ? "undefined" : _typeof(_ret2)) === "object") return _ret2.v;
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            return false;
        },
        isTimeConflict: function isTimeConflict(candidate, jobs, targetJob) {
            if (!jobs) {
                return null;
            }
            var listCandidateJobs = this.filterJobsOfCandidate(jobs, candidate.id);
            var bufferHours = Number(candidate.buffer_time) || this.$store.getters.defaultCandidateBufferTime;
            if (bufferHours) {
                // For example: if bufferHours = 1h, first job ending by 10:00, the second can start from 11:00
                // We need to reduce bufferHours a little bit to handle that case
                bufferHours = bufferHours - 0.001;
            }
            var listDateTimesOfJobs = []; // List date time of job + buffer time
            var listStartDateTimes = this.getListDateOfRepeatBooking(targetJob, null);
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = listStartDateTimes[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var startDateTimes = _step8.value;

                    var startDate = startDateTimes.date;
                    var startTime = this.getTimeString(startDateTimes.start_time);
                    var endTime = this.getTimeString(startDateTimes.end_time);
                    var jobTimeWithBuffer = this.subtractDateByHour(this.dateInDjangoFormat(startDate), startTime, bufferHours);
                    var endDate = this.getBookingEndDate(_extends({}, targetJob, {
                        date: startDate,
                        start_time: startTime,
                        end_time: endTime
                    }));
                    var jobEndTimeWithBuffer = this.addDateByHour(this.dateInDjangoFormat(endDate), endTime, bufferHours);
                    var bufferTimeJob = {
                        date: jobTimeWithBuffer.date,
                        start_time: jobTimeWithBuffer.time,
                        end_date: jobEndTimeWithBuffer.date,
                        end_time: jobEndTimeWithBuffer.time
                    };
                    listDateTimesOfJobs = [].concat(_toConsumableArray(listDateTimesOfJobs), _toConsumableArray(this.getListDateTimeOfJobs(bufferTimeJob)));
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = listCandidateJobs[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var job = _step9.value;

                    if (targetJob.id) {
                        if (job.id === targetJob.id) {
                            continue;
                        }
                    }
                    // Check conflict of each job with the current job
                    var listDateTimeOfJobs2 = this.getListDateTimeOfJobs(job);
                    var _iteratorNormalCompletion10 = true;
                    var _didIteratorError10 = false;
                    var _iteratorError10 = undefined;

                    try {
                        for (var _iterator10 = listDateTimeOfJobs2[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                            var datetimes2 = _step10.value;
                            var _iteratorNormalCompletion11 = true;
                            var _didIteratorError11 = false;
                            var _iteratorError11 = undefined;

                            try {
                                for (var _iterator11 = listDateTimesOfJobs[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                    var datetimes = _step11.value;

                                    if (datetimes.date !== datetimes2.date) {
                                        continue;
                                    }
                                    if (this.isTimeRangeOverlap(datetimes.startTime, datetimes.endTime, datetimes2.startTime, datetimes2.endTime)) {
                                        return job;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError11 = true;
                                _iteratorError11 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                        _iterator11.return();
                                    }
                                } finally {
                                    if (_didIteratorError11) {
                                        throw _iteratorError11;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError10 = true;
                        _iteratorError10 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                _iterator10.return();
                            }
                        } finally {
                            if (_didIteratorError10) {
                                throw _iteratorError10;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            return null;
        },
        isAvailabilityConflict: function isAvailabilityConflict(candidate, listRelatedAvailabilities, weekAvailabilities, listDateTimesOfJobs) {
            var _this6 = this;

            var acceptNoAvailability = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            // We want to get the availabilities belonging to each candidate
            var candidateAvailabilities = listRelatedAvailabilities.filter(function (availability) {
                return availability.user == candidate.id && availability.type == "Availability";
            });

            // Check if user is unavailable in one of list dates
            var isUnavaialble = candidateAvailabilities.some(function (availability) {
                return availability.unavailable;
            });
            if (isUnavaialble) {
                // Unavailable in one of the dates
                return true;
            }

            var listWeekAvailabilities = weekAvailabilities.filter(function (weekAvailability) {
                return weekAvailability.user == candidate.id;
            }).sort(function (a, b) {
                return a.effective_date < b.effective_date ? 1 : -1;
            });

            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
                var _loop3 = function _loop3() {
                    var datetimes = _step12.value;

                    var date = datetimes.date;
                    var listDayBlocksAvailability = candidateAvailabilities.filter(function (availability) {
                        return availability.date === date && !availability.unavailable;
                    }).map(function (availability) {
                        var endTime = availability.end_time;
                        if (availability.start_time && endTime && endTime < availability.start_time) {
                            // Next day
                            endTime = "23:59:59";
                        }
                        return [availability.start_time, endTime];
                    });
                    if (!listDayBlocksAvailability.length) {
                        // If there is no day availabilities, weekly availability will be used
                        var currentWeekAvailability = listWeekAvailabilities.find(function (weekAvailability) {
                            return _this6.isEffectiveObject(weekAvailability, date);
                        });
                        if (currentWeekAvailability) {
                            listDayBlocksAvailability = currentWeekAvailability[_this6.getDayOfWeek(date)];
                        }
                    }
                    // Find start and end in hours of job
                    var startInHours = _this6.convertTimeToInHours(datetimes.startTime);
                    var endInHours = _this6.convertTimeToInHours(datetimes.endTime);
                    // Find an availability which contains duration from startTime to endTime
                    var hasAvailability = listDayBlocksAvailability.some(function (availability) {
                        if (!availability[0]) {
                            return false;
                        }
                        var availabilityStart = _this6.convertTimeToInHours(availability[0]);
                        var availabilityEndTime = availability[1];
                        if (!availabilityEndTime || availabilityEndTime === "00:00:00") {
                            availabilityEndTime = "23:59:59";
                        }
                        var availabilityEnd = _this6.convertTimeToInHours(availabilityEndTime);

                        // If the job times fall within the availability block, we are good to go

                        return startInHours >= availabilityStart && endInHours <= availabilityEnd;
                    });
                    if (!hasAvailability) {
                        if (!acceptNoAvailability) {
                            return {
                                v: true
                            };
                        }
                    }
                };

                for (var _iterator12 = listDateTimesOfJobs[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var _ret3 = _loop3();

                    if ((typeof _ret3 === "undefined" ? "undefined" : _typeof(_ret3)) === "object") return _ret3.v;
                }
            } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                        _iterator12.return();
                    }
                } finally {
                    if (_didIteratorError12) {
                        throw _iteratorError12;
                    }
                }
            }

            return false;
        },
        hasNoAvailability: function hasNoAvailability(candidate, listRelatedAvailabilities, weekAvailabilities, listDateTimesOfJobs) {
            var _this7 = this;

            // We want to get the availabilities belonging to each candidate
            var candidateAvailabilities = listRelatedAvailabilities.filter(function (availability) {
                return availability.user == candidate.id && availability.type == "Availability";
            });
            var listWeekAvailabilities = weekAvailabilities.filter(function (weekAvailability) {
                return weekAvailability.user == candidate.id;
            }).sort(function (a, b) {
                return a.effective_date < b.effective_date ? 1 : -1;
            });

            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
                var _loop4 = function _loop4() {
                    var datetimes = _step13.value;

                    var date = datetimes.date;
                    var listDayBlocksAvailability = candidateAvailabilities.filter(function (availability) {
                        return availability.date === date && !availability.unavailable;
                    });
                    if (listDayBlocksAvailability.length) {
                        return {
                            v: false
                        };
                    }
                    // If there is no day availabilities, weekly availability will be used
                    var currentWeekAvailability = listWeekAvailabilities.find(function (weekAvailability) {
                        return _this7.isEffectiveObject(weekAvailability, date);
                    });
                    if (currentWeekAvailability) {
                        listDayBlocksAvailability = currentWeekAvailability[_this7.getDayOfWeek(date)];
                        if (listDayBlocksAvailability && listDayBlocksAvailability.length) {
                            return {
                                v: false
                            };
                        }
                    }
                };

                for (var _iterator13 = listDateTimesOfJobs[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                    var _ret4 = _loop4();

                    if ((typeof _ret4 === "undefined" ? "undefined" : _typeof(_ret4)) === "object") return _ret4.v;
                }
            } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion13 && _iterator13.return) {
                        _iterator13.return();
                    }
                } finally {
                    if (_didIteratorError13) {
                        throw _iteratorError13;
                    }
                }
            }

            return true;
        },

        /* Get map of all candidate which is available on 'date'
         Return:
         candidateID => [{start: startTime, end: endTime}]
         */
        getMapAvailableCandidates: function getMapAvailableCandidates(date, listAvailabilities, listWeekAvailabilities, listJobs, listFilteredIds, listCandidates) {
            var _this8 = this;

            if (!date) {
                return {};
            }
            // Get all candidates which has availabilities on 'date'
            var dayOfWeek = this.getDayOfWeek(date);
            var listRelatedDayAvailabilities = listAvailabilities.filter(function (availability) {
                return availability.date === date;
            });
            var listRelatedWeekAvailabilities = listWeekAvailabilities.filter(function (weekAvailability) {
                var availabilityOfDay = weekAvailability[dayOfWeek];
                if (!availabilityOfDay || !availabilityOfDay.length) {
                    return false;
                }
                if (!_this8.isEffectiveObject(weekAvailability, date)) {
                    return false;
                }
                return true;
            }).sort(function (a, b) {
                return a.effective_date < b.effective_date ? 1 : -1;
            });
            var listCandidateIds = [].concat(_toConsumableArray(listRelatedDayAvailabilities.map(function (availability) {
                return availability.user;
            })), _toConsumableArray(listRelatedWeekAvailabilities.map(function (availability) {
                return availability.user;
            })));
            if (listFilteredIds) {
                listCandidateIds = listCandidateIds.filter(function (id) {
                    return listFilteredIds.includes(id);
                });
            }
            listCandidateIds = this.deduplicateArrayOfObject(listCandidateIds);
            var result = {};
            var minDuration = this.$store.getters.shiftRequestMinimumHoursAllTypes;
            // Check availability duration of each candidate in the list
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                var _loop5 = function _loop5() {
                    var candidateId = _step14.value;

                    // Find list available time blocks of the candidate
                    var listAvailableBlocks = [];
                    var listUnavailableBlocks = []; // Time off or has job
                    var listCandidateDayAvailability = listRelatedDayAvailabilities.filter(function (availability) {
                        return availability.user === candidateId;
                    });
                    var isUnavaialble = false;
                    var _iteratorNormalCompletion15 = true;
                    var _didIteratorError15 = false;
                    var _iteratorError15 = undefined;

                    try {
                        for (var _iterator15 = listCandidateDayAvailability[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                            var dayAvailability = _step15.value;

                            if (dayAvailability.type === 'Availability') {
                                if (dayAvailability.unavailable) {
                                    // All day unavailable
                                    isUnavaialble = true;
                                    break;
                                }
                                var _availabilityBlock = _this8.getTimeBlock(dayAvailability);
                                var duration = _this8.calculateDiffTimeInHours(_availabilityBlock.startTime, _availabilityBlock.endTime);
                                if (duration < minDuration) {
                                    continue;
                                }
                                listAvailableBlocks.push(_availabilityBlock);
                            } else if (dayAvailability.type === "Time Off" && dayAvailability.status !== "Declined") {
                                if (dayAvailability.unavailable) {
                                    // Check if all day timeoff
                                    isUnavaialble = true;
                                    break;
                                }
                                listUnavailableBlocks.push(_this8.getTimeBlock(dayAvailability));
                            }
                        }
                    } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion15 && _iterator15.return) {
                                _iterator15.return();
                            }
                        } finally {
                            if (_didIteratorError15) {
                                throw _iteratorError15;
                            }
                        }
                    }

                    if (isUnavaialble) {
                        return "continue";
                    }
                    // If day availability is not defined => check week availability
                    if (!listAvailableBlocks.length) {
                        var _currentWeekAvailability = listRelatedWeekAvailabilities.find(function (availability) {
                            return availability.user === candidateId;
                        });
                        if (_currentWeekAvailability) {
                            var listBlocks = _currentWeekAvailability[dayOfWeek];
                            if (listBlocks && listBlocks.length) {
                                var _iteratorNormalCompletion16 = true;
                                var _didIteratorError16 = false;
                                var _iteratorError16 = undefined;

                                try {
                                    for (var _iterator16 = listBlocks[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                                        var block = _step16.value;

                                        var availabilityBlock = {
                                            startTime: block[0] || '00:00:00',
                                            endTime: block[1] || '23:59:59'
                                        };
                                        if (availabilityBlock.endTime === '00:00:00') {
                                            availabilityBlock.endTime = '23:59:59';
                                        }
                                        listAvailableBlocks.push(availabilityBlock);
                                    }
                                } catch (err) {
                                    _didIteratorError16 = true;
                                    _iteratorError16 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion16 && _iterator16.return) {
                                            _iterator16.return();
                                        }
                                    } finally {
                                        if (_didIteratorError16) {
                                            throw _iteratorError16;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // Find list jobs of candidate
                    var listCandidateJobs = _this8.filterJobsOfCandidate(listJobs.filter(function (job) {
                        return job.date === date;
                    }), candidateId);
                    var bufferHours = _this8.$store.getters.defaultCandidateBufferTime;
                    var candidate = listCandidates.find(function (candidate) {
                        return candidate.id === candidateId;
                    });
                    if (candidate) {
                        bufferHours = Number(candidate.buffer_time) || _this8.$store.getters.defaultCandidateBufferTime;
                    }
                    var _iteratorNormalCompletion17 = true;
                    var _didIteratorError17 = false;
                    var _iteratorError17 = undefined;

                    try {
                        for (var _iterator17 = listCandidateJobs[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                            var job = _step17.value;

                            listUnavailableBlocks.push(_this8.getTimeBlock(job, bufferHours));
                        }
                        // Check for all block in list available, but not in list unavailable
                    } catch (err) {
                        _didIteratorError17 = true;
                        _iteratorError17 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion17 && _iterator17.return) {
                                _iterator17.return();
                            }
                        } finally {
                            if (_didIteratorError17) {
                                throw _iteratorError17;
                            }
                        }
                    }

                    if (listAvailableBlocks.length) {
                        if (listUnavailableBlocks.length) {
                            var listTimePoint = [];

                            var _arr = [].concat(_toConsumableArray(listAvailableBlocks), listUnavailableBlocks);

                            for (var _i = 0; _i < _arr.length; _i++) {
                                var _block = _arr[_i];
                                listTimePoint.push(_block.startTime);
                                listTimePoint.push(_block.endTime);
                            }
                            listTimePoint = _this8.deduplicateArrayOfObject(listTimePoint).sort();
                            var _listBlocks = [];

                            var _loop6 = function _loop6(index) {
                                var startTime = listTimePoint[index];
                                var endTime = listTimePoint[index + 1];
                                // Check if block [startTime, endTime] in any unavailable block
                                if (listUnavailableBlocks.some(function (block) {
                                    return block.startTime <= startTime && block.endTime >= endTime;
                                })) {
                                    return "continue";
                                }
                                if (listAvailableBlocks.some(function (block) {
                                    return block.startTime <= startTime && block.endTime >= endTime;
                                })) {
                                    var duration = _this8.calculateDiffTimeInHours(startTime, endTime);
                                    if (duration < minDuration) {
                                        return "continue";
                                    }
                                    _listBlocks.push({ startTime: startTime, endTime: endTime });
                                }
                            };

                            for (var index = 0; index < listTimePoint.length - 1; index++) {
                                var _ret6 = _loop6(index);

                                if (_ret6 === "continue") continue;
                            }
                            listAvailableBlocks = _listBlocks;
                        }
                    }
                    if (listAvailableBlocks.length) {
                        result[candidateId] = listAvailableBlocks;
                    }
                };

                for (var _iterator14 = listCandidateIds[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var _ret5 = _loop5();

                    if (_ret5 === "continue") continue;
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }

            return result;
        },

        // Get startTime, endTime from object
        getTimeBlock: function getTimeBlock(obj, bufferHours) {
            var startTime = obj.start_time || '00:00:00';
            var endTime = obj.end_time || '23:59:59';
            if (endTime === '00:00:00') {
                endTime = '23:59:59';
            }
            if (obj.end_date && obj.end_date > obj.date) {
                // Overnight booking
                endTime = '23:59:59';
            }

            if (bufferHours) {
                var newStartTime = this.subtractDateByHour(this.todayDjangoFormat, startTime, bufferHours);
                if (newStartTime.date != this.todayDjangoFormat) {
                    // Previous day
                    startTime = '00:00:00';
                } else {
                    startTime = newStartTime.time;
                }
                var newEndTime = this.addDateByHour(this.todayDjangoFormat, endTime, bufferHours);
                if (newEndTime.date != this.todayDjangoFormat) {
                    // Next day
                    endTime = '23:59:59';
                } else {
                    endTime = newEndTime.time;
                }
            }
            return {
                startTime: startTime,
                endTime: endTime
            };
        },
        getListDateOfRepeatBooking: function getListDateOfRepeatBooking(job, selectedDate) {
            if (!job) {
                return [];
            }
            var startDate = job.date || selectedDate;
            if (!startDate) {
                return [];
            }
            var listAdditionalDates = job.additional_dates || [];
            listAdditionalDates = listAdditionalDates.filter(function (date) {
                return date.date;
            });
            startDate = this.dateInDjangoFormat(startDate);
            var startTime = this.getTimeString(job.start_time);
            var endTime = this.getTimeString(job.end_time);
            var baseBooking = {
                date: startDate,
                start_time: startTime,
                end_time: endTime
            };
            if (!job.repeat || !job.repeat_end_date || !job.repeat_count || !job.repeat_type) {
                return [baseBooking].concat(_toConsumableArray(listAdditionalDates));
            }
            var result = [];
            if (job.repeat_type == 'Days') {
                var _date = startDate;
                var endDate = this.dateInDjangoFormat(job.repeat_end_date);
                while (_date <= endDate) {
                    result.push(_date);
                    _date = this.getDateAfterDays(_date, job.repeat_count);
                }
            } else {
                var repeatWeekDay = job.repeat_weekdays;
                if (!repeatWeekDay || !repeatWeekDay.length) {
                    return [baseBooking].concat(_toConsumableArray(listAdditionalDates));
                }
                repeatWeekDay = repeatWeekDay.map(function (day) {
                    return day.toLowerCase();
                });
                var _date2 = startDate;
                var count = 0;
                var _endDate = this.dateInDjangoFormat(job.repeat_end_date);
                while (_date2 <= _endDate) {
                    count += 1;
                    if (count <= 7) {
                        console.log(repeatWeekDay);
                        if (repeatWeekDay.includes(this.getDayOfWeek(_date2))) {
                            result.push(_date2);
                        }
                        _date2 = this.getDateAfterDays(_date2, 1);
                    } else {
                        count = 0;
                        _date2 = this.getDateAfterDays(_date2, 7 * (job.repeat_count - 1));
                    }
                }
            }
            var listRecurringBookings = this.deduplicateArrayOfObject([].concat(_toConsumableArray(result.map(function (date) {
                return {
                    date: date,
                    start_time: startTime,
                    end_time: endTime
                };
            }))), 'date');
            return [].concat(_toConsumableArray(listRecurringBookings), _toConsumableArray(listAdditionalDates));
        },

        // calculate how many hours a candidate is working this week
        getWeeklyHours: function getWeeklyHours(candidate, filteredJobs, startDate, endDate) {
            var _this9 = this;

            var result = 0;
            var candidateJobs = filteredJobs.filter(function (job) {
                if (_this9.$store.getters.listShiftJobStatusesCancelled.includes(job.status)) {
                    return false;
                }
                if (_this9.$store.getters.multipleFillersShiftJob) {
                    if (!job.fillers || !job.fillers.includes(candidate.id)) {
                        return false;
                    }
                } else {
                    if (job.filler != candidate.id) {
                        return false;
                    }
                }
                return job.date >= startDate && job.date <= endDate;
            });
            var _iteratorNormalCompletion18 = true;
            var _didIteratorError18 = false;
            var _iteratorError18 = undefined;

            try {
                for (var _iterator18 = candidateJobs[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                    var job = _step18.value;

                    if (!job.start_time || !job.end_time) {
                        continue;
                    }
                    var jobDuration = this.calculateDuration(job.date, job.start_time, job.end_date, job.end_time, job.breaks);
                    result += jobDuration;
                }
            } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion18 && _iterator18.return) {
                        _iterator18.return();
                    }
                } finally {
                    if (_didIteratorError18) {
                        throw _iteratorError18;
                    }
                }
            }

            return this.roundNumberTwoDigits(result);
        },
        correctEndDate: function correctEndDate(booking) {
            if (!booking.date) {
                return;
            }
            booking.end_date = this.getBookingEndDate(booking);
        },
        getBookingEndDate: function getBookingEndDate(booking) {
            if (!booking.date) {
                return;
            }
            if (booking.end_date) {
                if (booking.date < booking.end_date) {
                    return booking.end_date;
                }
            }
            if (booking.start_time && booking.end_time) {
                if (booking.start_time >= booking.end_time) {
                    // End date = Start date + 1
                    return this.getNextDate(booking.date);
                }
            }
            return booking.date;
        },
        getPosterName: function getPosterName(job) {
            var posterName = void 0;
            if (this.$store.getters.shiftJobCalendarClientNameModel === "name") {
                posterName = job.poster__first_name + " " + job.poster__last_name;
            } else {
                posterName = job["poster__" + this.$store.getters.shiftJobCalendarClientNameModel];
            }
            return posterName;
        },
        isJobCreatedInBusinessHour: function isJobCreatedInBusinessHour(job) {
            var businessHours = this.$store.getters.businessHours;
            if (businessHours && businessHours.length) {
                var createdDate = job && job.created_date ? new Date(job.created_date) : new Date();
                var dayNum = createdDate.getDay();
                // They start the days of the week from Sunday (as 0)
                dayNum = dayNum - 1; // Want to turn Monday into 0
                if (dayNum === -1) {
                    dayNum = 6; // Need Sunday to be 6
                }
                var hoursRangeStr = businessHours[dayNum];
                if (hoursRangeStr) {
                    var hourRange = hoursRangeStr.split('\t');
                    var _startTime = hourRange[0];
                    var _endTime = hourRange[1];
                    var createdTime = this.getTimeStringFromDateTime(createdDate);
                    var startTimeStr = this.getTimeString(_startTime);
                    var endTimeStr = this.getTimeString(_endTime);
                    if (_startTime && createdTime < startTimeStr) {
                        return { isInside: false, startTime: startTimeStr, endTime: endTimeStr };
                    }
                    if (_endTime && createdTime > endTimeStr) {
                        return { isInside: false, startTime: startTimeStr, endTime: endTimeStr };
                    }
                    return { isInside: true };
                } else {
                    return { isInside: false };
                }
            } else {
                // Business hours is not defined
                return { isInside: true };
            }
        },
        filterJobsByMinChildrenAge: function filterJobsByMinChildrenAge(listJobs, user) {
            var _this10 = this;

            if (!user) {
                return listJobs;
            }
            var minChildrenAgeField = this.$store.getters.minChildrenAgeField;
            if (minChildrenAgeField && user[minChildrenAgeField]) {
                // Filter out jobs which has children age < min children age
                var minAge = user[minChildrenAgeField];
                if (Array.isArray(minAge)) {
                    minAge = Math.min.apply(Math, _toConsumableArray(minAge.map(function (age) {
                        return _this10.getNumberFromString(age);
                    })));
                } else {
                    minAge = this.getNumberFromString(minAge);
                }
                if (minAge) {
                    listJobs = listJobs.filter(function (job) {
                        if (!job.children_birthdays || !job.children_birthdays.length) {
                            return true;
                        }
                        return job.children_birthdays.every(function (birthday) {
                            return !birthday || _this10.getAgeInYears(birthday) >= minAge;
                        });
                    });
                }
            }
            return listJobs;
        },
        getAFillerIdOfJob: function getAFillerIdOfJob(job) {
            if (job.selected_filler_id) {
                return job.selected_filler_id;
            }
            if (this.$store.getters.multipleFillersShiftJob) {
                if (Array.isArray(job.fillers)) {
                    if (!job.fillers || !job.fillers.length) {
                        return null;
                    }
                    var filler = job.fillers[0];
                    if ((typeof filler === "undefined" ? "undefined" : _typeof(filler)) === 'object') {
                        return filler.id;
                    }
                    return filler;
                } else {
                    return job.fillers;
                }
            } else {
                return job.filler;
            }
        },
        getObjectToCalculatePrice: function getObjectToCalculatePrice(user, job, expression, selectedDate) {
            var _this11 = this;

            var object = _extends({}, user);
            if (job) {
                var _iteratorNormalCompletion19 = true;
                var _didIteratorError19 = false;
                var _iteratorError19 = undefined;

                try {
                    for (var _iterator19 = Object.keys(job)[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                        var key = _step19.value;

                        if (['filler', 'selected_filler_id', 'tentatively_filler'].includes(key) && job[key] && !isNaN(job[key])) {
                            object['candidate_rate'] = this.getCandidateRateById(job[key]);
                        }
                        var bookingVal = job[key];
                        if (['start_time', 'end_time'].includes(key)) {
                            if (bookingVal) {
                                bookingVal = this.getTimeString(bookingVal);
                            } else {
                                bookingVal = '';
                            }
                        }
                        object["booking_" + key] = bookingVal;
                        if (key === 'pet_ids') {
                            var numberOfPets = 0;
                            if (bookingVal && Array.isArray(bookingVal)) {
                                numberOfPets = bookingVal.length;
                            }
                            object["booking_number_pets"] = numberOfPets;
                        }
                    }
                } catch (err) {
                    _didIteratorError19 = true;
                    _iteratorError19 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion19 && _iterator19.return) {
                            _iterator19.return();
                        }
                    } finally {
                        if (_didIteratorError19) {
                            throw _iteratorError19;
                        }
                    }
                }
            }
            if (job.index != null && job.index !== -1) {
                object['number_booking'] = job.index + 1;
            } else {
                object['number_booking'] = -1;
            }
            var number_fillers_need = job.number_fillers_need;
            if (number_fillers_need && !isNaN(number_fillers_need)) {
                object['number_fillers_need'] = Number(number_fillers_need);
            } else {
                object['number_fillers_need'] = 1;
            }

            // Check children_ages tag
            if (this.hasTagInExpression(expression, 'children_ages') && user) {
                var listChildren = user.children || [];
                var childrenAges = listChildren.filter(function (child) {
                    return child.birthday;
                }).map(function (child) {
                    return _this11.getAgeInYears(child.birthday);
                });
                object['children_ages'] = childrenAges.join(',');
            }
            object['booking_number_days'] = 1;
            // Replace day of week
            var startDate = this.dateInDjangoFormat(job.date || selectedDate);
            if (startDate) {
                object['booking_date'] = startDate;
                var dayOfWeek = this.dateDayOfTheWeek(this.addCurrentTimeToDate(startDate), true);
                object['booking_week_day'] = dayOfWeek;
                var hoursBooked = this.calculateDuration(startDate, this.getTimeString(job.start_time), job.end_date, this.getTimeString(job.end_time), null, false) || 0;
                object['hours_booked'] = hoursBooked;
                object['booking_number_days'] = Math.ceil(hoursBooked / 24);
            }

            // Replace is_holiday
            var isHoliday = false;
            var listHolidays = this.$store.getters.agencyHolidayDates;
            if (listHolidays && listHolidays.length) {
                if (listHolidays.includes(this.getDayMonthFromDate(startDate))) {
                    isHoliday = true;
                }
            }
            object['on_holiday'] = isHoliday;
            // Replace hours_from_now
            object['hours_from_now'] = this.calculateHoursFromNow(startDate, job ? job.start_time : null);
            var outsideResult = this.isJobCreatedInBusinessHour(job);
            // Replace outside_business_hours
            object['outside_business_hours'] = !(outsideResult && outsideResult.isInside);
            // Replace is overnight booking
            object['overnight_booking'] = false;

            if (job.start_time && job.end_time) {
                var _startTime2 = this.getTimeString(job.start_time);
                var _endTime2 = this.getTimeString(job.end_time);
                if (_startTime2 && _endTime2) {
                    if (_startTime2 > _endTime2) {
                        object['overnight_booking'] = true;
                    }
                }
            }
            object['end_time_hours'] = 0;
            if (job.end_time) {
                var _endTime3 = this.getTimeString(job.end_time);
                object['end_time_hours'] = this.convertTimeToInHours(_endTime3) || 0;
            }
            if (job.end_date) {
                var endDate = this.dateInDjangoFormat(job.end_date);
                if (endDate > startDate) {
                    object['overnight_booking'] = true;
                }
            }
            // Check filler_hours_worked_in_week tag
            if (this.hasTagInExpression(expression, 'filler_hours_worked_in_week')) {
                var mapHoursWorkedOfWeek = this.$store.getters.mapHoursWorkedOfWeek;
                if (mapHoursWorkedOfWeek && mapHoursWorkedOfWeek[job.id]) {
                    object['filler_hours_worked_in_week'] = mapHoursWorkedOfWeek[job.id];
                } else {
                    object['filler_hours_worked_in_week'] = 0;
                }
            }
            // Check filler_number_job_in_month tag
            object['filler_number_job_in_month'] = 1;
            if (this.hasTagInExpression(expression, 'filler_number_job_in_month')) {
                var fillerId = this.getAFillerIdOfJob(job);
                var mapJobNumberOfMonth = this.$store.getters.mapJobNumberOfMonth;
                if (mapJobNumberOfMonth && mapJobNumberOfMonth.fillerId == fillerId && mapJobNumberOfMonth.jobId == job.id && mapJobNumberOfMonth.date == startDate) {
                    object['filler_number_job_in_month'] = mapJobNumberOfMonth.number || 1;
                } else {
                    object['filler_number_job_in_month'] = 1;
                }
            }
            // Check poster_number_job_in_month tag
            if (this.hasTagInExpression(expression, 'poster_number_job_in_month')) {
                var mapJobNumber = this.$store.getters.mapPosterJobNumber;
                var val = mapJobNumber[(job.poster_id || job.poster) + "_" + startDate + "_" + (job.id || '') + "_month"];
                if (val) {
                    if (!job.id) {
                        val = val + 1;
                    }
                    object['poster_number_job_in_month'] = val;
                } else {
                    object['poster_number_job_in_month'] = 1;
                }
            }
            // Check poster_number_job_in_week tag
            if (this.hasTagInExpression(expression, 'poster_number_job_in_week')) {
                var _mapJobNumber = this.$store.getters.mapPosterJobNumber;
                var _val = _mapJobNumber[(job.poster_id || job.poster) + "_" + startDate + "_" + (job.id || '') + "_week"];
                if (_val) {
                    if (!job.id) {
                        _val = _val + 1;
                    }
                    object['poster_number_job_in_week'] = _val;
                } else {
                    object['poster_number_job_in_week'] = 1;
                }
            }
            // Check candidate_rate
            if (this.hasTagInExpression(expression, 'candidate_rate')) {
                var _fillerId = this.getAFillerIdOfJob(job);
                if (_fillerId) {
                    object['candidate_rate'] = this.getCandidateRateById(_fillerId);
                }
            }
            return object;
        },
        hasTagInExpression: function hasTagInExpression(expression, tag) {
            if (!expression) {
                return false;
            }
            // Price expression
            if (expression.includes("[[" + tag + "]]")) {
                return true;
            }
            // Price condition
            if (expression.includes("\"model\":\"" + tag + "\"")) {
                return true;
            }
            return false;
        },
        getCandidateRateById: function getCandidateRateById(fillerId) {
            var candidateRate = 0;
            if (fillerId) {
                var _candidate = void 0;
                if (this.$store.getters.selectedCandidate && this.$store.getters.selectedCandidate.id == fillerId) {
                    _candidate = this.$store.getters.selectedCandidate;
                }
                if (!_candidate) {
                    var candidateList = this.$store.getters.candidateListMainInfo || [];
                    _candidate = candidateList.find(function (cand) {
                        return cand.id === fillerId;
                    });
                }

                if (_candidate && _candidate.rate && !isNaN(_candidate.rate)) {
                    candidateRate = Number(_candidate.rate);
                }
            }
            return candidateRate;
        },
        getPriceFromExpression: function getPriceFromExpression(user, job, expression, selectedDate) {
            var object = this.getObjectToCalculatePrice(user, job, expression, selectedDate);
            try {
                var price = this.calcEval("(function() {" + this.replaceTagValue(expression, object, false, [], true) + "}())");
                return this.roundNumberTwoDigits(price);
            } catch (e) {
                console.log(e);
                return null;
            }
        },
        getJobLocations: function getJobLocations(poster, job) {
            var listLocations = [];
            if (job.locations && job.locations.length) {
                listLocations = job.locations;
            } else if (job.poster__locations && job.poster__locations.length) {
                listLocations = job.poster__locations;
            } else {
                if (poster && poster.locations) {
                    listLocations = poster.locations;
                }
            }
            return listLocations;
        },
        getTitleAvailableJobBoardCalendar: function getTitleAvailableJobBoardCalendar(job) {
            var shiftJobCalendarClientNameModel = this.$store.getters.shiftJobCalendarClientNameModel;
            var posterName = void 0;
            if (shiftJobCalendarClientNameModel === "name") {
                posterName = job.poster__first_name + " " + job.poster__last_name;
            } else {
                posterName = job["poster__" + shiftJobCalendarClientNameModel];
            }
            var mapTagValue = _extends({}, job);
            mapTagValue.poster_name = posterName;
            var mapConvertKeys = {
                poster_first_name: 'poster__first_name',
                poster_last_name: 'poster__last_name',
                poster_employer_name: 'poster__employer_name'
            };
            var _iteratorNormalCompletion20 = true;
            var _didIteratorError20 = false;
            var _iteratorError20 = undefined;

            try {
                for (var _iterator20 = Object.keys(mapConvertKeys)[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                    var key = _step20.value;

                    mapTagValue[key] = mapTagValue[mapConvertKeys[key]];
                }
            } catch (err) {
                _didIteratorError20 = true;
                _iteratorError20 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion20 && _iterator20.return) {
                        _iterator20.return();
                    }
                } finally {
                    if (_didIteratorError20) {
                        throw _iteratorError20;
                    }
                }
            }

            var addresses = [];
            if (job.address1) {
                addresses.push(job.address1);
            }
            if (job.address2) {
                addresses.push(job.address2);
            }
            var address = addresses.join(' - ');
            if (address) {
                address = "- " + address;
            }
            mapTagValue.address = address;

            if (job.start_time && job.end_time) {
                mapTagValue.start_time = this.djangotimeformatAMPM(job.start_time);
                mapTagValue.end_time = this.djangotimeformatAMPM(job.end_time);
            }

            var bookingTitle = this.replaceTagValue(this.$store.getters.shiftJobCalendarTitleAvailableJobBoard, mapTagValue);
            var mapReplaceValues = { "{}": "", "( - )": "", " - )": ")" };
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
                for (var _iterator21 = Object.keys(mapReplaceValues)[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                    var replaceKey = _step21.value;

                    bookingTitle = bookingTitle.replace(replaceKey, mapReplaceValues[replaceKey]);
                }
            } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion21 && _iterator21.return) {
                        _iterator21.return();
                    }
                } finally {
                    if (_didIteratorError21) {
                        throw _iteratorError21;
                    }
                }
            }

            return bookingTitle;
        },
        getMapJobTags: function getMapJobTags(job, poster) {
            var _this12 = this;

            // Get replaced value for broadcast new shift job
            return new Promise(function _callee(resolve) {
                var mapReplacedValues, listChildren, children, childrenText, mapReplaced, childrenAges, compressedChildrenAges, pets;
                return regeneratorRuntime.async(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                mapReplacedValues = {};

                                if (!poster) {
                                    _context.next = 21;
                                    break;
                                }

                                _context.next = 4;
                                return regeneratorRuntime.awrap(_this12.getListChildren(poster));

                            case 4:
                                listChildren = _context.sent;
                                _context.next = 7;
                                return regeneratorRuntime.awrap(_this12.getProfileSectionContent(poster, listChildren, _fieldTypes.MAP_DIALOG_SECTION.Children.name, true));

                            case 7:
                                children = _context.sent;

                                mapReplacedValues['children'] = children;
                                childrenText = _this12.getHtmlText(children, true).trim();
                                mapReplaced = {
                                    '\n\n\n\n\n\n\n\n\n': '\n',
                                    '\n\n\n\n\n\n\n\n': '\n',
                                    '\n\n\n\n\n\n\n': '\n',
                                    '\n\n\n\n\n\n': '\n',
                                    '\n\n\n': ': '
                                };

                                childrenText = _this12.replaceAllByMap(childrenText, mapReplaced);
                                mapReplacedValues['children_text'] = childrenText;
                                childrenAges = listChildren.map(function (child) {
                                    return _this12.getAge(child.birthday);
                                }).join('; ');

                                mapReplacedValues['ages_of_children'] = childrenAges;
                                compressedChildrenAges = listChildren.map(function (child) {
                                    return _this12.getCompressedAge(child.birthday);
                                }).join('; ');

                                mapReplacedValues['ages_of_children_compressed'] = compressedChildrenAges;

                                _context.next = 19;
                                return regeneratorRuntime.awrap(_this12.getListPets(poster));

                            case 19:
                                pets = _context.sent;

                                mapReplacedValues['pets'] = _this12.getProfileSectionContent(poster, pets, _fieldTypes.MAP_DIALOG_SECTION.Pet.name);

                            case 21:
                                resolve(mapReplacedValues);
                                return _context.abrupt("return");

                            case 23:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, null, _this12);
            });
        },
        getJobTitle: function getJobTitle(job) {
            var jobTitle = "";
            if (job.date) {
                jobTitle += " on " + this.getDateString(job.date);
                if (job.start_time && job.end_time) {
                    jobTitle += " " + this.djangotimeformatAMPM(job.start_time) + "-" + this.djangotimeformatAMPM(job.end_time);
                }
            }
            return jobTitle;
        },
        getCategoryList: function getCategoryList(bookingField) {
            if (!bookingField || !bookingField.categoryList) {
                return [];
            }
            return this.normalizedArrayValue(bookingField.categoryList);
        },
        setMapJobNumberOfMonthOnAssignJob: function setMapJobNumberOfMonthOnAssignJob(job, startDate, fillerId) {
            var _this13 = this;

            return new Promise(function _callee2(resolve) {
                var jobNumber, date, url, res;
                return regeneratorRuntime.async(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                jobNumber = 1;
                                date = _this13.dateInDjangoFormat(startDate);

                                if (!fillerId) {
                                    _context2.next = 9;
                                    break;
                                }

                                url = "/get-job-number-of-month/?filler=" + fillerId + "&date=" + date;

                                if (job.id) {
                                    url = url + "&job=" + job.id;
                                }
                                _context2.next = 7;
                                return regeneratorRuntime.awrap(_axios2.default.get(url));

                            case 7:
                                res = _context2.sent;

                                jobNumber = res.data.number;

                            case 9:

                                _this13.$store.dispatch('setMapJobNumberOfMonth', {
                                    number: jobNumber,
                                    fillerId: fillerId,
                                    jobId: job.id,
                                    date: date,
                                    time: _this13.getTimeString(job.start_time)
                                });
                                resolve();

                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, null, _this13);
            });
        },
        getJobsDatesTimes: function getJobsDatesTimes(listJobs) {
            var _this14 = this;

            if (!listJobs) {
                return "";
            }
            return listJobs.map(function (job) {
                if (!job.date) {
                    return "";
                }
                var startTime = job.start_time;
                if ((typeof startTime === "undefined" ? "undefined" : _typeof(startTime)) === 'object') {
                    startTime = _this14.getTimeString(job.start_time);
                }
                var endTime = job.end_time;
                if ((typeof endTime === "undefined" ? "undefined" : _typeof(endTime)) === 'object') {
                    endTime = _this14.getTimeString(job.end_time);
                }
                return _this14.getDateString(job.date) + ": " + _this14.djangotimeformatAMPM(startTime) + " - " + _this14.djangotimeformatAMPM(endTime);
            }).join("<br/>");
        },
        getJobsDatesTimesCompressed: function getJobsDatesTimesCompressed(listJobs) {
            var _this15 = this;

            if (!listJobs) {
                return "";
            }
            return listJobs.map(function (job) {
                if (!job.date) {
                    return "";
                }
                var startTime = job.start_time;
                if ((typeof startTime === "undefined" ? "undefined" : _typeof(startTime)) === 'object') {
                    startTime = _this15.getTimeString(job.start_time);
                }
                var endTime = job.end_time;
                if ((typeof endTime === "undefined" ? "undefined" : _typeof(endTime)) === 'object') {
                    endTime = _this15.getTimeString(job.end_time);
                }
                return _this15.compressDateFormat(job.date) + ": " + _this15.compressTimeFormat(startTime) + " - " + _this15.compressTimeFormat(endTime);
            }).join("\n");
        },
        formatDisplayJobField: function formatDisplayJobField(job, field) {
            var model = field.model;
            var data = job[field.model];
            if (Array.isArray(data) && !data.length) {
                return "";
            }
            if (Array.isArray(data) && data.length) {
                return data.join(", ");
            }
            if (model === "location") {
                var locationInfo = [];
                var listLocationModels = ["city", "provincestate", "postal_code"];
                var _iteratorNormalCompletion22 = true;
                var _didIteratorError22 = false;
                var _iteratorError22 = undefined;

                try {
                    for (var _iterator22 = listLocationModels[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                        var locationModel = _step22.value;

                        if (job[locationModel]) {
                            locationInfo.push(job[locationModel]);
                        }
                    }
                } catch (err) {
                    _didIteratorError22 = true;
                    _iteratorError22 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion22 && _iterator22.return) {
                            _iterator22.return();
                        }
                    } finally {
                        if (_didIteratorError22) {
                            throw _iteratorError22;
                        }
                    }
                }

                if (locationInfo.length == 3) {
                    // if job has city, state and postal code, join by comma and space
                    var last = locationInfo.pop();
                    return locationInfo.join(", ") + " " + last;
                }
                return locationInfo.join(", ");
            }
            if (["date", "end_date", "created_date", "last_updated_date", "last_activity", "actual_start_date", "actual_end_date", "filled_date"].includes(model)) {
                return data ? new Date(data).toDateString() : "";
            }
            return data;
        },
        isRefundCreditByFilledStatus: function isRefundCreditByFilledStatus(job) {
            if (this.$store.getters.onlyRefundForFilledJob) {
                if (job.filled) {
                    return true;
                }
            } else if (this.$store.getters.onlyRefundForNonFilledJob) {
                if (!job.filled) {
                    return true;
                }
            } else {
                return true;
            }
            return false;
        }
    })
});

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        attachKeapInfo: function attachKeapInfo(outputObj, additionalInfo, listFields, dataObj) {
            if (additionalInfo && additionalInfo.add_to_keap) {
                var listKeapFields = listFields.filter(function (field) {
                    return field.keapCustomField;
                }).map(function (field) {
                    return {
                        id: field.keapCustomField,
                        content: dataObj[field.model]
                    };
                }).filter(function (field) {
                    return field.content;
                });
                var listCustomFields = listKeapFields.filter(function (field) {
                    return typeof field.id === "number";
                });
                var listStringKeysFields = listKeapFields.filter(function (field) {
                    return typeof field.id === "string";
                });
                // Get social media fields
                var fieldTypeKey = "Social Media (";
                var listSocialMediaFields = listStringKeysFields.filter(function (field) {
                    return field.id.indexOf(fieldTypeKey) === 0;
                }).map(function (field) {
                    return {
                        name: field.content,
                        type: field.id.substring(fieldTypeKey.length, field.id.length - 1)
                    };
                });
                // Get phone fields
                fieldTypeKey = "Phone (";
                var listPhoneFields = listStringKeysFields.filter(function (field) {
                    return field.id.indexOf(fieldTypeKey) === 0;
                }).map(function (field, index) {
                    return {
                        number: field.content,
                        type: field.id.substring(fieldTypeKey.length, field.id.length - 1),
                        field: "PHONE" + (index + 1)
                    };
                });
                // Get fax fields
                fieldTypeKey = "Fax (";
                var listFaxFields = listStringKeysFields.filter(function (field) {
                    return field.id.indexOf(fieldTypeKey) === 0;
                }).map(function (field, index) {
                    return {
                        number: field.content,
                        type: field.id.substring(fieldTypeKey.length, field.id.length - 1),
                        field: "FAX" + (index + 1)
                    };
                });
                outputObj["keap_custom_data"] = {
                    custom_fields: listCustomFields,
                    social_accounts: listSocialMediaFields,
                    phone_numbers: listPhoneFields,
                    fax_numbers: listFaxFields
                };
            }
        }
    }
});

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _arrayHandling = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
    data: function data() {
        return { filterFast: _arrayHandling.filterFast, sortArrayByProp: _arrayHandling.sortArrayByProp, containsAllElements: _arrayHandling.containsAllElements, insertArrayInArray: _arrayHandling.insertArrayInArray, deduplicateArrayOfObject: _arrayHandling.deduplicateArrayOfObject, deduplicateArray: _arrayHandling.deduplicateArray, replaceItemInList: _arrayHandling.replaceItemInList };
    },

    methods: {
        findListMatchKeys: function findListMatchKeys(item, inputKeyword) {
            var keyword = inputKeyword.toLowerCase();
            var result = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(item)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (['password', 'email_username', 'resume', 'profile_pic', 'modelMatches'].includes(key)) {
                        continue;
                    }
                    if (key.indexOf('file') === 0) {
                        continue;
                    }
                    var value = item[key];
                    if (!value) {
                        continue;
                    }
                    if (Array.isArray(value)) {
                        value = value.join(' ');
                    }
                    if (typeof value === 'string' && value.toLowerCase().includes(keyword)) {
                        result.push(key);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return result;
        },

        // Search for all items which has any attributes contains keyword
        searchInListObject: function searchInListObject(listItems, keyword) {
            var result = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = listItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    item.modelMatches = [];
                    var listKeys = this.findListMatchKeys(item, keyword);
                    item.modelMatches = listKeys;
                    if (listKeys && listKeys.length) {
                        result.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return result;
        },
        searchInListObjectAnyKeywords: function searchInListObjectAnyKeywords(listItems, listKeywords) {
            var result = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = listItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    var isMatch = false;
                    var listMatchingKeys = [];
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = listKeywords[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var keyword = _step4.value;

                            var listKeys = this.findListMatchKeys(item, keyword);
                            if (listKeys && listKeys.length) {
                                listMatchingKeys = listMatchingKeys.concat(listKeys);
                                isMatch = true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    if (isMatch) {
                        item.modelMatches = [].concat(_toConsumableArray(new Set(listMatchingKeys)));
                        result.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return result;
        },
        searchInListObjectAllKeywords: function searchInListObjectAllKeywords(listItems, listKeywords) {
            var result = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = listItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item = _step5.value;

                    var isMatch = true;
                    var listMatchingKeys = [];
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = listKeywords[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var keyword = _step6.value;

                            var listKeys = this.findListMatchKeys(item, keyword);
                            if (listKeys && listKeys.length) {
                                listMatchingKeys = listMatchingKeys.concat(listKeys);
                            } else {
                                isMatch = false;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }

                    if (isMatch) {
                        item.modelMatches = [].concat(_toConsumableArray(new Set(listMatchingKeys)));
                        result.push(item);
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return result;
        },
        trimElementOfList: function trimElementOfList(inputArr) {
            if (!Array.isArray(inputArr)) {
                return inputArr;
            }
            return inputArr.map(function (item) {
                if (typeof item === 'string') {
                    return item.trim();
                } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = Object.keys(item)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var key = _step7.value;

                            if (typeof item[key] === 'string') {
                                item[key] = item[key].trim();
                            }
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }

                    return item;
                } else {
                    return item;
                }
            });
        },
        calculateSumOfProperty: function calculateSumOfProperty(inputArr, prop, transformFunc) {
            var _this = this;

            if (!inputArr) {
                return 0;
            }
            return inputArr.reduce(function (acc, cur) {
                var val = void 0;
                if (prop) {
                    val = _this.getValueOfObjectKey(cur, prop);
                } else if (transformFunc) {
                    val = transformFunc(cur);
                }
                if (!val) {
                    return acc;
                }
                return acc + Number(val);
            }, 0);
        },
        cloneArrayOfObject: function cloneArrayOfObject(inputArr) {
            var result = [];
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = inputArr[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var item = _step8.value;

                    result.push(_extends({}, item));
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            return result;
        },
        groupArrayByKey: function groupArrayByKey(list, key) {
            return list.reduce(function (hash, obj) {
                return _extends({}, hash, _defineProperty({}, obj[key], (hash[obj[key]] || []).concat(obj)));
            }, {});
        },
        filterArrayOfObjectsWithOptions: function filterArrayOfObjectsWithOptions(inputArr, filteredValues, matchingOption, key) {
            var _this2 = this;

            if (!inputArr) {
                return [];
            }
            if (filteredValues && filteredValues.length) {
                if (matchingOption === "All Of") {
                    return inputArr.filter(function (item) {
                        return _this2.containsAllElements(item[key], filteredValues);
                    });
                } else if (matchingOption === "Any Of") {
                    return inputArr.filter(function (item) {
                        return _this2.hasCommonElement(item[key], filteredValues);
                    });
                } else if (matchingOption === "None Of") {
                    return inputArr.filter(function (item) {
                        return !_this2.hasCommonElement(item[key], filteredValues);
                    });
                }
            }
            return inputArr;
        },
        arrayMove: function arrayMove(arr, oldIndex, newIndex) {
            var length = arr.length;
            var itemToMove = arr[oldIndex];

            if (oldIndex === newIndex || oldIndex > length || newIndex > length) {
                return arr;
            }

            return arr.reduce(function (acc, item, index) {
                if (index === oldIndex) return acc;
                if (index === newIndex) return oldIndex < newIndex ? [].concat(_toConsumableArray(acc), [item, itemToMove]) : [].concat(_toConsumableArray(acc), [itemToMove, item]);
                return [].concat(_toConsumableArray(acc), [item]);
            }, []);
        }
    }
});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        // Concat 2 strings by separator
        concatStrings: function concatStrings(str1, str2, separator) {
            var result = '';
            if (str1) {
                result = str1;
            }
            if (str2) {
                if (result) {
                    result = result + separator + str2;
                } else {
                    result = str2;
                }
            }
            return result;
        },
        splitFirstOccurrence: function splitFirstOccurrence(str, separator) {
            if (!str) {
                return [];
            }
            var index = str.indexOf(separator);
            if (index === -1) {
                // Not found
                return [str];
            }
            return [str.substring(0, index), str.substring(index + 1)];
        },
        limitStringLength: function limitStringLength(str, maxLength) {
            if (!str) {
                return '';
            }
            return str.substring(0, maxLength);
        }
    }
});

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        deg2rad: function deg2rad(deg) {
            return deg * (Math.PI / 180);
        },
        getDistanceFromLatLon: function getDistanceFromLatLon(lat1, lon1, lat2, lon2) {
            // https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
            // const R = 6371; // Radius of the earth in km
            var R = this.$store.getters.agencyDistanceUnit === 'km' ? 6371 : 3959; // Radius of the earth in mi
            var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
            var dLon = this.deg2rad(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            // Distance in km
            return R * c;
        },
        distanceBetweenCandidateJob: function distanceBetweenCandidateJob(candidate, job) {
            if (candidate.user_latitude && candidate.user_longitude && job.latitude && job.longitude) {
                var dist = this.getDistanceFromLatLon(Number(candidate.user_latitude), Number(candidate.user_longitude), Number(job.latitude), Number(job.longitude));
                // console.log(dist)
                return this.roundNumberTwoDigits(dist);
            } else {
                // return 'Could not compute'
                return null;
            }
        },
        calcEval: function calcEval(str) {
            try {
                return eval(str);
            } catch (error) {
                var subject = this.formatContent(this.$store.getters.errorCalculatingPrice.subject, this.$store.getters.agencyID);
                var message = this.formatContent(this.$store.getters.errorCalculatingPrice.message, this.$store.getters.agencyID, this.$store.getters.userID, str, String(error));
                this.sendBackgroundEmailToEnginehire(subject, message, ["support@enginehire.ca"]);
                throw error;
            }
        }
    }
});

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

var _customDefineType = __webpack_require__(6);

var _vuex = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_vue2.default.mixin({
    methods: _extends({}, (0, _vuex.mapActions)(['loadProfileBuilderList', 'reloadProfileBuilderList']), {
        getListAllowReturningApplicantStatuses: function getListAllowReturningApplicantStatuses(profile) {
            var _this = this;

            var allowStatuses = this.tryGet(function () {
                return _this.profile.additional_information.allow_returning_applicant_statuses;
            });
            if (allowStatuses && allowStatuses.length) {
                return allowStatuses;
            }
            var applicationAbandonStatus = this.tryGet(function () {
                return profile.additional_information.application_abandon_status;
            }) || "Application Started";
            var result = ["Pre Application", applicationAbandonStatus];
            if (profile.user_type === _customDefineType.BUILDER_USER_TYPE.CANDIDATE) {
                var candidateReapplicationStatuses = this.$store.getters.candidateReapplicationStatuses;
                if (candidateReapplicationStatuses && candidateReapplicationStatuses.length) {
                    result = [].concat(_toConsumableArray(result), _toConsumableArray(candidateReapplicationStatuses));
                }
            } else if (profile.user_type === _customDefineType.BUILDER_USER_TYPE.CLIENT) {
                var clientReapplicationStatuses = this.$store.getters.clientReapplicationStatuses;
                if (clientReapplicationStatuses && clientReapplicationStatuses.length) {
                    result = [].concat(_toConsumableArray(result), _toConsumableArray(clientReapplicationStatuses));
                }
            }
            return this.deduplicateArray(result);
        }
    })
});

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        getCurrentLocation: function getCurrentLocation() {
            var _this = this;

            return new Promise(function (resolve) {
                _this.showLoading();
                navigator.geolocation.getCurrentPosition(function (position) {
                    _this.hideLoading();
                    if (position && position.coords) {
                        resolve({
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        });
                    } else {
                        resolve(null);
                    }
                }, function (error) {
                    _this.hideLoading();
                    console.log(error);
                    resolve(null);
                });
            });
        }
    }
});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        addClientAndCandidateTags: function addClientAndCandidateTags(listFields) {
            // Insert client (poster) fields
            var listClientFields = this.getListFieldsByUserType(this.$store.getters.profileBuilderList, "Client");
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = listClientFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var field = _step.value;

                    if (!field.model) {
                        continue;
                    }
                    listFields.push({
                        label: field.label + " (Client - Job Poster)",
                        model: "client_" + field.model
                    });
                }
                // Insert candidate fields
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var listCandidateFields = this.getListFieldsByUserType(this.$store.getters.profileBuilderList, "Candidate");
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = listCandidateFields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _field = _step2.value;

                    if (!_field.model) {
                        continue;
                    }
                    listFields.push({
                        label: _field.label + " (Candidate)",
                        model: "candidate_" + _field.model
                    });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }
});

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        getMobileOperatingSystem: function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        }
    }
});

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        // Sort reference, experience, ... sections
        handleSortDependentSections: function handleSortDependentSections(listData, builder, listFields) {
            if (!listFields) {
                listFields = [];
                if (builder && builder.list_fields) {
                    listFields = builder.list_fields;
                }
            }
            var additionalInfo = builder ? builder.additionalInformation || builder.additional_information : null;
            // Sort model is specified
            if (additionalInfo && additionalInfo.sort_model) {
                var sortModel = additionalInfo.sort_model;
                var isDescending = additionalInfo.is_descending;
                var nullAtTop = additionalInfo.null_at_top;
                listData.sort(function (item1, item2) {
                    var val1 = item1[sortModel];
                    var val2 = item2[sortModel];
                    // equal items sort equally
                    if (val1 === val2) {
                        // If section is sorted by end_date, and end_date is equal, sort by start date
                        if (sortModel === "end_date" && nullAtTop) {
                            return item1.start_date > item2.start_date ? -1 : 1;
                        }
                        return 0;
                    }
                    // nulls sort after anything else
                    else if (val1 == null) {
                            return nullAtTop ? -1 : 1;
                        } else if (val2 == null) {
                            return nullAtTop ? 1 : -1;
                        }

                    // Convert string to lower case
                    var normalizedVal1 = val1;
                    if (typeof normalizedVal1 === "string") {
                        normalizedVal1 = normalizedVal1.toLowerCase();
                    }
                    var normalizedVal2 = val2;
                    if (typeof normalizedVal2 === "string") {
                        normalizedVal2 = normalizedVal2.toLowerCase();
                    }

                    // otherwise, if we're ascending, lowest sorts first
                    if (isDescending) {
                        return normalizedVal1 < normalizedVal2 ? 1 : -1;
                    }
                    // if descending, highest sorts first
                    else {
                            return normalizedVal1 < normalizedVal2 ? -1 : 1;
                        }
                });
                return;
            }

            // Sort model is not specified => Default sort
            // Check if start_date is defined
            if (listFields && listFields.some(function (field) {
                return field.model === "start_date";
            })) {
                var hasEndDateField = listFields.some(function (field) {
                    return field.model === "end_date";
                });

                listData.sort(function (a, b) {
                    // Put item without end date to top
                    if (hasEndDateField) {
                        if (!a.end_date && b.end_date) {
                            return -1;
                        }
                        if (a.end_date && !b.end_date) {
                            return 1;
                        }
                    }
                    return a.start_date > b.start_date ? -1 : 1;
                });
            } else {
                listData.sort(function (a, b) {
                    return a.id > b.id ? 1 : -1;
                });
            }
        }
    }
});

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.directive('click-outside', {
    bind: function bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(9);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.directive('scroll', {
  inserted: function inserted(el, binding) {
    var onScrollCallback = binding.value;
    window.addEventListener('scroll', function () {
      return onScrollCallback();
    });
  }
});

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Hotjar tracking code for https://directory.enginehire.io/agency/directory

(function (h, o, t, j, a, r) {
  h.hj = h.hj || function () {
    (h.hj.q = h.hj.q || []).push(arguments);
  };h._hjSettings = { hjid: 3348089, hjsv: 6 };a = o.getElementsByTagName('head')[0];r = o.createElement('script');r.async = 1;r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;a.appendChild(r);
})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=6)}([function(t,e,n){"use strict";function r(){d=!1}function i(t){if(!t)return void(f!==m&&(f=m,r()));if(t!==f){if(t.length!==m.length)throw new Error("Custom alphabet for shortid must be "+m.length+" unique characters. You submitted "+t.length+" characters: "+t);var e=t.split("").filter(function(t,e,n){return e!==n.lastIndexOf(t)});if(e.length)throw new Error("Custom alphabet for shortid must be "+m.length+" unique characters. These characters were not unique: "+e.join(", "));f=t,r()}}function o(t){return i(t),f}function a(t){h.seed(t),p!==t&&(r(),p=t)}function s(){f||i(m);for(var t,e=f.split(""),n=[],r=h.nextValue();e.length>0;)r=h.nextValue(),t=Math.floor(r*e.length),n.push(e.splice(t,1)[0]);return n.join("")}function c(){return d||(d=s())}function u(t){return c()[t]}function l(){return f||m}var f,p,d,h=n(19),m="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";t.exports={get:l,characters:o,seed:a,lookup:u,shuffled:c}},function(t,e,n){"use strict";var r=n(5),i=n.n(r);e.a={animateIn:function(t){i()({targets:t,translateY:"-35px",opacity:1,duration:300,easing:"easeOutCubic"})},animateOut:function(t,e){i()({targets:t,opacity:0,marginTop:"-40px",duration:300,easing:"easeOutExpo",complete:e})},animateOutBottom:function(t,e){i()({targets:t,opacity:0,marginBottom:"-40px",duration:300,easing:"easeOutExpo",complete:e})},animateReset:function(t){i()({targets:t,left:0,opacity:1,duration:300,easing:"easeOutExpo"})},animatePanning:function(t,e,n){i()({targets:t,duration:10,easing:"easeOutQuad",left:e,opacity:n})},animatePanEnd:function(t,e){i()({targets:t,opacity:0,duration:300,easing:"easeOutExpo",complete:e})},clearAnimation:function(t){var e=i.a.timeline();t.forEach(function(t){e.add({targets:t.el,opacity:0,right:"-40px",duration:300,offset:"-=150",easing:"easeOutExpo",complete:function(){t.remove()}})})}}},function(t,e,n){"use strict";t.exports=n(16)},function(t,e,n){"use strict";n.d(e,"a",function(){return s});var r=n(8),i=n(1),o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=n(2);n(11).polyfill();var s=function t(e){var n=this;return this.id=a.generate(),this.options=e,this.cached_options={},this.global={},this.groups=[],this.toasts=[],this.container=null,l(this),u(this),this.group=function(e){e||(e={}),e.globalToasts||(e.globalToasts={}),Object.assign(e.globalToasts,n.global);var r=new t(e);return n.groups.push(r),r},this.register=function(t,e,r){return r=r||{},f(n,t,e,r)},this.show=function(t,e){return c(n,t,e)},this.success=function(t,e){return e=e||{},e.type="success",c(n,t,e)},this.info=function(t,e){return e=e||{},e.type="info",c(n,t,e)},this.error=function(t,e){return e=e||{},e.type="error",c(n,t,e)},this.remove=function(t){n.toasts=n.toasts.filter(function(e){return e.el.hash!==t.hash}),t.parentNode&&t.parentNode.removeChild(t)},this.clear=function(t){return i.a.clearAnimation(n.toasts,function(){t&&t()}),n.toasts=[],!0},this},c=function(t,e,i){i=i||{};var a=null;if("object"!==(void 0===i?"undefined":o(i)))return console.error("Options should be a type of object. given : "+i),null;t.options.singleton&&t.toasts.length>0&&(t.cached_options=i,t.toasts[t.toasts.length-1].goAway(0));var s=Object.assign({},t.options);return Object.assign(s,i),a=n.i(r.a)(t,e,s),t.toasts.push(a),a},u=function(t){var e=t.options.globalToasts,n=function(e,n){return"string"==typeof n&&t[n]?t[n].apply(t,[e,{}]):c(t,e,n)};e&&(t.global={},Object.keys(e).forEach(function(r){t.global[r]=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e[r].apply(null,[t,n])}}))},l=function(t){var e=document.createElement("div");e.id=t.id,e.setAttribute("role","status"),e.setAttribute("aria-live","polite"),e.setAttribute("aria-atomic","false"),document.body.appendChild(e),t.container=e},f=function(t,e,n,r){t.options.globalToasts||(t.options.globalToasts={}),t.options.globalToasts[e]=function(t,e){var i=null;return"string"==typeof n&&(i=n),"function"==typeof n&&(i=n(t)),e(i,r)},u(t)}},function(t,e,n){n(22);var r=n(21)(null,null,null,null);t.exports=r.exports},function(t,e,n){(function(n){var r,i,o,a={scope:{}};a.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(t,e,n){if(n.get||n.set)throw new TypeError("ES3 does not support getters and setters.");t!=Array.prototype&&t!=Object.prototype&&(t[e]=n.value)},a.getGlobal=function(t){return"undefined"!=typeof window&&window===t?t:void 0!==n&&null!=n?n:t},a.global=a.getGlobal(this),a.SYMBOL_PREFIX="jscomp_symbol_",a.initSymbol=function(){a.initSymbol=function(){},a.global.Symbol||(a.global.Symbol=a.Symbol)},a.symbolCounter_=0,a.Symbol=function(t){return a.SYMBOL_PREFIX+(t||"")+a.symbolCounter_++},a.initSymbolIterator=function(){a.initSymbol();var t=a.global.Symbol.iterator;t||(t=a.global.Symbol.iterator=a.global.Symbol("iterator")),"function"!=typeof Array.prototype[t]&&a.defineProperty(Array.prototype,t,{configurable:!0,writable:!0,value:function(){return a.arrayIterator(this)}}),a.initSymbolIterator=function(){}},a.arrayIterator=function(t){var e=0;return a.iteratorPrototype(function(){return e<t.length?{done:!1,value:t[e++]}:{done:!0}})},a.iteratorPrototype=function(t){return a.initSymbolIterator(),t={next:t},t[a.global.Symbol.iterator]=function(){return this},t},a.array=a.array||{},a.iteratorFromArray=function(t,e){a.initSymbolIterator(),t instanceof String&&(t+="");var n=0,r={next:function(){if(n<t.length){var i=n++;return{value:e(i,t[i]),done:!1}}return r.next=function(){return{done:!0,value:void 0}},r.next()}};return r[Symbol.iterator]=function(){return r},r},a.polyfill=function(t,e,n,r){if(e){for(n=a.global,t=t.split("."),r=0;r<t.length-1;r++){var i=t[r];i in n||(n[i]={}),n=n[i]}t=t[t.length-1],r=n[t],e=e(r),e!=r&&null!=e&&a.defineProperty(n,t,{configurable:!0,writable:!0,value:e})}},a.polyfill("Array.prototype.keys",function(t){return t||function(){return a.iteratorFromArray(this,function(t){return t})}},"es6-impl","es3");var s=this;!function(n,a){i=[],r=a,void 0!==(o="function"==typeof r?r.apply(e,i):r)&&(t.exports=o)}(0,function(){function t(t){if(!R.col(t))try{return document.querySelectorAll(t)}catch(t){}}function e(t,e){for(var n=t.length,r=2<=arguments.length?arguments[1]:void 0,i=[],o=0;o<n;o++)if(o in t){var a=t[o];e.call(r,a,o,t)&&i.push(a)}return i}function n(t){return t.reduce(function(t,e){return t.concat(R.arr(e)?n(e):e)},[])}function r(e){return R.arr(e)?e:(R.str(e)&&(e=t(e)||e),e instanceof NodeList||e instanceof HTMLCollection?[].slice.call(e):[e])}function i(t,e){return t.some(function(t){return t===e})}function o(t){var e,n={};for(e in t)n[e]=t[e];return n}function a(t,e){var n,r=o(t);for(n in t)r[n]=e.hasOwnProperty(n)?e[n]:t[n];return r}function c(t,e){var n,r=o(t);for(n in e)r[n]=R.und(t[n])?e[n]:t[n];return r}function u(t){t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(t,e,n,r){return e+e+n+n+r+r});var e=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);t=parseInt(e[1],16);var n=parseInt(e[2],16),e=parseInt(e[3],16);return"rgba("+t+","+n+","+e+",1)"}function l(t){function e(t,e,n){return 0>n&&(n+=1),1<n&&--n,n<1/6?t+6*(e-t)*n:.5>n?e:n<2/3?t+(e-t)*(2/3-n)*6:t}var n=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);t=parseInt(n[1])/360;var r=parseInt(n[2])/100,i=parseInt(n[3])/100,n=n[4]||1;if(0==r)i=r=t=i;else{var o=.5>i?i*(1+r):i+r-i*r,a=2*i-o,i=e(a,o,t+1/3),r=e(a,o,t);t=e(a,o,t-1/3)}return"rgba("+255*i+","+255*r+","+255*t+","+n+")"}function f(t){if(t=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t))return t[2]}function p(t){return-1<t.indexOf("translate")||"perspective"===t?"px":-1<t.indexOf("rotate")||-1<t.indexOf("skew")?"deg":void 0}function d(t,e){return R.fnc(t)?t(e.target,e.id,e.total):t}function h(t,e){if(e in t.style)return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function m(t,e){return R.dom(t)&&i(D,e)?"transform":R.dom(t)&&(t.getAttribute(e)||R.svg(t)&&t[e])?"attribute":R.dom(t)&&"transform"!==e&&h(t,e)?"css":null!=t[e]?"object":void 0}function v(t,n){var r=p(n),r=-1<n.indexOf("scale")?1:0+r;if(!(t=t.style.transform))return r;for(var i=[],o=[],a=[],s=/(\w+)\((.+?)\)/g;i=s.exec(t);)o.push(i[1]),a.push(i[2]);return t=e(a,function(t,e){return o[e]===n}),t.length?t[0]:r}function g(t,e){switch(m(t,e)){case"transform":return v(t,e);case"css":return h(t,e);case"attribute":return t.getAttribute(e)}return t[e]||0}function y(t,e){var n=/^(\*=|\+=|-=)/.exec(t);if(!n)return t;var r=f(t)||0;switch(e=parseFloat(e),t=parseFloat(t.replace(n[0],"")),n[0][0]){case"+":return e+t+r;case"-":return e-t+r;case"*":return e*t+r}}function b(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))}function x(t){t=t.points;for(var e,n=0,r=0;r<t.numberOfItems;r++){var i=t.getItem(r);0<r&&(n+=b(e,i)),e=i}return n}function T(t){if(t.getTotalLength)return t.getTotalLength();switch(t.tagName.toLowerCase()){case"circle":return 2*Math.PI*t.getAttribute("r");case"rect":return 2*t.getAttribute("width")+2*t.getAttribute("height");case"line":return b({x:t.getAttribute("x1"),y:t.getAttribute("y1")},{x:t.getAttribute("x2"),y:t.getAttribute("y2")});case"polyline":return x(t);case"polygon":var e=t.points;return x(t)+b(e.getItem(e.numberOfItems-1),e.getItem(0))}}function w(t,e){function n(n){return n=void 0===n?0:n,t.el.getPointAtLength(1<=e+n?e+n:0)}var r=n(),i=n(-1),o=n(1);switch(t.property){case"x":return r.x;case"y":return r.y;case"angle":return 180*Math.atan2(o.y-i.y,o.x-i.x)/Math.PI}}function E(t,e){var n,r=/-?\d*\.?\d+/g;if(n=R.pth(t)?t.totalLength:t,R.col(n))if(R.rgb(n)){var i=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n);n=i?"rgba("+i[1]+",1)":n}else n=R.hex(n)?u(n):R.hsl(n)?l(n):void 0;else i=(i=f(n))?n.substr(0,n.length-i.length):n,n=e&&!/\s/g.test(n)?i+e:i;return n+="",{original:n,numbers:n.match(r)?n.match(r).map(Number):[0],strings:R.str(t)||e?n.split(r):[]}}function C(t){return t=t?n(R.arr(t)?t.map(r):r(t)):[],e(t,function(t,e,n){return n.indexOf(t)===e})}function S(t){var e=C(t);return e.map(function(t,n){return{target:t,id:n,total:e.length}})}function O(t,e){var n=o(e);if(R.arr(t)){var i=t.length;2!==i||R.obj(t[0])?R.fnc(e.duration)||(n.duration=e.duration/i):t={value:t}}return r(t).map(function(t,n){return n=n?0:e.delay,t=R.obj(t)&&!R.pth(t)?t:{value:t},R.und(t.delay)&&(t.delay=n),t}).map(function(t){return c(t,n)})}function A(t,e){var n,r={};for(n in t){var i=d(t[n],e);R.arr(i)&&(i=i.map(function(t){return d(t,e)}),1===i.length&&(i=i[0])),r[n]=i}return r.duration=parseFloat(r.duration),r.delay=parseFloat(r.delay),r}function I(t){return R.arr(t)?F.apply(this,t):z[t]}function M(t,e){var n;return t.tweens.map(function(r){r=A(r,e);var i=r.value,o=g(e.target,t.name),a=n?n.to.original:o,a=R.arr(i)?i[0]:a,s=y(R.arr(i)?i[1]:i,a),o=f(s)||f(a)||f(o);return r.from=E(a,o),r.to=E(s,o),r.start=n?n.end:t.offset,r.end=r.start+r.delay+r.duration,r.easing=I(r.easing),r.elasticity=(1e3-Math.min(Math.max(r.elasticity,1),999))/1e3,r.isPath=R.pth(i),r.isColor=R.col(r.from.original),r.isColor&&(r.round=1),n=r})}function k(t,r){return e(n(t.map(function(t){return r.map(function(e){var n=m(t.target,e.name);if(n){var r=M(e,t);e={type:n,property:e.name,animatable:t,tweens:r,duration:r[r.length-1].end,delay:r[0].delay}}else e=void 0;return e})})),function(t){return!R.und(t)})}function P(t,e,n,r){var i="delay"===t;return e.length?(i?Math.min:Math.max).apply(Math,e.map(function(e){return e[t]})):i?r.delay:n.offset+r.delay+r.duration}function L(t){var e,n=a(_,t),r=a(X,t),i=S(t.targets),o=[],s=c(n,r);for(e in t)s.hasOwnProperty(e)||"targets"===e||o.push({name:e,offset:s.offset,tweens:O(t[e],r)});return t=k(i,o),c(n,{children:[],animatables:i,animations:t,duration:P("duration",t,n,r),delay:P("delay",t,n,r)})}function j(t){function n(){return window.Promise&&new Promise(function(t){return f=t})}function r(t){return d.reversed?d.duration-t:t}function i(t){for(var n=0,r={},i=d.animations,o=i.length;n<o;){var a=i[n],s=a.animatable,c=a.tweens,u=c.length-1,l=c[u];u&&(l=e(c,function(e){return t<e.end})[0]||l);for(var c=Math.min(Math.max(t-l.start-l.delay,0),l.duration)/l.duration,f=isNaN(c)?1:l.easing(c,l.elasticity),c=l.to.strings,p=l.round,u=[],m=void 0,m=l.to.numbers.length,v=0;v<m;v++){var g=void 0,g=l.to.numbers[v],y=l.from.numbers[v],g=l.isPath?w(l.value,f*g):y+f*(g-y);p&&(l.isColor&&2<v||(g=Math.round(g*p)/p)),u.push(g)}if(l=c.length)for(m=c[0],f=0;f<l;f++)p=c[f+1],v=u[f],isNaN(v)||(m=p?m+(v+p):m+(v+" "));else m=u[0];Y[a.type](s.target,a.property,m,r,s.id),a.currentValue=m,n++}if(n=Object.keys(r).length)for(i=0;i<n;i++)N||(N=h(document.body,"transform")?"transform":"-webkit-transform"),d.animatables[i].target.style[N]=r[i].join(" ");d.currentTime=t,d.progress=t/d.duration*100}function o(t){d[t]&&d[t](d)}function a(){d.remaining&&!0!==d.remaining&&d.remaining--}function s(t){var e=d.duration,s=d.offset,h=s+d.delay,m=d.currentTime,v=d.reversed,g=r(t);if(d.children.length){var y=d.children,b=y.length;if(g>=d.currentTime)for(var x=0;x<b;x++)y[x].seek(g);else for(;b--;)y[b].seek(g)}(g>=h||!e)&&(d.began||(d.began=!0,o("begin")),o("run")),g>s&&g<e?i(g):(g<=s&&0!==m&&(i(0),v&&a()),(g>=e&&m!==e||!e)&&(i(e),v||a())),o("update"),t>=e&&(d.remaining?(u=c,"alternate"===d.direction&&(d.reversed=!d.reversed)):(d.pause(),d.completed||(d.completed=!0,o("complete"),"Promise"in window&&(f(),p=n()))),l=0)}t=void 0===t?{}:t;var c,u,l=0,f=null,p=n(),d=L(t);return d.reset=function(){var t=d.direction,e=d.loop;for(d.currentTime=0,d.progress=0,d.paused=!0,d.began=!1,d.completed=!1,d.reversed="reverse"===t,d.remaining="alternate"===t&&1===e?2:e,i(0),t=d.children.length;t--;)d.children[t].reset()},d.tick=function(t){c=t,u||(u=c),s((l+c-u)*j.speed)},d.seek=function(t){s(r(t))},d.pause=function(){var t=H.indexOf(d);-1<t&&H.splice(t,1),d.paused=!0},d.play=function(){d.paused&&(d.paused=!1,u=0,l=r(d.currentTime),H.push(d),q||V())},d.reverse=function(){d.reversed=!d.reversed,u=0,l=r(d.currentTime)},d.restart=function(){d.pause(),d.reset(),d.play()},d.finished=p,d.reset(),d.autoplay&&d.play(),d}var N,_={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},X={duration:1e3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},D="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),R={arr:function(t){return Array.isArray(t)},obj:function(t){return-1<Object.prototype.toString.call(t).indexOf("Object")},pth:function(t){return R.obj(t)&&t.hasOwnProperty("totalLength")},svg:function(t){return t instanceof SVGElement},dom:function(t){return t.nodeType||R.svg(t)},str:function(t){return"string"==typeof t},fnc:function(t){return"function"==typeof t},und:function(t){return void 0===t},hex:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)},rgb:function(t){return/^rgb/.test(t)},hsl:function(t){return/^hsl/.test(t)},col:function(t){return R.hex(t)||R.rgb(t)||R.hsl(t)}},F=function(){function t(t,e,n){return(((1-3*n+3*e)*t+(3*n-6*e))*t+3*e)*t}return function(e,n,r,i){if(0<=e&&1>=e&&0<=r&&1>=r){var o=new Float32Array(11);if(e!==n||r!==i)for(var a=0;11>a;++a)o[a]=t(.1*a,e,r);return function(a){if(e===n&&r===i)return a;if(0===a)return 0;if(1===a)return 1;for(var s=0,c=1;10!==c&&o[c]<=a;++c)s+=.1;--c;var c=s+(a-o[c])/(o[c+1]-o[c])*.1,u=3*(1-3*r+3*e)*c*c+2*(3*r-6*e)*c+3*e;if(.001<=u){for(s=0;4>s&&0!==(u=3*(1-3*r+3*e)*c*c+2*(3*r-6*e)*c+3*e);++s)var l=t(c,e,r)-a,c=c-l/u;a=c}else if(0===u)a=c;else{var c=s,s=s+.1,f=0;do{l=c+(s-c)/2,u=t(l,e,r)-a,0<u?s=l:c=l}while(1e-7<Math.abs(u)&&10>++f);a=l}return t(a,n,i)}}}}(),z=function(){function t(t,e){return 0===t||1===t?t:-Math.pow(2,10*(t-1))*Math.sin(2*(t-1-e/(2*Math.PI)*Math.asin(1))*Math.PI/e)}var e,n="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),r={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],t],Out:[[.25,.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(e,n){return 1-t(1-e,n)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(e,n){return.5>e?t(2*e,n)/2:1-t(-2*e+2,n)/2}]},i={linear:F(.25,.25,.75,.75)},o={};for(e in r)o.type=e,r[o.type].forEach(function(t){return function(e,r){i["ease"+t.type+n[r]]=R.fnc(e)?e:F.apply(s,e)}}(o)),o={type:o.type};return i}(),Y={css:function(t,e,n){return t.style[e]=n},attribute:function(t,e,n){return t.setAttribute(e,n)},object:function(t,e,n){return t[e]=n},transform:function(t,e,n,r,i){r[i]||(r[i]=[]),r[i].push(e+"("+n+")")}},H=[],q=0,V=function(){function t(){q=requestAnimationFrame(e)}function e(e){var n=H.length;if(n){for(var r=0;r<n;)H[r]&&H[r].tick(e),r++;t()}else cancelAnimationFrame(q),q=0}return t}();return j.version="2.2.0",j.speed=1,j.running=H,j.remove=function(t){t=C(t);for(var e=H.length;e--;)for(var n=H[e],r=n.animations,o=r.length;o--;)i(t,r[o].animatable.target)&&(r.splice(o,1),r.length||n.pause())},j.getValue=g,j.path=function(e,n){var r=R.str(e)?t(e)[0]:e,i=n||100;return function(t){return{el:r,property:t,totalLength:T(r)*(i/100)}}},j.setDashoffset=function(t){var e=T(t);return t.setAttribute("stroke-dasharray",e),e},j.bezier=F,j.easings=z,j.timeline=function(t){var e=j(t);return e.pause(),e.duration=0,e.add=function(n){return e.children.forEach(function(t){t.began=!0,t.completed=!0}),r(n).forEach(function(n){var r=c(n,a(X,t||{}));r.targets=r.targets||t.targets,n=e.duration;var i=r.offset;r.autoplay=!1,r.direction=e.direction,r.offset=R.und(i)?n:y(i,n),e.began=!0,e.completed=!0,e.seek(r.offset),r=j(r),r.began=!0,r.completed=!0,r.duration>n&&(e.duration=r.duration),e.children.push(r)}),e.seek(0),e.reset(),e.autoplay&&e.restart(),e},e},j.random=function(t,e){return Math.floor(Math.random()*(e-t+1))+t},j})}).call(e,n(25))},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(3),i=n(4),o=n.n(i),a={install:function(t,e){e||(e={});var n=new r.a(e);t.component("toasted",o.a),t.toasted=t.prototype.$toasted=n}};"undefined"!=typeof window&&window.Vue&&(window.Toasted=a),e.default=a},function(t,e,n){"use strict";n.d(e,"a",function(){return c});var r=n(1),i=this,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(t,e,n){return setTimeout(function(){if(n.cached_options.position&&n.cached_options.position.includes("bottom"))return void r.a.animateOutBottom(t,function(){n.remove(t)});r.a.animateOut(t,function(){n.remove(t)})},e),!0},s=function(t,e){return("object"===("undefined"==typeof HTMLElement?"undefined":o(HTMLElement))?e instanceof HTMLElement:e&&"object"===(void 0===e?"undefined":o(e))&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName)?t.appendChild(e):t.innerHTML=e,i},c=function(t,e){var n=!1;return{el:t,text:function(e){return s(t,e),this},goAway:function(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:800;return n=!0,a(t,r,e)},remove:function(){e.remove(t)},disposed:function(){return n}}}},function(t,e,n){"use strict";var r=n(12),i=n.n(r),o=n(1),a=n(7),s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},c=n(2);String.prototype.includes||Object.defineProperty(String.prototype,"includes",{value:function(t,e){return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}});var u={},l=null,f=function(t){return t.className=t.className||null,t.onComplete=t.onComplete||null,t.position=t.position||"top-right",t.duration=t.duration||null,t.keepOnHover=t.keepOnHover||!1,t.theme=t.theme||"toasted-primary",t.type=t.type||"default",t.containerClass=t.containerClass||null,t.fullWidth=t.fullWidth||!1,t.icon=t.icon||null,t.action=t.action||null,t.fitToScreen=t.fitToScreen||null,t.closeOnSwipe=void 0===t.closeOnSwipe||t.closeOnSwipe,t.iconPack=t.iconPack||"material",t.className&&"string"==typeof t.className&&(t.className=t.className.split(" ")),t.className||(t.className=[]),t.theme&&t.className.push(t.theme.trim()),t.type&&t.className.push(t.type),t.containerClass&&"string"==typeof t.containerClass&&(t.containerClass=t.containerClass.split(" ")),t.containerClass||(t.containerClass=[]),t.position&&t.containerClass.push(t.position.trim()),t.fullWidth&&t.containerClass.push("full-width"),t.fitToScreen&&t.containerClass.push("fit-to-screen"),u=t,t},p=function(t,e){var r=document.createElement("div");if(r.classList.add("toasted"),r.hash=c.generate(),e.className&&e.className.forEach(function(t){r.classList.add(t)}),("object"===("undefined"==typeof HTMLElement?"undefined":s(HTMLElement))?t instanceof HTMLElement:t&&"object"===(void 0===t?"undefined":s(t))&&null!==t&&1===t.nodeType&&"string"==typeof t.nodeName)?r.appendChild(t):r.innerHTML=t,d(e,r),e.closeOnSwipe){var u=new i.a(r,{prevent_default:!1});u.on("pan",function(t){var e=t.deltaX;r.classList.contains("panning")||r.classList.add("panning");var n=1-Math.abs(e/80);n<0&&(n=0),o.a.animatePanning(r,e,n)}),u.on("panend",function(t){var n=t.deltaX;Math.abs(n)>80?o.a.animatePanEnd(r,function(){"function"==typeof e.onComplete&&e.onComplete(),r.parentNode&&l.remove(r)}):(r.classList.remove("panning"),o.a.animateReset(r))})}if(Array.isArray(e.action))e.action.forEach(function(t){var e=m(t,n.i(a.a)(r,l));e&&r.appendChild(e)});else if("object"===s(e.action)){var f=m(e.action,n.i(a.a)(r,l));f&&r.appendChild(f)}return r},d=function(t,e){if(t.icon){var n=document.createElement("i");switch(n.setAttribute("aria-hidden","true"),t.iconPack){case"fontawesome":n.classList.add("fa");var r=t.icon.name?t.icon.name:t.icon;r.includes("fa-")?n.classList.add(r.trim()):n.classList.add("fa-"+r.trim());break;case"mdi":n.classList.add("mdi");var i=t.icon.name?t.icon.name:t.icon;i.includes("mdi-")?n.classList.add(i.trim()):n.classList.add("mdi-"+i.trim());break;case"custom-class":var o=t.icon.name?t.icon.name:t.icon;"string"==typeof o?o.split(" ").forEach(function(t){n.classList.add(t)}):Array.isArray(o)&&o.forEach(function(t){n.classList.add(t.trim())});break;case"callback":var a=t.icon&&t.icon instanceof Function?t.icon:null;a&&(n=a(n));break;default:n.classList.add("material-icons"),n.textContent=t.icon.name?t.icon.name:t.icon}t.icon.after&&n.classList.add("after"),h(t,n,e)}},h=function(t,e,n){t.icon&&(t.icon.after&&t.icon.name?n.appendChild(e):(t.icon.name,n.insertBefore(e,n.firstChild)))},m=function(t,e){if(!t)return null;var n=document.createElement("a");if(n.classList.add("action"),n.classList.add("ripple"),t.text&&(n.text=t.text),t.href&&(n.href=t.href),t.target&&(n.target=t.target),t.icon){n.classList.add("icon");var r=document.createElement("i");switch(u.iconPack){case"fontawesome":r.classList.add("fa"),t.icon.includes("fa-")?r.classList.add(t.icon.trim()):r.classList.add("fa-"+t.icon.trim());break;case"mdi":r.classList.add("mdi"),t.icon.includes("mdi-")?r.classList.add(t.icon.trim()):r.classList.add("mdi-"+t.icon.trim());break;case"custom-class":"string"==typeof t.icon?t.icon.split(" ").forEach(function(t){n.classList.add(t)}):Array.isArray(t.icon)&&t.icon.forEach(function(t){n.classList.add(t.trim())});break;default:r.classList.add("material-icons"),r.textContent=t.icon}n.appendChild(r)}return t.class&&("string"==typeof t.class?t.class.split(" ").forEach(function(t){n.classList.add(t)}):Array.isArray(t.class)&&t.class.forEach(function(t){n.classList.add(t.trim())})),t.push&&n.addEventListener("click",function(n){if(n.preventDefault(),!u.router)return void console.warn("[vue-toasted] : Vue Router instance is not attached. please check the docs");u.router.push(t.push),t.push.dontClose||e.goAway(0)}),t.onClick&&"function"==typeof t.onClick&&n.addEventListener("click",function(n){t.onClick&&(n.preventDefault(),t.onClick(n,e))}),n};e.a=function(t,e,r){l=t,r=f(r);var i=l.container;r.containerClass.unshift("toasted-container"),i.className!==r.containerClass.join(" ")&&(i.className="",r.containerClass.forEach(function(t){i.classList.add(t)}));var s=p(e,r);e&&i.appendChild(s),s.style.opacity=0,o.a.animateIn(s);var c=r.duration,u=void 0;if(null!==c){var d=function(){return setInterval(function(){null===s.parentNode&&window.clearInterval(u),s.classList.contains("panning")||(c-=20),c<=0&&(o.a.animateOut(s,function(){"function"==typeof r.onComplete&&r.onComplete(),s.parentNode&&l.remove(s)}),window.clearInterval(u))},20)};u=d(),r.keepOnHover&&(s.addEventListener("mouseover",function(){window.clearInterval(u)}),s.addEventListener("mouseout",function(){u=d()}))}return n.i(a.a)(s,l)}},function(t,e,n){e=t.exports=n(10)(),e.push([t.i,".toasted{padding:0 20px}.toasted.rounded{border-radius:24px}.toasted .primary,.toasted.toasted-primary{border-radius:2px;min-height:38px;line-height:1.1em;background-color:#353535;padding:6px 20px;font-size:15px;font-weight:300;color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.toasted .primary.success,.toasted.toasted-primary.success{background:#4caf50}.toasted .primary.error,.toasted.toasted-primary.error{background:#f44336}.toasted .primary.info,.toasted.toasted-primary.info{background:#3f51b5}.toasted .primary .action,.toasted.toasted-primary .action{color:#a1c2fa}.toasted.bubble{border-radius:30px;min-height:38px;line-height:1.1em;background-color:#ff7043;padding:0 20px;font-size:15px;font-weight:300;color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.toasted.bubble.success{background:#4caf50}.toasted.bubble.error{background:#f44336}.toasted.bubble.info{background:#3f51b5}.toasted.bubble .action{color:#8e2b0c}.toasted.outline{border-radius:30px;min-height:38px;line-height:1.1em;background-color:#fff;border:1px solid #676767;padding:0 20px;font-size:15px;color:#676767;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);font-weight:700}.toasted.outline.success{color:#4caf50;border-color:#4caf50}.toasted.outline.error{color:#f44336;border-color:#f44336}.toasted.outline.info{color:#3f51b5;border-color:#3f51b5}.toasted.outline .action{color:#607d8b}.toasted-container{position:fixed;z-index:10000}.toasted-container,.toasted-container.full-width{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.toasted-container.full-width{max-width:86%;width:100%}.toasted-container.full-width.fit-to-screen{min-width:100%}.toasted-container.full-width.fit-to-screen .toasted:first-child{margin-top:0}.toasted-container.full-width.fit-to-screen.top-right{top:0;right:0}.toasted-container.full-width.fit-to-screen.top-left{top:0;left:0}.toasted-container.full-width.fit-to-screen.top-center{top:0;left:0;-webkit-transform:translateX(0);transform:translateX(0)}.toasted-container.full-width.fit-to-screen.bottom-right{right:0;bottom:0}.toasted-container.full-width.fit-to-screen.bottom-left{left:0;bottom:0}.toasted-container.full-width.fit-to-screen.bottom-center{left:0;bottom:0;-webkit-transform:translateX(0);transform:translateX(0)}.toasted-container.top-right{top:10%;right:7%}.toasted-container.top-left{top:10%;left:7%}.toasted-container.top-center{top:10%;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.toasted-container.bottom-right{right:5%;bottom:7%}.toasted-container.bottom-left{left:5%;bottom:7%}.toasted-container.bottom-center{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:7%}.toasted-container.bottom-left .toasted,.toasted-container.top-left .toasted{float:left}.toasted-container.bottom-right .toasted,.toasted-container.top-right .toasted{float:right}.toasted-container .toasted{top:35px;width:auto;clear:both;margin-top:10px;position:relative;max-width:100%;height:auto;word-break:normal;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;box-sizing:inherit}.toasted-container .toasted .fa,.toasted-container .toasted .fab,.toasted-container .toasted .far,.toasted-container .toasted .fas,.toasted-container .toasted .material-icons,.toasted-container .toasted .mdi{margin-right:.5rem;margin-left:-.4rem}.toasted-container .toasted .fa.after,.toasted-container .toasted .fab.after,.toasted-container .toasted .far.after,.toasted-container .toasted .fas.after,.toasted-container .toasted .material-icons.after,.toasted-container .toasted .mdi.after{margin-left:.5rem;margin-right:-.4rem}.toasted-container .toasted .action{text-decoration:none;font-size:.8rem;padding:8px;margin:5px -7px 5px 7px;border-radius:3px;text-transform:uppercase;letter-spacing:.03em;font-weight:600;cursor:pointer}.toasted-container .toasted .action.icon{padding:4px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.toasted-container .toasted .action.icon .fa,.toasted-container .toasted .action.icon .material-icons,.toasted-container .toasted .action.icon .mdi{margin-right:0;margin-left:4px}.toasted-container .toasted .action.icon:hover{text-decoration:none}.toasted-container .toasted .action:hover{text-decoration:underline}@media only screen and (max-width:600px){.toasted-container{min-width:100%}.toasted-container .toasted:first-child{margin-top:0}.toasted-container.top-right{top:0;right:0}.toasted-container.top-left{top:0;left:0}.toasted-container.top-center{top:0;left:0;-webkit-transform:translateX(0);transform:translateX(0)}.toasted-container.bottom-right{right:0;bottom:0}.toasted-container.bottom-left{left:0;bottom:0}.toasted-container.bottom-center{left:0;bottom:0;-webkit-transform:translateX(0);transform:translateX(0)}.toasted-container.bottom-center,.toasted-container.top-center{-ms-flex-align:stretch!important;align-items:stretch!important}.toasted-container.bottom-left .toasted,.toasted-container.bottom-right .toasted,.toasted-container.top-left .toasted,.toasted-container.top-right .toasted{float:none}.toasted-container .toasted{border-radius:0}}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(r[o]=!0)}for(i=0;i<e.length;i++){var a=e[i];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(t,e,n){"use strict";function r(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),r=1;r<arguments.length;r++){var i=arguments[r];if(void 0!==i&&null!==i)for(var o=Object.keys(Object(i)),a=0,s=o.length;a<s;a++){var c=o[a],u=Object.getOwnPropertyDescriptor(i,c);void 0!==u&&u.enumerable&&(n[c]=i[c])}}return n}function i(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:r})}t.exports={assign:r,polyfill:i}},function(t,e,n){var r;!function(i,o,a,s){"use strict";function c(t,e,n){return setTimeout(d(t,n),e)}function u(t,e,n){return!!Array.isArray(t)&&(l(t,n[e],n),!0)}function l(t,e,n){var r;if(t)if(t.forEach)t.forEach(e,n);else if(t.length!==s)for(r=0;r<t.length;)e.call(n,t[r],r,t),r++;else for(r in t)t.hasOwnProperty(r)&&e.call(n,t[r],r,t)}function f(t,e,n){var r="DEPRECATED METHOD: "+e+"\n"+n+" AT \n";return function(){var e=new Error("get-stack-trace"),n=e&&e.stack?e.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",o=i.console&&(i.console.warn||i.console.log);return o&&o.call(i.console,r,n),t.apply(this,arguments)}}function p(t,e,n){var r,i=e.prototype;r=t.prototype=Object.create(i),r.constructor=t,r._super=i,n&&ht(r,n)}function d(t,e){return function(){return t.apply(e,arguments)}}function h(t,e){return typeof t==gt?t.apply(e?e[0]||s:s,e):t}function m(t,e){return t===s?e:t}function v(t,e,n){l(x(e),function(e){t.addEventListener(e,n,!1)})}function g(t,e,n){l(x(e),function(e){t.removeEventListener(e,n,!1)})}function y(t,e){for(;t;){if(t==e)return!0;t=t.parentNode}return!1}function b(t,e){return t.indexOf(e)>-1}function x(t){return t.trim().split(/\s+/g)}function T(t,e,n){if(t.indexOf&&!n)return t.indexOf(e);for(var r=0;r<t.length;){if(n&&t[r][n]==e||!n&&t[r]===e)return r;r++}return-1}function w(t){return Array.prototype.slice.call(t,0)}function E(t,e,n){for(var r=[],i=[],o=0;o<t.length;){var a=e?t[o][e]:t[o];T(i,a)<0&&r.push(t[o]),i[o]=a,o++}return n&&(r=e?r.sort(function(t,n){return t[e]>n[e]}):r.sort()),r}function C(t,e){for(var n,r,i=e[0].toUpperCase()+e.slice(1),o=0;o<mt.length;){if(n=mt[o],(r=n?n+i:e)in t)return r;o++}return s}function S(){return Et++}function O(t){var e=t.ownerDocument||t;return e.defaultView||e.parentWindow||i}function A(t,e){var n=this;this.manager=t,this.callback=e,this.element=t.element,this.target=t.options.inputTarget,this.domHandler=function(e){h(t.options.enable,[t])&&n.handler(e)},this.init()}function I(t){var e=t.options.inputClass;return new(e||(Ot?H:At?W:St?B:Y))(t,M)}function M(t,e,n){var r=n.pointers.length,i=n.changedPointers.length,o=e&Mt&&r-i==0,a=e&(Pt|Lt)&&r-i==0;n.isFirst=!!o,n.isFinal=!!a,o&&(t.session={}),n.eventType=e,k(t,n),t.emit("hammer.input",n),t.recognize(n),t.session.prevInput=n}function k(t,e){var n=t.session,r=e.pointers,i=r.length;n.firstInput||(n.firstInput=j(e)),i>1&&!n.firstMultiple?n.firstMultiple=j(e):1===i&&(n.firstMultiple=!1);var o=n.firstInput,a=n.firstMultiple,s=a?a.center:o.center,c=e.center=N(r);e.timeStamp=xt(),e.deltaTime=e.timeStamp-o.timeStamp,e.angle=R(s,c),e.distance=D(s,c),P(n,e),e.offsetDirection=X(e.deltaX,e.deltaY);var u=_(e.deltaTime,e.deltaX,e.deltaY);e.overallVelocityX=u.x,e.overallVelocityY=u.y,e.overallVelocity=bt(u.x)>bt(u.y)?u.x:u.y,e.scale=a?z(a.pointers,r):1,e.rotation=a?F(a.pointers,r):0,e.maxPointers=n.prevInput?e.pointers.length>n.prevInput.maxPointers?e.pointers.length:n.prevInput.maxPointers:e.pointers.length,L(n,e);var l=t.element;y(e.srcEvent.target,l)&&(l=e.srcEvent.target),e.target=l}function P(t,e){var n=e.center,r=t.offsetDelta||{},i=t.prevDelta||{},o=t.prevInput||{};e.eventType!==Mt&&o.eventType!==Pt||(i=t.prevDelta={x:o.deltaX||0,y:o.deltaY||0},r=t.offsetDelta={x:n.x,y:n.y}),e.deltaX=i.x+(n.x-r.x),e.deltaY=i.y+(n.y-r.y)}function L(t,e){var n,r,i,o,a=t.lastInterval||e,c=e.timeStamp-a.timeStamp;if(e.eventType!=Lt&&(c>It||a.velocity===s)){var u=e.deltaX-a.deltaX,l=e.deltaY-a.deltaY,f=_(c,u,l);r=f.x,i=f.y,n=bt(f.x)>bt(f.y)?f.x:f.y,o=X(u,l),t.lastInterval=e}else n=a.velocity,r=a.velocityX,i=a.velocityY,o=a.direction;e.velocity=n,e.velocityX=r,e.velocityY=i,e.direction=o}function j(t){for(var e=[],n=0;n<t.pointers.length;)e[n]={clientX:yt(t.pointers[n].clientX),clientY:yt(t.pointers[n].clientY)},n++;return{timeStamp:xt(),pointers:e,center:N(e),deltaX:t.deltaX,deltaY:t.deltaY}}function N(t){var e=t.length;if(1===e)return{x:yt(t[0].clientX),y:yt(t[0].clientY)};for(var n=0,r=0,i=0;i<e;)n+=t[i].clientX,r+=t[i].clientY,i++;return{x:yt(n/e),y:yt(r/e)}}function _(t,e,n){return{x:e/t||0,y:n/t||0}}function X(t,e){return t===e?jt:bt(t)>=bt(e)?t<0?Nt:_t:e<0?Xt:Dt}function D(t,e,n){n||(n=Yt);var r=e[n[0]]-t[n[0]],i=e[n[1]]-t[n[1]];return Math.sqrt(r*r+i*i)}function R(t,e,n){n||(n=Yt);var r=e[n[0]]-t[n[0]],i=e[n[1]]-t[n[1]];return 180*Math.atan2(i,r)/Math.PI}function F(t,e){return R(e[1],e[0],Ht)+R(t[1],t[0],Ht)}function z(t,e){return D(e[0],e[1],Ht)/D(t[0],t[1],Ht)}function Y(){this.evEl=Vt,this.evWin=Wt,this.pressed=!1,A.apply(this,arguments)}function H(){this.evEl=$t,this.evWin=Gt,A.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function q(){this.evTarget=Qt,this.evWin=Jt,this.started=!1,A.apply(this,arguments)}function V(t,e){var n=w(t.touches),r=w(t.changedTouches);return e&(Pt|Lt)&&(n=E(n.concat(r),"identifier",!0)),[n,r]}function W(){this.evTarget=te,this.targetIds={},A.apply(this,arguments)}function U(t,e){var n=w(t.touches),r=this.targetIds;if(e&(Mt|kt)&&1===n.length)return r[n[0].identifier]=!0,[n,n];var i,o,a=w(t.changedTouches),s=[],c=this.target;if(o=n.filter(function(t){return y(t.target,c)}),e===Mt)for(i=0;i<o.length;)r[o[i].identifier]=!0,i++;for(i=0;i<a.length;)r[a[i].identifier]&&s.push(a[i]),e&(Pt|Lt)&&delete r[a[i].identifier],i++;return s.length?[E(o.concat(s),"identifier",!0),s]:void 0}function B(){A.apply(this,arguments);var t=d(this.handler,this);this.touch=new W(this.manager,t),this.mouse=new Y(this.manager,t),this.primaryTouch=null,this.lastTouches=[]}function $(t,e){t&Mt?(this.primaryTouch=e.changedPointers[0].identifier,G.call(this,e)):t&(Pt|Lt)&&G.call(this,e)}function G(t){var e=t.changedPointers[0];if(e.identifier===this.primaryTouch){var n={x:e.clientX,y:e.clientY};this.lastTouches.push(n);var r=this.lastTouches,i=function(){var t=r.indexOf(n);t>-1&&r.splice(t,1)};setTimeout(i,ee)}}function Z(t){for(var e=t.srcEvent.clientX,n=t.srcEvent.clientY,r=0;r<this.lastTouches.length;r++){var i=this.lastTouches[r],o=Math.abs(e-i.x),a=Math.abs(n-i.y);if(o<=ne&&a<=ne)return!0}return!1}function Q(t,e){this.manager=t,this.set(e)}function J(t){if(b(t,se))return se;var e=b(t,ce),n=b(t,ue);return e&&n?se:e||n?e?ce:ue:b(t,ae)?ae:oe}function K(t){this.options=ht({},this.defaults,t||{}),this.id=S(),this.manager=null,this.options.enable=m(this.options.enable,!0),this.state=fe,this.simultaneous={},this.requireFail=[]}function tt(t){return t&ve?"cancel":t&he?"end":t&de?"move":t&pe?"start":""}function et(t){return t==Dt?"down":t==Xt?"up":t==Nt?"left":t==_t?"right":""}function nt(t,e){var n=e.manager;return n?n.get(t):t}function rt(){K.apply(this,arguments)}function it(){rt.apply(this,arguments),this.pX=null,this.pY=null}function ot(){rt.apply(this,arguments)}function at(){K.apply(this,arguments),this._timer=null,this._input=null}function st(){rt.apply(this,arguments)}function ct(){rt.apply(this,arguments)}function ut(){K.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function lt(t,e){return e=e||{},e.recognizers=m(e.recognizers,lt.defaults.preset),new ft(t,e)}function ft(t,e){this.options=ht({},lt.defaults,e||{}),this.options.inputTarget=this.options.inputTarget||t,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=t,this.input=I(this),this.touchAction=new Q(this,this.options.touchAction),pt(this,!0),l(this.options.recognizers,function(t){var e=this.add(new t[0](t[1]));t[2]&&e.recognizeWith(t[2]),t[3]&&e.requireFailure(t[3])},this)}function pt(t,e){var n=t.element;if(n.style){var r;l(t.options.cssProps,function(i,o){r=C(n.style,o),e?(t.oldCssProps[r]=n.style[r],n.style[r]=i):n.style[r]=t.oldCssProps[r]||""}),e||(t.oldCssProps={})}}function dt(t,e){var n=o.createEvent("Event");n.initEvent(t,!0,!0),n.gesture=e,e.target.dispatchEvent(n)}var ht,mt=["","webkit","Moz","MS","ms","o"],vt=o.createElement("div"),gt="function",yt=Math.round,bt=Math.abs,xt=Date.now;ht="function"!=typeof Object.assign?function(t){if(t===s||null===t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),n=1;n<arguments.length;n++){var r=arguments[n];if(r!==s&&null!==r)for(var i in r)r.hasOwnProperty(i)&&(e[i]=r[i])}return e}:Object.assign;var Tt=f(function(t,e,n){for(var r=Object.keys(e),i=0;i<r.length;)(!n||n&&t[r[i]]===s)&&(t[r[i]]=e[r[i]]),i++;return t},"extend","Use `assign`."),wt=f(function(t,e){return Tt(t,e,!0)},"merge","Use `assign`."),Et=1,Ct=/mobile|tablet|ip(ad|hone|od)|android/i,St="ontouchstart"in i,Ot=C(i,"PointerEvent")!==s,At=St&&Ct.test(navigator.userAgent),It=25,Mt=1,kt=2,Pt=4,Lt=8,jt=1,Nt=2,_t=4,Xt=8,Dt=16,Rt=Nt|_t,Ft=Xt|Dt,zt=Rt|Ft,Yt=["x","y"],Ht=["clientX","clientY"];A.prototype={handler:function(){},init:function(){this.evEl&&v(this.element,this.evEl,this.domHandler),this.evTarget&&v(this.target,this.evTarget,this.domHandler),this.evWin&&v(O(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&g(this.element,this.evEl,this.domHandler),this.evTarget&&g(this.target,this.evTarget,this.domHandler),this.evWin&&g(O(this.element),this.evWin,this.domHandler)}};var qt={mousedown:Mt,mousemove:kt,mouseup:Pt},Vt="mousedown",Wt="mousemove mouseup";p(Y,A,{handler:function(t){var e=qt[t.type];e&Mt&&0===t.button&&(this.pressed=!0),e&kt&&1!==t.which&&(e=Pt),this.pressed&&(e&Pt&&(this.pressed=!1),this.callback(this.manager,e,{pointers:[t],changedPointers:[t],pointerType:"mouse",srcEvent:t}))}});var Ut={pointerdown:Mt,pointermove:kt,pointerup:Pt,pointercancel:Lt,pointerout:Lt},Bt={2:"touch",3:"pen",4:"mouse",5:"kinect"},$t="pointerdown",Gt="pointermove pointerup pointercancel";i.MSPointerEvent&&!i.PointerEvent&&($t="MSPointerDown",Gt="MSPointerMove MSPointerUp MSPointerCancel"),p(H,A,{handler:function(t){var e=this.store,n=!1,r=t.type.toLowerCase().replace("ms",""),i=Ut[r],o=Bt[t.pointerType]||t.pointerType,a="touch"==o,s=T(e,t.pointerId,"pointerId");i&Mt&&(0===t.button||a)?s<0&&(e.push(t),s=e.length-1):i&(Pt|Lt)&&(n=!0),s<0||(e[s]=t,this.callback(this.manager,i,{pointers:e,changedPointers:[t],pointerType:o,srcEvent:t}),n&&e.splice(s,1))}});var Zt={touchstart:Mt,touchmove:kt,touchend:Pt,touchcancel:Lt},Qt="touchstart",Jt="touchstart touchmove touchend touchcancel";p(q,A,{handler:function(t){var e=Zt[t.type];if(e===Mt&&(this.started=!0),this.started){var n=V.call(this,t,e);e&(Pt|Lt)&&n[0].length-n[1].length==0&&(this.started=!1),this.callback(this.manager,e,{pointers:n[0],changedPointers:n[1],pointerType:"touch",srcEvent:t})}}});var Kt={touchstart:Mt,touchmove:kt,touchend:Pt,touchcancel:Lt},te="touchstart touchmove touchend touchcancel";p(W,A,{handler:function(t){var e=Kt[t.type],n=U.call(this,t,e);n&&this.callback(this.manager,e,{pointers:n[0],changedPointers:n[1],pointerType:"touch",srcEvent:t})}});var ee=2500,ne=25;p(B,A,{handler:function(t,e,n){var r="touch"==n.pointerType,i="mouse"==n.pointerType;if(!(i&&n.sourceCapabilities&&n.sourceCapabilities.firesTouchEvents)){if(r)$.call(this,e,n);else if(i&&Z.call(this,n))return;this.callback(t,e,n)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var re=C(vt.style,"touchAction"),ie=re!==s,oe="auto",ae="manipulation",se="none",ce="pan-x",ue="pan-y",le=function(){if(!ie)return!1;var t={},e=i.CSS&&i.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(n){t[n]=!e||i.CSS.supports("touch-action",n)}),t}();Q.prototype={set:function(t){"compute"==t&&(t=this.compute()),ie&&this.manager.element.style&&le[t]&&(this.manager.element.style[re]=t),this.actions=t.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var t=[];return l(this.manager.recognizers,function(e){h(e.options.enable,[e])&&(t=t.concat(e.getTouchAction()))}),J(t.join(" "))},preventDefaults:function(t){var e=t.srcEvent,n=t.offsetDirection;if(this.manager.session.prevented)return void e.preventDefault();var r=this.actions,i=b(r,se)&&!le[se],o=b(r,ue)&&!le[ue],a=b(r,ce)&&!le[ce];if(i){var s=1===t.pointers.length,c=t.distance<2,u=t.deltaTime<250;if(s&&c&&u)return}return a&&o?void 0:i||o&&n&Rt||a&&n&Ft?this.preventSrc(e):void 0},preventSrc:function(t){this.manager.session.prevented=!0,t.preventDefault()}};var fe=1,pe=2,de=4,he=8,me=he,ve=16;K.prototype={defaults:{},set:function(t){return ht(this.options,t),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(t){if(u(t,"recognizeWith",this))return this;var e=this.simultaneous;return t=nt(t,this),e[t.id]||(e[t.id]=t,t.recognizeWith(this)),this},dropRecognizeWith:function(t){return u(t,"dropRecognizeWith",this)?this:(t=nt(t,this),delete this.simultaneous[t.id],this)},requireFailure:function(t){if(u(t,"requireFailure",this))return this;var e=this.requireFail;return t=nt(t,this),-1===T(e,t)&&(e.push(t),t.requireFailure(this)),this},dropRequireFailure:function(t){if(u(t,"dropRequireFailure",this))return this;t=nt(t,this);var e=T(this.requireFail,t);return e>-1&&this.requireFail.splice(e,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(t){return!!this.simultaneous[t.id]},emit:function(t){function e(e){n.manager.emit(e,t)}var n=this,r=this.state;r<he&&e(n.options.event+tt(r)),e(n.options.event),t.additionalEvent&&e(t.additionalEvent),r>=he&&e(n.options.event+tt(r))},tryEmit:function(t){if(this.canEmit())return this.emit(t);this.state=32},canEmit:function(){for(var t=0;t<this.requireFail.length;){if(!(this.requireFail[t].state&(32|fe)))return!1;t++}return!0},recognize:function(t){var e=ht({},t);if(!h(this.options.enable,[this,e]))return this.reset(),void(this.state=32);this.state&(me|ve|32)&&(this.state=fe),this.state=this.process(e),this.state&(pe|de|he|ve)&&this.tryEmit(e)},process:function(t){},getTouchAction:function(){},reset:function(){}},p(rt,K,{defaults:{pointers:1},attrTest:function(t){var e=this.options.pointers;return 0===e||t.pointers.length===e},process:function(t){var e=this.state,n=t.eventType,r=e&(pe|de),i=this.attrTest(t);return r&&(n&Lt||!i)?e|ve:r||i?n&Pt?e|he:e&pe?e|de:pe:32}}),p(it,rt,{defaults:{event:"pan",threshold:10,pointers:1,direction:zt},getTouchAction:function(){var t=this.options.direction,e=[];return t&Rt&&e.push(ue),t&Ft&&e.push(ce),e},directionTest:function(t){var e=this.options,n=!0,r=t.distance,i=t.direction,o=t.deltaX,a=t.deltaY;return i&e.direction||(e.direction&Rt?(i=0===o?jt:o<0?Nt:_t,n=o!=this.pX,r=Math.abs(t.deltaX)):(i=0===a?jt:a<0?Xt:Dt,n=a!=this.pY,r=Math.abs(t.deltaY))),t.direction=i,n&&r>e.threshold&&i&e.direction},attrTest:function(t){return rt.prototype.attrTest.call(this,t)&&(this.state&pe||!(this.state&pe)&&this.directionTest(t))},emit:function(t){this.pX=t.deltaX,this.pY=t.deltaY;var e=et(t.direction);e&&(t.additionalEvent=this.options.event+e),this._super.emit.call(this,t)}}),p(ot,rt,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[se]},attrTest:function(t){return this._super.attrTest.call(this,t)&&(Math.abs(t.scale-1)>this.options.threshold||this.state&pe)},emit:function(t){if(1!==t.scale){var e=t.scale<1?"in":"out";t.additionalEvent=this.options.event+e}this._super.emit.call(this,t)}}),p(at,K,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[oe]},process:function(t){var e=this.options,n=t.pointers.length===e.pointers,r=t.distance<e.threshold,i=t.deltaTime>e.time;if(this._input=t,!r||!n||t.eventType&(Pt|Lt)&&!i)this.reset();else if(t.eventType&Mt)this.reset(),this._timer=c(function(){this.state=me,this.tryEmit()},e.time,this);else if(t.eventType&Pt)return me;return 32},reset:function(){clearTimeout(this._timer)},emit:function(t){this.state===me&&(t&&t.eventType&Pt?this.manager.emit(this.options.event+"up",t):(this._input.timeStamp=xt(),this.manager.emit(this.options.event,this._input)))}}),p(st,rt,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[se]},attrTest:function(t){return this._super.attrTest.call(this,t)&&(Math.abs(t.rotation)>this.options.threshold||this.state&pe)}}),p(ct,rt,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Rt|Ft,pointers:1},getTouchAction:function(){return it.prototype.getTouchAction.call(this)},attrTest:function(t){var e,n=this.options.direction;return n&(Rt|Ft)?e=t.overallVelocity:n&Rt?e=t.overallVelocityX:n&Ft&&(e=t.overallVelocityY),this._super.attrTest.call(this,t)&&n&t.offsetDirection&&t.distance>this.options.threshold&&t.maxPointers==this.options.pointers&&bt(e)>this.options.velocity&&t.eventType&Pt},emit:function(t){var e=et(t.offsetDirection);e&&this.manager.emit(this.options.event+e,t),this.manager.emit(this.options.event,t)}}),p(ut,K,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ae]},process:function(t){var e=this.options,n=t.pointers.length===e.pointers,r=t.distance<e.threshold,i=t.deltaTime<e.time;if(this.reset(),t.eventType&Mt&&0===this.count)return this.failTimeout();if(r&&i&&n){if(t.eventType!=Pt)return this.failTimeout();var o=!this.pTime||t.timeStamp-this.pTime<e.interval,a=!this.pCenter||D(this.pCenter,t.center)<e.posThreshold;this.pTime=t.timeStamp,this.pCenter=t.center,a&&o?this.count+=1:this.count=1,this._input=t;if(0===this.count%e.taps)return this.hasRequireFailures()?(this._timer=c(function(){this.state=me,this.tryEmit()},e.interval,this),pe):me}return 32},failTimeout:function(){return this._timer=c(function(){this.state=32},this.options.interval,this),32},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==me&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),lt.VERSION="2.0.7",lt.defaults={domEvents:!1,touchAction:"compute",enable:!0,inputTarget:null,inputClass:null,preset:[[st,{enable:!1}],[ot,{enable:!1},["rotate"]],[ct,{direction:Rt}],[it,{direction:Rt},["swipe"]],[ut],[ut,{event:"doubletap",taps:2},["tap"]],[at]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};ft.prototype={set:function(t){return ht(this.options,t),t.touchAction&&this.touchAction.update(),t.inputTarget&&(this.input.destroy(),this.input.target=t.inputTarget,this.input.init()),this},stop:function(t){this.session.stopped=t?2:1},recognize:function(t){var e=this.session;if(!e.stopped){this.touchAction.preventDefaults(t);var n,r=this.recognizers,i=e.curRecognizer;(!i||i&&i.state&me)&&(i=e.curRecognizer=null);for(var o=0;o<r.length;)n=r[o],2===e.stopped||i&&n!=i&&!n.canRecognizeWith(i)?n.reset():n.recognize(t),!i&&n.state&(pe|de|he)&&(i=e.curRecognizer=n),o++}},get:function(t){if(t instanceof K)return t;for(var e=this.recognizers,n=0;n<e.length;n++)if(e[n].options.event==t)return e[n];return null},add:function(t){if(u(t,"add",this))return this;var e=this.get(t.options.event);return e&&this.remove(e),this.recognizers.push(t),t.manager=this,this.touchAction.update(),t},remove:function(t){if(u(t,"remove",this))return this;if(t=this.get(t)){var e=this.recognizers,n=T(e,t);-1!==n&&(e.splice(n,1),this.touchAction.update())}return this},on:function(t,e){if(t!==s&&e!==s){var n=this.handlers;return l(x(t),function(t){n[t]=n[t]||[],n[t].push(e)}),this}},off:function(t,e){if(t!==s){var n=this.handlers;return l(x(t),function(t){e?n[t]&&n[t].splice(T(n[t],e),1):delete n[t]}),this}},emit:function(t,e){this.options.domEvents&&dt(t,e);var n=this.handlers[t]&&this.handlers[t].slice();if(n&&n.length){e.type=t,e.preventDefault=function(){e.srcEvent.preventDefault()};for(var r=0;r<n.length;)n[r](e),r++}},destroy:function(){this.element&&pt(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},ht(lt,{INPUT_START:Mt,INPUT_MOVE:kt,INPUT_END:Pt,INPUT_CANCEL:Lt,STATE_POSSIBLE:fe,STATE_BEGAN:pe,STATE_CHANGED:de,STATE_ENDED:he,STATE_RECOGNIZED:me,STATE_CANCELLED:ve,STATE_FAILED:32,DIRECTION_NONE:jt,DIRECTION_LEFT:Nt,DIRECTION_RIGHT:_t,DIRECTION_UP:Xt,DIRECTION_DOWN:Dt,DIRECTION_HORIZONTAL:Rt,DIRECTION_VERTICAL:Ft,DIRECTION_ALL:zt,Manager:ft,Input:A,TouchAction:Q,TouchInput:W,MouseInput:Y,PointerEventInput:H,TouchMouseInput:B,SingleTouchInput:q,Recognizer:K,AttrRecognizer:rt,Tap:ut,Pan:it,Swipe:ct,Pinch:ot,Rotate:st,Press:at,on:v,off:g,each:l,merge:wt,extend:Tt,assign:ht,inherit:p,bindFn:d,prefixed:C}),(void 0!==i?i:"undefined"!=typeof self?self:{}).Hammer=lt,(r=function(){return lt}.call(e,n,e,t))!==s&&(t.exports=r)}(window,document)},function(t,e){t.exports=function(t,e,n){for(var r=(2<<Math.log(e.length-1)/Math.LN2)-1,i=-~(1.6*r*n/e.length),o="";;)for(var a=t(i),s=i;s--;)if(o+=e[a[s]&r]||"",o.length===+n)return o}},function(t,e,n){"use strict";function r(t){var e="",n=Math.floor(.001*(Date.now()-s));return n===o?i++:(i=0,o=n),e+=a(c),e+=a(t),i>0&&(e+=a(i)),e+=a(n)}var i,o,a=n(15),s=(n(0),1567752802062),c=7;t.exports=r},function(t,e,n){"use strict";function r(t){for(var e,n=0,r="";!e;)r+=a(o,i.get(),1),e=t<Math.pow(16,n+1),n++;return r}var i=n(0),o=n(18),a=n(13);t.exports=r},function(t,e,n){"use strict";function r(e){return s.seed(e),t.exports}function i(e){return l=e,t.exports}function o(t){return void 0!==t&&s.characters(t),s.shuffled()}function a(){return c(l)}var s=n(0),c=n(14),u=n(17),l=n(20)||0;t.exports=a,t.exports.generate=a,t.exports.seed=r,t.exports.worker=i,t.exports.characters=o,t.exports.isValid=u},function(t,e,n){"use strict";function r(t){return!(!t||"string"!=typeof t||t.length<6)&&!new RegExp("[^"+i.get().replace(/[|\\{}()[\]^$+*?.-]/g,"\\$&")+"]").test(t)}var i=n(0);t.exports=r},function(t,e,n){"use strict";var r,i="object"==typeof window&&(window.crypto||window.msCrypto);r=i&&i.getRandomValues?function(t){return i.getRandomValues(new Uint8Array(t))}:function(t){for(var e=[],n=0;n<t;n++)e.push(Math.floor(256*Math.random()));return e},t.exports=r},function(t,e,n){"use strict";function r(){return(o=(9301*o+49297)%233280)/233280}function i(t){o=t}var o=1;t.exports={nextValue:r,seed:i}},function(t,e,n){"use strict";t.exports=0},function(t,e){t.exports=function(t,e,n,r){var i,o=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(i=t,o=t.default);var s="function"==typeof o?o.options:o;if(e&&(s.render=e.render,s.staticRenderFns=e.staticRenderFns),n&&(s._scopeId=n),r){var c=Object.create(s.computed||null);Object.keys(r).forEach(function(t){var e=r[t];c[t]=function(){return e}}),s.computed=c}return{esModule:i,exports:o,options:s}}},function(t,e,n){var r=n(9);"string"==typeof r&&(r=[[t.i,r,""]]),r.locals&&(t.exports=r.locals);n(23)("df0682cc",r,!0,{})},function(t,e,n){function r(t){for(var e=0;e<t.length;e++){var n=t[e],r=l[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(o(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var a=[],i=0;i<n.parts.length;i++)a.push(o(n.parts[i]));l[n.id]={id:n.id,refs:1,parts:a}}}}function i(){var t=document.createElement("style");return t.type="text/css",f.appendChild(t),t}function o(t){var e,n,r=document.querySelector("style["+g+'~="'+t.id+'"]');if(r){if(h)return m;r.parentNode.removeChild(r)}if(y){var o=d++;r=p||(p=i()),e=a.bind(null,r,o,!1),n=a.bind(null,r,o,!0)}else r=i(),e=s.bind(null,r),n=function(){r.parentNode.removeChild(r)};return e(t),function(r){if(r){if(r.css===t.css&&r.media===t.media&&r.sourceMap===t.sourceMap)return;e(t=r)}else n()}}function a(t,e,n,r){var i=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=b(e,i);else{var o=document.createTextNode(i),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(o,a[e]):t.appendChild(o)}}function s(t,e){var n=e.css,r=e.media,i=e.sourceMap;if(r&&t.setAttribute("media",r),v.ssrId&&t.setAttribute(g,e.id),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u=n(24),l={},f=c&&(document.head||document.getElementsByTagName("head")[0]),p=null,d=0,h=!1,m=function(){},v=null,g="data-vue-ssr-id",y="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n,i){h=n,v=i||{};var o=u(t,e);return r(o),function(e){for(var n=[],i=0;i<o.length;i++){var a=o[i],s=l[a.id];s.refs--,n.push(s)}e?(o=u(t,e),r(o)):o=[];for(var i=0;i<n.length;i++){var s=n[i];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete l[s.id]}}}};var b=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],r={},i=0;i<e.length;i++){var o=e[i],a=o[0],s=o[1],c=o[2],u=o[3],l={id:t+":"+i,css:s,media:c,sourceMap:u};r[a]?r[a].parts.push(l):n.push(r[a]={id:a,parts:[l]})}return n}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n}])});

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(836)


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Bugsnag = f()}})(function(){var define,module,exports;
var _$breadcrumbTypes_8 = ['navigation', 'request', 'process', 'log', 'user', 'state', 'error', 'manual'];

// Array#reduce
var _$reduce_17 = function (arr, fn, accum) {
  var val = accum;

  for (var i = 0, len = arr.length; i < len; i++) {
    val = fn(val, arr[i], i, arr);
  }

  return val;
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#filter


var _$filter_12 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return !fn(item, i, arr) ? accum : accum.concat(item);
  }, []);
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#includes


var _$includes_13 = function (arr, x) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum === true || item === x;
  }, false);
};

// Array#isArray
var _$isArray_14 = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/* eslint-disable-next-line no-prototype-builtins */
var _hasDontEnumBug = !{
  toString: null
}.propertyIsEnumerable('toString');

var _dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor']; // Object#keys

var _$keys_15 = function (obj) {
  // stripped down version of
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
  var result = [];
  var prop;

  for (prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
  }

  if (!_hasDontEnumBug) return result;

  for (var i = 0, len = _dontEnums.length; i < len; i++) {
    if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
  }

  return result;
};

var _$intRange_24 = function (min, max) {
  if (min === void 0) {
    min = 1;
  }

  if (max === void 0) {
    max = Infinity;
  }

  return function (value) {
    return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
  };
};

/* removed: var _$filter_12 = require('../es-utils/filter'); */;

/* removed: var _$isArray_14 = require('../es-utils/is-array'); */;

var _$listOfFunctions_25 = function (value) {
  return typeof value === 'function' || _$isArray_14(value) && _$filter_12(value, function (f) {
    return typeof f === 'function';
  }).length === value.length;
};

var _$stringWithLength_26 = function (value) {
  return typeof value === 'string' && !!value.length;
};

var _$config_5 = {};
/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;

/* removed: var _$isArray_14 = require('./lib/es-utils/is-array'); */;

/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;

/* removed: var _$intRange_24 = require('./lib/validators/int-range'); */;

/* removed: var _$stringWithLength_26 = require('./lib/validators/string-with-length'); */;

/* removed: var _$listOfFunctions_25 = require('./lib/validators/list-of-functions'); */;

/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;

var defaultErrorTypes = function () {
  return {
    unhandledExceptions: true,
    unhandledRejections: true
  };
};

_$config_5.schema = {
  apiKey: {
    defaultValue: function () {
      return null;
    },
    message: 'is required',
    validate: _$stringWithLength_26
  },
  appVersion: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  appType: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  autoDetectErrors: {
    defaultValue: function () {
      return true;
    },
    message: 'should be true|false',
    validate: function (value) {
      return value === true || value === false;
    }
  },
  enabledErrorTypes: {
    defaultValue: function () {
      return defaultErrorTypes();
    },
    message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
    allowPartialObject: true,
    validate: function (value) {
      // ensure we have an object
      if (typeof value !== 'object' || !value) return false;
      var providedKeys = _$keys_15(value);
      var defaultKeys = _$keys_15(defaultErrorTypes()); // ensure it only has a subset of the allowed keys

      if (_$filter_12(providedKeys, function (k) {
        return _$includes_13(defaultKeys, k);
      }).length < providedKeys.length) return false; // ensure all of the values are boolean

      if (_$filter_12(_$keys_15(value), function (k) {
        return typeof value[k] !== 'boolean';
      }).length > 0) return false;
      return true;
    }
  },
  onError: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onSession: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onBreadcrumb: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  endpoints: {
    defaultValue: function () {
      return {
        notify: 'https://notify.bugsnag.com',
        sessions: 'https://sessions.bugsnag.com'
      };
    },
    message: 'should be an object containing endpoint URLs { notify, sessions }',
    validate: function (val) {
      return (// first, ensure it's an object
        val && typeof val === 'object' && // notify and sessions must always be set
        _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
        _$filter_12(_$keys_15(val), function (k) {
          return !_$includes_13(['notify', 'sessions'], k);
        }).length === 0
      );
    }
  },
  autoTrackSessions: {
    defaultValue: function (val) {
      return true;
    },
    message: 'should be true|false',
    validate: function (val) {
      return val === true || val === false;
    }
  },
  enabledReleaseStages: {
    defaultValue: function () {
      return null;
    },
    message: 'should be an array of strings',
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$filter_12(value, function (f) {
        return typeof f === 'string';
      }).length === value.length;
    }
  },
  releaseStage: {
    defaultValue: function () {
      return 'production';
    },
    message: 'should be a string',
    validate: function (value) {
      return typeof value === 'string' && value.length;
    }
  },
  maxBreadcrumbs: {
    defaultValue: function () {
      return 25;
    },
    message: 'should be a number ≤100',
    validate: function (value) {
      return _$intRange_24(0, 100)(value);
    }
  },
  enabledBreadcrumbTypes: {
    defaultValue: function () {
      return _$breadcrumbTypes_8;
    },
    message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(',') + ")",
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$reduce_17(value, function (accum, maybeType) {
        if (accum === false) return accum;
        return _$includes_13(_$breadcrumbTypes_8, maybeType);
      }, true);
    }
  },
  context: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || typeof value === 'string';
    }
  },
  user: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object with { id, email, name } properties',
    validate: function (value) {
      return value === null || value && _$reduce_17(_$keys_15(value), function (accum, key) {
        return accum && _$includes_13(['id', 'email', 'name'], key);
      }, true);
    }
  },
  metadata: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object',
    validate: function (value) {
      return typeof value === 'object' && value !== null;
    }
  },
  logger: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be null or an object with methods { debug, info, warn, error }',
    validate: function (value) {
      return !value || value && _$reduce_17(['debug', 'info', 'warn', 'error'], function (accum, method) {
        return accum && typeof value[method] === 'function';
      }, true);
    }
  },
  redactedKeys: {
    defaultValue: function () {
      return ['password'];
    },
    message: 'should be an array of strings|regexes',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (s) {
        return typeof s === 'string' || s && typeof s.test === 'function';
      }).length;
    }
  },
  plugins: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of plugin objects',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (p) {
        return p && typeof p === 'object' && typeof p.load === 'function';
      }).length;
    }
  },
  featureFlags: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of objects that have a "name" property',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (feature) {
        return feature && typeof feature === 'object' && typeof feature.name === 'string';
      }).length;
    }
  }
};

// extends helper from babel
// https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
var _$assign_11 = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/* removed: var _$reduce_17 = require('./reduce'); */; // Array#map


var _$map_16 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum.concat(fn(item, i, arr));
  }, []);
};

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var schema = _$config_5.schema;

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

var _$config_1 = {
  releaseStage: _$assign_11({}, schema.releaseStage, {
    defaultValue: function () {
      if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
      return 'production';
    }
  }),
  appType: _extends({}, schema.appType, {
    defaultValue: function () {
      return 'browser';
    }
  }),
  logger: _$assign_11({}, schema.logger, {
    defaultValue: function () {
      return (// set logger based on browser capability
        typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined
      );
    }
  })
};

var getPrefixedConsole = function () {
  var logger = {};
  var consoleLog = console.log;
  _$map_16(['debug', 'info', 'warn', 'error'], function (method) {
    var consoleMethod = console[method];
    logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
  });
  return logger;
};

var Breadcrumb = /*#__PURE__*/function () {
  function Breadcrumb(message, metadata, type, timestamp) {
    if (timestamp === void 0) {
      timestamp = new Date();
    }

    this.type = type;
    this.message = message;
    this.metadata = metadata;
    this.timestamp = timestamp;
  }

  var _proto = Breadcrumb.prototype;

  _proto.toJSON = function toJSON() {
    return {
      type: this.type,
      name: this.message,
      timestamp: this.timestamp,
      metaData: this.metadata
    };
  };

  return Breadcrumb;
}();

var _$Breadcrumb_3 = Breadcrumb;

var _$stackframe_34 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('stackframe', [], factory);
  } else if (typeof _$stackframe_34 === 'object') {
    _$stackframe_34 = factory();
  } else {
    root.StackFrame = factory();
  }
})(this, function () {
  'use strict';

  function _isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  }

  function _getter(p) {
    return function () {
      return this[p];
    };
  }

  var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
  var numericProps = ['columnNumber', 'lineNumber'];
  var stringProps = ['fileName', 'functionName', 'source'];
  var arrayProps = ['args'];
  var props = booleanProps.concat(numericProps, stringProps, arrayProps);

  function StackFrame(obj) {
    if (obj instanceof Object) {
      for (var i = 0; i < props.length; i++) {
        if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
          this['set' + _capitalize(props[i])](obj[props[i]]);
        }
      }
    }
  }

  StackFrame.prototype = {
    getArgs: function () {
      return this.args;
    },
    setArgs: function (v) {
      if (Object.prototype.toString.call(v) !== '[object Array]') {
        throw new TypeError('Args must be an Array');
      }

      this.args = v;
    },
    getEvalOrigin: function () {
      return this.evalOrigin;
    },
    setEvalOrigin: function (v) {
      if (v instanceof StackFrame) {
        this.evalOrigin = v;
      } else if (v instanceof Object) {
        this.evalOrigin = new StackFrame(v);
      } else {
        throw new TypeError('Eval Origin must be an Object or StackFrame');
      }
    },
    toString: function () {
      var functionName = this.getFunctionName() || '{anonymous}';
      var args = '(' + (this.getArgs() || []).join(',') + ')';
      var fileName = this.getFileName() ? '@' + this.getFileName() : '';
      var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
      var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
      return functionName + args + fileName + lineNumber + columnNumber;
    }
  };

  for (var i = 0; i < booleanProps.length; i++) {
    StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);

    StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
      return function (v) {
        this[p] = Boolean(v);
      };
    }(booleanProps[i]);
  }

  for (var j = 0; j < numericProps.length; j++) {
    StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);

    StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
      return function (v) {
        if (!_isNumber(v)) {
          throw new TypeError(p + ' must be a Number');
        }

        this[p] = Number(v);
      };
    }(numericProps[j]);
  }

  for (var k = 0; k < stringProps.length; k++) {
    StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);

    StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
      return function (v) {
        this[p] = String(v);
      };
    }(stringProps[k]);
  }

  return StackFrame;
});

var _$errorStackParser_31 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('error-stack-parser', ['stackframe'], factory);
  } else if (typeof _$errorStackParser_31 === 'object') {
    _$errorStackParser_31 = factory(_$stackframe_34);
  } else {
    root.ErrorStackParser = factory(root.StackFrame);
  }
})(this, function ErrorStackParser(StackFrame) {
  'use strict';

  var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
  var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
  var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
  return {
    /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */
    parse: function ErrorStackParser$$parse(error) {
      if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
        return this.parseOpera(error);
      } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
        return this.parseV8OrIE(error);
      } else if (error.stack) {
        return this.parseFFOrSafari(error);
      } else {
        throw new Error('Cannot parse given Error object');
      }
    },
    // Separate line and column numbers from a string of the form: (URI:Line:Column)
    extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
      // Fail-fast but return locations like "(native)"
      if (urlLike.indexOf(':') === -1) {
        return [urlLike];
      }

      var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
      var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
      return [parts[1], parts[2] || undefined, parts[3] || undefined];
    },
    parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(CHROME_IE_STACK_REGEXP);
      }, this);
      return filtered.map(function (line) {
        if (line.indexOf('(eval ') > -1) {
          // Throw away eval information until we implement stacktrace.js/stackframe#8
          line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
        }

        var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '('); // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
        // case it has spaces in it, as the string is split on \s+ later on

        var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/); // remove the parenthesized location from the line, if it was matched

        sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
        var tokens = sanitizedLine.split(/\s+/).slice(1); // if a location was matched, pass it to extractLocation() otherwise pop the last token

        var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
        var functionName = tokens.join(' ') || undefined;
        var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
        return new StackFrame({
          functionName: functionName,
          fileName: fileName,
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    },
    parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !line.match(SAFARI_NATIVE_CODE_REGEXP);
      }, this);
      return filtered.map(function (line) {
        // Throw away eval information until we implement stacktrace.js/stackframe#8
        if (line.indexOf(' > eval') > -1) {
          line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
        }

        if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
          // Safari eval frames only have function names and nothing else
          return new StackFrame({
            functionName: line
          });
        } else {
          var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
          var matches = line.match(functionNameRegex);
          var functionName = matches && matches[1] ? matches[1] : undefined;
          var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
          return new StackFrame({
            functionName: functionName,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }
      }, this);
    },
    parseOpera: function ErrorStackParser$$parseOpera(e) {
      if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
        return this.parseOpera9(e);
      } else if (!e.stack) {
        return this.parseOpera10(e);
      } else {
        return this.parseOpera11(e);
      }
    },
    parseOpera9: function ErrorStackParser$$parseOpera9(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
      var lines = e.message.split('\n');
      var result = [];

      for (var i = 2, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);

        if (match) {
          result.push(new StackFrame({
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }

      return result;
    },
    parseOpera10: function ErrorStackParser$$parseOpera10(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
      var lines = e.stacktrace.split('\n');
      var result = [];

      for (var i = 0, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);

        if (match) {
          result.push(new StackFrame({
            functionName: match[3] || undefined,
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }

      return result;
    },
    // Opera 10.65+ Error.stack very similar to FF/Safari
    parseOpera11: function ErrorStackParser$$parseOpera11(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
      }, this);
      return filtered.map(function (line) {
        var tokens = line.split('@');
        var locationParts = this.extractLocation(tokens.pop());
        var functionCall = tokens.shift() || '';
        var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
        var argsRaw;

        if (functionCall.match(/\(([^\)]*)\)/)) {
          argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
        }

        var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
        return new StackFrame({
          functionName: functionName,
          args: args,
          fileName: locationParts[0],
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    }
  };
});

var _$errorStackParser_10 = _$errorStackParser_31;

var _$safeJsonStringify_30 = function (data, replacer, space, opts) {
  var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
  var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
  return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
};

var MAX_DEPTH = 20;
var MAX_EDGES = 25000;
var MIN_PRESERVED_DEPTH = 8;
var REPLACEMENT_NODE = '...';

function isError(o) {
  return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
}

function throwsMessage(err) {
  return '[Throws: ' + (err ? err.message : '?') + ']';
}

function find(haystack, needle) {
  for (var i = 0, len = haystack.length; i < len; i++) {
    if (haystack[i] === needle) return true;
  }

  return false;
} // returns true if the string `path` starts with any of the provided `paths`


function isDescendent(paths, path) {
  for (var i = 0, len = paths.length; i < len; i++) {
    if (path.indexOf(paths[i]) === 0) return true;
  }

  return false;
}

function shouldRedact(patterns, key) {
  for (var i = 0, len = patterns.length; i < len; i++) {
    if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
    if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
  }

  return false;
}

function __isArray_30(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

function safelyGetProp(obj, prop) {
  try {
    return obj[prop];
  } catch (err) {
    return throwsMessage(err);
  }
}

function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
  var seen = []; // store references to objects we have seen before

  var edges = 0;

  function visit(obj, path) {
    function edgesExceeded() {
      return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
    }

    edges++;
    if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
    if (edgesExceeded()) return REPLACEMENT_NODE;
    if (obj === null || typeof obj !== 'object') return obj;
    if (find(seen, obj)) return '[Circular]';
    seen.push(obj);

    if (typeof obj.toJSON === 'function') {
      try {
        // we're not going to count this as an edge because it
        // replaces the value of the currently visited object
        edges--;
        var fResult = visit(obj.toJSON(), path);
        seen.pop();
        return fResult;
      } catch (err) {
        return throwsMessage(err);
      }
    }

    var er = isError(obj);

    if (er) {
      edges--;
      var eResult = visit({
        name: obj.name,
        message: obj.message
      }, path);
      seen.pop();
      return eResult;
    }

    if (__isArray_30(obj)) {
      var aResult = [];

      for (var i = 0, len = obj.length; i < len; i++) {
        if (edgesExceeded()) {
          aResult.push(REPLACEMENT_NODE);
          break;
        }

        aResult.push(visit(obj[i], path.concat('[]')));
      }

      seen.pop();
      return aResult;
    }

    var result = {};

    try {
      for (var prop in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;

        if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
          result[prop] = '[REDACTED]';
          continue;
        }

        if (edgesExceeded()) {
          result[prop] = REPLACEMENT_NODE;
          break;
        }

        result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
      }
    } catch (e) {}

    seen.pop();
    return result;
  }

  return visit(obj, []);
}

/* removed: var _$map_16 = require('./es-utils/map'); */;

/* removed: var _$keys_15 = require('./es-utils/keys'); */;

/* removed: var _$isArray_14 = require('./es-utils/is-array'); */;

/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;

function add(existingFeatures, name, variant) {
  if (typeof name !== 'string') {
    return;
  }

  if (variant === undefined) {
    variant = null;
  } else if (variant !== null && typeof variant !== 'string') {
    variant = _$safeJsonStringify_30(variant);
  }

  existingFeatures[name] = variant;
}

function merge(existingFeatures, newFeatures) {
  if (!_$isArray_14(newFeatures)) {
    return;
  }

  for (var i = 0; i < newFeatures.length; ++i) {
    var feature = newFeatures[i];

    if (feature === null || typeof feature !== 'object') {
      continue;
    } // 'add' will handle if 'name' doesn't exist & 'variant' is optional


    add(existingFeatures, feature.name, feature.variant);
  }
} // convert feature flags from a map of 'name -> variant' into the format required
// by the Bugsnag Event API:
//   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]


function toEventApi(featureFlags) {
  return _$map_16(_$keys_15(featureFlags), function (name) {
    var flag = {
      featureFlag: name
    }; // don't add a 'variant' property unless there's actually a value

    if (typeof featureFlags[name] === 'string') {
      flag.variant = featureFlags[name];
    }

    return flag;
  });
}

var _$featureFlagDelegate_18 = {
  add: add,
  merge: merge,
  toEventApi: toEventApi
};

// Given `err` which may be an error, does it have a stack property which is a string?
var _$hasStack_19 = function (err) {
  return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
};

/**
 * Expose `isError`.
 */
var _$isError_32 = __isError_32;
/**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */

function __isError_32(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;

    case '[object Exception]':
      return true;

    case '[object DOMException]':
      return true;

    default:
      return value instanceof Error;
  }
}

var _$iserror_20 = _$isError_32;

/* removed: var _$assign_11 = require('./es-utils/assign'); */;

var __add_22 = function (state, section, keyOrObj, maybeVal) {
  var _updates;

  if (!section) return;
  var updates; // addMetadata("section", null) -> clears section

  if (keyOrObj === null) return clear(state, section); // normalise the two supported input types into object form

  if (typeof keyOrObj === 'object') updates = keyOrObj;
  if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates); // exit if we don't have an updates object at this point

  if (!updates) return; // ensure a section with this name exists

  if (!state[section]) state[section] = {}; // merge the updates with the existing section

  state[section] = _$assign_11({}, state[section], updates);
};

var get = function (state, section, key) {
  if (typeof section !== 'string') return undefined;

  if (!key) {
    return state[section];
  }

  if (state[section]) {
    return state[section][key];
  }

  return undefined;
};

var clear = function (state, section, key) {
  if (typeof section !== 'string') return; // clear an entire section

  if (!key) {
    delete state[section];
    return;
  } // clear a single value from a section


  if (state[section]) {
    delete state[section][key];
  }
};

var _$metadataDelegate_22 = {
  add: __add_22,
  get: get,
  clear: clear
};

var _$stackGenerator_33 = {};
(function (root, factory) {
  'use strict'; // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */

  if (typeof define === 'function' && define.amd) {
    define('stack-generator', ['stackframe'], factory);
  } else if (typeof _$stackGenerator_33 === 'object') {
    _$stackGenerator_33 = factory(_$stackframe_34);
  } else {
    root.StackGenerator = factory(root.StackFrame);
  }
})(this, function (StackFrame) {
  return {
    backtrace: function StackGenerator$$backtrace(opts) {
      var stack = [];
      var maxStackSize = 10;

      if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
        maxStackSize = opts.maxStackSize;
      }

      var curr = arguments.callee;

      while (curr && stack.length < maxStackSize && curr['arguments']) {
        // Allow V8 optimizations
        var args = new Array(curr['arguments'].length);

        for (var i = 0; i < args.length; ++i) {
          args[i] = curr['arguments'][i];
        }

        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
          stack.push(new StackFrame({
            functionName: RegExp.$1 || undefined,
            args: args
          }));
        } else {
          stack.push(new StackFrame({
            args: args
          }));
        }

        try {
          curr = curr.caller;
        } catch (e) {
          break;
        }
      }

      return stack;
    }
  };
});

/* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */;

/* removed: var _$stackGenerator_33 = require('stack-generator'); */;

/* removed: var _$hasStack_19 = require('./lib/has-stack'); */;

/* removed: var _$map_16 = require('./lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;

/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;

/* removed: var _$featureFlagDelegate_18 = require('./lib/feature-flag-delegate'); */;

/* removed: var _$iserror_20 = require('./lib/iserror'); */;

var Event = /*#__PURE__*/function () {
  function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
    if (stacktrace === void 0) {
      stacktrace = [];
    }

    if (handledState === void 0) {
      handledState = defaultHandledState();
    }

    this.apiKey = undefined;
    this.context = undefined;
    this.groupingHash = undefined;
    this.originalError = originalError;
    this._handledState = handledState;
    this.severity = this._handledState.severity;
    this.unhandled = this._handledState.unhandled;
    this.app = {};
    this.device = {};
    this.request = {};
    this.breadcrumbs = [];
    this.threads = [];
    this._metadata = {};
    this._features = {};
    this._user = {};
    this._session = undefined;
    this.errors = [{
      errorClass: ensureString(errorClass),
      errorMessage: ensureString(errorMessage),
      type: Event.__type,
      stacktrace: _$reduce_17(stacktrace, function (accum, frame) {
        var f = formatStackframe(frame); // don't include a stackframe if none of its properties are defined

        try {
          if (JSON.stringify(f) === '{}') return accum;
          return accum.concat(f);
        } catch (e) {
          return accum;
        }
      }, [])
    }]; // Flags.
    // Note these are not initialised unless they are used
    // to save unnecessary bytes in the browser bundle

    /* this.attemptImmediateDelivery, default: true */
  }

  var _proto = Event.prototype;

  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };

  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };

  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };

  _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
    if (variant === void 0) {
      variant = null;
    }

    _$featureFlagDelegate_18.add(this._features, name, variant);
  };

  _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
    _$featureFlagDelegate_18.merge(this._features, featureFlags);
  };

  _proto.clearFeatureFlag = function clearFeatureFlag(name) {
    delete this._features[name];
  };

  _proto.clearFeatureFlags = function clearFeatureFlags() {
    this._features = {};
  };

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto.toJSON = function toJSON() {
    return {
      payloadVersion: '4',
      exceptions: _$map_16(this.errors, function (er) {
        return _$assign_11({}, er, {
          message: er.errorMessage
        });
      }),
      severity: this.severity,
      unhandled: this._handledState.unhandled,
      severityReason: this._handledState.severityReason,
      app: this.app,
      device: this.device,
      request: this.request,
      breadcrumbs: this.breadcrumbs,
      context: this.context,
      groupingHash: this.groupingHash,
      metaData: this._metadata,
      user: this._user,
      session: this._session,
      featureFlags: _$featureFlagDelegate_18.toEventApi(this._features)
    };
  };

  return Event;
}(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
// and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)


var formatStackframe = function (frame) {
  var f = {
    file: frame.fileName,
    method: normaliseFunctionName(frame.functionName),
    lineNumber: frame.lineNumber,
    columnNumber: frame.columnNumber,
    code: undefined,
    inProject: undefined
  }; // Some instances result in no file:
  // - calling notify() from chrome's terminal results in no file/method.
  // - non-error exception thrown from global code in FF
  // This adds one.

  if (f.lineNumber > -1 && !f.file && !f.method) {
    f.file = 'global code';
  }

  return f;
};

var normaliseFunctionName = function (name) {
  return /^global code$/i.test(name) ? 'global code' : name;
};

var defaultHandledState = function () {
  return {
    unhandled: false,
    severity: 'warning',
    severityReason: {
      type: 'handledException'
    }
  };
};

var ensureString = function (str) {
  return typeof str === 'string' ? str : '';
}; // Helpers


Event.getStacktrace = function (error, errorFramesToSkip, backtraceFramesToSkip) {
  if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip); // error wasn't provided or didn't have a stacktrace so try to walk the callstack

  try {
    return _$filter_12(_$stackGenerator_33.backtrace(), function (frame) {
      return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
    }).slice(1 + backtraceFramesToSkip);
  } catch (e) {
    return [];
  }
};

Event.create = function (maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
  if (errorFramesToSkip === void 0) {
    errorFramesToSkip = 0;
  }

  var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger),
      error = _normaliseError[0],
      internalFrames = _normaliseError[1];

  var event;

  try {
    var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
    // tell the getStacktrace() function to skip the number of frames we know will
    // be from our own functions. This is added to the number of frames deep we
    // were told about
    internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
    // this is how many frames should be removed because they come from our library
    1 + errorFramesToSkip);
    event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
  } catch (e) {
    event = new Event(error.name, error.message, [], handledState, maybeError);
  }

  if (error.name === 'InvalidError') {
    event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
  }

  return event;
};

var makeSerialisable = function (err) {
  if (err === null) return 'null';
  if (err === undefined) return 'undefined';
  return err;
};

var normaliseError = function (maybeError, tolerateNonErrors, component, logger) {
  var error;
  var internalFrames = 0;

  var createAndLogInputError = function (reason) {
    if (logger) logger.warn(component + " received a non-error: \"" + reason + "\"");
    var err = new Error(component + " received a non-error. See \"" + component + "\" tab for more detail.");
    err.name = 'InvalidError';
    return err;
  }; // In some cases:
  //
  //  - the promise rejection handler (both in the browser and node)
  //  - the node uncaughtException handler
  //
  // We are really limited in what we can do to get a stacktrace. So we use the
  // tolerateNonErrors option to ensure that the resulting error communicates as
  // such.


  if (!tolerateNonErrors) {
    if (_$iserror_20(maybeError)) {
      error = maybeError;
    } else {
      error = createAndLogInputError(typeof maybeError);
      internalFrames += 2;
    }
  } else {
    switch (typeof maybeError) {
      case 'string':
      case 'number':
      case 'boolean':
        error = new Error(String(maybeError));
        internalFrames += 1;
        break;

      case 'function':
        error = createAndLogInputError('function');
        internalFrames += 2;
        break;

      case 'object':
        if (maybeError !== null && _$iserror_20(maybeError)) {
          error = maybeError;
        } else if (maybeError !== null && hasNecessaryFields(maybeError)) {
          error = new Error(maybeError.message || maybeError.errorMessage);
          error.name = maybeError.name || maybeError.errorClass;
          internalFrames += 1;
        } else {
          error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
          internalFrames += 2;
        }

        break;

      default:
        error = createAndLogInputError('nothing');
        internalFrames += 2;
    }
  }

  if (!_$hasStack_19(error)) {
    // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
    try {
      throw error;
    } catch (e) {
      if (_$hasStack_19(e)) {
        error = e; // if the error only got a stacktrace after we threw it here, we know it
        // will only have one extra internal frame from this function, regardless
        // of whether it went through createAndLogInputError() or not

        internalFrames = 1;
      }
    }
  }

  return [error, internalFrames];
}; // default value for stacktrace.type


Event.__type = 'browserjs';

var hasNecessaryFields = function (error) {
  return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
};

var _$Event_6 = Event;

// This is a heavily modified/simplified version of
//   https://github.com/othiym23/async-some
// with the logic flipped so that it is akin to the
// synchronous "every" method instead of "some".
// run the asynchronous test function (fn) over each item in the array (arr)
// in series until:
//   - fn(item, cb) => calls cb(null, false)
//   - or the end of the array is reached
// the callback (cb) will be passed (null, false) if any of the items in arr
// caused fn to call back with false, otherwise it will be passed (null, true)
var _$asyncEvery_7 = function (arr, fn, cb) {
  var index = 0;

  var next = function () {
    if (index >= arr.length) return cb(null, true);
    fn(arr[index], function (err, result) {
      if (err) return cb(err);
      if (result === false) return cb(null, false);
      index++;
      next();
    });
  };

  next();
};

/* removed: var _$asyncEvery_7 = require('./async-every'); */;

var _$callbackRunner_9 = function (callbacks, event, onCallbackError, cb) {
  // This function is how we support different kinds of callback:
  //  - synchronous - return value
  //  - node-style async with callback - cb(err, value)
  //  - promise/thenable - resolve(value)
  // It normalises each of these into the lowest common denominator – a node-style callback
  var runMaybeAsyncCallback = function (fn, cb) {
    if (typeof fn !== 'function') return cb(null);

    try {
      // if function appears sync…
      if (fn.length !== 2) {
        var ret = fn(event); // check if it returned a "thenable" (promise)

        if (ret && typeof ret.then === 'function') {
          return ret.then( // resolve
          function (val) {
            return setTimeout(function () {
              return cb(null, val);
            });
          }, // reject
          function (err) {
            setTimeout(function () {
              onCallbackError(err);
              return cb(null, true);
            });
          });
        }

        return cb(null, ret);
      } // if function is async…


      fn(event, function (err, result) {
        if (err) {
          onCallbackError(err);
          return cb(null);
        }

        cb(null, result);
      });
    } catch (e) {
      onCallbackError(e);
      cb(null);
    }
  };

  _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
};

var _$syncCallbackRunner_23 = function (callbacks, callbackArg, callbackType, logger) {
  var ignore = false;
  var cbs = callbacks.slice();

  while (!ignore) {
    if (!cbs.length) break;

    try {
      ignore = cbs.pop()(callbackArg) === false;
    } catch (e) {
      logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
      logger.error(e);
    }
  }

  return ignore;
};

var _$pad_29 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_29 = require('./pad.js'); */;

var env = typeof window === 'object' ? window : self;
var globalCount = 0;

for (var prop in env) {
  if (Object.hasOwnProperty.call(env, prop)) globalCount++;
}

var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);

var _$fingerprint_28 = function fingerprint() {
  return clientId;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_29 = require('./lib/pad.js'); */;

var c = 0,
    blockSize = 4,
    base = 36,
    discreteValues = Math.pow(base, blockSize);

function randomBlock() {
  return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
}

function safeCounter() {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal

  return c - 1;
}

function cuid() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(base),
      // Prevent same-machine collisions.
  counter = _$pad_29(safeCounter().toString(base), blockSize),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_28(),
      // Grab some more chars from Math.random()
  random = randomBlock() + randomBlock();
  return letter + timestamp + counter + print + random;
}

cuid.fingerprint = _$fingerprint_28;
var _$cuid_27 = cuid;

/* removed: var _$cuid_27 = require('@bugsnag/cuid'); */;

var Session = /*#__PURE__*/function () {
  function Session() {
    this.id = _$cuid_27();
    this.startedAt = new Date();
    this._handled = 0;
    this._unhandled = 0;
    this._user = {};
    this.app = {};
    this.device = {};
  }

  var _proto = Session.prototype;

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto.toJSON = function toJSON() {
    return {
      id: this.id,
      startedAt: this.startedAt,
      events: {
        handled: this._handled,
        unhandled: this._unhandled
      }
    };
  };

  _proto._track = function _track(event) {
    this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
  };

  return Session;
}();

var _$Session_35 = Session;

/* removed: var _$config_5 = require('./config'); */;

/* removed: var _$Event_6 = require('./event'); */;

/* removed: var _$Breadcrumb_3 = require('./breadcrumb'); */;

/* removed: var _$Session_35 = require('./session'); */;

/* removed: var _$map_16 = require('./lib/es-utils/map'); */;

/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;

/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;

/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;

/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;

/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;

/* removed: var _$callbackRunner_9 = require('./lib/callback-runner'); */;

/* removed: var _$featureFlagDelegate_18 = require('./lib/feature-flag-delegate'); */;

/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;

/* removed: var _$syncCallbackRunner_23 = require('./lib/sync-callback-runner'); */;

/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;

var noop = function () {};

var Client = /*#__PURE__*/function () {
  function Client(configuration, schema, internalPlugins, notifier) {
    var _this = this;

    if (schema === void 0) {
      schema = _$config_5.schema;
    }

    if (internalPlugins === void 0) {
      internalPlugins = [];
    }

    // notifier id
    this._notifier = notifier; // intialise opts and config

    this._config = {};
    this._schema = schema; // i/o

    this._delivery = {
      sendSession: noop,
      sendEvent: noop
    };
    this._logger = {
      debug: noop,
      info: noop,
      warn: noop,
      error: noop
    }; // plugins

    this._plugins = {}; // state

    this._breadcrumbs = [];
    this._session = null;
    this._metadata = {};
    this._features = {};
    this._context = undefined;
    this._user = {}; // callbacks:
    //  e: onError
    //  s: onSession
    //  sp: onSessionPayload
    //  b: onBreadcrumb
    // (note these names are minified by hand because object
    // properties are not safe to minify automatically)

    this._cbs = {
      e: [],
      s: [],
      sp: [],
      b: []
    }; // expose internal constructors

    this.Client = Client;
    this.Event = _$Event_6;
    this.Breadcrumb = _$Breadcrumb_3;
    this.Session = _$Session_35;
    this._config = this._configure(configuration, internalPlugins);
    _$map_16(internalPlugins.concat(this._config.plugins), function (pl) {
      if (pl) _this._loadPlugin(pl);
    }); // when notify() is called we need to know how many frames are from our own source
    // this inital value is 1 not 0 because we wrap notify() to ensure it is always
    // bound to have the client as its `this` value – see below.

    this._depth = 1;
    var self = this;
    var notify = this.notify;

    this.notify = function () {
      return notify.apply(self, arguments);
    };
  }

  var _proto = Client.prototype;

  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };

  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };

  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };

  _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
    if (variant === void 0) {
      variant = null;
    }

    _$featureFlagDelegate_18.add(this._features, name, variant);
  };

  _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
    _$featureFlagDelegate_18.merge(this._features, featureFlags);
  };

  _proto.clearFeatureFlag = function clearFeatureFlag(name) {
    delete this._features[name];
  };

  _proto.clearFeatureFlags = function clearFeatureFlags() {
    this._features = {};
  };

  _proto.getContext = function getContext() {
    return this._context;
  };

  _proto.setContext = function setContext(c) {
    this._context = c;
  };

  _proto._configure = function _configure(opts, internalPlugins) {
    var schema = _$reduce_17(internalPlugins, function (schema, plugin) {
      if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
      return schema;
    }, this._schema); // accumulate configuration and error messages

    var _reduce = _$reduce_17(_$keys_15(schema), function (accum, key) {
      var defaultValue = schema[key].defaultValue(opts[key]);

      if (opts[key] !== undefined) {
        var valid = schema[key].validate(opts[key]);

        if (!valid) {
          accum.errors[key] = schema[key].message;
          accum.config[key] = defaultValue;
        } else {
          if (schema[key].allowPartialObject) {
            accum.config[key] = _$assign_11(defaultValue, opts[key]);
          } else {
            accum.config[key] = opts[key];
          }
        }
      } else {
        accum.config[key] = defaultValue;
      }

      return accum;
    }, {
      errors: {},
      config: {}
    }),
        errors = _reduce.errors,
        config = _reduce.config;

    if (schema.apiKey) {
      // missing api key is the only fatal error
      if (!config.apiKey) throw new Error('No Bugsnag API Key set'); // warn about an apikey that is not of the expected format

      if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
    } // update and elevate some options


    this._metadata = _$assign_11({}, config.metadata);
    _$featureFlagDelegate_18.merge(this._features, config.featureFlags);
    this._user = _$assign_11({}, config.user);
    this._context = config.context;
    if (config.logger) this._logger = config.logger; // add callbacks

    if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
    if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
    if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession); // finally warn about any invalid config where we fell back to the default

    if (_$keys_15(errors).length) {
      this._logger.warn(generateConfigErrorMessage(errors, opts));
    }

    return config;
  };

  _proto.getUser = function getUser() {
    return this._user;
  };

  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };

  _proto._loadPlugin = function _loadPlugin(plugin) {
    var result = plugin.load(this); // JS objects are not the safest way to store arbitrarily keyed values,
    // so bookend the key with some characters that prevent tampering with
    // stuff like __proto__ etc. (only store the result if the plugin had a
    // name)

    if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
    return this;
  };

  _proto.getPlugin = function getPlugin(name) {
    return this._plugins["~" + name + "~"];
  };

  _proto._setDelivery = function _setDelivery(d) {
    this._delivery = d(this);
  };

  _proto.startSession = function startSession() {
    var session = new _$Session_35();
    session.app.releaseStage = this._config.releaseStage;
    session.app.version = this._config.appVersion;
    session.app.type = this._config.appType;
    session._user = _$assign_11({}, this._user); // run onSession callbacks

    var ignore = _$syncCallbackRunner_23(this._cbs.s, session, 'onSession', this._logger);

    if (ignore) {
      this._logger.debug('Session not started due to onSession callback');

      return this;
    }

    return this._sessionDelegate.startSession(this, session);
  };

  _proto.addOnError = function addOnError(fn, front) {
    if (front === void 0) {
      front = false;
    }

    this._cbs.e[front ? 'unshift' : 'push'](fn);
  };

  _proto.removeOnError = function removeOnError(fn) {
    this._cbs.e = _$filter_12(this._cbs.e, function (f) {
      return f !== fn;
    });
  };

  _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
    this._cbs.sp.push(fn);
  };

  _proto.addOnSession = function addOnSession(fn) {
    this._cbs.s.push(fn);
  };

  _proto.removeOnSession = function removeOnSession(fn) {
    this._cbs.s = _$filter_12(this._cbs.s, function (f) {
      return f !== fn;
    });
  };

  _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
    if (front === void 0) {
      front = false;
    }

    this._cbs.b[front ? 'unshift' : 'push'](fn);
  };

  _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
    this._cbs.b = _$filter_12(this._cbs.b, function (f) {
      return f !== fn;
    });
  };

  _proto.pauseSession = function pauseSession() {
    return this._sessionDelegate.pauseSession(this);
  };

  _proto.resumeSession = function resumeSession() {
    return this._sessionDelegate.resumeSession(this);
  };

  _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
    // coerce bad values so that the defaults get set
    message = typeof message === 'string' ? message : '';
    type = typeof type === 'string' && _$includes_13(_$breadcrumbTypes_8, type) ? type : 'manual';
    metadata = typeof metadata === 'object' && metadata !== null ? metadata : {}; // if no message, discard

    if (!message) return;
    var crumb = new _$Breadcrumb_3(message, metadata, type); // run onBreadcrumb callbacks

    var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, 'onBreadcrumb', this._logger);

    if (ignore) {
      this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');

      return;
    } // push the valid crumb onto the queue and maintain the length


    this._breadcrumbs.push(crumb);

    if (this._breadcrumbs.length > this._config.maxBreadcrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
    }
  };

  _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
    var types = this._config.enabledBreadcrumbTypes;
    return types === null || _$includes_13(types, type);
  };

  _proto.notify = function notify(maybeError, onError, cb) {
    if (cb === void 0) {
      cb = noop;
    }

    var event = _$Event_6.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);

    this._notify(event, onError, cb);
  };

  _proto._notify = function _notify(event, onError, cb) {
    var _this2 = this;

    if (cb === void 0) {
      cb = noop;
    }

    event.app = _$assign_11({}, event.app, {
      releaseStage: this._config.releaseStage,
      version: this._config.appVersion,
      type: this._config.appType
    });
    event.context = event.context || this._context;
    event._metadata = _$assign_11({}, event._metadata, this._metadata);
    event._features = _$assign_11({}, event._features, this._features);
    event._user = _$assign_11({}, event._user, this._user);
    event.breadcrumbs = this._breadcrumbs.slice(); // exit early if events should not be sent on the current releaseStage

    if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
      this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');

      return cb(null, event);
    }

    var originalSeverity = event.severity;

    var onCallbackError = function (err) {
      // errors in callbacks are tolerated but we want to log them out
      _this2._logger.error('Error occurred in onError callback, continuing anyway…');

      _this2._logger.error(err);
    };

    var callbacks = [].concat(this._cbs.e).concat(onError);
    _$callbackRunner_9(callbacks, event, onCallbackError, function (err, shouldSend) {
      if (err) onCallbackError(err);

      if (!shouldSend) {
        _this2._logger.debug('Event not sent due to onError callback');

        return cb(null, event);
      }

      if (_this2._isBreadcrumbTypeEnabled('error')) {
        // only leave a crumb for the error if actually got sent
        Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
          errorClass: event.errors[0].errorClass,
          errorMessage: event.errors[0].errorMessage,
          severity: event.severity
        }, 'error');
      }

      if (originalSeverity !== event.severity) {
        event._handledState.severityReason = {
          type: 'userCallbackSetSeverity'
        };
      }

      if (event.unhandled !== event._handledState.unhandled) {
        event._handledState.severityReason.unhandledOverridden = true;
        event._handledState.unhandled = event.unhandled;
      }

      if (_this2._session) {
        _this2._session._track(event);

        event._session = _this2._session;
      }

      _this2._delivery.sendEvent({
        apiKey: event.apiKey || _this2._config.apiKey,
        notifier: _this2._notifier,
        events: [event]
      }, function (err) {
        return cb(err, event);
      });
    });
  };

  return Client;
}();

var generateConfigErrorMessage = function (errors, rawInput) {
  var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function (key) {
    return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
  }).join('\n\n'));
  return er;
};

var stringify = function (val) {
  switch (typeof val) {
    case 'string':
    case 'number':
    case 'object':
      return JSON.stringify(val);

    default:
      return String(val);
  }
};

var _$Client_4 = Client;

var _$jsonPayload_21 = {};
/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;

var EVENT_REDACTION_PATHS = ['events.[].metaData', 'events.[].breadcrumbs.[].metaData', 'events.[].request'];

_$jsonPayload_21.event = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null, {
    redactedPaths: EVENT_REDACTION_PATHS,
    redactedKeys: redactedKeys
  });

  if (payload.length > 10e5) {
    event.events[0]._metadata = {
      notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
    };
    payload = _$safeJsonStringify_30(event, null, null, {
      redactedPaths: EVENT_REDACTION_PATHS,
      redactedKeys: redactedKeys
    });
    if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
  }

  return payload;
};

_$jsonPayload_21.session = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null);
  if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
  return payload;
};

var _$delivery_36 = {};
/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;

_$delivery_36 = function (client, win) {
  if (win === void 0) {
    win = window;
  }

  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      var url = getApiUrl(client._config, 'notify', '4', win);
      var req = new win.XDomainRequest();

      req.onload = function () {
        cb(null);
      };

      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.event(event, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);

          cb(e);
        }
      }, 0);
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      var url = getApiUrl(client._config, 'sessions', '1', win);
      var req = new win.XDomainRequest();

      req.onload = function () {
        cb(null);
      };

      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);

          cb(e);
        }
      }, 0);
    }
  };
};

var getApiUrl = function (config, endpoint, version, win) {
  // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
  // to an ISO string when you use JSON stringify. Simply parsing the result of
  // JSON.stringify is smaller than using a toISOstring() polyfill.
  var isoDate = JSON.parse(JSON.stringify(new Date()));
  var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
  return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
};

var matchPageProtocol = _$delivery_36._matchPageProtocol = function (endpoint, pageProtocol) {
  return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
};

/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;

var _$delivery_37 = function (client, win) {
  if (win === void 0) {
    win = window;
  }

  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      try {
        var url = client._config.endpoints.notify;
        var req = new win.XMLHttpRequest();

        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
        };

        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '4');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.event(event, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }

      try {
        var url = client._config.endpoints.sessions;
        var req = new win.XMLHttpRequest();

        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
        };

        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '1');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    }
  };
};

var appStart = new Date();

var reset = function () {
  appStart = new Date();
};

var _$app_38 = {
  name: 'appDuration',
  load: function (client) {
    client.addOnError(function (event) {
      var now = new Date();
      event.app.duration = now - appStart;
    }, true);
    return {
      reset: reset
    };
  }
};

/*
 * Sets the default context to be the current URL
 */
var _$context_39 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.context !== undefined) return;
        event.context = win.location.pathname;
      }, true);
    }
  };
};

var _$pad_43 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_43 = require('./pad.js'); */;

var __env_42 = typeof window === 'object' ? window : self;
var __globalCount_42 = 0;

for (var __prop_42 in __env_42) {
  if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
}

var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);

var _$fingerprint_42 = function fingerprint() {
  return __clientId_42;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_43 = require('./lib/pad.js'); */;

var __c_41 = 0,
    __blockSize_41 = 4,
    __base_41 = 36,
    __discreteValues_41 = Math.pow(__base_41, __blockSize_41);

function __randomBlock_41() {
  return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
}

function __safeCounter_41() {
  __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
  __c_41++; // this is not subliminal

  return __c_41 - 1;
}

function __cuid_41() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(__base_41),
      // Prevent same-machine collisions.
  counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_42(),
      // Grab some more chars from Math.random()
  random = __randomBlock_41() + __randomBlock_41();
  return letter + timestamp + counter + print + random;
}

__cuid_41.fingerprint = _$fingerprint_42;
var _$cuid_41 = __cuid_41;

/* removed: var _$cuid_41 = require('@bugsnag/cuid'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';

var getDeviceId = function () {
  try {
    var storage = window.localStorage;
    var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY); // If we get an ID, make sure it looks like a valid cuid. The length can
    // fluctuate slightly, so some leeway is built in

    if (id && /^c[a-z0-9]{20,32}$/.test(id)) {
      return id;
    }

    id = _$cuid_41();
    storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
    return id;
  } catch (err) {// If localStorage is not available (e.g. because it's disabled) then give up
  }
};
/*
 * Automatically detects browser device details
 */


var _$device_40 = function (nav, screen) {
  if (nav === void 0) {
    nav = navigator;
  }

  if (screen === void 0) {
    screen = window.screen;
  }

  return {
    load: function (client) {
      var device = {
        locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
        userAgent: nav.userAgent
      };

      if (screen && screen.orientation && screen.orientation.type) {
        device.orientation = screen.orientation.type;
      } else {
        device.orientation = document.documentElement.clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';
      }

      if (client._config.generateAnonymousId) {
        device.id = getDeviceId();
      }

      client.addOnSession(function (session) {
        session.device = _$assign_11({}, session.device, device); // only set device id if collectUserIp is false

        if (!client._config.collectUserIp) setDefaultUserId(session);
      }); // add time just as the event is sent

      client.addOnError(function (event) {
        event.device = _$assign_11({}, event.device, device, {
          time: new Date()
        });
        if (!client._config.collectUserIp) setDefaultUserId(event);
      }, true);
    },
    configSchema: {
      generateAnonymousId: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};

var setDefaultUserId = function (eventOrSession) {
  // device id is also used to populate the user id field, if it's not already set
  var user = eventOrSession.getUser();

  if (!user || !user.id) {
    eventOrSession.setUser(eventOrSession.device.id);
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
/*
 * Sets the event request: { url } to be the current href
 */


var _$request_44 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.request && event.request.url) return;
        event.request = _$assign_11({}, event.request, {
          url: win.location.href
        });
      }, true);
    }
  };
};

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;

var _$session_45 = {
  load: function (client) {
    client._sessionDelegate = sessionDelegate;
  }
};
var sessionDelegate = {
  startSession: function (client, session) {
    var sessionClient = client;
    sessionClient._session = session;
    sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled

    if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
      sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');

      return sessionClient;
    }

    sessionClient._delivery.sendSession({
      notifier: sessionClient._notifier,
      device: session.device,
      app: session.app,
      sessions: [{
        id: session.id,
        startedAt: session.startedAt,
        user: session._user
      }]
    });

    return sessionClient;
  },
  resumeSession: function (client) {
    // Do nothing if there's already an active session
    if (client._session) {
      return client;
    } // If we have a paused session then make it the active session


    if (client._pausedSession) {
      client._session = client._pausedSession;
      client._pausedSession = null;
      return client;
    } // Otherwise start a new session


    return client.startSession();
  },
  pauseSession: function (client) {
    client._pausedSession = client._session;
    client._session = null;
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
/*
 * Prevent collection of user IPs
 */


var _$clientIp_46 = {
  load: function (client) {
    if (client._config.collectUserIp) return;
    client.addOnError(function (event) {
      // If user.id is explicitly undefined, it will be missing from the payload. It needs
      // removing so that the following line replaces it
      if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
      event._user = _$assign_11({
        id: '[REDACTED]'
      }, event._user);
      event.request = _$assign_11({
        clientIp: '[REDACTED]'
      }, event.request);
    });
  },
  configSchema: {
    collectUserIp: {
      defaultValue: function () {
        return true;
      },
      message: 'should be true|false',
      validate: function (value) {
        return value === true || value === false;
      }
    }
  }
};

var _$consoleBreadcrumbs_47 = {};
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;
/*
 * Leaves breadcrumbs when console log methods are called
 */


_$consoleBreadcrumbs_47.load = function (client) {
  var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
  if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
  _$map_16(CONSOLE_LOG_METHODS, function (method) {
    var original = console[method];

    console[method] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      client.leaveBreadcrumb('Console output', _$reduce_17(args, function (accum, arg, i) {
        // do the best/simplest stringification of each argument
        var stringified = '[Unknown value]'; // this may fail if the input is:
        // - an object whose [[Prototype]] is null (no toString)
        // - an object with a broken toString or @@toPrimitive implementation

        try {
          stringified = String(arg);
        } catch (e) {} // if it stringifies to [object Object] attempt to JSON stringify


        if (stringified === '[object Object]') {
          // catch stringify errors and fallback to [object Object]
          try {
            stringified = JSON.stringify(arg);
          } catch (e) {}
        }

        accum["[" + i + "]"] = stringified;
        return accum;
      }, {
        severity: method.indexOf('group') === 0 ? 'log' : method
      }), 'log');
      original.apply(console, args);
    };

    console[method]._restore = function () {
      console[method] = original;
    };
  });
};

if (false) {
  _$consoleBreadcrumbs_47.destroy = function () {
    return CONSOLE_LOG_METHODS.forEach(function (method) {
      if (typeof console[method]._restore === 'function') console[method]._restore();
    });
  };
}

var CONSOLE_LOG_METHODS = _$filter_12(['log', 'debug', 'info', 'warn', 'error'], function (method) {
  return typeof console !== 'undefined' && typeof console[method] === 'function';
});

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;

var MAX_LINE_LENGTH = 200;
var MAX_SCRIPT_LENGTH = 500000;

var _$inlineScriptContent_48 = function (doc, win) {
  if (doc === void 0) {
    doc = document;
  }

  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!client._config.trackInlineScripts) return;
      var originalLocation = win.location.href;
      var html = ''; // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
      // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing

      var isOldIe = !!doc.attachEvent;
      var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';

      var getHtml = function () {
        return doc.documentElement.outerHTML;
      }; // get whatever HTML exists at this point in time


      html = getHtml();
      var prev = doc.onreadystatechange; // then update it when the DOM content has loaded

      doc.onreadystatechange = function () {
        // IE8 compatible alternative to document#DOMContentLoaded
        if (doc.readyState === 'interactive') {
          html = getHtml();
          DOMContentLoaded = true;
        }

        try {
          prev.apply(this, arguments);
        } catch (e) {}
      };

      var _lastScript = null;

      var updateLastScript = function (script) {
        _lastScript = script;
      };

      var getCurrentScript = function () {
        var script = doc.currentScript || _lastScript;

        if (!script && !DOMContentLoaded) {
          var scripts = doc.scripts || doc.getElementsByTagName('script');
          script = scripts[scripts.length - 1];
        }

        return script;
      };

      var addSurroundingCode = function (lineNumber) {
        // get whatever html has rendered at this point
        if (!DOMContentLoaded || !html) html = getHtml(); // simulate the raw html

        var htmlLines = ['<!-- DOC START -->'].concat(html.split('\n'));
        var zeroBasedLine = lineNumber - 1;
        var start = Math.max(zeroBasedLine - 3, 0);
        var end = Math.min(zeroBasedLine + 3, htmlLines.length);
        return _$reduce_17(htmlLines.slice(start, end), function (accum, line, i) {
          accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
          return accum;
        }, {});
      };

      client.addOnError(function (event) {
        // remove any of our own frames that may be part the stack this
        // happens before the inline script check as it happens for all errors
        event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function (f) {
          return !/__trace__$/.test(f.method);
        });
        var frame = event.errors[0].stacktrace[0]; // if frame.file exists and is not the original location of the page, this can't be an inline script

        if (frame && frame.file && frame.file.replace(/#.*$/, '') !== originalLocation.replace(/#.*$/, '')) return; // grab the last script known to have run

        var currentScript = getCurrentScript();

        if (currentScript) {
          var content = currentScript.innerHTML;
          event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH)); // only attempt to grab some surrounding code if we have a line number

          if (frame && frame.lineNumber) {
            frame.code = addSurroundingCode(frame.lineNumber);
          }
        }
      }, true); // Proxy all the timer functions whose callback is their 0th argument.
      // Keep a reference to the original setTimeout because we need it later

      var _map = _$map_16(['setTimeout', 'setInterval', 'setImmediate', 'requestAnimationFrame'], function (fn) {
        return __proxy(win, fn, function (original) {
          return __traceOriginalScript(original, function (args) {
            return {
              get: function () {
                return args[0];
              },
              replace: function (fn) {
                args[0] = fn;
              }
            };
          });
        });
      }),
          _setTimeout = _map[0]; // Proxy all the host objects whose prototypes have an addEventListener function


      _$map_16(['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'], function (o) {
        if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;

        __proxy(win[o].prototype, 'addEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor);
        });

        __proxy(win[o].prototype, 'removeEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
        });
      });

      function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
        if (alsoCallOriginal === void 0) {
          alsoCallOriginal = false;
        }

        return function () {
          // this is required for removeEventListener to remove anything added with
          // addEventListener before the functions started being wrapped by Bugsnag
          var args = [].slice.call(arguments);

          try {
            var cba = callbackAccessor(args);
            var cb = cba.get();
            if (alsoCallOriginal) fn.apply(this, args);
            if (typeof cb !== 'function') return fn.apply(this, args);

            if (cb.__trace__) {
              cba.replace(cb.__trace__);
            } else {
              var script = getCurrentScript(); // this function mustn't be annonymous due to a bug in the stack
              // generation logic, meaning it gets tripped up
              // see: https://github.com/stacktracejs/stack-generator/issues/6

              cb.__trace__ = function __trace__() {
                // set the script that called this function
                updateLastScript(script); // immediately unset the currentScript synchronously below, however
                // if this cb throws an error the line after will not get run so schedule
                // an almost-immediate aysnc update too

                _setTimeout(function () {
                  updateLastScript(null);
                }, 0);

                var ret = cb.apply(this, arguments);
                updateLastScript(null);
                return ret;
              };

              cb.__trace__.__trace__ = cb.__trace__;
              cba.replace(cb.__trace__);
            }
          } catch (e) {// swallow these errors on Selenium:
            // Permission denied to access property '__trace__'
            // WebDriverException: Message: Permission denied to access property "handleEvent"
          } // IE8 doesn't let you call .apply() on setTimeout/setInterval


          if (fn.apply) return fn.apply(this, args);

          switch (args.length) {
            case 1:
              return fn(args[0]);

            case 2:
              return fn(args[0], args[1]);

            default:
              return fn();
          }
        };
      }
    },
    configSchema: {
      trackInlineScripts: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};

function __proxy(host, name, replacer) {
  var original = host[name];
  if (!original) return original;
  var replacement = replacer(original);
  host[name] = replacement;
  return original;
}

function eventTargetCallbackAccessor(args) {
  var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
  return {
    get: function () {
      return isEventHandlerObj ? args[1].handleEvent : args[1];
    },
    replace: function (fn) {
      if (isEventHandlerObj) {
        args[1].handleEvent = fn;
      } else {
        args[1] = fn;
      }
    }
  };
}

/*
 * Leaves breadcrumbs when the user interacts with the DOM
 */
var _$interactionBreadcrumbs_49 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._isBreadcrumbTypeEnabled('user')) return;
      win.addEventListener('click', function (event) {
        var targetText, targetSelector;

        try {
          targetText = getNodeText(event.target);
          targetSelector = getNodeSelector(event.target, win);
        } catch (e) {
          targetText = '[hidden]';
          targetSelector = '[hidden]';

          client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
        }

        client.leaveBreadcrumb('UI click', {
          targetText: targetText,
          targetSelector: targetSelector
        }, 'user');
      }, true);
    }
  };
}; // extract text content from a element


var getNodeText = function (el) {
  var text = el.textContent || el.innerText || '';
  if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
  text = text.replace(/^\s+|\s+$/g, ''); // trim whitespace

  return truncate(text, 140);
}; // Create a label from tagname, id and css class of the element


function getNodeSelector(el, win) {
  var parts = [el.tagName];
  if (el.id) parts.push('#' + el.id);
  if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.')); // Can't get much more advanced with the current browser

  if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');

  try {
    if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
  } catch (e) {
    // Sometimes the query selector can be invalid just return it as-is
    return parts.join('');
  } // try to get a more specific selector if this one matches more than one element


  if (el.parentNode.childNodes.length > 1) {
    var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
    parts.push(":nth-child(" + index + ")");
  }

  if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join(''); // try prepending the parent node selector

  if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
  return parts.join('');
}

function truncate(value, length) {
  var ommision = '(...)';
  if (value && value.length <= length) return value;
  return value.slice(0, length - ommision.length) + ommision;
}

var _$navigationBreadcrumbs_50 = {};
/*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/
_$navigationBreadcrumbs_50 = function (win) {
  if (win === void 0) {
    win = window;
  }

  var plugin = {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._isBreadcrumbTypeEnabled('navigation')) return; // returns a function that will drop a breadcrumb with a given name

      var drop = function (name) {
        return function () {
          return client.leaveBreadcrumb(name, {}, 'navigation');
        };
      }; // simple drops – just names, no meta


      win.addEventListener('pagehide', drop('Page hidden'), true);
      win.addEventListener('pageshow', drop('Page shown'), true);
      win.addEventListener('load', drop('Page loaded'), true);
      win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true); // some browsers like to emit popstate when the page loads, so only add the popstate listener after that

      win.addEventListener('load', function () {
        return win.addEventListener('popstate', drop('Navigated back'), true);
      }); // hashchange has some metadata that we care about

      win.addEventListener('hashchange', function (event) {
        var metadata = event.oldURL ? {
          from: relativeLocation(event.oldURL, win),
          to: relativeLocation(event.newURL, win),
          state: getCurrentState(win)
        } : {
          to: relativeLocation(win.location.href, win)
        };
        client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
      }, true); // the only way to know about replaceState/pushState is to wrap them… >_<

      if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
      if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
    }
  };

  if (false) {
    plugin.destroy = function (win) {
      if (win === void 0) {
        win = window;
      }

      win.history.replaceState._restore();

      win.history.pushState._restore();
    };
  }

  return plugin;
};

if (false) {
  _$navigationBreadcrumbs_50.destroy = function (win) {
    if (win === void 0) {
      win = window;
    }

    win.history.replaceState._restore();

    win.history.pushState._restore();
  };
} // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
// just the path and hash parts, e.g. /pages/01.html?yes=no#section-2


var relativeLocation = function (url, win) {
  var a = win.document.createElement('A');
  a.href = url;
  return "" + a.pathname + a.search + a.hash;
};

var stateChangeToMetadata = function (win, state, title, url) {
  var currentPath = relativeLocation(win.location.href, win);
  return {
    title: title,
    state: state,
    prevState: getCurrentState(win),
    to: url || currentPath,
    from: currentPath
  };
};

var wrapHistoryFn = function (client, target, fn, win) {
  var orig = target[fn];

  target[fn] = function (state, title, url) {
    client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation'); // if throttle plugin is in use, reset the event sent count

    if (typeof client.resetEventCount === 'function') client.resetEventCount(); // if the client is operating in auto session-mode, a new route should trigger a new session

    if (client._config.autoTrackSessions) client.startSession(); // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
    // to '/undefined'. therefore we only pass the url if it's not undefined.

    orig.apply(target, [state, title].concat(url !== undefined ? url : []));
  };

  if (false) {
    target[fn]._restore = function () {
      target[fn] = orig;
    };
  }
};

var getCurrentState = function (win) {
  try {
    return win.history.state;
  } catch (e) {}
};

var BREADCRUMB_TYPE = 'request'; // keys to safely store metadata on the request object

var REQUEST_SETUP_KEY = 'BS~~S';
var REQUEST_URL_KEY = 'BS~~U';
var REQUEST_METHOD_KEY = 'BS~~M';

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
/*
 * Leaves breadcrumbs when network requests occur
 */


var _$networkBreadcrumbs_51 = function (_ignoredUrls, win) {
  if (_ignoredUrls === void 0) {
    _ignoredUrls = [];
  }

  if (win === void 0) {
    win = window;
  }

  var restoreFunctions = [];
  var plugin = {
    load: function (client) {
      if (!client._isBreadcrumbTypeEnabled('request')) return;
      var ignoredUrls = [client._config.endpoints.notify, client._config.endpoints.sessions].concat(_ignoredUrls);
      monkeyPatchXMLHttpRequest();
      monkeyPatchFetch(); // XMLHttpRequest monkey patch

      function monkeyPatchXMLHttpRequest() {
        if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
        var nativeOpen = win.XMLHttpRequest.prototype.open; // override native open()

        win.XMLHttpRequest.prototype.open = function open(method, url) {
          // store url and HTTP method for later
          this[REQUEST_URL_KEY] = url;
          this[REQUEST_METHOD_KEY] = method; // if we have already setup listeners, it means open() was called twice, we need to remove
          // the listeners and recreate them

          if (this[REQUEST_SETUP_KEY]) {
            this.removeEventListener('load', handleXHRLoad);
            this.removeEventListener('error', handleXHRError);
          } // attach load event listener


          this.addEventListener('load', handleXHRLoad); // attach error event listener

          this.addEventListener('error', handleXHRError);
          this[REQUEST_SETUP_KEY] = true;
          nativeOpen.apply(this, arguments);
        };

        if (false) {
          restoreFunctions.push(function () {
            win.XMLHttpRequest.prototype.open = nativeOpen;
          });
        }
      }

      function handleXHRLoad() {
        var url = this[REQUEST_URL_KEY];

        if (url === undefined) {
          client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');

          return;
        } // an XMLHttpRequest's URL can be an object as long as its 'toString'
        // returns a URL, e.g. a HTMLAnchorElement


        if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        }

        var metadata = {
          status: this.status,
          request: this[REQUEST_METHOD_KEY] + " " + this[REQUEST_URL_KEY]
        };

        if (this.status >= 400) {
          // contacted server but got an error response
          client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
        }
      }

      function handleXHRError() {
        var url = this[REQUEST_URL_KEY];

        if (url === undefined) {
          client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');

          return;
        }

        if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        } // failed to contact server


        client.leaveBreadcrumb('XMLHttpRequest error', {
          request: this[REQUEST_METHOD_KEY] + " " + this[REQUEST_URL_KEY]
        }, BREADCRUMB_TYPE);
      } // window.fetch monkey patch


      function monkeyPatchFetch() {
        // only patch it if it exists and if it is not a polyfill (patching a polyfilled
        // fetch() results in duplicate breadcrumbs for the same request because the
        // implementation uses XMLHttpRequest which is also patched)
        if (!('fetch' in win) || win.fetch.polyfill) return;
        var oldFetch = win.fetch;

        win.fetch = function fetch() {
          var _arguments = arguments;
          var urlOrRequest = arguments[0];
          var options = arguments[1];
          var method;
          var url = null;

          if (urlOrRequest && typeof urlOrRequest === 'object') {
            url = urlOrRequest.url;

            if (options && 'method' in options) {
              method = options.method;
            } else if (urlOrRequest && 'method' in urlOrRequest) {
              method = urlOrRequest.method;
            }
          } else {
            url = urlOrRequest;

            if (options && 'method' in options) {
              method = options.method;
            }
          }

          if (method === undefined) {
            method = 'GET';
          }

          return new Promise(function (resolve, reject) {
            // pass through to native fetch
            oldFetch.apply(void 0, _arguments).then(function (response) {
              handleFetchSuccess(response, method, url);
              resolve(response);
            })["catch"](function (error) {
              handleFetchError(method, url);
              reject(error);
            });
          });
        };

        if (false) {
          restoreFunctions.push(function () {
            win.fetch = oldFetch;
          });
        }
      }

      var handleFetchSuccess = function (response, method, url) {
        var metadata = {
          status: response.status,
          request: method + " " + url
        };

        if (response.status >= 400) {
          // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
          client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
        }
      };

      var handleFetchError = function (method, url) {
        client.leaveBreadcrumb('fetch() error', {
          request: method + " " + url
        }, BREADCRUMB_TYPE);
      };
    }
  };

  if (false) {
    plugin.destroy = function () {
      restoreFunctions.forEach(function (fn) {
        return fn();
      });
      restoreFunctions = [];
    };
  }

  return plugin;
};

/* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */;
/*
 * Throttles and dedupes events
 */


var _$throttle_52 = {
  load: function (client) {
    // track sent events for each init of the plugin
    var n = 0; // add onError hook

    client.addOnError(function (event) {
      // have max events been sent already?
      if (n >= client._config.maxEvents) return false;
      n++;
    });

    client.resetEventCount = function () {
      n = 0;
    };
  },
  configSchema: {
    maxEvents: {
      defaultValue: function () {
        return 10;
      },
      message: 'should be a positive integer ≤100',
      validate: function (val) {
        return _$intRange_24(1, 100)(val);
      }
    }
  }
};

var _$stripQueryString_53 = {};
/*
 * Remove query strings (and fragments) from stacktraces
 */
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;

_$stripQueryString_53 = {
  load: function (client) {
    client.addOnError(function (event) {
      var allFrames = _$reduce_17(event.errors, function (accum, er) {
        return accum.concat(er.stacktrace);
      }, []);
      _$map_16(allFrames, function (frame) {
        frame.file = strip(frame.file);
      });
    });
  }
};

var strip = _$stripQueryString_53._strip = function (str) {
  return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
};

/*
 * Automatically notifies Bugsnag when window.onerror is called
 */
var _$onerror_54 = function (win) {
  if (win === void 0) {
    win = window;
  }

  return {
    load: function (client) {
      if (!client._config.autoDetectErrors) return;
      if (!client._config.enabledErrorTypes.unhandledExceptions) return;

      function onerror(messageOrEvent, url, lineNo, charNo, error) {
        // Ignore errors with no info due to CORS settings
        if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) {
          client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
        } else {
          // any error sent to window.onerror is unhandled and has severity=error
          var handledState = {
            severity: 'error',
            unhandled: true,
            severityReason: {
              type: 'unhandledException'
            }
          };
          var event; // window.onerror can be called in a number of ways. This big if-else is how we
          // figure out which arguments were supplied, and what kind of values it received.

          if (error) {
            // if the last parameter (error) was supplied, this is a modern browser's
            // way of saying "this value was thrown and not caught"
            event = client.Event.create(error, true, handledState, 'window onerror', 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          } else if ( // This complex case detects "error" events that are typically synthesised
          // by jquery's trigger method (although can be created in other ways). In
          // order to detect this:
          // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
          // - the second argument (url) must either not exist or be something other than a string (if it
          //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
          //    function)
          // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
          typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
            // The jQuery event may have a "type" property, if so use it as part of the error message
            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error'; // attempt to find a message from one of the conventional properties, but
            // default to empty string (the event will fill it with a placeholder)

            var message = messageOrEvent.message || messageOrEvent.detail || '';
            event = client.Event.create({
              name: name,
              message: message
            }, true, handledState, 'window onerror', 1); // provide the original thing onerror received – not our error-like object we passed to _notify

            event.originalError = messageOrEvent; // include the raw input as metadata – it might contain more info than we extracted

            event.addMetadata('window onerror', {
              event: messageOrEvent,
              extraParameters: url
            });
          } else {
            // Lastly, if there was no "error" parameter this event was probably from an old
            // browser that doesn't support that. Instead we need to generate a stacktrace.
            event = client.Event.create(messageOrEvent, true, handledState, 'window onerror', 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          }

          client._notify(event);
        }

        if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
      }

      var prevOnError = win.onerror;
      win.onerror = onerror;
    }
  };
}; // Sometimes the stacktrace has less information than was passed to window.onerror.
// This function will augment the first stackframe with any useful info that was
// received as arguments to the onerror callback.


var decorateStack = function (stack, url, lineNo, charNo) {
  if (!stack[0]) stack.push({});
  var culprit = stack[0];
  if (!culprit.file && typeof url === 'string') culprit.file = url;
  if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;

  if (!culprit.columnNumber) {
    if (isActualNumber(charNo)) {
      culprit.columnNumber = charNo;
    } else if (window.event && isActualNumber(window.event.errorCharacter)) {
      culprit.columnNumber = window.event.errorCharacter;
    }
  }
};

var isActualNumber = function (n) {
  return typeof n === 'number' && String.call(n) !== 'NaN';
};

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$iserror_20 = require('@bugsnag/core/lib/iserror'); */;

var _listener;
/*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */


var _$unhandledRejection_55 = function (win) {
  if (win === void 0) {
    win = window;
  }

  var plugin = {
    load: function (client) {
      if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;

      var listener = function (evt) {
        var error = evt.reason;
        var isBluebird = false; // accessing properties on evt.detail can throw errors (see #394)

        try {
          if (evt.detail && evt.detail.reason) {
            error = evt.detail.reason;
            isBluebird = true;
          }
        } catch (e) {}

        var event = client.Event.create(error, false, {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledPromiseRejection'
          }
        }, 'unhandledrejection handler', 1, client._logger);

        if (isBluebird) {
          _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
        }

        client._notify(event, function (event) {
          if (_$iserror_20(event.originalError) && !event.originalError.stack) {
            var _event$addMetadata;

            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
              name: event.originalError.name,
              message: event.originalError.message,
              code: event.originalError.code
            }, _event$addMetadata));
          }
        });
      };

      if ('addEventListener' in win) {
        win.addEventListener('unhandledrejection', listener);
      } else {
        win.onunhandledrejection = function (reason, promise) {
          listener({
            detail: {
              reason: reason,
              promise: promise
            }
          });
        };
      }

      _listener = listener;
    }
  };

  if (false) {
    plugin.destroy = function (win) {
      if (win === void 0) {
        win = window;
      }

      if (_listener) {
        if ('addEventListener' in win) {
          win.removeEventListener('unhandledrejection', _listener);
        } else {
          win.onunhandledrejection = null;
        }
      }

      _listener = null;
    };
  }

  return plugin;
}; // The stack parser on bluebird stacks in FF get a suprious first frame:
//
// Error: derp
//   b@http://localhost:5000/bluebird.html:22:24
//   a@http://localhost:5000/bluebird.html:18:9
//   @http://localhost:5000/bluebird.html:14:9
//
// results in
//   […]
//     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
//     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
//     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
//     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
//
// so the following reduce/accumulator function removes such frames
//
// Bluebird pads method names with spaces so trim that too…
// https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571


var fixBluebirdStacktrace = function (error) {
  return function (frame) {
    if (frame.file === error.toString()) return;

    if (frame.method) {
      frame.method = frame.method.replace(/^\s+/, '');
    }
  };
};

var _$notifier_2 = {};
var name = 'Bugsnag JavaScript';
var version = '7.16.1';
var url = 'https://github.com/bugsnag/bugsnag-js';

/* removed: var _$Client_4 = require('@bugsnag/core/client'); */;

/* removed: var _$Event_6 = require('@bugsnag/core/event'); */;

/* removed: var _$Session_35 = require('@bugsnag/core/session'); */;

/* removed: var _$Breadcrumb_3 = require('@bugsnag/core/breadcrumb'); */;

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;

/* removed: var _$keys_15 = require('@bugsnag/core/lib/es-utils/keys'); */;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */; // extend the base config schema with some browser-specific options


var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1);

/* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */;

/* removed: var _$unhandledRejection_55 = require('@bugsnag/plugin-window-unhandled-rejection'); */;

/* removed: var _$app_38 = require('@bugsnag/plugin-app-duration'); */;

/* removed: var _$device_40 = require('@bugsnag/plugin-browser-device'); */;

/* removed: var _$context_39 = require('@bugsnag/plugin-browser-context'); */;

/* removed: var _$request_44 = require('@bugsnag/plugin-browser-request'); */;

/* removed: var _$throttle_52 = require('@bugsnag/plugin-simple-throttle'); */;

/* removed: var _$consoleBreadcrumbs_47 = require('@bugsnag/plugin-console-breadcrumbs'); */;

/* removed: var _$networkBreadcrumbs_51 = require('@bugsnag/plugin-network-breadcrumbs'); */;

/* removed: var _$navigationBreadcrumbs_50 = require('@bugsnag/plugin-navigation-breadcrumbs'); */;

/* removed: var _$interactionBreadcrumbs_49 = require('@bugsnag/plugin-interaction-breadcrumbs'); */;

/* removed: var _$inlineScriptContent_48 = require('@bugsnag/plugin-inline-script-content'); */;

/* removed: var _$session_45 = require('@bugsnag/plugin-browser-session'); */;

/* removed: var _$clientIp_46 = require('@bugsnag/plugin-client-ip'); */;

/* removed: var _$stripQueryString_53 = require('@bugsnag/plugin-strip-query-string'); */; // delivery mechanisms


/* removed: var _$delivery_36 = require('@bugsnag/delivery-x-domain-request'); */;

/* removed: var _$delivery_37 = require('@bugsnag/delivery-xml-http-request'); */;

var Bugsnag = {
  _client: null,
  createClient: function (opts) {
    // handle very simple use case where user supplies just the api key as a string
    if (typeof opts === 'string') opts = {
      apiKey: opts
    };
    if (!opts) opts = {};
    var internalPlugins = [// add browser-specific plugins
    _$app_38, _$device_40(), _$context_39(), _$request_44(), _$throttle_52, _$session_45, _$clientIp_46, _$stripQueryString_53, _$onerror_54(), _$unhandledRejection_55(), _$navigationBreadcrumbs_50(), _$interactionBreadcrumbs_49(), _$networkBreadcrumbs_51(), _$consoleBreadcrumbs_47, // this one added last to avoid wrapping functionality before bugsnag uses it
    _$inlineScriptContent_48()]; // configure a client with user supplied options

    var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
      name: name,
      version: version,
      url: url
    }); // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)

    bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);

    bugsnag._logger.debug('Loaded!');

    bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
    return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
  },
  start: function (opts) {
    if (Bugsnag._client) {
      Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');

      return Bugsnag._client;
    }

    Bugsnag._client = Bugsnag.createClient(opts);
    return Bugsnag._client;
  }
};
_$map_16(['resetEventCount'].concat(_$keys_15(_$Client_4.prototype)), function (m) {
  if (/^_/.test(m)) return;

  Bugsnag[m] = function () {
    if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
    Bugsnag._client._depth += 1;

    var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);

    Bugsnag._client._depth -= 1;
    return ret;
  };
});
_$notifier_2 = Bugsnag;
_$notifier_2.Client = _$Client_4;
_$notifier_2.Event = _$Event_6;
_$notifier_2.Session = _$Session_35;
_$notifier_2.Breadcrumb = _$Breadcrumb_3; // Export a "default" property for compatibility with ESM imports

_$notifier_2["default"] = Bugsnag;

return _$notifier_2;

});
//# sourceMappingURL=bugsnag.js.map


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.BugsnagPluginVue = f()}})(function(){var define,module,exports;
var _this = this,
    _ErrorTypeStrings;

var _$vue_2 = function (app, client) {
  var prev = app.config.errorHandler;

  var handler = function (err, vm, info) {
    var handledState = {
      severity: 'error',
      unhandled: true,
      severityReason: {
        type: 'unhandledException'
      }
    };
    var event = client.Event.create(err, true, handledState, 'vue error handler', 1);
    event.addMetadata('vue', {
      errorInfo: ErrorTypeStrings[info] || info,
      component: vm ? formatComponentName(vm, true) : undefined,
      props: vm && vm.$options ? vm.$options.propsData : undefined
    });

    client._notify(event);

    if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err);
    if (typeof prev === 'function') prev.call(_this, err, vm, info);
  };

  app.config.errorHandler = handler;
};

function formatComponentName(vm) {
  if (vm.$parent === null) return 'App';
  return vm.$options && vm.$options.name ? vm.$options.name : 'Anonymous';
} // We copy in the following data structures from Vue's source so we can map the "info" parameter in the errorhandler
// callback (which is supplied as either a string or int) back to something meaningful
// https://github.com/vuejs/vue-next/blob/d5cce47789db8f37b9f5f8ea6602ea63e3a04b07/packages/runtime-core/src/component.ts#L153-L167


var LifecycleHooks = {
  BEFORE_CREATE: 'bc',
  CREATED: 'c',
  BEFORE_MOUNT: 'bm',
  MOUNTED: 'm',
  BEFORE_UPDATE: 'bu',
  UPDATED: 'u',
  BEFORE_UNMOUNT: 'bum',
  UNMOUNTED: 'um',
  DEACTIVATED: 'da',
  ACTIVATED: 'a',
  RENDER_TRIGGERED: 'rtg',
  RENDER_TRACKED: 'rtc',
  ERROR_CAPTURED: 'ec'
}; // https://github.com/vuejs/vue-next/blob/d5cce47789db8f37b9f5f8ea6602ea63e3a04b07/packages/runtime-core/src/errorHandling.ts#L6-L24

var ErrorCodes = {
  SETUP_FUNCTION: 0,
  RENDER_FUNCTION: 1,
  WATCH_GETTER: 2,
  WATCH_CALLBACK: 3,
  WATCH_CLEANUP: 4,
  NATIVE_EVENT_HANDLER: 5,
  COMPONENT_EVENT_HANDLER: 6,
  VNODE_HOOK: 7,
  DIRECTIVE_HOOK: 8,
  TRANSITION_HOOK: 9,
  APP_ERROR_HANDLER: 10,
  APP_WARN_HANDLER: 11,
  FUNCTION_REF: 12,
  ASYNC_COMPONENT_LOADER: 13,
  SCHEDULER: 14
}; // https://github.com/vuejs/vue-next/blob/d5cce47789db8f37b9f5f8ea6602ea63e3a04b07/packages/runtime-core/src/errorHandling.ts#L26-L57

var ErrorTypeStrings = (_ErrorTypeStrings = {}, _ErrorTypeStrings[LifecycleHooks.BEFORE_CREATE] = 'beforeCreate hook', _ErrorTypeStrings[LifecycleHooks.CREATED] = 'created hook', _ErrorTypeStrings[LifecycleHooks.BEFORE_MOUNT] = 'beforeMount hook', _ErrorTypeStrings[LifecycleHooks.MOUNTED] = 'mounted hook', _ErrorTypeStrings[LifecycleHooks.BEFORE_UPDATE] = 'beforeUpdate hook', _ErrorTypeStrings[LifecycleHooks.UPDATED] = 'updated', _ErrorTypeStrings[LifecycleHooks.BEFORE_UNMOUNT] = 'beforeUnmount hook', _ErrorTypeStrings[LifecycleHooks.UNMOUNTED] = 'unmounted hook', _ErrorTypeStrings[LifecycleHooks.ACTIVATED] = 'activated hook', _ErrorTypeStrings[LifecycleHooks.DEACTIVATED] = 'deactivated hook', _ErrorTypeStrings[LifecycleHooks.ERROR_CAPTURED] = 'errorCaptured hook', _ErrorTypeStrings[LifecycleHooks.RENDER_TRACKED] = 'renderTracked hook', _ErrorTypeStrings[LifecycleHooks.RENDER_TRIGGERED] = 'renderTriggered hook', _ErrorTypeStrings[ErrorCodes.SETUP_FUNCTION] = 'setup function', _ErrorTypeStrings[ErrorCodes.RENDER_FUNCTION] = 'render function', _ErrorTypeStrings[ErrorCodes.WATCH_GETTER] = 'watcher getter', _ErrorTypeStrings[ErrorCodes.WATCH_CALLBACK] = 'watcher callback', _ErrorTypeStrings[ErrorCodes.WATCH_CLEANUP] = 'watcher cleanup function', _ErrorTypeStrings[ErrorCodes.NATIVE_EVENT_HANDLER] = 'native event handler', _ErrorTypeStrings[ErrorCodes.COMPONENT_EVENT_HANDLER] = 'component event handler', _ErrorTypeStrings[ErrorCodes.VNODE_HOOK] = 'vnode hook', _ErrorTypeStrings[ErrorCodes.DIRECTIVE_HOOK] = 'directive hook', _ErrorTypeStrings[ErrorCodes.TRANSITION_HOOK] = 'transition hook', _ErrorTypeStrings[ErrorCodes.APP_ERROR_HANDLER] = 'app errorHandler', _ErrorTypeStrings[ErrorCodes.APP_WARN_HANDLER] = 'app warnHandler', _ErrorTypeStrings[ErrorCodes.FUNCTION_REF] = 'ref function', _ErrorTypeStrings[ErrorCodes.ASYNC_COMPONENT_LOADER] = 'async component loader', _ErrorTypeStrings[ErrorCodes.SCHEDULER] = 'scheduler flush. This is likely a Vue internals bug. ' + 'Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/vue-next', _ErrorTypeStrings);

var _$vue2_3 = {};
var ___this_3 = this;

_$vue2_3 = function (Vue, client) {
  var prev = Vue.config.errorHandler;

  var handler = function (err, vm, info) {
    var handledState = {
      severity: 'error',
      unhandled: true,
      severityReason: {
        type: 'unhandledException'
      }
    };
    var event = client.Event.create(err, true, handledState, 'vue error handler', 1);
    event.addMetadata('vue', {
      errorInfo: info,
      component: vm ? __formatComponentName_3(vm, true) : undefined,
      props: vm ? vm.$options.propsData : undefined
    });

    client._notify(event);

    if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(err);
    if (typeof prev === 'function') prev.call(___this_3, err, vm, info);
  };

  Vue.config.errorHandler = handler;
}; // taken and reworked from Vue.js source


var __formatComponentName_3 = function (vm, includeFile) {
  if (vm.$root === vm) return '<Root>';
  var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
  var name = options.name || options._componentTag;
  var file = options.__file;

  if (!name && file) {
    var match = file.match(/([^/\\]+)\.vue$/);
    name = match && match[1];
  }

  return (name ? '<' + classify(name) + '>' : '<Anonymous>') + (file && includeFile !== false ? ' at ' + file : '');
}; // taken and reworked from Vue.js source


var classify = _$vue2_3.classify = function (str) {
  return str.replace(/(?:^|[-_])(\w)/g, function (c) {
    return c.toUpperCase();
  }).replace(/[-_]/g, '');
};

var _$src_1 = {};
/* removed: var _$vue2_3 = require('./vue2'); */;

/* removed: var _$vue_2 = require('./vue'); */;

_$src_1 = /*#__PURE__*/function () {
  function BugsnagPluginVue() {
    // Fetch Vue from the window object, if it exists
    var globalVue = typeof window !== 'undefined' && window.Vue;
    this.name = 'vue';
    this.lazy = arguments.length === 0 && !globalVue;

    if (!this.lazy) {
      this.Vue = (arguments.length <= 0 ? undefined : arguments[0]) || globalVue;
      if (!this.Vue) throw new Error('@bugsnag/plugin-vue reference to `Vue` was undefined');
    }
  }

  var _proto = BugsnagPluginVue.prototype;

  _proto.load = function load(client) {
    if (this.Vue) {
      _$vue2_3(this.Vue, client);
      return {
        installVueErrorHandler: function () {
          return client._logger.warn('installVueErrorHandler() was called unnecessarily');
        }
      };
    }

    return {
      install: function (app) {
        if (!app) client._logger.error(new Error('@bugsnag/plugin-vue reference to Vue `app` was undefined'));
        _$vue_2(app, client);
      },
      installVueErrorHandler: function (Vue) {
        if (!Vue) client._logger.error(new Error('@bugsnag/plugin-vue reference to `Vue` was undefined'));
        _$vue2_3(Vue, client);
      }
    };
  };

  return BugsnagPluginVue;
}(); // add a default export for ESM modules without interop


_$src_1["default"] = _$src_1;

return _$src_1;

});
//# sourceMappingURL=bugsnag-vue.js.map


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fdc8072_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGroupRowLayout_vue__ = __webpack_require__(881);
function injectStyle (ssrContext) {
  __webpack_require__(839)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fdc8072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGroupRowLayout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fdc8072_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGroupRowLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(840);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f2b58f1a", content, true, {});

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".header-section[data-v-1fdc8072]{margin-bottom:0}.form-type-label[data-v-1fdc8072]{padding-top:.375rem}.list-item[data-v-1fdc8072]{color:var(--coredarkcolor)}.list-textbox-container[data-v-1fdc8072]{width:100%}.color-picker-container[data-v-1fdc8072]{display:flex;align-items:center;margin-top:15px}.color-picker-label>label[data-v-1fdc8072]{margin-top:0;margin-bottom:0}.color-picker-label[data-v-1fdc8072]{flex-basis:33em}.col-lg-2[data-v-1fdc8072]:empty,.col-lg-3[data-v-1fdc8072]:empty,.col-lg-4[data-v-1fdc8072]:empty,.col-lg-6[data-v-1fdc8072]:empty,.col-lg-12[data-v-1fdc8072]:empty,.col-lg[data-v-1fdc8072]:empty,.col[data-v-1fdc8072]:empty{display:none}.builder-setting-header-slot[data-v-1fdc8072]{position:absolute;right:15px;top:0;z-index:1}", ""]);

// exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(842);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("064e9e99", content, true, {});

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".description[data-v-14976853]{font-size:80%;font-weight:400}.space-top[data-v-14976853]{margin-top:1em}.tab-label label.display-flex[data-v-14976853]{margin-top:0!important}.tab-label[data-v-14976853]{margin-bottom:0!important}.speech-input[data-v-14976853]{position:absolute;right:0;bottom:0}.input-text[data-v-14976853]{padding-right:1.3em}", ""]);

// exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(844);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9505e358", content, true, {});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".mic-icon[data-v-e90138ac]{cursor:pointer}.mic-recording[data-v-e90138ac]{color:red}", ""]);

// exports


/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmbed)?_c('div',[_c('i',{staticClass:"material-icons mic-icon",class:_vm.isRecording ? 'mic-recording' : '',on:{"click":function($event){return _vm.startSpeechToText()}}},[_vm._v("mic")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{class:'display-flex' + (_vm.labelSpaceBottom ? ' mb-0' : '')},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"position-relative input-container"},[((_vm.type === 'password' ? 'password' : 'text')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:"input",staticClass:"form-control input-text",class:!_vm.label && _vm.hasSpaceTop ? 'space-top' : '',attrs:{"spellcheck":"true","maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"disabled":_vm.isDisabled,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.inputVal)?_vm._i(_vm.inputVal,null)>-1:(_vm.inputVal)},on:{"input":function($event){return _vm.handleOnInput()},"blur":function($event){return _vm.handleBlurField()},"change":function($event){var $$a=_vm.inputVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inputVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inputVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inputVal=$$c}}}}):((_vm.type === 'password' ? 'password' : 'text')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:"input",staticClass:"form-control input-text",class:!_vm.label && _vm.hasSpaceTop ? 'space-top' : '',attrs:{"spellcheck":"true","maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"disabled":_vm.isDisabled,"type":"radio"},domProps:{"checked":_vm._q(_vm.inputVal,null)},on:{"input":function($event){return _vm.handleOnInput()},"blur":function($event){return _vm.handleBlurField()},"change":function($event){_vm.inputVal=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:"input",staticClass:"form-control input-text",class:!_vm.label && _vm.hasSpaceTop ? 'space-top' : '',attrs:{"spellcheck":"true","maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"disabled":_vm.isDisabled,"type":_vm.type === 'password' ? 'password' : 'text'},domProps:{"value":(_vm.inputVal)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputVal=$event.target.value},function($event){return _vm.handleOnInput()}],"blur":function($event){return _vm.handleBlurField()}}}),_vm._v(" "),_c('SpeechInput',{staticClass:"speech-input",attrs:{"field":_vm.builderField},on:{"input":function($event){return _vm.handleSpeechInput($event)}}})],1),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e(),_vm._v(" "),((_vm.submitClicked || _vm.isBlur) && _vm.validationErrorMessage)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.validationErrorMessage)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isInvalidPhone)?_c('p',{staticClass:"required-message"},[_vm._v("\n    Please enter a valid phone number.\n  ")]):_vm._e(),_vm._v(" "),(_vm.listDisplayButtons && _vm.listDisplayButtons.length)?_c('div',{staticClass:"button-group mt-2"},_vm._l((_vm.listDisplayButtons),function(button){return _c('button',{key:'button-' + button.id,staticClass:"btn btn-secondary mr-1",on:{"click":function($event){return _vm.handleClickButton(button)}}},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys(button.keyLangLabel))+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6ad524c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAreaWithLabel_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6ad524c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextAreaWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6ad524c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextAreaWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(849);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e2575f38", content, true, {});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".speech-input[data-v-e6ad524c]{position:absolute;right:0;bottom:.3em}", ""]);

// exports


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"display-flex"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e(),_vm._v(" "),_vm._t("inside-label")],2):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"position-relative input-container"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],staticClass:"form-control",attrs:{"rows":_vm.rows,"spellcheck":"true","maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"disabled":_vm.isDisabled},domProps:{"value":(_vm.inputVal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputVal=$event.target.value}}}),_vm._v(" "),_c('SpeechInput',{staticClass:"speech-input",attrs:{"field":_vm.builderField},on:{"input":function($event){return _vm.handleSpeechInput($event)}}})],1),_vm._v(" "),(_vm.isCounter && _vm.inputVal && _vm.inputVal.length)?_c('small',{staticClass:"float-right mr-2"},[_vm._v("\n    "+_vm._s(_vm.inputVal.length)+"\n    "),(_vm.inputVal.length == 1)?_c('span',[_vm._v(" character ")]):_c('span',[_vm._v(" characters ")])]):_vm._e(),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('DatePicker',{staticClass:"date-picker form-control registration-date",attrs:{"disabled":_vm.isDisabled,"format":_vm.datePickerFormat,"placeholder":_vm.datePickerPlaceholder,"default-panel":_vm.initialView,"disabled-date":_vm.disableDates,"append-to-body":true,"lang":_vm.lang},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(_vm.isShowAge && _vm.inputVal)?_c('div',[_vm._v("\n    (Age: "+_vm._s(_vm.calculateAgeInMonthsAndYears(_vm.inputVal))+")\n  ")]):_vm._e(),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearPickerWithLabel_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearPickerWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearPickerWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearPickerWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearPickerWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f29e9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearPickerWithLabel_vue__ = __webpack_require__(853);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearPickerWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f29e9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearPickerWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('DatePicker',{staticClass:"date-picker form-control registration-date",attrs:{"disabled":_vm.isDisabled,"placeholder":"yyyy","type":"year"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(855);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b58e9b08", content, true, {});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".time-label[data-v-7ac485b0]{display:inline-block;width:3em}", ""]);

// exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue__time-picker{display:inline-block;position:relative;font-size:1em;width:10em;font-family:sans-serif;vertical-align:middle}.vue__time-picker *{-webkit-box-sizing:border-box;box-sizing:border-box}.vue__time-picker input.display-time{border:1px solid #d2d2d2;width:10em;height:2.2em;padding:.3em .5em;font-size:1em}.vue__time-picker input.has-custom-icon{padding-left:1.8em}.vue__time-picker input.display-time.invalid:not(.skip-error-style){border-color:#c03;outline-color:#c03}.vue__time-picker input.display-time.disabled,.vue__time-picker input.display-time:disabled{color:#d2d2d2}.vue__time-picker .controls{position:absolute;top:0;bottom:0;right:0;z-index:3;-webkit-box-orient:horizontal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;pointer-events:none}.vue__time-picker .controls,.vue__time-picker .controls>*{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}.vue__time-picker .controls>*{cursor:pointer;width:auto;-webkit-box-orient:vertical;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 .35em;color:#d2d2d2;line-height:100%;font-style:normal;pointer-events:auto;-webkit-transition:color .2s,opacity .2s;transition:color .2s,opacity .2s}.vue__time-picker .controls>:hover{color:#797979}.vue__time-picker .controls>:active,.vue__time-picker .controls>:focus{outline:0}.vue__time-picker .controls .char{font-size:1.1em;line-height:100%;-webkit-margin-before:-.15em}.vue__time-picker .custom-icon{z-index:2;position:absolute;left:0;top:0;bottom:0;width:1.8em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;pointer-events:none}.vue__time-picker .controls img,.vue__time-picker .controls svg,.vue__time-picker .custom-icon img,.vue__time-picker .custom-icon svg{display:inline-block;vertical-align:middle;margin:0;border:0;outline:0;max-width:1em;height:auto}.vue__time-picker .time-picker-overlay{z-index:4;position:fixed;top:0;left:0;right:0;bottom:0}.vue__time-picker-dropdown,.vue__time-picker .dropdown{position:absolute;z-index:5;top:calc(2.2em + 2px);left:0;background:#fff;-webkit-box-shadow:0 1px 6px rgba(0,0,0,.15);box-shadow:0 1px 6px rgba(0,0,0,.15);width:10em;height:10em;font-weight:400}.vue__time-picker-dropdown{position:fixed;z-index:100}.vue__time-picker-dropdown.drop-up,.vue__time-picker .dropdown.drop-up{top:auto;bottom:calc(2.2em + 1px)}.vue__time-picker-dropdown .select-list,.vue__time-picker .dropdown .select-list{width:10em;height:10em;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.vue__time-picker-dropdown .select-list:active,.vue__time-picker-dropdown .select-list:focus,.vue__time-picker .dropdown .select-list:active,.vue__time-picker .dropdown .select-list:focus{outline:0}.vue__time-picker-dropdown ul,.vue__time-picker .dropdown ul{padding:0;margin:0;list-style:none;outline:0;-webkit-box-flex:1;-ms-flex:1 1 0.00001px;flex:1 1 0.00001px;overflow-x:hidden;overflow-y:auto}.vue__time-picker-dropdown ul.apms,.vue__time-picker-dropdown ul.minutes,.vue__time-picker-dropdown ul.seconds,.vue__time-picker .dropdown ul.apms,.vue__time-picker .dropdown ul.minutes,.vue__time-picker .dropdown ul.seconds{border-left:1px solid #fff}.vue__time-picker-dropdown ul li,.vue__time-picker .dropdown ul li{list-style:none;text-align:center;padding:.3em 0;color:#161616}.vue__time-picker-dropdown ul li:not(.hint):not([disabled]):focus,.vue__time-picker-dropdown ul li:not(.hint):not([disabled]):hover,.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus,.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover{background:rgba(0,0,0,.08);color:#161616;cursor:pointer}.vue__time-picker-dropdown ul li:not([disabled]).active,.vue__time-picker-dropdown ul li:not([disabled]).active:focus,.vue__time-picker-dropdown ul li:not([disabled]).active:hover,.vue__time-picker .dropdown ul li:not([disabled]).active,.vue__time-picker .dropdown ul li:not([disabled]).active:focus,.vue__time-picker .dropdown ul li:not([disabled]).active:hover{background:#41b883;color:#fff}.vue__time-picker-dropdown ul li[disabled],.vue__time-picker-dropdown ul li[disabled]:hover,.vue__time-picker .dropdown ul li[disabled],.vue__time-picker .dropdown ul li[disabled]:hover{background:transparent;opacity:.3;cursor:not-allowed}.vue__time-picker-dropdown .hint,.vue__time-picker .dropdown .hint{color:#a5a5a5;cursor:default;font-size:.8em}", ""]);

// exports


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"timepicker-container"},[_c('vue-timepicker',{staticClass:"form-control",attrs:{"format":!_vm.is24HoursFormat ? 'hh:mm A' : '',"disabled":_vm.isDisabled,"minute-interval":_vm.minutesInterval},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1),_vm._v(" "),(
      (_vm.inputVal == null ||
        _vm.inputVal.hh === '' ||
        _vm.inputVal.mm === '' ||
        _vm.inputVal.A === '') &&
      _vm.submitClicked &&
      _vm.isRequired &&
      !_vm.isDisabled
    )?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthPickerWithLabel_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthPickerWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthPickerWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthPickerWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthPickerWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d950ced6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthPickerWithLabel_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d950ced6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthPickerWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d950ced6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthPickerWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(860);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2edb9d36", content, true, {});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".select-month[data-v-d950ced6]{margin-right:.5em}.input-year[data-v-d950ced6]{margin-left:.5em}.month-picker-section[data-v-d950ced6]{display:flex}", ""]);

// exports


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('DatePicker',{staticClass:"date-picker form-control registration-date",attrs:{"disabled":_vm.isDisabled,"default-panel":_vm.initialView,"placeholder":"yyyy-mm","type":"month"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.submitClicked && _vm.after && _vm.showErrorEndAfterStartDate)?_c('p',{staticClass:"required-message"},[_vm._v("\n    End Date must be after Start Date\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"form-label-btn"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.hasAddOptionBtn)?_c('div',{staticClass:"setting-container"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Add Option'),expression:"'Add Option'"}],staticClass:"material-icons ml-2 add-option-icon",on:{"click":function($event){return _vm.$emit('clickBtn', 'add-option')}}},[_vm._v("\n        add_circle_outline\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.displayOptionList),function(chunk,chunkIndex){return _c('div',{key:'chunk-' + chunkIndex,class:_vm.columnClass},[_vm._l((chunk),function(option,index){return _c('div',{key:'option-' + _vm.optionsPerColumn * chunkIndex + index,staticClass:"form-check pl-4"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","id":_vm.getOptionId(_vm.optionsPerColumn * chunkIndex + index),"disabled":_vm.isDisabled},domProps:{"value":option,"checked":_vm.isCheck(option, _vm.optionsPerColumn * chunkIndex + index)},on:{"change":function($event){return _vm.handleOnChange(option, _vm.optionsPerColumn * chunkIndex + index)}}}),_vm._v(" "),(_vm.isHtml)?_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":_vm.getOptionId(_vm.optionsPerColumn * chunkIndex + index)},domProps:{"innerHTML":_vm._s(_vm.getDisplayOption(option))}}):_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":_vm.getOptionId(_vm.optionsPerColumn * chunkIndex + index)}},[_vm._v("\n          "+_vm._s(_vm.getDisplayOption(option))+"\n        ")])])}),_vm._v(" "),(
          chunkIndex === _vm.displayOptionList.length - 1 &&
          _vm.hasOther &&
          _vm.isOtherSelected
        )?_c('div',[_c('input',{staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.getOtherValue},on:{"input":function($event){return _vm.handleOtherTextboxInput($event)}}})]):_vm._e()],2)}),0),_vm._v(" "),(_vm.bottomDescription)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.bottomDescription)}})]):_vm._e(),_vm._v(" "),((_vm.value == null || _vm.value === '') && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.listDisplayButtons && _vm.listDisplayButtons.length)?_c('div',{staticClass:"button-group"},_vm._l((_vm.listDisplayButtons),function(button){return _c('button',{key:'button-' + button.id,staticClass:"btn btn-secondary mr-1",on:{"click":function($event){return _vm.handleClickButton(button)}}},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys(button.keyLangLabel))+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioIconGroup_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioIconGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioIconGroup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioIconGroup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioIconGroup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d17daca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioIconGroup_vue__ = __webpack_require__(866);
function injectStyle (ssrContext) {
  __webpack_require__(864)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d17daca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RadioIconGroup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d17daca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RadioIconGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(865);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("65932b30", content, true, {});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".option-container img[data-v-3d17daca]{width:80px;height:80px;border:3px solid #b6b6b6;border-radius:16px}.checkbox-container>.checkmark[data-v-3d17daca]{border-radius:50%;position:absolute;top:63px;background-color:#fff;border:3px solid #b6b6b6;height:28px;width:28px;left:0;right:0;margin:auto}.checkbox-container[data-v-3d17daca]{padding-left:0;text-align:center;position:relative}.option-label[data-v-3d17daca]{font-weight:700;margin-top:.5em}.list-options-container[data-v-3d17daca]{display:flex;flex-wrap:wrap}.option-container[data-v-3d17daca]{flex-basis:80px;flex-grow:1}", ""]);

// exports


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-options-container"},_vm._l((_vm.normalizedOptionList),function(option,index){return _c('div',{key:'option' + index,staticClass:"option-container"},[_c('label',{staticClass:"checkbox-container"},[_c('img',{attrs:{"src":_vm.normalizedIconList[index],"alt":option}}),_vm._v(" "),_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","id":'radio-' + _vm.name + index,"disabled":_vm.isDisabled},domProps:{"value":option,"checked":_vm.isCheck(option, index)},on:{"change":function($event){return _vm.handleOnChange(option, index)}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('div',{staticClass:"option-label"},[_vm._v(_vm._s(_vm.getDisplayOption(option)))])])])}),0),_vm._v(" "),(_vm.bottomDescription)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.bottomDescription)}})]):_vm._e(),_vm._v(" "),((_vm.value == null || _vm.value === '') && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxIconGroup_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxIconGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxIconGroup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxIconGroup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxIconGroup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6653e764_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxIconGroup_vue__ = __webpack_require__(870);
function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6653e764"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxIconGroup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6653e764_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxIconGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b3c9cb58", content, true, {});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".option-container img[data-v-6653e764]{width:80px;height:80px;border:3px solid #b6b6b6;border-radius:16px}.checkbox-container>.checkmark[data-v-6653e764]{border-radius:50%;position:absolute;top:63px;background-color:#fff;border:3px solid #b6b6b6;height:28px;width:28px;left:0;right:0;margin:auto}.checkbox-container[data-v-6653e764]{padding-left:0;text-align:center;position:relative}.option-label[data-v-6653e764]{font-weight:700;margin-top:.5em}.list-options-container[data-v-6653e764]{display:flex;flex-wrap:wrap}.option-container[data-v-6653e764]{flex-basis:80px;flex-grow:1}", ""]);

// exports


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"list-options-container"},_vm._l((_vm.normalizedOptionList),function(option,index){return _c('div',{key:'option' + index,staticClass:"option-container"},[_c('label',{staticClass:"checkbox-container"},[_c('img',{attrs:{"src":_vm.normalizedIconList[index],"alt":option}}),_vm._v(" "),_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":'checkbox-' + _vm.name + index,"disabled":_vm.isDisabled},domProps:{"value":option,"checked":_vm.isOptionCheck(option)},on:{"change":function($event){return _vm.onChangeCheck(option, $event.target.checked, index)}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"}),_vm._v(" "),_c('div',{staticClass:"option-label"},[_vm._v(_vm._s(_vm.getDisplayOption(option)))])])])}),0),_vm._v(" "),(_vm.listCheckedOption.length === 0 && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a298aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownWithLabel_vue__ = __webpack_require__(872);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8a298aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"d-flex"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],staticClass:"form-control",attrs:{"disabled":_vm.isDisabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.inputVal=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.normalizedOptionList),function(option,index){return _c('option',{key:'option' + index},[_vm._v("\n      "+_vm._s(_vm.getDisplayOption(option))+"\n    ")])}),0),_vm._v(" "),(!_vm.inputVal && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(874);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("d82d41f8", content, true, {});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".textbox-option[data-v-525696c8]{display:inline-block;width:100%}", ""]);

// exports


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"form-label-btn"},[_vm._v("\n    "+_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired && _vm.label.trim().length > 0)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("\n      *\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasAddOptionBtn)?_c('div',{staticClass:"setting-container"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Add Option'),expression:"'Add Option'"}],staticClass:"material-icons ml-2 add-option-icon",on:{"click":function($event){return _vm.$emit('clickBtn', 'add-option')}}},[_vm._v("\n        add_circle_outline\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.label === '')?_c('label',{staticClass:"no-margin-top"}):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),(_vm.hasCheckAll)?_c('div',{staticClass:"form-check pl-4"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","value":"all","id":_vm.idCheckAll},domProps:{"checked":_vm.listCheckedOption.length === _vm.normalizedOptionList.length},on:{"change":function($event){return _vm.handleClickCheckAll($event.target.checked)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":_vm.idCheckAll}},[_vm._v(" All ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.displayOptionList),function(chunk,chunkIndex){return _c('div',{key:'chunk-' + chunkIndex,class:_vm.columnClass},[_vm._l((chunk),function(option,index){return _c('div',{key:'option-' + _vm.optionsPerColumn * chunkIndex + index,staticClass:"form-check pl-4"},[(_vm.isOptionShow(option))?_c('div',{style:({
            'margin-left':
              _vm.mapParentOptions && _vm.mapParentOptions[option] ? '1em' : '0',
          })},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","disabled":_vm.isOptionDisabled(_vm.optionsPerColumn * chunkIndex + index),"id":_vm.getCheckboxId(chunkIndex, index)},domProps:{"value":option,"checked":_vm.isOptionCheck(option)},on:{"change":function($event){return _vm.onChangeCheck(
                option,
                $event.target.checked,
                _vm.optionsPerColumn * chunkIndex + index
              )}}}),_vm._v(" "),(_vm.isHtml)?_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":_vm.getCheckboxId(chunkIndex, index)},domProps:{"innerHTML":_vm._s(_vm.getDisplayOption(option))}}):_c('label',{staticClass:"form-check-label ml-1",attrs:{"for":_vm.getCheckboxId(chunkIndex, index)}},[_vm._v("\n            "+_vm._s(_vm.getDisplayOption(option))+"\n          ")]),_vm._v(" "),(
              _vm.textboxOption.includes(_vm.optionsPerColumn * chunkIndex + index)
            )?_c('input',{staticClass:"form-control textbox-option",attrs:{"type":"text"},domProps:{"value":_vm.getTextboxOptionValue(_vm.optionsPerColumn * chunkIndex + index)},on:{"input":function($event){return _vm.handleTextboxOptionInput(
                $event,
                _vm.optionsPerColumn * chunkIndex + index
              )}}}):_vm._e()]):_vm._e()])}),_vm._v(" "),(
          chunkIndex === _vm.displayOptionList.length - 1 &&
          _vm.hasOther &&
          _vm.value != null &&
          _vm.hasOtherOption
        )?_c('div',[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":_vm.isDisabled},domProps:{"value":_vm.getOtherValue},on:{"input":function($event){return _vm.handleOtherTextboxInput($event)}}})]):_vm._e()],2)}),0),_vm._v(" "),(_vm.listCheckedOption.length === 0 && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.listDisplayButtons && _vm.listDisplayButtons.length)?_c('div',{staticClass:"button-group"},_vm._l((_vm.listDisplayButtons),function(button){return _c('button',{key:'button-' + button.id,staticClass:"btn btn-secondary mr-1",on:{"click":function($event){return _vm.handleClickButton(button)}}},[_vm._v("\n      "+_vm._s(_vm.getLabelByKeys(button.keyLangLabel))+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelectWithLabel_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelectWithLabel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelectWithLabel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelectWithLabel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelectWithLabel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f72cf844_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelectWithLabel_vue__ = __webpack_require__(879);
function injectStyle (ssrContext) {
  __webpack_require__(877)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f72cf844"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelectWithLabel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f72cf844_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelectWithLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(878);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c792a26", content, true, {});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".multi-select-container[data-v-f72cf844]{white-space:normal}", ""]);

// exports


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayedOptionList && _vm.displayedOptionList.length)?_c('div',{staticClass:"multi-select-container",class:_vm.classList},[(_vm.label)?_c('label',{staticClass:"form-label-btn"},[_vm._v(_vm._s(_vm.label.trim().replace(/\*$/, ""))+"\n    "),(_vm.isRequired)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.hasAddOptionBtn)?_c('div',{staticClass:"setting-container"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Add Option'),expression:"'Add Option'"}],staticClass:"material-icons ml-2 add-option-icon",on:{"click":function($event){return _vm.$emit('clickBtn', 'add-option')}}},[_vm._v("\n        add_circle_outline\n      ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.adminDescription && _vm.$store.getters.isAgent)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.adminDescription)}})]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e(),_vm._v(" "),_c('MultiSelect',{attrs:{"id":"multiselect-select-field","optionList":_vm.displayedOptionList,"isMultiple":_vm.isMulti,"closeOnSelect":_vm.closeOnSelect,"placeholder":_vm.placeholder,"optionLabel":_vm.displayOptionLabel,"optionModel":_vm.displayOptionModel,"hasClearButton":_vm.hasClearButton,"buttonGroups":_vm.buttonGroups,"additionalSelectedInfoFunc":_vm.additionalSelectedInfoFunc},on:{"clickBtn":function($event){return _vm.$emit('clickBtn', $event)},"select":function($event){return _vm.$emit('select', $event)},"userInput":function($event){return _vm.$emit('userInput', $event)}},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(_vm.hasOther && _vm.isOtherSelected)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otherValue),expression:"otherValue"}],staticClass:"form-control",attrs:{"type":"text","placeholder":(_vm.otherOption + " value")},domProps:{"value":(_vm.otherValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.otherValue=$event.target.value},function($event){return _vm.handleOtherTextboxInput($event)}]}})]):_vm._e(),_vm._v(" "),(!_vm.isValueInputted && _vm.submitClicked && _vm.isRequired)?_c('p',{staticClass:"required-message"},[_vm._v("\n    "+_vm._s(_vm.getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED"))+"\n  ")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DATA_MODEL_MAX_LENGTH = exports.DATA_MODEL_MAX_LENGTH = {
  email: 255,
  email2: 255,
  email_username: 255,
  username: 255,
  first_name: 255,
  last_name: 255,
  name: 255,
  phone: 255,
  phone2: 255,
  title: 255,
  present_employer: 255,
  status: 255,
  salary_range: 255,
  specialty_areas: 500,
  education_institution: 500,
  degree: 500,
  address1: 1024,
  address2: 1024,
  postal_code: 12,
  city: 1024,
  provincestate: 128,
  country: 40,
  website: 1024,
  facebook: 1024,
  twitter: 1024,
  instagram: 1024,
  youtube: 1024,
  linkedin: 1024,
  video: 1024,
  employer_name: 255,
  stripe_customer_id: 255,
  stripe_refresh_token: 255,
  stripe_connect_id: 255,
  organization_type: 255,
  size: 255,
  agency_owner: 255,
  second_status: 200,
  // marketing_source: 255,
  // bank: 255,
  // bank_account_type: 255,
  // bank_account_number: 255,
  // bank_account_name: 255,
  // government_ID_number: 255,
  // social_security: 255,
  category: 255
};

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.listFieldsVal),function(el,index){return _c('div',{key:'field' + index,class:_vm.getClassList(el)},[(
          _vm.isItemShow(_vm.modelData, el, _vm.listAllRelatedFields || _vm.listFieldsVal, _vm.isAnnonymousAccess) &&
          !el.isHidden
        )?[(el.type === _vm.FORM_TYPE.ARRAY_OBJECT)?[(!isNaN(_vm.modelData[el.size]))?[_vm._l((Number(_vm.modelData[el.size])),function(childRowIndex){return [_c('FormGroupRowLayout',{key:'childRowIndex-' + childRowIndex,attrs:{"listFields":el.items,"modelData":_vm.modelData[el.model][childRowIndex - 1],"submitClicked":_vm.isHightlightError(index)},on:{"input":function($event){return _vm.handleInputField(el, index)}}})]})]:_vm._e()]:(el.type === _vm.FORM_TYPE.HEADER_SLOT)?[_vm._m(0,true)]:(el.type === _vm.FORM_TYPE.HEADER)?[_c('h3',{key:'header' + index,staticClass:"mt-4 d-flex"},[_vm._v("\n            "+_vm._s(_vm.getFieldProperty(el, "label"))+"\n          ")]),_vm._v(" "),(!el.isFirst)?_c('hr',{key:'header-separate' + index,staticStyle:{"margin":"0"}}):_vm._e(),_vm._v(" "),(el.adminDescription)?_c('div',{key:'admin-description' + index,staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(el.adminDescription)}})]):_vm._e(),_vm._v(" "),(el.description)?_c('div',{key:'description' + index,staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(el.description)}})]):_vm._e()]:(el.type === _vm.FORM_TYPE.SUB_HEADER)?[_c('div',{key:'sub_header' + index,attrs:{"classList":""}},[_c('h4',{staticStyle:{"margin-top":"1em"}},[_vm._v("\n              "+_vm._s(_vm.getFieldProperty(el, "label"))+"\n            ")]),_vm._v(" "),(el.adminDescription)?_c('div',{staticClass:"admin-description"},[_c('div',{domProps:{"innerHTML":_vm._s(el.adminDescription)}})]):_vm._e(),_vm._v(" "),(el.description)?_c('div',{staticClass:"description"},[_c('div',{domProps:{"innerHTML":_vm._s(el.description)}})]):_vm._e()])]:(el.type === _vm.FORM_TYPE.HTML)?[_c('div',{key:'html' + index,domProps:{"innerHTML":_vm._s(el.html)}})]:(
            [
              _vm.FORM_TYPE.SLOT,
              _vm.FORM_TYPE.SECTION,
              _vm.FORM_TYPE.BOOKING_SECTION,
              _vm.FORM_TYPE.EVALUATION,
              _vm.FORM_TYPE.FILE_WITH_INFO,
              _vm.FORM_TYPE.PAYMENT,
              _vm.FORM_TYPE.RETURNING_APPLICANT_BTN ].includes(el.type)
          )?[_vm._t(el.label)]:(el.type === _vm.FORM_TYPE.SIGN_DOCUMENT)?[_vm._t(el.documentTemplateId + '-' + el.label)]:(el.type === _vm.FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION)?[_vm._t('stripe-subscription-selection' + el.label)]:(el.type === _vm.FORM_TYPE.CHECKBOX_CONDITION)?[_vm._t('checkbox-condition' + el.label)]:(el.type === _vm.FORM_TYPE.SEPARATOR)?[_c('hr',{key:'seprator' + index,staticStyle:{"margin-bottom":"0"}})]:[(
              el.type === _vm.FORM_TYPE.TEXTAREA &&
              el.isShareModel &&
              Array.isArray(_vm.modelData[el.model])
            )?_c('TextAreaWithLabel',{key:'textarea-share-model' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"rows":el.rows,"maxLength":_vm.getMaxLength(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"placeholder":_vm.getFieldProperty(el, 'placeholder'),"defaultValue":el.defaultValue,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"isCounter":el.isCounter,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][el.shareModelIndex]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], el.shareModelIndex, $$v)},expression:"modelData[el.model][el.shareModelIndex]"}}):(el.type === _vm.FORM_TYPE.TEXTAREA)?_c('TextAreaWithLabel',{key:'textarea' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"rows":el.rows,"maxLength":_vm.getMaxLength(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"placeholder":_vm.getFieldProperty(el, 'placeholder'),"defaultValue":el.defaultValue,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"isCounter":el.isCounter,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.PASSWORD)?_c('PasswordWithLabel',{key:'password' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"confirmLabel":_vm.getFieldProperty(el, 'confirmLabel'),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CHECKBOX)?_c('CheckboxGroup',{key:'checkbox' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"mapDisplayedOptions":el.mapDisplayedOptions,"numberOfColumn":el.numberOfColumn,"hasOther":el.hasOther,"isHtml":el.isHtml,"exclusiveOptions":el.exclusiveOptions,"hasCheckAll":el.hasCheckAll,"markAllAsChecked":el.markAllAsChecked,"textboxOption":el.textboxOption,"defaultValue":el.defaultValue,"messageDialogs":el.messageDialogs,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"tagData":_vm.tagData,"buttonGroups":el.buttonGroups},on:{"input":function($event){return _vm.handleInputField(el, index)},"reloadData":function($event){return _vm.$emit('reloadData')},"clickBtn":function($event){return _vm.$emit('clickMultiSelectBtn', {
                btnId: $event,
                model: el.model,
                el: el,
              })}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CHECKBOX_ITEM)?_c('CheckboxItem',{key:'checkbox-item' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"option":el.option,"messageDialogs":el.messageDialogs,"buttonGroups":el.buttonGroups,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"defaultValue":el.defaultValue,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CHECKBOX_ICON)?_c('CheckboxIconGroup',{key:'checkbox-icon' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"defaultValue":el.defaultValue,"iconList":el.iconList,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(
              el.type === _vm.FORM_TYPE.RADIO &&
              el.isShareModel &&
              Array.isArray(_vm.modelData[el.model])
            )?_c('RadioGroup',{key:'radio' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model + '-shareIndex-' + el.shareModelIndex,"description":_vm.getFieldProperty(el, 'description'),"isHtml":el.isHtml,"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"hasOther":el.hasOther,"defaultValue":el.defaultValue,"numberOfColumn":el.numberOfColumn,"isBooleanModel":_vm.isBooleanRadioModel(el.model),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][el.shareModelIndex]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], el.shareModelIndex, $$v)},expression:"modelData[el.model][el.shareModelIndex]"}}):(el.type === _vm.FORM_TYPE.RADIO)?_c('RadioGroup',{key:'radio' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"isHtml":el.isHtml,"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"bottomDescription":el.bottomDescription,"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"hasOther":el.hasOther,"defaultValue":el.defaultValue,"numberOfColumn":el.numberOfColumn,"isBooleanModel":_vm.isBooleanRadioModel(el.model),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"buttonGroups":el.buttonGroups},on:{"input":function($event){return _vm.handleInputField(el, index)},"clickBtn":function($event){return _vm.$emit('clickMultiSelectBtn', {
                btnId: $event,
                model: el.model,
                el: el,
              })}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.RATING)?_c('StarRating',{key:'rating' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"hasOther":el.hasOther,"defaultValue":el.defaultValue,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(
              el.type === _vm.FORM_TYPE.RADIO_ICON &&
              el.isShareModel &&
              Array.isArray(_vm.modelData[el.model])
            )?_c('RadioIconGroup',{key:'radio' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"defaultValue":el.defaultValue,"isBooleanModel":_vm.isBooleanRadioModel(el.model),"iconList":el.iconList,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][el.shareModelIndex]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], el.shareModelIndex, $$v)},expression:"modelData[el.model][el.shareModelIndex]"}}):(el.type === _vm.FORM_TYPE.RADIO_ICON)?_c('RadioIconGroup',{key:'radio' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"bottomDescription":el.bottomDescription,"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"defaultValue":el.defaultValue,"iconList":el.iconList,"isBooleanModel":_vm.isBooleanRadioModel(el.model),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(
              el.type === _vm.FORM_TYPE.DROPDOWN &&
              el.isShareModel &&
              Array.isArray(_vm.modelData[el.model])
            )?_c('DropdownWithLabel',{key:'dropdown' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"defaultValue":el.defaultValue,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][el.shareModelIndex]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], el.shareModelIndex, $$v)},expression:"modelData[el.model][el.shareModelIndex]"}}):(el.type === _vm.FORM_TYPE.DROPDOWN)?_c('DropdownWithLabel',{key:'dropdown' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"defaultValue":el.defaultValue,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DATEPICKER)?_c('DatePickerWithLabel',{key:'datepicker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"initialView":el.initialView,"allowPastDate":el.allowPastDate,"dateFormat":el.dateFormat,"appendToBody":_vm.isAppendToBody(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"minDate":el.minDate,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.YEAR_PICKER)?_c('YearPickerWithLabel',{key:'datepicker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.MULTI_DATEPICKER)?_c('MultiDatePicker',{key:'multi-datepicker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.name,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.TIME_PICKER)?_c('TimePickerWithLabel',{key:'timepicker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"minutesInterval":el.minutesInterval,"is24HoursFormat":_vm.is24HoursFormat(el),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"defaultValue":_vm.defaultTime(el)},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.MONTH_PICKER)?_c('MonthPickerWithLabel',{key:'monthpicker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"initialView":el.initialView,"after":_vm.modelData[el.after],"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DATETIME_PICKER)?_c('DateTimePickerWithLabel',{key:'datetimepicker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"initialView":el.initialView,"allowPastDate":el.allowPastDate,"minutesInterval":el.minutesInterval,"is24HoursFormat":_vm.is24HoursFormat(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.DAY_HOURS_SELECTOR)?_c('div',{key:'day-hours-selector' + index,attrs:{"classList":""}},[_c('DayHoursInput',{attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"listDays":_vm.getFieldProperty(el, 'listDays'),"hasTimeOff":el.hasTimeOff,"hasNote":el.hasNote,"customLabels":_vm.getFieldProperty(el, 'customLabels'),"minutesInterval":el.minutesInterval,"is24HoursFormat":_vm.is24HoursFormat(el),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"useTimePicker":el.useTimePicker},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}})],1):(el.type === _vm.FORM_TYPE.SALARY_RANGE)?_c('SalaryRange',{key:'salary-range' + index,attrs:{"label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"hidePeriod":el.hidePeriod,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.MULTI_SELECT)?_c('MultiSelectWithLabel',{key:'multi-select' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"optionList":_vm.getOptionList(el) ||
              _vm.modelData[el.optionListModel] ||
              _vm.getOptionListByConditions(el),"optionKey":_vm.modelData[el.optionKey],"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"isMulti":el.isMulti,"isArrayModel":el.isArrayModel,"searchable":el.searchable,"closeOnSelect":!el.openOnSelect,"defaultValue":el.defaultValue,"placeholder":_vm.getFieldProperty(el, 'placeholder'),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"hasOther":el.hasOther,"optionLabel":el.optionLabel,"optionModel":el.optionModel,"hasClearButton":el.hasClearButton,"buttonGroups":el.buttonGroups,"additionalSelectedInfoFunc":el.additionalSelectedInfoFunc,"infoLinkId":el.infoLinkId,"optionListTransformFunc":el.optionListTransformFunc,"formObject":_vm.modelData},on:{"userInput":function($event){return _vm.handleUserSelect($event, el, index)},"select":function($event){return _vm.handleSelect($event, el.model)},"changed":_vm.handleChange,"clickBtn":function($event){return _vm.$emit('clickMultiSelectBtn', {
                btnId: $event,
                model: el.model,
                el: el,
              })}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.HTML_SELECTION)?_c('HtmlSelection',{key:'html-selection' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"isMulti":el.isMulti,"htmlList":el.htmlList,"numberOfColumn":el.numberOfColumn,"messageDialogs":el.messageDialogs,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"scrollToNextItem":el.scrollToNextItem},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.FILE && _vm.submitInfo)?_c('FileWithLabel',{key:'file' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"remark":el.remark,"maxSize":el.maxSize,"fileType":el.fileType,"initialUrl":el.initialUrl,"blankFileUrl":el.blankFileUrl,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"submitInfo":_vm.submitInfo},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.FILE)?_c('FileUpload',{key:'file' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"remark":el.remark,"maxSize":el.maxSize,"fileType":el.fileType,"initialUrl":el.initialUrl,"blankFileUrl":el.blankFileUrl,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"hasAccessControlBtn":_vm.hasFileAccessControlBtn},on:{"input":function($event){return _vm.handleInputField(el, index)},"accessControl":function($event){return _vm.$emit('fileAccessControl', el)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CROPABLE_FILE)?_c('CroppedFileUpload',{key:'cropped-file' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"remark":el.remark,"maxSize":el.maxSize,"fileType":el.fileType,"initialUrl":el.initialUrl,"blankFileUrl":el.blankFileUrl,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"submitInfo":_vm.submitInfo},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.RATING_GROUP)?_c('RatingGroup',{key:'rating-group' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"itemList":el.itemList,"gradeList":el.gradeList,"numberOfColumn":el.numberOfColumn,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.RADIO_TABLE)?_c('RadioTable',{key:'radio-table' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"itemList":el.itemList,"headerList":el.headerList,"numberOfColumn":el.numberOfColumn,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.CHECKBOX_TABLE)?_c('CheckboxTable',{key:'checkbox-table' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"itemList":el.itemList,"headerList":el.headerList,"hasNote":el.hasNote,"noteHeader":el.noteHeader,"numberOfColumn":el.numberOfColumn,"customizableItemList":el.customizableItemList,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.LANGUAGE_INPUT)?_c('LanguageInput',{key:'language input' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"optionList":_vm.getOptionList(el),"mapOptionListByLang":_vm.getMapOptionListByLanguage(el),"numberOfColumn":el.numberOfColumn,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.PRODUCT_SELECTION)?_c('ProductSelection',{key:'product selection' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"productList":el.productList,"descriptionList":el.descriptionList,"priceList":el.priceList,"iconList":el.iconList,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):([_vm.FORM_TYPE.CREDIT_PACKAGE_SELECTION, _vm.FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION].includes(el.type))?_c('CreditPackageSelection',{key:'credit package selection' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"htmlList":el.htmlList,"creditNumberList":el.creditNumberList,"isMonthly":el.isMonthlyCreditSubscription,"isCashCredit":el.isCashCredit,"priceList":el.priceList,"idList":el.idList,"userTypeList":el.userTypeList,"nameList":el.nameList,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData.credit_package),callback:function ($$v) {_vm.$set(_vm.modelData, "credit_package", $$v)},expression:"modelData.credit_package"}}):(el.type === _vm.FORM_TYPE.TEXT_EDITOR)?_c('TextEditor',{key:'code-editor' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"defaultValue":el.defaultValue,"listTagFields":el.listTagFields,"isMail":el.isMail,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"openTag":el.openTag,"closeTag":el.closeTag,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.LOGGING)?_c('LogItem',{key:'logging' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"name":el.model,"description":_vm.getFieldProperty(el, 'description'),"logItem":el.logItem,"adminDescription":_vm.getFieldProperty(el, 'adminDescription')},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.EXPRESSION)?_c('ComputedExpression',{key:'expression' + index,attrs:{"classList":"","expression":el.expression,"applicationData":_vm.modelData}}):(el.type === _vm.FORM_TYPE.LIST_DATE_TIMES_PICKER)?_c('ListDateTimesPickerInput',{key:'list-date-times-picker' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"allowPastDate":el.allowPastDate,"appendToBody":el.appendToBody,"minutesInterval":el.minutesInterval,"additionalLabel":el.additionalLabel,"additionalModel":el.additionalModel,"maxDate":el.maxDate,"secondaryLabel":_vm.getFieldProperty(el, 'description'),"objectData":_vm.modelData,"minDuration":el.minDuration},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.PLACEMENT_JOB_SELECTION)?_c('PlacementJobSelection',{key:'placement-job-selection' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"buttonText":_vm.getFieldProperty(el, 'buttonText'),"secondaryLabel":_vm.getFieldProperty(el, 'description')},model:{value:(_vm.modelData.selected_placement_jobs),callback:function ($$v) {_vm.$set(_vm.modelData, "selected_placement_jobs", $$v)},expression:"modelData.selected_placement_jobs"}}):(el.type === _vm.FORM_TYPE.LIST_FILES)?_c('EmailAttachment',{key:'list-files' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"name":_vm.getFieldProperty(el, 'name')},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.VIDEO)?_c('VideoInput',{key:'video-input' + index,attrs:{"classList":"","label":_vm.getFieldLabel(el),"description":_vm.getFieldProperty(el, 'description'),"userID":el.userID,"initialVideoUrl":_vm.modelData[el.videoUrlModel || 'video_url'],"type":el.videoType || 'Candidate Job Application',"showResultMessage":false},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):(el.type === _vm.FORM_TYPE.LABEL)?_c('div',{key:'label' + index,attrs:{"classList":""}},[_c('label',[_vm._v(_vm._s(_vm.getFieldProperty(el, "label")))]),_vm._v(" "),(el.model)?_c('div',{staticClass:"form-type-label"},[_vm._v("\n              "+_vm._s(el.model)+"\n            ")]):_vm._e()]):(el.type === _vm.FORM_TYPE.LIST_ITEMS)?_c('div',{key:'label' + index,attrs:{"classList":""}},[_c('label',[_vm._v(_vm._s(_vm.getFieldProperty(el, "label")))]),_vm._v(" "),_c('ul',_vm._l((_vm.convertStringToArray(el.itemList)),function(item){return _c('li',{key:item,staticClass:"list-item"},[_vm._v("\n                "+_vm._s(item)+"\n              ")])}),0)]):(el.type === _vm.FORM_TYPE.LIST_TEXTBOX)?_c('div',{key:'list-textbox' + index,staticClass:"list-textbox-container"},[(
                _vm.modelData[el.labelModel] &&
                _vm.modelData[el.labelModel].length > 0
              )?_c('div',[_c('label',[_vm._v(_vm._s(_vm.getFieldProperty(el, "label")))]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"-8px"}},_vm._l((_vm.modelData[el.labelModel]),function(label,subIndex){return _c('TextBoxWithLabel',{key:'textbox-' + index + '-' + subIndex,attrs:{"classList":"col-lg-6","label":label,"submitClicked":_vm.isHightlightError(index),"isRequired":true},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][subIndex]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], subIndex, $$v)},expression:"modelData[el.model][subIndex]"}})}),1)]):_vm._e()]):(el.type === _vm.FORM_TYPE.LIST_TEXTAREA)?_c('div',{key:'list-textarea' + index,staticClass:"list-textarea-container"},[(
                _vm.modelData[el.referModel] &&
                _vm.modelData[el.referModel].length > 0
              )?_c('div',[_c('label',[_vm._v(_vm._s(_vm.getFieldProperty(el, "label")))]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"-8px"}},_vm._l((_vm.modelData[el.referModel]),function(model,subIndex){return _c('TextAreaWithLabel',{key:'text-area-' + index + '-' + subIndex,attrs:{"classList":"col-lg-6","label":el.transformLabel(model),"submitClicked":_vm.isHightlightError(index),"placeholder":el.placeholder,"isRequired":true},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][model]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], model, $$v)},expression:"modelData[el.model][model]"}})}),1)]):_vm._e()]):(el.type === _vm.FORM_TYPE.COLOR_PICKER)?_c('div',{key:'color-picker' + index,staticClass:"color-picker-container",attrs:{"classList":""}},[_c('div',{staticClass:"color-picker-label"},[_c('label',[_vm._v("\n                "+_vm._s(_vm.getFieldProperty(el, "label"))+"\n                "),(el.isRequired !== false)?_c('span',{staticClass:"asterisk-mark"},[_vm._v("*")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"color-picker pl-2"},[_c('v-swatches',{attrs:{"swatches":_vm.getColorPickerOptions(),"show-fallback":"","fallback-input-type":"color","popover-x":"left"},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}})],1)]):(el.type === _vm.FORM_TYPE.SIGNATURE_FIELD)?_c('div',{key:'signature' + index,attrs:{"classList":""}},[_c('SignatureField',{attrs:{"classList":"","label":_vm.getFieldLabel(el),"maxLength":_vm.getMaxLength(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"defaultValue":el.defaultValue,"placeholder":_vm.getFieldProperty(el, 'placeholder'),"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}})],1):(
              ![
                _vm.FORM_TYPE.SECTION,
                _vm.FORM_TYPE.BOOKING_SECTION,
                _vm.FORM_TYPE.FILE_WITH_INFO,
                _vm.FORM_TYPE.PAYMENT,
                _vm.FORM_TYPE.DATA,
                _vm.FORM_TYPE.RETURNING_APPLICANT_BTN ].includes(el.type) &&
              el.isShareModel &&
              Array.isArray(_vm.modelData[el.model])
            )?_c('div',{key:'textbox' + index,attrs:{"classList":""}},[_c('TextBoxWithLabel',{attrs:{"classList":"","label":_vm.getFieldLabel(el),"maxLength":_vm.getMaxLength(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"defaultValue":el.defaultValue,"type":_vm.getInputType(el),"placeholder":_vm.getFieldProperty(el, 'placeholder'),"validation":el.validation,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)}},model:{value:(_vm.modelData[el.model][el.shareModelIndex]),callback:function ($$v) {_vm.$set(_vm.modelData[el.model], el.shareModelIndex, $$v)},expression:"modelData[el.model][el.shareModelIndex]"}})],1):(
              ![
                _vm.FORM_TYPE.SECTION,
                _vm.FORM_TYPE.BOOKING_SECTION,
                _vm.FORM_TYPE.FILE_WITH_INFO,
                _vm.FORM_TYPE.DATA,
                _vm.FORM_TYPE.RETURNING_APPLICANT_BTN ].includes(el.type)
            )?_c('div',{key:'textbox' + index,attrs:{"classList":""}},[(el.hasConfirmField)?_c('TextFieldWithConfirmation',{class:{
                'email-textbox': ['email', 'email2'].includes(el.model),
              },attrs:{"classList":"","label":_vm.getFieldLabel(el),"confirmLabel":_vm.getFieldProperty(el, 'confirmLabel'),"maxLength":_vm.getMaxLength(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"defaultValue":el.defaultValue,"type":_vm.getInputType(el),"placeholder":_vm.getFieldProperty(el, 'placeholder'),"validation":el.validation,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el},on:{"input":function($event){return _vm.handleInputField(el, index)},"blur":function($event){return _vm.$emit('blur', el.model)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}):_c('TextBoxWithLabel',{class:{
                'email-textbox': ['email', 'email2'].includes(el.model),
              },attrs:{"classList":"","label":_vm.getFieldLabel(el),"maxLength":_vm.getMaxLength(el),"description":_vm.getFieldProperty(el, 'description'),"adminDescription":_vm.getFieldProperty(el, 'adminDescription'),"defaultValue":el.defaultValue,"type":_vm.getInputType(el),"placeholder":_vm.getFieldProperty(el, 'placeholder') ||
                _vm.getDefaultPlaceHolder(el),"validation":el.validation,"submitClicked":_vm.isHightlightError(index),"isRequired":el.isRequired,"builderField":el,"buttonGroups":el.buttonGroups,"formData":_vm.modelData},on:{"input":function($event){return _vm.handleInputField(el, index)},"clickBtn":function($event){return _vm.$emit('clickTextboxBtn', { btnId: $event, model: el.model })},"blur":function($event){return _vm.$emit('blur', el.model)}},model:{value:(_vm.modelData[el.model]),callback:function ($$v) {_vm.$set(_vm.modelData, el.model, $$v)},expression:"modelData[el.model]"}}),_vm._v(" "),(el.slotTag)?_vm._t(el.slotTag):_vm._e()],2):_vm._e()]]:_vm._e()],2)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"builder-setting-header-slot"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLabelSetting_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLabelSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLabelSetting_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLabelSetting_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLabelSetting_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7514eab6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditLabelSetting_vue__ = __webpack_require__(885);
function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7514eab6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLabelSetting_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7514eab6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditLabelSetting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(884);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5e4bc81d", content, true, {});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".setting-container[data-v-7514eab6]{display:inline-block;display:flex;align-items:center}.settings-icon[data-v-7514eab6]{cursor:pointer;opacity:.8;color:var(--coredarkcolor);font-size:14px}.settings-icon.small[data-v-7514eab6]{font-size:10px}", ""]);

// exports


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.displayLabelTag)},on:{"click":function($event){return _vm.$emit('click', $event)}}}),_vm._v(" "),_vm._t("after-label"),_vm._v(" "),_vm._t("after-label2"),_vm._v(" "),(_vm.isAgent)?_c('div',{staticClass:"setting-container ml-1"},[_c('i',{staticClass:"settings-icon material-icons",class:{ small: _vm.useSmallIcon },attrs:{"title":"Settings"},on:{"click":function($event){return _vm.showSettingDialog()}}},[_vm._v("\n      edit\n    ")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditButtonSetting_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditButtonSetting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditButtonSetting_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditButtonSetting_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditButtonSetting_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f05f7d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditButtonSetting_vue__ = __webpack_require__(887);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditButtonSetting_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f05f7d2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditButtonSetting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditLabelSetting',{attrs:{"title":"Edit Button Text","modelKey":("public_advance_setting." + _vm.modelKey),"defaultValue":_vm.defaultValue,"classList":_vm.classList,"tagName":"button","disabled":_vm.disabled,"additionalFields":_vm.convertedAdditionalFields},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueSignaturePad = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _signature_pad = __webpack_require__(889);

var _signature_pad2 = _interopRequireDefault(_signature_pad);

var _mergeImages = __webpack_require__(890);

var _mergeImages2 = _interopRequireDefault(_mergeImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];
var checkSaveType = function checkSaveType(type) {
  return IMAGE_TYPES.includes(type);
};
var DEFAULT_OPTIONS = {
  dotSize: (0.5 + 2.5) / 2,
  minWidth: 0.5,
  maxWidth: 2.5,
  throttle: 16,
  minDistance: 5,
  backgroundColor: 'rgba(0,0,0,0)',
  penColor: 'black',
  velocityFilterWeight: 0.7,
  onBegin: function onBegin() {},
  onEnd: function onEnd() {}
};
var convert2NonReactive = function convert2NonReactive(observerValue) {
  return JSON.parse(JSON.stringify(observerValue));
};
var TRANSPARENT_PNG = {
  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
  x: 0,
  y: 0
};

var script = {
  name: 'VueSignaturePad',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    customStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    scaleToDevicePixelRatio: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      signaturePad: {},
      cacheImages: [],
      signatureData: TRANSPARENT_PNG,
      onResizeHandler: null
    };
  },
  computed: {
    propsImagesAndCustomImages: function propsImagesAndCustomImages() {
      var nonReactiveProrpImages = convert2NonReactive(this.images);
      var nonReactiveCachImages = convert2NonReactive(this.cacheImages);
      return [].concat(_toConsumableArray(nonReactiveProrpImages), _toConsumableArray(nonReactiveCachImages));
    }
  },
  watch: {
    options: function options(nextOptions) {
      var _this = this;

      Object.keys(nextOptions).forEach(function (option) {
        if (_this.signaturePad[option]) {
          _this.signaturePad[option] = nextOptions[option];
        }
      });
    }
  },

  mounted: function mounted() {
    var options = this.options;

    var canvas = this.$refs.signaturePadCanvas;
    var signaturePad = new _signature_pad2.default(canvas, _extends({}, DEFAULT_OPTIONS, options));
    this.signaturePad = signaturePad;

    if (options.resizeHandler) {
      this.resizeCanvas = options.resizeHandler.bind(this);
    }

    this.onResizeHandler = this.resizeCanvas.bind(this);
    window.addEventListener('resize', this.onResizeHandler, false);
    this.resizeCanvas();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.onResizeHandler) {
      window.removeEventListener('resize', this.onResizeHandler, false);
    }
  },


  methods: {
    resizeCanvas: function resizeCanvas() {
      var canvas = this.$refs.signaturePadCanvas;
      var data = this.signaturePad.toData();
      var ratio = this.scaleToDevicePixelRatio ? Math.max(window.devicePixelRatio || 1, 1) : 1;
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      this.signaturePad.clear();
      this.signatureData = TRANSPARENT_PNG;
      this.signaturePad.fromData(data);
    },
    saveSignature: function saveSignature() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IMAGE_TYPES[0];
      var encoderOptions = arguments[1];
      var signaturePad = this.signaturePad;

      var status = {
        isEmpty: false,
        data: undefined
      };

      if (!checkSaveType(type)) {
        var imageTypesString = IMAGE_TYPES.join(', ');
        throw new Error('The Image type is incorrect! We are support ' + imageTypesString + ' types.');
      }

      if (signaturePad.isEmpty()) {
        return _extends({}, status, {
          isEmpty: true
        });
      } else {
        this.signatureData = signaturePad.toDataURL(type, encoderOptions);
        return _extends({}, status, {
          data: this.signatureData
        });
      }
    },
    undoSignature: function undoSignature() {
      var signaturePad = this.signaturePad;

      var record = signaturePad.toData();

      if (record) {
        return signaturePad.fromData(record.slice(0, -1));
      }
    },
    mergeImageAndSignature: function mergeImageAndSignature(customSignature) {
      this.signatureData = customSignature;
      return (0, _mergeImages2.default)([].concat(_toConsumableArray(this.images), _toConsumableArray(this.cacheImages), [this.signatureData]));
    },
    addImages: function addImages() {
      var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.cacheImages = [].concat(_toConsumableArray(this.cacheImages), _toConsumableArray(images));
      return (0, _mergeImages2.default)([].concat(_toConsumableArray(this.images), _toConsumableArray(this.cacheImages), [this.signatureData]));
    },
    fromDataURL: function fromDataURL(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments[2];

      return this.signaturePad.fromDataURL(data, options, callback);
    },
    fromData: function fromData(data) {
      return this.signaturePad.fromData(data);
    },
    toData: function toData() {
      return this.signaturePad.toData();
    },
    lockSignaturePad: function lockSignaturePad() {
      return this.signaturePad.off();
    },
    openSignaturePad: function openSignaturePad() {
      return this.signaturePad.on();
    },
    isEmpty: function isEmpty() {
      return this.signaturePad.isEmpty();
    },
    getPropImagesAndCacheImages: function getPropImagesAndCacheImages() {
      return this.propsImagesAndCustomImages;
    },
    clearCacheImages: function clearCacheImages() {
      this.cacheImages = [];
      return this.cacheImages;
    },
    clearSignature: function clearSignature() {
      return this.signaturePad.clear();
    }
  },

  render: function render(createElement) {
    var width = this.width,
        height = this.height,
        customStyle = this.customStyle;

    return createElement('div', {
      style: _extends({
        width: width,
        height: height
      }, customStyle)
    }, [createElement('canvas', {
      style: {
        width: width,
        height: height
      },
      ref: 'signaturePadCanvas'
    })]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  var options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  var hook = void 0;
  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}

/* script */
var __vue_script__ = script;
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  VueSignaturePad: __vue_component__
});

var install = function installVSignature(Vue) {
  Object.entries(components).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        componentName = _ref2[0],
        component = _ref2[1];

    Vue.component(componentName, component);
  });
};

exports.default = install;
exports.VueSignaturePad = __vue_component__;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Signature Pad v3.0.0-beta.4 | https://github.com/szimek/signature_pad
 * (c) 2020 Szymon Nowak | Released under the MIT license
 */

var Point = function () {
    function Point(x, y, time) {
        _classCallCheck(this, Point);

        this.x = x;
        this.y = y;
        this.time = time || Date.now();
    }

    _createClass(Point, [{
        key: 'distanceTo',
        value: function distanceTo(start) {
            return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            return this.x === other.x && this.y === other.y && this.time === other.time;
        }
    }, {
        key: 'velocityFrom',
        value: function velocityFrom(start) {
            return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
        }
    }]);

    return Point;
}();

var Bezier = function () {
    function Bezier(startPoint, control2, control1, endPoint, startWidth, endWidth) {
        _classCallCheck(this, Bezier);

        this.startPoint = startPoint;
        this.control2 = control2;
        this.control1 = control1;
        this.endPoint = endPoint;
        this.startWidth = startWidth;
        this.endWidth = endWidth;
    }

    _createClass(Bezier, [{
        key: 'length',
        value: function length() {
            var steps = 10;
            var length = 0;
            var px = void 0;
            var py = void 0;
            for (var i = 0; i <= steps; i += 1) {
                var t = i / steps;
                var cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                var cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                if (i > 0) {
                    var xdiff = cx - px;
                    var ydiff = cy - py;
                    length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                }
                px = cx;
                py = cy;
            }
            return length;
        }
    }, {
        key: 'point',
        value: function point(t, start, c1, c2, end) {
            return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
        }
    }], [{
        key: 'fromPoints',
        value: function fromPoints(points, widths) {
            var c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
            var c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
            return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
        }
    }, {
        key: 'calculateControlPoints',
        value: function calculateControlPoints(s1, s2, s3) {
            var dx1 = s1.x - s2.x;
            var dy1 = s1.y - s2.y;
            var dx2 = s2.x - s3.x;
            var dy2 = s2.y - s3.y;
            var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
            var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };
            var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            var dxm = m1.x - m2.x;
            var dym = m1.y - m2.y;
            var k = l2 / (l1 + l2);
            var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };
            var tx = s2.x - cm.x;
            var ty = s2.y - cm.y;
            return {
                c1: new Point(m1.x + tx, m1.y + ty),
                c2: new Point(m2.x + tx, m2.y + ty)
            };
        }
    }]);

    return Bezier;
}();

function throttle(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var previous = 0;
    var timeout = null;
    var result = void 0;
    var storedContext = void 0;
    var storedArgs = void 0;
    var later = function later() {
        previous = Date.now();
        timeout = null;
        result = fn.apply(storedContext, storedArgs);
        if (!timeout) {
            storedContext = null;
            storedArgs = [];
        }
    };
    return function wrapper() {
        var now = Date.now();
        var remaining = wait - (now - previous);
        storedContext = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        storedArgs = args;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = fn.apply(storedContext, storedArgs);
            if (!timeout) {
                storedContext = null;
                storedArgs = [];
            }
        } else if (!timeout) {
            timeout = window.setTimeout(later, remaining);
        }
        return result;
    };
}

var SignaturePad = function () {
    function SignaturePad(canvas) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, SignaturePad);

        this.canvas = canvas;
        this.options = options;
        this._handleMouseDown = function (event) {
            if (event.which === 1) {
                _this._mouseButtonDown = true;
                _this._strokeBegin(event);
            }
        };
        this._handleMouseMove = function (event) {
            if (_this._mouseButtonDown) {
                _this._strokeMoveUpdate(event);
            }
        };
        this._handleMouseUp = function (event) {
            if (event.which === 1 && _this._mouseButtonDown) {
                _this._mouseButtonDown = false;
                _this._strokeEnd(event);
            }
        };
        this._handleTouchStart = function (event) {
            event.preventDefault();
            if (event.targetTouches.length === 1) {
                var touch = event.changedTouches[0];
                _this._strokeBegin(touch);
            }
        };
        this._handleTouchMove = function (event) {
            event.preventDefault();
            var touch = event.targetTouches[0];
            _this._strokeMoveUpdate(touch);
        };
        this._handleTouchEnd = function (event) {
            var wasCanvasTouched = event.target === _this.canvas;
            if (wasCanvasTouched) {
                event.preventDefault();
                var touch = event.changedTouches[0];
                _this._strokeEnd(touch);
            }
        };
        this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
        this.minWidth = options.minWidth || 0.5;
        this.maxWidth = options.maxWidth || 2.5;
        this.throttle = 'throttle' in options ? options.throttle : 16;
        this.minDistance = 'minDistance' in options ? options.minDistance : 5;
        this.dotSize = options.dotSize || function dotSize() {
            return (this.minWidth + this.maxWidth) / 2;
        };
        this.penColor = options.penColor || 'black';
        this.backgroundColor = options.backgroundColor || 'rgba(0,0,0,0)';
        this.onBegin = options.onBegin;
        this.onEnd = options.onEnd;
        this._strokeMoveUpdate = this.throttle ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate;
        this._ctx = canvas.getContext('2d');
        this.clear();
        this.on();
    }

    _createClass(SignaturePad, [{
        key: 'clear',
        value: function clear() {
            var ctx = this._ctx,
                canvas = this.canvas;

            ctx.fillStyle = this.backgroundColor;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            this._data = [];
            this._reset();
            this._isEmpty = true;
        }
    }, {
        key: 'fromDataURL',
        value: function fromDataURL(dataUrl) {
            var _this2 = this;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var callback = arguments[2];

            var image = new Image();
            var ratio = options.ratio || window.devicePixelRatio || 1;
            var width = options.width || this.canvas.width / ratio;
            var height = options.height || this.canvas.height / ratio;
            this._reset();
            image.onload = function () {
                _this2._ctx.drawImage(image, 0, 0, width, height);
                if (callback) {
                    callback();
                }
            };
            image.onerror = function (error) {
                if (callback) {
                    callback(error);
                }
            };
            image.src = dataUrl;
            this._isEmpty = false;
        }
    }, {
        key: 'toDataURL',
        value: function toDataURL() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image/png';
            var encoderOptions = arguments[1];

            switch (type) {
                case 'image/svg+xml':
                    return this._toSVG();
                default:
                    return this.canvas.toDataURL(type, encoderOptions);
            }
        }
    }, {
        key: 'on',
        value: function on() {
            this.canvas.style.touchAction = 'none';
            this.canvas.style.msTouchAction = 'none';
            if (window.PointerEvent) {
                this._handlePointerEvents();
            } else {
                this._handleMouseEvents();
                if ('ontouchstart' in window) {
                    this._handleTouchEvents();
                }
            }
        }
    }, {
        key: 'off',
        value: function off() {
            this.canvas.style.touchAction = 'auto';
            this.canvas.style.msTouchAction = 'auto';
            this.canvas.removeEventListener('pointerdown', this._handleMouseDown);
            this.canvas.removeEventListener('pointermove', this._handleMouseMove);
            document.removeEventListener('pointerup', this._handleMouseUp);
            this.canvas.removeEventListener('mousedown', this._handleMouseDown);
            this.canvas.removeEventListener('mousemove', this._handleMouseMove);
            document.removeEventListener('mouseup', this._handleMouseUp);
            this.canvas.removeEventListener('touchstart', this._handleTouchStart);
            this.canvas.removeEventListener('touchmove', this._handleTouchMove);
            this.canvas.removeEventListener('touchend', this._handleTouchEnd);
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this._isEmpty;
        }
    }, {
        key: 'fromData',
        value: function fromData(pointGroups) {
            var _this3 = this;

            this.clear();
            this._fromData(pointGroups, function (_ref) {
                var color = _ref.color,
                    curve = _ref.curve;
                return _this3._drawCurve({ color: color, curve: curve });
            }, function (_ref2) {
                var color = _ref2.color,
                    point = _ref2.point;
                return _this3._drawDot({ color: color, point: point });
            });
            this._data = pointGroups;
        }
    }, {
        key: 'toData',
        value: function toData() {
            return this._data;
        }
    }, {
        key: '_strokeBegin',
        value: function _strokeBegin(event) {
            var newPointGroup = {
                color: this.penColor,
                points: []
            };
            if (typeof this.onBegin === 'function') {
                this.onBegin(event);
            }
            this._data.push(newPointGroup);
            this._reset();
            this._strokeUpdate(event);
        }
    }, {
        key: '_strokeUpdate',
        value: function _strokeUpdate(event) {
            if (this._data.length === 0) {
                this._strokeBegin(event);
                return;
            }
            var x = event.clientX;
            var y = event.clientY;
            var point = this._createPoint(x, y);
            var lastPointGroup = this._data[this._data.length - 1];
            var lastPoints = lastPointGroup.points;
            var lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
            var isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
            var color = lastPointGroup.color;
            if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
                var curve = this._addPoint(point);
                if (!lastPoint) {
                    this._drawDot({ color: color, point: point });
                } else if (curve) {
                    this._drawCurve({ color: color, curve: curve });
                }
                lastPoints.push({
                    time: point.time,
                    x: point.x,
                    y: point.y
                });
            }
        }
    }, {
        key: '_strokeEnd',
        value: function _strokeEnd(event) {
            this._strokeUpdate(event);
            if (typeof this.onEnd === 'function') {
                this.onEnd(event);
            }
        }
    }, {
        key: '_handlePointerEvents',
        value: function _handlePointerEvents() {
            this._mouseButtonDown = false;
            this.canvas.addEventListener('pointerdown', this._handleMouseDown);
            this.canvas.addEventListener('pointermove', this._handleMouseMove);
            document.addEventListener('pointerup', this._handleMouseUp);
        }
    }, {
        key: '_handleMouseEvents',
        value: function _handleMouseEvents() {
            this._mouseButtonDown = false;
            this.canvas.addEventListener('mousedown', this._handleMouseDown);
            this.canvas.addEventListener('mousemove', this._handleMouseMove);
            document.addEventListener('mouseup', this._handleMouseUp);
        }
    }, {
        key: '_handleTouchEvents',
        value: function _handleTouchEvents() {
            this.canvas.addEventListener('touchstart', this._handleTouchStart);
            this.canvas.addEventListener('touchmove', this._handleTouchMove);
            this.canvas.addEventListener('touchend', this._handleTouchEnd);
        }
    }, {
        key: '_reset',
        value: function _reset() {
            this._lastPoints = [];
            this._lastVelocity = 0;
            this._lastWidth = (this.minWidth + this.maxWidth) / 2;
            this._ctx.fillStyle = this.penColor;
        }
    }, {
        key: '_createPoint',
        value: function _createPoint(x, y) {
            var rect = this.canvas.getBoundingClientRect();
            return new Point(x - rect.left, y - rect.top, new Date().getTime());
        }
    }, {
        key: '_addPoint',
        value: function _addPoint(point) {
            var _lastPoints = this._lastPoints;

            _lastPoints.push(point);
            if (_lastPoints.length > 2) {
                if (_lastPoints.length === 3) {
                    _lastPoints.unshift(_lastPoints[0]);
                }
                var widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2]);
                var curve = Bezier.fromPoints(_lastPoints, widths);
                _lastPoints.shift();
                return curve;
            }
            return null;
        }
    }, {
        key: '_calculateCurveWidths',
        value: function _calculateCurveWidths(startPoint, endPoint) {
            var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
            var newWidth = this._strokeWidth(velocity);
            var widths = {
                end: newWidth,
                start: this._lastWidth
            };
            this._lastVelocity = velocity;
            this._lastWidth = newWidth;
            return widths;
        }
    }, {
        key: '_strokeWidth',
        value: function _strokeWidth(velocity) {
            return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
        }
    }, {
        key: '_drawCurveSegment',
        value: function _drawCurveSegment(x, y, width) {
            var ctx = this._ctx;
            ctx.moveTo(x, y);
            ctx.arc(x, y, width, 0, 2 * Math.PI, false);
            this._isEmpty = false;
        }
    }, {
        key: '_drawCurve',
        value: function _drawCurve(_ref3) {
            var color = _ref3.color,
                curve = _ref3.curve;

            var ctx = this._ctx;
            var widthDelta = curve.endWidth - curve.startWidth;
            var drawSteps = Math.floor(curve.length()) * 2;
            ctx.beginPath();
            ctx.fillStyle = color;
            for (var i = 0; i < drawSteps; i += 1) {
                var t = i / drawSteps;
                var tt = t * t;
                var ttt = tt * t;
                var u = 1 - t;
                var uu = u * u;
                var uuu = uu * u;
                var x = uuu * curve.startPoint.x;
                x += 3 * uu * t * curve.control1.x;
                x += 3 * u * tt * curve.control2.x;
                x += ttt * curve.endPoint.x;
                var y = uuu * curve.startPoint.y;
                y += 3 * uu * t * curve.control1.y;
                y += 3 * u * tt * curve.control2.y;
                y += ttt * curve.endPoint.y;
                var width = Math.min(curve.startWidth + ttt * widthDelta, this.maxWidth);
                this._drawCurveSegment(x, y, width);
            }
            ctx.closePath();
            ctx.fill();
        }
    }, {
        key: '_drawDot',
        value: function _drawDot(_ref4) {
            var color = _ref4.color,
                point = _ref4.point;

            var ctx = this._ctx;
            var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
            ctx.beginPath();
            this._drawCurveSegment(point.x, point.y, width);
            ctx.closePath();
            ctx.fillStyle = color;
            ctx.fill();
        }
    }, {
        key: '_fromData',
        value: function _fromData(pointGroups, drawCurve, drawDot) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = pointGroups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var group = _step.value;
                    var color = group.color,
                        points = group.points;

                    if (points.length > 1) {
                        for (var j = 0; j < points.length; j += 1) {
                            var basicPoint = points[j];
                            var point = new Point(basicPoint.x, basicPoint.y, basicPoint.time);
                            this.penColor = color;
                            if (j === 0) {
                                this._reset();
                            }
                            var curve = this._addPoint(point);
                            if (curve) {
                                drawCurve({ color: color, curve: curve });
                            }
                        }
                    } else {
                        this._reset();
                        drawDot({
                            color: color,
                            point: points[0]
                        });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: '_toSVG',
        value: function _toSVG() {
            var _this4 = this;

            var pointGroups = this._data;
            var ratio = Math.max(window.devicePixelRatio || 1, 1);
            var minX = 0;
            var minY = 0;
            var maxX = this.canvas.width / ratio;
            var maxY = this.canvas.height / ratio;
            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width', this.canvas.width.toString());
            svg.setAttribute('height', this.canvas.height.toString());
            this._fromData(pointGroups, function (_ref5) {
                var color = _ref5.color,
                    curve = _ref5.curve;

                var path = document.createElement('path');
                if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
                    var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
                    path.setAttribute('d', attr);
                    path.setAttribute('stroke-width', (curve.endWidth * 2.25).toFixed(3));
                    path.setAttribute('stroke', color);
                    path.setAttribute('fill', 'none');
                    path.setAttribute('stroke-linecap', 'round');
                    svg.appendChild(path);
                }
            }, function (_ref6) {
                var color = _ref6.color,
                    point = _ref6.point;

                var circle = document.createElement('circle');
                var dotSize = typeof _this4.dotSize === 'function' ? _this4.dotSize() : _this4.dotSize;
                circle.setAttribute('r', dotSize.toString());
                circle.setAttribute('cx', point.x.toString());
                circle.setAttribute('cy', point.y.toString());
                circle.setAttribute('fill', color);
                svg.appendChild(circle);
            });
            var prefix = 'data:image/svg+xml;base64,';
            var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
            var body = svg.innerHTML;
            if (body === undefined) {
                var dummy = document.createElement('dummy');
                var nodes = svg.childNodes;
                dummy.innerHTML = '';
                for (var i = 0; i < nodes.length; i += 1) {
                    dummy.appendChild(nodes[i].cloneNode(true));
                }
                body = dummy.innerHTML;
            }
            var footer = '</svg>';
            var data = header + body + footer;
            return prefix + btoa(data);
        }
    }]);

    return SignaturePad;
}();

exports.default = SignaturePad;
//# sourceMappingURL=signature_pad.js.map

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// Defaults
var defaultOptions = {
	format: 'image/png',
	quality: 0.92,
	width: undefined,
	height: undefined,
	Canvas: undefined,
	crossOrigin: undefined
};

// Return Promise
var mergeImages = function (sources, options) {
	if ( sources === void 0 ) sources = [];
	if ( options === void 0 ) options = {};

	return new Promise(function (resolve) {
	options = Object.assign({}, defaultOptions, options);

	// Setup browser/Node.js specific variables
	var canvas = options.Canvas ? new options.Canvas() : window.document.createElement('canvas');
	var Image = options.Canvas ? options.Canvas.Image : window.Image;
	if (options.Canvas) {
		options.quality *= 100;
	}

	// Load sources
	var images = sources.map(function (source) { return new Promise(function (resolve, reject) {
		// Convert sources to objects
		if (source.constructor.name !== 'Object') {
			source = { src: source };
		}

		// Resolve source and img when loaded
		var img = new Image();
		img.crossOrigin = options.crossOrigin;
		img.onerror = function () { return reject(new Error('Couldn\'t load image')); };
		img.onload = function () { return resolve(Object.assign({}, source, { img: img })); };
		img.src = source.src;
	}); });

	// Get canvas context
	var ctx = canvas.getContext('2d');

	// When sources have loaded
	resolve(Promise.all(images)
		.then(function (images) {
			// Set canvas dimensions
			var getSize = function (dim) { return options[dim] || Math.max.apply(Math, images.map(function (image) { return image.img[dim]; })); };
			canvas.width = getSize('width');
			canvas.height = getSize('height');

			// Draw images to canvas
			images.forEach(function (image) {
				ctx.globalAlpha = image.opacity ? image.opacity : 1;
				return ctx.drawImage(image.img, image.x || 0, image.y || 0);
			});

			if (options.Canvas && options.format === 'image/jpeg') {
				// Resolve data URI for node-canvas jpeg async
				return new Promise(function (resolve) {
					canvas.toDataURL(options.format, {
						quality: options.quality,
						progressive: false
					}, function (err, jpeg) {
						if (err) {
							throw err;
						}
						resolve(jpeg);
					});
				});
			}

			// Resolve all other data URIs sync
			return canvas.toDataURL(options.format, options.quality);
		}));
});
};

/* harmony default export */ __webpack_exports__["default"] = (mergeImages);
//# sourceMappingURL=index.es2015.js.map


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(892);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ea985c22", content, true, {});

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".mx-icon-double-left:after,.mx-icon-double-left:before,.mx-icon-double-right:after,.mx-icon-double-right:before,.mx-icon-left:before,.mx-icon-right:before{content:\"\";position:relative;top:-1px;display:inline-block;width:10px;height:10px;vertical-align:middle;border-style:solid;border-color:currentColor;border-width:2px 0 0 2px;border-radius:1px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-45deg) scale(.7);transform:rotate(-45deg) scale(.7)}.mx-icon-double-left:after{left:-4px}.mx-icon-double-right:before{left:4px}.mx-icon-double-right:after,.mx-icon-double-right:before,.mx-icon-right:before{-webkit-transform:rotate(135deg) scale(.7);transform:rotate(135deg) scale(.7)}.mx-btn{-webkit-box-sizing:border-box;box-sizing:border-box;line-height:1;font-size:14px;font-weight:500;padding:7px 15px;margin:0;cursor:pointer;background-color:transparent;outline:none;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:#73879c;white-space:nowrap}.mx-btn:hover{border-color:#1284e7;color:#1284e7}.mx-btn-text{border:0;padding:0 4px;text-align:left;line-height:inherit}.mx-scrollbar{height:100%}.mx-scrollbar:hover .mx-scrollbar-track{opacity:1}.mx-scrollbar-wrap{height:100%;overflow-x:hidden;overflow-y:auto}.mx-scrollbar-track{position:absolute;top:2px;right:2px;bottom:2px;width:6px;z-index:1;border-radius:4px;opacity:0;-webkit-transition:opacity .24s ease-out;transition:opacity .24s ease-out}.mx-scrollbar-track .mx-scrollbar-thumb{position:absolute;width:100%;height:0;cursor:pointer;border-radius:inherit;background-color:hsla(220,4%,58%,.3);-webkit-transition:background-color .3s;transition:background-color .3s}.mx-zoom-in-down-enter-active,.mx-zoom-in-down-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:center top;transform-origin:center top}.mx-zoom-in-down-enter,.mx-zoom-in-down-enter-from,.mx-zoom-in-down-leave-to{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.mx-datepicker{position:relative;display:inline-block;width:210px}.mx-datepicker svg{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden}.mx-datepicker-range{width:320px}.mx-datepicker-inline{width:auto}.mx-input-wrapper{position:relative}.mx-input-wrapper .mx-icon-clear{display:none}.mx-input-wrapper:hover .mx-icon-clear{display:block}.mx-input-wrapper:hover .mx-icon-clear+.mx-icon-calendar{display:none}.mx-input{display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:34px;padding:6px 30px;padding-left:10px;font-size:14px;line-height:1.4;color:#555;background-color:#fff;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.mx-input:focus,.mx-input:hover{border-color:#409aff}.mx-input.disabled,.mx-input:disabled{color:#ccc;background-color:#f3f3f3;border-color:#ccc;cursor:not-allowed}.mx-input:focus{outline:none}.mx-input::-ms-clear{display:none}.mx-icon-calendar,.mx-icon-clear{position:absolute;top:50%;right:8px;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:16px;line-height:1;color:rgba(0,0,0,.5);vertical-align:middle}.mx-icon-clear{cursor:pointer}.mx-icon-clear:hover{color:rgba(0,0,0,.8)}.mx-datepicker-main{font:14px/1.5 Helvetica Neue,Helvetica,Arial,Microsoft Yahei,sans-serif;color:#73879c;background-color:#fff;border:1px solid #e8e8e8}.mx-datepicker-popup{position:absolute;margin-top:1px;margin-bottom:1px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);z-index:2001}.mx-datepicker-sidebar{float:left;-webkit-box-sizing:border-box;box-sizing:border-box;width:100px;padding:6px;overflow:auto}.mx-datepicker-sidebar+.mx-datepicker-content{margin-left:100px;border-left:1px solid #e8e8e8}.mx-datepicker-body{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mx-btn-shortcut{display:block;padding:0 6px;line-height:24px}.mx-range-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}@media(max-width:750px){.mx-range-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.mx-datepicker-header{padding:6px 8px;border-bottom:1px solid #e8e8e8}.mx-datepicker-footer{padding:6px 8px;text-align:right;border-top:1px solid #e8e8e8}.mx-calendar{-webkit-box-sizing:border-box;box-sizing:border-box;width:248px;padding:6px 12px}.mx-calendar+.mx-calendar{border-left:1px solid #e8e8e8}.mx-calendar-header,.mx-time-header{-webkit-box-sizing:border-box;box-sizing:border-box;height:34px;line-height:34px;text-align:center;overflow:hidden}.mx-btn-icon-double-left,.mx-btn-icon-left{float:left}.mx-btn-icon-double-right,.mx-btn-icon-right{float:right}.mx-calendar-header-label{font-size:14px}.mx-calendar-decade-separator{margin:0 2px}.mx-calendar-decade-separator:after{content:\"~\"}.mx-calendar-content{position:relative;height:224px;-webkit-box-sizing:border-box;box-sizing:border-box}.mx-calendar-content .cell{cursor:pointer}.mx-calendar-content .cell:hover{color:#73879c;background-color:#f3f9fe}.mx-calendar-content .cell.active{color:#fff;background-color:#1284e7}.mx-calendar-content .cell.hover-in-range,.mx-calendar-content .cell.in-range{color:#73879c;background-color:#dbedfb}.mx-calendar-content .cell.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-calendar-week-mode .mx-date-row{cursor:pointer}.mx-calendar-week-mode .mx-date-row:hover{background-color:#f3f9fe}.mx-calendar-week-mode .mx-date-row.mx-active-week{background-color:#dbedfb}.mx-calendar-week-mode .mx-date-row .cell.active,.mx-calendar-week-mode .mx-date-row .cell:hover{color:inherit;background-color:transparent}.mx-week-number{opacity:.5}.mx-table{table-layout:fixed;border-collapse:separate;border-spacing:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:center}.mx-table th{font-weight:500}.mx-table td,.mx-table th{padding:0;vertical-align:middle}.mx-table-date td,.mx-table-date th{height:32px;font-size:12px}.mx-table-date .today{color:#2a90e9}.mx-table-date .cell.not-current-month{color:#ccc;background:none}.mx-time{-webkit-box-flex:1;-ms-flex:1;flex:1;width:224px;background:#fff}.mx-time+.mx-time{border-left:1px solid #e8e8e8}.mx-calendar-time{position:absolute;top:0;left:0;width:100%;height:100%}.mx-time-header{border-bottom:1px solid #e8e8e8}.mx-time-content{height:224px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.mx-time-columns{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;overflow:hidden}.mx-time-column{-webkit-box-flex:1;-ms-flex:1;flex:1;position:relative;border-left:1px solid #e8e8e8;text-align:center}.mx-time-column:first-child{border-left:0}.mx-time-column .mx-time-list{margin:0;padding:0;list-style:none}.mx-time-column .mx-time-list:after{content:\"\";display:block;height:192px}.mx-time-column .mx-time-item{cursor:pointer;font-size:12px;height:32px;line-height:32px}.mx-time-column .mx-time-item:hover{color:#73879c;background-color:#f3f9fe}.mx-time-column .mx-time-item.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-column .mx-time-item.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-time-option{cursor:pointer;padding:8px 10px;font-size:14px;line-height:20px}.mx-time-option:hover{color:#73879c;background-color:#f3f9fe}.mx-time-option.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-option.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}", ""]);

// exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js